/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "../js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Webpack build for Portals starts form this file
	 * It loads some 3rd party dependencies and makes them available globally
	 * (to prevent need in requiring them in modules)
	 * Then loads a proper main.js file in a Portal
	 */
	
	/**
	 * Babel Polyfill (to include Promise etc.)
	 *
	 * https://babeljs.io/docs/usage/polyfill/
	 */
	__webpack_require__(1);
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(333), __webpack_require__(334)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jquery, moment) {
	    // jQuery has to be loaded before AngularJS
	    // to make AngularJS use it instead of jqLite
	    window.$ = window.jQuery = jquery;
	
	    window.moment = moment; // needed for datetimepicker
	
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    // Loaded using the full path because "angular" alias
	    // is set to return just a global "angular" variable
	    // but here we have to load an AngularJS file
	    __webpack_require__(335)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        // AngularJS add itself to a global space automatically
	        // It has to be loaded before any modules which may use it
	
	        // START THE APP
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(336)], __WEBPACK_AMD_DEFINE_RESULT__ = function (app) {
	            return angular.bootstrap(document, [app.name]);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* eslint max-len: 0 */
	
	"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(328);
	
	// Should be removed in the next major release:
	
	__webpack_require__(330);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(189);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(207);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(211);
	__webpack_require__(221);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	module.exports = __webpack_require__(9);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var META = __webpack_require__(25).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(21);
	var setToStringTag = __webpack_require__(26);
	var uid = __webpack_require__(19);
	var wks = __webpack_require__(27);
	var wksExt = __webpack_require__(28);
	var wksDefine = __webpack_require__(29);
	var enumKeys = __webpack_require__(30);
	var isArray = __webpack_require__(45);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var toObject = __webpack_require__(46);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(16);
	var createDesc = __webpack_require__(17);
	var _create = __webpack_require__(47);
	var gOPNExt = __webpack_require__(50);
	var $GOPD = __webpack_require__(52);
	var $GOPS = __webpack_require__(43);
	var $DP = __webpack_require__(11);
	var $keys = __webpack_require__(31);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(51).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(22)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 4 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 5 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var hide = __webpack_require__(10);
	var redefine = __webpack_require__(18);
	var ctx = __webpack_require__(23);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 9 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var toPrimitive = __webpack_require__(16);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function () {
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(5);
	var SRC = __webpack_require__(19)('src');
	var $toString = __webpack_require__(20);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 19 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(21)('native-function-to-string', Function.toString);


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(22) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(24);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(19)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(5);
	var setDesc = __webpack_require__(11).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(5);
	var TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(21)('wks');
	var uid = __webpack_require__(19);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(27);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var LIBRARY = __webpack_require__(22);
	var wksExt = __webpack_require__(28);
	var defineProperty = __webpack_require__(11).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(32);
	var enumBugKeys = __webpack_require__(42);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(5);
	var toIObject = __webpack_require__(33);
	var arrayIndexOf = __webpack_require__(37)(false);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(34);
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 35 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(33);
	var toLength = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(40);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(21)('keys');
	var uid = __webpack_require__(19);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 43 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 44 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(48);
	var enumBugKeys = __webpack_require__(42);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(49).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(31);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(33);
	var gOPN = __webpack_require__(51).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(32);
	var hiddenKeys = __webpack_require__(42).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(44);
	var createDesc = __webpack_require__(17);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(16);
	var has = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(47) });


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(48) });


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(33);
	var $getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	__webpack_require__(57)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(46);
	var $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(57)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(5);
	var toObject = __webpack_require__(46);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(46);
	var $keys = __webpack_require__(31);
	
	__webpack_require__(57)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(57)('getOwnPropertyNames', function () {
	  return __webpack_require__(50).f;
	});


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(57)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(57)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(57)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(57)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(57)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(57)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(69) });


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(6);
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	var toObject = __webpack_require__(46);
	var IObject = __webpack_require__(34);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(71) });


/***/ },
/* 71 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(73).set });


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(23)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75);
	var test = {};
	test[__webpack_require__(27)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(27)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(77) });


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(24);
	var isObject = __webpack_require__(13);
	var invoke = __webpack_require__(78);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(13);
	var getPrototypeOf = __webpack_require__(59);
	var HAS_INSTANCE = __webpack_require__(27)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt;
	var $trim = __webpack_require__(83).trim;
	var ws = __webpack_require__(84);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(36);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(84);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat;
	var $trim = __webpack_require__(83).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var cof = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(88);
	var toPrimitive = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(51).f;
	var gOPD = __webpack_require__(52).f;
	var dP = __webpack_require__(11).f;
	var $trim = __webpack_require__(83).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(47)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var setPrototypeOf = __webpack_require__(73).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(39);
	var aNumberValue = __webpack_require__(90);
	var repeat = __webpack_require__(91);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(36);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(90);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(96) });


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(96);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(104);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 104 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(108);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 108 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(112);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 112 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(114) });


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(108);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(104) });


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(108) });


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(40);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var toLength = __webpack_require__(38);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(128)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(129)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(36);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(130);
	var $iterCreate = __webpack_require__(131);
	var setToStringTag = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(59);
	var ITERATOR = __webpack_require__(27)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(47);
	var descriptor = __webpack_require__(17);
	var setToStringTag = __webpack_require__(26);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(38);
	var context = __webpack_require__(134);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135);
	var defined = __webpack_require__(36);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13);
	var cof = __webpack_require__(35);
	var MATCH = __webpack_require__(27)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(27)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(134);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(38);
	var context = __webpack_require__(134);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(36);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(157);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(27)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(160));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(45) });


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(23);
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var toLength = __webpack_require__(38);
	var createProperty = __webpack_require__(165);
	var getIterFn = __webpack_require__(166);
	
	$export($export.S + $export.F * !__webpack_require__(167)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(130);
	var ITERATOR = __webpack_require__(27)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(75);
	var ITERATOR = __webpack_require__(27)('iterator');
	var Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(27)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(165);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(34) != Object || !__webpack_require__(170)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(49);
	var cof = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var toObject = __webpack_require__(46);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(170)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(174)(0);
	var STRICT = __webpack_require__(170)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(23);
	var IObject = __webpack_require__(34);
	var toObject = __webpack_require__(46);
	var toLength = __webpack_require__(38);
	var asc = __webpack_require__(175);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(176);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var isArray = __webpack_require__(45);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(174)(1);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(174)(2);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(174)(3);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(174)(4);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(24);
	var toObject = __webpack_require__(46);
	var IObject = __webpack_require__(34);
	var toLength = __webpack_require__(38);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(37)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(187) });
	
	__webpack_require__(188)('copyWithin');


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(46);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(27)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(190) });
	
	__webpack_require__(188)('fill');


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(46);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(194)('Array');


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var dP = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(188);
	var step = __webpack_require__(196);
	var Iterators = __webpack_require__(130);
	var toIObject = __webpack_require__(33);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(129)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 196 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var inheritIfRequired = __webpack_require__(88);
	var dP = __webpack_require__(11).f;
	var gOPN = __webpack_require__(51).f;
	var isRegExp = __webpack_require__(135);
	var $flags = __webpack_require__(198);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(27)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(194)('RegExp');


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(200);
	__webpack_require__(8)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(198);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(202);
	var anObject = __webpack_require__(12);
	var $flags = __webpack_require__(198);
	var DESCRIPTORS = __webpack_require__(6);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(198)
	});


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(38);
	var advanceStringIndex = __webpack_require__(204);
	var regExpExec = __webpack_require__(205);
	
	// @@match logic
	__webpack_require__(206)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(128)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(75);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(199);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(36);
	var wks = __webpack_require__(27);
	var regexpExec = __webpack_require__(200);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toObject = __webpack_require__(46);
	var toLength = __webpack_require__(38);
	var toInteger = __webpack_require__(39);
	var advanceStringIndex = __webpack_require__(204);
	var regExpExec = __webpack_require__(205);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(206)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var sameValue = __webpack_require__(71);
	var regExpExec = __webpack_require__(205);
	
	// @@search logic
	__webpack_require__(206)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(135);
	var anObject = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(210);
	var advanceStringIndex = __webpack_require__(204);
	var toLength = __webpack_require__(38);
	var callRegExpExec = __webpack_require__(205);
	var regexpExec = __webpack_require__(200);
	var fails = __webpack_require__(7);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(206)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(24);
	var SPECIES = __webpack_require__(27)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var global = __webpack_require__(4);
	var ctx = __webpack_require__(23);
	var classof = __webpack_require__(75);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(24);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var speciesConstructor = __webpack_require__(210);
	var task = __webpack_require__(214).set;
	var microtask = __webpack_require__(215)();
	var newPromiseCapabilityModule = __webpack_require__(216);
	var perform = __webpack_require__(217);
	var userAgent = __webpack_require__(218);
	var promiseResolve = __webpack_require__(219);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(27)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(220)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(26)($Promise, PROMISE);
	__webpack_require__(194)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(167)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 212 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(23);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(38);
	var getIterFn = __webpack_require__(166);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(23);
	var invoke = __webpack_require__(78);
	var html = __webpack_require__(49);
	var cel = __webpack_require__(15);
	var global = __webpack_require__(4);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var macrotask = __webpack_require__(214).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(24);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 217 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var newPromiseCapability = __webpack_require__(216);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(222);
	var validate = __webpack_require__(223);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(224)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(11).f;
	var create = __webpack_require__(47);
	var redefineAll = __webpack_require__(220);
	var ctx = __webpack_require__(23);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var $iterDefine = __webpack_require__(129);
	var step = __webpack_require__(196);
	var setSpecies = __webpack_require__(194);
	var DESCRIPTORS = __webpack_require__(6);
	var fastKey = __webpack_require__(25).fastKey;
	var validate = __webpack_require__(223);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var redefineAll = __webpack_require__(220);
	var meta = __webpack_require__(25);
	var forOf = __webpack_require__(213);
	var anInstance = __webpack_require__(212);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(167);
	var setToStringTag = __webpack_require__(26);
	var inheritIfRequired = __webpack_require__(88);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(222);
	var validate = __webpack_require__(223);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(224)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var each = __webpack_require__(174)(0);
	var redefine = __webpack_require__(18);
	var meta = __webpack_require__(25);
	var assign = __webpack_require__(69);
	var weak = __webpack_require__(227);
	var isObject = __webpack_require__(13);
	var validate = __webpack_require__(223);
	var NATIVE_WEAK_MAP = __webpack_require__(223);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(224)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(220);
	var getWeak = __webpack_require__(25).getWeak;
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var createArrayMethod = __webpack_require__(174);
	var $has = __webpack_require__(5);
	var validate = __webpack_require__(223);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(227);
	var validate = __webpack_require__(223);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(224)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(230);
	var buffer = __webpack_require__(231);
	var anObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	var isObject = __webpack_require__(13);
	var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
	var speciesConstructor = __webpack_require__(210);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(194)(ARRAY_BUFFER);


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var uid = __webpack_require__(19);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(6);
	var LIBRARY = __webpack_require__(22);
	var $typed = __webpack_require__(230);
	var hide = __webpack_require__(10);
	var redefineAll = __webpack_require__(220);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(212);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	var toIndex = __webpack_require__(232);
	var gOPN = __webpack_require__(51).f;
	var dP = __webpack_require__(11).f;
	var arrayFill = __webpack_require__(190);
	var setToStringTag = __webpack_require__(26);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(230).ABV, {
	  DataView: __webpack_require__(231).DataView
	});


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(6)) {
	  var LIBRARY = __webpack_require__(22);
	  var global = __webpack_require__(4);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(230);
	  var $buffer = __webpack_require__(231);
	  var ctx = __webpack_require__(23);
	  var anInstance = __webpack_require__(212);
	  var propertyDesc = __webpack_require__(17);
	  var hide = __webpack_require__(10);
	  var redefineAll = __webpack_require__(220);
	  var toInteger = __webpack_require__(39);
	  var toLength = __webpack_require__(38);
	  var toIndex = __webpack_require__(232);
	  var toAbsoluteIndex = __webpack_require__(40);
	  var toPrimitive = __webpack_require__(16);
	  var has = __webpack_require__(5);
	  var classof = __webpack_require__(75);
	  var isObject = __webpack_require__(13);
	  var toObject = __webpack_require__(46);
	  var isArrayIter = __webpack_require__(164);
	  var create = __webpack_require__(47);
	  var getPrototypeOf = __webpack_require__(59);
	  var gOPN = __webpack_require__(51).f;
	  var getIterFn = __webpack_require__(166);
	  var uid = __webpack_require__(19);
	  var wks = __webpack_require__(27);
	  var createArrayMethod = __webpack_require__(174);
	  var createArrayIncludes = __webpack_require__(37);
	  var speciesConstructor = __webpack_require__(210);
	  var ArrayIterators = __webpack_require__(195);
	  var Iterators = __webpack_require__(130);
	  var $iterDetect = __webpack_require__(167);
	  var setSpecies = __webpack_require__(194);
	  var arrayFill = __webpack_require__(190);
	  var arrayCopyWithin = __webpack_require__(187);
	  var $DP = __webpack_require__(11);
	  var $GOPD = __webpack_require__(52);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var rApply = (__webpack_require__(4).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(47);
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(77);
	var rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(11);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(52).f;
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(52);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(52);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(59);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(255) });


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(51);
	var gOPS = __webpack_require__(43);
	var anObject = __webpack_require__(12);
	var Reflect = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(11);
	var gOPD = __webpack_require__(52);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(17);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(73);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(37)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(188)('includes');


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(261);
	var toObject = __webpack_require__(46);
	var toLength = __webpack_require__(38);
	var aFunction = __webpack_require__(24);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatMap');


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(45);
	var isObject = __webpack_require__(13);
	var toLength = __webpack_require__(38);
	var ctx = __webpack_require__(23);
	var IS_CONCAT_SPREADABLE = __webpack_require__(27)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(261);
	var toObject = __webpack_require__(46);
	var toLength = __webpack_require__(38);
	var toInteger = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatten');


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(true);
	var $fails = __webpack_require__(7);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(265);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(38);
	var repeat = __webpack_require__(91);
	var defined = __webpack_require__(36);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(265);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(36);
	var toLength = __webpack_require__(38);
	var isRegExp = __webpack_require__(135);
	var getFlags = __webpack_require__(198);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(29)('asyncIterator');


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(29)('observable');


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(255);
	var toIObject = __webpack_require__(33);
	var gOPD = __webpack_require__(52);
	var createProperty = __webpack_require__(165);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $values = __webpack_require__(274)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(6);
	var getKeys = __webpack_require__(31);
	var toIObject = __webpack_require__(33);
	var isEnum = __webpack_require__(44).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $entries = __webpack_require__(274)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var aFunction = __webpack_require__(24);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(22) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(4)[K];
	});


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var aFunction = __webpack_require__(24);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(46);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(282)('Map') });


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75);
	var from = __webpack_require__(283);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(213);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(282)('Set') });


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(286)('Map');


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(286)('Set');


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(286)('WeakMap');


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(286)('WeakSet');


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(291)('Map');


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var ctx = __webpack_require__(23);
	var forOf = __webpack_require__(213);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(291)('Set');


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(291)('WeakMap');


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(291)('WeakSet');


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(4) });


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(302);
	var fround = __webpack_require__(114);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 302 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(302) });


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(210);
	var promiseResolve = __webpack_require__(219);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(216);
	var perform = __webpack_require__(217);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(221);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(21)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(226))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(225);
	var from = __webpack_require__(283);
	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(24);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(215)();
	var process = __webpack_require__(4).process;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var microtask = __webpack_require__(215)();
	var OBSERVABLE = __webpack_require__(27)('observable');
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var anInstance = __webpack_require__(212);
	var redefineAll = __webpack_require__(220);
	var hide = __webpack_require__(10);
	var forOf = __webpack_require__(213);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(194)('Observable');


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var userAgent = __webpack_require__(218);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(214);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(195);
	var getKeys = __webpack_require__(31);
	var redefine = __webpack_require__(18);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(130);
	var wks = __webpack_require__(27);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(329)))

/***/ },
/* 329 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(331);
	module.exports = __webpack_require__(9).RegExp.escape;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(332)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 332 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 333 */
/***/ function(module, exports) {

	/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
	!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=a.document,m="2.1.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){return!n.isArray(a)&&a-parseFloat(a)+1>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!j.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=l.createElement("script"),b.text=a,l.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:g.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(e=d.call(arguments,2),f=function(){return a.apply(b||this,e.concat(d.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:k}),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function s(a){var b="length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N=M.replace("w","w#"),O="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+N+"))|)"+L+"*\\]",P=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+O+")*)|.*)\\)|)",Q=new RegExp(L+"+","g"),R=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),S=new RegExp("^"+L+"*,"+L+"*"),T=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),U=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),V=new RegExp(P),W=new RegExp("^"+N+"$"),X={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M.replace("w","w*")+")"),ATTR:new RegExp("^"+O),PSEUDO:new RegExp("^"+P),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,aa=/[+~]/,ba=/'|\\/g,ca=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),da=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,"string"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(ba,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(",")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener("unload",ea,!1):e.attachEvent&&e.attachEvent("onunload",ea)),p=!f(g),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\f]' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){var b=g.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",P)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||"").replace(ca,da),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(Q," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,w=/^.[^:#\[\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return g.call(b,a)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,"string"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=n.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:l,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}return d=l.getElementById(c[2]),d&&d.parentNode&&(this.length=1,this[0]=d),this.context=l,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};A.prototype=n.fn,y=n(l);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?"string"==typeof a?g.call(n(a),this[0]):g.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,"parentNode")},parentsUntil:function(a,b,c){return n.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return n.dir(a,"nextSibling")},prevAll:function(a){return n.dir(a,"previousSibling")},nextUntil:function(a,b,c){return n.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return n.dir(a,"previousSibling",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(C[a]||n.unique(e),B.test(a)&&e.reverse()),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return n.each(a.match(E)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(b=a.memory&&l,c=!0,g=e||0,e=0,f=h.length,d=!0;h&&f>g;g++)if(h[g].apply(l[0],l[1])===!1&&a.stopOnFalse){b=!1;break}d=!1,h&&(i?i.length&&j(i.shift()):b?h=[]:k.disable())},k={add:function(){if(h){var c=h.length;!function g(b){n.each(b,function(b,c){var d=n.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&g(c)})}(arguments),d?f=h.length:b&&(e=c,j(b))}return this},remove:function(){return h&&n.each(arguments,function(a,b){var c;while((c=n.inArray(b,h,c))>-1)h.splice(c,1),d&&(f>=c&&f--,g>=c&&g--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],f=0,this},disable:function(){return h=i=b=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,b||k.disable(),this},locked:function(){return!i},fireWith:function(a,b){return!h||c&&!i||(b=b||[],b=[a,b.slice?b.slice():b],d?i.push(b):j(b)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!c}};return k},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(H.resolveWith(l,[n]),n.fn.triggerHandler&&(n(l).triggerHandler("ready"),n(l).off("ready"))))}});function I(){l.removeEventListener("DOMContentLoaded",I,!1),a.removeEventListener("load",I,!1),n.ready()}n.ready.promise=function(b){return H||(H=n.Deferred(),"complete"===l.readyState?setTimeout(n.ready):(l.addEventListener("DOMContentLoaded",I,!1),a.addEventListener("load",I,!1))),H.promise(b)},n.ready.promise();var J=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f};n.acceptData=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function K(){Object.defineProperty(this.cache={},0,{get:function(){return{}}}),this.expando=n.expando+K.uid++}K.uid=1,K.accepts=n.acceptData,K.prototype={key:function(a){if(!K.accepts(a))return 0;var b={},c=a[this.expando];if(!c){c=K.uid++;try{b[this.expando]={value:c},Object.defineProperties(a,b)}catch(d){b[this.expando]=c,n.extend(a,b)}}return this.cache[c]||(this.cache[c]={}),c},set:function(a,b,c){var d,e=this.key(a),f=this.cache[e];if("string"==typeof b)f[b]=c;else if(n.isEmptyObject(f))n.extend(this.cache[e],b);else for(d in b)f[d]=b[d];return f},get:function(a,b){var c=this.cache[this.key(a)];return void 0===b?c:c[b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=this.key(a),g=this.cache[f];if(void 0===b)this.cache[f]={};else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in g?d=[b,e]:(d=e,d=d in g?[d]:d.match(E)||[])),c=d.length;while(c--)delete g[d[c]]}},hasData:function(a){return!n.isEmptyObject(this.cache[a[this.expando]]||{})},discard:function(a){a[this.expando]&&delete this.cache[a[this.expando]]}};var L=new K,M=new K,N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(O,"-$1").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}M.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return M.hasData(a)||L.hasData(a)},data:function(a,b,c){
	return M.access(a,b,c)},removeData:function(a,b){M.remove(a,b)},_data:function(a,b,c){return L.access(a,b,c)},_removeData:function(a,b){L.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=M.get(f),1===f.nodeType&&!L.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));L.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){M.set(this,a)}):J(this,function(b){var c,d=n.camelCase(a);if(f&&void 0===b){if(c=M.get(f,a),void 0!==c)return c;if(c=M.get(f,d),void 0!==c)return c;if(c=P(f,d,void 0),void 0!==c)return c}else this.each(function(){var c=M.get(this,d);M.set(this,d,b),-1!==a.indexOf("-")&&void 0!==c&&M.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){M.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=L.get(a,b),c&&(!d||n.isArray(c)?d=L.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return L.get(a,c)||L.access(a,c,{empty:n.Callbacks("once memory").add(function(){L.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=L.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var Q=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,R=["Top","Right","Bottom","Left"],S=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)},T=/^(?:checkbox|radio)$/i;!function(){var a=l.createDocumentFragment(),b=a.appendChild(l.createElement("div")),c=l.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var U="undefined";k.focusinBubbles="onfocusin"in a;var V=/^key/,W=/^(?:mouse|pointer|contextmenu)|click/,X=/^(?:focusinfocus|focusoutblur)$/,Y=/^([^.]*)(?:\.(.+)|)$/;function Z(){return!0}function $(){return!1}function _(){try{return l.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return typeof n!==U&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(E)||[""],j=b.length;while(j--)h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g,!1)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.hasData(a)&&L.get(a);if(r&&(i=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&(delete r.handle,L.remove(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,m,o,p=[d||l],q=j.call(b,"type")?b.type:b,r=j.call(b,"namespace")?b.namespace.split("."):[];if(g=h=d=d||l,3!==d.nodeType&&8!==d.nodeType&&!X.test(q+n.event.triggered)&&(q.indexOf(".")>=0&&(r=q.split("."),q=r.shift(),r.sort()),k=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=r.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},e||!o.trigger||o.trigger.apply(d,c)!==!1)){if(!e&&!o.noBubble&&!n.isWindow(d)){for(i=o.delegateType||q,X.test(i+q)||(g=g.parentNode);g;g=g.parentNode)p.push(g),h=g;h===(d.ownerDocument||l)&&p.push(h.defaultView||h.parentWindow||a)}f=0;while((g=p[f++])&&!b.isPropagationStopped())b.type=f>1?i:o.bindType||q,m=(L.get(g,"events")||{})[b.type]&&L.get(g,"handle"),m&&m.apply(g,c),m=k&&g[k],m&&m.apply&&n.acceptData(g)&&(b.result=m.apply(g,c),b.result===!1&&b.preventDefault());return b.type=q,e||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!n.acceptData(d)||k&&n.isFunction(d[q])&&!n.isWindow(d)&&(h=d[k],h&&(d[k]=null),n.event.triggered=q,d[q](),n.event.triggered=void 0,h&&(d[k]=h)),b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(L.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(g.namespace))&&(a.handleObj=g,a.data=g.data,e=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(a.result=e)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!==this;i=i.parentNode||this)if(i.disabled!==!0||"click"!==a.type){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>=0:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||l,d=c.documentElement,e=c.body,a.pageX=b.clientX+(d&&d.scrollLeft||e&&e.scrollLeft||0)-(d&&d.clientLeft||e&&e.clientLeft||0),a.pageY=b.clientY+(d&&d.scrollTop||e&&e.scrollTop||0)-(d&&d.clientTop||e&&e.clientTop||0)),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=W.test(e)?this.mouseHooks:V.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=l),3===a.target.nodeType&&(a.target=a.target.parentNode),g.filter?g.filter(a,f):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==_()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===_()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?Z:$):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:$,isPropagationStopped:$,isImmediatePropagationStopped:$,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=Z,a&&a.preventDefault&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=Z,a&&a.stopPropagation&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=Z,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.focusinBubbles||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=L.access(d,b);e||d.addEventListener(a,c,!0),L.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=L.access(d,b)-1;e?L.access(d,b,e):(d.removeEventListener(a,c,!0),L.remove(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(g in a)this.on(g,b,c,a[g],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=$;else if(!d)return this;return 1===e&&(f=d,d=function(a){return n().off(a),f.apply(this,arguments)},d.guid=f.guid||(f.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=$),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var aa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ba=/<([\w:]+)/,ca=/<|&#?\w+;/,da=/<(?:script|style|link)/i,ea=/checked\s*(?:[^=]|=\s*.checked.)/i,fa=/^$|\/(?:java|ecma)script/i,ga=/^true\/(.*)/,ha=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ia={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ia.optgroup=ia.option,ia.tbody=ia.tfoot=ia.colgroup=ia.caption=ia.thead,ia.th=ia.td;function ja(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function ka(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function la(a){var b=ga.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function ma(a,b){for(var c=0,d=a.length;d>c;c++)L.set(a[c],"globalEval",!b||L.get(b[c],"globalEval"))}function na(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(L.hasData(a)&&(f=L.access(a),g=L.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}M.hasData(a)&&(h=M.access(a),i=n.extend({},h),M.set(b,i))}}function oa(a,b){var c=a.getElementsByTagName?a.getElementsByTagName(b||"*"):a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function pa(a,b){var c=b.nodeName.toLowerCase();"input"===c&&T.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}n.extend({clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=oa(h),f=oa(a),d=0,e=f.length;e>d;d++)pa(f[d],g[d]);if(b)if(c)for(f=f||oa(a),g=g||oa(h),d=0,e=f.length;e>d;d++)na(f[d],g[d]);else na(a,h);return g=oa(h,"script"),g.length>0&&ma(g,!i&&oa(a,"script")),h},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k=b.createDocumentFragment(),l=[],m=0,o=a.length;o>m;m++)if(e=a[m],e||0===e)if("object"===n.type(e))n.merge(l,e.nodeType?[e]:e);else if(ca.test(e)){f=f||k.appendChild(b.createElement("div")),g=(ba.exec(e)||["",""])[1].toLowerCase(),h=ia[g]||ia._default,f.innerHTML=h[1]+e.replace(aa,"<$1></$2>")+h[2],j=h[0];while(j--)f=f.lastChild;n.merge(l,f.childNodes),f=k.firstChild,f.textContent=""}else l.push(b.createTextNode(e));k.textContent="",m=0;while(e=l[m++])if((!d||-1===n.inArray(e,d))&&(i=n.contains(e.ownerDocument,e),f=oa(k.appendChild(e),"script"),i&&ma(f),c)){j=0;while(e=f[j++])fa.test(e.type||"")&&c.push(e)}return k},cleanData:function(a){for(var b,c,d,e,f=n.event.special,g=0;void 0!==(c=a[g]);g++){if(n.acceptData(c)&&(e=c[L.expando],e&&(b=L.cache[e]))){if(b.events)for(d in b.events)f[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);L.cache[e]&&delete L.cache[e]}delete M.cache[c[M.expando]]}}}),n.fn.extend({text:function(a){return J(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(oa(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&ma(oa(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(oa(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return J(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!da.test(a)&&!ia[(ba.exec(a)||["",""])[1].toLowerCase()]){a=a.replace(aa,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(oa(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(oa(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,m=this,o=l-1,p=a[0],q=n.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&ea.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(c=n.buildFragment(a,this[0].ownerDocument,!1,this),d=c.firstChild,1===c.childNodes.length&&(c=d),d)){for(f=n.map(oa(c,"script"),ka),g=f.length;l>j;j++)h=c,j!==o&&(h=n.clone(h,!0,!0),g&&n.merge(f,oa(h,"script"))),b.call(this[j],h,j);if(g)for(i=f[f.length-1].ownerDocument,n.map(f,la),j=0;g>j;j++)h=f[j],fa.test(h.type||"")&&!L.access(h,"globalEval")&&n.contains(i,h)&&(h.src?n._evalUrl&&n._evalUrl(h.src):n.globalEval(h.textContent.replace(ha,"")))}return this}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),g=e.length-1,h=0;g>=h;h++)c=h===g?this:this.clone(!0),n(e[h])[b](c),f.apply(d,c.get());return this.pushStack(d)}});var qa,ra={};function sa(b,c){var d,e=n(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:n.css(e[0],"display");return e.detach(),f}function ta(a){var b=l,c=ra[a];return c||(c=sa(a,b),"none"!==c&&c||(qa=(qa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=qa[0].contentDocument,b.write(),b.close(),c=sa(a,b),qa.detach()),ra[a]=c),c}var ua=/^margin/,va=new RegExp("^("+Q+")(?!px)[a-z%]+$","i"),wa=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)};function xa(a,b,c){var d,e,f,g,h=a.style;return c=c||wa(a),c&&(g=c.getPropertyValue(b)||c[b]),c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),va.test(g)&&ua.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function ya(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d=l.documentElement,e=l.createElement("div"),f=l.createElement("div");if(f.style){f.style.backgroundClip="content-box",f.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===f.style.backgroundClip,e.style.cssText="border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute",e.appendChild(f);function g(){f.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",f.innerHTML="",d.appendChild(e);var g=a.getComputedStyle(f,null);b="1%"!==g.top,c="4px"===g.width,d.removeChild(e)}a.getComputedStyle&&n.extend(k,{pixelPosition:function(){return g(),b},boxSizingReliable:function(){return null==c&&g(),c},reliableMarginRight:function(){var b,c=f.appendChild(l.createElement("div"));return c.style.cssText=f.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",f.style.width="1px",d.appendChild(e),b=!parseFloat(a.getComputedStyle(c,null).marginRight),d.removeChild(e),f.removeChild(c),b}})}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var za=/^(none|table(?!-c[ea]).+)/,Aa=new RegExp("^("+Q+")(.*)$","i"),Ba=new RegExp("^([+-])=("+Q+")","i"),Ca={position:"absolute",visibility:"hidden",display:"block"},Da={letterSpacing:"0",fontWeight:"400"},Ea=["Webkit","O","Moz","ms"];function Fa(a,b){if(b in a)return b;var c=b[0].toUpperCase()+b.slice(1),d=b,e=Ea.length;while(e--)if(b=Ea[e]+c,b in a)return b;return d}function Ga(a,b,c){var d=Aa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Ha(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+R[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+R[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+R[f]+"Width",!0,e))):(g+=n.css(a,"padding"+R[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+R[f]+"Width",!0,e)));return g}function Ia(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=wa(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=xa(a,b,f),(0>e||null==e)&&(e=a.style[b]),va.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Ha(a,b,c||(g?"border":"content"),d,f)+"px"}function Ja(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=L.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&S(d)&&(f[g]=L.access(d,"olddisplay",ta(d.nodeName)))):(e=S(d),"none"===c&&e||L.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=xa(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Fa(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=Ba.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||n.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Fa(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=xa(a,b,d)),"normal"===e&&b in Da&&(e=Da[b]),""===c||c?(f=parseFloat(e),c===!0||n.isNumeric(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?za.test(n.css(a,"display"))&&0===a.offsetWidth?n.swap(a,Ca,function(){return Ia(a,b,d)}):Ia(a,b,d):void 0},set:function(a,c,d){var e=d&&wa(a);return Ga(a,c,d?Ha(a,b,d,"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),n.cssHooks.marginRight=ya(k.reliableMarginRight,function(a,b){return b?n.swap(a,{display:"inline-block"},xa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+R[d]+b]=f[d]||f[d-2]||f[0];return e}},ua.test(a)||(n.cssHooks[a+b].set=Ga)}),n.fn.extend({css:function(a,b){return J(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=wa(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Ja(this,!0)},hide:function(){return Ja(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){S(this)?n(this).show():n(this).hide()})}});function Ka(a,b,c,d,e){return new Ka.prototype.init(a,b,c,d,e)}n.Tween=Ka,Ka.prototype={constructor:Ka,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ka.propHooks[this.prop];return a&&a.get?a.get(this):Ka.propHooks._default.get(this)},run:function(a){var b,c=Ka.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ka.propHooks._default.set(this),this}},Ka.prototype.init.prototype=Ka.prototype,Ka.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Ka.propHooks.scrollTop=Ka.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=Ka.prototype.init,n.fx.step={};var La,Ma,Na=/^(?:toggle|show|hide)$/,Oa=new RegExp("^(?:([+-])=|)("+Q+")([a-z%]*)$","i"),Pa=/queueHooks$/,Qa=[Va],Ra={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=Oa.exec(b),f=e&&e[3]||(n.cssNumber[a]?"":"px"),g=(n.cssNumber[a]||"px"!==f&&+d)&&Oa.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function Sa(){return setTimeout(function(){La=void 0}),La=n.now()}function Ta(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=R[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ua(a,b,c){for(var d,e=(Ra[b]||[]).concat(Ra["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Va(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&S(a),q=L.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?L.get(a,"olddisplay")||ta(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Na.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?ta(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=L.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;L.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ua(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function Wa(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function Xa(a,b,c){var d,e,f=0,g=Qa.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=La||Sa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:La||Sa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Wa(k,j.opts.specialEasing);g>f;f++)if(d=Qa[f].call(j,a,k,j.opts))return d;return n.map(k,Ua,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(Xa,{tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],Ra[c]=Ra[c]||[],Ra[c].unshift(b)},prefilter:function(a,b){b?Qa.unshift(a):Qa.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(S).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=Xa(this,n.extend({},a),f);(e||L.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=L.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Pa.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=L.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Ta(b,!0),a,d,e)}}),n.each({slideDown:Ta("show"),slideUp:Ta("hide"),slideToggle:Ta("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(La=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),La=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ma||(Ma=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(Ma),Ma=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a=l.createElement("input"),b=l.createElement("select"),c=b.appendChild(l.createElement("option"));a.type="checkbox",k.checkOn=""!==a.value,k.optSelected=c.selected,b.disabled=!0,k.optDisabled=!c.disabled,a=l.createElement("input"),a.value="t",a.type="radio",k.radioValue="t"===a.value}();var Ya,Za,$a=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return J(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===U?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?Za:Ya)),
	void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void n.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),Za={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=$a[b]||n.find.attr;$a[b]=function(a,b,d){var e,f;return d||(f=$a[b],$a[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,$a[b]=f),e}});var _a=/^(?:input|select|textarea|button)$/i;n.fn.extend({prop:function(a,b){return J(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){return a.hasAttribute("tabindex")||_a.test(a.nodeName)||a.href?a.tabIndex:-1}}}}),k.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var ab=/[\t\r\n\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h="string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0===arguments.length||"string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?n.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=n(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===U||"boolean"===c)&&(this.className&&L.set(this,"__className__",this.className),this.className=this.className||a===!1?"":L.get(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ab," ").indexOf(b)>=0)return!0;return!1}});var bb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(bb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(d.value,f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},k.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var cb=n.now(),db=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(a){var b,c;if(!a||"string"!=typeof a)return null;try{c=new DOMParser,b=c.parseFromString(a,"text/xml")}catch(d){b=void 0}return(!b||b.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+a),b};var eb=/#.*$/,fb=/([?&])_=[^&]*/,gb=/^(.*?):[ \t]*([^\r\n]*)$/gm,hb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,ib=/^(?:GET|HEAD)$/,jb=/^\/\//,kb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,lb={},mb={},nb="*/".concat("*"),ob=a.location.href,pb=kb.exec(ob.toLowerCase())||[];function qb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function rb(a,b,c,d){var e={},f=a===mb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function sb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function tb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function ub(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:ob,type:"GET",isLocal:hb.test(pb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":nb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?sb(sb(a,n.ajaxSettings),b):sb(n.ajaxSettings,a)},ajaxPrefilter:qb(lb),ajaxTransport:qb(mb),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!f){f={};while(b=gb.exec(e))f[b[1].toLowerCase()]=b[2]}b=f[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?e:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return c&&c.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||ob)+"").replace(eb,"").replace(jb,pb[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(h=kb.exec(k.url.toLowerCase()),k.crossDomain=!(!h||h[1]===pb[1]&&h[2]===pb[2]&&(h[3]||("http:"===h[1]?"80":"443"))===(pb[3]||("http:"===pb[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),rb(lb,k,b,v),2===t)return v;i=n.event&&k.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!ib.test(k.type),d=k.url,k.hasContent||(k.data&&(d=k.url+=(db.test(d)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=fb.test(d)?d.replace(fb,"$1_="+cb++):d+(db.test(d)?"&":"?")+"_="+cb++)),k.ifModified&&(n.lastModified[d]&&v.setRequestHeader("If-Modified-Since",n.lastModified[d]),n.etag[d]&&v.setRequestHeader("If-None-Match",n.etag[d])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+nb+"; q=0.01":""):k.accepts["*"]);for(j in k.headers)v.setRequestHeader(j,k.headers[j]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(j in{success:1,error:1,complete:1})v[j](k[j]);if(c=rb(mb,k,b,v)){v.readyState=1,i&&m.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,c.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,f,h){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),c=void 0,e=h||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,f&&(u=tb(k,v,f)),u=ub(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(n.lastModified[d]=w),w=v.getResponseHeader("etag"),w&&(n.etag[d]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,i&&m.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),i&&(m.trigger("ajaxComplete",[v,k]),--n.active||n.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var vb=/%20/g,wb=/\[\]$/,xb=/\r?\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Ab(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join("&").replace(vb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!T.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(xb,"\r\n")}}):{name:b.name,value:c.replace(xb,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new XMLHttpRequest}catch(a){}};var Bb=0,Cb={},Db={0:200,1223:204},Eb=n.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in Cb)Cb[a]()}),k.cors=!!Eb&&"withCredentials"in Eb,k.ajax=Eb=!!Eb,n.ajaxTransport(function(a){var b;return k.cors||Eb&&!a.crossDomain?{send:function(c,d){var e,f=a.xhr(),g=++Bb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)f.setRequestHeader(e,c[e]);b=function(a){return function(){b&&(delete Cb[g],b=f.onload=f.onerror=null,"abort"===a?f.abort():"error"===a?d(f.status,f.statusText):d(Db[f.status]||f.status,f.statusText,"string"==typeof f.responseText?{text:f.responseText}:void 0,f.getAllResponseHeaders()))}},f.onload=b(),f.onerror=b("error"),b=Cb[g]=b("abort");try{f.send(a.hasContent&&a.data||null)}catch(h){if(b)throw h}},abort:function(){b&&b()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(d,e){b=n("<script>").prop({async:!0,charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&e("error"===a.type?404:200,a.type)}),l.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Fb=[],Gb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Fb.pop()||n.expando+"_"+cb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Gb.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Gb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Gb,"$1"+e):b.jsonp!==!1&&(b.url+=(db.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Fb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||l;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var Hb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Hb)return Hb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e,dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,f||[a.responseText,b,a])}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var Ib=a.document.documentElement;function Jb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(typeof d.getBoundingClientRect!==U&&(e=d.getBoundingClientRect()),c=Jb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||Ib;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ib})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(b,c){var d="pageYOffset"===c;n.fn[b]=function(e){return J(this,function(b,e,f){var g=Jb(b);return void 0===f?g?g[c]:b[e]:void(g?g.scrollTo(d?a.pageXOffset:f,d?f:a.pageYOffset):b[e]=f)},b,e,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=ya(k.pixelPosition,function(a,c){return c?(c=xa(a,b),va.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return J(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Kb=a.jQuery,Lb=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Lb),b&&a.jQuery===n&&(a.jQuery=Kb),n},typeof b===U&&(a.jQuery=a.$=n),n});
	//# sourceMappingURL=jquery.min.map

/***/ },
/* 334 */
/***/ function(module, exports) {

	(function (global, factory) {
	    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                require('./locale/' + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set (mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction (sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' &&
	            Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	        ['YYYY-DDD', /\d{4}-\d{3}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	        ['HH:mm', /(T| )\d\d:\d\d/],
	        ['HH', /(T| )\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             return other < this ? this : other;
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            return other > this ? this : other;
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = ((string || '').match(matchOffset) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset () {
	        return this._isUTC;
	    }
	
	    function isUtc () {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function diff (input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta, output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function moment_format__format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getSetISOWeekYear (input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add          = add_subtract__add;
	    momentPrototype__proto.calendar     = moment_calendar__calendar;
	    momentPrototype__proto.clone        = clone;
	    momentPrototype__proto.diff         = diff;
	    momentPrototype__proto.endOf        = endOf;
	    momentPrototype__proto.format       = moment_format__format;
	    momentPrototype__proto.from         = from;
	    momentPrototype__proto.fromNow      = fromNow;
	    momentPrototype__proto.to           = to;
	    momentPrototype__proto.toNow        = toNow;
	    momentPrototype__proto.get          = getSet;
	    momentPrototype__proto.invalidAt    = invalidAt;
	    momentPrototype__proto.isAfter      = isAfter;
	    momentPrototype__proto.isBefore     = isBefore;
	    momentPrototype__proto.isBetween    = isBetween;
	    momentPrototype__proto.isSame       = isSame;
	    momentPrototype__proto.isValid      = moment_valid__isValid;
	    momentPrototype__proto.lang         = lang;
	    momentPrototype__proto.locale       = locale;
	    momentPrototype__proto.localeData   = localeData;
	    momentPrototype__proto.max          = prototypeMax;
	    momentPrototype__proto.min          = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set          = getSet;
	    momentPrototype__proto.startOf      = startOf;
	    momentPrototype__proto.subtract     = add_subtract__subtract;
	    momentPrototype__proto.toArray      = toArray;
	    momentPrototype__proto.toObject     = toObject;
	    momentPrototype__proto.toDate       = toDate;
	    momentPrototype__proto.toISOString  = moment_format__toISOString;
	    momentPrototype__proto.toJSON       = moment_format__toISOString;
	    momentPrototype__proto.toString     = toString;
	    momentPrototype__proto.unix         = unix;
	    momentPrototype__proto.valueOf      = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment_moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment_moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (typeof output === 'function') ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months       =        localeMonths;
	    prototype__proto._months      = defaultLocaleMonths;
	    prototype__proto.monthsShort  =        localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse  =        localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var duration_get__months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes === 1          && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   === 1          && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    === 1          && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  === 1          && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   === 1          && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = duration_get__months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	    ;
	
	    //! moment.js
	    //! version : 2.10.6
	    //! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	    //! license : MIT
	    //! momentjs.com
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment_moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment_moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment__default = utils_hooks__hooks;
	
	    //! moment.js locale configuration
	    //! locale : afrikaans (af)
	    //! author : Werner Mollentze : https://github.com/wernerm
	
	    var af = _moment__default.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Moroccan Arabic (ar-ma)
	    //! author : ElFadili Yassine : https://github.com/ElFadiliY
	    //! author : Abdel Said : https://github.com/abdelsaid
	
	    var ar_ma = _moment__default.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Arabic Saudi Arabia (ar-sa)
	    //! author : Suhail Alkowaileet : https://github.com/xsoh
	
	    var ar_sa__symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, ar_sa__numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = _moment__default.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return ar_sa__numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return ar_sa__symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale  : Tunisian Arabic (ar-tn)
	
	    var ar_tn = _moment__default.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! Locale: Arabic (ar)
	    //! Author: Abdel Said: https://github.com/abdelsaid
	    //! Changes in months, weekdays: Ahmed Elkhatib
	    //! Native plural forms: forabi https://github.com/forabi
	
	    var ar__symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, ar__numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, ar__months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = _moment__default.defineLocale('ar', {
	        months : ar__months,
	        monthsShort : ar__months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return ar__numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return ar__symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : azerbaijani (az)
	    //! author : topchiyev : https://github.com/topchiyev
	
	    var az__suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = _moment__default.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (az__suffixes[a] || az__suffixes[b] || az__suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : belarusian (be)
	    //! author : Dmitry Demidov : https://github.com/demidov91
	    //! author: Praleska: http://praleska.pro/
	    //! Author : Menelion Elensúle : https://github.com/Oire
	
	    function be__plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function be__relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + be__plural(format[key], +number);
	        }
	    }
	    function be__monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	            'accusative': 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function be__weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            'accusative': 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var be = _moment__default.defineLocale('be', {
	        months : be__monthsCaseReplace,
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : be__weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : be__relativeTimeWithPlural,
	            mm : be__relativeTimeWithPlural,
	            h : be__relativeTimeWithPlural,
	            hh : be__relativeTimeWithPlural,
	            d : 'дзень',
	            dd : be__relativeTimeWithPlural,
	            M : 'месяц',
	            MM : be__relativeTimeWithPlural,
	            y : 'год',
	            yy : be__relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : bulgarian (bg)
	    //! author : Krasen Borisov : https://github.com/kraz
	
	    var bg = _moment__default.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Bengali (bn)
	    //! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	    var bn__symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    bn__numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = _moment__default.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রুবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্রু_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কএক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return bn__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return bn__symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকেল|রাত/,
	        isPM: function (input) {
	            return /^(দুপুর|বিকেল|রাত)$/.test(input);
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকেল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : tibetan (bo)
	    //! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	    var bo__symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    bo__numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = _moment__default.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return bo__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return bo__symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function (input) {
	            return /^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : breton (br)
	    //! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = _moment__default.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : bosnian (bs)
	    //! author : Nedim Cholich : https://github.com/frontyard
	    //! based on (hr) translation by Bojan Marković
	
	    function bs__translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = _moment__default.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : bs__translate,
	            mm     : bs__translate,
	            h      : bs__translate,
	            hh     : bs__translate,
	            d      : 'dan',
	            dd     : bs__translate,
	            M      : 'mjesec',
	            MM     : bs__translate,
	            y      : 'godinu',
	            yy     : bs__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : catalan (ca)
	    //! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	    var ca = _moment__default.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'LT:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : czech (cs)
	    //! author : petrbela : https://github.com/petrbela
	
	    var cs__months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        cs__monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function cs__plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function cs__translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (cs__plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (cs__plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (cs__plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (cs__plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (cs__plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = _moment__default.defineLocale('cs', {
	        months : cs__months,
	        monthsShort : cs__monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(cs__months, cs__monthsShort)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : cs__translate,
	            m : cs__translate,
	            mm : cs__translate,
	            h : cs__translate,
	            hh : cs__translate,
	            d : cs__translate,
	            dd : cs__translate,
	            M : cs__translate,
	            MM : cs__translate,
	            y : cs__translate,
	            yy : cs__translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : chuvash (cv)
	    //! author : Anatoly Mironov : https://github.com/mirontoli
	
	    var cv = _moment__default.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Welsh (cy)
	    //! author : Robert Allen
	
	    var cy = _moment__default.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : danish (da)
	    //! author : Ulrik Nielsen : https://github.com/mrbase
	
	    var da = _moment__default.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : austrian german (de-at)
	    //! author : lluchs : https://github.com/lluchs
	    //! author: Menelion Elensúle: https://github.com/Oire
	    //! author : Martin Groller : https://github.com/MadMG
	
	    function de_at__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = _moment__default.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : de_at__processRelativeTime,
	            mm : '%d Minuten',
	            h : de_at__processRelativeTime,
	            hh : '%d Stunden',
	            d : de_at__processRelativeTime,
	            dd : de_at__processRelativeTime,
	            M : de_at__processRelativeTime,
	            MM : de_at__processRelativeTime,
	            y : de_at__processRelativeTime,
	            yy : de_at__processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : german (de)
	    //! author : lluchs : https://github.com/lluchs
	    //! author: Menelion Elensúle: https://github.com/Oire
	
	    function de__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = _moment__default.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : de__processRelativeTime,
	            mm : '%d Minuten',
	            h : de__processRelativeTime,
	            hh : '%d Stunden',
	            d : de__processRelativeTime,
	            dd : de__processRelativeTime,
	            M : de__processRelativeTime,
	            MM : de__processRelativeTime,
	            y : de__processRelativeTime,
	            yy : de__processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : modern greek (el)
	    //! author : Aggelos Karalias : https://github.com/mehiel
	
	    var el = _moment__default.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (typeof output === 'function') {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : australian english (en-au)
	
	    var en_au = _moment__default.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : canadian english (en-ca)
	    //! author : Jonathan Abourbih : https://github.com/jonbca
	
	    var en_ca = _moment__default.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM, YYYY',
	            LLL : 'D MMMM, YYYY h:mm A',
	            LLLL : 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : great britain english (en-gb)
	    //! author : Chris Gedrim : https://github.com/chrisgedrim
	
	    var en_gb = _moment__default.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : esperanto (eo)
	    //! author : Colin Dean : https://github.com/colindean
	    //! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	    //!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	    var eo = _moment__default.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : spanish (es)
	    //! author : Julio Napurí : https://github.com/julionc
	
	    var monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
	        es__monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_');
	
	    var es = _moment__default.defineLocale('es', {
	        months : 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return es__monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays : 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mié._Jue._Vie._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : estonian (et)
	    //! author : Henry Kehlmann : https://github.com/madhenry
	    //! improvements : Illimar Tambek : https://github.com/ragulka
	
	    function et__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = _moment__default.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : et__processRelativeTime,
	            m      : et__processRelativeTime,
	            mm     : et__processRelativeTime,
	            h      : et__processRelativeTime,
	            hh     : et__processRelativeTime,
	            d      : et__processRelativeTime,
	            dd     : '%d päeva',
	            M      : et__processRelativeTime,
	            MM     : et__processRelativeTime,
	            y      : et__processRelativeTime,
	            yy     : et__processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : euskara (eu)
	    //! author : Eneko Illarramendi : https://github.com/eillarra
	
	    var eu = _moment__default.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Persian (fa)
	    //! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	    var fa__symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, fa__numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = _moment__default.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return fa__numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return fa__symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : finnish (fi)
	    //! author : Tarmo Aidantausta : https://github.com/bleadof
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function fi__translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = _moment__default.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : fi__translate,
	            m : fi__translate,
	            mm : fi__translate,
	            h : fi__translate,
	            hh : fi__translate,
	            d : fi__translate,
	            dd : fi__translate,
	            M : fi__translate,
	            MM : fi__translate,
	            y : fi__translate,
	            yy : fi__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : faroese (fo)
	    //! author : Ragnar Johannesen : https://github.com/ragnar123
	
	    var fo = _moment__default.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : canadian french (fr-ca)
	    //! author : Jonathan Abourbih : https://github.com/jonbca
	
	    var fr_ca = _moment__default.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : french (fr)
	    //! author : John Fischer : https://github.com/jfroffice
	
	    var fr = _moment__default.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : frisian (fy)
	    //! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	    var fy__monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        fy__monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = _moment__default.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return fy__monthsShortWithoutDots[m.month()];
	            } else {
	                return fy__monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : galician (gl)
	    //! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	    var gl = _moment__default.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Hebrew (he)
	    //! author : Tomer Cohen : https://github.com/tomer
	    //! author : Moshe Simantov : https://github.com/DevelopmentIL
	    //! author : Tal Ater : https://github.com/TalAter
	
	    var he = _moment__default.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : hindi (hi)
	    //! author : Mayank Singhal : https://github.com/mayanksinghal
	
	    var hi__symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    hi__numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = _moment__default.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return hi__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return hi__symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : hrvatski (hr)
	    //! author : Bojan Marković : https://github.com/bmarkovic
	
	    function hr__translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = _moment__default.defineLocale('hr', {
	        months : 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : hr__translate,
	            mm     : hr__translate,
	            h      : hr__translate,
	            hh     : hr__translate,
	            d      : 'dan',
	            dd     : hr__translate,
	            M      : 'mjesec',
	            MM     : hr__translate,
	            y      : 'godinu',
	            yy     : hr__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : hungarian (hu)
	    //! author : Adam Brunner : https://github.com/adambrunner
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function hu__translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = _moment__default.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : hu__translate,
	            m : hu__translate,
	            mm : hu__translate,
	            h : hu__translate,
	            hh : hu__translate,
	            d : hu__translate,
	            dd : hu__translate,
	            M : hu__translate,
	            MM : hu__translate,
	            y : hu__translate,
	            yy : hu__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Armenian (hy-am)
	    //! author : Armendarabyan : https://github.com/armendarabyan
	
	    function hy_am__monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
	            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function hy_am__monthsShortCaseReplace(m, format) {
	        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');
	        return monthsShort[m.month()];
	    }
	    function hy_am__weekdaysCaseReplace(m, format) {
	        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');
	        return weekdays[m.day()];
	    }
	
	    var hy_am = _moment__default.defineLocale('hy-am', {
	        months : hy_am__monthsCaseReplace,
	        monthsShort : hy_am__monthsShortCaseReplace,
	        weekdays : hy_am__weekdaysCaseReplace,
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Bahasa Indonesia (id)
	    //! author : Mohammad Satrio Utomo : https://github.com/tyok
	    //! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	    var id = _moment__default.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : icelandic (is)
	    //! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	    function is__plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function is__translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (is__plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (is__plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (is__plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (is__plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (is__plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = _moment__default.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : is__translate,
	            m : is__translate,
	            mm : is__translate,
	            h : 'klukkustund',
	            hh : is__translate,
	            d : is__translate,
	            dd : is__translate,
	            M : is__translate,
	            MM : is__translate,
	            y : is__translate,
	            yy : is__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : italian (it)
	    //! author : Lorenzo : https://github.com/aliem
	    //! author: Mattia Larentis: https://github.com/nostalgiaz
	
	    var it = _moment__default.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'D_L_Ma_Me_G_V_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : japanese (ja)
	    //! author : LI Long : https://github.com/baryon
	
	    var ja = _moment__default.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Boso Jowo (jv)
	    //! author : Rony Lantip : https://github.com/lantip
	    //! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	    var jv = _moment__default.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Georgian (ka)
	    //! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	    function ka__monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        nounCase = (/D[oD] *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function ka__weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
	        },
	        nounCase = (/(წინა|შემდეგ)/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ka = _moment__default.defineLocale('ka', {
	        months : ka__monthsCaseReplace,
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : ka__weekdaysCaseReplace,
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : khmer (km)
	    //! author : Kruy Vanna : https://github.com/kruyvanna
	
	    var km = _moment__default.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : korean (ko)
	    //!
	    //! authors
	    //!
	    //! - Kyungwook, Park : https://github.com/kyungw00k
	    //! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	    var ko = _moment__default.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한달',
	            MM : '%d달',
	            y : '일년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Luxembourgish (lb)
	    //! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	    function lb__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = _moment__default.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : lb__processRelativeTime,
	            mm : '%d Minutten',
	            h : lb__processRelativeTime,
	            hh : '%d Stonnen',
	            d : lb__processRelativeTime,
	            dd : '%d Deeg',
	            M : lb__processRelativeTime,
	            MM : '%d Méint',
	            y : lb__processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Lithuanian (lt)
	    //! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	    var lt__units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    },
	    weekDays = 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_');
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function lt__monthsCaseReplace(m, format) {
	        var months = {
	                'nominative': 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	                'accusative': 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_')
	            },
	            nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	                'accusative' :
	                'nominative';
	        return months[nounCase][m.month()];
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return lt__units[key].split('_');
	    }
	    function lt__translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    function relativeWeekDay(moment, format) {
	        var nominative = format.indexOf('dddd HH:mm') === -1,
	            weekDay = weekDays[moment.day()];
	        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + 'į';
	    }
	
	    var lt = _moment__default.defineLocale('lt', {
	        months : lt__monthsCaseReplace,
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : relativeWeekDay,
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : lt__translate,
	            h : translateSingular,
	            hh : lt__translate,
	            d : translateSingular,
	            dd : lt__translate,
	            M : translateSingular,
	            MM : lt__translate,
	            y : translateSingular,
	            yy : lt__translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : latvian (lv)
	    //! author : Kristaps Karlsons : https://github.com/skakri
	    //! author : Jānis Elmeris : https://github.com/JanisE
	
	    var lv__units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function lv__format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function lv__relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + lv__format(lv__units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return lv__format(lv__units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = _moment__default.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : lv__relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : lv__relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : lv__relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : lv__relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : lv__relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Montenegrin (me)
	    //! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	    var me__translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = me__translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + me__translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = _moment__default.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : me__translator.translate,
	            mm     : me__translator.translate,
	            h      : me__translator.translate,
	            hh     : me__translator.translate,
	            d      : 'dan',
	            dd     : me__translator.translate,
	            M      : 'mjesec',
	            MM     : me__translator.translate,
	            y      : 'godinu',
	            yy     : me__translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : macedonian (mk)
	    //! author : Borislav Mickov : https://github.com/B0k0
	
	    var mk = _moment__default.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : 'dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Во изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Во изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : malayalam (ml)
	    //! author : Floyd Pink : https://github.com/floydpink
	
	    var ml = _moment__default.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM : function (input) {
	            return /^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Marathi (mr)
	    //! author : Harshad Kale : https://github.com/kalehv
	
	    var mr__symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    mr__numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var mr = _moment__default.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s नंतर',
	            past : '%s पूर्वी',
	            s : 'सेकंद',
	            m: 'एक मिनिट',
	            mm: '%d मिनिटे',
	            h : 'एक तास',
	            hh : '%d तास',
	            d : 'एक दिवस',
	            dd : '%d दिवस',
	            M : 'एक महिना',
	            MM : '%d महिने',
	            y : 'एक वर्ष',
	            yy : '%d वर्षे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return mr__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return mr__symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Bahasa Malaysia (ms-MY)
	    //! author : Weldan Jamili : https://github.com/weldan
	
	    var ms_my = _moment__default.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Bahasa Malaysia (ms-MY)
	    //! author : Weldan Jamili : https://github.com/weldan
	
	    var locale_ms = _moment__default.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Burmese (my)
	    //! author : Squar team, mysquar.com
	
	    var my__symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, my__numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = _moment__default.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return my__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return my__symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : norwegian bokmål (nb)
	    //! authors : Espen Hovlandsdal : https://github.com/rexxars
	    //!           Sigurd Gartmann : https://github.com/sigurdga
	
	    var nb = _moment__default.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tirs_ons_tors_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'H.mm',
	            LTS : 'H.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H.mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] H.mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : nepali/nepalese
	    //! author : suvash : https://github.com/suvash
	
	    var ne__symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    ne__numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = _moment__default.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आइ._सो._मङ्_बु._बि._शु._श.'.split('_'),
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return ne__numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return ne__symbolMap[match];
	            });
	        },
	        meridiemParse: /राती|बिहान|दिउँसो|बेलुका|साँझ|राती/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 3 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'बेलुका' || meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राती';
	            } else if (hour < 10) {
	                return 'बिहान';
	            } else if (hour < 15) {
	                return 'दिउँसो';
	            } else if (hour < 18) {
	                return 'बेलुका';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राती';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोली] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडी',
	            s : 'केही समय',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : dutch (nl)
	    //! author : Joris Röling : https://github.com/jjupiter
	
	    var nl__monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        nl__monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = _moment__default.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return nl__monthsShortWithoutDots[m.month()];
	            } else {
	                return nl__monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : norwegian nynorsk (nn)
	    //! author : https://github.com/mechuwind
	
	    var nn = _moment__default.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : polish (pl)
	    //! author : Rafal Hirsz : https://github.com/evoL
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function pl__plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function pl__translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (pl__plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (pl__plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (pl__plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (pl__plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = _moment__default.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : pl__translate,
	            mm : pl__translate,
	            h : pl__translate,
	            hh : pl__translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : pl__translate,
	            y : 'rok',
	            yy : pl__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : brazilian portuguese (pt-br)
	    //! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	    var pt_br = _moment__default.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    //! moment.js locale configuration
	    //! locale : portuguese (pt)
	    //! author : Jefferson : https://github.com/jalex79
	
	    var pt = _moment__default.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : romanian (ro)
	    //! author : Vlad Gurdiga : https://github.com/gurdiga
	    //! author : Valentin Agachi : https://github.com/avaly
	
	    function ro__relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = _moment__default.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : ro__relativeTimeWithPlural,
	            h : 'o oră',
	            hh : ro__relativeTimeWithPlural,
	            d : 'o zi',
	            dd : ro__relativeTimeWithPlural,
	            M : 'o lună',
	            MM : ro__relativeTimeWithPlural,
	            y : 'un an',
	            yy : ro__relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : russian (ru)
	    //! author : Viktorminator : https://github.com/Viktorminator
	    //! Author : Menelion Elensúle : https://github.com/Oire
	
	    function ru__plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function ru__relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + ru__plural(format[key], +number);
	        }
	    }
	    function ru__monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function ru__monthsShortCaseReplace(m, format) {
	        var monthsShort = {
	            'nominative': 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return monthsShort[nounCase][m.month()];
	    }
	    function ru__weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ru = _moment__default.defineLocale('ru', {
	        months : ru__monthsCaseReplace,
	        monthsShort : ru__monthsShortCaseReplace,
	        weekdays : ru__weekdaysCaseReplace,
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function () {
	                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : ru__relativeTimeWithPlural,
	            mm : ru__relativeTimeWithPlural,
	            h : 'час',
	            hh : ru__relativeTimeWithPlural,
	            d : 'день',
	            dd : ru__relativeTimeWithPlural,
	            M : 'месяц',
	            MM : ru__relativeTimeWithPlural,
	            y : 'год',
	            yy : ru__relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Sinhalese (si)
	    //! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	    var si = _moment__default.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : slovak (sk)
	    //! author : Martin Minka : https://github.com/k2s
	    //! based on work of petrbela : https://github.com/petrbela
	
	    var sk__months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        sk__monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function sk__plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function sk__translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (sk__plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (sk__plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (sk__plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (sk__plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (sk__plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = _moment__default.defineLocale('sk', {
	        months : sk__months,
	        monthsShort : sk__monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(sk__months, sk__monthsShort)),
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : sk__translate,
	            m : sk__translate,
	            mm : sk__translate,
	            h : sk__translate,
	            hh : sk__translate,
	            d : sk__translate,
	            dd : sk__translate,
	            M : sk__translate,
	            MM : sk__translate,
	            y : sk__translate,
	            yy : sk__translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : slovenian (sl)
	    //! author : Robert Sedovšek : https://github.com/sedovsek
	
	    function sl__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = _moment__default.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : sl__processRelativeTime,
	            m      : sl__processRelativeTime,
	            mm     : sl__processRelativeTime,
	            h      : sl__processRelativeTime,
	            hh     : sl__processRelativeTime,
	            d      : sl__processRelativeTime,
	            dd     : sl__processRelativeTime,
	            M      : sl__processRelativeTime,
	            MM     : sl__processRelativeTime,
	            y      : sl__processRelativeTime,
	            yy     : sl__processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Albanian (sq)
	    //! author : Flakërim Ismani : https://github.com/flakerimi
	    //! author: Menelion Elensúle: https://github.com/Oire (tests)
	    //! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	    var sq = _moment__default.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Serbian-cyrillic (sr-cyrl)
	    //! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	    var sr_cyrl__translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = sr_cyrl__translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + sr_cyrl__translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = _moment__default.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : sr_cyrl__translator.translate,
	            mm     : sr_cyrl__translator.translate,
	            h      : sr_cyrl__translator.translate,
	            hh     : sr_cyrl__translator.translate,
	            d      : 'дан',
	            dd     : sr_cyrl__translator.translate,
	            M      : 'месец',
	            MM     : sr_cyrl__translator.translate,
	            y      : 'годину',
	            yy     : sr_cyrl__translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Serbian-latin (sr)
	    //! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	    var sr__translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = sr__translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + sr__translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = _moment__default.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : sr__translator.translate,
	            mm     : sr__translator.translate,
	            h      : sr__translator.translate,
	            hh     : sr__translator.translate,
	            d      : 'dan',
	            dd     : sr__translator.translate,
	            M      : 'mesec',
	            MM     : sr__translator.translate,
	            y      : 'godinu',
	            yy     : sr__translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : swedish (sv)
	    //! author : Jens Alm : https://github.com/ulmus
	
	    var sv = _moment__default.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : tamil (ta)
	    //! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	    var ta = _moment__default.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : thai (th)
	    //! author : Kridsada Thanabulpong : https://github.com/sirn
	
	    var th = _moment__default.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Tagalog/Filipino (tl-ph)
	    //! author : Dan Hagman
	
	    var tl_ph = _moment__default.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : turkish (tr)
	    //! authors : Erhan Gundogan : https://github.com/erhangundogan,
	    //!           Burak Yiğit Kaya: https://github.com/BYK
	
	    var tr__suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = _moment__default.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (tr__suffixes[a] || tr__suffixes[b] || tr__suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : talossan (tzl)
	    //! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	
	    var tzl = _moment__default.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'LT.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY LT',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY LT'
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : tzl__processRelativeTime,
	            m : tzl__processRelativeTime,
	            mm : tzl__processRelativeTime,
	            h : tzl__processRelativeTime,
	            hh : tzl__processRelativeTime,
	            d : tzl__processRelativeTime,
	            dd : tzl__processRelativeTime,
	            M : tzl__processRelativeTime,
	            MM : tzl__processRelativeTime,
	            y : tzl__processRelativeTime,
	            yy : tzl__processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function tzl__processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', ' ' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', ' ' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', ' ' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', ' ' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', ' ' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1].trim());
	    }
	
	    //! moment.js locale configuration
	    //! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	    //! author : Abdel Said : https://github.com/abdelsaid
	
	    var tzm_latn = _moment__default.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : Morocco Central Atlas Tamaziɣt (tzm)
	    //! author : Abdel Said : https://github.com/abdelsaid
	
	    var tzm = _moment__default.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : ukrainian (uk)
	    //! author : zemlanin : https://github.com/zemlanin
	    //! Author : Menelion Elensúle : https://github.com/Oire
	
	    function uk__plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function uk__relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'хвилина_хвилини_хвилин',
	            'hh': 'година_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + uk__plural(format[key], +number);
	        }
	    }
	    function uk__monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
	            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
	        },
	        nounCase = (/D[oD]? *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function uk__weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = _moment__default.defineLocale('uk', {
	        months : uk__monthsCaseReplace,
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : uk__weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : uk__relativeTimeWithPlural,
	            mm : uk__relativeTimeWithPlural,
	            h : 'годину',
	            hh : uk__relativeTimeWithPlural,
	            d : 'день',
	            dd : uk__relativeTimeWithPlural,
	            M : 'місяць',
	            MM : uk__relativeTimeWithPlural,
	            y : 'рік',
	            yy : uk__relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : uzbek (uz)
	    //! author : Sardor Muminov : https://github.com/muminoff
	
	    var uz = _moment__default.defineLocale('uz', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : vietnamese (vi)
	    //! author : Bang Nguyen : https://github.com/bangnk
	
	    var vi = _moment__default.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : chinese (zh-cn)
	    //! author : suupic : https://github.com/suupic
	    //! author : Zeno Zeng : https://github.com/zenozeng
	
	    var zh_cn = _moment__default.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = _moment__default().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = _moment__default().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	    //! locale : traditional chinese (zh-tw)
	    //! author : Ben : https://github.com/ben-lin
	
	    var zh_tw = _moment__default.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '一分鐘',
	            mm : '%d分鐘',
	            h : '一小時',
	            hh : '%d小時',
	            d : '一天',
	            dd : '%d天',
	            M : '一個月',
	            MM : '%d個月',
	            y : '一年',
	            yy : '%d年'
	        }
	    });
	
	    var moment_with_locales = _moment__default;
	    moment_with_locales.locale('en');
	
	    return moment_with_locales;
	
	}));

/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.4.5
	 * (c) 2010-2015 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, document, undefined) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.4.5/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  shallowCopy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives.
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	  if (obj == null || isWindow(obj)) {
	    return false;
	  }
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  if (obj.nodeType === NODE_TYPE_ELEMENT && length) {
	    return true;
	  }
	
	  return isString(obj) || isArray(obj) || length === 0 ||
	         typeof length === 'number' && length > 0 && (length - 1) in obj;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * Providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) { iteratorFn(key, value); };
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	     function transformer(transformationFn, value) {
	       return (transformationFn || angular.identity)(value);
	     };
	   ```
	  * @param {*} value to be returned.
	  * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== Object.prototype.toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (Uint8(Clamped)?)|(Uint16)|(Uint32)|(Int8)|(Int16)|(Int32)|(Float(32)|(64))Array\]$/;
	function isTypedArray(value) {
	  return TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // we are a direct element
	    || (node.prop && node.attr && node.find)));  // we have an on and find method part of jQuery API
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(","), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to 'destination' an exception will be thrown.
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	 <example module="copyExample">
	 <file name="index.html">
	 <div ng-controller="ExampleController">
	 <form novalidate class="simple-form">
	 Name: <input type="text" ng-model="user.name" /><br />
	 E-mail: <input type="email" ng-model="user.email" /><br />
	 Gender: <input type="radio" ng-model="user.gender" value="male" />male
	 <input type="radio" ng-model="user.gender" value="female" />female<br />
	 <button ng-click="reset()">RESET</button>
	 <button ng-click="update(user)">SAVE</button>
	 </form>
	 <pre>form = {{user | json}}</pre>
	 <pre>master = {{master | json}}</pre>
	 </div>
	
	 <script>
	  angular.module('copyExample', [])
	    .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	 </script>
	 </file>
	 </example>
	 */
	function copy(source, destination, stackSource, stackDest) {
	  if (isWindow(source) || isScope(source)) {
	    throw ngMinErr('cpws',
	      "Can't copy! Making copies of Window or Scope instances is not supported.");
	  }
	  if (isTypedArray(destination)) {
	    throw ngMinErr('cpta',
	      "Can't copy! TypedArray destination cannot be mutated.");
	  }
	
	  if (!destination) {
	    destination = source;
	    if (isObject(source)) {
	      var index;
	      if (stackSource && (index = stackSource.indexOf(source)) !== -1) {
	        return stackDest[index];
	      }
	
	      // TypedArray, Date and RegExp have specific copy functionality and must be
	      // pushed onto the stack before returning.
	      // Array and other objects create the base object and recurse to copy child
	      // objects. The array/object will be pushed onto the stack when recursed.
	      if (isArray(source)) {
	        return copy(source, [], stackSource, stackDest);
	      } else if (isTypedArray(source)) {
	        destination = new source.constructor(source);
	      } else if (isDate(source)) {
	        destination = new Date(source.getTime());
	      } else if (isRegExp(source)) {
	        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        destination.lastIndex = source.lastIndex;
	      } else {
	        var emptyObject = Object.create(getPrototypeOf(source));
	        return copy(source, emptyObject, stackSource, stackDest);
	      }
	
	      if (stackDest) {
	        stackSource.push(source);
	        stackDest.push(destination);
	      }
	    }
	  } else {
	    if (source === destination) throw ngMinErr('cpi',
	      "Can't copy! Source and destination are identical.");
	
	    stackSource = stackSource || [];
	    stackDest = stackDest || [];
	
	    if (isObject(source)) {
	      stackSource.push(source);
	      stackDest.push(destination);
	    }
	
	    var result, key;
	    if (isArray(source)) {
	      destination.length = 0;
	      for (var i = 0; i < source.length; i++) {
	        destination.push(copy(source[i], null, stackSource, stackDest));
	      }
	    } else {
	      var h = destination.$$hashKey;
	      if (isArray(destination)) {
	        destination.length = 0;
	      } else {
	        forEach(destination, function(value, key) {
	          delete destination[key];
	        });
	      }
	      if (isBlankObject(source)) {
	        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	        for (key in source) {
	          destination[key] = copy(source[key], null, stackSource, stackDest);
	        }
	      } else if (source && typeof source.hasOwnProperty === 'function') {
	        // Slow path, which must rely on hasOwnProperty
	        for (key in source) {
	          if (source.hasOwnProperty(key)) {
	            destination[key] = copy(source[key], null, stackSource, stackDest);
	          }
	        }
	      } else {
	        // Slowest path --- hasOwnProperty can't be called as a method
	        for (key in source) {
	          if (hasOwnProperty.call(source, key)) {
	            destination[key] = copy(source[key], null, stackSource, stackDest);
	          }
	        }
	      }
	      setHashKey(destination,h);
	    }
	  }
	  return destination;
	}
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2) {
	    if (t1 == 'object') {
	      if (isArray(o1)) {
	        if (!isArray(o2)) return false;
	        if ((length = o1.length) == o2.length) {
	          for (key = 0; key < length; key++) {
	            if (!equals(o1[key], o2[key])) return false;
	          }
	          return true;
	        }
	      } else if (isDate(o1)) {
	        if (!isDate(o2)) return false;
	        return equals(o1.getTime(), o2.getTime());
	      } else if (isRegExp(o1)) {
	        return isRegExp(o2) ? o1.toString() == o2.toString() : false;
	      } else {
	        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	          isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	        keySet = createMap();
	        for (key in o1) {
	          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	          if (!equals(o1[key], o2[key])) return false;
	          keySet[key] = true;
	        }
	        for (key in o2) {
	          if (!(key in keySet) &&
	              key.charAt(0) !== '$' &&
	              o2[key] !== undefined &&
	              !isFunction(o2[key])) return false;
	        }
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (document.querySelector('[ng-csp]') ||
	                    document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // in IE, native methods are not functions so they cannot be bound (note: they don't need to be)
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 */
	function toJson(obj, pretty) {
	  if (typeof obj === 'undefined') return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	function timezoneToOffset(timezone, fallback) {
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
	  return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) { return '<' + lowercase(nodeName); });
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * Only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 * found in the document will be used to define the root element to auto-bootstrap as an
	 * application. To run multiple applications in an HTML document you must manually bootstrap them using
	 * {@link angular.bootstrap} instead. AngularJS applications cannot be nested within each other.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * See: {@link guide/bootstrap Bootstrap}
	 *
	 * Note that Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === document) ? 'document' : startingTag(element);
	      //Encode angle brackets to prevent input from being sanitized to empty string #8683
	      throw ngMinErr(
	          'btstrpd',
	          "App Already Bootstrapped with this Element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	var skipDestroyOnNextJQueryCleanData;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = window.jQuery; // use default jQuery.
	  if (isDefined(jqName)) { // `ngJq` present
	    jQuery = jqName === null ? undefined : window[jqName]; // if empty; use jqLite. if not empty, use jQuery specified by `ngJq`.
	  }
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      if (!skipDestroyOnNextJQueryCleanData) {
	        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	          events = jQuery._data(elem, "events");
	          if (events && events.$destroy) {
	            jQuery(elem).triggerHandler('$destroy');
	          }
	        }
	      } else {
	        skipDestroyOnNextJQueryCleanData = false;
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {jqLite} jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
	  //             collection, otherwise update the original collection.
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes = [node];
	
	  do {
	    node = node.nextSibling;
	    if (!node) break;
	    blockNodes.push(node);
	  } while (node !== endNode);
	
	  return jqLite(blockNodes);
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constant are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} The name of the service to decorate.
	           * @param {Function} This function will be invoked when the service needs to be
	           *                                    instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global: toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '<<already seen>>';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (typeof obj === 'undefined') {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateQueueProvider,
	  $$CoreAnimateRunnerProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version. This object has the
	 * following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.4.5',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 4,
	  dot: 5,
	  codeName: 'permanent-internship'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$CoreAnimateRunnerProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or "jqLite."
	 *
	 * <div class="alert alert-success">jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. **jqLite** implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.</div>
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file.
	 *
	 * <div class="alert">**Note:** all element references in Angular are always wrapped with jQuery or
	 * jqLite; they are never raw DOM references.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/)
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`. As a setter, does not convert numbers to strings or append 'px'.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/)
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/)
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers.
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = tmp || fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	    forEach(type.split(' '), function(type) {
	      if (isDefined(fn)) {
	        var listenerFns = events[type];
	        arrayRemove(listenerFns || [], fn);
	        if (listenerFns && listenerFns.length > 0) {
	          return;
	        }
	      }
	
	      removeEventListenerFn(element, type, handle);
	      delete events[type];
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if ((value = jqLite.data(element, names[i])) !== undefined) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behaviour
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (document.readyState === 'complete') {
	      setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(element, name) {
	  var nodeName = element.nodeName;
	  return (nodeName === 'INPUT' || nodeName === 'TEXTAREA') && ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2) === undefined)) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (value === undefined) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        eventFns[i].call(element, event);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    while (i--) {
	      type = types[i];
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        events[type] = [];
	
	        if (type === 'mouseenter' || type === 'mouseleave') {
	          // Refer to jQuery's implementation of mouseenter & mouseleave
	          // Read about mouseenter and mouseleave:
	          // http://www.quirksmode.org/js/events_mouse.html#link8
	
	          jqLiteOn(element, MOUSE_EVENT_MAP[type], function(event) {
	            var target = this, related = event.relatedTarget;
	            // For mousenter/leave call the handler if related is outside the target.
	            // NB: No relatedTarget if the mouse left/entered the browser window
	            if (!related || (related !== target && !target.contains(related))) {
	              handle(event, type);
	            }
	          });
	
	        } else {
	          if (type !== '$destroy') {
	            addEventListenerFn(element, type, handle);
	          }
	        }
	        eventFns = events[type];
	      }
	      eventFns.push(fn);
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    wrapNode = jqLite(wrapNode).eq(0).clone()[0];
	    var parent = element.parentNode;
	    if (parent) {
	      parent.replaceChild(wrapNode, element);
	    }
	    wrapNode.appendChild(element);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var fnText = fn.toString().replace(STRIP_COMMENTS, ''),
	      args = fnText.match(FN_ARGS);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      fnText,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        fnText = fn.toString().replace(STRIP_COMMENTS, '');
	        argDecl = fnText.match(FN_ARGS);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(fn)} - registers a service **factory function**, `fn`,
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(class)} - registers a **constructor function**, `class`
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is the service
	 * constructor function that will be used to instantiate the service instance.
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function.  This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular
	 * {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service**, such as a string, a number, an array, an object or a function,
	 * with the {@link auto.$injector $injector}. Unlike {@link auto.$provide#value value} it can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **service decorator** with the {@link auto.$injector $injector}. A service decorator
	 * intercepts the creation of a service, allowing it to override or modify the behaviour of the
	 * service. The object returned by the decorator may be the original service, or a new service
	 * object which replaces or wraps and delegates to the original service.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    instantiated and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      instanceInjector = (instanceCache.$injector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
	          }));
	
	
	  forEach(loadModules(modulesToLoad), function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName),
	          length, i,
	          key;
	
	      for (i = 0, length = $inject.length; i < length; i++) {
	        key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(
	          locals && locals.hasOwnProperty(key)
	          ? locals[key]
	          : getService(key, serviceName)
	        );
	      }
	      if (isArray(fn)) {
	        fn = fn[length];
	      }
	
	      // http://jsperf.com/angularjs-invoke-apply-vs-switch
	      // #5388
	      return fn.apply(self, args);
	    }
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      // Object creation: http://jsperf.com/create-constructor/2
	      var instance = Object.create((isArray(Type) ? Type[Type.length - 1] : Type).prototype || null);
	      var returnedValue = invoke(Type, instance, locals, serviceName);
	
	      return isObject(returnedValue) || isFunction(returnedValue) ? returnedValue : instance;
	    }
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://dev.w3.org/html5/spec/Overview.html#the-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateRunnerProvider = function() {
	  this.$get = ['$q', '$$rAF', function($q, $$rAF) {
	    function AnimateRunner() {}
	    AnimateRunner.all = noop;
	    AnimateRunner.chain = noop;
	    AnimateRunner.prototype = {
	      end: noop,
	      cancel: noop,
	      resume: noop,
	      pause: noop,
	      complete: noop,
	      then: function(pass, fail) {
	        return $q(function(resolve) {
	          $$rAF(function() {
	            resolve();
	          });
	        }).then(pass, fail);
	      }
	    };
	    return AnimateRunner;
	  }];
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        return new $$AnimateRunner(); // jshint ignore:line
	      }
	    };
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var classVal, data = postDigestQueue.get(element);
	
	      if (!data) {
	        postDigestQueue.put(element, data = {});
	        postDigestElements.push(element);
	      }
	
	      var updateData = function(classes, value) {
	        var changed = false;
	        if (classes) {
	          classes = isString(classes) ? classes.split(' ') :
	                    isArray(classes) ? classes : [];
	          forEach(classes, function(className) {
	            if (className) {
	              changed = true;
	              data[className] = value;
	            }
	          });
	        }
	        return changed;
	      };
	
	      var classesAdded = updateData(add, true);
	      var classesRemoved = updateData(remove, false);
	      if ((!classesAdded && !classesRemoved) || postDigestElements.length > 1) return;
	
	      $rootScope.$$postDigest(function() {
	        forEach(postDigestElements, function(element) {
	          var data = postDigestQueue.get(element);
	          if (data) {
	            var existing = splitClasses(element.attr('class'));
	            var toAdd = '';
	            var toRemove = '';
	            forEach(data, function(status, className) {
	              var hasClass = !!existing[className];
	              if (status !== hasClass) {
	                if (status) {
	                  toAdd += (toAdd.length ? ' ' : '') + className;
	                } else {
	                  toRemove += (toRemove.length ? ' ' : '') + className;
	                }
	              }
	            });
	
	            forEach(element, function(elm) {
	              toAdd    && jqLiteAddClass(elm, toAdd);
	              toRemove && jqLiteRemoveClass(elm, toRemove);
	            });
	            postDigestQueue.remove(element);
	          }
	        });
	
	        postDigestElements.length = 0;
	      });
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger an animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `listenerFn` that is set
	       * // to listen for `enter` on the given `element` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string} event the animation event (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className then the provided from and
	       * to styles will be applied alongside the given transition. If a JavaScript animation is detected then the provided styles
	       * will be given in as function paramters into the `animate` method (or as apart of the `options` parameter).
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be appplied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', function($$rAF, $q) {
	
	    var RAFPromise = function() {};
	    RAFPromise.prototype = {
	      done: function(cancel) {
	        this.defer && this.defer[cancel === true ? 'reject' : 'resolve']();
	      },
	      end: function() {
	        this.done();
	      },
	      cancel: function() {
	        this.done(true);
	      },
	      getPromise: function() {
	        if (!this.defer) {
	          this.defer = $q.defer();
	        }
	        return this.defer.promise;
	      },
	      then: function(f1,f2) {
	        return this.getPromise().then(f1,f2);
	      },
	      'catch': function(f1) {
	        return this.getPromise()['catch'](f1);
	      },
	      'finally': function(f1) {
	        return this.getPromise()['finally'](f1);
	      }
	    };
	
	    return function(element, options) {
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new RAFPromise();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          close();
	          if (!closed) {
	            runner.done();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function close() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      rawDocument = document[0],
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      reloadLocation = null;
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase || reloadLocation) {
	          reloadLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	      }
	      return self;
	    // getter
	    } else {
	      // - reloadLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened.
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return reloadLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    cacheState();
	    fireUrlChange();
	  }
	
	  function getCurrentState() {
	    try {
	      return history.state;
	    } catch (e) {
	      // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	    }
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if ($scope.cache.get(key) === undefined) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, value === undefined ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = {},
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = {},
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = {};
	          size = 0;
	          lruHash = {};
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	 * or just the `postLink` function (all other properties will have the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioural (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * **If set to `true`,** then a new scope will be created for this directive. If multiple directives on the
	 * same element request a new scope, only one new scope is created. The new scope rule does not
	 * apply for the root of the template since the root of the template always gets a new scope.
	 *
	 * **If set to `{}` (object hash),** then a new "isolate" scope is created. The 'isolate' scope differs from
	 * normal scope in that it does not prototypically inherit from the parent scope. This is useful
	 * when creating reusable components, which should not accidentally read or modify data in the
	 * parent scope.
	 *
	 * The 'isolate' scope takes an object hash which defines a set of local scope properties
	 * derived from the parent scope. These local properties are useful for aliasing values for
	 * templates. Locals definition is a hash of local scope property to its source:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified  then the
	 *   attribute name is assumed to be the same as the local name.
	 *   Given `<widget my-attr="hello {{name}}">` and widget definition
	 *   of `scope: { localName:'@myAttr' }`, then widget scope property `localName` will reflect
	 *   the interpolated value of `hello {{name}}`. As the `name` attribute changes so will the
	 *   `localName` property on the widget scope. The `name` is read from the parent scope (not
	 *   component scope).
	 *
	 * * `=` or `=attr` - set up bi-directional binding between a local scope property and the
	 *   parent scope property of name defined via the value of the `attr` attribute. If no `attr`
	 *   name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<widget my-attr="parentModel">` and widget definition of
	 *   `scope: { localModel:'=myAttr' }`, then widget scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel` and any changes in `localModel` will reflect in `parentModel`. If the parent
	 *   scope property doesn't exist, it will throw a NON_ASSIGNABLE_MODEL_EXPRESSION exception. You
	 *   can avoid this behavior using `=?` or `=?attr` in order to flag the property as optional. If
	 *   you want to shallow watch for changes (i.e. $watchCollection instead of $watch) you can use
	 *   `=*` or `=*attr` (`=*?` or `=*?attr` if the property is optional).
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. Given `<widget my-attr="count = count + value">` and widget definition of
	 *   `scope: { localFn:'&myAttr' }`, then isolate scope property `localFn` will point to
	 *   a function wrapper for the `count = count + value` expression. Often it's desirable to
	 *   pass data from the isolated scope via an expression to the parent scope, this can be
	 *   done by passing a map of local variable names and values into the expression wrapper fn.
	 *   For example, if the expression is `increment(amount)` then we can specify the amount value
	 *   by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 *
	 * #### `bindToController`
	 * When an isolate scope is used for a component (see above), and `controllerAs` is used, `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope. When the controller
	 * is instantiated, the initial values of the isolate scope bindings are already available.
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and it is shared with other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement)`.
	 *    * `scope`: optional argument to override the scope.
	 *    * `cloneLinkingFn`: optional argument to create clones of the original transcluded content.
	 *    * `futureParentElement`:
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` takes a string name (or array of strings) of the directive(s) to pass in. If an array is used, the
	 * injected argument will be an array in corresponding order. If no such directive can be
	 * found, or if the directive does not have a controller, then an error is raised (unless no link function
	 * is specified, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. The directive
	 * needs to define a scope for this configuration to be used. Useful in the case when
	 * directive is used as component.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 * There are two kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element or the entire element:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and a
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude`
	 *     parameter of directive controllers, see there for details.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a translude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	 * ```
	 * - $rootScope
	 *   - isolate
	 *     - transclusion
	 * ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	 * ```
	 * - $rootScope
	 *   - transclusion
	 * - isolate
	 * ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * accessing *Normalized attribute names:*
	 * Directives like 'ngBind' can be expressed in many ways: 'ng:bind', `data-ng-bind`, or 'x-ng-bind'.
	 * the attributes object allows for normalized access to
	 *   the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to controller instances; if given, it will make the controllers
	 *        available to directives.
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = {};
	
	    forEach(scope, function(definition, scopeName) {
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See
	   *    {@link guide/directive} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	   this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = directive.require || (directive.controller && directive.name);
	                directive.restrict = directive.restrict || 'EA';
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$document', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $document,   $sce,   $animate,   $$sanitizeUri) {
	
	    var Attributes = function(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    };
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(node, key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && key === 'href') ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset') {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || value === undefined) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            this.$$element.attr(attrName, value);
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/directive#text-and-attribute-bindings Directives} guide for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' || endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      forEach($compileNodes, function(node, index) {
	        if (node.nodeType == NODE_TYPE_TEXT && node.nodeValue.match(/\S+/) /* non-empty */ ) {
	          $compileNodes[index] = jqLite(node).wrap('<span></span>').parent()[0];
	        }
	      });
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && node.toString().match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	              var destroyBindings = nodeLinkFn.$$destroyBindings;
	              if (destroyBindings) {
	                nodeLinkFn.$$destroyBindings = null;
	                childScope.$on('$destroyed', destroyBindings);
	              }
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn,
	                       nodeLinkFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	
	      var boundTranscludeFn = function(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      };
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var directiveNName = ngAttrName.replace(/(Start|End)$/, '');
	            if (directiveIsMultiElement(directiveNName)) {
	              if (ngAttrName === directiveNName + 'Start') {
	                attrStartName = name;
	                attrEndName = name.substr(0, name.length - 5) + 'end';
	                name = name.substr(0, name.length - 6);
	              }
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          try {
	            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	            if (match) {
	              nName = directiveNormalize(match[1]);
	              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[2]);
	              }
	            }
	          } catch (e) {
	            // turns out that under some circumstances IE9 throws errors when one attempts to read
	            // comment's node value.
	            // Just ignore it and continue. (Can't seem to reproduce in test case.)
	          }
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(document.createComment(' ' + directiveName + ': ' +
	                                              templateAttrs[directiveName] + ' '));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compile($template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compile($template, transcludeFn);
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective) {
	              markDirectivesAsIsolate(templateDirectives);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            if (isFunction(linkFn)) {
	              addLinkFns(null, linkFn, attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(linkFn.pre, linkFn.post, attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	
	      function getControllers(directiveName, require, $element, elementControllers) {
	        var value;
	
	        if (isString(require)) {
	          var match = require.match(REQUIRE_PREFIX_REGEXP);
	          var name = require.substring(match[0].length);
	          var inheritType = match[1] || match[3];
	          var optional = match[2] === '?';
	
	          //If only parents then start at the parent element
	          if (inheritType === '^^') {
	            $element = $element.parent();
	          //Otherwise attempt getting the controller from elementControllers in case
	          //the element is transcluded (and has no data) and to avoid .data if possible
	          } else {
	            value = elementControllers && elementControllers[name];
	            value = value && value.instance;
	          }
	
	          if (!value) {
	            var dataName = '$' + name + 'Controller';
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	
	          if (!value && !optional) {
	            throw $compileMinErr('ctreq',
	                "Controller '{0}', required by directive '{1}', can't be found!",
	                name, directiveName);
	          }
	        } else if (isArray(require)) {
	          value = [];
	          for (var i = 0, ii = require.length; i < ii; i++) {
	            value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	          }
	        }
	
	        return value || null;
	      }
	
	      function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope) {
	        var elementControllers = createMap();
	        for (var controllerKey in controllerDirectives) {
	          var directive = controllerDirectives[controllerKey];
	          var locals = {
	            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	            $element: $element,
	            $attrs: attrs,
	            $transclude: transcludeFn
	          };
	
	          var controller = directive.controller;
	          if (controller == '@') {
	            controller = attrs[directive.name];
	          }
	
	          var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	          // For directives with element transclusion the element is a comment,
	          // but jQuery .data doesn't support attaching data to comment nodes as it's hard to
	          // clean up (http://bugs.jquery.com/ticket/8335).
	          // Instead, we save the controllers for the element in a local hash and attach to .data
	          // later, once we have the actual element.
	          elementControllers[directive.name] = controllerInstance;
	          if (!hasElementTranscludeDirective) {
	            $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	          }
	        }
	        return elementControllers;
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn,
	                          thisLinkFn) {
	        var i, ii, linkFn, controller, isolateScope, elementControllers, transcludeFn, $element,
	            attrs;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          initializeDirectiveBindings(scope, attrs, isolateScope,
	                                      isolateScope.$$isolateBindings,
	                                      newIsolateScopeDirective, isolateScope);
	        }
	        if (elementControllers) {
	          // Initialize bindToController bindings for new/isolate scopes
	          var scopeDirective = newIsolateScopeDirective || newScopeDirective;
	          var bindings;
	          var controllerForBindings;
	          if (scopeDirective && elementControllers[scopeDirective.name]) {
	            bindings = scopeDirective.$$bindings.bindToController;
	            controller = elementControllers[scopeDirective.name];
	
	            if (controller && controller.identifier && bindings) {
	              controllerForBindings = controller;
	              thisLinkFn.$$destroyBindings =
	                  initializeDirectiveBindings(scope, attrs, controller.instance,
	                                              bindings, scopeDirective);
	            }
	          }
	          for (i in elementControllers) {
	            controller = elementControllers[i];
	            var controllerResult = controller();
	
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers and update the element data
	              controller.instance = controllerResult;
	              $element.data('$' + i + 'Controller', controllerResult);
	              if (controller === controllerForBindings) {
	                // Remove and re-install bindToController bindings
	                thisLinkFn.$$destroyBindings();
	                thisLinkFn.$$destroyBindings =
	                  initializeDirectiveBindings(scope, attrs, controllerResult, bindings, scopeDirective);
	              }
	            }
	          }
	        }
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement) {
	          var transcludeControllers;
	
	          // No scope passed in:
	          if (!isScope(scope)) {
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	        }
	      }
	    }
	
	    function markDirectivesAsIsolate(directives) {
	      // mark all directives as needing isolate scope.
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: true});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((maxPriority === undefined || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        if (key == 'class') {
	          safeAddClass($element, value);
	          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
	        } else if (key == 'style') {
	          $element.attr('style', $element.attr('style') + ';' + value);
	          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
	          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	          // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
	          dst[key] = value;
	          dstAttr[key] = srcAttr[key];
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              markDirectivesAsIsolate(templateDirectives);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn, afterTemplateNodeLinkFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn,
	                                  afterTemplateNodeLinkFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = {}));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // TODO(perf): what's this document fragment for? is it needed? can we at least reuse it?
	      var fragment = document.createDocumentFragment();
	      fragment.appendChild(firstElementToRemove);
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite(newNode).data(jqLite(firstElementToRemove).data());
	
	        // Remove data of the replaced element. We cannot just call .remove()
	        // on the element it since that would deallocate scope that is needed
	        // for the new node. Instead, remove the data "manually".
	        if (!jQuery) {
	          delete jqLite.cache[firstElementToRemove[jqLite.expando]];
	        } else {
	          // jQuery 2.x doesn't expose the data storage. Use jQuery.cleanData to clean up after
	          // the replaced element. The cleanData version monkey-patched by Angular would cause
	          // the scope to be trashed and we do need the very same scope to work with the new
	          // element. However, we cannot just cache the non-patched version and use it here as
	          // that would break if another library patches the method after Angular does (one
	          // example is jQuery UI). Instead, set a flag indicating scope destroying should be
	          // skipped this one time.
	          skipDestroyOnNextJQueryCleanData = true;
	          jQuery.cleanData([firstElementToRemove]);
	        }
	      }
	
	      for (var k = 1, kk = elementsToRemove.length; k < kk; k++) {
	        var element = elementsToRemove[k];
	        jqLite(element).remove(); // must do this way to clean up expando
	        fragment.appendChild(element);
	        delete elementsToRemove[k];
	      }
	
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings,
	                                         directive, newScope) {
	      var onNewScopeDestroyed;
	      forEach(bindings, function(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, or &
	        lastValue,
	        parentGet, parentSet, compare;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value)) {
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            if (isString(attrs[attrName])) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(attrs[attrName])(scope);
	            }
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' used with directive '{1}' is non-assignable!",
	                  attrs[attrName], directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            var unwatch;
	            if (definition.collection) {
	              unwatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              unwatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            onNewScopeDestroyed = (onNewScopeDestroyed || []);
	            onNewScopeDestroyed.push(unwatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	      var destroyBindings = onNewScopeDestroyed ? function destroyBindings() {
	        for (var i = 0, ii = onNewScopeDestroyed.length; i < ii; ++i) {
	          onNewScopeDestroyed[i]();
	        }
	      } : noop;
	      if (newScope && destroyBindings !== noop) {
	        newScope.$on('$destroy', destroyBindings);
	        return noop;
	      }
	      return destroyBindings;
	    }
	  }];
	}
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+(\w+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * ```js
	 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	 * ```
	 *
	 * This example will override the normal action of `$exceptionHandler`, to make angular
	 * exceptions fail hard when they happen, instead of just logging to the console.
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v, k) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {Object} - an object built with {@link ng.$cacheFactory `$cacheFactory`}
	   * that will provide the cache for all requests who set their `cache` property to `true`.
	   * If you set the `defaults.cache = false` then only requests that specify their own custom
	   * cache object will be cached. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a normal promise without the `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a configuration object —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example :
	     *   $http.get('/someUrl').
	     *     then(function(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * ```js
	     *   // Simple POST request example (passing data) :
	     *   $http.post('/someUrl', {msg:'hello word!'}).
	     *     then(function(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and
	     * will result in the success callback being called. Note that if the response is a redirect,
	     * XMLHttpRequest will transparently follow it, meaning that the error callback will not be
	     * called for such responses.
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests.
	     *
	     * ```js
	     *   $http.get('/someUrl').then(successCallback);
	     *   $http.post('/someUrl', data).then(successCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w'
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * To enable caching, set the request configuration `cache` property to `true` (to use default
	     * cache) or to a custom cache object (built with {@link ng.$cacheFactory `$cacheFactory`}).
	     * When the cache is enabled, `$http` stores the response from the server in the specified
	     * cache. The next time the same request is made, the response is served from the cache without
	     * sending a request to the server.
	     *
	     * Note that even if the response is served from cache, delivery of the data is asynchronous in
	     * the same way that real requests are.
	     *
	     * If there are multiple GET requests for the same URL that should be cached using the same
	     * cache, but the cache is not populated yet, only one request to the server will be made and
	     * the remaining requests will be fulfilled using the response from the first request.
	     *
	     * You can change the default cache to a new object (built with
	     * {@link ng.$cacheFactory `$cacheFactory`}) by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property. All requests who set
	     * their `cache` property to `true` will now use this cache object.
	     *
	     * If you set the default cache to `false` then only requests that specify their own custom
	     * cache object will be cached.
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http `config` object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is a technique by which
	     * an unauthorized site can gain your user's private data. Angular provides a mechanism
	     * to counter XSRF. When performing XHR requests, the $http service reads a token from a cookie
	     * (by default, `XSRF-TOKEN`) and sets it as an HTTP header (`X-XSRF-TOKEN`). Since only
	     * JavaScript that runs on your domain could read the cookie, your server can be assured that
	     * the XHR came from JavaScript running on your domain. The header will not be set for
	     * cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default TransformationjqLiks}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	     *      GET request, otherwise if a cache instance built with
	     *      {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	     *      caching.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!angular.isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	        $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var serverRequest = function(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	                delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      };
	
	      var chain = [serverRequest, undefined];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          chain.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          chain.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      while (chain.length) {
	        var thenFn = chain.shift();
	        var rejectFn = chain.shift();
	
	        promise = promise.then(thenFn, rejectFn);
	      }
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        if (!response.data) {
	          resp.data = response.data;
	        } else {
	          resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
	        }
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType);
	      }
	
	      return promise;
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        // normalize internal statuses to 0
	        status = Math.max(status, 0);
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	function createXhr() {
	    return new window.XMLHttpRequest();
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $window
	 * @requires $document
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$window', '$document', function($browser, $window, $document) {
	    return createHttpBackend($browser, createXhr, $browser.defer, $window.angular.callbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) == 'jsonp') {
	      var callbackId = '_' + (callbacks.counter++).toString(36);
	      callbacks[callbackId] = function(data) {
	        callbacks[callbackId].data = data;
	        callbacks[callbackId].called = true;
	      };
	
	      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
	          callbackId, function(status, text) {
	        completeRequest(callback, status, callbacks[callbackId].data, "", text);
	        callbacks[callbackId] = noop;
	      });
	    } else {
	
	      var xhr = createXhr();
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (timeoutId !== undefined) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackId, done) {
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks[callbackId].called) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * @example
	<example module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-app="App" ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'}).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * ####Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q',
	       function($rootScope,   $window,   $q,   $$q) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.then(null, null, (!hasParams) ? fn : function() {
	        fn.apply(null, args);
	      });
	
	      promise.$$intervalId = setInterval(function tick() {
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	
	/**
	 *
	 * @param {string} begin
	 * @param {string} whole
	 * @returns {string} returns text from whole after begin or undefined if it does not begin with
	 *                   expected string.
	 */
	function beginsWith(begin, whole) {
	  if (whole.indexOf(begin) === 0) {
	    return whole.substr(begin.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = beginsWith(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if ((appUrl = beginsWith(appBase, url)) !== undefined) {
	      prevAppUrl = appUrl;
	      if ((appUrl = beginsWith(basePrefix, appUrl)) !== undefined) {
	        rewrittenUrl = appBaseNoFile + (beginsWith('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if ((appUrl = beginsWith(appBaseNoFile, url)) !== undefined) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = beginsWith(appBase, url) || beginsWith(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = beginsWith(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (url.indexOf(base) === 0) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = beginsWith(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {string} path
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return hash fragment when called without any parameter.
	   *
	   * Change hash fragment when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during current `$digest` will be replacing current history
	   * record, instead of adding new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(beginsWith(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdent(ch)) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdent: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (!(this.isIdent(ch) || this.isNumber(ch))) {
	        break;
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.constants.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.constants[this.consume().text]);
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.expression());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        this.consume(':');
	        property.value = this.expression();
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	
	  /* `undefined` is not a constant, it is an identifier,
	   * but using it as an identifier is not supported
	   */
	  constants: {
	    'true': { type: AST.Literal, value: true },
	    'false': { type: AST.Literal, value: false },
	    'null': { type: AST.Literal, value: null },
	    'undefined': {type: AST.Literal, value: undefined },
	    'this': {type: AST.ThisExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assing a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        self.recurse(property.value, self.nextId(), undefined, function(expr) {
	          args.push(self.escape(
	              property.key.type === AST.Identifier ? property.key.name :
	                ('' + property.key.value)) +
	              ':' + expr);
	        });
	      });
	      expression = '{' + args.join(',') + '}';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    return left + '.' + right;
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? function() {} :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        args.push({key: property.key.type === AST.Identifier ?
	                        property.key.name :
	                        ('' + property.key.value),
	                   value: self.recurse(property.value)
	        });
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign, inputs) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1 && lhs && !(lhs[rhs])) {
	          lhs[rhs] = {};
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1 && lhs && !(lhs[right])) {
	        lhs[right] = {};
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(this.lexer);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	var getterFnCacheDefault = createMap();
	var getterFnCacheExpensive = createMap();
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true
	        };
	
	    return function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return noop;
	      }
	    };
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        return parsedExpression(scope);
	      }, function constantListener(value, old, scope) {
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        unwatch();
	      }, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6 Harmony,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 Harmony promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 *  # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	  function callOnce(self, resolveFn, rejectFn) {
	    var called = false;
	    function wrap(fn) {
	      return function(value) {
	        if (called) return;
	        called = true;
	        fn.call(self, value);
	      };
	    }
	
	    return [wrap(resolveFn), wrap(rejectFn)];
	  }
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    return new Deferred();
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	    //Necessary to support unbound execution :/
	    this.resolve = simpleBind(this, this.resolve);
	    this.reject = simpleBind(this, this.reject);
	    this.notify = simpleBind(this, this.notify);
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then, fns;
	
	      fns = callOnce(this, this.$$resolve, this.$$reject);
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, fns[0], fns[1], this.notify);
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        fns[1](e);
	        exceptionHandler(e);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    if (!(this instanceof Q)) {
	      // More useful when $Q is the Promise itself.
	      return new Q(resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - this means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in middle are expensive so we use linked list
	 *
	 * There are few watches then a lot of observers. This is why you don't want the observer to be
	 * implemented in the same way as watch. Watch requires return of initialization function which
	 * are expensive to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide an event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$injector', '$exceptionHandler', '$parse', '$browser',
	      function($injector, $exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (Since
	       *   {@link ng.$rootScope.Scope#$digest $digest()} reruns when it detects changes the
	       *   `watchExpression` can execute multiple times per
	       *   {@link ng.$rootScope.Scope#$digest $digest()} and should be idempotent.)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} objectEquality Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (newValue.hasOwnProperty(key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!newValue.hasOwnProperty(key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, logMsg, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          while (asyncQueue.length) {
	            try {
	              asyncTask = asyncQueue.shift();
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    if ((value = watch.get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      watch.fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        while (postDigestQueue.length) {
	          try {
	            postDigestQueue.shift()();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // All of the code below is bogus code that works around V8's memory leak via optimized code
	        // and inline caches.
	        //
	        // see:
	        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	        this.$parent = this.$$nextSibling = this.$$prevSibling = this.$$childHead =
	            this.$$childTail = this.$root = this.$$watchers = null;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: expr, locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   *     Note: **an empty whitelist array will block all URLs**!
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || trustedValue === undefined || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || maybeTrusted === undefined || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix.substr(0, 1).toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!($window.history && $window.history.pushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $compileMinErr = minErr('$compile');
	
	/**
	 * @ngdoc service
	 * @name $templateRequest
	 *
	 * @description
	 * The `$templateRequest` service runs security checks then downloads the provided template using
	 * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	 * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	 * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	 * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	 * when `tpl` is of type string and `$templateCache` has the matching entry.
	 *
	 * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	 * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	 *
	 * @return {Promise} a promise for the HTTP response data of the given URL.
	 *
	 * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	 */
	function $TemplateRequestProvider() {
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || !$templateCache.get(tpl)) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      var httpOptions = {
	        cache: $templateCache,
	        transformResponse: transformResponse
	      };
	
	      return $http.get(tpl, httpOptions)
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $compileMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The value this
	      *   promise will be resolved with is the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (lastCookies[name] === undefined) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	 *     property of the object or its nested object properties. That's equivalent to the simple
	 *     substring match with a `string` as described above. The predicate can be negated by prefixing
	 *     the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	function filterFilter() {
	  return function(array, expression, comparator) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression.$, comparator, false);
	    }
	    return deepCompare(item, expression, comparator, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === '$';
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity/-Infinity) the Infinity symbol '∞' is returned.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to decimalPlaces and places a “,” after each third digit.
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	
	
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	var DECIMAL_SEP = '.';
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	  if (isObject(number)) return '';
	
	  var isNegative = number < 0;
	  number = Math.abs(number);
	
	  var isInfinity = number === Infinity;
	  if (!isInfinity && !isFinite(number)) return '';
	
	  var numStr = number + '',
	      formatedText = '',
	      hasExponent = false,
	      parts = [];
	
	  if (isInfinity) formatedText = '\u221e';
	
	  if (!isInfinity && numStr.indexOf('e') !== -1) {
	    var match = numStr.match(/([\d\.]+)e(-?)(\d+)/);
	    if (match && match[2] == '-' && match[3] > fractionSize + 1) {
	      number = 0;
	    } else {
	      formatedText = numStr;
	      hasExponent = true;
	    }
	  }
	
	  if (!isInfinity && !hasExponent) {
	    var fractionLen = (numStr.split(DECIMAL_SEP)[1] || '').length;
	
	    // determine fractionSize if it is not specified
	    if (isUndefined(fractionSize)) {
	      fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac);
	    }
	
	    // safely round numbers in JS without hitting imprecisions of floating-point arithmetics
	    // inspired by:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
	    number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize);
	
	    var fraction = ('' + number).split(DECIMAL_SEP);
	    var whole = fraction[0];
	    fraction = fraction[1] || '';
	
	    var i, pos = 0,
	        lgroup = pattern.lgSize,
	        group = pattern.gSize;
	
	    if (whole.length >= (lgroup + group)) {
	      pos = whole.length - lgroup;
	      for (i = 0; i < pos; i++) {
	        if ((pos - i) % group === 0 && i !== 0) {
	          formatedText += groupSep;
	        }
	        formatedText += whole.charAt(i);
	      }
	    }
	
	    for (i = pos; i < whole.length; i++) {
	      if ((whole.length - i) % lgroup === 0 && i !== 0) {
	        formatedText += groupSep;
	      }
	      formatedText += whole.charAt(i);
	    }
	
	    // format fraction part.
	    while (fraction.length < fractionSize) {
	      fraction += '0';
	    }
	
	    if (fractionSize && fractionSize !== "0") formatedText += decimalSep + fraction.substr(0, fractionSize);
	  } else {
	    if (fractionSize > 0 && number < 1) {
	      formatedText = number.toFixed(fractionSize);
	      number = parseFloat(formatedText);
	    }
	  }
	
	  if (number === 0) {
	    isNegative = false;
	  }
	
	  parts.push(isNegative ? pattern.negPre : pattern.posPre,
	             formatedText,
	             isNegative ? pattern.negSuf : pattern.posSuf);
	  return parts.join('');
	}
	
	function padNumber(num, digits, trim) {
	  var neg = '';
	  if (num < 0) {
	    neg =  '-';
	    num = -num;
	  }
	  num = '' + num;
	  while (num.length < digits) num = '0' + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim);
	  };
	}
	
	function dateStrGetter(name, shortForm) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var get = uppercase(shortForm ? ('SHORT' + name) : name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4),
	    yy: dateGetter('FullYear', 2, 0, true),
	     y: dateGetter('FullYear', 1),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements
	 * are taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	 * converted to a string.
	 *
	 * @param {Array|string|number} input Source array, string or number to be limited.
	 * @param {string|number} limit The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
	 *     indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	 *     had less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArray(input) && !isString(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;
	
	    if (limit >= 0) {
	      return input.slice(begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return input.slice(limit, input.length);
	      } else {
	        return input.slice(Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	 * as expected, make sure they are actually being saved as numbers and not strings.
	 *
	 * @param {Array} array The array to sort.
	 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	 *    used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `function`: Getter function. The result of this function will be sorted using the
	 *      `<`, `===`, `>` operator.
	 *    - `string`: An Angular expression. The result of this expression is used to compare elements
	 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	 *      3 first characters of a property called `name`). The result of a constant expression
	 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	 *      to sort object by the value of their `special name` property). An expression can be
	 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	 *      element itself is used to compare where sorting.
	 *    - `Array`: An array of function or string predicates. The first predicate in the array
	 *      is used for sorting, but when two items are equivalent, the next predicate is used.
	 *
	 *    If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse Reverse the order of the array.
	 * @returns {Array} Sorted copy of the source array.
	 *
	 *
	 * @example
	 * The example below demonstrates a simple ngRepeat, where the data is sorted
	 * by age in descending order (predicate is set to `'-age'`).
	 * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	     <file name="index.html">
	       <script>
	         angular.module('orderByExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.friends =
	                 [{name:'John', phone:'555-1212', age:10},
	                  {name:'Mary', phone:'555-9876', age:19},
	                  {name:'Mike', phone:'555-4321', age:21},
	                  {name:'Adam', phone:'555-5678', age:35},
	                  {name:'Julie', phone:'555-8765', age:29}];
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <table class="friend">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	   </example>
	 *
	 * The predicate and reverse parameters can be controlled dynamically through scope properties,
	 * as shown in the next example.
	 * @example
	   <example module="orderByExample">
	     <file name="index.html">
	       <script>
	         angular.module('orderByExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.friends =
	                 [{name:'John', phone:'555-1212', age:10},
	                  {name:'Mary', phone:'555-9876', age:19},
	                  {name:'Mike', phone:'555-4321', age:21},
	                  {name:'Adam', phone:'555-5678', age:35},
	                  {name:'Julie', phone:'555-8765', age:29}];
	             $scope.predicate = 'age';
	             $scope.reverse = true;
	             $scope.order = function(predicate) {
	               $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	               $scope.predicate = predicate;
	             };
	           }]);
	       </script>
	       <style type="text/css">
	         .sortorder:after {
	           content: '\25b2';
	         }
	         .sortorder.reverse:after {
	           content: '\25bc';
	         }
	       </style>
	       <div ng-controller="ExampleController">
	         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	         <hr/>
	         [ <a href="" ng-click="predicate=''">unsorted</a> ]
	         <table class="friend">
	           <tr>
	             <th>
	               <a href="" ng-click="order('name')">Name</a>
	               <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	             </th>
	             <th>
	               <a href="" ng-click="order('phone')">Phone Number</a>
	               <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	             </th>
	             <th>
	               <a href="" ng-click="order('age')">Age</a>
	               <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	   </example>
	 *
	 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	 * desired parameters.
	 *
	 * Example:
	 *
	 * @example
	  <example module="orderByExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <table class="friend">
	          <tr>
	            <th><a href="" ng-click="reverse=false;order('name', false)">Name</a>
	              (<a href="" ng-click="order('-name',false)">^</a>)</th>
	            <th><a href="" ng-click="reverse=!reverse;order('phone', reverse)">Phone Number</a></th>
	            <th><a href="" ng-click="reverse=!reverse;order('age',reverse)">Age</a></th>
	          </tr>
	          <tr ng-repeat="friend in friends">
	            <td>{{friend.name}}</td>
	            <td>{{friend.phone}}</td>
	            <td>{{friend.age}}</td>
	          </tr>
	        </table>
	      </div>
	    </file>
	
	    <file name="script.js">
	      angular.module('orderByExample', [])
	        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate, reverse) {
	            $scope.friends = orderBy($scope.friends, predicate, reverse);
	          };
	          $scope.order('-age',false);
	        }]);
	    </file>
	</example>
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder) {
	
	    if (!(isArrayLike(array))) return array;
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate, reverseOrder);
	    // Add a predicate at the end that evaluates to the element index. This makes the
	    // sort stable as it works as a tie-breaker when all the input predicates cannot
	    // distinguish between two elements.
	    predicates.push({ get: function() { return {}; }, descending: reverseOrder ? -1 : 1});
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      return {
	        value: value,
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      var result = 0;
	      for (var index=0, length = predicates.length; index < length; ++index) {
	        result = compare(v1.predicateValues[index], v2.predicateValues[index]) * predicates[index].descending;
	        if (result) break;
	      }
	      return result;
	    }
	  };
	
	  function processPredicates(sortPredicate, reverseOrder) {
	    reverseOrder = reverseOrder ? -1 : 1;
	    return sortPredicate.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return { get: get, descending: descending * reverseOrder };
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value, index) {
	    // If `valueOf` is a valid function use that
	    if (typeof value.valueOf === 'function') {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	    // We have a basic object so we use the position of the object in the collection
	    return index;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'string') {
	      value = value.toLowerCase();
	    } else if (type === 'object') {
	      value = objectValue(value, index);
	    }
	    return { value: value, type: type };
	  }
	
	  function compare(v1, v2) {
	    var result = 0;
	    if (v1.type === v2.type) {
	      if (v1.value !== v2.value) {
	        result = v1.value < v2.value ? -1 : 1;
	      }
	    } else {
	      result = v1.type < v2.type ? -1 : 1;
	    }
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute.  The following example would make the button enabled on Chrome/Firefox
	 * but not on older IEs:
	 *
	 * ```html
	 * <!-- See below for an example of ng-disabled being used correctly -->
	 * <div ng-init="isDisabled = false">
	 *  <button disabled="{{isDisabled}}">Disabled</button>
	 * </div>
	 * ```
	 *
	 * This is because the HTML specification does not require browsers to preserve the values of
	 * boolean attributes such as `disabled` (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * ### Why do we need `ngChecked`?
	 *
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as checked. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngChecked` directive solves this problem for the `checked` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as readonly. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngReadonly` directive solves this problem for the `readonly` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as selected. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngSelected` directive solves this problem for the `selected` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * The HTML specification does not require browsers to preserve the values of boolean attributes
	 * such as open. (Their presence means true and their absence means false.)
	 * If we put an Angular interpolation expression into such an attribute then the
	 * binding information would be lost when the browser removes the attribute.
	 * The `ngOpen` directive solves this problem for the `open` attribute.
	 * This complementary directive is not removed by the browser and so provides
	 * a permanent reliable place to store the binding information.
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  var parentForm = form.$$parentForm = element.parent().controller('form') || nullFormCtrl;
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	
	  parentForm.$addControl(form);
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   *
	   * @description
	   * Register a control with the form.
	   *
	   * Input elements using ngModelController do this automatically when they are linked.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    parentForm: parentForm,
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive which behaves identically to
	 * `<form>` but can be nested.  This allows you to have nested forms, which is very useful when
	 * using Angular validation directives in forms that are dynamically generated using the
	 * {@link ng.directive:ngRepeat `ngRepeat`} directive. Since you cannot dynamically generate the `name`
	 * attribute of input elements using interpolation, you have to wrap each set of repeated inputs in an
	 * `ngForm` directive and nest these in an outer `form` element.
	 *
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, controller) {
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = controller.$$parentForm;
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                parentFormCtrl.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              parentFormCtrl.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code is obtained from SO: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
	var URL_REGEXP = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
	var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <tt>text = {{example.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     * valid ISO date string (yyyy-MM-dd).
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     * a valid ISO date string (yyyy-MM-dd).
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	    * valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	    * a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	   * valid ISO time format (HH:mm:ss).
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be a
	   * valid ISO time format (HH:mm:ss).
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	    * valid ISO week format (yyyy-W##).
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	    * a valid ISO week format (yyyy-W##).
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be
	   * a valid ISO month format (yyyy-MM).
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must
	   * be a valid ISO month format (yyyy-MM).
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	   *    a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function(data) {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var timeout;
	
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) ? (isDate(val) ? val : parseDate(val)) : undefined;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      // Detect bug in FF35 for input[email] (https://bugzilla.mozilla.org/show_bug.cgi?id=1064430):
	      // - also sets validity.badInput (should only be validity.typeMismatch).
	      // - see http://www.whatwg.org/specs/web-apps/current-work/multipage/forms.html#e-mail-state-(type=email)
	      // - can ignore this case as we can still read out the erroneous email...
	      return validity.badInput && !validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	 *    a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
	 *    a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = value === undefined ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = value === undefined ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function getStringValue(value) {
	        return (value || '').toString();
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // we re-evaluate the expr because we want a TrustedValueHolderType
	          // for $sce, not a string
	          element.html($sce.getTrustedHtml(ngBindHtmlGetter(scope)) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          if (selector === true || scope.$index % 2 === selector) {
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          oldVal = shallowCopy(newVal);
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @animations
	 * **add** - happens just before the class is applied to the elements
	 *
	 * **remove** - happens just before the class is removed from the element
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimising $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automcatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * enter - happens just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container
	 * leave - happens just before the `ngIf` contents are removed from the DOM
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', function($animate) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = document.createComment(' end ngIf: ' + $attr.ngIf + ' ');
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * enter - animation is used to bring new content into the browser.
	 * leave - animation is used to animate existing content away.
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (/SVG/.test($element[0].toString())) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * The only appropriate use of `ngInit` is for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below. Besides this case, you
	 * should use {@link guide/controller controllers} rather than `ngInit`
	 * to initialize values on a scope.
	 * </div>
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with {@link ng.$filter `$filter`}, make
	 * sure you have parenthesis for correct precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = (data | orderBy:'name')"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on whitespace
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {string} $viewValue Actual string value in the view.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: ctrl.$modelValue});
	        } else {
	          parsedNgModelAssign($scope, ctrl.$modelValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous value. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  var parentForm = $element.inheritedData('$formController') || nullFormCtrl,
	      currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    parentForm: parentForm,
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced events or events such
	   * as blur you can have a situation where there is a period when the `$viewValue`
	   * is out of synch with the ngModel's `$modelValue`.
	   *
	   * In this case, you can run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.resetWithCancel = function(e) {
	   *         if (e.keyCode == 27) {
	   *           $scope.myForm.myInput1.$rollbackViewValue();
	   *           $scope.myValue = '';
	   *         }
	   *       };
	   *       $scope.resetWithoutCancel = function(e) {
	   *         if (e.keyCode == 27) {
	   *           $scope.myValue = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Try typing something in each input.  See that the model only updates when you
	   *          blur off the input.
	   *        </p>
	   *        <p>Now see what happens if you start typing then press the Escape key</p>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <p id="inputDescription1">With $rollbackViewValue()</p>
	   *         <input name="myInput1" aria-describedby="inputDescription1" ng-model="myValue"
	   *                ng-keydown="resetWithCancel($event)"><br/>
	   *         myValue: "{{ myValue }}"
	   *
	   *         <p id="inputDescription2">Without $rollbackViewValue()</p>
	   *         <input name="myInput2" aria-describedby="inputDescription2" ng-model="myValue"
	   *                ng-keydown="resetWithoutCancel($event)"><br/>
	   *         myValue: "{{ myValue }}"
	   *       </form>
	   *     </div>
	   *   </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (parserValid === undefined) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr("$asyncValidators",
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function(error) {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when an input directive want to change the view value; typically,
	   * this is done from within a DOM event handler.
	   *
	   * For example {@link ng.directive:input input} calls it when the value of the input changes and
	   * {@link ng.directive:select select} calls it when an option is selected.
	   *
	   * If the new `value` is an object (rather than a string or a number), we should make a copy of the
	   * object before passing it to `$setViewValue`.  This is because `ngModel` does not perform a deep
	   * watch of objects, it only looks for a change of identity. If you only change the property of
	   * the object then ngModel will not realise that the object has changed and will not invoke the
	   * `$parsers` and `$validators` pipelines.
	   *
	   * For this reason, you should not change properties of the copy once it has been passed to
	   * `$setViewValue`. Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * When this method is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute.
	   *
	   * Lastly, all the registered change listeners, in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   *
	   * Note that calling this function does not trigger a `$digest`.
	   *
	   * @param {string} value Value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`, `ng-untouched`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes are: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || nullFormCtrl;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              formCtrl.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            formCtrl.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function(ev) {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'say', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' hello');
	        input.click();
	        expect(model.getText()).toEqual('say');
	        other.click();
	        expect(model.getText()).toEqual('say hello');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' hello');
	        expect(input.getAttribute('value')).toEqual('say hello');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('say');
	        other.click();
	        expect(model.getText()).toEqual('say');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'say' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (this.$options.updateOn !== undefined) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      parentForm = context.parentForm,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (state === undefined) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * **Note:** By default, `ngModel` watches the model by reference, not value. This is important when
	 * binding any input directive to a model that is an object or a collection.
	 *
	 * Since this is a common situation for `ngOptions` the directive additionally watches the model using
	 * `$watchCollection` when the select has the `multiple` attribute or when there is a `track by` clause in
	 * the options expression. This allows ngOptions to trigger a re-rendering of the options even if the actual
	 * object/collection has not changed identity but only a property on the object or an item in the collection
	 * changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper inside the object/collection that the
	 * first level will not trigger a re-rendering.
	 *
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Do not use `select` **`as`** and **`track by`** in the same expression. They are not designed to work together.
	 * </div>
	 *
	 * Consider the following example:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in values track by item.id" ng-model="selected"></select>
	 * ```
	 *
	 * ```js
	 * $scope.values = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 *
	 * $scope.selected = { name: 'aSubItem' };
	 * ```
	 *
	 * With the purpose of preserving the selection, the **`track by`** expression is always applied to the element
	 * of the data source (to `item` in this example). To calculate whether an element is selected, we do the
	 * following:
	 *
	 * 1. Apply **`track by`** to the elements in the array. In the example: `[1, 2]`
	 * 2. Apply **`track by`** to the already selected value in `ngModel`.
	 *    In the example: this is not possible as **`track by`** refers to `item.id`, but the selected
	 *    value from `ngModel` is `{name: 'aSubItem'}`, so the **`track by`** expression is applied to
	 *    a wrong object, the selected element can't be found, `<select>` is always reset to the "not
	 *    selected" option.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$parse', function($compile, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(optionValues[key], key);
	          var selectValue = getTrackByValueFn(optionValues[key], locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = document.createElement('option'),
	      optGroupTemplate = document.createElement('optgroup');
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', '?ngModel'],
	    link: function(scope, selectElement, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option && !option.disabled) {
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	              option.element.setAttribute('selected', 'selected');
	            }
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option && !option.disabled) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        if (option.value !== element.value) element.value = option.selectValue;
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	      }
	
	      function addOrReuseElement(parent, current, type, templateElement) {
	        var element;
	        // Check whether we can reuse the next element
	        if (current && lowercase(current.nodeName) === type) {
	          // The next element is the right type so reuse it
	          element = current;
	        } else {
	          // The next element is not the right type so create a new one
	          element = templateElement.cloneNode(false);
	          if (!current) {
	            // There are no more elements so just append it to the select
	            parent.appendChild(element);
	          } else {
	            // The next element is not a group so insert the new one
	            parent.insertBefore(element, current);
	          }
	        }
	        return element;
	      }
	
	
	      function removeExcessElements(current) {
	        var next;
	        while (current) {
	          next = current.nextSibling;
	          jqLiteRemove(current);
	          current = next;
	        }
	      }
	
	
	      function skipEmptyAndUnknownOptions(current) {
	        var emptyOption_ = emptyOption && emptyOption[0];
	        var unknownOption_ = unknownOption && unknownOption[0];
	
	        if (emptyOption_ || unknownOption_) {
	          while (current &&
	                (current === emptyOption_ ||
	                current === unknownOption_)) {
	            current = current.nextSibling;
	          }
	        }
	        return current;
	      }
	
	
	      function updateOptions() {
	
	        var previousValue = options && selectCtrl.readValue();
	
	        options = ngOptions.getOptions();
	
	        var groupMap = {};
	        var currentElement = selectElement[0].firstChild;
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        currentElement = skipEmptyAndUnknownOptions(currentElement);
	
	        options.items.forEach(function updateOption(option) {
	          var group;
	          var groupElement;
	          var optionElement;
	
	          if (option.group) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            group = groupMap[option.group];
	
	            if (!group) {
	
	              // We have not already created this group
	              groupElement = addOrReuseElement(selectElement[0],
	                                               currentElement,
	                                               'optgroup',
	                                               optGroupTemplate);
	              // Move to the next element
	              currentElement = groupElement.nextSibling;
	
	              // Update the label on the group element
	              groupElement.label = option.group;
	
	              // Store it for use later
	              group = groupMap[option.group] = {
	                groupElement: groupElement,
	                currentOptionElement: groupElement.firstChild
	              };
	
	            }
	
	            // So now we have a group for this option we add the option to the group
	            optionElement = addOrReuseElement(group.groupElement,
	                                              group.currentOptionElement,
	                                              'option',
	                                              optionTemplate);
	            updateOptionElement(option, optionElement);
	            // Move to the next element
	            group.currentOptionElement = optionElement.nextSibling;
	
	          } else {
	
	            // This option is not in a group
	            optionElement = addOrReuseElement(selectElement[0],
	                                              currentElement,
	                                              'option',
	                                              optionTemplate);
	            updateOptionElement(option, optionElement);
	            // Move to the next element
	            currentElement = optionElement.nextSibling;
	          }
	        });
	
	
	        // Now remove all excess options and group
	        Object.keys(groupMap).forEach(function(key) {
	          removeExcessElements(groupMap[key].currentOptionElement);
	        });
	        removeExcessElements(currentElement);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          if (ngOptions.trackBy ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to exlicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 * This may be useful when, for instance, nesting ngRepeats.
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * You need to be aware that the JavaScript specification does not define the order of keys
	 * returned for an object. (To mitigate this in Angular 1.3 the `ngRepeat` directive
	 * used to sort the keys alphabetically.)
	 *
	 * Version 1.4 removed the alphabetic sorting. We now rely on the order returned by the browser
	 * when running `for key in myObj`. It seems that browsers generally follow the strategy of providing
	 * keys in the order in which they were defined, although there are exceptions when keys are deleted
	 * and reinstated. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_issues
	 *
	 * If this is not desired, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`.  You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * When the contents of the collection change, `ngRepeat` makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * By default, `ngRepeat` does not allow duplicate items in arrays. This is because when
	 * there are duplicates, it is not possible to maintain a one-to-one mapping between collection
	 * items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * If you are working with objects that have an identifier property, you can track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones:
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * **.enter** - when a new item is added to the list or when an item is revealed after a filter
	 *
	 * **.leave** - when an item is removed from the list or when an item is filtered out
	 *
	 * **.move** - when an adjacent item is filtered out causing a reorder or when the item contents are reordered
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example initializes the scope to a list of names and
	 * then uses `ngRepeat` to display every person:
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-init="friends = [
	        {name:'John', age:25, gender:'boy'},
	        {name:'Jessie', age:30, gender:'girl'},
	        {name:'Johanna', age:28, gender:'girl'},
	        {name:'Joy', age:15, gender:'girl'},
	        {name:'Mary', age:28, gender:'girl'},
	        {name:'Peter', age:95, gender:'boy'},
	        {name:'Sebastian', age:50, gender:'boy'},
	        {name:'Erika', age:27, gender:'girl'},
	        {name:'Patrick', age:40, gender:'boy'},
	        {name:'Samantha', age:60, gender:'girl'}
	      ]">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:40px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:40px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', function($parse, $animate) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = document.createComment(' end ngRepeat: ' + expression + ' ');
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (collection.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, jqLite(previousNode));
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                // TODO(perf): support naked previousNode in `enter` to avoid creation of jqLite wrapper?
	                $animate.enter(clone, null, jqLite(previousNode));
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * addClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a truthy value and the just before contents are set to visible
	 * removeClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * removeClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden
	 * addClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a non truthy value and just before the contents are set to visible
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * enter - happens after the ngSwitch contents change and the matched child element is placed inside the container
	 * leave - happens just after the ngSwitch contents change and just before the former contents are removed from the DOM
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', function($animate) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = document.createComment(' end ngSwitchWhen: ');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * Any existing content of the element that this directive is placed on will be removed before the transcluded content is inserted.
	 *
	 * @element ANY
	 *
	 * @example
	   <example module="transcludeExample">
	     <file name="index.html">
	       <script>
	         angular.module('transcludeExample', [])
	          .directive('pane', function(){
	             return {
	               restrict: 'E',
	               transclude: true,
	               scope: { title:'@' },
	               template: '<div style="border: 1px solid black;">' +
	                           '<div style="background-color: gray">{{title}}</div>' +
	                           '<ng-transclude></ng-transclude>' +
	                         '</div>'
	             };
	         })
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.title = 'Lorem Ipsum';
	           $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	         }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input ng-model="title" aria-label="title"> <br/>
	         <textarea ng-model="text" aria-label="text"></textarea> <br/>
	         <pane title="{{title}}">{{text}}</pane>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	        it('should have transcluded', function() {
	          var titleElement = element(by.model('title'));
	          titleElement.clear();
	          titleElement.sendKeys('TITLE');
	          var textElement = element(by.model('text'));
	          textElement.clear();
	          textElement.sendKeys('TEXT');
	          expect(element(by.binding('title')).getText()).toEqual('TITLE');
	          expect(element(by.binding('text')).getText()).toEqual('TEXT');
	        });
	     </file>
	   </example>
	 *
	 */
	var ngTranscludeDirective = ngDirective({
	  restrict: 'EAC',
	  link: function($scope, $element, $attrs, controller, $transclude) {
	    if (!$transclude) {
	      throw minErr('ngTransclude')('orphan',
	       'Illegal use of ngTransclude directive in the template! ' +
	       'No parent directive that requires a transclusion found. ' +
	       'Element: {0}',
	       startingTag($element));
	    }
	
	    $transclude(function(clone) {
	      $element.empty();
	      $element.append(clone);
	    });
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * Ìt also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explictly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    link: function(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	  };
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	
	  function chromeHack(optionElement) {
	    // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	    // Adding an <option selected="selected"> element to a <select required="required"> should
	    // automatically select the new element
	    if (optionElement[0].hasAttribute('selected')) {
	      optionElement[0].selected = true;
	    }
	  }
	
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	
	      // If the value attribute is not defined then we fall back to the
	      // text content of the option element, which may be interpolated
	      if (isUndefined(attr.value)) {
	        var interpolateFn = $interpolate(element.text(), true);
	        if (!interpolateFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        // Only update trigger option updates if this is an option within a `select`
	        // that also has `ngModel` attached
	        if (selectCtrl && selectCtrl.ngModelCtrl) {
	
	          if (interpolateFn) {
	            scope.$watch(interpolateFn, function interpolateWatchAction(newVal, oldVal) {
	              attr.$set('value', newVal);
	              if (oldVal !== newVal) {
	                selectCtrl.removeOption(oldVal);
	              }
	              selectCtrl.addOption(newVal, element);
	              selectCtrl.ngModelCtrl.$render();
	              chromeHack(element);
	            });
	          } else {
	            selectCtrl.addOption(attr.value, element);
	            selectCtrl.ngModelCtrl.$render();
	            chromeHack(element);
	          }
	
	          element.on('$destroy', function() {
	            selectCtrl.removeOption(attr.value);
	            selectCtrl.ngModelCtrl.$render();
	          });
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  console.log('WARNING: Tried to load angular more than once.');
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(document).ready(function() {
	    angularInit(document, bootstrap);
	  });
	
	})(window, document);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(337), __webpack_require__(341), __webpack_require__(347), __webpack_require__(535), __webpack_require__(556), __webpack_require__(863)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NavBarDirective) {
	    return angular.module('portal.app', ['ui.router', 'edge.platform.widgets.pagestructure', 'edge.platform.l10n', 'edge.quoteandbind.app', 'edge.platform.util', 'customerEdge.addressstandardization.app', 'ngSanitize'
	    // 'reCaptcha' *Princy,
	    // 'angularjs-crypto'
	    ]).directive('gwPortalNavBar', NavBarDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(338)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NavBarCtrl) {
	    return function () {
	        return {
	            restrict: 'EA',
	            template: '<div ng-transclude></div>',
	            transclude: true,
	            controller: NavBarCtrl
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(339)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NavBarWizardBaseCtrl) {
	    return ['$scope', '$element', 'StateUtils', '$rootScope', '$state', 'LoginLinkDev', 'LoginLinkTest', 'AAADEV', 'AAATEST', 'GWDEV', 'GWTEST', function ($scope, $element, StateUtils, $rootScope, $state, LoginLinkDev, LoginLinkTest, AAADEV, AAATEST, GWDEV, GWTEST) {
	
	        var baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
	        var ctrl = Object.create(baseNavbarCtrl);
	
	        function addPageInfoToAnalytics() {
	            if ($scope.submission && $scope.submission.draftData.productCode) {
	                var insuranceType = $scope.submission.draftData.productCode;
	            } else {
	                var insuranceType = "Product NA";
	            }
	
	            if ($state.current && $state.current.name) {
	                var stateName = $state.current.name;
	            } else {
	                var stateName = "State NA";
	            }
	
	            // CHG0031104 - Set QnB Source for Google Analytics
	            // AB - 05/12/2018
	
	            // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
	            // AB - 11/23/2020
	
	            switch ($rootScope.Arg1) {
	                //                switch($rootScope.Arg1.toUpperCase()){
	                case "SECU":
	                    var source = "SECU";
	                    break;
	                case "GORMISH":
	                    var source = "GORMISH";
	                    break;
	                case "SEA":
	                    var source = "SEA";
	                    break;
	                case "YOMTOB":
	                    var source = "YOMTOB";
	                    break;
	                case "BWE":
	                    var source = "BWE";
	                    break;
	                case "SCOTT":
	                    var source = "SCOTT";
	                    break;
	                case "CROWFIELD":
	                    var source = "CROWFIELD";
	                    break;
	                case "RICKARD":
	                    var source = "RICKARD";
	                    break;
	                case "NIXON":
	                    var source = "NIXON";
	                    break;
	                case "BLUE":
	                    var source = "BLUE";
	                    break;
	                case "GRAY":
	                    var source = "GRAY";
	                    break;
	                case "JONES":
	                    var source = "JONES";
	                    break;
	                case "MCCARTHY":
	                    var source = "MCCARTHY";
	                    break;
	                case "ASSOCIATES":
	                    var source = "ASSOCIATES";
	                    break;
	                case "ANTHONY":
	                    var source = "ANTHONY";
	                    break;
	
	                case "SIMMONS":
	                    var source = "SIMMONS";
	                    break;
	                case "WILLIAMS":
	                    var source = "WILLIAMS";
	                    break;
	                case "MORRISON":
	                    var source = "MORRISON";
	                    break;
	                case "CRUMEL":
	                    var source = "CRUMEL";
	                    break;
	                case "YOU":
	                    var source = "YOU";
	                    break;
	                case "MILLER":
	                    var source = "MILLER";
	                    break;
	                case "PERSINSKI":
	                    var source = "PERSINSKI";
	                    break;
	                case "FLOURNOY":
	                    var source = "FLOURNOY";
	                    break;
	                default:
	                    var source = "AAA";
	            }
	
	            dataLayer.push({
	                event: insuranceType + ' : State Change',
	                virtualPageURL: '/qnb-flow/' + stateName,
	                virtualPageTitle: insuranceType + ':' + stateName,
	                quoteSource: source
	
	            });
	
	            //                console.log("Data Layer", dataLayer);
	        }
	
	        ctrl.init = function () {
	            $scope.headerMessageKey = '';
	            $scope.isContextPageMenuOpen = false;
	
	            //Added to display the year dynamically in footer
	            $scope.CurrentYear = new Date();
	
	            $rootScope.$on('stickyHeaderExitViewport', ctrl.closeContextPageMenu);
	            $scope.$on('updateHeaderMessageKey', function (event, messageKey) {
	                $scope.updateHeaderMessageKey(messageKey);
	            });
	
	            StateUtils.beforeStateInit(ctrl._setQuoteSummaryData);
	            StateUtils.afterStateInit(ctrl._checkIfSideMenuShouldBeClosed);
	
	            $rootScope.$on('$stateChangeSuccess', addPageInfoToAnalytics);
	
	            /*$rootScope.$on('$stateChangeStart',addPageInfoToAnalytics);*/
	
	            // CHG0031104 - Capture QnB Source
	            // AB - 05/12/2018
	
	            var urlString = window.location.search.substring(1); // Extract argument string from url
	            var argArray = urlString.split('&'); // build array of url arugemnts
	            var argKeyValuePair = argArray[0].split('='); // pick the first row from argArray (Source)
	            $rootScope.Arg1 = argKeyValuePair[1]; // pick the 2nd element
	        };
	
	        //TODO:this function is used for login from dev and test environment. To be changed when moving to other environments.
	        ctrl.navigateToLogin = function () {
	            var link = window.location;
	            if (link.host.indexOf(AAADEV) >= 0 || link.host.indexOf(GWDEV) >= 0) {
	                window.location = LoginLinkDev;
	            } else if (link.host.indexOf(AAATEST) >= 0 || link.host.indexOf(GWTEST) >= 0) {
	                window.location = LoginLinkTest;
	            }
	        };
	
	        ///// Context menu methods ///////////////////////////////////////////
	        ctrl.toggleContextPageMenu = function () {
	            $scope.isContextPageMenuOpen = !$scope.isContextPageMenuOpen;
	        };
	
	        ctrl.closeContextPageMenu = function () {
	            $scope.isContextPageMenuOpen = false;
	        };
	
	        ///// Header message ///////////////////////////////////////////
	        $scope.updateHeaderMessageKey = function (messageKey) {
	            $scope.headerMessageKey = messageKey;
	        };
	
	        // CHG0031104 - Capture QnB Source
	        // This function is called in index.html page. The function returns the QnB Source //////////
	
	        $scope.GetQnBSource = function () {
	            var urlString = window.location.search.substring(1); // Extract argument string from url
	            var argArray = urlString.split('&'); // build array of url arugemnts
	            var argKeyValuePair = argArray[0].split('='); // pick the first row from argArray (Source)
	            var qnbSource = argKeyValuePair[1]; // pick the 2nd element
	            if (qnbSource == null) {
	                return qnbSource; // return qnbSource as null
	            } else {
	
	                return qnbSource.toUpperCase(); // return qnbSource in Upper Case
	            }
	        };
	
	        $scope.shouldShowHeaderMessage = function () {
	            return $state.$current.name === 'quickQuote' && angular.isDefined($scope.headerMessageKey);
	        };
	
	        ///////////// Quote summary dropdown methods /////////////////////////
	        ctrl._setQuoteSummaryData = function () {
	            if (StateUtils.hasState('baseQnbWizard')) {
	                $scope.submission = StateUtils.dataForState('baseQnbWizard').flowModel.snapshot.value;
	            } else {
	                $scope.submission = null;
	            }
	        };
	
	        ctrl._isQuoteWizardVisible = function () {
	            return StateUtils.hasState('baseQnbWizard');
	        };
	
	        ctrl._checkIfSideMenuShouldBeClosed = function () {
	            if (!ctrl._isQuoteWizardVisible() && ctrl.isSideBarMenuVisible()) {
	                ctrl.hideSideBarMenu();
	            }
	        };
	
	        return ctrl.create($scope);
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, $element) {
	        function setElementVisibility(isVisible) {
	            $scope.sideBarMenuVisible = isVisible;
	            $element.toggleClass('gw-slidebar-menu-open', isVisible);
	        }
	
	        var ctrl = Object.create(BaseCtrl);
	
	        ctrl.init = function () {
	            $scope.sideBarMenuVisible = false;
	        };
	
	        ctrl.toggleSideBarMenu = function () {
	            setElementVisibility(!$scope.sideBarMenuVisible);
	        };
	
	        ctrl.hideSideBarMenu = function () {
	            setElementVisibility(false);
	        };
	
	        ctrl.showSideBarMenu = function () {
	            setElementVisibility(true);
	        };
	
	        ctrl.isSideBarMenuVisible = function () {
	            return $scope.sideBarMenuVisible;
	        };
	
	        return ctrl.create($scope);
	    };
	
	    fn.$inject = ['$scope', '$element'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var nonScopeMethods = ['init', 'defineWatches', '$inject'];
	
	    return {
	        create: function create($scope) {
	            this.defineWatches();
	            this.init();
	            for (var prop in this) {
	                if (this.hasOwnProperty(prop) && prop.charAt(0) !== '_' && typeof this[prop] === 'function' && nonScopeMethods.indexOf(prop) === -1) {
	                    $scope[prop] = this[prop];
	                }
	            }
	            return this;
	        },
	
	
	        defineWatches: function defineWatches() {
	            //OVERRIDE : put all watches and event listeners here
	        },
	
	        init: function init() {
	            //OVERRIDE : Initialise the scope with service populated data when controller is instantiated
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(342), __webpack_require__(344), __webpack_require__(346)], __WEBPACK_AMD_DEFINE_RESULT__ = function (StickyHeader, StickyFooter, PageDrawerSlideoutDirective) {
	    return angular.module('edge.platform.widgets.pagestructure', []).constant('phoneMediaBreakpoint', 639) // in px
	    .directive('gwPlStickyHeader', StickyHeader).directive('gwPlStickyFooterWrapper', StickyFooter).directive('gwPlPageDrawerSlideout', PageDrawerSlideoutDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Directive implements sticky header behavior
	 * with auto-hiding on scrolling a page down
	 *
	 * <div gw-pl-sticky-header class="header-sticky"></div>
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	// https://github.com/eduardomb/scroll-up-bar
	__webpack_require__(343)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['phoneMediaBreakpoint', function (phoneMediaBreakpoint) {
	        return {
	            'restrict': 'A',
	            'link': function link($scope, element) {
	                /*--- VARS ---*/
	                var mediaQuery = window.matchMedia('(max-width: ' + phoneMediaBreakpoint + 'px)');
	
	                /*--- METHODS ---*/
	
	                // APPLY "FIXED" HEADER ONLY FOR MOBILE DEVICES
	                // media query change
	                function breakpointReached(_mediaQuery) {
	                    if (_mediaQuery.matches) {
	                        // < break
	                        element.scrollupbar({
	                            exitViewport: function exitViewport() {
	                                $scope.$emit('stickyHeaderExitViewport');
	                                angularApply();
	                            }
	                        });
	                    } else {
	                        // >= break
	                        resetToDefault();
	                    }
	                }
	
	                function resetToDefault() {
	                    $.scrollupbar.destroy();
	
	                    element.css({
	                        'position': '',
	                        'top': ''
	                    });
	                }
	
	                // has to be invoked when some functionality is called outside of AngularJs
	                function angularApply() {
	                    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
	                        $scope.$apply();
	                    }
	                }
	
	                // INIT
	                breakpointReached(mediaQuery);
	
	                // EVENTS
	                mediaQuery.addListener(breakpointReached);
	
	                // remove listeners on $scope destroying
	                $scope.$on('$destroy', function () {
	                    mediaQuery.removeListener(breakpointReached);
	                    resetToDefault();
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 343 */
/***/ function(module, exports) {

	/* scroll-up-bar v0.3.0 (https://github.com/eduardomb/scroll-up-bar) */
	(function($) {
	  'use strict';
	
	  var _destroyFn;
	
	  $.scrollupbar = function($bar, options) {
	    // Default options
	    options = $.extend({
	      enterViewport: $.noop,
	      fullyEnterViewport: $.noop,
	      exitViewport: $.noop,
	      partiallyExitViewport: $.noop
	    }, options);
	
	    function isFullyInViewport() {
	      return $window.scrollTop() <= $bar.offset().top;
	    }
	
	    function isInViewport() {
	      return $window.scrollTop() < $bar.offset().top + $bar.outerHeight();
	    }
	
	    var $window = $(window),
	        $document = $(document),
	        minY = $bar.css('position') == 'fixed' ? 0 : $bar.offset().top,
	        lastY = $window.scrollTop(), // Use last Y to detect scroll direction.
	        initialPosTop = $bar.position().top,
	        iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent),
	        timeout;
	
	    $.scrollupbar.isInViewport = isInViewport();
	    $.scrollupbar.isFullyInViewport = isFullyInViewport();
	
	    // iOS can't handle momentum scroll properly (See discussion on
	    // http://stackoverflow.com/questions/2863547).
	    if (!iOS) {
	      $window.on('scroll.scrollupbar', function() {
	        var y = $window.scrollTop(),
	            barHeight = $bar.outerHeight();
	
	        // Ignore elastic scrolling.
	        if (y < 0 || y > ($document.height() - $window.height())) {
	          return;
	        }
	
	        // Cancel the event fired by the previous scroll.
	        if (timeout) {
	          clearTimeout(timeout);
	        }
	
	        if (y < lastY) { // Scrolling up
	          // If the bar is hidden, place it right above the top frame.
	          if (!$.scrollupbar.isInViewport && lastY - barHeight >= minY) {
	            $bar.css('top', lastY - barHeight);
	            $.scrollupbar.isInViewport = true;
	            options.enterViewport();
	          }
	
	          // Scrolls up bigger than the bar's height fixes the bar on top.
	          if (isFullyInViewport()) {
	            if (y >= minY) {
	              $bar.css({
	                'position': 'fixed',
	                'top': 0
	              });
	            } else {
	              $bar.css({
	                'position': 'absolute',
	                'top': initialPosTop
	              });
	            }
	
	            if (!$.scrollupbar.isFullyInViewport) {
	              $.scrollupbar.isFullyInViewport = true;
	              options.fullyEnterViewport();
	            }
	          }
	
	          // Fire an event to reveal the entire bar after 400ms if the scroll
	          // wasn't big enough.
	          timeout = setTimeout(function() {
	            if (!isFullyInViewport()) {
	              $bar.css({
	                'position': 'fixed',
	                'top': $bar.offset().top - y
	              });
	
	              $bar.animate({'top': 0}, 100, function() {
	                $.scrollupbar.isFullyInViewport = true;
	                options.fullyEnterViewport();
	              });
	            }
	          }, 400);
	        } else if (y > lastY) { // Scrolling down
	          // Unfix the bar allowing it to scroll with the page.
	          if ($.scrollupbar.isFullyInViewport) {
	            $bar.css({
	              'position': 'absolute',
	              'top': lastY > minY ? lastY : initialPosTop
	            });
	
	            if (!isFullyInViewport()) {
	              $.scrollupbar.isFullyInViewport = false;
	              options.partiallyExitViewport();
	            }
	          }
	
	          if ($.scrollupbar.isInViewport && !isInViewport()) {
	            $.scrollupbar.isInViewport = false;
	            options.exitViewport();
	          }
	
	          // Fire an event to hide the entire bar after 400ms if the scroll
	          // wasn't big enough.
	          timeout = setTimeout(function() {
	            if (isInViewport() && y - barHeight >= minY) {
	              $bar.animate({'top': y - barHeight}, 100, function() {
	                $.scrollupbar.isInViewport = false;
	                options.exitViewport();
	              });
	            }
	          }, 400);
	        }
	
	        lastY = y;
	      });
	    } else { // Fallback simplified behaviour for iOS.
	      $window.on('touchstart.scrollupbar', function () {
	        lastY = $window.scrollTop();
	      });
	
	      $window.on('touchend.scrollupbar', function () {
	        var y = $window.scrollTop();
	
	        if (y < lastY || y - $bar.outerHeight() < minY) { // Scrolling up
	          if (y <= minY) {
	            // Restore original position.
	            $bar.css({
	              'position': 'absolute',
	              'top': initialPosTop
	            });
	
	            $bar.show(function() {
	              $.scrollupbar.isInViewport = true;
	              $.scrollupbar.isFullyInViewport = true;
	              options.enterViewport();
	              options.fullyEnterViewport();
	            });
	          } else {
	            $bar.css({
	              'position': 'fixed',
	              'top': 0
	            });
	
	            $.scrollupbar.isInViewport = true;
	            options.enterViewport();
	
	            $bar.slideDown(function() {
	              $.scrollupbar.isFullyInViewport = true;
	              options.fullyEnterViewport();
	            });
	          }
	        } else if (y > lastY) { // Scrolling down
	          $.scrollupbar.isFullyInViewport = false;
	          options.partiallyExitViewport();
	
	          $bar.slideUp(function() {
	            $.scrollupbar.isInViewport = false;
	            options.exitViewport();
	          });
	        }
	
	        lastY = y;
	      });
	    }
	
	    _destroyFn = function() {
	      // Unbind all listeners added by scrollupbar plugin
	      $window.off('.scrollupbar');
	
	      // Restore original bar position.
	      $bar.css({
	        'position': 'absolute',
	        'top': initialPosTop
	      });
	    };
	
	    return $bar;
	  };
	
	  $.scrollupbar.destroy = function() {
	    if (_destroyFn) {
	      return _destroyFn();
	    }
	  };
	
	  $.fn.scrollupbar = function(options) {
	    return $.scrollupbar(this, options);
	  };
	})(jQuery);


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Directive implements sticky footer behavior
	 *
	 * <div gw-pl-sticky-footer-wrapper class="footer-sticky">
	 *     <div gw-pl-sticky-footer class="footer-sticky"></div>
	 * </div>
	 *
	 * gw-pl-sticky-footer-wrapper is used to measure a top position
	 * gw-pl-sticky-footer is used to assign a "translate" property
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(345)], __WEBPACK_AMD_DEFINE_RESULT__ = function (stickyUtils) {
	    return ['phoneMediaBreakpoint', function (phoneMediaBreakpoint) {
	        return {
	            'restrict': 'A',
	            'link': function link($scope, element) {
	                // VARS
	                var $footerStickyWrapper = $(element);
	                var $footerSticky = $footerStickyWrapper.find('[gw-pl-sticky-footer]');
	                var $scrollElement = $(document);
	
	                var $window = $(window);
	
	                // FIXED POSITION
	                function refreshPosition() {
	                    var stickyFooterTopPos = $footerStickyWrapper.offset().top;
	                    var windowBottom = $window.scrollTop() + $window.height();
	                    var footerStickyHeight = $footerStickyWrapper.outerHeight();
	
	                    if (windowBottom > stickyFooterTopPos + footerStickyHeight) {
	                        resetPositionToDefault();
	                        return;
	                    }
	
	                    var translateY = windowBottom - stickyFooterTopPos - footerStickyHeight;
	                    $footerSticky.css('transform', 'translateY(' + translateY + 'px)');
	                }
	
	                function resetPositionToDefault() {
	                    $footerSticky.css('transform', '');
	                }
	
	                // COMMON STICKY BEHAVIOR
	                stickyUtils = stickyUtils({
	                    $scope: $scope,
	                    $scrollElement: $scrollElement,
	                    refreshPosition: refreshPosition,
	                    resetPositionToDefault: resetPositionToDefault,
	                    phoneMediaBreakpoint: phoneMediaBreakpoint
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Provide common utils methods and fields
	 * for sticky elements (header/footer)
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    // is used to provide unique eventName
	    // to subscribe/unsubscribe to global events
	    var eventNamePostfix = 'sticky';
	    var eventNameId = 0;
	
	    return function (params) {
	        // EVENTS
	        // from params
	        var phoneMediaBreakpoint = params.phoneMediaBreakpoint;
	        var _eventNamePostfix = eventNamePostfix + eventNameId++; // generates unique
	        var $scope = params.$scope;
	        var refreshPosition = params.refreshPosition;
	        var $scrollElement = params.$scrollElement;
	        var resetPositionToDefault = params.resetPositionToDefault;
	
	        // others
	        var $window = $(window);
	
	        var mediaQuery = window.matchMedia('(max-width: ' + phoneMediaBreakpoint + 'px)');
	
	        // STICKY POSITION
	
	        // APPLY "FIXED" HEADER ONLY FOR MOBILE DEVICES
	        // media query change
	        function breakpointReached(_mediaQuery) {
	            if (_mediaQuery.matches) {
	                // < break
	                $window.on('resize.' + _eventNamePostfix, refreshPosition);
	                $scrollElement.on('scroll.' + _eventNamePostfix, refreshPosition);
	                refreshPosition();
	            } else {
	                // >= break
	                $window.off('resize.' + _eventNamePostfix);
	                $scrollElement.off('scroll.' + _eventNamePostfix);
	                resetPositionToDefault();
	            }
	        }
	
	        // INIT
	        breakpointReached(mediaQuery);
	        // make sure sticky is positioned well after all $digest cycles etc.
	        setTimeout(function () {
	            breakpointReached(mediaQuery);
	        }, 100);
	
	        // EVENTS
	        mediaQuery.addListener(breakpointReached);
	
	        // remove listeners on $scope destroying
	        $scope.$on('$destroy', function () {
	            $window.off('resize.stickyheader');
	            $scrollElement.off('scroll.stickyheader');
	            mediaQuery.removeListener(breakpointReached);
	        });
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    return function () {
	        var ctrlConstructor = function ctrlConstructor($scope, phoneMediaBreakpoint, $window, $element) {
	            // indicator to prevent a slide panel closing on opener element click
	            // when opener is in a content section
	            var drawerIsOpening = false;
	            var drawerIsOpenPostfix = 'DrawerIsOpen';
	            var mediaQuery = $window.matchMedia('(max-width: ' + phoneMediaBreakpoint + 'px)');
	
	            var ctrl = Object.create(BaseCtrl);
	
	            ctrl.init = function () {
	                $scope['left' + drawerIsOpenPostfix] = false; // leftDrawerIsOpen
	                $scope['right' + drawerIsOpenPostfix] = false; // rightDrawerIsOpen
	
	                ctrl._breakpointReached(mediaQuery);
	
	                // EVENTS
	                mediaQuery.addListener(ctrl._breakpointReached);
	
	                $element.on('click', function () {
	                    if (drawerIsOpening) {
	                        drawerIsOpening = false;
	                        return;
	                    }
	                    ctrl.closeDrawers();
	                });
	
	                // remove listeners on $scope destroying
	                $scope.$on('$destroy', function () {
	                    mediaQuery.removeListener(ctrl._breakpointReached);
	                    ctrl._retrieveContentFocus();
	                    $element.off('click');
	                });
	            };
	
	            /**
	             * @param drawerSide {String} 'left' || 'right'
	             */
	            ctrl.openDrawer = function (drawerSide) {
	                // close other
	                var otherDrawerSide = ctrl._getOtherDrawerSide(drawerSide);
	                if ($scope[otherDrawerSide + drawerIsOpenPostfix]) {
	                    ctrl.closeDrawer(otherDrawerSide);
	                }
	                // open current
	                $element.addClass('gw-snap-drawer-' + drawerSide + '-active');
	                ctrl._preventContentFocus();
	
	                drawerIsOpening = true;
	                $scope[drawerSide + drawerIsOpenPostfix] = true; // set drawer state to $scope
	            };
	
	            /**
	             * @param drawerSide {String} 'left' || 'right'
	             */
	            ctrl.closeDrawer = function (drawerSide) {
	                $element.removeClass('gw-snap-drawer-' + drawerSide + '-active');
	                ctrl._retrieveContentFocus();
	
	                $scope[drawerSide + drawerIsOpenPostfix] = false; // set drawer state to $scope
	            };
	
	            ctrl.closeDrawers = function () {
	                if ($scope['left' + drawerIsOpenPostfix]) {
	                    ctrl.closeDrawer('left');
	                    ctrl._angularApply();
	                }
	
	                if ($scope['right' + drawerIsOpenPostfix]) {
	                    ctrl.closeDrawer('right');
	                    ctrl._angularApply();
	                }
	            };
	
	            // UTILS
	            ctrl._getOtherDrawerSide = function (drawerSide) {
	                switch (drawerSide) {
	                    case 'left':
	                        return 'right';
	                    case 'right':
	                        return 'left';
	                    default:
	                        break;
	                }
	            };
	
	            // Required when some functionality is called outside of AngularJs
	            ctrl._angularApply = function () {
	                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
	                    $scope.$apply();
	                }
	            };
	
	            /* EVENT */
	            // PREVENT SCROLLING AND FOCUS INSIDE ELEMENTS WHEN DRAWER IS OPEN
	            ctrl._preventContentFocus = function () {
	                $element.on('focusin.snap', function (e) {
	                    return $(e.target).blur();
	                });
	            };
	
	            ctrl._retrieveContentFocus = function () {
	                $element.off('focusin.snap');
	            };
	
	            // media query change
	            ctrl._breakpointReached = function () {
	                if (!mediaQuery.matches) {
	                    // >= break
	                    ctrl.closeDrawers(); // close drawers on switching from a mobile to a bigger screen
	                }
	            };
	
	            return ctrl.create($scope);
	        };
	        ctrlConstructor.$inject = ['$scope', 'phoneMediaBreakpoint', '$window', '$element'];
	
	        return {
	            restrict: 'A',
	            replace: false,
	            template: '<div ng-transclude></div>',
	            transclude: true,
	            controller: ctrlConstructor
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// console.log("App 2") //*Princy
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(348), __webpack_require__(781), __webpack_require__(463), __webpack_require__(857)], __WEBPACK_AMD_DEFINE_RESULT__ = function (SupportedLobModules) {
	
	    SupportedLobModules.push('edge.quoteandbind.quickquote.app');
	    SupportedLobModules.push('edge.policyjob.app');
	    SupportedLobModules.push('edge.platform.navigation');
	
	    return angular.module('edge.quoteandbind.app', SupportedLobModules);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(349), __webpack_require__(352), __webpack_require__(746), __webpack_require__(780)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ApplicationFeatures) {
	    var lobModules = [];
	
	    if (!ApplicationFeatures.hasFeature('role.vendor')) {
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
	            lobModules.push('edge.quoteandbind.pa.app');
	        }
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
	            lobModules.push('edge.quoteandbind.ho.app');
	        }
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
	            lobModules.push('edge.quoteandbind.cp.app');
	        }
	    }
	
	    return lobModules;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(350), __webpack_require__(351)], __WEBPACK_AMD_DEFINE_RESULT__ = function (has, featureCategories) {
	    var hasFeatureFn = function hasFeatureFn(featureCategory) {
	        return featureCategory && featureCategory !== 'false';
	    };
	
	    for (var featureCategory in featureCategories) {
	        if (featureCategories.hasOwnProperty(featureCategory)) {
	            if (Array.isArray(featureCategories[featureCategory])) {
	                for (var i = 0; i < featureCategories[featureCategory].length; i++) {
	                    if (!has.add(featureCategory + '.' + featureCategories[featureCategory][i])) {
	                        has.add(featureCategory + '.' + featureCategories[featureCategory][i], hasFeatureFn.bind(undefined, featureCategories[featureCategory][i]));
	                    }
	                }
	            } else {
	                if (!has.add(featureCategory)) {
	                    has.add(featureCategory, hasFeatureFn.bind(undefined, featureCategories[featureCategory]));
	                }
	            }
	        }
	    }
	    /**
	     * Service for setting up has feature check functions and returning feature categories
	     */
	    return {
	        getAllFeatures: function getAllFeatures() {
	            return featureCategories;
	        },
	        hasFeature: function hasFeature(featureName) {
	            return has(featureName);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 350 */
/***/ function(module, exports) {

	;(function(g){
	
	    // summary: A simple feature detection function/framework.
	    //
	    // name: String
	    //      The name of the feature to detect, as defined by the overall `has` tests.
	    //      Tests can be registered via `has.add(testname, testfunction)`.
	    //
	    // example:
	    //      mylibrary.bind = has("native-bind") ? function(fn, context){
	    //          return fn.bind(context);
	    //      } : function(fn, context){
	    //          return function(){
	    //              fn.apply(context, arguments);
	    //          }
	    //      }
	
	    var NON_HOST_TYPES = { "boolean": 1, "number": 1, "string": 1, "undefined": 1 },
	        VENDOR_PREFIXES = ["Webkit", "Moz", "O", "ms", "Khtml"],
	        d = isHostType(g, "document") && g.document,
	        el = d && isHostType(d, "createElement") && d.createElement("DiV"),
	        freeExports = typeof exports == "object" && exports,
	        freeModule = typeof module == "object" && module,
	        testCache = {}
	    ;
	
	    function has(/* String */name){
	        if(typeof testCache[name] == "function"){
	            testCache[name] = testCache[name](g, d, el);
	        }
	        return testCache[name]; // Boolean
	    }
	
	    function add(/* String */name, /* Function */test, /* Boolean? */now){
	        // summary: Register a new feature detection test for some named feature
	        //
	        // name: String
	        //      The name of the feature to test.
	        //
	        // test: Function
	        //      A test function to register. If a function, queued for testing until actually
	        //      needed. The test function should return a boolean indicating
	        //      the presence of a feature or bug.
	        //
	        // now: Boolean?
	        //      Optional. Omit if `test` is not a function. Provides a way to immediately
	        //      run the test and cache the result.
	        // example:
	        //      A redundant test, testFn with immediate execution:
	        //  |       has.add("javascript", function(){ return true; }, true);
	        //
	        // example:
	        //      Again with the redundantness. You can do this in your tests, but we should
	        //      not be doing this in any internal has.js tests
	        //  |       has.add("javascript", true);
	        //
	        // example:
	        //      Three things are passed to the testFunction. `global`, `document`, and a generic element
	        //      from which to work your test should the need arise.
	        //  |       has.add("bug-byid", function(g, d, el){
	        //  |           // g  == global, typically window, yadda yadda
	        //  |           // d  == document object
	        //  |           // el == the generic element. a `has` element.
	        //  |           return false; // fake test, byid-when-form-has-name-matching-an-id is slightly longer
	        //  |       });
	        testCache[name] = now ? test(g, d, el) : test;
	    }
	
	    // cssprop adapted from http://gist.github.com/598008 (thanks, ^pi)
	    function cssprop(name, el){
	        var supported = false,
	            capitalized = name.charAt(0).toUpperCase() + name.slice(1),
	            length = VENDOR_PREFIXES.length,
	            style = el.style;
	
	        if(typeof style[name] == "string"){
	            supported = true;
	        }else{
	            while(length--){
	                if(typeof style[VENDOR_PREFIXES[length] + capitalized] == "string"){
	                    supported = true;
	                    break;
	                }
	            }
	        }
	        return supported;
	    }
	
	    function clearElement(el){
	        if(el){
	            while(el.lastChild){
	                el.removeChild(el.lastChild);
	            }
	        }
	        return el;
	    }
	
	    // Host objects can return type values that are different from their actual
	    // data type. The objects we are concerned with usually return non-primitive
	    // types of object, function, or unknown.
	    function isHostType(object, property){
	        var type = typeof object[property];
	        return type == "object" ? !!object[property] : !NON_HOST_TYPES[type];
	    }
	
	    //>>excludeStart("production", true);
	    function all(){
	        // summary: For debugging or logging, can be removed in production. Run all known tests
	        //  at some point in time for the current environment.
	        var name, ret = {};
	        for(name in testCache){
	            try{
	                ret[name] = has(name);
	            }catch(e){
	                ret[name] = "error";
	                ret[name].ERROR_MSG = e.toString();
	            }
	        }
	        return ret;
	    }
	
	    has.all = all;
	    //>>excludeEnd("production");
	    has.add = add;
	    has.clearElement = clearElement;
	    has.cssprop = cssprop;
	    has.isHostType = isHostType;
	    has._tests = testCache;
	
	    has.add("dom", function(g, d, el){
	        return d && el && isHostType(g, "location") && isHostType(d, "documentElement") &&
	            isHostType(d, "getElementById") && isHostType(d, "getElementsByName") &&
	            isHostType(d, "getElementsByTagName") && isHostType(d, "createComment") &&
	            isHostType(d, "createElement") && isHostType(d, "createTextNode") &&
	            isHostType(el, "appendChild") && isHostType(el, "insertBefore") &&
	            isHostType(el, "removeChild") && isHostType(el, "getAttribute") &&
	            isHostType(el, "setAttribute") && isHostType(el, "removeAttribute") &&
	            isHostType(el, "style") && typeof el.style.cssText == "string";
	    });
	
	    // Stop repeat background-image requests and reduce memory consumption in IE6 SP1
	    // http://misterpixel.blogspot.com/2006/09/forensic-analysis-of-ie6.html
	    // http://blogs.msdn.com/b/cwilso/archive/2006/11/07/ie-re-downloading-background-images.aspx?PageIndex=1
	    // http://support.microsoft.com/kb/823727
	    try{
	        document.execCommand("BackgroundImageCache", false, true);
	    }catch(e){}
	
	    // Expose has()
	    // some AMD build optimizers, like r.js, check for specific condition patterns like the following:
	    if(typeof define == "function" && typeof define.amd == "object" && define.amd){
	        define("has", function(){
	            return has;
	        });
	    }
	    // check for `exports` after `define` in case a build optimizer adds an `exports` object
	    else if(freeExports){
	        // in Node.js or RingoJS v0.8.0+
	        if(freeModule && freeModule.exports == freeExports){
	          (freeModule.exports = has).has = has;
	        }
	        // in Narwhal or RingoJS v0.7.0-
	        else{
	          freeExports.has = has;
	        }
	    }
	    // in a browser or Rhino
	    else{
	        // use square bracket notation so Closure Compiler won't munge `has`
	        // http://code.google.com/closure/compiler/docs/api-tutorial3.html#export
	        g["has"] = has;
	    }
	})(this);


/***/ },
/* 351 */
/***/ function(module, exports) {

	module.exports = {"transport-service":"default","quoteandbind_lob":["pa","ho"],"agentquoteandbind":"false","phone-validation":["libphonenumber"]}

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	console.log("App 3"); //*Princy
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(365), __webpack_require__(356), __webpack_require__(359), __webpack_require__(361), __webpack_require__(363), __webpack_require__(353), __webpack_require__(389), __webpack_require__(390), __webpack_require__(463), __webpack_require__(738), __webpack_require__(512)
	// '../../../../../../app/customer/js/src/edge/quoteandbind/pa/assets/angularjs-crypto.js', //*Princy
	// '../../../../../../app/customer/js/src/edge/quoteandbind/pa/assets/CryptoJSCipher.js' //*Princy
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, RouteConfig, EditDriver, EditVehicle, PAConfirmation, PAEditCoverages, PAViewCoverages) {
	    return angular.module('edge.quoteandbind.pa.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']) //*Princy added angularjs-crypto
	
	    .config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
	        var states = new RouteConfig(RootStateConfig);
	        for (var stateName in states) {
	            if (states.hasOwnProperty(stateName)) {
	                $stateProvider.state(stateName, states[stateName]);
	            }
	        }
	    }]).filter('orderObjectBy', function () {
	        return function (items, field, reverse) {
	            var filtered = [];
	            angular.forEach(items, function (item) {
	                filtered.push(item);
	            });
	            filtered.sort(function (a, b) {
	                /*eslint-disable */
	                return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
	                /*eslint-enable */
	            });
	            if (reverse) {
	                filtered.reverse();
	            }
	            return filtered;
	        };
	    }).directive('gwQnbPaEditDriver', EditDriver).directive('gwQnbPaEditVehicle', EditVehicle).directive('gwPaConfirmation', PAConfirmation).directive('gwQnbPaEditCoverages', PAEditCoverages).directive('gwQnbPaViewCoverages', PAViewCoverages).constant('VinLookupEnabled', true).value('pa.qnb.editableDriverDOB', false);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(354)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbPaViewCoverages'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 354 */
/***/ function(module, exports) {

	module.exports = "<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.General Coverages' | translate}}</span>\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.(Apply to all vehicles)' | translate}}</span>\n</h4>\n\n<div gw-qnb-readonly-coverages=\"model.lineCoverages\"></div>\n\n<div ng-repeat=\"vehicle in model.vehicleCoverages\">\n    <h4 class=\"gw-coverage-header\">{{ vehicle.vehicleName }}</h4>\n\n    <div class=\"gw-quote-boxes\">\n        <div gw-qnb-readonly-coverages=\"vehicle.coverages\"></div>\n    </div>\n</div>\n"

/***/ },
/* 355 */
/***/ function(module, exports) {

	//     Underscore.js 1.8.0
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Reusable constructor function for prototype setting.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (typeof exports !== 'undefined') {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.0';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var isArrayLike = function(collection) {
	    var length = collection && collection.length;
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, target) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    return _.indexOf(obj, target) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = input && input.length; i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (array == null) return [];
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = array.length; i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    if (array == null) return [];
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = array.length; i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, 'length').length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = list && list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    var i = 0, length = array && array.length;
	    if (typeof isSorted == 'number') {
	      i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
	    } else if (isSorted && length) {
	      i = _.sortedIndex(array, item);
	      return array[i] === item ? i : -1;
	    }
	    if (item !== item) {
	      return _.findIndex(slice.call(array, i), _.isNaN);
	    }
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  _.lastIndexOf = function(array, item, from) {
	    var idx = array ? array.length : 0;
	    if (typeof from == 'number') {
	      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
	    }
	    if (item !== item) {
	      return _.findLastIndex(slice.call(array, 0, idx), _.isNaN);
	    }
	    while (--idx >= 0) if (array[idx] === item) return idx;
	    return -1;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = array != null && array.length;
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createIndexFinder(1);
	
	  _.findLastIndex = createIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    return function bound() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function bound() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var proto = typeof obj.constructor === 'function' ? FuncProto : ObjProto;
	
	    while (nonEnumIdx--) {
	      var prop = nonEnumerableProps[nonEnumIdx];
	      if (prop === 'constructor' ? _.has(obj, prop) : prop in obj &&
	        obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj, iteratee, context) {
	    var result = {}, key;
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      iteratee = optimizeCb(iteratee, context);
	      for (key in obj) {
	        var value = obj[key];
	        if (iteratee(value, key, obj)) result[key] = value;
	      }
	    } else {
	      var keys = flatten(arguments, false, false, 1);
	      obj = new Object(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        key = keys[i];
	        if (key in obj) result[key] = obj[key];
	      }
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of 
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	  
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (typeof define === 'function' && define.amd) {
	    define('underscore', [], function() {
	      return _;
	    });
	  }
	}.call(this));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(357), __webpack_require__(355), __webpack_require__(358), __webpack_require__(334)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, _, LocalDateUtil, moment) {
	    return ['AgeAllowedToDrive', 'pa.qnb.editableDriverDOB', 'LicensedAgeAllowedToDrive', 'ModalService', function (AgeAllowedToDrive, editableDriverDOB, LicensedAgeAllowedToDrive, ModalService) {
	        return {
	            restrict: 'A',
	            scope: {
	                driver: '=',
	                prefillVehicles: '=',
	                vehicles: '='
	            },
	            // added '$rootScope' *Princy
	            template: templateStr,
	            controller: ['$scope', '$rootScope', '$filter', 'DriverProcessService', function ($scope, $rootScope, $filter, DriverProcessService) {
	
	                //SSN INC0019597
	                $scope.ssnMask = '999-99-9999';
	                $scope.ssnOriginal = [];
	                $scope.isSsnEdit = false;
	                // added scope.age = null along with console.log *Princy
	                $scope.age = null;
	
	                // console.log( $rootScope) 
	                // addded isPrefilledDriverFlag *Princy UI
	                if ($scope.driver.isPrefilledDriver.value == true) {
	                    $rootScope.isPrefilledDriver = true;
	                }
	                // end of statement-- isPrefilledDriverFlag *Princy
	
	                // ctrl.init  added  *Princy
	
	                //   console.log($scope.driver);
	                //   console.log($scope.age);
	
	
	                // adding age *Princy UI
	                $scope.getAge = function (localDate) {
	
	                    var year = parseInt(localDate.year);
	                    if (isNaN(year)) return '';
	                    var month = parseInt(localDate.month) - 1;
	                    var day = parseInt(localDate.day);
	                    var today = new Date();
	                    var birthDate = new Date(year, month, day);
	                    var age = today.getFullYear() - birthDate.getFullYear();
	                    var m = today.getMonth() - birthDate.getMonth();
	                    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	                        age--;
	                    }
	                    return age ? age : null;
	                };
	
	                $scope.age = $scope.getAge($scope.driver.dateOfBirth.value);
	
	                // end of statemenet 
	
	                //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	                $scope.minDob = "01-01-1800";
	                $scope.isMinDateOfBirthValid = true;
	                $scope.checkDate = function () {
	                    if ($scope.driver.dateOfBirth.value && $scope.driver.dateOfBirth.value.year && $scope.driver.dateOfBirth.value.year < "1800") {
	                        $scope.isMinDateOfBirthValid = false;
	                        $scope.driver.dateOfBirth.value = '';
	                        return;
	                    } else {
	                        $scope.isMinDateOfBirthValid = true;
	                    }
	                };
	                //DFCT0020397 - QnB Date Of Birth Validation ends
	
	                $scope.checkExistingSSN = function (elem) {
	                    if ($scope.isSsnEdit) {
	                        return;
	                    }
	                    if ($scope.driver.value.ssnunMasked && $scope.driver.value.ssnunMasked.length == 11) elem.value = "";
	                };
	
	                $scope.checkExistingSSNfout = function (elem) {
	                    if ($scope.ssnOriginal.join('').length < 9 && $scope.driver.value.ssnunMasked) {
	                        ssnvalid = $scope.driver.value.ssnunMasked.substring(0, 3).replace(/\d/gi, '*') + '-' + $scope.driver.value.ssnunMasked.substring(4, 6).replace(/\d/gi, '*') + '-' + $scope.driver.value.ssnunMasked.substring(7, 11);
	                        elem.value = ssnvalid;
	                    }
	                };
	
	                // testing Code *Princy added getAgeFunction
	
	
	                //$scope.age= 17;
	
	                //end of get age function
	
	
	                $scope.updateSSN = function (elem) {
	
	                    $scope.isSsnEdit = true;
	                    //Taking only number as inputs
	                    var reg = /^\d+$/;
	                    var ssnvalue = elem.value.replace(/[*-]/g, '');
	                    if (!reg.test(ssnvalue)) {
	
	                        if ($scope.driver.value.socialSecurityNumber.length > 7) {
	                            var temp = ssnvalue;
	                            temp = temp.substr(0, temp.length - 1);
	                            ssnvalue = $scope.driver.value.socialSecurityNumber.substr(0, 7) + temp;
	                        } else {
	                            ssnvalue = ssnvalue.substr(0, ssnvalue.length - 1);
	                        }
	                        angular.element(elem).val(String(ssnvalue));
	                        $scope.$apply();
	                        return;
	                    } else {
	                        if ($scope.ssnOriginal[5]) {
	                            $scope.ssnOriginal[5] = ssnvalue;
	                        } else {
	
	                            $scope.ssnOriginal.push(ssnvalue);
	                        }
	                    }
	
	                    //masking first 5 digits of ssn 
	                    var maskedSSNValue = elem.value.replace(/-/gi, '').replace(/_/gi, '').split('');
	                    var newMaskedSSNValue = [];
	                    maskedSSNValue.map(function (num, index) {
	
	                        if (index <= 4) {
	                            if (index == 3 || index == 5) {
	
	                                newMaskedSSNValue[index] = '-*';
	                            } else {
	                                newMaskedSSNValue[index] = '*';
	                            }
	                        } else {
	                            if (index == 3 || index == 5) {
	                                newMaskedSSNValue[index] = '-' + num;
	                            } else {
	                                newMaskedSSNValue[index] = num;
	                            }
	                        }
	                    });
	
	                    $scope.driver.socialSecurityNumber = newMaskedSSNValue.join('');
	
	                    if ($scope.ssnOriginal.join('').length == 9) {
	
	                        var orgssnvalue = angular.copy($scope.ssnOriginal).join('');
	                        $scope.driver.value.ssnunMasked = orgssnvalue.substring(0, 3) + '-' + orgssnvalue.substring(3, 5) + '-' + orgssnvalue.substring(5, 9);
	                    }
	
	                    $scope.$apply();
	                };
	                //SSN INC0019597 
	
	
	                var deregisterDriverWatch = void 0;
	                var deregisterDobWatch = void 0;
	                var deregisterAgeWatch = void 0;
	                //let deregisterAssignmentWatch;
	                var deregisterIncludeMCWatch = void 0;
	                var deregisterAccidentsInLast3Years = void 0;
	
	                // Current date
	                var currentDate = new Date();
	
	                // Current local date
	                $scope.currentLocalDate = {
	                    year: currentDate.getFullYear(),
	                    month: currentDate.getMonth(),
	                    day: currentDate.getDate()
	                };
	
	                $scope.filterNameDetailCodes = {
	                    suffix: ["c_II"]
	                };
	
	                // Residence Type Filter Codes
	                $scope.residenceTypeFilterCodes = ["Fam2", "Fam3", "Fam4", "Fam5", "Coop", "Triplex_aaa", "Quadplex_aaa"];
	
	                // Dont display state codes from this list in license state
	                $scope.stateFilterCodes = ["PR"];
	
	                // Not display occupation typecodes from this list
	                $scope.occupationFilterCodes = ["studentawaymorethan100mi"];
	
	                //$scope.addFormErrror = false;
	                //$scope.editFormErrror = false;
	
	                // Prefill Drivers list
	                $scope.prefillDriversList = [];
	
	                // Assign driver and vehicle fields
	                function assignDriversToPrefillVehicles() {
	                    if ($scope.driver.value.oftenDriveVehicle == "principal") {
	                        if ($scope.driver.value.mostDriveVehicle.prinicipalSelected) {
	                            //console.log("Another driver is selected as a primary driver for this vehicle.");
	                            $scope.driver.value.oftenDriveVehicle = undefined;
	                            ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Vehicle Usage Error");
	                        } else {
	                            $scope.driver.value.mostDriveVehicle.prinicipalSelected = true;
	                        }
	                    }
	
	                    for (var idx in $scope.vehicles) {
	                        //console.log("Veh:: ", $scope.vehicles[idx]);
	                        if ($scope.vehicles[idx]["vin"] == $scope.driver.value.mostDriveVehicle.vin) {
	                            $scope.vehicles[idx]["assignedDriver"] = $scope.driver.value;
	                            $scope.vehicles[idx]["driverType"] = $scope.driver.value.oftenDriveVehicle;
	                            //console.log("Matched Vehicle:: ", $scope.vehicles[idx]);
	                            break;
	                        }
	                    }
	                };
	
	                //console.log("jj: ",$scope.accountHolder, $scope.accountHolder.primaryAddress.state);
	
	                // Set account holder state for driver
	                //$scope.driver.accountHolderState.value = $scope.accountHolder.primaryAddress.state;
	
	                // Set license number exists or not
	                $scope.isLicenseNumberExists = $scope.driver.licenseNumber.value ? true : false;
	
	                //console.log("Account Holder State: ",$scope.driver.accountHolderState.value);                         
	
	                // reset values
	                $scope.resetValues = function () {
	
	                    return {
	                        category: undefined,
	                        type: undefined,
	                        amount: undefined,
	                        date: undefined,
	                        waivedStatusStr: undefined,
	                        editing: false,
	                        remove: false
	                    };
	                };
	
	                // Relationhip List
	                $scope.relationShipList = DriverProcessService.getRelationShipList();
	
	                // Set relationship pc mapping 
	                $scope.setRelationShipPcMapping = function () {
	
	                    // PC Mapping - if selected value is Child then map it to Relative
	                    if ($scope.driver.relationShipToYou.value == "Child") {
	                        $scope.driver.relationShip.value = "Relative";
	                    } else {
	                        $scope.driver.relationShip.value = $scope.driver.relationShipToYou.value;
	                    }
	                };
	
	                //$scope.driver.licenseNumber.value = "125899";                    
	                //console.log("driver.licenseNumber.value: ", $scope.driver.licenseNumber, $scope.driver.licenseNumber.value);
	
	                // Add New accident voilation model
	                $scope.addAccidentVoilation = $scope.resetValues();
	
	                // Edit accident voilation model
	                $scope.editAccidentVoilation = $scope.resetValues();
	
	                // Temp association list
	                $scope.associationList = DriverProcessService.getAssociationList();
	
	                // Usage of vehicle
	                $scope.vehicleUsageList = DriverProcessService.getVehicleUsageList();
	
	                // Accident/ Voilation Category List for add form
	                $scope.addCateogryList = DriverProcessService.getCategoryList();
	
	                // Accident/ Voilation Category List for edit form
	                $scope.editCateogryList = DriverProcessService.getCategoryList();
	
	                // Type Description List for accidents
	                $scope.accidents = DriverProcessService.getAccidentList();
	
	                // Type description list for claims
	                $scope.claims = DriverProcessService.getClaimList();
	
	                // Merge accidents and claims
	                //$scope.accidentsClaims = angular.extend($scope.accidents, $scope.claims);
	
	                // Type Description List for voilations
	                $scope.voilations = DriverProcessService.getVoilationList();
	
	                //console.log("AccidentsClaims: ",$scope.accidentsClaims);
	                //console.log("Voilations: ",$scope.voilations);
	
	                // hold type list values for add form
	                $scope.addTypeList = {};
	
	                // Load add type list values
	                $scope.loadAddTypeList = function () {
	                    //console.log("Selected Category: ",$scope.addAccidentVoilation.category);
	                    if ($scope.addAccidentVoilation.category == "accident") {
	                        $scope.addTypeList = $scope.accidents;
	                    } else if ($scope.addAccidentVoilation.category == "claim") {
	                        $scope.addTypeList = $scope.claims;
	                    } else if ($scope.addAccidentVoilation.category == "voilation") {
	                        $scope.addTypeList = $scope.voilations;
	                    }
	                };
	
	                // holds type list values for edit form
	                $scope.editTypeList = {};
	
	                // Load edit type list values
	                $scope.loadEditTypeList = function () {
	                    //console.log("Selected Category: ",$scope.addAccidentVoilation.category);
	                    if ($scope.editAccidentVoilation.category == "accident") {
	                        $scope.editTypeList = $scope.accidents;
	                    } else if ($scope.editAccidentVoilation.category == "claim") {
	                        $scope.editTypeList = $scope.claims;
	                    } else if ($scope.editAccidentVoilation.category == "voilation") {
	                        $scope.editTypeList = $scope.voilations;
	                    }
	                };
	
	                // Load Accident/Claim/Voilation List
	                $scope.loadAccidentVoilationList = function (pcAccidentVoilationList, accountHolderState) {
	
	                    if (pcAccidentVoilationList == undefined) {
	                        pcAccidentVoilationList = [];
	                    }
	
	                    //console.log("loadAccidentVoilationList:: ",pcAccidentVoilationList, accountHolderState);
	                    return DriverProcessService.mapAccidentListToPortal(pcAccidentVoilationList, accountHolderState);
	                };
	
	                //console.log("AccidentVoilationList: ",$scope.driver.accidentVoilationList);
	
	                // Test Code
	                //$scope.driver.accidentVoilationList.value = [{"dateOfEvent":{"year":1987, "month":4, "day":29}, "description":"AFA - PD ONLY >1,800 <3000"}];
	
	                // accident claim voilation list
	                //$scope.accidentVoilationList = DriverProcessService.mapAccidentListToPortal($scope.driver.accidentVoilationList.value, $scope.driver.accountHolderState.value.code);
	
	                // Set accidentsInLast3Years value to true if accidentVoilationList is not empty
	                /*if($scope.accidentVoilationList.length > 0){
	                    $scope.driver.accidentsInLast3Years.value = true;
	                }*/
	
	                // Add accident claim voilations
	                $scope.addAccidentClaimVoilation = function () {
	
	                    var accidentVoilation = angular.copy($scope.addAccidentVoilation);
	
	                    $scope.driver.value.isAddAccidentValid = true;
	
	                    if (!accidentVoilation.category || !accidentVoilation.type || !accidentVoilation.date) {
	                        $scope.driver.value.isAddAccidentValid = false;
	                        return;
	                    }
	
	                    if ($scope.driver.accountHolderState.value == 'NC' && accidentVoilation.category != "voilation" && !accidentVoilation.amount) {
	                        $scope.driver.value.isAddAccidentValid = false;
	                        return;
	                    }
	
	                    // check occurence date is a future date
	                    var occurenceDate = new Date(accidentVoilation.date.year, accidentVoilation.date.month, accidentVoilation.date.day);
	                    var tempDate = new Date();
	                    var currentDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
	
	                    if (occurenceDate.getTime() > currentDate.getTime()) {
	
	                        $scope.driver.value.isAddAccidentValid = false;
	                        ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Future Date Error");
	                        return;
	                    }
	
	                    // Set edit mode is false by default
	                    accidentVoilation.editing = false;
	                    $scope.driver.value.accidentVoilationPortalList.push(accidentVoilation);
	
	                    // Reset add form values
	                    $scope.addAccidentVoilation = $scope.resetValues();
	
	                    $scope.addTypeList = {};
	
	                    var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.driver.value.accidentVoilationPortalList, $scope.driver.accountHolderState.value.code);
	                    $scope.driver.value.accidentVoilationList = pcAccidentList;
	                };
	
	                // display edit form
	                $scope.displayEditForm = false;
	
	                // Current item idx is on edit mode
	                $scope.editIndex = -1;
	
	                // Edit accident voilation item
	                $scope.editAccidentVoilationItem = function (idx) {
	
	                    $scope.displayEditForm = true;
	
	                    $scope.editIndex = idx; //_.findLastIndex($scope.accidentVoilationList, accidentVoilation);
	                    //console.log("Index1: ", idx, $scope.editIndex);
	                    var accidentVoilation = $scope.accidentVoilationList[idx];
	                    resetEditFlag(accidentVoilation);
	                    //$scope.editAccidentVoilation = accidentVoilation;
	                    $scope.editAccidentVoilation = angular.copy(accidentVoilation);
	                    // Load edit type list values
	                    $scope.loadEditTypeList();
	                };
	
	                // Reset edit flag for other than passed input 
	                // on the $scope.accidentVoilationList 
	                function resetEditFlag(accidentVoilation) {
	                    for (var idx in $scope.accidentVoilationList) {
	                        if ($scope.accidentVoilationList[idx] === accidentVoilation) {
	                            $scope.accidentVoilationList[idx]["editing"] = true;
	                        } else {
	                            $scope.accidentVoilationList[idx]["editing"] = false;
	                        }
	                    }
	                };
	
	                // Update accident claim voilation item
	                $scope.updateAccidentClaimVoilation = function (idx) {
	
	                    // Currently editing item
	                    var accidentVoilation = $scope.accidentVoilationList[idx];
	
	                    // Edit data
	                    var editCopy = angular.copy($scope.editAccidentVoilation);
	
	                    $scope.driver.value.isEditAccidentValid = true;
	
	                    if (!editCopy.category || !editCopy.type || !editCopy.date) {
	                        $scope.driver.value.isEditAccidentValid = false;
	                        return;
	                    }
	
	                    if (editCopy.category != "voilation" && !editCopy.amount) {
	                        $scope.driver.value.isEditAccidentValid = false;
	                        return;
	                    }
	                    accidentVoilation["editing"] = false;
	                    accidentVoilation["category"] = editCopy.category;
	                    accidentVoilation["type"] = editCopy.type;
	                    accidentVoilation["amount"] = editCopy.amount;
	                    accidentVoilation["date"] = editCopy.date;
	                    accidentVoilation["pcDescription"] = editCopy.description;
	
	                    // Reset edit form values
	                    $scope.editAccidentVoilation = $scope.resetValues();
	                    $scope.displayEditForm = false;
	
	                    var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.accidentVoilationList, $scope.driver.accountHolderState.value.code);
	                    $scope.driver.accidentVoilationList.value = pcAccidentList;
	                    //console.log("$scope.driver.accidentVoilationList: ", $scope.driver.accidentVoilationList.value);
	                };
	
	                // Delete accident claim voilation item
	                $scope.deleteAccidentClaimVoilation = function (idx) {
	
	                    $scope.driver.value.accidentVoilationPortalList[idx]["editing"] = false;
	
	                    var accidentVoilation = $scope.driver.value.accidentVoilationPortalList[idx];
	                    var deleteVoilation = angular.copy(accidentVoilation);
	
	                    // Initialize delete accident voilation list
	                    if ($scope.driver.value.deleteViolationList == null || $scope.driver.value.deleteViolationList == undefined) {
	                        $scope.driver.value.deleteViolationList = [];
	                    }
	
	                    // Add deleted accident voilation into the deletion list to
	                    // deleted the initial disclosures from driver entity
	                    if (deleteVoilation.publicID) {
	                        $scope.driver.value.deleteViolationList.push(deleteVoilation);
	                    }
	
	                    $scope.driver.value.accidentVoilationPortalList = _.without($scope.driver.value.accidentVoilationPortalList, _.findWhere($scope.driver.value.accidentVoilationPortalList, accidentVoilation));
	
	                    $scope.displayEditForm = false;
	                    //console.log("DeleteAccidentClaimVoilation.List: ", $scope.accidentVoilationList, accidentVoilation);
	
	                    var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.driver.value.accidentVoilationPortalList, $scope.driver.accountHolderState.value.code);
	                    $scope.driver.value.accidentVoilationList = pcAccidentList;
	                    //console.log("Delete AccidentVoilationList: ", $scope.driver.value.accidentVoilationList);
	                };
	
	                // Display Type 
	                $scope.displayItemType = function (item) {
	
	                    /*if(item.category == "accident"){
	                        return $scope.accidents[item.type];
	                    }
	                    else if(item.category == "voilation"){
	                        return $scope.voilations[item.type];
	                    }
	                    else if (item.category == "claim"){
	                        return $scope.claims[item.type];
	                    }
	                    
	                    return "N/A";*/
	                    if (item.category == "voilation" && item.pcDescription == "DWI") {
	                        return "major violation";
	                    } else if (item.category == "voilation" && (item.pcDescription == undefined || item.pcDescription == "FAIL TO REDUCE SPEED")) {
	                        return "moving violation";
	                    } else {
	                        if (item.pcDescription == null || item.pcDescription == undefined) {
	                            return item.description;
	                        } else {
	                            return item.pcDescription;
	                        }
	                    }
	                };
	
	                // Display amount in gw currency format
	                $scope.displayAmount = function (item) {
	                    return item.amount;
	                };
	
	                // Display date in MM/DD/YYYY format
	                $scope.displayDate = function (item) {
	
	                    var date = new Date(item.date.year, item.date.month, item.date.day, 0, 0, 0);
	
	                    return moment(date.toJSON()).format("MM/DD/YYYY");
	                };
	
	                function resetForm() {
	
	                    if (angular.isDefined($scope.driver.value)) {
	
	                        // Set prefill vehicle count
	                        $scope.driver.value.prefillVehicleCount = $scope.prefillVehicles.length;
	                        $scope.driver.prefillVehicleCount.value = $scope.prefillVehicles.length;
	
	                        //console.log("Hello: ",$scope.prefillVehicles, $scope.driver.value.prefillVehicleCount);
	
	                        $scope.driver.value.accidentVoilationPortalList = DriverProcessService.mapAccidentListToPortal($scope.driver.value.accidentVoilationList, $scope.driver.accountHolderState.value.code);
	                    }
	                    //reset ssn original
	                    $scope.ssnOriginal = [];
	                    $scope.isSsnEdit = false;
	
	                    //console.log("Hello1: ",$scope.driver.value);
	
	                    var startingYear = new Date();
	
	                    $scope.editableDriverDOB = editableDriverDOB;
	                    $scope.maxDateOfBirth = {
	                        year: startingYear.getFullYear() - AgeAllowedToDrive,
	                        month: startingYear.getMonth(),
	                        day: startingYear.getDate()
	                    };
	
	                    // Driver max date of birth
	                    $scope.maxDriverDateOfBirth = {
	                        year: startingYear.getFullYear() - LicensedAgeAllowedToDrive,
	                        month: startingYear.getMonth(),
	                        day: startingYear.getDate()
	                    };
	
	                    $scope.years = [];
	                    var currentYear = new Date().getUTCFullYear();
	
	                    $scope.setYears = function (earliestYear) {
	                        $scope.years.length = 0;
	                        for (var i = currentYear - earliestYear; i <= currentYear; i++) {
	                            $scope.years.unshift(i);
	                            if (i === currentYear) {
	                                //last iteration of loop, if user has changed their dob to be after year first licensed
	                                //make sure that the yearLicensed previously chosen is still valid.
	                                if ($scope.driver.value && $scope.driver.yearLicensed.value && $scope.years.indexOf($scope.driver.yearLicensed.value) === -1) {
	                                    $scope.driver.yearLicensed.value = undefined;
	                                }
	                            }
	                        }
	                    };
	
	                    $scope.updateDriverExperience = function (dateOfBirth, firstLicensed) {
	
	                        if (dateOfBirth && firstLicensed) {
	
	                            var driverExperience = DriverProcessService.getDriverExperience(dateOfBirth, firstLicensed);
	                            //console.log("inExperiencedDriver:::: ", $scope.driver.inExperiencedDriver);
	                            if (driverExperience < 3) {
	                                $scope.driver.inExperiencedDriver.value = true;
	                            } else {
	                                $scope.driver.inExperiencedDriver.value = false;
	                            }
	
	                            // Update Year First Licensed
	                            $scope.driver.yearLicensed.value = DriverProcessService.calcYearFirstLicensed(dateOfBirth, firstLicensed);
	                        }
	                    };
	
	                    if ($scope.driver.value && $scope.driver.dateOfBirth.value) {
	                        var dobDate = $scope.driver.dateOfBirth.value;
	                        $scope.setYears(currentYear - (dobDate.year + AgeAllowedToDrive));
	                    } else {
	                        $scope.setYears(AgeAllowedToDrive);
	                    }
	
	                    deregisterDobWatch = $scope.$watch('driver.dateOfBirth.value', function (dob) {
	                        if (angular.isDefined(dob)) {
	                            $scope.setYears(currentYear - (dob.year + AgeAllowedToDrive));
	                            //updateDriverExperience(dob, $scope.driver.firstLicensed.value); 
	                            $scope.updateDriverExperience(dob, $scope.driver.firstLicensed.value);
	                            $scope.age = $scope.getAge(dob); //added age *Princy UI
	                            if (dob) {
	                                $scope.checkDate();
	                            }
	                        }
	                    }, true);
	
	                    deregisterAgeWatch = $scope.$watch('driver.firstLicensed.value', function (ageFirstLicensed) {
	                        if (angular.isDefined(ageFirstLicensed)) {
	                            //updateDriverExperience($scope.driver.dateOfBirth.value, ageFirstLicensed);
	                            $scope.updateDriverExperience($scope.driver.dateOfBirth.value, ageFirstLicensed);
	                        }
	                    }, true);
	
	                    deregisterDriverWatch = $scope.$watch('driver.value', function () {
	                        if (angular.isDefined($scope.driver.value)) {
	                            //devendra commented below line
	                            $scope.fixedDateOfBirth = LocalDateUtil.toMidnightDate($scope.driver.dateOfBirth.value);
	                            $scope.driver.accidents.value = $scope.driver.accidents.value || $scope.driver.accidents.aspects.availableValues[0];
	                            $scope.driver.violations.value = $scope.driver.violations.value || $scope.driver.violations.aspects.availableValues[0];
	
	                            $scope.driver.value.accidentVoilationPortalList = DriverProcessService.mapAccidentListToPortal($scope.driver.value.accidentVoilationList, $scope.driver.accountHolderState.value.code);
	
	                            // Reset add accident selection when switch on drivers
	                            $scope.addAccidentVoilation = $scope.resetValues();
	                        }
	                    });
	
	                    /*deregisterAssignmentWatch = $scope.$watch('driver.oftenDriveVehicle.value', () => {
	                        if (angular.isDefined($scope.driver.oftenDriveVehicle.value)) {
	                            //assignDriversToPrefillVehicles();
	                        }
	                    });*/
	
	                    deregisterIncludeMCWatch = $scope.$watch('driver.inMotorCycle.value', function (inMotorCycle) {
	                        if (inMotorCycle == false) {
	
	                            if ($scope.driver.takenMotorSafetyCourse.value == true) {
	                                $scope.driver.takenMotorSafetyCourse.value = undefined;
	                            }
	
	                            if ($scope.driver.endorsementOnDriverLicense.value == true) {
	                                $scope.driver.endorsementOnDriverLicense.value = undefined;
	                            }
	                            $scope.driver.motorCycleSafetyCourseYear.value = undefined;
	                        }
	                    });
	
	                    deregisterIncludeMcDateWatch = $scope.$watch('driver.takenMotorSafetyCourse.value', function () {
	
	                        if (!$scope.driver.takenMotorSafetyCourse.value) {
	                            $scope.driver.motorCycleSafetyCourseYear.value = undefined;
	                        }
	                    });
	
	                    // Delete incidents if selected value for  accidentsInLast3Years is false
	                    deregisterAccidentsInLast3Years = $scope.$watch('driver.accidentsInLast3Years.value', function () {
	
	                        if ($scope.driver.accidentsInLast3Years.value != undefined && $scope.driver.accidentsInLast3Years.value == false) {
	
	                            var accidentVoilations = angular.copy($scope.driver.value.accidentVoilationPortalList);
	
	                            // Initialize delete accident voilation list
	                            if ($scope.driver.value.deleteViolationList == null || $scope.driver.value.deleteViolationList == undefined) {
	                                $scope.driver.value.deleteViolationList = [];
	                            }
	
	                            for (var idx in accidentVoilations) {
	
	                                var deleteVoilation = accidentVoilations[idx];
	
	                                // Add deleted accident voilation into the deletion list to
	                                // deleted the initial disclosures from driver entity
	                                if (deleteVoilation.publicID) {
	                                    $scope.driver.value.deleteViolationList.push(deleteVoilation);
	                                }
	                            }
	
	                            $scope.driver.value.accidentVoilationPortalList = [];
	                            $scope.driver.value.accidentVoilationList = [];
	                        }
	                    });
	                }
	
	                resetForm();
	                $scope.$on('update-form', function () {
	                    deregisterDriverWatch();
	                    deregisterDobWatch();
	                    deregisterAgeWatch();
	                    //deregisterAssignmentWatch();
	                    deregisterIncludeMCWatch();
	                    deregisterAccidentsInLast3Years();
	                    resetForm();
	                });
	            }]
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 357 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <div gw-pl-name-details contact=\"driver.person\" filter-name-detail-codes=\"filterNameDetailCodes\"\r\n         readonly=\"driver.person.value.accountHolder\"></div>\r\n</div>\r\n\r\n<div>\r\n    <!-- *Princy UI ng-show=\"!driver.isPrefilledDriver.value\" -->\r\n    <div ng-show=\"!driver.isPrefilledDriver.value\" gw-pl-ctrl-group model=\"driver.dateOfBirth\" \r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Date of Birth' | translate}}\">\r\n         <!-- DFCT0020397 - QnB Date Of Birth Validation - added min date,method on blur and keyup -Arpita -->\r\n        <span gw-pl-local-date-chooser model=\"driver.dateOfBirth.value\" max-date=\"maxDriverDateOfBirth\"\r\n              initial-date=\"maxDriverDateOfBirth\"\r\n              ng-show=\"!driver.person.value.accountHolder || editableDriverDOB\" required=\"driver.isPrefilledDriver ? false : true\" min-date=\"minDob\" >\r\n        </span>\r\n        <!-- DFCT0020397 - QnB Date Of Birth Validation - added error msg -Arpita -->\r\n        <div  class=\"custom-error\" ng-show=\"!isMinDateOfBirthValid\">\r\n            {{'quoteandbind.views.contact-details.Date of Birth must be no earlier than 01/01/1800' | translate}}\r\n        </div>\r\n        <!-- Show if inverse of above. De Morgan's laws -->\r\n        <!-- added one more condition for ng-show \"&&  driver.age == undefined\" *Princy*-->\r\n        <span ng-show=\"driver.person.value.accountHolder && !editableDriverDOB\" >{{fixedDateOfBirth | date}}</span>\r\n    </div>\r\n    <!-- Added below <div> for age  *Princy UI -->\r\n        <div ng-show=\"driver.isPrefilledDriver.value\" style=\"margin-bottom: 15px;\">\r\n            <div style =\"color: #848484;width: 37.2%;float: left;\">Age</div>\r\n            <span class =\"age-span-pa-edit-driver\">{{age}}</span>\r\n        </div>\r\n    <!--end of <div> for age prefill-->\r\n        <!--Added below <div> for age  *Princy*-->  \r\n   <!-- <div gw-pl-ctrl-group model=\"driver.dateOfBirth\"\r\n    label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Age' | translate}}\"\r\n    ng-show=\"driver.age !== undefined\">\r\n    \r\n   <span gw-pl-local-date-chooser model=\"driver.dateOfBirth.value\" max-date=\"maxDriverDateOfBirth\"\r\n         initial-date=\"maxDriverDateOfBirth\"></span>\r\n   <span ng-show=\"driver.age !== undefined\">{{getAge(driver.dateOfBirth)}}</span>\r\n    </div> -->\r\n    <!--end of <div> for age prefill-->\r\n    <div ng-show=\"!driver.isPrefilledDriver.value\" gw-pl-ctrl-group model=\"driver.gender\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Gender' | translate}}\">\r\n        <select gw-pl-select=\"driver.gender.value\" options='driver.gender.aspects.availableValues' render-by=\"'name'\"\r\n                placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.-- Choose Driver Gender --' | translate}}\" required=\"driver.isPrefilledDriver ? false : true\"></select>\r\n    </div>\r\n    <div gw-pl-ctrl-group model=\"driver.maritialStatus\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Maritial Status' | translate}}\">\r\n        <select gw-pl-select=\"driver.maritialStatus.value\" options=\"driver.maritialStatus.aspects.availableValues\"\r\n                render-by=\"'name'\"\r\n                placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Maritial Status--' | translate}}\"></select>\r\n    </div>\r\n <!-- SSN INC0019597 -->\r\n\r\n    <div gw-pl-ctrl-group model=\"driver.socialSecurityNumber\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Social Security Number' | translate}}\"\r\n         help-tip=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.SSN Tooltip' | translate }}\">\r\n\r\n       \r\n              <input type=\"text\" required ng-model=\"driver.socialSecurityNumber.value\" maxlength=\"11\" placeholder=\"___-__-____\"  oninput=\"angular.element(this).scope().updateSSN(this)\"\r\n               onfocusin=\"angular.element(this).scope().checkExistingSSN(this)\"   />\r\n              </div>\r\n    <div gw-pl-ctrl-group model=\"driver.educationalLevel\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Education Level' | translate}}\">\r\n        <select gw-pl-select=\"driver.educationalLevel.value\" options=\"driver.educationalLevel.aspects.availableValues\"\r\n                render-by=\"'name'\"\r\n                placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Education Level--' | translate}}\"></select>\r\n    </div>\r\n    <gw-pl-input-ctrl model=\"driver.occupation\"\r\n                      filter-codes=\"occupationFilterCodes\"\r\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Occupation' | translate }}\"\r\n                      placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Occupation--' | translate }}\">\r\n    </gw-pl-input-ctrl>\r\n    <div gw-pl-ctrl-group\r\n         model=\"driver.payGrade\"\r\n         ng-show=\"driver.occupation.value.code == 'military'\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Whats your pay grade?' | translate}}\">\r\n        <select gw-pl-select=\"driver.payGrade.value\" options=\"driver.payGrade.aspects.availableValues\"\r\n                render-by=\"'name'\"\r\n                placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Pay Grade--' | translate}}\"></select>\r\n    </div>\r\n    <div gw-pl-yes-no-group\r\n         ng-show=\"driver.isAccountHolder.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Does the insured own their home?' | translate }}\"\r\n         model=\"driver.ownHome\" name=\"OwnHome\">\r\n    </div>\r\n    <hr>\r\n    <!-- Author Dev: Show the License number field into UI if the prefilled License number is not available -->\r\n    <gw-pl-input-ctrl ng-hide=\"driver.isPrefilledDriver.value && driver.hasPrefilledLicenseNumber.value && driver.eNCLicenseNumber.value\" model=\"driver.licenseNumber\"\r\n                      maxlength=\"25\"\r\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Drivers License Number' | translate}}\" required=\"driver.isPrefilledDriver ? false : true\">\r\n    </gw-pl-input-ctrl>\r\n    <!-- ENHC0011961_EODB QnB Defaults- hide the licence state --Arpita Sengupta -->\r\n    <gw-pl-input-ctrl class=\"ng-hide\" model=\"driver.licenseState\"\r\n                      filter-codes=\"stateFilterCodes\"\r\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.License State' | translate }}\"\r\n                      placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.-- Choose License State --' | translate }}\" required=\"driver.isPrefilledDriver ? false : true\">\r\n    </gw-pl-input-ctrl> \r\n    <gw-pl-input-ctrl model=\"driver.firstLicensed\" maxlength=\"2\"\r\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Age First Licensed in the US' | translate}}\">\r\n    </gw-pl-input-ctrl>\r\n    <div gw-pl-ctrl-group model=\"driver.relationShipToYou\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Relationship to You' | translate}}\"\r\n         ng-show=\"!driver.isAccountHolder.value\">\r\n        <select ng-model=\"driver.relationShipToYou.value\"\r\n                ng-options=\"k as v for (k, v) in relationShipList\"\r\n                ng-change=\"setRelationShipPcMapping()\">\r\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Relationship to You--' |\r\n                translate }}\r\n            </option>\r\n        </select>\r\n    </div>\r\n    <div gw-pl-ctrl-group\r\n         model=\"driver.associationOrAffiliation\"\r\n         ng-show=\"driver.accountHolderState.value.code == 'SC' && driver.isAccountHolder.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Select an association/affiliation:' | translate}}\">\r\n        <select gw-pl-select=\"driver.associationOrAffiliation.value\"\r\n                options=\"driver.associationOrAffiliation.aspects.availableValues\"\r\n                render-by=\"'name'\"\r\n                placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose association/affiliation--' | translate}}\"></select>\r\n    </div>\r\n    <div gw-pl-yes-no-group\r\n         ng-show=\"driver.accountHolderState.value.code === 'SC'\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Have you taken a defensive driving course?' | translate }}\"\r\n         model=\"driver.takenDefDrivingCourse\" name=\"TakenDefDrivingCourse\">\r\n    </div>\r\n    <gw-pl-input-ctrl model=\"driver.defensiveCourseYear\"\r\n                      ng-show=\"driver.accountHolderState.value.code == 'SC' && driver.takenDefDrivingCourse.value\"\r\n                      maxlength=\"4\"\r\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Enter defensive driver course year' | translate}}\">\r\n    </gw-pl-input-ctrl>\r\n    <!-- ENHC0011961_EODB QnB Defaults- hide the question --Arpita Sengupta -->\r\n    <div gw-pl-yes-no-group\r\n        class=\"ng-hide\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Would you like to include a motorcycle to this quote?' | translate }}\"\r\n         model=\"driver.inMotorCycle\" name=\"InMotorCycle\">\r\n    </div>\r\n    <!-- ended -->\r\n    <div gw-pl-yes-no-group\r\n         ng-show=\"driver.inMotorCycle.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Have you taken a motorcycle safety course?' | translate }}\"\r\n         model=\"driver.takenMotorSafetyCourse\" name=\"TakenMotorSafetyCourse\">\r\n    </div>\r\n    <div gw-pl-ctrl-group model=\"driver.motorCycleSafetyCourseYear\"\r\n         ng-show=\"driver.takenMotorSafetyCourse.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Enter motorcyle safety course year'| translate}}\">\r\n        <span gw-pl-local-date-chooser model=\"driver.motorCycleSafetyCourseYear.value\"></span>\r\n    </div>\r\n    <div gw-pl-yes-no-group\r\n         ng-show=\"driver.inMotorCycle.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Do you have a motorcycle endorsement on your drivers license?' | translate }}\"\r\n         model=\"driver.endorsementOnDriverLicense\" name=\"EndorsementOnDriverLicense\"\r\n         help-tip=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Motorcycle Endorsement Tooltip' | translate }}\">\r\n    </div>\r\n\r\n    <div gw-pl-ctrl-group model=\"driver.endorsementEffectiveDate\"\r\n         ng-show=\"driver.endorsementOnDriverLicense.value\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.Enter motorcycle endorsement effective date' | translate}}\">\r\n        <span gw-pl-local-date-chooser model=\"driver.endorsementEffectiveDate.value\"></span>\r\n    </div>\r\n    <div gw-pl-yes-no-group\r\n         ng-show=\"driver.accountHolderState.value.code == 'SC'\"\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Do you need a SR-22?' | translate }}\"\r\n         model=\"driver.needSR22\" name=\"NeedSR22\"\r\n         help-tip=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.SR22 Tooltip' | translate }}\">\r\n    </div>\r\n    <div gw-pl-yes-no-group\r\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Have you had any accidents and or violations in the last 3 years?' | translate }}\"\r\n         model=\"driver.accidentsInLast3Years\" name=\"AccidentsInLast3Years\">\r\n    </div>\r\n    <div class=\"pa-edit-driver-voilations\" ng-show=\"driver.accidentsInLast3Years.value\">\r\n        <div class=\"pa-edit-driver-voilations-add\">\r\n            <!--<form name=\"addAccidentForm\" ng-submit=\"addAccidentClaimVoilation(addAccidentForm.$valid)\" novalidate>-->\r\n            <div class=\"voilations-add-title\">\r\n                {{'quoteandbind.pa.directives.templates.pa-edit-driver.Please specify the type and date of the event' |\r\n                translate }}\r\n            </div>\r\n            <div class=\"voilations-category\">\r\n                <select name=\"voilationCategory\" ng-model=\"addAccidentVoilation.category\"\r\n                        ng-options=\"k as v for (k, v) in addCateogryList\" ng-change=\"loadAddTypeList()\">\r\n                    <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Select Category--' |\r\n                        translate }}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n            <div class=\"voilations-type\">\r\n                <select name=\"voilationType\" ng-model=\"addAccidentVoilation.type\"\r\n                        ng-options=\"k as v for (k, v) in addTypeList\">\r\n                    <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Select Type--' | translate\r\n                        }}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n            <div class=\"voilations-amount\"\r\n                 ng-if=\"addAccidentVoilation.category != 'voilation'\">\r\n                <span class=\"pa-driver-violation-amount-dollar-sign\">&#36;\r\n                    <input class=\"pa-driver-violation-amount-input\" type=\"number\" name=\"voilationAmount\" ng-model=\"addAccidentVoilation.amount\"\r\n                           placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Enter Amount' | translate }}\"/>\r\n                </span>\r\n            </div>\r\n            <div class=\"voilations-date\">\r\n                <span gw-pl-local-date-chooser model=\"addAccidentVoilation.date\" max-date=\"currentLocalDate\"></span>\r\n            </div>\r\n            <div class=\"voilations-addNew\">\r\n                <button class=\"gw-btn-primary\" next-button ng-click=\"addAccidentClaimVoilation()\">\r\n                    {{'quoteandbind.pa.directives.templates.pa-edit-driver.Add' | translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div class=\"pa-edit-driver-voilations-list\" ng-show=\"driver.value.accidentVoilationPortalList.length > 0\">\r\n            <div class=\"voilations-list-display\">\r\n                <!--<table class=\"violationsGrid\">\r\n                    <thead>\r\n                        <th>Accidents/Violations</th>\r\n                    </thead>\r\n                    <tbody>\r\n                    <tr ng-repeat=\"item in driver.value.accidentVoilationPortalList track by $id(item)\">\r\n                        <td>\r\n                            {{displayItemType(item)}}\r\n                        </td>\r\n                        <td>\r\n                            {{displayAmount(item)}}\r\n                        </td>\r\n                        <td>\r\n                            {{displayDate(item)}}\r\n                        </td>\r\n                        <td>\r\n                            <button class=\"gw-btn gw-btn-primary\" next-button ng-click=\"deleteAccidentClaimVoilation($index)\">\r\n                                {{'quoteandbind.pa.directives.templates.pa-edit-driver.Delete' | translate}}\r\n                            </button>\r\n                        </td>\r\n                    </tr>\r\n                    </tbody>\r\n                </table>-->\r\n                <div class=\"pa-edit-driver-accidentviolation-header\">Accidents/Violations</div>\r\n                <div ng-repeat=\"item in driver.value.accidentVoilationPortalList track by $id(item)\" class=\"driver-violation-list\">\r\n                    <div class=\"pa-edit-driver-accidentviolation-type\">{{displayItemType(item)}}</div>\r\n                    <div class=\"pa-edit-driver-accidentviolation-amount\">{{displayAmount(item)}}</div>\r\n                    <div class=\"pa-edit-driver-accidentviolation-date\">{{displayDate(item)}}</div>\r\n                    <div class=\"pa-edit-driver-accidentviolation-delete\"> <button class=\"gw-btn gw-btn-primary\" next-button ng-click=\"deleteAccidentClaimVoilation($index)\">\r\n                        {{'quoteandbind.pa.directives.templates.pa-edit-driver.Delete' | translate}}\r\n                    </button></div>\r\n                </div>\r\n            </div>\r\n            <div class=\"voilations-edit-display\" ng-show=\"displayEditForm\">\r\n                <div class=\"voilations-error-message\" ng-show=\"!driver.isEditAccidentValid.value\">\r\n                    {{'quoteandbind.pa.directives.templates.pa-edit-driver.voilation error message' | translate }}\r\n                </div>\r\n                <div class=\"voilations-category\">\r\n                    <select ng-model=\"editAccidentVoilation.category\" ng-options=\"k as v for (k, v) in editCateogryList\"\r\n                            ng-change=\"loadEditTypeList()\">\r\n                        <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Select Category--' |\r\n                            translate }}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"voilations-type\">\r\n                    <select ng-model=\"editAccidentVoilation.type\" ng-options=\"k as v for (k, v) in editTypeList\">\r\n                        <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Select Type--' |\r\n                            translate }}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"voilations-amount\"\r\n                     ng-if=\"editAccidentVoilation.category != 'voilation'\">\r\n                    <input type=\"text\" ng-model=\"editAccidentVoilation.amount\"\r\n                           placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Enter Amount' | translate }}\"/>\r\n                </div>\r\n                <div class=\"voilations-date\">\r\n                    <span gw-pl-local-date-chooser model=\"editAccidentVoilation.date\" max-date=\"maxDateOfBirth\"\r\n                          initial-date=\"maxDateOfBirth\"></span>\r\n                </div>\r\n                <div class=\"voilations-update\">\r\n                    <button class=\"gw-btn-primary\" next-button ng-click=\"updateAccidentClaimVoilation(editIndex)\">\r\n                        {{'quoteandbind.pa.directives.templates.pa-edit-driver.Update' | translate}}\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    function daysInMonth(year, month) {
	        return new Date(year, month + 1, 0).getDate();
	    }
	
	    function getAgeInYears(localDate) {
	
	        var birthDate = new Date(localDate.year, localDate.month, localDate.day);
	        var birthYear = birthDate.getFullYear();
	        var birthMonth = birthDate.getMonth();
	        var birthDay = birthDate.getDate();
	
	        var currentDate = new Date();
	        var currentYear = currentDate.getFullYear();
	        var currentMonth = currentDate.getMonth();
	        var currentDay = currentDate.getDate();
	
	        var age = currentYear - birthYear;
	        var ageMonth = currentMonth - birthMonth;
	        var ageDay = currentDay - birthDay;
	
	        if (ageMonth < 0 || ageMonth == 0 && ageDay < 0) {
	            age = parseInt(age) - 1;
	        }
	
	        return age;
	    }
	
	    function _isValidAge(localDate, ageLimit) {
	
	        //var ageLimit = 18;
	        if (!localDate) {
	            return true;
	        }
	        var age = getAgeInYears(localDate);
	
	        //console.log("Birth Date: ",birthYear,birthMonth,birthDay);
	        //console.log("Current Date: ", currentYear, currentMonth, currentDay);       
	
	        if (age < ageLimit) {
	            //console.log("Not a valid age: ", age, ageMonth, ageDay); 
	            return false;
	        }
	
	        //console.log("Valid Age: ", age, ageMonth, ageDay); 
	
	        return true;
	    }
	
	    // To validate age first licensed in US in Add drivers screen
	    function _isLicensedAgeValid(inputAge, dateOfBirth, minAge) {
	        if (!dateOfBirth) {
	            return true;
	        }
	        //console.log("Min Age:: ",minAge, inputAge);
	
	        var currentAge = getAgeInYears(dateOfBirth);
	
	        return inputAge <= currentAge && inputAge >= minAge ? true : false;
	    }
	
	    return {
	        daysInMonth: daysInMonth,
	        daysInLocalDate: function daysInLocalDate(ld) {
	            return ld ? daysInMonth(ld.year, ld.month) : null;
	        },
	        toMidnightDate: function toMidnightDate(localDate) {
	            return localDate ? new Date(localDate.year, localDate.month, localDate.day) : null;
	        },
	        toMidnightCustomDate: function toMidnightCustomDate(localDate) {
	            return localDate ? new Date(localDate.year, localDate.month, localDate.day) : null;
	        },
	        isValidAge: function isValidAge(localDate, ageLimit) {
	            return _isValidAge(localDate, ageLimit);
	        },
	        isValidLicenseAge: function isValidLicenseAge(localDate) {
	            return _isValidAge(localDate, 16);
	        },
	        isLicensedAgeValid: function isLicensedAgeValid(inputAge, dateOfBirth, minAge) {
	            return _isLicensedAgeValid(inputAge, dateOfBirth, minAge);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(360)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return ['VinLookupService', 'VinLookupEnabled', '$q', '$filter', 'ModalService', '$timeout', function (VinLookupService, VinLookupEnabled, $q, $filter, ModalService, $timeout) {
	        return {
	            restrict: 'A',
	            scope: {
	                vehicle: '=',
	                drivers: '=',
	                readonly: '=',
	                quoteId: '=',
	                availableYears: '='
	            },
	            template: templateStr,
	            //added $rootScope *Princy
	            controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
	
	                var watchYear = void 0;
	                var watchMake = void 0;
	                var watchModel = void 0;
	                var watchCylinder = void 0;
	                var watchphysicalDamage = void 0;
	                var watchStorageTye = void 0;
	                $scope.isFormSubmitted = false;
	                $scope.leaseOptions = [{ name: "Other" }];
	                $scope.leaseSelectedOption = $scope.leaseOptions[0];
	                $scope.financeOptions = [{ name: "Other" }];
	                $scope.financeSelectedOption = $scope.financeOptions[0];
	
	                $scope.showCost = false;
	
	                // addded isPrefilledVehicle Flag *Princy
	                //   console.log($rootScope)
	                if ($scope.vehicle.isPrefilledVehicle.value == true) {
	                    $rootScope.isPrefilledVehicle = true;
	                }
	                // console.log($rootScope)
	                // end of statement-- isPrefilledDriver Flag *Princy
	
	                $scope.showCostDiv = function () {
	                    $scope.vehicle.costNew.amount = undefined;
	                    $scope.showCost = true;
	                };
	                if ($scope.vehicle.isPrefilledVehicle.value) {
	                    if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == 'auto' && ($scope.vehicle.comprehensiveSymbolCd.value == "" || $scope.vehicle.comprehensiveSymbolCd.value == " ") && ($scope.vehicle.collisionSymbolCd.value == "" || $scope.vehicle.collisionSymbolCd.value == " ") && ($scope.vehicle.twoDgVSRSymbol.value == "" || $scope.vehicle.twoDgVSRSymbol.value == " ")) {
	                        $scope.showCost = true;
	                    } else {
	                        $scope.showCost = false;
	                    }
	                    if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == 'motorcycle_aaa' && ($scope.vehicle.costNew.amount.value == "" || $scope.vehicle.costNew.amount.value == " " || $scope.vehicle.costNew.amount.value == undefined)) {
	                        $scope.showCost = true;
	                    } else {
	                        $scope.showCost = false;
	                    }
	                }
	                $scope.hasMotorcycleEndorsement = function (vehicle) {
	                    for (var endorse = 0; endorse < $scope.drivers.length; endorse++) {
	                        if ($scope.drivers[endorse].inMotorCycle == true && $scope.drivers[endorse].endorsementOnDriverLicense == true) {
	                            vehicle.motorcycleEndorsement.value = true;
	                            return true;
	                        }
	                    }
	
	                    return false;
	                };
	
	                $scope.populateYears = function () {
	                    var vinDetails = {
	                        searchType: undefined
	                    };
	                    vinDetails.searchType = "AvailableYears";
	
	                    // Set additional request params required to call new vin service
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    /*$q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails),
	                            (result) => {
	                    var arr = JSON.parse("[" + result.jsonOutputString + "]");
	                            for (var i = 0; i < arr[0].length; i++)
	                    {
	                    $scope.years.push(parseInt(arr[0][i]));
	                    }
	                    
	                    // When quote retrieved
	                    if($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined){
	                        $scope.populateMake();
	                    }
	                     
	                    });*/
	
	                    $timeout(function () {
	                        $scope.minYear = $scope.availableYears[0];
	                        $scope.maxYear = $scope.availableYears[$scope.availableYears.length - 1];
	                        // When quote retrieved
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN!=false*/) {
	                                if ($scope.vehicle.year && $scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.makesList.length == 0) {
	                                    $scope.populateMake();
	                                }
	                            } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/) {
	                                if ($scope.vehicle.year && $scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined) {
	                                    $scope.populateHldiMake();
	                                }
	                            }
	                    }, 100);
	                };
	
	                // Check the vin is long vin
	                $scope.isLongVIN = function () {
	
	                    if ($scope.vehicle.vin && $scope.vehicle.vin.value && $scope.vehicle.vin.value.length == 17) {
	                        return true;
	                    }
	
	                    return false;
	                };
	
	                function resetForm() {
	                    $scope.years = [];
	                    $scope.makes = [];
	                    $scope.models = [];
	                    $scope.shortVins = [];
	                    $scope.series = [];
	                    $scope.cylinders = [];
	                    $scope.makesList = [];
	                    $scope.modelsList = [];
	                    $scope.vinPatList = [];
	                    //$scope.vinPatList = [];
	                    $scope.cylinderList = [];
	                    $scope.seriesList = [];
	                    $scope.errorMsg = '';
	                    $scope.showLoading = false;
	                    //$scope.invalidVIN = null;
	                    $scope.tmpVehicleType = undefined;
	                    $scope.selectedIndex = 0;
	                    //To display within last 60 days question
	                    //For defect DE1703
	                    // $scope.isPurchase = false
	                    $scope.vehicleType = null;
	                    $scope.vinOld = undefined;
	                    $scope.vinNew = undefined;
	                    $scope.today = new Date();
	                    $scope.today.setHours(0, 0, 0, 0);
	                    $scope.motorcycleEndorsement = false;
	                    var currentYear = new Date().getUTCFullYear();
	
	                    var OLDEST_CAR_YEAR = 1908;
	
	                    // Populate year list for short VIN for the retrieved quote
	                    // Populate years
	                    $timeout(function () {
	                        $scope.populateYears();
	                    }, 1000);
	
	                    //************** Resetting Values*************************************
	                    if ($scope.vehicle.paType != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code != undefined) {
	                        $scope.vehicle.tmpPaType.value = $scope.vehicle.paType.value.code;
	                    }
	
	                    if ($scope.vehicle.vin != undefined && $scope.vehicle.vin.value != undefined) {
	
	                        $scope.readonly = true;
	                        $scope.showLoading = false;
	                        //$scope.invalidVIN = false;
	                    }
	
	                    if ($scope.vehicle.primaryUse != undefined && $scope.vehicle.primaryUse.value != undefined && $scope.vehicle.primaryUse.value.code != undefined) {
	
	                        //$scope.vehicle.tmpPrimeUse.value = "less10"
	                        if ($scope.vehicle.primaryUse.value.code == "commuting") {
	                            if ($scope.vehicle.commutingMiles.value == 5) $scope.vehicle.tmpPrimeUse.value = "less10";
	                            if ($scope.vehicle.commutingMiles.value == 15) $scope.vehicle.tmpPrimeUse.value = "more10";
	                        } else if ($scope.vehicle.primaryUse.value.code == "pleasure") {
	                            $scope.vehicle.tmpPrimeUse.value = "Personal";
	                        } else {
	                            $scope.vehicle.tmpPrimeUse.value = "Business";
	                        }
	                    }
	                    if ($scope.vehicle.ownership != undefined) {
	                        if ($scope.vehicle.ownership.value != undefined && $scope.vehicle.ownership.value.code != undefined) {
	                            $scope.vehicle.tmpOwnership.value = $scope.vehicle.ownership.value.code;
	                        } else {
	                            $scope.vehicle.tmpOwnership.value = "Own";
	                        }
	                    }
	                    //*************End Resetting************************************
	                    //For testing purpose defaulting vehicle to car
	                    if ($scope.vehicle.paType != undefined) {
	                        if ($scope.vehicle.paType.value == undefined) $scope.vehicle.paType.value = "auto";
	                    }
	                    watchYear = $scope.$watch('vehicle.year.value', function (newValue, oldValue) {
	
	                        //console.log("Year newValue: ",newValue," oldValue: ",oldValue);                                
	
	                        // if the values are same which means user has not changed the value
	                        // Below logic only get execute if user change the value for year
	                        if (!newValue || newValue === oldValue) {
	                            return;
	                        }
	
	                        // If long vin no need to do any action 
	                        if ($scope.isLongVIN()) {
	                            return;
	                        }
	
	                        //Added to handle the case if prefill service is not returning cost
	                        if ($scope.vehicle.isPrefilledVehicle.value && $scope.vehicle.vin.value && $scope.vehicle.vin.value.length == 17) {
	                            if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == 'auto' && ($scope.vehicle.comprehensiveSymbolCd.value == "" || $scope.vehicle.comprehensiveSymbolCd.value == " ") && ($scope.vehicle.collisionSymbolCd.value == "" || $scope.vehicle.collisionSymbolCd.value == " ") && ($scope.vehicle.twoDgVSRSymbol.value == "" || $scope.vehicle.twoDgVSRSymbol.value == " ")) {
	                                $scope.showCost = true;
	                            } else {
	                                $scope.showCost = false;
	                            }
	                            if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == 'motorcycle_aaa' && ($scope.vehicle.costNew.amount.value == "" || $scope.vehicle.costNew.amount.value == " " || $scope.vehicle.costNew.amount.value == undefined)) {
	                                $scope.showCost = true;
	                            } else {
	                                $scope.showCost = false;
	                            }
	                        } else if ($scope.vehicle.year) {
	                            $scope.showCost = true;
	                        }
	
	                        //Fix for Defect DE1073
	                        //if ($scope.vehicle.year.value == undefined)
	                        // $scope.populateYears();
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto") {
	
	                            // $scope.setPurchaseDayVisible();
	                            $scope.populateMake();
	                        } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa") {
	                            // $scope.setPurchaseDayVisible();
	                            $scope.populateHldiMake();
	                        }
	                        if ($scope.vehicle.year.value != undefined && $scope.years.length > 0 && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN!=false*/) {
	
	                                // $scope.setPurchaseDayVisible();
	                                $scope.makesList = [];
	                                $scope.models = [];
	                                $scope.cylinders = [];
	                                $scope.populateMake();
	                            } else if ($scope.vehicle.year.value != undefined && $scope.years.length > 0 && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/) {
	                                // $scope.setPurchaseDayVisible();
	                                $scope.makesList = [];
	                                $scope.series = [];
	                                $scope.models = [];
	                                $scope.populateHldiMake();
	                            }
	                    });
	
	                    watchMake = $scope.$watch('vehicle.make.value', function (newValue, oldValue) {
	
	                        //console.log("Make newValue: ", newValue, " oldValue: ", oldValue);
	                        // if the values are same which means user has not changed the value
	                        // Below logic only get execute if user change the value for make
	                        if (!newValue || newValue === oldValue) {
	                            return;
	                        }
	
	                        // If long vin no need to do any action 
	                        if ($scope.isLongVIN()) {
	                            return;
	                        }
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateModels();
	                            } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/) {
	                                for (var make = 0; make < $scope.makesList.length; make++) {
	                                    if ($scope.makesList[make].makeName == $scope.vehicle.make.value) {
	                                        $scope.hldiMakeNumber = $scope.makesList[make].makeNumber;
	                                    }
	                                }
	                                $scope.populateHldiSeries();
	                            }
	                    });
	
	                    watchSeries = $scope.$watch('vehicle.series.value', function (newValue, oldValue) {
	
	                        // if the values are same which means user has not changed the value
	                        // Below logic only get execute if user change the value for make
	                        if (!newValue || newValue === oldValue) {
	                            return;
	                        }
	                        // If long vin no need to do any action
	                        if ($scope.isLongVIN()) {
	                            return;
	                        }
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" && $scope.vehicle.series.value != undefined /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateHldiModels();
	                            }
	                    });
	
	                    watchModel = $scope.$watch('vehicle.model.value', function (newValue, oldValue) {
	
	                        //console.log("Model newValue: ", newValue, " oldValue: ", oldValue);
	                        // if the values are same which means user has not changed the value
	                        // Below logic only get execute if user change the value for model
	                        if (!newValue || newValue === oldValue) {
	                            return;
	                        }
	
	                        // If long vin no need to do any action 
	                        if ($scope.isLongVIN()) {
	                            return;
	                        }
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateCylinders();
	                            } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateBikeShortVin();
	                            } else if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.models != undefined && $scope.models.length > 0 && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateBikeShortVin();
	                            }
	                    });
	
	                    watchCylinder = $scope.$watch('vehicle.cylinder.value', function (newValue, oldValue) {
	
	                        //console.log("Cylinder newValue: ", newValue, " oldValue: ", oldValue);
	                        // if the values are same which means user has not changed the value
	                        // Below logic only get execute if user change the value for cylinder
	                        if (!newValue || newValue === oldValue) {
	                            return;
	                        }
	
	                        // If long vin no need to do any action 
	                        if ($scope.isLongVIN()) {
	                            return;
	                        }
	
	                        if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" /*&& $scope.invalidVIN != false*/) {
	                                $scope.populateCarShortVin();
	                            }
	                    });
	
	                    watchphysicalDamage = $scope.$watch('vehicle.damageInAccident.value', function () {
	                        if ($scope.vehicle.damageInAccident.value) {
	                            ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.directives.PAEditVehicle.physicalDamage.errorMsg');
	                        }
	                    });
	
	                    watchStorageTye = $scope.$watch('vehicle.storageType.value.code', function (oldValue, newValue) {
	                        if ($scope.vehicle.storageType && $scope.vehicle.storageType.value) {
	                            if ('driveway' === $scope.vehicle.storageType.value.code || 'onstreet' === $scope.vehicle.storageType.value.code || 'parkinglot' === $scope.vehicle.storageType.value.code || 'other' === $scope.vehicle.storageType.value.code) {
	                                if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined) {
	                                    var message = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.StorageTypePhysicalDamage.WithVehicleDetails', { vehicleYear: $scope.vehicle.year.value, vehicleMake: $scope.vehicle.make.value, vehicleModel: $scope.vehicle.model.value });
	                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', message);
	                                } else {
	
	                                    ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.directives.PAEditVehicle.StorageTypePhysicalDamage.Msg');
	                                }
	                            }
	                        }
	                    });
	
	                    $scope.primaryUser = {
	                        less10: "Commute less than 10 miles one way to work",
	                        more10: "Commute more than 10 miles one way work",
	                        Personal: "Personal use",
	                        Business: "Business (errands, sales calls)"
	                    };
	
	                    $scope.ownership = {
	                        LOSSP: "Own and Make Payments",
	                        additionalinterest_aaa: "Lease",
	                        Own: "Own"
	                    };
	
	                    $scope.driverType = {
	                        principal: "More than 50%",
	                        occasional: "Less than 50 %"
	                    };
	
	                    $scope.paTypes = {
	                        auto: "Vehicle",
	                        motorcycle_aaa: "Motorcycle"
	                    };
	                }
	
	                $scope.setVehicleType = function () {
	                    // ENHC0011961_EODB QnB Defaults- defaulting vehicle --Arpita sengupta
	                    $scope.vehicle.paType = $scope.vehicle.tmpPaType.value ? $scope.vehicle.tmpPaType.value : 'auto';
	                    $scope.makesList = undefined;
	                    $scope.series = undefined;
	                    $scope.models = undefined;
	                    $scope.cylinders = undefined;
	                    $scope.vehicle.vin.value = undefined;
	                    $scope.vehicle.year.value = undefined;
	                    $scope.vehicle.make.value = undefined;
	                    $scope.vehicle.series.value = undefined;
	                    $scope.vehicle.model.value = undefined;
	                    $scope.vehicle.cylinder.value = undefined;
	                    $scope.vehicle.cCs.value = undefined;
	                    $scope.vehicle.bodyType.value = undefined;
	                    $scope.vehicle.bodyStyle.value = undefined;
	                    // Reset vehicle modifiers and symbols value
	                    $scope.vehicle.vehicleSurchargeCd.value = undefined;
	                    $scope.vehicle.comprehensiveSymbolCd.value = undefined;
	                    $scope.vehicle.collisionSymbolCd.value = undefined;
	                    $scope.vehicle.twoDgVSRSymbol.value = undefined;
	                    $scope.vehicle.paAntiLockBrakes.value = undefined;
	                    $scope.vehicle.paPassiveRestraint.value = undefined;
	                    $scope.vehicle.paAntiTheft.value = undefined;
	                    $scope.vehicle.costNew.amount.value = undefined;
	                    // $scope.showCost = true;
	
	                    if ($scope.years.length == 0) {
	                        $scope.populateYears();
	                    }
	                };
	
	                //To set the dropdown value of the Usage type
	                $scope.setVehicleUsage = function () {
	                    if ($scope.vehicle.tmpPrimeUse.value == "less10") {
	                        $scope.vehicle.primaryUse.value = "commuting";
	                        $scope.vehicle.commutingMiles.value = 5;
	                    } else if ($scope.vehicle.tmpPrimeUse.value == "more10") {
	                        $scope.vehicle.primaryUse.value = "commuting";
	                        $scope.vehicle.commutingMiles.value = 15;
	                    } else if ($scope.vehicle.tmpPrimeUse.value == "Personal") {
	                        $scope.vehicle.primaryUse.value = "pleasure";
	                    } else if ($scope.vehicle.tmpPrimeUse.value == "Business") {
	                        $scope.vehicle.primaryUse.value = "business";
	                    } else {
	                        $scope.vehicle.primaryUse.value = "Commercial";
	                    }
	                };
	
	                //To set ownership
	                $scope.setOwnership = function (assignowner) {
	                    $scope.vehicle.tmpOwnership.value = assignowner;
	                    if (assignowner == "LOSSP") {
	                        $scope.vehicle.ownership = "LOSSP";
	                        $scope.vehicle.addnlInterest = {};
	                        $scope.vehicle.addnlInterest.addnlInterestAddress = {};
	                    } else if (assignowner == "additionalinterest_aaa") {
	                        $scope.vehicle.ownership = "additionalinterest_aaa";
	                        $scope.vehicle.addnlInterest = {};
	                        $scope.vehicle.addnlInterest.addnlInterestAddress = {};
	                    } else if (assignowner == "Own") {
	                        $scope.vehicle.ownership = undefined;
	                        $scope.vehicle.addnlInterest = undefined;
	                    }
	                };
	                /*Added for ownership dropdown in mobile view*/
	                $scope.setOwnerShipSelected = function () {
	                    var selectedType = $scope.vehicle.tmpOwnership.value;
	                    $scope.setOwnership(selectedType);
	                };
	
	                /*##################### VIN  Start ############################ */
	                $scope.populateMake = function () {
	
	                    var vinDetails = {
	                        vinNumber: undefined,
	                        policyEffectiveDate: undefined,
	                        year: undefined,
	                        make: undefined,
	                        model: undefined,
	                        cylinder: undefined,
	                        restraints: undefined,
	                        shortvin: undefined,
	                        searchType: undefined
	                    };
	                    // $scope.vinDetails.searchType = "MakesByYear"
	                    vinDetails.searchType = "MakesByYear";
	                    vinDetails.year = $scope.vehicle.year.value;
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (vehicleInfo) {
	                        $scope.makesList = vehicleInfo.makesList || [];
	
	                        // When quote retrieved
	                        $timeout(function () {
	                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.models.length == 0) {
	                                $scope.populateModels();
	                            }
	                        }, 100);
	                    });
	                };
	
	                $scope.populateModels = function () {
	
	                    var vinDetails = {
	                        vinNumber: undefined,
	                        policyEffectiveDate: undefined,
	                        year: undefined,
	                        make: undefined,
	                        model: undefined,
	                        cylinder: undefined,
	                        restraints: undefined,
	                        shortvin: undefined,
	                        searchType: undefined
	                    };
	                    vinDetails.searchType = "ModelsByYearAndMake";
	                    vinDetails.searchType = "ModelsByYearAndMake";
	                    vinDetails.year = $scope.vehicle.year.value;
	                    vinDetails.make = $scope.vehicle.make.value;
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (modelInfo) {
	                        $scope.modelsList = modelInfo.modelsList || [];
	                        $scope.models = [];
	                        for (var model = 0; model < $scope.modelsList.length; model++) {
	                            $scope.models.push($scope.modelsList[model].modelCode);
	                        }
	
	                        // When quote retrieved
	                        // When quote retrieved
	                        $timeout(function () {
	                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.vehicle.cylinder.value != undefined && $scope.cylinders.length == 0) {
	                                $scope.populateCylinders();
	                            }
	                        }, 100);
	                    });
	                };
	
	                $scope.populateCylinders = function () {
	                    var vinDetails = {
	                        vinNumber: undefined,
	                        policyEffectiveDate: undefined,
	                        year: undefined,
	                        make: undefined,
	                        model: undefined,
	                        cylinder: undefined,
	                        restraints: undefined,
	                        shortvin: undefined,
	                        searchType: undefined
	                    };
	                    vinDetails.searchType = "AvailableCylindersforaModel";
	                    vinDetails.year = $scope.vehicle.year.value;
	                    vinDetails.make = $scope.vehicle.make.value;
	                    vinDetails.model = $scope.vehicle.model.value;
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (cylinderInfo) {
	                        $scope.cylinderList = cylinderInfo.cylindersList || [];
	                        //$scope.cylinders.length = 0
	                        $scope.cylinders = [];
	                        for (var cylinder = 0; cylinder < $scope.cylinderList.length; cylinder++) {
	                            $scope.cylinders.push($scope.cylinderList[cylinder]);
	                        }
	                    });
	                };
	
	                $scope.populateRestraints = function () {
	
	                    var vinDetails = {
	                        searchType: "Restraints",
	                        year: $scope.vehicle.year.value,
	                        make: $scope.vehicle.make.value,
	                        model: $scope.vehicle.model.value,
	                        cylinder: $scope.vehicle.cylinder.value,
	                        vinNumber: $scope.vehicle.vin.value
	                    };
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (restraintInfo) {
	
	                        $scope.vehicle.restrInd.value = restraintInfo.restraints;
	                        $scope.vehicle.paPassiveRestraint.value = restraintInfo.vehicleData.paPassiveRestraint;
	                        $scope.vehicle.bodyType.value = restraintInfo.vehicleData.bodyType;
	
	                        // Populate price new symbol list
	                        $scope.populatePriceNewSymbol();
	                    }, function (error) {
	                        console.log(error);
	                    });
	                };
	
	                $scope.populatePriceNewSymbol = function () {
	
	                    var vinDetails = {
	                        searchType: "PriceNewSymbol",
	                        year: $scope.vehicle.year.value,
	                        make: $scope.vehicle.make.value,
	                        model: $scope.vehicle.model.value,
	                        cylinder: $scope.vehicle.cylinder.value,
	                        vinNumber: $scope.vehicle.vin.value
	                    };
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (priceNewSymInfo) {
	
	                        // TODO:: Set cost new or not
	                        if (priceNewSymInfo.vehicleData && priceNewSymInfo.vehicleData.costNew) $scope.vehicle.costNew.amount.value = priceNewSymInfo.vehicleData.costNew.amount;
	                    }, function (error) {
	                        console.log(error);
	                    });
	                };
	
	                $scope.populateCarShortVin = function () {
	
	                    var vinDetails = {
	                        vinNumber: undefined,
	                        policyEffectiveDate: undefined,
	                        year: undefined,
	                        make: undefined,
	                        model: undefined,
	                        cylinder: undefined,
	                        restraints: undefined,
	                        shortvin: undefined,
	                        searchType: undefined
	                    };
	                    //$scope.vinDetails.searchType = "AvailableShortVins";
	                    vinDetails.searchType = "AvailableShortVins";
	                    vinDetails.year = $scope.vehicle.year.value;
	                    vinDetails.make = $scope.vehicle.make.value;
	                    vinDetails.model = $scope.vehicle.model.value;
	                    vinDetails.cylinder = $scope.vehicle.cylinder.value;
	
	                    $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                    $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (shortVinInfo) {
	                        //Changed for DE752
	                        $scope.shortvinsList = shortVinInfo.shortvinsList || [];
	                        $scope.vehicle.shortVin = $scope.shortvinsList[0];
	                        if ($scope.vehicle.vin.value != undefined && $scope.vehicle.vin.value.length < 17) {
	                            if ($scope.vehicle.shortVin.value && $scope.vehicle.shortVin.value.length > 0) {
	                                $scope.vehicle.vin.value = $scope.vehicle.shortVin.value;
	                                $scope.showCost = false;
	                                if (shortVinInfo.vehicleData.comprehensiveSymbolCd) {
	                                    $scope.vehicle.comprehensiveSymbolCd.value = shortVinInfo.vehicleData.comprehensiveSymbolCd.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.collisionSymbolCd) {
	                                    $scope.vehicle.collisionSymbolCd.value = shortVinInfo.vehicleData.collisionSymbolCd.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.twoDgVSRSymbol) {
	                                    $scope.vehicle.twoDgVSRSymbol.value = shortVinInfo.vehicleData.twoDgVSRSymbol.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.vehicleSurchargeCode) {
	                                    $scope.vehicle.vehicleSurchargeCd.value = shortVinInfo.vehicleData.vehicleSurchargeCode.trim();
	                                }
	                            }
	                        } else {
	                            if (typeof $scope.vehicle.vin.value === 'undefined') {
	                                $scope.vehicle.vin.value = $scope.vehicle.shortVin.value;
	                                $scope.showCost = $scope.vehicle.shortVin && $scope.vehicle.shortVin.value ? false : true;
	                                if (shortVinInfo.vehicleData.comprehensiveSymbolCd) {
	                                    $scope.vehicle.comprehensiveSymbolCd.value = shortVinInfo.vehicleData.comprehensiveSymbolCd.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.collisionSymbolCd) {
	                                    $scope.vehicle.collisionSymbolCd.value = shortVinInfo.vehicleData.collisionSymbolCd.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.twoDgVSRSymbol) {
	                                    $scope.vehicle.twoDgVSRSymbol.value = shortVinInfo.vehicleData.twoDgVSRSymbol.trim();
	                                }
	
	                                if (shortVinInfo.vehicleData.vehicleSurchargeCode) {
	                                    $scope.vehicle.vehicleSurchargeCd.value = shortVinInfo.vehicleData.vehicleSurchargeCode.trim();
	                                }
	                            }
	                        }
	
	                        // Populate Restraints
	                        $scope.populateRestraints();
	                    });
	                };
	
	                /*##################### VIN  end  ############################ */
	
	                $scope.populateBikeShortVin = function () {
	                    var hldiDetails = {
	                        vin: undefined,
	                        ccr: undefined,
	                        modelYear: undefined,
	                        seriesName: undefined,
	                        makeNumber: undefined,
	                        modelName: undefined,
	                        searchType: undefined,
	                        make: undefined,
	                        quoteId: undefined
	                    };
	                    hldiDetails.searchType = "GetVinPatSpecsList";
	                    hldiDetails.CCR = "ZEM2O9S8F9A1";
	                    hldiDetails.vin = $scope.vehicle.vin.value;
	                    hldiDetails.modelYear = $scope.vehicle.year.value;
	                    //hldiDetails.makeNumber = $scope.vehicle.make.value;
	                    hldiDetails.makeNumber = $scope.hldiMakeNumber;
	                    hldiDetails.modelName = $scope.vehicle.model.value;
	                    hldiDetails.makeList = $scope.makesList;
	                    hldiDetails.make = $scope.vehicle.make.value;
	                    hldiDetails.seriesName = $scope.vehicle.series.value;
	                    hldiDetails.quoteId = $scope.quoteId.value;
	
	                    $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails), function (shortVinInfo) {
	                        //Changed for DE752
	                        if ($scope.vehicle.vin.value != undefined && $scope.vehicle.vin.value.length < 17) {
	                            if (shortVinInfo.shortVinList && shortVinInfo.shortVinList.length > 0 && shortVinInfo.shortVinList[0].vinPat) {
	                                $scope.vehicle.vin.value = shortVinInfo.shortVinList[0].vinPat.trim();
	                                // Set body style - INC0001398 
	                                $scope.vehicle.bodyStyle.value = shortVinInfo.shortVinList[0].vehicleClassDesc.trim();
	                                $scope.vehicle.cCs.value = shortVinInfo.shortVinList[0].displacement.trim();
	                                if (shortVinInfo.shortVinList[0].basePrice != undefined) {
	                                    $scope.vehicle.costNew.amount.value = shortVinInfo.shortVinList[0].basePrice.trim();
	                                }
	                            }
	                        } else {
	                            if (typeof $scope.vehicle.vin.value === 'undefined') {
	                                if (shortVinInfo.shortVinList && shortVinInfo.shortVinList.length > 0 && shortVinInfo.shortVinList[0].vinPat) {
	                                    $scope.vehicle.vin.value = shortVinInfo.shortVinList[0].vinPat.trim();
	                                    // Set body style - INC0001398
	                                    $scope.vehicle.bodyStyle.value = shortVinInfo.shortVinList[0].vehicleClassDesc.trim();
	                                    $scope.vehicle.cCs.value = shortVinInfo.shortVinList[0].displacement.trim();
	                                    if (shortVinInfo.shortVinList[0].basePrice != undefined) {
	                                        $scope.vehicle.costNew.amount.value = shortVinInfo.shortVinList[0].basePrice.trim();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                };
	                /**************************    HLDI     ****************************/
	                $scope.populateHldiModels = function () {
	                    var hldiDetails = {
	                        vin: undefined,
	                        ccr: undefined,
	                        modelYear: undefined,
	                        seriesName: undefined,
	                        makeNumber: undefined,
	                        modelName: undefined,
	                        searchType: undefined,
	                        quoteId: undefined
	                    };
	
	                    hldiDetails.CCR = "ZEM2O9S8F9A1";
	                    hldiDetails.searchType = "GetModelList";
	                    hldiDetails.modelYear = $scope.vehicle.year.value;
	                    //hldiDetails.makeNumber = $scope.vehicle.make.value;
	                    hldiDetails.make = $scope.vehicle.make.value;
	                    hldiDetails.makeNumber = $scope.hldiMakeNumber;
	                    hldiDetails.makeList = $scope.makesList;
	                    hldiDetails.seriesName = $scope.vehicle.series.value;
	                    hldiDetails.quoteId = $scope.quoteId.value;
	                    $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails), function (modelInfo) {
	                        $scope.modelsList = modelInfo.modelNameList || [];
	                        //$scope.models.length = 0
	                        $scope.models = [];
	                        for (var model = 0; model < $scope.modelsList.length; model++) {
	                            $scope.models.push($scope.modelsList[model]);
	                        }
	                    });
	                };
	
	                $scope.populateHldiMake = function () {
	                    var hldiDetails = {
	                        vin: undefined,
	                        ccr: undefined,
	                        modelYear: undefined,
	                        seriesName: undefined,
	                        makeNumber: undefined,
	                        modelName: undefined,
	                        searchType: undefined,
	                        quoteId: undefined
	                    };
	
	                    hldiDetails.searchType = "GetMakeList";
	                    hldiDetails.CCR = "ZEM2O9S8F9A1";
	                    hldiDetails.modelYear = $scope.vehicle.year.value;
	                    hldiDetails.quoteId = $scope.quoteId.value;
	                    $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails), function (makeInfo) {
	                        $scope.makesList = makeInfo.makeList;
	                        //Commented for DE807 : Start
	                        /*$scope.makes.length = 0
	                        for (let make = 0; make < $scope.makesList.length; make++){
	                        $scope.makes.push($scope.makesList[make].makeName)
	                        }
	                        console.log("HLDI Makes 1 = ", $scope.makes);
	                        console.log("HLDI Makes 2 = ", $scope.makesList);*/
	                        //Commented for DE807 : End
	                        // When quote retrieved
	                        $timeout(function () {
	                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.series.value != undefined) {
	                                $scope.populateHldiSeries();
	                            }
	                        }, 100);
	                    });
	                };
	
	                $scope.populateHldiSeries = function () {
	                    var hldiDetails = {
	                        vin: undefined,
	                        ccr: undefined,
	                        modelYear: undefined,
	                        seriesName: undefined,
	                        makeNumber: undefined,
	                        modelName: undefined,
	                        searchType: undefined,
	                        quoteId: undefined,
	                        makeList: undefined
	                    };
	
	                    hldiDetails.searchType = "GetSeriesList";
	                    hldiDetails.CCR = "ZEM2O9S8F9A1";
	                    hldiDetails.modelYear = $scope.vehicle.year.value;
	                    //hldiDetails.makeNumber = $scope.vehicle.make.value;
	                    hldiDetails.make = $scope.vehicle.make.value;
	                    hldiDetails.makeNumber = $scope.hldiMakeNumber;
	                    hldiDetails.makeList = $scope.makesList;
	                    hldiDetails.quoteId = $scope.quoteId.value;
	                    $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails), function (seriesInfo) {
	                        $scope.seriesList = seriesInfo.seriesNameList || [];
	                        $scope.series = [];
	                        for (var serieal = 0; serieal < $scope.seriesList.length; serieal++) {
	                            $scope.series.push($scope.seriesList[serieal]);
	                        }
	                        // When quote retrieved
	
	
	                        $timeout(function () {
	                            if ($scope.vehicle.year.value != undefined && $scope.vehicle.make.value != undefined && $scope.vehicle.model.value != undefined && $scope.vehicle.series.value != undefined) {
	                                $scope.populateHldiModels();
	                            }
	                        }, 100);
	                    });
	                };
	
	                $scope.populateDriverName = function (person) {
	                    if (person != undefined) return person.firstName + " " + person.lastName;
	                };
	
	                // Set additional request params for VIN service new implementation
	                $scope.setAdditionalRequestParamsAuto = function (vinDetails) {
	
	                    vinDetails.vinServiceSearchType = angular.copy(vinDetails.searchType);
	                    vinDetails.quoteID = $scope.quoteId.value;
	
	                    if ($scope.vehicle && $scope.vehicle.publicID) {
	                        vinDetails.vehiclePublicId = $scope.vehicle.publicID.value;
	                    }
	
	                    if ($scope.vehicle && $scope.vehicle.tmpPaType) {
	                        vinDetails.vehicleType = $scope.vehicle.tmpPaType.value;
	                    }
	
	                    vinDetails.masterMakeList = {};
	                    var makeList = angular.copy($scope.makesList);
	
	                    // Populating master make list which will be used to create 
	                    // a mastermake list in VehicleUIHelper instance
	                    if (makeList && makeList.length > 0) {
	
	                        //console.log("makeList: ", makeList);
	
	                        //make => {makeCode: "ACUR", makeValue: "ACURA"}
	                        for (var idx in makeList) {
	                            var make = makeList[idx];
	                            vinDetails.masterMakeList[make.makeCode] = make.makeValue;
	                            if ($scope.vehicle.make.value && $scope.vehicle.make.value == make.makeCode) {
	                                vinDetails.makeValue = make.makeValue;
	                            }
	                        }
	                    }
	
	                    // Set restraint value for price new symbol list service call
	                    if ($scope.vehicle.restrInd != null || $scope.vehicle.restrInd != undefined) {
	                        vinDetails.restraints = $scope.vehicle.restrInd.value;
	                    }
	                };
	
	                $scope.lookupVehicleVin = function () {
	
	                    var vinDetails = {
	                        vinNumber: undefined,
	                        policyEffectiveDate: undefined,
	                        year: undefined,
	                        make: undefined,
	                        model: undefined,
	                        cylinder: undefined,
	                        restraints: undefined,
	                        shortvin: undefined,
	                        searchType: undefined
	                    };
	                    if (VinLookupEnabled) {
	                        //$scope.invalidVIN = null;
	                        $scope.readonly = true;
	                        $scope.showLoading = true;
	                        //$scope.vinDetails.vinNumber = $scope.vehicle.vin.value
	                        //$scope.vinDetails.policyEffectiveDate = $scope.today
	
	                        //$scope.vinDetails.searchType = "DecodeVinByDate"
	                        vinDetails.vinNumber = $scope.vehicle.vin.value;
	                        vinDetails.policyEffectiveDate = $scope.today;
	                        vinDetails.searchType = "DecodeVinByDate";
	
	                        // Set additional request params required to call new vin service
	                        $scope.setAdditionalRequestParamsAuto(vinDetails);
	
	                        $q.when(VinLookupService.aaaVINLookup('quoteandbind', vinDetails), function (vehicleInfo) {
	                            if (vehicleInfo && vehicleInfo.vehicleData.make && vehicleInfo.vehicleData.fullModelName && vehicleInfo.vehicleData.isoYear) {
	                                //Autofill with the returned data
	                                //$scope.invalidVIN = false;
	                                //security vulnerabilities --Arpita
	                                var yearCylVal = /^[0-9]+$/;
	                                if (!vehicleInfo.vehicleData.isoYear.trim().match(yearCylVal)) {
	                                    throw new Error('Please input numeric characters only');
	                                } else if (!vehicleInfo.vehicleData.engineCyl.trim().match(yearCylVal)) {
	                                    $scope.vehicle.cylinder.value = "";
	                                    throw new Error('Please input numeric characters only');
	                                }
	                                //ended 
	                                $scope.vehicle.make.value = vehicleInfo.vehicleData.make.trim();
	                                $scope.vehicle.model.value = vehicleInfo.vehicleData.fullModelName.trim();
	                                $scope.vehicle.year.value = vehicleInfo.vehicleData.isoYear.trim();
	                                $scope.vehicle.cylinder.value = vehicleInfo.vehicleData.engineCyl.trim();
	                                $scope.vinYear = vehicleInfo.vehicleData.isoYear.trim();
	                                $scope.vehicle.paType.value = "auto";
	                                $scope.vehicle.bodyStyle = vehicleInfo.vehicleData.bodyStyle.trim();
	                                $scope.vehicle.vehicleSurchargeCd.value = vehicleInfo.vehicleData.vehicleSurchargeCode.trim();
	                                $scope.errorMsg = '';
	                                $scope.vehicle.comprehensiveSymbolCd.value = vehicleInfo.vehicleData.comprehensiveSymbolCd.trim();
	                                $scope.vehicle.collisionSymbolCd.value = vehicleInfo.vehicleData.collisionSymbolCd.trim();
	                                if (vehicleInfo.vehicleData.twoDgVSRSymbol) {
	                                    $scope.vehicle.twoDgVSRSymbol.value = vehicleInfo.vehicleData.twoDgVSRSymbol.trim();
	                                }
	                                // Portal Integration New Fields
	                                $scope.vehicle.bodyType.value = vehicleInfo.vehicleData.bodyType;
	                                $scope.vehicle.paAntiLockBrakes.value = vehicleInfo.vehicleData.paAntiLockBrakes;
	                                $scope.vehicle.paPassiveRestraint.value = vehicleInfo.vehicleData.paPassiveRestraint;
	                                $scope.vehicle.paAntiTheft.value = vehicleInfo.vehicleData.paAntiTheft;
	
	                                if (vehicleInfo.vehicleData.comprehensiveSymbolCd.trim() == "" && vehicleInfo.vehicleData.collisionSymbolCd.trim() == "" && vehicleInfo.vehicleData.twoDgVSRSymbol.trim() == "") {
	                                    $scope.showCost = true;
	                                } else {
	                                    $scope.showCost = false;
	                                }
	                                if (vehicleInfo.vehicleData.abs != null && vehicleInfo.vehicleData.abs != undefined) {
	                                    $scope.vehicle.abs.value = vehicleInfo.vehicleData.abs.trim();
	                                }
	                                if (vehicleInfo.vehicleData.antiTheft != null && vehicleInfo.vehicleData.antiTheft != undefined) {
	                                    $scope.vehicle.antiTheft.value = vehicleInfo.vehicleData.antiTheft.trim();
	                                }
	                                if (vehicleInfo.vehicleData.restrInd != null && vehicleInfo.vehicleData.restrInd != undefined) {
	                                    $scope.vehicle.restrInd.value = vehicleInfo.vehicleData.restrInd.trim();
	                                }
	
	                                // Set cost new if long vin returns cost new
	                                if (vehicleInfo.vehicleData.costNew && vehicleInfo.vehicleData.costNew.amount) {
	                                    $scope.vehicle.costNew.amount.value = vehicleInfo.vehicleData.costNew.amount;
	                                }
	                            } else {
	                                ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.controller.integration.vinvalidation.info');
	                                $scope.readonly = false;
	                                $scope.showLoading = false;
	                                $scope.makesList = undefined;
	                                $scope.models = undefined;
	                                $scope.cylinders = undefined;
	                                $scope.vehicle.vin.value = undefined;
	                                $scope.vehicle.year.value = undefined;
	                                $scope.vehicle.make.value = undefined;
	                                $scope.vehicle.model.value = undefined;
	                                $scope.vehicle.cylinder.value = undefined;
	                                $scope.vehicle.cCs.value = undefined;
	                                $scope.vehicle.comprehensiveSymbolCd.value = undefined;
	                                $scope.vehicle.collisionSymbolCd.value = undefined;
	                                $scope.vehicle.twoDgVSRSymbol.value = undefined;
	                                $scope.vehicle.bodyStyle.value = undefined;
	                                $scope.vehicle.bodyType.value = undefined;
	                                $scope.showCost = true;
	                                $scope.populateYears();
	                            }
	                            $scope.showLoading = false;
	                        }, function () {
	                            //Something has gone legitimately wrong, let the user input the data manually
	                            //$scope.errorMsg = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.errorMsg'); // POR-2061
	                            $scope.showCost = true;
	                            ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.controller.integration.vinvalidation.info');
	                            $scope.readonly = false;
	                            $scope.showLoading = false;
	                            $scope.makesList = undefined;
	                            $scope.models = undefined;
	                            $scope.cylinders = undefined;
	                            $scope.vehicle.vin.value = undefined;
	                            $scope.vehicle.year.value = undefined;
	                            $scope.vehicle.make.value = undefined;
	                            $scope.vehicle.model.value = undefined;
	                            $scope.vehicle.cylinder.value = undefined;
	                            $scope.vehicle.cCs.value = undefined;
	                            $scope.vehicle.bodyStyle.value = undefined;
	                            $scope.vehicle.bodyType.value = undefined;
	                            $scope.vehicle.comprehensiveSymbolCd.value = undefined;
	                            $scope.vehicle.collisionSymbolCd.value = undefined;
	                            $scope.vehicle.twoDgVSRSymbol.value = undefined;
	                            $scope.populateYears();
	                        });
	                    }
	                };
	                $scope.checkVIN = function () {
	                    if ($scope.vehicle.vin.value.length == 0) {
	                        $scope.vehicle.year.value = undefined;
	                        $scope.vehicle.make.value = undefined;
	                        $scope.vehicle.series.value = undefined;
	                        $scope.vehicle.model.value = undefined;
	                        $scope.vehicle.cylinder.value = undefined;
	                        $scope.vehicle.cCs.value = undefined;
	                        //$scope.showCost = true;
	                        //$scope.populateYears();
	
	                        // Reset vehicle modifiers and symbols value
	                        $scope.vehicle.vehicleSurchargeCd.value = undefined;
	                        $scope.vehicle.comprehensiveSymbolCd.value = undefined;
	                        $scope.vehicle.collisionSymbolCd.value = undefined;
	                        $scope.vehicle.twoDgVSRSymbol.value = undefined;
	                        $scope.vehicle.bodyType.value = undefined;
	                        $scope.vehicle.paAntiLockBrakes.value = undefined;
	                        $scope.vehicle.paPassiveRestraint.value = undefined;
	                        $scope.vehicle.paAntiTheft.value = undefined;
	                        $scope.vehicle.costNew.amount.value = undefined;
	                        $scope.vehicle.bodyStyle.value = undefined;
	                    }
	                    // ENHC0011961_EODB QnB Defaults- populating drivers --Arpita sengupta
	                    $scope.vehicle.paType = $scope.vehicle.tmpPaType.value ? $scope.vehicle.tmpPaType.value : 'auto';
	                    //ended
	                };
	
	                $scope.lookupVin = function () {
	                    //Added If condition to fix Defect 862
	                    if ($scope.vehicle.vin.value == undefined) {
	                        $scope.makesList = undefined;
	                        $scope.series = undefined;
	                        $scope.models = undefined;
	                        $scope.cylinders = undefined;
	                        //$scope.vehicle.vin.value = undefined;
	                        $scope.vehicle.year.value = undefined;
	                        $scope.vehicle.make.value = undefined;
	                        $scope.vehicle.series.value = undefined;
	                        $scope.vehicle.model.value = undefined;
	                        $scope.vehicle.cylinder.value = undefined;
	                        $scope.vehicle.cCs.value = undefined;
	                        $scope.vehicle.bodyStyle.value = undefined;
	                        $scope.vehicle.bodyType.value = undefined;
	                        $scope.vehicle.costNew.amount = undefined;
	                        // $scope.showCost = true;
	                        //$scope.populateYears();
	                        if ($scope.years.length == 0) {
	                            $scope.populateYears();
	                        }
	                    } else if ($scope.vehicle.vin.value) {
	                        if ($scope.vehicle.vin.value.length > 0 && $scope.vehicle.vin.value.length < 17) {
	                            ModalService.showInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.directives.PAEditVehicle.checkVin.errorMsg').result;
	                            $scope.makesList = undefined;
	                            $scope.series = undefined;
	                            $scope.models = undefined;
	                            $scope.cylinders = undefined;
	                            $scope.vehicle.vin.value = "";
	                            $scope.vehicle.year.value = undefined;
	                            $scope.vehicle.make.value = undefined;
	                            $scope.vehicle.series.value = undefined;
	                            $scope.vehicle.model.value = undefined;
	                            $scope.vehicle.cylinder.value = undefined;
	                            $scope.vehicle.cCs.value = undefined;
	                            $scope.vehicle.bodyStyle.value = undefined;
	                            $scope.vehicle.bodyType.value = undefined;
	                            $scope.vehicle.costNew.amount = undefined;
	                            //$scope.showCost = true;
	                            $scope.populateYears();
	                        } else {
	                            if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa" && $scope.vehicle.vin.value.length == 17) {
	                                $scope.lookupBikeVin();
	                            } else if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto" && $scope.vehicle.vin.value.length == 17) {
	                                $scope.lookupVehicleVin();
	                            }
	                        }
	                    }
	                    // ENHC0011961_EODB QnB Defaults- populating drivers --Arpita sengupta
	                    if ($scope.drivers.length >= $scope.$parent.vehicles.length) {
	                        $scope.vehicle.chosenDriver.value = $scope.drivers[$scope.$parent.vehicles.length - 1];
	                    } else if ($scope.drivers.length < $scope.$parent.vehicles.length) {
	                        $scope.vehicle.chosenDriver.value = $scope.drivers[$scope.$parent.vehicles.length - 1] ? $scope.drivers[$scope.$parent.vehicles.length - 1] : $scope.drivers[0];
	                    }
	                    //ended
	                };
	
	                $scope.lookupBikeVin = function () {
	
	                    var hldiDetails = {
	                        vin: undefined,
	                        ccr: undefined,
	                        modelYear: undefined,
	                        seriesName: undefined,
	                        makeNumber: undefined,
	                        modelName: undefined,
	                        searchType: undefined,
	                        quoteId: undefined
	                    };
	                    //The Bike VIN does not return a match, VIN is invalid
	
	                    hldiDetails.searchType = "Vindicate";
	                    hldiDetails.CCR = "ZEM2O9S8F9A1";
	                    hldiDetails.vin = $scope.vehicle.vin.value;
	                    hldiDetails.quoteId = $scope.quoteId.value;
	                    $scope.showLoading = true;
	                    $q.when(VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails), function (bikeInfo) {
	                        if (bikeInfo && bikeInfo.vindicatorData.makeName && bikeInfo.vindicatorData.modelName && bikeInfo.vindicatorData.modelYear) {
	                            //$scope.invalidVIN = false;
	                            $scope.vehicle.make.value = bikeInfo.vindicatorData.makeName;
	                            $scope.vehicle.model.value = bikeInfo.vindicatorData.modelName;
	                            $scope.vehicle.year.value = bikeInfo.vindicatorData.modelYear.trim();
	                            $scope.vehicle.cCs.value = bikeInfo.vindicatorData.displacement.trim();
	                            $scope.vehicle.bodyStyle.value = bikeInfo.vindicatorData.vehicleClassDesc.trim();
	                            $scope.vehicle.bodyType.value = bikeInfo.vindicatorData.bodyType;
	
	                            $scope.vehicle.paType.value = "motorcycle_aaa";
	                            $scope.errorMsg = '';
	                            $scope.showLoading = false;
	                            $scope.vehicle.series.value = bikeInfo.vindicatorData.seriesName.trim();
	                            if (bikeInfo.vindicatorData.basePrice.trim() == "" || bikeInfo.vindicatorData.basePrice == undefined) {
	                                //$scope.vehicle.costNew.amount = 1;
	                                $scope.showCost = true;
	                            } else {
	                                $scope.vehicle.costNew.amount = bikeInfo.vindicatorData.basePrice.trim();
	                                $scope.showCost = false;
	                            }
	                        } else {
	                            ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.controller.integration.vinvalidation.info');
	                            $scope.readonly = false;
	                            $scope.showLoading = false;
	                            //$scope.invalidVIN = true;
	                            //Need to check use of the below statement
	                            //$scope.vehicle.year.value = undefined;
	                            $scope.makesList = undefined;
	                            $scope.models = undefined;
	                            $scope.cylinders = undefined;
	                            $scope.vehicle.vin.value = undefined;
	                            $scope.vehicle.year.value = undefined;
	                            $scope.vehicle.make.value = undefined;
	                            $scope.vehicle.model.value = undefined;
	                            $scope.vehicle.cylinder.value = undefined;
	                            $scope.vehicle.cCs.value = undefined;
	                            $scope.vehicle.bodyStyle.value = undefined;
	                            $scope.vehicle.bodyType.value = undefined;
	                            $scope.vehicle.series.value = undefined;
	                            $scope.vehicle.costNew.amount = undefined;
	                            $scope.showCost = true;
	                            $scope.populateYears();
	                        }
	                        $scope.showLoading = false;
	                    }, function () {
	                        $scope.showCost = true;
	                        ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.pa.controller.integration.vinvalidation.info');
	                        $scope.readonly = false;
	                        $scope.showLoading = false;
	                        //$scope.invalidVIN = true;
	                        $scope.errorMsg = '';
	
	                        $scope.makesList = undefined;
	                        $scope.series = undefined;
	                        $scope.models = undefined;
	                        $scope.vehicle.vin.value = undefined;
	                        $scope.vehicle.year.value = undefined;
	                        $scope.vehicle.make.value = undefined;
	                        $scope.vehicle.series.value = undefined;
	                        $scope.vehicle.model.value = undefined;
	                        $scope.vehicle.cCs.value = undefined;
	                        $scope.vehicle.bodyStyle.value = undefined;
	                        $scope.vehicle.bodyType.value = undefined;
	                        $scope.vehicle.costNew.amount = undefined;
	                        $scope.populateYears();
	                    });
	                };
	
	                $scope.generateShortVIN = function () {
	                    if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "motorcycle_aaa") {
	                        $scope.populateBikeShortVin();
	                    } else if ($scope.vehicle.paType.value != undefined && $scope.vehicle.paType.value.code == "auto") {
	                        $scope.populateCarShortVin();
	                    }
	                };
	
	                resetForm();
	                $scope.$on('update-form', function () {
	
	                    resetForm();
	                    $scope.isFormSubmitted = true;
	                    /*if ($scope.vehicle!= undefined 
	                            && $scope.vehicle.year!=undefined 
	                                && $scope.vehicle.year.value == undefined){
	                        $scope.populateYears();   
	                     }*/
	                    //$scope.populateYears(); 
	
	                    watchYear();
	                    watchMake();
	                    watchCylinder();
	                    watchModel();
	                    watchphysicalDamage();
	                    watchStorageTye();
	                    //resetForm();
	                });
	                $scope.$on('submit-form', function () {
	                    $scope.isFormSubmitted = true;
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 360 */
/***/ function(module, exports) {

	module.exports = "<!--Added below ng-hide to hide Vin *Princy*  ng-hide=\"vehicle.isPrefilledVehicle\"-->   \n<div ng-hide=\"vehicle.isPrefilledVehicle.value\">\n    <p class=\"gw-mb20\">\n        {{'quoteandbind.pa.directives.templates.pa-edit-vehicle.fillInMsg'| translate}}\n    </p>\n</div>\n<!-- ENHC0011961_EODB QnB Defaults hiding question  --Arpita Sengupta-->\n<!-- <div gw-pl-ctrl-group model=\"vehicle.tmpPaType\"\n     label=\"{{'quoteandbind.pa.directives.templates.pa-vehicle.What type of vehicle would you like to add?'|translate}}\">\n    <select ng-model=\"vehicle.tmpPaType.value\"\n            ng-options=\"k as v for (k, v) in paTypes\"\n            ng-change=\"setVehicleType()\">\n        <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Type --'| translate}}</option>\n    </select>\n</div> -->\n<!--Added below ng-hide to hide Vin *Princy*  ng-hide=\"vehicle.isPrefilledVehicle\" --> \n<div ng-hide=\"vehicle.isPrefilledVehicle.value\" gw-pl-ctrl-group model=\"vehicle.tmpPaType\">\n    <select ng-model=\"vehicle.tmpPaType.value\"\n            ng-options=\"k as v for (k, v) in paTypes\"\n            ng-change=\"setVehicleType()\">\n        <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Type --'| translate}}</option>\n    </select>\n</div>\n<!-- ended -->\n<div ng-show=\"vehicle.tmpPaType.value\">\n    <!-- Commenting line 25-28 & 32 *Princy -->\n    <!-- <div model=\"vehicle.vin\" gw-pl-ctrl-group\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.VIN'| translate}}\">\n        <input type=\"text\" id=\"Vin\" ng-model=\"vehicle.vin.value\"\n               ng-keyup=\"checkVIN()\" ng-blur=\"lookupVin()\" name=\"Vin\" maxlength=\"17\"/> -->\n        <!--<div ng-show=\"invalidVIN\" class=\"gw-error gw-inline-messages\">\n            <span class=\"gw-error-inline\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Enter 17 digit VIN.'| translate}}</span>\n        </div>-->\n    <!-- </div> -->\n\n    <!--Added below div to hide Vin *Princy*-->\n    <div ng-hide= \"vehicle.isPrefilledVehicle.value\" model=\"vehicle.vin\" gw-pl-ctrl-group\n        label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.VIN'| translate}}\"\n    >\n        <input type=\"text\" id=\"Vin\" ng-model=\"vehicle.vin.value\"\n               ng-keyup=\"checkVIN()\" ng-blur=\"lookupVin()\" name=\"Vin\" maxlength=\"17\" required=\"vehicle.isPrefilledVehicle.value ? false : true\"\n          />  \n    </div>\n    <!--end of   div to hide Vin *Princy*-->\n\n    <!--<div ng-show=\"errorMsg.length > 0\" class=\"gw-error gw-inline-messages\">\n        <span class=\"gw-error-inline\">{{errorMsg}}</span>\n    </div>-->\n    <!--Added below ng-hide to hide Vin *Princy*  ng-hide=\"vehicle.isPrefilledVehicle\"--> \n    <p ng-hide= \"vehicle.isPrefilledVehicle.value\" class=\"section-label\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.OR' | translate}}</p>\n\n\n    <div gw-pl-ctrl-group model=\"vehicle.year\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Year'| translate}}\">\n        <!-- devendra added or condition below for data prefill changes-->\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.year.value}}</span>\n        <span class=\"gw-imageDiv\" ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n        <select ng-model=\"vehicle.year.value\" \n                ng-options=\"year as year for year in availableYears\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Year --'| translate}}</option>\n        </select>\n    </div>\n\n    <!-- Changed for DE807 : Start-->\n    <!--<div gw-pl-ctrl-group model=\"vehicle.make\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Make'| translate}}\">\n        <span ng-if=\"vehicle.vin.value\">{{vehicle.make.value}}</span>\n\n        <select ng-model=\"vehicle.make.value\" \n                ng-options=\"make as make for make in makes\"\n                ng-if=\"!vehicle.vin.value\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.&#45;&#45; Choose Vehicle Make &#45;&#45;'| translate}}</option>\n        </select>\n        <span ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>-->\n\n    <div ng-show=\"vehicle.tmpPaType.value == 'auto'\"\n         gw-pl-ctrl-group model=\"vehicle.make\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Make'| translate}}\">\n        <!-- devendra added or condition below for data prefill changes-->\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.make.value}}</span>\n\n        <select ng-model=\"vehicle.make.value\"\n                ng-options=\"value.makeCode as value.makeValue for value in makesList\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Make --'| translate}}</option>\n        </select>\n        <span ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>\n\n    <div ng-show=\"vehicle.tmpPaType.value == 'motorcycle_aaa'\"\n         gw-pl-ctrl-group model=\"vehicle.make\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Make'| translate}}\">\n        <!-- devendra added or condition below for data prefill changes-->\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.make.value}}</span>\n\n        <!--<select ng-model=\"vehicle.make.value\"\n                ng-options=\"value.makeNumber as value.makeName for value in makesList\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.&#45;&#45; Choose Vehicle Make &#45;&#45;'| translate}}</option>\n        </select>-->\n        <select ng-model=\"vehicle.make.value\"\n                ng-options=\"value.makeName as value.makeName for value in makesList\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Make --'| translate}}</option>\n        </select>\n        <span ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>\n    <!-- Changed for DE807 : End-->\n\n    <div gw-pl-ctrl-group model=\"vehicle.series\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Series'| translate}}\" ng-show=\"vehicle.tmpPaType.value == 'motorcycle_aaa'\">\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.series.value}}</span>\n        <select ng-model=\"vehicle.series.value\" \n                ng-options=\"serial as serial for serial in series track by serial\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Series --'| translate}}</option>\n        </select>\n\n        <span class=\"gw-imageDiv\" ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>\n\n    <div gw-pl-ctrl-group model=\"vehicle.model\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Model'| translate}}\">\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.model.value}}</span>\n        <!--<select ng-model=\"vehicle.model.value\"\n                ng-options=\"model as model for model in models\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\"\n                ng-change=\"showCostDiv()\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.&#45;&#45; Choose Vehicle Model &#45;&#45;'| translate}}</option>\n        </select>-->\n        <select ng-model=\"vehicle.model.value\"\n                ng-options=\"model as model for model in models\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Model --'| translate}}</option>\n        </select>\n        <span class=\"gw-imageDiv\" ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>\n\n    <div gw-pl-ctrl-group model=\"vehicle.cylinder\" ng-show=\"vehicle.year != undefined && vehicle.make != undefined && vehicle.model != undefined && vehicle.tmpPaType.value == 'auto'\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Cylinders'| translate}}\" ng-show=\"vehicle.paType.value == 'auto'\">\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.cylinder.value}}</span>\n        <select ng-model=\"vehicle.cylinder.value\" \n                ng-options=\"cylinder as cylinder for cylinder in cylinders\"\n                ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" >\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Cylinder --'| translate}}</option>\n        </select>\n        <span class=\"gw-imageDiv\" ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n    </div>\n    <!-- ENHC0011961_EODB QnB Defaults --Arpita Sengupta  -->\n    <!-- <div ng-show=\"showCost\"> -->\n    <div class=\"ng-hide\">\n        <div gw-pl-ctrl-group model=\"vehicle.costNew.amount\"\n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Cost New'| translate}}\">\n            <input ng-model=\"vehicle.costNew.amount.value\" type=\"text\" maxlength=\"10\"/>\n            <span class=\"custom-error\"\n                  ng-if=\"isFormSubmitted && (vehicle.costNew.amount.value === undefined || vehicle.costNew.amount.value == '')\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n        </div>\n    </div>\n    <!-- ended -->\n    <div gw-pl-ctrl-group model=\"vehicle.cCs\" readonly=\"readonly\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.CC'| translate}}\" ng-show=\"vehicle.tmpPaType.value == 'motorcycle_aaa'\">\n        <span ng-if=\"(vehicle.vin.value && vehicle.vin.value.length === 17) || (vehicle.vin.value && vehicle.isPrefilledVehicle.value)\">{{vehicle.cCs.value}}</span>\n        <input type=\"text\" id=\"cCs\" ng-model=\"vehicle.cCs.value\"\n               name=\"CCs\" maxlength=\"5\" ng-if=\"!vehicle.vin.value || vehicle.vin.value.length < 17\" />\n\n        <span class=\"gw-imageDiv\" ng-hide=\"!showLoading\">\n            <img src=\"../styles/images/common/throbber.gif\"/>\n        </span>\n\n        <!--<div ng-show=\"errorMsg.length > 0\" class=\"gw-error gw-inline-messages\">\n            <span class=\"gw-error-inline\">{{errorMsg}}</span>\n        </div>-->\n    </div>\n</div>\n\n    <hr>\n   <!-- <div gw-pl-ctrl-group model=\"vehicle.tmpPaType\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-vehicle.What type of vehicle would you like to add?'|translate}}\">\n        <select ng-model=\"vehicle.tmpPaType.value\"\n                ng-options=\"k as v for (k, v) in paTypes\"\n                ng-change=\"setVehicleType()\">\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- Choose Vehicle Type --'| translate}}</option>\n        </select>\n    </div>-->\n\n    <!-- For defect DE1703 -->\n    <!--<div ng-show=\"isPurchase\">\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Did you purchase this vehicle in the last 60 days'|translate}}\" \n             model=\"vehicle.nearTwoMonths\" name=\"NearTwoMonths\">\n        </div>\n\n\n        <div ng-show=\"vehicle.nearTwoMonths.value\">\n            &lt;!&ndash;<div gw-pl-ctrl-group model=\"submissionVm.draftData.accountHolder.dateOfBirth\"\n                  label=\"{{'quoteandbind.views.contact-details.Date of Birth' | translate}}\">\n                 <span gw-pl-local-date-chooser\n                       model=\"submissionVm.draftData.accountHolder.dateOfBirth.value\"\n                       max-date=\"maxDateOfBirth\" initial-date=\"maxDateOfBirth\"></span>\n             </div>&ndash;&gt;\n            <div gw-pl-ctrl-group model=\"vehicle.purchasedOn\"\n                 label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Purchase Date'| translate }}\" >\n                <span ng-datepicker\n                      default-date=\"today\"\n                      min-view=\"day\"\n                      ng-model=\"vehicle.purchasedOn.value\"></span>\n            </div>\n        </div>\n    </div>-->\n\n    <div>\n        <div gw-pl-ctrl-group model=\"vehicle.chosenDriver\"\n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Who drives this vehicle/motorcycle the most?'|translate}}\">\n            <select name=\"chosenDriver\" id=\"chosenDriver\" ng-model=\"vehicle.chosenDriver.value\"  ng-options=\"populateDriverName(option.person) for option in  drivers track by (option.person.firstName + option.person.lastName)\" ></select>\n            </select>\n        </div>\n    </div>\n\n    <div gw-pl-ctrl-group model=\"vehicle.tmpPrimeUse\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.How do you use this vehicle?'|translate}}\" \n         >\n        <select ng-model=\"vehicle.tmpPrimeUse.value\" \n                ng-options=\"key as val for (key, val) in primaryUser\"\n                ng-change=\"setVehicleUsage()\">\n            <option value=\"\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.-- None --'|translate}}</option>\n        </select>\n        <span class=\"custom-error\"\n              ng-if=\"(vehicle.tmpPrimeUse.value === undefined || vehicle.tmpPrimeUse.value === null)\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n\n    </div>\n\n    <div ng-show=\"vehicle.accountHolderState.value.code == 'SC'\">\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Is your vehicle address within the city limits?'|translate}}\" \n             model=\"vehicle.inCitiyLimits\" name=\"CityLimits\">\n        </div>\n    </div>\n\n    <div>\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Is the address you previously entered where your vehicle is regularly garaged or parked?'|translate}}\" \n             model=\"vehicle.regularlyParked\" name=\"RegularlyParked\">\n        </div>\n    </div>\n\n    <div ng-show=\"vehicle.regularlyParked.value != undefined && !vehicle.regularlyParked.value\">\n        <div gw-pl-ctrl-group model=\"vehicle.parkedZipCode\"\n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Enter Zipcode where vehicle is garaged'| translate}}\">\n\n            <input type=\"text\" id=\"parkedZipCode\" ng-model=\"vehicle.parkedZipCode.value\" name=\"ParkedZipCode\"  maxlength=\"5\"/>\n        </div>\n    </div>\n    <!--<div ng-show=\"hasMotorcycleEndorsement(vehicle)\">\n        <div gw-pl-yes-no-group\n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Is your motorcycle kept in a locked garage?'|translate}}\"\n             model=\"vehicle.inLockedGarage\" name=\"InLockedGarage\" >\n        </div>\n    </div>-->\n\n<div ng-show=\"vehicle.tmpPaType.value === 'motorcycle_aaa'\">\n<gw-pl-input-ctrl model=\"vehicle.storageType\"\n                  label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Where is your motorcycle parked?' | translate }}\"\n                  placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Where is your motorcycle parked.-- Choose storage Type --' | translate }}\">\n</gw-pl-input-ctrl>\n\n</div>\n<div ng-show=\"vehicle.tmpPaType.value === 'motorcycle_aaa'\">\n    <div gw-pl-yes-no-group\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Has This Vehicle Been Converted to a Trike?'|translate}}\"\n         model=\"vehicle.isConvertedToTrike\" name=\"IsConvertedToTrike\">\n    </div>\n</div>\n\n    <div gw-pl-ctrl-group model=\"vehicle.tmpOwnership\"\n         label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Ownership'|translate}}\">\n         <div class=\"trinary-radiogroup ownership-web-view\">\n            <input name=\"ownership\" id=\"own\" type=\"radio\"\n                   ng-model=\"vehicle.tmpOwnership.value\"\n                   ng-value=\"Own\" ng-click=\"setOwnership('Own')\"/>\n            <label for=\"own\" class=\"gw-radio inline\" ng-class=\"{active:vehicle.tmpOwnership.value == 'Own'}\">\n                {{'quoteandbind.pa.directives.templates.pa-vehicle.Own'|translate}}\n            </label>\n\n            <input name=\"ownership\" id=\"leased\" type=\"radio\"\n                   ng-model=\"vehicle.tmpOwnership.value\"\n                   ng-value=\"additionalinterest_aaa\" ng-click=\"setOwnership('additionalinterest_aaa')\" />\n            <label for=\"leased\" class=\"gw-radio gw-inline\" ng-class=\"{active:vehicle.tmpOwnership.value == 'additionalinterest_aaa'}\">\n                {{'quoteandbind.pa.directives.templates.pa-vehicle.Leased'|translate}}\n            </label>\n\n            <input name=\"ownership\" id=\"ownandmakepayments\" type=\"radio\"\n                   ng-model=\"vehicle.tmpOwnership.value\"\n                   ng-value=\"LOSSP\" ng-click=\"setOwnership('LOSSP')\"/>\n            <label for=\"ownandmakepayments\" class=\"gw-radio gw-inline\" ng-class=\"{active:vehicle.tmpOwnership.value == 'LOSSP'}\">\n                {{'quoteandbind.pa.directives.templates.pa-vehicle.Own and Make Payments'|translate}}\n            </label>\n        </div>\n        <!--Added for ownership dropdown in mobile view -->\n        <select class=\"ownership-mobile-view\" ng-model=\"vehicle.tmpOwnership.value\"   ng-options=\"k as v for (k, v) in  ownership\"  render-by=\"'name'\"\n                ng-change=\"setOwnerShipSelected()\">\n               ></select>\n    </div>\n\n    <!--------------------------------------------------------------  changes for DE 747 start here----------------------------------------------------- -->\n\n\n    <div class=\"bottom-padding-30\" ng-if=\"vehicle.tmpOwnership.value === 'additionalinterest_aaa'\">\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle Lease Contact Details' | translate}}</h2>\n        <!--<div >\n            <div>{{'quoteandbind.pa.views.pa-policy-info.LeaseCompanyInstruction' | translate}}</div><br/>\n            <div class=\"gw-controls\">\n                <select ng-options=\"lease.name for lease in leaseOptions\" ng-model=\"leaseSelectedOption\"></select>\n            </div>\n        </div>\n        <br/>-->\n        <div ng-if=\"leaseSelectedOption.name === 'Other' \">\n            <div model=\"vehicle.addnlInterest.name\">\n\n                <input type=\"text\" ng-model=\"vehicle.addnlInterest.name.value\" name=\"Name\"\n                       placeholder =\"{{'quoteandbind.pa.views.pa-policy-info.Lease Company Name' | translate}}\"\n                       maxlength=\"30\"/>\n\n                <span class=\"aaa-inline-info-wrapper finance-select-div\">\n                       <div class=\"aaa-inline-info\">{{'quoteandbind.pa.views.pa-policy-info.leasecompany.name.Tooltip' | translate }}\n                       </div>\n                       <i class=\"fa fa-info-circle\"></i>\n                </span>\n\n                <span class=\"custom-error\"\n                      ng-show=\"!vehicle.addnlInterest.name.value && isFormSubmitted\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n\n            </div>\n            <br>\n            <div gw-pl-ownership-address lease=\"true\"\n                 address=\"vehicle.addnlInterest.addnlInterestAddress\"\n                 maxlength=\"50\"></div>\n        </div>\n    </div>\n    <div class=\"bottom-padding-30\" ng-if=\"vehicle.tmpOwnership.value === 'LOSSP'\">\n        <br/>\n        <h3>{{vehicle.year.value}}&nbsp;{{vehicle.make.value}}&nbsp;{{vehicle.model.value}}</h3>\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle Finance/Loan Contact Details' | translate}}</h2>\n        <!--<div>\n            <div>{{'quoteandbind.pa.views.pa-policy-info.FinanceCompanyInstruction' | translate}}</div>\n            <br/>\n            <div class=\"gw-controls\">\n                <select ng-options=\"finance.name for finance in financeOptions\" ng-model=\"financeSelectedOption\"></select>\n            </div>\n        </div>\n        <br/>-->\n        <div ng-if=\"financeSelectedOption.name === 'Other' \">\n            <div  model=\"vehicle.addnlInterest.name\">\n\n                <input type=\"text\" ng-model=\"vehicle.addnlInterest.name.value\"\n                       placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.Finance Company Name' | translate}}\" maxlength=\"50\"/>\n\n                <span class=\"aaa-inline-info-wrapper finance-select-div\">\n                <div class=\"aaa-inline-info\">{{'quoteandbind.pa.views.pa-policy-info.financecompany.name.Tooltip' | translate }}</div>\n                <i class=\"fa fa-info-circle\"></i>\n                </span>\n\n                <span class=\"custom-error\"\n                      ng-show=\"!vehicle.addnlInterest.name.value && isFormSubmitted\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n            </div>\n            <br>\n            <div gw-pl-ownership-address lease=\"false\"\n                 vehicle = \"vehicle\"\n                 address=\"vehicle.addnlInterest.addnlInterestAddress\" maxlength=\"50\"></div>\n\n        </div>\n    </div>\n\n    <!-------------------------------------------------------------- changes  for DE 747 Ends here----------------------------------------------------- -->\n\n\n    <div>\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Have you customized your vehicle?'|translate}}\" \n             model=\"vehicle.isCustomizedVehicle\" name=\"IsCustomizedVehicle\">\n        </div>\n    </div>\n\n    <div>\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Does vehicle have a salvage title?'|translate}}\" \n             model=\"vehicle.salvageTitle\" name=\"SalvageTitle\" >\n        </div>\n       \n    </div>\n    \n\n    <div>\n        <div gw-pl-yes-no-group \n             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Does the vehicle have any physical damage resulting from an accident?'|translate}}\" \n             model=\"vehicle.damageInAccident\" name=\"DamageInAccident\">\n        </div>\n    </div>\n"

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(362)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	
	            controller: ['$scope', function ($scope) {
	                this._getCoveragesForVehicle = function (veh) {
	                    return veh.coverages.map(function (vehicleCov) {
	                        return { name: veh.vehicleName + ' - ' + vehicleCov.name, amount: vehicleCov.amount };
	                    });
	                };
	
	                this._coverages = function () {
	                    var lineCoverages = $scope.chosenQuote.lobs.personalAuto.lineCoverages.map(function (lineCov) {
	                        return { name: lineCov.name, amount: lineCov.amount };
	                    });
	                    var coveragesForVehicles = $scope.chosenQuote.lobs.personalAuto.vehicleCoverages.map(this._getCoveragesForVehicle);
	
	                    return lineCoverages.concat(_.flatten(coveragesForVehicles));
	                };
	
	                $scope.coverages = this._coverages();
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div gw-pl-accordion>\n        <div gw-pl-accordion-group is-open=\"status.driverOpen\">\n            <div gw-pl-accordion-heading>\n                <h2 class=\"gw-page-section-title\">\n                    <span>{{'quoteandbind.pa.views.pa-confirmation.Driver Details' | translate:this}}</span>\n                    <gw-pl-accordion-chevron is-open=\"status.driverOpen\"></gw-pl-accordion-chevron>\n                </h2>\n            </div>\n            <div ng-repeat=\"(key, driver) in submission.draftData.lobs.personalAuto.drivers\">\n                <div>\n                    <h5>{{driver.name}}</h5>\n\n                    <div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.Drivers License Number' | translate}}</div>\n                            <div class=\"gw-controls\">{{driver.licenseNumber}}</div>\n                        </div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.License State' | translate}}</div>\n                            <div class=\"gw-controls\">{{driver.licenseState}}</div>\n                        </div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.Year First Licensed' | translate}}</div>\n                            <div class=\"gw-controls\">{{driver.yearLicensed}}</div>\n                        </div>\n                    </div>\n                    <!-- Garog : To implement along with driver question sets <div label=\"Licence Suspended\">\n                        <input type=\"text\" id=\"licenceSuspended\" name=\"LicenceSuspended\"ng-model=\"driver.YearLicensed\"/>\n                    </div>  -->\n                </div>\n            </div>\n        </div>\n        <div gw-pl-accordion-group is-open=\"status.vehicleOpen\">\n            <div gw-pl-accordion-heading>\n                <h2 class=\"gw-page-section-title\">\n                    <span>{{'quoteandbind.pa.views.pa-confirmation.Vehicle Details' | translate}}</span>\n                    <gw-pl-accordion-chevron is-open=\"status.vehicleOpen\"></gw-pl-accordion-chevron>\n                </h2>\n            </div>\n            <div>\n                <table class=\"gw-table\">\n                    <thead>\n                    <tr>\n                        <th>{{'quoteandbind.pa.views.pa-confirmation.Make' | translate}}</th>\n                        <th>{{'quoteandbind.pa.views.pa-confirmation.Model' | translate}}</th>\n                        <th>{{'quoteandbind.pa.views.pa-confirmation.License Plate' | translate}}</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat=\"vehicles in submission.draftData.lobs.personalAuto.vehicles\">\n                        <td title=\"{{'quoteandbind.pa.views.pa-confirmation.Make' | translate}}\">\n                            {{ vehicles.make }}\n                        </td>\n                        <td title=\"{{'quoteandbind.pa.views.pa-confirmation.Model' | translate}}\">\n                            {{ vehicles.model }}\n                        </td>\n                        <td title=\"{{'quoteandbind.pa.views.pa-confirmation.License Plate' | translate}}\">\n                            {{ vehicles.license }}\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div gw-pl-accordion-group is-open=\"status.premiumOpen\">\n            <div gw-pl-accordion-heading>\n                <h2 class=\"gw-page-section-title\">\n                    <span>{{'quoteandbind.pa.views.pa-confirmation.Coverage Premium Details' | translate}}</span>\n                    <gw-pl-accordion-chevron is-open=\"status.premiumOpen\"></gw-pl-accordion-chevron>\n                </h2>\n            </div>\n            <div>\n                <table class=\"gw-table\">\n                    <thead>\n                    <tr>\n                        <th>{{'quoteandbind.pa.views.pa-confirmation.Coverage' | translate}}</th>\n                        <th>{{'quoteandbind.pa.views.pa-confirmation.Limits' | translate}}</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat=\"coverage in coverages\">\n                        <td class=\"gw-notitle gw-mobile-hidden\">{{ coverage.name }}</td>\n                        <td title=\"{{ coverage.name }}\">{{coverage.amount|gwCurrency}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div gw-pl-accordion-group is-open=\"status.infoOpen\">\n            <div gw-pl-accordion-heading>\n                <h2 class=\"gw-page-section-title\">\n                    <span>{{'quoteandbind.pa.views.pa-confirmation.Contact Information Details' | translate}}</span>\n                    <gw-pl-accordion-chevron is-open=\"status.infoOpen\"></gw-pl-accordion-chevron>\n                </h2>\n            </div>\n            <div>\n                <div>\n                    <div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.FirstName' | translate}}</div>\n                            <div class=\"gw-controls\">{{accountHolder.firstName}}</div>\n                        </div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.LastName' | translate}}</div>\n                            <div class=\"gw-controls\">{{accountHolder.lastName}}</div>\n                        </div>\n                        <div class=\"gw-control-group\" ng-if=\"contactNumber\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.Phone' | translate}}</div>\n                            <div class=\"gw-controls\">{{contactNumber}}</div>\n                        </div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.Email' | translate}}</div>\n                            <div class=\"gw-controls\">{{accountHolder.emailAddress1}}</div>\n                        </div>\n                        <div class=\"gw-control-group\">\n                            <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-confirmation.Address' | translate}}</div>\n                            <div class=\"gw-controls\">{{accountHolderAddress.addressLine1}},\n                                <div ng-if=\"accountHolderAddress.addressLine2\">{{accountHolderAddress.addressLine2}},</div>\n                                <div ng-if=\"accountHolderAddress.city\">{{accountHolderAddress.city}},</div>\n                                <div ng-if=\"accountHolderAddress.state\">{{accountHolderAddress.state}},</div>\n                                <div ng-if=\"accountHolderAddress.postalCode\">{{accountHolderAddress.postalCode}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(364)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbPaEditCoverages',
	                onCovChange: '=',
	                loading: '=?'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 364 */
/***/ function(module, exports) {

	module.exports = "<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.General Coverages' | translate}}</span>\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.(Apply to all vehicles)' | translate}}</span>\n</h4>\n<div class=\"gw-quote-boxes\">\n    <div gw-qnb-editable-coverages=\"model.lineCoverages.value\" loading=\"loading\" on-cov-change=\"onCovChange\" allow-select-coverage=\"true\"></div>\n</div>\n\n<div class=\"gw-quote-boxes\">\n    <div ng-repeat=\"vehicle in model.vehicleCoverages.value\">\n        <h4 class=\"gw-coverage-header\">{{ vehicle.vehicleName }}</h4>\n\n        <div class=\"gw-quote-boxes\">\n            <div gw-qnb-editable-coverages=\"vehicle.coverages\" loading=\"loading\" on-cov-change=\"onCovChange\" allow-select-coverage=\"true\"></div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(367), __webpack_require__(377), __webpack_require__(368), __webpack_require__(369), __webpack_require__(370), __webpack_require__(371), __webpack_require__(372), __webpack_require__(373), __webpack_require__(374), __webpack_require__(375), __webpack_require__(376), __webpack_require__(366), __webpack_require__(378), __webpack_require__(379), __webpack_require__(380), __webpack_require__(381), __webpack_require__(382), __webpack_require__(383), __webpack_require__(384), __webpack_require__(386), __webpack_require__(387), __webpack_require__(388)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAContactDetailsView, PAPreQualQuestionsView, PAMembershipView, PADriverVehiclePrefilledView, PAPrevCarrierInfoView, DriverDetailsView, VehicleDetailsView, PolicyInfoView, PolicySummaryView, ReQuoteDetailsView, PAESignatureView, PAContactDetailsCtrl, PAPreQualQuestionsCtrl, MembershipCtrl, DriverVehiclePrefilledCtrl, PrevCarrierInfoCtrl, DriverDetailsCtrl, VehicleDetailsCtrl, PolicyInfoCtrl, PolicySummaryCtrl, ReQuoteDetailsCtrl, PAESignatureCtrl) {
	    return function () {
	        var wizardParentState = 'baseQnbWizard';
	
	        return {
	            paContactDetails: {
	                parent: wizardParentState,
	                template: PAContactDetailsView,
	                controller: PAContactDetailsCtrl
	            },
	            paPrequalQuestions: {
	                parent: wizardParentState,
	                controller: PAPreQualQuestionsCtrl,
	                template: PAPreQualQuestionsView
	            },
	            paMembership: {
	                parent: wizardParentState,
	                template: PAMembershipView,
	                controller: MembershipCtrl
	            },
	
	            paDriverVehiclePrefillInfo: {
	                parent: wizardParentState,
	                template: PADriverVehiclePrefilledView,
	                controller: DriverVehiclePrefilledCtrl
	            },
	            paPrevCarrierInfo: {
	                parent: wizardParentState,
	                template: PAPrevCarrierInfoView,
	                controller: PrevCarrierInfoCtrl
	            },
	            paDriverDetails: {
	                parent: wizardParentState,
	                controller: DriverDetailsCtrl,
	                template: DriverDetailsView
	            },
	            paVehicleDetails: {
	                parent: wizardParentState,
	                controller: VehicleDetailsCtrl,
	                template: VehicleDetailsView,
	                resolve: {
	                    availableYears: ['$q', 'VinLookupService', 'submissionViewModel', 'ModalService', function ($q, VinLookupService, submissionViewModel, ModalService) {
	
	                        var submissionVm = new submissionViewModel();
	                        var vinDetails = {};
	                        vinDetails.searchType = "AvailableYears";
	                        vinDetails.vinServiceSearchType = angular.copy(vinDetails.searchType);
	                        vinDetails.quoteID = submissionVm.quoteID.value;
	                        vinDetails.masterMakeList = {};
	                        vinDetails.vehicleType = "auto";
	
	                        var msgBox = ModalService.showLoadingDialog('quoteandbind.views.modal.Please wait');
	
	                        var deferred = $q.defer();
	                        VinLookupService.aaaVINLookup('quoteandbind', vinDetails).then(function (response) {
	                            msgBox.close();
	                            deferred.resolve(response);
	                        }, function (error) {
	                            msgBox.close();
	                            deferred.resolve({});
	                        });
	
	                        return deferred.promise;
	                    }]
	                }
	            },
	
	            paRequoteDetails: {
	                //name: 'requoteDetails',
	                parent: wizardParentState,
	                controller: ReQuoteDetailsCtrl,
	                template: ReQuoteDetailsView
	            },
	
	            paPolicyInfo: {
	                parent: wizardParentState,
	                controller: PolicyInfoCtrl,
	                template: PolicyInfoView
	            },
	            paPolicySummary: {
	                parent: wizardParentState,
	                controller: PolicySummaryCtrl,
	                template: PolicySummaryView
	            },
	            paEsignature: {
	                parent: wizardParentState,
	                controller: PAESignatureCtrl,
	                template: PAESignatureView
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, _) {
	    var fn = function fn($scope, $state, $rootScope, $filter, ModalService, AgeAllowedToDrive, submissionViewModel, StateUtils, LocaleService, MembershipService, InputValidationService) {
	
	        var ctrl = Object.create(BaseCtrl);
	
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	            //^Princy
	            // $scope.source_string = 'parvez.alam';
	            // console.log('source String = ' + $scope.source_string);
	            // var encrypted = CryptoJS.AES.encrypt(
	            //             $scope.source_string,
	            //             $rootScope.base64Key,
	            //             { iv: $rootScope.iv });
	            // console.log('encrypted = ' + encrypted);
	            $scope.isNameValid = true; ////ENHC0013007 -- Insurance Premium Refunds --Arpita
	            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	            $scope.minDob = "01-01-1800";
	            $scope.isMinDateOfBirthValid = true;
	            //DFCT0020397 - QnB Date Of Birth Validation ends
	            $scope.isPeriodStartDateValid = true;
	            $scope.addressOverridden = false;
	            //            $rootScope.xxx = false
	            // ENHC0011961 -  initializing membership scope --Arpita Sengupta
	            $scope.accountHolder = submissionVM.draftData.accountHolder.value;
	            $scope.membershipDetails = {
	                membershipNumber: $scope.accountHolder.membershipNumber || '',
	                firstName: '',
	                lastName: ''
	            };
	            // ENHC0011961 - assigning membershipnumber if available
	            if ($scope.submission.draftData.accountHolder.membershipNumber) {
	                $scope.membershipDetails.membershipNumber = $scope.submission.draftData.accountHolder.membershipNumber;
	            }
	            //ended
	            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	
	            var today = new Date();
	            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
	            var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(accountHolder) {
	                if (accountHolder.firstName === '0streamlinedquote0') {
	                    accountHolder.firstName = undefined;
	                    accountHolder.lastName = undefined;
	                    accountHolder.dateOfBirth = undefined;
	                }
	            };
	
	            $scope.submissionVm = submissionViewModel();
	
	            //Added for Cancel button on Personal Information
	            //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
	            $scope.goToCancel = function (form) {
	                if ($scope.cancel) {
	                    $scope.cancel(function (_model, args) {
	                        return flowModel.cancel(_model, args);
	                    }, form);
	                } else {
	                    flowModel.cancel(model);
	                }
	            };
	
	            $scope.submissionVM = submissionVM;
	
	            $scope.accountHolder = $scope.submissionVm.draftData.accountHolder.value;
	            //Added for the defect DE1321
	            $scope.accountCellNumber = $scope.accountHolder.cellNumber;
	            $scope.accountWorkNumber = $scope.accountHolder.workNumber;
	            $scope.accountHomeNumber = $scope.accountHolder.homeNumber;
	
	            //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
	            // Not display occupation typecodes from this list
	            $scope.occupationFilterCodes = ["studentawaymorethan100mi"];
	
	            //Added for defect DE823
	            if ($scope.accountHolder.primaryPhoneType == "mobile") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.cellNumber;
	            } else if ($scope.accountHolder.primaryPhoneType == "home") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.homeNumber;
	            } else if ($scope.accountHolder.primaryPhoneType == "work") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.workNumber;
	            }
	            // DFCT0021660-phone no display issue
	            if ($scope.submissionVm.draftData.accountHolder.value.homeNumber && $scope.submissionVm.draftData.accountHolder.value.homeNumber.length > 10) {
	                $scope.submissionVm.draftData.accountHolder.value.homeNumber = $scope.submissionVm.draftData.accountHolder.value.homeNumber.slice($scope.submissionVm.draftData.accountHolder.value.homeNumber.length - 10);
	            } else if ($scope.submissionVm.draftData.accountHolder.value.cellNumber && $scope.submissionVm.draftData.accountHolder.value.cellNumber.length > 10) {
	                $scope.submissionVm.draftData.accountHolder.value.cellNumber = $scope.submissionVm.draftData.accountHolder.value.cellNumber.slice($scope.submissionVm.draftData.accountHolder.value.cellNumber.length - 10);
	            } else if ($scope.submissionVm.draftData.accountHolder.value.workNumber && $scope.submissionVm.draftData.accountHolder.value.workNumber.length > 10) {
	                $scope.submissionVm.draftData.accountHolder.value.workNumber = $scope.submissionVm.draftData.accountHolder.value.workNumber.slice($scope.submissionVm.draftData.accountHolder.value.workNumber.length - 10);
	            } //ended
	            // adding function to update period start date --Arpita Sengupta
	            $scope.submissionVM.draftData.periodStartDate.value = $scope.submissionVm.draftData.periodStartDate.value ? $scope.submissionVm.draftData.periodStartDate.value : today;
	            var startDt = new Date($scope.submissionVm.draftData.periodStartDate.value);
	            var effectiveDtManipulation = function effectiveDtManipulation(addedDt) {
	                var defaultEffDt = Date.UTC(addedDt.getUTCFullYear(), addedDt.getUTCMonth(), addedDt.getUTCDate(), addedDt.getUTCHours(), addedDt.getUTCMinutes(), addedDt.getUTCSeconds());
	                $scope.submissionVm.draftData.periodStartDate.value = new Date(defaultEffDt);
	            };
	
	            if (!$scope.submissionVM.quoteID.value) {
	                startDt.setDate(startDt.getDate() + 7);
	                effectiveDtManipulation(startDt);
	            }
	            //for quote retrieval
	            if ($scope.submissionVM.quoteID.value && new Date(startDt).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
	                var formtdt = new Date(today.toISOString());
	                formtdt.setDate(formtdt.getDate() + 7);
	                effectiveDtManipulation(formtdt);
	            }
	            //ended
	            $scope.entryDate = $scope.submissionVm.draftData.periodStartDate.value;
	
	            // CHG0031104 - Set QnB Source, Credit Union Member Flag and Credit Union Join year
	            // AB - 05/14/2018
	
	            // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
	            // AB - 11/23/2020
	
	            if ($rootScope.Arg1 == null) {
	                var arg1 = $rootScope.Arg1;
	            } else {
	                var arg1 = $rootScope.Arg1.toUpperCase();
	            }
	
	            switch (arg1) {
	                case "GORMISH":
	                case "SEA":
	                case "YOMTOB":
	                case "SECU":
	                case "BWE":
	                case "SCOTT":
	                case "MERRILL":
	                case "CROWFIELD":
	                case "RICKARD":
	                case "NIXON":
	                case "BLUE":
	                case "GRAY":
	                case "JONES":
	                case "MCCARTHY":
	                case "ASSOCIATES":
	                case "ANTHONY":
	                case "SIMMONS":
	                case "WILLIAMS":
	                case "MORRISON":
	                case "CRUMEL":
	                case "YOU":
	                case "MILLER":
	                case "PERSINSKI":
	                case "FLOURNOY":
	                    //                 $scope.submissionVM.draftData.accountHolder.qnbSource = "SECU";
	                    // Get Credit Union Member Flag and Credit Union Join year from the Membership page
	                    // AB -  April 05, 2020
	                    //                  $scope.submissionVM.draftData.accountHolder.isCreditUnionMember = true
	                    //                  $scope.submissionVM.draftData.accountHolder.joinedYearCreditUnionMembership = (new Date()).getFullYear()
	                    //                  break
	                    //                  $scope.submissionVM.draftData.accountHolder.qnbSource = "GORMISH";
	                    $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase();
	                    break;
	                default:
	                    //                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1;
	                    $scope.submissionVM.draftData.accountHolder.qnbSource = null;
	            }
	
	            sanitisePrefillDataFromQuickQuote($scope.accountHolder);
	
	            //$scope.accountHolder.primaryPhoneType = null;
	            $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "home";
	
	            $scope.submissionVM.draftData.accountHolder.value.ageLimit = 16;
	            $scope.submissionVm.draftData.policyAddress.addressType.value = $scope.submissionVm.draftData.policyAddress.addressType.value || 'home';
	
	            $scope.maxDateOfBirth = {
	                year: today.getFullYear() - AgeAllowedToDrive,
	                month: today.getMonth(),
	                day: today.getDate()
	            };
	
	            $scope.today = new Date();
	            $scope.today.setHours(0, 0, 0, 0);
	
	            $scope.coverageStartDt = today.setHours(720);
	            /*current date from the Calendar fix by devendra start*/
	            if (new Date().getTimezoneOffset() > 0) {
	                $scope.today.setHours(-1);
	            }
	            /*current date from the Calendar fix by devendra end*/
	            // Check for the valid account holder details
	            var isValidAccount = $scope.accountHolder["dateOfBirth"] ? true : false;
	            //console.log("isValidAccount: ",isValidAccount);
	            if (!isValidAccount) {
	
	                var accountDetails = angular.copy($rootScope.accountDetails);
	                var accountHolder = accountDetails.accountHolder;
	                var accountHolderAddress = accountDetails.accountHolderAddress;
	                // check account exists
	                if (accountHolder.accountExists) {
	
	                    // Fill Account Details
	                    $scope.accountHolder.publicID = accountHolder.publicID;
	                    $scope.accountHolder.accountNumber = accountHolder.accountNumber;
	                    $scope.accountHolder.displayName = accountHolder.displayName;
	                    $scope.accountHolder.accountExists = accountHolder.accountExists;
	                    $scope.accountHolder.firstName = accountHolder.firstName;
	                    $scope.accountHolder.lastName = accountHolder.lastName;
	                    $scope.accountHolder.emailAddress1 = accountHolder.emailAddress1;
	                    $scope.accountHolder.emailExist = true;
	                    var dateOfBirth = accountHolder.dateOfBirth;
	                    var day = parseInt($filter('date')(dateOfBirth, "dd"));
	                    var month = parseInt($filter('date')(dateOfBirth, "MM")) - 1;
	                    var year = parseInt($filter('date')(dateOfBirth, "yyyy"));
	                    //console.log("DateOfBirth: ", day, month, year);
	                    $scope.accountHolder.dateOfBirth = {
	                        day: day,
	                        month: month,
	                        year: year
	                    };
	                    $scope.accountHolder.workNumber = accountHolder.workNumber;
	                    $scope.accountHolder.homeNumber = accountHolder.homeNumber;
	                    $scope.accountHolder.cellNumber = accountHolder.cellNumber;
	                    //console.log("DateOfBirth: ",$scope.accountHolder.dateOfBirth);
	
	                    // Fill Policy Address
	                    $scope.submissionVm.draftData.policyAddress.addressLine1 = accountHolderAddress.addressLine1;
	                    $scope.submissionVm.draftData.policyAddress.addressLine2 = accountHolderAddress.addressLine2;
	                    $scope.submissionVm.draftData.policyAddress.addressLine3 = accountHolderAddress.addressLine3;
	                    $scope.submissionVM.draftData.policyAddress.state = accountHolderAddress.state;
	                    $scope.submissionVM.draftData.policyAddress.city = accountHolderAddress.city;
	
	                    $scope.submissionVM.draftData.accountHolder.primaryPhoneType = accountHolder.primaryPhoneType;
	                    var primaryPhType = $scope.submissionVM.draftData.accountHolder.primaryPhoneType;
	                    if (primaryPhType && primaryPhType.value.code === "mobile") {
	                        $scope.submissionVM.draftData.accountHolder.cellNumber = accountHolder.phoneNumber;
	                    } else if (primaryPhType && primaryPhType.value.code === "home") {
	                        $scope.submissionVM.draftData.accountHolder.homeNumber = accountHolder.phoneNumber;
	                    } else if (primaryPhType && primaryPhType.value.code === "work") {
	                        $scope.submissionVM.draftData.accountHolder.workNumber = accountHolder.phoneNumber;
	                    }
	                } else {
	                    $scope.accountHolder.accountExists = accountHolder.accountExists;
	                }
	
	                // Remove accountDetails object from rootscope
	                $rootScope.accountDetails = {
	                    accountHolder: {
	                        accountExists: false
	                    }
	                };
	            }
	        };
	        //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	        ctrl.checkDate = function () {
	            if ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && $scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800") {
	                $scope.isMinDateOfBirthValid = false;
	                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = '';
	            } else {
	                $scope.isMinDateOfBirthValid = true;
	            }
	        };
	        //DFCT0020397 - QnB Date Of Birth Validation ends
	
	        $scope.$watch('submissionVm.draftData.accountHolder.dateOfBirth.value', function () {
	            //console.log($scope.submissionVm.draftData.accountHolder.dateOfBirth.value);
	            // When coming from a Streamlined Quote, ensure the driver DOB is in sync with the Account Holder
	            if (angular.isDefined($scope.submissionVm.draftData.lobs.personalAuto)) {
	                var drivers = $scope.submissionVm.draftData.lobs.personalAuto.drivers;
	                if (drivers && drivers.length > 0) {
	                    var slqDriver = _.findWhere(drivers.value, { licenseNumber: '0streamlinedquote0' });
	                    if (angular.isDefined(slqDriver)) {
	                        slqDriver.dateOfBirth = angular.copy($scope.submissionVm.draftData.accountHolder.dateOfBirth.value);
	                    }
	                }
	            }
	        });
	
	        function validateInputs(inputsToValidate, scopeVar) {
	            var inputValidationData = [];
	            inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	            if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                for (var i = 0; i < inputValidationData[1].length; i++) {
	                    scopeVar[inputValidationData[1][i]] = '';
	                    $scope.isNameValid = false;
	                }
	            } else {
	                $scope.isNameValid = true;
	            }
	        }
	        //Added for Next button on Personal Information
	        //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
	        ctrl.displayDisclaimer = function (form) {
	
	            // Changes for incident INC0019053 begins
	
	            var currentDate = new Date();
	            var diffOfDaysForBackDate = moment(currentDate).startOf('day').diff(moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day'), 'days');
	            var submissionVM = submissionViewModel();
	            //ENHC0013007 -- Insurance Premium Refunds --Arpita
	            var inputsToValidate = [{ 'firstName': $scope.submissionVM.draftData.accountHolder.firstName.value }, { 'middleName': $scope.submissionVM.draftData.accountHolder.middleName.value }, { 'lastName': $scope.submissionVM.draftData.accountHolder.lastName.value }];
	            var primaryAddInput = [{ 'addressLine1': $scope.submissionVM.draftData.policyAddress.addressLine1.value }, { 'addressLine2': $scope.submissionVM.draftData.policyAddress.addressLine2.value }, { 'city': $scope.submissionVM.draftData.policyAddress.city.value }];
	            validateInputs(inputsToValidate, $scope.submissionVM.draftData.accountHolder.value);
	            if (!$scope.isNameValid) {
	                return;
	            }
	            validateInputs(primaryAddInput, $scope.submissionVM.draftData.policyAddress.value);
	            if (!$scope.isNameValid) {
	                return;
	            }
	            //ended
	
	            // Period Start Date should not be back date
	            if (diffOfDaysForBackDate >= 1) {
	                $scope.isPeriodStartDateValid = false;
	                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	
	            var diffOfDaysForFutureDate = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(currentDate).startOf('day'), 'days');
	            if (diffOfDaysForFutureDate > 30) {
	                submissionVM.draftData.lobs.value = {};
	                $scope.isPeriodStartDateValid = false;
	                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	
	            var policyEnqDate = new Date($scope.entryDate);
	            var diffOfDays = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(policyEnqDate).startOf('day'), 'days');
	
	            // Period Start Date should not be more than 30 days from date of quotation
	            if (diffOfDays > 30) {
	                $scope.isPeriodStartDateValid = false;
	                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	
	            // Changes for incident INC0019053 ends
	
	            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	            if ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && $scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800") {
	                $scope.isMinDateOfBirthValid = false;
	                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = '';
	                return;
	            }
	            //DFCT0020397 - QnB Date Of Birth Validation ends
	
	            var title = $filter('translate')('quoteandbind.ho.views.contact-details.informationdisclosure.heading');
	            var message = $filter('translate')('quoteandbind.ho.views.contact-details.informationdisclosure.static');
	            var continueModel = ModalService.showDisclaimer(title, message);
	            continueModel.result.then(function () {
	                ctrl.setNextState(form);
	            }, function () {});
	        };
	        ctrl.next = function (form) {
	            $scope.submissionVM.draftData.accountHolder.value.emailExist = true;
	            //eodb part2 quote default as member --Arpita Sengupta
	            if (!$scope.submissionVM.draftData.accountHolder.membershipNumber.value) {
	                $scope.submissionVM.draftData.accountHolder.quoteAsAAAMember.value = true;
	                $scope.submissionVM.draftData.accountHolder.isMember.value = false;
	            }
	            // ended
	            if ($scope.submissionVm.draftData.policyAddress.value.county == "NA") {
	                $scope.submissionVM.draftData.accountHolder.isAddressOverridden = true;
	            } else {
	                $scope.submissionVM.draftData.accountHolder.isAddressOverridden = false;
	            }
	            form.submitted = true;
	            if ($scope.submissionVM.draftData.accountHolder.value.emailAddress1 == undefined || $scope.submissionVM.draftData.accountHolder.value.emailAddress1 == '') {
	                return false;
	            }
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	        ctrl.setNextState = function (form) {
	
	            /*if(!$scope.accountHolder.accountExists){
	                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "home";
	            }else{
	                //Added for the defect DE1321
	                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = $scope.accountHolder.primaryPhoneType;
	                $scope.submissionVM.draftData.accountHolder.cellNumber = $scope.accountCellNumber;
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHomeNumber;
	                $scope.submissionVM.draftData.accountHolder.workNumber = $scope.accountWorkNumber;
	            }*/
	            //console.log("inside HO next State: ",$scope.submissionVM.draftData)
	            //console.log("Printing inside Contact details222", $scope.questionSets)
	            //This is hardcoded to Oregon
	            //$scope.submissionVM.draftData.policyAddress.county = "OR";
	            //console.log("Scope Address", $scope.address)
	            //console.log("Print Form ", form)
	            // console.log("Print Form valid", form.valid)
	
	            form.submitted = true;
	
	            if (!form.valid) {
	                //console.log("Invalid form inside HO next State")
	                return;
	            } else {
	                // $scope.saveQuote();
	                ctrl.next(form);
	            }
	        };
	        //ENHC0011961 - adding membership attention message ---Arpita Sengupta
	        ctrl.showMemberWarning = function () {
	
	            if (null != $scope.membershipDetails.membershipNumber && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length != 16) {
	
	                ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.controllers.MembershipCtrl.AttentionMessage');
	            }
	        };
	        //ENHC0011961 - checking validation for Membership number - Arpita Sengupta
	        ctrl.checkMembershipNum = function () {
	            if ($scope.membershipDetails.membershipNumber != null && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length == '16') {
	
	                var membershipPromise = MembershipService.isMember('quoteandbind', $scope.membershipDetails);
	                ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);
	
	                membershipPromise.then(function (membershipResp) {
	
	                    if (membershipResp[0].membershipStatus && membershipResp[0].firstName && membershipResp[0].lastName) {
	                        $scope.accountHolder.membershipNumber = membershipResp[0].membershipNumber;
	                        $scope.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
	                        $scope.accountHolder.membershipType = membershipResp[0].serviceLevel;
	                        $scope.accountHolder.membershipStatus = membershipResp[0].membershipStatus;
	                        $scope.accountHolder.firstName = membershipResp[0].firstName;
	                        $scope.accountHolder.lastName = membershipResp[0].lastName;
	                        $scope.accountHolder.Address1 = membershipResp[0].Address1 ? membershipResp[0].Address1 : '';
	                        $scope.accountHolder.Email = membershipResp[0].Email ? membershipResp[0].Email : '';
	                        $scope.accountHolder.PhoneNumber = membershipResp[0].PhoneNumber ? membershipResp[0].PhoneNumber : '';
	                    }
	                    $scope.accountHolder.isMember = true;
	                }).catch(function () {
	                    personalDetailsUpdate();
	                    var errorPromise = ModalService.showError('quoteandbind.controllers.MembershipCtrl.Error', 'quoteandbind.controllers.MembershipCtrl.PC system down error');
	                });
	            } else {
	                personalDetailsUpdate();
	            }
	            //ended
	        };
	        var personalDetailsUpdate = function personalDetailsUpdate() {
	            ['membershipNumber', 'joinedYear', 'membershipType', 'membershipStatus', 'firstName', 'lastName', 'Address1', 'Email', 'PhoneNumber'].forEach(function (accountHolderData) {
	                return delete $scope.accountHolder[accountHolderData];
	            });
	        };
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$state', '$rootScope', '$filter', 'ModalService', 'AgeAllowedToDrive', 'submissionViewModel', 'StateUtils', 'LocaleService', 'MembershipService', 'qnb.InputValidationService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 367 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.contact-details.Your Information' |\n        translate }}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <!-- ENHC0013007 -- Insurance Premium Refunds --Arpita -->\n        <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\n            <div  class=\"custom-error\">\n                {{'quoteandbind.views.Name OR Address Value May Not Be Formatted Correctly' | translate}}\n            </div>\n        </div>\n        <!-- ended -->\n        <!-- ENHC0011961 added mebership number field --Arpita Sengupta -->\n        <div class=\"gw-control-group\">\n            <label class=\"gw-control-label\">{{'quoteandbind.views.Membership.Number' | translate}}\n                <span class=\"aaa-inline-info-wrapper\">\n                <div class=\"aaa-inline-info\">   {{'quoteandbind.views.membership.number.Tooltip' | translate }}</div>\n                <i class=\"fa fa-info-circle\"></i>\n             </span>\n            </label>\n\n            <div class=\"gw-controls\">\n                <input type=\"text\"\n                    onkeypress='return (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || ( event.charCode >= 48 && event.charCode <= 57))'\n                    ng-model=\"membershipDetails.membershipNumber\"\n                    maxlength=\"16\"\n                    name=\"memberNumber\"\n                    placeholder=\"{{'quoteandbind.views.membership.placeholder' | translate }}\"\n                    ng-blur=\"showMemberWarning()\"\n                    ng-keyup=\"checkMembershipNum()\"/>\n            </div>\n        </div>\n        <!-- ended -->\n        <div>\n            <div>\n                <div gw-pl-name-details contact=\"submissionVm.draftData.accountHolder\" readonly=\"false\"\n                ></div>\n            </div>\n\n            <div>\n                <div gw-pl-ctrl-group model=\"submissionVm.draftData.accountHolder.dateOfBirth\"\n                     label=\"{{'quoteandbind.views.contact-details.Date of Birth' | translate}}\">\n                    <!-- DFCT0020397 - QnB Date Of Birth Validation - added min date,method on blur and keyup -Arpita -->\n                    <span gw-pl-local-date-chooser\n                          model=\"submissionVm.draftData.accountHolder.dateOfBirth.value\"\n                          max-date=\"maxDateOfBirth\" initial-date=\"maxDateOfBirth\" min-date=\"minDob\" ng-keyup=\"checkDate()\"></span>\n                </div>\n                <!-- DFCT0020397 - QnB Date Of Birth Validation  - added error msg-->\n                <div  class=\"custom-error\" ng-show=\"!isMinDateOfBirthValid\">\n                    {{'quoteandbind.views.contact-details.Date of Birth must be no earlier than 01/01/1800' | translate}}\n                </div>\n                <!-- ended -->\n            </div>\n\n            <!--ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024 -->\n            <gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.occupation\"\n                      filter-codes=\"occupationFilterCodes\"\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Occupation' | translate }}\"\n                      placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Occupation--' | translate }}\">\n            </gw-pl-input-ctrl>\n            <div gw-pl-ctrl-group\n                model=\"submissionVM.draftData.accountHolder.payGrade\"\n                ng-show=\"submissionVM.draftData.accountHolder.occupation.value.code == 'military'\"\n                label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Whats your pay grade?' | translate}}\">\n                <select gw-pl-select=\"submissionVM.draftData.accountHolder.payGrade.value\" options=\"submissionVM.draftData.accountHolder.payGrade.aspects.availableValues\"\n                        render-by=\"'name'\"\n                        placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Pay Grade--' | translate}}\"></select>\n            </div>\n\n            <div gw-pl-standard-address address=\"submissionVM.draftData.policyAddress\"></div>\n\n            <div ng-if=\"submissionVM.draftData.accountHolder.primaryPhoneType.value.code ==='work'\">\n                <div gw-pl-ctrl-group model=\"submissionVm.draftData.accountHolder.workNumber\"\n                     label=\"{{'quoteandbind.views.contact-details.Telephone Number'|translate}}\">\n                    <input type=\"text\"\n                           ng-model=\"submissionVm.draftData.accountHolder.workNumber.value\"\n                           gw-pl-ui-mask=\"{{phoneMask}}\"\n                           leave-value-masked/>\n                </div>\n            </div>\n            <div ng-if=\"submissionVM.draftData.accountHolder.primaryPhoneType.value.code ==='mobile'\">\n                <div gw-pl-ctrl-group model=\"submissionVm.draftData.accountHolder.cellNumber\"\n                     label=\"{{'quoteandbind.views.contact-details.Telephone Number'|translate}}\">\n                    <input type=\"text\"\n                           ng-model=\"submissionVm.draftData.accountHolder.cellNumber.value\"\n                           gw-pl-ui-mask=\"{{phoneMask}}\"\n                           leave-value-masked/>\n                </div>\n            </div>\n            <div ng-if=\"submissionVM.draftData.accountHolder.primaryPhoneType.value.code ==='home'\">\n                <div gw-pl-ctrl-group model=\"submissionVm.draftData.accountHolder.homeNumber\"\n                     label=\"{{'quoteandbind.views.contact-details.Telephone Number'|translate}}\">\n                    <input type=\"text\"\n                           ng-model=\"submissionVm.draftData.accountHolder.homeNumber.value\"\n                           gw-pl-ui-mask=\"{{phoneMask}}\"\n                           leave-value-masked/>\n                </div>\n            </div>\n            <!--<gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.workNumber\" label=\"{{'quoteandbind.views.contact-details.Telephone Number'| translate }}\" ng-attr-maxlength=\"10\"></gw-pl-input-ctrl>-->\n            <gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.emailAddress1\" ng-attr-maxlength=\"50\"\n                              label=\"{{'quoteandbind.views.contact-details.Email Address' | translate }}\"></gw-pl-input-ctrl>\n            <span class=\"custom-error\"\n                  ng-show=\"form.submitted && submissionVM.draftData.accountHolder.emailExist.value === undefined\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n        </div>\n\n        <!-- Add static text for DNC waiver consent, AB 09/29/2022 -->\n        <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.contact-details.DNC Waiver Consent'|translate}}\n            </p>\n        </div>\n\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.views.contact-details.For Your Quote' | translate }}</h2>\n\n        <div>\n            <div gw-pl-ctrl-group model=\"submissionVM.draftData.periodStartDate\"\n                 label=\"{{'quoteandbind.views.contact-details.I\\'d like my coverage to start on' | translate }}\">\n                <span ng-datepicker\n                    default-date=\"today\"\n                    min-view=\"day\"\n                    max-date=\"coverageStartDt\"\n                    input-id=\"PeriodStartDate\"\n                    name=\"PeriodStartDate\"\n                    min-date=\"today\"\n                    ng-model=\"submissionVM.draftData.periodStartDate.value\"></span>\n        \n            </div>\n            <div  class=\"custom-error\" ng-show=\"!isPeriodStartDateValid\">\n                {{'quoteandbind.views.policy-date.Policy Effective date should be today or up to 30 days in the future.'|translate}}\n            </div>\n        </div>\n        <!-- *Princy Captcha -->\n        <!-- <div class=\"g-recaptcha\" data-sitekey=\"6LdAMu0iAAAAAC7nQoCER8uhlvGQzTY-104vOiNA\">Captcha</div> -->\n\n            <!-- <div vc-recaptcha key='6LdAMu0iAAAAAC7nQoCER8uhlvGQzTY-104vOiNA'>here</div> -->\n\n\n\n        <!-- <div class=\"g-recaptcha\" data-sitekey=\"6LdAMu0iAAAAAC7nQoCER8uhlvGQzTY-104vOiNA\">\n        </div> -->\n\n        <div class=\"yourInfo-static\">\n            <div class=\"yourInfo-static-message\">\n                <!--<h4>{{'quoteandbind.pa.views.contact-details.disclaimer.heading'|translate}}</h4>-->\n                <p>\n                    {{'quoteandbind.pa.views.contact-details.disclaimer.static'|translate}}\n                </p>\n                <p></p>\n                <p>\n                    {{'quoteandbind.pa.views.contact-details.disclaimer.static.TCPA'|translate}}\n                </p>\n            </div>\n        </div>\n\n        <div class=\"gw-page-buttons\">\n            <button class=\"gw-btn\" ng-click=\"goToCancel(form)\">{{'platform.widgets.wizard.Cancel'| translate }}</button>\n            <button class=\"gw-btn-primary\" ng-disabled=\"gwPlWizard.requestInFlight\"\n                    ng-click=\"displayDisclaimer(form)\">{{'platform.widgets.wizard.Next'| translate }}\n            </button>\n\n        </div>\n\n    </ng-form>\n</div>\n"

/***/ },
/* 368 */
/***/ function(module, exports) {

	module.exports = "<div class=\"membership-page\">\r\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.Membership' | translate }}</h2>\r\n    <form novalidate name=\"form\">\r\n<!--\r\n    CHG0031104 - Add OMEGA QnB link to SECU’s website\r\n    AB - April 05, 2020 -->\r\n\r\n        <div class=\"gw-control-group\">\r\n            <div ng-switch=\"GetQnBSource()\">\r\n                <div ng-switch-when=\"SECU\">\r\n                    <span class=\"gw-control-label\"> {{'quoteandbind.views.membership.Are you a credit union member?' | translate}}</span>\r\n                    <div gw-pl-radios-binary\r\n                         title1=\"{{'quoteandbind.views.Membership.radio.yes' | translate}}\"\r\n                         title2=\"{{'quoteandbind.views.Membership.radio.no' | translate}}\">\r\n\r\n                        <input type=\"radio\"\r\n                               id=\"YesCreditUnionMember\"\r\n                               data-ng-value=\"true\"\r\n                               ng-model=\"accountHolder.isCreditUnionMember\"/>\r\n                        <input  type=\"radio\"\r\n                                id=\"NoCreditUnionMember\"\r\n                                data-ng-value=\"false\"\r\n                                ng-model=\"accountHolder.isCreditUnionMember\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"gw-control-group\" ng-show = \"accountHolder.isCreditUnionMember\">\r\n            <span class=\"gw-control-label\"> {{'quoteandbind.views.Membership.Please enter the year you joined:' | translate }}</span>\r\n            <div gw-control-group class=\"year-joined-align\" >\r\n                <input  type=\"text\"\r\n                        maxlength=\"4\"\r\n                        ng-model=\"accountHolder.joinedYearCreditUnionMembership\"/>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- End of CHG0031104 changes -->\r\n\r\n        <!-- ENHC0011961  commented below div from membership page and added in contact info page -- Arpita Sengupta -->\r\n        <div class=\"gw-control-group\" ng-show=\"productCode=='Homeowners'\">\r\n            <label class=\"gw-control-label\">{{'quoteandbind.views.Membership.Number' | translate}}\r\n                <span class=\"aaa-inline-info-wrapper\">\r\n                <div class=\"aaa-inline-info\">   {{'quoteandbind.views.membership.number.Tooltip' | translate }}</div>\r\n                <i class=\"fa fa-info-circle\"></i>\r\n             </span>\r\n            </label>\r\n\r\n            <div class=\"gw-controls\">\r\n                <input type=\"text\"\r\n                       onkeypress='return (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || ( event.charCode >= 48 && event.charCode <= 57))'\r\n                       ng-model=\"membershipDetails.membershipNumber\"\r\n                       maxlength=\"16\"\r\n                       name=\"memberNumber\"\r\n                       placeholder=\"{{'quoteandbind.views.membership.placeholder' | translate }}\"\r\n                       ng-blur=\"showMemberWarning()\"\r\n                />\r\n            </div>\r\n        </div>\r\n        <!-- ended -->\r\n        <br/>\r\n        <br/>\r\n        <div>\r\n            <span class=\"membership-labels\"> {{'quoteandbind.views.Membership.Do you have any other products with us?' | translate}}</span>\r\n            <div gw-pl-radios-binary\r\n                 title1=\"{{'quoteandbind.views.Membership.radio.yes' | translate}}\"\r\n                 title2=\"{{'quoteandbind.views.Membership.radio.no' | translate}}\">\r\n                <input type=\"radio\"\r\n                       name=\"answer\"\r\n                       id=\"YesAnswer\"\r\n                       ng-model=\"Answer\"\r\n                       value=\"true\"\r\n                       />\r\n                <input  type=\"radio\"\r\n                        name=\"answer\"\r\n                        id=\"NoAnswer\"\r\n                        value=\"false\"\r\n                        ng-model=\"Answer\"/>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <!--<div ng-if=\"productCode=='Homeowners'\" gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.views.Membership.Do you have any other products with us?' | translate }}\"\r\n             model=\"HOView.otherPolicies\" name=\"otherPoliciesHO\">\r\n        </div>\r\n        <div ng-if=\"productCode=='PersonalAuto'\" gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.views.Membership.Do you have any other products with us?' | translate }}\"\r\n             model=\"PAView.otherPolicies\" name=\"otherPolicies\">\r\n        </div>-->\r\n        <br/>\r\n        <div class=\"product-check-box container\" ng-if=\"Answer == 'true' &&  productCode=='Homeowners' \">\r\n            <div class=\"product-info\">{{'quoteandbind.views.Membership.Please select the Products you have:'| translate}}</div><br/>\r\n            <div> <input type=\"checkbox\" name=\"product\" value=\"auto\" ng-model=\"otherProducts.personalAuto\"/>\r\n                <span class=\"row-data\">{{'quoteandbind.views.Membership.auto' | translate}}</span> <br/><br/></div>\r\n            <input type=\"checkbox\" name=\"product\" value=\"fire\" ng-model=\"otherProducts.fire\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Dwellling Fire' | translate}}</span> <br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"flood\" ng-model=\"otherProducts.flood\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Flood'| translate}}</span> <br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"life\" ng-model=\"otherProducts.life\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Life' | translate}}</span><br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"umbrella\" ng-model=\"otherProducts.umbrella\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Personal Umbrella' | translate}}</span><br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"watercraft\" ng-model=\"otherProducts.watercraft\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Watercraft' | translate}}</span><br/><br/>\r\n        </div>\r\n        <div class=\"product-check-box container\" ng-if=\"Answer == 'true' &&  productCode=='PersonalAuto' \">\r\n            <div class=\"product-info\">{{'quoteandbind.views.Membership.Please select the Products you have:'| translate}}</div><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"home\" ng-model=\"otherProducts.homeOwners\" />\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.home' | translate}}</span> <br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"fire\" ng-model=\"otherProducts.fire\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Dwellling Fire' | translate}}</span> <br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"flood\" ng-model=\"otherProducts.flood\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Flood'| translate}}</span> <br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"life\" ng-model=\"otherProducts.life\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Life' | translate}}</span><br/><br/>\r\n            <input type=\"checkbox\" name=\"product\" value=\"umbrella\" ng-model=\"otherProducts.umbrella\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Personal Umbrella' | translate}}</span><br/><br/>\r\n            <div><input type=\"checkbox\" name=\"product\" value=\"renters\" ng-model=\"otherProducts.renters\" />\r\n                <span class=\"row-data\">{{'quoteandbind.views.Membership.rent' | translate}}</span><br/><br/></div>\r\n            <input type=\"checkbox\" name=\"product\" value=\"watercraft\" ng-model=\"otherProducts.watercraft\"/>\r\n            <span class=\"row-data\">{{'quoteandbind.views.Membership.Watercraft' | translate}}</span><br/><br/>\r\n        </div>\r\n        <br/>\r\n\r\n        <!-- PLACEHOLDER FOR PAYMENT OPTION\r\n\r\n        <div gw-pl-ctrl-group model=\"policyInfoPaymentMethod\"\r\n             label=\"{{'quoteandbind.views.payment-details.Payment Method'| translate}}\">\r\n            <select gw-pl-select=\"policyInfoPaymentMethod.value\"\r\n                    options=\"policyInfoPaymentMethodOptions\" render-by=\"'name'\"\r\n                    placeholder=\"{{'quoteandbind.views.payment-details.Choose Payment Method'|translate}}\">\r\n            </select>\r\n            <span class=\"custom-error\" ng-show=\"form.submitted && !policyInfoPaymentMethod.value\">\r\n                {{'quoteandbind.views.payment-details.A selected response is needed'|translate}}\r\n            </span>\r\n        </div> -->\r\n        <!-- PLACEHOLDER FOR Document Delivery -->\r\n\r\n        <!--<div gw-pl-ctrl-group model=\"policyInfoDocumentDeliveryMethod\"\r\n             label=\"{{'quoteandbind.views.payment-details.Document Delivery'| translate}}\">\r\n            <select gw-pl-select=\"policyInfoDocumentDeliveryMethod.value\"\r\n                    options=\"policyInfoDocumentDeliveryOptions\" render-by=\"'name'\"\r\n                     placeholder=\"{{'quoteandbind.views.payment-details.Choose Document Delivery'|translate}}\">\r\n            </select>\r\n            <span class=\"custom-error\" ng-show=\"form.submitted && !policyInfoDocumentDeliveryMethod.value\">\r\n                {{'quoteandbind.views.payment-details.A selected response is needed'|translate}}\r\n            </span>\r\n        </div> -->\r\n\r\n        <br/>\r\n\r\n\r\n        <div class=\"member-info\">\r\n            {{'quoteandbind.views.Membership.MemberInfo'| translate}}<a target=\"_blank\" ng-href=\"{{'quoteandbind.views.Membership.membershipLink'| translate}}\"><b>{{'quoteandbind.views.Membership.MemberInfo.here' | translate}}</b></a>{{'quoteandbind.views.Membership.MemberInfo.enroll'| translate}}\r\n            <br/>\r\n            <br/>\r\n        </div>\r\n        <div class=\"yourInfo-static\">\r\n            <div class=\"yourInfo-static-message\">\r\n                <!--<h4>{{'quoteandbind.pa.views.contact-details.disclaimer.heading'|translate}}</h4>-->\r\n                <p>\r\n                    {{'quoteandbind.pa.views.contact-details.disclaimer.static'|translate}}\r\n                </p>\r\n                <p></p>\r\n                <p>\r\n                    {{'quoteandbind.pa.views.contact-details.disclaimer.static.TCPA'|translate}}\r\n                </p>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n    </form>\r\n\r\n    <!--<div gw-wizard-page-actions next=\"next\"></div>-->\r\n    <div class=\"gw-page-buttons\">\r\n        <button class=\"gw-btn\" type=\"button\"\r\n                ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n        </button>\r\n        <!--\r\n        Commented for consistencey\r\n        <button class=\"gw-btn\" type=\"button\"\r\n                 ng-click=\"previous()\">{{'platform.widgets.wizard.Previous'|translate}}\r\n         </button> -->\r\n        <button class=\"gw-btn-primary\" next-button\r\n                ng-click=\"membership(form)\">{{'platform.widgets.wizard.Next' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n</div>\r\n"

/***/ },
/* 369 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <form novalidate name=\"form\">\r\n        <h3 class=\"gw-prefill-title-label\" ng-if=\"page.drivers.length > 0\">{{'quoteandbind.pa.views.prefill.To save you time' | translate}}</h3>\r\n        <div ng-if=\"page.drivers.length > 0\">\r\n            <h2 class=\"gw-page-section-title gw-as-page-title gw-prefill-header-label\">\r\n                {{'quoteandbind.pa.views.prefill.DriversFoundInYourHousehold' | translate}}</h2>\r\n            <div class=\"gw-prefill-subheader-label\">{{'quoteandbind.pa.views.prefill.OpportunityToAddDriverLater' |\r\n                translate}}\r\n            </div>\r\n            <section class=\"gw-driver-prefill-page\">\r\n                <div class=\"gw-driver-prefill-box-wrapper\">\r\n                    <section class=\"gw-driver-prefill-box\">\r\n                        <section class=\"gw-driver-prefill-inner\">\r\n                            <div class=\"gw-driver-prefill-area\">\r\n                                <div class=\"gw-driver-prefill-forms\">\r\n                                    <div class=\"gw-driver-prefill-form\" data-ng-repeat=\"driver in  page.drivers\">\r\n                                        <div class=\"gw-driver-prefill-header\">\r\n                                            <i class=\"fa fa-user\" style=\"font-size:50px\" aria-hidden=\"true\"></i>\r\n                                        </div>\r\n                                        <div class=\"gw-driver-detail-prefill-label\">\r\n                                            {{driver.person.firstName}}\r\n                                            {{driver.person.middleName}}\r\n                                            {{driver.person.lastName}}\r\n                                            <br/>\r\n                                            Age {{getAge(driver)}}\r\n                                            \r\n                                        </div>\r\n                                        <div ng-if=\"driver.person.accountHolder\"\r\n                                             class=\"gw-driver-policyStatus-prefill-label\">\r\n                                            Policy Holder\r\n                                        </div>\r\n                                        <div ng-if=\"!driver.person.accountHolder\" class=\"gw-driver-action\">\r\n                                            <button class=\"gw-btn-primary remove-button\" type=\"submit\"\r\n                                                    ng-click=\"removeDriver($index)\" tabindex=\"0\">\r\n                                                <b class=\"ng-binding\">Remove</b>\r\n                                            </button>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </section>\r\n                    </section>\r\n                </div>\r\n            </section>\r\n        </div>\r\n        <div ng-if=\"page.vehicles.length > 0\">\r\n            <h2 class=\"gw-page-section-title gw-as-page-title gw-prefill-header-label\">\r\n                {{'quoteandbind.pa.views.prefill.VehiclesFoundInYourHousehold' | translate}}</h2>\r\n            <div class=\"gw-prefill-subheader-label\">{{'quoteandbind.pa.views.prefill.OpportunityToAddVehiclesLater' |\r\n                translate}}\r\n            </div>\r\n            <section class=\"gw-driver-prefill-page\">\r\n                <div class=\"gw-driver-prefill-box-wrapper\">\r\n                    <section class=\"gw-driver-prefill-box\">\r\n                        <section class=\"gw-driver-prefill-inner\">\r\n                            <div class=\"gw-driver-prefill-area\">\r\n                                <div class=\"gw-driver-prefill-forms\">\r\n                                    <div class=\"gw-driver-prefill-form\" data-ng-repeat=\"vehicle in  page.vehicles\">\r\n                                        <div class=\"gw-driver-prefill-header\">\r\n                                            <i class=\"fa fa-3x fa-automobile\"></i>\r\n                                        </div>\r\n                                        <div class=\"gw-vehicle-make-prefill-label\">\r\n                                            {{vehicle.year}}\r\n                                            {{vehicle.make}}\r\n                                        </div>\r\n                                        <div class=\"gw-driver-policyStatus-prefill-label\">\r\n                                            {{vehicle.model}}\r\n                                            <!--  //{{vehicle.trim}}-->\r\n                                        </div>\r\n                                        <button class=\"gw-btn-primary remove-button\" type=\"submit\"\r\n                                                ng-click=\"removeVehicle($index)\" tabindex=\"0\">\r\n                                            <b class=\"ng-binding\">Remove</b>\r\n                                        </button>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </section>\r\n                    </section>\r\n                </div>\r\n            </section>\r\n        </div>\r\n        <!--<div gw-wizard-page-actions next=\"next\"></div>-->\r\n        <div class=\"gw-page-buttons\" ng-if=\"page.vehicles.length > 0 || page.drivers.length > 0\">\r\n            <button class=\"gw-btn\" type=\"button\"\r\n                    ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n            </button>\r\n\r\n            <button class=\"gw-btn-primary\" next-button\r\n                    ng-click=\"continueAction(form)\">{{'platform.widgets.wizard.Next' | translate}}\r\n            </button>\r\n        </div>\r\n    </form>\r\n</div>\r\n"

/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n<ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\"  novalidate name=\"form\">\r\n\r\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.pa.views.PrevCarrierInfo' | translate }}</h2>\r\n\r\n        <div gw-pl-ctrl-group model=\"prevCarrierInfo.portalStatus\"\r\n             label=\"{{'quoteandbind.pa.views.prevCarrierInfo.policyStatus' | translate}}\">\r\n            <select ng-model=\"prevCarrierInfo.portalStatus.value\"\r\n                    ng-options=\"k as v for (k, v) in policyStatusValue\"\r\n                    >\r\n                <option value=\"\" >--Choose Insurance Policy Status--</option>\r\n            </select>\r\n        </div>\r\n\r\n        <!--<gw-pl-input-ctrl model=\"prevCarrierInfo.policyStatus\"-->\r\n                          <!--label=\"{{'quoteandbind.pa.views.prevCarrierInfo.policyStatus' | translate }}\"-->\r\n                          <!--placeholder=\"&#45;&#45;Choose Insurance Policy Status&#45;&#45;\"  >-->\r\n        <!--</gw-pl-input-ctrl>-->\r\n\r\n        <!--<gw-pl-input-ctrl ng-if=\"prevCarrierInfo.portalStatus.value == 'I have Insurance' || prevCarrierInfo.portalStatus.value == 'My Insurance cancelled or expired'\"\r\n                          model=\"prevCarrierInfo.insuranceCarriers\"\r\n                          label=\"{{'quoteandbind.pa.views.prevCarrierInfo.insuranceCarriers' | translate }}\"\r\n                          placeholder=\"--Choose Insurance Carrier--\" >\r\n        </gw-pl-input-ctrl>-->\r\n        \r\n        <div ng-if=\"prevCarrierInfo.portalStatus.value == 'I have Insurance' || prevCarrierInfo.portalStatus.value == 'My Insurance cancelled or expired'\">\r\n            <div gw-pl-ctrl-group model=\"prevCarrierInfo.insuranceCarriers\" readonly=\"readonly\"\r\n                 label=\"{{'quoteandbind.pa.views.prevCarrierInfo.insuranceCarriers'|translate}}\" >\r\n                <select gw-pl-select=\"prevCarrierInfo.insuranceCarriers.value\"\r\n                        options=\"insuranceCarriers\" \r\n                        render-by=\"'name'\"\r\n                        placeholder=\"{{'--Choose Insurance Carrier--'|translate}}\"\r\n                        ></select>\r\n            </div>\r\n        </div>\r\n\r\n        <gw-pl-input-ctrl ng-if=\"prevCarrierInfo.portalStatus.value == 'I have Insurance' || prevCarrierInfo.portalStatus.value == 'My Insurance cancelled or expired'\"\r\n                          model=\"prevCarrierInfo.priorBILimits\"\r\n                          label=\"{{'quoteandbind.pa.views.prevCarrierInfo.priorBILimits' | translate }}\"\r\n                          help-tip=\"{{'quoteandbind.pa.views.prevCarrierInfo.priorBILimits Tooltip' | translate }}\"\r\n                          placeholder=\"--Choose Bodily Injury Limits--\" >\r\n        </gw-pl-input-ctrl>     \r\n\r\n\r\n        <div gw-pl-ctrl-group ng-if=\"prevCarrierInfo.portalStatus.value == 'My Insurance cancelled or expired'\"\r\n             model=\"prevCarrierInfo.expirationDate\"\r\n             help-tip=\"{{'quoteandbind.pa.views.prevCarrierInfo.expirationDate Tooltip' | translate }}\"\r\n             label=\"{{'quoteandbind.pa.views.prevCarrierInfo.expirationDate' | translate }}\">\r\n                <span ng-datepicker\r\n                      default-date=\"today\"\r\n                      min-view=\"day\"\r\n                      input-id=\"expirationDate\"\r\n                      name=\"expirationDate\"\r\n                      ng-model=\"prevCarrierInfo.expirationDate.value\"></span>\r\n        </div>\r\n\r\n    <!--<div gw-wizard-page-actions next=\"next\"></div>-->\r\n\r\n    <div class=\"gw-page-buttons\">\r\n        <button class=\"gw-btn\" type=\"button\"\r\n                ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n        </button>\r\n        <button class=\"gw-btn-primary\" next-button\r\n                ng-click=\"next(form)\">{{'platform.widgets.wizard.Next' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n    </ng-form>\r\n\r\n</div>\r\n"

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = "<div class=\"driver-wrap\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.pa.views.pa-driver-details.Drivers' | translate}}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <table at-table list=\"page.drivers\" class=\"gw-table drivers\" id=\"driversTable\" ng-show=\"page.drivers.length > 1\">\n            <thead class=\"nopointer\">\n            </thead>\n            <tbody>\n            <tr ng-init=\"index=$index\" ng-click=\"editDriver(item, form, index)\"\n                ng-class=\"index==selectedRow||item == page.currentDriver.value?'grid-selected-row':'grid-not-selected-row'\"\n                >\n                <td title=\"{{'quoteandbind.pa.views.pa-driver-details.Name' | translate}}\"\n                    attribute=\"\">{{item.getDisplayName(undefined, $filter)}}\n                </td>\n                <!--commenting out License Number tag no longer needed as part of Data Prefill enhancement *Princy -->\n                <!-- <td title=\"{{'quoteandbind.pa.views.pa-driver-details.License Number' | translate}}\" at-implicit\n                    attribute=\"licenseNumber\"></td> -->\n                <td title=\"{{'quoteandbind.pa.views.pa-driver-details.License Year' | translate}}\" at-implicit\n                    attribute=\"yearLicensed\"></td>\n                <!--commenting out License State tag no longer needed as part of Data Prefill enhancement *Princy -->\n                 <!-- <td title=\"{{'quoteandbind.pa.views.pa-driver-details.License State' | translate}}\" at-implicit\n                    attribute=\"licenseState\"></td>  -->\n                <td>\n                    <button type=\"button\" class=\"gw-btn gw-btn-primary\" ng-disabled=\"item == page.currentDriver.value\"\n                            ng-click=\"editDriver(item, form, index)\">\n                        {{'quoteandbind.pa.views.pa-driver-details.edit-button' | translate}}\n                    </button>\n                    <button class=\"gw-btn\" ng-show=\"!item.person.accountHolder\" type=\"button\" ng-click=\"removeDriver(item)\">\n                        {{'quoteandbind.pa.views.pa-driver-details.delete-button' | translate}}\n                    </button>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <h2 ng-show=\"page.drivers.length > 1\" class=\"gw-page-section-title gw-as-page-title\">\n            {{'quoteandbind.pa.views.pa-driver-details.Driver-Information' | translate}}</h2>\n            <!-- ENHC0013007 -- Insurance Premium Refunds --Arpita -->\n            <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\n                <div  class=\"custom-error\">\n                    {{'quoteandbind.pa.views.pa-driver-details.Name OR Address Value May Not Be Formatted Correctly' | translate}}\n                </div>\n            </div>\n            <!-- ended -->\n        <div gw-qnb-pa-edit-driver driver=\"page.currentDriver\" prefill-vehicles=\"page.prefillVehicles\" vehicles=\"page.vehicles\"></div>\n\n        <div class=\"gw-page-buttons\">           \n            <span ng-hide=true>{{'quoteandbind.pa.views.pa-driver-details.Will there be additional drivers named on the policy?' | translate}}</span>\n            <!--<button class=\"gw-btn\" type=\"button\" ng-click=\"previous()\">\n                {{'platform.widgets.wizard.Previous'|translate}}\n            </button>-->\n            <div class=\"add-driver-button-wrapper\">\n                <button class=\"gw-btn gw-pull-left pa-add-driver-vehicle-button\" type=\"button\" ng-click=\"addDriver(form)\">\n                    <span class=\"gw-icon fa fa-plus\"></span>\n                    {{'quoteandbind.pa.views.pa-driver-details.Add Driver' | translate}}\n                </button>\n            </div>\n            <div class=\"next-cancel-button-wrapper\">\n                <button class=\"gw-btn driver-cancel-button\" type=\"button\" ng-click=\"cancel()\">\n                    {{'platform.widgets.wizard.Cancel'|translate}}\n                </button>\n                <button class=\"gw-btn-primary driver-next-button\" next-button ng-click=\"next(form)\">\n                    {{'quoteandbind.pa.views.pa-driver-details.Next' | translate}}\n                </button>\n\n            </div>\n\n        </div>\n        \n        <div>\n            <br><br><br><br><br><br><br>\n        </div>\n    </ng-form>\n</div>\n"

/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports = "<div class=\"vehicle-details-wrap\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.pa.views.pa-vehicle-details.Vehicles' |\n        translate}}</h2>\n\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <!-- ENHC0013007 -- Insurance Premium Refunds --Arpita -->\n        <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\n            <div  class=\"custom-error\">\n                {{'quoteandbind.views.Name OR Address Value May Not Be Formatted Correctly' | translate}}\n            </div>\n        </div>\n        <!-- ended -->\n        <div ng-show=\"vehicles.length > 1\">\n            <table at-table list=\"vehicles\" class=\"gw-table vehicles\" id=\"vehiclesTable\">\n                <thead class=\"nopointer\"></thead>\n                <tbody>\n                <tr ng-init=\"index=$index\" ng-click=\"editVehicle(item, form, index)\"\n                    ng-class=\"index==selectedRow||item == page.selectedVehicle.value?'grid-selected-row':'grid-not-selected-row'\">\n                    <!--<td title=\"{{'quoteandbind.pa.views.pa-vehicle-details.License Plate' | translate}}\" at-implicit\n                        attribute=\"license\"></td>-->\n                    <td title=\"{{'quoteandbind.pa.views.pa-vehicle-details.Year' | translate}}\" at-implicit\n                        attribute=\"year\"></td>\n                    <td title=\"{{'quoteandbind.pa.views.pa-vehicle-details.Make' | translate}}\" at-implicit\n                        attribute=\"make\"></td>\n                    <td title=\"{{'quoteandbind.pa.views.pa-vehicle-details.Model' | translate}}\" at-implicit\n                        attribute=\"model\"></td>\n                    <td>\n                        <button type=\"button\" class=\"gw-btn gw-btn-primary\"\n                                ng-disabled=\"item == page.selectedVehicle.value\"\n                                ng-click=\"editVehicle(item, form, index)\">\n                            {{'quoteandbind.pa.views.pa-vehicle-details.edit-button' | translate}}\n                        </button>\n                        <button type=\"button\" class=\"gw-btn\" ng-disabled=\"vehicles.length === 1\"\n                                ng-click=\"removeVehicle(item)\">\n                            {{'quoteandbind.pa.views.pa-vehicle-details.delete-button' | translate}}\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <h2 ng-show=\"vehicles.length > 1\" class=\"gw-page-section-title gw-as-page-title\">\n            {{'quoteandbind.pa.views.pa-vehicle-details.Vehicle-Information' | translate}}</h2>\n\n        <div gw-qnb-pa-edit-vehicle \n             readonly=\"page.readonly\" \n             vehicle=\"page.selectedVehicle\" \n             drivers=\"drivers\" \n             quote-id=\"quoteID\" \n             available-years=\"availableYears\"></div>\n\n        <div class=\"gw-page-buttons\">\n            <!-- OOTB label commented <span>{{'quoteandbind.pa.views.pa-vehicle-details.Are there other vehicles to insure?' | translate}}</span> -->\n            <span ng-hide=\"true\">{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Are there other vehicles or motorcycles to insure?' | translate}}</span>\n            <button ng-hide=\"true\" class=\"gw-btn\" type=\"button\" ng-click=\"previous()\">\n                {{'platform.widgets.wizard.Previous'|translate}}\n            </button>\n            <button class=\"gw-btn gw-pull-left pa-add-driver-vehicle-button\" type=\"button\" ng-click=\"addVehicle(form)\">\n                <span class=\"gw-icon fa fa-plus\"></span>\n                {{'quoteandbind.pa.views.pa-vehicle-details.Add Vehicle' | translate}}\n            </button>\n            <div class=\"next-cancel-button-wrapper\">\n                <button class=\"gw-btn\" type=\"button\" ng-click=\"cancel()\">\n                    {{'platform.widgets.wizard.Cancel'|translate}}\n                </button>\n                <button class=\"gw-btn-primary\" next-button ng-click=\"next(form)\">\n                    {{'quoteandbind.pa.views.pa-vehicle-details.Next' | translate}}\n                </button>\n            </div>\n        </div>\n    </ng-form>\n</div>\n"

/***/ },
/* 373 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <ng-form class=\"ng-class:{ 'gw-submitted': policyInfoForm.submitted }\" novalidate name=\"policyInfoForm\">\n        <h1 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Policy Information' | translate}}</h1>\n\n        <form class=\"ng-class:{ 'gw-submitted': vehiclesForm.submitted };\" novalidate\n              name=\"policyDetailsForm\">\n            <div class=\"gw-control-group\">\n                <div class=\"gw-controls aaa-coverage-date-right\">\n                    {{'quoteandbind.pa.views.pa-policy-info.Coverage Start Date' | translate}}\n                </div>\n                <div class=\"gw-controls aaa-coverage-date-right\">\n                    {{draftData.periodStartDate | date : medium}}\n                </div>\n            </div>\n        </form>\n\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Drivers' | translate}}</h2>\n        <table class=\"gw-table\">\n            <thead>\n            <tr>\n                <td>{{'quoteandbind.pa.views.pa-policy-info.Name' | translate}}</td>\n                <!-- license no. and state *Princy   ng-if=\"!licenseNumberFlagArray[$index]\"-->\n                <td ng-if=\"!allPrefillDriversFlag\">{{'quoteandbind.pa.views.pa-policy-info.License Number' | translate}}</td>\n                <td ng-if=\"!allPrefillDriversFlag\">{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}</td>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"driver in driversVM\" ng-class=\"{'gw-bold' : isAccountHolder(driver)}\" style=\"border-bottom: 1px solid #ddd;\"><!--coomented line 32 and 37\" in license no. and state *Princy-->\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Name' | translate}}\">{{driver.value.getDisplayName(undefined, $filter)}}</td>\n                <td ng-if=\"licenseNumberFlagArray[$index] && !driver.isPrefilledDriver.value\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License Number' | translate}}\">{{driver.value.licenseNumber}}</td>\n                <td ng-if=\"!licenseNumberFlagArray[$index] && !driver.isPrefilledDriver.value\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License Number' | translate}}\">\n                    <input type=\"text\" ng-model=\"driver.licenseNumber.value\" maxlength=\"25\"/>\n                    <span  ng-if=\"policyInfoForm.submitted && (driver.licenseNumber.value === undefined || driver.licenseNumber.value === '')\" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n                </td>\n                <!-- Princy ng-if= \"!licenseNumberFlagArray[$index]\" -->\n                <td ng-if= \"!driver.isPrefilledDriver.value\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}\">{{driver.value.licenseState}}</td>\n                <!-- <td ng-if=\"!lookupState(driver.licenseState.value).name\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}\">s\n                    <select gw-pl-select=\"states.value\" ng-model=\"driver.licenseState.value\" options=\"states\" render-by=\" 'name' \"></select>\n                </td> -->\n\n                <!--added below tag for state *Princy  line 37 commented avobe.-->\n               <!-- <td ng-if= \"!licenseNumberFlagArray[$index]\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}\">\n                    <select gw-pl-select=\"states.value\" ng-model=\"driver.licenseState.value\" options=\"states\" render-by=\" 'name' \"></select>\n                </td> -->\n            </tr>\n            </tbody>\n        </table>\n\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Primary Driver Contact Details'|translate}}</h2>\n\n        <!--<form class=\"ng-class:{ 'gw-submitted': driversForm.submitted };\" novalidate name=\"driversForm\">-->\n            <div ng-repeat=\"(key, driver) in draftData.lobs.personalAuto.drivers\">\n                <div>\n                    <div ng-if=\"isAccountHolder(driver)\">\n                        <div gw-pl-ctrl-group\n                             label=\"{{'quoteandbind.pa.views.pa-policy-info.Phone Number' | translate}}\"\n                             model=\"bindData.contactPhone\">\n                            <input type=\"text\"\n                                   ng-model=\"bindData.contactPhone.value\"\n                                   gw-pl-ui-mask=\"{{phoneMask}}\"\n                                   leave-value-masked/>\n\n                            <span  ng-if=\"policyInfoForm.submitted && (bindData.contactPhone.value === undefined || bindData.contactPhone.value === '')\" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n                        </div>\n                        <div gw-pl-input-ctrl model=\"bindData.contactEmail\" label=\"{{'quoteandbind.pa.views.pa-policy-info.Email Address' | translate}}\" ng-attr-maxlength=\"50\"></div>\n                    </div>\n                </div>\n            </div>\n       <!-- </form>-->\n\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicles' | translate}}</h2>\n        <table class=\"gw-table\">\n            <thead>\n            <tr>\n                <td >\n                {{'quoteandbind.pa.views.pa-policy-info.Make' | translate}}</td>\n                <td >\n                {{'quoteandbind.pa.views.pa-policy-info.Model' | translate}}</td>\n                <td >\n                {{'quoteandbind.pa.views.pa-policy-info.Year' | translate}}</td>\n                <!-- Princy  ng-if=\"!(vinFlagArray[$index])\"-->\n                <td ng-if=\"!allPrefillVehicleFlag\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle ID (VIN)' | translate}}</td>\n            </tr>\n            </thead>\n            <tbody>\n\n            <tr ng-repeat=\"vehicle in vehiclesVM track by $index\" style=\"border-bottom: 1px solid #ddd;\">\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Make' | translate}}\">{{vehicle.make.value}}</td>\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Model' | translate}}\">{{vehicle.model.value}}</td>\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Year' | translate}}\">{{vehicle.year.value}}</td>\n                <!-- Commenting for VIN *Princy -->\n                <td ng-if=\"vinFlagArray[$index] && !vehicle.isPrefilledVehicle.value\" title=\"{{'quoteandbind.pa.views.pa-policy-info.Vehicle ID (VIN)' | translate}}\">{{vehicle.vin.value}}</td>\n                <td ng-if=\"!vinFlagArray[$index] && !vehicle.isPrefilledVehicle.value\" title=\"{{'quoteandbind.pa.views.pa-policy-info.Vehicle ID (VIN)' | translate}}\">\n                    <input type=\"text\" ng-model=\"vehicle.vin.value\" maxlength=\"17\" ng-blur=\"lookupVIN(vehicle)\"/>\n                    <span  ng-if=\"policyInfoForm.submitted && (vehicle.vin.value === undefined || vehicle.vin.value === '')\" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n                   <!-- <span ng-show=\"invalidVIN\" class=\"gw-error-inline\">{{'quoteandbind.pa.views.pa-policy-info.Invalid Vin' | translate}}</span>-->\n                    <span ng-show=\"vehicle.vin.value !== undefined && vehicle.vin.value.length > 0 && !isValidVin(vehicle)\" class=\"custom-error\">{{'quoteandbind.pa.views.pa-policy-info.Invalid Vin' | translate}}</span>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n\n        <!--<div ng-repeat=\"vehicle in vehiclesVM\">\n            <div ng-if=\"vehicle.ownership.value.code === 'additionalinterest_aaa'\">\n                <br/>\n                <h3>{{vehicle.year.value}}&nbsp;{{vehicle.make.value}}&nbsp;{{vehicle.model.value}}</h3>\n                <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle Lease Contact Details' | translate}}</h2>\n                <div >\n                    <div>{{'quoteandbind.pa.views.pa-policy-info.LeaseCompanyInstruction' | translate}}</div><br/>\n                    <div class=\"gw-controls\">\n                    <select ng-options=\"lease.name for lease in leaseOptions\" ng-model=\"leaseSelectedOption\"></select>\n                        </div>\n                </div>\n                <br/>\n                <div ng-if=\"leaseSelectedOption.name === 'Other' \">\n                    <div model=\"vehicle.addnlInterest.name\">\n                         <span class=\"aaa-inline-info-wrapper\">\n                            <div class=\"aaa-inline-info\">   {{'quoteandbind.pa.views.pa-policy-info.leasecompany.name.Tooltip' | translate }}\n                            </div>\n                            <i class=\"fa fa-info-circle\"></i>\n                        </span>\n                        <input type=\"text\" ng-model=\"vehicle.addnlInterest.name.value\" name='leaseCompany'\n                         placeholder =\"{{'quoteandbind.pa.views.pa-policy-info.Lease Company Name' | translate}}\"\n                        maxlength=\"50\"/>\n                        <span class=\"custom-error\" \n                        ng-show=\"isNull(vehicle.addnlInterest.name.value) && isRequoteButtonClicked\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n                    </div>\n                    <br>\n\n                    <div policyInfoForm=\"policyInfoForm\" gw-pl-ownership-address lease=\"true\" vehicles=\"vehiclesVM\" is-requote-button-clicked=\"isRequoteButtonClicked\"address=\"vehicle.addnlInterest.addnlInterestAddress\" maxlength=\"50\"></div>\n                </div>\n            </div>\n            <div ng-if=\"vehicle.ownership.value.code === 'LOSSP'\">\n                <br/>\n                <h3>{{vehicle.year.value}}&nbsp;{{vehicle.make.value}}&nbsp;{{vehicle.model.value}}</h3>\n                <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle Finance/Loan Contact Details' | translate}}</h2>\n               &lt;!&ndash;  <div>{{'quoteandbind.pa.views.pa-policy-info.FinanceCompanyInstruction' | translate}}</div> <br/> &ndash;&gt;\n                &lt;!&ndash;Commented for DE788 by Diwakar-26th Dec,2016&ndash;&gt;\n               &lt;!&ndash;  <div class=\"gw-control-group\">\n                    <div class=\"gw-control-label\">{{'quoteandbind.pa.views.pa-policy-info.FinanceCompanyInstruction' | translate}}</div><br/> &ndash;&gt;\n                    <div>\n                    <div>{{'quoteandbind.pa.views.pa-policy-info.FinanceCompanyInstruction' | translate}}</div>\n                    <br/> \n                <div class=\"gw-controls\">\n                    <select ng-options=\"finance.name for finance in financeOptions\" ng-model=\"financeSelectedOption\"></select>\n                </div>\n                </div>\n                <br/>\n                <div ng-if=\"financeSelectedOption.name === 'Other' \">\n                    <div  model=\"vehicle.addnlInterest.name\">\n                              <span class=\"aaa-inline-info-wrapper\">\n                <div class=\"aaa-inline-info\">   {{'quoteandbind.pa.views.pa-policy-info.financecompany.name.Tooltip' | translate }}</div>\n                <i class=\"fa fa-info-circle\"></i>\n             </span>\n                        <input type=\"text\" ng-model=\"vehicle.addnlInterest.name.value\"  \n                        placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.Finance Company Name' | translate}}\" maxlength=\"50\"/>\n                         <span class=\"custom-error\" \n                         ng-show=\"isNull(vehicle.addnlInterest.name.value) && isRequoteButtonClicked\">\n                        {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\n                    </div>\n                    <br>\n                    <div gw-pl-ownership-address is-requote-button-clicked=\"isRequoteButtonClicked\"lease=\"false\" vehicles=\"vehiclesVM\" address=\"vehicle.addnlInterest.addnlInterestAddress\" maxlength=\"50\"></div>\n\n                </div>\n            </div>\n        </div>-->\n\n      <!--  <div g-repeat=\"vehicle in draftData.lobs.personalAuto.vehicles\">\n            <div ng-if=\"vehicle.ownership === 'Own and Make Payments'\">\n                <br/>\n                <h3>{{vehicle.year}}&nbsp;{{vehicle.make}}&nbsp;{{vehicle.model}}</h3>\n                <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle Finance/Loan Contact Details' | translate}}</h2>\n                <div>{{'quoteandbind.pa.views.pa-policy-info.FinanceCompanyInstruction' | translate}}</div><br/>\n                <div>\n                    <select ng-options=\"finance.name for finance in financeOptions\" ng-model=\"financeSelectedOption\"></select>\n                </div>\n                <br/>\n                <div ng-if=\"financeSelectedOption.name === 'Other' \">\n                    <div gw-pl-input-ctrl model=\"vehicle.addnlInterest.name\" ng-attr-maxlength=\"50\" label=\"{{'quoteandbind.pa.views.pa-policy-info.Finance Company Name' | translate}}\"></div>\n                   &lt;!&ndash; <div gw-pl-ownership-address address=\"bindData.ownershipAddress\"></div>&ndash;&gt;\n                </div>\n            </div>\n        </div>-->\n\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Coverages' | translate}}</h2>\n        <div ng-if=\"chosenQuoteData.lobs.personalAuto\">\n            <div gw-qnb-pa-view-coverages=\"chosenQuoteData.lobs.personalAuto\"></div>\n        </div>\n\n       <!-- <div gw-wizard-page-actions></div>-->\n        <div class=\"gw-page-buttons\">\n            <button class=\"gw-btn\" type=\"button\"\n                    ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\n            </button>\n            <!--\n            Commented for consistencey\n            <button class=\"gw-btn\" type=\"button\"\n                     ng-click=\"previous()\">{{'platform.widgets.wizard.Previous'|translate}}\n             </button> -->\n            <button class=\"gw-btn-primary\" next-button\n                    ng-click=\"reQuote(policyInfoForm)\">{{'platform.widgets.wizard.Next' | translate}}\n            </button>\n        </div>\n    </ng-form>\n</div>\n"

/***/ },
/* 374 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <ng-form class=\"ng-class:{ 'gw-submitted': policyInfoForm.submitted }\" novalidate name=\"policyInfoForm\">\r\n        <h1 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Policy Information Screen 2' | translate}}</h1>\r\n\r\n        <form class=\"ng-class:{ 'gw-submitted': vehiclesForm.submitted };\" novalidate\r\n              name=\"policyDetailsForm\">\r\n            <div class=\"gw-control-group\">\r\n                <div class=\"gw-controls aaa-coverage-date-right\">\r\n                    {{'quoteandbind.pa.views.pa-policy-info.Coverage Start Date' | translate}}\r\n                </div>\r\n                <div class=\"gw-controls aaa-coverage-date-right\">\r\n                    {{draftData.periodStartDate | date : medium}}\r\n                </div>\r\n            </div>\r\n        </form>\r\n\r\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Drivers' | translate}}</h2>\r\n        <table class=\"gw-table\">\r\n            <thead>\r\n            <tr>\r\n                <td>{{'quoteandbind.pa.views.pa-policy-info.Name' | translate}}</td>\r\n                <!-- Princy ng-if='allPrefillDriversFlag' -->\r\n                <td ng-if=\"!allPrefillDriversFlag\">{{'quoteandbind.pa.views.pa-policy-info.License Number' | translate}}</td>\r\n                <td ng-if=\"!allPrefillDriversFlag\">{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}</td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr\r\n                ng-repeat=\"(key, driver) in draftData.lobs.personalAuto.drivers | orderBy:driverSort\"\r\n                ng-class=\"{'gw-bold' : isAccountHolder(driver)}\" style=\"border-bottom: 1px solid #ddd;\"\r\n            >\r\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Name' | translate}}\">{{driver.getDisplayName(undefined, $filter)}}</td>\r\n                <td ng-if= \"!driver.isPrefilledDriver\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License Number' | translate}}\">{{driver.licenseNumber}}</td>\r\n                <td ng-if= \"!driver.isPrefilledDriver\" title=\"{{'quoteandbind.pa.views.pa-policy-info.License State' | translate}}\">{{lookupState(driver.licenseState).name}}</td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n\r\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Primary Driver Contact Details'|translate}}</h2>\r\n        <form class=\"ng-class:{ 'gw-submitted': driversForm.submitted };\" novalidate name=\"driversForm\">\r\n            <div ng-repeat=\"(key, driver) in draftData.lobs.personalAuto.drivers\">\r\n                <div>\r\n                    <div ng-if=\"isAccountHolder(driver)\">\r\n                        <!--<div label=\"{{'quoteandbind.pa.views.pa-policy-info.Phone Number'| translate }}\">{{bindData.contactPhone.value}}</div>\r\n                        <div label=\"{{'quoteandbind.pa.views.pa-policy-info.Email Address' | translate}}\">{{bindData.contactEmail.value}}</div>-->\r\n                        <div gw-pl-input-ctrl readonly=\"true\" model=\"bindData.contactPhone\" label=\"{{'quoteandbind.pa.views.pa-policy-info.Phone Number' | translate }}\"></div>\r\n                        <div gw-pl-input-ctrl readonly=\"true\" model=\"bindData.contactEmail\" label=\"{{'quoteandbind.pa.views.pa-policy-info.Email Address' | translate }}\"></div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </form>\r\n\r\n\r\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Vehicles' | translate}}</h2>\r\n        <table class=\"gw-table\">\r\n            <thead>\r\n            <tr>\r\n                <td>{{'quoteandbind.pa.views.pa-policy-info.Make' | translate}}</td>\r\n                <td>{{'quoteandbind.pa.views.pa-policy-info.Model' | translate}}</td>\r\n                <td>{{'quoteandbind.pa.views.pa-policy-info.Year' | translate}}</td>\r\n                <td ng-if=\"!allPrefillVehicleFlag\">{{'quoteandbind.pa.views.pa-policy-info.Vehicle ID (VIN)' | translate}}</td>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"vehicle in draftData.lobs.personalAuto.vehicles\" style=\"border-bottom: 1px solid #ddd;\">\r\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Make' | translate}}\">{{vehicle.make}}</td>\r\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Model' | translate}}\">{{vehicle.model}}</td>\r\n                <td title=\"{{'quoteandbind.pa.views.pa-policy-info.Year' | translate}}\">{{vehicle.year}}</td>\r\n                <td ng-if=\"!vehicle.isPrefilledVehicle\" title=\"{{'quoteandbind.pa.views.pa-policy-info.Vehicle ID (VIN)' | translate}}\">{{vehicle.vin}}</td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.pa.views.pa-policy-info.Coverages' | translate}}</h2>\r\n        <div ng-if=\"chosenQuoteData.lobs.personalAuto\">\r\n            <div gw-qnb-pa-view-coverages=\"chosenQuoteData.lobs.personalAuto\"></div>\r\n        </div>\r\n\r\n        <div class=\"gw-page-buttons\">\r\n            <button class=\"gw-btn\" type=\"button\" ng-click=\"cancel()\">\r\n                {{'platform.widgets.wizard.Cancel'|translate}}\r\n            </button>\r\n            <button class=\"gw-btn-primary\" next-button ng-click=\"next()\">\r\n                {{'quoteandbind.pa.views.pa-vehicle-details.Next' | translate}}\r\n            </button>\r\n        </div>\r\n    </ng-form>\r\n</div>\r\n"

/***/ },
/* 375 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <div class=\"gw-page-section-title gw-page-section-title__area\"><div class=\"gw-page-section-title__left\">{{'quoteandbind.views.quote-details.Quote' | translate}}</div>\r\n        <span class=\"gw-printing-buttons gw-page-section-title__right\">\r\n            <button class=\"gw-btn\" ng-click=\"printQuote()\">\r\n                <span class=\"gw-icon fa fa-print\"></span>&nbsp;\r\n                {{'quoteandbind.views.quote-details.Print Quote' | translate}}\r\n            </button>\r\n        </span>\r\n    </div>\r\n\r\n    <tabset ng-if=\"page.standardQuotes.length !== 0\" justified=\"true\" default-tab =\"{{tabSelected}}\" lob-tab=\"{{page.productCode}}\">\r\n        <tab ng-repeat=\"quote in page.standardQuotes\" select=\"setSelectedQuote(quote)\">\r\n            <tab-heading class=\"gw-quotetab-header\">\r\n                <div class=\"gw-offeringName\">{{ page.offeringLabels[$index] || quote.branchName }}</div>\r\n                <div class=\"gw-offeringCost\">{{quote.monthlyPremium|gwCurrency}}</div>\r\n                <div class=\"gw-offeringName\">{{ 'quoteandbind.offeringLabels.Monthly' | translate }}</div>\r\n            </tab-heading>\r\n\r\n            <div gw-qnb-quote-offering=\"quote\" buy=\"buy\" next-steps=\"nextSteps\" header=\"{{page.offeringLabels[$index]}}\" bi-limits=\"{{biLimits}}\"></div>\r\n        </tab>\r\n        <tab ng-repeat=\"quote in page.customQuotes\" heading=\"Custom $0.00\" select=\"setSelectedQuote(quote)\">\r\n            <tab-heading class=\"gw-quotetab-header\">\r\n                <!--<div class=\"gw-offeringName\">{{'quoteandbind.views.quote-details.Custom' | translate}}</div>-->\r\n                <div class=\"gw-offeringName\">{{'quoteandbind.offeringLabels.Build your quote here' | translate}}</div>\r\n                <div class=\"gw-offeringCost\">{{getCustomQuoteHeaderCostString()}}</div>\r\n                <div class=\"gw-offeringName\">{{ 'quoteandbind.offeringLabels.Monthly' | translate }}</div>\r\n            </tab-heading>\r\n\r\n            <div gw-qnb-custom-quote custom-quote=\"quote\" standard-offering=\"page.baseOffering\"\r\n                 buy=\"buy\" sessionid=\"page.sessionUUID\" submissionid=\"page.quoteID\" header=\"{{'quoteandbind.offeringLabels.Build your quote here' | translate}}\" bi-limits=\"{{biLimits}}\"></div>\r\n        </tab>\r\n    </tabset>\r\n\r\n    <div ng-if=\"page.standardQuotes.length === 0\" gw-qnb-custom-quote custom-quote=\"page.customQuotes[0]\" standard-offering=\"page.baseOffering\"\r\n         buy=\"buy\" sessionid=\"page.sessionUUID\" submissionid=\"page.quoteID\"></div>\r\n\r\n</div>\r\n"

/***/ },
/* 376 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.pa.views.E-Signature' | translate }}</h2>\r\n    <form novalidate name=\"form\">\r\n       <!-- <div class=\"gw-esignature-form\" id=\"gw-esignature-form\">\r\n            <div class=\"gw-esignature-form-inner\" ng-if=\"eSignedPdfUrl\">\r\n                <div class=\"iframe-placeholder\">\r\n                    <iframe ng-src=\"{{eSignedPdfUrl}}\" id=\"qb-esign-form\" ng-class=\"{'iframe-ie': isIeBrowser, 'iframe-not-ie': !isIeBrowser}\"></iframe>\r\n                </div>\r\n            </div>\r\n        </div>-->\r\n\r\n        <div id=\"Iframe-Cicis-Menu-To-Go\" class=\"set-margin-cicis-menu-to-go set-padding-cicis-menu-to-go set-border-cicis-menu-to-go set-box-shadow-cicis-menu-to-go center-block-horiz\">\r\n            <div class=\"responsive-wrapper responsive-wrapper-padding-bottom-90pct\">\r\n                 <!--style=\"-webkit-overflow-scrolling: touch; overflow: auto;\">-->\r\n                <div class=\"iframe-placeholder\" style=\"-webkit-overflow-scrolling: touch; overflow: auto;\">\r\n                   <!-- <iframe ng-src=\"{{eSignedPdfUrl}}\" id=\"qb-esign-form\"></iframe>-->\r\n                    <!--\r\n                    <object ng-attr-data=\"{{eSignedPdfUrl}}\" type=\"application/pdf\">\r\n                        <embed ng-src=\"{{eSignedPdfUrl}}\" id=\"qb-esign-form\" type=\"application/pdf\" />\r\n                    </object>-->\r\n                    <object ng-attr-data=\"{{eSignedPdfUrl}}\" type=\"application/pdf\">\r\n                        <iframe ng-src=\"{{eSignedPdfUrl}}\" id=\"qb-esign-form\"></iframe>\r\n                    </object>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <!--<a target=\"_blank\" data-ng-href=\"{{eSignedPdfUrl}}\">{{'quoteandbind.pa.views.esignature.open document in new tab'|translate}}</a>-->\r\n        <div class=\"gw-esignature-agreement\">\r\n            <input type=\"checkbox\" class=\"gw-esignature-agreement-checkbox\" \r\n                   name=\"agree\"\r\n                   ng-model=\"view.eSignAgreed.value\" \r\n                   ng-change=\"changeAgreeCondition()\"/>&nbsp;&nbsp;\r\n            {{'quoteandbind.pa.views.esignature.agreementText1'|translate}}&nbsp;\r\n            <a ng-click=\"openModalWindow()\">{{'quoteandbind.pa.views.esignature.agreementText2'|translate}}</a>&nbsp;\r\n            {{'quoteandbind.pa.views.esignature.agreementText3'|translate}}\r\n        </div> \r\n    </form>\r\n<br>\r\n    <!--<div gw-wizard-page-actions next=\"next\"></div>-->\r\n\r\n    <div class=\"gw-page-buttons\">\r\n        <button class=\"gw-btn\" type=\"button\"\r\n                ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n        </button>\r\n        <button class=\"gw-btn-primary\" next-button\r\n                ng-click=\"next(form)\" \r\n                ng-disabled=\"isItAgreed()\">{{'platform.widgets.wizard.Next' | translate}}\r\n        </button>\r\n    </div>\r\n\r\n\r\n</div>\r\n\r\n\r\n\r\n"

/***/ },
/* 377 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-prequal-questions\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.prequal-questions.Qualification' | translate}}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" name=\"form\">\n        <div data-ng-repeat=\"qs in questionSets\">\n            <div gw-pl-question-set=\"qs\"></div>\n        </div>\n\n        <div gw-wizard-page-actions next=\"next\"></div>\n    </ng-form>\n</div>"

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, StateUtils, submissionViewModel) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        ctrl.init = function () {
	            $scope.questionSets = submissionVM.draftData.lobs.personalAuto.preQualQuestionSets.value;
	
	            //set default answer of "false" to all the questions
	            for (var key in $scope.questionSets[0]["answers"]) {
	
	                $scope.questionSets[0]["answers"][key] = "false";
	            }
	        };
	
	        //hide this page from portal
	        flowModel.next(submissionVM, true);
	
	        ctrl.next = function (nextFn, form) {
	
	            //prequal question requiredness not captured in the submission model, so pass form validity for isValid check
	            nextFn(submissionVM, form.valid);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn($scope, $stateParams, $state, submissionViewModel, ModalService, MembershipService, $q, StateUtils, InMemorySession) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	            $scope.accountHolder = submissionVM.draftData.accountHolder.value;
	
	            //ENHC0011961 - commenting initialization and moved to contact page --Arpita Sengupta
	            $scope.membershipDetails = {
	                membershipNumber: $scope.accountHolder.membershipNumber || '',
	                firstName: '',
	                lastName: ''
	            };
	            //ended
	
	            $scope.otherProducts = {
	                personalAuto: false,
	                homeOwners: false,
	                fire: false,
	                flood: false,
	                life: false,
	                umbrella: false,
	                renters: false,
	                watercraft: false
	            };
	
	            $scope.productCode = $scope.submission.draftData.productCode;
	
	            if ($scope.productCode == 'Homeowners') {
	                $scope.HOView = submissionVM.draftData.lobs.homeowners.membershipHO;
	                $scope.HOView.value = $scope.HOView.value || {};
	
	                if ($scope.HOView.value) {
	                    /*console.log("HO2",$scope.HOView.value);*/
	                    if ($scope.HOView.otherPolicies === "true") {
	                        $scope.Answer = 'true';
	                    }
	                    $scope.otherProducts.personalAuto = $scope.HOView.value.personalAuto;
	                    $scope.otherProducts.homeOwners = $scope.HOView.value.homeOwners;
	                    $scope.otherProducts.flood = $scope.HOView.value.flood;
	                    $scope.otherProducts.renters = $scope.HOView.value.renters;
	                    $scope.otherProducts.life = $scope.HOView.value.life;
	                    $scope.otherProducts.watercraft = $scope.HOView.value.waterCraft;
	                    $scope.otherProducts.umbrella = $scope.HOView.value.umbrella;
	                    $scope.otherProducts.fire = $scope.HOView.value.dwellingFire;
	                }
	            } else if ($scope.productCode == 'PersonalAuto') {
	                $scope.PAView = submissionVM.draftData.lobs.personalAuto.membershipPA;
	                $scope.PAView.value = $scope.PAView.value || {};
	                // ENHC0011961_EODB QnB Defaults --Arpita Sengupta
	                if (submissionVM.value.quoteStatus == "Draft") {
	                    $scope.PAView.otherPolicies = "true";
	                    $scope.PAView.homeOwners = true;
	                }
	                //ended
	                //console.log("PA1",$scope.PAView);
	
	                if ($scope.PAView.value) {
	                    /*console.log("PA2",$scope.PAView.value);*/
	                    // ENHC0011961_EODB QnB Defaults --Arpita Sengupta
	                    if ($scope.PAView.otherPolicies.value === "true") {
	                        $scope.Answer = 'true';
	                    } else {
	                        $scope.Answer = 'false';
	                    }
	                    //ended
	                    $scope.otherProducts.homeOwners = $scope.PAView.value.homeOwners;
	                    $scope.otherProducts.umbrella = $scope.PAView.umbrella;
	                }
	            }
	            //Datas prefill -- Arpita
	            // if($scope.productCode == 'PersonalAuto' && $scope.submission.draftData.lobs.personalAuto.drivers){
	            //     for(let idxDriver in  $scope.submission.draftData.lobs.personalAuto.drivers){
	            //         if($scope.submission.draftData.lobs.personalAuto.drivers[idxDriver].isPrefilledDriver){
	            //             let getDate = string => (([year, month, day]) => ({ year, month, day }))(string.split('-'));
	            //             let temDob = InMemorySession.decryptData($scope.submission.draftData.lobs.personalAuto.drivers[idxDriver].eNCDateOfBirth).split(' ')[0];
	            //             submissionVM.draftData.lobs.personalAuto.drivers.value[idxDriver].dateOfBirth = getDate(temDob);
	            //         }
	            //     }  
	            // }   
	            /*console.log("PA",$scope.PAView);
	            console.log("HO",$scope.HOView);*/
	
	            $scope.visitedNumber = false;
	            /* $scope.Answer = false;*/
	            $scope.activeSection = 'new';
	
	            // For CHG0030501
	            /*$scope.policyInfoPaymentMethod = submissionVM.draftData.policyInfoPaymentMethod;
	            $scope.policyInfoDocumentDeliveryMethod = submissionVM.draftData.policyInfoDocumentDeliveryMethod;
	            $scope.policyInfoPaymentMethodOptions = _.filter(submissionVM.draftData.policyInfoPaymentMethod.aspects.availableValues,(options) => {
	                if($scope.productCode == 'PersonalAuto'){
	                    const availablepolicyInofPaymentMethods = ["paid_in_full","billbymail","recurring"];
	                    return availablepolicyInofPaymentMethods.indexOf(options.code) != -1;
	                }else{
	                    return options;
	                }
	              });
	             $scope.policyInfoDocumentDeliveryOptions =  _.filter(submissionVM.draftData.policyInfoDocumentDeliveryMethod.aspects.availableValues,(options) => {
	                    const availableDocumentDeliveryOptions = ["email","mail"];
	                    return availableDocumentDeliveryOptions.indexOf(options.code) != -1;
	            });*/
	        };
	
	        // ENHC0011961 - commenting warning message from membership page
	        ctrl.showMemberWarning = function () {
	
	            if (null != $scope.membershipDetails.membershipNumber && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length != 16) {
	
	                ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.controllers.MembershipCtrl.AttentionMessage');
	            }
	        };
	        // ended
	
	        ctrl.next = function (form) {
	            if ($scope.productCode == 'Homeowners') {
	                if ($scope.Answer) {
	                    $scope.HOView.otherPolicies = $scope.Answer;
	                    $scope.HOView.personalAuto = $scope.otherProducts.personalAuto;
	                    $scope.HOView.homeOwners = $scope.otherProducts.homeOwners;
	                    $scope.HOView.flood = $scope.otherProducts.flood;
	                    $scope.HOView.renters = $scope.otherProducts.renters;
	                    $scope.HOView.life = $scope.otherProducts.life;
	                    $scope.HOView.waterCraft = $scope.otherProducts.watercraft;
	                    $scope.HOView.umbrella = $scope.otherProducts.umbrella;
	                    $scope.HOView.dwellingFire = $scope.otherProducts.fire;
	                } else {
	                    $scope.Answer = '';
	                }
	            } else if ($scope.productCode == 'PersonalAuto') {
	                if ($scope.Answer) {
	                    $scope.PAView.otherPolicies = $scope.Answer;
	                    $scope.PAView.homeOwners = $scope.otherProducts.homeOwners;
	                    $scope.PAView.umbrella = $scope.otherProducts.umbrella;
	                } else {
	                    $scope.Answer = '';
	                }
	            }
	
	            //  CHG0031104 - Add OMEGA QnB link to SECU’s website
	            //  AB - April 05, 2020
	            //
	            if (!$scope.accountHolder.isCreditUnionMember) {
	                $scope.accountHolder.joinedYearCreditUnionMembership = null;
	            }
	
	            submissionVM.draftData.insuranceScoreAgreed = true;
	            submissionVM.draftData.policyInfoPaymentMethod.value = "recurring";
	            submissionVM.draftData.policyInfoDocumentDeliveryMethod.value = "email";
	            form.submitted = true;
	            flowModel.next(submissionVM);
	        };
	        ctrl.previous = function () {
	            flowModel.previous(submissionVM);
	        };
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        ctrl.membership = function (form) {
	            form.submitted = true;
	            $scope.accountHolder.isFairCreditReportingAct = true;
	            // ENHC0011961 no validation required and default quote as member
	            if ($scope.productCode == 'Homeowners') {
	                if ($scope.membershipDetails.membershipNumber != null && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length == '16') {
	
	                    var membershipPromise = MembershipService.isMember('quoteandbind', $scope.membershipDetails);
	                    ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);
	
	                    membershipPromise.then(function (membershipResp) {
	
	                        if (membershipResp[0].membershipStatus && membershipResp[0].firstName && membershipResp[0].lastName) {
	                            $scope.accountHolder.isMember = true;
	                            $scope.accountHolder.membershipNumber = membershipResp[0].membershipNumber;
	                            $scope.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
	                            $scope.accountHolder.membershipType = membershipResp[0].serviceLevel;
	                            $scope.accountHolder.membershipStatus = membershipResp[0].membershipStatus;
	                        } else {
	                            $scope.accountHolder.isMember = false;
	                        }
	
	                        ctrl.next(form);
	                    }).catch(function () {
	                        var errorPromise = ModalService.showError('quoteandbind.controllers.MembershipCtrl.Error', 'quoteandbind.controllers.MembershipCtrl.PC system down error');
	                    });
	                    ctrl.next(form);
	                } else {
	                    $scope.accountHolder.isMember = false;
	                    ctrl.next(form);
	                }
	            } else {
	                ctrl.next(form);
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel', 'ModalService', 'MembershipService', '$q', 'StateUtils', 'InMemorySession'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    // added '$rootScope' *Princy
	    var fn = function fn($filter, $scope, $rootScope, $stateParams, $state, submissionViewModel, ModalService, PrefillService, $q, StateUtils, InMemorySession) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	        $scope.submissionVM = submissionVM;
	        var paModel = $scope.submissionVM.draftData.lobs.personalAuto.value;
	        var accountHolder = $scope.submissionVM.value.getAccountHolderPerson();
	        var navFrom = flowModel.navigatingFromStep();
	        var flowSteps = flowModel.steps;
	        var currentStepIndex = _.findIndex(flowSteps, function (step) {
	            return step.name === flowModel.currentStep.name;
	        });
	        $scope.page = {
	            drivers: {},
	            vehicles: {}
	        };
	        // added vehicleFlagPrefillArray flag *Princy
	        $scope.vehicleFlagPrefillArray = [];
	        $scope.driverFlagPrefillArray = [];
	        //YearLicenced,LicenseNumber,Accidents,Violations are no longer mandatory parameters
	
	        function addDriver(data) {
	            var isDriverAdded = false;
	            if (typeof data.drivers !== 'undefined' && data.drivers.length > 0) {
	                var primaryDriver = paModel.createDriver(accountHolder);
	                primaryDriver.isPrefilledDriver = true;
	                angular.forEach(data.drivers, function (driver) {
	                    if (isPrimaryDriver(driver)) {
	                        primaryDriver.gender = driver.gender;
	                        primaryDriver.licenseNumber = driver.licenseNumber;
	                        primaryDriver.licenseState = driver.licenseState;
	                        primaryDriver.accidents = '0';
	                        primaryDriver.violations = '0';
	                        primaryDriver.isPrefilledDriver = true;
	                        $scope.driverFlagPrefillArray.push(primaryDriver.tempID);
	                    } else {
	                        var addr = submissionVM.draftData.policyAddress.value;
	                        var newPerson = submissionVM.value.createPerson({
	                            primaryAddress: addr,
	                            isPrefilledDriver: true
	                        });
	
	                        var newDriver = paModel.createDriver(newPerson);
	                        newDriver.person.firstName = driver.firstName;
	                        newDriver.person.middleName = driver.middleName;
	                        newDriver.person.lastName = driver.lastName;
	                        var d2 = angular.isDefined(driver.dateOfBirth) ? new Date(driver.dateOfBirth) : undefined;
	                        if (angular.isDefined(d2)) {
	                            d2.setHours(0, 0, 0, 0);
	                        };
	                        newDriver.dateOfBirth = {
	                            "year": angular.isDefined(d2) ? d2.getFullYear().toString() : '',
	                            //devendra commented
	                            //"month": angular.isDefined(d2) ? (d2.getMonth() + 1).toString() : '',
	                            "month": angular.isDefined(d2) ? d2.getMonth().toString() : '',
	                            "day": angular.isDefined(d2) ? d2.getDate().toString() : ''
	                        };
	                        // added below code for age: *Princy//
	                        newDriver.age = ctrl.getAge(newDriver);
	                        newDriver.gender = driver.gender;
	                        newDriver.licenseNumber = driver.licenseNumber;
	                        newDriver.licenseState = driver.licenseState;
	                        newDriver.accidents = '0';
	                        newDriver.violations = '0';
	                        newDriver.isPrefilledDriver = true;
	
	                        // added below code for rootscope: *Princy//
	                        $rootScope.isPrefilledDriver = true;
	                        $scope.driverFlagPrefillArray.push(driver.tempID);
	                    }
	                });
	                isDriverAdded = true;
	            }
	            return isDriverAdded;
	        }
	
	        function isPrimaryDriver(driver) {
	            var person = accountHolder;
	            var d1 = new Date(person.dateOfBirth.year, person.dateOfBirth.month, person.dateOfBirth.day);
	            var d2 = new Date(driver.dateOfBirth);
	            d2.setHours(0, 0, 0, 0);
	            if (driver.firstName.toLowerCase() === person.firstName.toLowerCase() && driver.lastName.toLowerCase() === person.lastName.toLowerCase() && d1.getTime() == d2.getTime()) {
	                return true;
	            }
	            return false;
	        }
	        function addVehicles(data) {
	            var isVehicleAdded = false;
	            if (typeof data.vehicles !== 'undefined' && data.vehicles.length > 0) {
	                angular.forEach(data.vehicles, function (vehicle) {
	                    var newVehicle = paModel.createVehicle(accountHolder);
	                    newVehicle.paType = vehicle.pAType;
	                    newVehicle.tmpPaType = newVehicle.paType;
	                    newVehicle.vin = vehicle.vin;
	                    $scope.vehicleFlagPrefillArray.push(vehicle.vin); // added Vin Flag *Princy
	                    newVehicle.year = vehicle.modelYear;
	                    newVehicle.make = vehicle.make;
	                    newVehicle.model = vehicle.model;
	                    newVehicle.isGpaQuote = true;
	                    if ('motorcycle_aaa' === vehicle.pAType) {
	                        newVehicle.cCs = vehicle.cCs;
	                        newVehicle.series = vehicle.series;
	                        newVehicle.costNew = {
	                            "amount": undefined
	                        };
	                        newVehicle.costNew.amount = vehicle.basePrice;
	                        newVehicle.bodyStyle = vehicle.bodyStyle;
	                    }
	                    if ('auto' === vehicle.pAType) {
	                        newVehicle.bodyStyle = vehicle.bodyStyle;
	                        newVehicle.cylinder = vehicle.engineCyl;
	                        //newVehicle.costNew.amount = vehicle.priceNewSymbolCd;
	                        newVehicle.comprehensiveSymbolCd = vehicle.comprehensiveSymbolCd;
	                        newVehicle.collisionSymbolCd = vehicle.collisionSymbolCd;
	                        newVehicle.twoDgVSRSymbol = vehicle.twoDgVSRSymbol;
	                        newVehicle.abs = vehicle.abs;
	                        newVehicle.antiTheft = vehicle.antiTheft;
	                        newVehicle.restrInd = vehicle.restrInd;
	                        newVehicle.vehicleSurchargeCd = vehicle.vehicleSurchargeCode;
	                        newVehicle.bodyType = vehicle.bodyType;
	                        newVehicle.paAntiLockBrakes = vehicle.paAntiLockBrakes;
	                        newVehicle.paPassiveRestraint = vehicle.paPassiveRestraint;
	                        newVehicle.paAntiTheft = vehicle.paAntiTheft;
	                    }
	                    newVehicle.isPrefilledVehicle = true;
	                });
	                // added array vehicle *Princy
	                $rootScope.prefillVehiclesArray = $scope.vehicleFlagPrefillArray;
	                $rootScope.prefillDriversArray = $scope.driverFlagPrefillArray;
	                isVehicleAdded = true;
	            }
	            return isVehicleAdded;
	        }
	
	        function navigatingFromDriversPage() {
	            if (typeof navFrom.index !== 'undefined' && parseInt(navFrom.index) > currentStepIndex) {
	                return true;
	            }
	            return false;
	        }
	
	        ctrl.init = function () {
	            var quoteID = submissionVM.quoteID.value;
	            var goToNext = false;
	            var prefillReq = {
	                "submissionNumber": quoteID,
	                "isFromPriorPolicy": false
	            };
	            if (paModel.drivers.length === 0) {
	                //If there are no drivers and this is the first visit, initialise a new driver and also fill in the data obtained from service
	                // Getting Prefill details from factory - INC0019969
	
	                //INC2762580 Remove LN Service Call
	                //    flowModel.next(submissionVM, true);
	                //Un-commenting below part for Data Prefill *Princy
	                var prefillResponseFromFactory = InMemorySession.getPrefillData();
	                if (prefillResponseFromFactory != null && (typeof prefillResponseFromFactory === 'undefined' ? 'undefined' : _typeof(prefillResponseFromFactory)) === 'object' && (typeof prefillResponseFromFactory.drivers !== 'undefined' || typeof prefillResponseFromFactory.vehicles !== 'undefined')) {
	
	                    var driverAdded = addDriver(prefillResponseFromFactory);
	                    var vehicleAdded = addVehicles(prefillResponseFromFactory);
	                    updatePage(paModel, prefillResponseFromFactory);
	                } else {
	
	                    flowModel.next(submissionVM, true);
	                }
	                // Commented below part for INC0019969
	                /*var responsePromise = PrefillService.getDriverVehiclePrefillData(prefillReq);
	                ModalService.showProgressDialog('quoteandbind.controllers.Please wait', responsePromise);
	                responsePromise.then(function (response) {
	                    if (typeof response === 'object' &&
	                        (typeof response.drivers !== 'undefined' || typeof response.vehicles !== 'undefined')) {
	                        const driverAdded = addDriver(response);
	                        const vehicleAdded = addVehicles(response);
	                        updatePage(paModel)
	                    } else {
	                        flowModel.next(submissionVM, true);
	                    }
	                }, function (response) {
	                    flowModel.next(submissionVM, true);
	                })*/
	            } else {
	                var isPageUpdated = updatePage(paModel, null);
	                if (!isPageUpdated) {
	                    navigateFromPage();
	                }
	            }
	        };
	
	        function navigateFromPage() {
	            /*if(navigatingFromDriversPage()){
	                flowModel.previous(submissionVM);
	            }else{*/
	            flowModel.next(submissionVM, true);
	            //}
	        }
	
	        function updatePage(paModel, prefillResponseFromFactory) {
	            $scope.page.drivers = _.filter(paModel.drivers, function (item) {
	                if (typeof item.isPrefilledDriver !== 'undefined' && item.isPrefilledDriver) {
	                    return item;
	                }
	            });
	            if (prefillResponseFromFactory) {
	                $scope.page.drivers.forEach(function (obj) {
	                    var ind = prefillResponseFromFactory.drivers.findIndex(function (driver) {
	                        return driver.firstName == obj.person.firstName && driver.lastName == obj.person.lastName;
	                    });
	                    if (obj.dateOfBirth.year == '' && obj.dateOfBirth.month == '' && obj.dateOfBirth.day == '' && !_.isUndefined(prefillResponseFromFactory.drivers[ind].dateOfBirth)) {
	                        //const x = InMemorySession.decryptData(prefillResponseFromFactory.drivers[ind].eNCDateOfBirth).split(' ')[0].split('-');
	                        var x = prefillResponseFromFactory.drivers[ind].dateOfBirth.split(' ')[0].split('-');
	                        obj['dateOfBirth']['year'] = parseInt(x[0]);
	                        obj['dateOfBirth']['month'] = parseInt(x[1]) - 1;
	                        obj['dateOfBirth']['day'] = parseInt(x[2]);
	                    }
	                });
	            }
	            $scope.page.vehicles = _.filter(paModel.vehicles, function (item) {
	                if (typeof item.isPrefilledVehicle !== 'undefined' && item.isPrefilledVehicle) {
	                    return item;
	                }
	            });
	            return $scope.page.drivers.length > 0 || $scope.page.vehicles.length > 0;
	        }
	
	        ctrl.removeVehicle = function (index) {
	            var vehicle = $scope.page.vehicles[index];
	            //var name = this.make || '';
	            var name = vehicle.year || '';
	            if (this.make) {
	                if (name) {
	                    name += ' ';
	                }
	                name += this.make;
	            }
	            if (vehicle.model) {
	                if (name) {
	                    name += ' ';
	                }
	                name += vehicle.model;
	            }
	
	            var confirmationMsg = {
	                key: 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.RemoveConfirmationMsg',
	                args: { vehicle: name }
	            };
	            ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Remove vehicle?', confirmationMsg, '', $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes'), 'gw-btn-primary', $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.No')).result.then(function () {
	
	                paModel.removeVehicle(vehicle);
	                updatePage(paModel, null);
	            });
	        };
	
	        ctrl.removeDriver = function (index) {
	            var driver = $scope.page.drivers[index];
	            var name = driver.person.firstName + ' ' + driver.person.lastName;
	            var msg = {
	                key: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.DriverRemovalMsg',
	                args: { driver: name }
	            };
	
	            ModalService.showWarning('quoteandbind.pa.controllers.PADriverDetailsCtrl.Remove driver?', msg, '', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.Yes'), 'gw-btn-primary', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.No')).result.then(function () {
	                paModel.removeDriver(driver);
	                updatePage(paModel, null);
	            });
	        };
	
	        ctrl.getAge = function (driver) {
	            if (driver.dateOfBirth) {
	                localDate = driver.dateOfBirth;
	            } else if (driver.eNCDateOfBirth) {
	                var getDate = function getDate(string) {
	                    return function (_ref) {
	                        var _ref2 = _slicedToArray(_ref, 3),
	                            year = _ref2[0],
	                            month = _ref2[1],
	                            day = _ref2[2];
	
	                        return { year: year, month: month, day: day };
	                    }(string.split('-'));
	                };
	                var temDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0];
	                localDate = getDate(temDob);
	            }
	            var year = parseInt(localDate.year);
	            if (isNaN(year)) return '';
	            var month = parseInt(localDate.month) - 1;
	            var day = parseInt(localDate.day);
	            var today = new Date();
	            var birthDate = new Date(year, month, day);
	            var age = today.getFullYear() - birthDate.getFullYear();
	            var m = today.getMonth() - birthDate.getMonth();
	            if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	                age--;
	            }
	            return age;
	        };
	
	        ctrl.next = function (form) {
	            form.submitted = true;
	            flowModel.next(submissionVM);
	        };
	        ctrl.previous = function () {
	            flowModel.previous(submissionVM);
	        };
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        ctrl.continueAction = function (form) {
	            ctrl.next(form);
	        };
	
	        return ctrl.create($scope);
	    };
	    // added '$rootScope' *Princy
	    fn.$inject = ['$filter', '$scope', '$rootScope', '$stateParams', '$state', 'submissionViewModel', 'ModalService', 'PrefillService', '$q', 'StateUtils', 'InMemorySession'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by Ganesh.Sharma on 15-10-2016.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, _) {
	    var fn = function fn($scope, $stateParams, $state, submissionViewModel, ModalService, PrefillService, $q, StateUtils, InMemorySession) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	
	            var today = new Date();
	            $scope.prevCarrierInfo = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo;
	            $scope.prevCarrierInfo.value = $scope.prevCarrierInfo.value || {};
	            $scope.today = new Date();
	            $scope.today.setHours(0, 0, 0, 0);
	
	            $scope.retrievePrevCarrierInfo = submissionVM.draftData.retrievePrevCarrierInfo;
	            $scope.retrievePrevCarrierInfo.value = $scope.retrievePrevCarrierInfo.value || {};
	
	            var otherOption = _.find($scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues, function (limit) {
	                return limit.code == "Other";
	            });
	            $scope.insuranceCarriers = _.filter($scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues, function (limit) {
	                return limit.code != "Other";
	            });
	            $scope.insuranceCarriers.push(otherOption);
	            /* ENHC0011961_EODB QnB Defaults -added code for defaulting insurance information -- Arpita Sengupta */
	            var insuranceCarriersArr = $scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues;
	            var priorBILimitArr = $scope.prevCarrierInfo.priorBILimits.aspects.availableValues;
	            //defaulting insuranceCarriers
	            for (var insC = 0; insC <= insuranceCarriersArr.length; insC++) {
	                if (insuranceCarriersArr[insC] && insuranceCarriersArr[insC].code && insuranceCarriersArr[insC].code == "Other") {
	                    $scope.prevCarrierInfo.insuranceCarriers = insuranceCarriersArr[insC].code;
	                }
	            }
	            //defaulting priorBILimits
	            for (var priorBIL = 0; priorBIL <= priorBILimitArr.length; priorBIL++) {
	                if (priorBILimitArr[priorBIL] && priorBILimitArr[priorBIL].code && priorBILimitArr[priorBIL].code == "100_300") {
	                    $scope.prevCarrierInfo.priorBILimits = priorBILimitArr[priorBIL].code;
	                }
	            }
	            /*ended*/
	            $scope.policyStatusValue = {
	                "I have Insurance": "I have Insurance",
	                "I don't have Insurance": "I don't have Insurance",
	                "My Insurance cancelled or expired": "My Insurance cancelled or expired"
	            };
	            /* ENHC0011961_EODB QnB Defaults -- Arpita Sengupta */
	            if ($scope.policyStatusValue["I have Insurance"] !== undefined) {
	                $scope.prevCarrierInfo.portalStatus = $scope.policyStatusValue["I have Insurance"];
	            }
	            /*ended*/
	            $scope.lapsePeriod = today.setHours(720, 0, 0, 0);
	
	            var quoteID = submissionVM.quoteID.value;
	            var prefillReq = {
	                "submissionNumber": quoteID,
	                "isFromPriorPolicy": true
	            };
	
	            if ($scope.retrievePrevCarrierInfo.value.policyStatus != null) {
	                if ($scope.retrievePrevCarrierInfo.value.policyStatus == 'Active') {
	                    $scope.prevCarrierInfo.portalStatus.value = "I have Insurance";
	                } else if ($scope.retrievePrevCarrierInfo.value.policyStatus == 'NoPrior') {
	                    $scope.prevCarrierInfo.portalStatus.value = "I don't have Insurance";
	                } else {
	                    $scope.prevCarrierInfo.portalStatus.value = "My Insurance cancelled or expired";
	                }
	                $scope.prevCarrierInfo.insuranceCarriers.value = $scope.retrievePrevCarrierInfo.value.insuranceCarriers;
	                $scope.prevCarrierInfo.expirationDate.value = $scope.retrievePrevCarrierInfo.value.expirationDate;
	                $scope.prevCarrierInfo.priorBILimits = $scope.retrievePrevCarrierInfo.value.priorBILimits;
	            }
	            //INC2762580 Remove LN Service Call
	            //Un-commenting below else part for Data Prefill *Princy
	            //else {
	            var responsePromise = PrefillService.getDriverVehiclePrefillData(prefillReq);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', responsePromise);
	            responsePromise.then(function (response) {
	                // Setting the prefill data in Factory for reuse - INC0019969
	                if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && response != null) {
	                    // decrypting prefill data start devendra
	                    if (typeof response.drivers !== 'undefined' && response.drivers.length > 0) {
	                        for (idx = 0; idx < response.drivers.length; idx++) {
	                            if (response.drivers[idx].eNCDateOfBirth != null && typeof response.drivers[idx].eNCDateOfBirth !== 'undefined') {
	                                var temDob = InMemorySession.decryptData(response.drivers[idx].eNCDateOfBirth).split(' ')[0] + "T05:00:00Z";
	                                var dob = new Date(temDob);
	                                response.drivers[idx].dateOfBirth = dob;
	                            }
	                            if (response.drivers[idx].eNCGender != null && typeof response.drivers[idx].eNCGender !== 'undefined') {
	                                // prefill --Arpita
	                                response.drivers[idx].gender = InMemorySession.decryptData(response.drivers[idx].eNCGender) ? response.drivers[idx].eNCGender : InMemorySession.decryptData(response.drivers[idx].eNCGender);
	                            }
	                            if (response.drivers[idx].eNCLicenseNumber != null && typeof response.drivers[idx].eNCLicenseNumber !== 'undefined') {
	                                response.drivers[idx].licenseNumber = InMemorySession.decryptData(response.drivers[idx].eNCLicenseNumber) ? response.drivers[idx].eNCLicenseNumber : InMemorySession.decryptData(response.drivers[idx].eNCLicenseNumber);
	                            }
	                            if (response.drivers[idx].eNCLicenseState != null && typeof response.drivers[idx].eNCLicenseState !== 'undefined') {
	                                response.drivers[idx].licenseState = InMemorySession.decryptData(response.drivers[idx].eNCLicenseState) ? response.drivers[idx].eNCLicenseState : InMemorySession.decryptData(response.drivers[idx].eNCLicenseState);
	                            }
	                        }
	                    }
	                    if (typeof response.vehicles !== 'undefined' && response.vehicles.length > 0) {
	                        for (idxv = 0; idxv < response.vehicles.length; idxv++) {
	                            if (response.vehicles[idxv].encryptedVIN != null && typeof response.vehicles[idxv].encryptedVIN !== 'undefined') {
	                                response.vehicles[idxv].vin = InMemorySession.decryptData(response.vehicles[idxv].encryptedVIN) ? response.vehicles[idxv].encryptedVIN : InMemorySession.decryptData(response.vehicles[idxv].encryptedVIN);
	                            }
	                        }
	                    }
	                    // decrypting prefill data end devendra
	                    InMemorySession.setPrefillData(response);
	                }
	                if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && typeof response.priorPolicies !== 'undefined') {
	                    if (response.priorPolicies[0].policyStatus == 'Active' || response.priorPolicies[0].policyStatus == 'IN-EFFECT' || response.priorPolicies[0].policyStatus == 'in-effect' || response.priorPolicies[0].policyStatus == 'active') {
	                        $scope.prevCarrierInfo.portalStatus.value = "I have Insurance";
	                    } else if (response.priorPolicies[0].policyStatus == 'NoPrior') {
	                        $scope.prevCarrierInfo.portalStatus.value = "I don't have Insurance";
	                    } else {
	                        $scope.prevCarrierInfo.portalStatus.value = "My Insurance cancelled or expired";
	                    }
	                    $scope.prevCarrierInfo.insuranceCarriers.value = response.priorPolicies[0].carrier;
	                    $scope.prevCarrierInfo.expirationDate.value = response.priorPolicies[0].expirationDate;
	                    $scope.prevCarrierInfo.effectiveDate.value = response.priorPolicies[0].effectiveDate;
	                    $scope.prevCarrierInfo.policyNumber.value = response.priorPolicies[0].policyNumber;
	                    $scope.prevCarrierInfo.priorBILimits = response.priorPolicies[0].priorBILimit;
	                }
	            });
	            //}
	
	        };
	
	        ctrl.next = function (form) {
	
	            // PC Mapping corresponding to the policy status type list, based on validations
	
	            if ($scope.prevCarrierInfo.portalStatus.value == "My Insurance cancelled or expired" && new Date($scope.prevCarrierInfo.expirationDate.value).getDate() < $scope.lapsePeriod) {
	                $scope.prevCarrierInfo.policyStatus = "Lapse30Less";
	            }
	            if ($scope.prevCarrierInfo.portalStatus.value == "My Insurance cancelled or expired" /*&& $scope.prevCarrierInfo.expirationDate.value !== null*/
	            && new Date($scope.prevCarrierInfo.expirationDate.value).getDate() > $scope.lapsePeriod) {
	                $scope.prevCarrierInfo.policyStatus = "Lapse30DaysMore";
	            }
	            if ($scope.prevCarrierInfo.portalStatus.value == "I have Insurance") {
	                $scope.prevCarrierInfo.policyStatus = "Active";
	                $scope.prevCarrierInfo.expirationDate = undefined;
	            }
	
	            if ($scope.prevCarrierInfo.portalStatus.value == "I don't have Insurance") {
	                $scope.prevCarrierInfo.policyStatus = "NoPrior";
	                $scope.prevCarrierInfo.expirationDate = undefined;
	                $scope.prevCarrierInfo.insuranceCarriers = undefined;
	                $scope.prevCarrierInfo.priorBILimits = undefined;
	            }
	
	            /*if($scope.prevCarrierInfo.priorBILimits.value == "Other"){
	                $scope.prevCarrierInfo.priorBILimits = "MinimumLimits";
	            }*/
	
	            InMemorySession.setBiLimits($scope.prevCarrierInfo.priorBILimits.value);
	            form.submitted = true;
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel', 'ModalService', 'PrefillService', '$q', 'StateUtils', 'InMemorySession'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn($filter, $scope, $rootScope, $translate, $anchorScroll, ModalService, StateUtils, submissionViewModel, InMemorySession, InputValidationService) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVm = submissionViewModel();
	        //adding a listener function that will be called while navigating from one Step to another
	        flowModel.addStepChangeListener(deleteCorruptNode);
	        var paModel = submissionVm.draftData.lobs.personalAuto.value;
	        var accountHolder = submissionVm.value.getAccountHolderPerson();
	        $scope.currentPageName = flowModel.currentStep.name;
	        var flowSteps = flowModel.steps;
	        var currentStepIndex = _.findIndex(flowSteps, function (step) {
	            return step.name === flowModel.currentStep.name;
	        });
	        //ENHC0013007 -- Insurance Premium Refunds --Arpita
	        $scope.isNameValid = true;
	        //ended
	        //This method will delete any invalid driver node from model
	        //when navigating from the driver's page using Wizard menu and NOT next button
	        //Currently checking for both Driver and vehicle node coming from prefill service
	
	
	        function deleteCorruptNode(model, fromStep, goingToStep) {
	            var goingToStepIndex = _.findIndex(flowSteps, function (step) {
	                return step.name === goingToStep.name;
	            });
	            var isGoingNextPage = goingToStepIndex === currentStepIndex + 1;
	            if ($scope.currentPageName === fromStep.name && !isGoingNextPage) {
	                //validate all the drivers that are in viewmodel
	                var corruptedDrivers = [];
	                var drivers = model.draftData.lobs.personalAuto.drivers;
	                if (typeof drivers != 'undefined' && drivers.length > 0) {
	                    _.forEach(drivers, function (item, index) {
	                        if (!drivers.getElement(index).aspects.subtreeValid) {
	                            corruptedDrivers.push(drivers.getElement(index).value);
	                        }
	                    });
	                }
	
	                _.forEach(corruptedDrivers, function (driver) {
	                    model.draftData.lobs.personalAuto.value.removeDriver(driver);
	                });
	
	                //remove the vehicles also if all the drivers are removed
	                //validating vehicle node
	                if (model.draftData.lobs.personalAuto.drivers.length === 0) {
	                    model.draftData.lobs.personalAuto.vehicles.value = [];
	                }
	                var corruptedVehicles = [];
	                var vehicles = model.draftData.lobs.personalAuto.vehicles;
	                if (typeof vehicles != 'undefined' && vehicles.length > 0) {
	                    _.forEach(vehicles, function (item, index) {
	                        if (!vehicles.getElement(index).aspects.subtreeValid) {
	                            corruptedVehicles.push(vehicles.getElement(index).value);
	                        }
	                    });
	                }
	
	                _.forEach(corruptedVehicles, function (vehicle) {
	                    model.draftData.lobs.personalAuto.value.removeVehicle(vehicle);
	                });
	            }
	        }
	
	        function validateInputs(inputsToValidate, scopeVar) {
	            var inputValidationData = [];
	            inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	            if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                for (var i = 0; i < inputValidationData[1].length; i++) {
	                    scopeVar[inputValidationData[1][i]] = '';
	                    $scope.isNameValid = false;
	                }
	            } else {
	                $scope.isNameValid = true;
	            }
	        }
	
	        ctrl.init = function () {
	            var prefillResponseFromFactory = InMemorySession.getPrefillData();
	            // Scroll to top of page onload
	            $anchorScroll();
	
	            // State Code for account holder
	            $scope.accountHolder = accountHolder;
	
	            // Fill prefill vehicles
	            var prefillVehicles = [];
	            if (paModel.vehicles && paModel.vehicles.length > 0) {
	                for (var idx in paModel.vehicles) {
	                    if (paModel.vehicles[idx]["isPrefilledVehicle"] == true) {
	                        prefillVehicles.push(paModel.vehicles[idx]);
	                    }
	                }
	            }
	            //devendra prefill code started
	            if (paModel.drivers && paModel.drivers.length > 0 && prefillResponseFromFactory && typeof prefillResponseFromFactory.drivers !== "undefined") {
	                for (var idxDriver in paModel.drivers) {
	                    paModel.drivers[parseInt(idxDriver)].hasPrefilledLicenseNumber = false;
	                    if (paModel.drivers[parseInt(idxDriver)].eNCLicenseNumber != "undefined" && paModel.drivers[parseInt(idxDriver)].eNCLicenseNumber != '') {
	                        paModel.drivers[parseInt(idxDriver)].hasPrefilledLicenseNumber = true;
	                    }
	                    if (typeof paModel.drivers[parseInt(idxDriver)] != "undefined" && prefillResponseFromFactory.drivers.length > 0) {
	                        $scope.prefillDriverCheck(paModel.drivers[idxDriver], parseInt(idxDriver), prefillResponseFromFactory);
	                    }
	                }
	            }
	            //devendra prefill code end
	            $scope.$filter = $filter;
	            $scope.page = {
	                drivers: paModel.drivers,
	                prefillVehicles: prefillVehicles,
	                vehicles: paModel.vehicles
	            };
	
	            var currentDriver = void 0;
	            if (paModel.drivers.length === 0) {
	                //If there are no drivers and this is the first visit, initialise a new driver
	                currentDriver = paModel.createDriver(accountHolder);
	            } else {
	                //Select account holder
	                //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
	                var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(driver) {
	                    if (driver.licenseNumber === '0streamlinedquote0') {
	                        driver.licenseNumber = undefined;
	                        driver.yearLicensed = undefined;
	                        driver.gender = undefined;
	                    }
	                };
	                currentDriver = paModel.getDriverForPerson(accountHolder);
	                sanitisePrefillDataFromQuickQuote(currentDriver);
	            }
	            /* ENHC0011961_EODB QnB Defaults - defaulting licensed age for first driver -- Arpita Sengupta */
	            if (paModel.drivers.length <= 1) {
	                currentDriver.firstLicensed = "16";
	            }
	            //ended
	            $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(currentDriver);
	
	            // added below code for getting age *Princy
	            $scope.age = $scope.getAge($scope.page.currentDriver.dateOfBirth);
	
	            //submissionVm.draftData.lobs.personalAuto.drivers.forEach(driver -> driver.age = getAge(driver.dateofBirth))
	            //added code for drivers DOB *Princy
	            submissionVm.draftData.lobs.personalAuto.drivers.forEach(function (driver) {
	                if (driver.dateofBirth != undefined) {
	                    $scope.age = $scope.getAge(driver.dateofBirth);
	                }
	            });
	
	            //$scope.page.currentDriver.relationShipToYou.value = "Spouse";
	            //console.log("RelationShip: ", $scope.page.currentDriver.relationShipToYou.value);
	        };
	
	        // *Princy*
	        $scope.getAge = function (localDate) {
	
	            var year = parseInt(localDate.year);
	            if (isNaN(year)) return '';
	            var month = parseInt(localDate.month) - 1;
	            var day = parseInt(localDate.day);
	            var today = new Date();
	            var birthDate = new Date(year, month, day);
	            var age = today.getFullYear() - birthDate.getFullYear();
	            var m = today.getMonth() - birthDate.getMonth();
	            if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	                age--;
	            }
	            return age ? age : null;
	        };
	        //devendra prefill code started
	        $scope.prefillDriverCheck = function (driver, index, prefillResponseFromFactory) {
	            var isPrefilledDriverCheck = false;
	            if (prefillResponseFromFactory && prefillResponseFromFactory.drivers) {
	                prefillResponseFromFactory.drivers.forEach(function (obj) {
	                    if (driver.person.firstName !== "undefined" && obj.dateOfBirth) {
	                        var d1 = {};
	                        if (driver.dateOfBirth) {
	                            d1 = new Date(driver.dateOfBirth.year, driver.dateOfBirth.month, driver.dateOfBirth.day);
	                        } else if (driver.eNCDateOfBirth) {
	                            var encDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0].split("-");
	                            d1 = new Date(encDob[0], encDob[1] - 1, encDob[2]);
	                        }
	                        var d2 = obj.dateOfBirth;
	                        d2.setHours(0, 0, 0, 0);
	                        if (driver.person.firstName.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()) {
	                            //prefill --Arpita
	                            paModel.drivers[index].eNCGender = paModel.drivers[index].eNCGender ? paModel.drivers[index].eNCGender : paModel.drivers[index].gender;
	
	                            paModel.drivers[index].eNCDateOfBirth = paModel.drivers[index].eNCDateOfBirth ? paModel.drivers[index].eNCDateOfBirth : paModel.drivers[index].dateOfBirth;
	                            //DFCT0019638 - added condition when giving random data and drivers have 1 prefilled and other non prefilled and license no for prefilled is not present - Arpita
	                            paModel.drivers[index].eNCLicenseNumber = paModel.drivers[index].eNCLicenseNumber ? paModel.drivers[index].eNCLicenseNumber : !InMemorySession.decryptData(paModel.drivers[index].licenseNumber) && paModel.drivers[index].licenseNumber ? InMemorySession.encryptData(paModel.drivers[index].licenseNumber).toString() : paModel.drivers[index].licenseNumber;
	                            //ended
	
	                            paModel.drivers[index].eNCLicenseState = paModel.drivers[index].eNCLicenseState ? paModel.drivers[index].eNCLicenseState : paModel.drivers[index].licenseState;
	                            paModel.drivers[index].licenseNumber = null;
	                            paModel.drivers[index].gender = null;
	                            paModel.drivers[index].licenseState = null;
	
	                            isPrefilledDriverCheck = true;
	                        }
	                    }
	                });
	            }
	            if (isPrefilledDriverCheck) {
	                paModel.drivers[index].isPrefilledDriver = true;
	            } else {
	                paModel.drivers[index].isPrefilledDriver = false;
	            }
	        };
	        //devendra prefill code end
	
	        ctrl.isDriverValid = function () {
	            return $scope.page.currentDriver.aspects.subtreeValid;
	        };
	
	        ctrl.addDriver = function (form) {
	            if (ctrl._isValid(form)) {
	                $anchorScroll();
	                //ENHC0013007 -- Insurance Premium Refunds --Arpita
	                //security vulnerabilities
	                var inputsToValidate = [{ 'firstName': $scope.page.currentDriver.value.person.firstName }, { 'middleName': $scope.page.currentDriver.value.person.middleName }, { 'lastName': $scope.page.currentDriver.value.person.lastName }];
	                validateInputs(inputsToValidate, $scope.page.currentDriver.value.person);
	                if (!$scope.isNameValid) {
	                    return;
	                }
	                //ended
	                var paddr = submissionVm.draftData.policyAddress.value;
	                var newPerson = submissionVm.value.createPerson({
	                    primaryAddress: paddr
	                });
	                /* ENHC0011961_EODB QnB Defaults - defaulting state while adding driver -- Arpita Sengupta */
	                newPerson.primaryAddress = {
	                    state: paddr.state
	                };
	                //ended
	                var newDriver = paModel.createDriver(newPerson);
	
	                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(newDriver);
	                /**
	                * Defect : DFCT0016955 - GPA – SC Auto Date First Licensed Rules no Longer Working (reference CHG00328640)
	                * Developer : Devnandan Kumar*/
	                if ($scope.page.currentDriver.accountHolderState.value.code === 'SC') {
	                    $scope.page.currentDriver.minAge.value = 15;
	                } else {
	                    $scope.page.currentDriver.minAge.value = 16;
	                }
	                $scope.$broadcast('update-form');
	                form.submitted = false;
	                form.setPristine();
	            } else {
	
	                form.submitted = true;
	                if (!ctrl._isValid() || form.valid === false) {
	                    return;
	                }
	            }
	        };
	
	        ctrl.editDriver = function (driver, form, rowIndex) {
	            //Validate the current input, and if correct, save the current changes and select the next driver
	            $scope.selectedRow = rowIndex;
	
	            if (ctrl._isValid(form)) {
	                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driver);
	                if (typeof $scope.currentDriver != 'undefined') {
	                    $scope.age = $scope.getAge($scope.currentDriver.dateOfBirth.value); //age functionality call *Princy
	                } else {
	                    $scope.age = null;
	                }
	                //console.log($scope.age);
	            } else {
	
	                form.submitted = true;
	                if (!ctrl._isValid() || form.valid === false) {
	                    return;
	                }
	            }
	        };
	
	        ctrl.removeDriver = function (driver) {
	            var msg = {
	                key: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.DriverRemovalMsg',
	                args: { driver: driver.getDisplayName(undefined, $filter) }
	            };
	            ModalService.showWarning('quoteandbind.pa.controllers.PADriverDetailsCtrl.Remove driver?', msg, '', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.Yes'), 'gw-btn-primary', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.No')).result.then(function () {
	                //If block commented by IN010M58288 for production issue raised by Vijay Mallik Reddy
	                /*if (driver === $scope.page.currentDriver.value) {
	                    $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(paModel.drivers[0]);
	                }*/
	                // Start Below code added by IN010M58288 for production issue raised by Vijay Mallik Reddy
	                var driverObj = void 0;
	                if (submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driver) === $scope.page.currentDriver) {
	                    //If we're about to delete the current vehicle, show the first vehicle or blank
	                    if (paModel.drivers.length > 1) {
	                        if (paModel.drivers[0] !== driver) {
	                            driverObj = paModel.drivers[0];
	                        } else {
	                            driverObj = paModel.drivers[1];
	                        }
	                    }
	                } else {
	                    driverObj = $scope.page.currentDriver.value;
	                }
	                // End Below code added by IN010M58288 for production issue raised by Vijay Mallik Reddy
	                paModel.removeDriver(driver);
	                $scope.page.currentDriver = submissionVm.draftData.lobs.personalAuto.drivers.findFirstElement(driverObj); // Added by IN010M58288 for production issue raised by Vijay Mallik Reddy
	                $scope.$broadcast('update-form');
	            });
	        };
	
	        ctrl._isValid = function () {
	            if (!ctrl.isDriverValid()) {
	                return false;
	            }
	
	            //console.log("_isAddAccidentValid:: ",$scope.page.currentDriver.value.accidentsInLast3Years, $scope.page.currentDriver.value.accidentVoilationList.length);
	
	            // Check if accident/ claim summary selected and with no accident / claim summary is defined
	            if ($scope.page.currentDriver.value.accidentsInLast3Years == true && $scope.page.currentDriver.value.accidentVoilationList.length == 0) {
	                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Please specify the type and date of the event");
	
	                return false;
	            }
	
	            var licenceMatchedDriver = ctrl._ensureUniqueLicenseNumber($scope.page.currentDriver.value);
	            if (licenceMatchedDriver) {
	                var msg = $translate('quoteandbind.pa.controllers.PADriverDetailsCtrl.LicenceMatchMsg', { driver: licenceMatchedDriver.getDisplayName(undefined, $filter) });
	                ModalService.showWarning('quoteandbind.pa.controllers.PADriverDetailsCtrl.Licence number is not unique', msg);
	
	                return false;
	            }
	            return true;
	        };
	
	        ctrl._ensureUniqueLicenseNumber = function (driver) {
	            var driverMatch = _.where(paModel.drivers, { licenseNumber: driver.licenseNumber });
	            if (!driverMatch) {
	                return undefined;
	            } else if (driverMatch.length === 1) {
	                return driverMatch[0] !== driver ? driverMatch : undefined;
	            }
	            return _.find(driverMatch, function (d) {
	                if (d.licenseNumber != "" && d.licenseNumber != undefined) {
	                    return d !== driver;
	                }
	            });
	        };
	
	        // Find Primary Driver
	        ctrl.findPrimaryDriver = function () {
	
	            var drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
	
	            for (var idx in drivers) {
	                var driver = drivers[idx];
	                if (driver.person.accountHolder) {
	                    return driver;
	                }
	            }
	        };
	
	        // Validate spouse is selected for primary insurer if he is married
	        ctrl.validateSpouse = function () {
	
	            var primaryDriver = ctrl.findPrimaryDriver();
	
	            // TypeList code needs to be changed
	            if (primaryDriver.maritialStatus != "M") {
	                return true;
	            }
	
	            var drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
	            var spouseFound = false;
	
	            for (var idx in drivers) {
	                var driver = drivers[idx];
	                //console.log("driver.relationShip:: ",driver.relationShip);
	                if (driver.relationShip == "Spouse") {
	                    spouseFound = true;
	                }
	            }
	
	            return spouseFound;
	        };
	
	        // DFCT0022696: Marital status on SC Renewal flipped from married to single: Rate bearing issue--Arpita
	        ctrl.validAdditionalDriverdRel = function () {
	            var primaryDriver = ctrl.findPrimaryDriver();
	            var validrel = true;
	            var drivers = submissionVm.value.draftData.lobs.personalAuto.drivers;
	
	            for (var idx in drivers) {
	                var driver = drivers[idx];
	
	                if (primaryDriver.maritialStatus == "S" && driver.relationShip == "Spouse") {
	                    //if named insured has a marital status single and additional driver who is selected as spouse of named insured has a marital status married or single don't allow user to move to next screen
	                    if (driver.maritialStatus == "M" || driver.maritialStatus == "S") {
	                        validrel = false;
	                    }
	                }
	                //if named insured has a marital status married and additional driver who is selected as spouse of named insured has a marital status single don't allow user to move to next screen
	                if (primaryDriver.maritialStatus == "M") {
	                    if (driver.maritialStatus == "S" && driver.relationShip == "Spouse") {
	                        validrel = false;
	                    }
	                }
	            }
	
	            return validrel;
	        }; //end
	
	        ctrl.next = function (form) {
	
	            form.submitted = true;
	
	            //console.log("Driver Screen Form:: ",form);
	
	            if (!ctrl._isValid() || form.valid === false) {
	                return;
	            }
	
	            var spouseValidStatus = ctrl.validateSpouse();
	            // if spouse not found not allow user to move to next screen
	            if (spouseValidStatus === false) {
	                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Relationship to you message");
	                return;
	            }
	
	            // DFCT0022696: Marital status on SC Renewal flipped from married to single: Rate bearing issue--Arpita
	            var validAddDriverRel = ctrl.validAdditionalDriverdRel();
	            if (validAddDriverRel === false) {
	                ModalService.showWarning('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Relationship to you message");
	                return;
	            }
	
	            // Check all driver are valid
	            /*for(var idx in $scope.page.drivers){
	                var driver = $scope.page.drivers[idx];
	                console.log("Check Valid Driver: ",driver);
	                if(driver.aspects.subtreeValid == false){
	                    console.log("Invalid Driver:: ",driver.value);
	                }
	            }  */
	
	            // Enable this line if want to validate all drivers form vaild status
	            if (!submissionVm.draftData.lobs.personalAuto.drivers.aspects.subtreeValid) {
	                ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Driver Validation Error");
	                return;
	            }
	            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	            var isDobEmpty = false;
	            var isDOBValid = true;
	            var drivers = submissionVm.draftData.lobs.personalAuto.drivers.value;
	            if (typeof drivers != 'undefined' && drivers.length > 0) {
	                _.forEach(drivers, function (item, index) {
	                    if (item && !item.dateOfBirth) {
	                        ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Driver Validation Error");
	                        isDobEmpty = true;
	                    }
	                    if (item.dateOfBirth && item.dateOfBirth.year && item.dateOfBirth.year < "1800") {
	                        item.dateOfBirth.value = '';
	                        isDOBValid = false;
	                        return;
	                    }
	                    //ENHC0013007 -- Insurance Premium Refunds --Arpita
	                    var inputsToValidate = [{ 'firstName': item.person.firstName }, { 'middleName': item.person.middleName }, { 'lastName': item.person.lastName }];
	                    validateInputs(inputsToValidate, item.person);
	                    //ended
	                });
	                if (!$scope.isNameValid) {
	                    return;
	                }
	                if (isDobEmpty || !isDOBValid) {
	                    return;
	                }
	                //ENHC0013007 -- Insurance Premium Refunds --Arpita
	                if (!$scope.isNameValid) {
	                    return;
	                } //ended
	            }
	            //DFCT0020397 - QnB Date Of Birth Validation ends
	
	            flowModel.next(submissionVm);
	        };
	        ctrl.previous = function () {
	            flowModel.previous(submissionVm);
	        };
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVm);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$filter', '$scope', '$rootScope', '$translate', '$anchorScroll', 'ModalService', 'StateUtils', 'submissionViewModel', 'InMemorySession', 'qnb.InputValidationService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn($filter, $scope, $translate, $anchorScroll, ModalService, StateUtils, submissionViewModel, editableDriverDOB, $rootScope, availableYears, InMemorySession, InputValidationService) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVm = submissionViewModel();
	        var paModel = submissionVm.draftData.lobs.personalAuto.value;
	        var paModelVM = submissionVm.draftData.lobs.personalAuto;
	        var accountHolder = submissionVm.value.getAccountHolderPerson();
	
	        ctrl.init = function () {
	            // Scroll to top of page 
	            $anchorScroll();
	            //ENHC0013007 -- Insurance Premium Refunds --Arpita
	            $scope.isNameValid = true;
	            //ended
	            $scope.page = {
	                readonly: false
	            };
	            var selectedVehicle = void 0;
	
	            $scope.vehicles = paModel.vehicles;
	            $scope.drivers = paModel.drivers;
	            $scope.quoteID = submissionVm.quoteID;
	
	            //populate vehicle primary usage
	            for (var idx in paModel.vehicles) {
	                var vehicle = paModel.vehicles[idx];
	                //devendra prefill code start
	                if (!paModel.vehicles[idx].vin && paModel.vehicles[idx].encryptedVIN) {
	                    paModel.vehicles[idx].vin = paModel.vehicles[idx].encryptedVIN;
	                }
	                prefillVehicleCheck(vehicle, parseInt(idx));
	                //devendra prefill code end
	                if (vehicle.primaryUse != undefined) {
	
	                    //$scope.vehicle.tmpPrimeUse.value = "less10"
	                    if (vehicle.primaryUse == "commuting") {
	                        if (vehicle.commutingMiles == 5) {
	                            vehicle.tmpPrimeUse = "less10";
	                        } else if (vehicle.commutingMiles == 15) {
	                            vehicle.tmpPrimeUse = "more10";
	                        }
	                    } else if (vehicle.primaryUse == "pleasure") {
	                        vehicle.tmpPrimeUse = "Personal";
	                    } else {
	                        vehicle.tmpPrimeUse = "Business";
	                    }
	                }
	            }
	
	            // Populate available year list from resolve, populate the list
	            // and pass on to vehicle directive -> PAEdiVehicle.js
	            $scope.availableYears = [];
	            if (availableYears.jsonOutputString) {
	                // check for valid server response
	                var availYearArr = JSON.parse("[" + availableYears.jsonOutputString + "]");
	                for (var idx = 0; idx < availYearArr[0].length; idx++) {
	                    var year = availYearArr[0][idx];
	                    $scope.availableYears.push(parseInt(year.trim()));
	                }
	            }
	
	            /**
	             *  If there are no vehicles in the table, initialise an empty vehicle to be populated,
	             *  otherwise on first enter, when there are vehicles, pick the first one from the array.
	             */
	            if (paModel.vehicles.length === 0) {
	                selectedVehicle = paModel.createVehicle(accountHolder);
	            } else {
	                selectedVehicle = paModel.vehicles[0];
	            }
	
	            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
	            var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(vehicles) {
	                var vehicle = _.findWhere(vehicles, { license: '0streamlinedquote0' });
	                if (angular.isDefined(vehicle)) {
	                    vehicle.license = undefined;
	                    vehicle.costNew.amount = undefined;
	                    if (vehicle.vin === '0streamlinedquote0') {
	                        vehicle.vin = undefined;
	                    }
	                }
	            };
	            sanitisePrefillDataFromQuickQuote(paModel.vehicles);
	
	            $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(selectedVehicle);
	        };
	
	        function validateInputs(inputsToValidate, scopeVar) {
	            var inputValidationData = [];
	            inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	            if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                for (var i = 0; i < inputValidationData[1].length; i++) {
	                    scopeVar[inputValidationData[1][i]] = '';
	                    $scope.isNameValid = false;
	                }
	            } else {
	                $scope.isNameValid = true;
	            }
	        }
	        ctrl.addVehicle = function (form) {
	            if (ctrl._isValid(form)) {
	                //ENHC0013007 -- Insurance Premium Refunds --Arpita
	                if ($scope.page.selectedVehicle.value.addnlInterest != undefined) {
	                    var inputsToValidate = [{ 'name': $scope.page.selectedVehicle.value.addnlInterest.name }, { 'addnlInterestAddress.addressLine1': $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.addressLine1 }, { 'addnlInterestAddress.addressLine2': $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.addressLine2 }, { 'addnlInterestAddress.city': $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.city }];
	                    validateInputs(inputsToValidate, $scope.page.selectedVehicle.value.addnlInterest);
	                    if (!$scope.isNameValid) {
	                        return;
	                    }
	                }
	                //ended
	                var newVehicle = paModel.createVehicle();
	                $anchorScroll();
	                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(newVehicle);
	                $scope.page.readonly = false;
	                $scope.$broadcast('update-form');
	                form.submitted = false;
	                form.setPristine();
	                form.$setUntouched();
	            }
	        };
	        //devendra prefill code start
	        function prefillVehicleCheck(vehicle, index) {
	            var prefillResponseFromFactory = InMemorySession.getPrefillData();
	            if (prefillResponseFromFactory !== "undefined" && typeof prefillResponseFromFactory.vehicles !== "undefined" && prefillResponseFromFactory.vehicles.length > 0) {
	                prefillResponseFromFactory.vehicles.forEach(function (obj) {
	                    if (obj.vin == vehicle.vin || obj.vin == InMemorySession.encryptData(vehicle.vin)) {
	                        $scope.vehicles[index].isPrefilledVehicle = true;
	                        paModel.vehicles[index].encryptedVIN = paModel.vehicles[index].encryptedVIN ? paModel.vehicles[index].encryptedVIN : paModel.vehicles[index].vin;
	                        paModel.vehicles[index].vin = InMemorySession.decryptData(paModel.vehicles[index].vin);
	                    }
	                });
	            }
	        };
	        //devendra prefill code end
	
	        ctrl.removeVehicle = function (vehicle) {
	            var confirmationMsg = {
	                key: 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.RemoveConfirmationMsg',
	                args: { vehicle: vehicle.getDisplayName(undefined, $filter) }
	            };
	            ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Remove vehicle?', confirmationMsg, '', $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes'), 'gw-btn-primary', $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.No')).result.then(function () {
	                var vehicleObj = void 0;
	                if (submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicle) === $scope.page.selectedVehicle) {
	                    //If we're about to delete the current vehicle, show the first vehicle or blank
	                    if (paModel.vehicles.length > 1) {
	                        if (paModel.vehicles[0] !== vehicle) {
	                            vehicleObj = paModel.vehicles[0];
	                        } else {
	                            vehicleObj = paModel.vehicles[1];
	                        }
	                    }
	                } else {
	                    vehicleObj = $scope.page.selectedVehicle.value;
	                }
	                paModel.removeVehicle(vehicle);
	                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicleObj);
	                $scope.$broadcast('update-form');
	            });
	        };
	
	        ctrl.isVehicleValid = function (form) {
	            form.submitted = true;
	            if ($scope.page.selectedVehicle.tmpPrimeUse.value === undefined || $scope.page.selectedVehicle.tmpPrimeUse.value === null) {
	                return false;
	            }
	            if ($scope.page.selectedVehicle.tmpPaType.value == "auto" && ($scope.page.selectedVehicle.comprehensiveSymbolCd.value === undefined || $scope.page.selectedVehicle.comprehensiveSymbolCd.value == "") && ($scope.page.selectedVehicle.collisionSymbolCd.value === undefined || $scope.page.selectedVehicle.collisionSymbolCd.value == "") && ($scope.page.selectedVehicle.twoDgVSRSymbol.value === undefined || $scope.page.selectedVehicle.twoDgVSRSymbol.value == "") && ($scope.page.selectedVehicle.costNew.amount.value === undefined || $scope.page.selectedVehicle.costNew.amount.value == "")) {
	                return false;
	            }
	            if ($scope.page.selectedVehicle.tmpPaType.value == "motorcycle_aaa" && ($scope.page.selectedVehicle.costNew.amount.value === undefined || $scope.page.selectedVehicle.costNew.amount.value == "")) {
	                return false;
	            }
	            if ($scope.page.selectedVehicle.tmpPaType.value == "auto" && ($scope.page.selectedVehicle.tmpOwnership.value == "additionalinterest_aaa" || $scope.page.selectedVehicle.tmpOwnership.value == "LOSSP" && $scope.page.selectedVehicle.tmpOwnership.value != "Own") && ($scope.page.selectedVehicle.addnlInterest.name.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.name.value.trim() == "" || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.addressLine1.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.addressLine1.value.trim() == "" || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.postalCode.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.postalCode.value.trim() == "" || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.city.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.city.value.trim() == "" || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.state.value === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.state.value == "")) {
	                return false;
	            }
	            return $scope.page.selectedVehicle.aspects.subtreeValid;
	        };
	
	        ctrl.editVehicle = function (vehicle, form, rowIndex) {
	            //Validate the current input, and if correct, save the current changes and select the next vehicle
	            $scope.selectedRow = rowIndex; // for highlighting selected row
	            if (ctrl._isValid(form)) {
	                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicle);
	            } else {
	                form.submitted = true;
	            }
	            $scope.page.readonly = false;
	        };
	
	        ctrl._isValid = function (form) {
	            if (!ctrl.isVehicleValid(form)) {
	                form.submitted = true;
	                return false;
	            }
	            var licenceMatchedVehicle = ctrl._ensureUniqueLicensePlate($scope.page.selectedVehicle.value);
	            var vinMatchedVehicle = ctrl._ensureUniqueVin($scope.page.selectedVehicle.value);
	            /* if (licenceMatchedVehicle) {
	                 const licenceMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.LicenceMatchMsg', {licenceMatchedVehicle: licenceMatchedVehicle.getDisplayName(undefined, $filter)});
	                 ModalService.showError('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Licence plate is not unique', licenceMatchedMsg);
	                 return false;
	             } else*/if (vinMatchedVehicle) {
	                var vinMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VinMatchMsg', { vinMatchedVehicle: vinMatchedVehicle.getDisplayName(undefined, $filter) });
	                ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VIN is not unique', vinMatchedMsg);
	                return false;
	            }
	            return true;
	        };
	
	        ctrl._ensureUniqueLicensePlate = function (vehicle) {
	            var vehicleMatch = _.where(paModel.vehicles, { license: vehicle.license });
	            if (!vehicleMatch) {
	                return undefined;
	            } else if (vehicleMatch.length === 1) {
	                return vehicleMatch[0] !== vehicle ? vehicleMatch : undefined;
	            }
	            return _.find(vehicleMatch, function (v) {
	                return v !== vehicle;
	            });
	        };
	
	        ctrl._ensureUniqueVin = function (vehicle) {
	            var vehicleMatch = _.where(paModel.vehicles, { vin: vehicle.vin });
	            if (!vehicleMatch) {
	                return undefined;
	            } else if (vehicleMatch.length === 1) {
	                return vehicleMatch[0] !== vehicle ? vehicleMatch : undefined;
	            }
	            return _.find(vehicleMatch, function (v) {
	                //Added if condition for Defect 861 
	                if (v.vin != "" && v.vin != undefined) {
	                    return v !== vehicle;
	                }
	            });
	        };
	
	        /*ctrl._setVehicleDefaults = ()=> {
	            _.forEach(paModel.vehicles, (vehicle)=> {
	                vehicle.primaryUse = 'pleasure';
	            });
	        };
	        */
	        function formatDOB(dobYear, dobMonth, dobDay) {
	            var dt = new Date(dobYear, dobMonth, dobDay),
	                month = '' + (dt.getMonth() + 1),
	                year = '' + dt.getFullYear(),
	                day = '' + dt.getDate();
	
	            if (month.length < 2) month = '0' + month;
	            if (day.length < 2) day = '0' + day;
	            var dob = [year, month, day].join('-');
	            return dob;
	        }
	        ctrl.next = function (form) {
	            $rootScope.$broadcast('submit-form');
	            form.submitted = true;
	
	            if (!ctrl._isValid(form) || form.valid === false) {
	                return;
	            }
	
	            //ctrl._setVehicleDefaults();
	
	            if (editableDriverDOB) {
	                paModel.drivers.forEach(function (driver) {
	                    if (driver.person.accountHolder) {
	                        submissionVm.draftData.accountHolder.dateOfBirth.value = driver.dateOfBirth;
	                    }
	                });
	            }
	
	            //remove ssnunMasked property
	            paModel.drivers.forEach(function (driver, idx) {
	                driver.socialSecurityNumber = driver.ssnunMasked;
	                delete driver["ssnunMasked"];
	                // data prefill -- Arpita 
	                if (driver.isPrefilledDriver && driver.dateOfBirth) {
	                    var dob = formatDOB(driver.dateOfBirth.year, driver.dateOfBirth.month, driver.dateOfBirth.day);
	                    driver.eNCDateOfBirth = InMemorySession.encryptData(dob).toString();
	                    submissionVm.draftData.lobs.personalAuto.drivers.value[idx].eNCDateOfBirth = driver.eNCDateOfBirth;
	                    submissionVm.draftData.lobs.personalAuto.drivers.value[idx].dateOfBirth = null;
	                    driver.dateOfBirth = null;
	                    if (submissionVm.draftData.accountHolder.publicID.value !== submissionVm.draftData.lobs.personalAuto.drivers.value[idx].person.publicID) {
	                        submissionVm.draftData.lobs.personalAuto.drivers.value[idx].person.dateOfBirth = null;
	                    }
	                }
	                //ended
	            });
	
	            // temporary validation added in the front end since driver details are removing whenever we get entity validation exception and then try to proceed.
	            if (paModel.vehicles && accountHolder.primaryAddress.state == "SC" && paModel.vehicles.length > 0) {
	                var count = 0;
	                _.forEach(paModel.vehicles, function (vehicle) {
	                    if (vehicle.tmpPaType == "motorcycle_aaa") {
	                        count++;
	                    }
	                });
	                if (count == paModel.vehicles.length) {
	                    ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Validation Error SC");
	                    return;
	                }
	            }
	            // Enable this line if want to validate all vehicles form vaild status
	            if (paModel.vehicles && paModel.vehicles.length > 1 && !paModelVM.vehicles.aspects.subtreeValid) {
	                ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Validation Error");
	                return;
	            }
	            // data prefill
	            if (paModel.vehicles) {
	                var inputsToValidate = [];
	                _.forEach(paModel.vehicles, function (vehicle, index) {
	                    if (vehicle.isPrefilledVehicle) {
	                        if (vehicle.chosenDriver.dateOfBirth && vehicle.chosenDriver.isPrefilledDriver) {
	                            var date_of_birth = vehicle.chosenDriver.dateOfBirth;
	                            var dob = formatDOB(date_of_birth.year, date_of_birth.month, date_of_birth.day);
	                            vehicle.chosenDriver.eNCDateOfBirth = InMemorySession.encryptData(dob).toString();
	                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].chosenDriver.eNCDateOfBirth = vehicle.chosenDriver.eNCDateOfBirth;
	                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].chosenDriver.dateOfBirth = null;
	                        }
	                        vehicle.vin = null;
	                        submissionVm.draftData.lobs.personalAuto.vehicles.value[index].vin = null;
	                        if (submissionVm.draftData.lobs.personalAuto.vehicles.value[index].licenseState) {
	                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].licenseState = null;
	                        }
	                    }
	                    //ENHC0013007 -- Insurance Premium Refunds --Arpita
	                    if (vehicle.addnlInterest != undefined) {
	                        inputsToValidate.push({ 'name': vehicle.addnlInterest.name });
	                        validateInputs(inputsToValidate, vehicle.addnlInterest);
	                        inputsToValidate = [];
	                        if (!$scope.isNameValid) {
	                            return;
	                        }
	                        if (vehicle.addnlInterest.addnlInterestAddress != undefined) {
	                            inputsToValidate.push({ 'addressLine1': vehicle.addnlInterest.addnlInterestAddress.addressLine1 }, { 'addressLine2': vehicle.addnlInterest.addnlInterestAddress.addressLine2 }, { 'city': vehicle.addnlInterest.addnlInterestAddress.city });
	                            validateInputs(inputsToValidate, vehicle.addnlInterest.addnlInterestAddress);
	                            inputsToValidate = [];
	                            if (!$scope.isNameValid) {
	                                return;
	                            }
	                        }
	                    }
	                });
	                if (!$scope.isNameValid) {
	                    return;
	                } //ended
	            }
	            //ended
	            flowModel.next(submissionVm);
	        };
	        ctrl.previous = function () {
	            flowModel.previous(submissionVm);
	        };
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVm);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$filter', '$scope', '$translate', '$anchorScroll', 'ModalService', 'StateUtils', 'submissionViewModel', 'pa.qnb.editableDriverDOB', '$rootScope', 'availableYears', 'InMemorySession', 'qnb.InputValidationService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340), __webpack_require__(385)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl, membershipDetailTemplate) {
	    // added membership confirmation template - QnB Issue with payment amount not updating – DFCT0020740
	    // added '$rootScope' *Princy UI
	    var fn = function fn($scope, $rootScope, $filter, $timeout, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel, VinLookupService, VinLookupEnabled, $q, ModalService, $state, InMemorySession, LoadSaveService, MembershipService) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
	        var driver = angular.copy(submissionVM.draftData.lobs.personalAuto.value.drivers);
	        var vehicles = angular.copy(submissionVM.draftData.lobs.personalAuto.value.vehicles);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var vinArray = [];
	        var driverLicenseArr = [];
	        var policyAddress = angular.copy(submissionVM.draftData.policyAddress.value);
	
	        ///////////////////////////////////////////////////////////////
	        //submissionVM.draftData.value = InMemorySession.getDraftData();
	        ///////////////////////////////////////////////////////////////
	        ctrl.init = function () {
	
	            $scope.skip = true;
	            ctrl._setBindDataDefaultValues();
	            if (ctrl.skipOnResume()) {
	                flowModel.next(submissionVM);
	            }
	            $scope.$filter = $filter;
	            $scope.startDate = new Date();
	            $scope.disabled = false;
	            $scope.vehicleVinValidMap = [];
	            $scope.states = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').codes;
	            $scope.bindData = submissionVM.bindData;
	            $scope.bindData.chosenQuote.value = chosenQuoteId;
	            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	            $scope.leaseOptions = [{ name: "Other" }];
	            $scope.leaseSelectedOption = $scope.leaseOptions[0];
	            $scope.financeOptions = [{ name: "Other" }];
	            $scope.financeSelectedOption = $scope.financeOptions[0];
	            $scope.displayLeaseCompanyInput = false;
	            $scope.displayFinanceCompanyInput = false;
	            $scope.showCoverages = true;
	            $scope.invalidVIN = false;
	            $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, { publicID: chosenQuoteId });
	            $scope.vinFlagArray = [];
	            $scope.licenseNumberFlagArray = [];
	            $scope.displayVehiclesFeatures = 0;
	            $scope.prefillResponseFromFactory = InMemorySession.getPrefillData();
	            //$scope.driverFlagPrefillArray = []; // driverFlagPrefillArray added *Princy UI
	            //$scope.vehicleFlagPrefillArray = []; // vehicleFlagPrefillArray added *Princy
	            _.forEach(vehicles, function (item) {
	                var vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
	                if (vin_no && vin_no.length === 17) {
	                    $scope.vinFlagArray.push(true);
	                    // added vehiclePrefill Flag Array *Princy
	                    //$scope.vehicleFlagPrefillArray.push(item.publicID)
	                } else {
	                    $scope.vinFlagArray.push(false);
	                }
	                vinArray.push(vin_no);
	            });
	
	            _.forEach(driver, function (item) {
	                var licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
	                if (licenseno) {
	                    $scope.licenseNumberFlagArray.push(true);
	                    // added driverPrefill Flag Array *Princy UI
	                    //$scope.driverFlagPrefillArray.push(item.publicID);
	                } else {
	                    $scope.licenseNumberFlagArray.push(false);
	                }
	                driverLicenseArr.push(licenseno);
	            });
	
	            // added prefillDriver Flag and Vehicle Flag *Princy UI commented 68-69 coz of rootScope
	            // $rootScope.prefillDrivers =  $scope.driverFlagPrefillArray;
	            //$rootScope.prefillVehicles =  $scope.vehicleFlagPrefillArray;
	            //devendra prefill code started
	            $scope.prefillDriverCheck = function (driver, index) {
	                var isPrefilledDriverCheck = false;
	                if ($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.drivers) {
	                    $scope.prefillResponseFromFactory.drivers.forEach(function (obj) {
	                        if (driver.person.firstName.value !== "undefined" && obj.dateOfBirth && driver.eNCDateOfBirth && (typeof driver.eNCDateOfBirth == 'string' || typeof driver.eNCDateOfBirth.value !== "undefined")) {
	                            var encDob = InMemorySession.decryptData(driver.eNCDateOfBirth.value).split(' ')[0].split("-");
	                            var d1 = new Date(encDob[0], encDob[1] - 1, encDob[2]);
	                            // let d1 = new Date(driver.dateOfBirth.year.value, driver.dateOfBirth.month.value, driver.dateOfBirth.day.value);
	                            var d2 = obj.dateOfBirth;
	                            d2.setHours(0, 0, 0, 0);
	                            if (driver.person.firstName.value.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.value.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()) {
	                                isPrefilledDriverCheck = true;
	                            }
	                        }
	                    });
	                }
	                if (isPrefilledDriverCheck) {
	                    $scope.driversVM[index].value.isPrefilledDriver = true;
	                } else {
	                    $scope.driversVM[index].value.isPrefilledDriver = false;
	                    $scope.allPrefillDriversFlag = false;
	                }
	            };
	            $scope.prefillVehicleCheck = function (vehicle, index) {
	                var isPrefilledVehicleCheck = false;
	                if ($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.vehicles) {
	                    $scope.prefillResponseFromFactory.vehicles.forEach(function (obj) {
	                        if (vehicle.encryptedVIN && (typeof vehicle.encryptedVIN == 'string' && obj.vin == vehicle.encryptedVIN || vehicle.encryptedVIN.value && obj.vin == vehicle.encryptedVIN.value)) {
	                            isPrefilledVehicleCheck = true;
	                        }
	                    });
	                }
	                if (isPrefilledVehicleCheck) {
	                    $scope.vehiclesVM[index].isPrefilledVehicle = true;
	                } else {
	                    $scope.vehiclesVM[index].isPrefilledVehicle = false;
	                    $scope.allPrefillVehicleFlag = false;
	                }
	            };
	            //devendra prefill code end
	            $scope.vehiclesVM = submissionVM.draftData.lobs.personalAuto.vehicles.children;
	            $scope.driversVM = submissionVM.draftData.lobs.personalAuto.drivers.children;
	            //devendra prefill code started
	            $scope.allPrefillDriversFlag = true;
	            if ($scope.driversVM && $scope.driversVM.length > 0) {
	                for (var idxDriver in $scope.driversVM) {
	                    if (typeof $scope.driversVM[parseInt(idxDriver)] != "undefined" && typeof $scope.prefillResponseFromFactory !== "undefined" && typeof $scope.prefillResponseFromFactory.drivers !== "undefined" && $scope.prefillResponseFromFactory.drivers.length > 0) {
	                        $scope.prefillDriverCheck($scope.driversVM[idxDriver], parseInt(idxDriver));
	                    } else {
	                        $scope.driversVM[idxDriver].isPrefilledDriver = false;
	                        $scope.allPrefillDriversFlag = false;
	                    }
	                }
	            }
	            $scope.allPrefillVehicleFlag = true;
	            if ($scope.vehiclesVM && $scope.vehiclesVM.length > 0) {
	                for (var idxVehicle in $scope.vehiclesVM) {
	                    if (typeof $scope.vehiclesVM[parseInt(idxVehicle)] != "undefined" && typeof $scope.prefillResponseFromFactory !== "undefined" && typeof $scope.prefillResponseFromFactory.vehicles !== "undefined" && $scope.prefillResponseFromFactory.vehicles.length > 0) {
	                        $scope.prefillVehicleCheck($scope.vehiclesVM[idxVehicle], parseInt(idxVehicle));
	                    } else {
	                        $scope.vehiclesVM[idxVehicle].isPrefilledVehicle = false;
	                        $scope.allPrefillVehicleFlag = false;
	                    }
	                }
	            }
	            //devendra prefill code end
	            //ctrl.initAdditionalInterestVM();
	            $scope.draftData = submissionVM.draftData.value;
	            //ENHC0011961 popup for membership validation
	            membershipDetailCheck();
	        };
	        //ENHC0011961 popup for membership validation
	        //added below codes for DFCT0020740 --Arpita
	        function membershipDetailCheck() {
	            var result = [];
	            if (!$scope.draftData.accountHolder.membershipNumber) {
	                ModalService.showSimpleDialog(membershipDetailTemplate, submissionVM.value, {
	                    quoteAsNonMember: ctrl._quoteAsNonMember,
	                    showMemberWarning: ctrl._showMemberWarning,
	                    membershipValidation: ctrl._membershipValidation
	                }, null);
	            }
	        }
	        //ended
	        //Eodb - membership quote as non member --Arpita
	        // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
	        ctrl._quoteAsNonMember = function (dialogScope, formData) {
	            submissionVM.value.draftData.accountHolder.isMember = false;
	            submissionVM.value.draftData.accountHolder.quoteAsAAAMember = false;
	            var saveQuotedSubmission = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
	            saveQuotedSubmission.then(function (nonMembershipResp) {
	                submissionVM.value = nonMembershipResp;
	                dialogScope.$close();
	            });
	        };
	        //ENHC0011961 - adding membership attention message ---Arpita Sengupta
	        // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
	        ctrl._showMemberWarning = function (dialogScope, formData) {
	            dialogScope.showMemberWarningMsg = false;
	            if (null != formData.memberNumber.$modelValue && formData.memberNumber.$modelValue != '' && formData.memberNumber.$modelValue.length != 16) {
	                dialogScope.showMemberWarningMsg = true;
	            }
	        };
	        //ENHC0011961 - checking validation for Membership number - Arpita Sengupta
	        // added below codes from ModalCtrl.js to her as part of QnB Issue with payment amount not updating – DFCT0020740 --Arpita
	        ctrl._membershipValidation = function (dialogScope, formData) {
	            var membershipDetails = { membershipNumber: formData.memberNumber.$modelValue };
	            dialogScope.showErrorMsg = false;
	            dialogScope.showMemValidationError = false;
	            if (membershipDetails.membershipNumber != null && membershipDetails.membershipNumber != '' && membershipDetails.membershipNumber.length == '16') {
	                var membershipPromise = MembershipService.isMember('quoteandbind', membershipDetails);
	                ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);
	
	                membershipPromise.then(function (membershipResp) {
	                    if (membershipResp[0].membershipStatus && membershipResp[0].firstName && membershipResp[0].lastName) {
	                        submissionVM.value.draftData.accountHolder.isMember = true;
	                        submissionVM.value.draftData.accountHolder.quoteAsAAAMember = false;
	                        submissionVM.value.draftData.accountHolder.membershipNumber = membershipResp[0].membershipNumber;
	                        submissionVM.value.draftData.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
	                        submissionVM.value.draftData.accountHolder.membershipType = membershipResp[0].serviceLevel;
	                        submissionVM.value.draftData.accountHolder.membershipStatus = membershipResp[0].membershipStatus;
	
	                        var saveQuotedSubmission = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
	                        ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
	                        saveQuotedSubmission.then(function (reQuoteResponse) {
	                            submissionVM.value = reQuoteResponse;
	                        });
	                        dialogScope.$close();
	                    }
	                }).catch(function () {
	                    dialogScope.showMemValidationError = true;
	                });
	            } else {
	                dialogScope.showErrorMsg = true;
	            }
	        }; //ended
	
	
	        ctrl.skipOnResume = function () {
	            //skip this page
	            //1.All the vehicles have valid Vin
	            //2.All the drivers have driving license
	            //3.bind data phone is available
	            //4. email is available
	            var validDrivers = true;
	            var validVehicles = true;
	            var phone = submissionVM.bindData.contactPhone.value;
	            var email = submissionVM.bindData.contactEmail.value;
	            _.forEach(driver, function (item) {
	                var licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
	                if (typeof licenseno === 'undefined' || licenseno === '') {
	                    validDrivers = false;
	                }
	            });
	
	            _.forEach(vehicles, function (item) {
	                var vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
	                if (typeof vin_no === 'undefined' || vin_no === '' || vin_no.length < 17) {
	                    validVehicles = false;
	                }
	            });
	
	            return validDrivers && validVehicles && phone && email;
	        };
	
	        ctrl.reQuote = function (form) {
	            $scope.isRequoteButtonClicked = true; //isRequoteButtonClicked
	            $scope.countOfInvalidData = 0; //validation for lease & finance options
	            form.submitted = true;
	            if (!form.valid) {
	                return;
	            }
	            if (!$scope.bindData.contactPhone.value) {
	                return;
	            }
	            var reqoutedata = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', reqoutedata);
	            reqoutedata.then(function (reQuotedResponse) {
	                submissionVM.value = reQuotedResponse;
	                // check if there is change in vin details or in license number or
	                // state
	                var latestVehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
	                var latestDrivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
	                var latestVinArr = [];
	                var latestLicenseNumberArr = [];
	
	                var isValidVehicle = true;
	                var isValidLicense = true;
	
	                // All the drivers should have license number in order to proceed
	                _.forEach(latestDrivers, function (item) {
	                    var licenseno = item.isPrefilledDriver ? InMemorySession.decryptData(item.eNCLicenseNumber) : item.licenseNumber;
	                    if (licenseno === undefined || licenseno === '') {
	                        isValidLicense = false;
	                    } else {
	                        latestLicenseNumberArr.push(licenseno);
	                    }
	                });
	
	                if (!isValidLicense) {
	                    return;
	                }
	
	                // for all the vehicles enetrd Vin should be present and valid
	
	                _.forEach($scope.vehicleVinValidMap, function (item) {
	                    if (!item.isValidVin) {
	                        isValidVehicle = false;
	                    }
	                });
	
	                if (!isValidVehicle) {
	                    return;
	                }
	                //Changed for Short Vin Validation
	                _.forEach(latestVehicles, function (item) {
	                    var vin_no = item.isPrefilledVehicle ? InMemorySession.decryptData(item.encryptedVIN) : item.vin;
	                    if (vin_no === undefined || vin_no === '' || vin_no.length < 17) {
	                        isValidVehicle = false;
	                        $scope.vehicleVinValidMap.push({
	                            "publicID": item.publicID,
	                            "isValidVin": false
	                        });
	                    } else {
	                        latestVinArr.push(vin_no);
	                    }
	                });
	
	                if (!isValidVehicle) {
	                    return;
	                }
	
	                if (_.isEqual(latestVinArr, vinArray) && _.isEqual(latestLicenseNumberArr, driverLicenseArr)) {
	                    flowModel.next(submissionVM);
	                } else {
	                    $state.go("paRequoteDetails");
	                }
	            });
	        };
	
	        ctrl.isAccountHolder = function (driver) {
	            return submissionVM.value.getAccountHolderPerson() === driver.person;
	        };
	
	        ctrl.lookupPerson = function (driver) {
	            return _.findWhere(submissionVM.submission.persons.value, { publicID: driver.personID });
	        };
	
	        ctrl.lookupState = function (state) {
	            var stateName = _.findWhere($scope.states, { code: state });
	            if (!stateName) {
	                //try the country
	                stateName = _.findWhere(InsuranceSuiteMetadata.get('pc').types.getTypelist('Country').codes, { code: state });
	            }
	            return stateName;
	        };
	
	        ctrl.driverSort = function (driver) {
	            if (ctrl.isAccountHolder(driver)) {
	                return -1;
	            }
	            return driver.getDisplayName(undefined, $filter);
	        };
	
	        ctrl.lookupVIN = function (vehicle) {
	            if (vehicle.vin.value && vehicle.vin.value.length === 17) {
	                if (vehicle.tmpPaType.value === 'motorcycle_aaa') {
	                    motorcycleVinLookUp(vehicle);
	                } else if (vehicle.tmpPaType.value === 'auto') {
	                    autoVinLookUp(vehicle);
	                }
	            } else {
	                if (vehicle.vin.value.length < 17) {
	                    var vehicleChosen = _.findWhere($scope.vehicleVinValidMap, { publicID: vehicle.value.publicID });
	                    if (vehicleChosen === undefined) {
	                        $scope.vehicleVinValidMap.push({
	                            "publicID": vehicle.value.publicID,
	                            "isValidVin": false
	                        });
	                    } else {
	                        vehicleChosen.isValidVin = false;
	                    }
	                }
	            }
	        };
	
	        function motorcycleVinLookUp(vehicle) {
	            var hldiDetails = {
	                vin: vehicle.vin.value,
	                ccr: "ZEM2O9S8F9A1",
	                searchType: "Vindicate",
	                quoteId: submissionVM.quoteID.value
	            };
	            //The Bike VIN does not return a match, VIN is invalid
	            var bikePromise = VinLookupService.aaaHLDILookup('quoteandbind', hldiDetails);
	            var validVIN = false;
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', bikePromise);
	            bikePromise.then(function (bikeInfo) {
	                if (bikeInfo && bikeInfo.vindicatorData.makeName && bikeInfo.vindicatorData.modelName && bikeInfo.vindicatorData.modelYear) {
	                    vehicle.make.value = bikeInfo.vindicatorData.makeName;
	                    vehicle.model.value = bikeInfo.vindicatorData.modelName;
	                    vehicle.year.value = bikeInfo.vindicatorData.modelYear.trim();
	                    vehicle.cCs.value = bikeInfo.vindicatorData.displacement.trim();
	                    vehicle.bodyStyle.value = bikeInfo.vindicatorData.vehicleClassDesc.trim();
	                    vehicle.series.value = bikeInfo.vindicatorData.seriesName.trim();
	                    if (bikeInfo.vindicatorData.basePrice != "" && bikeInfo.vindicatorData.basePrice != undefined && bikeInfo.vindicatorData.basePrice.trim() != "") {
	                        vehicle.costNew.amount.value = bikeInfo.vindicatorData.basePrice.trim();
	                    }
	                    validVIN = true;
	                }
	                var vehicleChosen = _.findWhere($scope.vehicleVinValidMap, { publicID: vehicle.value.publicID });
	                if (vehicleChosen === undefined) {
	                    $scope.vehicleVinValidMap.push({
	                        "publicID": vehicle.value.publicID,
	                        "isValidVin": validVIN
	                    });
	                } else {
	                    vehicleChosen.isValidVin = validVIN;
	                }
	            });
	        }
	
	        function autoVinLookUp(vehicle) {
	            var vinDetails = {
	                vinNumber: vehicle.vin.value,
	                policyEffectiveDate: $scope.startDate,
	                searchType: "DecodeVinByDate",
	                quoteID: submissionVM.quoteID.value
	            };
	            var validVIN = false;
	            var vehiclePromise = VinLookupService.aaaVINLookup('quoteandbind', vinDetails);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', vehiclePromise);
	            vehiclePromise.then(function (vehicleInfo) {
	                if (vehicleInfo && vehicleInfo.vehicleData.make && vehicleInfo.vehicleData.fullModelName && vehicleInfo.vehicleData.isoYear) {
	                    vehicle.make.value = vehicleInfo.vehicleData.make.trim();
	                    vehicle.model.value = vehicleInfo.vehicleData.fullModelName.trim();
	                    vehicle.year.value = vehicleInfo.vehicleData.isoYear.trim();
	                    vehicle.cylinder.value = vehicleInfo.vehicleData.engineCyl.trim();
	                    vehicle.bodyStyle = vehicleInfo.vehicleData.bodyStyle.trim();
	
	                    // New fields addded for the new VIN service approach
	                    vehicle.vehicleSurchargeCd.value = vehicleInfo.vehicleData.vehicleSurchargeCode.trim();
	                    vehicle.comprehensiveSymbolCd.value = vehicleInfo.vehicleData.comprehensiveSymbolCd.trim();
	                    vehicle.collisionSymbolCd.value = vehicleInfo.vehicleData.collisionSymbolCd.trim();
	                    vehicle.twoDgVSRSymbol.value = vehicleInfo.vehicleData.twoDgVSRSymbol.trim();
	                    vehicle.bodyType.value = vehicleInfo.vehicleData.bodyType;
	                    vehicle.paAntiLockBrakes.value = vehicleInfo.vehicleData.paAntiLockBrakes;
	                    vehicle.paPassiveRestraint.value = vehicleInfo.vehicleData.paPassiveRestraint;
	                    vehicle.paAntiTheft.value = vehicleInfo.vehicleData.paAntiTheft;
	
	                    if (vehicleInfo.vehicleData.abs != null && vehicleInfo.vehicleData.abs != undefined) {
	                        vehicle.abs.value = vehicleInfo.vehicleData.abs.trim();
	                    }
	
	                    if (vehicleInfo.vehicleData.antiTheft != null && vehicleInfo.vehicleData.antiTheft != undefined) {
	                        vehicle.antiTheft.value = vehicleInfo.vehicleData.antiTheft.trim();
	                    }
	
	                    if (vehicleInfo.vehicleData.restrInd != null && vehicleInfo.vehicleData.restrInd != undefined) {
	                        vehicle.restrInd.value = vehicleInfo.vehicleData.restrInd.trim();
	                    }
	
	                    // Set cost new if long vin returns cost new
	                    if (vehicleInfo.vehicleData.costNew && vehicleInfo.vehicleData.costNew.amount) {
	                        vehicle.costNew.amount.value = vehicleInfo.vehicleData.costNew.amount;
	                    }
	
	                    validVIN = true;
	                }
	                var vehicleChosen = _.findWhere($scope.vehicleVinValidMap, { publicID: vehicle.value.publicID });
	                if (vehicleChosen === undefined) {
	                    $scope.vehicleVinValidMap.push({
	                        "publicID": vehicle.value.publicID,
	                        "isValidVin": validVIN
	                    });
	                } else {
	                    vehicleChosen.isValidVin = validVIN;
	                }
	            });
	        }
	
	        ctrl.isValidVin = function (vehicle) {
	            var vehicleKey = _.findWhere($scope.vehicleVinValidMap, { publicID: vehicle.value.publicID });
	            if (vehicleKey) {
	                return vehicleKey.isValidVin;
	            } else {
	                return true;
	            }
	        };
	
	        ctrl._setBindDataDefaultValues = function () {
	            submissionVM.bindData.value = submissionVM.bindData.value || {};
	            if (!submissionVM.bindData.billingAddress.value) {
	                submissionVM.bindData.billingAddress.value = {};
	                angular.copy(submissionVM.draftData.policyAddress.value, submissionVM.bindData.billingAddress.value);
	            }
	            submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
	            submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value || submissionVM.draftData.accountHolder.emailAddress1.value;
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        return ctrl.create($scope);
	    };
	    // added '$rootScope' *Princy UI
	    fn.$inject = ['$scope', '$rootScope', '$filter', '$timeout', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel', 'VinLookupService', 'VinLookupEnabled', '$q', 'ModalService', '$state', 'InMemorySession', 'qnb.LoadSaveService', 'MembershipService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 385 */
/***/ function(module, exports) {

	module.exports = "\r\n<ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\"> \r\n    <div style=\"padding: 2%\">\r\n        <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.Membership' |\r\n            translate }}\r\n        </h2>\r\n        <div style=\"padding-bottom: 10px;\">\r\n            <div class=\"wrapper\" ng-style='position' ng-show=\"showMemValidationError\" style=\"color: red;\">\r\n                <span class=\"text-danger\">{{\"quoteandbind.controllers.MembershipCtrl.PC system down error\" | translate}}</span>\r\n            </div>\r\n            <div class=\"wrapper\" ng-style='position' ng-show=\"showMemberWarningMsg\" style=\"color: red;\">\r\n                <span class=\"text-danger\">{{\"quoteandbind.controllers.MembershipCtrl.AttentionMessage\" | translate}}</span>\r\n            </div>\r\n            <div class=\"wrapper\" ng-style='position' ng-show=\"showErrorMsg\" style=\"padding-bottom: 10px;color: red;\">\r\n                <span class=\"text-danger\">{{\"quoteandbind.views.Membership.Number Missing\" | translate}}</span>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"gw-control-group\">\r\n                <label class=\"gw-control-label\">{{\"quoteandbind.views.Membership.Number\" | translate}}\r\n                    <span class=\"aaa-inline-info-wrapper\">\r\n                        <div class=\"aaa-inline-info\">   {{\"quoteandbind.views.membership.number.Tooltip\" | translate }}</div>\r\n                        <i class=\"fa fa-info-circle\"></i>\r\n                    </span>\r\n                </label>\r\n    \r\n                <div class='gw-controls'>\r\n                    <input type='text' onkeypress='return (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || ( event.charCode >= 48 && event.charCode <= 57))' ng-model='draftData.membershipInfo.membershipNumber' maxlength='16' name='memberNumber' placeholder=\"{{'quoteandbind.views.membership.placeholder' | translate }}\" ng-blur=\"showMemberWarning(form)\" value=\"{{selectedMembershipNumber}}\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"gw-page-buttons\">\r\n            <button ng-click=\"quoteAsNonMember(form)\" class=\"gw-btn\" tabindex=\"0\">Quote as non member</button>\r\n            <button ng-click=\"membershipValidation(form)\" class=\"gw-btn gw-btn-primary\" tabindex=\"0\">Submit</button>\r\n        </div>\r\n    </div>\r\n</ng-form>"

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Mayank.Jain1 on 19-10-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    // added '$rootScope' *Princy
	    var fn = function fn($scope, $filter, $timeout, $anchorScroll, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel, VinLookupService, $q, ModalService, InMemorySession) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        ctrl.init = function () {
	            $anchorScroll();
	            ctrl._setBindDataDefaultValues();
	            $scope.$filter = $filter;
	            $scope.startDate = new Date();
	            $scope.disabled = false;
	            $scope.states = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').codes;
	            $scope.bindData = submissionVM.bindData;
	            $scope.bindData.chosenQuote.value = chosenQuoteId;
	            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	            $scope.prefillResponseFromFactory = InMemorySession.getPrefillData();
	            //devendra prefill code started
	            $scope.prefillDriverCheck = function (driver, index) {
	                var isPrefilledDriverCheck = false;
	                if ($scope.prefillResponseFromFactory && $scope.prefillResponseFromFactory.drivers) {
	                    InMemorySession.getPrefillData().drivers.forEach(function (obj) {
	                        if (driver.person.firstName !== "undefined" && obj.dateOfBirth && driver.eNCDateOfBirth && (typeof driver.eNCDateOfBirth == 'string' || typeof driver.eNCDateOfBirth.value !== "undefined")) {
	                            var encDob = InMemorySession.decryptData(driver.eNCDateOfBirth).split(' ')[0].split("-");
	                            var d1 = new Date(encDob[0], encDob[1] - 1, encDob[2]);
	                            // let d1 = new Date(driver.dateOfBirth.year, driver.dateOfBirth.month, driver.dateOfBirth.day);
	                            var d2 = obj.dateOfBirth;
	                            d2.setHours(0, 0, 0, 0);
	                            if (driver.person.firstName.toLowerCase() == obj.firstName.toLowerCase() && driver.person.lastName.toLowerCase() == obj.lastName.toLowerCase() && d1.getTime() == d2.getTime()) {
	                                isPrefilledDriverCheck = true;
	                            }
	                        }
	                    });
	                }
	                if (isPrefilledDriverCheck) {
	                    submissionVM.draftData.value.lobs.personalAuto.drivers[index].isPrefilledDriver = true;
	                } else {
	                    submissionVM.draftData.value.lobs.personalAuto.drivers[index].isPrefilledDriver = false;
	                    $scope.allPrefillDriversFlag = false;
	                }
	            };
	            $scope.prefillVehicleCheck = function (vehicle, index) {
	                var isPrefilledVehicleCheck = false;
	                if (InMemorySession.getPrefillData() && InMemorySession.getPrefillData().vehicles) {
	                    InMemorySession.getPrefillData().vehicles.forEach(function (obj) {
	                        if (vehicle.encryptedVIN && (typeof vehicle.encryptedVIN == 'string' && obj.vin == vehicle.encryptedVIN || vehicle.encryptedVIN.value && obj.vin == vehicle.encryptedVIN.value)) {
	                            isPrefilledVehicleCheck = true;
	                        }
	                    });
	                }
	                if (isPrefilledVehicleCheck) {
	                    submissionVM.draftData.value.lobs.personalAuto.vehicles[index].isPrefilledVehicle = true;
	                } else {
	                    submissionVM.draftData.value.lobs.personalAuto.vehicles[index].isPrefilledVehicle = false;
	                    $scope.allPrefillVehicleFlag = false;
	                }
	            };
	            $scope.allPrefillDriversFlag = true;
	            if (submissionVM.draftData.value.lobs.personalAuto.drivers && submissionVM.draftData.value.lobs.personalAuto.drivers.length > 0) {
	                for (var idxDriver in submissionVM.draftData.value.lobs.personalAuto.drivers) {
	                    if (typeof submissionVM.draftData.value.lobs.personalAuto.drivers[parseInt(idxDriver)] != "undefined" && typeof InMemorySession.getPrefillData().drivers !== "undefined" && InMemorySession.getPrefillData().drivers.length > 0) {
	                        $scope.prefillDriverCheck(submissionVM.draftData.value.lobs.personalAuto.drivers[idxDriver], parseInt(idxDriver));
	                    } else {
	                        submissionVM.draftData.value.lobs.personalAuto.drivers[idxDriver].isPrefilledDriver = false;
	                        $scope.allPrefillDriversFlag = false;
	                    }
	                }
	            }
	            $scope.allPrefillVehicleFlag = true;
	            if (submissionVM.draftData.value.lobs.personalAuto.vehicles && submissionVM.draftData.value.lobs.personalAuto.vehicles.length > 0) {
	                for (var idxVehicle in submissionVM.draftData.value.lobs.personalAuto.vehicles) {
	                    if (typeof submissionVM.draftData.value.lobs.personalAuto.vehicles[parseInt(idxVehicle)] != "undefined" && typeof InMemorySession.getPrefillData().vehicles !== "undefined" && InMemorySession.getPrefillData().vehicles.length > 0) {
	                        $scope.prefillVehicleCheck(submissionVM.draftData.value.lobs.personalAuto.vehicles[idxVehicle], parseInt(idxVehicle));
	                    } else {
	                        submissionVM.draftData.value.lobs.personalAuto.vehicles[idxVehicle].isPrefilledVehicle = false;
	                        $scope.allPrefillVehicleFlag = false;
	                    }
	                }
	            }
	            //devendra prefill code end
	            $scope.draftData = submissionVM.draftData.value;
	
	            $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, { publicID: chosenQuoteId });
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        ctrl.next = function () {
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.isAccountHolder = function (driver) {
	            return submissionVM.value.getAccountHolderPerson() === driver.person;
	        };
	
	        ctrl.lookupState = function (state) {
	            var stateName = _.findWhere($scope.states, { code: state });
	            if (!stateName) {
	                //try the country
	                stateName = _.findWhere(InsuranceSuiteMetadata.get('pc').types.getTypelist('Country').codes, { code: state });
	            }
	            return stateName;
	        };
	
	        ctrl.driverSort = function (driver) {
	            if (ctrl.isAccountHolder(driver)) {
	                return -1;
	            }
	            return driver.getDisplayName(undefined, $filter);
	        };
	
	        ctrl._setBindDataDefaultValues = function () {
	            submissionVM.bindData.value = submissionVM.bindData.value || {};
	            if (!submissionVM.bindData.billingAddress.value) {
	                submissionVM.bindData.billingAddress.value = {};
	                angular.copy(submissionVM.draftData.policyAddress.value, submissionVM.bindData.billingAddress.value);
	            }
	            submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
	            submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value || submissionVM.draftData.accountHolder.emailAddress1.value;
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$filter', '$timeout', '$anchorScroll', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel', 'VinLookupService', '$q', 'ModalService', 'InMemorySession'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn(LocaleService, $filter, $scope, $anchorScroll, StateUtils, LoadSaveService, MVRClueService, $window, submissionViewModel, $state, ModalService, InMemorySession, $q, ErrorHandlingService, ViewModelService, ViewModelContext) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	        var vehicles;
	        var drivers;
	        var doReQuoteOnFail;
	
	        ctrl.init = function () {
	            $anchorScroll();
	            $scope.page = {
	                sessionUUID: submissionVM.sessionUUID.value,
	                quoteID: submissionVM.quoteID.value,
	                productCode: submissionVM.value.draftData.productCode
	            };
	
	            processMVRClue();
	        };
	
	        var requotedDataOnSuccess = function requotedDataOnSuccess() {
	
	            var quoting = submissionVM.quoteData.value;
	            //$scope.page.standardQuotes = _.where(quoting.offeredQuotes, {branchCode: "StandardProgram"});
	            if (submissionVM.value.draftData.productCode == "PersonalAuto") {
	                //$scope.page.standardQuotes = _.where(requotedOffers, {branchCode: "StandardProgram"});
	                $scope.page.standardQuotes = [];
	            } else {
	                $scope.page.standardQuotes = _.where(quoting.offeredQuotes, { isCustom: false });
	            }
	            $scope.page.customQuotes = _.where(quoting.offeredQuotes, { isCustom: true });
	            $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
	            $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
	            if (submissionVM.value.draftData.productCode === "PersonalAuto") {
	                vehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
	                var message = '';
	                for (var i in vehicles) {
	                    message = message + ErrorHandlingService.getVehicleAgeValidated(vehicles[i], $scope.page.customQuotes);
	                }
	                if (message != '') {
	                    ModalService.showError('quoteandbind.controllers.QuoteDetails.Attention', message).result;
	                }
	                drivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
	                for (x in $scope.page.offeringLabels) {
	                    if ("Best Value" == $scope.page.offeringLabels[x]) {
	                        $scope.tabSelected = parseInt(x) + 1;
	                    }
	                }
	                //TODO: get BI Limits from Submission VM
	                if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
	                    $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
	                } else {
	                    if (InMemorySession.getBiLimits() != undefined) $scope.biLimits = InMemorySession.getBiLimits().name;
	                }
	            }
	        };
	
	        ctrl.printQuote = function () {
	            $window.print();
	        };
	
	        ctrl.setSelectedQuote = function (quote) {
	            if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
	                $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
	            }
	        };
	
	        ctrl.getCustomQuoteHeaderCostString = function () {
	            return LocaleService.getLocaleInfo().currency.symbol + '0.00';
	        };
	
	        var jobDetails = {
	            jobNumber: submissionVM.quoteID.value
	        };
	
	        ctrl.buy = function (selectedQuote, numberOfPayments) {
	            StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	            StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
	            submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
	            var saveQuotedSubmission = LoadSaveService.saveQuotedSubmission(null, submissionVM.value);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
	            saveQuotedSubmission.then(function (response) {
	                var submissionModel = ViewModelService.create(response, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
	                flowModel.next(submissionModel);
	            }, function (error) {
	                $state.go('contactUs', { quoteID: submissionVM ? submissionVM.quoteID.value : null });
	            });
	        };
	
	        var processMVRClue = function processMVRClue() {
	            var response = MVRClueService.orderMVRClue(jobDetails);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', response);
	            return response.then(function (mvrDataResponse) {
	                getSubmission();
	            }, function (error) {
	                getSubmission();
	            });
	        };
	
	        var getSubmission = function getSubmission(selectedQuote, numberOfPayments) {
	            var submissionDTO = {
	                postalCode: submissionVM,
	                quoteID: submissionVM.quoteID.value
	            };
	
	            var requotedData = LoadSaveService.saveAndQuoteSubmission(null, submissionVM.value);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', requotedData);
	            return requotedData.then(function (reQuotedResponse) {
	                var premiumChangedFlag = 0;
	                var coveragesChanged = false;
	                doReQuoteOnFail = false;
	                var requotedOffers = reQuotedResponse.quoteData.offeredQuotes;
	                var quotedOffers = submissionVM.quoteData.offeredQuotes.value;
	                for (var x in requotedOffers) {
	                    if (requotedOffers[x].branchCode == "CUSTOM") {
	                        for (var vehicleCov in requotedOffers[x].lobs.personalAuto.vehicleCoverages) {
	                            if (requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != quotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length) {
	                                if (requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != 0) {
	                                    coveragesChanged = true;
	                                }
	                            }
	                        }
	                    }
	                }
	
	                if (coveragesChanged) {
	                    ModalService.showCustomInfo('quoteandbind.controllers.QuoteDetails.Attention', 'quoteandbind.controllers.QuoteDetails.coverages have changed').result;
	                }
	
	                submissionVM.quoteData = reQuotedResponse.quoteData;
	                requotedDataOnSuccess();
	            }, function (error) {
	
	                var exception = { error: error };
	
	                if (error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data && error[0].baseError.data.error && error[0].baseError.data.error.message != undefined) {
	                    message = error[0].baseError.data.error.message;
	                }
	
	                if (message && message.indexOf('coverage') > -1) {
	                    doReQuoteOnFail = true;
	                    var quoting = submissionVM.quoteData.value;
	                    if (submissionVM.value.draftData.productCode === "Homeowners") {
	                        $scope.page.standardQuotes = _.where(quoting.offeredQuotes, { isCustom: false });
	                    }
	                    if (submissionVM.value.draftData.productCode === "PersonalAuto") {
	                        $scope.page.standardQuotes = [];
	                    }
	                    $scope.page.customQuotes = _.where(quoting.offeredQuotes, { isCustom: true });
	                    $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
	                    $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
	
	                    $scope.page.standardQuotes = undefined;
	                    if (submissionVM.value.draftData.productCode != "Homeowners") {
	
	                        //TODO: get BI Limits from Submission VM
	                        if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
	                            $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
	                        } else {
	                            if (InMemorySession.getBiLimits() != undefined) $scope.biLimits = InMemorySession.getBiLimits().name;
	                        }
	                    }
	
	                    goToStep = ErrorHandlingService.getQuoteExceptionHandler(exception, submissionVM);
	                    if ('error' == goToStep) {
	                        var messageHeader = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
	                        var errorMsg = submissionVM.draftData.lobs.value.exception;
	                        if (ErrorHandlingService.isDisplayError(errorMsg)) {
	                            ModalService.showError(messageHeader, errorMsg);
	                        } else {
	                            $state.go('contactUs', { quoteID: submissionVM ? submissionVM.quoteID.value : null, errorMsg: submissionVM.draftData.lobs.value.exception });
	                        }
	                    }
	                } else {
	                    ErrorHandlingService.getBindExceptionHandler(exception, submissionVM);
	                    $state.go('contactUs', { quoteID: submissionVM ? submissionVM.quoteID.value : null, errorMsg: submissionVM.draftData.lobs.value.exception });
	                }
	                //StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	                //StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
	                //flowModel.next(submissionVM);
	                /*const errorPromise = ModalService.showError(
	                    'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
	                    'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
	                ).result;
	                errorPromise.then(function(resp) {
	                    $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null});
	                });*/
	            });
	        };
	
	        ctrl._setOfferingLabels = function (standardOfferings) {
	            return _.map(standardOfferings, function (offering) {
	                return $filter('translate')('quoteandbind.controllers.QuoteDetails.' + offering.branchCode);
	            });
	        };
	
	        ctrl._setBaseOffering = function (standardOfferings) {
	            if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
	                return standardOfferings[0];
	            } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
	                return standardOfferings[1];
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['LocaleService', '$filter', '$scope', '$anchorScroll', 'StateUtils', 'qnb.LoadSaveService', 'MVRClueService', '$window', 'submissionViewModel', '$state', 'ModalService', 'InMemorySession', '$q', 'qnb.ErrorHandlingService', 'ViewModelService', 'qnb.ViewModelCtx'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * Created by Neelakandan S.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	
	    var fn = function fn($scope, $http, $timeout, $stateParams, $state, submissionViewModel, ModalService, $q, StateUtils, InMemorySession, CustomQuoteService) {
	
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        var paModel = submissionVM.draftData.lobs.personalAuto.value;
	        var accountHolder = submissionVM.value.getAccountHolderPerson();
	
	        ctrl.init = function () {
	
	            $scope.eSignedPdfUrl = undefined;
	
	            $scope.view = submissionVM.draftData.eSignature;
	            $scope.retrievedIPAddress = false;
	
	            // Fill static values
	            $scope.view.ipAddress.value = "127.0.0.1";
	            $scope.view.eSignedName.value = accountHolder.displayName;
	            $scope.view.emailAddress.value = accountHolder.emailAddress1;
	            $scope.view.quoteNumber.value = submissionVM.quoteID.value;
	
	            $scope.servicePointUrl = window.location.origin;
	
	            // Set docLoaded as false when controller init; So it will shows the loading animator
	            $scope.docLoaded = false;
	
	            // Detect IE browser            
	            var isIeBrowser = function isIeBrowser() {
	                var userAgent = window.navigator.userAgent;
	                return userAgent.indexOf("Trident") > -1 || userAgent.indexOf("trident") > -1;
	            };
	
	            // scope varible to used to apply the css class
	            $scope.isIeBrowser = isIeBrowser();
	            console.log("isIeBrowser:: ", $scope.isIeBrowser);
	
	            // Increase the height of the gw esign form frame to avoid the overlapping of 
	            // iframe over the agreement checkbox.
	            //var esignFrame = document.getElementById("gw-esignature-form"); 
	            //esignFrame.style.height = "500px";            
	
	            // Check Iframe content:: Timer Function
	            // Every 1 second this function will check iframe content is
	            // loaded or not. if loaded then timer gets stopped and 
	            // loading animator frame will be hidden
	            var checkIframe = function checkIframe() {
	
	                var iframe = document.getElementById("qb-esign-form");
	
	                if (iframe == null) {
	                    $timeout(checkIframe, 1000);
	                } else {
	
	                    /*var elem = angular.element("#qb-esign-form");
	                    console.log("Elem Content: ",elem.contents());
	                    
	                    var iframeLoaded  = iframe.contentWindow.document.body.innerHTML;
	                    if(iframeLoaded == ""){
	                        $timeout(checkIframe, 1000);
	                    }
	                    else{
	                        $scope.docLoaded = true;
	                        
	                        // Reduce the height of the gw esign form frame to its original size  
	                        var esignFrame = document.getElementById("gw-esignature-form");
	                        esignFrame.style.height = "350px";
	                    }*/
	
	                    // For IE browser
	                    if (navigator.userAgent.indexOf("Trident") > -1) {
	                        $scope.docLoaded = true;
	                    }
	                    // Other than IE browsers
	                    else {
	
	                            iframe.onload = function () {
	                                $scope.docLoaded = true;
	
	                                // Reduce the height of the gw esign form frame to its original size  
	                                var esignFrame = document.getElementById("gw-esignature-form");
	                                esignFrame.style.height = "350px";
	                            };
	                        }
	                }
	            };
	
	            // Get IP Address from third party service
	            $http.get($scope.servicePointUrl + "/pc/service/clientip").then(function (successResponse) {
	
	                $scope.retrievedIPAddress = true;
	                //formatted ip to get the first ip from array for firewall issue --Arpita
	                var rawIP = successResponse.data.ip;
	                if (rawIP.length > 50) {
	                    rawIP = rawIP.substring(0, 50);
	                }
	                if (rawIP.includes(",")) {
	                    var formattedIp = successResponse.data.ip.split(',');
	                    $scope.view.ipAddress.value = formattedIp[0];
	                } else {
	                    $scope.view.ipAddress.value = rawIP;
	                }
	                //ended
	                var url = $scope.servicePointUrl + "/pc/service/docviewer";
	                var pdfurl = url + "?jobNumber=" + $scope.view.quoteNumber.value + "&eventName=Quote#toolbar=0";
	                //$scope.eSignedPdfUrl = 'http://docs.google.com/gview?url=' + pdfurl + '&embedded=true';
	                $scope.eSignedPdfUrl = pdfurl;
	                // Init Document Loader Timer
	                //$timeout(checkIframe, 1000);
	            }, function (failureResponse) {});
	        };
	
	        ctrl.isItAgreed = function () {
	
	            if ($scope.retrievedIPAddress && $scope.view.eSignAgreed && $scope.view.eSignAgreed.value
	            /*&& $scope.docLoaded*/) {
	                    // Enable this check if user wants to wait until the doc loads
	                    return false;
	                }
	
	            return true;
	        };
	
	        /*CustomQuoteService.doEsignature
	        
	        var ncDescriptionChoices = CustomQuoteService.retrieveVoilationTypes('quoteandbind', {state: "NC"});
	        $q.when(ncDescriptionChoices, function(response){
	        //console.log("producerCodeSummary:: ", response);
	        $scope.ncDescriptions = response.result;
	        });*/
	
	        ctrl.changeAgreeCondition = function () {
	
	            if ($scope.view.eSignAgreed.value) {
	                $scope.view.eSignedDate.value = new Date();
	                //console.log("eSignedDate: ",$scope.view.value);
	                var eSignReq = CustomQuoteService.doEsignature('quoteandbind', $scope.view.value);
	                $q.when(eSignReq, function (response) {
	                    //console.log("eSignReq:: ", response);
	                    //$scope.isValidSign = response.result;
	                });
	            }
	        };
	
	        ctrl.openModalWindow = function () {
	            //console.log("Open Modal Window!!!");
	            ModalService.showEsignAgreementModal();
	        };
	
	        ctrl.next = function (form) {
	
	            form.submitted = true;
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        return ctrl.create($scope);
	    };
	
	    fn.$inject = ['$scope', '$http', '$timeout', '$stateParams', '$state', 'submissionViewModel', 'ModalService', '$q', 'StateUtils', 'InMemorySession', 'qnb.CustomQuoteService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            autofillBasedOnVIN: function autofillBasedOnVIN(callGroups, vin) {
	                var deferred = $q.defer();
	                JsonRPCService.send('vinlookup', 'lookup', 'lookupBasedOnVIN', [vin], callGroups).then(function (vehicleInfo) {
	                    return deferred.resolve(vehicleInfo);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            autofillBasedOnPartialDto: function autofillBasedOnPartialDto(callGroups, dto) {
	                var deferred = $q.defer();
	                JsonRPCService.send('vinlookup', 'lookup', 'lookupBasedOnPartialDTO', [dto], callGroups).then(function (vehicleInfo) {
	                    return deferred.resolve(vehicleInfo);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            lookupMakes: function lookupMakes(callGroups) {
	                var deferred = $q.defer();
	                JsonRPCService.send('vinlookup', 'lookup', 'lookupMakes', [], callGroups).then(function (vehicleInfo) {
	                    return deferred.resolve(vehicleInfo);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            aaaVINLookup: function aaaVINLookup(callGroups, vinRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('vinlookup', 'aaalookup', 'vinValidation', [vinRequestDTO], callGroups).then(function (vehicleInfo) {
	                    return deferred.resolve(vehicleInfo);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            aaaHLDILookup: function aaaHLDILookup(callGroups, hldiRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('vinlookup', 'aaahldilookup', 'hldiValidation', [hldiRequestDTO], callGroups).then(function (vehicleInfo) {
	                    return deferred.resolve(vehicleInfo);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355),
	//'./config/RouteConfig',
	__webpack_require__(429), __webpack_require__(349), __webpack_require__(393), __webpack_require__(394), __webpack_require__(395), __webpack_require__(403), __webpack_require__(404), __webpack_require__(405), __webpack_require__(406), __webpack_require__(407), __webpack_require__(408), __webpack_require__(410), __webpack_require__(414), __webpack_require__(416), __webpack_require__(418), __webpack_require__(421), __webpack_require__(423), __webpack_require__(424), __webpack_require__(425), __webpack_require__(427), __webpack_require__(391), __webpack_require__(450), __webpack_require__(452), __webpack_require__(454), __webpack_require__(462), __webpack_require__(463), __webpack_require__(513), __webpack_require__(588), __webpack_require__(514), __webpack_require__(596), __webpack_require__(629), __webpack_require__(559), __webpack_require__(631), __webpack_require__(637), __webpack_require__(643), __webpack_require__(656), __webpack_require__(666), __webpack_require__(708), __webpack_require__(727), __webpack_require__(511), __webpack_require__(512)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, RouteConfig, ApplicationFeatures, QuestionSets, EmailService, LoadSaveService, ErrorHandlingService, CustomQuoteService, PolicyService, UserAccountService, InputValidationService, WizardSidebarAdditional, EditableCoverages, ReadonlyCoverages, CoveragePremiums, QuotePolicyBox, QuoteDetailsBox, QuoteComparisonPanel, Money, InfoBar, Confirmation, QuoteOffering, CustomQuote, LobSelection, CompositeFlowConfig, DefaultProductProvider) {
	    var questionSets = JSON.parse(QuestionSets);
	
	    return angular.module('edge.quoteandbind.common.app', ['edge.policyjob.app', 'portal.config', 'edge.platform.base', 'edge.platform.questionsets', 'ui.router', 'edge.platform.widgets.loadingMsg', 'edge.platform.widgets.modal', 'edge.platform.widgets.inputs', 'edge.platform.widgets.table', 'edge.platform.paymentdetails', 'edge.platform.widgets.ui.bootstrap.datetimepicker', 'edge.platform.widgets.ui.bootstrap.accordion', 'edge.platform.widgets.basicinputs', 'edge.platform.viewmodel.aspects', 'edge.platform.flow', 'edge.platform.widgets.wizard']).constant('lobConfig', {
	        lobs: ApplicationFeatures.getAllFeatures().quoteandbind_lob
	    }).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
	        var states = new RouteConfig(RootStateConfig);
	        for (var stateName in states) {
	            if (states.hasOwnProperty(stateName)) {
	                $stateProvider.state(stateName, states[stateName]);
	            }
	        }
	    }]).config(['QuestionSetServiceProvider', function (QuestionSetServiceProvider) {
	        QuestionSetServiceProvider.addQuestionSets(questionSets);
	    }]).factory('qnb.ErrorHandlingService', ErrorHandlingService).factory('qnb.EmailService', EmailService).factory('qnb.LoadSaveService', LoadSaveService).factory('qnb.CustomQuoteService', CustomQuoteService).factory('qnb.PolicyService', PolicyService).factory('qnb.UserAccountService', UserAccountService).factory('qnb.InputValidationService', InputValidationService).directive('gwQnbInfoBar', InfoBar).directive('gwWizardSidebarAdditional', WizardSidebarAdditional).directive('gwQnbEditableCoverages', EditableCoverages).directive('gwQnbReadonlyCoverages', ReadonlyCoverages).directive('gwQnbQuotePolicyBox', QuotePolicyBox).directive('gwQnbQuoteOffering', QuoteOffering).directive('gwQnbQuoteDetailsBox', QuoteDetailsBox).directive('gwQnbCoveragePremiums', CoveragePremiums).directive('gwQnbCustomQuote', CustomQuote).directive('gwQnbConfirmation', Confirmation).directive('gwQnbQuoteComparisonPanel', QuoteComparisonPanel).directive('gwQnbMoney', Money).directive('gwLobSelection', LobSelection).factory('qnb.CompositeFlowDefn', CompositeFlowConfig).factory('qnb.DefaultProductProvider', DefaultProductProvider).value('qnb.ViewModelCtx', {
	        'AccountEmailRequired': true,
	        'DriverEmailRequired': true,
	        'AccountDOBRequired': true
	    }).value('qnb.endpointConfig', {
	        'loadSaveEndpoint': 'quote',
	        'emailEndpoint': 'quote'
	    }).value('qnb.returnStateFn', function () {
	        return ['zipCode'];
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(392)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                quote: '=gwQnbQuoteOffering',
	                buy: '&',
	                nextSteps: '&',
	                header: '@',
	                biLimits: '@',
	                lob: '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 392 */
/***/ function(module, exports) {

	module.exports = "\n<div><b>{{header}}</b></div>\n<div ng-show=\"header === '{{'quoteandbind.controllers.QuoteDetails.PABasic' | translate}}'\">\n        {{'quoteandbind.controllers.QuoteDetails.PABasic.Market.Tagline' | translate}}\n</div>\n<div ng-show=\"header === '{{'quoteandbind.offeringLabels.Monthly Premium.Maximum Available' | translate}}'\">\n    {{'quoteandbind.controllers.QuoteDetails.StandardProgram.Market.Tagline' | translate}}\n    </div>\n</div>\n<div class=\"gw-start-policy\">\n    <div class=\"gw-single-quote\">\n        <div gw-qnb-quote-policy-box=\"quote\" class=\"gw-quote-box\" next-steps=\"nextSteps()\" buy=\"buy()\" quote-status=\"quoteStatus\"></div>\n    </div>\n</div>\n\n<div ng-if=\"quote.lobs.personalAuto && biLimits\">\n    <span>{{'quoteandbind.controllers.QuoteDetails.Current.Liability.Limits' | translate}}</span><span>{{biLimits}}</span>\n</div>\n\n\n<div ng-if=\"quote.lobs.personalAuto\">\n    <div gw-qnb-pa-view-coverages=\"quote.lobs.personalAuto\"></div>\n</div>\n<div ng-if=\"quote.lobs.homeowners\">\n    <div gw-qnb-ho-view-coverages=\"quote.lobs.homeowners\" lob=\"{{lob}}\"></div>\n</div>\n<div ng-if=\"quote.lobs.commercialProperty\">\n    <gw-qnb-cp-coverages commercial-property=\"quote.lobs.commercialProperty\" editable=\"false\"></gw-qnb-cp-coverages>\n</div>\n\n"

/***/ },
/* 393 */
/***/ function(module, exports) {

	module.exports = "{\n    \"HOGAGenericPreQual_HOE\": {\n        \"code\": \"HOGAGenericPreQual_HOE\",\n        \"displayKey\": \"questionkey.QuestionSet_HOGAGenericPreQual_HOE.Name\",\n        \"orderedQuestions\": [\n            {\n                \"code\": \"HOCovDeclined_HOE\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.HOCovDeclined_HOE.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 0\n            },\n            {\n                \"code\": \"HOBusiness_HOE\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.HOBusiness_HOE.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 1\n            },\n            {\n                \"code\": \"HOBusinesType_HOE\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.HOBusinesType_HOE.Text\",\n                \"required\": true,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"HOFarming\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zqlhmsc1bl8mu80n6btqpqktl09.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"HODayCare\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zi3jc3uouh7jgd5n8igi19bv63a.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"HOOffice\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zvtgoptuli1ruflpgc1ju8u7n18.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"HOBusTypeOther\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zbvjuh99a2v5tak29gcbl7pee78.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 2\n            },\n            {\n                \"code\": \"HOBusTypeOther_HOE\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.HOBusTypeOther_HOE.Text\",\n                \"required\": true,\n                \"questionType\": \"String\",\n                \"choices\": [],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"HOBusinesType_HOE\",\n                        \"answer\": \"HOBusTypeOther\"\n                    },\n                    {\n                        \"questionCode\": \"HOBusiness_HOE\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 3\n            },\n            {\n                \"code\": \"Select_Prior_InsStatus_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.Select_Prior_InsStatus_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"ContinuousCoverage_aaa\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z8fi2e448h7pu1egabn64sc3gcb.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"Lapse_30Days_aaa\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zd1h80pb53ploap3qkcpla79kt9.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"Lapsegrt_30days_aaa\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z3fis0sdgb4a94k4jq10j3jnv49.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"NewHomePurchase_aaa\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zsbj428u8166rce2dlbl3oavpe8.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 4\n            },\n            {\n                \"code\": \"IsPropertyInsCancelled_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.IsPropertyInsCancelled_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 5\n            },\n            {\n                \"code\": \"IsPropertyPurFC_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.IsPropertyPurFC_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 6\n            },\n            {\n                \"code\": \"conductbusiness_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.conductbusiness_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 7\n            },\n            {\n                \"code\": \"isFootTraffic_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isFootTraffic_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"conductbusiness_aaa\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 8\n            },\n            {\n                \"code\": \"descriptionofbusiness_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.descriptionofbusiness_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"String\",\n                \"choices\": [],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"isFootTraffic_aaa\",\n                        \"answer\": \"false\"\n                    }\n                ],\n                \"order\": 9\n            },\n            {\n                \"code\": \"isInsFraud_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isInsFraud_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 10\n            },\n            {\n                \"code\": \"isHomeSafe_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isHomeSafe_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 11\n            },\n            {\n                \"code\": \"DWOccupied_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.DWOccupied_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"owner_prim\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z5gjmvmovtm9j80kshesm3cn088.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"owner_sec\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z3biuc220co0h3clgvbiddqm7a9.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"rental_property\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z4kgev1tjp01n256uh03krli548.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"vacant\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zb3jktrdel9027rffvec6v2lp58.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"under_cons\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z8fi4b2gnbglu6dogjbbrsulgk9.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 12\n            },\n            {\n                \"code\": \"yearOfCons_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.yearOfCons_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Integer\",\n                \"choices\": [],\n                \"filters\": [],\n                \"order\": 13\n            },\n            {\n                \"code\": \"isPetDogAvailable_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isPetDogAvailable_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 14\n            },\n            {\n                \"code\": \"isLiabilityExp_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isLiabilityExp_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 15\n            },\n            {\n                \"code\": \"floodLosses_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.floodLosses_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 16\n            },\n            {\n                \"code\": \"isPlumbingPresent_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isPlumbingPresent_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 17\n            },\n            {\n                \"code\": \"isthereUnrepairedDamaged_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.isthereUnrepairedDamaged_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 18\n            },\n            {\n                \"code\": \"resLoc_aaa\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.resLoc_aaa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 19\n            },\n            {\n                \"code\": \"z3hhe2gai3rbfdorsr4vlvujfv9\",\n                \"displayKey\": \"questionkey.Question_HOGAGenericPreQual_HOE.z3hhe2gai3rbfdorsr4vlvujfv9.Text\",\n                \"required\": false,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"ho3\",\n                        \"displayKey\": \"questionkey.QuestionChoice_znbi4qmlk79lv91qkhee4jv8qaa.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"ho4\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zali6616i819f1ston1h5hhbshb.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"ho6\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zatgubn9tllg2a0pru32iqa47j8.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"he7\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zroikflse0ek9c1i4jv2cd6m37a.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"ho8\",\n                        \"displayKey\": \"questionkey.QuestionChoice_z86gqgffdap8qeb9f6r4e53ia4a.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 20\n            }\n        ]\n    },\n    \"PAPortal\": {\n        \"code\": \"PAPortal\",\n        \"displayKey\": \"questionkey.QuestionSet_PAPortal.Name\",\n        \"orderedQuestions\": [\n            {\n                \"code\": \"q1\",\n                \"displayKey\": \"questionkey.Question_PAPortal.q1.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 0\n            },\n            {\n                \"code\": \"q2\",\n                \"displayKey\": \"questionkey.Question_PAPortal.q2.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 1\n            },\n            {\n                \"code\": \"q3\",\n                \"displayKey\": \"questionkey.Question_PAPortal.q3.Text\",\n                \"required\": false,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"yes\",\n                        \"displayKey\": \"questionkey.QuestionChoice_ze0h0692grhjs5hiuimv4002caa.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"no\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zepgc8mjcmpvo2lois4mpmp2fl8.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"nonew\",\n                        \"displayKey\": \"questionkey.QuestionChoice_zcqic97nkbuke1j8msoavlk57p8.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 2\n            },\n            {\n                \"code\": \"q4\",\n                \"displayKey\": \"questionkey.Question_PAPortal.q4.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 3\n            }\n        ]\n    },\n    \"PAPersonalAutoPreQual\": {\n        \"code\": \"PAPersonalAutoPreQual\",\n        \"displayKey\": \"questionkey.QuestionSet_PAPersonalAutoPreQual.Name\",\n        \"orderedQuestions\": [\n            {\n                \"code\": \"PACurrentlyInsured\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.PACurrentlyInsured.Text\",\n                \"required\": false,\n                \"questionType\": \"Choice\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"notrenewed\",\n                        \"displayKey\": \"questionkey.QuestionChoice_wKgJFgdTaKwAAAAA.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"yes\",\n                        \"displayKey\": \"questionkey.QuestionChoice_wKgJFlgHZrIAAAAA.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"newdriver\",\n                        \"displayKey\": \"questionkey.QuestionChoice_wKgJFtjsLj4AAAAA.Name\"\n                    },\n                    {\n                        \"choiceCode\": \"notknown\",\n                        \"displayKey\": \"questionkey.QuestionChoice_wKgJFudb23cAAAAA.Name\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 0\n            },\n            {\n                \"code\": \"CurrentSuspense\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.CurrentSuspense.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 1\n            },\n            {\n                \"code\": \"Suspense\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.Suspense.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 2\n            },\n            {\n                \"code\": \"MovingViolations2\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.MovingViolations2.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 3\n            },\n            {\n                \"code\": \"DriverNameConviction\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.DriverNameConviction.Text\",\n                \"required\": true,\n                \"questionType\": \"String\",\n                \"choices\": [],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"MovingViolations2\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 4\n            },\n            {\n                \"code\": \"PriorDeclinedPolicy\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.PriorDeclinedPolicy.Text\",\n                \"required\": false,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 5\n            },\n            {\n                \"code\": \"z6agiu8u28ai5ev09ovkffvpcib\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.z6agiu8u28ai5ev09ovkffvpcib.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 6\n            },\n            {\n                \"code\": \"zsrh8c2m616hb8rtotggblckpa8\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zsrh8c2m616hb8rtotggblckpa8.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 7\n            },\n            {\n                \"code\": \"zifiuq0k5p1jk3cj0mcgqrnth99\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zifiuq0k5p1jk3cj0mcgqrnth99.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 8\n            },\n            {\n                \"code\": \"z49gs6dcgpsm138uqno87lq39a9\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.z49gs6dcgpsm138uqno87lq39a9.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 9\n            },\n            {\n                \"code\": \"znojuj59m5krv5o7bkme9ie5jk8\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.znojuj59m5krv5o7bkme9ie5jk8.Text\",\n                \"required\": true,\n                \"questionType\": \"String\",\n                \"choices\": [],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"z49gs6dcgpsm138uqno87lq39a9\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 10\n            },\n            {\n                \"code\": \"z5lg4an3uho9tdnlk5t9k4gm9j8\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.z5lg4an3uho9tdnlk5t9k4gm9j8.Text\",\n                \"required\": true,\n                \"questionType\": \"String\",\n                \"choices\": [],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"z49gs6dcgpsm138uqno87lq39a9\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 11\n            },\n            {\n                \"code\": \"ztjhui6mik0ctbtitk064j6niqa\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.ztjhui6mik0ctbtitk064j6niqa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"questionCode\": \"z49gs6dcgpsm138uqno87lq39a9\",\n                        \"answer\": \"true\"\n                    }\n                ],\n                \"order\": 12\n            },\n            {\n                \"code\": \"zlqjqkl1acu9e7r9gtmvnl6dt09\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zlqjqkl1acu9e7r9gtmvnl6dt09.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 13\n            },\n            {\n                \"code\": \"zf6h0fri4ikq39pkkff46osc6hb\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zf6h0fri4ikq39pkkff46osc6hb.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 14\n            },\n            {\n                \"code\": \"zu2jm5i0tg308assmtihps6rm88\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zu2jm5i0tg308assmtihps6rm88.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 15\n            },\n            {\n                \"code\": \"z16ig3t6fff637fd5jbgvr643vb\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.z16ig3t6fff637fd5jbgvr643vb.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 16\n            },\n            {\n                \"code\": \"zk8i2e6o7j3hva00ge0ts9rpp58\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zk8i2e6o7j3hva00ge0ts9rpp58.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 17\n            },\n            {\n                \"code\": \"zeiio6cnsgi92d3msunraq9fvg9\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zeiio6cnsgi92d3msunraq9fvg9.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 18\n            },\n            {\n                \"code\": \"z8fiovkghnit15tgqee9ji4icm9\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.z8fiovkghnit15tgqee9ji4icm9.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 19\n            },\n            {\n                \"code\": \"zhfgc784v4jdq6s49hddr69413b\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zhfgc784v4jdq6s49hddr69413b.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 20\n            },\n            {\n                \"code\": \"zaei8qh2qvm0u37i1994db6vat8\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zaei8qh2qvm0u37i1994db6vat8.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 21\n            },\n            {\n                \"code\": \"zdqj44m1p7072eqb7v4g3hts6oa\",\n                \"displayKey\": \"questionkey.Question_PAPersonalAutoPreQual.zdqj44m1p7072eqb7v4g3hts6oa.Text\",\n                \"required\": true,\n                \"questionType\": \"Boolean\",\n                \"choices\": [\n                    {\n                        \"choiceCode\": \"true\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.True\"\n                    },\n                    {\n                        \"choiceCode\": \"false\",\n                        \"displayKey\": \"displaykey.Java.NameValueView.Boolean.False\"\n                    }\n                ],\n                \"filters\": [],\n                \"order\": 22\n            }\n        ]\n    }\n}"

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', 'qnb.endpointConfig', function ($q, JsonRPCService, endpointConfig) {
	        var endpoint = endpointConfig.emailEndpoint;
	        return {
	            emailQuote: function emailQuote(callGroups, quoteEmailDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('quote', endpoint, 'emailQuote', [quoteEmailDTO], callGroups).then(function () {
	                    return deferred.resolve();
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(396)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Submission) {
	    return ['$q', 'JsonRPCService', 'qnb.ErrorHandlingService', 'qnb.endpointConfig', 'ModalService', function ($q, JsonRPCService, ErrorHandlingService, endpointConfig, ModalService) {
	
	        /**
	         *
	         * @param {Object} params
	         * @param params.callGroups
	         * @param params.submissionDTO
	         * @param {String} params.processName
	         * @param {Boolean} params.handleErrorBeforeRequest
	         * @param {Boolean} params.setDTOBeforeHandling
	         * @returns Promise
	         */
	        function processSubmission(params) {
	            var submissionDTO = params.submissionDTO;
	            var handleErrorBeforeRequest = params.handleErrorBeforeRequest;
	            var setDTOBeforeHandling = params.setDTOBeforeHandling;
	
	            var deferred = $q.defer();
	            if (handleErrorBeforeRequest) {
	                ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
	            }
	
	            var endpoint = endpointConfig.loadSaveEndpoint;
	            JsonRPCService.send('quote', endpoint, params.processName, [submissionDTO], params.callGroups).then(function (response) {
	                if (!handleErrorBeforeRequest) {
	                    if (setDTOBeforeHandling) {
	                        submissionDTO = new Submission(response);
	                    }
	                    ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
	                    if (!setDTOBeforeHandling) {
	                        submissionDTO = new Submission(response);
	                    }
	                } else {
	                    submissionDTO = new Submission(response);
	                }
	                return deferred.resolve(submissionDTO);
	            }, function (error, status, headers) {
	                return deferred.reject([error, status, headers]);
	            });
	            return deferred.promise;
	        }
	
	        return {
	            createSubmission: function createSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'create',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: true
	                });
	            },
	            saveAndQuoteSubmission: function saveAndQuoteSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'saveAndQuote',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: false
	                });
	            },
	            saveAndReQuoteSubmission: function saveAndReQuoteSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'saveAndReQuotes',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: false
	                });
	            },
	            saveSubmission: function saveSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'save',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: false
	                });
	            },
	            quoteSubmission: function quoteSubmission(callGroups, quoteID, sessionUUID) {
	                var submissionDTO = void 0;
	                var deferred = $q.defer();
	                var endpoint = endpointConfig.loadSaveEndpoint;
	                JsonRPCService.send('quote', endpoint, 'quote', [quoteID, sessionUUID], callGroups).then(function (response) {
	                    ErrorHandlingService.checkSessionUUID({ sessionUUID: sessionUUID }, deferred);
	                    submissionDTO = new Submission(response);
	                    return deferred.resolve(submissionDTO);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            saveQuotedSubmission: function saveQuotedSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'updateQuotedSubmission',
	                    handleErrorBeforeRequest: true,
	                    setDTOBeforeHandling: false
	                });
	            },
	            bindSubmission: function bindSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'bind',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: false
	                });
	            },
	            retrieveSubmission: function retrieveSubmission(callGroups, submissionDTO) {
	                return processSubmission({
	                    callGroups: callGroups,
	                    submissionDTO: submissionDTO,
	                    processName: 'retrieve',
	                    handleErrorBeforeRequest: false,
	                    setDTOBeforeHandling: false
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(397), __webpack_require__(399)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Person, PolicyLineExtensionConfiguration) {
	    var _nextId = 1;
	
	    function Submission(data) {
	        // PROCESS
	        if (data) {
	            data.persons = [];
	
	            data.draftData.accountHolder = this._forcePerson(data, data.draftData.accountHolder);
	            if (data.draftData.accountHolder) {
	                if (!data.draftData.accountHolder.subtype) {
	                    data.draftData.accountHolder.subtype = 'Person';
	                }
	                data.draftData.accountHolder.accountHolder = true;
	
	                //Sanitisation for data coming from core products. This can cause problems returning to backend
	                _.map(['prefix', 'suffix'], function (key) {
	                    data.draftData.accountHolder[key] = undefined;
	                });
	            }
	
	            _.extend(this, data);
	            _.map(this.persons, function (p) {
	                _.map(['prefix', 'suffix'], function (key) {
	                    p[key] = undefined;
	                });
	            });
	        } else {
	            this.persons = [];
	
	            this.draftData = {
	                accountHolder: {
	                    subtype: 'Person',
	                    accountHolder: true
	                },
	                // commented out to test default eff dt --Arpita Sengupta
	                // periodStartDate: new Date(),
	                // ended
	                lobs: {}
	            };
	        }
	        this.draftData.questionSetNames = [];
	
	        PolicyLineExtensionConfiguration.mixinLobDraftDataExtensions(this);
	    }
	
	    Submission.prototype.createId = function () {
	        return _nextId++;
	    };
	
	    Submission.prototype.nextId = function () {
	        return _nextId++;
	    };
	
	    // PERSON
	    Submission.prototype.createPerson = function () /*options*/{
	        var person = new Person({
	            tempId: _nextId++
	        });
	        this.persons.push(person);
	        return person;
	    };
	
	    // UTILS
	    Submission.prototype.getAccountHolderPerson = function () {
	        return this.draftData.accountHolder;
	    };
	
	    Submission.prototype.submissionExists = function () {
	        return !!this.quoteID;
	    };
	
	    Submission.prototype.findPerson = function (submission, person) {
	        if (_.isEmpty(person)) {
	            return null;
	        }
	
	        return this._forcePerson(submission, person);
	    };
	
	    Submission.prototype._forcePerson = function (submission, person) {
	        var p = person.publicID ? _.findWhere(submission.persons, { publicID: person.publicID }) : null;
	        if (!p) {
	            p = new Person(person);
	            p.tempId = _nextId++;
	            submission.persons.push(p);
	        }
	        return p;
	    };
	
	    return Submission;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(398)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, localeConfig) {
	    var nameConfig = JSON.parse(localeConfig).name;
	
	    function _append(sb, fieldId, value) {
	        if (!_.isEmpty(value) && _.contains(nameConfig.visibleFields, fieldId)) {
	            sb.push(value);
	        }
	    }
	
	    function _format(person, delimiter) {
	        var lastName = person.lastNameKanji || person.lastName;
	        var firstName = person.firstNameKanji || person.firstName;
	        var result = [];
	        switch (nameConfig.formatMode) {
	            case 'default':
	                _append(result, 'FirstName', firstName);
	                _append(result, 'LastName', lastName);
	                break;
	            case 'France':
	                _append(result, 'LastName', lastName);
	                _append(result, 'FirstName', firstName);
	                break;
	            case 'Japan':
	                _append(result, 'LastName', lastName);
	                _append(result, 'FirstName', firstName);
	                break;
	            case 'China':
	                _append(result, 'LastName', lastName);
	                _append(result, 'FirstName', firstName);
	                break;
	            default:
	                break;
	        }
	        return result.join(delimiter);
	    }
	
	    function Person(data) {
	        this.getDisplayName = function (defaultName, $filter) {
	            return _format(this, ' ') || defaultName || $filter('translate')('quoteandbind.controllers.Unnamed');
	        };
	
	        if (data) {
	            _.extend(this, data);
	            if (!data.firstName) {
	                data.firstName = '';
	            }
	            if (!data.lastName) {
	                data.lastName = '';
	            }
	        }
	    }
	
	    return Person;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 398 */
/***/ function(module, exports) {

	module.exports = "{\n    \"country\": {\n        \"code\": \"US\",\n        \"name\": \"United States\"\n    },\n    \"locales\": {\n        \"en_US\": \"English (US)\",\n        \"spanish_aaa\": \"Spanish\"\n    },\n    \"address\": {\n        \"fieldNames\": [\n            \"AddressLine3\",\n            \"AddressLine2\",\n            \"AddressLine1\",\n            \"State\",\n            \"Country\",\n            \"PostalCode\",\n            \"City\",\n            \"County\"\n        ],\n        \"pcfMode\": \"default\",\n        \"PostalCodeRegex\": \"[0-9]{5}(-[0-9]{4})?\"\n    },\n    \"phone\": {\n        \"UserDefaultPhoneCountry\": \"US\",\n        \"sample\": \"201-555-0123\"\n    },\n    \"name\": {\n        \"mode\": \"default\",\n        \"formatMode\": \"default\",\n        \"visibleFields\": [\n            \"Suffix\",\n            \"FirstName\",\n            \"Prefix\",\n            \"LastName\",\n            \"MiddleName\",\n            \"Name\"\n        ]\n    },\n    \"currency\": {\n        \"symbol\": \"$\",\n        \"fractionSize\": 2\n    },\n    \"preferredLocale\": \"en_US\"\n}"

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(396), __webpack_require__(400)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Submission, PASubmissionDraftDataExtension) {
	    return {
	        mixinLobDraftDataExtensions: function mixinLobDraftDataExtensions(submission) {
	            if (submission && submission.draftData && submission.draftData.productCode === 'PersonalAuto') {
	                submission.draftData.lobs = submission.draftData.lobs || {};
	                submission.draftData.lobs.personalAuto = new PASubmissionDraftDataExtension(submission);
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(396), __webpack_require__(401), __webpack_require__(397), __webpack_require__(402)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Submission, Driver, Person, Vehicle, DriverProcessService) {
	    var nextId = void 0;
	
	    var PASubmissionDraftDataExtension = function PASubmissionDraftDataExtension(submission) {
	        nextId = submission.nextId;
	
	        var data = submission.draftData.lobs.personalAuto;
	        //const accountHolder = submission.draftData.accountHolder;
	        //console.log("PA Submission AccountHolder:: ",accountHolder);
	
	        // Add account holder in the prototype
	        this.accountHolder = submission.draftData.accountHolder;
	
	        if (data && _.isObject(data)) {
	            this.drivers = _.map(data.drivers, function (d) {
	
	                var driver = new Driver(d);
	                if (d.person) {
	                    driver.person = submission.findPerson(submission, d.person);
	                }
	                if (driver.socialSecurityNumber && driver.socialSecurityNumber.indexOf("*") < 0) {
	                    driver.ssnunMasked = angular.copy(driver.socialSecurityNumber);
	                }
	                if (driver.socialSecurityNumber) {
	                    var ssnvalid = driver.socialSecurityNumber;
	                    ssnvalid = ssnvalid.substring(0, 3).replace(/\d/gi, '*') + '-' + ssnvalid.substring(4, 6).replace(/\d/gi, '*') + '-' + ssnvalid.substring(7, 11);
	                    driver.socialSecurityNumber = ssnvalid;
	                }
	                return driver;
	            }, this);
	
	            this.vehicles = _.map(data.vehicles, function (v) {
	                return new Vehicle(v);
	            }, this);
	            // ENHC0011961_EODB QnB Defaults - added membership details 
	            this.membershipPA = data.membershipPA;
	            // ended
	            this.preQualQuestionSets = data.preQualQuestionSets;
	        } else {
	            this.drivers = [];
	            this.vehicles = [];
	            this.preQualQuestionSets = [];
	            // ENHC0011961_EODB QnB Defaults - added membership details 
	            this.membershipPA = {};
	            //ended
	        }
	    };
	
	    PASubmissionDraftDataExtension.prototype.createDriver = function (person) {
	        var driver = new Driver({
	            person: person,
	            dateOfBirth: person.dateOfBirth
	        });
	        // extend
	        if (person && person.primaryAddress) {
	            driver.licenseState = person.primaryAddress.state;
	        }
	
	        driver.tempID = nextId();
	
	        //ssn
	        driver.ssnunMasked = "";
	        driver.socialSecurityNumber = "";
	
	        // Set state code for all drivers
	        driver.accountHolderState = this.accountHolder.primaryAddress.state;
	
	        driver.inExperiencedDriver = false;
	
	        driver.isAddAccidentValid = true;
	        driver.isEditAccidentValid = true;
	
	        // Defaulting drive status as "Rated" for all drivers
	        driver.driverStatus = "Rated";
	
	        // Set empty list for accident voilation list and accident portal list
	        driver.accidentVoilationList = [];
	        driver.accidentVoilationPortalList = [];
	        driver.drivesTheVehicle = false;
	        //ENHC0011961_EODB QnB Defaults --Arpita Sengupta
	        driver.maritialStatus = "S";
	        driver.educationalLevel = "highschool";
	        // driver.firstLicensed = "16";
	        driver.accidentsInLast3Years = false;
	        //ended
	        //driver.accid,entVoilationPortalList = DriverProcessService.mapAccidentListToPortal(driver.accidentVoilationList, driver.accountHolderState);
	
	        // Set account holder value if driver is primay driver
	        if (person && person.accountHolder) {
	            driver.isAccountHolder = true;
	        } else {
	            driver.isAccountHolder = false;
	        }
	        //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
	        if (driver.isAccountHolder && driver.person.occupation != null) {
	            driver.occupation = driver.person.occupation;
	        } else {
	            driver.occupation = "othersnotlisted";
	        }
	        if (driver.isAccountHolder && driver.person.payGrade != null) {
	            driver.payGrade = driver.person.payGrade;
	        }
	
	        //console.log("Driver:: ",driver);
	
	        /**
	             * Defect : DFCT0016955 - GPA – SC Auto Date First Licensed Rules no Longer Working (reference CHG00328640)
	             * Developer : Devnandan Kumar*/
	        if (driver.accountHolderState === 'SC') {
	            driver.minAge = 15;
	        } else {
	            driver.minAge = 16;
	        }
	        this.drivers.push(driver);
	        return driver;
	    };
	
	    PASubmissionDraftDataExtension.prototype.removeDriver = function (driver) {
	        var idx = _.indexOf(this.drivers, driver);
	        if (idx >= 0) {
	            this.drivers.splice(idx, 1);
	        }
	    };
	
	    PASubmissionDraftDataExtension.prototype.createVehicle = function (person) {
	        var v = new Vehicle({ tempID: nextId() });
	        if (person && person.primaryAddress) {
	            v.licenseState = person.primaryAddress.state;
	        }
	        //console.log("The account holderstate is",this.accountHolder)
	        v.accountHolderState = this.accountHolder.primaryAddress.state;
	        //v.inExpDriver = []
	        // ENHC0011961_EODB QnB Defaults --Arpita Sengupta 
	        v.primaryUse = "pleasure";
	        v.tmpPrimeUse = "Personal";
	        v.tmpPaType = "auto";
	        v.regularlyParked = true;
	        v.isCustomizedVehicle = false;
	        v.salvageTitle = false;
	        v.damageInAccident = false;
	        //ended
	        this.vehicles.push(v);
	        return v;
	    };
	
	    PASubmissionDraftDataExtension.prototype.removeVehicle = function (vehicle) {
	        var idx = _.indexOf(this.vehicles, vehicle);
	        if (idx >= 0) {
	            this.vehicles.splice(idx, 1);
	        }
	    };
	
	    PASubmissionDraftDataExtension.prototype.getDriverForPerson = function (person) {
	        var driver = _.findWhere(this.drivers, { person: person });
	
	        if (driver.dateOfBirth !== person.dateOfBirth) {
	            driver.dateOfBirth = person.dateOfBirth;
	        }
	
	        return driver;
	    };
	
	    return PASubmissionDraftDataExtension;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    function Driver(data) {
	        if (data) {
	            _.extend(this, data);
	            if (!data.dateOfBirth) {
	                data.dateOfBirth = null;
	            }
	        }
	    }
	
	    Driver.prototype.getDisplayName = function (defaultName, $filter) {
	        if (this.person.firstName === '0streamlinedquote0') {
	            return '';
	        }
	        return this.person.getDisplayName(defaultName, $filter);
	    };
	
	    Driver.prototype.getDriverStatesForCountry = function (states, countryCode) {
	        return _.filter(states, function (state) {
	            var countryConstraint = _.find(state.categories, function (constraint) {
	                return _.keys(constraint).indexOf('Country') !== -1;
	            });
	            if (countryConstraint) {
	                return countryConstraint.Country === countryCode;
	            }
	            return false;
	        });
	    };
	
	    return Driver;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    function Vehicle(data) {
	        if (data) {
	            _.extend(this, data);
	        }
	
	        if (!angular.isDefined(this.costNew)) {
	            this.costNew = {};
	        }
	    }
	
	    Vehicle.prototype.getDisplayName = function (defaultName, $filter) {
	        var name = this.make || '';
	        if (this.model) {
	            if (name) {
	                name += ' ';
	            }
	            name += this.model;
	        }
	        if (this.year) {
	            if (name) {
	                name += ' ';
	            }
	            name += this.year;
	        }
	        if (name.length < 1) {
	            name = $filter('translate')('quoteandbind.controllers.Unnamed');
	        } else if (this.license !== '0streamlinedquote0') {
	            if (this.license) {
	                name += ' (';
	                name += this.license;
	                if (this.licenseState) {
	                    name += '/';
	                    name += this.licenseState;
	                }
	                name += ')';
	            }
	        }
	        return name;
	    };
	
	    Vehicle.prototype.getVehicleStatesForCountry = function (states, countryCode) {
	        return _.filter(states, function (state) {
	            var countryConstraint = _.find(state.categories, function (constraint) {
	                return _.keys(constraint).indexOf('Country') !== -1;
	            });
	            if (countryConstraint) {
	                return countryConstraint.Country === countryCode;
	            }
	            return false;
	        });
	    };
	
	    return Vehicle;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return ['ModalService', '$filter', '$state', 'state_plugin_config', '$stateParams', function (ModalService, $filter, $state, statePluginConfig, $stateParams) {
	
	        function handleEntityExceptionAtQuote(error, model) {
	            var message = $filter('translate')('integration.quoteandbind.directives.ErrorHandling.An Error Occured While Quoting');
	            var errorMsg = '';
	            if (error) {
	                errorMsg = error;
	                var replacementText = '<br>&#9679;&nbsp;';
	                errorMsg = formatMessage(errorMsg, replacementText);
	                errorMsg = errorMsg.replace(/;/g, '');
	                errorMsg = removeDuplicates(errorMsg, '<br>&#9679&nbsp');
	                model.draftData.lobs.value.exception = errorMsg;
	                //ModalService.showError(message, errorMsg);
	                //model.draftData.lobs.value.exception = errorMsg;
	                //var promise = ModalService.showError(message, errorMsg);
	                //return 'paVehicleDetails'; //INC0017332-mail from kelsey to go to contact page
	                //ENHC0012054- Property / Update Eligibility for Protection Class 10 and 10W - adding error msg to display in contact us page - Arpita
	                if (errorMsg.indexOf('Protection Class Code') >= 0) {
	                    $stateParams.errorMsg = errorMsg;
	                } //ended
	                return 'error';
	            } else {
	                return 'error';
	            }
	        }
	        function removeDuplicates(msg, text) {
	            var msgArray = msg.split(text);
	            if (msgArray.length === 1) return msg;
	            var unique = [].concat(_toConsumableArray(new Set(msgArray)));
	            var modifiedMsg = '';
	            for (var count = 0; count < unique.length; count++) {
	                if (unique[count].trim() !== '') {
	                    modifiedMsg = modifiedMsg + text + unique[count];
	                }
	            }
	            return modifiedMsg;
	        }
	
	        function handleEntityExceptionAtBind(error, model) {
	            var errorMsg = '';
	            if (error) {
	                errorMsg = error;
	                var replacementText = '<br>';
	                errorMsg = formatMessage(errorMsg, replacementText);
	                errorMsg = errorMsg.startsWith("<br>") ? errorMsg.substring(4) : errorMsg;
	                errorMsg = errorMsg.replace(/;/g, '');
	                model.draftData.lobs.value.exception = errorMsg;
	            }
	            return 'error';
	        }
	
	        function handleUWException(error, model) {
	            var errorMsg = error;
	            if (errorMsg) {
	                if (errorMsg.indexOf('UnderwritingException') > -1) {
	                    errorMsg = errorMsg.replace(/edge.capabilities.quote.quoting.exception.UnderwritingException:/g, '');
	                }
	                if (errorMsg.indexOf('UWIssue') > -1) {
	                    errorMsg = errorMsg.replace(/UWIssue:/g, '');
	                }
	                errorMsg = errorMsg.replace(/\n/g, '<br />');
	                //UW issues not to be shown to user INC0017332 ex: slavage title
	                //model.draftData.lobs.value.exception = errorMsg;
	            }
	            return 'error';
	        }
	
	        function formatMessage(errorMsg, replacementText) {
	
	            if (errorMsg.indexOf('PersonalVehicleCov') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PersonalVehicleCov\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PersonalVehicleCov\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PolicyLine') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PolicyLine\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PolicyLine\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PolicyPeriod') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PolicyPeriod\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PolicyPeriod\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PolicyLocation') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PolicyLocation\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PolicyLocation\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PARiskAnalysis') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PARiskAnalysis\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PARiskAnalysis\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PersonalVehicle') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PersonalVehicle\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PersonalVehicle\//g, replacementText);
	                errorMsg = errorMsg.replace(/error:entity.PersonalVehicle.BodyType\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PAPolicyInfo') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PAPolicyInfo\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PAPolicyInfo\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PALineCoverages') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PALineCoverages\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PALineCoverages\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PALine') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PALine\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PALine\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PALineAssignment') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PALineAssignment\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PALineAssignment\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PALineDrivers') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PALineDrivers\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PALineDrivers\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PALineVehicles') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PALineVehicles\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PALineVehicles\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PersonalAutoLine') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PersonalAutoLine\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PersonalAutoLine\//g, replacementText);
	            }
	            if (errorMsg.indexOf('PersonalAutoCov') > -1) {
	                errorMsg = errorMsg.replace(/error:entity.PersonalAutoCov\//g, replacementText);
	                errorMsg = errorMsg.replace(/warning:entity.PersonalAutoCov\//g, replacementText);
	            }
	
	            return errorMsg;
	        }
	
	        return {
	            checkSessionUUID: function checkSessionUUID(submissionDTO, deferred) {
	                if (submissionDTO === undefined || submissionDTO.sessionUUID === null || submissionDTO.sessionUUID === '') {
	                    // If a session UUID wasn't created, reject with an error message
	                    return deferred.reject('Error creating quote');
	                }
	            },
	
	            getQuoteExceptionHandler: function getQuoteExceptionHandler(exception, model) {
	                var message = null;
	                var error = exception.error;
	                if (error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data && error[0].baseError.data.error && error[0].baseError.data.error.message != undefined) {
	                    message = error[0].baseError.data.error.message;
	                }
	                if (message && message.indexOf('entity') > -1) {
	                    return handleEntityExceptionAtQuote(message, model);
	                } else if (message && message.indexOf('UWIssue') > -1) {
	                    return handleUWException(message, model);
	                } else {
	                    return 'error';
	                }
	            },
	
	            getBindExceptionHandler: function getBindExceptionHandler(exception, model) {
	                var message = null;
	                var error = exception.error;
	                if (error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data && error[0].baseError.data.error && error[0].baseError.data.error.message != undefined) {
	                    message = error[0].baseError.data.error.message;
	                }
	                if (message && message.indexOf('entity') > -1) {
	                    return handleEntityExceptionAtBind(message, model);
	                } //added else if block for Underwriting issues for incident: INC0020671 by IN010M58288
	                else if (message && (message.indexOf('UWIssue') > -1 || message.indexOf('UnderwritingException') > -1)) {
	                        return handleUWException(message, model);
	                    } else {
	                        return 'error';
	                    }
	            },
	
	            getVehicleAgeValidated: function getVehicleAgeValidated(vehicle, customQuote) {
	                var vehicleYear = vehicle.year;
	                var vehicleName = vehicleYear + " " + vehicle.make + " " + vehicle.model + " ";
	                var vehicleId = vehicle.publicID;
	                var vehicleCovs = _.where(customQuote[0].lobs.personalAuto.vehicleCoverages, { publicID: vehicleId });
	                var today = new Date();
	                var year = today.getFullYear();
	                var errorMsg = '';
	
	                if (parseInt(year) >= parseInt(vehicleYear) + 20 && (vehicleCovs[0].coverages.length == 0 || vehicleCovs[0].coverages.find(function (x) {
	                    return x.publicID == "PAComprehensiveCov";
	                }) === undefined)) {
	                    var message = $filter('translate')('quoteandbind.controllers.ModalService.Attention');
	                    errorMsg = $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleAgePart1') + vehicleName + $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleAgePart2');
	                }
	                return errorMsg;
	            },
	
	            isDisplayError: function isDisplayError(errorMsg) {
	                var remPhysicalDamageCoverage = 'please remove physical damage coverages';
	                if (errorMsg.indexOf(remPhysicalDamageCoverage) > -1) {
	                    return true;
	                }
	                return false;
	            }
	
	            /*,
	             checkVehicleOutOfState: (vehicle, customQuote)=> {
	                     var vehicleYear =  vehicle.year;
	                     var vehicleName = vehicle.make +" "+ vehicle.model+" " + vehicleYear;
	                     var vehicleId = vehicle.publicID;
	                     var vehicleGarageState =  vehicle.parkedState;
	                     var vehicleCovs = _.where(customQuote[0].lobs.personalAuto.vehicleCoverages, {publicID: vehicleId});
	                     var errorMsg = '';
	                       var retVal = false
	                         if(vehicleGarageState == "CA" || vehicleGarageState == "FL" ||
	                             vehicleGarageState == "DC" || vehicleGarageState == "HI"
	                             || vehicleGarageState == "MA"
	                              || vehicleGarageState == "NJ"
	                             || vehicleGarageState == "NY" ){
	                           retVal = true
	                         }
	                       if(retVal && vehicleCovs[0].coverages.length == 0){
	                        var message = $filter('translate')('quoteandbind.controllers.ModalService.Attention');
	                        errorMsg = $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleOutOfState')+'<br>'+'<b>'+vehicleName+'</b>'+'<br><br>';
	                     }
	                     return errorMsg;
	                }*/
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(396)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            updateCustomQuote: function updateCustomQuote(callGroups, quoteDTO, sessionID, quoteID) {
	                var customQuoteDTO = {
	                    quote: quoteDTO,
	                    sessionUUID: sessionID,
	                    quoteID: quoteID
	                };
	                return JsonRPCService.send('quote', 'customquote', 'updateCustomQuote', [customQuoteDTO], callGroups);
	            },
	
	            updateCustomQuoteCoverages: function updateCustomQuoteCoverages(callGroups, quoteDTO, sessionID, quoteID) {
	                var customQuoteDTO = {
	                    quote: quoteDTO,
	                    sessionUUID: sessionID,
	                    quoteID: quoteID
	                };
	                return JsonRPCService.send('quote', 'customquote', 'updateCustomQuoteCoverages', [customQuoteDTO], callGroups);
	            },
	            doEsignature: function doEsignature(callGroups, eSignDTO) {
	
	                return JsonRPCService.send('quote', 'customquote', 'doEsignature', [eSignDTO], callGroups);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['JsonRPCService', function (JsonRPCService) {
	        return {
	            getAccountPolicySummaries: function getAccountPolicySummaries(callGroups) {
	                return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicySummaries', [], callGroups);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['JsonRPCService', function (JsonRPCService) {
	        return {
	            getAccountContactSummary: function getAccountContactSummary() {
	                return JsonRPCService.send('pc', 'profileinfo/user', 'getAccountContactSummary', []);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return ['ModalService', '$filter', '$state', 'state_plugin_config', '$stateParams', function (ModalService, $filter, $state, statePluginConfig, $stateParams) {
	        return {
	            isInputValid: function isInputValid(inputs) {
	                var regex = /^[A-Za-z0-9)(\":#\\\/&`', ._-]+$/;
	                var isValid = true;
	                var inValidInputs = [];
	                for (var i = 0; i < inputs.length; i++) {
	                    if (Object.values(inputs[i]).toString() && !regex.test(Object.values(inputs[i]).toString())) {
	                        inValidInputs.push(Object.keys(inputs[i]).toString());
	                        isValid = false;
	                    }
	                }
	                return [isValid, inValidInputs];
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(409)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return ['ModalService', 'qnb.EmailService', '$q', 'StateUtils', '$state', '$translate', function (ModalService, QuoteEmailService, $q, StateUtils, $state, $translate) {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            link: function link(scope) {
	                scope.quoteNumber = function () {
	                    var submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
	                    return submission ? submission.quoteID : null;
	                };
	
	                scope.emailQuote = function () {
	                    var submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
	                    var acctHolder = _.findWhere(submission.persons, { accountHolder: true });
	                    var emailInfo = {
	                        quoteID: submission.quoteID,
	                        sessionID: submission.sessionUUID
	                    };
	
	                    $q.when(QuoteEmailService.emailQuote('quoteandbind', emailInfo), function () {
	                        ModalService.showInfo('quoteandbind.directives.QnbWizardButtons.Quote Emailed', $translate('quoteandbind.directives.QnbWizardButtons.The quote details have been emailed', { emailAddress: acctHolder.emailAddress1 }));
	                    }, function () {
	                        ModalService.showError('quoteandbind.directives.QnbWizardButtons.Error', 'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
	                    });
	                };
	
	                scope.submissionCreated = function () {
	                    var submission = StateUtils.activeDataForState(true).flowModel.snapshot.value;
	                    return submission.submissionExists() && submission.draftData.accountHolder.emailAddress1;
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-wizard-sidebar-additional\">\n\n    <div class=\"gw-quote-saved-info\" ng-show=\"quoteNumber()\">\n        <p class=\"gw-title-line\">\n            {{'quoteandbind.directives.templates.QnbWizardButtons.Quote has been saved.' | translate }}\n        </p>\n        <p>\n            {{'quoteandbind.directives.templates.QnbWizardButtons.Write down this quote number to recall it later:' |\n            translate}}\n        </p>\n        <p class=\"gw-highlight\">{{quoteNumber()}}</p>\n    </div>\n\n    <!-- INC2595228 - Add Code for Phone Hyperlinks for Agencies\n        AB - 12/03/2020 -->\n\n    <p>\n        Have questions about your quote?<br>\n        Call us at <br>\n        <!--<b class=\"header-contact-info\">1-877-840-8642</b>. -->\n        <div class=\"header-contact-info\">\n            <div ng-switch=\"GetQnBSource()\">\n                <div ng-switch-when=\"SECU\">\n                    <a href=\"tel:{{'portal.index.SECU Contact' | translate}}\">\n                        <b>{{'portal.index.SECU Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"GORMISH\">\n                    <a href=\"tel:{{'portal.index.GORMISH Contact' | translate}}\">\n                        <b>{{'portal.index.GORMISH Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"SEA\">\n                    <a href=\"tel:{{'portal.index.SEA Contact' | translate}}\">\n                        <b>{{'portal.index.SEA Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"YOMTOB\">\n                    <a href=\"tel:{{'portal.index.YOMTOB Contact' | translate}}\">\n                        <b>{{'portal.index.YOMTOB Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"BWE\">\n                    <a href=\"tel:{{'portal.index.BWE Contact' | translate}}\">\n                        <b>{{'portal.index.BWE Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"SCOTT\">\n                    <a href=\"tel:{{'portal.index.SCOTT Contact' | translate}}\">\n                        <b>{{'portal.index.SCOTT Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"MERRILL\">\n                    <a href=\"tel:{{'portal.index.MERRILL Contact' | translate}}\">\n                        <b>{{'portal.index.MERRILL Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"CROWFIELD\">\n                    <a href=\"tel:{{'portal.index.CROWFIELD Contact' | translate}}\">\n                        <b>{{'portal.index.CROWFIELD Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"RICKARD\">\n                    <a href=\"tel:{{'portal.index.RICKARD Contact' | translate}}\">\n                        <b>{{'portal.index.RICKARD Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"NIXON\">\n                    <a href=\"tel:{{'portal.index.NIXON Contact' | translate}}\">\n                        <b>{{'portal.index.NIXON Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"BLUE\">\n                    <a href=\"tel:{{'portal.index.BLUE Contact' | translate}}\">\n                        <b>{{'portal.index.BLUE Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"GRAY\">\n                    <a href=\"tel:{{'portal.index.GRAY Contact' | translate}}\">\n                        <b>{{'portal.index.GRAY Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"JONES\">\n                    <a href=\"tel:{{'portal.index.JONES Contact' | translate}}\">\n                        <b>{{'portal.index.JONES Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"MCCARTHY\">\n                    <a href=\"tel:{{'portal.index.MCCARTHY Contact' | translate}}\">\n                        <b>{{'portal.index.MCCARTHY Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"ASSOCIATES\">\n                    <a href=\"tel:{{'portal.index.ASSOCIATES Contact' | translate}}\">\n                        <b>{{'portal.index.ASSOCIATES Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"ANTHONY\">\n                    <a href=\"tel:{{'portal.index.ANTHONY Contact' | translate}}\">\n                        <b>{{'portal.index.ANTHONY Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"SIMMONS\">\n                    <a href=\"tel:{{'portal.index.SIMMONS Contact' | translate}}\">\n                        <b>{{'portal.index.SIMMONS Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"WILLIAMS\">\n                    <a href=\"tel:{{'portal.index.WILLIAMS Contact' | translate}}\">\n                        <b>{{'portal.index.WILLIAMS Contact' | translate}}</b>\n                    </a>\n                </div>\n\n                <div ng-switch-when=\"MORRISON\">\n                    <a href=\"tel:{{'portal.index.MORRISON Contact' | translate}}\">\n                        <b>{{'portal.index.MORRISON Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"CRUMEL\">\n                    <a href=\"tel:{{'portal.index.CRUMEL Contact' | translate}}\">\n                        <b>{{'portal.index.CRUMEL Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"YOU\">\n                    <a href=\"tel:{{'portal.index.YOU Contact' | translate}}\">\n                        <b>{{'portal.index.YOU Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"MILLER\">\n                    <a href=\"tel:{{'portal.index.MILLER Contact' | translate}}\">\n                        <b>{{'portal.index.MILLER Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"PERSINSKI\">\n                    <a href=\"tel:{{'portal.index.PERSINSKI Contact' | translate}}\">\n                        <b>{{'portal.index.PERSINSKI Contact' | translate}}</b>\n                    </a>\n                </div>\n                <div ng-switch-when=\"FLOURNOY\">\n                    <a href=\"tel:{{'portal.index.FLOURNOY Contact' | translate}}\">\n                        <b>{{'portal.index.FLOURNOY Contact' | translate}}</b>\n                    </a>\n                </div>\n\n                <div ng-switch-default>\n                    <a href=\"tel:{{'portal.index.AAA Contact' | translate}}\">\n                        <b>{{'portal.index.AAA Contact' | translate}}</b>\n                    </a>\n                </div>\n            </div>\n        </div>\n    </p>\n\n</div>\n"

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(411), __webpack_require__(355), __webpack_require__(412)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, _, Coverage) {
	    var guid = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                coverages: '=gwQnbEditableCoverages',
	                loading: '=',
	                onCovChange: '=',
	                allowSelectCoverage: '=',
	                lob: '@'
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.uid = 'covs' + guid++;
	                $scope.showSelect = $scope.allowSelectCoverage;
	                function isLoading() {
	                    return $scope.loading;
	                }
	
	                function onChange() {
	                    if ($scope.onCovChange) {
	                        $scope.onCovChange();
	                    }
	                }
	
	                coveragesArray = ['HODW_SectionI_Ded_HOE', 'HODW_Dwelling_Cov_HOE', 'HODW_Other_Structures_HOE', 'HODW_Personal_Property_HOE', 'HODW_Loss_Of_Use_HOE', 'HOLI_Personal_Liability_HOE', 'HOLI_Med_Pay_HOE', 'AdditionalAmtInsHOE_aaa', 'ReplacementCost_ContentsCovHOE_aaa', 'ReplacementCostDweling_aaa', 'Refrigerated_PP_CovHOE_aaa', 'AccidentalDeathHOE_aaa', 'Identity_Fraud_Exp_Cov_aaa', 'WaterBackup_Sump_CovHOE_aaa', 'HOLI_PersonalInjury_HOE', 'Service_Line_Coverage_aaa', 'Home_Systems_Protection_aaa', 'Inland_Flood_Coverage_aaa', 'zk4gep2qoal242a7j69fqqc2489', 'zbmheeo71ls731ema216p58g9t9', 'zugggoahqeqao6efk0m7r8afbja', 'CICovAHOE_aaa'];
	
	                function setNewModel() {
	                    $scope.model = $scope.coverages.map(_.partial(Coverage.create, _, isLoading, onChange));
	                    if ($scope.lob === 'Homeowners') {
	                        $scope.filteredModel = _.filter($scope.model, function (item) {
	                            if (coveragesArray.indexOf(item.publicID) != -1) return item;
	                        });
	                    } else {
	                        $scope.filteredModel = $scope.model;
	                    }
	                }
	
	                setNewModel();
	                $scope.$watch('coverages', setNewModel);
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = "<table ng-if=\"model.length>0\" class=\"gw-table gw-qnb-coverages gw-table-custom\">\n\n    <tbody ng-repeat=\"coverage in filteredModel track by coverage.publicID\">\n    <tr>\n        <td class=\"gw-coverage-cell gw-notitle \">\n            <input ng-if=\"!coverage.required && showSelect\"\n                   type=\"checkbox\"\n                   id=\"{{uid}}_coverage_{{$index}}\"\n                   ng-model=\"coverage.selected\"\n                   ng-disabled=\"coverage.updating\" />\n            <label for=\"{{uid}}_coverage_{{$index}}\">\n                <b>{{ coverage.name }}</b>\n            </label>\n            <span class=\"aaa-inline-info-wrapper\">\n              <div class=\"aaa-inline-info\">  {{ coverage.description }}</div>\n              <i class=\"fa fa-info-circle\"></i>\n            </span>\n        </td>\n        <td title=\"{{coverage.name}}\" class=\"gw-term-cell custom-paddingTop25px\" ng-class=\"{'gw-notitle ' : !coverage.required && showSelect}\">\n            {{ coverage.amount | gwCurrency }}\n        </td>\n    </tr>\n    <!--DE2241 Fix : Start -->\n    <!--<tr ng-repeat=\"term in coverage.terms track by $index\" >\n        <td class=\"gw-notitle  gw-term-cell\">\n             <span class=\"aaa-inline-info-wrapper\">\n               &lt;!&ndash;<div class=\"aaa-inline-info\">{{ coverage.description }}</div>&ndash;&gt;\n                 {{ term.name }}\n            </span></td>\n        <td title=\"{{term.name}}\" class=\"gw-term-cell\">\n            <span class=\"gw-imageDiv\" ng-hide=\"!term.updating\">\n                <img src=\"../styles/images/common/throbber.gif\"/>\n            </span>\n            <select ng-if=\"term.hasOptions\"\n                    ng-disabled=\"term.updating\"\n                    gw-pl-select=\"term.value\"\n                    options=\"term.options\"\n                    option-value=\"'code'\"\n                    render-by=\"'name'\">\n            </select>\n            <input ng-if=\"!term.hasOptions && !term.hasDate\"\n                   type=\"text\"\n                   ng-disabled=\"term.updating\"\n                   ng-model=\"term.newValue\"\n                   ng-blur=\"term.applyNewValue()\"/>\n            <span ng-datepicker ng-if=\"!term.hasOptions && term.hasDate\"\n                      default-date=\"today\"\n                      min-view=\"day\"\n                      min-date=\"today\"\n                      ng-model=\"term.newValue\"\n                      ng-disabled=\"term.updating\"\n                     ></span>\n\n        </td>\n    </tr>-->\n\n    <tr ng-repeat=\"term in coverage.terms track by $index\">\n        <td class=\"gw-notitle gw-mobile-hidden gw-term-cell\" ng-if=\"term.visible\">{{ term.name }}</td>\n        <td class=\"gw-term-cell gw-notitle\" ng-if=\"term.visible\">\n            <div class=\"customFixClass\">\n                <span class=\"gw-imageDiv\" ng-hide=\"!term.updating\">\n                    <img src=\"../styles/images/common/throbber.gif\"/>\n                </span>\n                <span class=\"gw-desktop-hide\">{{term.name}}</span>\n                <select ng-if=\"term.hasOptions\"\n                        ng-disabled=\"term.updating\"\n                        gw-pl-select=\"term.value\"\n                        options=\"term.options\"\n                        option-value=\"'code'\"\n                        render-by=\"'name'\">\n                </select>\n                <input ng-if=\"!term.hasOptions && !term.hasDate && term.editable\"\n                       type=\"text\"\n                       ng-disabled=\"term.updating\"\n                       ng-model=\"term.newValue\"\n                       ng-blur=\"term.applyNewValue()\"/>\n                <label ng-if=\"!term.hasOptions && !term.hasDate && !term.editable\">{{term.newValue}}</label>\n                <span ng-datepicker ng-if=\"!term.hasOptions && term.hasDate\"\n                      default-date=\"today\"\n                      min-view=\"day\"\n                      min-date=\"today\"\n                      ng-model=\"term.newValue\"\n                      ng-disabled=\"term.updating\"\n                ></span>\n            </div>\n        </td>\n    </tr>\n    <!--DE2241 Fix : End -->\n    </tbody>\n</table>"

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(413), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CovTerm, _) {
	    /** Coverage model. */
	
	    return {
	        /**
	         * Creates a new coverage with the underlying coverage model. Return a new coverage with the following
	         * functions and properties:
	         *
	         * <dl>
	         *     <dt>name : String</dt><dd>Name of the coverage term</dd>
	         *     <dt>amount : Currency</dt><dd>Coverage amount</dd>
	         *     <dt>required : Boolean</dt><dd>Flag indicating that coverage is mandatory.</dd>
	         *     <dt>updating : () => Boolean</dt><dd>Flag set when this coverage is updating.</dd>
	         *     <dt>terms : CovTerm[]</dt><dd>Array of terms for this coverage</dd>
	         *     <dt>selected : Boolean</dt><dd>Flag indicating that property is selected.</dd>
	         *     <dt>publicId : String</dt><dd>Identifier of the coverage</dd>
	         * </dl>
	         *
	         * @param model coverage model.
	         * @param loading {Function} to retrieve current loading status.
	         * @param [onChange] {Function} function to invoke on the term change.
	         */
	        'create': function create(model, loading, onChange) {
	            onChange = onChange || _.noop;
	
	            var res = {
	                'name': model.name,
	                'amount': model.amount,
	                'required': model.required,
	                'publicID': model.publicID,
	                'description': model.description,
	                'terms': model.terms.map(_.partial(CovTerm.create, _, loading, onChange))
	            };
	
	            Object.defineProperty(res, 'updating', {
	                'get': loading || _.constant(false)
	            });
	
	            if (res.required) {
	                res.selected = true;
	            } else {
	                Object.defineProperty(res, 'selected', {
	                    'get': function get() {
	                        return model.selected;
	                    },
	                    'set': function set(nv) {
	                        model.selected = nv;
	                        model.updated = true;
	                        model.terms.forEach(function (term) {
	                            term.updated = true;
	                        });
	                        onChange();
	                    }
	                });
	            }
	
	            return Object.freeze(res);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    function createChoiceTerm(model, onChange) {
	        var res = {
	            'hasOptions': true,
	            'options': model.options
	        };
	
	        Object.defineProperty(res, 'value', {
	            'get': function get() {
	                return model.chosenTerm;
	            },
	            'set': function set(term) {
	                model.chosenTerm = term;
	                model.updated = true;
	                onChange();
	            }
	        });
	
	        return res;
	    }
	
	    function createInputTerm(model, onChange) {
	        var newValue = model.directValue;
	        var res = {
	            'hasOptions': false,
	            'hasDate': false,
	            'applyNewValue': function applyNewValue() {
	                if (newValue === model.directValue) {
	                    return;
	                }
	
	                if (newValue === '') {
	
	                    model.directValue = null;
	                } else {
	                    model.directValue = newValue;
	                }
	
	                model.updated = true;
	                onChange();
	            }
	        };
	
	        Object.defineProperty(res, 'newValue', {
	            'get': function get() {
	                return newValue;
	            },
	            'set': function set(nv) {
	                newValue = nv;
	            }
	        });
	
	        Object.defineProperty(res, 'value', {
	            'get': function get() {
	                return model.directValue;
	            },
	            'set': function set(nv) {
	                newValue = nv;
	                model.directValue = nv;
	                model.updated = true;
	                onChange();
	            }
	        });
	
	        return res;
	    }
	
	    function createInputDateTerm(model, onChange) {
	        var newValue = model.dateValue;
	        var res = {
	            'hasOptions': false,
	            'hasDate': true,
	            'applyNewValue': function applyNewValue() {
	                if (newValue === model.dateValue) {
	                    return;
	                }
	
	                if (newValue === '') {
	
	                    model.dateValue = null;
	                } else {
	                    model.dateValue = newValue;
	                }
	
	                model.updated = true;
	                onChange();
	            }
	        };
	
	        Object.defineProperty(res, 'newValue', {
	            'get': function get() {
	                return newValue;
	            },
	            'set': function set(ndv) {
	                newValue = ndv;
	                model.dateValue = ndv;
	                model.updated = true;
	                onChange();
	            }
	        });
	
	        Object.defineProperty(res, 'value', {
	            'get': function get() {
	                return model.dateValue;
	            },
	            'set': function set(ndv) {
	                newValue = ndv;
	                model.dateValue = ndv;
	                model.updated = true;
	                onChange();
	            }
	        });
	
	        return res;
	    }
	
	    /** Model of the coverage term. */
	    return {
	        /**  Creates a new coverage term with the underlying coverage model. Return a new term with the following
	         * functions and properties:
	         *
	         * <dl>
	         *     <dt>name : String</dt><dd>Name of the coverage term</dd>
	         *     <dt>options : Array</dt><dd>Optional array of the term options.</dd>
	         *     <dt>hasOptions : Boolean</dt>
	         *          <dd>Flag indicating that options are present and should be used for the term.</dd>
	         *     <dt>value : String</dt><dd>Read-write property of the coverage's value.</dd>
	         *     <dt>updating : () => Boolean</dt><dd>Flag set when this coverage is updating.</dd>
	         * </dl>
	         *
	         * @param model coverage model.
	         * @param loading {Function} to retrieve current loading status.
	         * @param [onChange] {Function} function to invoke on the term change.
	         */
	        'create': function create(model, loading, onChange) {
	            onChange = onChange || _.noop;
	
	            var base = !model.valueType ? createChoiceTerm(model, onChange) : model.valueType == 'datetime' ? createInputDateTerm(model, onChange) : createInputTerm(model, onChange);
	
	            base.name = model.name;
	            base.visible = model.visible;
	            base.editable = model.editable;
	
	            Object.defineProperty(base, 'updating', {
	                'get': loading || _.constant(false)
	            });
	
	            return Object.freeze(base);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(415), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, _) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                coverages: '=?gwQnbReadonlyCoverages',
	                lob: '@'
	            },
	            controller: ['$scope', function (scope) {
	                coveragesArray = ['HODW_SectionI_Ded_HOE', 'HODW_Dwelling_Cov_HOE', 'HODW_Other_Structures_HOE', 'HODW_Personal_Property_HOE', 'HODW_Loss_Of_Use_HOE', 'HOLI_Personal_Liability_HOE', 'HOLI_Med_Pay_HOE', 'AdditionalAmtInsHOE_aaa', 'ReplacementCost_ContentsCovHOE_aaa', 'ReplacementCostDweling_aaa', 'Refrigerated_PP_CovHOE_aaa', 'AccidentalDeathHOE_aaa', 'Identity_Fraud_Exp_Cov_aaa', 'WaterBackup_Sump_CovHOE_aaa', 'HOLI_PersonalInjury_HOE', 'Service_Line_Coverage_aaa', 'Home_Systems_Protection_aaa', 'Inland_Flood_Coverage_aaa', 'zk4gep2qoal242a7j69fqqc2489', 'zbmheeo71ls731ema216p58g9t9', 'zugggoahqeqao6efk0m7r8afbja', 'CICovAHOE_aaa'];
	
	                scope.model = scope.coverages.filter(function (coverage) {
	                    return coverage.selected;
	                });
	                if (scope.lob === 'Homeowners') {
	                    scope.selectedCoverages = _.filter(scope.model, function (item) {
	                        if (coveragesArray.indexOf(item.publicID) != -1) return item;
	                    });
	                } else {
	                    scope.selectedCoverages = scope.model;
	                }
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports = "<table ng-if=\"coverages.length>0\" class=\"gw-table gw-qnb-coverages\">\n    <tbody ng-repeat=\"coverage in selectedCoverages track by coverage.publicID\">\n    <tr>\n        <td class=\"gw-coverage-cell gw-notitle gw-mobile-hidden\">\n            <label>\n               {{ coverage.name }}\n            </label>\n            <span class=\"aaa-inline-info-wrapper\">\n                <div class=\"aaa-inline-info\">   {{ coverage.description }}\n                </div>\n                <i class=\"fa fa-info-circle\"></i>\n            </span></td>\n        <td title=\"{{coverage.name}}\" class=\"gw-term-cell\">{{ coverage.amount | gwCurrency }}</td>\n    </tr>\n    <tr ng-repeat=\"term in coverage.terms\">\n        <td class=\"gw-notitle gw-mobile-hidden gw-term-cell\">\n            <label>\n                {{ term.name }}\n            </label>\n        </td>\n        <td title=\"{{term.name}}\" class=\"gw-term-cell\">{{ term.chosenTermValue }}</td>\n    </tr>\n    </tbody>\n</table>\n\n"

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(417)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            scope: {
	                model: '=gwQnbCoveragePremiums'
	            },
	            template: templateStr,
	            controller: function controller($scope) {
	                $scope.buildingCoveragesByLocation = _.map(_.groupBy($scope.model.value.buildingCoverages, function (buildingCoverage) {
	                    return buildingCoverage.building.locationId;
	                }));
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 417 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-page-section-title gw-page-section-title__area\">{{'quoteandbind.directives.CoveragePremiums.Premiums' | translate}}</div>\n<div ng-if=\"buildingCoveragesByLocation.length > 0\" class=\"gw-qnb-coverage-premiums\">\n    <div class=\"gw-qnb-coverage-premiums__location\"\n         ng-repeat=\"location in buildingCoveragesByLocation track by $index\">\n\n        <!--TODO: is-primary should be taken from DTO -->\n        <gw-cp-location-header\n                is-primary=\"$index === 0\"\n                display-name=\"location[0].building.addressDisplayName\"\n                num-buildings=\"location.length\"\n                is-accordion-open=\"isAccordionOpen\"\n                primary-mark-next-line=\"false\"\n                show-building=\"false\"\n                show-actions=\"false\"\n                show-carrot=\"false\"\n        ></gw-cp-location-header>\n\n        <div class=\"gw-qnb-coverage-premiums__buildings\">\n            <div class=\"gw-qnb-coverage-premiums__building\"\n                 ng-repeat=\"buildingCoverages in location track by $index\">\n                <div class=\"gw-qnb-coverage-premiums__building-name\">\n                    <i class=\"fa fa-building-o gw-qnb-coverage-premiums__building-name-icon\"></i>\n                    {{ buildingCoverages.building.description }}\n                </div>\n                <div class=\"gw-qnb-coverage-premiums__building-premium\">\n                    {{ buildingCoverages.premium | gwCurrency }}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(419), __webpack_require__(420)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, templateStr, DiscountsTemplate) {
	    return ['$filter', 'ViewDiscountsService', 'ModalService', function ($filter, ViewDiscountsService, ModalService) {
	        var labelIDCounter = 0; //counter to allow for unique labels to be created for radio buttons
	
	        return {
	            restrict: 'A',
	            scope: {
	                buy: '=',
	                quote: '=gwQnbQuotePolicyBox',
	                loading: '=',
	                nextSteps: '='
	            },
	            template: templateStr,
	            controller: ['$scope', '$modal', function (scope, $modal) {
	
	                scope.labelIDCounter = labelIDCounter++;
	                scope.paymentPeriod = 'fullTerm';
	
	                scope.buyLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.Buy this policy');
	                scope.buyInFullLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.X Months', { termMonths: scope.quote.termMonths });
	                scope.buyInFullPALabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.Pay in Full');
	
	                scope.buyQuote = function () {
	                    var termInMonths = scope.paymentPeriod === 'fullTerm' ? scope.quote.termMonths : 1;
	                    scope.buy(scope.quote, termInMonths);
	                };
	
	                scope.goToNextSteps = function () {
	                    var termInMonths = scope.paymentPeriod === 'fullTerm' ? scope.quote.termMonths : 1;
	                    scope.nextSteps(scope.quote, termInMonths);
	                };
	
	                scope.viewDiscounts = function (quote) {
	                    scope.discounts = quote.discounts;
	                    var modalInstance = $modal.open({
	                        template: DiscountsTemplate,
	                        scope: scope
	                    });
	                };
	                /*
	                        CHG0031272 -    Display alert popup message when
	                                        comprehensive or collision coverages are not selected
	                                        for any vehicle on the quote
	                        AB - 06/27/2018
	                */
	                scope.confirmBuy = function (quote) {
	                    veh = quote.lobs.personalAuto.vehicleCoverages; //get all vehicles on the quote
	                    var NoCompColl = 0;
	                    for (i in veh) {
	                        // loop thru each vehicle on the quote
	                        var covs = veh[i].coverages; // get all coverages for a vehicle
	                        for (c in covs) {
	                            if (covs[c].name === "Comprehensive" && covs[c].selected === false) {
	                                NoCompColl = NoCompColl + 1;
	                            };
	
	                            if (covs[c].name === "Collision" && covs[c].selected === false) {
	                                NoCompColl = NoCompColl + 1;
	                            };
	                        }
	                    }
	
	                    if (NoCompColl > 0) {
	                        var title = $filter('translate')('quoteandbind.directives.QuotePolicyBox.CoverageAlert.heading');
	                        var message = $filter('translate')('quoteandbind.directives.QuotePolicyBox.CoverageAlert.static');
	                        var continueModel = ModalService.showCoverageAlert(title, message);
	                        continueModel.result.then(function () {
	                            scope.buyQuote();
	                        }, function () {});
	                    } else {
	                        scope.buyQuote();
	                    }
	                };
	
	                /* end of CHG0031272 */
	
	                //TODO: viewdiscounts to be enabled after clarification on how discounts are applied
	                /*  PersonalAuto={
	                    discountsLob : "PA"
	                    };
	                 HomeOwners={
	                    discountsLob : "HO"
	                }
	                 scope.viewDiscounts = (quote)=>{
	                    console.log("view discounts is clicked");
	                    if(quote.lobs.personalAuto){
	                        ViewDiscountsService.getDiscounts(PersonalAuto);
	                    }else if (quote.lobs.homeowners){
	                        ViewDiscountsService.getDiscounts(HomeOwners);
	                    }
	                 };*/
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 419 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"quote.lobs.homeowners \">\n    <div class=\"gw-price-details gw-text-align-center\">\n        <div>\n            <!--<input type=\"radio\"-->\n                   <!--id=\"quoteTermSingle{{labelIDCounter}}\"-->\n                   <!--ng-model=\"paymentPeriod\"-->\n                   <!--value=\"monthly\"/>-->\n            <label>\n                <!--for=\"quoteTermSingle{{labelIDCounter}}\"-->\n                <span class=\"gw-price\">{{quote.total|gwCurrency}}</span>\n                <span class=\"gw-term\">{{buyInFullLabel}}</span>\n            </label>\n        </div>\n        <!--<div>-->\n            <!--<input type=\"radio\"-->\n                   <!--id=\"quoteTermFull{{labelIDCounter}}\"-->\n                   <!--ng-model=\"paymentPeriod\"-->\n                   <!--value=\"fullTerm\"/>-->\n            <!--<label for=\"quoteTermFull{{labelIDCounter}}\">-->\n\n                <!--<span class=\"gw-price\">{{quote.monthlyPremium|gwCurrency}}</span>-->\n                <!--<span class=\"gw-term\">{{'quoteandbind.directives.QuotePolicyBox.Monthly' | translate}}</span>-->\n            <!--</label>-->\n        <!--</div>-->\n    </div>\n</div>\n<div ng-if=\"quote.lobs.personalAuto\">\n    <div class=\"gw-price-details \" >\n        <div>\n            <input type=\"radio\"\n            id=\"quoteTermSingle{{labelIDCounter}}\"\n            ng-model=\"paymentPeriod\"\n            value=\"monthly\"/>\n            <label  for=\"quoteTermSingle{{labelIDCounter}}\">\n                <span class=\"gw-price\">{{quote.total|gwCurrency}}</span>\n                <span class=\"gw-term\">{{buyInFullPALabel}}</span>\n            </label>\n        </div>\n        <div>\n            <input type=\"radio\"\n            id=\"quoteTermFull{{labelIDCounter}}\"\n            ng-model=\"paymentPeriod\"\n            value=\"fullTerm\"/>\n            <label for=\"quoteTermFull{{labelIDCounter}}\">\n                <span class=\"gw-price\">{{quote.monthlyPremium|gwCurrency}}</span>\n                <span class=\"gw-term\">{{'quoteandbind.directives.QuotePolicyBox.Monthly' | translate}}</span>\n            </label>\n        </div>\n    </div>\n</div>\n<div ng-if=\"quote.lobs.personalAuto\" class=\"gw-text-align-center\">\n    <!-- CHG0031272 -- Call confirmBuy function on ng-click -- AB 06/27/2018 -->\n    <!--<button class=\"gw-bordered\" ng-click=\"buyQuote()\" ng-disabled=\"loading\">{{buyLabel}}</button> -->\n        <button class=\"gw-bordered\" ng-click=\"confirmBuy(quote)\" ng-disabled=\"loading\">{{buyLabel}}</button>\n        <span ng-click=\"viewDiscounts(quote)\" ng-if=\"quote.discounts.length > 0\"><a>{{'quoteandbind.offeringLabels.link.view your discounts' | translate}}</a></span>\n    </div>\n\n    <div ng-if=\"quote.lobs.homeowners\" class=\"gw-text-align-center\">\n        <button class=\"gw-bordered\" ng-click=\"goToNextSteps()\" ng-disabled=\"loading\">{{'quoteandbind.offeringLabels.buttonLabel.Next Steps' | translate}}</button>\n        <span ng-click=\"viewDiscounts(quote)\" ng-if=\"quote.discounts.length > 0\"><a>{{'quoteandbind.offeringLabels.link.view your discounts' | translate}}</a></span>\n    </div>\n\n\n\n"

/***/ },
/* 420 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <div class=\"gw-modal-header\">\r\n        {{'quoteandbind.discounts.header' | translate}}\r\n    </div>\r\n    <div class=\"gw-modal-body\">\r\n        <div class=\"message\">\r\n            <table title=\"Discounts\">\r\n                <tbody>\r\n                <tr ng-repeat=\"item in discounts\">\r\n                    <td attribute=\"description\" title=\"Description\">\r\n                        {{item.discountName}}\r\n                    </td>\r\n                </tr>\r\n                </tbody>\r\n            </table>\r\n       </div>\r\n    </div>\r\n    <div class=\"gw-modal-footer\">\r\n        <button class=\"gw-btn gw-btn-primary\" ng-click=\"$close()\">\r\n            {{'quoteandbind.discounts.buttonLabel.Close' | translate}}\r\n        </button>\r\n    </div>\r\n</div>"

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(422), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, BaseCtrl) {
	    return [function () {
	        return {
	            restrict: 'A',
	            scope: {
	                buy: '=',
	                quote: '=gwQnbQuoteDetailsBox'
	            },
	            template: templateStr,
	            controller: ['$scope', 'StateUtils', function (scope, StateUtils) {
	
	                var ctrl = Object.create(BaseCtrl);
	                var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	                ctrl.init = function () {
	                    if (!flowModel) {
	                        return;
	                    }
	
	                    scope.paymentPeriod = 'fullTerm';
	                    scope.buyQuote = function () {
	                        var termInMonths = scope.paymentPeriod === 'fullTerm' ? scope.quote.termMonths : 1;
	                        scope.buy(scope.quote, termInMonths);
	                    };
	                };
	                /**
	                 * Method used by wizard ribbon to move between steps.
	                 * @param {Object} step - selected step
	                 */
	                ctrl.selectStep = function (step) {
	                    var currentModel = StateUtils.activeDataForState(true).model;
	                    if (flowModel.isStepAccessibleFromCurrent(step)) {
	                        flowModel.jumpToStep(step, currentModel);
	                    }
	                };
	
	                return ctrl.create(scope);
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 422 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-quote-details-box\">\n    <div class=\"gw-quote-details-box-container\">\n        <div class=\"gw-total-due\">\n            <div class=\"gw-total-row\">\n                <div>{{'quoteandbind.directives.QuoteDetailsBox.TotalPremium' | translate}}</div>\n                <div>{{quote.totalBeforeTaxes | gwCurrency}}</div>\n            </div>\n            <div class=\"gw-total-row\">\n                <div>{{'quoteandbind.directives.QuoteDetailsBox.Taxes' | translate}}</div>\n                <div>{{quote.taxes | gwCurrency}}</div>\n            </div>\n            <div class=\"gw-total-row\">\n                <hr/>\n            </div>\n            <div class=\"gw-total-row\">\n                <div>{{'quoteandbind.directives.QuoteDetailsBox.TotalCost' | translate}}</div>\n                <div class=\"gw-large-total\">{{quote.total | gwCurrency}}</div>\n            </div>\n        </div>\n        <div class=\"gw-actions\">\n            <div class=\"gw-total-row\">\n                <div>{{'quoteandbind.directives.QuoteDetailsBox.PolicyPeriod' | translate}}</div>\n                <div>{{ quote.periodStartDate | date: \"longDate\" }} - {{ quote.periodEndDate | date: \"longDate\" }}</div>\n            </div>\n            <div class=\"gw-page-buttons gw-total-row\">\n                <button class=\"gw-btn gw-quote-details-box__action-button\" ng-click=\"selectStep('cpCoverages')\">{{'quoteandbind.directives.QuoteDetailsBox.EditCoveragesButtonLabel' | translate}}</button>\n                <button class=\"gw-btn-primary gw-quote-details-box__action-button\" ng-click=\"buyQuote()\" ng-disabled=\"loading\">{{'quoteandbind.directives.QuoteDetailsBox.BuyButtonLabel' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return ['$window', function ($window) {
	        var windowEl = angular.element($window);
	
	        return {
	            restrict: 'A',
	            scope: {},
	
	            link: function link(scope, element) {
	                var startYOffset = void 0;
	                var isPositionedByTransform = false;
	
	                var throttleRunChecks = _.debounce(function () {
	                    checkPosition();
	                }, 50);
	
	                scope.$on('CustomQuoteSelected', function () {
	                    //have to wait until custom tab is selected and tab contents are visible until top coordinate can be retrieved
	                    $window.setTimeout(function () {
	                        startYOffset = startYOffset || angular.element(element).offset().top;
	                        checkPosition();
	                    }, 1000);
	                });
	
	                //check if node needs to be positioned
	                function checkPosition() {
	                    var repositionViaTransform = windowEl.scrollTop() > startYOffset;
	                    if (repositionViaTransform || repositionViaTransform !== isPositionedByTransform) {
	                        isPositionedByTransform = repositionViaTransform;
	                        handleNodeRepositioning();
	                    }
	                }
	
	                //position element either fixed or normal
	                function handleNodeRepositioning() {
	                    if (isPositionedByTransform) {
	                        //postion comparison panel 5px down from viewport
	                        var scollPosition = windowEl.scrollTop() - startYOffset;
	
	                        element.css({
	                            transform: 'translateY(' + scollPosition + 'px)',
	                            position: 'relative',
	                            'z-index': 100
	                        });
	                    } else {
	                        element.css({
	                            'transform': '',
	                            'z-index': ''
	                        });
	                    }
	                }
	
	                windowEl.on('scroll resize', throttleRunChecks);
	                scope.$on('$destroy', function () {
	                    windowEl.off('scroll resize');
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['LocaleService', function (LocaleService) {
	        function link(scope, el, attrs, ngModelCtrl) {
	            var symbol = LocaleService.getLocaleInfo().currency.symbol;
	
	            ngModelCtrl.$parsers.push(function (value) {
	                value = value.trim();
	                if (value[0] === symbol) {
	                    return value.slice(1);
	                }
	                if (value[value.length - 1] === symbol) {
	                    return value.substring(0, value.length - 1);
	                }
	                return value;
	            });
	        }
	
	        return {
	            require: 'ngModel',
	            restrict: 'A',
	            link: link
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(426)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return ['$filter', function ($filter) {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                'submission': '=gwQnbInfoBar'
	            },
	            controller: ['$scope', function (scope) {
	                scope.$filter = $filter;
	                scope.getAddress = function () {
	                    if (!scope.submission || !scope.submission.draftData || !scope.submission.draftData.accountHolder || !scope.submission.draftData.policyAddress) {
	                        return [];
	                    }
	
	                    var addr = scope.submission.draftData.policyAddress;
	                    return [addr.addressLine1, addr.city + ', ' + addr.state + ' ' + addr.postalCode];
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 426 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-quoteinfobar\" ng-if=\"submission.quoteID\">\n    <div class=\"gw-quoteinfobar-inner\" ng-if=\"submission && submission.draftData.productCode == 'PersonalAuto'\">\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Auto Insurance Quote' | translate}}\n            </div>\n            <div class=\"gw-infobar-content\">\n                {{submission.quoteID}}\n            </div>\n        </div>\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Location' | translate}}\n            </div>\n            <div class=\"gw-infobar-content\">\n                <ul>\n                    <li ng-repeat=\"line in getAddress()\">{{line}}</li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Vehicles' | translate}}\n                <span\n                        ng-if=\"submission.draftData.lobs.personalAuto.vehicles.length\"\n                        class=\"gw-infobar-badge\">{{submission.draftData.lobs.personalAuto.vehicles.length}}</span>\n            </div>\n            <div class=\"gw-infobar-content\">\n                <ul>\n                    <li ng-repeat=\"vehicle in submission.draftData.lobs.personalAuto.vehicles\">\n                        {{vehicle.getDisplayName(undefined, $filter)}}\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Drivers' | translate}}\n                <span\n                        ng-if=\"submission.draftData.lobs.personalAuto.drivers.length\"\n                        class=\"gw-infobar-badge\">{{submission.draftData.lobs.personalAuto.drivers.length}}</span>\n            </div>\n            <div class=\"gw-infobar-content\">\n                <ul>\n                    <li ng-repeat=\"driver in submission.draftData.lobs.personalAuto.drivers\">\n                        {{driver.getDisplayName(undefined, $filter)}}\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <!-- ENHC0011961_EODB QnB Defaults - adding label of effective and expiration date -- Arpita Sengupta */ -->\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Effective and Expiration' | translate}}\n            </div>\n            <div class=\"gw-infobar-content\">\n                <ul>\n                    <li ng-if=\"submission.draftData.periodEndDate.length && submission.draftData.periodStartDate.length\">{{submission.draftData.periodStartDate | date:'MM/dd/yyyy'}} - {{submission.draftData.periodEndDate | date:'MM/dd/yyyy'}}</li>\n                </ul>\n            </div>\n        </div>\n        <!-- ended -->\n    </div>\n    <div class=\"gw-quoteinfobar-inner\" ng-if=\"submission && submission.draftData.productCode == 'Homeowners'\">\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Homeowners Insurance Quote' | translate}}\n            </div>\n            <div class=\"gw-infobar-content\">\n                {{submission.quoteID}}\n            </div>\n        </div>\n        <div class=\"gw-infobar-item\">\n            <div class=\"gw-infobar-title\">\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Location' | translate}}\n            </div>\n            <div class=\"gw-infobar-content\">\n                <ul>\n                    <li ng-repeat=\"line in getAddress()\">{{line}}</li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(428), __webpack_require__(390)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"submission.draftData.productCode === 'Homeowners'\">\n    <div gw-ho-confirmation/>\n</div>\n<div ng-if=\"submission.draftData.productCode === 'PersonalAuto'\">\n    <div gw-pa-confirmation/>\n</div>\n<div ng-if=\"submission.draftData.productCode === 'CommercialProperty'\">\n    <div gw-cp-confirmation/>\n</div>\n\n"

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	//        'text!customerEdge/quoteandbind/common/views/account-lookup.html',
	__webpack_require__(431), __webpack_require__(439), __webpack_require__(432), __webpack_require__(433), __webpack_require__(434), __webpack_require__(435), __webpack_require__(436), __webpack_require__(437),
	
	//        'customerEdge/quoteandbind/common/controllers/AccountLookupCtrl',
	__webpack_require__(438), __webpack_require__(430), __webpack_require__(440), __webpack_require__(441), __webpack_require__(443), __webpack_require__(445), __webpack_require__(446), __webpack_require__(448), __webpack_require__(449), __webpack_require__(349)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseQnbWizardView, QuoteDetailsView, PaymentDetailsView, PaymentConfirmationView, ContactUsView, ConfirmationView, NextStepsView, ZipCodeView, QuoteEntryCtrl, BaseQnbWizardCtrl, QuoteDetailsCtrl, PaymentDetailsCtrl, PaymentConfirmationCtrl, ContactUsCtrl, ConfirmationCtrl, NextStepsCtrl, ZipCodeCtrl) {
	    return function (RootStates) {
	
	        var parentState = RootStates.quote_bind;
	        var wizardParentState = 'baseQnbWizard';
	        var homeState = RootStates.home;
	
	        return {
	            //changed for AAA : added account lookup state
	            // CHG0031104 - Changed back to Zipcode page
	            /*landingAccount: {
	                name: 'landingAccount',
	                parent: parentState,
	                url:'/home',
	                controller: AccountLookupCtrl,
	                template: AccountLookupView,
	                data: {
	                    errorMsg: null,
	                    actions: {
	                         next: 'zipCode'
	                    },
	                    homeState: homeState
	                }
	            },*/
	
	            zipCode: {
	                name: 'zipCode',
	                parent: parentState,
	                url: '/zipCode?account',
	                controller: ZipCodeCtrl,
	                template: ZipCodeView
	            },
	
	            quoteentry: {
	                name: 'quoteentry',
	                parent: parentState,
	                url: '/quoteentry',
	                controller: QuoteEntryCtrl,
	                params: {
	                    quoteID: null, //provided when resuming a draft submission
	                    postalCode: null, //provided when resuming or starting a submission
	                    productCode: null, //provided when starting a submission
	                    effectiveDate: null, //provided when starting a submission
	                    agentportalnewsubmission: null, //provided when starting a quote from gpa,
	                    account: null, // provided when starting a quote from amp
	                    shouldUpdateEffectiveDate: null // provided when starting a quote from qnb
	                },
	                resolve: {
	                    originState: ['$state', function ($state) {
	                        //remember the state we came from so we can return if there is an error loading the claim
	                        return { name: $state.current, params: $state.params };
	                    }]
	                }
	            },
	
	            baseQnbWizard: {
	                parent: parentState,
	                url: '/qnb-flow',
	                controller: BaseQnbWizardCtrl,
	                template: BaseQnbWizardView,
	                resolve: {
	                    submissionViewModel: ['StateUtils', function (StateUtils) {
	                        return function () {
	                            return StateUtils.dataForState(wizardParentState).model;
	                        };
	                    }]
	                }
	            },
	
	            quoteDetails: {
	                name: 'quoteDetails',
	                parent: wizardParentState,
	                controller: QuoteDetailsCtrl,
	                template: QuoteDetailsView
	            },
	
	            paymentDetails: {
	                name: 'paymentDetails',
	                parent: wizardParentState,
	                template: PaymentDetailsView,
	                controller: PaymentDetailsCtrl
	            },
	
	            paymentConfirmation: {
	                name: 'paymentConfirmation',
	                parent: wizardParentState,
	                template: PaymentConfirmationView,
	                controller: PaymentConfirmationCtrl
	
	            },
	
	            contactUs: {
	                name: 'contactUs',
	                url: '/contactus',
	                parent: parentState,
	                controller: ContactUsCtrl,
	                template: ContactUsView,
	                params: {
	                    returnStateInfo: null,
	                    errorMsg: null,
	                    quoteID: null
	                }
	            },
	
	            qnbconfirmation: {
	                name: 'confirmation',
	                url: '/qnbconfirmation',
	                parent: parentState,
	                controller: ConfirmationCtrl,
	                template: ConfirmationView,
	                params: {
	                    returnStateInfo: null,
	                    quoteSummary: null
	                }
	            },
	            nextSteps: {
	                name: 'nextSteps',
	                parent: parentState,
	                template: NextStepsView,
	                controller: NextStepsCtrl,
	                params: {
	                    returnStateInfo: null,
	                    submission: null
	                }
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    /*
	     The information being collected on this page is covered by PCI-DSS.
	     It is the customer's responsibility to ensure that any security/data protection measures that are required are implemented.
	     Data from this page should only ever be transmitted over HTTPS.
	     */
	    var fn = function fn($scope, StateUtils, $state, RootStates) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = StateUtils.dataForState('baseQnbWizard').model;
	
	        //work around for ui-router issue abstract base state and child state without url causes infinite loop
	        //so we have to make this base state concrete. But if we just refresh the browser here we need to redirect to home page.
	        if (!submissionVM) {
	            $state.go(RootStates.home);
	        }
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'StateUtils', '$state', 'state_plugin_config'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 431 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-quotewizard\">\n    <div class=\"gw-wizard\">\n        <div class=\"gw-wizard-sidebar\">\n            <div class=\"gw-wizard-sidebar-steps-wrapper\">\n                <div gw-wizard-sidebar-ribbon title=\"{{'quoteandbind.views.qnb.Quote Request' | translate }}\"></div>\n            </div>\n            <div gw-wizard-sidebar-additional/>\n        </div>\n        <div gw-wizard-content>\n            <div ui-view></div>\n        </div>\n    </div>\n</div>\n"

/***/ },
/* 432 */
/***/ function(module, exports) {

	module.exports = "<div>\n\n    <form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n         <!-- security vulnerabilities -->\n         <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\n            <div  class=\"custom-error\">\n                {{'quoteandbind.views.Name OR Address Value May Not Be Formatted Correctly' | translate}}\n            </div>\n        </div>\n        <!-- ended -->\n        <div ng-if=\"numberOfPayments != 1\">\n            <h2 class=\"gw-page-section-title\">{{'quoteandbind.views.payment-details.Please select your payment plan below' | translate }}</h2>\n            <section class=\"gw-payment-selection\">\n                <table at-table list=\"paymentPlans\" fill-last-page class=\"gw-table\">\n                    <thead></thead>\n                    <tbody>\n                    <tr>\n                        <td class=\"gw-notitle\">\n                            <input type=\"radio\" id=\"{{ item.name }}\" id=\"selectedPaymentPlan\"\n                                   ng-value=\"item.billingId\" ng-model=\"view.selectedPaymentPlan.value\">\n                            <label for=\"{{ item.name }}\">\n                                <!--without this label radio button disappears on mobile screens -->\n                            </label>\n                        </td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Name' | translate }}\">{{ item.name }}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Down Payment' | translate }}\">{{item.downPayment|gwCurrency}}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Installment' | translate }}\">{{item.installment|gwCurrency}}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Total' | translate }}\">{{item.total|gwCurrency}}</td>\n                    </tr>\n\n                </table>\n            </section>\n        </div>\n        <div ng-if=\"numberOfPayments == 1\">\n            <h2 class=\"gw-page-section-title\">{{'quoteandbind.views.payment-details.Please select your payment plan below' | translate }}</h2>\n            <section class=\"gw-payment-selection\">\n                <table at-table list=\"paymentPlans\" fill-last-page class=\"gw-table\">\n                    <thead></thead>\n                    <tbody>\n                    <tr>\n                        <td title=\"{{'quoteandbind.views.payment-details.Name' | translate }}\">{{ item.name }}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Down Payment' | translate }}\">{{item.downPayment|gwCurrency}}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Installment' | translate }}\">{{item.installment|gwCurrency}}</td>\n                        <td title=\"{{'quoteandbind.views.payment-details.Total' | translate }}\">{{item.total|gwCurrency}}</td>\n                    </tr>\n\n                </table>\n            </section>\n        </div><br/><br/>\n\n\n        <div ng-if=\"getPaymentFrequency()\">\n            <div class=\"payment-recurring-class\"><b>{{'quoteandbind.views.payment-details.Please note that monthly plan is a reoccurring payment option.' | translate }}</b></div><br/>\n            <div gw-payment-date-selector policy-effective-date=\"policyEffectiveDay\"  value-selected=\"dateSelected\"></div>\n        </div>\n\n        <span  ng-if=\"form.submitted && getPaymentFrequency() && dateSelected.value == '' \" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n\n        <div gw-wizard-page-actions next=\"next\"></div>\n\n    </form>\n</div>\n"

/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\r\n    <h2 class=\"gw-page-section-title\">{{'quoteandbind.views.payment-details.Please confirm this is the card' | translate }}\r\n        ${{downPayment}} {{'quoteandbind.views.payment-details.to' | translate }}\r\n    </h2> <br/>\r\n\r\n\r\n    <div>\r\n            <input type=\"radio\" id=\"PaymentItem\" ng-model=\"payment.selectedItem\" value=\"{{info.token}}\">\r\n            <label for=\"PaymentItem\">{{info.displayName}}</label>\r\n    </div>\r\n        <span  ng-if=\"form.submitted && (payment.selectedItem == undefined || payment.selectedItem == false)\" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\r\n    <br/><br/>\r\n\r\n    <!-- Devnandan : Added as part of EDelivery Enhancement -->\r\n    <div>{{'quoteandbind.views.payment-details.EDelivery.info' | translate}}</div><br></br>\r\n    <div>{{'quoteandbind.views.payment-details.Please note the card selected will be saved and charged for future installments.' | translate }}</div>\r\n    <br/><br/><br/>\r\n\r\n        <div >\r\n        <input type=\"checkbox\" ng-model=\"payment.terms\"  class=\"gw-no-label custom-margin-right5px\"><span>{{'quoteandbind.view.make-payment.EPT1'| translate}}\r\n            <a ng-click=\"showTerms()\">{{'quoteandbind.view.make-payment.EPT2'| translate}}</a></span>\r\n        <br>\r\n        <span  ng-if=\"form.submitted && (payment.terms == undefined || payment.terms == false)\" class=\"custom-error\">{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\r\n\r\n    </div><br/>\r\n\r\n\r\n   <!-- <div gw-wizard-page-actions next=\"next\" next-label=\"quoteandbind.views.payment-details.Purchase Policy\"></div>-->\r\n\r\n        <div class=\"gw-page-buttons\">\r\n            <button class=\"gw-btn\" type=\"button\"\r\n                    ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n            </button>\r\n\r\n            <button class=\"gw-btn-primary\" next-button\r\n                    ng-click=\"next(form)\">{{'quoteandbind.views.payment-details.Purchase Policy' | translate}}\r\n            </button>\r\n        </div>\r\n    </form>\r\n</div>\r\n"

/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <div class=\"gw-page gw-box\">\n        <h1 class=\"gw-page-title\">{{'quoteandbind.views.contact-us.Contact Us' | translate }}</h1>\n        <section class=\"gw-error-contact\">\n            <section class=\"gw-error-message gw-hmargin15\" ng-show=\"errorMsg\">\n                <h4>\n                    <span class=\"fa fa-exclamation-circle\"></span>\n                    <div class=\"custom-error\" ng-bind-html=\"errorMsg\"></div>\n\n                </h4>\n\n            </section>\n\n            <!-- INC2595228 - Add Code for Phone Hyperlinks for Agencies\n                 AB - 12/03/2020 -->\n\n            <section class=\"gw-main-content\">\n                <div ng-switch=\"GetQnBSource()\">\n                    <div ng-switch-when=\"SECU\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.SECU Contact' | translate}}\">\n                            {{'portal.index.SECU Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.SECU Contact' | translate}}\">\n                                    {{'portal.index.SECU Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"GORMISH\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.GORMISH Contact' | translate}}\">\n                                {{'portal.index.GORMISH Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.GORMISH Contact' | translate}}\">\n                                    {{'portal.index.GORMISH Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"SEA\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.SEA Contact' | translate}}\">\n                                {{'portal.index.SEA Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.SEA Contact' | translate}}\">\n                                    {{'portal.index.SEA Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"YOMTOB\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.YOMTOB Contact' | translate}}\">\n                                {{'portal.index.YOMTOB Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.YOMTOB Contact' | translate}}\">\n                                    {{'portal.index.YOMTOB Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"BWE\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.BWE Contact' | translate}}\">\n                                {{'portal.index.BWE Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.BWE Contact' | translate}}\">\n                                    {{'portal.index.BWE Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"SCOTT\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.SCOTT Contact' | translate}}\">\n                                {{'portal.index.SCOTT Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.SCOTT Contact' | translate}}\">\n                                    {{'portal.index.SCOTT Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"MERRILL\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.MERRILL Contact' | translate}}\">\n                                {{'portal.index.MERRILL Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.MERRILL Contact' | translate}}\">\n                                    {{'portal.index.MERRILL Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"CROWFIELD\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.CROWFIELD Contact' | translate}}\">\n                                {{'portal.index.CROWFIELD Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.CROWFIELD Contact' | translate}}\">\n                                    {{'portal.index.CROWFIELD Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"RICKARD\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.RICKARD Contact' | translate}}\">\n                                {{'portal.index.RICKARD Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.RICKARD Contact' | translate}}\">\n                                    {{'portal.index.RICKARD Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"NIXON\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.NIXON Contact' | translate}}\">\n                                {{'portal.index.NIXON Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.NIXON Contact' | translate}}\">\n                                    {{'portal.index.NIXON Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"BLUE\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.BLUE Contact' | translate}}\">\n                                {{'portal.index.BLUE Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.BLUE Contact' | translate}}\">\n                                    {{'portal.index.BLUE Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"GRAY\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.GRAY Contact' | translate}}\">\n                                {{'portal.index.GRAY Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.GRAY Contact' | translate}}\">\n                                    {{'portal.index.GRAY Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"JONES\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.JONES Contact' | translate}}\">\n                                {{'portal.index.JONES Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.JONES Contact' | translate}}\">\n                                    {{'portal.index.JONES Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"MCCARTHY\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.MCCARTHY Contact' | translate}}\">\n                                {{'portal.index.MCCARTHY Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.CROWFIELD Contact' | translate}}\">\n                                    {{'portal.index.MCCARTHY Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"ASSOCIATES\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.ASSOCIATES Contact' | translate}}\">\n                                {{'portal.index.ASSOCIATES Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.ASSOCIATES Contact' | translate}}\">\n                                    {{'portal.index.ASSOCIATES Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"ANTHONY\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.ANTHONY Contact' | translate}}\">\n                                {{'portal.index.ANTHONY Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.ANTHONY Contact' | translate}}\">\n                                    {{'portal.index.ANTHONY Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"SIMMONS\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.SIMMONS Contact' | translate}}\">\n                                {{'portal.index.SIMMONS Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.SIMMONS Contact' | translate}}\">\n                                    {{'portal.index.SIMMONS Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"WILLIAMS\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.WILLIAMS Contact' | translate}}\">\n                                {{'portal.index.WILLIAMS Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.WILLIAMS Contact' | translate}}\">\n                                    {{'portal.index.WILLIAMS Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div ng-switch-when=\"MORRISON\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.MORRISON Contact' | translate}}\">\n                                {{'portal.index.MORRISON Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.MORRISON Contact' | translate}}\">\n                                    {{'portal.index.MORRISON Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"CRUMEL\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.CRUMEL Contact' | translate}}\">\n                                {{'portal.index.CRUMEL Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.CRUMEL Contact' | translate}}\">\n                                    {{'portal.index.CRUMEL Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"YOU\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.YOU Contact' | translate}}\">\n                                {{'portal.index.YOU Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.YOU Contact' | translate}}\">\n                                    {{'portal.index.YOU Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"MILLER\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.MILLER Contact' | translate}}\">\n                                {{'portal.index.MILLER Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.MILLER Contact' | translate}}\">\n                                    {{'portal.index.MILLER Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"PERSINSKI\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.PERSINSKI Contact' | translate}}\">\n                                {{'portal.index.PERSINSKI Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.PERSINSKI Contact' | translate}}\">\n                                    {{'portal.index.PERSINSKI Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-switch-when=\"FLOURNOY\">\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.FLOURNOY Contact' | translate}}\">\n                                {{'portal.index.FLOURNOY Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.FLOURNOY Contact' | translate}}\">\n                                    {{'portal.index.FLOURNOY Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div ng-switch-default>\n                        <div ng-if=\"!quoteID\">\n                            {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                            <a href=\"tel:{{'portal.index.AAA Contact' | translate}}\">\n                                {{'portal.index.AAA Contact' | translate}}\n                            </a>\n                        </div>\n                        <div ng-show=\"quoteID != null\">\n                            <div ng-if=\"quoteID\">\n                                {{'quoteandbind.views.contact-us.Please contact us to discuss your quote over the phone.' | translate }}\n                                <a href=\"tel:{{'portal.index.AAA Contact' | translate}}\">\n                                    {{'portal.index.AAA Contact' | translate}}\n                                </a>\n                            </div>\n                            <div class=\"gw-control-group gw-reference-number\">\n                                <div class=\"gw-control-label gw-strong\">{{'quoteandbind.views.contact-us.Reference Number' | translate }}</div>\n                                <div class=\"gw-controls\">{{quoteID}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </section>\n        </section>\n    </div>\n</section>"

/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-page gw-box gw-quote-confirmation\">\n    <h1 class=\"gw-page-title\">\n        {{'quoteandbind.views.confirmation.Thank you for your purchase' | translate}}\n        <span class=\"gw-printing-buttons\">\n            <button ng-click=\"printQuote()\">\n                <span class=\"gw-icon fa fa-print\"></span>&nbsp;\n                {{'quoteandbind.views.quote-details.Print Quote' | translate}}\n            </button>\n        </span>\n    </h1>\n\n    <b>{{\"quoteandbind.views.confirmation.Register to Access Your Account Information 24/7:\" | translate}} </b>\n    <a ng-click=\"navigateToLogin()\" class=\"custom-underline\">{{'quoteandbind.views.confirmation.Manage My Account'|translate}}</a>\n\n    <h2 class=\"gw-page-section-title\"></h2>\n    <!-- Devnandan : Added as part of EDelivery Enhancement -->\n    <i>{{\"quoteandbind.views.payment-details.EDelivery.info\" | translate}}</i><br></br>\n    <i>{{\"quoteandbind.views.payment-details.Please note the card selected will be saved and charged for future installments.\" | translate}} </i>\n    <div>\n\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Policy Number' | translate}}</div>\n            <div class=\"gw-controls\">{{submission.bindData.policyNumber}}</div>\n        </div>\n\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Policy Effective and Expiration Date' | translate}}</div>\n            <div class=\"gw-controls\">{{submission.draftData.periodStartDate | date:'longDate'}} - {{submission.draftData.periodEndDate | date:'longDate'}}</div>\n        </div>\n\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Policy Total Amount' | translate}}</div>\n            <div class=\"gw-controls\">{{chosenQuote.total|gwCurrency}}</div>\n        </div>\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Payment Plan Selected' | translate}}</div>\n            <div class=\"gw-controls\">{{chosenPlan.name}}</div>\n        </div>\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Down Payment Received' | translate}}</div>\n            <div class=\"gw-controls\">{{chosenPlan.downPayment|gwCurrency}} {{'quoteandbind.views.confirmation.on' | translate}} {{today | date:'MMMM d,y h:mm a' }}</div>\n        </div>\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.views.confirmation.Next Schedule Installment' | translate}}</div>\n            <div class=\"gw-controls\">{{chosenPlan.installment|gwCurrency}} <!--{{'quoteandbind.views.confirmation.due on' | translate}} {{submission.draftData.periodStartDate | date:'longDate'}}--></div>\n        </div>\n    </div>\n\n\n    <div class=\"service-wrapper\">\n        <div><b>{{\"quoteandbind.views.confirmation.Register to...\" | translate}}</b></div>\n        <div><button class=\"gw-btn-primary\" ng-click=\"navigateToLogin()\">{{\"quoteandbind.views.confirmation.Manage My Account\" | translate}}</button></div>\n        <br/>\n        <div><b>{{\"quoteandbind.views.confirmation.Here are the tools and services for your insured\" | translate}}</b></div>\n        <div>{{\"quoteandbind.views.confirmation.View your policy information and account status\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.Submit auto and homeowners policy changes\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.View and pay your bill\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.Manage your reoccuring account settings\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.Report an auto and a homeowners claim\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.Check claim status\"| translate}}</div>\n        <div>{{\"quoteandbind.views.confirmation.View and print policy documents\"| translate}}</div>\n        <div><i><b>{{\"quoteandbind.views.confirmation.Our Promise Note\"| translate}}</b></i></div>\n    </div>\n</div>"

/***/ },
/* 436 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-quoteinfobar\" ng-if=\"quoteNo\">\r\n    <div class=\"gw-quoteinfobar-inner\">\r\n        <div class=\"gw-infobar-item\">\r\n            <div class=\"gw-infobar-title\">\r\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Homeowners Insurance Quote' | translate}}\r\n            </div>\r\n            <div class=\"gw-infobar-content\">\r\n                {{quoteNo}}\r\n            </div>\r\n        </div>\r\n        <div class=\"gw-infobar-item\">\r\n            <div class=\"gw-infobar-title\">\r\n                {{'integration.quoteandbind.directives.templates.qnb-info-bar.Location' | translate}}\r\n            </div>\r\n            <div class=\"gw-infobar-content\">\r\n                <ul>\r\n                    <li ng-repeat=\"line in getAddress()\">{{line}}</li>\r\n                </ul>\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!--    INC4972923 - Display agency name and phone number of the corresponding linked agency sites\r\n        AB - Aug 15, 2024\r\n-->\r\n<div class=\"next-steps-wrapper\">\r\n    <div class=\"body-wrapper\">\r\n        <div class=\"page box \">\r\n            <div class=\"next-steps-header\">\r\n                {{'quoteandbind.ho.views.next-steps.Next Steps'|translate}}\r\n            </div>\r\n            <div>\r\n                <div class=\"next-steps-body\">\r\n                    <div ng-switch=\"GetQnBSource()\">\r\n                        <div ng-switch-when=\"BWE\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BWE'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.BWE Contact'|translate}}\"><b>{{'portal.index.BWE Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BWE'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BWE'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.BWE Contact'|translate}}\"><b>{{'portal.index.BWE Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"SCOTT\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SCOTT'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.SCOTT Contact'|translate}}\"><b>{{'portal.index.SCOTT Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SCOTT'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SCOTT'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.SCOTT Contact'|translate}}\"><b>{{'portal.index.SCOTT Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"MERRILL\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MERRILL'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.MERRILL Contact'|translate}}\"><b>{{'portal.index.MERRILL Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MERRILL'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MERRILL'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.MERRILL Contact'|translate}}\"><b>{{'portal.index.MERRILL Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"GORMISH\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GORMISH'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.GORMISH Contact'|translate}}\"><b>{{'portal.index.GORMISH Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GORMISH'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GORMISH'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.GORMISH Contact'|translate}}\"><b>{{'portal.index.GORMISH Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"RICKARD\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_RICKARD'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.RICKARD Contact'|translate}}\"><b>{{'portal.index.RICKARD Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_RICKARD'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_RICKARD'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.RICKARD Contact'|translate}}\"><b>{{'portal.index.RICKARD Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"NIXON\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_NIXON'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.NIXON Contact'|translate}}\"><b>{{'portal.index.NIXON Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_NIXON'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_NIXON'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.NIXON Contact'|translate}}\"><b>{{'portal.index.NIXON Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"BLUE\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BLUE'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.BLUE Contact'|translate}}\"><b>{{'portal.index.BLUE Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BLUE'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_BLUE'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.BLUE Contact'|translate}}\"><b>{{'portal.index.BLUE Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"GRAY\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GRAY'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.GRAY Contact'|translate}}\"><b>{{'portal.index.GRAY Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GRAY'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_GRAY'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.GRAY Contact'|translate}}\"><b>{{'portal.index.GRAY Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"JONES\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_JONES'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.JONES Contact'|translate}}\"><b>{{'portal.index.JONES Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_JONES'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_JONES'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.JONES Contact'|translate}}\"><b>{{'portal.index.JONES Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"MCCARTHY\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MCCARTHY'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.MCCARTHY Contact'|translate}}\"><b>{{'portal.index.MCCARTHY Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MCCARTHY'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MCCARTHY'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.MCCARTHY Contact'|translate}}\"><b>{{'portal.index.MCCARTHY Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"SIMMONS\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SIMMONS'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.SIMMONS Contact'|translate}}\"><b>{{'portal.index.SIMMONS Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SIMMONS'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_SIMMONS'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.SIMMONS Contact'|translate}}\"><b>{{'portal.index.SIMMONS Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"WILLIAMS\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_WILLIAMS'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.WILLIAMS Contact'|translate}}\"><b>{{'portal.index.WILLIAMS Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_WILLIAMS'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_WILLIAMS'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.WILLIAMS Contact'|translate}}\"><b>{{'portal.index.WILLIAMS Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"MORRISON\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MORRISON'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.MORRISON Contact'|translate}}\"><b>{{'portal.index.MORRISON Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MORRISON'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MORRISON'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.MORRISON Contact'|translate}}\"><b>{{'portal.index.MORRISON Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"YOU\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_YOU'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.YOU Contact'|translate}}\"><b>{{'portal.index.YOU Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_YOU'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_YOU'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.YOU Contact'|translate}}\"><b>{{'portal.index.YOU Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"MILLER\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MILLER'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.MILLER Contact'|translate}}\"><b>{{'portal.index.MILLER Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MILLER'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_MILLER'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.MILLER Contact'|translate}}\"><b>{{'portal.index.MILLER Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-when=\"FLOURNOY\">\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_FLOURNOY'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.FLOURNOY Contact'|translate}}\"><b>{{'portal.index.FLOURNOY Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_FLOURNOY'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_FLOURNOY'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.FLOURNOY Contact'|translate}}\"><b>{{'portal.index.FLOURNOY Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-switch-default>\r\n                            <div class=\"next-steps-body-content\">\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P1'|translate}}\r\n                                </p>\r\n                                <p class=\"agent-details\">\r\n                                    {{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_AAA'|translate}} <br/>\r\n                                    <a ng-href=\"tel:{{'portal.index.AAA Contact'|translate}}\"><b>{{'portal.index.AAA Contact'|translate}}</b></a>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"next-steps-body-footer\">\r\n                                <p>\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_AAA'|translate}}</b>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P2_2'|translate}}\r\n                                </p>\r\n                                <p>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_1'|translate}}\r\n                                    <a ng-click=\"doNavigate()\" class=\"next-steps--underline\">{{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_2'|translate}}</a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_3'|translate}}\r\n                                    <b>{{'quoteandbind.ho.views.next-steps.QNB_SOURCE_NAME_AAA'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_4'|translate}}\r\n                                    <a ng-href=\"tel:{{'portal.index.AAA Contact'|translate}}\"><b>{{'portal.index.AAA Contact'|translate}}</b></a>\r\n                                    {{'quoteandbind.ho.views.next-steps.Thank you for quoting with AAA Insurance!.P3_5'|translate}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = "<section class=\"gw-quote-zip-page\">\n    <form class=\"gw-zip-box ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <div class=\"gw-zip-box-wrapper\">\n            <section class=\"gw-zip-box\">\n                <section class=\"gw-quote-inner\">\n                    <div class=\"gw-quote-area\">\n                        <!--<div class=\"gw-slq-area\">\n                            <a gw-quick-quote-link></a>\n                        </div>-->\n                        <div class=\"gw-zip-forms\">\n                            <div class=\"gw-zip-form\"\n                                ng-hide=\"hideGetQuoteForLeadcloud\"\n                                 ng-click=\"activateNewQuote()\"\n                                 ng-class=\"{'gw-selected-zip-form': activeSection !== 'new'}\"\n                            >\n                                <div class=\"gw-quote-header\">{{'quoteandbind.views.zip-code.GET A QUOTE' | translate }}\n                                </div>\n\n                                <div class=\"gw-zip-form-group\">\n                                    <div class=\"gw-zip-form-row-wrapper gw-mobile-input-width\">\n                                        <span class=\"gw-bullet-point\">1</span>\n                                        <input type=\"text\" ng-model=\"zipNew\"\n                                               ng-focus=\"activeSection = 'new'\"\n                                               name=\"PostalCodeNew\"\n                                               placeholder=\"{{'quoteandbind.views.zip-code.Enter Your ZIP' | translate }}\"\n                                               id=\"PostalCodeNew\"\n                                               class=\"gw-zip-input\"/>\n                                        <div class=\"gw-error-inline gw-error-zip\"\n                                             ng-class=\"{'gw-zip-hidden': !form.submitted || view.postalCode.aspects.valid}\">\n                                            {{view.postalCode.aspects.validationMessage}}\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div gw-lob-selection=\"view\" form=\"form\"></div>\n\n                                <div class=\"gw-zip-form-group\">\n                                    <div class=\"gw-zip-form-row-wrapper\">\n                                        <span class=\"gw-bullet-point\">3</span>\n                                        <button class=\"gw-btn-primary\" ng-click=\"goToNewQuote(form)\"\n                                                type=\"{{activeSection === 'new' ? 'submit' : 'button'}}\"\n                                                ng-focus=\"activeSection = 'new'\"\n                                        >\n                                            {{'quoteandbind.views.zip-code.Go!' | translate }}\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"gw-zip-form\"\n                                 ng-click=\"activateRetrieveQuote()\"\n                                 ng-class=\"{'gw-selected-zip-form': activeSection !== 'retrieve'}\"\n                            >\n                                <div class=\"gw-quote-header\">\n                                    {{'quoteandbind.views.zip-code.RETRIEVE A QUOTE' | translate }} \n                                    <span class=\"aaa-inline-info-wrapper\">\n                                        <div class=\"aaa-inline-info\">{{'quoteandbind.views.zip-code.retrieveQuote.Tooltip'|translate}}</div>\n                                        <i class=\"fa fa-info-circle\"></i>\n                                    </span>\n                                </div>\n\n                                <div class=\"gw-zip-form-group\">\n                                    <div class=\"gw-zip-form-row-wrapper gw-mobile-input-width\">\n                                        <span class=\"gw-bullet-point\">1</span>\n                                        <input type=\"text\" ng-model=\"zipRetrieve\"\n                                               ng-focus=\"activeSection = 'retrieve'\"\n                                               name=\"PostalCodeRetrieve\"\n                                               placeholder=\"{{'quoteandbind.views.zip-code.Enter Your ZIP' | translate }}\"\n                                               id=\"PostalCodeRetrieve\"\n                                               class=\"gw-zip-input\" \n                                               maxlength=\"5\"/>\n                                        <div class=\"gw-error-inline gw-error-zip\"\n                                             ng-class=\"{'gw-zip-hidden': !form.submitted || view.postalCode.aspects.valid}\">\n                                            {{view.postalCode.aspects.validationMessage}}\n                                        </div>\n\n                                    </div>\n                                </div>\n                                <div class=\"gw-zip-form-group\">\n                                    <div class=\"gw-zip-form-row-wrapper gw-mobilie-input-width\">\n                                        <span class=\"gw-bullet-point\">2</span>\n                                        <input type=\"text\"\n                                               ng-focus=\"activeSection = 'retrieve'\"\n                                               placeholder=\"{{'quoteandbind.views.zip-code.Enter Quote #' | translate }}\"\n                                               id=\"QuoteIDRetrieve\"\n                                               name=\"QuoteIDRetrieve\"\n                                               ng-model=\"view.quoteID.value\" \n                                               maxlength=\"25\">\n                                        <div class=\"gw-error-zip gw-error-inline\"\n                                             ng-class=\"{'gw-zip-hidden': !form.submitted || view.quoteID.value}\">\n                                            {{'quoteandbind.controllers.ZipCodeCtrl.Please enter your valid quote number to proceed.' | translate }}\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"gw-zip-form-group\">\n                                    <div class=\"gw-zip-form-row-wrapper\">\n                                        <span class=\"gw-bullet-point\">3</span>\n                                        <button type=\"{{activeSection === 'retrieve' ? 'submit' : 'button'}}\"\n                                                ng-focus=\"activeSection = 'retrieve'\"\n                                                class=\"gw-btn-primary\" ng-click=\"goToRetrieveQuote(form)\">\n                                            {{'quoteandbind.views.zip-code.Go!' | translate }}\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </section>\n            </section>\n        </div>\n\n        <!-- INC2595228 - Add Code for Phone Hyperlinks for Agencies\n             AB - 12/03/2020 -->\n\n        <div class=\"other-products-info\"> <!--{{'quoteandbind.views.zip-code.disclaimer.info' | translate }}</div> -->\n                <div ng-switch=\"GetQnBSource()\">\n                    <div ng-switch-when=\"SECU\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info SECU' | translate}}\n                            <a href=\"tel:{{'portal.index.SECU Contact' | translate}}\">\n                               {{'portal.index.SECU Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"GORMISH\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.GORMISH Contact' | translate}}\">\n                                {{'portal.index.GORMISH Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"SEA\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.SEA Contact' | translate}}\">\n                                {{'portal.index.SEA Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"YOMTOB\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.YOMTOB Contact' | translate}}\">\n                                {{'portal.index.YOMTOB Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"BWE\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.BWE Contact' | translate}}\">\n                                {{'portal.index.BWE Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"SCOTT\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.SCOTT Contact' | translate}}\">\n                                {{'portal.index.SCOTT Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"MERRILL\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.MERRILL Contact' | translate}}\">\n                                {{'portal.index.MERRILL Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"CROWFIELD\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.CROWFIELD Contact' | translate}}\">\n                                {{'portal.index.CROWFIELD Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"RICKARD\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.RICKARD Contact' | translate}}\">\n                                {{'portal.index.RICKARD Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"NIXON\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.NIXON Contact' | translate}}\">\n                                {{'portal.index.NIXON Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"BLUE\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.BLUE Contact' | translate}}\">\n                                {{'portal.index.BLUE Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"GRAY\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.GRAY Contact' | translate}}\">\n                                {{'portal.index.GRAY Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"JONES\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.JONES Contact' | translate}}\">\n                                {{'portal.index.JONES Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"MCCARTHY\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.MCCARTHY Contact' | translate}}\">\n                                {{'portal.index.MCCARTHY Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"ASSOCIATES\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.ASSOCIATES Contact' | translate}}\">\n                                {{'portal.index.ASSOCIATES Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"ANTHONY\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.ANTHONY Contact' | translate}}\">\n                                {{'portal.index.ANTHONY Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"SIMMONS\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.SIMMONS Contact' | translate}}\">\n                                {{'portal.index.SIMMONS Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"WILLIAMS\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.WILLIAMS Contact' | translate}}\">\n                                {{'portal.index.WILLIAMS Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n\n                    <div ng-switch-when=\"MORRISON\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.MORRISON Contact' | translate}}\">\n                                {{'portal.index.MORRISON Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"CRUMEL\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.CRUMEL Contact' | translate}}\">\n                                {{'portal.index.CRUMEL Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"YOU\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.YOU Contact' | translate}}\">\n                                {{'portal.index.YOU Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"MILLER\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.MILLER Contact' | translate}}\">\n                                {{'portal.index.MILLER Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"PERSINSKI\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.PERSINSKI Contact' | translate}}\">\n                                {{'portal.index.PERSINSKI Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n                    <div ng-switch-when=\"FLOURNOY\">\n                        <p class=\"other-products-info\">\n                            {{'quoteandbind.views.zip-code.disclaimer.info COMMON' | translate}}\n                            <a href=\"tel:{{'portal.index.FLOURNOY Contact' | translate}}\">\n                                {{'portal.index.FLOURNOY Contact' | translate}}\n                            </a>\n                        </p>\n                    </div>\n\n                    <div ng-switch-default>\n                        {{'quoteandbind.views.zip-code.disclaimer.info' | translate }}\n                        <a href=\"tel:{{'portal.index.AAA Contact' | translate}}\">\n                            {{'portal.index.AAA Contact' | translate}}\n                        </a>\n                    </div>\n                </div>\n        </div>\n\n        <!-- ENHC0012431 - Display Marketing related disclaimer on QnB landing page - AB 12/27/2022\n             ENHC0012609 (AAA Effort) QnB Disclaimer Update - AB 06/14/2023\n        -->\n        <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.zip-code.marketing.disclaimer.info.1'|translate}}\n            </p>\n        </div>\n        <!-- JD Power Disclaimer -->\n        <!-- <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.zip-code.marketing.disclaimer.info.3'|translate}}\n            </p>\n        </div> -->\n\n        <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.zip-code.marketing.disclaimer.info.2'|translate}}\n            </p>\n        </div>\n        <!-- ENHC0013603: Quote & Buy Portal Discliamer for JD Power -->\n        <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.zip-code.marketing.disclaimer.info.4'|translate}}\n                <a href=\"{{'quoteandbind.views.zip-code.marketing.disclaimer.info.5' | translate}}\">\n                    {{'quoteandbind.views.zip-code.marketing.disclaimer.info.6' | translate}}\n                </a>\n            </p>\n        </div>\n\n    </form>\n        </section>\n"

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(396), __webpack_require__(334)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, Submission, moment) {
	    var fn = function fn($scope, $rootScope, $state, $stateParams, LoadSaveService, ModalService, wizardFlowService, qnbCompositeFlowDefn, ViewModelService, viewModelContext, returnStateFn, AvailabilityService) {
	        var ctrl = Object.create(BaseCtrl);
	        var parentWizardState = 'baseQnbWizard';
	
	        ctrl.init = function () {
	
	            var stepToStateMapping = {
	                returnHome: function returnHome(model) {
	                    return returnStateFn(model);
	                },
	                confirmation: function confirmation(model) {
	                    return ['qnbconfirmation', {
	                        quoteSummary: model.value,
	                        returnStateInfo: returnStateFn(model.value)
	                    }];
	                },
	                nextSteps: function nextSteps(model) {
	                    return ['nextSteps', {
	                        submission: model.value,
	                        returnStateInfo: returnStateFn(model.value)
	                    }];
	                },
	                error: function error(model) {
	                    return ['contactUs', {
	                        errorMsg: model ? model.draftData.lobs.value.exception : '',
	                        quoteID: model ? model.quoteID.value : null
	                    }];
	                }
	            };
	            var flowfactory = wizardFlowService(qnbCompositeFlowDefn, parentWizardState, stepToStateMapping);
	
	            if ($stateParams.quoteID) {
	                //resume draft submission
	
	                // Check zipcode availability before retrieve submission
	                // Passing dummy productCode to avoid DTO validation error in back end
	                var availabilityRequest = {
	                    effectiveDate: new Date(),
	                    postalCode: $stateParams.postalCode,
	                    productCode: 'PersonalAuto'
	                };
	
	                var availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode('quoteandbind', availabilityRequest);
	                ModalService.showProgressDialog('quoteandbind.controllers.QuoteEntryCtrl.Retrieving draft submission...', availabilityPromise);
	                availabilityPromise.then(function (availabilityResponse) {
	
	                    if (availabilityResponse.isAvailable) {
	
	                        var submissionLoadPromise = LoadSaveService.retrieveSubmission('quoteandbind', $stateParams);
	                        ModalService.showProgressDialog('quoteandbind.controllers.QuoteEntryCtrl.Retrieving draft submission...', submissionLoadPromise);
	
	                        submissionLoadPromise.then(function (submissionData) {
	                            // Check the quote has expired or not, if expired then display error message
	                            if (submissionData.quoteStatus == 'Expired') {
	
	                                var errorPromise = ModalService.showError('quoteandbind.controllers.ZipCodeCtrl.Error', 'quoteandbind.controllers.ZipCodeCtrl.Quote Expired').result;
	
	                                $rootScope["isValidZipCodeRequest"] = true;
	
	                                errorPromise.then(function () {
	                                    //return the home page
	                                    $state.go('zipCode');
	                                });
	
	                                return;
	                            }
	                            //commenting to test default eff dt --Arpita Sengupta
	                            // if ($stateParams.shouldUpdateEffectiveDate && moment(submissionData.draftData.periodStartDate).isBefore(moment(), 'day')) {
	                            //     submissionData.draftData.periodStartDate = new Date();
	                            // }
	                            //ended
	                            var submission = new Submission(submissionData);
	                            var submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);
	                            flowfactory.resume(submissionVM, $stateParams);
	                        }).catch(function (errorResponse) {
	
	                            // Get response data
	                            var responseData = errorResponse[0].baseError.data;
	                            // Check if the response data has error message object
	                            // then check the error message and error app code
	                            // display the error message based on the error message and error app code
	                            if (angular.isObject(responseData) && responseData.error.message == 'Submission not found') {
	
	                                var errorPromise = ModalService.showError('quoteandbind.controllers.ZipCodeCtrl.Error', 'quoteandbind.controllers.ZipCodeCtrl.Please enter your valid quote number to proceed.').result;
	
	                                $rootScope["isValidZipCodeRequest"] = true;
	
	                                errorPromise.then(function () {
	                                    //return the home page
	                                    $state.go('zipCode');
	                                });
	                            }
	                            // check if response data is string (i.e HTTP error page)
	                            // then we are getting no response from server
	                            else {
	
	                                    var _errorPromise = ModalService.showError('quoteandbind.controllers.ZipCodeCtrl.Error', 'quoteandbind.controllers.ZipCodeCtrl.PC system down error').result;
	
	                                    $rootScope["isValidZipCodeRequest"] = true;
	
	                                    _errorPromise.then(function () {
	                                        //return the home page
	                                        $state.go('zipCode');
	                                    });
	                                }
	
	                            /*const errorPromise = ModalService.showError(
	                                'quoteandbind.controllers.QuoteEntryCtrl.Error retrieving submission',
	                                'quoteandbind.controllers.QuoteEntryCtrl.Sorry, but we can\'t seem to locate a quote with that number and that ZIP code. Please try again.'
	                            ).result;
	                            errorPromise.then(() => {
	                                //return the home page
	                                $state.go('zipCode');
	                            });*/
	                        });
	                    } else {
	                        //Show user error page explaining that the product isn't available
	                        /* ModalService.showError(
	                                 'quoteandbind.controllers.ZipCodeCtrl.Error',
	                                 'quoteandbind.controllers.ZipCodeCtrl.We do not recognize the zipcode entered, please try again.').result;*/
	
	                        ModalService.showError('quoteandbind.controllers.ZipCodeCtrl.Error', 'It seems you have entered a zip code not within the region of AAA Carolinas. Please try again or click ' + '<a target="_blank" href="http://www.aaa.com/stop">here</a>' + ' and reenter your zip code to find the AAA Club in your state.').result;
	
	                        $rootScope["isValidZipCodeRequest"] = true;
	
	                        //errorPromise.then(() => {
	                        //return the home page
	                        $state.go('zipCode');
	                        //});
	                    }
	                }).catch(function (e) {
	
	                    var errorPromise = ModalService.showError('quoteandbind.controllers.ZipCodeCtrl.Error', 'quoteandbind.controllers.ZipCodeCtrl.PC system down error').result;
	
	                    $rootScope["isValidZipCodeRequest"] = true;
	
	                    errorPromise.then(function () {
	                        //return the home page
	                        $state.go('zipCode');
	                    });
	                });
	            } else {
	                var submission = new Submission();
	                submission.draftData.productCode = $stateParams.productCode;
	                if ($stateParams.account) {
	                    submission.draftData.accountHolder = $stateParams.account;
	                    //submission.draftData.accountNumber = $stateParams.account.accountNumber;
	                    submission.draftData.policyAddress = $stateParams.account.primaryAddress;
	                }
	                var submissionModel = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);
	                flowfactory.start(submissionModel, $stateParams);
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'qnb.LoadSaveService', 'ModalService', 'WizardFlowService', 'qnb.CompositeFlowDefn', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.returnStateFn', 'AvailabilityService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"gw-page-section-title gw-page-section-title__area\"><div class=\"gw-page-section-title__left\">{{'quoteandbind.views.quote-details.Quote' | translate}}</div>\n        <span class=\"gw-printing-buttons gw-page-section-title__right\">\n            <button class=\"gw-btn\" ng-click=\"printQuote()\">\n                <span class=\"gw-icon fa fa-print\"></span>&nbsp;\n                {{'quoteandbind.views.quote-details.Print Quote' | translate}}\n            </button>\n        </span>\n    </div>\n\n    <div ng-if=\"page.productCode != 'PersonalAuto'\">\n\n        <tabset ng-if=\"page.standardQuotes.length !== 0\" justified=\"true\" default-tab =\"{{tabSelected}}\" lob-tab=\"{{page.productCode}}\">\n            <tab ng-repeat=\"quote in page.standardQuotes\" select=\"setSelectedQuote(quote)\">\n                <tab-heading class=\"gw-quotetab-header\">\n                    <div class=\"gw-offeringName\">{{ page.offeringLabels[$index] || quote.branchName }}</div>\n                    <div class=\"gw-offeringCost\">{{quote.monthlyPremium|gwCurrency}}</div>\n                    <div class=\"gw-offeringName\">{{'quoteandbind.offeringLabels.Monthly' | translate }}</div>\n                </tab-heading>\n\n                <div gw-qnb-quote-offering=\"quote\" buy=\"buy\" next-steps=\"nextSteps\" header=\"{{page.offeringLabels[$index]}}\" bi-limits=\"{{biLimits}}\" lob=\"{{page.productCode}}\"></div>\n            </tab>\n            <tab ng-repeat=\"quote in page.customQuotes\" heading=\"Custom $0.00\" select=\"setSelectedQuote(quote)\">\n                <tab-heading class=\"gw-quotetab-header\">\n                    <!--<div class=\"gw-offeringName\">{{'quoteandbind.views.quote-details.Custom' | translate}}</div>-->\n                    <div class=\"gw-offeringName\">{{'quoteandbind.offeringLabels.Build your quote here' | translate}}</div>\n                    <div class=\"gw-offeringCost\">{{getCustomQuoteHeaderCostString()}}</div>\n                    <div class=\"gw-offeringName\">{{'quoteandbind.offeringLabels.Monthly' | translate }}</div>\n                </tab-heading>\n\n                <div gw-qnb-custom-quote custom-quote=\"quote\"  next-steps=\"nextSteps\" standard-offering=\"page.baseOffering\" lob=\"{{page.productCode}}\"\n                     buy=\"buy\" sessionid=\"page.sessionUUID\" submissionid=\"page.quoteID\" header=\"{{'quoteandbind.offeringLabels.Build your quote here' | translate}}\" bi-limits=\"{{biLimits}}\"></div>\n            </tab>\n        </tabset>\n\n        <div ng-if=\"page.standardQuotes.length === 0\" gw-qnb-custom-quote custom-quote=\"page.customQuotes[0]\" next-steps=\"nextSteps\" standard-offering=\"page.baseOffering\"\n             buy=\"buy\" sessionid=\"page.sessionUUID\" submissionid=\"page.quoteID\"></div>\n\n    </div>\n\n    <div ng-if=\"page.productCode == 'PersonalAuto'\">\n        <tabset  justified=\"true\" default-tab =\"{{tabSelected}}\" lob-tab=\"{{page.productCode}}\" hide=\"true\"><!--ng-if=\"page.standardQuotes.length !== 0\"-->\n            <tab ng-repeat=\"quote in page.customQuotes\"  select=\"setSelectedQuote(quote)\"><!--heading=\"Custom $0.00\"-->\n                <div gw-qnb-custom-quote custom-quote=\"quote\" standard-offering=\"page.baseOffering\" lob=\"{{page.productCode}}\" next-steps=\"nextSteps\"\n                     buy=\"buy\" sessionid=\"page.sessionUUID\" submissionid=\"page.quoteID\"  bi-limits=\"{{biLimits}}\"></div> <!--header=\"{{'quoteandbind.offeringLabels.Build your quote here' | translate}}\"-->\n            </tab>\n        </tabset>\n    </div>\n\n\n\n</div>\n"

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn(LocaleService, $filter, $scope, $anchorScroll, StateUtils, LoadSaveService, MVRClueService, $window, submissionViewModel, $state, ModalService, InMemorySession, ErrorHandlingService, $timeout) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	        var vehicles;
	        var drivers;
	        var mvrClueFlag;
	        var doReQuoteOnFail;
	
	        ctrl.init = function () {
	            var quoting = submissionVM.quoteData.value;
	            $anchorScroll();
	            $scope.page = {
	                sessionUUID: submissionVM.sessionUUID.value,
	                quoteID: submissionVM.quoteID.value,
	                productCode: submissionVM.value.draftData.productCode
	            };
	            if (submissionVM.value.draftData.productCode === "Homeowners") {
	                $scope.page.standardQuotes = _.where(quoting.offeredQuotes, { isCustom: false });
	            }
	
	            if (submissionVM.value.draftData.productCode != "Homeowners") {
	                //$scope.page.standardQuotes = _.where(quoting.offeredQuotes, {branchCode: "StandardProgram"});
	                $scope.page.standardQuotes = [];
	            }
	            $scope.page.customQuotes = _.where(quoting.offeredQuotes, { isCustom: true });
	            $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
	            $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
	            $scope.$broadcast('CustomQuoteSelected', [$scope.page.customQuotes[0].publicID]);
	
	            if (submissionVM.value.draftData.productCode === "PersonalAuto") {
	
	                vehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
	                var message = '';
	                for (var i in vehicles) {
	                    message = message + ErrorHandlingService.getVehicleAgeValidated(vehicles[i], $scope.page.customQuotes);
	                }
	                if (message != '') {
	                    ModalService.showError('quoteandbind.controllers.QuoteDetails.Attention', message).result;
	                }
	                drivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
	                for (x in $scope.page.offeringLabels) {
	                    if ("Best Value" == $scope.page.offeringLabels[x]) {
	                        $scope.tabSelected = parseInt(x) + 1;
	                    }
	                }
	                //TODO: get BI Limits from Submission VM
	                if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
	                    $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
	                } else {
	                    if (InMemorySession.getBiLimits()) {
	                        $scope.biLimits = InMemorySession.getBiLimits().name;
	                    }
	                }
	                mvrClueFlag = true;
	            }
	        };
	
	        ctrl.printQuote = function () {
	            // $window.print();
	
	            var url = "/pc/service/printQuote";
	            $scope.pdfurl = url + "?jobNumber=" + submissionVM.quoteID.value;
	
	            var msgBox;
	            msgBox = ModalService.showLoadingDialog('quoteandbind.controllers.Please wait');
	
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (this.status === 200) {
	                    if (this.readyState === 4) {
	                        // Create the Blob Obj:
	                        var buffer = xhr.response;
	                        var blob = new Blob([buffer], {
	                            type: 'application/pdf'
	                        });
	                        if (window.navigator.msSaveOrOpenBlob) {
	                            window.navigator.msSaveOrOpenBlob(blob, 'Quote_' + submissionVM.quoteID.value + '_AAA');
	                        } else {
	                            var file_path = window.URL.createObjectURL(blob);
	                            var a = document.createElement('A');
	                            a.href = file_path;
	                            a.download = 'Quote_' + submissionVM.quoteID.value + '_AAA';
	                            document.body.appendChild(a);
	                            a.click();
	                            document.body.removeChild(a);
	                        }
	                    }
	                    msgBox.close();
	                } else if (this.status != 200 && this.status != 0 && this.readyState === 4) {
	                    msgBox.close();
	                    ModalService.showError('quoteandbind.controllers.ModalService.Attention', 'quoteandbind.controllers.Print Error');
	                }
	            };
	            xhr.open('GET', $scope.pdfurl, true);
	            xhr.responseType = 'arraybuffer';
	            xhr.send();
	            $timeout(function () {
	                msgBox.close();
	            }, 50000);
	        };
	
	        ctrl.setSelectedQuote = function (quote) {
	            if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
	                $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
	            }
	        };
	
	        ctrl.getCustomQuoteHeaderCostString = function () {
	            return LocaleService.getLocaleInfo().currency.symbol + '0.00';
	        };
	
	        jobDetails = {
	            jobNumber: submissionVM.quoteID.value
	        };
	
	        ctrl.buy = function (selectedQuote, numberOfPayments) {
	            //stash some bind information in state data so it can be accessed later when we call the bind method
	            var vinflag = 0;
	            var licflag = 0;
	
	            for (x in vehicles) {
	                if (vehicles[x].vin && vehicles[x].vin.length === 17 || vehicles[x].isPrefilledVehicle && vehicles[x].encryptedVIN && InMemorySession.decryptData(vehicles[x].encryptedVIN).length === 17) {
	                    vinflag = vinflag + 1;
	                }
	            };
	
	            for (x in drivers) {
	                if (drivers[x].licenseNumber || drivers[x].eNCLicenseNumber) {
	                    licflag = licflag + 1;
	                }
	            };
	
	            if ($scope.reqoutedvehicleCoverages) {
	                for (index in $scope.reqoutedvehicleCoverages) {
	                    if ($scope.reqoutedvehicleCoverages[index].coverages.length == 1 && selectedQuote.lobs.personalAuto.vehicleCoverages[index].coverages.length > 1) {
	                        mvrClueFlag = true;
	                    }
	                }
	            }
	
	            if (vehicles.length == vinflag && drivers.length == licflag) {
	
	                if (mvrClueFlag) {
	                    processMVRClue(selectedQuote, numberOfPayments);
	                    mvrClueFlag = false;
	                } else if (doReQuoteOnFail) {
	                    getSubmission(selectedQuote, numberOfPayments);
	                } else {
	                    StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	                    StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
	                    submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
	                    flowModel.next(submissionVM);
	                }
	            } else {
	                StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	                StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
	                submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
	                flowModel.next(submissionVM);
	            }
	        };
	
	        processMVRClue = function processMVRClue(selectedQuote, numberOfPayments) {
	            var response = MVRClueService.orderMVRClue(jobDetails);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', response);
	            var msgBox = ModalService.showLoadingDialog('quoteandbind.controllers.Please wait');
	
	            $timeout(function () {
	                msgBox.close();
	                response.then(function (mvrDataResponse) {
	                    getSubmission(selectedQuote, numberOfPayments);
	                }, function (error) {
	                    getSubmission(selectedQuote, numberOfPayments);
	                });
	            }, 5000);
	        };
	
	        getSubmission = function getSubmission(selectedQuote, numberOfPayments) {
	            var submissionDTO = {
	                postalCode: submissionVM.draftData.accountHolder.primaryAddress.postalCode.value,
	                quoteID: submissionVM.quoteID.value
	            };
	
	            var reqoutedata = LoadSaveService.saveAndReQuoteSubmission(null, submissionVM.value);
	            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', reqoutedata);
	            reqoutedata.then(function (reQuotedResponse) {
	                doReQuoteOnFail = false;
	                var premiumChangedFlag = 0;
	                var coveragesChanged = false;
	                var quotedOffers = submissionVM.quoteData.offeredQuotes.value;
	                var requotedOffers = reQuotedResponse.quoteData.offeredQuotes;
	                submissionVM.value = reQuotedResponse;
	
	                for (var x in requotedOffers) {
	
	                    if (requotedOffers[x].branchCode == "CUSTOM") {
	                        if (requotedOffers[x].monthlyPremium.amount != quotedOffers[x].monthlyPremium.amount || requotedOffers[x].total.amount != quotedOffers[x].total.amount) {
	                            premiumChangedFlag = premiumChangedFlag + 1;
	                        }
	
	                        for (var vehicleCov in requotedOffers[x].lobs.personalAuto.vehicleCoverages) {
	                            if (requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != quotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length) {
	                                coveragesChanged = true;
	                            }
	                        }
	                    }
	                }
	
	                if (premiumChangedFlag > 0 || coveragesChanged) {
	                    ModalService.showCustomInfo('quoteandbind.controllers.QuoteDetails.Attention', 'quoteandbind.controllers.QuoteDetails.quote changed').result;
	
	                    if (coveragesChanged) {
	                        ModalService.showCustomInfo('quoteandbind.controllers.QuoteDetails.Attention', 'quoteandbind.controllers.QuoteDetails.coverages have changed').result;
	                    }
	
	                    if (submissionVM.value.draftData.productCode === "Homeowners") {
	                        $scope.page.standardQuotes = _.where(requotedOffers, { isCustom: false });
	                    }
	                    if (submissionVM.value.draftData.productCode != "Homeowners") {
	                        //$scope.page.standardQuotes = _.where(requotedOffers, {branchCode: "StandardProgram"});
	                        $scope.page.standardQuotes = [];
	                    }
	                    $scope.page.customQuotes = _.where(requotedOffers, { isCustom: true });
	                    $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
	                    $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
	                    $scope.$broadcast('CustomQuoteSelected', [$scope.page.customQuotes[0].publicID]);
	                    $scope.reqoutedvehicleCoverages = $scope.page.customQuotes[0].lobs.personalAuto.vehicleCoverages;
	                } else {
	                    $scope.page.standardQuotes = _.where(requotedOffers, { branchCode: "StandardProgram" });
	                    if (submissionVM.value.draftData.productCode === "PersonalAuto") {
	                        $scope.page.standardQuotes = [];
	                    }
	                    $scope.page.customQuotes = _.where(requotedOffers, { isCustom: true });
	                    if (selectedQuote.branchCode === "StandardProgram") {
	                        StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	                        StateUtils.activeDataForState(true).chosenQuote = $scope.page.standardQuotes[0].publicID;
	                        submissionVM.value.bindData.chosenQuote = $scope.page.standardQuotes[0].publicID;
	                    } else if (selectedQuote.branchCode === "CUSTOM") {
	                        _.where(requotedOffers, { branchCode: "CUSTOM" });
	                        StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	                        StateUtils.activeDataForState(true).chosenQuote = $scope.page.customQuotes[0].publicID;
	                        submissionVM.value.bindData.chosenQuote = $scope.page.customQuotes[0].publicID;
	                    }
	
	                    flowModel.next(submissionVM);
	                }
	            }, function (error) {
	
	                var exception = {
	                    error: error
	                };
	
	                var message;
	
	                if (error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data && error[0].baseError.data.error && error[0].baseError.data.error.message != undefined) {
	                    message = error[0].baseError.data.error.message;
	                }
	
	                if (message !== undefined && message.indexOf('coverage') > -1) {
	                    doReQuoteOnFail = true;
	                    $scope.page.standardQuotes = [];
	                    var goToStep = ErrorHandlingService.getQuoteExceptionHandler(exception, submissionVM);
	                    if ('error' == goToStep) {
	                        var messageHeader = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
	                        var errorMsg = submissionVM.draftData.lobs.value.exception;
	                        if (ErrorHandlingService.isDisplayError(errorMsg)) {
	                            ModalService.showError(messageHeader, errorMsg);
	                        } else {
	                            $state.go('contactUs', { quoteID: submissionVM ? submissionVM.quoteID.value : null, errorMsg: submissionVM.draftData.lobs.value.exception });
	                        }
	                    }
	                } else {
	                    ErrorHandlingService.getBindExceptionHandler(exception, submissionVM);
	                    $state.go('contactUs', { quoteID: submissionVM ? submissionVM.quoteID.value : null, errorMsg: submissionVM.draftData.lobs.value.exception });
	                }
	
	                /*const errorPromise = ModalService.showError(
	                    'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
	                    'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
	                ).result;
	                errorPromise.then(function(resp) {
	                    $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null});
	                });*/
	            });
	        };
	
	        ctrl.nextSteps = function (selectedQuote, numberOfPayments) {
	            //stash some bind information in state data so it can be accessed later when we call the bind method
	            StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
	            StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
	            // StateUtils.activeDataForState(true).flowModel =  flowModel;
	            // Redirect to next steps state
	            //$state.go("nextSteps");
	            flowModel.next(submissionVM);
	        };
	
	        ctrl._setOfferingLabels = function (standardOfferings) {
	            return _.map(standardOfferings, function (offering) {
	                return $filter('translate')('quoteandbind.controllers.QuoteDetails.' + offering.branchCode);
	            });
	        };
	
	        ctrl._setBaseOffering = function (standardOfferings) {
	            if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
	                return standardOfferings[0];
	            } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
	                return standardOfferings[1];
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['LocaleService', '$filter', '$scope', '$anchorScroll', 'StateUtils', 'qnb.LoadSaveService', 'MVRClueService', '$window', 'submissionViewModel', '$state', 'ModalService', 'InMemorySession', 'qnb.ErrorHandlingService', '$timeout'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355), __webpack_require__(442)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, _, Fun) {
	    /*
	     The information being collected on this page is covered by PCI-DSS.
	     It is the customer's responsibility to ensure that any security/data protection measures that are required are implemented.
	     Data from this page should only ever be transmitted over HTTPS.
	     */
	    var fn = function fn($filter, $scope, StateUtils, ModalService, submissionViewModel, CustomPaymentService, $state, $q, CCDEV_APPID, CCDEV_APPKEY, CCDEV_MID, CCDEV_PAYMENTID, CCDEV_PAYMENTURL, InputValidationService) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var numberOfPayments = StateUtils.activeDataForState(true).numberOfPayments;
	        var chosenQuoteId = StateUtils.activeDataForState(true).model.value.quoteData.offeredQuotes[0].publicID;
	        var messagePoster, paymentModal;
	
	        ctrl.init = function () {
	            $scope.dateSelected = {
	                value: ''
	            };
	            $scope.isNameValid = true;
	            $scope.quoteID = submissionVM.value.quoteID;
	
	            $scope.ccDetails = {};
	            submissionVM.bindData.chosenQuote.value = chosenQuoteId;
	            $scope.view = submissionVM.bindData;
	            $scope.view.paymentDetails.value = $scope.view.paymentDetails.value || {};
	            $scope.view.paymentDetails.paymentMethod.value = 'creditcard';
	
	            $scope.view.selectedPaymentPlan.value = '';
	
	            $scope.view.paymentDetails.creditCardData = {};
	            $scope.policyEffectiveDay = new Date(submissionVM.draftData.periodStartDate.value).getDate();
	            $scope.dateSelected.value = $scope.policyEffectiveDay;
	            if ($scope.view.paymentDetails.paymentEffectiveDate && $scope.view.paymentDetails.paymentEffectiveDate.value) {
	                $scope.dateSelected.value = $scope.view.paymentDetails.paymentEffectiveDate.value;
	            }
	            $scope.drivers = submissionVM.value.draftData.lobs.personalAuto.drivers;
	
	            $scope.numberOfPayments = numberOfPayments;
	
	            $scope.paymentPlans = ctrl.getPaymentPlans($scope.numberOfPayments);
	
	            if ($scope.paymentPlans.length === 1) {
	                $scope.view.selectedPaymentPlan.value = $scope.paymentPlans[0].billingId;
	            }
	
	            //$scope.paymentFrequency = $scope.view.paymentDetails.paymentFrequency.value.code || "";
	
	
	            $scope.paymentPlans = ctrl.filterPaymentPlans();
	
	            $scope.chosenQuoteData = _.findWhere(submissionVM.quoteData.offeredQuotes.value, { publicID: chosenQuoteId });
	        };
	
	        $scope.getPaymentFrequency = function () {
	            var isMonthly = false;
	            angular.forEach(submissionVM.value.bindData.paymentPlans, function (x) {
	                if ($scope.view.selectedPaymentPlan.value === x.billingId) {
	                    if (x.numberOfInstallments > 1) {
	                        isMonthly = true;
	                    } else {
	                        isMonthly = false;
	                    }
	                }
	            });
	            return isMonthly;
	        };
	
	        ctrl.getPaymentPlans = function (numPayments) {
	            var allPlans = $scope.view.value.paymentPlans;
	            return allPlans;
	            //return ctrl.filterPaymentPlans(allPlans);
	            /* if (numPayments > 1) {
	                  return ctrl.filterPaymentPlans(allPlans);
	             }*/
	
	            /*return [
	                _.find(allPlans, plan => plan.installment.amount === 0)
	            ];*/
	        };
	
	        ctrl.getAmount = function (quoteAmount) {
	            return $filter('gwCurrency')(quoteAmount);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        /* ctrl.filterPaymentPlans = (allPlans)=>{
	             allPlans = _.filter(allPlans,(plans) => {
	                return ( (plans.invoiceFrequency == "monthly" || plans.invoiceFrequency == "everysixmonths") &&
	                (plans.name.indexOf("EFT/RCC") > 0  && plans.name.indexOf("Book Roll") <= 0 && plans.name.indexOf("Ann") <= 0) )
	            });
	             _.forEach($scope.drivers, function(driver){
	                if(driver.needSR22){
	                    allPlans = _.filter(allPlans,(plans) => {
	                        return plans.name.indexOf("SR22") > 0
	                    });
	                }else{
	                    allPlans = _.filter(allPlans,(plans) => {
	                        return plans.name.indexOf("SR22") <= 0
	                    });
	                }
	            });
	             return allPlans;
	        }; */
	
	        ctrl.filterPaymentPlans = function () {
	
	            var paymentPlans = $scope.paymentPlans;
	            var aDriverWithSR22 = false;
	            _.forEach($scope.drivers, function (driver) {
	                if (driver.needSR22) {
	                    aDriverWithSR22 = true;
	                }
	            });
	
	            if (aDriverWithSR22) {
	                if (submissionVM.value.draftData.termType.toLowerCase() == "annual") {
	                    paymentPlans = _.filter($scope.paymentPlans, function (plans) {
	                        return plans.name.includes("12 mo") && plans.name.includes("SR-22") || plans.name.includes("Full Pay");
	                    });
	                } else if (submissionVM.value.draftData.termType.toLowerCase() == "halfyear") {
	                    paymentPlans = _.filter($scope.paymentPlans, function (plans) {
	                        return plans.name.includes("6 mo") && plans.name.includes("SR-22") || plans.name.includes("Full Pay");
	                    });
	                }
	            } else if (submissionVM.value.draftData.termType.toLowerCase() == "annual") {
	                paymentPlans = _.filter($scope.paymentPlans, function (plans) {
	                    return plans.name.includes("12 mo") && !plans.name.includes("SR-22") || plans.name.includes("Full Pay");
	                });
	            } else if (submissionVM.value.draftData.termType.toLowerCase() == "halfyear") {
	                paymentPlans = _.filter($scope.paymentPlans, function (plans) {
	                    return plans.name.includes("6 mo") && !plans.name.includes("SR-22") || plans.name.includes("Full Pay");
	                });
	            }
	            return paymentPlans;
	        };
	
	        ctrl.openPaymentWindow = function (onetimeInd) {
	            $scope.oneTime = onetimeInd;
	
	            /**
	             * THIS IS THE PAYLOAD BEING SENT TO PAYMENT PAGE
	             */
	            var message = JSON.stringify({
	                'transaction_type': 'CCTATOKENIZE',
	                'app_id': CCDEV_APPID,
	                'mid_id': CCDEV_MID,
	                'payment_id': CCDEV_PAYMENTID,
	                'app_key': CCDEV_APPKEY,
	                'redirect_url': '',
	                'cardholder_name': '',
	                'merchant_ref': $scope.quoteID,
	                'terms': '<span class="sup">‡</span>Terms and Conditions</a> | <a href="http://carolinas.aaa.com/about/privacypolicy">Privacy Policy</a> | <a href="https://join.carolinas.aaa.com/security.htm">Your information is secure.</a>',
	                'billing_address': {
	                    'street': submissionVM.value.draftData.accountHolder.primaryAddress.addressLine1, //string
	                    'city': submissionVM.value.draftData.accountHolder.primaryAddress.city, //string
	                    'state_prov': submissionVM.value.draftData.accountHolder.primaryAddress.state, //string
	                    'zip': submissionVM.value.draftData.accountHolder.primaryAddress.postalCode, //number,
	                    'email': submissionVM.value.draftData.accountHolder.emailAddress1
	                }
	            });
	
	            // Create modal
	            if (!paymentModal) {
	                var modal = document.createElement('div');
	                modal.id = 'modal';
	                modal.innerHTML = CCDEV_PAYMENTURL;
	                document.body.appendChild(modal);
	                paymentModal = document.getElementById('modal');
	            }
	
	            var paymentWindow = document.getElementById('payment-page');
	            messagePoster = setInterval(function () {
	                paymentWindow.contentWindow.postMessage(message, '*');
	            }, 100);
	
	            function validateInputs(inputsToValidate, scopeVar) {
	                var inputValidationData = [];
	                inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	                if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                    for (var i = 0; i < inputValidationData[1].length; i++) {
	                        scopeVar[inputValidationData[1][i]] = '';
	                        $scope.isNameValid = false;
	                    }
	                } else {
	                    $scope.isNameValid = true;
	                }
	            }
	
	            //  Consider events originated form Pay Test/Production sites only
	            //  Bypass any other events like Google Tag related events
	            //  AB - 01/19/2021
	            var eventHandler = function eventHandler(event) {
	                if (event.origin === 'https://paytest.carolinas.aaa.com' || event.origin === 'https://pay.carolinas.aaa.com') {
	                    clearInterval(messagePoster);
	                    if (event.data !== 'close') {
	                        if (event.data !== 'stop') {
	                            var received_data = JSON.parse(event.data);
	                            var infoMarkup = '';
	                            for (var key in received_data) {
	                                infoMarkup += '<p>' + key + ': ' + received_data[key] + '</p>';
	                                if (key == 'cardholder_name') {
	                                    $scope.ccDetails.cardHolderName = received_data[key];
	                                } else if (key == 'token') {
	
	                                    var token_data = JSON.parse(JSON.stringify(received_data[key]));
	                                    for (ky in token_data) {
	                                        if (ky == 'value') {
	                                            $scope.ccDetails.token = token_data[ky];
	                                        } else if (ky == 'card_type') {
	                                            $scope.ccDetails.cardType = token_data[ky];
	                                        } else if (ky == 'exp_date') {
	                                            $scope.ccDetails.expdateUI = token_data[ky].substring(0, 2) + "/" + token_data[ky].substring(2, 4);
	                                            $scope.ccDetails.expiryDate = token_data[ky];
	                                        } else if (ky == 'token_id') {
	                                            $scope.ccDetails.tokenId = token_data[ky];
	                                        } else if (ky == 'provider_id') {
	                                            $scope.ccDetails.providerId = token_data[ky];
	                                        } else if (ky == 'card_number') {
	                                            $scope.ccDetails.cardNumber = token_data[ky];
	                                        }
	                                    }
	                                } else if (key == 'billing_address') {
	                                    var address_data = JSON.parse(JSON.stringify(received_data[key]));
	                                    for (k in address_data) {
	                                        if (k == 'street') {
	                                            $scope.ccDetails.billingStreet = address_data[k];
	                                        } else if (k == 'city') {
	                                            $scope.ccDetails.billingCity = address_data[k];
	                                        } else if (k == 'state_prov') {
	                                            $scope.ccDetails.billingState = address_data[k];
	                                        } else if (k == 'zip') {
	                                            $scope.ccDetails.billingZip = address_data[k];
	                                        }
	                                    }
	                                }
	                            }
	                            //$scope.ccDetails.displayName = $scope.ccDetails.cardType+" "+$scope.ccDetails.cardNumber.slice(-4)+" "+$scope.ccDetails.expdateUI;
	                            $scope.ccDetails.displayName = $scope.ccDetails.cardType + " " + $scope.ccDetails.cardNumber + " " + $scope.ccDetails.expdateUI;
	                            $scope.ccDetails.paymentMethod = "creditcard";
	
	                            if (paymentModal != null) {
	                                paymentModal.parentElement.removeChild(paymentModal);
	                                paymentModal = null;
	                            }
	
	                            $scope.ccDetails.oneTime = false;
	                            $scope.ccDetails.nickName = $scope.ccDetails.displayName;
	                            $scope.ccDetails.accountNumber = submissionVM.value.draftData.accountNumber;
	
	                            var inputsToValidate = [{ 'billingStreet': $scope.ccDetails.billingStreet }, { 'billingCity': $scope.ccDetails.billingCity }];
	                            validateInputs(inputsToValidate, $scope.ccDetails);
	                            if (!$scope.isNameValid) {
	                                ;
	                                return;
	                            }
	                            window.removeEventListener("message", eventHandler);
	                            var createInstrument = void 0;
	                            createInstrument = CustomPaymentService.createPaymentInstrumentForAccount($scope.ccDetails, ['createInstrumentInfo']);
	                            ModalService.showProgressDialog('quoteandbind.views.modal.Please wait', createInstrument);
	                            $q.when(createInstrument, Fun.setter($scope, 'createInstrumentInfo')).then(function (createInstrument) {
	
	                                if ($scope.ccDetails.token) {
	                                    $scope.view.paymentDetails.value.creditCardData.displayName = $scope.ccDetails.displayName;
	                                    $scope.view.paymentDetails.value.creditCardData.cardHolderName = $scope.ccDetails.cardHolderName;
	                                    $scope.view.paymentDetails.value.creditCardData.cardType = $scope.ccDetails.cardType;
	                                    $scope.view.paymentDetails.value.creditCardData.expiryDate = $scope.ccDetails.expiryDate;
	                                    $scope.view.paymentDetails.value.creditCardData.oneTime = $scope.ccDetails.oneTime;
	                                    $scope.view.paymentDetails.value.creditCardData.nickName = $scope.ccDetails.nickName;
	                                    $scope.view.paymentDetails.value.creditCardData.token = $scope.ccDetails.token;
	                                    $scope.view.paymentDetails.value.creditCardData.publicID = $scope.createInstrumentInfo.publicID;
	                                    $scope.view.paymentDetails.value.creditCardData.cardNumber = $scope.ccDetails.cardNumber;
	                                    $scope.view.paymentDetails.value.creditCardData.providerId = $scope.ccDetails.providerId;
	                                    $scope.view.paymentDetails.value.creditCardData.tokenId = $scope.ccDetails.tokenId;
	
	                                    if ($scope.view.paymentDetails.paymentType.value.code == 'recurring') {
	                                        $scope.view.paymentDetails.value.paymentEffectiveDate = $scope.dateSelected.value;
	                                    }
	                                    //console.log("After Payment:: ",$scope.view.paymentDetails.paymentType, $scope.view.paymentDetails.value.paymentEffectiveDate);
	                                    //console.log("SubmissonVM:: ",submissionVM);
	                                    flowModel.next(submissionVM, true);
	                                }
	                            });
	                        }
	                    } else if (event.data == 'close') {
	                        if (paymentModal != null) {
	                            paymentModal.parentElement.removeChild(paymentModal);
	                            paymentModal = null;
	                        }
	                        window.removeEventListener("message", eventHandler);
	                    }
	                }
	            };
	
	            window.addEventListener("message", eventHandler);
	        };
	
	        ctrl.next = function (form) {
	            form.submitted = true;
	
	            if (!$scope.view.selectedPaymentPlan.value) {
	                ModalService.showError('quoteandbind.controllers.PaymentDetailsCtrl.Please choose a payment plan', 'quoteandbind.controllers.PaymentDetailsCtrl.You have not chosen a payment plan');
	                return;
	            }
	
	            //console.log("date selected",$scope.dateSelected.value);
	
	            // if($scope.getPaymentFrequency() && $scope.dateSelected.value == '')
	            // {
	            //     return false;
	            // }
	
	            // if($scope.getPaymentFrequency()){
	            //     $scope.view.paymentDetails.paymentType = 'recurring'
	            // }
	            // else{
	            //     $scope.view.paymentDetails.paymentType = 'billbymail'
	            // }
	
	            // Added By : Devnandan (10/05/2021) - DFCT0016957 - QnB Full Pay Payment Plan Mapping is Incorrect
	            if (submissionVM.value.bindData.selectedPaymentPlan === _.findWhere($scope.paymentPlans, { 'name': 'Full Pay' }).billingId) {
	                submissionVM.value.bindData.policyQuotePaymentMethod = 'recurring';
	                submissionVM.value.draftData.policyQuotePaymentMethod = 'recurring';
	
	                $scope.view.paymentDetails.paymentType = 'recurring';
	                submissionVM.value.bindData.paymentDetails.paymentType = 'recurring';
	
	                submissionVM.value.bindData.policyInfoPaymentMethod = 'paid_in_full';
	                submissionVM.value.draftData.policyInfoPaymentMethod = 'paid_in_full';
	            } else if (submissionVM.value.bindData.selectedPaymentPlan === _.findWhere($scope.paymentPlans, { 'name': 'Monthly (6 mo)' }).billingId) {
	                $scope.view.paymentDetails.paymentType = 'recurring';
	                submissionVM.value.bindData.paymentDetails.paymentType = 'recurring';
	                submissionVM.value.draftData.policyInfoPaymentMethod = 'recurring';
	                submissionVM.value.bindData.policyInfoPaymentMethod = 'recurring';
	            }
	
	            ctrl.openPaymentWindow(false);
	
	            if ($scope.view.paymentDetails.paymentMethod.value === 'wire') {
	                //Remove unused payment data to avoid validation exception
	                $scope.view.paymentDetails.creditCardData.value = null;
	            } else {
	                $scope.view.paymentDetails.bankAccountData.value = null;
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$filter', '$scope', 'StateUtils', 'ModalService', 'submissionViewModel', 'CustomPaymentService', '$state', '$q', 'CCDEV_APPID', 'CCDEV_APPKEY', 'CCDEV_MID', 'CCDEV_PAYMENTID', 'CCDEV_PAYMENTURL', 'qnb.InputValidationService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Functional extenders. Some required and convenient features are not supported by
	     * the underscore.js (yet). And we (I) want to use that features right now.
	     */
	    return {
	        /**
	         * Creates a setter for a specific field in the object. Useful for simple callback actions. For example,
	         * $q.when(someAsyncOperation, Fun.setter(item, 'asyncOpResult'));
	         * @param item {Object|Array} object to set field on.
	         * @param field {String|int} field name or index to set.
	         * @returns {Function} Setter for the item[field]. This setter sets item[field] to its first argument.
	         */
	        'setter': function setter(item, field) {
	            return function (value) {
	                item[field] = value;
	            };
	        },
	
	        /**
	         * Creates a field getter function. Function will get a field with the specific name from the object.
	         * @param field field name.
	         */
	        'fieldGetter': function fieldGetter(field) {
	            return function (item) {
	                return item[field];
	            };
	        },
	
	        /**
	         * Finds an index of item matching the predicate. Returns -1 if value was not found.
	         * @param items items (array) to search the item.
	         * @param predicate predicate to check.
	         */
	        'indexWhere': function indexWhere(items, predicate) {
	            for (var i = 0; i < items.length; i++) {
	                if (predicate(items[i])) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 02-01-2017.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355), __webpack_require__(444)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, _, TermsTemplate) {
	    var fn = function fn(filter, $scope, $state, $stateParams, submissionViewModel, $modal, $modalStack, StateUtils) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        ctrl.init = function () {
	
	            angular.forEach(submissionVM.value.bindData.paymentPlans, function (x) {
	                if (x.billingId === submissionVM.value.bindData.selectedPaymentPlan) {
	                    $scope.downPayment = x.downPayment.amount.toFixed(2);
	                }
	            });
	
	            var displayName = submissionVM.value.bindData.paymentDetails.creditCardData.displayName;
	
	            displayName = displayName.substring(0, displayName.length - 5) + "exp " + displayName.substring(displayName.length - 5, displayName.length);
	
	            $scope.info = {
	                'displayName': displayName,
	                'token': submissionVM.value.bindData.paymentDetails.creditCardData.token
	            };
	
	            $scope.payment = {
	                terms: false,
	                selectedItem: false
	            };
	        };
	
	        ctrl.showTerms = function () {
	            var modalInstance = $modal.open({
	                backdrop: 'static',
	                keyboard: false,
	                template: TermsTemplate,
	                controller: function controller($scope) {
	                    $scope.close = function (evt) {
	                        var modal = $modalStack.getTop();
	                        if (modal && modal.value.backdrop) {
	                            evt.preventDefault();
	                            evt.stopPropagation();
	                            $modalStack.dismiss(modal.key, 'backdrop click');
	                        }
	                    };
	                }
	            });
	        };
	
	        ctrl.next = function (form) {
	            form.submitted = true;
	            if ($scope.payment.selectedItem == undefined || $scope.payment.selectedItem == false || $scope.payment.terms == false || $scope.payment.terms == undefined) {
	                return false;
	            }
	
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.previous(submissionVM);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'submissionViewModel', '$modal', '$modalStack', 'StateUtils'];
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = "<div aria-hidden=\"true\" role=\"dialog\" class=\"\">\r\n    <div class=\"gw-pull-right gw-padded10 \" ng-click=\"close($event)\">\r\n        <span ><i class=\"fa fa-times\" aria-hidden=\"true\" ></i></span>\r\n    </div>\r\n\r\n<br>\r\n<div class=\"gw-padded20\">{{'quoteandbind.view.make-payment.EPTMessage1' | translate}}</div>\r\n<div class=\"gw-padded20\">{{'quoteandbind.view.make-payment.EPTMessage2' | translate}}</div>\r\n\r\n</div>"

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, $stateParams) {
	        var ctrl = Object.create(BaseCtrl);
	
	        ctrl.init = function () {
	            $scope.errorMsg = $stateParams.errorMsg;
	            $scope.quoteID = $stateParams.quoteID;
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$stateParams'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340), __webpack_require__(447) // without 'exports' doesn't export a variable when is loaded as a module
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl, phoneUtils) {
	    var fn = function fn($scope, $window, LocaleService, $stateParams, StateUtils, LoginLinkDev, LoginLinkTest, AAADEV, AAATEST, GWDEV, GWTEST) {
	        var ctrl = Object.create(BaseCtrl);
	
	        ctrl.init = function () {
	            $scope.submission = $stateParams.quoteSummary;
	            $scope.today = new Date();
	
	            $scope.chosenQuote = _.findWhere($scope.submission.quoteData.offeredQuotes, { publicID: $scope.submission.bindData.chosenQuote });
	            $scope.chosenPlan = _.findWhere($scope.submission.bindData.paymentPlans, { billingId: $scope.submission.bindData.selectedPaymentPlan });
	
	            $scope.accountHolderAddress = $scope.submission.draftData.policyAddress;
	            $scope.accountHolder = $scope.submission.draftData.accountHolder;
	            $scope.accountHolder.contactNumber = $scope.accountHolder.homeNumber; // alternative if we need to use primary contact number this._contactNumber();
	        };
	
	        ctrl.printQuote = function () {
	            $window.print();
	        };
	
	        //TODO:this function is used for login from dev and test environment. To be changed when moving to other environments.
	        ctrl.navigateToLogin = function () {
	
	            var link = window.location;
	
	            var url = link.origin + "/account-management-portal/html";
	
	            /*if (link.host.indexOf("insurance.carolinas.aaa.com") >= 0) {
	                url = link.origin + "/account";
	            }*/
	
	            window.open(url, '_blank');
	        };
	
	        ctrl._contactNumber = function () {
	            var acctHolder = $scope.submission.draftData.accountHolder;
	            var phoneType = acctHolder.primaryPhoneType;
	            if (phoneType === null) {
	                return;
	            }
	
	            var number = void 0;
	            if (phoneType === 'work') {
	                number = acctHolder.workNumber;
	            } else if (phoneType === 'home') {
	                number = acctHolder.homeNumber;
	            } else if (phoneType === 'mobile') {
	                number = acctHolder.cellNumber;
	            }
	            if (number === null) {
	                return;
	            }
	
	            return phoneUtils.formatNational(number, LocaleService.getConfiguredPhoneRegion());
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$window', 'LocaleService', '$stateParams', 'StateUtils', 'LoginLinkDev', 'LoginLinkTest', 'AAADEV', 'AAATEST', 'GWDEV', 'GWTEST'];
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 447 */
/***/ function(module, exports) {

	(function(){function i(a){throw a;}var k=!0,l=null,m=!1,aa=this;function n(a,b){var c=a.split("."),e=aa;!(c[0]in e)&&e.execScript&&e.execScript("var "+c[0]);for(var d;c.length&&(d=c.shift());)!c.length&&void 0!==b?e[d]=b:e=e[d]?e[d]:e[d]={}}function p(a,b){function c(){}c.prototype=b.prototype;a.ea=b.prototype;a.prototype=new c;a.prototype.constructor=a};var q=Array.prototype,ba=q.indexOf?function(a,b,c){return q.indexOf.call(a,b,c)}:function(a,b,c){c=c==l?0:0>c?Math.max(0,a.length+c):c;if("string"==typeof a)return"string"!=typeof b||1!=b.length?-1:a.indexOf(b,c);for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};function ca(a,b){q.sort.call(a,b||da)}function da(a,b){return a>b?1:a<b?-1:0};function fa(a){var b=[],c=0,e;for(e in a)b[c++]=a[e];return b};function ga(a,b,c){this.z=a;this.ca=b.name||l;this.la=b.l||l;this.t=b.ka;this.h={};for(a=0;a<c.length;a++)b=c[a],this.h[b.f]=b}ga.prototype.j=function(){return!this.t?l:this.t.d()};function ha(a){a=fa(a.h);ca(a,function(a,c){return a.f-c.f});return a};function ia(a,b,c){this.da=a;this.f=b;this.ca=c.name;this.o=!!c.p;this.ma=!!c.required;this.i=c.a;this.s=c.type;this.v=m;switch(this.i){case ja:case ka:case la:case ma:case na:this.v=k}this.q=c.defaultValue}var ja=3,ka=4,la=6,ma=16,na=18;ia.prototype.j=function(){return this.da.d()};function r(){this.e={};this.h=this.d().h;this.b=this.r=l}r.prototype.d=function(){var a=this.constructor,b;if(!(b=a.u)){var c;b=a.aa;var e=[],d;for(d in b)b.hasOwnProperty(d)&&(0==d?c=b[0]:e.push(new ia(a,d,b[d])));c=new ga(a,c,e);b=a.u=c}return b};r.prototype.set=function(a,b){a.j();this.d();s(this,a.f,b)};r.prototype.add=function(a,b){a.j();this.d();var c=a.f;this.e[c]||(this.e[c]=[]);this.e[c].push(b);this.b&&delete this.b[c]};r.prototype.clear=function(a){a.j();this.d();t(this,a.f)};
	function oa(a,b){for(var c=ha(a.d()),e=0;e<c.length;e++){var d=c[e],f=b,g=d;g.j();f.d();if(u(f,g.f))if(a.b&&delete a.b[d.f],f=11==d.i||10==d.i,d.o){var g=b,h=d;h.j();g.d();g=v(g,h.f);for(h=0;h<g.length;h++)a.add(d,f?w(g[h]):g[h])}else g=x(b,d),f?(f=x(a,d))?oa(f,g):a.set(d,w(g)):a.set(d,g)}}function w(a){var b=new a.constructor;b!=a&&(b.e={},b.b&&(b.b={}),oa(b,a));return b}function u(a,b){return b in a.e&&void 0!==a.e[b]&&a.e[b]!==l}
	function x(a,b){var c=b.f;if(!c in a.e)return l;var e=a.e[c];if(e==l)return l;if(a.r){if(!(c in a.b)){var d=a.r;if(e!=l)if(b.o){for(var f=[],g=0;g<e.length;g++)f[g]=d.n(b,e[g]);e=f}else e=d.n(b,e);return a.b[c]=e}return a.b[c]}return e}function y(a,b,c){b=a.h[b];a=x(a,b);return b.o?a[c||0]:a}function z(a,b){var c;if(u(a,b))c=y(a,b,void 0);else{c=a.h[b];if(void 0===c.q){var e=c.s;c.q=e===Boolean?m:e===Number?0:e===String?"":new e}c=c.q}return c}function v(a,b){return x(a,a.h[b])||[]}
	function s(a,b,c){a.e[b]=c;a.b&&(a.b[b]=c)}function t(a,b){delete a.e[b];a.b&&delete a.b[b]}function A(a,b){a.aa=b;a.d=function(){return a.u||(new a).d()}};function B(){}B.prototype.k=function(a){new a.z;i(Error("Unimplemented"))};B.prototype.n=function(a,b){if(11==a.i||10==a.i)return b instanceof r?b:this.k(a.s.d(),b);if(!a.v)return b;var c=a.s;if(c===String){if("number"===typeof b)return String(b)}else if(c===Number&&"string"===typeof b&&/^-?[0-9]+$/.test(b))return Number(b);return b};function C(){}p(C,B);C.prototype.k=function(a,b){var c=new a.z;c.r=this;c.e=b;c.b={};return c};function D(){}p(D,C);D.prototype.fa=m;D.prototype.n=function(a,b){return 8==a.i?1===b:B.prototype.n.apply(this,arguments)};D.prototype.k=function(a,b){var c=b;if(this.fa){var c=[],e;for(e in b)c[parseInt(e,10)+1]=b[e]}return D.ea.k.call(this,a,c)};function E(a,b){a!=l&&this.append.apply(this,arguments)}E.prototype.g="";E.prototype.set=function(a){this.g=""+a};E.prototype.append=function(a,b,c){this.g+=a;if(b!=l)for(var e=1;e<arguments.length;e++)this.g+=arguments[e];return this};E.prototype.clear=function(){this.g=""};E.prototype.toString=function(){return this.g};/*
	
	 Protocol Buffer 2 Copyright 2008 Google Inc.
	 All other code copyright its respective owners.
	 Copyright (C) 2010 The Libphonenumber Authors
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function F(){r.apply(this)}p(F,r);function G(){r.apply(this)}p(G,r);function H(){r.apply(this)}p(H,r);H.prototype.c=function(){return z(this,10)};H.prototype.m=function(a){s(this,10,a)};function pa(){r.apply(this)}p(pa,r);
	A(F,{"0":{name:"NumberFormat",l:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:k,a:9,type:String},2:{name:"format",required:k,a:9,type:String},3:{name:"leading_digits_pattern",p:k,a:9,type:String},4:{name:"national_prefix_formatting_rule",a:9,type:String},6:{name:"national_prefix_optional_when_formatting",a:8,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",a:9,type:String}});
	A(G,{"0":{name:"PhoneNumberDesc",l:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",a:9,type:String},3:{name:"possible_number_pattern",a:9,type:String},6:{name:"example_number",a:9,type:String}});
	A(H,{"0":{name:"PhoneMetadata",l:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",required:k,a:11,type:G},2:{name:"fixed_line",required:k,a:11,type:G},3:{name:"mobile",required:k,a:11,type:G},4:{name:"toll_free",required:k,a:11,type:G},5:{name:"premium_rate",required:k,a:11,type:G},6:{name:"shared_cost",required:k,a:11,type:G},7:{name:"personal_number",required:k,a:11,type:G},8:{name:"voip",required:k,a:11,type:G},21:{name:"pager",required:k,a:11,type:G},25:{name:"uan",required:k,a:11,type:G},
	27:{name:"emergency",required:k,a:11,type:G},28:{name:"voicemail",required:k,a:11,type:G},24:{name:"no_international_dialling",required:k,a:11,type:G},9:{name:"id",required:k,a:9,type:String},10:{name:"country_code",required:k,a:5,type:Number},11:{name:"international_prefix",required:k,a:9,type:String},17:{name:"preferred_international_prefix",a:9,type:String},12:{name:"national_prefix",a:9,type:String},13:{name:"preferred_extn_prefix",a:9,type:String},15:{name:"national_prefix_for_parsing",a:9,type:String},
	16:{name:"national_prefix_transform_rule",a:9,type:String},18:{name:"same_mobile_and_fixed_line_pattern",a:8,defaultValue:m,type:Boolean},19:{name:"number_format",p:k,a:11,type:F},20:{name:"intl_number_format",p:k,a:11,type:F},22:{name:"main_country_for_code",a:8,defaultValue:m,type:Boolean},23:{name:"leading_digits",a:9,type:String},26:{name:"leading_zero_possible",a:8,defaultValue:m,type:Boolean}});
	A(pa,{"0":{name:"PhoneMetadataCollection",l:"i18n.phonenumbers.PhoneMetadataCollection"},1:{name:"metadata",p:k,a:11,type:H}});/*
	
	 Protocol Buffer 2 Copyright 2008 Google Inc.
	 All other code copyright its respective owners.
	 Copyright (C) 2010 The Libphonenumber Authors
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function I(){r.apply(this)}p(I,r);I.prototype.c=function(){return z(this,1)};I.prototype.m=function(a){s(this,1,a)};I.prototype.getExtension=function(){return y(this,3)};
	A(I,{"0":{name:"PhoneNumber",l:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:k,a:5,type:Number},2:{name:"national_number",required:k,a:4,type:Number},3:{name:"extension",a:9,type:String},4:{name:"italian_leading_zero",a:8,type:Boolean},8:{name:"number_of_leading_zeros",a:5,defaultValue:1,type:Number},5:{name:"raw_input",a:9,type:String},6:{name:"country_code_source",a:14,defaultValue:1,type:{ja:1,ia:5,ha:10,ga:20}},7:{name:"preferred_domestic_carrier_code",a:9,type:String}});/*
	
	 Copyright (C) 2010 The Libphonenumber Authors
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var J={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],
	86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],
	253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],379:["VA"],380:["UA"],381:["RS"],382:["ME"],385:["HR"],
	386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],
	691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},qa={AC:[,[,,"[2-467]\\d{3}","\\d{4}"],[,
	,"(?:[267]\\d|3[0-5]|4[4-69])\\d{2}","\\d{4}",,,"6889"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AC",247,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AD:[,[,,"(?:[346-9]|180)\\d{5}","\\d{6,8}"],[,,"[78]\\d{5}","\\d{6}",,,"712345"],[,,"[346]\\d{5}","\\d{6}",,,"312345"],[,,"180[02]\\d{4}","\\d{8}",,,"18001234"],[,,"9\\d{5}","\\d{6}",,,"912345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})",
	"$1 $2",["[346-9]"],"","",0],[,"(180[02])(\\d{4})","$1 $2",["1"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AE:[,[,,"[2-79]\\d{7,8}|800\\d{2,9}","\\d{5,12}"],[,,"[2-4679][2-8]\\d{6}","\\d{7,8}",,,"22345678"],[,,"5[0256]\\d{7}","\\d{9}",,,"501234567"],[,,"400\\d{6}|800\\d{2,9}","\\d{5,12}",,,"800123456"],[,,"900[02]\\d{5}","\\d{9}",,,"900234567"],[,,"700[05]\\d{5}","\\d{9}",,,"700012345"],[,,"NA","NA"],[,,"NA","NA"],"AE",971,"00","0",,,"0",,,,[[,"([2-4679])(\\d{3})(\\d{4})",
	"$1 $2 $3",["[2-4679][2-8]"],"0$1","",0],[,"(5[0256])(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1","",0],[,"([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]0"],"$1","",0],[,"([68]00)(\\d{2,9})","$1 $2",["60|8"],"$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"600[25]\\d{5}","\\d{9}",,,"600212345"],,,[,,"NA","NA"]],AF:[,[,,"[2-7]\\d{8}","\\d{7,9}"],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}","\\d{7,9}",,,"234567890"],[,,"7[057-9]\\d{7}","\\d{9}",,,"701234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA",
	"NA"],[,,"NA","NA"],"AF",93,"00","0",,,"0",,,,[[,"([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AG:[,[,,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}","\\d{7}(?:\\d{3})?",,,"2684601234"],[,,"268(?:464|7(?:2[0-9]|64|7[0-689]|8[02-68]))\\d{4}","\\d{10}",,,"2684641234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}",
	"\\d{10}",,,"5002345678"],[,,"26848[01]\\d{4}","\\d{10}",,,"2684801234"],"AG",1,"011","1",,,"1",,,,,,[,,"26840[69]\\d{4}","\\d{10}",,,"2684061234"],,"268",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AI:[,[,,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"2644(?:6[12]|9[78])\\d{4}","\\d{7}(?:\\d{3})?",,,"2644612345"],[,,"264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}","\\d{10}",,,"2642351234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],
	[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"AI",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"264",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AL:[,[,,"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}","\\d{5,9}"],[,,"(?:2(?:[168][1-9]|[247]\\d|9[1-7])|3(?:1[1-3]|[2-6]\\d|[79][1-8]|8[1-9])|4\\d{2}|5(?:1[1-4]|[2-578]\\d|6[1-5]|9[1-7])|8(?:[19][1-5]|[2-6]\\d|[78][1-7]))\\d{5}","\\d{5,8}",,,"22345678"],[,,"6[6-9]\\d{7}","\\d{9}",,,"661234567"],[,,"800\\d{4}","\\d{7}",,,"8001234"],
	[,,"900\\d{3}","\\d{6}",,,"900123"],[,,"808\\d{3}","\\d{6}",,,"808123"],[,,"700\\d{5}","\\d{8}",,,"70012345"],[,,"NA","NA"],"AL",355,"00","0",,,"0",,,,[[,"(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"],"0$1","",0],[,"(6[6-9])(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"],"0$1","",0],[,"(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|8[016-9]|[79]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AM:[,[,,"[1-9]\\d{7}",
	"\\d{5,8}"],[,,"(?:1[01]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}","\\d{5,8}",,,"10123456"],[,,"(?:55|77|9[1-9])\\d{6}","\\d{8}",,,"77123456"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"90[016]\\d{5}","\\d{8}",,,"90012345"],[,,"80[1-4]\\d{5}","\\d{8}",,,"80112345"],[,,"NA","NA"],[,,"60[2-6]\\d{5}","\\d{8}",,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)","",0],[,"(\\d{2})(\\d{6})","$1 $2",["[5-7]|9[1-9]"],"0$1","",0],[,"(\\d{3})(\\d{5})",
	"$1 $2",["[23]"],"(0$1)","",0],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AO:[,[,,"[29]\\d{8}","\\d{9}"],[,,"2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}","\\d{9}",,,"222123456"],[,,"9[1-49]\\d{7}","\\d{9}",,,"923123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AR:[,
	[,,"[1-368]\\d{9}|9\\d{10}","\\d{6,11}"],[,,"11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}",
	"\\d{6,10}",,,"1123456789"],[,,"675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})","\\d{6,11}",,,"91123456789"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"60[04579]\\d{7}","\\d{10}",,,"6001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[124-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:1[1568]|2[15]|3[145]|4[13]|5[14-8]|[069]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
	"9$1",,,[[,"([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1","",0],[,"(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],"0$1","",0],[,"(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[234689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9(?:[17-9]|4[13479]))|3(?:36|4[12358]|5(?:[18]|3[014-689])|6[24]|7[069]|8(?:[01]|3[013469]|5[0-39]|7[0-2459]|8[0-49])))"],"0$1","",0],[,"(9)(\\d{4})(\\d{3})(\\d{3})",
	"$2 15-$3-$4",["93[58]","9(?:3(?:53|8[78]))","9(?:3(?:537|8(?:73|88)))"],"0$1","",0],[,"(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],"0$1","",0],[,"(11)(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578])","2(?:2[013]|3[067]|49|6[01346]|80|9(?:[17-9]|4[13479]))|3(?:36|4[12358]|5(?:[18]|3[0-689])|6[24]|7[069]|8(?:[01]|3[013469]|5[0-39]|7[0-2459]|8[0-49]))"],"0$1","",
	1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2-$3",["3(?:53|8[78])","3(?:537|8(?:73|88))"],"0$1","",1],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],"0$1","",1],[,"(\\d{3})","$1",["1[012]|911"],"$1","",0]],[[,"([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]","[68]"],"0$1","",0],[,"(9)(11)(\\d{4})(\\d{4})","$1 $2 $3-$4",["911"]],[,"(9)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9(?:2[234689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))","9(?:2(?:2[013]|3[067]|49|6[01346]|80|9(?:[17-9]|4[13479]))|3(?:36|4[12358]|5(?:[18]|3[014-689])|6[24]|7[069]|8(?:[01]|3[013469]|5[0-39]|7[0-2459]|8[0-49])))"]],
	[,"(9)(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3-$4",["93[58]","9(?:3(?:53|8[78]))","9(?:3(?:537|8(?:73|88)))"]],[,"(9)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9[23]"]],[,"(11)(\\d{4})(\\d{4})","$1 $2-$3",["1","1"],"0$1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578])","2(?:2[013]|3[067]|49|6[01346]|80|9(?:[17-9]|4[13479]))|3(?:36|4[12358]|5(?:[18]|3[0-689])|6[24]|7[069]|8(?:[01]|3[013469]|5[0-39]|7[0-2459]|8[0-49]))",
	"2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578])","2(?:2[013]|3[067]|49|6[01346]|80|9(?:[17-9]|4[13479]))|3(?:36|4[12358]|5(?:[18]|3[0-689])|6[24]|7[069]|8(?:[01]|3[013469]|5[0-39]|7[0-2459]|8[0-49]))"],"0$1","",1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2-$3",["3(?:53|8[78])","3(?:537|8(?:73|88))","3(?:53|8[78])","3(?:537|8(?:73|88))"],"0$1","",1],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]","[23]"],"0$1","",1]],[,,"NA","NA"],,,[,,"810\\d{7}","\\d{10}",,,"8101234567"],
	[,,"810\\d{7}","\\d{10}",,,"8101234567"],,,[,,"NA","NA"]],AS:[,[,,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}","\\d{7}(?:\\d{3})?",,,"6846221234"],[,,"684(?:25[2468]|7(?:3[13]|70))\\d{4}","\\d{10}",,,"6847331234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"AS",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"684",[,,"NA","NA"],
	[,,"NA","NA"],,,[,,"NA","NA"]],AT:[,[,,"[1-9]\\d{3,12}","\\d{3,13}"],[,,"1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}","\\d{3,13}",,,"1234567890"],[,,"6(?:44|5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}","\\d{7,13}",,,"644123456"],[,,"80[02]\\d{6,10}",
	"\\d{9,13}",,,"800123456"],[,,"(?:711|9(?:0[01]|3[019]))\\d{6,10}","\\d{9,13}",,,"900123456"],[,,"8(?:10|2[018])\\d{6,10}","\\d{9,13}",,,"810123456"],[,,"NA","NA"],[,,"780\\d{6,10}","\\d{9,13}",,,"780123456"],"AT",43,"00","0",,,"0",,,,[[,"(1)(\\d{3,12})","$1 $2",["1"],"0$1","",0],[,"(5\\d)(\\d{3,5})","$1 $2",["5[079]"],"0$1","",0],[,"(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"],"0$1","",0],[,"(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"],"0$1","",0],[,"(\\d{3})(\\d{3,10})","$1 $2",["316|46|51|732|6(?:44|5[0-3579]|[6-9])|7(?:1|[28]0)|[89]"],
	"0$1","",0],[,"(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-35-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}","\\d{5,13}",,,"50123"],,,[,,"NA","NA"]],AU:[,[,,"[1-578]\\d{5,9}","\\d{6,10}"],[,,"[237]\\d{8}|8(?:[68]\\d{3}|7[0-69]\\d{2}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}","\\d{8,9}",,,"212345678"],[,,"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[0457-9]|8[17-9]|9[07-9])\\d{6}",
	"\\d{9}",,,"412345678"],[,,"180(?:0\\d{3}|2)\\d{3}","\\d{7,10}",,,"1800123456"],[,,"190[0126]\\d{6}","\\d{10}",,,"1900123456"],[,,"13(?:00\\d{2})?\\d{4}","\\d{6,10}",,,"1300123456"],[,,"500\\d{6}","\\d{9}",,,"500123456"],[,,"550\\d{6}","\\d{9}",,,"550123456"],"AU",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",,,"0",,"0011",,[[,"([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","",0],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[45]|14"],"0$1","",0],[,"(16)(\\d{3})(\\d{2,4})","$1 $2 $3",
	["16"],"0$1","",0],[,"(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[38]0|90)","1(?:[38]00|90)"],"$1","",0],[,"(180)(2\\d{3})","$1 $2",["180","1802"],"$1","",0],[,"(19\\d)(\\d{3})","$1 $2",["19[13]"],"$1","",0],[,"(19\\d{2})(\\d{4})","$1 $2",["19[67]"],"$1","",0],[,"(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"],"$1","",0]],,[,,"16\\d{3,7}","\\d{5,9}",,,"1612345"],1,,[,,"1(?:3(?:\\d{4}|00\\d{6})|80(?:0\\d{6}|2\\d{3}))","\\d{6,10}",,,"1300123456"],[,,"NA","NA"],,,[,,"NA","NA"]],AW:[,[,,"[25-9]\\d{6}",
	"\\d{7}"],[,,"5(?:2\\d|8[1-9])\\d{4}","\\d{7}",,,"5212345"],[,,"(?:5(?:6\\d|9[2-478])|6(?:[039]0|22|4[01]|6[0-2])|7[34]\\d|9(?:6[45]|9[4-8]))\\d{4}","\\d{7}",,,"5601234"],[,,"800\\d{4}","\\d{7}",,,"8001234"],[,,"900\\d{4}","\\d{7}",,,"9001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"28\\d{5}|501\\d{4}","\\d{7}",,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],AX:[,[,,"[135]\\d{5,9}|[27]\\d{4,9}|4\\d{5,10}|6\\d{7,8}|8\\d{6,9}",
	"\\d{5,12}"],[,,"18[1-8]\\d{3,9}","\\d{6,12}",,,"1812345678"],[,,"4\\d{5,10}|50\\d{4,8}","\\d{6,11}",,,"412345678"],[,,"800\\d{4,7}","\\d{7,10}",,,"8001234567"],[,,"[67]00\\d{5,6}","\\d{8,9}",,,"600123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AX",358,"00|99[049]","0",,,"0",,,,,,[,,"NA","NA"],,,[,,"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",,,"100123"],[,,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
	"\\d{5,10}",,,"10112345"],,,[,,"NA","NA"]],AZ:[,[,,"[1-9]\\d{8}","\\d{7,9}"],[,,"(?:1[28]\\d|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])|365)\\d{6}","\\d{7,9}",,,"123123456"],[,,"(?:4[04]|5[015]|60|7[07])\\d{7}","\\d{9}",,,"401234567"],[,,"88\\d{7}","\\d{9}",,,"881234567"],[,,"900200\\d{3}","\\d{9}",,,"900200123"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["(?:1[28]|2(?:[45]2|[0-36])|365)"],"(0$1)","",0],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["[4-8]"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BA:[,[,,"[3-9]\\d{7,8}","\\d{6,9}"],[,,"(?:[35]\\d|49)\\d{6}","\\d{6,8}",,,"30123456"],[,,"6(?:03|44|71|[1-356])\\d{6}","\\d{8,9}",,,"61123456"],[,,"8[08]\\d{6}","\\d{8}",,,"80123456"],[,,"9[0246]\\d{6}","\\d{8}",,,"90123456"],[,,"8[12]\\d{6}","\\d{8}",,,"82123456"],[,,"NA","NA"],[,,"NA","NA"],"BA",387,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})",
	"$1 $2-$3",["[3-5]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"],"0$1","",0],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"70[23]\\d{5}","\\d{8}",,,"70223456"],,,[,,"NA","NA"]],BB:[,[,,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"246[2-9]\\d{6}","\\d{7}(?:\\d{3})?",,,"2462345678"],[,,"246(?:(?:2[346]|45|82)\\d|25[0-4])\\d{4}","\\d{10}",,,"2462501234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],
	[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"BB",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"246",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BD:[,[,,"[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}","\\d{6,10}"],[,,"2(?:7(?:1[0-267]|2[0-289]|3[0-29]|[46][01]|5[1-3]|7[017]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|6[1-35]|7[1-5]|8[1-8])|9(?:0[0-2]|1[1-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[016-8]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}",
	"\\d{6,9}",,,"27111234"],[,,"(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}","\\d{10}",,,"1812345678"],[,,"80[03]\\d{7}","\\d{10}",,,"8001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"96(?:0[49]|1[0-4]|6[69])\\d{6}","\\d{10}",,,"9604123456"],"BD",880,"00[12]?","0",,,"0",,"00",,[[,"(2)(\\d{7})","$1-$2",["2"],"0$1","",0],[,"(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"],"0$1","",0],[,"(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"],
	"0$1","",0],[,"(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BE:[,[,,"[1-9]\\d{7,8}","\\d{8,9}"],[,,"(?:1[0-69]|[49][23]|5\\d|6[013-57-9]|71|8[0-79])[1-9]\\d{5}|[23][2-8]\\d{6}","\\d{8}",,,"12345678"],[,,"4(?:[679]\\d|8[03-9])\\d{6}","\\d{9}",,,"470123456"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"(?:70[2-7]|90\\d)\\d{5}","\\d{8}",,,"90123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BE",32,"00","0",,,"0",,,,[[,"(4[6-9]\\d)(\\d{2})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["4[6-9]"],"0$1","",0],[,"([2-49])(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|[49][23]"],"0$1","",0],[,"([15-8]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"],"0$1","",0],[,"([89]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"78\\d{6}","\\d{8}",,,"78123456"],,,[,,"NA","NA"]],BF:[,[,,"[24-7]\\d{7}","\\d{8}"],[,,"(?:20(?:49|5[23]|9[016-9])|40(?:4[569]|5[4-6]|7[0179])|50(?:[34]\\d|50))\\d{4}","\\d{8}",
	,,"20491234"],[,,"6(?:[0-24-689]\\d|3[0-7]|7[0-2])\\d{5}|7\\d{7}","\\d{8}",,,"70123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BG:[,[,,"[23567]\\d{5,7}|[489]\\d{6,8}","\\d{5,9}"],[,,"2(?:[0-8]\\d{5,6}|9\\d{4,6})|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}","\\d{5,8}",,,
	"2123456"],[,,"(?:8[7-9]|98)\\d{7}|4(?:3[0789]|8\\d)\\d{5}","\\d{8,9}",,,"48123456"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"90\\d{6}","\\d{8}",,,"90123456"],[,,"NA","NA"],[,,"700\\d{5}","\\d{5,9}",,,"70012345"],[,,"NA","NA"],"BG",359,"00","0",,,"0",,,,[[,"(2)(\\d{5})","$1 $2",["29"],"0$1","",0],[,"(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1","",0],[,"(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{3})",
	"$1 $2 $3",["[78]00"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BH:[,[,,"[136-9]\\d{7}","\\d{8}"],[,,"(?:1(?:3[13-6]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|88)|9[69][69])|7(?:7\\d{2}|178))\\d{4}","\\d{8}",,,"17001234"],[,,"(?:3(?:[1-4679]\\d|5[0135]|8[0-48])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9])))\\d{4}",
	"\\d{8}",,,"36001234"],[,,"80\\d{6}","\\d{8}",,,"80123456"],[,,"(?:87|9[014578])\\d{6}","\\d{8}",,,"90123456"],[,,"84\\d{6}","\\d{8}",,,"84123456"],[,,"NA","NA"],[,,"NA","NA"],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BI:[,[,,"[27]\\d{7}","\\d{8}"],[,,"22(?:2[0-7]|[3-5]0)\\d{4}","\\d{8}",,,"22201234"],[,,"(?:29|7[14-9])\\d{6}","\\d{8}",,,"79561234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],
	"BI",257,"00",,,,,,,,[[,"([27]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BJ:[,[,,"[2689]\\d{7}|7\\d{3}","\\d{4,8}"],[,,"2(?:02|1[037]|2[45]|3[68])\\d{5}","\\d{8}",,,"20211234"],[,,"(?:6[146-8]|9[03-9])\\d{6}","\\d{8}",,,"90011234"],[,,"7[3-5]\\d{2}","\\d{4}",,,"7312"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"857[58]\\d{4}","\\d{8}",,,"85751234"],"BJ",229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,
	"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"81\\d{6}","\\d{8}",,,"81123456"],,,[,,"NA","NA"]],BL:[,[,,"[56]\\d{8}","\\d{9}"],[,,"590(?:2[7-9]|5[12]|87)\\d{4}","\\d{9}",,,"590271234"],[,,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",,,"690301234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BL",590,"00","0",,,"0",,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BM:[,[,,"[4589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}",
	"\\d{7}(?:\\d{3})?",,,"4412345678"],[,,"441(?:[37]\\d|5[0-39])\\d{5}","\\d{10}",,,"4413701234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"BM",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"441",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BN:[,[,,"[2-578]\\d{6}","\\d{7}"],[,,"[2-5]\\d{6}","\\d{7}",,,"2345678"],[,,"[78]\\d{6}","\\d{7}",,,"7123456"],[,,"NA",
	"NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BN",673,"00",,,,,,,,[[,"([2-578]\\d{2})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BO:[,[,,"[23467]\\d{7}","\\d{7,8}"],[,,"(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}","\\d{7,8}",,,"22123456"],[,,"[67]\\d{7}","\\d{8}",,,
	"71234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BO",591,"00(1\\d)?","0",,,"0(1\\d)?",,,,[[,"([234])(\\d{7})","$1 $2",["[234]"],"","0$CC $1",0],[,"([67]\\d{7})","$1",["[67]"],"","0$CC $1",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BQ:[,[,,"[347]\\d{6}","\\d{7}"],[,,"(?:318[023]|416[023]|7(?:1[578]|50)\\d)\\d{3}","\\d{7}",,,"7151234"],[,,"(?:318[14-68]|416[15-9]|7(?:0[01]|7[07]|[89]\\d)\\d)\\d{3}","\\d{7}",,,"3181234"],[,,"NA","NA"],[,,"NA",
	"NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BQ",599,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BR:[,[,,"[1-46-9]\\d{7,10}|5\\d{8,9}","\\d{8,11}"],[,,"1[1-9][2-5]\\d{7}|(?:[4689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}","\\d{8,11}",,,"1123456789"],[,,"1[1-9](?:7|9\\d)\\d{7}|2[12478]9?[6-9]\\d{7}|(?:3[1-578]|[4689][1-9]|5[13-5]|7[13-579])[6-9]\\d{7}","\\d{10,11}",,,"11961234567"],[,,"800\\d{6,7}","\\d{8,11}",,,"800123456"],[,,"[359]00\\d{6,7}","\\d{8,11}",
	,,"300123456"],[,,"[34]00\\d{5}","\\d{8}",,,"40041234"],[,,"NA","NA"],[,,"NA","NA"],"BR",55,"00(?:1[45]|2[135]|[34]1|43)","0",,,"0(?:(1[245]|2[135]|[34]1)(\\d{10,11}))?","$2",,,[[,"(\\d{4})(\\d{4})","$1-$2",["[2-9](?:[1-9]|0[1-9])"],"$1","",0],[,"(\\d{5})(\\d{4})","$1-$2",["9(?:[1-9]|0[1-9])"],"$1","",0],[,"(\\d{3,5})","$1",["1[125689]"],"$1","",0],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["(?:1[1-9]|2[12478])9"],"($1)","0 $CC ($1)",0],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)",
	"0 $CC ($1)",0],[,"([34]00\\d)(\\d{4})","$1-$2",["[34]00"],"","",0],[,"([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1","",0]],[[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["(?:1[1-9]|2[12478])9","(?:1[1-9]|2[12478])9"],"($1)","0 $CC ($1)",0],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]","[1-9][1-9]"],"($1)","0 $CC ($1)",0],[,"([34]00\\d)(\\d{4})","$1-$2",["[34]00","[34]00"],"","",0],[,"([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00","[3589]00"],"0$1","",0]],[,,"NA","NA"],,,[,
	,"[34]00\\d{5}","\\d{8}",,,"40041234"],[,,"NA","NA"],,,[,,"NA","NA"]],BS:[,[,,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[3467]|8[0-4]|9[2-467])|461|502|6(?:12|7[67]|8[78]|9[89])|702)\\d{4}","\\d{7}(?:\\d{3})?",,,"2423456789"],[,,"242(?:3(?:5[79]|[79]5)|4(?:[2-4][1-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-9]|65|77)|6[34]6|727)\\d{4}","\\d{10}",,,"2423591234"],[,,"242300\\d{4}|8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}",
	"\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"BS",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"242",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BT:[,[,,"[1-8]\\d{6,7}","\\d{6,8}"],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}","\\d{6,7}",,,"2345678"],[,,"[17]7\\d{6}","\\d{8}",,,"17123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BT",975,"00",,,,,,,,[[,"([17]7)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
	["1|77"],"","",0],[,"([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BW:[,[,,"[2-79]\\d{6,7}","\\d{7,8}"],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0235-9]|55|6\\d|7[01]|9[0-57])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}","\\d{7}",,,"2401234"],[,,"7(?:[1-35]\\d{6}|[46][0-7]\\d{5}|7[01467]\\d{5})","\\d{8}",,,"71123456"],[,,"NA","NA"],[,,"90\\d{5}","\\d{7}",,,"9012345"],
	[,,"NA","NA"],[,,"NA","NA"],[,,"79[12][01]\\d{4}","\\d{8}",,,"79101234"],"BW",267,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-6]"],"","",0],[,"(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"],"","",0],[,"(90)(\\d{5})","$1 $2",["9"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],BY:[,[,,"[1-4]\\d{8}|[89]\\d{9,10}","\\d{7,11}"],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
	"\\d{7,9}",,,"152450911"],[,,"(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}","\\d{9}",,,"294911911"],[,,"8(?:0[13]|20\\d)\\d{7}","\\d{10,11}",,,"8011234567"],[,,"(?:810|902)\\d{7}","\\d{10}",,,"9021234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BY",375,"810","8",,,"8?0?",,"8~10",,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])",
	"1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1","",0],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1","",0],[,"([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1","",0],[,"(8\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1","",0]],,[,,"NA","NA"],,,[,,"8(?:[013]|[12]0)\\d{8}|902\\d{7}","\\d{10,11}",,,"82012345678"],
	[,,"NA","NA"],,,[,,"NA","NA"]],BZ:[,[,,"[2-8]\\d{6}|0\\d{10}","\\d{7}(?:\\d{4})?"],[,,"[234578][02]\\d{5}","\\d{7}",,,"2221234"],[,,"6[0-367]\\d{5}","\\d{7}",,,"6221234"],[,,"0800\\d{7}","\\d{11}",,,"08001234123"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"],"","",0],[,"(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],CA:[,[,,"[2-9]\\d{9}|3\\d{6}","\\d{7}(?:\\d{3})?"],
	[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|79|8[17])|6(?:0[04]|13|39|47)|7(?:0[59]|78|80)|8(?:[06]7|19|73)|90[25])[2-9]\\d{6}|310\\d{4}","\\d{7}(?:\\d{3})?",,,"2042345678"],[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|79|8[17])|6(?:0[04]|13|39|47)|7(?:0[59]|78|80)|8(?:[06]7|19|73)|90[25])[2-9]\\d{6}","\\d{7}(?:\\d{3})?",,,"2042345678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}","\\d{7}(?:\\d{3})?",,,"8002123456"],[,,"900[2-9]\\d{6}",
	"\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"CA",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CC:[,[,,"[1458]\\d{5,9}","\\d{6,10}"],[,,"89162\\d{4}","\\d{8,9}",,,"891621234"],[,,"4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-37-9]|6[6-9]|7[07-9]|8[7-9])\\d{6}","\\d{9}",,,"412345678"],[,,"1(?:80(?:0\\d{2})?|3(?:00\\d{2})?)\\d{4}","\\d{6,10}",,,"1800123456"],[,,"190[0126]\\d{6}","\\d{10}",,,"1900123456"],[,
	,"NA","NA"],[,,"500\\d{6}","\\d{9}",,,"500123456"],[,,"550\\d{6}","\\d{9}",,,"550123456"],"CC",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",,,"0",,"0011",,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CD:[,[,,"[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}","\\d{7,9}"],[,,"1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}","\\d{7,9}",,,"1234567"],[,,"8(?:[0-2459]\\d{2}|8)\\d{5}|9[7-9]\\d{7}","\\d{7,9}",,,"991234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CD",243,
	"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"],"0$1","",0],[,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"],"0$1","",0],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1","",0],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CF:[,[,,"[278]\\d{7}","\\d{8}"],[,,"2[12]\\d{6}","\\d{8}",,,"21612345"],[,,"7[0257]\\d{6}","\\d{8}",,,"70012345"],[,,"NA","NA"],[,,"8776\\d{4}","\\d{8}",,,"87761234"],[,,"NA","NA"],
	[,,"NA","NA"],[,,"NA","NA"],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CG:[,[,,"[028]\\d{8}","\\d{9}"],[,,"222[1-589]\\d{5}","\\d{9}",,,"222123456"],[,,"0[14-6]\\d{7}","\\d{9}",,,"061234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CG",242,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"],"","",0],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",
	["8"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],CH:[,[,,"[2-9]\\d{8}|860\\d{9}","\\d{9}(?:\\d{3})?"],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}","\\d{9}",,,"212345678"],[,,"7[5-9]\\d{7}","\\d{9}",,,"781234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"90[016]\\d{6}","\\d{9}",,,"900123456"],[,,"84[0248]\\d{6}","\\d{9}",,,"840123456"],[,,"878\\d{6}","\\d{9}",,,"878123456"],[,,"NA","NA"],"CH",41,"00","0",,,"0",,,,[[,"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["[2-7]|[89]1"],"0$1","",0],[,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"],"0$1","",0]],,[,,"74[0248]\\d{6}","\\d{9}",,,"740123456"],,,[,,"NA","NA"],[,,"5[18]\\d{7}","\\d{9}",,,"581234567"],,,[,,"860\\d{9}","\\d{12}",,,"860123456789"]],CI:[,[,,"[02-7]\\d{7}","\\d{8}"],[,,"(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}","\\d{8}",,,"21234567"],[,,"(?:0[1-9]|4[0-24-9]|5[4-9]|6[015-79]|77)\\d{6}",
	"\\d{8}",,,"01234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],CK:[,[,,"[2-57]\\d{4}","\\d{5}"],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}","\\d{5}",,,"21234"],[,,"(?:5[0-68]|7\\d)\\d{3}","\\d{5}",,,"71234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",,"",
	"",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CL:[,[,,"(?:[2-9]|600|123)\\d{7,8}","\\d{6,11}"],[,,"(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[1347])\\d{7}|65\\d{6,7}","\\d{6,9}",,,"221234567"],[,,"9[5-9]\\d{7}","\\d{8,9}",,,"961234567"],[,,"800\\d{6}|1230\\d{7}","\\d{9,11}",,,"800123456"],[,,"NA","NA"],[,,"600\\d{7,8}","\\d{10,11}",,,"6001234567"],[,,"NA","NA"],[,,"44\\d{7}","\\d{9}",,,"441234567"],"CL",56,"(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0","0",,,"0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))",
	,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"($1)","$CC ($1)",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)","$CC ($1)",0],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["65"],"($1)","$CC ($1)",0],[,"(9)([5-9]\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1","",0],[,"(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"],"0$1","",0],[,"([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"],"$1","",0],[,"(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"],"$1","",0],[,"(1230)(\\d{3})(\\d{4})","$1 $2 $3",
	["1"],"$1","",0],[,"(\\d{4,5})","$1",["[1-9]"],"$1","",0]],[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2","2"],"($1)","$CC ($1)",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]","[357]|4[1-35]|6[13-57]"],"($1)","$CC ($1)",0],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["65","65"],"($1)","$CC ($1)",0],[,"(9)([5-9]\\d{3})(\\d{4})","$1 $2 $3",["9","9"],"0$1","",0],[,"(44)(\\d{3})(\\d{4})","$1 $2 $3",["44","44"],"0$1","",0],[,"([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8","60|8"],"$1","",
	0],[,"(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60","60"],"$1","",0],[,"(1230)(\\d{3})(\\d{4})","$1 $2 $3",["1","1"],"$1","",0]],[,,"NA","NA"],,,[,,"600\\d{7,8}","\\d{10,11}",,,"6001234567"],[,,"NA","NA"],,,[,,"NA","NA"]],CM:[,[,,"[2357-9]\\d{7}","\\d{8}"],[,,"(?:22|33)\\d{6}","\\d{8}",,,"22123456"],[,,"[579]\\d{7}","\\d{8}",,,"71234567"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"88\\d{6}","\\d{8}",,,"88012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CM",237,"00",,,,,,,,[[,"([2357-9]\\d)(\\d{2})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["[23579]|88"],"","",0],[,"(800)(\\d{2})(\\d{3})","$1 $2 $3",["80"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CN:[,[,,"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{9}","\\d{4,12}"],[,,"21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:71|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})|80(?:29|6[03578]|7[018]|81)\\d{4}",
	"\\d{4,12}",,,"1012345678"],[,,"1(?:[38]\\d|4[57]|5[0-35-9])\\d{8}","\\d{11}",,,"13123456789"],[,,"(?:10)?800\\d{7}","\\d{10,12}",,,"8001234567"],[,,"16[08]\\d{5}","\\d{8}",,,"16812345"],[,,"400\\d{7}","\\d{10}",,,"4001234567"],[,,"NA","NA"],[,,"NA","NA"],"CN",86,"(1[1279]\\d{3})?00","0",,,"(1[1279]\\d{3})|0",,"00",,[[,"(80\\d{2})(\\d{4})","$1 $2",["80[2678]"],"0$1","$CC $1",1],[,"([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"],"","",0],[,"(\\d{5,6})","$1",["100|95"],"","",0],[,"(\\d{2})(\\d{5,6})",
	"$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|95)","(?:10|2\\d)(?:100|95)"],"0$1","$CC $1",0],[,"(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d{2}[19]","[3-9]\\d{2}(?:10|95)"],"0$1","$CC $1",0],[,"(\\d{3,4})(\\d{4})","$1 $2",["[2-9]"],"","",0],[,"(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","$CC $1",1],[,"([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:71|98)"],
	"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","$CC $1",1],[,"(1[3-58]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["1[3-58]"],"","$CC $1",0],[,"(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108",
	"1080","10800"],"","",0]],[[,"(80\\d{2})(\\d{4})","$1 $2",["80[2678]","80[2678]"],"0$1","$CC $1",1],[,"([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00","[48]00"],"","",0],[,"(\\d{2})(\\d{5,6})","$1 $2","(?:10|2\\d)[19] (?:10|2\\d)(?:10|95) (?:10|2\\d)(?:100|95) (?:10|2\\d)[19] (?:10|2\\d)(?:10|95) (?:10|2\\d)(?:100|95)".split(" "),"0$1","$CC $1",0],[,"(\\d{3})(\\d{5,6})","$1 $2","[3-9] [3-9]\\d{2}[19] [3-9]\\d{2}(?:10|95) [3-9] [3-9]\\d{2}[19] [3-9]\\d{2}(?:10|95)".split(" "),"0$1","$CC $1",0],[,"(21)(\\d{4})(\\d{4,6})",
	"$1 $2 $3",["21","21"],"0$1","$CC $1",1],[,"([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3","10[1-9]|2[02-9] 10[1-9]|2[02-9] 10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9] 10[1-9]|2[02-9] 10[1-9]|2[02-9] 10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]".split(" "),"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:71|98)","3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:71|98)"],
	"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])","3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],
	"0$1","$CC $1",1],[,"(1[3-58]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["1[3-58]","1[3-58]"],"","$CC $1",0],[,"(10800)(\\d{3})(\\d{4})","$1 $2 $3","108 1080 10800 108 1080 10800".split(" "),"","",0]],[,,"NA","NA"],,,[,,"(?:4|(?:10)?8)00\\d{7}","\\d{10,12}",,,"4001234567"],[,,"NA","NA"],,,[,,"NA","NA"]],CO:[,[,,"(?:[13]\\d{0,3}|[24-8])\\d{7}","\\d{7,11}"],[,,"[124-8][2-9]\\d{6}","\\d{8}",,,"12345678"],[,,"3(?:0[0-5]|1\\d|[25][01])\\d{7}","\\d{10}",,,"3211234567"],[,,"1800\\d{7}","\\d{11}",,,"18001234567"],
	[,,"19(?:0[01]|4[78])\\d{7}","\\d{11}",,,"19001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0([3579]|4(?:44|56))?",,,,[[,"(\\d)(\\d{7})","$1 $2",["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"],"($1)","0$CC $1",0],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"","0$CC $1",0],[,"(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1","",0]],[[,"(\\d)(\\d{7})","$1 $2",["1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]",
	"1(?:8[2-9]|9[0-3]|[2-7])|[24-8]","1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"],"($1)","0$CC $1",0],[,"(\\d{3})(\\d{7})","$1 $2",["3","3"],"","0$CC $1",0],[,"(1)(\\d{3})(\\d{7})","$1 $2 $3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"]]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CR:[,[,,"[24-9]\\d{7,9}","\\d{8,10}"],[,,"2[24-7]\\d{6}","\\d{8}",,,"22123456"],[,,"5(?:0[0-4]|7[0-3])\\d{5}|6(?:[0-2]\\d|30)\\d{5}|7[0-3]\\d{6}|8[3-9]\\d{6}","\\d{8}",,,"83123456"],[,,"800\\d{7}","\\d{10}",
	,,"8001234567"],[,,"90[059]\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"210[0-6]\\d{4}|4(?:0(?:[04]0\\d{4}|10[0-3]\\d{3}|2900\\d{2}|3[01]\\d{4}|5\\d{5}|70[01]\\d{3}|8[0-2]\\d{4})|1[01]\\d{5}|20[0-3]\\d{4}|400\\d{4}|70[0-2]\\d{4})|5100\\d{4}","\\d{8}",,,"40001234"],"CR",506,"00",,,,"(19(?:0[01468]|19|20|66|77))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"],"","$CC $1",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"],"","$CC $1",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA",
	"NA"],,,[,,"NA","NA"]],CU:[,[,,"[2-57]\\d{5,7}","\\d{4,8}"],[,,"2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}","\\d{4,8}",,,"71234567"],[,,"5\\d{7}","\\d{8}",,,"51234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CU",53,"119","0",,,"0",,,,[[,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)","",0],[,"(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"],"(0$1)","",0],[,"(\\d)(\\d{7})","$1 $2",["5"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA",
	"NA"],,,[,,"NA","NA"]],CV:[,[,,"[259]\\d{6}","\\d{7}"],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}","\\d{7}",,,"2211234"],[,,"(?:9\\d|59)\\d{5}","\\d{7}",,,"9911234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CW:[,[,,"[169]\\d{6,7}","\\d{7,8}"],[,,"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","\\d{7,8}",
	,,"94151234"],[,,"9(?:5(?:[1246]\\d|3[01])|6(?:[16-9]\\d|3[01]))\\d{4}","\\d{7,8}",,,"95181234"],[,,"NA","NA"],[,,"NA","NA"],[,,"(?:10|69)\\d{5}","\\d{7}",,,"1011234"],[,,"NA","NA"],[,,"NA","NA"],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[13-7]"],"","",0],[,"(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"],"","",0]],,[,,"955\\d{5}","\\d{7,8}",,,"95581234"],1,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CX:[,[,,"[1458]\\d{5,9}","\\d{6,10}"],[,,"89164\\d{4}","\\d{8,9}",,,"891641234"],[,,"4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-37-9]|6[6-9]|7[07-9]|8[7-9])\\d{6}",
	"\\d{9}",,,"412345678"],[,,"1(?:80(?:0\\d{2})?|3(?:00\\d{2})?)\\d{4}","\\d{6,10}",,,"1800123456"],[,,"190[0126]\\d{6}","\\d{10}",,,"1900123456"],[,,"NA","NA"],[,,"500\\d{6}","\\d{9}",,,"500123456"],[,,"550\\d{6}","\\d{9}",,,"550123456"],"CX",61,"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","0",,,"0",,"0011",,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],CY:[,[,,"[257-9]\\d{7}","\\d{8}"],[,,"2[2-6]\\d{6}","\\d{8}",,,"22345678"],[,,"9[5-79]\\d{6}","\\d{8}",,,"96123456"],[,,
	"800\\d{5}","\\d{8}",,,"80001234"],[,,"90[09]\\d{5}","\\d{8}",,,"90012345"],[,,"80[1-9]\\d{5}","\\d{8}",,,"80112345"],[,,"700\\d{5}","\\d{8}",,,"70012345"],[,,"NA","NA"],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"(?:50|77)\\d{6}","\\d{8}",,,"77123456"],,,[,,"NA","NA"]],CZ:[,[,,"[2-8]\\d{8}|9\\d{8,11}","\\d{9,12}"],[,,"2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}","\\d{9,12}",,,"212345678"],[,,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}","\\d{9,12}",
	,,"601123456"],[,,"800\\d{6}","\\d{9,12}",,,"800123456"],[,,"9(?:0[05689]|76)\\d{6}","\\d{9,12}",,,"900123456"],[,,"8[134]\\d{7}","\\d{9,12}",,,"811234567"],[,,"70[01]\\d{6}","\\d{9,12}",,,"700123456"],[,,"9[17]0\\d{6}","\\d{9,12}",,,"910123456"],"CZ",420,"00",,,,,,,,[[,"([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"],"","",0],[,"(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"],"","",0],[,"(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"],"","",0]],,[,,"NA","NA"],,,[,,"NA",
	"NA"],[,,"9(?:5\\d|7[234])\\d{6}","\\d{9,12}",,,"972123456"],,,[,,"9(?:3\\d{9}|6\\d{7,10})","\\d{9,12}",,,"93123456789"]],DE:[,[,,"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,7})","\\d{2,15}"],[,,"[246]\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-9]\\d)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})","\\d{2,15}",,,"30123456"],[,
	,"1(?:5[0-2579]\\d{8}|6[023]\\d{7,8}|7(?:[0-57-9]\\d?|6\\d)\\d{7})","\\d{10,11}",,,"15123456789"],[,,"800\\d{7,12}","\\d{10,15}",,,"8001234567890"],[,,"900(?:[135]\\d{6}|9\\d{7})","\\d{10,11}",,,"9001234567"],[,,"180\\d{5,11}","\\d{8,14}",,,"18012345"],[,,"700\\d{8}","\\d{11}",,,"70012345678"],[,,"NA","NA"],"DE",49,"00","0",,,"0",,,,[[,"(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"],"0$1","",0],[,"(1\\d{3})(\\d{7})","$1 $2",["15"],"0$1","",0],[,"(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"],"0$1","",0],
	[,"(\\d{3})(\\d{3,11})","$1 $2",["2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"],"0$1","",0],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])","[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"],
	"0$1","",0],[,"(3\\d{4})(\\d{1,10})","$1 $2",["3"],"0$1","",0],[,"(800)(\\d{7,12})","$1 $2",["800"],"0$1","",0],[,"(177)(99)(\\d{7,8})","$1 $2 $3",["177","1779","17799"],"0$1","",0],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["(?:18|90)0","180|900[1359]"],"0$1","",0],[,"(1\\d{2})(\\d{5,11})","$1 $2",["181"],"0$1","",0],[,"(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"],"0$1","",0],[,"(18\\d{2})(\\d{7})","$1 $2",["18[68]"],"0$1","",0],[,"(18\\d)(\\d{8})","$1 $2",["18[2-579]"],"0$1","",0],[,"(700)(\\d{4})(\\d{4})",
	"$1 $2 $3",["700"],"0$1","",0]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})","\\d{4,14}",,,"16412345"],,,[,,"NA","NA"],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})","\\d{8,14}",,,"18500123456"],,,[,,"17799\\d{7,8}","\\d{12,13}",,,"177991234567"]],DJ:[,[,,"[27]\\d{7}","\\d{8}"],[,,"2(?:1[2-5]|7[45])\\d{5}","\\d{8}",,,"21360003"],[,,"77[6-8]\\d{5}","\\d{8}",,,"77831001"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",
	0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],DK:[,[,,"[2-9]\\d{7}","\\d{8}"],[,,"(?:[2-7]\\d|8[126-9]|9[126-9])\\d{6}","\\d{8}",,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[126-9])\\d{6}","\\d{8}",,,"20123456"],[,,"80\\d{6}","\\d{8}",,,"80123456"],[,,"90\\d{6}","\\d{8}",,,"90123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"DK",45,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],DM:[,[,,"[57-9]\\d{9}",
	"\\d{7}(?:\\d{3})?"],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}","\\d{7}(?:\\d{3})?",,,"7674201234"],[,,"767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[2-7])\\d{4}","\\d{10}",,,"7672251234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"DM",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"767",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],DO:[,[,,"[589]\\d{9}",
	"\\d{7}(?:\\d{3})?"],[,,"8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})","\\d{7}(?:\\d{3})?",,,"8092345678"],[,,"8[024]9[2-9]\\d{6}","\\d{7}(?:\\d{3})?",,,"8092345678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}",
	"\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"DO",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"8[024]9",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],DZ:[,[,,"(?:[1-4]|[5-9]\\d)\\d{7}","\\d{8,9}"],[,,"(?:1\\d|2[014-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}","\\d{8,9}",,,"12345678"],[,,"(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-2])\\d{6}","\\d{9}",,,"551234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],
	[,,"80[3-689]1\\d{5}","\\d{9}",,,"808123456"],[,,"80[12]1\\d{5}","\\d{9}",,,"801123456"],[,,"NA","NA"],[,,"98[23]\\d{6}","\\d{9}",,,"983123456"],"DZ",213,"00","0",,,"0",,,,[[,"([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1","",0],[,"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1","",0],[,"(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],EC:[,[,,"1\\d{9,10}|[2-8]\\d{7}|9\\d{8}","\\d{7,11}"],
	[,,"[2-7][2-7]\\d{6}","\\d{7,8}",,,"22123456"],[,,"9(?:39|[45][89]|[67][7-9]|[89]\\d)\\d{6}","\\d{9}",,,"991234567"],[,,"1800\\d{6,7}","\\d{10,11}",,,"18001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"[2-7]890\\d{4}","\\d{8}",,,"28901234"],"EC",593,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],"(0$1)","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1","",0],[,"(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["1"],"$1","",0]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",
	["[247]|[356][2-8]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9","9"],"0$1","",0],[,"(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["1","1"],"$1","",0]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],EE:[,[,,"1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}","\\d{4,10}"],[,,"(?:3[23589]|4(?:0\\d|[3-8])|6\\d|7[1-9]|88)\\d{5}","\\d{7,8}",,,"3212345"],[,,"(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}","\\d{7,8}",,,"51234567"],[,,"800(?:0\\d{3}|1\\d|[2-9])\\d{3}",
	"\\d{7,10}",,,"80012345"],[,,"900\\d{4}","\\d{7}",,,"9001234"],[,,"NA","NA"],[,,"70[0-2]\\d{5}","\\d{8}",,,"70012345"],[,,"NA","NA"],"EE",372,"00",,,,,,,,[[,"([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"],"","",0],[,"(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"],"","",0],[,"(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"],"","",0],[,"([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"],
	"","",0]],,[,,"NA","NA"],,,[,,"1\\d{3,4}|800[2-9]\\d{3}","\\d{4,7}",,,"8002123"],[,,"1(?:2[01245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[012])\\d{1,2}","\\d{4,5}",,,"12123"],,,[,,"NA","NA"]],EG:[,[,,"1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}","\\d{5,10}"],[,,"(?:1(3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|[57][23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}|1[69]\\d{3}","\\d{5,9}",,,"234567890"],
	[,,"1(?:0[0-269]|1[0-245]|2[0-278])\\d{7}","\\d{10}",,,"1001234567"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"900\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[012]|[89]00"],"0$1","",0],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|[89][2-9]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],EH:[,[,,"[5689]\\d{8}","\\d{9}"],
	[,,"528[89]\\d{5}","\\d{9}",,,"528812345"],[,,"6(?:0[0-8]|[12-7]\\d|8[01]|9[27-9])\\d{6}","\\d{9}",,,"650123456"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"89\\d{7}","\\d{9}",,,"891234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"EH",212,"00","0",,,"0",,,,,,[,,"NA","NA"],,"528[89]",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ER:[,[,,"[178]\\d{6}","\\d{6,7}"],[,,"1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}","\\d{6,7}",,,"8370362"],[,,"17[1-3]\\d{4}|7\\d{6}","\\d{7}",,,"7123456"],[,,"NA","NA"],
	[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ES:[,[,,"[5-9]\\d{8}","\\d{9}"],[,,"8(?:[13]0|[28][0-8]|[47][1-9]|5[01346-9]|6[0457-9])\\d{6}|9(?:[1238][0-8]\\d{6}|4[1-9]\\d{6}|5\\d{7}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})","\\d{9}",,,"810123456"],[,,"(?:6\\d{6}|7[1-4]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}",
	"\\d{9}",,,"612345678"],[,,"[89]00\\d{6}","\\d{9}",,,"800123456"],[,,"80[367]\\d{6}","\\d{9}",,,"803123456"],[,,"90[12]\\d{6}","\\d{9}",,,"901123456"],[,,"70\\d{7}","\\d{9}",,,"701234567"],[,,"NA","NA"],"ES",34,"00",,,,,,,,[[,"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"51\\d{7}","\\d{9}",,,"511234567"],,,[,,"NA","NA"]],ET:[,[,,"[1-59]\\d{8}","\\d{7,9}"],[,,"(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[57]|44|5[0-4])|6(?:18|2[69]|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
	"\\d{7,9}",,,"111112345"],[,,"9(?:[1-3]\\d|5[89])\\d{6}","\\d{9}",,,"911234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ET",251,"00","0",,,"0",,,,[[,"([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],FI:[,[,,"1\\d{4,11}|[2-9]\\d{4,10}","\\d{5,12}"],[,,"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}","\\d{5,12}",,,"1312345678"],[,,"4\\d{5,10}|50\\d{4,8}",
	"\\d{6,11}",,,"412345678"],[,,"800\\d{4,7}","\\d{7,10}",,,"8001234567"],[,,"[67]00\\d{5,6}","\\d{8,9}",,,"600123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"FI",358,"00|99[049]","0",,,"0",,,,[[,"(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]00|[6-8]0)"],"0$1","",0],[,"(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1","",0],[,"(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"],"0$1","",0]],,[,,"NA","NA"],1,,[,,"[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
	"\\d{5,10}",,,"100123"],[,,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})","\\d{5,10}",,,"10112345"],,,[,,"NA","NA"]],FJ:[,[,,"[36-9]\\d{6}|0\\d{10}","\\d{7}(?:\\d{4})?"],[,,"(?:3[0-5]|6[25-7]|8[58])\\d{5}","\\d{7}",,,"3212345"],[,,"(?:7[0-8]|8[03467]|9\\d)\\d{5}","\\d{7}",,,"7012345"],[,,"0800\\d{7}","\\d{11}",,,"08001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"FJ",679,"0(?:0|52)",,,,,,"00",,
	[[,"(\\d{3})(\\d{4})","$1 $2",["[36-9]"],"","",0],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],FK:[,[,,"[2-7]\\d{4}","\\d{5}"],[,,"[2-47]\\d{4}","\\d{5}",,,"31234"],[,,"[56]\\d{4}","\\d{5}",,,"51234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"FK",500,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],FM:[,[,,"[39]\\d{6}","\\d{7}"],[,,"3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}","\\d{7}",
	,,"3201234"],[,,"3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}","\\d{7}",,,"3501234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],FO:[,[,,"[2-9]\\d{5}","\\d{6}"],[,,"(?:20|[3-4]\\d|8[19])\\d{4}","\\d{6}",,,"201234"],[,,"(?:2[1-9]|5\\d|7[1-79])\\d{4}","\\d{6}",,,"211234"],[,,"80[257-9]\\d{3}","\\d{6}",,,"802123"],[,,"90(?:[1345][15-7]|2[125-7]|99)\\d{2}","\\d{6}",
	,,"901123"],[,,"NA","NA"],[,,"NA","NA"],[,,"(?:6[0-36]|88)\\d{4}","\\d{6}",,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",,"","$CC $1",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],FR:[,[,,"[1-9]\\d{8}","\\d{9}"],[,,"[1-5]\\d{8}","\\d{9}",,,"123456789"],[,,"6\\d{8}|7[0-24-9]\\d{7}","\\d{9}",,,"612345678"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"89[1-37-9]\\d{6}","\\d{9}",,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}","\\d{9}",,,"810123456"],[,,
	"NA","NA"],[,,"9\\d{8}","\\d{9}",,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1","",0],[,"(1\\d{2})(\\d{3})","$1 $2",["11"],"$1","",0],[,"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1","",0]],[[,"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]","[1-79]"],"0$1","",0],[,"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8","8"],"0 $1","",0]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA",
	"NA"]],GA:[,[,,"0\\d{7}","\\d{8}"],[,,"01\\d{6}","\\d{8}",,,"01441234"],[,,"0[2-7]\\d{6}","\\d{8}",,,"06031234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GA",241,"00",,,,,,,,[[,"(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],GB:[,[,,"\\d{7,10}","\\d{4,10}"],[,,"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[012])\\d{7}|1(?:(?:1(?:3[0-48]|[46][0-4]|5[012789]|7[0-49]|8[01349])|21[0-7]|31[0-8]|[459]1\\d|61[0-46-9]))\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-4789]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1235679]|9[24578])|4(?:0[03-9]|[28][02-5789]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1235-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-5789])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[023678]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-5789]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-5789]|4[2-9]|5[0-579]|6[234789]|7[0124578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-4789]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[015789]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[234678]\\d{2}|16977[23]\\d{3}",
	"\\d{4,10}",,,"1212345678"],[,,"7(?:[1-4]\\d\\d|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[04-9]\\d|1[02-9]|2[0-35-9]|3[0-689]))\\d{6}","\\d{10}",,,"7400123456"],[,,"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","\\d{7}(?:\\d{2,3})?",,,"8001234567"],[,,"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","\\d{10}",,,"9012345678"],[,,"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})","\\d{7}(?:\\d{3})?",,,"8431234567"],[,,"70\\d{8}","\\d{10}",,,"7012345678"],[,,"56\\d{8}",
	"\\d{10}",,,"5612345678"],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7(?:0|6[013-9])","2|5[56]|7(?:0|6(?:[013-9]|2[0-35-9]))"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:1|\\d1)|3|9[018]"],"0$1","",0],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:387|5(?:24|39)|697|768|946)","1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"],"0$1","",0],[,"(1\\d{3})(\\d{5,6})","$1 $2",["1"],"0$1","",0],[,"(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-5789]|62)",
	"7(?:[1-5789]|624)"],"0$1","",0],[,"(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1","",0],[,"(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"],"0$1","",0],[,"(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"],"0$1","",0],[,"(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","",0],[,"([58]00)(\\d{6})","$1 $2",["[58]00"],"0$1","",0]],,[,,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",,,"7640123456"],1,,[,,"NA","NA"],[,,"(?:3[0347]|55)\\d{8}",
	"\\d{10}",,,"5512345678"],,,[,,"NA","NA"]],GD:[,[,,"[4589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|938)\\d{4}","\\d{7}(?:\\d{3})?",,,"4732691234"],[,,"473(?:4(?:0[3-79]|1[04-9]|20|58)|5(?:2[01]|3[3-8]))\\d{4}","\\d{10}",,,"4734031234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],
	[,,"NA","NA"],"GD",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"473",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GE:[,[,,"[34578]\\d{8}","\\d{6,9}"],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}","\\d{6,9}",,,"322123456"],[,,"5(?:14|5[01578]|68|7[0147-9]|9[0-35-9])\\d{6}","\\d{9}",,,"555123456"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"706\\d{6}","\\d{9}",,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["[348]"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"],"$1","",0]],,[,,"NA","NA"],,,[,,"706\\d{6}","\\d{9}",,,"706123456"],[,,"NA","NA"],,,[,,"NA","NA"]],GF:[,[,,"[56]\\d{8}","\\d{9}"],[,,"594(?:10|2[012457-9]|3[0-57-9]|4[3-9]|5[7-9]|6[0-3]|9[014])\\d{4}","\\d{9}",,,"594101234"],[,,"694(?:[04][0-7]|1[0-5]|3[018]|[29]\\d)\\d{4}","\\d{9}",,,"694201234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],
	[,,"NA","NA"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GG:[,[,,"[135789]\\d{6,9}","\\d{6,10}"],[,,"1481\\d{6}","\\d{6,10}",,,"1481456789"],[,,"7(?:781|839|911)\\d{6}","\\d{10}",,,"7781123456"],[,,"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}","\\d{7}(?:\\d{2,3})?",,,"8001234567"],[,,"(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","\\d{10}",,,"9012345678"],[,,"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",
	"\\d{7}(?:\\d{3})?",,,"8431234567"],[,,"70\\d{8}","\\d{10}",,,"7012345678"],[,,"56\\d{8}","\\d{10}",,,"5612345678"],"GG",44,"00","0"," x",,"0",,,,,,[,,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",,,"7640123456"],,,[,,"NA","NA"],[,,"(?:3[0347]|55)\\d{8}","\\d{10}",,,"5512345678"],,,[,,"NA","NA"]],GH:[,[,,"[235]\\d{8}|8\\d{7}","\\d{7,9}"],[,,"3(?:0[237]\\d|[167](?:2[0-6]|7\\d)|2(?:2[0-5]|7\\d)|3(?:2[0-3]|7\\d)|4(?:2[013-9]|3[01]|7\\d)|5(?:2[0-7]|7\\d)|8(?:2[0-2]|7\\d)|9(?:20|7\\d))\\d{5}",
	"\\d{7,9}",,,"302345678"],[,,"(?:2[034678]|5[047])\\d{7}","\\d{9}",,,"231234567"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GH",233,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1","",0],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1","",0]],,[,,"NA","NA"],,,[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"NA","NA"],,,[,,"NA","NA"]],GI:[,[,,"[2568]\\d{7}","\\d{8}"],[,,"2(?:00\\d|1(?:6[24-7]|9\\d)|2(?:00|2[2457]))\\d{4}","\\d{8}",,,"20012345"],
	[,,"(?:5[46-8]|62)\\d{6}","\\d{8}",,,"57123456"],[,,"80\\d{6}","\\d{8}",,,"80123456"],[,,"8[1-689]\\d{6}","\\d{8}",,,"88123456"],[,,"87\\d{6}","\\d{8}",,,"87123456"],[,,"NA","NA"],[,,"NA","NA"],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GL:[,[,,"[1-689]\\d{5}","\\d{6}"],[,,"(?:19|3[1-6]|6[14689]|8[14-79]|9\\d)\\d{4}","\\d{6}",,,"321000"],[,,"[245][2-9]\\d{4}","\\d{6}",,,"221234"],[,,"80\\d{4}","\\d{6}",,,"801234"],
	[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"3[89]\\d{4}","\\d{6}",,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GM:[,[,,"[2-9]\\d{6}","\\d{7}"],[,,"(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}","\\d{7}",,,"5661234"],[,,"(?:2[0-6]|[3679]\\d)\\d{5}","\\d{7}",,,"3012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA",
	"NA"],"GM",220,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GN:[,[,,"[367]\\d{7,8}","\\d{8,9}"],[,,"30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}","\\d{8}",,,"30241234"],[,,"6[02356]\\d{7}","\\d{9}",,,"601123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"722\\d{6}","\\d{9}",,,"722123456"],"GN",224,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"],"","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["[67]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GP:[,[,,"[56]\\d{8}","\\d{9}"],[,,"590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}","\\d{9}",,,"590201234"],[,,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",,,"690301234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GP",590,"00","0",,,"0",,,,[[,"([56]90)(\\d{2})(\\d{4})","$1 $2-$3",,"0$1","",0]],,[,,"NA","NA"],1,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA",
	"NA"]],GQ:[,[,,"[23589]\\d{8}","\\d{9}"],[,,"3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}","\\d{9}",,,"333091234"],[,,"(?:222|551)\\d{6}","\\d{9}",,,"222123456"],[,,"80\\d[1-9]\\d{5}","\\d{9}",,,"800123456"],[,,"90\\d[1-9]\\d{5}","\\d{9}",,,"900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"],"","",0],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GR:[,
	[,,"[26-9]\\d{9}","\\d{10}"],[,,"2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}","\\d{10}",,,"2123456789"],[,,"69\\d{8}","\\d{10}",,,"6912345678"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],
	[,,"90[19]\\d{7}","\\d{10}",,,"9091234567"],[,,"8(?:0[16]|12|25)\\d{7}","\\d{10}",,,"8011234567"],[,,"70\\d{8}","\\d{10}",,,"7012345678"],[,,"NA","NA"],"GR",30,"00",,,,,,,,[[,"([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"],"","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"],"","",0],[,"(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GT:[,[,,"[2-7]\\d{7}|1[89]\\d{9}","\\d{8}(?:\\d{3})?"],[,,"[267][2-9]\\d{6}","\\d{8}",
	,,"22456789"],[,,"[345]\\d{7}","\\d{8}",,,"51234567"],[,,"18[01]\\d{8}","\\d{11}",,,"18001112222"],[,,"19\\d{9}","\\d{11}",,,"19001112222"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"],"","",0],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GU:[,[,,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}",
	"\\d{7}(?:\\d{3})?",,,"6713001234"],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:56|7[1-9]|8[236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[5-9])|7(?:[079]7|2[0167]|3[45]|8[789])|8(?:[2-5789]8|6[48])|9(?:2[29]|6[79]|7[179]|8[789]|9[78]))\\d{4}","\\d{7}(?:\\d{3})?",,,"6713001234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"GU",1,"011","1",
	,,"1",,,1,,,[,,"NA","NA"],,"671",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GW:[,[,,"[3-79]\\d{6}","\\d{7}"],[,,"3(?:2[0125]|3[1245]|4[12]|5[1-4]|70|9[1-467])\\d{4}","\\d{7}",,,"3201234"],[,,"(?:[5-7]\\d|9[012])\\d{5}","\\d{7}",,,"5012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"40\\d{5}","\\d{7}",,,"4012345"],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],GY:[,[,,"[2-4679]\\d{6}","\\d{7}"],[,,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
	"\\d{7}",,,"2201234"],[,,"6\\d{6}","\\d{7}",,,"6091234"],[,,"(?:289|862)\\d{4}","\\d{7}",,,"2891234"],[,,"9008\\d{3}","\\d{7}",,,"9008123"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],HK:[,[,,"[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}","\\d{5,11}"],[,,"(?:[23]\\d|5[78])\\d{6}","\\d{8}",,,"21234567"],[,,"(?:5[1-69]\\d|6\\d{2}|9(?:0[1-9]|[1-8]\\d))\\d{5}","\\d{8}",,,"51234567"],[,,"800\\d{6}",
	"\\d{9}",,,"800123456"],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})","\\d{5,11}",,,"90012345678"],[,,"NA","NA"],[,,"8[1-3]\\d{6}","\\d{8}",,,"81123456"],[,,"NA","NA"],"HK",852,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[235-7]|[89](?:0[1-9]|[1-9])"],"","",0],[,"(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"],"","",0],[,"(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"],"","",0],[,"(900)(\\d{2,5})","$1 $2",["900"],"","",0]],,[,,"7\\d{7}","\\d{8}",,,"71234567"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],
	HN:[,[,,"[237-9]\\d{7}","\\d{8}"],[,,"2(?:2(?:0[019]|1[1-36]|[23]\\d|4[056]|5[57]|7[01389]|8[0146-9]|9[012])|4(?:2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:4[3-5]|5\\d|6[56]|74)|6(?:[056]\\d|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[34])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}","\\d{8}",,,"22123456"],[,,"[37-9]\\d{7}","\\d{8}",,,"91234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],
	[,,"NA","NA"],,,[,,"NA","NA"]],HR:[,[,,"[1-7]\\d{5,8}|[89]\\d{6,11}","\\d{6,12}"],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6}","\\d{6,8}",,,"12345678"],[,,"9[1257-9]\\d{6,10}","\\d{8,12}",,,"912345678"],[,,"80[01]\\d{4,7}","\\d{7,10}",,,"8001234567"],[,,"6(?:[09]\\d{7}|[145]\\d{4,7})","\\d{6,9}",,,"611234"],[,,"NA","NA"],[,,"7[45]\\d{4,7}","\\d{6,9}",,,"741234567"],[,,"NA","NA"],"HR",385,"00","0",,,"0",,,,[[,"(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1","",0],[,"(6[09])(\\d{4})(\\d{3})",
	"$1 $2 $3",["6[09]"],"0$1","",0],[,"(62)(\\d{3})(\\d{3,4})","$1 $2 $3",["62"],"0$1","",0],[,"([2-5]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-5]"],"0$1","",0],[,"(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1","",0],[,"(9\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9"],"0$1","",0],[,"(9\\d)(\\d{3,4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"],"0$1","",0],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[145]|7"],"0$1","",0],[,"(\\d{2})(\\d{3,4})(\\d{3})","$1 $2 $3",["6[145]|7"],"0$1","",0],[,"(80[01])(\\d{2})(\\d{2,3})",
	"$1 $2 $3",["8"],"0$1","",0],[,"(80[01])(\\d{3,4})(\\d{3})","$1 $2 $3",["8"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"62\\d{6,7}","\\d{8,9}",,,"62123456"],,,[,,"NA","NA"]],HT:[,[,,"[2-489]\\d{7}","\\d{8}"],[,,"2(?:[24]\\d|5[1-5]|94)\\d{5}","\\d{8}",,,"22453300"],[,,"(?:3[1-9]|4\\d)\\d{6}","\\d{8}",,,"34101234"],[,,"8\\d{7}","\\d{8}",,,"80012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"98[89]\\d{5}","\\d{8}",,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",
	,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],HU:[,[,,"[1-9]\\d{7,8}","\\d{6,9}"],[,,"(?:1\\d|2(?:1\\d|[2-9])|3[2-7]|4[24-9]|5[2-79]|6[23689]|7(?:1\\d|[2-9])|8[2-57-9]|9[2-69])\\d{6}","\\d{6,9}",,,"12345678"],[,,"(?:[27]0|3[01])\\d{7}","\\d{9}",,,"201234567"],[,,"80\\d{6}","\\d{8}",,,"80123456"],[,,"9[01]\\d{6}","\\d{8}",,,"90123456"],[,,"40\\d{6}","\\d{8}",,,"40123456"],[,,"NA","NA"],[,,"NA","NA"],"HU",36,"00","06",,,"06",,,,[[,"(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"($1)",
	"",0],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"($1)","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ID:[,[,,"[1-9]\\d{6,10}","\\d{5,11}"],[,,"2(?:1(?:[0-8]\\d{6,7}|9\\d{6})|[24]\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|2[1-578]|3[1-68]|4[1-3]|5[1-8]|6[1-3568]|7[0-46]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[1246-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-469]|4[1-6])|7(?:1[1-46-9]|2[14-9]|[36]\\d|4[1-8]|5[1-9]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
	"\\d{5,10}",,,"612345678"],[,,"(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359]|9\\d)|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,9}","\\d{9,11}",,,"812345678"],[,,"177\\d{6,8}|800\\d{5,7}","\\d{8,11}",,,"8001234567"],[,,"809\\d{7}","\\d{10}",
	,,"8091234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ID",62,"0(?:0[1789]|10(?:00|1[67]))","0",,,"0",,,,[[,"(\\d{2})(\\d{7,8})","$1 $2",["2[124]|[36]1"],"(0$1)","",0],[,"(\\d{3})(\\d{5,7})","$1 $2",["[4579]|2[035-9]|[36][02-9]"],"(0$1)","",0],[,"(8\\d{2})(\\d{3,4})(\\d{3,4})","$1-$2-$3",["8[1-35-9]"],"0$1","",0],[,"(177)(\\d{6,8})","$1 $2",["1"],"0$1","",0],[,"(800)(\\d{5,7})","$1 $2",["800"],"0$1","",0],[,"(809)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["809"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA",
	"NA"],[,,"NA","NA"],,,[,,"NA","NA"]],IE:[,[,,"[124-9]\\d{6,9}","\\d{5,10}"],[,,"1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})","\\d{5,10}",,,"2212345"],[,,"8(?:22\\d{6}|[35-9]\\d{7})","\\d{9}",,,"850123456"],[,,"1800\\d{6}","\\d{10}",,,"1800123456"],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}","\\d{10}",,,"1520123456"],
	[,,"18[59]0\\d{6}","\\d{10}",,,"1850123456"],[,,"700\\d{6}","\\d{9}",,,"700123456"],[,,"76\\d{7}","\\d{9}",,,"761234567"],"IE",353,"00","0",,,"0",,,,[[,"(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)","",0],[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)","",0],[,"(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"],"(0$1)","",0],[,"(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"],"(0$1)","",0],[,"(818)(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)","",0],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",
	["[24-69]|7[14]"],"(0$1)","",0],[,"([78]\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1","",0],[,"(700)(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1","",0],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:8[059]|5)","1(?:8[059]0|5)"],"$1","",0]],,[,,"NA","NA"],,,[,,"18[59]0\\d{6}","\\d{10}",,,"1850123456"],[,,"818\\d{6}","\\d{9}",,,"818123456"],,,[,,"8[35-9]\\d{8}","\\d{10}",,,"8501234567"]],IL:[,[,,"[17]\\d{6,9}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}","\\d{4,10}"],[,,"[2-489]\\d{7}","\\d{7,8}",,,"21234567"],
	[,,"5(?:[02347-9]\\d{2}|5(?:2[23]|3[34]|4[45]|5[5689]|6[67]|7[78]|8[89])|6[2-9]\\d)\\d{5}","\\d{9}",,,"501234567"],[,,"1(?:80[019]\\d{3}|255)\\d{3}","\\d{7,10}",,,"1800123456"],[,,"1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}","\\d{8,10}",,,"1919123456"],[,,"1700\\d{6}","\\d{10}",,,"1700123456"],[,,"NA","NA"],[,,"7(?:2[23]\\d|3[237]\\d|47\\d|6(?:5\\d|8[08])|7\\d{2}|8(?:33|55|77|81))\\d{5}","\\d{9}",,,"771234567"],"IL",972,"0(?:0|1[2-9])","0",,,"0",,,,[[,"([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],
	"0$1","",0],[,"([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1","",0],[,"(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"],"$1","",0],[,"(1255)(\\d{3})","$1-$2",["125"],"$1","",0],[,"(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120"],"$1","",0],[,"(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121"],"$1","",0],[,"(1599)(\\d{6})","$1-$2",["15"],"$1","",0],[,"(\\d{4})","*$1",["[2-689]"],"$1","",0]],,[,,"NA","NA"],,,[,,"1700\\d{6}|[2-689]\\d{3}","\\d{4,10}",,,"1700123456"],[,,"[2-689]\\d{3}|1599\\d{6}","\\d{4}(?:\\d{6})?",
	,,"1599123456"],,,[,,"NA","NA"]],IM:[,[,,"[135789]\\d{6,9}","\\d{6,10}"],[,,"1624\\d{6}","\\d{6,10}",,,"1624456789"],[,,"7[569]24\\d{6}","\\d{10}",,,"7924123456"],[,,"808162\\d{4}","\\d{10}",,,"8081624567"],[,,"(?:872299|90[0167]624)\\d{4}","\\d{10}",,,"9016247890"],[,,"8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}","\\d{10}",,,"8456247890"],[,,"70\\d{8}","\\d{10}",,,"7012345678"],[,,"56\\d{8}","\\d{10}",,,"5612345678"],"IM",44,"00","0"," x",,"0",,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",
	"\\d{10}",,,"5512345678"],,,[,,"NA","NA"]],IN:[,[,,"1\\d{7,12}|[2-9]\\d{9,10}","\\d{6,13}"],[,,"(?:11|2[02]|33|4[04]|79)[2-7]\\d{7}|80[2-467]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[126-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:[136][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-467])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-58]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}",
	"\\d{6,10}",,,"1123456789"],[,,"(?:7(?:2(?:0[04-9]|5[09]|7[5-8]|9[389])|3(?:0[1-9]|[58]\\d|7[3679]|9[689])|4(?:0[1-9]|1[15-9]|[29][89]|39|8[389])|5(?:[034678]\\d|2[03-9]|5[017-9]|9[7-9])|6(?:0[0127]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9]\\d)|7(?:0[2-9]|[1-79]\\d|8[1-9])|8(?:[0-7]\\d|9[013-9]))|8(?:0(?:[01589]\\d|6[67])|1(?:[02-589]\\d|1[0135-9]|7[0-79])|2(?:[236-9]\\d|5[1-9])|3(?:[0357-9]\\d|4[1-9])|[45]\\d{2}|6[02457-9]\\d|7[1-69]\\d|8(?:[0-26-9]\\d|44|5[2-9])|9(?:[035-9]\\d|2[2-9]|4[0-8]))|9\\d{3})\\d{6}",
	"\\d{10}",,,"9123456789"],[,,"1(?:600\\d{6}|80(?:0\\d{4,8}|3\\d{9}))","\\d{8,13}",,,"1800123456"],[,,"186[12]\\d{9}","\\d{13}",,,"1861123456789"],[,,"1860\\d{7}","\\d{11}",,,"18603451234"],[,,"NA","NA"],[,,"NA","NA"],"IN",91,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{6})","$1 $2 $3",["7(?:2[0579]|3[057-9]|4[0-389]|6[0-35-9]|[57]|8[0-79])|8(?:0[015689]|1[0-57-9]|2[2356-9]|3[0-57-9]|[45]|6[02457-9]|7[1-69]|8[0124-9]|9[02-9])|9","7(?:2(?:0[04-9]|5[09]|7[5-8]|9[389])|3(?:0[1-9]|[58]|7[3679]|9[689])|4(?:0[1-9]|1[15-9]|[29][89]|39|8[389])|5(?:[034678]|2[03-9]|5[017-9]|9[7-9])|6(?:0[0-27]|1[0-257-9]|2[0-4]|3[19]|5[4589]|[6-9])|7(?:0[2-9]|[1-79]|8[1-9])|8(?:[0-7]|9[013-9]))|8(?:0(?:[01589]|6[67])|1(?:[02-589]|1[0135-9]|7[0-79])|2(?:[236-9]|5[1-9])|3(?:[0357-9]|4[1-9])|[45]|6[02457-9]|7[1-69]|8(?:[0-26-9]|44|5[2-9])|9(?:[035-9]|2[2-9]|4[0-8]))|9"],
	"0$1","",1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79|80[2-46]"],"0$1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[569][14]|7[1257]|8[1346]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[126-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:[136][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)"],"0$1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
	["7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)","7(?:12|2[14]|3[134]|4[47]|5(?:1|5[2-6])|[67]1|88)"],"0$1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"],"0$1","",1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"],"0$1","",1],[,"(1600)(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1","",1],[,"(1800)(\\d{4,5})","$1 $2",["180","1800"],"$1","",1],[,"(18[06]0)(\\d{2,4})(\\d{4})","$1 $2 $3",["18[06]","18[06]0"],"$1","",1],[,"(140)(\\d{3})(\\d{4})",
	"$1 $2 $3",["140"],"$1","",1],[,"(\\d{4})(\\d{3})(\\d{4})(\\d{2})","$1 $2 $3 $4",["18[06]","18(?:03|6[12])"],"$1","",1]],,[,,"NA","NA"],,,[,,"1(?:600\\d{6}|8(?:0(?:0\\d{4,8}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))","\\d{8,13}",,,"1800123456"],[,,"140\\d{7}","\\d{10}",,,"1409305260"],,,[,,"NA","NA"]],IO:[,[,,"3\\d{6}","\\d{7}"],[,,"37\\d{5}","\\d{7}",,,"3709100"],[,,"38\\d{5}","\\d{7}",,,"3801234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})",
	"$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],IQ:[,[,,"[1-7]\\d{7,9}","\\d{6,10}"],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}","\\d{6,9}",,,"12345678"],[,,"7[3-9]\\d{8}","\\d{10}",,,"7912345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"IQ",964,"00","0",,,"0",,,,[[,"(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1","",0],[,"([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1","",0],[,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
	["7"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],IR:[,[,,"[14-8]\\d{6,9}|[23]\\d{4,9}|9(?:[1-4]\\d{8}|9\\d{2,8})","\\d{4,10}"],[,,"1(?:[13-589][12]|[27][1-4])\\d{7}|2(?:1\\d{3,8}|3[12]\\d{7}|4(?:1\\d{4,7}|2\\d{7})|5(?:1\\d{3,7}|[2356]\\d{7})|6\\d{8}|7[34]\\d{7}|[89][12]\\d{7})|3(?:1(?:1\\d{4,7}|2\\d{7})|2[1-4]\\d{7}|3(?:[125]\\d{7}|4\\d{6,7})|4(?:1\\d{6,7}[24-9]\\d{7})|5(?:1\\d{4,7}|[23]\\d{7})|[6-9][12]\\d{7})|4(?:[135-9][12]\\d{7}|2[1-467]\\d{7}|4(?:1\\d{4,7}|[2-4]\\d{7}))|5(?:1(?:1\\d{4,7}|2\\d{7})|2[89]\\d{7}|3[1-5]\\d{7}|4(?:1\\d{4,7}|[2-8]\\d{7})|[5-7][12]\\d{7}|8[1245]\\d{7})|6(?:1(?:1\\d{6,7}|2\\d{7})|[347-9][12]\\d{7}|5(?:1\\d{7}|2\\d{6,7})|6[1-6]\\d{7})|7(?:[13589][12]|2[1289]|4[1-4]|6[1-6]|7[1-3])\\d{7}|8(?:[145][12]|3[124578]|6[1256]|7[1245])\\d{7}",
	"\\d{5,10}",,,"2123456789"],[,,"9[1-3]\\d{8}","\\d{10}",,,"9123456789"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"(?:[2-6]0\\d|993)\\d{7}","\\d{10}",,,"9932123456"],"IR",98,"00","0",,,"0",,,,[[,"(2[15])(\\d{3,5})","$1 $2",["2(?:1|5[0-47-9])"],"0$1","",0],[,"(2[15])(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1|5[0-47-9])"],"0$1","",0],[,"(2\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2(?:[16]|5[0-47-9])"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]|2[02-57-9]"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2,3})",
	"$1 $2 $3",["[13-9]|2[02-57-9]"],"0$1","",0],[,"(\\d{3})(\\d{3})","$1 $2",["[13-9]|2[02-57-9]"],"0$1","",0]],,[,,"943\\d{7}","\\d{10}",,,"9432123456"],,,[,,"NA","NA"],[,,"9990\\d{0,6}","\\d{4,10}",,,"9990123456"],,,[,,"NA","NA"]],IS:[,[,,"[4-9]\\d{6}|38\\d{7}","\\d{7,9}"],[,,"(?:4(?:[14][0-245]|2[0-7]|[37][0-8]|5[0-3568]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[013-7]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}","\\d{7}",,,"4101234"],[,,"38[589]\\d{6}|(?:6(?:1[0-8]|3[0-27-9]|4[0-27]|5[0-29]|[67][0-69]|9\\d)|7(?:5[057]|7\\d|8[0-3])|8(?:2[0-5]|[469]\\d|5[1-9]))\\d{4}",
	"\\d{7,9}",,,"6101234"],[,,"800\\d{4}","\\d{7}",,,"8001234"],[,,"90\\d{5}","\\d{7}",,,"9011234"],[,,"NA","NA"],[,,"NA","NA"],[,,"49[0-24-79]\\d{4}","\\d{7}",,,"4921234"],"IS",354,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"],"","",0],[,"(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"(?:6(?:2[0-8]|49|8\\d)|8(?:2[6-9]|[38]\\d|50|7[014-9])|95[48])\\d{4}","\\d{7}",,,"6201234"]],IT:[,[,,"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",
	"\\d{6,11}"],[,,"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","\\d{6,11}",,,"0212345678"],[,,"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","\\d{9,11}",,,"3123456789"],
	[,,"80(?:0\\d{6}|3\\d{3})","\\d{6,9}",,,"800123456"],[,,"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","\\d{6,10}",,,"899123456"],[,,"84(?:[08]\\d{6}|[17]\\d{3})","\\d{6,9}",,,"848123456"],[,,"1(?:78\\d|99)\\d{6}","\\d{9,10}",,,"1781234567"],[,,"55\\d{8}","\\d{10}",,,"5512345678"],"IT",39,"00",,,,,,,,[[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"],"","",0],[,"(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"],"","",0],[,"(0[26])(\\d{4,6})",
	"$1 $2",["0[26]"],"","",0],[,"(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"],"","",0],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"],"","",0],[,"(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"],"","",0],[,"(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"],"","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"],"","",0],[,"(\\d{4})(\\d{4})",
	"$1 $2",["894","894[5-9]"],"","",0],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"],"","",0]],,[,,"NA","NA"],,,[,,"848\\d{6}","\\d{9}",,,"848123456"],[,,"NA","NA"],1,,[,,"NA","NA"]],JE:[,[,,"[135789]\\d{6,9}","\\d{6,10}"],[,,"1534\\d{6}","\\d{6,10}",,,"1534456789"],[,,"7(?:509|7(?:00|97)|829|937)\\d{6}","\\d{10}",,,"7797123456"],[,,"80(?:07(?:35|81)|8901)\\d{4}","\\d{10}",,,"8007354567"],[,,"(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","\\d{10}",,,"9018105678"],[,,"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}",
	"\\d{10}",,,"8447034567"],[,,"701511\\d{4}","\\d{10}",,,"7015115678"],[,,"56\\d{8}","\\d{10}",,,"5612345678"],"JE",44,"00","0"," x",,"0",,,,,,[,,"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","\\d{10}",,,"7640123456"],,,[,,"NA","NA"],[,,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","\\d{10}",,,"5512345678"],,,[,,"NA","NA"]],JM:[,[,,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[027-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}",
	"\\d{7}(?:\\d{3})?",,,"8765123456"],[,,"876(?:2[1789]\\d|[348]\\d{2}|5(?:08|27|6[0-24-9]|[3-578]\\d)|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}","\\d{10}",,,"8762101234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"JM",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"876",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],JO:[,[,,"[235-9]\\d{7,8}",
	"\\d{7,9}"],[,,"(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][02]|9[0-2])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-2]|[57][02]|60)|53(?:0[0-2]|[13][02]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|300|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|9[09]))\\d{4}","\\d{7,8}",,,"62001234"],[,,"7(?:55|7[25-9]|8[05-9]|9[015-9])\\d{6}",
	"\\d{9}",,,"790123456"],[,,"80\\d{6}","\\d{8}",,,"80012345"],[,,"900\\d{5}","\\d{8}",,,"90012345"],[,,"85\\d{6}","\\d{8}",,,"85012345"],[,,"70\\d{7}","\\d{9}",,,"700123456"],[,,"NA","NA"],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)","",0],[,"(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"],"0$1","",0],[,"(\\d{3})(\\d{5,6})","$1 $2",["70|8[0158]|9"],"0$1","",0]],,[,,"74(?:66|77)\\d{5}","\\d{9}",,,"746612345"],,,[,,"NA","NA"],[,,"8(?:10|8\\d)\\d{5}","\\d{8}",,,
	"88101234"],,,[,,"NA","NA"]],JP:[,[,,"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})","\\d{8,17}"],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}","\\d{9}",,,"312345678"],[,,"(?:[79]0\\d|80[1-9])\\d{7}","\\d{10}",,,"7012345678"],[,,"120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})",
	"\\d{8,17}",,,"120123456"],[,,"990\\d{6}","\\d{9}",,,"990123456"],[,,"NA","NA"],[,,"60\\d{7}","\\d{9}",,,"601234567"],[,,"50[1-9]\\d{7}","\\d{10}",,,"5012345678"],"JP",81,"010","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1","",0],[,"(\\d{4})(\\d{4})","$1-$2",["0077"],"$1","",0],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["0077"],"$1","",0],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["0088"],"$1","",0],[,"(\\d{4})(\\d{3})(\\d{3,4})",
	"$1-$2-$3",["00(?:37|66)"],"$1","",0],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["00(?:37|66)"],"$1","",0],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["00(?:37|66)"],"$1","",0],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",["00(?:37|66)"],"$1","",0],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"],"0$1","",0],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))",
	"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))",
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"],
	"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"],
	"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:9[14-79]|74|[34]7|[56]9)|82|993"],"0$1","",0],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"],"0$1","",0]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0","(?:12|57|99)0"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800","800"],"0$1","",0],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]","[2579]0|80[1-9]"],"0$1","",0],[,"(\\d{4})(\\d)(\\d{4})",
	"$1-$2-$3","1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16]) 1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69)) 1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69)) 1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16]) 1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69)) 1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))".split(" "),
	"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3","1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7]) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7])) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7])) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7])) 1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7]) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7])) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7])) 1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))".split(" "),
	"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3","1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93) 1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34]) 1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4)) 1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93) 1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34]) 1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))".split(" "),
	"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:9[14-79]|74|[34]7|[56]9)|82|993","2(?:9[14-79]|74|[34]7|[56]9)|82|993"],"0$1","",0],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]","3|4(?:2[09]|7[01])|6[1-9]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]","[2479][1-9]"],"0$1","",0]],[,,"20\\d{8}","\\d{10}",,,"2012345678"],,,[,,"00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})","\\d{8,17}",,,"00777012"],[,,"570\\d{6}","\\d{9}",
	,,"570123456"],1,,[,,"NA","NA"]],KE:[,[,,"20\\d{6,7}|[4-9]\\d{6,9}","\\d{5,10}"],[,,"20\\d{6,7}|4(?:[013]\\d{7}|[24-6]\\d{5,7})|5(?:[0-36-8]\\d{5,7}|[459]\\d{5})|6(?:[08]\\d{5}|[14-79]\\d{5,7}|2\\d{7})","\\d{5,9}",,,"202012345"],[,,"7(?:0[0-8]|[123]\\d|5[0-6]|7[0-5]|8[5-9])\\d{6}","\\d{9}",,,"712123456"],[,,"800[24-8]\\d{5,6}","\\d{9,10}",,,"800223456"],[,,"900[02-578]\\d{5}","\\d{9}",,,"900223456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{4,7})","$1 $2",
	["[24-6]"],"0$1","",0],[,"(\\d{3})(\\d{6,7})","$1 $2",["7"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KG:[,[,,"[35-8]\\d{8,9}","\\d{5,10}"],[,,"(?:3(?:1(?:2\\d|3[1-9]|47|5[02]|6[1-8])|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6[0-4])|5(?:22|3[4-7]|59|6[0-5])|6(?:22|5[35-7]|6[0-3])|7(?:22|3[468]|4[1-9]|59|6\\d|7[5-7])|9(?:22|4[1-8]|6[0-8]))|6(?:09|12|2[2-4])\\d)\\d{5}","\\d{5,10}",,,"312123456"],[,,"5[124-7]\\d{7}|7(?:0[0-357-9]|7\\d)\\d{6}",
	"\\d{9}",,,"700123456"],[,,"800\\d{6,7}","\\d{9,10}",,,"800123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KG",996,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["31[25]|[5-7]"],"0$1","",0],[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KH:[,[,,"[1-9]\\d{7,9}","\\d{6,10}"],[,,"(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|238\\d{6}",
	"\\d{6,9}",,,"23756789"],[,,"(?:1(?:[013-9]|2\\d?)|31\\d|6[016-9]|7(?:[07-9]|6\\d)|8(?:[013-79]|8\\d)|9(?:6\\d|7\\d?|[0-589]))\\d{6}","\\d{8,9}",,,"91234567"],[,,"1800(?:1\\d|2[019])\\d{4}","\\d{10}",,,"1800123456"],[,,"1900(?:1\\d|2[09])\\d{4}","\\d{10}",,,"1900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1","",0],[,"(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0"],"","",0]],,[,,"NA","NA"],,,
	[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KI:[,[,,"[2-58]\\d{4}|7\\d{7}","\\d{5,8}"],[,,"(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}","\\d{5}",,,"31234"],[,,"7(?:[24]\\d|3[1-9]|8[0-5])\\d{5}","\\d{8}",,,"72012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KI",686,"00",,,,"0",,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KM:[,[,,"[379]\\d{6}","\\d{7}"],[,,"7(?:6[0-37-9]|7[0-57-9])\\d{4}","\\d{7}",,,"7712345"],[,,"3[234]\\d{5}","\\d{7}",,,"3212345"],[,,"NA",
	"NA"],[,,"(?:39[01]|9[01]0)\\d{4}","\\d{7}",,,"9001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KN:[,[,,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"869(?:2(?:29|36)|302|4(?:6[5-9]|70))\\d{4}","\\d{7}(?:\\d{3})?",,,"8692361234"],[,,"869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-6])\\d{4}","\\d{10}",,,"8695561234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],
	[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"KN",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"869",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KP:[,[,,"1\\d{9}|[28]\\d{7}","\\d{6,8}|\\d{10}"],[,,"2\\d{7}|85\\d{6}","\\d{6,8}",,,"21234567"],[,,"19[123]\\d{7}","\\d{10}",,,"1921234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
	["1"],"0$1","",0],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1","",0]],,[,,"NA","NA"],,,[,,"2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}","\\d{8}",,,"23821234"],[,,"NA","NA"],,,[,,"NA","NA"]],KR:[,[,,"[1-7]\\d{3,9}|8\\d{8}","\\d{4,10}"],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})","\\d{4,10}",,,"22123456"],[,,"1[0-26-9]\\d{7,8}","\\d{9,10}",,,"1023456789"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"60[2-9]\\d{6}","\\d{9}",
	,,"602345678"],[,,"NA","NA"],[,,"50\\d{8}","\\d{10}",,,"5012345678"],[,,"70\\d{8}","\\d{10}",,,"7012345678"],"KR",82,"00(?:[124-68]|[37]\\d{2})","0",,,"0(8[1-46-8]|85\\d{2})?",,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["1(?:0|1[19]|[69]9|5[458])|[57]0","1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"],"0$1","0$CC-$1",0],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1(?:[169][2-8]|[78]|5[1-4])|[68]0|[3-6][1-9][1-9]","1(?:[169][2-8]|[78]|5(?:[1-3]|4[56]))|[68]0|[3-6][1-9][1-9]"],"0$1","0$CC-$1",0],[,"(\\d{3})(\\d)(\\d{4})",
	"$1-$2-$3",["131","1312"],"0$1","0$CC-$1",0],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["131","131[13-9]"],"0$1","0$CC-$1",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["13[2-9]"],"0$1","0$CC-$1",0],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3-$4",["30"],"0$1","0$CC-$1",0],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"],"0$1","0$CC-$1",0],[,"(\\d)(\\d{3,4})","$1-$2",["21[0-46-9]"],"0$1","0$CC-$1",0],[,"(\\d{2})(\\d{3,4})","$1-$2",["[3-6][1-9]1","[3-6][1-9]1(?:[0-46-9])"],"0$1","0$CC-$1",0],[,"(\\d{4})(\\d{4})",
	"$1-$2",["1(?:5[46-9]|6[04678])","1(?:5(?:44|66|77|88|99)|6(?:00|44|6[16]|70|88))"],"$1","0$CC-$1",0]],,[,,"15\\d{7,8}","\\d{9,10}",,,"1523456789"],,,[,,"NA","NA"],[,,"1(?:5(?:44|66|77|88|99)|6(?:00|44|6[16]|70|88))\\d{4}","\\d{8}",,,"15441234"],,,[,,"NA","NA"]],KW:[,[,,"[12569]\\d{6,7}","\\d{7,8}"],[,,"(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}","\\d{7,8}",,,"22345678"],[,,"(?:5(?:[05]\\d|1[0-6])|6(?:0[034679]|5[015-9]|6\\d|7[067]|9[0369])|9(?:0[09]|4[049]|6[069]|[79]\\d|8[08]))\\d{5}",
	"\\d{8}",,,"50012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[1269]"],"","",0],[,"(5[015]\\d)(\\d{5})","$1 $2",["5"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KY:[,[,,"[3589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}","\\d{7}(?:\\d{3})?",,,"3452221234"],[,,"345(?:32[1-9]|5(?:1[67]|2[5-7]|4[6-8]|76)|9(?:1[67]|2[3-9]|3[689]))\\d{4}",
	"\\d{10}",,,"3453231234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}|345976\\d{4}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"KY",1,"011","1",,,"1",,,,,,[,,"345849\\d{4}","\\d{10}",,,"3458491234"],,"345",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],KZ:[,[,,"(?:33\\d|7\\d{2}|80[09])\\d{7}","\\d{10}"],[,,"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[023]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[1-79]|4[0-35-9]|59)|4(?:2\\d|3[013-79]|4[0-8]|5[1-79])|5(?:2\\d|3[1-8]|4[1-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[237]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
	"\\d{10}",,,"7123456789"],[,,"7(?:0[01257]|47|6[02-4]|7[15-8]|85)\\d{7}","\\d{10}",,,"7710009998"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"809\\d{7}","\\d{10}",,,"8091234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"751\\d{7}","\\d{10}",,,"7511234567"],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,"NA","NA"],,,[,,"751\\d{7}","\\d{10}",,,"7511234567"],[,,"NA","NA"],,,[,,"NA","NA"]],LA:[,[,,"[2-8]\\d{7,9}","\\d{6,10}"],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}","\\d{6,8}",,,"21212862"],[,,"20(?:2[2389]|5[4-689]|7[6-8]|9[57-9])\\d{6}",
	"\\d{10}",,,"2023123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"LA",856,"00","0",,,"0",,,,[[,"(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"],"0$1","",0],[,"([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|[3-8]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LB:[,[,,"[13-9]\\d{6,7}","\\d{7,8}"],[,,"(?:[14-6]\\d{2}|7(?:[2-579]\\d|62|8[0-7])|[89][2-9]\\d)\\d{4}","\\d{7}",,,"1123456"],[,,"(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|91))\\d{5}","\\d{7,8}",
	,,"71123456"],[,,"NA","NA"],[,,"9[01]\\d{6}","\\d{8}",,,"90123456"],[,,"8[01]\\d{6}","\\d{8}",,,"80123456"],[,,"NA","NA"],[,,"NA","NA"],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-6]|7(?:[2-579]|62|8[0-7])|[89][2-9]"],"0$1","",0],[,"([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[89][01]|7(?:[01]|6[013-9]|8[89]|91)"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LC:[,[,,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"758(?:234|4(?:30|5[0-9]|6[2-9]|8[0-2])|572|638|758)\\d{4}",
	"\\d{7}(?:\\d{3})?",,,"7582345678"],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2[0-6]))\\d{4}","\\d{10}",,,"7582845678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"LC",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"758",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LI:[,[,,"6\\d{8}|[23789]\\d{6}","\\d{7,9}"],[,,"(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}",
	"\\d{7}",,,"2345678"],[,,"6(?:51[01]|6(?:[01][0-4]|2[016-9]|88)|710)\\d{5}|7(?:36|4[25]|56|[7-9]\\d)\\d{4}","\\d{7,9}",,,"661234567"],[,,"80(?:0(?:2[238]|79)|9\\d{2})\\d{2}","\\d{7}",,,"8002222"],[,,"90(?:0(?:2[278]|79)|1(?:23|3[012])|6(?:4\\d|6[0126]))\\d{2}","\\d{7}",,,"9002222"],[,,"NA","NA"],[,,"701\\d{4}","\\d{7}",,,"7011234"],[,,"NA","NA"],"LI",423,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[23]|7[3-57-9]|87"],"","",0],[,"(6\\d)(\\d{3})(\\d{3})","$1 $2 $3",["6"],"","",0],[,
	"(6[567]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["6[567]"],"","",0],[,"(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"],"","",0],[,"([7-9]0\\d)(\\d{2})(\\d{2})","$1 $2 $3",["[7-9]0"],"","",0],[,"([89]0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]0"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"87(?:0[128]|7[0-4])\\d{3}","\\d{7}",,,"8770123"],,,[,,"697(?:[35]6|4[25]|[7-9]\\d)\\d{4}","\\d{9}",,,"697361234"]],LK:[,[,,"[1-9]\\d{8}","\\d{7,9}"],[,,"(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
	"\\d{7,9}",,,"112345678"],[,,"7[125-8]\\d{7}","\\d{9}",,,"712345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{1})(\\d{6})","$1 $2 $3",["[1-689]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LR:[,[,,"(?:[29]\\d|[4-6]|7\\d{1,2}|[38]\\d{2})\\d{6}","\\d{7,9}"],[,,"2\\d{7}","\\d{8}",,,"21234567"],[,,"(?:4[67]|5\\d|6[4-8]|77?\\d{2}|88\\d{2})\\d{5}",
	"\\d{7,9}",,,"4612345"],[,,"NA","NA"],[,,"90\\d{6}","\\d{8}",,,"90123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"33200\\d{4}","\\d{9}",,,"332001234"],"LR",231,"00","0",,,"0",,,,[[,"([279]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[279]"],"0$1","",0],[,"(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1","",0],[,"([4-6])(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[38]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LS:[,[,,"[2568]\\d{7}",
	"\\d{8}"],[,,"2\\d{7}","\\d{8}",,,"22123456"],[,,"[56]\\d{7}","\\d{8}",,,"50123456"],[,,"800[256]\\d{4}","\\d{8}",,,"80021234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LT:[,[,,"[3-9]\\d{7}","\\d{8}"],[,,"(?:3[1478]|4[124-6]|52)\\d{6}","\\d{8}",,,"31234567"],[,,"6\\d{7}","\\d{8}",,,"61234567"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}","\\d{8}",
	,,"90012345"],[,,"808\\d{5}","\\d{8}",,,"80812345"],[,,"700\\d{5}","\\d{8}",,,"70012345"],[,,"NA","NA"],"LT",370,"00","8",,,"[08]",,,,[[,"([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"],"(8-$1)","",1],[,"([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"],"(8-$1)","",1],[,"([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1","",1],[,"(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"],"(8-$1)","",1]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"70[67]\\d{5}","\\d{8}",,,"70712345"],,,[,,"NA",
	"NA"]],LU:[,[,,"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})","\\d{4,11}"],[,,"(?:2(?:2\\d{1,2}|3[2-9]|[67]\\d|4[1-8]\\d?|5[1-5]\\d?|9[0-24-9]\\d?)|3(?:[059][05-9]|[13]\\d|[26][015-9]|4[0-26-9]|7[0-389]|8[08])\\d?|4\\d{2,3}|5(?:[01458]\\d|[27][0-69]|3[0-3]|[69][0-7])\\d?|7(?:1[019]|2[05-9]|3[05]|[45][07-9]|[679][089]|8[06-9])\\d?|8(?:0[2-9]|1[0-36-9]|3[3-9]|[469]9|[58][7-9]|7[89])\\d?|9(?:0[89]|2[0-49]|37|49|5[0-27-9]|7[7-9]|9[0-478])\\d?)\\d{1,7}","\\d{4,11}",,,"27123456"],[,,"6(?:[269][18]|71)\\d{6}",
	"\\d{9}",,,"628123456"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"90[01]\\d{5}","\\d{8}",,,"90012345"],[,,"801\\d{5}","\\d{8}",,,"80112345"],[,,"70\\d{6}","\\d{8}",,,"70123456"],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})","\\d{4,10}",,,"20201234"],"LU",352,"00",,,,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{3})",
	"$1 $2 $3",["20"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],"","$CC $1",0],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|[89](?:[1-9]|0[2-9])"],"","$CC $1",0],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0[01]|70"],"","$CC $1",0],[,"(\\d{3})(\\d{3})(\\d{3})",
	"$1 $2 $3",["6"],"","$CC $1",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LV:[,[,,"[2689]\\d{7}","\\d{8}"],[,,"6[3-8]\\d{6}","\\d{8}",,,"63123456"],[,,"2\\d{7}","\\d{8}",,,"21234567"],[,,"80\\d{6}","\\d{8}",,,"80123456"],[,,"90\\d{6}","\\d{8}",,,"90123456"],[,,"81\\d{6}","\\d{8}",,,"81123456"],[,,"NA","NA"],[,,"NA","NA"],"LV",371,"00",,,,,,,,[[,"([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],LY:[,[,,"[25679]\\d{8}",
	"\\d{7,9}"],[,,"(?:2[1345]|5[1347]|6[123479]|71)\\d{7}","\\d{7,9}",,,"212345678"],[,,"9[1-6]\\d{7}","\\d{9}",,,"912345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"LY",218,"00","0",,,"0",,,,[[,"([25679]\\d)(\\d{7})","$1-$2",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MA:[,[,,"[5689]\\d{8}","\\d{9}"],[,,"5(?:2(?:(?:[015-7]\\d|2[2-9]|3[2-57]|4[2-8]|8[235-7])\\d|9(?:0\\d|[89]0))|3(?:(?:[0-4]\\d|[57][2-9]|6[235-8]|9[3-9])\\d|8(?:0\\d|[89]0)))\\d{4}",
	"\\d{9}",,,"520123456"],[,,"6(?:0[0-8]|[12-7]\\d|8[01]|9[27-9])\\d{6}","\\d{9}",,,"650123456"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"89\\d{7}","\\d{9}",,,"891234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MA",212,"00","0",,,"0",,,,[[,"([56]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|6"],"0$1","",0],[,"([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9])|892","5(?:2(?:[2-48]|90)|3(?:[5-79]|80))|892"],"0$1","",0],[,"(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"],"0$1","",0],
	[,"(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"],"0$1","",0]],,[,,"NA","NA"],1,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MC:[,[,,"[4689]\\d{7,8}","\\d{8,9}"],[,,"9[2-47-9]\\d{6}","\\d{8}",,,"99123456"],[,,"6\\d{8}|4\\d{7}","\\d{8,9}",,,"612345678"],[,,"(?:8\\d|90)\\d{6}","\\d{8}",,,"90123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MC",377,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"$1","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1",
	"",0],[,"(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1","",0]],,[,,"NA","NA"],,,[,,"8\\d{7}","\\d{8}"],[,,"NA","NA"],,,[,,"NA","NA"]],MD:[,[,,"[235-9]\\d{7}","\\d{8}"],[,,"(?:2(?:1[0569]|2\\d|3[015-7]|4[1-46-9]|5[0-24689]|6[2-589]|7[1-37]|9[1347-9])|5(?:33|5[257]))\\d{5}","\\d{8}",,,"22212345"],[,,"(?:562|6(?:50|7[1-6]|[089]\\d)|7(?:67|7[457-9]|[89]\\d))\\d{5}","\\d{8}",,,"65012345"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"90[056]\\d{5}","\\d{8}",,,"90012345"],[,,"808\\d{5}",
	"\\d{8}",,,"80812345"],[,,"NA","NA"],[,,"3[08]\\d{6}","\\d{8}",,,"30123456"],"MD",373,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1","",0],[,"([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-79]|[5-7]"],"0$1","",0],[,"([89]\\d{2})(\\d{5})","$1 $2",["[89]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"8(?:03|14)\\d{5}","\\d{8}",,,"80312345"],,,[,,"NA","NA"]],ME:[,[,,"[2-9]\\d{7,8}","\\d{6,9}"],[,,"(?:20[2-8]|3(?:0[2-7]|1[35-7]|2[3567]|3[4-7])|4(?:0[237]|1[27])|5(?:0[47]|1[27]|2[378]))\\d{5}",
	"\\d{6,8}",,,"30234567"],[,,"6(?:32\\d|[89]\\d{2}|7(?:[0-8]\\d|9(?:[3-9]|[0-2]\\d)))\\d{4}","\\d{8,9}",,,"67622901"],[,,"800[28]\\d{4}","\\d{8}",,,"80080002"],[,,"(?:88\\d|9(?:4[13-8]|5[16-8]))\\d{5}","\\d{8}",,,"94515151"],[,,"NA","NA"],[,,"NA","NA"],[,,"78[1-9]\\d{5}","\\d{8}",,,"78108780"],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[3789]","[2-57-9]|6(?:[389]|7(?:[0-8]|9[3-9]))"],"0$1","",0],[,"(67)(9)(\\d{3})(\\d{3})","$1 $2 $3 $4",["679","679[0-2]"],"0$1",
	"",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"77\\d{6}","\\d{8}",,,"77273012"],,,[,,"NA","NA"]],MF:[,[,,"[56]\\d{8}","\\d{9}"],[,,"590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}","\\d{9}",,,"590271234"],[,,"690(?:0[0-7]|[1-9]\\d)\\d{4}","\\d{9}",,,"690301234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MF",590,"00","0",,,"0",,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MG:[,[,,"[23]\\d{8}","\\d{7,9}"],[,,"20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}",
	"\\d{7,9}",,,"202123456"],[,,"3[2-49]\\d{7}","\\d{9}",,,"321234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"22\\d{7}","\\d{9}",,,"221234567"],"MG",261,"00","0",,,"0",,,,[[,"([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MH:[,[,,"[2-6]\\d{6}","\\d{7}"],[,,"(?:247|528|625)\\d{4}","\\d{7}",,,"2471234"],[,,"(?:235|329|45[56]|545)\\d{4}","\\d{7}",,,"2351234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,
	"NA","NA"],[,,"635\\d{4}","\\d{7}",,,"6351234"],"MH",692,"011","1",,,"1",,,,[[,"(\\d{3})(\\d{4})","$1-$2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MK:[,[,,"[2-578]\\d{7}","\\d{8}"],[,,"(?:2(?:[23]\\d|5[124578]|6[01])|3(?:1[3-6]|[23][2-6]|4[2356])|4(?:[23][2-6]|4[3-6]|5[256]|6[25-8]|7[24-6]|8[4-6]))\\d{5}","\\d{6,8}",,,"22212345"],[,,"7(?:[0-25-8]\\d{2}|32\\d|421)\\d{4}","\\d{8}",,,"72345678"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"5[02-9]\\d{6}","\\d{8}",,,"50012345"],
	[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}","\\d{8}",,,"80123456"],[,,"NA","NA"],[,,"NA","NA"],"MK",389,"00","0",,,"0",,,,[[,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1","",0],[,"([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1","",0],[,"([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ML:[,[,,"[246-9]\\d{7}","\\d{8}"],[,,"(?:2(?:0(?:2[0-589]|7\\d)|1(?:2[5-7]|[3-689]\\d|7[2-4689]))|44[239]\\d)\\d{4}","\\d{8}",,,"20212345"],
	[,,"[67]\\d{7}|9[0-25-9]\\d{6}","\\d{8}",,,"65012345"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ML",223,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"],"","",0],[,"(\\d{4})","$1",["67|74"],"","",0]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]","[246-9]"],"","",0]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MM:[,[,,"[14578]\\d{5,7}|[26]\\d{5,8}|9(?:2\\d{0,2}|[58]|3\\d|4\\d{1,2}|[679]\\d?)\\d{6}",
	"\\d{5,10}"],[,,"1(?:2\\d{1,2}|[3-5]\\d|6\\d?|[89][0-6]\\d)\\d{4}|2(?:[236-9]\\d{4}|4(?:0\\d{5}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5}))|4(?:2[245-8]|[346][2-6]|5[3-5])\\d{4}|5(?:2(?:20?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7(?:[2367]|4\\d|5\\d?|8[145]\\d)|8[245]|9[24])\\d{4}|7(?:[04][24-8]|[15][2-7]|22|3[2-4])\\d{4}|8(?:1(?:2\\d?|[3-689])|2[2-8]|3[24]|4[24-7]|5[245]|6[23])\\d{4}","\\d{5,9}",,,"1234567"],[,,"17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2})|3[136]\\d|4(?:0[0-4]\\d|[1379]\\d|[24][0-589]\\d|5\\d{2}|88)|5[0-6]|61?\\d|73\\d|8\\d|9(?:1\\d|[089]))\\d{5}",
	"\\d{7,10}",,,"92123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"1333\\d{4}","\\d{8}",,,"13331234"],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[45]"],"0$1","",0],[,"(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"],"0$1","",0],[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["67|81"],"0$1","",0],[,"(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"],"0$1","",0],[,"(9)(\\d{3})(\\d{4,5})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[13789])"],
	"0$1","",0],[,"(9)(4\\d{4})(\\d{4})","$1 $2 $3",["94[0245]"],"0$1","",0],[,"(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["925"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MN:[,[,,"[12]\\d{7,9}|[57-9]\\d{7}","\\d{6,10}"],[,,"[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}","\\d{6,10}",,,"50123456"],[,,"(?:8[89]|9[013-9])\\d{6}","\\d{8}",,,"88123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"7[05-8]\\d{6}",
	"\\d{8}",,,"75123456"],"MN",976,"001","0",,,"0",,,,[[,"([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1","",0],[,"([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1","",0],[,"([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"],"0$1","",0],[,"(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1","",0],[,"([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MO:[,[,,"[268]\\d{7}","\\d{8}"],
	[,,"(?:28[2-57-9]|8[2-57-9]\\d)\\d{5}","\\d{8}",,,"28212345"],[,,"6[236]\\d{6}","\\d{8}",,,"66123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MO",853,"00",,,,,,,,[[,"([268]\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MP:[,[,,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}","\\d{7}(?:\\d{3})?",,,"6702345678"],[,,"670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[589]|8[3-9]8|989)\\d{4}",
	"\\d{7}(?:\\d{3})?",,,"6702345678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"MP",1,"011","1",,,"1",,,1,,,[,,"NA","NA"],,"670",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MQ:[,[,,"[56]\\d{8}","\\d{9}"],[,,"596(?:0[2-5]|[12]0|3[05-9]|4[024-8]|[5-7]\\d|89|9[4-8])\\d{4}","\\d{9}",,,"596301234"],[,,"696(?:[0-479]\\d|5[01]|8[0-689])\\d{4}","\\d{9}",
	,,"696201234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MQ",596,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MR:[,[,,"[2-48]\\d{7}","\\d{8}"],[,,"25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}","\\d{8}",,,"35123456"],[,,"(?:2(?:2\\d|70)|3(?:3\\d|6[1-36]|7[1-3])|4(?:4\\d|6[0457-9]|7[4-9]|8[01346-8]))\\d{5}","\\d{8}",,,"22123456"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"NA","NA"],
	[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MR",222,"00",,,,,,,,[[,"([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MS:[,[,,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"664491\\d{4}","\\d{7}(?:\\d{3})?",,,"6644912345"],[,,"66449[2-6]\\d{4}","\\d{10}",,,"6644923456"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",
	,,"5002345678"],[,,"NA","NA"],"MS",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"664",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MT:[,[,,"[2357-9]\\d{7}","\\d{8}"],[,,"2(?:0(?:1[0-6]|3[1-4]|[69]\\d)|[1-357]\\d{2})\\d{4}","\\d{8}",,,"21001234"],[,,"(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|696|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}","\\d{8}",,,"96961234"],[,,"800[3467]\\d{4}","\\d{8}",,,"80071234"],[,,"5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168])|[12]\\d0[1-5])\\d{3}","\\d{8}",,,"50037123"],[,,"NA","NA"],[,,"NA",
	"NA"],[,,"3550\\d{4}","\\d{8}",,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",,"","",0]],,[,,"7117\\d{4}","\\d{8}",,,"71171234"],,,[,,"NA","NA"],[,,"501\\d{5}","\\d{8}",,,"50112345"],,,[,,"NA","NA"]],MU:[,[,,"[2-9]\\d{6,7}","\\d{7,8}"],[,,"(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}","\\d{7,8}",,,"2012345"],[,,"5(?:2[59]\\d|4(?:2[1-389]|4\\d|7[1-9]|9\\d)|7\\d{2}|8(?:[256]\\d|7[15-8])|9[0-8]\\d)\\d{4}","\\d{8}",,,"52512345"],
	[,,"80[012]\\d{4}","\\d{7}",,,"8001234"],[,,"30\\d{5}","\\d{7}",,,"3012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"3(?:20|9\\d)\\d{4}","\\d{7}",,,"3201234"],"MU",230,"0(?:0|[2-7]0|33)",,,,,,"020",,[[,"([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"],"","",0],[,"(5\\d{3})(\\d{4})","$1 $2",["5"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MV:[,[,,"[3467]\\d{6}|9(?:00\\d{7}|\\d{6})","\\d{7,10}"],[,,"(?:3(?:0[01]|3[0-59])|6(?:[567][02468]|8[024689]|90))\\d{4}","\\d{7}",,,"6701234"],
	[,,"(?:46[46]|7[3-9]\\d|9[16-9]\\d)\\d{4}","\\d{7}",,,"7712345"],[,,"NA","NA"],[,,"900\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:[1-9]|0[1-9])"],"","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["900"],"","",0]],,[,,"781\\d{4}","\\d{7}",,,"7812345"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MW:[,[,,"(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}","\\d{7,9}"],[,,"(?:1[2-9]|21\\d{2})\\d{5}","\\d{7,9}",
	,,"1234567"],[,,"(?:111|77\\d|88\\d|99\\d)\\d{6}","\\d{9}",,,"991234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"],"0$1","",0],[,"(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1789]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MX:[,[,,"[1-9]\\d{9,10}","\\d{7,11}"],[,,"(?:33|55|81)\\d{8}|(?:2(?:2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}",
	"\\d{7,10}",,,"2221234567"],[,,"1(?:(?:33|55|81)\\d{8}|(?:2(?:2[2-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})","\\d{11}",,,"12221234567"],[,,"800\\d{7}",
	"\\d{10}",,,"8001234567"],[,,"900\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"MX",52,"0[09]","01",,,"0[12]|04[45](\\d{10})","1$1",,,[[,"([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"],"01 $1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[12457-9]|5[89]|8[02-9]|9[0-35-9]"],"01 $1","",1],[,"(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1","",1],[,"(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[12457-9]|5[89]|8[2-9]|9[1-35-9])"],
	"$1","",1]],[[,"([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81","33|55|81"],"01 $1","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[12457-9]|5[89]|8[02-9]|9[0-35-9]","[2467]|3[12457-9]|5[89]|8[02-9]|9[0-35-9]"],"01 $1","",1],[,"(1)([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3 $4",["1(?:33|55|81)"]],[,"(1)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1(?:[2467]|3[12457-9]|5[89]|8[2-9]|9[1-35-9])"]]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],MY:[,[,,"[13-9]\\d{7,9}","\\d{6,10}"],
	[,,"(?:3[2-9]\\d|[4-9][2-9])\\d{6}","\\d{6,9}",,,"323456789"],[,,"1(?:1[1-3]\\d{2}|[02-4679][2-9]\\d|59\\d{2}|8(?:1[23]|[2-9]\\d))\\d{5}","\\d{9,10}",,,"123456789"],[,,"1[378]00\\d{6}","\\d{10}",,,"1300123456"],[,,"1600\\d{6}","\\d{10}",,,"1600123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"154\\d{7}","\\d{10}",,,"1541234567"],"MY",60,"00","0",,,"0",,,,[[,"([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1","",0],[,"(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1","",0],[,"([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",
	["1[02-46-9][1-9]|8"],"0$1","",0],[,"(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0"],"","",0],[,"(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1","",0],[,"(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],MZ:[,[,,"[28]\\d{7,8}","\\d{8,9}"],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}","\\d{8}",,,"21123456"],[,,"8[246]\\d{7}","\\d{9}",,,"821234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA",
	"NA"],[,,"NA","NA"],"MZ",258,"00",,,,,,,,[[,"([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[246]"],"","",0],[,"(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NA:[,[,,"[68]\\d{7,8}","\\d{8,9}"],[,,"6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4[01]|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[29]|7[01]|81)|4(?:17|2(?:[012]|7?)|4(?:[06]|1\\d)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|69|7[01]))\\d{4}",
	"\\d{8,9}",,,"61221234"],[,,"(?:60|8[125])\\d{7}","\\d{9}",,,"811234567"],[,,"NA","NA"],[,,"8701\\d{5}","\\d{9}",,,"870123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"8(3\\d{2}|86)\\d{5}","\\d{8,9}",,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1235]"],"0$1","",0],[,"(6\\d)(\\d{2,3})(\\d{4})","$1 $2 $3",["6"],"0$1","",0],[,"(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1","",0],[,"(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,
	"NA","NA"],,,[,,"NA","NA"]],NC:[,[,,"[2-57-9]\\d{5}","\\d{6}"],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}","\\d{6}",,,"201234"],[,,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}","\\d{6}",,,"751234"],[,,"NA","NA"],[,,"36\\d{4}","\\d{6}",,,"366711"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NC",687,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NE:[,[,,"[0289]\\d{7}","\\d{8}"],[,,"2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
	"\\d{8}",,,"20201234"],[,,"(?:89|9[0-46-9])\\d{6}","\\d{8}",,,"93123456"],[,,"08\\d{6}","\\d{8}",,,"08123456"],[,,"09\\d{6}","\\d{8}",,,"09123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[289]|09"],"","",0],[,"(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],NF:[,[,,"[13]\\d{5}","\\d{5,6}"],[,,"(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}","\\d{5,6}",,,"106609"],[,
	,"38\\d{4}","\\d{5,6}",,,"381234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NF",672,"00",,,,,,,,[[,"(\\d{2})(\\d{4})","$1 $2",["1"],"","",0],[,"(\\d)(\\d{5})","$1 $2",["3"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NG:[,[,,"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}","\\d{5,14}"],[,,"[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}","\\d{5,9}",
	,,"12345678"],[,,"(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70(?:[13-9]\\d|2[1-9])|8(?:0[2-9]|1\\d)\\d|90[39]\\d)\\d{6}","\\d{8,10}",,,"8021234567"],
	[,,"800\\d{7,11}","\\d{10,14}",,,"80017591759"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NG",234,"009","0",,,"0",,,,[[,"([129])(\\d{3})(\\d{3,4})","$1 $2 $3",["[129]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[39]"],"0$1","",0],[,"([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"],"0$1","",0],[,"([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"],"0$1","",0],[,"(78)(\\d{2})(\\d{3})",
	"$1 $2 $3",["78"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"700\\d{7,11}","\\d{10,14}",,,"7001234567"],,,[,,"NA","NA"]],NI:[,[,,"[12578]\\d{7}","\\d{8}"],[,,"2\\d{7}","\\d{8}",,,"21234567"],[,,"5(?:500\\d{4}|7\\d{6})|78\\d{6}|8\\d{7}","\\d{8}",,,"81234567"],[,,"1800\\d{4}","\\d{8}",,,"18001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NL:[,[,,"1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",
	"\\d{5,10}"],[,,"(?:1[0135-8]|2[02-69]|3[0-68]|4[0135-9]|[57]\\d|8[478])\\d{7}","\\d{9}",,,"101234567"],[,,"6[1-58]\\d{7}","\\d{9}",,,"612345678"],[,,"800\\d{4,7}","\\d{7,10}",,,"8001234"],[,,"90[069]\\d{4,7}","\\d{7,10}",,,"9061234"],[,,"NA","NA"],[,,"NA","NA"],[,,"85\\d{7}","\\d{9}",,,"851234567"],"NL",31,"00","0",,,"0",,,,[[,"([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"],"0$1","",0],[,"([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
	"0$1","",0],[,"(6)(\\d{8})","$1 $2",["6[0-57-9]"],"0$1","",0],[,"(66)(\\d{7})","$1 $2",["66"],"0$1","",0],[,"(14)(\\d{3,4})","$1 $2",["14"],"$1","",0],[,"([89]0\\d)(\\d{4,7})","$1 $2",["80|9"],"0$1","",0]],,[,,"66\\d{7}","\\d{9}",,,"662345678"],,,[,,"14\\d{3,4}","\\d{5,6}"],[,,"140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])","\\d{5,6}",,,"14020"],,,[,,"NA","NA"]],NO:[,[,,"0\\d{4}|[2-9]\\d{7}","\\d{5}(?:\\d{3})?"],[,
	,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","\\d{8}",,,"21234567"],[,,"(?:4[015-8]|5[89]|9\\d)\\d{6}","\\d{8}",,,"41234567"],[,,"80[01]\\d{5}","\\d{8}",,,"80012345"],[,,"82[09]\\d{5}","\\d{8}",,,"82012345"],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}","\\d{8}",,,"81021234"],[,,"880\\d{5}","\\d{8}",,,"88012345"],[,,"85[0-5]\\d{5}","\\d{8}",,,"85012345"],"NO",47,"00",,,,,,,,[[,"([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"],"","",0],[,"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"],
	"","",0]],,[,,"NA","NA"],1,,[,,"NA","NA"],[,,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}","\\d{5}(?:\\d{3})?",,,"01234"],1,,[,,"81[23]\\d{5}","\\d{8}",,,"81212345"]],NP:[,[,,"[1-8]\\d{7}|9(?:[1-69]\\d{6}|7[2-6]\\d{5,7}|8\\d{8})","\\d{6,10}"],[,,"(?:1[0124-6]|2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-79])\\d{6}","\\d{6,8}",,,"14567890"],[,,"9(?:7[45]|8[01456])\\d{7}","\\d{10}",,,"9841234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NP",977,"00",
	"0",,,"0",,,,[[,"(1)(\\d{7})","$1-$2",["1[2-6]"],"0$1","",0],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"],"0$1","",0],[,"(9\\d{2})(\\d{7})","$1-$2",["9(?:7[45]|8)"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NR:[,[,,"[458]\\d{6}","\\d{7}"],[,,"(?:444|888)\\d{4}","\\d{7}",,,"4441234"],[,,"55[5-9]\\d{4}","\\d{7}",,,"5551234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"",
	"",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NU:[,[,,"[1-5]\\d{3}","\\d{4}"],[,,"[34]\\d{3}","\\d{4}",,,"4002"],[,,"[125]\\d{3}","\\d{4}",,,"1234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NU",683,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],NZ:[,[,,"6[235-9]\\d{6}|[2-57-9]\\d{7,10}","\\d{7,11}"],[,,"(?:3[2-79]|[49][2-689]|6[235-9]|7[2-5789])\\d{6}|24099\\d{3}","\\d{7,8}",,,"32345678"],[,,"2(?:[028]\\d{7,8}|1(?:[03]\\d{5,7}|[12457]\\d{5,6}|[689]\\d{5})|[79]\\d{7})",
	"\\d{8,10}",,,"211234567"],[,,"508\\d{6,7}|80\\d{6,8}","\\d{8,10}",,,"800123456"],[,,"90\\d{7,9}","\\d{9,11}",,,"900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"([34679])(\\d{3})(\\d{4})","$1-$2 $3",["[3467]|9[1-9]"],"0$1","",0],[,"(24099)(\\d{3})","$1 $2",["240","2409","24099"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|86"],"0$1","",0],[,"(2\\d)(\\d{3,4})(\\d{4})",
	"$1 $2 $3",["2[028]"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"],"0$1","",0]],,[,,"[28]6\\d{6,7}","\\d{8,9}",,,"26123456"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],OM:[,[,,"(?:2[2-6]|5|9[1-9])\\d{6}|800\\d{5,6}","\\d{7,9}"],[,,"2[2-6]\\d{6}","\\d{8}",,,"23123456"],[,,"9[1-9]\\d{6}","\\d{8}",,,"92123456"],[,,"8007\\d{4,5}|500\\d{4}","\\d{7,9}",,,"80071234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"OM",968,"00",,,,,,,,[[,"(2\\d)(\\d{6})","$1 $2",
	["2"],"","",0],[,"(9\\d{3})(\\d{4})","$1 $2",["9"],"","",0],[,"([58]00)(\\d{4,6})","$1 $2",["[58]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PA:[,[,,"[1-9]\\d{6,7}","\\d{7,8}"],[,,"(?:1(?:0[02-579]|19|2[37]|3[03]|4[479]|57|65|7[016-8]|8[58]|9[1349])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[09]\\d|1[14-7]|2[0-3]|3[03]|4[0457]|5[56]|6[068]|7[06-8]|8[089])|4(?:3[013-69]|4\\d|7[0-689])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[49]0|5[06-9]|7[0-24-7]|8[89])|8(?:[34]\\d|5[0-4]|8[02])|9(?:0[6-8]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}",
	"\\d{7}",,,"2001234"],[,,"(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[04-9])\\d{5}","\\d{7,8}",,,"60012345"],[,,"80[09]\\d{4}","\\d{7}",,,"8001234"],[,,"(?:779|8(?:2[235]|55|60|7[578]|86|95)|9(?:0[0-2]|81))\\d{4}","\\d{7}",,,"8601234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"],"","",0],[,"(\\d{4})(\\d{4})","$1-$2",["6"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PE:[,[,,"[14-9]\\d{7,8}",
	"\\d{6,9}"],[,,"(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}","\\d{6,8}",,,"11234567"],[,,"9\\d{8}","\\d{9}",,,"912345678"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"805\\d{5}","\\d{8}",,,"80512345"],[,,"801\\d{5}","\\d{8}",,,"80112345"],[,,"80[24]\\d{5}","\\d{8}",,,"80212345"],[,,"NA","NA"],"PE",51,"19(?:1[124]|77|90)00","0"," Anexo ",,"0",,,,[[,"(1)(\\d{7})","$1 $2",["1"],"(0$1)","",0],[,"([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"],"(0$1)","",0],[,"(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)",
	"",0],[,"(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PF:[,[,,"[2-79]\\d{5}|8\\d{5,7}","\\d{6}(?:\\d{2})?"],[,,"(?:4(?:[02-9]\\d|1[02-9])|[5689]\\d{2})\\d{3}","\\d{6}",,,"401234"],[,,"(?:[27]\\d{2}|3[0-79]\\d|411|89\\d{3})\\d{3}","\\d{6}(?:\\d{2})?",,,"212345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"PF",689,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["89"],"","",0],[,"(\\d{2})(\\d{2})(\\d{2})",
	"$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"44\\d{4}","\\d{6}",,,"441234"],[,,"NA","NA"],,,[,,"NA","NA"]],PG:[,[,,"[1-9]\\d{6,7}","\\d{7,8}"],[,,"(?:3[0-2]\\d|4[25]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}","\\d{7}",,,"3123456"],[,,"(?:68|7(?:[0-369]\\d|75))\\d{5}","\\d{7,8}",,,"6812345"],[,,"180\\d{4}","\\d{7}",,,"1801234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"275\\d{4}","\\d{7}",,,"2751234"],"PG",675,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-689]"],"","",0],
	[,"(7\\d{3})(\\d{4})","$1 $2",["7"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PH:[,[,,"2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}","\\d{5,13}"],[,,"2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})","\\d{5,10}",,,"21234567"],[,,"(?:81[37]|9(?:0[5-9]|1[025-9]|2[0-35-9]|3[02-9]|4[236-9]|7[3479]|89|9[46-9]))\\d{7}","\\d{10}",,,"9051234567"],[,,"1800\\d{7,9}","\\d{11,13}",,,"180012345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],
	[,,"NA","NA"],"PH",63,"00","0",,,"0",,,,[[,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)","",0],[,"(2)(\\d{5})","$1 $2",["2"],"(0$1)","",0],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)","",0],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)","",0],[,"([3-8]\\d)(\\d{3})(\\d{4})",
	"$1 $2 $3",["[3-8]"],"(0$1)","",0],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1","",0],[,"(1800)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"","",0],[,"(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PK:[,[,,"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))","\\d{6,12}"],[,,"(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}",
	"\\d{6,10}",,,"2123456789"],[,,"3(?:0\\d|[12][0-5]|[34][1-7]|55|64)\\d{7}","\\d{10}",,,"3012345678"],[,,"800\\d{5}","\\d{8}",,,"80012345"],[,,"900\\d{5}","\\d{8}",,,"90012345"],[,,"NA","NA"],[,,"122\\d{6}","\\d{9}",,,"122044444"],[,,"NA","NA"],"PK",92,"00","0",,,"0",,,,[[,"(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"],"(0$1)",
	"",0],[,"(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"],"(0$1)","",0],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)","",0],[,"(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d[2-9]"],"(0$1)","",0],[,"(3\\d{2})(\\d{7})","$1 $2",
	["3"],"0$1","",0],[,"([15]\\d{3})(\\d{5,6})","$1 $2",["58[12]|1"],"(0$1)","",0],[,"(586\\d{2})(\\d{5})","$1 $2",["586"],"(0$1)","",0],[,"([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}","\\d{11,12}",,,"21111825888"],,,[,,"NA","NA"]],PL:[,[,,"[1-58]\\d{6,8}|9\\d{8}|[67]\\d{5,8}",
	"\\d{6,9}"],[,,"(?:1[2-8]|2[2-59]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-6]|8[1-7])\\d{5,7}|77\\d{4,7}|(?:89|9[145])\\d{7}","\\d{6,9}",,,"123456789"],[,,"(?:5[0137]|6[069]|7[2389]|88)\\d{7}","\\d{9}",,,"512345678"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"70\\d{7}","\\d{9}",,,"701234567"],[,,"801\\d{6}","\\d{9}",,,"801234567"],[,,"NA","NA"],[,,"39\\d{7}","\\d{9}",,,"391234567"],"PL",48,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[124]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"],
	"","",0],[,"(\\d{2})(\\d{4,6})","$1 $2",["[124]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-7]"],"","",0],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|5[0137]|6[0469]|7[02389]|8[08]"],"","",0],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"],"","",0],[,"(\\d{3})(\\d{3})","$1 $2",["64"],"","",0]],,[,,"642\\d{3,6}","\\d{6,9}",,,"642123456"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PM:[,[,,"[45]\\d{5}","\\d{6}"],[,,"41\\d{4}","\\d{6}",,,"411234"],[,,"55\\d{4}","\\d{6}",,,"551234"],[,,"NA","NA"],[,,
	"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"PM",508,"00","0",,,"0",,,,[[,"([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PR:[,[,,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"(?:787|939)[2-9]\\d{6}","\\d{7}(?:\\d{3})?",,,"7872345678"],[,,"(?:787|939)[2-9]\\d{6}","\\d{7}(?:\\d{3})?",,,"7872345678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}",
	"\\d{10}",,,"5002345678"],[,,"NA","NA"],"PR",1,"011","1",,,"1",,,1,,,[,,"NA","NA"],,"787|939",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PS:[,[,,"[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})","\\d{4,10}"],[,,"(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}","\\d{7,8}",,,"22234567"],[,,"5[69]\\d{7}","\\d{9}",,,"599123456"],[,,"1800\\d{6}","\\d{10}",,,"1800123456"],[,,"1(?:4|9\\d)\\d{2}","\\d{4,5}",,,"19123"],[,,"1700\\d{6}","\\d{10}",,,"1700123456"],[,,"NA","NA"],[,,"NA","NA"],"PS",970,"00","0",,,
	"0",,,,[[,"([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]"],"0$1","",0],[,"(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1","",0],[,"(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]"],"$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PT:[,[,,"[2-46-9]\\d{8}","\\d{9}"],[,,"2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}","\\d{9}",,,"212345678"],[,,"9(?:[136]\\d{2}|2[0-79]\\d|480)\\d{5}","\\d{9}",,,"912345678"],[,,"80[02]\\d{6}","\\d{9}",,,"800123456"],
	[,,"76(?:0[1-57]|1[2-47]|2[237])\\d{5}","\\d{9}",,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}","\\d{9}",,,"808123456"],[,,"884[128]\\d{5}","\\d{9}",,,"884123456"],[,,"30\\d{7}","\\d{9}",,,"301234567"],"PT",351,"00",,,,,,,,[[,"(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"],"","",0],[,"([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"70(?:7\\d|8[17])\\d{5}","\\d{9}",,,"707123456"],,,[,,"NA","NA"]],PW:[,[,,"[2-8]\\d{6}","\\d{7}"],[,,"2552255|(?:277|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76))\\d{4}",
	"\\d{7}",,,"2771234"],[,,"(?:6[234689]0|77[45789])\\d{4}","\\d{7}",,,"6201234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],PY:[,[,,"5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}","\\d{5,9}"],[,,"(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}",
	"\\d{5,9}",,,"212345678"],[,,"9(?:6[12]|[78][1-6]|9[1-5])\\d{6}","\\d{9}",,,"961456789"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"8700[0-4]\\d{4}","\\d{9}",,,"870012345"],"PY",595,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"],"($1)","",0],[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1","",0],[,"(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8700"],"","",0],[,"(\\d{3})(\\d{4,6})","$1 $2",
	["[2-8][1-9]"],"($1)","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"[2-9]0\\d{4,7}","\\d{6,9}",,,"201234567"],,,[,,"NA","NA"]],QA:[,[,,"[2-8]\\d{6,7}","\\d{7,8}"],[,,"4[04]\\d{6}","\\d{7,8}",,,"44123456"],[,,"[3567]\\d{7}","\\d{7,8}",,,"33123456"],[,,"800\\d{4}","\\d{7,8}",,,"8001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"QA",974,"00",,,,,,,,[[,"([28]\\d{2})(\\d{4})","$1 $2",["[28]"],"","",0],[,"([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"],"","",0]],,[,,"2(?:[12]\\d|61)\\d{4}","\\d{7}",
	,,"2123456"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],RE:[,[,,"[268]\\d{8}","\\d{9}"],[,,"262\\d{6}","\\d{9}",,,"262161234"],[,,"6(?:9[23]|47)\\d{6}","\\d{9}",,,"692123456"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"89[1-37-9]\\d{6}","\\d{9}",,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}","\\d{9}",,,"810123456"],[,,"NA","NA"],[,,"NA","NA"],"RE",262,"00","0",,,"0",,,,[[,"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"0$1","",0]],,[,,"NA","NA"],1,"262|6[49]|8",[,,"NA","NA"],[,,"NA",
	"NA"],,,[,,"NA","NA"]],RO:[,[,,"2\\d{5,8}|[37-9]\\d{8}","\\d{6,9}"],[,,"2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3[13-6]\\d{7}","\\d{6,9}",,,"211234567"],[,,"7(?:000|[1-8]\\d{2}|99\\d)\\d{5}","\\d{9}",,,"712345678"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"90[036]\\d{6}","\\d{9}",,,"900123456"],[,,"801\\d{6}","\\d{9}",,,"801123456"],[,,"802\\d{6}","\\d{9}",,,"802123456"],[,,"NA","NA"],"RO",40,"00","0"," int ",,"0",,,,[[,"([237]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1","",0],[,
	"(21)(\\d{4})","$1 $2",["21"],"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"],"0$1","",0],[,"(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"37\\d{7}","\\d{9}",,,"372123456"],,,[,,"NA","NA"]],RS:[,[,,"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})","\\d{5,12}"],[,,"(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}","\\d{5,12}",,,"10234567"],[,,"6(?:[0-689]|7\\d)\\d{6,7}",
	"\\d{8,10}",,,"601234567"],[,,"800\\d{3,9}","\\d{6,12}",,,"80012345"],[,,"(?:90[0169]|78\\d)\\d{3,7}","\\d{6,12}",,,"90012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"RS",381,"00","0",,,"0",,,,[[,"([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"],"0$1","",0],[,"([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"],"0$1","",0],[,"(6\\d)(\\d{6,8})","$1 $2",["6"],"0$1","",0],[,"([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"],"0$1","",0],[,"(7[26])(\\d{4,9})","$1 $2",["7[26]"],
	"0$1","",0],[,"(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"7[06]\\d{4,10}","\\d{6,12}",,,"700123456"],,,[,,"NA","NA"]],RU:[,[,,"[3489]\\d{9}","\\d{10}"],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-7]|7[1-37-9]))\\d{7}","\\d{10}",,,"3011234567"],[,,"9\\d{9}","\\d{10}",,,"9123456789"],[,,"80[04]\\d{7}","\\d{10}",,,"8001234567"],[,,"80[39]\\d{7}","\\d{10}",
	,,"8091234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[1-79]"],"$1","",1],[,"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]"],"8 ($1)","",1],[,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)","",1]],[[,"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[34689]","[34689]"],"8 ($1)","",1],[,"(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7","7"],"8 ($1)","",1]],[,,"NA","NA"],1,,[,,"NA","NA"],[,,"NA",
	"NA"],,,[,,"NA","NA"]],RW:[,[,,"[027-9]\\d{7,8}","\\d{8,9}"],[,,"2[258]\\d{7}|06\\d{6}","\\d{8,9}",,,"250123456"],[,,"7[238]\\d{7}","\\d{9}",,,"720123456"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"900\\d{6}","\\d{9}",,,"900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"RW",250,"00","0",,,"0",,,,[[,"(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"$1","",0],[,"([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1","",0],[,"(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"],"","",0]],,[,,"NA",
	"NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],SA:[,[,,"1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}","\\d{7,10}"],[,,"11\\d{7}|1?(?:2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}","\\d{7,9}",,,"112345678"],[,,"(?:5[013-689]|811)\\d{7}","\\d{9,10}",,,"512345678"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"NA","NA"],[,,"92[05]\\d{6}","\\d{9}",,,"920012345"],[,,"NA","NA"],[,,"NA","NA"],"SA",966,"00","0",,,"0",,,,[[,"([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"],"0$1","",0],[,"(1\\d)(\\d{3})(\\d{4})",
	"$1 $2 $3",["1[1-467]"],"0$1","",0],[,"(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1","",0],[,"(92\\d{2})(\\d{5})","$1 $2",["92"],"$1","",0],[,"(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"$1","",0],[,"(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SB:[,[,,"[1-9]\\d{4,6}","\\d{5,7}"],[,,"(?:1[4-79]|[23]\\d|4[01]|5[03]|6[0-37])\\d{3}","\\d{5}",,,"40123"],[,,"48\\d{3}|7(?:[46-8]\\d|5[025-9]|90)\\d{4}|8[4-8]\\d{5}|9(?:[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}",
	"\\d{5,7}",,,"7421234"],[,,"1[38]\\d{3}","\\d{5}",,,"18123"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"5[12]\\d{3}","\\d{5}",,,"51123"],"SB",677,"0[01]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[7-9]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SC:[,[,,"[24689]\\d{5,6}","\\d{6,7}"],[,,"4[2-46]\\d{5}","\\d{7}",,,"4217123"],[,,"2[5-8]\\d{5}","\\d{7}",,,"2510123"],[,,"8000\\d{2}","\\d{6}",,,"800000"],[,,"98\\d{4}","\\d{6}",,,"981234"],[,,"NA","NA"],[,,"NA","NA"],[,,"64\\d{5}",
	"\\d{7}",,,"6412345"],"SC",248,"0[0-2]",,,,,,"00",,[[,"(\\d{3})(\\d{3})","$1 $2",["[89]"],"","",0],[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SD:[,[,,"[19]\\d{8}","\\d{9}"],[,,"1(?:[125]\\d|8[3567])\\d{6}","\\d{9}",,,"121231234"],[,,"9[012569]\\d{7}","\\d{9}",,,"911231234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",,"0$1","",0]],
	,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SE:[,[,,"[1-9]\\d{5,9}","\\d{5,10}"],[,,"1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:0[1-9]\\d{4,6}|[246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:0[1-9]\\d{4,6}|3\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8[1-9]\\d{5,7}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})",
	"\\d{5,9}",,,"8123456"],[,,"7[0236]\\d{7}","\\d{9}",,,"701234567"],[,,"20(?:0(?:0\\d{2}|[1-9](?:0\\d{1,4}|[1-9]\\d{4}))|1(?:0\\d{4}|[1-9]\\d{4,5})|[2-9]\\d{5})","\\d{6,9}",,,"20123456"],[,,"9(?:00|39|44)(?:1(?:[0-26]\\d{5}|[3-57-9]\\d{2})|2(?:[0-2]\\d{5}|[3-9]\\d{2})|3(?:[0139]\\d{5}|[24-8]\\d{2})|4(?:[045]\\d{5}|[1-36-9]\\d{2})|5(?:5\\d{5}|[0-46-9]\\d{2})|6(?:[679]\\d{5}|[0-58]\\d{2})|7(?:[078]\\d{5}|[1-69]\\d{2})|8(?:[578]\\d{5}|[0-469]\\d{2}))","\\d{7}(?:\\d{3})?",,,"9001234567"],[,,"77(?:0(?:0\\d{2}|[1-9](?:0\\d|[1-9]\\d{4}))|[1-6][1-9]\\d{5})",
	"\\d{6}(?:\\d{3})?",,,"771234567"],[,,"75[1-8]\\d{6}","\\d{9}",,,"751234567"],[,,"NA","NA"],"SE",46,"00","0",,,"0",,,,[[,"(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1","",0],[,"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],"0$1","",0],[,"([1-69]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["1[13689]|2[136]|3[1356]|4[0246]|54|6[03]|90"],"0$1","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2[2457-9]|3[0247-9]|4[1357-9]|5[0-35-9]|6[124-9]|9(?:[125-8]|3[0-5]|4[0-3])"],
	"0$1","",0],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2[2457-9]|3[0247-9]|4[1357-9]|5[0-35-9]|6[124-9]|9(?:[125-8]|3[0-5]|4[0-3])"],"0$1","",0],[,"(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],"0$1","",0],[,"(77)(\\d{2})(\\d{2})","$1-$2$3",["7"],"0$1","",0],[,"(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1","",0],[,"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],"0$1","",0],[,"(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],"0$1","",0]],[[,"(8)(\\d{2,3})(\\d{2,3})(\\d{2})",
	"$1 $2 $3 $4",["8"]],[,"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]],[,"([1-69]\\d)(\\d{3})(\\d{2})","$1 $2 $3",["1[13689]|2[136]|3[1356]|4[0246]|54|6[03]|90"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2457]|2[2457-9]|3[0247-9]|4[1357-9]|5[0-35-9]|6[124-9]|9(?:[125-8]|3[0-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2[2457-9]|3[0247-9]|4[1357-9]|5[0-35-9]|6[124-9]|9(?:[125-8]|3[0-5]|4[0-3])"]],[,"(7\\d)(\\d{3})(\\d{2})(\\d{2})",
	"$1 $2 $3 $4",["7"]],[,"(77)(\\d{2})(\\d{2})","$1 $2 $3",["7"]],[,"(20)(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9[034]"]],[,"(9[034]\\d)(\\d{4})","$1 $2",["9[034]"]]],[,,"74[02-9]\\d{6}","\\d{9}",,,"740123456"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SG:[,[,,"[36]\\d{7}|[17-9]\\d{7,10}","\\d{8,11}"],[,,"6[1-9]\\d{6}","\\d{8}",,,"61234567"],[,,"(?:8[1-7]|9[0-8])\\d{6}","\\d{8}",,,"81234567"],[,,"1?800\\d{7}","\\d{10,11}",,,"18001234567"],
	[,,"1900\\d{7}","\\d{11}",,,"19001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"3[12]\\d{6}","\\d{8}",,,"31234567"],"SG",65,"0[0-3]\\d",,,,,,,,[[,"([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"],"","",0],[,"(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]"],"","",0],[,"(7000)(\\d{4})(\\d{3})","$1 $2 $3",["70"],"","",0],[,"(800)(\\d{3})(\\d{4})","$1 $2 $3",["80"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"7000\\d{7}","\\d{11}",,,"70001234567"],,,[,,"NA","NA"]],SH:[,[,,"[2-79]\\d{3,4}","\\d{4,5}"],[,,"2(?:[0-57-9]\\d|6[4-9])\\d{2}|(?:[2-46]\\d|7[01])\\d{2}",
	"\\d{4,5}",,,"2158"],[,,"NA","NA"],[,,"NA","NA"],[,,"(?:[59]\\d|7[2-9])\\d{2}","\\d{4,5}",,,"5012"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SH",290,"00",,,,,,,,,,[,,"NA","NA"],1,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SI:[,[,,"[1-7]\\d{6,7}|[89]\\d{4,7}","\\d{5,8}"],[,,"(?:1\\d|[25][2-8]|3[4-8]|4[24-8]|7[3-8])\\d{6}","\\d{7,8}",,,"11234567"],[,,"(?:[37][01]|4[0139]|51|6[48])\\d{6}","\\d{8}",,,"31234567"],[,,"80\\d{4,6}","\\d{6,8}",,,"80123456"],[,,"90\\d{4,6}|89[1-3]\\d{2,5}","\\d{5,8}",
	,,"90123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"(?:59|8[1-3])\\d{6}","\\d{8}",,,"59012345"],"SI",386,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|3[4-8]|4[24-8]|5[2-8]|7[3-8]"],"(0$1)","",0],[,"([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1","",0],[,"([89][09])(\\d{3,6})","$1 $2",["[89][09]"],"0$1","",0],[,"([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SJ:[,[,,"0\\d{4}|[4789]\\d{7}",
	"\\d{5}(?:\\d{3})?"],[,,"79\\d{6}","\\d{8}",,,"79123456"],[,,"(?:4[015-8]|5[89]|9\\d)\\d{6}","\\d{8}",,,"41234567"],[,,"80[01]\\d{5}","\\d{8}",,,"80012345"],[,,"82[09]\\d{5}","\\d{8}",,,"82012345"],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}","\\d{8}",,,"81021234"],[,,"880\\d{5}","\\d{8}",,,"88012345"],[,,"85[0-5]\\d{5}","\\d{8}",,,"85012345"],"SJ",47,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}","\\d{5}(?:\\d{3})?",,,"01234"],1,,[,,"81[23]\\d{5}","\\d{8}",,,"81212345"]],
	SK:[,[,,"[2-689]\\d{8}","\\d{9}"],[,,"[2-5]\\d{8}","\\d{9}",,,"212345678"],[,,"9(?:0[1-8]|1[0-24-9]|4[0489])\\d{6}","\\d{9}",,,"912123456"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"9(?:[78]\\d{7}|00\\d{6})","\\d{9}",,,"900123456"],[,,"8[5-9]\\d{7}","\\d{9}",,,"850123456"],[,,"NA","NA"],[,,"6(?:5[0-4]|9[0-6])\\d{6}","\\d{9}",,,"690123456"],"SK",421,"00","0",,,"0",,,,[[,"(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1","",0],[,"([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1",
	"",0],[,"([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"(?:8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}","\\d{9}",,,"800123456"],[,,"96\\d{7}","\\d{9}",,,"961234567"],,,[,,"NA","NA"]],SL:[,[,,"[2-578]\\d{7}","\\d{6,8}"],[,,"[235]2[2-4][2-9]\\d{4}","\\d{6,8}",,,"22221234"],[,,"(?:2[15]|3[034]|4[04]|5[05]|7[6-9]|88)\\d{6}","\\d{6,8}",,,"25123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})",
	"$1 $2",,"(0$1)","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SM:[,[,,"[05-7]\\d{7,9}","\\d{6,10}"],[,,"0549(?:8[0157-9]|9\\d)\\d{4}","\\d{6,10}",,,"0549886377"],[,,"6[16]\\d{6}","\\d{8}",,,"66661212"],[,,"NA","NA"],[,,"7[178]\\d{6}","\\d{8}",,,"71123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"5[158]\\d{6}","\\d{8}",,,"58001110"],"SM",378,"00",,,,"(?:0549)?([89]\\d{5})","0549$1",,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"],"","",0],[,"(0549)(\\d{6})","$1 $2",["0"],
	"","",0],[,"(\\d{6})","0549 $1",["[89]"],"","",0]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]","[5-7]"],"","",0],[,"(0549)(\\d{6})","($1) $2",["0"]],[,"(\\d{6})","(0549) $1",["[89]"]]],[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],SN:[,[,,"[378]\\d{8}","\\d{9}"],[,,"3(?:0(?:1[0-2]|80)|211|3(?:8[1-9]|9[2-9])|90[1-5])\\d{5}","\\d{9}",,,"301012345"],[,,"7(?:[07]\\d|21|6[1-9]|8[0-26]|90)\\d{6}","\\d{9}",,,"701234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"88[4689]\\d{6}",
	"\\d{9}",,,"884123456"],[,,"81[02468]\\d{6}","\\d{9}",,,"810123456"],[,,"NA","NA"],[,,"391\\d{6}","\\d{9}",,,"391011234"],"SN",221,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[37]"],"","",0],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SO:[,[,,"[1-79]\\d{6,8}","\\d{7,9}"],[,,"(?:[134]\\d|2[0-79]|5[57-9])\\d{5}","\\d{7}",,,"5522010"],[,,"(?:15\\d|2(?:4\\d|8)|6[137-9]?\\d{2}|7\\d{2}|9(?:07|[13-9])\\d)\\d{5}",
	"\\d{7,9}",,,"907792024"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SO",252,"00","0",,,"0",,,,[[,"(\\d)(\\d{6})","$1 $2",["2[0-79]|[13-5]"],"","",0],[,"(\\d)(\\d{7})","$1 $2",["24|[67]"],"","",0],[,"(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1378]|9"],"","",0],[,"(69\\d)(\\d{6})","$1 $2",["69"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SR:[,[,,"[2-8]\\d{5,6}","\\d{6,7}"],[,,"(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}","\\d{6,7}",,,"211234"],[,
	,"(?:7(?:[1-357]\\d|4[0-5])|8[1-9]\\d)\\d{4}","\\d{7}",,,"7412345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"56\\d{4}","\\d{6}",,,"561234"],"SR",597,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"],"","",0],[,"(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"],"","",0],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SS:[,[,,"[19]\\d{8}","\\d{9}"],[,,"18\\d{7}","\\d{9}",,,"181234567"],[,,"(?:12|9[1257])\\d{7}","\\d{9}",
	,,"977123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",,"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ST:[,[,,"[29]\\d{6}","\\d{7}"],[,,"22\\d{5}","\\d{7}",,,"2221234"],[,,"9[89]\\d{5}","\\d{7}",,,"9812345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,
	"NA","NA"],,,[,,"NA","NA"]],SV:[,[,,"[267]\\d{7}|[89]\\d{6}(?:\\d{4})?","\\d{7,8}|\\d{11}"],[,,"2[1-6]\\d{6}","\\d{8}",,,"21234567"],[,,"[67]\\d{7}","\\d{8}",,,"70123456"],[,,"800\\d{4}(?:\\d{4})?","\\d{7}(?:\\d{4})?",,,"8001234"],[,,"900\\d{4}(?:\\d{4})?","\\d{7}(?:\\d{4})?",,,"9001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SV",503,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[267]"],"","",0],[,"(\\d{3})(\\d{4})","$1 $2",["[89]"],"","",0],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"],"",
	"",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SX:[,[,,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}","\\d{7}(?:\\d{3})?",,,"7215425678"],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}","\\d{10}",,,"7215205678"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002123456"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002123456"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"SX",1,"011","1",,,"1",,,,,,[,,"NA","NA"],
	,"721",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SY:[,[,,"[1-59]\\d{7,8}","\\d{6,9}"],[,,"(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}","\\d{6,9}",,,"112345678"],[,,"9(?:22|[35][0-8]|4\\d|6[024-9]|88|9[0-489])\\d{6}","\\d{9}",,,"944567890"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1","",1],[,"(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1","",1]],,[,
	,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],SZ:[,[,,"[027]\\d{7}","\\d{8}"],[,,"2(?:2(?:0[07]|[13]7|2[57])|3(?:0[34]|[1278]3|3[23]|[46][34])|(?:40[4-69]|67)|5(?:0[5-7]|1[6-9]|[23][78]|48|5[01]))\\d{4}","\\d{8}",,,"22171234"],[,,"7[6-8]\\d{6}","\\d{8}",,,"76123456"],[,,"0800\\d{4}","\\d{8}",,,"08001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[027]"],"","",0]],,[,,"NA","NA"],,,[,,"0800\\d{4}","\\d{8}",,,"08001234"],
	[,,"NA","NA"],1,,[,,"NA","NA"]],TA:[,[,,"8\\d{3}","\\d{4}"],[,,"8\\d{3}","\\d{4}",,,"8999"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TA",290,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TC:[,[,,"[5689]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"649(?:712|9(?:4\\d|50))\\d{4}","\\d{7}(?:\\d{3})?",,,"6497121234"],[,,"649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-7])|4[34][1-3])\\d{4}","\\d{10}",,,"6492311234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}",
	"\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"64971[01]\\d{4}","\\d{10}",,,"6497101234"],"TC",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"649",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TD:[,[,,"[2679]\\d{7}","\\d{8}"],[,,"22(?:[3789]0|5[0-5]|6[89])\\d{4}","\\d{8}",,,"22501234"],[,,"(?:6[02368]\\d|77\\d|9(?:5[0-4]|9\\d))\\d{5}","\\d{8}",,,"63012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],
	[,,"NA","NA"],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TG:[,[,,"[29]\\d{7}","\\d{8}"],[,,"2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}","\\d{8}",,,"22212345"],[,,"9[0-289]\\d{6}","\\d{8}",,,"90112345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],
	,,[,,"NA","NA"]],TH:[,[,,"[2-9]\\d{7,8}|1\\d{3}(?:\\d{6})?","\\d{4}|\\d{8,10}"],[,,"(?:2[1-9]|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}","\\d{8}",,,"21234567"],[,,"[89]\\d{8}","\\d{9}",,,"812345678"],[,,"1800\\d{6}","\\d{10}",,,"1800123456"],[,,"1900\\d{6}","\\d{10}",,,"1900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"60\\d{7}","\\d{9}",,,"601234567"],"TH",66,"00","0",,,"0",,,,[[,"(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1","",0],[,"([3-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[3-9]"],"0$1","",0],[,"(1[89]00)(\\d{3})(\\d{3})",
	"$1 $2 $3",["1"],"$1","",0]],,[,,"NA","NA"],,,[,,"1\\d{3}","\\d{4}",,,"1100"],[,,"1\\d{3}","\\d{4}",,,"1100"],,,[,,"NA","NA"]],TJ:[,[,,"[3-59]\\d{8}","\\d{3,9}"],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}","\\d{3,9}",,,"372123456"],[,,"(?:50[15]|9[0-35-9]\\d)\\d{6}","\\d{9}",,,"917123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TJ",992,"810","8",,,"8",,"8~10",,[[,"([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],"(8) $1","",1],[,
	"([459]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[48]|5|9(?:1[59]|[0235-9])"],"(8) $1","",1],[,"(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"],"(8) $1","",1],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"],"(8) $1","",1]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TK:[,[,,"[2-9]\\d{3}","\\d{4}"],[,,"[2-4]\\d{3}","\\d{4}",,,"3010"],[,,"[5-9]\\d{3}","\\d{4}",,,"5190"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],
	"TK",690,"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TL:[,[,,"[2-489]\\d{6}|7\\d{6,7}","\\d{7,8}"],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}","\\d{7}",,,"2112345"],[,,"7[3-8]\\d{6}","\\d{8}",,,"77212345"],[,,"80\\d{5}","\\d{7}",,,"8012345"],[,,"90\\d{5}","\\d{7}",,,"9012345"],[,,"NA","NA"],[,,"70\\d{5}","\\d{7}",,,"7012345"],[,,"NA","NA"],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]"],"","",0],[,"(\\d{4})(\\d{4})","$1 $2",["7"],"","",0]],,[,,"NA","NA"],,,[,
	,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TM:[,[,,"[1-6]\\d{7}","\\d{8}"],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}","\\d{8}",,,"12345678"],[,,"6[2-8]\\d{6}","\\d{8}",,,"66123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)","",0],[,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1","",0],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})",
	"$1 $2-$3-$4",["13|[2-5]"],"(8 $1)","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TN:[,[,,"[2-57-9]\\d{7}","\\d{8}"],[,,"3[012]\\d{6}|7\\d{7}|81200\\d{3}","\\d{8}",,,"71234567"],[,,"(?:[259]\\d|4[0-2])\\d{6}","\\d{8}",,,"20123456"],[,,"8010\\d{4}","\\d{8}",,,"80101234"],[,,"88\\d{6}","\\d{8}",,,"88123456"],[,,"8[12]10\\d{4}","\\d{8}",,,"81101234"],[,,"NA","NA"],[,,"NA","NA"],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],
	[,,"NA","NA"],,,[,,"NA","NA"]],TO:[,[,,"[02-8]\\d{4,6}","\\d{5,7}"],[,,"(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}","\\d{5}",,,"20123"],[,,"(?:7[578]|8[7-9])\\d{5}","\\d{7}",,,"7715123"],[,,"0800\\d{3}","\\d{7}",,,"0800222"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"],"","",0],[,"(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[7-9]"],"","",0],[,"(\\d{4})(\\d{3})","$1 $2",["0"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],
	[,,"NA","NA"],1,,[,,"NA","NA"]],TR:[,[,,"[2-589]\\d{9}|444\\d{4}","\\d{7,10}"],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}","\\d{10}",,,"2123456789"],[,,"5(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{7}","\\d{10}",,,"5012345678"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"900\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
	["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)","",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[589]"],"0$1","",1],[,"(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"],"","",0]],,[,,"512\\d{7}","\\d{10}",,,"5123456789"],,,[,,"444\\d{4}","\\d{7}",,,"4441444"],[,,"444\\d{4}|850\\d{7}","\\d{7,10}",,,"4441444"],,,[,,"NA","NA"]],TT:[,[,,"[589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"868(?:2(?:01|2[1-5])|6(?:07|1[4-6]|2[1-9]|[3-6]\\d|7[0-79]|9[0-8])|82[12])\\d{4}","\\d{7}(?:\\d{3})?",,,"8682211234"],[,,"868(?:2(?:8[5-9]|9\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:1[02-9]|[02-9]\\d))\\d{4}",
	"\\d{10}",,,"8682911234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"TT",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"868",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TV:[,[,,"[29]\\d{4,5}","\\d{5,6}"],[,,"2[02-9]\\d{3}","\\d{5}",,,"20123"],[,,"90\\d{4}","\\d{6}",,,"901234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TV",688,
	"00",,,,,,,,,,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TW:[,[,,"[2-9]\\d{7,8}","\\d{8,9}"],[,,"[2-8]\\d{7,8}","\\d{8,9}",,,"21234567"],[,,"9\\d{8}","\\d{9}",,,"912345678"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"900\\d{6}","\\d{9}",,,"900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"TW",886,"0(?:0[25679]|19)","0","#",,"0",,,,[[,"([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[2-7]|8[1-9]"],"0$1","",0],[,"([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["80|9"],"0$1","",0]],,[,,"NA",
	"NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],TZ:[,[,,"\\d{9}","\\d{7,9}"],[,,"2[2-8]\\d{7}","\\d{7,9}",,,"222345678"],[,,"(?:6[158]|7[1-9])\\d{7}","\\d{9}",,,"612345678"],[,,"80[08]\\d{6}","\\d{9}",,,"800123456"],[,,"90\\d{7}","\\d{9}",,,"900123456"],[,,"8(?:40|6[01])\\d{6}","\\d{9}",,,"840123456"],[,,"NA","NA"],[,,"41\\d{7}","\\d{9}",,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1","",0],[,"([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],
	"0$1","",0],[,"([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],UA:[,[,,"[3-689]\\d{8}","\\d{5,9}"],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}","\\d{5,9}",,,"311234567"],[,,"(?:39|50|6[36-8]|9[1-9])\\d{7}","\\d{9}",,,"391234567"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"900\\d{6}","\\d{9}",,,"900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"89\\d{7}","\\d{9}",,,"891234567"],"UA",380,"00","0",,,"0",,"0~0",,[[,"([3-689]\\d)(\\d{3})(\\d{4})",
	"$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|9[1-9]"],"0$1","",0],[,"([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"],"0$1","",0],[,"([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])",
	"3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],UG:[,[,,"\\d{9}","\\d{5,9}"],[,,"20(?:[0147]\\d{2}|2(?:40|[5-9]\\d)|3[23]\\d|5[0-4]\\d|6[03]\\d|8[0-2]\\d)\\d{4}|[34]\\d{8}","\\d{5,9}",,,"312345678"],[,,"7(?:0[0-7]|[15789]\\d|[23]0|[46][0-4])\\d{6}","\\d{9}",,,"712345678"],[,,"800[123]\\d{5}","\\d{9}",
	,,"800123456"],[,,"90[123]\\d{6}","\\d{9}",,,"901123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{3})(\\d{6})","$1 $2",["[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"],"0$1","",0],[,"(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"],"0$1","",0],[,"(2024)(\\d{5})","$1 $2",["2024"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],US:[,[,,"[2-9]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"(?:2(?:0[1-35-9]|1[02-9]|2[4589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|47|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|69|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[036]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[07]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[06-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[1678]|4[0179]|5[1246]|7[0-3589]|8[0459]))[2-9]\\d{6}",
	"\\d{7}(?:\\d{3})?",,,"2015555555"],[,,"(?:2(?:0[1-35-9]|1[02-9]|2[4589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|47|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|69|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[036]|3[016]|4[16]|5[017]|6[0-279]|78|8[12])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[07]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[06-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[1678]|4[0179]|5[1246]|7[0-3589]|8[0459]))[2-9]\\d{6}",
	"\\d{7}(?:\\d{3})?",,,"2015555555"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",,"","",1],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",,"","",1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3"]],[,,"NA","NA"],1,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],UY:[,[,,"[2489]\\d{6,7}","\\d{7,8}"],[,,"2\\d{7}|4[2-7]\\d{6}",
	"\\d{7,8}",,,"21231234"],[,,"9[1-9]\\d{6}","\\d{8}",,,"94231234"],[,,"80[05]\\d{4}","\\d{7}",,,"8001234"],[,,"90[0-8]\\d{4}","\\d{7}",,,"9001234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"UY",598,"0(?:1[3-9]\\d|0)","0"," int. ",,"0",,"00",,[[,"(\\d{4})(\\d{4})","$1 $2",["[24]"],"","",0],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1","",0],[,"(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],UZ:[,[,,"[679]\\d{8}","\\d{7,9}"],
	[,,"(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}","\\d{7,9}",,,"662345678"],[,,"6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}",
	"\\d{7,9}",,,"912345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"UZ",998,"810","8",,,"8",,"8~10",,[[,"([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",,"8 $1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],VA:[,[,,"06\\d{8}","\\d{10}"],[,,"06698\\d{5}","\\d{10}",,,"0669812345"],[,,"N/A","N/A"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"VA",379,"00",,,,,,,,[[,"(06)(\\d{4})(\\d{4})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],
	,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],VC:[,[,,"[5789]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8\\d|9[01])|555|638|784)\\d{4}","\\d{7}(?:\\d{3})?",,,"7842661234"],[,,"784(?:4(?:3[0-4]|5[45]|9[2-5])|5(?:2[6-9]|3[0-4]|93))\\d{4}","\\d{10}",,,"7844301234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],
	"VC",1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"784",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],VE:[,[,,"[24589]\\d{9}","\\d{7,10}"],[,,"(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}","\\d{7,10}",,,"2121234567"],[,,"4(?:1[24-8]|2[46])\\d{7}","\\d{10}",,,"4121234567"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"900\\d{7}","\\d{10}",,,"9001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"VE",58,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{7})","$1-$2",,"0$1","$CC $1",0]],,[,,"NA","NA"],,,[,,"NA",
	"NA"],[,,"NA","NA"],,,[,,"NA","NA"]],VG:[,[,,"[2589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})","\\d{7}(?:\\d{3})?",,,"2842291234"],[,,"284(?:(?:3(?:0[0-3]|4[0-367])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})","\\d{10}",,,"2843001234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}","\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"VG",
	1,"011","1",,,"1",,,,,,[,,"NA","NA"],,"284",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],VI:[,[,,"[3589]\\d{9}","\\d{7}(?:\\d{3})?"],[,,"340(?:2(?:01|2[067]|36|44|77)|3(?:32|44)|4(?:4[38]|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:[17]\\d|27)|884|998)\\d{4}","\\d{7}(?:\\d{3})?",,,"3406421234"],[,,"340(?:2(?:01|2[067]|36|44|77)|3(?:32|44)|4(?:4[38]|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:[17]\\d|27)|884|998)\\d{4}","\\d{7}(?:\\d{3})?",,,"3406421234"],[,,"8(?:00|44|55|66|77|88)[2-9]\\d{6}",
	"\\d{10}",,,"8002345678"],[,,"900[2-9]\\d{6}","\\d{10}",,,"9002345678"],[,,"NA","NA"],[,,"5(?:00|33|44)[2-9]\\d{6}","\\d{10}",,,"5002345678"],[,,"NA","NA"],"VI",1,"011","1",,,"1",,,1,,,[,,"NA","NA"],,"340",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],VN:[,[,,"[17]\\d{6,9}|[2-69]\\d{7,9}|8\\d{6,8}","\\d{7,10}"],[,,"(?:2(?:[025-79]|1[0189]|[348][01])|3(?:[0136-9]|[25][01])|4\\d|5(?:[01][01]|[2-9])|6(?:[0-46-8]|5[01])|7(?:[02-79]|[18][01])|8[1-9])\\d{7}","\\d{9,10}",,,"2101234567"],[,,"(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}",
	"\\d{9,10}",,,"912345678"],[,,"1800\\d{4,6}","\\d{8,10}",,,"1800123456"],[,,"1900\\d{4,6}","\\d{8,10}",,,"1900123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"VN",84,"00","0",,,"0",,,,[[,"([17]99)(\\d{4})","$1 $2",["[17]99"],"0$1","",1],[,"([48])(\\d{4})(\\d{4})","$1 $2 $3",["[48]"],"0$1","",1],[,"([235-7]\\d)(\\d{4})(\\d{3})","$1 $2 $3",["2[025-79]|3[0136-9]|5[2-9]|6[0-46-8]|7[02-79]"],"0$1","",1],[,"(80)(\\d{5})","$1 $2",["80"],"0$1","",1],[,"(69\\d)(\\d{4,5})","$1 $2",["69"],"0$1","",1],[,"([235-7]\\d{2})(\\d{4})(\\d{3})",
	"$1 $2 $3",["2[1348]|3[25]|5[01]|65|7[18]"],"0$1","",1],[,"(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1","",1],[,"(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"],"0$1","",1],[,"(1[89]00)(\\d{4,6})","$1 $2",["1[89]0"],"$1","",1]],,[,,"NA","NA"],,,[,,"[17]99\\d{4}|69\\d{5,6}","\\d{7,8}",,,"1992000"],[,,"[17]99\\d{4}|69\\d{5,6}|80\\d{5}","\\d{7,8}",,,"1992000"],,,[,,"NA","NA"]],VU:[,[,,"[2-57-9]\\d{4,6}","\\d{5,7}"],[,,"(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}",
	"\\d{5}",,,"22123"],[,,"(?:5(?:7[2-5]|[3-69]\\d)|7[013-7]\\d)\\d{4}","\\d{7}",,,"5912345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[579]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"3[03]\\d{3}|900\\d{4}","\\d{5,7}",,,"30123"],,,[,,"NA","NA"]],WF:[,[,,"[5-7]\\d{5}","\\d{6}"],[,,"(?:50|68|72)\\d{4}","\\d{6}",,,"501234"],[,,"(?:50|68|72)\\d{4}","\\d{6}",,,"501234"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA",
	"NA"],[,,"NA","NA"],"WF",681,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],WS:[,[,,"[2-8]\\d{4,6}","\\d{5,7}"],[,,"(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}","\\d{5,7}",,,"22123"],[,,"(?:60|7[25-7]\\d)\\d{4}","\\d{6,7}",,,"601234"],[,,"800\\d{3}","\\d{6}",,,"800123"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"WS",685,"0",,,,,,,,[[,"(8\\d{2})(\\d{3,4})","$1 $2",["8"],"","",0],[,"(7\\d)(\\d{5})","$1 $2",["7"],"",
	"",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],YE:[,[,,"[1-7]\\d{6,8}","\\d{6,9}"],[,,"(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}","\\d{6,8}",,,"1234567"],[,,"7[0137]\\d{7}","\\d{9}",,,"712345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"YE",967,"00","0",,,"0",,,,[[,"([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1","",0],[,"(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"],"0$1","",0]],,[,,"NA","NA"],
	,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],YT:[,[,,"[268]\\d{8}","\\d{9}"],[,,"2696[0-4]\\d{4}","\\d{9}",,,"269601234"],[,,"639\\d{6}","\\d{9}",,,"639123456"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"YT",262,"00","0",,,"0",,,,,,[,,"NA","NA"],,"269|63",[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ZA:[,[,,"[1-79]\\d{8}|8(?:[067]\\d{7}|[1-4]\\d{3,7})","\\d{5,9}"],[,,"(?:1[0-8]|2[0-378]|3[1-69]|4\\d|5[1346-8])\\d{7}","\\d{9}",,,"101234567"],[,
	,"(?:6[0-5]|7[0-46-9])\\d{7}|8[1-4]\\d{3,7}","\\d{5,9}",,,"711234567"],[,,"80\\d{7}","\\d{9}",,,"801234567"],[,,"86[2-9]\\d{6}|90\\d{7}","\\d{9}",,,"862345678"],[,,"860\\d{6}","\\d{9}",,,"860123456"],[,,"NA","NA"],[,,"87\\d{7}","\\d{9}",,,"871234567"],"ZA",27,"00","0",,,"0",,,,[[,"(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-47]|6[1-9])"],"0$1","",0],[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1","",0],[,"(\\d{2})(\\d{3})(\\d{2,3})",
	"$1 $2 $3",["8[1-4]"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"861\\d{6}","\\d{9}",,,"861123456"],,,[,,"NA","NA"]],ZM:[,[,,"[289]\\d{8}","\\d{9}"],[,,"21[1-8]\\d{6}","\\d{9}",,,"211234567"],[,,"9(?:5[05]|6\\d|7[13-9])\\d{6}","\\d{9}",,,"955123456"],[,,"800\\d{6}","\\d{9}",,,"800123456"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"ZM",260,"00","0",,,"0",,,,[[,"([29]\\d)(\\d{7})","$1 $2",["[29]"],"0$1","",0],[,"(800)(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1","",0]],,[,,"NA","NA"],
	,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],ZW:[,[,,"2(?:[012457-9]\\d{3,8}|6\\d{3,6})|[13-79]\\d{4,8}|8[06]\\d{8}","\\d{3,10}"],[,,"(?:1[3-9]|2(?:0[45]|[16]|2[28]|[49]8?|58[23]|7[246]|8[1346-9])|3(?:08?|17?|3[78]|[2456]|7[1569]|8[379])|5(?:[07-9]|1[78]|483|5(?:7?|8))|6(?:0|28|37?|[45][68][78]|98?)|848)\\d{3,6}|(?:2(?:27|5|7[135789]|8[25])|3[39]|5[1-46]|6[126-8])\\d{4,6}|2(?:(?:0|70)\\d{5,6}|2[05]\\d{7})|(?:4\\d|9[2-8])\\d{4,7}","\\d{3,10}",,,"1312345"],[,,"7[1378]\\d{7}|86(?:22|44)\\d{6}","\\d{9,10}",
	,,"711234567"],[,,"800\\d{7}","\\d{10}",,,"8001234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"86(?:1[12]|30|55|77|8[367]|99)\\d{6}","\\d{10}",,,"8686123456"],"ZW",263,"00","0",,,"0",,,,[[,"([49])(\\d{3})(\\d{2,5})","$1 $2 $3",["4|9[2-9]"],"0$1","",0],[,"([179]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[19]1|7"],"0$1","",0],[,"(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"],"0$1","",0],[,"([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:[278]|0[45]|[49]8)|3(?:08|17|3[78]|[78])|5[15][78]|6(?:[29]8|37|[68][78])"],
	"0$1","",0],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:[278]|0[45]|48)|3(?:08|17|3[78]|[78])|5[15][78]|6(?:[29]8|37|[68][78])|80"],"0$1","",0],[,"([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2(?:[1-469]|0[0-35-9]|[45][0-79])|3(?:0[0-79]|1[0-689]|[24-69]|3[0-69])|5(?:[02-46-9]|[15][0-69])|6(?:[0145]|[29][0-79]|3[0-689]|[68][0-69])"],"0$1","",0],[,"([1-356]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[3-9]|2(?:[1-469]|0[0-35-9]|[45][0-79])|3(?:0[0-79]|1[0-689]|[24-69]|3[0-69])|5(?:[02-46-9]|[15][0-69])|6(?:[0145]|[29][0-79]|3[0-689]|[68][0-69])"],
	"0$1","",0],[,"([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"],"0$1","",0],[,"([25]\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["(?:25|54)8","258[23]|5483"],"0$1","",0],[,"(8\\d{3})(\\d{6})","$1 $2",["86"],"0$1","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],800:[,[,,"\\d{8}","\\d{8}",,,"12345678"],[,,"NA","NA",,,"12345678"],[,,"NA","NA",,,"12345678"],[,,"\\d{8}","\\d{8}",,,"12345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"001",800,"",,,,,,,1,[[,"(\\d{4})(\\d{4})",
	"$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],808:[,[,,"\\d{8}","\\d{8}",,,"12345678"],[,,"NA","NA",,,"12345678"],[,,"NA","NA",,,"12345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"\\d{8}","\\d{8}",,,"12345678"],[,,"NA","NA"],[,,"NA","NA"],"001",808,"",,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]],870:[,[,,"[35-7]\\d{8}","\\d{9}",,,"301234567"],[,,"NA","NA",,,"301234567"],[,,"(?:[356]\\d|7[6-8])\\d{7}","\\d{9}",
	,,"301234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"001",870,"",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],878:[,[,,"1\\d{11}","\\d{12}",,,"101234567890"],[,,"NA","NA",,,"101234567890"],[,,"NA","NA",,,"101234567890"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"10\\d{10}","\\d{12}",,,"101234567890"],"001",878,"",,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",,"","",0]],
	,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],881:[,[,,"[67]\\d{8}","\\d{9}",,,"612345678"],[,,"NA","NA",,,"612345678"],[,,"[67]\\d{8}","\\d{9}",,,"612345678"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"001",881,"",,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[67]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],882:[,[,,"[13]\\d{6,11}","\\d{7,12}",,,"3451234567"],[,,"NA","NA",,,"3451234567"],[,,"3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}",
	"\\d{7,10}",,,"3451234567"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|345\\d{7}","\\d{7,12}",,,"3451234567"],"001",882,"",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"],"","",0],[,"(\\d{2})(\\d{5})","$1 $2",["16|342"],"","",0],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"],"","",0],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["348"],"","",0],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",
	["1"],"","",0],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"],"","",0],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["16"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"348[57]\\d{7}","\\d{11}",,,"3451234567"]],883:[,[,,"51\\d{7}(?:\\d{3})?","\\d{9}(?:\\d{3})?",,,"510012345"],[,,"NA","NA",,,"510012345"],[,,"NA","NA",,,"510012345"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})","\\d{9}(?:\\d{3})?",,,"510012345"],"001",883,"",,,,,,,1,
	[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"],"","",0],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"],"","",0],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"],"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],,,[,,"NA","NA"]],888:[,[,,"\\d{11}","\\d{11}",,,"12345678901"],[,,"NA","NA",,,"12345678901"],[,,"NA","NA",,,"12345678901"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"001",888,"",,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",,"","",0]],,[,
	,"NA","NA"],,,[,,"NA","NA"],[,,"\\d{11}","\\d{11}",,,"12345678901"],1,,[,,"NA","NA"]],979:[,[,,"\\d{9}","\\d{9}",,,"123456789"],[,,"NA","NA",,,"123456789"],[,,"NA","NA",,,"123456789"],[,,"NA","NA"],[,,"\\d{9}","\\d{9}",,,"123456789"],[,,"NA","NA"],[,,"NA","NA"],[,,"NA","NA"],"001",979,"",,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",,"","",0]],,[,,"NA","NA"],,,[,,"NA","NA"],[,,"NA","NA"],1,,[,,"NA","NA"]]};/*
	
	 Copyright (C) 2010 The Libphonenumber Authors.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function K(){this.$={}}K.ba=function(){return K.w?K.w:K.w=new K};
	var L={"0":"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"},ra={"0":"0",1:"1",2:"2",3:"3",4:"4",5:"5",
	6:"6",7:"7",8:"8",9:"9","+":"+","*":"*"},sa={"0":"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",A:"2",
	B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"},ta=/[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/,M=RegExp("^[+\uff0b]+"),ua=RegExp("([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])"),va=RegExp("[+\uff0b0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]"),wa=/[\\\/] *x/,xa=RegExp("[^0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9A-Za-z#]+$"),ya=/(?:.*?[A-Za-z]){3}.*/,za=RegExp("(?:;ext=([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})#?|[- ]+([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,5})#)$",
	"i"),Aa=RegExp("^[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{2}$|^[+\uff0b]*(?:[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*]*[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]){3,}[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]*(?:;ext=([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,7})#?|[- ]+([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,5})#)?$",
	"i"),Ba=/(\$\d)/,Ca=/\$NP/,Da=/\$FG/,Ea=/\$CC/;function Fa(a){var b=a.search(va);0<=b?(a=a.substring(b),a=a.replace(xa,""),b=a.search(wa),0<=b&&(a=a.substring(0,b))):a="";return a}function Ga(a){var b=O(ya,a.toString())?P(a.toString(),sa):P(a.toString(),L);a.clear();a.append(b)}function P(a,b){for(var c=new E,e,d=a.length,f=0;f<d;++f)e=a.charAt(f),e=b[e.toUpperCase()],e!=l&&c.append(e);return c.toString()}function Q(a){return a!=l&&isNaN(a)&&a.toUpperCase()in qa}
	function R(a,b,c){if(0==y(b,2)&&u(b,5)){var e=z(b,5);if(0<e.length)return e}var e=b.c(),d=S(b);if(0==c)return T(e,0,d,"");if(!(e in J))return d;a=U(a,e,V(e));b=Ha(b,a,c);d=Ia(d,a,c);return T(e,c,d,b)}function U(a,b,c){return"001"==c?W(a,""+b):W(a,c)}
	function Ja(a,b,c){if(!Q(c))return R(a,b,1);var e=b.c(),d=S(b);if(!(e in J))return d;if(1==e){if(c!=l&&0<=ba(J[1],c.toUpperCase()))return e+" "+R(a,b,2)}else if(e==Ka(a,c))return R(a,b,2);var f=W(a,c),g=z(f,11);c="";O(ta,g)?c=g:u(f,17)&&(c=z(f,17));a=U(a,e,V(e));d=Ia(d,a,1);b=Ha(b,a,1);return 0<c.length?c+" "+e+" "+d+b:T(e,1,d,b)}function S(a){var b=""+y(a,2);return u(a,4)&&y(a,4)?Array(z(a,8)+1).join("0")+b:b}
	function T(a,b,c,e){switch(b){case 0:return"+"+a+c+e;case 1:return"+"+a+" "+c+e;case 3:return"tel:+"+a+"-"+c+e;default:return c+e}}function Ia(a,b,c){b=0==v(b,20).length||2==c?v(b,19):v(b,20);b=X(b,a);return b==l?a:La(a,b,c,void 0)}function X(a,b){for(var c,e=a.length,d=0;d<e;++d){c=a[d];var f=c.h[3].o?u(c,3)?c.e[3].length:0:u(c,3)?1:0;if(0==f||0==b.search(y(c,3,f-1)))if(f=RegExp(y(c,1)),O(f,b))return c}return l}
	function La(a,b,c,e){var d=z(b,2),f=RegExp(y(b,1)),g=z(b,5),h="";2==c&&e!=l&&0<e.length&&0<g.length?(b=g.replace(Ea,e),d=d.replace(Ba,b),h=a.replace(f,d)):(b=z(b,4),h=2==c&&b!=l&&0<b.length?a.replace(f,d.replace(Ba,b)):a.replace(f,d));3==c&&(h=h.replace(RegExp("^[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+"),""),h=h.replace(RegExp("[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+",
	"g"),"-"));return h}function Ha(a,b,c){return!u(a,3)||0==a.getExtension().length?"":3==c?";ext="+a.getExtension():u(b,13)?y(b,13)+z(a,3):" ext. "+z(a,3)}function Ma(a,b){var c=y(b,1);return!u(c,2)||!Y(a,c)?-1:Y(a,y(b,5))?4:Y(a,y(b,4))?3:Y(a,y(b,6))?5:Y(a,y(b,8))?6:Y(a,y(b,7))?7:Y(a,y(b,21))?8:Y(a,y(b,25))?9:Y(a,y(b,28))?10:Y(a,y(b,2))?y(b,18)||Y(a,y(b,3))?2:0:!y(b,18)&&Y(a,y(b,3))?1:-1}
	function W(a,b){if(b==l)return l;b=b.toUpperCase();var c=a.$[b];if(c==l){c=qa[b];if(c==l)return l;c=(new D).k(H.d(),c);a.$[b]=c}return c}function Y(a,b){return O(z(b,3),a)&&O(z(b,2),a)}function Na(a,b){var c=Oa(a,b);return Pa(a,b,c)}function Pa(a,b,c){var e=b.c(),d=U(a,e,c);if(d==l||"001"!=c&&e!=Ka(a,c))return m;a=y(d,1);b=S(b);return!u(a,2)?(d=b.length,2<d&&17>=d):-1!=Ma(b,d)}
	function Oa(a,b){if(b==l)return l;var c=b.c(),c=J[c];if(c==l)c=l;else if(1==c.length)c=c[0];else a:{for(var e=S(b),d,f=c.length,g=0;g<f;g++){d=c[g];var h=W(a,d);if(u(h,23)){if(0==e.search(y(h,23))){c=d;break a}}else if(-1!=Ma(e,h)){c=d;break a}}c=l}return c}function V(a){a=J[a];return a==l?"ZZ":a[0]}function Ka(a,b){var c=W(a,b);c==l&&i("Invalid region code: "+b);return c.c()}function Qa(a,b){return O(a,b)?0:0==b.search(a)?3:2}
	function Ra(a){var b=Z,c=S(a);a=a.c();if(!(a in J))return 1;b=U(b,a,V(a));b=y(b,1);if(!u(b,2))return c=c.length,2>c?2:17<c?3:0;b=z(b,3);return Qa(b,c)}
	function Sa(a,b,c,e,d){if(0==a.length)return 0;a=new E(a);var f;b!=l&&(f=y(b,11));f==l&&(f="NonMatch");var g=a.toString();if(0==g.length)f=20;else if(M.test(g))g=g.replace(M,""),a.clear(),a.append(O(ya,g)?P(g,sa):P(g,L)),f=1;else{g=RegExp(f);Ga(a);f=a.toString();if(0==f.search(g)){var g=f.match(g)[0].length,h=f.substring(g).match(ua);h&&(h[1]!=l&&0<h[1].length)&&"0"==P(h[1],L)?f=m:(a.clear(),a.append(f.substring(g)),f=k)}else f=m;f=f?5:20}e&&s(d,6,f);if(20!=f){2>=a.g.length&&i("Phone number too short after IDD");
	a:{f=a.toString();if(!(0==f.length||"0"==f.charAt(0)))for(var h=f.length,j=1;3>=j&&j<=h;++j)if(g=parseInt(f.substring(0,j),10),g in J){c.append(f.substring(j));f=g;break a}f=0}if(0!=f)return d.m(f),f;i("Invalid country calling code")}if(b!=l&&(f=b.c(),g=""+f,h=a.toString(),0==h.lastIndexOf(g,0)&&(j=new E(h.substring(g.length)),h=y(b,1),g=RegExp(z(h,2)),Ta(j,b,l),b=j.toString(),h=z(h,3),!O(g,a.toString())&&O(g,b)||3==Qa(h,a.toString()))))return c.append(b),e&&s(d,6,10),d.m(f),f;d.m(0);return 0}
	function Ta(a,b,c){var e=a.toString(),d=e.length,f=y(b,15);if(!(0==d||f==l||0==f.length))if(f=RegExp("^(?:"+f+")"),d=f.exec(e)){var g=RegExp,h;h=y(b,1);h=z(h,2);g=g(h);h=O(g,e);var j=d.length-1;b=y(b,16);if(b==l||0==b.length||d[j]==l||0==d[j].length){if(!h||O(g,e.substring(d[0].length)))c!=l&&(0<j&&d[j]!=l)&&c.append(d[1]),a.set(e.substring(d[0].length))}else if(e=e.replace(f,b),!h||O(g,e))c!=l&&0<j&&c.append(d[1]),a.set(e)}}K.prototype.parse=function(a,b){return Ua(this,a,b,m)};
	function $(a,b){var c=Z;!Q(b)&&(0<a.length&&"+"!=a.charAt(0))&&i("Invalid country calling code");return Ua(c,a,b,k)}
	function Ua(a,b,c,e){b==l&&i("The string supplied did not seem to be a phone number");250<b.length&&i("The string supplied is too long to be a phone number");var d=new E,f=b.indexOf(";phone-context=");if(0<f){var g=f+15;if("+"==b.charAt(g)){var h=b.indexOf(";",g);0<h?d.append(b.substring(g,h)):d.append(b.substring(g))}d.append(b.substring(b.indexOf("tel:")+4,f))}else d.append(Fa(b));f=d.toString();g=f.indexOf(";isub=");0<g&&(d.clear(),d.append(f.substring(0,g)));(2>d.toString().length?0:O(Aa,d.toString()))||
	i("The string supplied did not seem to be a phone number");Q(c)||d.toString()!=l&&0<d.toString().length&&M.test(d.toString())||i("Invalid country calling code");f=new I;e&&s(f,5,b);a:{b=d.toString();g=b.search(za);if(0<=g&&(2>b.substring(0,g).length?0:O(Aa,b.substring(0,g))))for(var h=b.match(za),j=h.length,N=1;N<j;++N)if(h[N]!=l&&0<h[N].length){d.clear();d.append(b.substring(0,g));b=h[N];break a}b=""}0<b.length&&s(f,3,b);g=W(a,c);b=new E;h=0;j=d.toString();try{h=Sa(j,g,b,e,f)}catch(ea){"Invalid country calling code"==
	ea&&M.test(j)?(j=j.replace(M,""),h=Sa(j,g,b,e,f),0==h&&i(ea)):i(ea)}0!=h?(d=V(h),d!=c&&(g=U(a,h,d))):(Ga(d),b.append(d.toString()),c!=l?(h=g.c(),f.m(h)):e&&t(f,6));2>b.g.length&&i("The string supplied is too short to be a phone number");g!=l&&(a=new E,c=new E(b.toString()),Ta(c,g,a),d=c.toString(),g=y(g,1),g=z(g,3),2!=Qa(g,d)&&(b=c,e&&s(f,7,a.toString())));e=b.toString();a=e.length;2>a&&i("The string supplied is too short to be a phone number");17<a&&i("The string supplied is too long to be a phone number");
	if(1<e.length&&"0"==e.charAt(0)){s(f,4,k);for(a=1;a<e.length-1&&"0"==e.charAt(a);)a++;1!=a&&s(f,8,a)}s(f,2,parseInt(e,10));return f}function O(a,b){var c="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a);return c&&c[0].length==b.length?k:m};var Z=K.ba();n("phoneUtils.isPossibleNumber",function(a,b){var c=$(a,b||"us");return 0==Ra(c)});n("phoneUtils.isPossibleNumberWithReason",function(a,b){var c=$(a,b||"us");return Ra(c)});n("phoneUtils.isValidNumber",function(a,b){var c=$(a,b||"us");return Na(Z,c)});n("phoneUtils.isValidNumberForRegion",function(a,b){b=b||"us";var c=$(a,b);return Pa(Z,c,b)});n("phoneUtils.getRegionCodeForNumber",function(a,b){var c=$(a,b||"us");return Oa(Z,c)});
	n("phoneUtils.getNumberType",function(a,b){var c,e;e=$(a,b||"us");var d=Z,f=Oa(d,e),d=U(d,e.c(),f);d==l?e=-1:(e=S(e),e=Ma(e,d));switch(e){case 0:c="FIXED_LINE";break;case 1:c="MOBILE";break;case 2:c="FIXED_LINE_OR_MOBILE";break;case 3:c="TOLL_FREE";break;case 4:c="PREMIUM_RATE";break;case 5:c="SHARED_COST";break;case 6:c="VOIP";break;case 7:c="PERSONAL_NUMBER";break;case 8:c="PAGER";break;case 9:c="UAN";break;case -1:c="UNKNOWN"}return c});
	n("phoneUtils.formatE164",function(a,b){var c=$(a,b||"us");return R(Z,c,0)});n("phoneUtils.formatNational",function(a,b){var c=$(a,b||"us");return R(Z,c,2)});n("phoneUtils.formatInternational",function(a,b){var c=$(a,b||"us");return R(Z,c,1)});
	n("phoneUtils.formatInOriginalFormat",function(a,b){b=b||"us";var c;c=$(a,b);var e=b,d=Z,f;if(f=u(c,5)){if(f=u(c,4))f=c.c(),f=U(d,f,V(f)),f=!(f!=l&&z(f,26));if(!f){f=c.c();f=U(d,f,V(f));if(f==l)f=m;else{var g=S(c);f=X(v(f,19),g)!=l}f=!f}}if(f)c=z(c,5);else if(u(c,6)){switch(y(c,6)){case 1:d=R(d,c,1);break;case 5:d=Ja(d,c,e);break;case 10:d=R(d,c,1).substring(1);break;default:f=V(c.c());var h;e=W(d,f);e==l?h=l:(e=z(e,12),h=0==e.length?l:e=e.replace("~",""));e=R(d,c,2);if(h==l||0==h.length){d=e;break}var j;
	b:{g=z(c,5);g=P(g,L);if(0==g.lastIndexOf(h,0))try{j=Na(d,d.parse(g.substring(h.length),f));break b}catch(N){}j=m}if(j){d=e;break}j=W(d,f);f=S(c);j=X(v(j,19),f);if(j==l){d=e;break}f=z(j,4);g=f.indexOf("$1");if(0>=g){d=e;break}f=f.substring(0,g);f=P(f,L);if(0==f.length){d=e;break}j=w(j);t(j,4);f=[j];j=c.c();e=S(c);j in J?(d=U(d,j,V(j)),g="",g=X(f,e),g==l?g=e:(f=w(g),g=z(g,4),0<g.length&&(h=z(d,12),0<h.length?(g=g.replace(Ca,h).replace(Da,"$1"),s(f,4,g)):t(f,4)),g=La(e,f,2)),d=Ha(c,d,2),d=T(j,2,g,d)):
	d=e}c=z(c,5);d!=l&&0<c.length&&(j=P(d,ra),e=P(c,ra),j!=e&&(d=c));c=d}else c=R(d,c,2);return c});n("phoneUtils.formatOutOfCountryCallingNumber",function(a,b,c){if(c)return a=$(a,b),Ja(Z,a,c)});})();
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = phoneUtils;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, $stateParams, $state, ModalService, $q, ProducerContactService, $rootScope) {
	
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = $stateParams.submission;
	        //const flowModel = StateUtils.activeDataForState(true).flowModel;
	        ctrl.init = function () {
	
	            // Get quote id from submission
	            var quoteID = submissionVM.quoteID;
	            $scope.quoteNo = submissionVM.quoteID;
	            $scope.getAddress = function () {
	                if (submissionVM.persons[0].primaryAddress) {
	                    var addr = submissionVM.persons[0].primaryAddress;
	                    return [addr.addressLine1, addr.city + ", " + addr.state + " " + addr.postalCode];
	                }
	
	                /*const addr = scope.submission.draftData.policyAddress;
	                return [addr.addressLine1,
	                    `${addr.city}, ${addr.state} ${addr.postalCode}`];*/
	            };
	            $scope.address = submissionVM.persons[0].primaryAddress.displayName;
	
	            $scope.agentDetails = {};
	
	            var producerCodeSummary = ProducerContactService.getProducerContactSummaryByQuoteId(quoteID);
	            $q.when(producerCodeSummary, function (response) {
	
	                // Temp placeholder display for agent info
	                //$scope.agentDetails.displayName = (response.producerOfRecord.description) ? response.producerOfRecord.description : response.displayName;
	                //DE1866 : Commented out to pass hard code values for agents details as per the defect requirement
	
	                // QnB Link on Agents wiebsites
	                // Need to display producer information specific to EIA / AAOP / SP
	                // AB - 09/18/2019
	                //
	                // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
	                // AB - 11/23/2020
	
	                if ($rootScope.Arg1 == null) {
	                    var arg1 = $rootScope.Arg1;
	                } else {
	                    var arg1 = $rootScope.Arg1.toUpperCase();
	                }
	
	                switch (arg1) {
	                    case "GORMISH":
	                    case "SEA":
	                    case "YOMTOB":
	                        $scope.agentDetails.displayName = response.displayName ? response.displayName : response.producerOfRecord.description;
	                        var primaryAddress = response.producerOfRecord.address ? response.producerOfRecord.address : response.primaryAddress;
	                        if (primaryAddress && primaryAddress.displayName != "<empty>") {
	                            $scope.agentDetails.primaryAddress = primaryAddress.displayName;
	                        };
	                        $scope.agentDetails.phoneNumber = response.phoneNumber ? response.phoneNumber : "";
	                        $scope.agentDetails.email = response.email ? response.email : "";
	                        break;
	                    default:
	                        $scope.agentDetails.displayName = "AAA Insurance";
	                        $scope.agentDetails.primaryAddress = "6600 AAA Dr Charlotte, NC 28212";
	                        $scope.agentDetails.phoneNumber = "1-877-840-8642";
	                }
	            }, function (response) {});
	        };
	
	        ctrl.doNavigate = function () {
	            var account = submissionVM.draftData.accountHolder;
	            account.subtype = 'Person';
	            account.accountExists = true;
	            account.accountNumber = submissionVM.draftData.accountNumber;
	            var postalCode = account.primaryAddress.postalCode;
	
	            var details = {
	                postalCode: postalCode,
	                account: account,
	                effectiveDate: new Date(),
	                productCode: 'PersonalAuto'
	            };
	            $state.go('quoteentry', details);
	        };
	        return ctrl.create($scope);
	    };
	
	    fn.$inject = ['$scope', '$stateParams', '$state', 'ModalService', '$q', 'ProducerContactService', '$rootScope'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn($scope, $rootScope, $state, $stateParams, $q, ViewModelService, PolicyService, UserAccountService, DefaultProductProvider, $location) {
	        var ctrl = Object.create(BaseCtrl);
	
	        ctrl.init = function () {
	
	            //console.log("IsValidZipCodeRequest: ",$rootScope.isValidZipCodeRequest);
	            // Prevent this page from directly accessing with url
	            // checking the $rootScope.accountDetails is undefined, which means 
	            // user not clicked continue button in the AccountLookup screen
	            // so redirect to account lookup screen
	            // CHG0031104 - Commented if statement
	            /*if ($rootScope.isValidZipCodeRequest){
	                delete $rootScope["isValidZipCodeRequest"];
	            }
	            else{
	                // account lookup screen
	                //$state.go("nextSteps", {});
	                $state.go("landingAccount", {});
	            }*/
	
	            var applicantDetails = {
	                effectiveDate: new Date(),
	                postalCode: '',
	                account: undefined,
	                productCode: undefined
	            };
	            $scope.view = ViewModelService.create(applicantDetails, 'pc', 'edge.capabilities.policycommon.availability.dto.PostalCodeAvailabilityRequestDTO');
	
	            $scope.activeSection = 'new';
	
	            // populate only the selected zip pane
	            function getZip(activeSection) {
	                return function () {
	                    return $scope.activeSection === activeSection ? $scope.view.postalCode.value : '';
	                };
	            }
	            function setZip(val) {
	                $scope.view.postalCode.value = val;
	            }
	
	            Object.defineProperties($scope, {
	                'zipNew': {
	                    get: getZip('new'),
	                    set: setZip
	                },
	                'zipRetrieve': {
	                    get: getZip('retrieve'),
	                    set: setZip
	                }
	            });
	
	            if ($stateParams.postalCode && $stateParams.quoteID) {
	                $scope.view.postalCode.value = $stateParams.postalCode;
	                $scope.quoteID = $stateParams.quoteID;
	            }
	
	            if ($stateParams.account) {
	                var policySummariesPromise = PolicyService.getAccountPolicySummaries('policy');
	                var accountSummaryPromise = UserAccountService.getAccountContactSummary();
	
	                $q.when(accountSummaryPromise, function (accountSummary) {
	                    $scope.view.value.account = accountSummary;
	                    $scope.view.value.account.subtype = 'Person';
	                    $scope.view.postalCode.value = accountSummary.primaryAddress.postalCode;
	                });
	
	                $q.when(policySummariesPromise, function (policySummaries) {
	                    $scope.view.productCode.value = DefaultProductProvider.getDefaultProduct(policySummaries);
	                });
	            }
	            //leadscloud test codes added -- Arpita
	            $scope.hideGetQuoteForLeadcloud = false;
	            $scope.$watch('location.search()', function () {
	                if ($location.search().jobNum) {
	                    $scope.view.quoteID = { value: $location.search().jobNum };
	                }
	                if ($location.search().zip) {
	                    $scope.zipRetrieve = $location.search().zip;
	                }
	                if ($location.search().jobNum && $location.search().zip) {
	                    $scope.hideGetQuoteForLeadcloud = true;
	                    $scope.activeSection = 'retrieve';
	                }
	            }, true);
	        };
	
	        ctrl.activateNewQuote = function () {
	            $scope.activeSection = 'new';
	        };
	
	        ctrl.activateRetrieveQuote = function () {
	            $scope.activeSection = 'retrieve';
	        };
	
	        ctrl.goToRetrieveQuote = function (form) {
	            form.submitted = true;
	            if (!$scope.view.postalCode.aspects.valid || !$scope.view.quoteID.value) {
	                return;
	            }
	
	            // check if quote id is not filled or undefined
	            // then display error message
	            if ($scope.view.quoteID.value == '' || $scope.view.quoteID.value == undefined) {
	                return;
	            }
	
	            $state.go('quoteentry', {
	                quoteID: $scope.view.quoteID.value,
	                postalCode: $scope.view.postalCode.value,
	                shouldUpdateEffectiveDate: true
	            }); //enter quote wizard
	        };
	
	        ctrl.goToNewQuote = function (form) {
	
	            // check account details is undefined
	            // CHG0031104 - Uncommented if statement
	            if ($rootScope.accountDetails == undefined) {
	                $rootScope.accountDetails = {
	                    accountHolder: {
	                        accountExists: false
	                    }
	                };
	            }
	
	            form.submitted = true;
	            if (!$scope.view.aspects.subtreeValid) {
	                return;
	            }
	            $state.go('quoteentry', $scope.view.value); //enter quote wizard
	        };
	
	        return ctrl.create($scope);
	    };
	
	    fn.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$q', 'ViewModelService', 'qnb.PolicyService', 'qnb.UserAccountService', 'qnb.DefaultProductProvider', '$location'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(451), __webpack_require__(390)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return ['$window', '$timeout', function ($window, $timeout) {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            require: 'gwQnbCustomQuote',
	            scope: {
	                standardOffering: '=',
	                customQuote: '=',
	                buy: '=',
	                sessionid: '=',
	                submissionid: '=',
	                header: '@',
	                biLimits: '@',
	                lob: '@',
	                nextSteps: '&'
	            },
	            controller: ['$scope', 'qnb.CustomQuoteService', '$q', '$filter', 'ModalService', 'ViewModelService', '$state', function ($scope, CustomQuoteService, $q, $filter, ModalService, ViewModelService, $state) {
	                var self = this;
	
	                $scope.view = ViewModelService.create($scope.customQuote, 'pc', 'edge.capabilities.quote.quoting.dto.QuoteDTO');
	
	                var jobNumber = $scope.view.quoteID.value;
	
	                $scope.syncCoverage = function () {
	                    $scope.quoteStatus.isStale = true;
	                    if (!self._validateInputFields()) {
	                        return;
	                    }
	
	                    $scope.quoteStatus.showLoading = true;
	                    $scope.quoteStatus.calculatingQuote = true;
	                    var operation = CustomQuoteService.updateCustomQuoteCoverages('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
	                    operation.then(function (quote) {
	                        $scope.customQuote.lobs = quote.lobs;
	                    });
	                    operation.catch(self._handleQuoteError);
	                    operation.finally(function () {
	                        $timeout(function () {
	                            $scope.quoteStatus.showLoading = false;
	                            $scope.quoteStatus.calculatingQuote = false;
	                            $scope.CustomQuoteForm.submitted = false;
	                        }, 3000);
	                    });
	                };
	
	                $scope.markStale = function () {
	                    $scope.quoteStatus.isStale = true;
	                };
	
	                $scope.buyQuote = function () {
	                    if (!self._validateInputFields()) {
	                        return;
	                    }
	                    $scope.buy.apply(null, arguments);
	                };
	
	                $scope.buyQuoteWithDefaultParams = function () {
	                    var termInMonths = $scope.customQuote.termMonths;
	                    $scope.buy($scope.customQuote, termInMonths);
	                };
	
	                this.updateQuote = function () {
	                    if (!$scope.quoteStatus.isStale || !$scope.customQuote.total || !self._validateInputFields()) {
	                        //disable action if coverage selections have not changed or we don't have an existing quote price
	                        return;
	                    }
	
	                    $scope.quoteStatus.calculatingQuote = true;
	                    $scope.quoteStatus.showLoading = true;
	
	                    var operation = CustomQuoteService.updateCustomQuote('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
	                    operation.then(function (updatedCustomQuote) {
	                        $scope.customQuote.lobs = updatedCustomQuote.lobs;
	                        $scope.customQuote.total = updatedCustomQuote.total;
	                        $scope.customQuote.monthlyPremium = updatedCustomQuote.monthlyPremium;
	                        $scope.customQuote.totalBeforeTaxes = updatedCustomQuote.totalBeforeTaxes;
	                        $scope.customQuote.taxes = updatedCustomQuote.taxes;
	                        $scope.quoteStatus.isStale = false;
	                    });
	                    operation.catch(self._handleQuoteError);
	                    operation.finally(function () {
	                        $scope.quoteStatus.calculatingQuote = false;
	                        $scope.quoteStatus.showLoading = false;
	                        $scope.CustomQuoteForm.submitted = false;
	                    });
	                };
	
	                function removeDuplicates(msg, text) {
	                    var msgArray = msg.split(text);
	                    if (msgArray.length === 1) return msg;
	                    var unique = [].concat(_toConsumableArray(new Set(msgArray)));
	                    var modifiedMsg = '';
	                    for (var count = 0; count < unique.length; count++) {
	                        if (unique[count].trim() !== '') {
	                            modifiedMsg = modifiedMsg + text + unique[count];
	                        }
	                    }
	                    return modifiedMsg;
	                }
	
	                this._handleQuoteError = function (error) {
	                    var message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
	                    var description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Sorry, but that coverage option is invalid, please select a different value');
	                    var errorMsg = description;
	                    if (error.constructor != Array && error.baseError.data.error.message != undefined && error.baseError.data.error.message.constructor != Array) {
	                        errorMsg = error.baseError.data.error.message;
	                        if (errorMsg.indexOf('Dwelling_HOE') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.Dwelling_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.Dwelling_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('HomeownersLine_HOE') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.HomeownersLine_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.HomeownersLine_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('PersonalAutoLine') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.PersonalAutoLine\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.PersonalAutoLine\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('PersonalVehicleCov') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.PersonalVehicleCov\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.PersonalVehicleCov\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('PersonalVehicle') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.PersonalVehicle\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.PersonalVehicle\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('PersonalAutoCov') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.PersonalAutoCov\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.PersonalAutoCov\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('HomeownersCovCost_HOE') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.HomeownersCovCost_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.HomeownersCovCost_HOE\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('PolicyPeriod') > -1) {
	                            if (errorMsg.indexOf('warning') > -1) {
	                                errorMsg = errorMsg.replace(/warning:entity.PolicyPeriod\//g, '<br>&#9679;&nbsp;');
	                            }
	                            if (errorMsg.indexOf('error') > -1) {
	                                errorMsg = errorMsg.replace(/error:entity.PolicyPeriod\//g, '<br>&#9679;&nbsp;');
	                            }
	                            errorMsg = errorMsg.replace(/;/g, '');
	                        }
	                        if (errorMsg.indexOf('DisplayableException') > -1) {
	                            errorMsg = errorMsg.replace(/gw.api.util.DisplayableException:/g, '<br>&#9679;&nbsp;');
	                        }
	                    }
	                    errorMsg = removeDuplicates(errorMsg, '<br>&#9679&nbsp');
	                    console.log(errorMsg);
	                    if (errorMsg.indexOf('out of state exposure') > 0) {
	                        $state.go('contactUs', { quoteID: jobNumber });
	                    } else {
	                        ModalService.showError(message, errorMsg);
	                    }
	
	                    // ModalService.showError(message, description);
	                    //console.log('Error updating custom quote', error);
	                };
	
	                /**
	                 * Checks that there are no invalid inputs or nested forms, displays a modal prompting the user to
	                 * fix errors.
	                 *
	                 * @returns {boolean}
	                 */
	                this._validateInputFields = function () {
	                    if (!$scope.view.aspects.subtreeValid) {
	                        var message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid input values');
	                        var description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Please correct input field errors');
	                        //ModalService.showError(message, description);
	                        //$scope.CustomQuoteForm.submitted = true;
	                        //return false;
	                    }
	                    //If the form is valid then reset the submitted value. So pristine fields are not marked with errors
	                    $scope.CustomQuoteForm.submitted = false;
	                    return true;
	                };
	
	                $scope.quoteStatus = {
	                    calculatingQuote: false,
	                    showLoading: false,
	                    displayed: false,
	                    isStale: false
	                };
	
	                $scope.$on('CustomQuoteSelected', function () {
	                    //have to wait until custom tab is selected and tab contents are visible
	                    $timeout(function () {
	                        $scope.quoteStatus.displayed = true;
	                    }, 50);
	                });
	
	                $scope.updateQuote = this.updateQuote;
	            }],
	            'link': function link(scope, elt) {
	                elt[0].addEventListener('change', function () {
	                    scope.quoteStatus.isStale = true;
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 451 */
/***/ function(module, exports) {

	module.exports = "<form name=\"CustomQuoteForm\" class=\"ng-class:{ 'gw-submitted': CustomQuoteForm.submitted }\" novalidate>\n    <div ng-if=\"!customQuote.lobs.commercialProperty\" class=\"gw-start-policy gw-message-overlay-container\">\n        <div ng-if=\"customQuote.lobs.personalAuto\"><b>{{header}}</b></div>\n        <div class=\"gw-quote-comparison-panel\" gw-qnb-quote-comparison-panel quote-status=\"quoteStatus\">\n            <div class=\"gw-quote-comparison-panel-inner\" ng-class=\"{'gw-single-quote': customQuote.lobs.personalAuto}\">\n                <div ng-if=\"standardOffering\" gw-qnb-quote-policy-box=\"standardOffering\" class=\"gw-panel-item gw-quote-box gw-standard-offering\"\n                     buy=\"buyQuote\" loading=\"quoteStatus.calculatingQuote\" next-steps=\"nextSteps()\"></div>\n                <div class=\"gw-custom-quote\" ng-class=\"{'gw-panel-item': !customQuote.lobs.personalAuto}\">\n                    <div ng-show=\"(quoteStatus.isStale || !customQuote.total) && !quoteStatus.calculatingQuote\"\n                         class=\"gw-message-overlay\">\n                        <div class=\"gw-overlay-banner\">{{'integration.quoteandbind.directives.custom-quote.Click on the calculate button to get a new price' | translate}}</div>\n                    </div>\n                    <div gw-qnb-quote-policy-box=\"customQuote\" class=\"gw-quote-box\"\n                         ng-class=\"{'displayed':quoteStatus.displayed}\" buy=\"buyQuote\"\n                         loading=\"quoteStatus.calculatingQuote\" next-steps=\"nextSteps()\"></div>\n\n                    <div class=\"gw-calculate-btn-wrapper\" ng-class=\"{'gw-displayed': quoteStatus.displayed}\">\n                        <div class=\"gw-calculate-btn ng-class: {true: 'gw-active', false: 'gw-disabled'}[(quoteStatus.isStale && !quoteStatus.calculatingQuote) || !customQuote.total]\"\n                             ng-click=\"quoteStatus.calculatingQuote || updateQuote()\">\n                            <i class=\"fa fa-3x fa-calculator\"></i>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"quoteStatus.calculatingQuote\" class=\"gw-message-overlay\">\n                    <div class=\"gw-overlay-banner\">{{'integration.quoteandbind.directives.custom-quote.A change has been made to your policy ...' | translate}}</div>\n                    <div class=\"gw-quote-box gw-center\">\n                        <button class=\"gw-bordered widthAuto\"\n                                ng-disabled=\"quoteStatus.calculatingQuote\">{{'integration.quoteandbind.directives.custom-quote.Recalculating Quote...' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"customQuote.lobs.personalAuto && biLimits\">\n        <span>{{'quoteandbind.controllers.QuoteDetails.Current.Liability.Limits' | translate}}</span><span>{{biLimits}}</span>\n    </div>\n\n    <div ng-if=\"customQuote.lobs.personalAuto\">\n        <div gw-qnb-pa-edit-coverages=\"view.lobs.personalAuto\" loading=\"quoteStatus.showLoading\"\n             on-cov-change=\"syncCoverage\" on-general-change=\"markStale\"></div>\n    </div>\n    <div ng-if=\"customQuote.lobs.homeowners\">\n        <div gw-qnb-ho-edit-coverages=\"view.lobs.homeowners\" loading=\"quoteStatus.showLoading\" lob=\"{{lob}}\"\n             on-cov-change=\"syncCoverage\" on-general-change=\"markStale\"></div>\n    </div>\n    <div ng-if=\"customQuote.lobs.commercialProperty\">\n        <div gw-qnb-quote-details-box=\"customQuote\" buy=\"buyQuote\"></div>\n        <div gw-qnb-coverage-premiums=\"view.lobs.commercialProperty\"></div>\n        <div gw-wizard-page-actions next=\"buyQuoteWithDefaultParams\" next-label=\"integration.quoteandbind.directives.custom-quote.BuyPolicy\"></div>\n    </div>\n</form>\n"

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(453), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, _) {
	    return [function () {
	
	        /*    CHG0031104 - Add OMEGA QnB link to SECU’s website
	            AB - April 05, 2020 */
	
	        var urlString = window.location.search.substring(1); // Extract argument string from url
	        var argArray = urlString.split('&'); // build array of url arugemnts
	        var argKeyValuePair = argArray[0].split('='); // pick the first row from argArray (Source)
	        var qnbSource = argKeyValuePair[1]; // pick the 2nd element
	        return {
	            scope: {
	                model: '=gwLobSelection',
	                form: '='
	            },
	            template: templateStr,
	            controller: ['$scope', 'lobConfig', function ($scope, lobConfig) {
	                var lobMap = { 'PersonalAuto': 'pa', 'Homeowners': 'ho' };
	
	                $scope.moreThanOneLob = false;
	                $scope.moreThanOneLob = lobConfig.lobs.length > 1;
	                if (qnbSource == "SECU") {
	                    $scope.moreThanOneLob = false;
	                }
	                $scope.selectLob = function (lob) {
	                    if (_.contains(lobConfig.lobs, lobMap[lob])) {
	                        $scope.model.productCode.value = lob;
	                    }
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-zip-form-group gw-lob-selection-form-group\">\n    <span class=\"gw-bullet-point\">2</span>\n\n    <div id=\"lobSelection\" class=\"gw-lob-selection-wrapper\">\n        <div class=\"gw-lob-type\">\n                    <div class=\"gw-lob-cell\"\n                         ng-class=\"{'gw-selected': model.productCode.value == 'PersonalAuto'}\"\n                         ng-click=\"selectLob('PersonalAuto', form)\">\n                        <i class=\"fa fa-3x fa-automobile\"></i>\n                    </div>\n                   <div ng-hide=\"moreThanOneLob == false\"\n                         class=\"gw-lob-cell\"\n                         ng-class=\"{'gw-selected': model.productCode.value=='Homeowners', disabled : !moreThanOneLob}\"\n                         ng-click=\"selectLob('Homeowners', form)\">\n                        <i class=\"fa fa-3x fa-home\" ng-disabled=\"moreThanOneLob == false\"></i>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"gw-error-zip gw-error-inline\" ng-class=\"{'gw-zip-hidden': !form.submitted || model.productCode.aspects.valid}\">\n            {{'quoteandbind.views.zip-code.Please select a policy type.' | translate }}\n        </div>\n\n    </div>\n</div>"

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(455), __webpack_require__(460), __webpack_require__(461)], __WEBPACK_AMD_DEFINE_RESULT__ = function (createSubflowsFromDefns, flowBegining, wireLOBSection) {
	    return ['AvailabilityService', 'qnb.LoadSaveService', '$q', 'TranslateService', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.ErrorHandlingService', function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService) {
	
	        function branchOnProductCode(paFlows, hoFlows, cpFlows, flowPropertyKey) {
	            var paTransition = paFlows[flowPropertyKey] ? paFlows[flowPropertyKey].entry : null;
	            var hoTransition = hoFlows[flowPropertyKey] ? hoFlows[flowPropertyKey].entry : null;
	            var cpTransition = null;
	            if (cpFlows) {
	                cpTransition = cpFlows[flowPropertyKey] ? cpFlows[flowPropertyKey].entry : null;
	            }
	
	            return function (_ref) {
	                var submission = _ref.value;
	
	                if (submission.draftData.productCode === 'PersonalAuto') {
	                    return paTransition;
	                }
	                if (submission.draftData.productCode === 'Homeowners') {
	                    return hoTransition;
	                }
	                if (submission.draftData.productCode === 'CommercialProperty') {
	                    return cpTransition;
	                }
	            };
	        }
	
	        return function (step, junction, flow) {
	
	            var subFlows = createSubflowsFromDefns(flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService);
	            //create complete flow by wiring up sub flows
	            flowBegining(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
	            wireLOBSection(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(349), __webpack_require__(456), __webpack_require__(457), __webpack_require__(458), __webpack_require__(459)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ApplicationFeatures, commonSubFlowDefnFactories, paFlowDefnFactory, hoFlowDefnFactory, cpFlowDefnFactory) {
	    return function (flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService) {
	
	        /**
	         * Convert object containing flow definitions into object containing sub flows
	         * @param subFlowDefns Object containing flow definitions
	         */
	        function createSubFlowsFromFlowDefns(subFlowDefns) {
	            var subFlowsContainer = {};
	            Object.keys(subFlowDefns).reduce(function (container, flowDefnKey) {
	                container[flowDefnKey] = flow(subFlowDefns[flowDefnKey]);
	                return container;
	            }, subFlowsContainer);
	            return subFlowsContainer;
	        }
	
	        var commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService);
	
	        var globalExits = flow(commonSubFlowDefns.globalExits);
	        var availabilityFlow = flow(commonSubFlowDefns.availabilityCheck);
	        var needToSaveCheckFlow = flow(commonSubFlowDefns.needToSaveCheck);
	        var paFlows = void 0;
	        var hoFlows = void 0;
	        var cpFlows = void 0;
	        //if the personal auto feature is enabled then create the PA flow
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
	            var paFlowDefns = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
	            paFlows = createSubFlowsFromFlowDefns(paFlowDefns);
	        }
	        //if the homeowners feature is enabled then create the HO flow
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
	            var hoFlowDefns = hoFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService);
	            hoFlows = createSubFlowsFromFlowDefns(hoFlowDefns);
	        }
	        //if the commercial property feature is enabled then create the CP flow
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
	            var cpFlowDefns = cpFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
	            cpFlows = createSubFlowsFromFlowDefns(cpFlowDefns);
	        }
	        var quoteFlow = flow(commonSubFlowDefns.quote);
	        var bindFlow = flow(commonSubFlowDefns.bindAndPay);
	
	        return {
	            exit: globalExits,
	            availability: availabilityFlow,
	            needToSaveCheck: needToSaveCheckFlow,
	            paFlows: paFlows,
	            hoFlows: hoFlows,
	            cpFlows: cpFlows,
	            quote: quoteFlow,
	            bind: bindFlow
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext, ErrorHandlingService) {
	        var translateFn = TranslateService.instant;
	
	        function wrappedLoadSave(action, model) {
	            var promise = action.call(undefined, null, model);
	            return promise.then(function (submissionDTO) {
	                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
	            });
	        }
	
	        function deleteCorruptNodeonCancel(model) {
	            //validate all the drivers that are in viewmodel
	            var corruptedDrivers = [];
	            var drivers = model.draftData.lobs.personalAuto.drivers;
	
	            if (typeof drivers != 'undefined' && drivers.length > 0) {
	
	                _.forEach(drivers, function (item, index) {
	                    if (!drivers.getElement(index).aspects.subtreeValid) {
	                        corruptedDrivers.push(drivers.getElement(index).value);
	                    }
	                });
	            }
	
	            _.forEach(corruptedDrivers, function (driver) {
	                model.draftData.lobs.personalAuto.value.removeDriver(driver);
	            });
	
	            //remove the vehicles also if all the drivers are removed
	            //validating vehicle node
	            if (typeof model.draftData.lobs.personalAuto.drivers != "undefined" && model.draftData.lobs.personalAuto.drivers.length === 0) {
	                model.draftData.lobs.personalAuto.vehicles.value = [];
	            }
	
	            var corruptedVehicles = [];
	
	            var vehicles = model.draftData.lobs.personalAuto.vehicles;
	            if (typeof vehicles != 'undefined' && vehicles.length > 0) {
	                _.forEach(vehicles, function (item, index) {
	                    if (!vehicles.getElement(index).aspects.subtreeValid) {
	                        corruptedVehicles.push(vehicles.getElement(index).value);
	                    }
	                });
	            }
	
	            _.forEach(corruptedVehicles, function (vehicle) {
	                model.draftData.lobs.personalAuto.value.removeVehicle(vehicle);
	            });
	        }
	
	        var ACTION_MSG = {
	            cancelPrompt: {
	                noSaveRequired: 'quoteandbind.common.config.FlowConfig.The information you have entered will not be saved',
	                saveDraft: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a draft quote submission',
	                saveOffering: 'quoteandbind.common.config.FlowConfig.The information previously entered will be stored as a quote submission'
	            },
	            checkAvailability: {
	                /*error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
	                    message: 'quoteandbind.common.config.FlowConfig.Sorry we are unable to quote for this location and start date.'
	                },
	                progress: {
	                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
	                    message: 'quoteandbind.common.config.FlowConfig.Checking if a quote can be provided for that location'
	                }*/
	                error: {
	                    title: 'quoteandbind.controllers.ZipCodeCtrl.Error',
	                    //message: 'quoteandbind.controllers.ZipCodeCtrl.We do not recognize the zipcode entered, please try again.'
	                    message: 'It seems you have entered a zip code not within the region of AAA Carolinas. Please try again or click ' + '<a target="_blank" href="http://www.aaa.com/stop">here</a>' + ' and reenter your zip code to find the AAA Club in your state.'
	                },
	                progress: {
	                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
	                    message: 'quoteandbind.controllers.ZipCodeCtrl.Checking for availability in your state...'
	                },
	                systemdown: {
	                    title: 'quoteandbind.controllers.ZipCodeCtrl.Error',
	                    message: 'quoteandbind.controllers.ZipCodeCtrl.PC system down error'
	                }
	
	            },
	            checkPeriodStartDateChanged: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to request a quote',
	                    message: 'quoteandbind.common.config.FlowConfig.Sorry coverage is not available for the effective date specified.'
	                },
	                progress: {
	                    title: 'quoteandbind.common.config.FlowConfig.Checking product availability',
	                    message: 'quoteandbind.common.config.FlowConfig.Checking if coverage is available for that date.'
	                }
	            },
	            createSubmission: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to create submission',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to create the quote submission.'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Creating a new quote submission...'
	                }
	            },
	            saveSubmission: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Saving quote submission details...'
	                }
	            },
	            saveAndQuoteSubmission: {
	
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
	                }
	            },
	            bindSubmission: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to purchase quote',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to bind your quote submission'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Processing Payment...'
	                }
	            }
	        };
	        var ACTIONS = {
	            checkAvailability: function checkAvailability(model, availabilityRequest) {
	                //wrap the availablity check promise in a promise that returns the model with the policy address set
	                return new $q(function (resolve, reject) {
	                    var availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode(null, availabilityRequest);
	                    availabilityPromise.then(function (availabilityResp) {
	                        if (!availabilityResp.isAvailable) {
	                            reject();
	                        }
	                        // Set the policy address using the availability response if no address has been set yet
	                        if (!angular.isDefined(model.draftData.policyAddress.value)) {
	                            model.draftData.policyAddress.value = availabilityResp.addressCompletion;
	                        }
	                        resolve(model);
	                    }, function (error) {
	                        reject(error);
	                    });
	                });
	            },
	            cancel: function cancel(model) {
	                if (!model.quoteID.value) {
	                    //no submission was created so just exit without saving
	                    return $q.resolve(model);
	                }
	                if (!model.quoteData.value) {
	                    if (model.draftData.productCode.value === 'PersonalAuto') {
	                        deleteCorruptNodeonCancel(model);
	                    }
	                    return LoadSaveService.saveSubmission(null, model.value);
	                }
	                return LoadSaveService.saveQuotedSubmission(null, model.value);
	            },
	            createSubmission: function createSubmission(_ref) {
	                var submission = _ref.value;
	                return wrappedLoadSave(LoadSaveService.createSubmission, submission);
	            },
	            saveDraftSubmission: function saveDraftSubmission(_ref2) {
	                var submission = _ref2.value;
	                return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
	            },
	            saveQuotedSubmission: function saveQuotedSubmission(_ref3) {
	                var submission = _ref3.value;
	                return wrappedLoadSave(LoadSaveService.saveQuotedSubmission, submission);
	            },
	            saveAndQuoteSubmission: function saveAndQuoteSubmission(_ref4) {
	                var submission = _ref4.value;
	                return wrappedLoadSave(LoadSaveService.saveAndQuoteSubmission, submission);
	            },
	            bindSubmission: function bindSubmission(_ref5) {
	                var submission = _ref5.value;
	                return wrappedLoadSave(LoadSaveService.bindSubmission, submission);
	            }
	        };
	
	        return {
	            globalExits: function globalExits(step, junction) {
	                junction('error');
	
	                junction('returnHome');
	
	                junction('cancel').data({
	                    confirmationMsg: function confirmationMsg(model) {
	                        if (!model.quoteID.value) {
	                            return ACTION_MSG.cancelPrompt.noSaveRequired;
	                        }
	                        if (!model.quoteData.value) {
	                            return ACTION_MSG.cancelPrompt.saveDraft;
	                        }
	                        return ACTION_MSG.cancelPrompt.saveOffering;
	                    }
	                }).onNext.doAction(ACTIONS.cancel, ACTION_MSG.saveSubmission).thenGoTo('returnHome', 'error');
	            },
	            availabilityCheck: function availabilityCheck(step, junction) {
	                junction('checkAvailability', true).onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkAvailability).thenGoTo('productAvailable', 'error');
	
	                junction('productAvailable');
	            },
	            needToSaveCheck: function needToSaveCheck(step, junction) {
	                junction('checkNewSubmissionOrIfPeriodStartDateHasChanged', true).onNext.branch(function (model, args) {
	                    if (!model.quoteID.value) {
	                        return 'newSubmission';
	                    }
	                    if (args.periodStartDateChanged) {
	                        return 'periodStartDateChanged';
	                    }
	                    return 'needToSaveCheckSuccess';
	                });
	
	                junction('newSubmission').onNext.doAction(ACTIONS.createSubmission, ACTION_MSG.createSubmission).thenGoTo('needToSaveCheckSuccess', 'error');
	
	                junction('periodStartDateChanged').onNext.doAction(ACTIONS.checkAvailability, ACTION_MSG.checkPeriodStartDateChanged).thenGoTo('needToSaveCheckSuccess', 'error');
	
	                junction('needToSaveCheckSuccess');
	            },
	            quote: function quote(step, junction) {
	                junction('generateQuote', true).onNext.doAction(ACTIONS.saveAndQuoteSubmission, ACTION_MSG.saveAndQuoteSubmission).thenGoTo('quoteDetails', 'quoteFail'); //US-10685, mofified to allow user to edit.
	
	                step('quoteDetails').onNext.doAction(ACTIONS.saveQuotedSubmission, ACTION_MSG.saveSubmission).thenBranch(function (_ref6) {
	                    var submission = _ref6.value;
	
	                    if (submission.draftData.productCode == 'Homeowners') {
	                        return 'nextSteps';
	                    } else {
	                        return 'offeringSelected';
	                    }
	                }, function () {
	                    return 'quoteDetails';
	                }) //US-10685, mofified to allow user to edit.
	                /*).thenGoTo('offeringSelected', 'error')*/
	                .skipOnResumeIf(function () {
	                    return false;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Quote');
	                });
	
	                junction('offeringSelected');
	                junction('nextSteps');
	
	                junction('quoteFail').onNext.branch(function (model, args) {
	                    //ENHC0012054- Property / Update Eligibility for Protection Class 10 and 10W - added homeownder condition for display error msg - Arpita
	                    if (model.draftData.productCode.value == 'Homeowners') {
	                        return ErrorHandlingService.getQuoteExceptionHandler(args, model);
	                    } else if (model.draftData.productCode.value == 'PersonalAuto') {
	                        return ErrorHandlingService.getQuoteExceptionHandler(args, model);
	                    } else {
	                        return 'error';
	                    }
	                });
	            },
	            bindAndPay: function bindAndPay(step, junction) {
	                step('paymentDetails', true).onNext.goTo('paymentConfirmation').skipOnResumeIf(function (model) {
	                    return model.selectedPaymentPlan.value;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Payment Details');
	                });
	
	                step('paymentConfirmation').onNext.doAction(ACTIONS.bindSubmission, ACTION_MSG.bindSubmission).thenGoTo('confirmation', 'bindFail').skipOnResumeIf(function (model) {
	                    return model.selectedPaymentPlan.value;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Payment Confirmation');
	                });
	
	                junction('bindFail').onNext.branch(function (model, args) {
	                    return ErrorHandlingService.getBindExceptionHandler(args, model);
	                });
	
	                junction('confirmation');
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext) {
	        var translateFn = TranslateService.instant;
	
	        var ACTION_MSGS = {
	            saveSubmission: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Saving quote submission details...'
	                }
	            }
	        };
	
	        var ACTIONS = {
	            saveDraftSubmission: function saveDraftSubmission(_ref) {
	                var submission = _ref.value;
	                return LoadSaveService.saveSubmission(null, submission).then(function (submissionDTO) {
	                    return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
	                });
	            }
	        };
	
	        return {
	            contactDetails: function contactDetails(step, junction) {
	                step('paContactDetails', true).onNext.branch(function (model) {
	                    // If we come from quick quote go to intermediate step which will save the submission, otherwise
	                    // carry on as normal to the next state.
	                    return model.quoteID.value ? 'paQuickQuotePostContactDetails' : 'paContactDetailsComplete';
	                }).skipOnResumeIf(function (_ref2) {
	                    var submission = _ref2.value;
	                    return submission.persons[0].emailAddress1 && submission.persons[0].firstName !== '0streamlinedquote0';
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Your Info');
	                });
	
	                junction('paQuickQuotePostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('paContactDetailsComplete', 'error');
	
	                junction('paContactDetailsComplete');
	            },
	            coverables: function coverables(step, junction) {
	                step('paPrequalQuestions', true).onNext.goTo('paMembership').skipOnResumeIf(function (_ref3, _ref4) {
	                    var submission = _ref3.value;
	                    var agentportalnewsubmission = _ref4.agentportalnewsubmission;
	                    return submission.draftData.lobs.personalAuto.preQualQuestionSets && !agentportalnewsubmission;
	                }).isValid(function (model, isFormValid) {
	                    return model.aspects.valid && model.aspects.subtreeValid && isFormValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Qualification');
	                });
	
	                step('paMembership').onNext.goTo('paPrevCarrierInfo')
	                /*.isValid(model => model.aspects.valid && model.aspects.subtreeValid)*/
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Membership');
	                });
	
	                step('paPrevCarrierInfo').onNext.goTo('paDriverVehiclePrefillInfo').skipOnResumeIf(function (_ref5) {
	                    var submission = _ref5.value;
	                    return submission.draftData.lobs.personalAuto.prevCarrierInfo && !agentportalnewsubmission;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.PreviousCarrierInfo');
	                });
	
	                step('paDriverVehiclePrefillInfo').onNext.goTo('paDriverDetails')
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.PrefilledDriverVehicle');
	                });
	
	                step('paDriverDetails').onNext.goTo('paVehicleDetails').skipOnResumeIf(function (_ref6) {
	                    var submission = _ref6.value;
	                    return submission.draftData.lobs.personalAuto.drivers[0] && submission.draftData.lobs.personalAuto.drivers[0].licenseNumber && submission.draftData.lobs.personalAuto.drivers[0].licenseNumber !== '0streamlinedquote0';
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Drivers');
	                });
	
	                step('paVehicleDetails').onNext.goTo('paCoverablesComplete').skipOnResumeIf(function (_ref7) {
	                    var submission = _ref7.value;
	                    return submission.draftData.lobs.personalAuto.vehicles[0] && submission.draftData.lobs.personalAuto.vehicles[0].license && submission.quoteData && submission.quoteData.offeredQuotes && submission.draftData.lobs.personalAuto.vehicles[0].vin !== '0streamlinedquote0';
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Vehicles');
	                });
	
	                junction('paCoverablesComplete');
	            },
	            moreInfo: function moreInfo(step, junction) {
	                step('paPolicyInfo', true).onNext.goTo('paPolicySummary').skipOnResumeIf(function (_ref8) {
	                    var submission = _ref8.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Policy Info');
	                });
	
	                step('paPolicySummary').onNext.goTo('paEsignature')
	                //.onNext.goTo('paMoreInfoComplete')                
	                .skipOnResumeIf(function (_ref9) {
	                    var submission = _ref9.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Policy Summary');
	                });
	
	                step('paEsignature').onNext.goTo('paMoreInfoComplete').skipOnResumeIf(function (_ref10) {
	                    var submission = _ref10.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.E-Signature');
	                });
	
	                junction('paMoreInfoComplete');
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return function (AvailabilityService, LoadSaveService, $q, TranslateService) {
	        var translateFn = TranslateService.instant;
	
	        return {
	            contactDetails: function contactDetails(step, junction) {
	                step('hoContactDetails', true).onNext.goTo('hoContactDetailsComplete').skipOnResumeIf(function (_ref) {
	                    var submission = _ref.value;
	                    return submission.persons[0].emailAddress1;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Your Info');
	                });
	
	                junction('hoContactDetailsComplete');
	            },
	            //This is commented now for pre-qual questions
	            //May need a check for portal agent ***Start****
	            coverables: function coverables(step, junction) {
	                step('hoPrequalQuestions', true).onNext.goTo('hoMembership').skipOnResumeIf(function (_ref2, _ref3) {
	                    var submission = _ref2.value;
	                    var agentportalnewsubmission = _ref3.agentportalnewsubmission;
	
	                    if (agentportalnewsubmission) {
	                        return false;
	                    }
	                    if (submission.draftData.lobs.homeowners.preQualQuestionSets) {
	                        var answerValues = _.values(submission.draftData.lobs.homeowners.preQualQuestionSets[0].answers);
	                        return answerValues.some(function (value) {
	                            return value !== null;
	                        });
	                    }
	                    return false;
	                }).isValid(function (model, formValid) {
	                    return model.aspects.valid && model.aspects.subtreeValid && formValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Qualification');
	                });
	                //***end****
	                step('hoMembership').onNext.goTo('hoAdditionalInfo').skipOnResumeIf(function (_ref4) {
	                    var submission = _ref4.value;
	                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.occupancy;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Membership');
	                });
	
	                step('hoAdditionalInfo').onNext.goTo('hoYourHome').skipOnResumeIf(function (_ref5) {
	                    var submission = _ref5.value;
	                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.hoAdditionalInfo;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
	                });
	
	                step('hoYourHome').onNext.goTo('hoConstruction').skipOnResumeIf(function (_ref6) {
	                    var submission = _ref6.value;
	                    return submission.draftData.lobs.homeowners.yourHome && submission.draftData.lobs.homeowners.yourHome.hoYourHome;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
	                });
	
	                step('hoConstruction').onNext.goTo('hoRating').skipOnResumeIf(function (_ref7) {
	                    var submission = _ref7.value;
	                    return submission.draftData.lobs.homeowners.construction;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.ho.wizard.step.Your Home');
	                });
	
	                step('hoRating').onNext.goTo('hoCoverablesComplete').skipOnResumeIf(function (_ref8) {
	                    var submission = _ref8.value;
	                    return submission.draftData.lobs.homeowners.rating && submission.quoteData;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.ho.wizard.step.Discount');
	                });
	
	                junction('hoCoverablesComplete');
	            } /*,
	                     moreInfo: (step, junction) => {
	                         step('hoPolicyInfo', true)
	                         .onNext.goTo('hoMoreInfoComplete')
	                         .skipOnResumeIf(({value: submission}) => submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1)
	                         .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                         .label(() => translateFn('quoteandbind.wizard.step.Policy Info'));
	                  junction('hoMoreInfoComplete');
	              }*/
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 459 */
/***/ function(module, exports) {



/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (subFlows, branchOnProductCodeFn) {
	
	        return function (step, junction) {
	
	            //start with the availability check if not in agent quote
	            junction(subFlows.availability.entry, true);
	
	            subFlows.availability.exits.productAvailable.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, 'contactDetails'));
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (subFlows, branchOnProductCodeFn) {
	        //this function will get passed step,junction and flow parameters but we here we are not creating any new steps
	        // or junctions just to wiring up entry and exits so they are not needed.
	        return function () {
	            if (subFlows.paFlows) {
	                subFlows.paFlows.contactDetails.exits.paContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
	                subFlows.paFlows.coverables.exits.paCoverablesComplete.onNext.goTo(subFlows.quote.entry);
	                subFlows.paFlows.moreInfo.exits.paMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
	            }
	
	            if (subFlows.hoFlows) {
	                subFlows.hoFlows.contactDetails.exits.hoContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
	                subFlows.hoFlows.coverables.exits.hoCoverablesComplete.onNext.goTo(subFlows.quote.entry);
	                //subFlows.hoFlows.moreInfo.exits.hoMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
	            }
	
	            if (subFlows.cpFlows) {
	                subFlows.cpFlows.coverables.exits.cpCoverablesComplete.onNext.goTo(subFlows.quote.entry);
	                subFlows.cpFlows.moreInfo.exits.cpMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
	            }
	
	            subFlows.needToSaveCheck.exits.needToSaveCheckSuccess.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, 'coverables'));
	
	            subFlows.quote.exits.offeringSelected.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, 'moreInfo'));
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return [function () {
	        return {
	            /**
	             * Checks the existing policies in the policy summaries provided and returns a default
	             * product line that should be sold, based on the existing policy lines
	             * @param policySummaries
	             * @returns {*}
	             */
	            getDefaultProduct: function getDefaultProduct(policySummaries) {
	                var hasPersonalAutoPolicy = lineExistsInPolicySummaries(policySummaries, 'PersonalAutoLine');
	                var hasHomeownersPolicy = lineExistsInPolicySummaries(policySummaries, 'HomeownersLine_HOE');
	
	                if (hasHomeownersPolicy && !hasPersonalAutoPolicy) {
	                    return 'PersonalAuto';
	                } else if (hasPersonalAutoPolicy && !hasHomeownersPolicy) {
	                    return 'Homeowners';
	                }
	
	                return undefined;
	            }
	        };
	
	        /**
	         * Checks all periods for all policies in the given policy summaries
	         * to see if the given line exists in any period
	         */
	        function lineExistsInPolicySummaries(policySummaries, line) {
	            return policySummaries.filter(function (policy) {
	                return policy.periods.filter(function (policyPeriod) {
	                    return policyPeriod.lines.includes(line);
	                }).length > 0;
	            }).length > 0;
	        }
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(389), __webpack_require__(471), __webpack_require__(465), __webpack_require__(466), __webpack_require__(467), __webpack_require__(468), __webpack_require__(469), __webpack_require__(470), __webpack_require__(464), __webpack_require__(472), __webpack_require__(507), __webpack_require__(508), __webpack_require__(510), __webpack_require__(511), __webpack_require__(513)], __WEBPACK_AMD_DEFINE_RESULT__ = function (VinLookupService, AvailabilityService, AddressLookupService, AccountLookupService, MembershipService, ProducerContactService, ViewDiscountsService, MVRClueService, PrefillService, InMemorySession, DriverProcessService, PaymentDateSelector, CustomPaymentService) {
	    return angular.module('edge.policyjob.app', ['portal.config', 'edge.platform.base']).factory('VinLookupService', VinLookupService).factory('AvailabilityService', AvailabilityService).factory('AddressLookupService', AddressLookupService).factory('AccountLookupService', AccountLookupService).factory('MembershipService', MembershipService).factory('ProducerContactService', ProducerContactService).factory('ViewDiscountsService', ViewDiscountsService).factory('MVRClueService', MVRClueService).factory('PrefillService', PrefillService).factory('InMemorySession', InMemorySession).factory('DriverProcessService', DriverProcessService).factory('CustomPaymentService', CustomPaymentService).directive('gwPaymentDateSelector', PaymentDateSelector).constant('encryptedBase64Key', {
	        value: '2b7e151628aed2a6abf7158809cf4f3c'
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['JsonRPCService', function (JsonRPCService) {
	        return {
	            getDriverVehiclePrefillData: function getDriverVehiclePrefillData(prefillReq) {
	                return JsonRPCService.send('prefill', 'prefill', 'getPrefill', [prefillReq]);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            autofillBasedOnAdddress: function autofillBasedOnAdddress(callGroups, address) {
	                var deferred = $q.defer();
	                JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingString', [address], callGroups).then(function (addressResult) {
	                    return deferred.resolve(addressResult);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	            autofillBasedOnPostalCode: function autofillBasedOnPostalCode(callGroups, address) {
	                var deferred = $q.defer();
	                JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingObject', [address], callGroups).then(function (addressResult) {
	                    return deferred.resolve(addressResult);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            accountLookupBasedOnDob: function accountLookupBasedOnDob(callGroups, accountLookupRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('accountlookup', 'accountlookup', 'isAccountAvailable', [accountLookupRequestDTO], callGroups).then(function (accountLookupResponseDTO) {
	                    return deferred.resolve(accountLookupResponseDTO);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 29-06-2016.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            isMember: function isMember(callGroups, MembershipRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('membership', 'membership', 'isMember', [MembershipRequestDTO], callGroups).then(function (MembershipServiceResponse) {
	                    return deferred.resolve(MembershipServiceResponse);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['JsonRPCService', function (JsonRPCService) {
	        return {
	            getProducerContactSummary: function getProducerContactSummary() {
	                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummary', []);
	            },
	            getProducerContactSummaryByQuoteId: function getProducerContactSummaryByQuoteId(quoteId) {
	                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummaryByQuoteId', [quoteId]);
	            },
	            getProducerContactSummaryByPolicyNumber: function getProducerContactSummaryByPolicyNumber(policyNumber) {
	                return JsonRPCService.send('pc', 'profileinfo/producer', 'getProducerContactSummaryByPolicyNumber', [policyNumber]);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Venkata.Pittam on 07-10-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            getDiscounts: function getDiscounts(ViewDiscountsRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('discounts', 'discounts', 'getDiscounts', [ViewDiscountsRequestDTO]).then(function (ViewDiscountsServiceResponse) {
	                    return deferred.resolve(ViewDiscountsServiceResponse);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Venkata.Pittam on 11-10-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            orderMVRClue: function orderMVRClue(MVRClueRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('mvrclue', 'mvrclue', 'orderMVRClue', [MVRClueRequestDTO]).then(function (MVRServiceResponse) {
	                    return deferred.resolve(MVRServiceResponse);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	        return {
	            checkAvailabilityBasedOnPostalCode: function checkAvailabilityBasedOnPostalCode(callGroups, availabilityRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('availability', 'availability', 'isProductAvailableBasedOnPostalCode', [availabilityRequestDTO], callGroups).then(function (availabilityResponseDTO) {
	                    return deferred.resolve(availabilityResponseDTO);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            },
	
	            checkAvailabilityBasedOnAddress: function checkAvailabilityBasedOnAddress(callGroups, availabilityRequestDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('availability', 'availability', 'isProductAvailableBasedOnAddress', [availabilityRequestDTO], callGroups).then(function (response) {
	                    var availabilityResponseDTO = response;
	                    return deferred.resolve(availabilityResponseDTO);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['encryptedBase64Key', function (decryptKey) {
	        var _bilimits;
	        var _prefilldata;
	        return {
	            setBiLimits: function setBiLimits(bilimit) {
	                _bilimits = bilimit;
	            },
	            getBiLimits: function getBiLimits() {
	                return _bilimits;
	            },
	            setPrefillData: function setPrefillData(prefilldata) {
	                _prefilldata = prefilldata ? prefilldata : null;
	            },
	            getPrefillData: function getPrefillData() {
	                return _prefilldata ? _prefilldata : null;
	            },
	            decryptData: function decryptData(encryptedText) {
	                if (!encryptedText) {
	                    return "";
	                }
	                var CryptoJS = __webpack_require__(473); // importing the crypto js
	                var encryptedBase64Key = decryptKey.value; // base64 conversion key
	                var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
	                var encryptedCipherText = encryptedText; // or encryptedData;
	                var decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
	                    mode: CryptoJS.mode.ECB,
	                    padding: CryptoJS.pad.Pkcs7
	                });
	                // this is the decrypted data as a string
	                return decryptedData.toString(CryptoJS.enc.Utf8);
	            },
	            encryptData: function encryptData(plaintText) {
	                if (!plaintText) {
	                    return "";
	                }
	                var CryptoJS = __webpack_require__(473); // importing the crypto js
	                var encryptedBase64Key = decryptKey.value; // base64 conversion key
	                var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
	                // this is Base64-encoded encrypted data
	                var encryptedData = CryptoJS.AES.encrypt(plaintText, parsedBase64Key, {
	                    mode: CryptoJS.mode.ECB,
	                    padding: CryptoJS.pad.Pkcs7
	                });
	                return encryptedData;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(475), __webpack_require__(476), __webpack_require__(477), __webpack_require__(478), __webpack_require__(479), __webpack_require__(480), __webpack_require__(481), __webpack_require__(482), __webpack_require__(483), __webpack_require__(484), __webpack_require__(485), __webpack_require__(486), __webpack_require__(487), __webpack_require__(488), __webpack_require__(489), __webpack_require__(490), __webpack_require__(491), __webpack_require__(492), __webpack_require__(493), __webpack_require__(494), __webpack_require__(495), __webpack_require__(496), __webpack_require__(497), __webpack_require__(498), __webpack_require__(499), __webpack_require__(500), __webpack_require__(501), __webpack_require__(502), __webpack_require__(503), __webpack_require__(504), __webpack_require__(505), __webpack_require__(506));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(481));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(475));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    var Wih = Wi.high = M[offset + i * 2]     | 0;
		                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    var Wil = gamma0l + Wi7l;
		                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    var Wil = Wil + gamma1l;
		                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    var Wil = Wil + Wi16l;
		                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(475), __webpack_require__(483));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(475));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(480), __webpack_require__(487));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(480), __webpack_require__(487));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                var block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(489));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                var block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                var block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                var modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                var modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                var wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                var salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            var keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            var keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		            i--;
		        }
		        data.sigBytes = i + 1;
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(478), __webpack_require__(479), __webpack_require__(489), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(478), __webpack_require__(479), __webpack_require__(489), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
		            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
		            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(478), __webpack_require__(479), __webpack_require__(489), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(478), __webpack_require__(479), __webpack_require__(489), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(474), __webpack_require__(478), __webpack_require__(479), __webpack_require__(489), __webpack_require__(490));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return ['JsonRPCService', function (JsonRPCService) {
	
	        var driverProcessService = {};
	
	        driverProcessService.getCategoryList = function () {
	            return {
	                accident: "Accident",
	                claim: "Claim",
	                voilation: "Violation"
	            };
	        };
	
	        driverProcessService.getAccidentList = function () {
	            return {
	                a: "Hit a parked car/hit another vehicle while backing up",
	                b: "Hit a pedestrian/cyclist",
	                c: "Hit a stationary object (other than a parked car)",
	                d: "Rear-ended another vehicle",
	                e: "Vehicle hit while merging/sideswiped",
	                f: "Intersection accident",
	                g: "My vehicle was rear-ended",
	                h: "My vehicle was hit while parked",
	                i: "My vehicle overturned",
	                j: "Other accident" /*,
	                                    k: "Windshield or glass damage",
	                                    l: "Towing and labor",
	                                    m: "Hit an animal",
	                                    n: "Other claim (fire, theft, vandalism, etc.)"*/
	            };
	        };
	
	        driverProcessService.getClaimList = function () {
	            return {
	                a: "Windshield or glass damage",
	                b: "Towing and labor",
	                c: "Hit an animal",
	                d: "Other claim (fire, theft, vandalism, etc.)"
	            };
	        };
	
	        driverProcessService.getVoilationList = function () {
	            return {
	                a: "Moving Violation (failure to yield, stop sign/light violation, etc.)",
	                b: "Major Violation (driving while license suspended, driving while intoxicated, etc.)",
	                c: "Speeding (1-15 MPH over posted limit)",
	                d: "Speeding (16+ MPH over posted limit)"
	            };
	        };
	
	        driverProcessService.getAssociationList = function () {
	            return {
	                a: "American Legion/Legionnaires",
	                b: "AARP",
	                c: "BASS/Bassmaster",
	                d: "Carpenters Union",
	                e: "COSTCO",
	                f: "Sam's Club",
	                g: "Credit Union",
	                h: "National Guard",
	                i: "National Notary Association",
	                j: "NRA",
	                k: "Rural Letter Carriers",
	                l: "USC Alumni",
	                m: "None"
	            };
	        };
	
	        driverProcessService.getAgeInYears = function (dateOfBirth) {
	
	            var birthDate = new Date(dateOfBirth.year, dateOfBirth.month, dateOfBirth.day);
	            var birthYear = birthDate.getFullYear();
	            var birthMonth = birthDate.getMonth();
	            var birthDay = birthDate.getDate();
	
	            var currentDate = new Date();
	            var currentYear = currentDate.getFullYear();
	            var currentMonth = currentDate.getMonth();
	            var currentDay = currentDate.getDate();
	
	            var age = currentYear - birthYear;
	            var ageMonth = currentMonth - birthMonth;
	            var ageDay = currentDay - birthDay;
	
	            if (ageMonth < 0 || ageMonth == 0 && ageDay < 0) {
	                age = parseInt(age) - 1;
	            }
	
	            return age;
	        };
	
	        driverProcessService.getDriverExperience = function (dateOfBirth, ageFirstLicensed) {
	
	            //console.log("getDriverExperience::dateOfBirth ",dateOfBirth);
	
	            var currentAge = driverProcessService.getAgeInYears(dateOfBirth);
	
	            var drivingExperience = currentAge - ageFirstLicensed;
	
	            return drivingExperience;
	        };
	
	        driverProcessService.calcYearFirstLicensed = function (dateOfBirth, ageFirstLicensed) {
	
	            var drivingExperience = driverProcessService.getDriverExperience(dateOfBirth, ageFirstLicensed);
	
	            var currentDate = new Date();
	            var currentYear = currentDate.getFullYear();
	            var yearFirstLicensed = currentYear - drivingExperience;
	
	            return yearFirstLicensed;
	        };
	
	        driverProcessService.getVehicleUsageList = function () {
	            return {
	                "principal": "More than 50%",
	                "occasional": "Less than 50%"
	            };
	        };
	
	        // Get realation ship list
	        driverProcessService.getRelationShipList = function () {
	            return {
	                "Spouse": "Spouse",
	                "Child": "Child",
	                "Relative": "Relative",
	                "OtherParty": "Other"
	            };
	        };
	
	        // Get description code
	        driverProcessService.getDescCode = function (description, stateCode) {
	
	            var descriptionList = driverProcessService.getAccidentDescription();
	            var descStateCodes = descriptionList[stateCode];
	
	            for (var key in descStateCodes) {
	                //console.log("key", key, descStateCodes[key], description);
	                if (descStateCodes[key] === description) {
	                    return key;
	                }
	            }
	
	            return null;
	        };
	
	        // Map pc accident/claim/voilation description for portal
	        driverProcessService.mapAccidentListToPortal = function (accidentVoilationList, stateCode) {
	
	            //console.log("MapAccidentListToPortal In:: ", accidentVoilationList, stateCode);
	            var portalAccidentVoilationList = [];
	
	            if (accidentVoilationList == undefined || accidentVoilationList.length == 0) {
	                return portalAccidentVoilationList;
	            }
	
	            for (var idx in accidentVoilationList) {
	
	                var accidentVoilation = accidentVoilationList[idx];
	                var descriptionPcCode = driverProcessService.getDescCode(accidentVoilation.description, stateCode);
	                //console.log("descriptionPcCode:: ",accidentVoilation.description, descriptionPcCode);
	                var category = driverProcessService.getPortalCategory(stateCode, descriptionPcCode);
	                var categoryType = driverProcessService.getPortalCategoryType(stateCode, descriptionPcCode);
	                var dateOfEvent = accidentVoilation.dateOfEvent;
	                var amount = accidentVoilation.amount;
	
	                portalAccidentVoilationList.push({
	                    category: category,
	                    publicID: accidentVoilation.publicID,
	                    type: categoryType,
	                    amount: amount,
	                    pcDescription: accidentVoilation.description,
	                    description: accidentVoilation.description,
	                    date: dateOfEvent,
	                    editing: false,
	                    remove: false
	                });
	            }
	
	            //console.log("MapAccidentListToPortal Out:: ", portalAccidentVoilationList);
	
	            return portalAccidentVoilationList;
	        };
	
	        // Map portal accident/claim/voilation description for PC
	        driverProcessService.mapAccidentListToPC = function (accidentVoilationList, stateCode) {
	
	            //console.log("MapAccidentListToPC In::",accidentVoilationList);
	
	            var descriptionList = driverProcessService.getAccidentDescription();
	            var pcAccidentVoilationList = [];
	
	            for (var idx in accidentVoilationList) {
	
	                var accidentVoilation = accidentVoilationList[idx];
	                var descriptionCode = null;
	                //console.log("accidentVoilation ",accidentVoilation)
	
	                if (accidentVoilation.category == "accident") {
	                    if (accidentVoilation.type != null && accidentVoilation.type != undefined) {
	                        descriptionCode = driverProcessService.getAccidentDescriptionForPC(accidentVoilation.type, accidentVoilation.amount, accidentVoilation.date, stateCode);
	                    } else {
	                        descriptionCode = accidentVoilation.pcDescription;
	                    }
	                } else if (accidentVoilation.category == "claim") {
	                    descriptionCode = driverProcessService.getClaimDescriptionForPC(accidentVoilation.type, accidentVoilation.amount, stateCode);
	                } else if (accidentVoilation.category == "voilation") {
	                    descriptionCode = driverProcessService.getVoilationDescriptionForPC(accidentVoilation.type, stateCode);
	                }
	
	                var desc = descriptionList[stateCode][descriptionCode];
	
	                accidentVoilation.pcDescription = desc;
	
	                pcAccidentVoilationList.push({
	                    publicID: accidentVoilation.publicID,
	                    dateOfEvent: accidentVoilation.date,
	                    description: desc,
	                    category: accidentVoilation.category,
	                    amount: accidentVoilation.amount,
	                    type: accidentVoilation.type
	                });
	            }
	
	            //console.log("MapAccidentListToPC Out::", pcAccidentVoilationList);
	
	            return pcAccidentVoilationList;
	        };
	
	        // Accident Category Portal Mapping
	        driverProcessService.getPortalCategory = function (stateCode, descriptionCode) {
	
	            // For NC
	            // Accident: F35, F38, F39, F40, F41, F42
	            // Claim: F36, F37
	            // Voilation: A6, F2, F8, F30
	
	            // For SC
	            // Accident: A21
	            // Claim: A10
	            // Voilation: A3, A5, A11, A14	
	
	            var portalCategory = {
	                NC: {
	                    F35: "accident",
	                    /* F38 : "accident",
	                     F39 : "accident",
	                     F40 : "accident",*/
	                    F110: "accident",
	                    F111: "accident",
	                    F120: "accident",
	                    F121: "accident",
	                    F130: "accident",
	                    F131: "accident",
	                    F147: "accident",
	                    F148: "accident",
	                    F149: "accident",
	
	                    F41: "accident",
	                    F42: "accident",
	                    F36: "claim",
	                    F37: "claim",
	                    A6: "voilation",
	                    F2: "voilation",
	                    F8: "voilation",
	                    F30: "voilation"
	                },
	                SC: {
	                    A21: "accident",
	                    A10: "claim",
	                    A3: "voilation",
	                    A5: "voilation",
	                    A11: "voilation",
	                    A14: "voilation"
	                }
	
	            };
	
	            return portalCategory[stateCode][descriptionCode];
	        };
	
	        // Accident Category Type Portal Mapping
	        driverProcessService.getPortalCategoryType = function (stateCode, descriptionCode) {
	
	            var portalCategoryType = {
	                NC: {
	                    F35: "g",
	                    /*F38 : "a",
	                    F39 : "b",
	                    F40 : "a",*/
	                    F41: "d",
	                    F42: "a",
	                    F36: "a",
	                    F37: "b",
	                    A6: "a",
	                    F2: "c",
	                    F8: "d",
	                    F30: "b"
	                },
	                SC: {
	                    A21: "a",
	                    A10: "a",
	                    A3: "c",
	                    A5: "a",
	                    A11: "d",
	                    A14: "b"
	                }
	            };
	
	            return portalCategoryType[stateCode][descriptionCode];
	        };
	
	        // Accident Description / Actual PC Mapping
	        driverProcessService.getAccidentDescription = function () {
	
	            return {
	                NC: {
	                    "A6": "FAIL TO REDUCE SPEED",
	                    "F2": "SPEEDING",
	                    "F8": "SPEED >20 MPH <55MPH",
	                    "F30": "DWI",
	                    "F35": "ACCIDENT NOT AT FAULT",
	                    "F36": "COMP LOSS",
	                    "F37": "TOWING LOSS",
	                    /*"F38" : "AFA - PD ONLY 1,800 OR LESS",
	                    "F39" : "AFA - BI 1,800 OR LESS",
	                    "F40" : "AFA - PD ONLY >1,800 <3000",
	                    "F41" : "AFA - PD ONLY 3,000 OR GREATER",
	                    "F42" : "AFA - BI >1,800",*/
	                    "F47": "AFA - BI 1,800 OR LESS",
	                    "F48": "AFA - BI >1,800",
	                    "F49": "AFA - FATALITY",
	                    "F110": "AFA - PD ONLY <= 1800 PRIOR TO 3/1/16 or <= 1850 AFTER 3/1/16",
	                    "F111": "AFA - PD ONLY <= 1800 PRIOR TO 3/1/16 or <= 1850 AFTER 3/1/16 or <= 2300 after 10/1/17",
	                    "F120": "AFA - PD ONLY > 1800 <= 3000 PRIOR TO 3/1/16 or > 1850 <= 3085 AFTER 3/1/16",
	                    "F121": "AFA - PD ONLY > 1800 <= 3000 PRIOR TO 3/1/16 or > 1850 <= 3085 AFTER 3/1/16 or > 2300<3850 after 10/01/17",
	                    "F130": "AFA - PD ONLY > 3000 PRIOR TO 3/1/16 or > 3085 AFTER 3/1/16",
	                    "F131": "AFA - PD ONLY > 3000 PRIOR TO 3/1/16 or > 3085 AFTER 3/1/16 or >=3850 after 10/01/17"
	
	                },
	                SC: {
	                    "A3": "Speeding: minor <=15 mph over speed limit unless defined by state",
	                    "A5": "Failure to yield; failure to stop at red light/stop sign; failure to comply with traffic signal; failure to yield to pedestrian",
	                    "A10": "At Fault Accident: Minor (greater than 12 months old)",
	                    "A11": "Speeding: major >15 mph over speed limit unless defined by state",
	                    "A14": "Driver's license convictions: Driving while license suspended/ revoked/invalid; unlawful use of license; permit unlicensed person to drive (does not include failure to have license in your possession).",
	                    "A21": "At Fault Accident: Major (less than or equal to 12 months old)"
	                }
	            };
	        };
	
	        // Get Accident Description For PC Mapping
	        driverProcessService.getAccidentDescriptionForPC = function (option, amount, date, stateCode) {
	
	            if (stateCode == "NC") {
	                return driverProcessService.getAccidentDescriptionForNC(option, amount, date);
	            } else if (stateCode == "SC") {
	                return driverProcessService.getAccidentDescriptionForSC(option, amount);
	            }
	        };
	
	        // Get Claim Description For PC Mapping
	        driverProcessService.getClaimDescriptionForPC = function (option, amount, stateCode) {
	
	            if (stateCode == "NC") {
	                return driverProcessService.getClaimDescriptionForNC(option, amount);
	            } else if (stateCode == "SC") {
	                return driverProcessService.getClaimDescriptionForSC(option, amount);
	            }
	        };
	
	        // Get Voilation Description For PC Mapping
	        driverProcessService.getVoilationDescriptionForPC = function (option, stateCode) {
	            if (stateCode == "NC") {
	                return driverProcessService.getVoilationDescriptionForNC(option);
	            } else if (stateCode == "SC") {
	                return driverProcessService.getVoilationDescriptionForSC(option);
	            }
	        };
	
	        // Get accident description for state NC
	        driverProcessService.getAccidentDescriptionForNC = function (option, amount, date) {
	
	            amount = parseInt(amount);
	            var eventDate = new Date(date.year, date.month, date.day);
	            var accidentDate = new Date(2016, 2, 1);
	            var accidentDate1 = new Date(2017, 9, 1);
	
	            if (option == "a") {
	
	                if (amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F111";
	                } else if (amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F120";
	                } else if (amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F121";
	                } else if (amount > 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F130";
	                } else if (amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F131";
	                }
	                /*if(amount < 1800){
	                    return "F39";
	                }                
	                else if (amount > 1800 && amount < 3000){
	                    return "F40";
	                }
	                // Check with Iris
	                else {
	                    return "F38";
	                }*/
	            } else if (option == "b") {
	
	                if (amount <= 1800) {
	                    return "F47";
	                } else if (amount > 1800) {
	                    return "F48";
	                }
	                // Check with Iris
	                else {
	                        return "F49";
	                    }
	            } else if (option == "c") {
	                if (amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F111";
	                } else if (amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F120";
	                } else if (amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F121";
	                } else if (amount > 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F130";
	                } else if (amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F131";
	                }
	
	                /*if (amount < 1800){
	                    return "F38";
	                }
	                else if (amount > 1800 && amount < 3000){
	                    return "F40";
	                }
	                else if(amount > 3000){
	                    return "F41";
	                }
	                // Check with Iris
	                else{
	                    return "F38";
	                }*/
	            } else if (option == "d" || option == "f") {
	                if (amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F111";
	                } else if (amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F120";
	                } else if (amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F121";
	                } else if (amount > 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F130";
	                } else if (amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F131";
	                }
	
	                /* if (amount > 1800 && amount < 3000){
	                     return "F40";
	                 }
	                 else if(amount > 3000){
	                     return "F41";
	                 }
	                 // Check with Iris
	                 else{
	                     return "F40";
	                 }*/
	            } else if (option == "e") {
	                if (amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F111";
	                } else if (amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F120";
	                } else if (amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F121";
	                } else if (amount > 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F130";
	                } else if (amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F131";
	                }
	                /*if (amount > 1800 && amount < 3000){
	                    return "F40";
	                }
	                else if (amount > 3000){
	                    return "F41";
	                }
	                // Check with Iris
	                else{
	                    return "F40";
	                }*/
	            } else if (option == "g" || option == "h" || option == "j") {
	                return "F35";
	            } else if (option == "i") {
	                if (amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F110";
	                } else if (amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F111";
	                } else if (amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F120";
	                } else if (amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F121";
	                } else if (amount > 3000 && eventDate.getTime() <= accidentDate.getTime() || amount > 3085 && eventDate.getTime() >= accidentDate.getTime()) {
	                    return "F130";
	                } else if (amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
	                    return "F131";
	                }
	                /*if (amount > 3000){
	                    return "F41";
	                }
	                // Check with Iris
	                else{
	                    return "F41";
	                }*/
	            }
	        };
	
	        // Get claim description for state NC
	        driverProcessService.getClaimDescriptionForNC = function (option, amount) {
	
	            amount = parseInt(amount);
	
	            if (option == "a" || option == "c") {
	                return "F36";
	            } else if (option == "b") {
	                return "F37";
	            } else if (option == "d") {
	                return "F35";
	            }
	        };
	
	        // Get voilation description for state NC
	        driverProcessService.getVoilationDescriptionForNC = function (option) {
	
	            if (option == "a") {
	                return "A6";
	            } else if (option == "b") {
	                return "F30";
	            } else if (option == "c") {
	                return "F2";
	            } else if (option == "d") {
	                return "F8";
	            }
	        };
	
	        // Get accident description for state SC
	        driverProcessService.getAccidentDescriptionForSC = function (option) {
	
	            return "A21";
	        };
	
	        // Get claim description for state SC
	        driverProcessService.getClaimDescriptionForSC = function (option) {
	            return "A10";
	        };
	
	        // Get voilation description for state SC
	        driverProcessService.getVoilationDescriptionForSC = function (option) {
	            if (option == "a") {
	                return "A5";
	            } else if (option == "b") {
	                return "A14";
	            } else if (option == "c") {
	                return "A3";
	            } else if (option == "d") {
	                return "A11";
	            }
	        };
	
	        // Return DriverProcessService
	        return driverProcessService;
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(509)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            scope: {
	                policyEffectiveDate: '=policyEffectiveDate',
	                valueSelected: '=valueSelected'
	
	            },
	            template: templateStr,
	            controller: ['$scope', function (scope) {
	                var dateMap = new Map();
	                dateMap.set("1", ["1", "2", "3", "4", "5", "6"]);
	                dateMap.set("2", ["2", "3", "4", "5", "6", "7"]);
	                dateMap.set("3", ["3", "4", "5", "6", "7", "8"]);
	                dateMap.set("4", ["4", "5", "6", "7", "8", "9"]);
	                dateMap.set("5", ["5", "6", "7", "8", "9", "10"]);
	                dateMap.set("6", ["6", "7", "8", "9", "10", "11"]);
	                dateMap.set("7", ["7", "8", "9", "10", "11", "12"]);
	                dateMap.set("8", ["8", "9", "10", "11", "12", "13"]);
	                dateMap.set("9", ["9", "10", "11", "12", "13", "14"]);
	                dateMap.set("10", ["10", "11", "12", "13", "14", "15"]);
	                dateMap.set("11", ["11", "12", "13", "14", "15", "16"]);
	                dateMap.set("12", ["12", "13", "14", "15", "16", "17"]);
	                dateMap.set("13", ["13", "14", "15", "16", "17", "18"]);
	                dateMap.set("14", ["14", "15", "16", "17", "18", "19"]);
	                dateMap.set("15", ["15", "16", "17", "18", "19", "20"]);
	                dateMap.set("16", ["16", "17", "18", "19", "20", "21"]);
	                dateMap.set("17", ["17", "18", "19", "20", "21", "22"]);
	                dateMap.set("18", ["18", "19", "20", "21", "22", "23"]);
	                dateMap.set("19", ["19", "20", "21", "22", "23", "24"]);
	                dateMap.set("20", ["20", "21", "22", "23", "24", "25"]);
	                dateMap.set("21", ["21", "22", "23", "24", "25", "26"]);
	                dateMap.set("22", ["22", "23", "24", "25", "26", "27"]);
	                dateMap.set("23", ["23", "24", "25", "26", "27", "28"]);
	                dateMap.set("24", ["24", "25", "26", "27", "28"]);
	                dateMap.set("25", ["25", "26", "27", "28"]);
	                dateMap.set("26", ["26", "27", "28"]);
	                dateMap.set("27", ["27", "28"]);
	                dateMap.set("28", ["28"]);
	                dateMap.set("29", ["29"]);
	                dateMap.set("30", ["30"]);
	                dateMap.set("31", ["31"]);
	                scope.selectDateList = dateMap.get(scope.policyEffectiveDate.toString());
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-control-group\">\r\n    <label class=\"gw-control-label\">Please select a payment date</label>\r\n\r\n    <div class=\"gw-controls\">\r\n        <select ng-model=\"valueSelected.value\"\r\n            ng-options=\"item for item in selectDateList\">\r\n        </select>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 02-01-2017.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['JsonRPCService', function (JsonRPCService) {
	        return {
	            getExistingInstruments: function getExistingInstruments(callGroups) {
	                return JsonRPCService.send('custompayment', 'custompayment', 'getExistingPaymentInstrumentsForAccount', [], callGroups);
	            },
	            createPaymentInstrumentForAccount: function createPaymentInstrumentForAccount(instrumentDTO, callGroups) {
	                return JsonRPCService.send('custompayment', 'custompayment', 'createPaymentInstrumentForAccount', [instrumentDTO], callGroups);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(512)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    // Connects to localhost by default.
	    // Options: 'http://uxui-dev.guidewire.com'
	    var HOST_TO_CONNECT = /*backEndUrlPrefix_START*/'' /*backEndUrlPrefix_END*/;
	
	    var getPaymentDetails = function getPaymentDetails() {
	        var link = window.location;
	        var paymentDetails = {
	            appID: "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b",
	            appKey: "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9",
	            url: '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>'
	        };
	
	        if (link.host.indexOf("aaadev") >= 0 || link.host.indexOf("gwdev") >= 0 || link.host.indexOf("aaamsdf") >= 0 || link.host.indexOf("aaamshf") >= 0 || link.host.indexOf("aaadatamigration") >= 0) {
	            paymentDetails.appID = "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
	        } else if (link.host.indexOf("aaatest") >= 0 || link.host.indexOf("gwtest") >= 0 || link.host.indexOf("aaamstest") >= 0) {
	            paymentDetails.appID = "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
	        } else if (link.host.indexOf("aaasit") >= 0 || link.host.indexOf("gwsit") >= 0) {
	            paymentDetails.appID = "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
	        } else if (link.host.indexOf("aaatrain") >= 0 || link.host.indexOf("gwtrain") >= 0) {
	            paymentDetails.appID = "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
	        } else if (link.host.indexOf("www.aaacarolinasinsurancesolutions.com") >= 0 || link.host.indexOf("aaacarolinasinsurancesolutions.com") >= 0) {
	            paymentDetails.appID = "27fca103-0328-453d-b974-79876be7ff3e";
	            //paymentDetails.appKey="eyJDb25zdW1lckFwcElkIjoiMjdmY2ExMDMtMDMyOC00NTNkLWI5NzQtNzk4NzZiZTdmZjNlIiwiQXBpQXBwSWQiOiJjYzgyODY4Mi1jYmFkLTQwZmYtODA0Yy03MzVjMDFjYzNiZTIiLCJBcGlBcHBLZXkiOiJERVJzV2swTVpSL0I0Zyt3bkplWWZsTlpmUWFUOGdCZWRmS2ZZcGhNd1NmdzhBU2N0anNBQlM4bGlSZ01kOGFZUy9Ebnp6cm0ySkE4Rm4rRUpnaWNjbUxDVXZKUEt6LzhuZWNMbzFTSEQxaU5MRWZXNEJRekxoRlR2VXEwakF5ZSJ9";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMjdmY2ExMDMtMDMyOC00NTNkLWI5NzQtNzk4NzZiZTdmZjNlIiwiQXBpQXBwSWQiOiIwOTM3YzkwNy03NzQ2LTRiOTUtOWRmZC0xMmZiYTVhODVlMTQiLCJBcGlBcHBLZXkiOiJGeUxVNzRvZjI4VFpEMFJpV2Q5ZFk5d2wvdzh5RzdnVXFhRnM3N0dmclc4a2QwekNzTGxVTXptTkFFS2tnZVY0bW5yOTBGYlU4T3crSEI5RTlJbVVWZHV1OFVVNnlVQ3BhdmhHbnJVWTdmRkFDS2xVb1lDeEZHMGVCN211V2pmNCJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://pay.carolinas.aaa.com/default.aspx"></iframe>';
	        } else {
	            paymentDetails.appID = "0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b";
	            paymentDetails.appKey = "eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9";
	            paymentDetails.url = '<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/default.aspx"></iframe>';
	        }
	        return paymentDetails;
	    };
	
	    var paymentDetails = getPaymentDetails();
	
	    /**
	     * Module used to define application level configuration parameters that should be
	     * passed to capability modules
	     */
	    return angular.module('portal.config', ['ui.router'])
	
	    /**
	     * Defines the prefix url where the set of states for a sub module should
	     * plug into the portal application
	     */
	    .constant('state_plugin_config', {
	        quote_bind: 'root',
	        //changed for AAA; make account lookup page as home page
	        // CHG0031104 - Changed back to Zipcode page
	        home: 'zipCode',
	        //            home: 'landingAccount',
	        quickQuote: 'quickQuote'
	    }).constant('httpSettings', {
	        'timeout': 90000,
	        'reloadQueryParamName': 'goto',
	        'reloadURL': '/index.html',
	        'serviceBaseURLs': {
	            'pc': HOST_TO_CONNECT + '/pc/service/edge/',
	            'quote': HOST_TO_CONNECT + '/quote/',
	            'vinlookup': HOST_TO_CONNECT + '/vehicleinfo/',
	            'aaalookup': HOST_TO_CONNECT + '/vehicleinfo/',
	            'aaahldilookup': HOST_TO_CONNECT + '/vehicleinfo/',
	            'availability': HOST_TO_CONNECT + '/quote/',
	            'addressLookup': HOST_TO_CONNECT + '/address/',
	            //                'accountlookup': `${HOST_TO_CONNECT}/quote/`,
	            'membership': HOST_TO_CONNECT + '/quote/',
	            'discounts': HOST_TO_CONNECT + '/quote/',
	            'mvrclue': HOST_TO_CONNECT + '/quote/',
	            'auth': HOST_TO_CONNECT + '/auth/',
	            'addressstandardization': HOST_TO_CONNECT + '/address/',
	            'prefill': HOST_TO_CONNECT + '/quote/',
	            'custompayment': HOST_TO_CONNECT + '/quote/'
	
	        },
	        auth: {
	            kind: 'basic',
	            username: 'upstream',
	            password: 'password'
	        }
	    }).constant('defaultLocaleDetails', {
	        countryCode: 'US',
	        mapCenter: { lat: 37.923933, lon: -122.5203 }
	    })
	
	    //TODO:used for login from dev and test environment. To be changed when moving to other environments.
	    .constant('LoginLinkDev', 'https://stg.theagentszone.com/portallogin/Account/Login').constant('LoginLinkTest', 'https://stg.theagentszone.com/portallogintst/Account/Login').constant('AAADEV', 'aaadev').constant('AAATEST', 'aaadev').constant('GWDEV', 'gwdev').constant('GWTEST', 'gwtest').constant('PayTestUrl', 'https://paytest.carolinas.aaa.com').constant('PayProdUrl', 'https://pay.carolinas.aaa.com').constant('CCDEV_APPID', paymentDetails.appID).constant('CCDEV_APPKEY', paymentDetails.appKey).constant('CCDEV_PAYMENTURL', paymentDetails.url).constant('CCDEV_MID', '1').constant('CCDEV_PAYMENTID', '6') //INC2460206 - Changed from 7 to 6 - AB - 01/28/2021
	
	    //.constant('CCDEV_APPID','0c9c789e-c8f9-4fa9-b4a4-0cd710b0df7b')
	    //.constant('CCDEV_APPKEY','eyJDb25zdW1lckFwcElkIjoiMGM5Yzc4OWUtYzhmOS00ZmE5LWI0YTQtMGNkNzEwYjBkZjdiIiwiQXBpQXBwSWQiOiI0MzA5NTA2Ni1mNWJjLTQ4ODAtYWQ4ZC1lN2FkMjVhMWRkMzQiLCJBcGlBcHBLZXkiOiI5b2Uvb0t3ZDFTS1pVUC9icHo0S25jZ3NPVXNiSGRsMUlPMmtiOXlNQzRibVk2VXM2aHJCbkw2aUNRcEJ1T2kyb2lLN1E3L0hSZDhuNVllN0dxYlpMQkZROFBFOEl5MDQ1OUwxOWlZd0YvdVU4QlVDK29uSzlZblROU2d2cFdqayJ9')
	    //.constant('CCDEV_PAYMENTURL','<iframe id="payment-page" src="https://paytest.carolinas.aaa.com/payment-page.html"></iframe>')
	
	    //Used for date of birth dropdowns.
	    .constant('AgeAllowedForHO', 18).constant('AgeAllowedToDrive', 16).constant('LicensedAgeAllowedToDrive', 16).constant('MaximumAge', 100).constant('maxFileUploadSize', 50000000) //50MB. Used to specify the maximum file size for document upload.
	
	    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	        var states = [{
	            name: 'root',
	            url: '',
	            template: '<div ui-view></div>',
	            abstract: true,
	            data: {
	                defaultState: 'zipCode' //; Changed for AAA : set account lookup page as default page
	                // CHG0031104 - Changed back to Zipcode page
	                //                        defaultState:'landingAccount'
	            }
	        }];
	
	        for (var i = 0; i < states.length; i++) {
	            $stateProvider.state(states[i]);
	        }
	
	        //changed for AAA : set account lookup page as default home page
	        // CHG0031104 - Changed back to Zipcode page
	        $urlRouterProvider.when('home', 'zipCode');
	        $urlRouterProvider.otherwise('zipCode');
	    }]).constant('ASYNC_TRANSLATIONS', true) //Constant that allows us to load translations synchronously (tests/Components Examples)
	    .constant('ANGULARI18N_PRESET', '') //Constant that allows us to load Angular Locale from different path (Components Examples)
	    .constant('TRANSLATE_PROVIDER_PREFIX', ''); //Constant that allows us to load translations from different path (Components Examples)
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 512 */
/***/ function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.13
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="ui.router"),function(a,b,c){"use strict";function d(a,b){return M(new(M(function(){},{prototype:a})),b)}function e(a){return L(arguments,function(b){b!==a&&L(b,function(b,c){a.hasOwnProperty(c)||(a[c]=b)})}),a}function f(a,b){var c=[];for(var d in a.path){if(a.path[d]!==b.path[d])break;c.push(a.path[d])}return c}function g(a){if(Object.keys)return Object.keys(a);var c=[];return b.forEach(a,function(a,b){c.push(b)}),c}function h(a,b){if(Array.prototype.indexOf)return a.indexOf(b,Number(arguments[2])||0);var c=a.length>>>0,d=Number(arguments[2])||0;for(d=0>d?Math.ceil(d):Math.floor(d),0>d&&(d+=c);c>d;d++)if(d in a&&a[d]===b)return d;return-1}function i(a,b,c,d){var e,i=f(c,d),j={},k=[];for(var l in i)if(i[l].params&&(e=g(i[l].params),e.length))for(var m in e)h(k,e[m])>=0||(k.push(e[m]),j[e[m]]=a[e[m]]);return M({},j,b)}function j(a,b,c){if(!c){c=[];for(var d in a)c.push(d)}for(var e=0;e<c.length;e++){var f=c[e];if(a[f]!=b[f])return!1}return!0}function k(a,b){var c={};return L(a,function(a){c[a]=b[a]}),c}function l(a){var b={},c=Array.prototype.concat.apply(Array.prototype,Array.prototype.slice.call(arguments,1));for(var d in a)-1==h(c,d)&&(b[d]=a[d]);return b}function m(a,b){var c=K(a),d=c?[]:{};return L(a,function(a,e){b(a,e)&&(d[c?d.length:e]=a)}),d}function n(a,b){var c=K(a)?[]:{};return L(a,function(a,d){c[d]=b(a,d)}),c}function o(a,b){var d=1,f=2,i={},j=[],k=i,m=M(a.when(i),{$$promises:i,$$values:i});this.study=function(i){function n(a,c){if(s[c]!==f){if(r.push(c),s[c]===d)throw r.splice(0,h(r,c)),new Error("Cyclic dependency: "+r.join(" -> "));if(s[c]=d,I(a))q.push(c,[function(){return b.get(a)}],j);else{var e=b.annotate(a);L(e,function(a){a!==c&&i.hasOwnProperty(a)&&n(i[a],a)}),q.push(c,a,e)}r.pop(),s[c]=f}}function o(a){return J(a)&&a.then&&a.$$promises}if(!J(i))throw new Error("'invocables' must be an object");var p=g(i||{}),q=[],r=[],s={};return L(i,n),i=r=s=null,function(d,f,g){function h(){--u||(v||e(t,f.$$values),r.$$values=t,r.$$promises=r.$$promises||!0,delete r.$$inheritedValues,n.resolve(t))}function i(a){r.$$failure=a,n.reject(a)}function j(c,e,f){function j(a){l.reject(a),i(a)}function k(){if(!G(r.$$failure))try{l.resolve(b.invoke(e,g,t)),l.promise.then(function(a){t[c]=a,h()},j)}catch(a){j(a)}}var l=a.defer(),m=0;L(f,function(a){s.hasOwnProperty(a)&&!d.hasOwnProperty(a)&&(m++,s[a].then(function(b){t[a]=b,--m||k()},j))}),m||k(),s[c]=l.promise}if(o(d)&&g===c&&(g=f,f=d,d=null),d){if(!J(d))throw new Error("'locals' must be an object")}else d=k;if(f){if(!o(f))throw new Error("'parent' must be a promise returned by $resolve.resolve()")}else f=m;var n=a.defer(),r=n.promise,s=r.$$promises={},t=M({},d),u=1+q.length/3,v=!1;if(G(f.$$failure))return i(f.$$failure),r;f.$$inheritedValues&&e(t,l(f.$$inheritedValues,p)),M(s,f.$$promises),f.$$values?(v=e(t,l(f.$$values,p)),r.$$inheritedValues=l(f.$$values,p),h()):(f.$$inheritedValues&&(r.$$inheritedValues=l(f.$$inheritedValues,p)),f.then(h,i));for(var w=0,x=q.length;x>w;w+=3)d.hasOwnProperty(q[w])?h():j(q[w],q[w+1],q[w+2]);return r}},this.resolve=function(a,b,c,d){return this.study(a)(b,c,d)}}function p(a,b,c){this.fromConfig=function(a,b,c){return G(a.template)?this.fromString(a.template,b):G(a.templateUrl)?this.fromUrl(a.templateUrl,b):G(a.templateProvider)?this.fromProvider(a.templateProvider,b,c):null},this.fromString=function(a,b){return H(a)?a(b):a},this.fromUrl=function(c,d){return H(c)&&(c=c(d)),null==c?null:a.get(c,{cache:b,headers:{Accept:"text/html"}}).then(function(a){return a.data})},this.fromProvider=function(a,b,d){return c.invoke(a,null,d||{params:b})}}function q(a,b,e){function f(b,c,d,e){if(q.push(b),o[b])return o[b];if(!/^\w+(-+\w+)*(?:\[\])?$/.test(b))throw new Error("Invalid parameter name '"+b+"' in pattern '"+a+"'");if(p[b])throw new Error("Duplicate parameter name '"+b+"' in pattern '"+a+"'");return p[b]=new O.Param(b,c,d,e),p[b]}function g(a,b,c){var d=["",""],e=a.replace(/[\\\[\]\^$*+?.()|{}]/g,"\\$&");if(!b)return e;switch(c){case!1:d=["(",")"];break;case!0:d=["?(",")?"];break;default:d=["("+c+"|",")?"]}return e+d[0]+b+d[1]}function h(c,e){var f,g,h,i,j;return f=c[2]||c[3],j=b.params[f],h=a.substring(m,c.index),g=e?c[4]:c[4]||("*"==c[1]?".*":null),i=O.type(g||"string")||d(O.type("string"),{pattern:new RegExp(g)}),{id:f,regexp:g,segment:h,type:i,cfg:j}}b=M({params:{}},J(b)?b:{});var i,j=/([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,k=/([:]?)([\w\[\]-]+)|\{([\w\[\]-]+)(?:\:((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,l="^",m=0,n=this.segments=[],o=e?e.params:{},p=this.params=e?e.params.$$new():new O.ParamSet,q=[];this.source=a;for(var r,s,t;(i=j.exec(a))&&(r=h(i,!1),!(r.segment.indexOf("?")>=0));)s=f(r.id,r.type,r.cfg,"path"),l+=g(r.segment,s.type.pattern.source,s.squash),n.push(r.segment),m=j.lastIndex;t=a.substring(m);var u=t.indexOf("?");if(u>=0){var v=this.sourceSearch=t.substring(u);if(t=t.substring(0,u),this.sourcePath=a.substring(0,m+u),v.length>0)for(m=0;i=k.exec(v);)r=h(i,!0),s=f(r.id,r.type,r.cfg,"search"),m=j.lastIndex}else this.sourcePath=a,this.sourceSearch="";l+=g(t)+(b.strict===!1?"/?":"")+"$",n.push(t),this.regexp=new RegExp(l,b.caseInsensitive?"i":c),this.prefix=n[0],this.$$paramNames=q}function r(a){M(this,a)}function s(){function a(a){return null!=a?a.toString().replace(/\//g,"%2F"):a}function e(a){return null!=a?a.toString().replace(/%2F/g,"/"):a}function f(a){return this.pattern.test(a)}function i(){return{strict:t,caseInsensitive:p}}function j(a){return H(a)||K(a)&&H(a[a.length-1])}function k(){for(;x.length;){var a=x.shift();if(a.pattern)throw new Error("You cannot override a type's .pattern at runtime.");b.extend(v[a.name],o.invoke(a.def))}}function l(a){M(this,a||{})}O=this;var o,p=!1,t=!0,u=!1,v={},w=!0,x=[],y={string:{encode:a,decode:e,is:f,pattern:/[^/]*/},"int":{encode:a,decode:function(a){return parseInt(a,10)},is:function(a){return G(a)&&this.decode(a.toString())===a},pattern:/\d+/},bool:{encode:function(a){return a?1:0},decode:function(a){return 0!==parseInt(a,10)},is:function(a){return a===!0||a===!1},pattern:/0|1/},date:{encode:function(a){return this.is(a)?[a.getFullYear(),("0"+(a.getMonth()+1)).slice(-2),("0"+a.getDate()).slice(-2)].join("-"):c},decode:function(a){if(this.is(a))return a;var b=this.capture.exec(a);return b?new Date(b[1],b[2]-1,b[3]):c},is:function(a){return a instanceof Date&&!isNaN(a.valueOf())},equals:function(a,b){return this.is(a)&&this.is(b)&&a.toISOString()===b.toISOString()},pattern:/[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,capture:/([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/},json:{encode:b.toJson,decode:b.fromJson,is:b.isObject,equals:b.equals,pattern:/[^/]*/},any:{encode:b.identity,decode:b.identity,is:b.identity,equals:b.equals,pattern:/.*/}};s.$$getDefaultValue=function(a){if(!j(a.value))return a.value;if(!o)throw new Error("Injectable functions cannot be called at configuration time");return o.invoke(a.value)},this.caseInsensitive=function(a){return G(a)&&(p=a),p},this.strictMode=function(a){return G(a)&&(t=a),t},this.defaultSquashPolicy=function(a){if(!G(a))return u;if(a!==!0&&a!==!1&&!I(a))throw new Error("Invalid squash policy: "+a+". Valid policies: false, true, arbitrary-string");return u=a,a},this.compile=function(a,b){return new q(a,M(i(),b))},this.isMatcher=function(a){if(!J(a))return!1;var b=!0;return L(q.prototype,function(c,d){H(c)&&(b=b&&G(a[d])&&H(a[d]))}),b},this.type=function(a,b,c){if(!G(b))return v[a];if(v.hasOwnProperty(a))throw new Error("A type named '"+a+"' has already been defined.");return v[a]=new r(M({name:a},b)),c&&(x.push({name:a,def:c}),w||k()),this},L(y,function(a,b){v[b]=new r(M({name:b},a))}),v=d(v,{}),this.$get=["$injector",function(a){return o=a,w=!1,k(),L(y,function(a,b){v[b]||(v[b]=new r(a))}),this}],this.Param=function(a,b,d,e){function f(a){var b=J(a)?g(a):[],c=-1===h(b,"value")&&-1===h(b,"type")&&-1===h(b,"squash")&&-1===h(b,"array");return c&&(a={value:a}),a.$$fn=j(a.value)?a.value:function(){return a.value},a}function i(b,c,d){if(b.type&&c)throw new Error("Param '"+a+"' has two type configurations.");return c?c:b.type?b.type instanceof r?b.type:new r(b.type):"config"===d?v.any:v.string}function k(){var b={array:"search"===e?"auto":!1},c=a.match(/\[\]$/)?{array:!0}:{};return M(b,c,d).array}function l(a,b){var c=a.squash;if(!b||c===!1)return!1;if(!G(c)||null==c)return u;if(c===!0||I(c))return c;throw new Error("Invalid squash policy: '"+c+"'. Valid policies: false, true, or arbitrary string")}function p(a,b,d,e){var f,g,i=[{from:"",to:d||b?c:""},{from:null,to:d||b?c:""}];return f=K(a.replace)?a.replace:[],I(e)&&f.push({from:e,to:c}),g=n(f,function(a){return a.from}),m(i,function(a){return-1===h(g,a.from)}).concat(f)}function q(){if(!o)throw new Error("Injectable functions cannot be called at configuration time");return o.invoke(d.$$fn)}function s(a){function b(a){return function(b){return b.from===a}}function c(a){var c=n(m(w.replace,b(a)),function(a){return a.to});return c.length?c[0]:a}return a=c(a),G(a)?w.type.decode(a):q()}function t(){return"{Param:"+a+" "+b+" squash: '"+z+"' optional: "+y+"}"}var w=this;d=f(d),b=i(d,b,e);var x=k();b=x?b.$asArray(x,"search"===e):b,"string"!==b.name||x||"path"!==e||d.value!==c||(d.value="");var y=d.value!==c,z=l(d,y),A=p(d,x,y,z);M(this,{id:a,type:b,location:e,array:x,squash:z,replace:A,isOptional:y,value:s,dynamic:c,config:d,toString:t})},l.prototype={$$new:function(){return d(this,M(new l,{$$parent:this}))},$$keys:function(){for(var a=[],b=[],c=this,d=g(l.prototype);c;)b.push(c),c=c.$$parent;return b.reverse(),L(b,function(b){L(g(b),function(b){-1===h(a,b)&&-1===h(d,b)&&a.push(b)})}),a},$$values:function(a){var b={},c=this;return L(c.$$keys(),function(d){b[d]=c[d].value(a&&a[d])}),b},$$equals:function(a,b){var c=!0,d=this;return L(d.$$keys(),function(e){var f=a&&a[e],g=b&&b[e];d[e].type.equals(f,g)||(c=!1)}),c},$$validates:function(a){var b,c,d,e=!0,f=this;return L(this.$$keys(),function(g){d=f[g],c=a[g],b=!c&&d.isOptional,e=e&&(b||!!d.type.is(c))}),e},$$parent:c},this.ParamSet=l}function t(a,d){function e(a){var b=/^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(a.source);return null!=b?b[1].replace(/\\(.)/g,"$1"):""}function f(a,b){return a.replace(/\$(\$|\d{1,2})/,function(a,c){return b["$"===c?0:Number(c)]})}function g(a,b,c){if(!c)return!1;var d=a.invoke(b,b,{$match:c});return G(d)?d:!0}function h(d,e,f,g){function h(a,b,c){return"/"===p?a:b?p.slice(0,-1)+a:c?p.slice(1)+a:a}function m(a){function b(a){var b=a(f,d);return b?(I(b)&&d.replace().url(b),!0):!1}if(!a||!a.defaultPrevented){var e=o&&d.url()===o;if(o=c,e)return!0;var g,h=j.length;for(g=0;h>g;g++)if(b(j[g]))return;k&&b(k)}}function n(){return i=i||e.$on("$locationChangeSuccess",m)}var o,p=g.baseHref(),q=d.url();return l||n(),{sync:function(){m()},listen:function(){return n()},update:function(a){return a?void(q=d.url()):void(d.url()!==q&&(d.url(q),d.replace()))},push:function(a,b,e){d.url(a.format(b||{})),o=e&&e.$$avoidResync?d.url():c,e&&e.replace&&d.replace()},href:function(c,e,f){if(!c.validates(e))return null;var g=a.html5Mode();b.isObject(g)&&(g=g.enabled);var i=c.format(e);if(f=f||{},g||null===i||(i="#"+a.hashPrefix()+i),i=h(i,g,f.absolute),!f.absolute||!i)return i;var j=!g&&i?"/":"",k=d.port();return k=80===k||443===k?"":":"+k,[d.protocol(),"://",d.host(),k,j,i].join("")}}}var i,j=[],k=null,l=!1;this.rule=function(a){if(!H(a))throw new Error("'rule' must be a function");return j.push(a),this},this.otherwise=function(a){if(I(a)){var b=a;a=function(){return b}}else if(!H(a))throw new Error("'rule' must be a function");return k=a,this},this.when=function(a,b){var c,h=I(b);if(I(a)&&(a=d.compile(a)),!h&&!H(b)&&!K(b))throw new Error("invalid 'handler' in when()");var i={matcher:function(a,b){return h&&(c=d.compile(b),b=["$match",function(a){return c.format(a)}]),M(function(c,d){return g(c,b,a.exec(d.path(),d.search()))},{prefix:I(a.prefix)?a.prefix:""})},regex:function(a,b){if(a.global||a.sticky)throw new Error("when() RegExp must not be global or sticky");return h&&(c=b,b=["$match",function(a){return f(c,a)}]),M(function(c,d){return g(c,b,a.exec(d.path()))},{prefix:e(a)})}},j={matcher:d.isMatcher(a),regex:a instanceof RegExp};for(var k in j)if(j[k])return this.rule(i[k](a,b));throw new Error("invalid 'what' in when()")},this.deferIntercept=function(a){a===c&&(a=!0),l=a},this.$get=h,h.$inject=["$location","$rootScope","$injector","$browser"]}function u(a,e){function f(a){return 0===a.indexOf(".")||0===a.indexOf("^")}function l(a,b){if(!a)return c;var d=I(a),e=d?a:a.name,g=f(e);if(g){if(!b)throw new Error("No reference point given for path '"+e+"'");b=l(b);for(var h=e.split("."),i=0,j=h.length,k=b;j>i;i++)if(""!==h[i]||0!==i){if("^"!==h[i])break;if(!k.parent)throw new Error("Path '"+e+"' not valid for state '"+b.name+"'");k=k.parent}else k=b;h=h.slice(i).join("."),e=k.name+(k.name&&h?".":"")+h}var m=y[e];return!m||!d&&(d||m!==a&&m.self!==a)?c:m}function m(a,b){z[a]||(z[a]=[]),z[a].push(b)}function o(a){for(var b=z[a]||[];b.length;)p(b.shift())}function p(b){b=d(b,{self:b,resolve:b.resolve||{},toString:function(){return this.name}});var c=b.name;if(!I(c)||c.indexOf("@")>=0)throw new Error("State must have a valid name");if(y.hasOwnProperty(c))throw new Error("State '"+c+"'' is already defined");var e=-1!==c.indexOf(".")?c.substring(0,c.lastIndexOf(".")):I(b.parent)?b.parent:J(b.parent)&&I(b.parent.name)?b.parent.name:"";if(e&&!y[e])return m(e,b.self);for(var f in B)H(B[f])&&(b[f]=B[f](b,B.$delegates[f]));return y[c]=b,!b[A]&&b.url&&a.when(b.url,["$match","$stateParams",function(a,c){x.$current.navigable==b&&j(a,c)||x.transitionTo(b,a,{inherit:!0,location:!1})}]),o(c),b}function q(a){return a.indexOf("*")>-1}function r(a){var b=a.split("."),c=x.$current.name.split(".");if("**"===b[0]&&(c=c.slice(h(c,b[1])),c.unshift("**")),"**"===b[b.length-1]&&(c.splice(h(c,b[b.length-2])+1,Number.MAX_VALUE),c.push("**")),b.length!=c.length)return!1;for(var d=0,e=b.length;e>d;d++)"*"===b[d]&&(c[d]="*");return c.join("")===b.join("")}function s(a,b){return I(a)&&!G(b)?B[a]:H(b)&&I(a)?(B[a]&&!B.$delegates[a]&&(B.$delegates[a]=B[a]),B[a]=b,this):this}function t(a,b){return J(a)?b=a:b.name=a,p(b),this}function u(a,e,f,h,m,o,p){function s(b,c,d,f){var g=a.$broadcast("$stateNotFound",b,c,d);if(g.defaultPrevented)return p.update(),B;if(!g.retry)return null;if(f.$retry)return p.update(),C;var h=x.transition=e.when(g.retry);return h.then(function(){return h!==x.transition?u:(b.options.$retry=!0,x.transitionTo(b.to,b.toParams,b.options))},function(){return B}),p.update(),h}function t(a,c,d,g,i,j){var l=d?c:k(a.params.$$keys(),c),n={$stateParams:l};i.resolve=m.resolve(a.resolve,n,i.resolve,a);var o=[i.resolve.then(function(a){i.globals=a})];return g&&o.push(g),L(a.views,function(c,d){var e=c.resolve&&c.resolve!==a.resolve?c.resolve:{};e.$template=[function(){return f.load(d,{view:c,locals:n,params:l,notify:j.notify})||""}],o.push(m.resolve(e,n,i.resolve,a).then(function(f){if(H(c.controllerProvider)||K(c.controllerProvider)){var g=b.extend({},e,n);f.$$controller=h.invoke(c.controllerProvider,null,g)}else f.$$controller=c.controller;f.$$state=a,f.$$controllerAs=c.controllerAs,i[d]=f}))}),e.all(o).then(function(){return i})}var u=e.reject(new Error("transition superseded")),z=e.reject(new Error("transition prevented")),B=e.reject(new Error("transition aborted")),C=e.reject(new Error("transition failed"));return w.locals={resolve:null,globals:{$stateParams:{}}},x={params:{},current:w.self,$current:w,transition:null},x.reload=function(){return x.transitionTo(x.current,o,{reload:!0,inherit:!1,notify:!0})},x.go=function(a,b,c){return x.transitionTo(a,b,M({inherit:!0,relative:x.$current},c))},x.transitionTo=function(b,c,f){c=c||{},f=M({location:!0,inherit:!1,relative:null,notify:!0,reload:!1,$retry:!1},f||{});var g,j=x.$current,m=x.params,n=j.path,q=l(b,f.relative);if(!G(q)){var r={to:b,toParams:c,options:f},y=s(r,j.self,m,f);if(y)return y;if(b=r.to,c=r.toParams,f=r.options,q=l(b,f.relative),!G(q)){if(!f.relative)throw new Error("No such state '"+b+"'");throw new Error("Could not resolve '"+b+"' from state '"+f.relative+"'")}}if(q[A])throw new Error("Cannot transition to abstract state '"+b+"'");if(f.inherit&&(c=i(o,c||{},x.$current,q)),!q.params.$$validates(c))return C;c=q.params.$$values(c),b=q;var B=b.path,D=0,E=B[D],F=w.locals,H=[];if(!f.reload)for(;E&&E===n[D]&&E.ownParams.$$equals(c,m);)F=H[D]=E.locals,D++,E=B[D];if(v(b,j,F,f))return b.self.reloadOnSearch!==!1&&p.update(),x.transition=null,e.when(x.current);if(c=k(b.params.$$keys(),c||{}),f.notify&&a.$broadcast("$stateChangeStart",b.self,c,j.self,m).defaultPrevented)return p.update(),z;for(var I=e.when(F),J=D;J<B.length;J++,E=B[J])F=H[J]=d(F),I=t(E,c,E===b,I,F,f);var K=x.transition=I.then(function(){var d,e,g;if(x.transition!==K)return u;for(d=n.length-1;d>=D;d--)g=n[d],g.self.onExit&&h.invoke(g.self.onExit,g.self,g.locals.globals),g.locals=null;for(d=D;d<B.length;d++)e=B[d],e.locals=H[d],e.self.onEnter&&h.invoke(e.self.onEnter,e.self,e.locals.globals);return x.transition!==K?u:(x.$current=b,x.current=b.self,x.params=c,N(x.params,o),x.transition=null,f.location&&b.navigable&&p.push(b.navigable.url,b.navigable.locals.globals.$stateParams,{$$avoidResync:!0,replace:"replace"===f.location}),f.notify&&a.$broadcast("$stateChangeSuccess",b.self,c,j.self,m),p.update(!0),x.current)},function(d){return x.transition!==K?u:(x.transition=null,g=a.$broadcast("$stateChangeError",b.self,c,j.self,m,d),g.defaultPrevented||p.update(),e.reject(d))});return K},x.is=function(a,b,d){d=M({relative:x.$current},d||{});var e=l(a,d.relative);return G(e)?x.$current!==e?!1:b?j(e.params.$$values(b),o):!0:c},x.includes=function(a,b,d){if(d=M({relative:x.$current},d||{}),I(a)&&q(a)){if(!r(a))return!1;a=x.$current.name}var e=l(a,d.relative);return G(e)?G(x.$current.includes[e.name])?b?j(e.params.$$values(b),o,g(b)):!0:!1:c},x.href=function(a,b,d){d=M({lossy:!0,inherit:!0,absolute:!1,relative:x.$current},d||{});var e=l(a,d.relative);if(!G(e))return null;d.inherit&&(b=i(o,b||{},x.$current,e));var f=e&&d.lossy?e.navigable:e;return f&&f.url!==c&&null!==f.url?p.href(f.url,k(e.params.$$keys(),b||{}),{absolute:d.absolute}):null},x.get=function(a,b){if(0===arguments.length)return n(g(y),function(a){return y[a].self});var c=l(a,b||x.$current);return c&&c.self?c.self:null},x}function v(a,b,c,d){return a!==b||(c!==b.locals||d.reload)&&a.self.reloadOnSearch!==!1?void 0:!0}var w,x,y={},z={},A="abstract",B={parent:function(a){if(G(a.parent)&&a.parent)return l(a.parent);var b=/^(.+)\.[^.]+$/.exec(a.name);return b?l(b[1]):w},data:function(a){return a.parent&&a.parent.data&&(a.data=a.self.data=M({},a.parent.data,a.data)),a.data},url:function(a){var b=a.url,c={params:a.params||{}};if(I(b))return"^"==b.charAt(0)?e.compile(b.substring(1),c):(a.parent.navigable||w).url.concat(b,c);if(!b||e.isMatcher(b))return b;throw new Error("Invalid url '"+b+"' in state '"+a+"'")},navigable:function(a){return a.url?a:a.parent?a.parent.navigable:null},ownParams:function(a){var b=a.url&&a.url.params||new O.ParamSet;return L(a.params||{},function(a,c){b[c]||(b[c]=new O.Param(c,null,a,"config"))}),b},params:function(a){return a.parent&&a.parent.params?M(a.parent.params.$$new(),a.ownParams):new O.ParamSet},views:function(a){var b={};return L(G(a.views)?a.views:{"":a},function(c,d){d.indexOf("@")<0&&(d+="@"+a.parent.name),b[d]=c}),b},path:function(a){return a.parent?a.parent.path.concat(a):[]},includes:function(a){var b=a.parent?M({},a.parent.includes):{};return b[a.name]=!0,b},$delegates:{}};w=p({name:"",url:"^",views:null,"abstract":!0}),w.navigable=null,this.decorator=s,this.state=t,this.$get=u,u.$inject=["$rootScope","$q","$view","$injector","$resolve","$stateParams","$urlRouter","$location","$urlMatcherFactory"]}function v(){function a(a,b){return{load:function(c,d){var e,f={template:null,controller:null,view:null,locals:null,notify:!0,async:!0,params:{}};return d=M(f,d),d.view&&(e=b.fromConfig(d.view,d.params,d.locals)),e&&d.notify&&a.$broadcast("$viewContentLoading",d),e}}}this.$get=a,a.$inject=["$rootScope","$templateFactory"]}function w(){var a=!1;this.useAnchorScroll=function(){a=!0},this.$get=["$anchorScroll","$timeout",function(b,c){return a?b:function(a){c(function(){a[0].scrollIntoView()},0,!1)}}]}function x(a,c,d,e){function f(){return c.has?function(a){return c.has(a)?c.get(a):null}:function(a){try{return c.get(a)}catch(b){return null}}}function g(a,b){var c=function(){return{enter:function(a,b,c){b.after(a),c()},leave:function(a,b){a.remove(),b()}}};if(j)return{enter:function(a,b,c){var d=j.enter(a,null,b,c);d&&d.then&&d.then(c)},leave:function(a,b){var c=j.leave(a,b);c&&c.then&&c.then(b)}};if(i){var d=i&&i(b,a);return{enter:function(a,b,c){d.enter(a,null,b),c()},leave:function(a,b){d.leave(a),b()}}}return c()}var h=f(),i=h("$animator"),j=h("$animate"),k={restrict:"ECA",terminal:!0,priority:400,transclude:"element",compile:function(c,f,h){return function(c,f,i){function j(){l&&(l.remove(),l=null),n&&(n.$destroy(),n=null),m&&(r.leave(m,function(){l=null}),l=m,m=null)}function k(g){var k,l=z(c,i,f,e),s=l&&a.$current&&a.$current.locals[l];if(g||s!==o){k=c.$new(),o=a.$current.locals[l];var t=h(k,function(a){r.enter(a,f,function(){n&&n.$emit("$viewContentAnimationEnded"),(b.isDefined(q)&&!q||c.$eval(q))&&d(a)}),j()});m=t,n=k,n.$emit("$viewContentLoaded"),n.$eval(p)}}var l,m,n,o,p=i.onload||"",q=i.autoscroll,r=g(i,c);c.$on("$stateChangeSuccess",function(){k(!1)}),c.$on("$viewContentLoading",function(){k(!1)}),k(!0)}}};return k}function y(a,b,c,d){return{restrict:"ECA",priority:-400,compile:function(e){var f=e.html();return function(e,g,h){var i=c.$current,j=z(e,h,g,d),k=i&&i.locals[j];if(k){g.data("$uiView",{name:j,state:k.$$state}),g.html(k.$template?k.$template:f);var l=a(g.contents());if(k.$$controller){k.$scope=e;var m=b(k.$$controller,k);k.$$controllerAs&&(e[k.$$controllerAs]=m),g.data("$ngControllerController",m),g.children().data("$ngControllerController",m)}l(e)}}}}}function z(a,b,c,d){var e=d(b.uiView||b.name||"")(a),f=c.inheritedData("$uiView");return e.indexOf("@")>=0?e:e+"@"+(f?f.state.name:"")}function A(a,b){var c,d=a.match(/^\s*({[^}]*})\s*$/);if(d&&(a=b+"("+d[1]+")"),c=a.replace(/\n/g," ").match(/^([^(]+?)\s*(\((.*)\))?$/),!c||4!==c.length)throw new Error("Invalid state ref '"+a+"'");return{state:c[1],paramExpr:c[3]||null}}function B(a){var b=a.parent().inheritedData("$uiView");return b&&b.state&&b.state.name?b.state:void 0}function C(a,c){var d=["location","inherit","reload"];return{restrict:"A",require:["?^uiSrefActive","?^uiSrefActiveEq"],link:function(e,f,g,h){var i=A(g.uiSref,a.current.name),j=null,k=B(f)||a.$current,l=null,m="A"===f.prop("tagName"),n="FORM"===f[0].nodeName,o=n?"action":"href",p=!0,q={relative:k,inherit:!0},r=e.$eval(g.uiSrefOpts)||{};b.forEach(d,function(a){a in r&&(q[a]=r[a])});var s=function(c){if(c&&(j=b.copy(c)),p){l=a.href(i.state,j,q);var d=h[1]||h[0];return d&&d.$$setStateInfo(i.state,j),null===l?(p=!1,!1):void g.$set(o,l)}};i.paramExpr&&(e.$watch(i.paramExpr,function(a){a!==j&&s(a)},!0),j=b.copy(e.$eval(i.paramExpr))),s(),n||f.bind("click",function(b){var d=b.which||b.button;if(!(d>1||b.ctrlKey||b.metaKey||b.shiftKey||f.attr("target"))){var e=c(function(){a.go(i.state,j,q)});b.preventDefault();var g=m&&!l?1:0;b.preventDefault=function(){g--<=0&&c.cancel(e)}}})}}}function D(a,b,c){return{restrict:"A",controller:["$scope","$element","$attrs",function(b,d,e){function f(){g()?d.addClass(j):d.removeClass(j)}function g(){return"undefined"!=typeof e.uiSrefActiveEq?h&&a.is(h.name,i):h&&a.includes(h.name,i)}var h,i,j;j=c(e.uiSrefActiveEq||e.uiSrefActive||"",!1)(b),this.$$setStateInfo=function(b,c){h=a.get(b,B(d)),i=c,f()},b.$on("$stateChangeSuccess",f)}]}}function E(a){var b=function(b){return a.is(b)};return b.$stateful=!0,b}function F(a){var b=function(b){return a.includes(b)};return b.$stateful=!0,b}var G=b.isDefined,H=b.isFunction,I=b.isString,J=b.isObject,K=b.isArray,L=b.forEach,M=b.extend,N=b.copy;b.module("ui.router.util",["ng"]),b.module("ui.router.router",["ui.router.util"]),b.module("ui.router.state",["ui.router.router","ui.router.util"]),b.module("ui.router",["ui.router.state"]),b.module("ui.router.compat",["ui.router"]),o.$inject=["$q","$injector"],b.module("ui.router.util").service("$resolve",o),p.$inject=["$http","$templateCache","$injector"],b.module("ui.router.util").service("$templateFactory",p);var O;q.prototype.concat=function(a,b){var c={caseInsensitive:O.caseInsensitive(),strict:O.strictMode(),squash:O.defaultSquashPolicy()};return new q(this.sourcePath+a+this.sourceSearch,M(c,b),this)},q.prototype.toString=function(){return this.source},q.prototype.exec=function(a,b){function c(a){function b(a){return a.split("").reverse().join("")}function c(a){return a.replace(/\\-/,"-")}var d=b(a).split(/-(?!\\)/),e=n(d,b);return n(e,c).reverse()}var d=this.regexp.exec(a);if(!d)return null;b=b||{};var e,f,g,h=this.parameters(),i=h.length,j=this.segments.length-1,k={};if(j!==d.length-1)throw new Error("Unbalanced capture group in route '"+this.source+"'");for(e=0;j>e;e++){g=h[e];var l=this.params[g],m=d[e+1];for(f=0;f<l.replace;f++)l.replace[f].from===m&&(m=l.replace[f].to);m&&l.array===!0&&(m=c(m)),k[g]=l.value(m)}for(;i>e;e++)g=h[e],k[g]=this.params[g].value(b[g]);return k},q.prototype.parameters=function(a){return G(a)?this.params[a]||null:this.$$paramNames},q.prototype.validates=function(a){return this.params.$$validates(a)},q.prototype.format=function(a){function b(a){return encodeURIComponent(a).replace(/-/g,function(a){return"%5C%"+a.charCodeAt(0).toString(16).toUpperCase()})}a=a||{};var c=this.segments,d=this.parameters(),e=this.params;if(!this.validates(a))return null;var f,g=!1,h=c.length-1,i=d.length,j=c[0];for(f=0;i>f;f++){var k=h>f,l=d[f],m=e[l],o=m.value(a[l]),p=m.isOptional&&m.type.equals(m.value(),o),q=p?m.squash:!1,r=m.type.encode(o);if(k){var s=c[f+1];if(q===!1)null!=r&&(j+=K(r)?n(r,b).join("-"):encodeURIComponent(r)),j+=s;else if(q===!0){var t=j.match(/\/$/)?/\/?(.*)/:/(.*)/;j+=s.match(t)[1]}else I(q)&&(j+=q+s)}else{if(null==r||p&&q!==!1)continue;K(r)||(r=[r]),r=n(r,encodeURIComponent).join("&"+l+"="),j+=(g?"&":"?")+(l+"="+r),g=!0}}return j},r.prototype.is=function(){return!0},r.prototype.encode=function(a){return a},r.prototype.decode=function(a){return a},r.prototype.equals=function(a,b){return a==b},r.prototype.$subPattern=function(){var a=this.pattern.toString();return a.substr(1,a.length-2)},r.prototype.pattern=/.*/,r.prototype.toString=function(){return"{Type:"+this.name+"}"},r.prototype.$asArray=function(a,b){function d(a,b){function d(a,b){return function(){return a[b].apply(a,arguments)}}function e(a){return K(a)?a:G(a)?[a]:[]}function f(a){switch(a.length){case 0:return c;case 1:return"auto"===b?a[0]:a;default:return a}}function g(a){return!a}function h(a,b){return function(c){c=e(c);var d=n(c,a);return b===!0?0===m(d,g).length:f(d)}}function i(a){return function(b,c){var d=e(b),f=e(c);if(d.length!==f.length)return!1;for(var g=0;g<d.length;g++)if(!a(d[g],f[g]))return!1;return!0}}this.encode=h(d(a,"encode")),this.decode=h(d(a,"decode")),this.is=h(d(a,"is"),!0),this.equals=i(d(a,"equals")),this.pattern=a.pattern,this.$arrayMode=b}if(!a)return this;if("auto"===a&&!b)throw new Error("'auto' array mode is for query parameters only");return new d(this,a)},b.module("ui.router.util").provider("$urlMatcherFactory",s),b.module("ui.router.util").run(["$urlMatcherFactory",function(){}]),t.$inject=["$locationProvider","$urlMatcherFactoryProvider"],b.module("ui.router.router").provider("$urlRouter",t),u.$inject=["$urlRouterProvider","$urlMatcherFactoryProvider"],b.module("ui.router.state").value("$stateParams",{}).provider("$state",u),v.$inject=[],b.module("ui.router.state").provider("$view",v),b.module("ui.router.state").provider("$uiViewScroll",w),x.$inject=["$state","$injector","$uiViewScroll","$interpolate"],y.$inject=["$compile","$controller","$state","$interpolate"],b.module("ui.router.state").directive("uiView",x),b.module("ui.router.state").directive("uiView",y),C.$inject=["$state","$timeout"],D.$inject=["$state","$stateParams","$interpolate"],b.module("ui.router.state").directive("uiSref",C).directive("uiSrefActive",D).directive("uiSrefActiveEq",D),E.$inject=["$state"],F.$inject=["$state"],b.module("ui.router.state").filter("isState",E).filter("includedByState",F)}(window,window.angular);

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(534), __webpack_require__(563),
	
	// start l10n
	__webpack_require__(535),
	// end l10n
	
	__webpack_require__(554), __webpack_require__(555), __webpack_require__(511), __webpack_require__(556), __webpack_require__(559), __webpack_require__(514), __webpack_require__(564), __webpack_require__(567), __webpack_require__(570), __webpack_require__(574), __webpack_require__(341), __webpack_require__(577), __webpack_require__(585)], __WEBPACK_AMD_DEFINE_RESULT__ = function (JsonRPCService, DefaultErrorHandlerService) {
	    return angular.module('edge.platform.base', ['ngAnimate', 'ngAria', 'portal.config', 'edge.platform.util', 'edge.platform.transport', 'edge.platform.widgets.loadingMsg', 'edge.platform.widgets.modal', 'edge.platform.decorator',
	    // start l10n
	    'edge.platform.l10n',
	    // end l10n
	    'edge.platform.atomic_design', 'edge.platform.widgets.dropdown', 'edge.platform.widgets.pagestructure', 'edge.platform.widgets.tabs', 'edge.platform.branding']) // -32768 to -32000 are reserved for pre-defined errors, The remainder of the space is available for application defined errors.
	    .constant('ERROR_CODES', {
	        PARSE_ERROR: -32700,
	        INVALID_REQUEST: -32600,
	        METHOD_NOT_FOUND: -32601,
	        INVALID_PARAMS: -32602,
	        INTERNAL_ERROR: -32603,
	        GW_MNP_SECURITY_ERROR: -33000,
	        GW_MNP_VALIDATION_ERROR: -33001,
	        GW_MNP_QUOTE_SESSION_TIMEOUT: -33004
	
	    }).constant('uiConstants', {
	        SUBMITTED: 'submitted'
	    }).factory('JsonRPCService', JsonRPCService).provider('DefaultErrorHandlerService', DefaultErrorHandlerService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(515), __webpack_require__(526), __webpack_require__(527), __webpack_require__(528), __webpack_require__(529), __webpack_require__(530), __webpack_require__(532), __webpack_require__(395), // Eodb membership detail popup--Arpita Sengupta
	__webpack_require__(467) // Eodb membership detail popup--Arpita Sengupta
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (ModalService, ModalController, ModalProvider, StackedMap, ModalStack, ModalBackdropDirective, ModalWindowDirective, LoadSaveService, MembershipService) {
	    return angular.module('edge.platform.widgets.modal', []).factory('$$stackedMap', StackedMap) //Internal data structure
	    .factory('$modalStack', ModalStack) //Internal data structure
	    .provider('$modal', ModalProvider).factory('ModalService', ModalService).controller('ModalController', ModalController).directive('modalBackdrop', ModalBackdropDirective) //A helper directive for the $modal service. It creates a backdrop element.
	    .directive('modalWindow', ModalWindowDirective).factory('LoadSaveService', LoadSaveService) // Eodb membership detail popup--Arpita Sengupta
	    .factory('MembershipService', MembershipService); // Eodb membership detail popup--Arpita Sengupta
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(521), __webpack_require__(517), __webpack_require__(518), __webpack_require__(519), __webpack_require__(520), __webpack_require__(516), __webpack_require__(522), __webpack_require__(523), __webpack_require__(524), __webpack_require__(525)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, addressStdTemplate, addressSuccessTemplate, addressSoftErrorTemplate, addressHardErrorTemplate, disclaimerTemplate, coverageAlertTemplate, customTemplate, messageTemplate, progressTemplate, eSignAgreementTemplate) {
	    //remove membersip template file from dependency as a part of DFCT0020740 and added in PaPolicyInfoCtrl//Arpita 
	    var _showMessage = function _showMessage($filter, $modal, title, message, description, actionObj, iconClass, templateStr, showCancel, options, cancelBtnLabel, customOptions) {
	        var opts = {
	            template: templateStr,
	            backdrop: true,
	            controller: 'ModalController',
	            resolve: {
	                model: function model() {
	                    return {
	                        title: title,
	                        message: message,
	                        description: description,
	                        showCancelBtn: showCancel,
	                        keyboard: 'false',
	                        iconClass: iconClass,
	                        cancelBtnLabel: cancelBtnLabel || $filter('translate')('platform.modal.ModalService.Close'),
	                        action: actionObj,
	                        customOptions: customOptions || {}
	
	                    };
	                }
	            }
	        };
	        if (options) {
	            angular.extend(opts, options);
	        }
	
	        return $modal.open(opts);
	    };
	
	    var _showDisclaimerMessage = function _showDisclaimerMessage($filter, $modal, title, message, description, actionObj, iconClass, templateStr, showCancel, options, cancelBtnLabel, customOptions) {
	        var opts = {
	            template: templateStr,
	            backdrop: true,
	            controller: 'ModalController',
	            resolve: {
	                model: function model() {
	                    return {
	                        title: title,
	                        message: message,
	                        description: description,
	                        showCancelBtn: showCancel,
	                        keyboard: 'false',
	                        iconClass: iconClass,
	                        cancelBtnLabel: cancelBtnLabel || $filter('translate')('platform.modal.ModalService.Cancel'),
	                        action: actionObj,
	                        customOptions: customOptions || {}
	
	                    };
	                }
	            }
	        };
	        if (options) {
	            angular.extend(opts, options);
	        }
	
	        return $modal.open(opts);
	    };
	
	    return ['$modal', '$filter', '$q', function ($modal, $filter, $q) {
	        return {
	
	            showCustomInfo: function showCustomInfo(title, message, description, actionLabel, actionBtnClass) {
	
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Close'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	
	                return _showMessage($filter, $modal, title, message, description, actionProperties, '', customTemplate);
	            },
	            showInfo: function showInfo(title, message, description, actionLabel, actionBtnClass) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageInformationIcon', messageTemplate);
	            },
	
	            showDisclaimer: function showDisclaimer(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.DisclaimerNext'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
	                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', disclaimerTemplate, cancelLabel);
	            },
	
	            /*
	                    CHG0031272 - Display alert popup message when comprehensive or collision coverages are not selected
	                    AB - 06/27/2018
	            */
	            showCoverageAlert: function showCoverageAlert(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.CoverageAlertYes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.CoverageAlertNo');
	                var opts = {
	                    keyboard: false
	                };
	                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', coverageAlertTemplate, true, opts, cancelLabel);
	            },
	
	            /*
	                    CHG0032036 - Omega Integration with Melissa Data Service
	                    Display popup message when Melissa Data Service returns soft errors
	                    AB - 01/10/2019
	            */
	            showMelissaSuccessPopup: function showMelissaSuccessPopup(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.MelissaSuccessYes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.MelissaSuccessNo');
	                var opts = {
	                    keyboard: false
	                };
	                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressSuccessTemplate, true, opts, cancelLabel);
	            },
	
	            showMelissaWarningPopup: function showMelissaWarningPopup(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.MelissaWarningYes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.MelissaWarningNo');
	                var opts = {
	                    keyboard: false
	                };
	                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressSoftErrorTemplate, true, opts, cancelLabel);
	            },
	
	            showMelissaErrorPopup: function showMelissaErrorPopup(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressHardErrorTemplate, true, opts, cancelLabel);
	            },
	
	            showConfirm: function showConfirm(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel,
	                    btnClass: actionBtnClass || 'gw-btn-primary'
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
	                var opts = {
	                    keyboard: false
	                };
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageQuestionIcon', messageTemplate, true, opts, cancelLabel);
	            },
	
	            showWarning: function showWarning(title, message, description, actionLabel, actionBtnClass, cancelLabel) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary'
	                };
	                var opts = {
	                    keyboard: false
	                };
	                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageWarningIcon', messageTemplate, true, opts, cancelLabel);
	            },
	
	            showError: function showError(title, message, description, actionLabel, actionBtnClass) {
	
	                title = $filter('translate')('platform.modal.ModalService.Attention');
	
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Close'),
	                    btnClass: actionBtnClass
	                };
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageErrorIcon', messageTemplate);
	            },
	
	            showSuccess: function showSuccess(title, message, description, actionLabel, actionBtnClass) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
	                    btnClass: actionBtnClass || 'gw-btn-primary'
	                };
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageSuccessIcon', messageTemplate);
	            },
	
	            showAddressStandard: function showAddressStandard(message, validationMessage, address, description, actionLabel, actionBtnClass) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                var title = "t";
	                var customOptions = { validationMessage: validationMessage, address: address };
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressStdTemplate, true, {}, "C", customOptions);
	            },
	
	            showAddressStandardNew: function showAddressStandardNew(message, address, description, actionLabel, actionBtnClass) {
	                var actionProperties = {
	                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
	                    btnClass: actionBtnClass || 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	                var title = "t";
	                var customOptions = { address: address };
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressStdTemplate, true, {}, "C", customOptions);
	            },
	
	            showEsignAgreementModal: function showEsignAgreementModal() {
	
	                var title,
	                    message,
	                    description = null;
	
	                var actionProperties = {
	                    label: 'Next',
	                    btnClass: 'gw-btn-primary',
	                    backdrop: 'static'
	                };
	
	                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageWarningIcon', eSignAgreementTemplate);
	            },
	
	            showProgressMessage: function showProgressMessage(title) {
	
	                var msgBox = $modal.open({
	                    template: progressTemplate,
	                    keyboard: false,
	                    backdrop: 'static',
	                    controller: 'ModalController',
	                    resolve: {
	                        model: function model() {
	                            return {
	                                title: title
	                            };
	                        }
	                    }
	                });
	
	                return msgBox;
	            },
	            showMembershipDetails: function showMembershipDetails(title) {
	                //ENHC0011961 - EoDB Membership detail popup -- Arpita
	
	                var msgBox = $modal.open({
	                    template: membershipDetailTemplate,
	                    keyboard: false,
	                    backdrop: 'static',
	                    controller: 'ModalController',
	                    resolve: {
	                        model: function model() {
	                            return {
	                                title: title
	                            };
	                        }
	                    }
	                });
	
	                return msgBox;
	            }, //ended
	            showLoadingDialog: function showLoadingDialog(title) {
	                var msgBox = $modal.open({
	                    template: progressTemplate,
	                    keyboard: false,
	                    backdrop: 'static',
	                    controller: 'ModalController',
	                    resolve: {
	                        model: function model() {
	                            return {
	                                title: title
	                            };
	                        }
	                    }
	                });
	
	                return msgBox;
	            },
	
	            showProgressDialog: function showProgressDialog(title, hidePromise) {
	                var msgBox = $modal.open({
	                    template: progressTemplate,
	                    keyboard: false,
	                    backdrop: 'static',
	                    controller: 'ModalController',
	                    resolve: {
	                        model: function model() {
	                            return {
	                                title: title
	                            };
	                        }
	                    }
	                });
	
	                msgBox.opened.then(function () {
	                    $q.when(hidePromise, function (response) {
	                        msgBox.close(response);
	                        return response;
	                    }, function (error) {
	                        msgBox.dismiss(error);
	                        return error;
	                    });
	                });
	
	                return msgBox;
	            },
	
	            showTwoPromiseProgressDialog: function showTwoPromiseProgressDialog(title, hidePromise1, hidePromise2) {
	                var msgBox = $modal.open({
	                    template: progressTemplate,
	                    keyboard: false,
	                    backdrop: 'static',
	                    controller: 'ModalController',
	                    resolve: {
	                        model: function model() {
	                            return {
	                                title: title
	                            };
	                        }
	                    }
	                });
	
	                var prom1Returned = false;
	                var prom2Returned = false;
	
	                $q.when(hidePromise1, function () {
	                    prom1Returned = true;
	                    if (prom2Returned === true) {
	                        msgBox.close();
	                    }
	                }, function (error) {
	                    console.error(error);
	                    msgBox.close();
	                    return $q.reject([error]);
	                });
	
	                $q.when(hidePromise2, function () {
	                    prom2Returned = true;
	                    if (prom1Returned === true) {
	                        msgBox.close();
	                    }
	                }, function (error) {
	                    console.error(error);
	                    msgBox.close();
	                    return $q.reject([error]);
	                });
	            },
	
	            /**
	             * Shows a simple dialog composed of external template and controller components. It allows user to create
	             * new dialog using just a simple functions and not a separate "controller" instance (which is anyway
	             * just a same collection of functions). Not recommended for a complex scenarios (use separate controller
	             * instead).
	             *
	             * @param template data rendering template.
	             * @param data simple scope data. This map is copied to scope "as-is". Useful to provide initial (or data)
	             * model values, some basic (non-scope) functions.
	             * @param scopeFunctions functions to bind to a scope. This map should have only a functions as it's values.
	             * Each that function should receive a $scope argument as it's first value. This functions are bound
	             * (partially applied) to a context. Result of that partial application is bound to the scope using
	             * original function's key.
	             * <p> Example. If we have a pair 'someFunction' : function($scope, a, b, c) {}, resulting scope will have
	             * a function 'someFunction': function(a, b, c) {};
	             * @param initializer optional function to invoke on the scope. This function may install watches,
	             * binding, etc...
	             */
	            'showSimpleDialog': function showSimpleDialog(template, data, scopeFunctions, initializer) {
	                $modal.open({
	                    template: template,
	                    backdrop: 'static',
	                    controller: ['$scope', function ($scope) {
	                        var key = void 0;
	                        if (data) {
	                            for (key in data) {
	                                if (data.hasOwnProperty(key)) {
	                                    $scope[key] = data[key];
	                                }
	                            }
	                        }
	
	                        if (scopeFunctions) {
	                            for (key in scopeFunctions) {
	                                if (scopeFunctions.hasOwnProperty(key)) {
	                                    $scope[key] = _.partial(scopeFunctions[key], $scope);
	                                }
	                            }
	                        }
	
	                        if (initializer) {
	                            initializer($scope);
	                        }
	                    }]
	                });
	            }
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <div class=\"gw-message\">\r\n        <p ng-bind-html=\"message\"></p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n<div class=\"gw-modal-footer\">\r\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\r\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\r\n</div>\r\n"

/***/ },
/* 517 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <div class=\"gw-message\">\r\n        <p ng-bind-html=\"message\"></p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"gw-modal-footer\">\r\n        <button ng-click=\"addressConfirmed('no')\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\r\n        <button ng-click=\"addressConfirmed('yes')\" class=\"gw-btn {{ action.btnClass}}\">{{ action.label}}</button>\r\n</div>\r\n"

/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <div class=\"gw-message\">\r\n        <p ng-bind-html=\"message\"></p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n    <div class=\"gw-message\">\r\n        <p>Moving forward without a verified US Postal Service mailing address can cause failure of mail delivery. Please ackowledge to proceed.</p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n<div class=\"gw-modal-footer\">\r\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\r\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\r\n</div>\r\n"

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <div class=\"gw-message\">\r\n        <p ng-bind-html=\"message\"></p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n<div class=\"gw-modal-footer\">\r\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\r\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\r\n</div>\r\n"

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\n    <h3>{{ title}}</h3>\n</div>\n<div class=\"gw-modal-body\">\n    <div class=\"message\">\n        <p>{{ message}}</p>\n\n        <p class=\"gw-description\" ng-show=\"description\">{{ description}}</p>\n    </div>\n</div>\n<div class=\"gw-modal-footer\">\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\n    <button ng-click=\"nextState()\" class=\"gw-btn {{ action.btnClass}}\">\n        {{ 'quoteandbind.ho.views.contact-details.informationdisclosure.accept-button-label' | translate}}</button>\n</div>\n"

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\n    <h3>{{ message}}</h3>\n</div>\n<div class=\"gw-modal-body\">\n    <span class=\"iconWrapper\">\n        <span ng-class=\"iconClass\" class=\"iconSpan\">\n            <img src=\"../styles/images/common/blank.gif\"/>\n        </span>\n    </span>\n    <div class=\"message\">\n        <p>{{customOptions.address}}</p>\n        <p class=\"gw-description\" ng-show=\"description\">{{ description}}</p>\n    </div>\n</div>\n<div class=\"gw-modal-footer address-std-footer\">\n    <div class=\"address-std-footer-left\">\n        <a ng-click=\"addressConfirmed('no')\" style=\"text-align: left;\">{{customOptions.validationMessage}}</a>\n    </div>\n    <div class=\"address-std-footer-right\">\n        <button ng-click=\"addressConfirmed('yes')\" class=\"gw-btn {{ action.btnClass}}\">{{ action.label}}</button>\n    </div>   \n</div>\n"

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <!--<span class=\"gw-iconWrapper\">-->\r\n        <!--<span ng-class=\"iconClass\" class=\"gw-iconSpan\">-->\r\n            <!--<img src=\"../styles/images/common/blank.gif\"/>-->\r\n        <!--</span>-->\r\n    <!--</span>-->\r\n\r\n    <div class=\"gw-message\">\r\n        <p>{{ message }}</p>\r\n\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n<div class=\"gw-modal-footer\">\r\n    <!--<button ng-show=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn\">{{ cancelBtnLabel}}</button>-->\r\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\r\n</div>\r\n"

/***/ },
/* 523 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\n    <h3>{{ title }}</h3>\n</div>\n<div class=\"gw-modal-body\">\n    <div class=\"gw-message\">\n        <p ng-bind-html=\"message\"></p>\n\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\n    </div>\n</div>\n<div class=\"gw-modal-footer\">\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\n</div>\n"

/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-header\">\n    <h3>{{ title }}</h3>\n</div>\n<div class=gw-modal-body>\n    <div class=\"gw-clearfix\">\n        <div class=\"gw-span2\"></div>\n        <div class=\"gw-span8\">\n            <div class=\"gw-progress gw-progress-striped gw-active\">\n                <div class=\"gw-bar\" style=\"width: 100%;\"></div>\n            </div>\n        </div>\n        <div class=\"gw-span2\"></div>\n    </div>\n</div>\n"

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-warning-modal-header gw-esign-modal-header\">\n    <!--<h3>{{ title}}</h3>-->\n    <i class=\"fa fa-times gw-esign-close\" aria-hidden=\"true\" ng-click=\"$close()\"></i>\n</div>\n<div class=\"gw-modal-body gw-esign-modal-body\">\n    <!--<span class=\"gw-iconWrapper\">\n        <span ng-class=\"iconClass\" class=\"gw-iconSpan\">\n            <img src=\"../styles/images/common/blank.gif\"/>\n        </span>\n    </span>-->\n\n    <div class=\"gw-message\">\n\n        <p class=\"gw-description gw-esign-message\">\n            The Electronic Signatures in Global and National Commerce Act of 2000 requires us to ask you for your consent to electronic transactions, including providing you with Insurance Policy Documents electronically.  \n            If you consent, you will receive all of your Insurance Policy Documents from us electronically, as permitted by law.  \n            Insurance Policy Documents in electronic format will have the same contractual force and effect as Insurance Policy Documents electronically, you may withdraw your consent at any time and begin receiving Insurance Policy Documents at any time.  \n            If you elect to receive paper copies of Insurance Policy Documents, you may, at any time, request and consent to electronic transactions, including receiving Insurance Policy Documents electronically.  Please call us for any such withdrawals or requests.  \n            By giving your consent to electronic transactions, including receiving Insurance Policy Documents electronically, you must have: (i) a computer capable of connecting to the Internet; (ii) an Internet Service Provider; (iii) a browser capable of viewing our Web site; \n            (iv) an email service account that allows you to read, write, and send email; and (v) the ability to use hyperlinks to access other Web sites (collectively referred to as the \"Technical Requirements\").  \n            You must have the Technical Requirements to download, display, print, and retain Insurance Policy Documents in Adobe Portable Display Format.  If you do not have the Technical Requirements, you cannot receive Insurance Policy Documents electronically.\n        </p>\n        <p class=\"gw-description gw-esign-message\">\n            To access your online account, go to <a target=\"_blank\" href=\"http://insurance.carolinas.aaa.com\">insurance.carolinas.aaa.com</a> and log in to your account with the email address and password you provided when you created or updated your account.  \n            Your Insurance Policy Documents will be accessible through your online account.  \n            To print any of your Insurance Policy Documents from your online account, click the \"print\" button located on the page or in your browser frame.  \n            To download and save any of your Insurance Policy Documents to your computer, open the insurance policy document by clicking on its hyperlink or icon and follow Adobe Reader's directions for downloading and saving documents. \n        </p>\n    </div>\n</div>\n<!--<div class=\"gw-modal-footer\">    \n    \n</div>-->\n"

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    function isPromise(value) {
	        return value && typeof value.then === 'function';
	    }
	
	    function isMessagePlusInterpolation(value) {
	        return value && typeof value.key === 'string';
	    }
	
	    return ['$scope', '$filter', '$translate', '$q', 'model', '$modalInstance', 'LoadSaveService', 'ModalService', '$rootScope', 'MembershipService', function ($scope, $filter, $translate, $q, model, $modalInstance, LoadSaveService, ModalService, $rootScope, MembershipService) {
	        function translate(val) {
	            if (isPromise(val)) {
	                return val;
	            }
	            if (isMessagePlusInterpolation(val)) {
	                return $translate(val.key, val.args || {});
	            }
	            return $q.when(typeof val === 'string' && val.length ? $translate(val) : val);
	        }
	
	        function writeToScope(prop) {
	            return function (msg) {
	                $scope[prop] = msg;
	            };
	        }
	        $scope.selectedMembershipNumber = '';
	        $scope.draftData = {};
	        //This is used for contact details page disclaimer
	        $scope.nextState = function () {
	            $modalInstance.close();
	        };
	
	        $scope.addressConfirmed = function (actionType) {
	            var result = { actionType: actionType
	
	                // console.log("Modal window for addrsss Std"  , actionType, "Scope options ",$scope.customOptions)
	            };$modalInstance.close(result);
	        };
	
	        $scope.iconClass = model.iconClass;
	        $scope.showCancelBtn = model.showCancelBtn;
	        $scope.cancelBtnLabel = model.cancelBtnLabel;
	        $scope.customOptions = model.customOptions;
	
	        translate(model.title).then(writeToScope('title'));
	        translate(model.message).then(writeToScope('message'));
	        translate(model.description).then(writeToScope('description'));
	
	        if (model.action) {
	            $scope.action = {
	                btnClass: model.action.btnClass || 'gw-btn-primary',
	                label: model.action.label || $filter('translate')('platform.modal.ModalCtrl.OK')
	            };
	        }
	        // removed quoteAsNonMember, showMemberWarning, membershipValidation and added in PAPolicyInfoCtrl.js
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    //Depends on ./dataStructures/ModalStack.js, but that is loaded as angular module
	    return function () {
	        var $modalProvider = {
	            options: {
	                backdrop: true, //can be also false or 'static'
	                keyboard: true
	            },
	            $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack', function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {
	                var $modal = {};
	
	                function getTemplatePromise(options) {
	                    return options.template ? $q.when(options.template) : $http.get(options.templateUrl, { cache: $templateCache }).then(function (result) {
	                        return result.data;
	                    });
	                }
	
	                function getResolvePromises(resolves) {
	                    var promisesArr = [];
	                    angular.forEach(resolves, function (value) {
	                        if (angular.isFunction(value) || angular.isArray(value)) {
	                            promisesArr.push($q.when($injector.invoke(value)));
	                        }
	                    });
	                    return promisesArr;
	                }
	
	                $modal.open = function (modalOptions) {
	                    var modalResultDeferred = $q.defer();
	                    var modalOpenedDeferred = $q.defer();
	
	                    //prepare an instance of a modal to be injected into controllers and returned to a caller
	                    var modalInstance = {
	                        result: modalResultDeferred.promise,
	                        opened: modalOpenedDeferred.promise,
	                        close: function close(result) {
	                            $modalStack.close(modalInstance, result);
	                        },
	                        dismiss: function dismiss(reason) {
	                            $modalStack.dismiss(modalInstance, reason);
	                        }
	                    };
	
	                    //merge and clean up options
	                    modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	                    modalOptions.resolve = modalOptions.resolve || {};
	
	                    //verify options
	                    if (!modalOptions.template && !modalOptions.templateUrl) {
	                        throw new Error('One of template or templateUrl options is required.');
	                    }
	
	                    var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	                    templateAndResolvePromise.then(function (tplAndVars) {
	                        var modalScope = (modalOptions.scope || $rootScope).$new();
	                        modalScope.$close = modalInstance.close;
	                        modalScope.$dismiss = modalInstance.dismiss;
	
	                        var ctrlLocals = {};
	                        var resolveIter = 1;
	
	                        //controllers
	                        if (modalOptions.controller) {
	                            ctrlLocals.$scope = modalScope;
	                            ctrlLocals.$modalInstance = modalInstance;
	                            angular.forEach(modalOptions.resolve, function (value, key) {
	                                ctrlLocals[key] = tplAndVars[resolveIter++];
	                            });
	
	                            $controller(modalOptions.controller, ctrlLocals);
	                        }
	
	                        $modalStack.open(modalInstance, {
	                            scope: modalScope,
	                            deferred: modalResultDeferred,
	                            content: tplAndVars[0],
	                            backdrop: modalOptions.backdrop,
	                            keyboard: modalOptions.keyboard,
	                            windowClass: modalOptions.windowClass
	                        });
	                    }, function (reason) {
	                        modalResultDeferred.reject(reason);
	                    });
	
	                    templateAndResolvePromise.then(function () {
	                        modalOpenedDeferred.resolve(true);
	                    }, function () {
	                        modalOpenedDeferred.reject(false);
	                    });
	
	                    return modalInstance;
	                };
	
	                return $modal;
	            }]
	        };
	
	        return $modalProvider;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * A helper, internal data structure that acts as a map but also allows getting / removing
	     * elements in the LIFO order
	     */
	    return function () {
	        return {
	            createNew: function createNew() {
	                var stack = [];
	
	                return {
	                    add: function add(key, value) {
	                        stack.push({
	                            key: key,
	                            value: value
	                        });
	                    },
	                    get: function get(key) {
	                        for (var i = 0; i < stack.length; i++) {
	                            if (key === stack[i].key) {
	                                return stack[i];
	                            }
	                        }
	                    },
	                    keys: function keys() {
	                        var keys = [];
	                        for (var i = 0; i < stack.length; i++) {
	                            keys.push(stack[i].key);
	                        }
	                        return keys;
	                    },
	                    top: function top() {
	                        return stack[stack.length - 1];
	                    },
	                    remove: function remove(key) {
	                        var idx = -1;
	                        for (var i = 0; i < stack.length; i++) {
	                            if (key === stack[i].key) {
	                                idx = i;
	                                break;
	                            }
	                        }
	                        return stack.splice(idx, 1)[0];
	                    },
	                    removeTop: function removeTop() {
	                        return stack.splice(stack.length - 1, 1)[0];
	                    },
	                    length: function length() {
	                        return stack.length;
	                    }
	                };
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    //Depends on ./StackedMap.js, but that one should defined as angular module
	    return ['$document', '$compile', '$rootScope', '$$stackedMap', function ($document, $compile, $rootScope, $$stackedMap) {
	        var OPENED_MODAL_CLASS = 'gw-modal-open';
	
	        var backdropjqLiteEl = void 0;
	        var backdropDomEl = void 0;
	        var backdropScope = $rootScope.$new(true);
	        var openedWindows = $$stackedMap.createNew();
	        var $modalStack = {};
	
	        function backdropIndex() {
	            var topBackdropIndex = -1;
	            var opened = openedWindows.keys();
	            for (var i = 0; i < opened.length; i++) {
	                if (openedWindows.get(opened[i]).value.backdrop) {
	                    topBackdropIndex = i;
	                }
	            }
	            return topBackdropIndex;
	        }
	
	        $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	            backdropScope.index = newBackdropIndex;
	        });
	
	        function removeModalWindow(modalInstance) {
	            var body = $document.find('body').eq(0);
	            var modalWindow = openedWindows.get(modalInstance).value;
	
	            //clean up the stack
	            openedWindows.remove(modalInstance);
	
	            //remove window DOM element
	            modalWindow.modalDomEl.remove();
	            body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
	
	            //remove backdrop if no longer needed
	            if (backdropDomEl && backdropIndex() === -1) {
	                backdropDomEl.remove();
	                backdropDomEl = undefined;
	            }
	
	            //destroy scope
	            modalWindow.modalScope.$destroy();
	        }
	
	        $document.bind('keydown', function (evt) {
	            var modal = void 0;
	
	            if (evt.which === 27) {
	                modal = openedWindows.top();
	                if (modal && modal.value.keyboard) {
	                    $rootScope.$apply(function () {
	                        $modalStack.dismiss(modal.key);
	                    });
	                }
	            }
	        });
	
	        $modalStack.open = function (modalInstance, modal) {
	            openedWindows.add(modalInstance, {
	                deferred: modal.deferred,
	                modalScope: modal.scope,
	                backdrop: modal.backdrop,
	                keyboard: modal.keyboard
	            });
	
	            var body = $document.find('body').eq(0);
	
	            if (backdropIndex() >= 0 && !backdropDomEl) {
	                backdropjqLiteEl = angular.element('<div modal-backdrop></div>');
	                backdropDomEl = $compile(backdropjqLiteEl)(backdropScope);
	                body.append(backdropDomEl);
	            }
	
	            var angularDomEl = angular.element('<div modal-window></div>');
	            angularDomEl.attr('window-class', modal.windowClass);
	            angularDomEl.attr('index', openedWindows.length() - 1);
	            angularDomEl.html(modal.content);
	
	            var modalDomEl = $compile(angularDomEl)(modal.scope);
	            openedWindows.top().value.modalDomEl = modalDomEl;
	            body.append(modalDomEl);
	            body.addClass(OPENED_MODAL_CLASS);
	        };
	
	        $modalStack.close = function (modalInstance, result) {
	            var modal = openedWindows.get(modalInstance);
	            if (modal) {
	                modal.value.deferred.resolve(result);
	                removeModalWindow(modalInstance);
	            }
	        };
	
	        $modalStack.dismiss = function (modalInstance, reason) {
	            var modalWindow = openedWindows.get(modalInstance).value;
	            if (modalWindow) {
	                modalWindow.deferred.reject(reason);
	                removeModalWindow(modalInstance);
	            }
	        };
	
	        $modalStack.getTop = function () {
	            return openedWindows.top();
	        };
	
	        return $modalStack;
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(531)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ModalBackdropTemplate) {
	    return ['$modalStack', '$timeout', function ($modalStack, $timeout) {
	        return {
	            restrict: 'EA',
	            replace: true,
	            template: ModalBackdropTemplate,
	            link: function link(scope) {
	                scope.animate = false;
	
	                //trigger CSS transitions
	                $timeout(function () {
	                    scope.animate = true;
	                });
	
	                scope.close = function (evt) {
	                    var modal = $modalStack.getTop();
	                    if (modal && modal.value.backdrop && modal.value.backdrop !== 'static') {
	                        evt.preventDefault();
	                        evt.stopPropagation();
	                        $modalStack.dismiss(modal.key, 'backdrop click');
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-modal-backdrop gw-fade\" ng-class=\"{'gw-in': animate}\" ng-style=\"{'z-index': 1040 + index*10}\"\n     ng-click=\"close($event)\"></div>"

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(533)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ModalWindowTemplate) {
	    return ['$timeout', function ($timeout) {
	        return {
	            restrict: 'EA',
	            scope: {
	                index: '@'
	            },
	            replace: true,
	            transclude: true,
	            template: ModalWindowTemplate,
	            link: function link(scope, element, attrs) {
	                scope.windowClass = attrs.windowClass || '';
	
	                // focus a freshly-opened modal
	                element[0].focus();
	
	                $timeout(function () {
	                    // trigger CSS transitions
	                    scope.animate = true;
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports = "<div tabindex=\"-1\" class=\"gw-modal gw-fade {{ windowClass }}\" ng-class=\"{in: animate}\"\n     ng-style=\"{'z-index': 1050 + index*10}\" ng-transclude></div>"

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$window', 'TransportService', 'CallTrackerService', function ($window, TransportService, CallTrackerService) {
	        return {
	            send: function send(xCenterType, serviceEndpoint, method, params, callGroups) {
	                CallTrackerService.registerCallStart(callGroups);
	                return TransportService.send(xCenterType, serviceEndpoint, method, params).then(function (response) {
	                    CallTrackerService.registerCallSuccess(callGroups);
	                    return response;
	                }, function (error) {
	                    CallTrackerService.registerCallError(callGroups);
	                    if (TransportService.isSessionExpiredReason(error)) {
	                        //refresh the page to get to login page
	                        /* mkarvonen: Set reload to true. Some "autentication solutions" does not set proper
	                         * caching headers.
	                         */
	                        $window.location.reload(true);
	                    }
	                    throw error;
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(536), __webpack_require__(544), __webpack_require__(538), __webpack_require__(539), __webpack_require__(540), __webpack_require__(349), __webpack_require__(541), __webpack_require__(543), __webpack_require__(398), __webpack_require__(511), __webpack_require__(546), __webpack_require__(547), __webpack_require__(548), __webpack_require__(549), __webpack_require__(550), __webpack_require__(551), __webpack_require__(552), __webpack_require__(553)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LanguageSelectDirective, LanguageExpandosDirective, DisplaykeyFormatterDirective, CurrencyFilter, LocaleService, ApplicationFeatures, TranslateService, DateFormatter, localeJSON) {
	    return angular.module('edge.platform.l10n', [
	    // start l10n
	    'ngCookies', 'pascalprecht.translate', 'portal.config', 'tmh.dynamicLocale', 'ngSanitize']).directive('gwPlLanguageSelect', LanguageSelectDirective).directive('gwPlLanguageExpandos', LanguageExpandosDirective).directive('gwDisplaykeyFormat', DisplaykeyFormatterDirective).service('LocaleService', LocaleService).service('DateFormatter', DateFormatter).filter('gwCurrency', CurrencyFilter).constant('DEBUG_MODE', /*DEBUG_MODE_START*/true /*DEBUG_MODE_END*/).constant('ANGULAR-I18N', /*ANGULAR-I18N_START*/'../../common/js/bower_components/angular-i18n' /*ANGULAR-I18N_END*/).constant('LOCALE_INFO', JSON.parse(localeJSON))
	    // Angular debug info
	    .config(['$compileProvider', 'DEBUG_MODE', function ($compileProvider, DEBUG_MODE) {
	        if (!DEBUG_MODE) {
	            $compileProvider.debugInfoEnabled(false); // disables AngularJS debug info
	        }
	    }]).config(['$translateProvider', 'DEBUG_MODE', 'ASYNC_TRANSLATIONS', 'LOCALE_INFO', 'TRANSLATE_PROVIDER_PREFIX', function ($translateProvider, DEBUG_MODE, ASYNC_TRANSLATIONS, LOCALE_INFO, TRANSLATE_PROVIDER_PREFIX) {
	        if (DEBUG_MODE) {
	            $translateProvider.useMissingTranslationHandlerLog(); // warns about missing translates
	        }
	
	        if (ASYNC_TRANSLATIONS) {
	            $translateProvider.useStaticFilesLoader({
	                prefix: TRANSLATE_PROVIDER_PREFIX || '../js/i18n/translations/',
	                suffix: '.json'
	            });
	        }
	
	        $translateProvider.useSanitizeValueStrategy(null); // http://angular-translate.github.io/docs/#/guide/19_security
	        $translateProvider.preferredLanguage(LOCALE_INFO.preferredLocale);
	        $translateProvider.useLocalStorage();
	    }])
	    // Angular Dynamic Locale
	    .config(['tmhDynamicLocaleProvider', 'ANGULARI18N_PRESET', 'ANGULAR-I18N', function (tmhDynamicLocaleProvider, ANGULARI18N_PRESET, ANGULARI18N) {
	        // ANGULARI18N_PRESET is added to reset angular locales path from 3rd party "Portals" (e.g. Components Examples)
	        tmhDynamicLocaleProvider.localeLocationPattern((ANGULARI18N_PRESET || ANGULARI18N) + '/angular-locale_{{locale}}.js');
	    }]).service('TranslateService', TranslateService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(537)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    /**
	     * Widget for displaying language dropdown
	     */
	    return function () {
	        return {
	            restrict: 'A',
	            replace: true,
	            template: templateStr,
	            controller: ['$scope', 'LocaleService', function ($scope, LocaleService) {
	                $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	                $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
	                $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;
	
	                // METHODS
	                $scope.changeLanguage = function (locale) {
	                    LocaleService.setLocaleByDisplayName(locale);
	                    $scope.currentLocaleDisplayName = locale;
	                };
	            }]
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 537 */
/***/ function(module, exports) {

	module.exports = "<div class=\"language-select\" ng-if=\"visible\">\n    <div class=\"gw-pl-dropdown-wrapper\">\n        <span class=\"gw-pl-dropdown-toggle\"\n              gw-pl-dropdown\n              closest-element-to-listen=\".gw-horizontal-scrolling-box\"\n              event-to-listen=\"scroll\"\n        >\n            {{currentLocaleDisplayName}}\n            <span class=\"gw-icon-caret fa fa-caret-down\"></span>\n        </span>\n\n        <div class=\"gw-pl-dropdown-menu-wrapper\">\n            <ul class=\"gw-dropdown-menu\">\n                <li\n                        ng-repeat=\"localeDisplayName in localesDisplayNames\"\n                        ng-click=\"changeLanguage(localeDisplayName)\"\n                        ng-if=\"localeDisplayName !== currentLocaleDisplayName\"\n                >\n                <span class=\"gw-dropdown-menu-item\">\n                    {{localeDisplayName}}\n                </span>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(333)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $) {
	    var PLACEHOLDER_BOUNDARY = '%%';
	    var PLACEHOLDER_RE_BASE = PLACEHOLDER_BOUNDARY + '.+?' + PLACEHOLDER_BOUNDARY;
	
	    var PLACEHOLDER_RE = new RegExp(PLACEHOLDER_RE_BASE); //Used to find next placeholder to replase
	    var PLACEHOLDER_RE_GLOBAL = new RegExp(PLACEHOLDER_RE_BASE, 'g'); //Used to find all placeholders in a string
	    var PLACEHOLDER_STRIP_WRAP_RE = new RegExp('(^' + PLACEHOLDER_BOUNDARY + '|' + PLACEHOLDER_BOUNDARY + '$)', 'g');
	
	    var REPLACES_ATTRIBUTE_NAME = 'gw-displaykey-format-replaces';
	
	    var format = function format(element, _format, values) {
	        element.textContent = _format; //Replace the current node content with the format text
	
	        var placeholders = _format.match(PLACEHOLDER_RE_GLOBAL);
	        if (values.length === 0 || !_format || !placeholders || placeholders.length !== values.length) {
	            throw new Error('Can not successfully format: no format given,\n                 no placeholders in format or number of contained elements\n                 does not matches the number of placeholders');
	        }
	        if (placeholders.length !== _.uniq(placeholders).length) {
	            throw new Error('Same placeholder can not be used twice within one string');
	        }
	
	        var placeholderMatch = void 0;
	        var textNode = element.childNodes[0]; //Contents changed, now first child is the only text node
	
	        /* That assignment is there on purpose */
	        /*eslint-disable */
	
	        var _loop = function _loop() {
	            /*eslint-enable */
	            var placeholderValue = placeholderMatch[0];
	            var placeholderName = placeholderValue.replace(PLACEHOLDER_STRIP_WRAP_RE, '');
	
	            //Split text at placeholder start, now there are two text nodes:
	            //text before placeholder and placeholder with the rest of the text
	            var placeholder = textNode.splitText(placeholderMatch.index);
	
	            //Separate the placeholder, now placeholder node contains nothing but placeholder,
	            //rest of the text is in two neighbouring nodes with textNode containing the rest of unprocessed text
	            textNode = placeholder.splitText(placeholderValue.length);
	
	            /*eslint no-loop-func: 0*/
	            //Replace the node containing the placeholder with whatever was intended to be there
	            var value = values.find(function (_value) {
	                return _value.getAttribute(REPLACES_ATTRIBUTE_NAME) === placeholderName;
	            });
	            if (!value) {
	                throw new Error('No replacement for placeholder ' + placeholderName);
	            }
	            element.replaceChild(value, placeholder);
	        };
	
	        while (placeholderMatch = PLACEHOLDER_RE.exec(textNode.textContent)) {
	            _loop();
	        }
	    };
	
	    /**
	     * Move child elements to respective position inside format string.
	     *
	     * Each replacement element should be marked with 'gw-displaykey-format-replaces' attribute specifying where
	     * in format string should it pe positioned.
	     *
	     * Any other elements not marked with 'gw-displaykey-format-replaces' or text nodes would be silently discarded.
	     *
	     * Placeholders may not be repeated within format string, e.g. "%%duplicate%% %%duplicate%%" would throw an exception.
	     *
	     * @example
	     *  Given key "call.Shruthi": "contact %%name%%",
	     *  this template:
	     *   <gw-displaykey-format format="{{ 'call.Shruthi' | translate }}">
	     *       <a gw-displaykey-format-replaces="name" ui-sref="accounts.detail.summary({accountNumber : activity.accountNumber})">Shruthi</a>
	     *   </gw-displaykey-format>
	     *
	     *  Produces:
	     *   contact <a ui-sref="accounts.detail.summary({accountNumber : activity.accountNumber})">Shruthi</a>
	     *
	     *
	     * @example:
	     *  Given key "my.key": "whaba %%1%% daba %%2%% doo",
	     *  this template:
	     *   <gw-displaykey-format format="{{ 'my.key' | translate }}">
	     *       <a gw-displaykey-format-replaces="1" href="http://guidewire.com">{{myInterpolatedValue}}</a>
	     *       <div gw-displaykey-format-replaces="2">I'm going to be a second inserted value</div>
	     *   </gw-displaykey-format>
	     *
	     *  Produces:
	     *   whaba
	     *   <a href="http://guidewire.com">whatever the value is</a>
	     *   daba
	     *   <div>I'm going to be a second inserted value</div>
	     *   doo
	     *
	     *
	     *
	     * @example:
	     *  Given two keys:
	     *   "agent.directives.activity-view-summary.Action for Product for Account" : "%%action%% for %%product%% for %%account%%",
	     *   "agent.directives.activity-view-summary.Action for Account" : "%%action%% for %%account%%"
	     *
	     *  The following template:
	     *   <gw-displaykey-format format="{{ (activity.productName ? 'agent.directives.activity-view-summary.Action for Product for Account' : 'agent.directives.activity-view-summary.Action for Account') | translate}}">
	     *       <span gw-displaykey-format-replaces="action">{{activity.subject}}</span>
	     *       <span gw-displaykey-format-replaces="product" ng-if="activity.productName">{{activity.productName}}</span>
	     *       <a gw-displaykey-format-replaces="account" ui-sref="accounts.detail.summary({accountNumber : activity.accountNumber})">{{activity.accountHolderName}}</a>
	     *   </gw-displaykey-format>
	     *
	     *  Produces either:
	     *      <span gw-displaykey-format-replaces="action">{{activity.subject}}</span>
	     *      for
	     *      <span gw-displaykey-format-replaces="product">{{activity.productName}}</span>
	     *      for
	     *      <a gw-displaykey-format-replaces="account" ui-sref="accounts.detail.summary({accountNumber : activity.accountNumber})">{{activity.accountHolderName}}</a>
	     *
	     *  or:
	     *      <span gw-displaykey-format-replaces="action">{{activity.subject}}</span>
	     *      for
	     *      <a gw-displaykey-format-replaces="account" ui-sref="accounts.detail.summary({accountNumber : activity.accountNumber})">{{activity.accountHolderName}}</a>
	     *
	     *  depending whether there is an activity.productName
	     */
	    return ['LocaleService', '$compile', function (LocaleService, $compile) {
	        return {
	            restrict: 'E',
	
	            compile: function compile(tElement) {
	                var contents = tElement.html(); //Cache replacements
	                tElement.empty(); //Clean up whatever was there.
	
	                return function ($scope, $element, attrs) {
	                    //Linking method. Need it to watch scope.
	                    var childScope = void 0;
	                    var onScopeChange = function onScopeChange() {
	                        if (childScope) {
	                            //If child scope were to be removed immediately after format, all the bindings would be lost.
	                            childScope.$destroy();
	                        }
	
	                        //Create child scope to link with contents.
	                        //We need a digest cycle to run on the contents after linking.
	                        //Child scope helps avoid infinite loop — now digest runs on child scope and parent scope is left intact.
	                        childScope = $scope.$new();
	
	                        //Directives with transclude: 'element' or directives relying on adding/removing/replacing nodes
	                        //need a parent node to work. Appending resulting elements to a wrapper provides such parent.
	                        //Wrapper is then discarded.
	                        var wrapper = $(document.createElement('div')).append($compile(contents)(childScope));
	
	                        //When child scope finishes digesting (forced below), run format.
	                        //At this point whatever transformations were taking place inside contents should have finished.
	                        childScope.$$postDigest(function () {
	                            var replacements = Array.from(wrapper.get(0).children).filter(
	                            //Only work with elements that have a 'replaces' attribute
	                            function (replacement) {
	                                return replacement.getAttribute(REPLACES_ATTRIBUTE_NAME);
	                            });
	
	                            format($element.get(0), attrs.format, replacements);
	
	                            //Cleanup
	                            wrapper.remove();
	                            wrapper = null;
	                        });
	
	                        if (childScope.$root.$$phase !== '$apply' && childScope.$root.$$phase !== '$digest') {
	                            //Force digest on the child scope otherwise contents are not interpolated
	                            childScope.$digest();
	                        }
	                    };
	
	                    //Call onScopeChange once per frame at 60fps (1000ms / 60)
	                    LocaleService.whenTranslateReady().then(function () {
	                        return $scope.$watch(_.debounce(onScopeChange, 16.6));
	                    });
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['LocaleService', '$filter', function (LocaleService, $filter) {
	        return function (amount) {
	            var formatted = void 0;
	            if (amount) {
	                if (!amount.hasOwnProperty('amount')) {
	                    console.error('Currency without amount was passed into currency filter!');
	                }
	                formatted = $filter('currency')(amount.amount, angular.isDefined(amount.currency) ? LocaleService.getCurrencySymbol(amount.currency) : LocaleService.getLocaleInfo().currency.symbol);
	            }
	            return formatted;
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(398), __webpack_require__(334)], __WEBPACK_AMD_DEFINE_RESULT__ = function (locales, moment) {
	    return ['$translate', 'LOCALE_INFO', '$rootScope', 'tmhDynamicLocale', '$q', function ($translate, LOCALE_INFO, $rootScope, tmhDynamicLocale, $q) {
	        /*--- VARS ---*/
	        var localesObj = LOCALE_INFO.locales;
	        var missingLocales = {};
	
	        // get locales and locales display names
	        var _LOCALES = Object.keys(localesObj);
	        if (!_LOCALES || _LOCALES.length === 0) {
	            console.error('There are no _LOCALES provided');
	        }
	        var _LOCALES_DISPLAY_NAMES = [];
	        _LOCALES.forEach(function (locale) {
	            _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
	        });
	
	        /**
	         * A promise for when angular-translate is loaded and translations are provided
	         * @type {Q.Promise}
	         */
	        var translateReadyDeferred = $q.defer();
	
	        var localeInfo = JSON.parse(locales);
	        var currencySymbols = {
	            'aud': '$',
	            'cad': '$',
	            'eur': '\u20AC',
	            'gbp': '\xA3',
	            'jpy': '\xA5',
	            'rub': '\u20BD',
	            'usd': '$',
	            'chf': 'Fr.',
	            'cny': '\xA5',
	            'nzd': '$'
	        };
	
	        var currentLocale = void 0;
	
	        /*--- METHODS ---*/
	        var checkLocaleIsValid = function checkLocaleIsValid(locale) {
	            return _LOCALES.indexOf(locale) !== -1;
	        };
	
	        var onSettingLocale = function onSettingLocale(locale) {
	            document.mp$currentLocale = locale; // set global var
	            document.documentElement.setAttribute('lang', locale.replace('_', '-')); // set "lang" attribute to html
	        };
	
	        var setLocale = function setLocale(locale) {
	            if (!checkLocaleIsValid(locale)) {
	                console.error('Locale name "' + locale + '" is invalid');
	                return;
	            }
	            startLoadingAnimation();
	            currentLocale = locale;
	            $translate.use(locale);
	        };
	
	        /**
	         * Stop application loading animation when translations are loaded
	         */
	        var $html = angular.element('html');
	        var LOADING_CLASS = 'app-loading';
	
	        function startLoadingAnimation() {
	            $html.addClass(LOADING_CLASS);
	        }
	
	        function stopLoadingAnimation() {
	            $html.removeClass(LOADING_CLASS);
	        }
	
	        /*--- EVENTS ---*/
	        $rootScope.$on('$translateChangeSuccess', function (event, data) {
	            onSettingLocale(data.language);
	            var localeComponents = data.language.split('_');
	            var countryCode = localeInfo.country.code.toLowerCase();
	            if (localeComponents.length > 1) {
	                localeComponents[1] = countryCode;
	            } else {
	                localeComponents.push(countryCode);
	            }
	            var localeCode = localeComponents[0] + '-' + localeComponents[1];
	            var replacementCode = missingLocales[localeCode];
	
	            /**
	             * Set locale for moment.js (is used in datepicker component)
	             * moment.js is loaded with locale included => synchronous change
	             */
	            if (moment.locale(localeCode) !== localeCode) {
	                // if locale isn't provided by moment.js
	
	                if (localeComponents[0] === 'zh') {
	                    //no moment zh.js default to zh-cn.js
	
	                    moment.locale('zh-cn');
	                } else {
	                    moment.locale(localeComponents[0]); // language
	                }
	            }
	
	            tmhDynamicLocale.set(replacementCode || localeCode); // load Angular locale
	
	            translateReadyDeferred.resolve();
	        });
	
	        $rootScope.$on('$localeChangeSuccess', function () {
	            stopLoadingAnimation();
	        });
	
	        $rootScope.$on('$localeChangeError', function (event, data) {
	            var comp = data.split('-');
	            if (comp.length > 1) {
	                missingLocales[data] = comp[0];
	                tmhDynamicLocale.set(comp[0]);
	            } else {
	                stopLoadingAnimation();
	            }
	        });
	
	        /*--- INIT ---*/
	        function onInit() {
	            // store current locale
	            currentLocale = $translate.proposedLanguage() || $translate.use(); // because of async loading
	            onSettingLocale(currentLocale);
	        }
	
	        onInit();
	
	        /*--- RETURN ---*/
	        return {
	            getCountry: function getCountry() {
	                return localeInfo.country;
	            },
	            getLocaleDisplayName: function getLocaleDisplayName() {
	                return localesObj[currentLocale];
	            },
	            setLocaleByDisplayName: function setLocaleByDisplayName(localeDisplayName) {
	                setLocale(_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
	                ]);
	            },
	            getCurrentLocale: function getCurrentLocale() {
	                return currentLocale;
	            },
	
	            getCurrentLanguage: function getCurrentLanguage() {
	                if (currentLocale) {
	                    if (currentLocale.indexOf('_') > -1) {
	                        return currentLocale.split('_').shift();
	                    }
	
	                    return currentLocale;
	                }
	
	                throw new Error('Unknown language');
	            },
	
	            getLocalesDisplayNames: function getLocalesDisplayNames() {
	                return _LOCALES_DISPLAY_NAMES;
	            },
	            getCurrencySymbol: function getCurrencySymbol(currency) {
	                return currencySymbols[currency] || '\xA4';
	            },
	            getNameConfig: function getNameConfig() {
	                return localeInfo.name;
	            },
	            getAddressConfig: function getAddressConfig() {
	                return localeInfo.address;
	            },
	            getLocaleInfo: function getLocaleInfo() {
	                return localeInfo;
	            },
	            getRegionSamplePhoneNumber: function getRegionSamplePhoneNumber() {
	                return localeInfo.phone.sample;
	            },
	            getConfiguredPhoneRegion: function getConfiguredPhoneRegion() {
	                return localeInfo.phone.UserDefaultPhoneCountry;
	            },
	
	            whenTranslateReady: function whenTranslateReady() {
	                return translateReadyDeferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @name TranslateService
	 * @description
	 * Service for locale change watching and updating translations
	 * Provide workaround to avoid many $rootScope.$translateChangeSuccess and $scope.$destroy listeners
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(542), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (KeyTranslator, _) {
	    return ['$translate', '$rootScope', function ($translate, $rootScope) {
	        // VARS
	        var watchers = {}; // contains all translations watchers
	        var watcherId = 0; // ID to increment and store for each translation watcher
	        var scopes = []; // contains unique scopes to identify $destroy listeners
	
	        var keyTranslators = {}; // Translators for the keys.
	
	        // METHODS
	
	        /** Retrieves a translator for the key. Creates a new translator if it is not present yet. */
	        function getKeyTranslator(key) {
	            if (keyTranslators.hasOwnProperty(key)) {
	                return keyTranslators[key];
	            }
	            var res = KeyTranslator.create($translate.instant, key, $translate(key));
	            keyTranslators[key] = res;
	            return res;
	        }
	
	        /** Narrows down the translator with the specific prefix. Instead of
	         * base.immediate('a.b.c.d.Key')
	         * base.immediate('a.b.c.d.AnotherKey')
	         * you could use
	         * const T = base.narrowDown('a.b.c.d')
	         * T.immediate('Key')
	         * T.immediate('AnotherKey')
	         * @param base base translator.
	         * @param prefix {String} prefix to prepend to each translation key.
	         */
	        function _narrowDown(base, prefix) {
	            return {
	                'translate': function translate(params) {
	                    params = Object.create(params);
	                    if (_typeof(params.displayKey) === 'object') {
	                        params.displayKey = {
	                            'key': prefix + params.displayKey.key,
	                            'args': params.displayKey.args
	                        };
	                    } else {
	                        params.displayKey = prefix + params.displayKey;
	                    }
	                    return base.translate(params);
	                },
	                'instant': function instant(key, params) {
	                    return base.instant(prefix + key, params);
	                },
	                'bindTranslation': function bindTranslation(key, params) {
	                    return base.bindTranslation(prefix + key, params);
	                },
	                'apply': function apply(key, params) {
	                    return base.apply(prefix + key, params);
	                },
	                'narrowDown': function narrowDown(otherPrefix) {
	                    return _narrowDown(base, '' + prefix + otherPrefix + '.');
	                }
	            };
	        }
	
	        /**
	         * Remove translation watch data on scope.$destroy
	         * If there is already listener for current scope- adds current watcher's ID there to be destroyed
	         *
	         * @param scope {Scope}
	         * @param _watcherId {Number} Translation watcher ID
	         */
	        var addDestroyListener = function addDestroyListener(scope, _watcherId) {
	            if (scopes.indexOf(scope) === -1) {
	                // there isn't listener of the current scope $destroy
	                scope.$on('$destroy', function () {
	                    watchers[_watcherId].removeOnDestroy.forEach(function (watcherIdToBeRemoved) {
	                        delete watchers[watcherIdToBeRemoved];
	                    });
	                    scopes.splice(scopes.indexOf(scope), 1); // remove $scope from "scopes"
	                });
	                scopes.push(scope); // add $scope to "scopes"
	            } else {
	                // there is already listener of the current scope $destroy
	                watchers[_watcherId].removeOnDestroy.push(_watcherId); // add current watcher to be removed on scope.$destroy
	            }
	        };
	
	        /**
	         * Provides current translation via Promise
	         * @param params.object {Object} object inside which translation has to be provided. Object- to pass-by-reference translation inside code
	         * @param params.propName {String} Property name where correct translation has to be provided
	         * @param params.displayKey {String|Object} display entity to be translated
	         * @param params.displayKeyArgs {Object} arguments for string interpolation during translation
	         * @param params._watcherId {Number} Translation watcher ID
	         */
	        var getCurrentTranslation = function getCurrentTranslation(params) {
	            $translate(params.displayKey, params.displayKeyArgs).then(function (translatedValue) {
	                if (!watchers[params._watcherId]) {
	                    return; // e.g. when scope is already destroyed
	                }
	                params.object[params.propName] = translatedValue; // provide translated value to object
	            });
	        };
	
	        /**
	         * Provides correct translations with update on locale change
	         *
	         * @param params.object {Object} object inside which translation has to be provided. Object- to pass-by-reference translation inside code
	         * @param params.propName {String} Property name where correct translation has to be provided
	         * @param params.displayKey {String|Object} display entity to be translated
	         * @param [params.scope] {Scope} scope to remove translation watcher data on $destroy
	         *
	         * Examples:
	         *
	         * TranslateService.translate({
	         *  object: obj1,
	         *  displayKey: 'platform.inputs.address-details.City',
	         *  propName: 'name',
	         *  scope: $scope
	         * });
	         *
	         * TranslateService.translate({
	         *  object: obj2,
	         *  displayKey: {
	         *      "args": {
	         *          "max": 60,
	         *          "min": 0
	         *      },
	         *      "key": "displaykey.Edge.Web.Api.Model.Size"
	         *  },
	         *  propName: 'name'
	         * });
	         *
	         */
	        var translate = function translate(params) {
	            var object = params.object; // required
	            var propName = params.propName; // required
	
	            var displayKey = void 0;
	            var displayKeyArgs = {};
	
	            if (_typeof(params.displayKey) === 'object') {
	                displayKey = params.displayKey.key;
	                displayKeyArgs = params.displayKey.args;
	            } else {
	                displayKey = params.displayKey;
	            }
	
	            var scope = params.scope; // optional
	            var _watcherId = ++watcherId;
	
	            watchers[_watcherId] = {
	                object: object,
	                propName: propName,
	                displayKey: displayKey,
	                displayKeyArgs: displayKeyArgs,
	                scope: scope,
	                removeOnDestroy: [_watcherId] // watchers objects to be removed on scope.$destroy (might be extended with others to avoid many scope.$destroy listeners)
	            };
	
	            getCurrentTranslation({
	                object: object,
	                propName: propName,
	                displayKey: displayKey,
	                displayKeyArgs: displayKeyArgs,
	                _watcherId: _watcherId
	            });
	
	            if (scope) {
	                addDestroyListener(scope, _watcherId);
	            }
	        };
	
	        /**
	         * Update all translations using resources file for selected locale
	         */
	        var updateTranslations = function updateTranslations() {
	            Object.keys(watchers).forEach(function (_watcherId) {
	                var watcher = watchers[_watcherId];
	                watcher.object[watcher.propName] = $translate.instant(watcher.displayKey, watcher.displayKeyArgs);
	            });
	            _.values(keyTranslators).forEach(function (keyTranslator) {
	                keyTranslator.refresh();
	            });
	        };
	
	        // EVENTS
	        $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // RETURN
	        var baseTranslator = {
	            translate: translate,
	            /** Returns an instant translation. */
	            instant: function instant(key, args) {
	                return getKeyTranslator(key).translate(args);
	            },
	            /** Returns a function used to translate value in current locale.
	             * <em>Warning</em>. This is not a monadic bind.
	             */
	            bindTranslation: function bindTranslation(key, args) {
	                return _.partial(getKeyTranslator(key).translate, args);
	            },
	            /** "Applicative" application of the translation. Each argument could be a function used to evaluate an
	             * argument or the constant value itself. Functions are called (without arguments) to get actual value
	             * arguments during each call.
	             */
	            apply: function apply(key, args) {
	                var translator = getKeyTranslator(key);
	                return function () {
	                    return translator.translate(_.mapObject(args, function (argValue) {
	                        return _.isFunction(argValue) ? argValue() : argValue;
	                    }));
	                };
	            },
	            'narrowDown': function narrowDown(prefix) {
	                return _narrowDown(baseTranslator, prefix + '.');
	            }
	        };
	
	        return baseTranslator;
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /** Creates a new display key translator. Display key translator have to functions. <code>translate</code> is used
	     * to provide an immediate version of the translation. It would produce an empty string if translations are not
	     * ready yet. <code>refresh</code> is used to notify this key translator that translations changed.
	     * @param imm function for the immediate translation.
	     * @param key key of this translator.
	     * @param promise promise for the key translation. This key is marked as "ready" after the promise is resolved.
	     */
	    function create(imm, key, promise) {
	        var ready = false;
	        var staticText = void 0;
	        promise.then(function (value) {
	            staticText = value;
	        });
	        promise.finally(function () {
	            ready = true;
	        });
	
	        return {
	            'translate': function translate(params) {
	                if (!ready) {
	                    return '';
	                }
	                if (!params) {
	                    return staticText;
	                }
	                return imm(key, params);
	            },
	            'refresh': function refresh() {
	                staticText = imm(key);
	            }
	        };
	    }
	
	    /** Implementation of the translator for the single display key (and do this very good).
	     * Main responsibility of this class is to provide an immediate translation even if it is not loaded yet. It could
	     * also update translation after parent notifies it about the locale change.
	     */
	    return {
	        create: create
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$filter', function ($filter) {
	        return {
	            formatShortDate: function formatShortDate(date) {
	                return $filter('date')(new Date(date), 'shortDate');
	            }
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(545)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    /**
	     * Widget for displaying language expandos
	     */
	    return function () {
	        return {
	            restrict: 'A',
	            replace: true,
	            template: templateStr,
	            controller: ['$scope', 'LocaleService', function ($scope, LocaleService) {
	                $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
	                $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
	                $scope.isVisible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;
	                $scope.isOpen = false;
	
	                // METHODS
	                $scope.changeLanguage = function (locale) {
	                    LocaleService.setLocaleByDisplayName(locale);
	                    $scope.currentLocaleDisplayName = locale;
	                };
	                $scope.toggleExpandos = function () {
	                    $scope.isOpen = !$scope.isOpen;
	                };
	            }]
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 545 */
/***/ function(module, exports) {

	module.exports = "<div\n        class=\"language-expandos\"\n        ng-class=\"{'gw-open': isOpen}\"\n        ng-if=\"isVisible\"\n>\n    <div class=\"drawer-menu-item\"\n         ng-click=\"toggleExpandos()\"\n    >\n            <span class=\"pull-right\">\n                <i class=\"gw-icon-caret fa fa-caret-down\"></i>\n            </span>\n        {{currentLocaleDisplayName}}\n    </div>\n    <ul class=\"expandos-menu\">\n        <li\n                ng-repeat=\"localeDisplayName in localesDisplayNames\"\n                ng-click=\"changeLanguage(localeDisplayName)\"\n                ng-if=\"localeDisplayName !== currentLocaleDisplayName\"\n        >\n            <div class=\"drawer-menu-item\">\n                {{localeDisplayName}}\n            </div>\n        </li>\n    </ul>\n</div>"

/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.4.8
	 * (c) 2010-2015 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this would be the URL that appears in your base tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For obvious security reasons the user agent will not accept the
	     *   cookie if the current domain is not a sub domain or equals to the requested domain.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - The cookie will be available only in secured connection.
	     *
	     * Note: by default the address that appears in your `<base>` tag will be used as path.
	     * This is important so that cookies will be visible for all routes in case html5mode is enabled
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ },
/* 547 */
/***/ function(module, exports) {

	/*!
	 * angular-translate - v2.7.2 - 2015-06-01
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	!function(a,b){"function"==typeof define&&define.amd?define([],function(){return b()}):"object"==typeof exports?module.exports=b():b()}(this,function(){function a(a){"use strict";var b=a.storageKey(),c=a.storage(),d=function(){var d=a.preferredLanguage();angular.isString(d)?a.use(d):c.put(b,a.use())};d.displayName="fallbackFromIncorrectStorageValue",c?c.get(b)?a.use(c.get(b))["catch"](d):d():angular.isString(a.preferredLanguage())&&a.use(a.preferredLanguage())}function b(){"use strict";var a,b,c=null,d=!1,e=!1;b={sanitize:function(a,b){return"text"===b&&(a=g(a)),a},escape:function(a,b){return"text"===b&&(a=f(a)),a},sanitizeParameters:function(a,b){return"params"===b&&(a=h(a,g)),a},escapeParameters:function(a,b){return"params"===b&&(a=h(a,f)),a}},b.escaped=b.escapeParameters,this.addStrategy=function(a,c){return b[a]=c,this},this.removeStrategy=function(a){return delete b[a],this},this.useStrategy=function(a){return d=!0,c=a,this},this.$get=["$injector","$log",function(f,g){var h=function(a,c,d){return angular.forEach(d,function(d){if(angular.isFunction(d))a=d(a,c);else{if(!angular.isFunction(b[d]))throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+d+"'");a=b[d](a,c)}}),a},i=function(){d||e||(g.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."),e=!0)};return f.has("$sanitize")&&(a=f.get("$sanitize")),{useStrategy:function(a){return function(b){a.useStrategy(b)}}(this),sanitize:function(a,b,d){if(c||i(),arguments.length<3&&(d=c),!d)return a;var e=angular.isArray(d)?d:[d];return h(a,b,e)}}}];var f=function(a){var b=angular.element("<div></div>");return b.text(a),b.html()},g=function(b){if(!a)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");return a(b)},h=function(a,b){if(angular.isObject(a)){var c=angular.isArray(a)?[]:{};return angular.forEach(a,function(a,d){c[d]=h(a,b)}),c}return angular.isNumber(a)?a:b(a)}}function c(a,b,c,d){"use strict";var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t={},u=[],v=a,w=[],x="translate-cloak",y=!1,z=!1,A=".",B=0,C=!0,D="default",E={"default":function(a){return(a||"").split("-").join("_")},java:function(a){var b=(a||"").split("-").join("_"),c=b.split("_");return c.length>1?c[0].toLowerCase()+"_"+c[1].toUpperCase():b},bcp47:function(a){var b=(a||"").split("_").join("-"),c=b.split("-");return c.length>1?c[0].toLowerCase()+"-"+c[1].toUpperCase():b}},F="2.7.2",G=function(){if(angular.isFunction(d.getLocale))return d.getLocale();var a,c,e=b.$get().navigator,f=["language","browserLanguage","systemLanguage","userLanguage"];if(angular.isArray(e.languages))for(a=0;a<e.languages.length;a++)if(c=e.languages[a],c&&c.length)return c;for(a=0;a<f.length;a++)if(c=e[f[a]],c&&c.length)return c;return null};G.displayName="angular-translate/service: getFirstBrowserLanguage";var H=function(){var a=G()||"";return E[D]&&(a=E[D](a)),a};H.displayName="angular-translate/service: getLocale";var I=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},J=function(){return this.toString().replace(/^\s+|\s+$/g,"")},K=function(a){for(var b=[],c=angular.lowercase(a),d=0,e=u.length;e>d;d++)b.push(angular.lowercase(u[d]));if(I(b,c)>-1)return a;if(f){var g;for(var h in f){var i=!1,j=Object.prototype.hasOwnProperty.call(f,h)&&angular.lowercase(h)===angular.lowercase(a);if("*"===h.slice(-1)&&(i=h.slice(0,-1)===a.slice(0,h.length-1)),(j||i)&&(g=f[h],I(b,angular.lowercase(g))>-1))return g}}if(a){var k=a.split("_");if(k.length>1&&I(b,angular.lowercase(k[0]))>-1)return k[0]}return a},L=function(a,b){if(!a&&!b)return t;if(a&&!b){if(angular.isString(a))return t[a]}else angular.isObject(t[a])||(t[a]={}),angular.extend(t[a],M(b));return this};this.translations=L,this.cloakClassName=function(a){return a?(x=a,this):x};var M=function(a,b,c,d){var e,f,g,h;b||(b=[]),c||(c={});for(e in a)Object.prototype.hasOwnProperty.call(a,e)&&(h=a[e],angular.isObject(h)?M(h,b.concat(e),c,e):(f=b.length?""+b.join(A)+A+e:e,b.length&&e===d&&(g=""+b.join(A),c[g]="@:"+f),c[f]=h));return c};M.displayName="flatObject",this.addInterpolation=function(a){return w.push(a),this},this.useMessageFormatInterpolation=function(){return this.useInterpolation("$translateMessageFormatInterpolation")},this.useInterpolation=function(a){return n=a,this},this.useSanitizeValueStrategy=function(a){return c.useStrategy(a),this},this.preferredLanguage=function(a){return N(a),this};var N=function(a){return a&&(e=a),e};this.translationNotFoundIndicator=function(a){return this.translationNotFoundIndicatorLeft(a),this.translationNotFoundIndicatorRight(a),this},this.translationNotFoundIndicatorLeft=function(a){return a?(q=a,this):q},this.translationNotFoundIndicatorRight=function(a){return a?(r=a,this):r},this.fallbackLanguage=function(a){return O(a),this};var O=function(a){return a?(angular.isString(a)?(h=!0,g=[a]):angular.isArray(a)&&(h=!1,g=a),angular.isString(e)&&I(g,e)<0&&g.push(e),this):h?g[0]:g};this.use=function(a){if(a){if(!t[a]&&!o)throw new Error("$translateProvider couldn't find translationTable for langKey: '"+a+"'");return i=a,this}return i};var P=function(a){return a?(v=a,this):l?l+v:v};this.storageKey=P,this.useUrlLoader=function(a,b){return this.useLoader("$translateUrlLoader",angular.extend({url:a},b))},this.useStaticFilesLoader=function(a){return this.useLoader("$translateStaticFilesLoader",a)},this.useLoader=function(a,b){return o=a,p=b||{},this},this.useLocalStorage=function(){return this.useStorage("$translateLocalStorage")},this.useCookieStorage=function(){return this.useStorage("$translateCookieStorage")},this.useStorage=function(a){return k=a,this},this.storagePrefix=function(a){return a?(l=a,this):a},this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog")},this.useMissingTranslationHandler=function(a){return m=a,this},this.usePostCompiling=function(a){return y=!!a,this},this.forceAsyncReload=function(a){return z=!!a,this},this.uniformLanguageTag=function(a){return a?angular.isString(a)&&(a={standard:a}):a={},D=a.standard,this},this.determinePreferredLanguage=function(a){var b=a&&angular.isFunction(a)?a():H();return e=u.length?K(b):b,this},this.registerAvailableLanguageKeys=function(a,b){return a?(u=a,b&&(f=b),this):u},this.useLoaderCache=function(a){return a===!1?s=void 0:a===!0?s=!0:"undefined"==typeof a?s="$translationCache":a&&(s=a),this},this.directivePriority=function(a){return void 0===a?B:(B=a,this)},this.statefulFilter=function(a){return void 0===a?C:(C=a,this)},this.$get=["$log","$injector","$rootScope","$q",function(a,b,c,d){var f,l,u,A=b.get(n||"$translateDefaultInterpolation"),D=!1,E={},G={},H=function(a,b,c,h){if(angular.isArray(a)){var j=function(a){for(var e={},f=[],g=function(a){var f=d.defer(),g=function(b){e[a]=b,f.resolve([a,b])};return H(a,b,c,h).then(g,g),f.promise},i=0,j=a.length;j>i;i++)f.push(g(a[i]));return d.all(f).then(function(){return e})};return j(a)}var m=d.defer();a&&(a=J.apply(a));var n=function(){var a=e?G[e]:G[i];if(l=0,k&&!a){var b=f.get(v);if(a=G[b],g&&g.length){var c=I(g,b);l=0===c?1:0,I(g,e)<0&&g.push(e)}}return a}();if(n){var o=function(){ab(a,b,c,h).then(m.resolve,m.reject)};o.displayName="promiseResolved",n["finally"](o,m.reject)}else ab(a,b,c,h).then(m.resolve,m.reject);return m.promise},Q=function(a){return q&&(a=[q,a].join(" ")),r&&(a=[a,r].join(" ")),a},R=function(a){i=a,c.$emit("$translateChangeSuccess",{language:a}),k&&f.put(H.storageKey(),i),A.setLocale(i);var b=function(a,b){E[b].setLocale(i)};b.displayName="eachInterpolatorLocaleSetter",angular.forEach(E,b),c.$emit("$translateChangeEnd",{language:a})},S=function(a){if(!a)throw"No language key specified for loading.";var e=d.defer();c.$emit("$translateLoadingStart",{language:a}),D=!0;var f=s;"string"==typeof f&&(f=b.get(f));var g=angular.extend({},p,{key:a,$http:angular.extend({},{cache:f},p.$http)}),h=function(b){var d={};c.$emit("$translateLoadingSuccess",{language:a}),angular.isArray(b)?angular.forEach(b,function(a){angular.extend(d,M(a))}):angular.extend(d,M(b)),D=!1,e.resolve({key:a,table:d}),c.$emit("$translateLoadingEnd",{language:a})};h.displayName="onLoaderSuccess";var i=function(a){c.$emit("$translateLoadingError",{language:a}),e.reject(a),c.$emit("$translateLoadingEnd",{language:a})};return i.displayName="onLoaderError",b.get(o)(g).then(h,i),e.promise};if(k&&(f=b.get(k),!f.get||!f.put))throw new Error("Couldn't use storage '"+k+"', missing get() or put() method!");if(w.length){var T=function(a){var c=b.get(a);c.setLocale(e||i),E[c.getInterpolationIdentifier()]=c};T.displayName="interpolationFactoryAdder",angular.forEach(w,T)}var U=function(a){var b=d.defer();if(Object.prototype.hasOwnProperty.call(t,a))b.resolve(t[a]);else if(G[a]){var c=function(a){L(a.key,a.table),b.resolve(a.table)};c.displayName="translationTableResolver",G[a].then(c,b.reject)}else b.reject();return b.promise},V=function(a,b,c,e){var f=d.defer(),g=function(d){if(Object.prototype.hasOwnProperty.call(d,b)){e.setLocale(a);var g=d[b];"@:"===g.substr(0,2)?V(a,g.substr(2),c,e).then(f.resolve,f.reject):f.resolve(e.interpolate(d[b],c)),e.setLocale(i)}else f.reject()};return g.displayName="fallbackTranslationResolver",U(a).then(g,f.reject),f.promise},W=function(a,b,c,d){var e,f=t[a];if(f&&Object.prototype.hasOwnProperty.call(f,b)){if(d.setLocale(a),e=d.interpolate(f[b],c),"@:"===e.substr(0,2))return W(a,e.substr(2),c,d);d.setLocale(i)}return e},X=function(a,c){if(m){var d=b.get(m)(a,i,c);return void 0!==d?d:a}return a},Y=function(a,b,c,e,f){var h=d.defer();if(a<g.length){var i=g[a];V(i,b,c,e).then(h.resolve,function(){Y(a+1,b,c,e,f).then(h.resolve)})}else h.resolve(f?f:X(b,c));return h.promise},Z=function(a,b,c,d){var e;if(a<g.length){var f=g[a];e=W(f,b,c,d),e||(e=Z(a+1,b,c,d))}return e},$=function(a,b,c,d){return Y(u>0?u:l,a,b,c,d)},_=function(a,b,c){return Z(u>0?u:l,a,b,c)},ab=function(a,b,c,e){var f=d.defer(),h=i?t[i]:t,j=c?E[c]:A;if(h&&Object.prototype.hasOwnProperty.call(h,a)){var k=h[a];"@:"===k.substr(0,2)?H(k.substr(2),b,c,e).then(f.resolve,f.reject):f.resolve(j.interpolate(k,b))}else{var l;m&&!D&&(l=X(a,b)),i&&g&&g.length?$(a,b,j,e).then(function(a){f.resolve(a)},function(a){f.reject(Q(a))}):m&&!D&&l?f.resolve(e?e:l):e?f.resolve(e):f.reject(Q(a))}return f.promise},bb=function(a,b,c){var d,e=i?t[i]:t,f=A;if(E&&Object.prototype.hasOwnProperty.call(E,c)&&(f=E[c]),e&&Object.prototype.hasOwnProperty.call(e,a)){var h=e[a];d="@:"===h.substr(0,2)?bb(h.substr(2),b,c):f.interpolate(h,b)}else{var j;m&&!D&&(j=X(a,b)),i&&g&&g.length?(l=0,d=_(a,b,f)):d=m&&!D&&j?j:Q(a)}return d},cb=function(a){j===a&&(j=void 0),G[a]=void 0};if(H.preferredLanguage=function(a){return a&&N(a),e},H.cloakClassName=function(){return x},H.fallbackLanguage=function(a){if(void 0!==a&&null!==a){if(O(a),o&&g&&g.length)for(var b=0,c=g.length;c>b;b++)G[g[b]]||(G[g[b]]=S(g[b]));H.use(H.use())}return h?g[0]:g},H.useFallbackLanguage=function(a){if(void 0!==a&&null!==a)if(a){var b=I(g,a);b>-1&&(u=b)}else u=0},H.proposedLanguage=function(){return j},H.storage=function(){return f},H.use=function(a){if(!a)return i;var b=d.defer();c.$emit("$translateChangeStart",{language:a});var e=K(a);return e&&(a=e),!z&&t[a]||!o||G[a]?j===a&&G[a]?G[a].then(function(a){return b.resolve(a.key),a},function(a){return b.reject(a),d.reject(a)}):(b.resolve(a),R(a)):(j=a,G[a]=S(a).then(function(a){return L(a.key,a.table),b.resolve(a.key),R(a.key),a},function(a){return c.$emit("$translateChangeError",{language:a}),b.reject(a),c.$emit("$translateChangeEnd",{language:a}),d.reject(a)}),G[a]["finally"](function(){cb(a)})),b.promise},H.storageKey=function(){return P()},H.isPostCompilingEnabled=function(){return y},H.isForceAsyncReloadEnabled=function(){return z},H.refresh=function(a){function b(){f.resolve(),c.$emit("$translateRefreshEnd",{language:a})}function e(){f.reject(),c.$emit("$translateRefreshEnd",{language:a})}if(!o)throw new Error("Couldn't refresh translation table, no loader registered!");var f=d.defer();if(c.$emit("$translateRefreshStart",{language:a}),a)if(t[a]){var h=function(c){L(c.key,c.table),a===i&&R(i),b()};h.displayName="refreshPostProcessor",S(a).then(h,e)}else e();else{var j=[],k={};if(g&&g.length)for(var l=0,m=g.length;m>l;l++)j.push(S(g[l])),k[g[l]]=!0;i&&!k[i]&&j.push(S(i));var n=function(a){t={},angular.forEach(a,function(a){L(a.key,a.table)}),i&&R(i),b()};n.displayName="refreshPostProcessor",d.all(j).then(n,e)}return f.promise},H.instant=function(a,b,c){if(null===a||angular.isUndefined(a))return a;if(angular.isArray(a)){for(var d={},f=0,h=a.length;h>f;f++)d[a[f]]=H.instant(a[f],b,c);return d}if(angular.isString(a)&&a.length<1)return a;a&&(a=J.apply(a));var j,k=[];e&&k.push(e),i&&k.push(i),g&&g.length&&(k=k.concat(g));for(var l=0,n=k.length;n>l;l++){var o=k[l];if(t[o]&&("undefined"!=typeof t[o][a]?j=bb(a,b,c):(q||r)&&(j=Q(a))),"undefined"!=typeof j)break}return j||""===j||(j=A.interpolate(a,b),m&&!D&&(j=X(a,b))),j},H.versionInfo=function(){return F},H.loaderCache=function(){return s},H.directivePriority=function(){return B},H.statefulFilter=function(){return C},o&&(angular.equals(t,{})&&H.use(H.use()),g&&g.length))for(var db=function(a){return L(a.key,a.table),c.$emit("$translateChangeEnd",{language:a.key}),a},eb=0,fb=g.length;fb>eb;eb++){var gb=g[eb];(z||!t[gb])&&(G[gb]=S(gb).then(db))}return H}]}function d(a,b){"use strict";var c,d={},e="default";return d.setLocale=function(a){c=a},d.getInterpolationIdentifier=function(){return e},d.useSanitizeValueStrategy=function(a){return b.useStrategy(a),this},d.interpolate=function(c,d){d=d||{},d=b.sanitize(d,"params");var e=a(c)(d);return e=b.sanitize(e,"text")},d}function e(a,b,c,d,e,f){"use strict";var g=function(){return this.toString().replace(/^\s+|\s+$/g,"")};return{restrict:"AE",scope:!0,priority:a.directivePriority(),compile:function(b,h){var i=h.translateValues?h.translateValues:void 0,j=h.translateInterpolation?h.translateInterpolation:void 0,k=b[0].outerHTML.match(/translate-value-+/i),l="^(.*)("+c.startSymbol()+".*"+c.endSymbol()+")(.*)",m="^(.*)"+c.startSymbol()+"(.*)"+c.endSymbol()+"(.*)";return function(b,n,o){b.interpolateParams={},b.preText="",b.postText="";var p={},q=function(a,c,d){if(c.translateValues&&angular.extend(a,e(c.translateValues)(b.$parent)),k)for(var f in d)if(Object.prototype.hasOwnProperty.call(c,f)&&"translateValue"===f.substr(0,14)&&"translateValues"!==f){var g=angular.lowercase(f.substr(14,1))+f.substr(15);a[g]=d[f]}},r=function(a){if(angular.isFunction(r._unwatchOld)&&(r._unwatchOld(),r._unwatchOld=void 0),angular.equals(a,"")||!angular.isDefined(a)){var d=g.apply(n.text()).match(l);if(angular.isArray(d)){b.preText=d[1],b.postText=d[3],p.translate=c(d[2])(b.$parent);var e=n.text().match(m);angular.isArray(e)&&e[2]&&e[2].length&&(r._unwatchOld=b.$watch(e[2],function(a){p.translate=a,x()}))}else p.translate=n.text().replace(/^\s+|\s+$/g,"")}else p.translate=a;x()},s=function(a){o.$observe(a,function(b){p[a]=b,x()})};q(b.interpolateParams,o,h);var t=!0;o.$observe("translate",function(a){"undefined"==typeof a?r(""):""===a&&t||(p.translate=a,x()),t=!1});for(var u in o)o.hasOwnProperty(u)&&"translateAttr"===u.substr(0,13)&&s(u);if(o.$observe("translateDefault",function(a){b.defaultText=a}),i&&o.$observe("translateValues",function(a){a&&b.$parent.$watch(function(){angular.extend(b.interpolateParams,e(a)(b.$parent))})}),k){var v=function(a){o.$observe(a,function(c){var d=angular.lowercase(a.substr(14,1))+a.substr(15);b.interpolateParams[d]=c})};for(var w in o)Object.prototype.hasOwnProperty.call(o,w)&&"translateValue"===w.substr(0,14)&&"translateValues"!==w&&v(w)}var x=function(){for(var a in p)p.hasOwnProperty(a)&&void 0!==p[a]&&y(a,p[a],b,b.interpolateParams,b.defaultText)},y=function(b,c,d,e,f){c?a(c,e,j,f).then(function(a){z(a,d,!0,b)},function(a){z(a,d,!1,b)}):z(c,d,!1,b)},z=function(b,c,e,f){if("translate"===f){e||"undefined"==typeof c.defaultText||(b=c.defaultText),n.html(c.preText+b+c.postText);var g=a.isPostCompilingEnabled(),i="undefined"!=typeof h.translateCompile,j=i&&"false"!==h.translateCompile;(g&&!i||j)&&d(n.contents())(c)}else{e||"undefined"==typeof c.defaultText||(b=c.defaultText);var k=o.$attr[f];"data-"===k.substr(0,5)&&(k=k.substr(5)),k=k.substr(15),n.attr(k,b)}};(i||k||o.translateDefault)&&b.$watch("interpolateParams",x,!0);var A=f.$on("$translateChangeSuccess",x);n.text().length?r(o.translate?o.translate:""):o.translate&&r(o.translate),x(),b.$on("$destroy",A)}}}}function f(a,b){"use strict";return{compile:function(c){var d=function(){c.addClass(b.cloakClassName())},e=function(){c.removeClass(b.cloakClassName())},f=a.$on("$translateChangeEnd",function(){e(),f(),f=null});return d(),function(a,c,f){f.translateCloak&&f.translateCloak.length&&f.$observe("translateCloak",function(a){b(a).then(e,d)})}}}}function g(a,b){"use strict";var c=function(c,d,e){return angular.isObject(d)||(d=a(d)(this)),b.instant(c,d,e)};return b.statefulFilter()&&(c.$stateful=!0),c}function h(a){"use strict";return a("translations")}return angular.module("pascalprecht.translate",["ng"]).run(a),a.$inject=["$translate"],a.displayName="runTranslate",angular.module("pascalprecht.translate").provider("$translateSanitization",b),angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider",{}).provider("$translate",c),c.$inject=["$STORAGE_KEY","$windowProvider","$translateSanitizationProvider","pascalprechtTranslateOverrider"],c.displayName="displayName",angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation",d),d.$inject=["$interpolate","$translateSanitization"],d.displayName="$translateDefaultInterpolation",angular.module("pascalprecht.translate").constant("$STORAGE_KEY","NG_TRANSLATE_LANG_KEY"),angular.module("pascalprecht.translate").directive("translate",e),e.$inject=["$translate","$q","$interpolate","$compile","$parse","$rootScope"],e.displayName="translateDirective",angular.module("pascalprecht.translate").directive("translateCloak",f),f.$inject=["$rootScope","$translate"],f.displayName="translateCloakDirective",angular.module("pascalprecht.translate").filter("translate",g),g.$inject=["$parse","$translate"],g.displayName="translateFilterFactory",angular.module("pascalprecht.translate").factory("$translationCache",h),h.$inject=["$cacheFactory"],h.displayName="$translationCache","pascalprecht.translate"});

/***/ },
/* 548 */
/***/ function(module, exports) {

	/*!
	 * angular-translate - v2.7.2 - 2015-06-01
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    define([], function () {
	      return (factory());
	    });
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateCookieStorage
	 * @requires $cookieStore
	 *
	 * @description
	 * Abstraction layer for cookieStore. This service is used when telling angular-translate
	 * to use cookieStore as storage.
	 *
	 */
	  .factory('$translateCookieStorage', $translateCookieStorageFactory);
	
	function $translateCookieStorageFactory($cookieStore) {
	
	  'use strict';
	
	  var $translateCookieStorage = {
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#get
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Returns an item from cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @return {string} Value of item name
	     */
	    get: function (name) {
	      return $cookieStore.get(name);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#set
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @deprecated use #put
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    set: function (name, value) {
	      $cookieStore.put(name, value);
	    },
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translateCookieStorage#put
	     * @methodOf pascalprecht.translate.$translateCookieStorage
	     *
	     * @description
	     * Sets an item in cookieStorage by given name.
	     *
	     * @param {string} name Item name
	     * @param {string} value Item value
	     */
	    put: function (name, value) {
	      $cookieStore.put(name, value);
	    }
	  };
	
	  return $translateCookieStorage;
	}
	$translateCookieStorageFactory.$inject = ['$cookieStore'];
	
	$translateCookieStorageFactory.displayName = '$translateCookieStorage';
	return 'pascalprecht.translate';
	
	}));


/***/ },
/* 549 */
/***/ function(module, exports) {

	/*!
	 * angular-translate - v2.7.2 - 2015-06-01
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    define([], function () {
	      return (factory());
	    });
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateLocalStorage
	 * @requires $window
	 * @requires $translateCookieStorage
	 *
	 * @description
	 * Abstraction layer for localStorage. This service is used when telling angular-translate
	 * to use localStorage as storage.
	 *
	 */
	.factory('$translateLocalStorage', $translateLocalStorageFactory);
	
	function $translateLocalStorageFactory($window, $translateCookieStorage) {
	
	  'use strict';
	
	  // Setup adapter
	  var localStorageAdapter = (function(){
	    var langKey;
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#get
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Returns an item from localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @return {string} Value of item name
	       */
	      get: function (name) {
	        if(!langKey) {
	          langKey = $window.localStorage.getItem(name);
	        }
	
	        return langKey;
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#set
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @deprecated use #put
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      set: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      },
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateLocalStorage#put
	       * @methodOf pascalprecht.translate.$translateLocalStorage
	       *
	       * @description
	       * Sets an item in localStorage by given name.
	       *
	       * @param {string} name Item name
	       * @param {string} value Item value
	       */
	      put: function (name, value) {
	        langKey=value;
	        $window.localStorage.setItem(name, value);
	      }
	    };
	  }());
	
	  var hasLocalStorageSupport = 'localStorage' in $window;
	  if (hasLocalStorageSupport) {
	    var testKey = 'pascalprecht.translate.storageTest';
	    try {
	      // this check have to be wrapped within a try/catch because on
	      // a SecurityError: Dom Exception 18 on iOS
	      if ($window.localStorage !== null) {
	        $window.localStorage.setItem(testKey, 'foo');
	        $window.localStorage.removeItem(testKey);
	        hasLocalStorageSupport = true;
	      } else {
	        hasLocalStorageSupport = false;
	      }
	    } catch (e){
	      hasLocalStorageSupport = false;
	    }
	  }
	  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
	  return $translateLocalStorage;
	}
	$translateLocalStorageFactory.$inject = ['$window', '$translateCookieStorage'];
	
	$translateLocalStorageFactory.displayName = '$translateLocalStorageFactory';
	return 'pascalprecht.translate';
	
	}));


/***/ },
/* 550 */
/***/ function(module, exports) {

	/*!
	 * angular-translate - v2.7.2 - 2015-06-01
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    define([], function () {
	      return (factory());
	    });
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateStaticFilesLoader
	 * @requires $q
	 * @requires $http
	 *
	 * @description
	 * Creates a loading function for a typical static file url pattern:
	 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
	 * the response of these urls must be an object of key-value pairs.
	 *
	 * @param {object} options Options object, which gets prefix, suffix and key.
	 */
	.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);
	
	function $translateStaticFilesLoader($q, $http) {
	
	  'use strict';
	
	  return function (options) {
	
	    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
	      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
	    }
	
	    if (!options.files) {
	      options.files = [{
	        prefix: options.prefix,
	        suffix: options.suffix
	      }];
	    }
	
	    var load = function (file) {
	      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
	        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
	      }
	
	      var deferred = $q.defer();
	
	      $http(angular.extend({
	        url: [
	          file.prefix,
	          options.key,
	          file.suffix
	        ].join(''),
	        method: 'GET',
	        params: ''
	      }, options.$http)).success(function (data) {
	        deferred.resolve(data);
	      }).error(function () {
	        deferred.reject(options.key);
	      });
	
	      return deferred.promise;
	    };
	
	    var deferred = $q.defer(),
	        promises = [],
	        length = options.files.length;
	
	    for (var i = 0; i < length; i++) {
	      promises.push(load({
	        prefix: options.files[i].prefix,
	        key: options.key,
	        suffix: options.files[i].suffix
	      }));
	    }
	
	    $q.all(promises).then(function (data) {
	      var length = data.length,
	          mergedData = {};
	
	      for (var i = 0; i < length; i++) {
	        for (var key in data[i]) {
	          mergedData[key] = data[i][key];
	        }
	      }
	
	      deferred.resolve(mergedData);
	    }, function (data) {
	      deferred.reject(data);
	    });
	
	    return deferred.promise;
	  };
	}
	$translateStaticFilesLoader.$inject = ['$q', '$http'];
	
	$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
	return 'pascalprecht.translate';
	
	}));


/***/ },
/* 551 */
/***/ function(module, exports) {

	/*!
	 * angular-translate - v2.7.2 - 2015-06-01
	 * http://github.com/angular-translate/angular-translate
	 * Copyright (c) 2015 ; Licensed MIT
	 */
	!function(a,b){"function"==typeof define&&define.amd?define([],function(){return b()}):"object"==typeof exports?module.exports=b():b()}(this,function(){function a(a){"use strict";return function(b){a.warn("Translation for "+b+" doesn't exist")}}return angular.module("pascalprecht.translate").factory("$translateMissingTranslationHandlerLog",a),a.$inject=["$log"],a.displayName="$translateMissingTranslationHandlerLog","pascalprecht.translate"});

/***/ },
/* 552 */
/***/ function(module, exports) {

	(function(window) {
	'use strict';
	angular.module('tmh.dynamicLocale', []).config(['$provide', function ($provide) {
	  function makeStateful($delegate) {
	    $delegate.$stateful = true;
	    return $delegate;
	  }
	
	  $provide.decorator('dateFilter', ['$delegate', makeStateful]);
	  $provide.decorator('numberFilter', ['$delegate', makeStateful]);
	  $provide.decorator('currencyFilter', ['$delegate', makeStateful]);
	
	}])
	.constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
	.provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {
	
	  var defaultLocale,
	    localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
	    storageFactory = 'tmhDynamicLocaleStorageCache',
	    storage,
	    storageKey = STORAGE_KEY,
	    promiseCache = {},
	    activeLocale;
	
	  /**
	   * Loads a script asynchronously
	   *
	   * @param {string} url The url for the script
	   @ @param {function) callback A function to be called once the script is loaded
	   */
	  function loadScript(url, callback, errorCallback, $timeout) {
	    var script = document.createElement('script'),
	      body = document.getElementsByTagName('body')[0],
	      removed = false;
	
	    script.type = 'text/javascript';
	    if (script.readyState) { // IE
	      script.onreadystatechange = function () {
	        if (script.readyState === 'complete' ||
	            script.readyState === 'loaded') {
	          script.onreadystatechange = null;
	          $timeout(
	            function () {
	              if (removed) return;
	              removed = true;
	              body.removeChild(script);
	              callback();
	            }, 30, false);
	        }
	      };
	    } else { // Others
	      script.onload = function () {
	        if (removed) return;
	        removed = true;
	        body.removeChild(script);
	        callback();
	      };
	      script.onerror = function () {
	        if (removed) return;
	        removed = true;
	        body.removeChild(script);
	        errorCallback();
	      };
	    }
	    script.src = url;
	    script.async = false;
	    body.appendChild(script);
	  }
	
	  /**
	   * Loads a locale and replaces the properties from the current locale with the new locale information
	   *
	   * @param localeUrl The path to the new locale
	   * @param $locale The locale at the curent scope
	   */
	  function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {
	
	    function overrideValues(oldObject, newObject) {
	      if (activeLocale !== localeId) {
	        return;
	      }
	      angular.forEach(oldObject, function(value, key) {
	        if (!newObject[key]) {
	          delete oldObject[key];
	        } else if (angular.isArray(newObject[key])) {
	          oldObject[key].length = newObject[key].length;
	        }
	      });
	      angular.forEach(newObject, function(value, key) {
	        if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
	          if (!oldObject[key]) {
	            oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
	          }
	          overrideValues(oldObject[key], newObject[key]);
	        } else {
	          oldObject[key] = newObject[key];
	        }
	      });
	    }
	
	
	    if (promiseCache[localeId]) return promiseCache[localeId];
	
	    var cachedLocale,
	      deferred = $q.defer();
	    if (localeId === activeLocale) {
	      deferred.resolve($locale);
	    } else if ((cachedLocale = localeCache.get(localeId))) {
	      activeLocale = localeId;
	      $rootScope.$evalAsync(function() {
	        overrideValues($locale, cachedLocale);
	        $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
	        storage.put(storageKey, localeId);
	        deferred.resolve($locale);
	      });
	    } else {
	      activeLocale = localeId;
	      promiseCache[localeId] = deferred.promise;
	      loadScript(localeUrl, function () {
	        // Create a new injector with the new locale
	        var localInjector = angular.injector(['ngLocale']),
	          externalLocale = localInjector.get('$locale');
	
	        overrideValues($locale, externalLocale);
	        localeCache.put(localeId, externalLocale);
	        delete promiseCache[localeId];
	
	        $rootScope.$apply(function () {
	          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
	          storage.put(storageKey, localeId);
	          deferred.resolve($locale);
	        });
	      }, function () {
	        delete promiseCache[localeId];
	
	        $rootScope.$apply(function () {
	          if (activeLocale === localeId) activeLocale = $locale.id;
	          $rootScope.$broadcast('$localeChangeError', localeId);
	          deferred.reject(localeId);
	        });
	      }, $timeout);
	    }
	    return deferred.promise;
	  }
	
	  this.localeLocationPattern = function(value) {
	    if (value) {
	      localeLocationPattern = value;
	      return this;
	    } else {
	      return localeLocationPattern;
	    }
	  };
	
	  this.useStorage = function(storageName) {
	    storageFactory = storageName;
	  };
	
	  this.useCookieStorage = function() {
	    this.useStorage('$cookieStore');
	  };
	
	  this.defaultLocale = function (value) {
	    defaultLocale = value;
	  };
	
	  this.storageKey = function (value) {
	    if (value) {
	      storageKey = value;
	      return this;
	    } else {
	      return storageKey;
	    }
	  };
	
	  this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
	    var localeLocation = interpolate(localeLocationPattern);
	
	    storage = $injector.get(storageFactory);
	    $rootScope.$evalAsync(function () {
	      var initialLocale;
	      if ((initialLocale = (storage.get(storageKey) || defaultLocale))) {
	        loadLocale(localeLocation({locale: initialLocale}), locale, initialLocale, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
	      }
	    });
	    return {
	      /**
	       * @ngdoc method
	       * @description
	       * @param {string=} value Sets the locale to the new locale. Changing the locale will trigger
	       *    a background task that will retrieve the new locale and configure the current $locale
	       *    instance with the information from the new locale
	       */
	      set: function(value) {
	        return loadLocale(localeLocation({locale: value}), locale, value, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
	      },
	      /**
	       * @ngdoc method
	       * @description Returns the configured locale
	       */
	      get: function() {
	        return activeLocale;
	      }
	    };
	  }];
	}]).provider('tmhDynamicLocaleCache', function() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('tmh.dynamicLocales');
	  }];
	}).provider('tmhDynamicLocaleStorageCache', function() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('tmh.dynamicLocales.store');
	  }];
	}).run(['tmhDynamicLocale', angular.noop]);
	}(window));


/***/ },
/* 553 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.4.5
	 * (c) 2010-2015 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	// They can potentially allow for arbitrary javascript to be executed. See #11290
	var svgElements = makeMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	        "radialGradient,rect,stop,svg,switch,text,title,tspan,use");
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements,
	                                   svgElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function makeMap(str, lowercaseKeys) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	  }
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[stack.length - 1]; };
	
	  while (html) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if (!stack.last() || !specialElements[stack.last()]) {
	
	      // Comment
	      if (html.indexOf("<!--") === 0) {
	        // comments containing -- are not allowed unless they terminate the comment
	        index = html.indexOf("--", 4);
	
	        if (index >= 0 && html.lastIndexOf("-->", index) === index) {
	          if (handler.comment) handler.comment(html.substring(4, index));
	          html = html.substring(index + 3);
	          chars = false;
	        }
	      // DOCTYPE
	      } else if (DOCTYPE_REGEXP.test(html)) {
	        match = html.match(DOCTYPE_REGEXP);
	
	        if (match) {
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	        match = html.match(END_TAG_REGEXP);
	
	        if (match) {
	          html = html.substring(match[0].length);
	          match[0].replace(END_TAG_REGEXP, parseEndTag);
	          chars = false;
	        }
	
	      // start tag
	      } else if (BEGIN_TAG_REGEXP.test(html)) {
	        match = html.match(START_TAG_REGEXP);
	
	        if (match) {
	          // We only have a valid start-tag if there is a '>'.
	          if (match[4]) {
	            html = html.substring(match[0].length);
	            match[0].replace(START_TAG_REGEXP, parseStartTag);
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if (chars) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring(0, index);
	        html = index < 0 ? "" : html.substring(index);
	
	        if (handler.chars) handler.chars(decodeEntities(text));
	      }
	
	    } else {
	      // IE versions 9 and 10 do not understand the regex '[^]', so using a workaround with [\W\w].
	      html = html.replace(new RegExp("([\\W\\w]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	      });
	
	      parseEndTag("", stack.last());
	    }
	
	    if (html == last) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag(tag, tagName, rest, unary) {
	    tagName = angular.lowercase(tagName);
	    if (blockElements[tagName]) {
	      while (stack.last() && inlineElements[stack.last()]) {
	        parseEndTag("", stack.last());
	      }
	    }
	
	    if (optionalEndTagElements[tagName] && stack.last() == tagName) {
	      parseEndTag("", tagName);
	    }
	
	    unary = voidElements[tagName] || !!unary;
	
	    if (!unary) {
	      stack.push(tagName);
	    }
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start(tagName, attrs, unary);
	  }
	
	  function parseEndTag(tag, tagName) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if (tagName) {
	      // Find the closest opened tag of the same type
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos] == tagName) break;
	      }
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (i = stack.length - 1; i >= pos; i--)
	        if (handler.end) handler.end(stack[i]);
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  hiddenPre.innerHTML = value.replace(/</g,"&lt;");
	  // innerText depends on styling as it doesn't display hidden elements.
	  // Therefore, it's better to use textContent not to cause unnecessary reflows.
	  return hiddenPre.textContent;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary) {
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    end: function(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars) {
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 554 */
/***/ function(module, exports) {

	/*
	 AngularJS v1.4.5
	 (c) 2010-2015 Google, Inc. http://angularjs.org
	 License: MIT
	*/
	(function(F,x,Z){'use strict';function ua(a,b,c){if(!a)throw ngMinErr("areq",b||"?",c||"required");return a}function va(a,b){if(!a&&!b)return"";if(!a)return b;if(!b)return a;$(a)&&(a=a.join(" "));$(b)&&(b=b.join(" "));return a+" "+b}function Ea(a){var b={};a&&(a.to||a.from)&&(b.to=a.to,b.from=a.from);return b}function V(a,b,c){var d="";a=$(a)?a:a&&M(a)&&a.length?a.split(/\s+/):[];q(a,function(a,y){a&&0<a.length&&(d+=0<y?" ":"",d+=c?b+a:a+b)});return d}function Fa(a){if(a instanceof I)switch(a.length){case 0:return[];
	case 1:if(1===a[0].nodeType)return a;break;default:return I(ma(a))}if(1===a.nodeType)return I(a)}function ma(a){if(!a[0])return a;for(var b=0;b<a.length;b++){var c=a[b];if(1==c.nodeType)return c}}function Ga(a,b,c){q(b,function(b){a.addClass(b,c)})}function Ha(a,b,c){q(b,function(b){a.removeClass(b,c)})}function Q(a){return function(b,c){c.addClass&&(Ga(a,b,c.addClass),c.addClass=null);c.removeClass&&(Ha(a,b,c.removeClass),c.removeClass=null)}}function ia(a){a=a||{};if(!a.$$prepared){var b=a.domOperation||
	L;a.domOperation=function(){a.$$domOperationFired=!0;b();b=L};a.$$prepared=!0}return a}function ea(a,b){wa(a,b);xa(a,b)}function wa(a,b){b.from&&(a.css(b.from),b.from=null)}function xa(a,b){b.to&&(a.css(b.to),b.to=null)}function R(a,b,c){var d=(b.addClass||"")+" "+(c.addClass||""),e=(b.removeClass||"")+" "+(c.removeClass||"");a=Ia(a.attr("class"),d,e);c.preparationClasses&&(b.preparationClasses=W(c.preparationClasses,b.preparationClasses),delete c.preparationClasses);d=b.domOperation!==L?b.domOperation:
	null;ya(b,c);d&&(b.domOperation=d);b.addClass=a.addClass?a.addClass:null;b.removeClass=a.removeClass?a.removeClass:null;return b}function Ia(a,b,c){function d(a){M(a)&&(a=a.split(" "));var b={};q(a,function(a){a.length&&(b[a]=!0)});return b}var e={};a=d(a);b=d(b);q(b,function(a,b){e[b]=1});c=d(c);q(c,function(a,b){e[b]=1===e[b]?null:-1});var y={addClass:"",removeClass:""};q(e,function(b,c){var e,d;1===b?(e="addClass",d=!a[c]):-1===b&&(e="removeClass",d=a[c]);d&&(y[e].length&&(y[e]+=" "),y[e]+=c)});
	return y}function G(a){return a instanceof x.element?a[0]:a}function Ja(a,b,c){var d="";b&&(d=V(b,"ng-",!0));c.addClass&&(d=W(d,V(c.addClass,"-add")));c.removeClass&&(d=W(d,V(c.removeClass,"-remove")));d.length&&(c.preparationClasses=d,a.addClass(d))}function ja(a,b){var c=b?"-"+b+"s":"";fa(a,[ga,c]);return[ga,c]}function na(a,b){var c=b?"paused":"",d=X+"PlayState";fa(a,[d,c]);return[d,c]}function fa(a,b){a.style[b[0]]=b[1]}function W(a,b){return a?b?a+" "+b:a:b}function za(a,b,c){var d=Object.create(null),
	e=a.getComputedStyle(b)||{};q(c,function(a,b){var c=e[a];if(c){var l=c.charAt(0);if("-"===l||"+"===l||0<=l)c=Ka(c);0===c&&(c=null);d[b]=c}});return d}function Ka(a){var b=0;a=a.split(/\s*,\s*/);q(a,function(a){"s"==a.charAt(a.length-1)&&(a=a.substring(0,a.length-1));a=parseFloat(a)||0;b=b?Math.max(a,b):a});return b}function oa(a){return 0===a||null!=a}function Aa(a,b){var c=N,d=a+"s";b?c+="Duration":d+=" linear all";return[c,d]}function Ba(){var a=Object.create(null);return{flush:function(){a=Object.create(null)},
	count:function(b){return(b=a[b])?b.total:0},get:function(b){return(b=a[b])&&b.value},put:function(b,c){a[b]?a[b].total++:a[b]={total:1,value:c}}}}var L=x.noop,ya=x.extend,I=x.element,q=x.forEach,$=x.isArray,M=x.isString,pa=x.isObject,La=x.isUndefined,Ma=x.isDefined,Ca=x.isFunction,qa=x.isElement,N,ra,X,sa;F.ontransitionend===Z&&F.onwebkittransitionend!==Z?(N="WebkitTransition",ra="webkitTransitionEnd transitionend"):(N="transition",ra="transitionend");F.onanimationend===Z&&F.onwebkitanimationend!==
	Z?(X="WebkitAnimation",sa="webkitAnimationEnd animationend"):(X="animation",sa="animationend");var ka=X+"Delay",ta=X+"Duration",ga=N+"Delay";F=N+"Duration";var Na={transitionDuration:F,transitionDelay:ga,transitionProperty:N+"Property",animationDuration:ta,animationDelay:ka,animationIterationCount:X+"IterationCount"},Oa={transitionDuration:F,transitionDelay:ga,animationDuration:ta,animationDelay:ka};x.module("ngAnimate",[]).provider("$$body",function(){this.$get=["$document",function(a){return I(a[0].body)}]}).directive("ngAnimateChildren",
	[function(){return function(a,b,c){a=c.ngAnimateChildren;x.isString(a)&&0===a.length?b.data("$$ngAnimateChildren",!0):c.$observe("ngAnimateChildren",function(a){b.data("$$ngAnimateChildren","on"===a||"true"===a)})}}]).factory("$$rAFScheduler",["$$rAF",function(a){function b(a){d=d.concat(a);c()}function c(){if(d.length){for(var b=d.shift(),v=0;v<b.length;v++)b[v]();e||a(function(){e||c()})}}var d,e;d=b.queue=[];b.waitUntilQuiet=function(b){e&&e();e=a(function(){e=null;b();c()})};return b}]).factory("$$AnimateRunner",
	["$q","$sniffer","$$animateAsyncRun",function(a,b,c){function d(a){this.setHost(a);this._doneCallbacks=[];this._runInAnimationFrame=c();this._state=0}d.chain=function(a,b){function c(){if(d===a.length)b(!0);else a[d](function(a){!1===a?b(!1):(d++,c())})}var d=0;c()};d.all=function(a,b){function c(v){l=l&&v;++d===a.length&&b(l)}var d=0,l=!0;q(a,function(a){a.done(c)})};d.prototype={setHost:function(a){this.host=a||{}},done:function(a){2===this._state?a():this._doneCallbacks.push(a)},progress:L,getPromise:function(){if(!this.promise){var b=
	this;this.promise=a(function(a,c){b.done(function(b){!1===b?c():a()})})}return this.promise},then:function(a,b){return this.getPromise().then(a,b)},"catch":function(a){return this.getPromise()["catch"](a)},"finally":function(a){return this.getPromise()["finally"](a)},pause:function(){this.host.pause&&this.host.pause()},resume:function(){this.host.resume&&this.host.resume()},end:function(){this.host.end&&this.host.end();this._resolve(!0)},cancel:function(){this.host.cancel&&this.host.cancel();this._resolve(!1)},
	complete:function(a){var b=this;0===b._state&&(b._state=1,b._runInAnimationFrame(function(){b._resolve(a)}))},_resolve:function(a){2!==this._state&&(q(this._doneCallbacks,function(b){b(a)}),this._doneCallbacks.length=0,this._state=2)}};return d}]).factory("$$animateAsyncRun",["$$rAF",function(a){function b(b){c.push(b);1<c.length||a(function(){for(var a=0;a<c.length;a++)c[a]();c=[]})}var c=[];return function(){var a=!1;b(function(){a=!0});return function(c){a?c():b(c)}}}]).provider("$$animateQueue",
	["$animateProvider",function(a){function b(a,b,c,q){return d[a].some(function(a){return a(b,c,q)})}function c(a,b){a=a||{};var c=0<(a.addClass||"").length,d=0<(a.removeClass||"").length;return b?c&&d:c||d}var d=this.rules={skip:[],cancel:[],join:[]};d.join.push(function(a,b,d){return!b.structural&&c(b.options)});d.skip.push(function(a,b,d){return!b.structural&&!c(b.options)});d.skip.push(function(a,b,c){return"leave"==c.event&&b.structural});d.skip.push(function(a,b,c){return c.structural&&2===c.state&&
	!b.structural});d.cancel.push(function(a,b,c){return c.structural&&b.structural});d.cancel.push(function(a,b,c){return 2===c.state&&b.structural});d.cancel.push(function(a,b,c){a=b.options;c=c.options;return a.addClass&&a.addClass===c.removeClass||a.removeClass&&a.removeClass===c.addClass});this.$get=["$$rAF","$rootScope","$rootElement","$document","$$body","$$HashMap","$$animation","$$AnimateRunner","$templateRequest","$$jqLite","$$forceReflow",function(d,y,v,z,l,s,O,x,t,la,E){function h(a,b){var c=
	G(a),f=[],g=w[b];g&&q(g,function(a){a.node.contains(c)&&f.push(a.callback)});return f}function S(a,b,c,f){d(function(){q(h(b,a),function(a){a(b,c,f)})})}function u(a,g,m){function d(b,c,g,f){S(c,a,g,f);b.progress(c,g,f)}function w(b){var c=a,g=m;g.preparationClasses&&(c.removeClass(g.preparationClasses),g.preparationClasses=null);g.activeClasses&&(c.removeClass(g.activeClasses),g.activeClasses=null);Da(a,m);ea(a,m);m.domOperation();e.complete(!b)}var B,h;if(a=Fa(a))B=G(a),h=a.parent();m=ia(m);var e=
	new x;$(m.addClass)&&(m.addClass=m.addClass.join(" "));m.addClass&&!M(m.addClass)&&(m.addClass=null);$(m.removeClass)&&(m.removeClass=m.removeClass.join(" "));m.removeClass&&!M(m.removeClass)&&(m.removeClass=null);m.from&&!pa(m.from)&&(m.from=null);m.to&&!pa(m.to)&&(m.to=null);if(!B)return w(),e;var k=[B.className,m.addClass,m.removeClass].join(" ");if(!C(k))return w(),e;var l=0<=["enter","move","leave"].indexOf(g),u=!H||U.get(B),k=!u&&A.get(B)||{},v=!!k.state;u||v&&1==k.state||(u=!p(a,h,g));if(u)return w(),
	e;l&&J(a);h={structural:l,element:a,event:g,close:w,options:m,runner:e};if(v){if(b("skip",a,h,k)){if(2===k.state)return w(),e;R(a,k.options,m);return k.runner}if(b("cancel",a,h,k))if(2===k.state)k.runner.end();else if(k.structural)k.close();else return R(a,k.options,h.options),k.runner;else if(b("join",a,h,k))if(2===k.state)R(a,m,{});else return Ja(a,l?g:null,m),g=h.event=k.event,m=R(a,k.options,h.options),k.runner}else R(a,m,{});(v=h.structural)||(v="animate"===h.event&&0<Object.keys(h.options.to||
	{}).length||c(h.options));if(!v)return w(),f(a),e;var t=(k.counter||0)+1;h.counter=t;r(a,1,h);y.$$postDigest(function(){var b=A.get(B),h=!b,b=b||{},J=0<(a.parent()||[]).length&&("animate"===b.event||b.structural||c(b.options));if(h||b.counter!==t||!J){h&&(Da(a,m),ea(a,m));if(h||l&&b.event!==g)m.domOperation(),e.end();J||f(a)}else g=!b.structural&&c(b.options,!0)?"setClass":b.event,r(a,2),b=O(a,g,b.options),b.done(function(b){w(!b);(b=A.get(B))&&b.counter===t&&f(G(a));d(e,g,"close",{})}),e.setHost(b),
	d(e,g,"start",{})});return e}function J(a){a=G(a).querySelectorAll("[data-ng-animate]");q(a,function(a){var b=parseInt(a.getAttribute("data-ng-animate")),c=A.get(a);switch(b){case 2:c.runner.end();case 1:c&&A.remove(a)}})}function f(a){a=G(a);a.removeAttribute("data-ng-animate");A.remove(a)}function B(a,b){return G(a)===G(b)}function p(a,b,c){c=B(a,l)||"HTML"===a[0].nodeName;var g=B(a,v),f=!1,d;for((a=a.data("$ngAnimatePin"))&&(b=a);b&&b.length;){g||(g=B(b,v));a=b[0];if(1!==a.nodeType)break;var w=
	A.get(a)||{};f||(f=w.structural||U.get(a));if(La(d)||!0===d)a=b.data("$$ngAnimateChildren"),Ma(a)&&(d=a);if(f&&!1===d)break;g||(g=B(b,v),g||(a=b.data("$ngAnimatePin"))&&(b=a));c||(c=B(b,l));b=b.parent()}return(!f||d)&&g&&c}function r(a,b,c){c=c||{};c.state=b;a=G(a);a.setAttribute("data-ng-animate",b);c=(b=A.get(a))?ya(b,c):c;A.put(a,c)}var A=new s,U=new s,H=null,g=y.$watch(function(){return 0===t.totalPendingRequests},function(a){a&&(g(),y.$$postDigest(function(){y.$$postDigest(function(){null===
	H&&(H=!0)})}))}),w={},k=a.classNameFilter(),C=k?function(a){return k.test(a)}:function(){return!0},Da=Q(la);return{on:function(a,b,c){b=ma(b);w[a]=w[a]||[];w[a].push({node:b,callback:c})},off:function(a,b,c){function g(a,b,c){var f=ma(b);return a.filter(function(a){return!(a.node===f&&(!c||a.callback===c))})}var f=w[a];f&&(w[a]=1===arguments.length?null:g(f,b,c))},pin:function(a,b){ua(qa(a),"element","not an element");ua(qa(b),"parentElement","not an element");a.data("$ngAnimatePin",b)},push:function(a,
	b,c,g){c=c||{};c.domOperation=g;return u(a,b,c)},enabled:function(a,b){var c=arguments.length;if(0===c)b=!!H;else if(qa(a)){var g=G(a),f=U.get(g);1===c?b=!f:(b=!!b)?f&&U.remove(g):U.put(g,!0)}else b=H=!!a;return b}}}]}]).provider("$$animation",["$animateProvider",function(a){function b(a){return a.data("$$animationRunner")}var c=this.drivers=[];this.$get=["$$jqLite","$rootScope","$injector","$$AnimateRunner","$$HashMap","$$rAFScheduler",function(a,e,y,v,z,l){function s(a){function b(a){if(a.processed)return a;
	a.processed=!0;var f=a.domNode,d=f.parentNode;e.put(f,a);for(var h;d;){if(h=e.get(d)){h.processed||(h=b(h));break}d=d.parentNode}(h||c).children.push(a);return a}var c={children:[]},d,e=new z;for(d=0;d<a.length;d++){var l=a[d];e.put(l.domNode,a[d]={domNode:l.domNode,fn:l.fn,children:[]})}for(d=0;d<a.length;d++)b(a[d]);return function(a){var b=[],c=[],d;for(d=0;d<a.children.length;d++)c.push(a.children[d]);a=c.length;var h=0,e=[];for(d=0;d<c.length;d++){var l=c[d];0>=a&&(a=h,h=0,b.push(e),e=[]);e.push(l.fn);
	l.children.forEach(function(a){h++;c.push(a)});a--}e.length&&b.push(e);return b}(c)}var O=[],x=Q(a);return function(t,z,E){function h(a){a=a.hasAttribute("ng-animate-ref")?[a]:a.querySelectorAll("[ng-animate-ref]");var b=[];q(a,function(a){var c=a.getAttribute("ng-animate-ref");c&&c.length&&b.push(a)});return b}function S(a){var b=[],c={};q(a,function(a,g){var d=G(a.element),f=0<=["enter","move"].indexOf(a.event),d=a.structural?h(d):[];if(d.length){var e=f?"to":"from";q(d,function(a){var b=a.getAttribute("ng-animate-ref");
	c[b]=c[b]||{};c[b][e]={animationID:g,element:I(a)}})}else b.push(a)});var d={},f={};q(c,function(c,e){var h=c.from,r=c.to;if(h&&r){var J=a[h.animationID],k=a[r.animationID],B=h.animationID.toString();if(!f[B]){var l=f[B]={structural:!0,beforeStart:function(){J.beforeStart();k.beforeStart()},close:function(){J.close();k.close()},classes:u(J.classes,k.classes),from:J,to:k,anchors:[]};l.classes.length?b.push(l):(b.push(J),b.push(k))}f[B].anchors.push({out:h.element,"in":r.element})}else h=h?h.animationID:
	r.animationID,r=h.toString(),d[r]||(d[r]=!0,b.push(a[h]))});return b}function u(a,b){a=a.split(" ");b=b.split(" ");for(var c=[],d=0;d<a.length;d++){var f=a[d];if("ng-"!==f.substring(0,3))for(var h=0;h<b.length;h++)if(f===b[h]){c.push(f);break}}return c.join(" ")}function J(a){for(var b=c.length-1;0<=b;b--){var d=c[b];if(y.has(d)&&(d=y.get(d)(a)))return d}}function f(a,c){a.from&&a.to?(b(a.from.element).setHost(c),b(a.to.element).setHost(c)):b(a.element).setHost(c)}function B(){var a=b(t);!a||"leave"===
	z&&E.$$domOperationFired||a.end()}function p(b){t.off("$destroy",B);t.removeData("$$animationRunner");x(t,E);ea(t,E);E.domOperation();H&&a.removeClass(t,H);t.removeClass("ng-animate");A.complete(!b)}E=ia(E);var r=0<=["enter","move","leave"].indexOf(z),A=new v({end:function(){p()},cancel:function(){p(!0)}});if(!c.length)return p(),A;t.data("$$animationRunner",A);var U=va(t.attr("class"),va(E.addClass,E.removeClass)),H=E.tempClasses;H&&(U+=" "+H,E.tempClasses=null);O.push({element:t,classes:U,event:z,
	structural:r,options:E,beforeStart:function(){t.addClass("ng-animate");H&&a.addClass(t,H)},close:p});t.on("$destroy",B);if(1<O.length)return A;e.$$postDigest(function(){var a=[];q(O,function(c){b(c.element)?a.push(c):c.close()});O.length=0;var c=S(a),d=[];q(c,function(a){d.push({domNode:G(a.from?a.from.element:a.element),fn:function(){a.beforeStart();var c,d=a.close;if(b(a.anchors?a.from.element||a.to.element:a.element)){var g=J(a);g&&(c=g.start)}c?(c=c(),c.done(function(a){d(!a)}),f(a,c)):d()}})});
	l(s(d))});return A}}]}]).provider("$animateCss",["$animateProvider",function(a){var b=Ba(),c=Ba();this.$get=["$window","$$jqLite","$$AnimateRunner","$timeout","$$forceReflow","$sniffer","$$rAFScheduler","$animate",function(a,e,y,v,z,l,s,O){function x(a,b){var c=a.parentNode;return(c.$$ngAnimateParentKey||(c.$$ngAnimateParentKey=++S))+"-"+a.getAttribute("class")+"-"+b}function t(h,f,l,p){var r;0<b.count(l)&&(r=c.get(l),r||(f=V(f,"-stagger"),e.addClass(h,f),r=za(a,h,p),r.animationDuration=Math.max(r.animationDuration,
	0),r.transitionDuration=Math.max(r.transitionDuration,0),e.removeClass(h,f),c.put(l,r)));return r||{}}function la(a){u.push(a);s.waitUntilQuiet(function(){b.flush();c.flush();for(var a=z(),d=0;d<u.length;d++)u[d](a);u.length=0})}function E(c,f,h){f=b.get(h);f||(f=za(a,c,Na),"infinite"===f.animationIterationCount&&(f.animationIterationCount=1));b.put(h,f);c=f;h=c.animationDelay;f=c.transitionDelay;c.maxDelay=h&&f?Math.max(h,f):h||f;c.maxDuration=Math.max(c.animationDuration*c.animationIterationCount,
	c.transitionDuration);return c}var h=Q(e),S=0,u=[];return function(a,c){function d(){r()}function p(){r(!0)}function r(b){if(!(s||S&&z)){s=!0;z=!1;c.$$skipPreparationClasses||e.removeClass(a,aa);e.removeClass(a,Z);na(g,!1);ja(g,!1);q(w,function(a){g.style[a[0]]=""});h(a,c);ea(a,c);if(c.onDone)c.onDone();m&&m.complete(!b)}}function A(a){n.blockTransition&&ja(g,a);n.blockKeyframeAnimation&&na(g,!!a)}function u(){m=new y({end:d,cancel:p});la(L);r();return{$$willAnimate:!1,start:function(){return m},
	end:d}}function H(){function b(){if(!s){A(!1);q(w,function(a){g.style[a[0]]=a[1]});h(a,c);e.addClass(a,Z);if(n.recalculateTimingStyles){ha=g.className+" "+aa;ba=x(g,ha);D=E(g,ha,ba);Y=D.maxDelay;I=Math.max(Y,0);K=D.maxDuration;if(0===K){r();return}n.hasTransitions=0<D.transitionDuration;n.hasAnimations=0<D.animationDuration}n.applyAnimationDelay&&(Y="boolean"!==typeof c.delay&&oa(c.delay)?parseFloat(c.delay):Y,I=Math.max(Y,0),D.animationDelay=Y,da=[ka,Y+"s"],w.push(da),g.style[da[0]]=da[1]);M=1E3*
	I;Q=1E3*K;if(c.easing){var k,p=c.easing;n.hasTransitions&&(k=N+"TimingFunction",w.push([k,p]),g.style[k]=p);n.hasAnimations&&(k=X+"TimingFunction",w.push([k,p]),g.style[k]=p)}D.transitionDuration&&m.push(ra);D.animationDuration&&m.push(sa);H=Date.now();var u=M+1.5*Q;k=H+u;var p=a.data("$$animateCss")||[],z=!0;if(p.length){var C=p[0];(z=k>C.expectedEndTime)?v.cancel(C.timer):p.push(r)}z&&(u=v(d,u,!1),p[0]={timer:u,expectedEndTime:k},p.push(r),a.data("$$animateCss",p));a.on(m.join(" "),l);xa(a,c)}}
	function d(){var b=a.data("$$animateCss");if(b){for(var c=1;c<b.length;c++)b[c]();a.removeData("$$animateCss")}}function l(a){a.stopPropagation();var b=a.originalEvent||a;a=b.$manualTimeStamp||b.timeStamp||Date.now();b=parseFloat(b.elapsedTime.toFixed(3));Math.max(a-H,0)>=M&&b>=K&&(S=!0,r())}if(!s)if(g.parentNode){var H,m=[],k=function(a){if(S)z&&a&&(z=!1,r());else if(z=!a,D.animationDuration)if(a=na(g,z),z)w.push(a);else{var b=w,c=b.indexOf(a);0<=a&&b.splice(c,1)}},p=0<W&&(D.transitionDuration&&
	0===T.transitionDuration||D.animationDuration&&0===T.animationDuration)&&Math.max(T.animationDelay,T.transitionDelay);p?v(b,Math.floor(p*W*1E3),!1):b();F.resume=function(){k(!0)};F.pause=function(){k(!1)}}else r()}var g=G(a);if(!g||!g.parentNode||!O.enabled())return u();c=ia(c);var w=[],k=a.attr("class"),C=Ea(c),s,z,S,m,F,I,M,K,Q;if(0===c.duration||!l.animations&&!l.transitions)return u();var ca=c.event&&$(c.event)?c.event.join(" "):c.event,R="",P="";ca&&c.structural?R=V(ca,"ng-",!0):ca&&(R=ca);c.addClass&&
	(P+=V(c.addClass,"-add"));c.removeClass&&(P.length&&(P+=" "),P+=V(c.removeClass,"-remove"));c.applyClassesEarly&&P.length&&h(a,c);var aa=[R,P].join(" ").trim(),ha=k+" "+aa,Z=V(aa,"-active"),k=C.to&&0<Object.keys(C.to).length;if(!(0<(c.keyframeStyle||"").length||k||aa))return u();var ba,T;0<c.stagger?(C=parseFloat(c.stagger),T={transitionDelay:C,animationDelay:C,transitionDuration:0,animationDuration:0}):(ba=x(g,ha),T=t(g,aa,ba,Oa));c.$$skipPreparationClasses||e.addClass(a,aa);c.transitionStyle&&(C=
	[N,c.transitionStyle],fa(g,C),w.push(C));0<=c.duration&&(C=0<g.style[N].length,C=Aa(c.duration,C),fa(g,C),w.push(C));c.keyframeStyle&&(C=[X,c.keyframeStyle],fa(g,C),w.push(C));var W=T?0<=c.staggerIndex?c.staggerIndex:b.count(ba):0;(ca=0===W)&&!c.skipBlocking&&ja(g,9999);var D=E(g,ha,ba),Y=D.maxDelay;I=Math.max(Y,0);K=D.maxDuration;var n={};n.hasTransitions=0<D.transitionDuration;n.hasAnimations=0<D.animationDuration;n.hasTransitionAll=n.hasTransitions&&"all"==D.transitionProperty;n.applyTransitionDuration=
	k&&(n.hasTransitions&&!n.hasTransitionAll||n.hasAnimations&&!n.hasTransitions);n.applyAnimationDuration=c.duration&&n.hasAnimations;n.applyTransitionDelay=oa(c.delay)&&(n.applyTransitionDuration||n.hasTransitions);n.applyAnimationDelay=oa(c.delay)&&n.hasAnimations;n.recalculateTimingStyles=0<P.length;if(n.applyTransitionDuration||n.applyAnimationDuration)K=c.duration?parseFloat(c.duration):K,n.applyTransitionDuration&&(n.hasTransitions=!0,D.transitionDuration=K,C=0<g.style[N+"Property"].length,w.push(Aa(K,
	C))),n.applyAnimationDuration&&(n.hasAnimations=!0,D.animationDuration=K,w.push([ta,K+"s"]));if(0===K&&!n.recalculateTimingStyles)return u();if(null!=c.delay){var da=parseFloat(c.delay);n.applyTransitionDelay&&w.push([ga,da+"s"]);n.applyAnimationDelay&&w.push([ka,da+"s"])}null==c.duration&&0<D.transitionDuration&&(n.recalculateTimingStyles=n.recalculateTimingStyles||ca);M=1E3*I;Q=1E3*K;c.skipBlocking||(n.blockTransition=0<D.transitionDuration,n.blockKeyframeAnimation=0<D.animationDuration&&0<T.animationDelay&&
	0===T.animationDuration);wa(a,c);n.blockTransition||n.blockKeyframeAnimation?A(K):c.skipBlocking||ja(g,!1);return{$$willAnimate:!0,end:d,start:function(){if(!s)return F={end:d,cancel:p,resume:null,pause:null},m=new y(F),la(H),m}}}}]}]).provider("$$animateCssDriver",["$$animationProvider",function(a){a.drivers.push("$$animateCssDriver");this.$get=["$animateCss","$rootScope","$$AnimateRunner","$rootElement","$$body","$sniffer","$$jqLite",function(a,c,d,e,y,v,z){function l(a){return a.replace(/\bng-\S+\b/g,
	"")}function s(a,b){M(a)&&(a=a.split(" "));M(b)&&(b=b.split(" "));return a.filter(function(a){return-1===b.indexOf(a)}).join(" ")}function O(c,e,u){function v(a){var b={},c=G(a).getBoundingClientRect();q(["width","height","top","left"],function(a){var d=c[a];switch(a){case "top":d+=F.scrollTop;break;case "left":d+=F.scrollLeft}b[a]=Math.floor(d)+"px"});return b}function f(){var c=l(u.attr("class")||""),d=s(c,r),c=s(r,c),d=a(p,{to:v(u),addClass:"ng-anchor-in "+d,removeClass:"ng-anchor-out "+c,delay:!0});
	return d.$$willAnimate?d:null}function z(){p.remove();e.removeClass("ng-animate-shim");u.removeClass("ng-animate-shim")}var p=I(G(e).cloneNode(!0)),r=l(p.attr("class")||"");e.addClass("ng-animate-shim");u.addClass("ng-animate-shim");p.addClass("ng-anchor");E.append(p);var A;c=function(){var c=a(p,{addClass:"ng-anchor-out",delay:!0,from:v(e)});return c.$$willAnimate?c:null}();if(!c&&(A=f(),!A))return z();var t=c||A;return{start:function(){function a(){c&&c.end()}var b,c=t.start();c.done(function(){c=
	null;if(!A&&(A=f()))return c=A.start(),c.done(function(){c=null;z();b.complete()}),c;z();b.complete()});return b=new d({end:a,cancel:a})}}}function x(a,b,c,e){var f=t(a,L),l=t(b,L),p=[];q(e,function(a){(a=O(c,a.out,a["in"]))&&p.push(a)});if(f||l||0!==p.length)return{start:function(){function a(){q(b,function(a){a.end()})}var b=[];f&&b.push(f.start());l&&b.push(l.start());q(p,function(a){b.push(a.start())});var c=new d({end:a,cancel:a});d.all(b,function(a){c.complete(a)});return c}}}function t(c){var d=
	c.element,e=c.options||{};c.structural&&(e.event=c.event,e.structural=!0,e.applyClassesEarly=!0,"leave"===c.event&&(e.onDone=e.domOperation));e.preparationClasses&&(e.event=W(e.event,e.preparationClasses));c=a(d,e);return c.$$willAnimate?c:null}if(!v.animations&&!v.transitions)return L;var F=G(y);c=G(e);var E=I(F.parentNode===c?F:c);Q(z);return function(a){return a.from&&a.to?x(a.from,a.to,a.classes,a.anchors):t(a)}}]}]).provider("$$animateJs",["$animateProvider",function(a){this.$get=["$injector",
	"$$AnimateRunner","$$jqLite",function(b,c,d){function e(c){c=$(c)?c:c.split(" ");for(var d=[],e={},s=0;s<c.length;s++){var q=c[s],y=a.$$registeredAnimations[q];y&&!e[q]&&(d.push(b.get(y)),e[q]=!0)}return d}var y=Q(d);return function(a,b,d,s){function x(){s.domOperation();y(a,s)}function F(a,b,d,e,f){switch(d){case "animate":b=[b,e.from,e.to,f];break;case "setClass":b=[b,E,h,f];break;case "addClass":b=[b,E,f];break;case "removeClass":b=[b,h,f];break;default:b=[b,f]}b.push(e);if(a=a.apply(a,b))if(Ca(a.start)&&
	(a=a.start()),a instanceof c)a.done(f);else if(Ca(a))return a;return L}function t(a,b,d,e,f){var g=[];q(e,function(e){var h=e[f];h&&g.push(function(){var e,g,f=!1,l=function(a){f||(f=!0,(g||L)(a),e.complete(!a))};e=new c({end:function(){l()},cancel:function(){l(!0)}});g=F(h,a,b,d,function(a){l(!1===a)});return e})});return g}function G(a,b,d,e,f){var g=t(a,b,d,e,f);if(0===g.length){var h,k;"beforeSetClass"===f?(h=t(a,"removeClass",d,e,"beforeRemoveClass"),k=t(a,"addClass",d,e,"beforeAddClass")):"setClass"===
	f&&(h=t(a,"removeClass",d,e,"removeClass"),k=t(a,"addClass",d,e,"addClass"));h&&(g=g.concat(h));k&&(g=g.concat(k))}if(0!==g.length)return function(a){var b=[];g.length&&q(g,function(a){b.push(a())});b.length?c.all(b,a):a();return function(a){q(b,function(b){a?b.cancel():b.end()})}}}3===arguments.length&&pa(d)&&(s=d,d=null);s=ia(s);d||(d=a.attr("class")||"",s.addClass&&(d+=" "+s.addClass),s.removeClass&&(d+=" "+s.removeClass));var E=s.addClass,h=s.removeClass,I=e(d),u,J;if(I.length){var f,B;"leave"==
	b?(B="leave",f="afterLeave"):(B="before"+b.charAt(0).toUpperCase()+b.substr(1),f=b);"enter"!==b&&"move"!==b&&(u=G(a,b,s,I,B));J=G(a,b,s,I,f)}if(u||J)return{start:function(){function b(c){f=!0;x();ea(a,s);h.complete(c)}var d,e=[];u&&e.push(function(a){d=u(a)});e.length?e.push(function(a){x();a(!0)}):x();J&&e.push(function(a){d=J(a)});var f=!1,h=new c({end:function(){f||((d||L)(void 0),b(void 0))},cancel:function(){f||((d||L)(!0),b(!0))}});c.chain(e,b);return h}}}}]}]).provider("$$animateJsDriver",
	["$$animationProvider",function(a){a.drivers.push("$$animateJsDriver");this.$get=["$$animateJs","$$AnimateRunner",function(a,c){function d(c){return a(c.element,c.event,c.classes,c.options)}return function(a){if(a.from&&a.to){var b=d(a.from),v=d(a.to);if(b||v)return{start:function(){function a(){return function(){q(d,function(a){a.end()})}}var d=[];b&&d.push(b.start());v&&d.push(v.start());c.all(d,function(a){e.complete(a)});var e=new c({end:a(),cancel:a()});return e}}}else return d(a)}}]}])})(window,
	window.angular);
	//# sourceMappingURL=angular-animate.min.js.map


/***/ },
/* 555 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.4.5
	 * (c) 2010-2015 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`, `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                   |
	 * |---------------------------------------------|----------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                          |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                            |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                               |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                              |
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keypress event, button role                                                               |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ##Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ##Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	 /* global -ngAriaModule */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        provider('$aria', $AriaProvider);
	
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaMultiline: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeypress: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaMultiline** – `{boolean}` – Enables/disables aria-multiline tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeypress** – `{boolean}` – Enables/disables keypress event binding on `&lt;div&gt;` and
	   *    `&lt;li&gt;` elements with ng-click
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements like `div`
	   *    using ng-click, making them more accessible to users of assistive technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled');
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes. The internal `$aria` service is used to watch the
	   * boolean attribute `ngDisabled`. If it has not been explicitly set by the developer,
	   * `aria-disabled` is injected as an attribute with its value synchronized to the value in
	   * `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   * * **ngDisabled**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr);
	  }
	
	  function shouldAttachRole(role, elem) {
	    return !elem.attr('role') && (elem.attr('type') === role) && (elem[0].nodeName !== 'INPUT');
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' :
	           (type || role) === 'textbox'   || elem[0].nodeName === 'TEXTAREA' ? 'multiline' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        pre: function(scope, elem, attr, ngModel) {
	          if (shape === 'checkbox' && attr.type !== 'checkbox') {
	            //Use the input[checkbox] $isEmpty implementation for elements with checkbox roles
	            ngModel.$isEmpty = function(value) {
	              return value === false;
	            };
	          }
	        },
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction() {
	            if (needsTabIndex) {
	              needsTabIndex = false;
	              return function ngAriaRadioReaction(newVal) {
	                var boolVal = (attr.value == ngModel.$viewValue);
	                elem.attr('aria-checked', boolVal);
	                elem.attr('tabindex', 0 - !boolVal);
	              };
	            } else {
	              return function ngAriaRadioReaction(newVal) {
	                elem.attr('aria-checked', (attr.value == ngModel.$viewValue));
	              };
	            }
	          }
	
	          function ngAriaCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction() : ngAriaCheckboxReaction);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              break;
	            case 'multiline':
	              if (shouldAttachAttr('aria-multiline', 'ariaMultiline', elem)) {
	                elem.attr('aria-multiline', true);
	              }
	              break;
	          }
	
	          if (needsTabIndex) {
	            elem.attr('tabindex', 0);
	          }
	
	          if (ngModel.$validators.required && shouldAttachAttr('aria-required', 'ariaRequired', elem)) {
	            scope.$watch(function ngAriaRequiredWatch() {
	              return ngModel.$error.required;
	            }, function ngAriaRequiredReaction(newVal) {
	              elem.attr('aria-required', !!newVal);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled');
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
	      return function(scope, elem, attr) {
	
	        var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA'];
	
	        function isNodeOneOf(elem, nodeTypeArray) {
	          if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	            return true;
	          }
	        }
	
	        if ($aria.config('bindRoleForClick')
	            && !elem.attr('role')
	              && !isNodeOneOf(elem, nodeBlackList)) {
	          elem.attr('role', 'button');
	        }
	
	        if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	          elem.attr('tabindex', 0);
	        }
	
	        if ($aria.config('bindKeypress') && !attr.ngKeypress && !isNodeOneOf(elem, nodeBlackList)) {
	          elem.on('keypress', function(event) {
	            var keyCode = event.which || event.keyCode;
	            if (keyCode === 32 || keyCode === 13) {
	              scope.$apply(callback);
	            }
	
	            function callback() {
	              fn(scope, { $event: event });
	            }
	          });
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(557), __webpack_require__(558)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseUtils, StateUtils) {
	    return angular.module('edge.platform.util', []).factory('BaseUtils', BaseUtils).factory('StateUtils', StateUtils);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Service for providing a set of helper functions across the application
	     */
	    return [function () {
	        var counter = 0;
	        return {
	            getUniqueID: function getUniqueID() {
	                return counter++;
	            },
	
	            assert: function () {
	                var assert = function assert(value, message) {
	                    if (!value) {
	                        throw new Error(message || 'Failed assertion');
	                    }
	                };
	
	                assert.string = function (value, message) {
	                    assert(value && typeof value === 'string', message || 'String expected');
	                };
	
	                assert.stringKey = function (object, key, message) {
	                    assert.string(object && object[key], message || 'Expected ' + key + ' to be a string');
	                };
	
	                return assert;
	            }()
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Helper for stateful data and state manipulation.
	     * This helper provides functions to serve following purposes:
	     * <ul>
	     *     <li>Introspect current application state and access it's internal state.
	     *     <li>Provide access to parent state for child states.
	     *     <li>Bind object lifecycle to state lifecycle and not to a "forever" cycle (as in the case of services).
	     * </ul>
	     *
	     * In general, it should simplify "context-related" display (like top menus depending on the internal state) and
	     * help to remove most of the "specific scenario" bugs. UI must be bound to the state and better to do that
	     * implicitly (so <em>transition history</em> would not affect UI).
	     */
	    return ['$state', '$rootScope', '$timeout', function ($state, $rootScope, $timeout) {
	        function getStateData(state) {
	            /* Data field name. */
	            var DATA_NAME = 'GW.PL.LiveData';
	
	            if (!state.data) {
	                state.data = {};
	            }
	
	            if (!state.data[DATA_NAME]) {
	                state.data[DATA_NAME] = {};
	            }
	            return state.data[DATA_NAME];
	        }
	
	        function getParentStatesArray(state) {
	            var collectedParentStates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            collectedParentStates.unshift(state);
	            if (state.parent === undefined) {
	                return collectedParentStates;
	            }
	            var parentState = typeof state.parent === 'string' ? $state.get(state.parent) : state.parent;
	            return getParentStatesArray(parentState, collectedParentStates);
	        }
	
	        function retrieveDataForStateName(stateName, includeInherited) {
	            var _angular;
	
	            var state = $state.get(stateName);
	            if (!state) {
	                return undefined;
	            }
	            var states = includeInherited ? getParentStatesArray(state) : [state];
	            var statesData = states.map(function (_state) {
	                return getStateData(_state);
	            });
	
	            //copying own enumerable properties from rightmost to leftmost parameters
	            return (_angular = angular).extend.apply(_angular, _toConsumableArray(statesData));
	        }
	
	        function deleteDataForStateName(stateName, propertiesToDelete, includeInherited) {
	            var state = $state.get(stateName);
	            if (!state) {
	                return undefined;
	            }
	            var states = includeInherited ? getParentStatesArray(state) : [state];
	            var statesData = states.map(function (_state) {
	                return getStateData(_state);
	            });
	
	            statesData.forEach(function (data) {
	                var propsToDel = Object.getOwnPropertyNames(data);
	                if (propertiesToDelete) {
	                    propsToDel = propsToDel.filter(function (prop) {
	                        return propertiesToDelete.includes(prop);
	                    });
	                }
	                //set any matching properties to undefined
	                propsToDel.forEach(function (prop) {
	                    return data[prop] = undefined;
	                });
	            });
	        }
	
	        function stateHasParent(testState, parentState) {
	            testState = $state.get(testState);
	            parentState = $state.get(parentState);
	            if (testState.name === parentState.name) {
	                return true;
	            }
	            if (testState.parent === undefined) {
	                return false;
	            }
	            return stateHasParent(testState.parent, parentState);
	        }
	
	        return {
	
	            /**
	             * Provides a location to store and access to data that relevant to the current state.
	             * Will create a live data structure for the object if that structure do not already exists.
	             *
	             * @param {Boolean} [includeInherited=false] - Flag to indicate that data from parents should be included (defaults to false).
	             *                                         Child properties will take precedence over parent properties of the same name
	             *
	             * @return '<code>undefined</code>' if <code>stateName</code> was provided but current state is not compatible
	             * with the requested state.
	             */
	            'activeDataForState': function activeDataForState() {
	                var includeInherited = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	                return retrieveDataForStateName($state.current.name, includeInherited);
	            },
	
	
	            /**
	             * Deletes data being held in the current state object based on the <code>propertiesToDelete</code> parameter.
	             *
	             * @param {Array} [propertiesToDelete]       - Array of properties to be deleted from the active state object.
	             *                                              If undefined then all active state data is deleted
	             *
	             * @param {Boolean} [includeInherited=false] -Flag to indicate that data from parent states also be deleted
	             *
	             */
	            'removeActiveDataForState': function removeActiveDataForState(propertiesToDelete) {
	                var includeInherited = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	                return deleteDataForStateName($state.current.name, propertiesToDelete, includeInherited);
	            },
	
	
	            /**
	             * Provides a location to store and access to data that relevant to a state specified by fnol.
	             * Will create a data structure for the object if that structure does not already exist.
	             *
	             *  @param {String} stateName - name of the state to fetch data for.
	             *  @param {Boolean} [includeInherited] - Flag to indicate that data from parents should be included (defaults to true).
	             *                                         Child properties will take precedence over parent properties of the same name
	             *
	             * @throws Error if stateName parameter not provided
	             * @throws Error if a state cannot be found for the stateName
	             *
	             * @returns new or existing data associated with the state given by stateName
	             */
	            'dataForState': function dataForState(stateName) {
	                var includeInherited = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	                if (!stateName) {
	                    throw new Error('A valid state name must be provided.');
	                }
	                var stateData = retrieveDataForStateName(stateName, includeInherited);
	
	                if (!stateData) {
	                    throw new Error('Unable to find state with name ' + stateName);
	                }
	                return stateData;
	            },
	
	
	            /**
	             *Deletes data being held in the state object identified by <code>stateName</code> based on the
	             * <code>propertiesToDelete</code> parameter.
	             *
	             * @param {String} stateName - name of the state to delete data on.
	             *
	             * @param {Array} [propertiesToDelete]       - Array of properties to be deleted from the active state object.
	             *                                              If undefined then all active state data is deleted
	             *
	             * @param {Boolean} [includeInherited=false] -Flag to indicate that data from parent states also be deleted
	             *
	             */
	            'removeDataForState': function removeDataForState(stateName, propertiesToDelete) {
	                var includeInherited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	                return deleteDataForStateName(stateName, propertiesToDelete, includeInherited);
	            },
	
	
	            /**
	             * Checks if <code>equalOrDescendantState</code> is equal to <code>equalOrParentState</code> or is a descendant of <code>equalOrParentState</code>.
	             * If equalOrDecendantState is undefined then tests against the current state
	             *
	             * @param {String} equalOrParentState parent state to check if equal or a parent to equalOrDescendantState
	             * @param {String} [equalOrDescendantState]  Defaults to the current state
	             *
	             * @returns boolean
	             *
	             */
	            'hasState': function hasState(equalOrParentState, equalOrDescendantState) {
	                if (!equalOrDescendantState) {
	                    //use current state
	                    return $state.includes(equalOrParentState);
	                }
	                var state = $state.get(equalOrDescendantState);
	                var parentState = $state.get(equalOrParentState);
	                return equalOrParentState ? stateHasParent(state, parentState) : false;
	            },
	
	
	            /**
	             * Calls a function on each state change but before each controller is initialized.
	             * @param callback function to call.
	             *
	             * @returns {Function} function to remove the listener
	             */
	            'beforeStateInit': function beforeStateInit(callback) {
	                return $rootScope.$on('$stateChangeSuccess', callback);
	            },
	
	
	            /**
	             * Calls a function on each state change after state controller is initalized.
	             * @param callback zero-arg function to call.
	             * @returns {Function} function to remove the listener
	             */
	            'afterStateInit': function afterStateInit(callback) {
	                return $rootScope.$on('$stateChangeSuccess', function () {
	                    $timeout(callback);
	                });
	            },
	
	
	            /**
	             * Calls a function before state change
	             * @param callback function to call.
	             *
	             * @returns {Function} function to remove the listener
	             */
	            'beforeStateChangeStart': function beforeStateChangeStart(callback) {
	                return $rootScope.$on('$stateChangeStart', callback);
	            }
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(560), __webpack_require__(562), __webpack_require__(511)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LoadingIndicationDirective, CallTrackerService) {
	    return angular.module('edge.platform.widgets.loadingMsg', ['portal.config']).factory('CallTrackerService', CallTrackerService).directive('gwPlLoadingMsg', LoadingIndicationDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(561)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    /**
	     * Usage example:
	     *
	     * Inline:
	     *<div gw-pl-loading-msg
	     *  inline
	     *  error-inline="getError()"
	     *></div>
	     */
	
	    return ['$rootScope', 'CallTrackerService', function ($rootScope, CallTrackerService) {
	        return {
	            restrict: 'A',
	            scope: {
	                id: '@id',
	                callGroup: '@',
	                msg: '@',
	                errorMsg: '@',
	                errorInline: '='
	            },
	            template: templateStr,
	
	            link: function link(scope, element, attrs) {
	                scope.inline = attrs.inline !== undefined;
	                scope.display = false;
	                scope.error = false;
	                scope.initTime = new Date();
	                scope.position = {
	                    top: attrs.top,
	                    left: attrs.left,
	                    right: attrs.right,
	                    bottom: attrs.bottom
	                };
	
	                $rootScope.$watch('callTrackerCounter', function () {
	                    scope.error = CallTrackerService.anyErrorAfter(scope.initTime, scope.callGroup);
	                    scope.display = !scope.error && CallTrackerService.anyInFlightCall(scope.callGroup);
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-loading-msg\" ng-show=\"errorInline || display || error\" ng-class=\"{'gw-loading-msg__inline': inline}\">\n    <div class=\"gw-wrapper\" ng-style='position' ng-show=\"display\">\n      <span class=\"gw-imageDiv\">\n          <img src=\"../styles/images/common/ajax-loader.gif\"/>\n      </span>\n        <span class=\"gw-hpadded\">{{msg}}</span>\n    </div>\n    <div class=\"gw-wrapper\" ng-style='position' ng-show=\"error\">\n        <span class=\"gw-hpadded\">{{errorInline || errorMsg}}</span>\n    </div>\n</div>\n"

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * This module defines a service to be used by JsonRPCService to register asynchronous call with call groups. These call
	 * groups are intended to be monitored by the LoadingIndication directive to show/hide spinners and inform the
	 * user about failed calls.
	 * Loading/Error indication directives can watch on $rootScope.callTrackerCounter
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$rootScope', function ($rootScope) {
	        var _ALL_CALLS = 'all-calls';
	        var registeredCallGroups = {};
	
	        function registerCallWithGroup(callGroup) {
	            if (callGroup) {
	                var groupInfo = registeredCallGroups[callGroup];
	                if (!groupInfo) {
	                    groupInfo = registeredCallGroups[callGroup] = { inFlightCalls: 0, lastError: 0 };
	                }
	                groupInfo.inFlightCalls += 1;
	            }
	        }
	
	        function registerCallSuccessWithGroup(callGroup) {
	            var groupInfo = registeredCallGroups[callGroup];
	            if (groupInfo) {
	                groupInfo.inFlightCalls -= 1;
	            }
	        }
	
	        function registerCallErrorWithGroup(callGroup) {
	            var groupInfo = registeredCallGroups[callGroup];
	            if (groupInfo) {
	                groupInfo.inFlightCalls -= 1;
	                groupInfo.lastError = new Date();
	            }
	        }
	
	        function forEachCallGroup(callGroups, op) {
	            if (Array.isArray(callGroups)) {
	                for (var i = 0; i < callGroups.length; i++) {
	                    op(callGroups[i]);
	                }
	            } else {
	                op(callGroups);
	            }
	        }
	
	        $rootScope.callTrackerCounter = 0;
	
	        return {
	            /**
	             * @constant {string} - The global call group name. Every call start, success and error is also
	             * registered with this call group.
	             */
	            ALL_CALLS: _ALL_CALLS,
	
	            /**
	             * Registers a new asynchronous call with a given set of call groups, incrementing the number of
	             * in-flight calls for the call groups. This method also register the call with the global call group.
	             *
	             * @param callGroups {(string|string[])} - call groups the call has to be registered with.
	             */
	            registerCallStart: function registerCallStart(callGroups) {
	                registerCallWithGroup(_ALL_CALLS);
	                forEachCallGroup(callGroups, registerCallWithGroup);
	                $rootScope.callTrackerCounter += 1;
	            },
	
	            /**
	             * Register a successful asynchronous call with the given set of call groups, decrementing the number
	             * of in-flight calls for the call groups.
	             *
	             * @param callGroups {(string|string[])} - call groups the successful call has to be registered with.
	             */
	            registerCallSuccess: function registerCallSuccess(callGroups) {
	                registerCallSuccessWithGroup(_ALL_CALLS);
	                forEachCallGroup(callGroups, registerCallSuccessWithGroup);
	                $rootScope.callTrackerCounter += 1;
	            },
	
	            /**
	             * Register a failed asynchronous call with the given set of call groups, decrementing the number
	             * of in-flight calls and setting the last error timestamp for the call groups.
	             *
	             * @param callGroups {(string|string[])} - call groups the failed call has to be registered with.
	             */
	            registerCallError: function registerCallError(callGroups) {
	                registerCallErrorWithGroup(_ALL_CALLS);
	                forEachCallGroup(callGroups, registerCallErrorWithGroup);
	                $rootScope.callTrackerCounter += 1;
	            },
	
	            /**
	             * Checks if there is any in-flight call for any of the given call groups.
	             *
	             * @param callGroups {(string|string[])} - call groups to check.
	             */
	            anyInFlightCall: function anyInFlightCall(callGroups) {
	                var callCount = 0;
	
	                if (!callGroups) {
	                    // No call group, test 'all-calls'
	                    var callGroup = registeredCallGroups[_ALL_CALLS];
	                    if (callGroup && callGroup.inFlightCalls) {
	                        callCount = callGroup.inFlightCalls > 0;
	                    }
	                } else {
	                    forEachCallGroup(callGroups, function (callGroup) {
	                        var group = registeredCallGroups[callGroup];
	                        if (group && group.inFlightCalls) {
	                            callCount += group.inFlightCalls;
	                        }
	                    });
	                }
	
	                return callCount > 0;
	            },
	
	            /**
	             * Checks if there is any error registered after the given time for any of the given call groups.
	             *
	             * @param fromTime {Date} - the time to check.
	             * @param callGroups {(string|string[])} - call groups to check.
	             */
	            anyErrorAfter: function anyErrorAfter(fromTime, callGroups) {
	                var latestError = new Date(0);
	
	                if (!callGroups) {
	                    // No call group, test 'all-calls'
	                    var callGroup = registeredCallGroups[_ALL_CALLS];
	                    if (callGroup && callGroup.lastError) {
	                        latestError = callGroup.lastError;
	                    }
	                } else {
	                    forEachCallGroup(callGroups, function (callGroup) {
	                        var group = registeredCallGroups[callGroup];
	                        if (group && group.lastError && group.lastError > latestError) {
	                            latestError = group.lastError;
	                        }
	                    });
	                }
	
	                return fromTime < latestError;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        $get: ['ModalService', '$filter', '$state', 'state_plugin_config', function (ModalService, $filter, $state, statePluginConfig) {
	            var quoteTimeout = function quoteTimeout() {
	                ModalService.showError($filter('translate')('platform.base.DefaultErrorHandlerService.Session Timeout'), $filter('translate')('platform.base.DefaultErrorHandlerService.Sorry, your session has timed out. Please restart your quote.')).result.then(function () {
	                    $state.transitionTo(statePluginConfig.home);
	                });
	            };
	
	            return {
	                getErrorHandlerForCode: function getErrorHandlerForCode(errorCode) {
	                    switch (errorCode) {
	                        case -33004:
	                            return quoteTimeout;
	                        default:
	                            return null;
	                    }
	                }
	            };
	        }]
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(565), __webpack_require__(511)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Transport) {
	    return angular.module('edge.platform.transport', ['portal.config']).factory('TransportService', Transport);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(566)

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Default implementation of low-level transport. Each low-level transport should implement following methods:
	 * <ul>
	 *     <li>send(kind : String, endpoint : String, method : String, params : *[]) : Promise<Object> -
	 *     performs a network query.
	 *     <li>isSessionExpiredReason(details : Object) - checks if query's failure object denotes a "session expired" failure.
	 * </ul>
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    function encodeBasicAuth(login, password) {
	        return window.btoa(login + ':' + password);
	    }
	
	    /** Searches for the authentication header. */
	    function findAuthHeader(settings) {
	        var authOptions = settings.auth;
	        if (authOptions === null) {
	            return null;
	        }
	        if (typeof authOptions === 'string') {
	            return authOptions;
	        }
	
	        switch (authOptions.kind) {
	            case 'basic':
	                return 'Basic ' + encodeBasicAuth(authOptions.username, authOptions.password);
	            default:
	                return null;
	        }
	    }
	
	    return ['$http', '$q', 'httpSettings', 'LocaleService', function ($http, $q, httpSettings, locale) {
	        var requestCode = 0;
	        var serviceBaseURLs = httpSettings.serviceBaseURLs;
	
	        var baseHeaders = {
	            'Content-Type': 'application/json; charset=utf-8'
	        };
	
	        var authValue = findAuthHeader(httpSettings);
	        // if (authValue) {
	        //     baseHeaders.Authorization = authValue;
	        // }
	
	        return {
	            send: function send(xCenterType, serviceEndpoint, method, params) {
	                var headers = angular.copy(baseHeaders);
	                headers['Accept-Language'] = locale.getCurrentLocale();
	                // UserToken should be portal user only; this usertoken will be used
	                // for tracking the transactions made from QB portal
	                headers['UserToken'] = "pu";
	                var callStart = new Date().getTime();
	                requestCode++;
	                return $http({
	                    method: 'POST',
	                    url: serviceBaseURLs[xCenterType] + serviceEndpoint,
	                    data: {
	                        method: method,
	                        params: params,
	                        'jsonrpc': '2.0'
	                    },
	                    headers: headers,
	                    timeout: httpSettings.timeout
	                }).then(function (response) {
	                    return response.data.result;
	                }, function (error) {
	                    console.error(error);
	                    var callTime = new Date().getTime() - callStart;
	                    return $q.reject({
	                        baseError: error,
	                        isTimeout: error.status === 0 && callTime < httpSettings.timeout
	                    });
	                });
	            },
	
	            isSessionExpiredReason: function isSessionExpiredReason(reason) {
	                return reason.isTimeout === true;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(568), __webpack_require__(569)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NgFormDecorator, EmailInputDecorator) {
	    angular.module('edge.platform.decorator', []).config(['$provide', NgFormDecorator]).config(['$provide', EmailInputDecorator]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Allows us to dynamically set ng-form names.
	     *
	     * It uses the AngularJS interpolator to determine the value in the name attribute
	     * and then sets this as the name of the ng-form.
	     *
	     * The issue, which is been tracked here https://github.com/angular/angular.js/issues/1404, was
	     * getting a lot of traffic, it may be the case that this gets fixed in the future, so we should
	     * keep an eye on it to see if it does. We can remove this decorator when it does.
	     */
	    return function ($provide) {
	        $provide.decorator('ngModelDirective', ['$delegate', function ($delegate) {
	            var ngModel = $delegate[0];
	            var controller = ngModel.controller;
	            ngModel.controller = ['$scope', '$element', '$attrs', '$injector', function (scope, element, attrs, $injector) {
	                var $interpolate = $injector.get('$interpolate');
	                attrs.$set('name', $interpolate(attrs.name || '')(scope));
	                $injector.invoke(controller, this, {
	                    '$scope': scope,
	                    '$element': element,
	                    '$attrs': attrs
	                });
	            }];
	            return $delegate;
	        }]);
	        $provide.decorator('ngFormDirective', ['$delegate', function ($delegate) {
	            var form = $delegate[0];
	            var controller = form.controller;
	            form.controller = ['$scope', '$element', '$attrs', '$injector', function (scope, element, attrs, $injector) {
	                var $interpolate = $injector.get('$interpolate');
	                attrs.$set('name', $interpolate(attrs.name || attrs.ngForm || '')(scope));
	                $injector.invoke(controller, this, {
	                    '$scope': scope,
	                    '$element': element,
	                    '$attrs': attrs
	                });
	            }];
	            return $delegate;
	        }]);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var EMAIL_REGEXP = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
	
	    /* Garog : The aim of this decorator is the override the default angular email validation which returns undefined when the view value
	     fails validation. This has the knock on effect of not setting the model value, which messes with our own DTO validation.
	     */
	    return function ($provide) {
	        $provide.decorator('inputDirective', ['$delegate', function ($delegate) {
	            var directive = $delegate[0];
	            var link = directive.link;
	
	            directive.compile = function () {
	                return function (scope, element, attrs, ctrl) {
	                    link.pre.apply(this, arguments); // Otherwise the formatters and parsers aren't there yet
	                    if (attrs.type === 'email') {
	                        var emailValidator = function emailValidator(value) {
	                            if (ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value)) {
	                                ctrl.$setValidity('email', true);
	                            } else {
	                                ctrl.$setValidity('email', false);
	                            }
	                            return value;
	                        };
	                        ctrl.$formatters = [emailValidator];
	                        ctrl.$parsers = [emailValidator];
	                    }
	                };
	            };
	
	            return $delegate;
	        }]);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(571)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return angular.module('edge.platform.atomic_design', ['edge.platform.atomic_design.molecules']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(572)], __WEBPACK_AMD_DEFINE_RESULT__ = function (RadiosBinaryDirective) {
	    return angular.module('edge.platform.atomic_design.molecules', []).directive('gwPlRadiosBinary', RadiosBinaryDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(573)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    /**
	     * Directive to show radio buttons bin ary group
	     *
	     * Examples uf usage:
	     *  <div gw-pl-radios-binary
	     *      title1="Yes"
	     *      title2="No"
	     *          >
	     *      <input class="someclass1" type="radio" name="somename" id="someid1"/>
	     *      <input class="someclass2" type="radio" name="somename" id="someid2"/>
	     *  </div>
	     *
	     * ID attrs for inputs are optional
	     */
	    return ['$timeout', function ($timeout) {
	        var _id = 0; // auto generated counter for ID. Is used if ID attr is not provided for input
	
	        /**
	         * Checks id ID attr is provided for element and adds and stores it otherwise to object field
	         * @param el {HTMLElement}
	         * @param objToStore {Object}
	         * @param fieldToStore {String}
	         */
	        function storeId(el, objToStore, fieldToStore) {
	            var id = el.attr('id');
	            if (!id) {
	                id = 'radio-binary' + ++_id; // + increase counter
	                el.attr('id', id);
	            }
	            objToStore[fieldToStore] = id;
	        }
	
	        return {
	            restrict: 'A',
	            replace: true,
	            transclude: true,
	            template: templateStr,
	
	            // directive has own scope
	            scope: {
	                'title1': '@',
	                'title2': '@'
	            },
	            link: function link(scope, element, attrs, ctrls, transcludeFn) {
	                // scope for content inside block with directive
	                // has to use scope.$parent
	                // (to keep logic provided before wrapping working)
	                transcludeFn(scope.$parent, function (content) {
	                    element.prepend(content);
	
	                    // VARS
	                    var inputs = element.find('input');
	                    var input1 = inputs.eq(0);
	                    var input2 = inputs.eq(1);
	
	                    // ADDITIONAL CLASSES
	                    inputs.addClass('gw-no-label');
	                    input1.addClass('gw-first');
	                    input2.addClass('gw-second');
	
	                    $timeout(function () {
	                        // to let Angular finish $digest cycle
	                        // IDs
	                        storeId(input1, scope, 'inputId1');
	                        storeId(input2, scope, 'inputId2');
	                    }, 0);
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 573 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-radios-binary\">\n    <div class=\"gw-switcher\"></div>\n\n    <div class=\"gw-labels\">\n        <label class=\"gw-first\" for=\"{{::inputId1}}\" ng-attr-title=\"{{title1}}\">\n        </label>\n        <label class=\"gw-second\" for=\"{{::inputId2}}\" ng-attr-title=\"{{title2}}\">\n        </label>\n    </div>\n\n    <label class=\"gw-overlap1\" for=\"{{::inputId1}}\"></label>\n    <label class=\"gw-overlap2\" for=\"{{::inputId2}}\"></label>\n</div>"

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(575), __webpack_require__(576)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DropdownDirective, DropdownToggleDirective) {
	    return angular.module('edge.platform.widgets.dropdown', []).directive('gwPlDropdown', DropdownDirective).directive('gwDropdownToggle', DropdownToggleDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /*
	     * Angular bootstrap dropdown directive is used as basis
	     * The biggest difference- append dropdown menu to content to prevent overflow: hidden; etc.
	     *
	     * dropdownToggle - Provides dropdown menu functionality in place of bootstrap js
	     * @restrict class or attribute
	     * @example:
	     *    <li class="gw-pl-dropdown-wrapper">
	     *        <a class="gw-pl-dropdown-toggle"
	     *          [closest-element-to-listen]
	     *          [event-to-listen]
	     *          >My Dropdown Menu</a>
	     *        <div class="gw-pl-dropdown-menu-wrapper">
	     *          <ul class="dropdown-menu">
	     *              <li ng-repeat="choice in dropChoices">
	     *                  <a ng-href="{{choice.href}}">{{choice.text}}</a>
	     *              </li>
	     *          </ul>
	     *        </div>
	     *    </li>
	     */
	
	    return ['$document', function ($document) {
	        var openElement = null;
	        var _closeMenu = angular.noop;
	
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                // VARIABLES
	                var $window = $(window);
	                var $elToAppendMenu = element.closest('.gw-snap-content-inner');
	
	                var $dropdownWrapper = element.parent();
	                var $dropdownMenuWrapper = $dropdownWrapper.find('.gw-pl-dropdown-menu-wrapper');
	                // elements for which "open" class would be added
	                var $openClassEls = $dropdownWrapper.add($dropdownMenuWrapper);
	
	                var $closestElementToListen = $();
	                var eventToListen = void 0;
	                if (attrs.closestElementToListen) {
	                    $closestElementToListen = element.closest(attrs.closestElementToListen);
	                    eventToListen = attrs.eventToListen;
	                }
	
	                // -----
	                // ANGULAR BOOTSTRAP DROPDOWN DIRECTIVE CODE
	                // -----
	                scope.$watch('$location.path', function () {
	                    _closeMenu();
	                });
	                $dropdownWrapper.on('click', function () {
	                    _closeMenu();
	                });
	                element.on('click', function (event) {
	                    var elementWasOpen = element === openElement;
	
	                    event.preventDefault();
	                    event.stopPropagation();
	
	                    if (!!openElement) {
	                        _closeMenu();
	                    }
	
	                    if (!elementWasOpen && !element.hasClass('gw-disabled') && !element.prop('disabled')) {
	                        $openClassEls.addClass('gw-open');
	                        openElement = element;
	                        _closeMenu = function closeMenu() {
	                            //if (event) {
	                            //    event.preventDefault();
	                            //    event.stopPropagation();
	                            //}
	
	                            $document.off('click', _closeMenu);
	
	                            // additional code starts
	                            $window.off('resize', _closeMenu);
	                            $closestElementToListen.off(eventToListen, _closeMenu);
	                            // additional code ends
	
	                            $openClassEls.removeClass('gw-open');
	                            _closeMenu = angular.noop;
	                            openElement = null;
	                        };
	
	                        $document.on('click', _closeMenu);
	
	                        // additional code starts
	                        $window.on('resize', _closeMenu);
	                        refreshDropdownPosition();
	                        $closestElementToListen.on(eventToListen, _closeMenu);
	                        $dropdownMenuWrapper.appendTo($elToAppendMenu);
	                        // additional code ends
	                    }
	                });
	
	                // -----
	                // ADDITIONAL CODE
	                // -----
	                $dropdownMenuWrapper.detach(); // detach element to prevent page size change on appearing
	
	                function refreshDropdownPosition() {
	                    var elToAppendMenuOffset = $elToAppendMenu.offset();
	                    var dropdownWrapperOffset = $dropdownWrapper.offset();
	                    $dropdownMenuWrapper.css({
	                        width: $dropdownWrapper.width(),
	                        height: $dropdownWrapper.height(),
	                        top: dropdownWrapperOffset.top - elToAppendMenuOffset.top,
	                        left: dropdownWrapperOffset.left - elToAppendMenuOffset.left
	                    }).appendTo($elToAppendMenu);
	                }
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Extracted from angular-ui-bootstrap 0.8.0
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$document', '$location', function ($document) {
	        var openElement = null;
	        var _closeMenu = angular.noop;
	        return {
	            restrict: 'CA',
	            link: function link(scope, element) {
	                scope.$watch('$location.path', function () {
	                    _closeMenu();
	                });
	                element.parent().bind('click', function () {
	                    _closeMenu();
	                });
	                element.bind('click', function (event) {
	                    var elementWasOpen = element === openElement;
	
	                    event.preventDefault();
	                    event.stopPropagation();
	
	                    if (!!openElement) {
	                        _closeMenu();
	                    }
	
	                    if (!elementWasOpen && !element.hasClass('gw-disabled') && !element.prop('disabled')) {
	                        element.parent().addClass('gw-open');
	                        openElement = element;
	                        _closeMenu = function closeMenu(_event) {
	                            if (_event) {
	                                _event.preventDefault();
	                                _event.stopPropagation();
	                            }
	                            $document.unbind('click', _closeMenu);
	                            element.parent().removeClass('gw-open');
	                            _closeMenu = angular.noop;
	                            openElement = null;
	                        };
	                        $document.bind('click', _closeMenu);
	                    }
	                });
	            }
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Extracted from angular-bootstrap-ui 0.8.0
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(578), __webpack_require__(579), __webpack_require__(581), __webpack_require__(583), __webpack_require__(584)], __WEBPACK_AMD_DEFINE_RESULT__ = function (TabsetCtrl, TabsetDirective, TabDirective, TabHeadingDirective, TabContentDirective) {
	    angular.module('edge.platform.widgets.tabs', []).controller('TabsetController', TabsetCtrl).directive('tabset', TabsetDirective).directive('tab', TabDirective).directive('tabHeadingTransclude', TabHeadingDirective).directive('tabContentTransclude', TabContentDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$scope', function ($scope) {
	        var ctrl = this;
	        var tabs = ctrl.tabs = $scope.tabs = [];
	
	        ctrl.select = function (tab) {
	            angular.forEach(tabs, function (_tab) {
	                _tab.active = false;
	            });
	            tab.active = true;
	        };
	
	        ctrl.addTab = function addTab(tab) {
	            tabs.push(tab);
	            var defaultTab = $scope.defaultTab;
	            var lobTab = $scope.lobTab;
	            if (defaultTab && lobTab === 'PersonalAuto') {
	                if (tabs.length === parseInt(defaultTab) || tab.active) {
	                    ctrl.select(tab);
	                }
	            } else {
	                if (tabs.length === 1 || tab.active) {
	                    ctrl.select(tab);
	                }
	            }
	        };
	
	        ctrl.removeTab = function removeTab(tab) {
	            var index = tabs.indexOf(tab);
	            //Select a new tab if the tab to be removed is selected
	            if (tab.active && tabs.length > 1) {
	                //If this is the last tab, select the previous tab. else, the next tab.
	                var newActiveIndex = index === tabs.length - 1 ? index - 1 : index + 1;
	                ctrl.select(tabs[newActiveIndex]);
	            }
	            tabs.splice(index, 1);
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(580)], __WEBPACK_AMD_DEFINE_RESULT__ = function (TabsetTemplate) {
	    /**
	     * @ngdoc directive
	     * @name ui.bootstrap.tabs.directive:tabset
	     * @restrict EA
	     *
	     * @description
	     * Tabset is the outer container for the tabs directive
	     *
	     * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	     *
	     * @example
	     <example module="ui.bootstrap">
	     <file name="index.html">
	     <tabset>
	     <tab heading="Vertical Tab 1"><b>First</b> Content!</tab>
	     <tab heading="Vertical Tab 2"><i>Second</i> Content!</tab>
	     </tabset>
	     <hr />
	     <tabset vertical="true">
	     <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
	     <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
	     </tabset>
	     </file>
	     </example>
	     */
	    return function () {
	        return {
	            restrict: 'EA',
	            transclude: true,
	            replace: true,
	            scope: {
	                defaultTab: '@',
	                lobTab: '@',
	                hide: '@'
	            },
	            controller: 'TabsetController',
	            template: TabsetTemplate,
	            link: function link(scope, element, attrs) {
	                scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	                scope.type = angular.isDefined(attrs.type) ? scope.$parent.$eval(attrs.type) : 'tabs';
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 580 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-tabbable\">\n    <ul class=\"gw-nav {{type && 'gw-nav-' + type}}\" ng-class=\"{'gw-nav-stacked': vertical,'tab-hide' : hide}\" ng-transclude>\n    </ul>\n    <div class=\"gw-tab-content\">\n        <div class=\"gw-tab-pane\"\n             ng-repeat=\"tab in tabs\"\n             ng-class=\"{'gw-active': tab.active}\"\n             tab-content-transclude=\"tab\">\n        </div>\n    </div>\n</div>"

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(582)], __WEBPACK_AMD_DEFINE_RESULT__ = function (TabTemplate) {
	    /**
	     * @ngdoc directive
	     * @name ui.bootstrap.tabs.directive:tab
	     * @restrict EA
	     *
	     * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	     * @param {string=} select An expression to evaluate when the tab is selected.
	     * @param {boolean=} active A binding, telling whether or not this tab is selected.
	     * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	     *
	     * @description
	     * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	     *
	     * @example
	     <example module="ui.bootstrap">
	     <file name="index.html">
	     <div ng-controller="TabsDemoCtrl">
	     <button class="btn btn-small" ng-click="items[0].active = true">
	     Select item 1, using active binding
	     </button>
	     <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	     Enable/disable item 2, using disabled binding
	     </button>
	     <br />
	     <tabset>
	     <tab heading="Tab 1">First Tab</tab>
	     <tab select="alertMe()">
	     <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	     Second Tab, with alert callback and html heading!
	     </tab>
	     <tab ng-repeat="item in items"
	     heading="{{item.title}}"
	     disabled="item.disabled"
	     active="item.active">
	     {{item.content}}
	     </tab>
	     </tabset>
	     </div>
	     </file>
	     <file name="script.js">
	     function TabsDemoCtrl($scope) {
	          $scope.items = [
	            { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	            { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	          ];
	           $scope.alertMe = function() {
	            setTimeout(function() {
	              alert("You've selected the alert tab!");
	            });
	          };
	        };
	     </file>
	     </example>
	     */
	
	    /**
	     * @ngdoc directive
	     * @name ui.bootstrap.tabs.directive:tabHeading
	     * @restrict EA
	     *
	     * @description
	     * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	     *
	     * @example
	     <example module="ui.bootstrap">
	     <file name="index.html">
	     <tabset>
	     <tab>
	     <tab-heading><b>HTML</b> in my titles?!</tab-heading>
	     And some content, too!
	     </tab>
	     <tab>
	     <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	     That's right.
	     </tab>
	     </tabset>
	     </file>
	     </example>
	     */
	    return ['$parse', function ($parse) {
	        return {
	            require: '^tabset',
	            restrict: 'EA',
	            replace: true,
	            template: TabTemplate,
	            transclude: true,
	            scope: {
	                heading: '@',
	                onSelect: '&select', //This callback is called in contentHeadingTransclude
	                //once it inserts the tab's content into the dom
	                onDeselect: '&deselect'
	            },
	            controller: function controller() {
	                //Empty controller so other directives can require being 'under' a tab
	            },
	            compile: function compile(elm, attrs, transclude) {
	                return function postLink(scope, _elm, _attrs, tabsetCtrl) {
	                    var getActive = void 0;
	                    var setActive = void 0;
	                    if (_attrs.active) {
	                        getActive = $parse(_attrs.active);
	                        setActive = getActive.assign;
	                        scope.$parent.$watch(getActive, function (value, oldVal) {
	                            // Avoid re-initializing scope.active as it is already initialized
	                            // below. (watcher is called async during init with value ===
	                            // oldVal)
	                            if (value !== oldVal) {
	                                scope.active = !!value;
	                            }
	                        });
	                        scope.active = getActive(scope.$parent);
	                    } else {
	                        setActive = getActive = angular.noop;
	                    }
	
	                    scope.$watch('active', function (active) {
	                        // Note this watcher also initializes and assigns scope.active to the
	                        // _attrs.active expression.
	                        setActive(scope.$parent, active);
	                        if (active) {
	                            tabsetCtrl.select(scope);
	                            scope.onSelect();
	                        } else {
	                            scope.onDeselect();
	                        }
	                    });
	
	                    scope.disabled = false;
	                    if (_attrs.disabled) {
	                        scope.$parent.$watch($parse(_attrs.disabled), function (value) {
	                            scope.disabled = !!value;
	                        });
	                    }
	
	                    scope.select = function () {
	                        if (!scope.disabled) {
	                            scope.active = true;
	                        }
	                    };
	
	                    tabsetCtrl.addTab(scope);
	                    scope.$on('$destroy', function () {
	                        tabsetCtrl.removeTab(scope);
	                    });
	
	                    //We need to transclude later, once the content container is ready.
	                    //when this link happens, we're inside a tab heading.
	                    scope.$transcludeFn = transclude;
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 582 */
/***/ function(module, exports) {

	module.exports = "<li ng-class=\"{'gw-active': active, disabled: disabled}\">\n    <a ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n</li>"

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function () {
	        return {
	            restrict: 'A',
	            require: '^tab',
	            link: function link(scope, elm) {
	                scope.$watch('headingElement', function (heading) {
	                    if (heading) {
	                        elm.html('');
	                        elm.append(heading);
	                    }
	                });
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function () {
	        return {
	            restrict: 'A',
	            require: '^tabset',
	            link: function link(scope, elm, attrs) {
	                var tab = scope.$eval(attrs.tabContentTransclude);
	
	                //Now our tab is ready to be transcluded: both the tab heading area
	                //and the tab content area are loaded.  Transclude 'em both.
	                tab.$transcludeFn(tab.$parent, function (contents) {
	                    angular.forEach(contents, function (node) {
	                        if (isTabHeading(node)) {
	                            //Let tabHeadingTransclude know.
	                            tab.headingElement = node;
	                        } else {
	                            elm.append(node);
	                        }
	                    });
	                });
	            }
	        };
	        function isTabHeading(node) {
	            return node.tagName && (node.hasAttribute('tab-heading') || node.hasAttribute('data-tab-heading') || node.tagName.toLowerCase() === 'tab-heading' || node.tagName.toLowerCase() === 'data-tab-heading');
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Applies domain-driven branding
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(586)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return angular.module('edge.platform.branding', []);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Invokes the code to assign branding to the app
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(587)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BrandingData) {
	  // adds branding class to an HTML element
	  document.documentElement.classList.add('gw-branding-' + BrandingData.BRANDING_DOMAIN);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Provides branding data
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        BRANDING_DOMAIN: window.location.hostname.split('.')[0] // e.g. custom-domain.guidewire.com gives "custom-domain"
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(589), __webpack_require__(594), __webpack_require__(511)], __WEBPACK_AMD_DEFINE_RESULT__ = function (QuestionSetService, QuestionSetDirective) {
	    return angular.module('edge.platform.questionsets', ['portal.config']).directive('gwPlQuestionSet', QuestionSetDirective).provider('QuestionSetService', QuestionSetService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(590)], __WEBPACK_AMD_DEFINE_RESULT__ = function (QuestionSetFactory) {
	    var questionSets = {};
	
	    return {
	        addQuestionSets: function addQuestionSets(metaDataObj) {
	            angular.extend(questionSets, metaDataObj);
	        },
	
	        $get: ['TranslateService', function (TranslateService) {
	            return QuestionSetFactory.create(questionSets, TranslateService.instant);
	        }]
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(591), __webpack_require__(592), __webpack_require__(593)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, requiredness, validity, availableValues) {
	    var INPUT_CTRL_TYPES = {
	        'Choice': 'SELECT',
	        'String': 'TEXT',
	        'Boolean': 'RADIO'
	    };
	
	    function createQuestionSetViewModel(questionSets, modelValue, translator) {
	        function createQuestionViewModel(question) {
	            var questionVmNode = {
	                get code() {
	                    return question.code;
	                },
	                get label() {
	                    return question.displayKey;
	                },
	                get answer() {
	                    //set radio buttons default answer to false
	                    if (question.questionType === 'Boolean' && modelValue.answers[question.code] === undefined) {
	                        return false;
	                    }
	                    return modelValue.answers[question.code];
	                },
	                set answer(answerValue) {
	                    modelValue.answers[question.code] = answerValue;
	                },
	                get type() {
	                    return INPUT_CTRL_TYPES[question.questionType];
	                },
	                aspects: {}
	            };
	
	            var aspectProperties = requiredness(questionVmNode, question, modelValue.answers);
	            _.extendOwn(aspectProperties, validity(questionVmNode, translator));
	            _.extendOwn(aspectProperties, availableValues(question));
	
	            Object.getOwnPropertyNames(aspectProperties).forEach(function (propName) {
	                Object.defineProperty(questionVmNode.aspects, propName, aspectProperties[propName]);
	            });
	
	            return questionVmNode;
	        }
	
	        function getQuestionSet(qsName) {
	            var questionSet = questionSets[qsName];
	            if (!questionSet || !questionSet.orderedQuestions) {
	                throw new Error('There is no question set loaded with the name ' + qsName);
	            }
	            return questionSet;
	        }
	
	        //note: uses ducktyping, checking if answers is a view model object by looking at aspects property
	        //if view model already created then just return that object
	        if (modelValue.aspects && modelValue.questions && _.isArray(modelValue.questions)) {
	            return modelValue;
	        }
	
	        var qsViewModel = {
	            value: modelValue
	        };
	        var questionSet = getQuestionSet(modelValue.code);
	
	        var allQuestions = questionSet.orderedQuestions.sort(function (a, b) {
	            return a.order - b.order;
	        });
	
	        var availableQuestions = _.filter(allQuestions, function (question) {
	            return modelValue.answers[question.code] !== undefined;
	        });
	        qsViewModel.questions = availableQuestions.map(createQuestionViewModel);
	
	        return qsViewModel;
	    }
	
	    return {
	        create: function create(questionSets, translator) {
	            return {
	                /**
	                 * Creates a new question set view model object with aspects expected by form input controls.
	                 *
	                 * @param qsModelArrayOrObject {Object | Array}: QuestionSetAnswersDTO model object or array that is used to create the view model. If the object
	                 * passed in is a view model object then it will just be returned as is
	                 *
	                 * @return {Array}: A new view model object or array of view model objects with a top level serializedForm aspect
	                 */
	                getQuestionSetViewModel: function getQuestionSetViewModel(qsModelArrayOrObject) {
	                    if (!qsModelArrayOrObject && !(_.isObject(qsModelArrayOrObject) || _.isArray(qsModelArrayOrObject))) {
	                        throw new Error('An model object is required for storing answers');
	                    }
	
	                    if (_.isArray(qsModelArrayOrObject)) {
	                        return qsModelArrayOrObject.map(function (qsModel) {
	                            return createQuestionSetViewModel(questionSets, qsModel, translator);
	                        });
	                    }
	
	                    return [createQuestionSetViewModel(questionSets, qsModelArrayOrObject, translator)];
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return function (currentVmNode, question, answers) {
	        return {
	            'visible': {
	                'get': function get() {
	                    return _.every(question.filters, function (filter) {
	                        return answers[filter.questionCode] === filter.answer;
	                    });
	                }
	            },
	            'required': {
	                'get': function get() {
	                    return currentVmNode.aspects.visible && question.required;
	                }
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var REQUIRED_DISPLAYKEY = 'displaykey.Edge.Web.Api.Model.NotNull';
	
	    return function (currentViewModelNode, translator) {
	        return {
	            'valid': {
	                'get': function get() {
	                    return !(currentViewModelNode.aspects.required && (currentViewModelNode.answer === undefined || currentViewModelNode.answer === null));
	                }
	            },
	            'validationMessages': {
	                'get': function get() {
	                    if (!currentViewModelNode.aspects.valid) {
	                        return [translator(REQUIRED_DISPLAYKEY)];
	                    }
	                    return [];
	                }
	            },
	            'validationMessage': {
	                'get': function get() {
	                    if (!currentViewModelNode.aspects.valid) {
	                        return translator(REQUIRED_DISPLAYKEY);
	                    }
	                }
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (question) {
	        var choices = question.choices.map(function (choice) {
	            return {
	                'code': choice.choiceCode,
	                'name': choice.displayKey
	            };
	        });
	
	        return {
	            'availableValues': {
	                value: choices
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(595)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                'gwPlQuestionSet': '='
	            },
	            controller: ['$scope', 'QuestionSetService', function ($scope, QuestionSetService) {
	                $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.gwPlQuestionSet);
	                // console.log("questionSets ",$scope.questionSets )
	            }]
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 595 */
/***/ function(module, exports) {

	module.exports = "<div ng-repeat=\"qs in questionSets\">\n    <div ng-repeat=\"q in qs.questions\">\n        <div ng-if=\"q.aspects.visible\">\n            <div gw-pl-ctrl-group label=\"{{q.label | translate}}\" model=\"q\">\n                <div ng-if=\"q.type ==='SELECT'\">\n                    <select type=\"text\"\n                            name=\"Answer{{$index}}\"\n                            ng-model=\"q.answer\"\n                            ng-options=\"choice.code as choice.name | translate for choice in q.aspects.availableValues\">\n                        <option value=\"\">{{'quoteandbind.views.prequal-questions.choose' | translate}}</option>\n                    </select>\n                </div>\n                <div ng-if=\"q.type ==='TEXT'\">\n                    <textarea name=\"Answer{{$index}}\" ng-model=\"q.answer\"></textarea>\n                </div>\n                <div ng-if=\"q.type ==='RADIO'\">\n                    <div class=\"gw-controls-radios\">\n                        <div gw-pl-radios-binary\n                             title1=\"{{'quoteandbind.views.prequal-questions.radio.yes' | translate}}\"\n                             title2=\"{{'quoteandbind.views.prequal-questions.radio.no' | translate}}\"\n                        >\n                            <input type=\"radio\"\n                                   name=\"Answer{{$index}}\"\n                                   id=\"YesAnswer{{$index}}\"\n                                   value=\"true\"\n                                   ng-model=\"q.answer\"/>\n                            <input type=\"radio\"\n                                   name=\"Answer{{$index}}\"\n                                   id=\"NoAnswer{{$index}}\"\n                                   value=\"false\"\n                                   ng-model=\"q.answer\"/>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(599), __webpack_require__(616), __webpack_require__(603), __webpack_require__(606), __webpack_require__(607), __webpack_require__(609), __webpack_require__(612), __webpack_require__(614), __webpack_require__(597), __webpack_require__(619), __webpack_require__(621), __webpack_require__(623), __webpack_require__(625), __webpack_require__(627), __webpack_require__(511)], __WEBPACK_AMD_DEFINE_RESULT__ = function (AddressDetails, NameDetails, CompanyNameDetails, UiMaskDirective, ClampTextDirective, DateDropDownDirective, AlertDirective, BinaryChoice, BinaryChoiceGroup, YesNo, YesNoGroup, Stepper, StepperSelect, PhoneDetails) {
	    return angular.module('edge.platform.widgets.inputs', ['portal.config']).value('uiMaskConfig', {
	        maskDefinitions: {
	            '9': /\d/,
	            'A': /[a-zA-Z]/,
	            '*': /[a-zA-Z0-9]/
	        },
	        clearOnBlur: false,
	        clearOnBlurPlaceholder: false,
	        eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	        addDefaultPlaceholder: true
	    }).directive('gwPlAddressDetails', AddressDetails).directive('gwPlNameDetails', NameDetails).directive('gwPlCompanyNameDetails', CompanyNameDetails).directive('gwPlUiMask', UiMaskDirective).directive('gwPlClampText', ClampTextDirective).directive('gwPlDateDropDown', DateDropDownDirective).directive('gwPlAlert', AlertDirective).directive('gwPlBinaryChoice', BinaryChoice).directive('gwPlBinaryChoiceGroup', BinaryChoiceGroup).directive('gwPlYesNo', YesNo).directive('gwPlYesNoGroup', YesNoGroup).directive('gwPlStepperCtrl', Stepper).directive('gwPlStepperSelect', StepperSelect).directive('gwPlPhoneDetails', PhoneDetails);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(598)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                label: '@',
	                titleLeft: '@',
	                titleRight: '@',
	                valueLeft: '=',
	                valueRight: '=',
	                model: '=',
	                helpTip: '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 598 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-ctrl-group label=\"{{label}}\" model=\"model\" help-tip=\"{{helpTip}}\">\n    <div gw-pl-binary-choice\n         model=\"model\"\n         title-left=\"{{titleLeft}}\" title-right=\"{{titleRight}}\"\n         value-left=\"valueLeft\" value-right=\"valueRight\">\n    </div>\n</div>"

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(600), __webpack_require__(601), __webpack_require__(602)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, defaultTemplate, bigToSmallTemplate, postCodeBeforeCityTemplate) {
	    return ['LocaleService', function (LocaleService) {
	        var addressConfig = LocaleService.getAddressConfig();
	        var template = void 0;
	
	        switch (addressConfig.pcfMode) {
	            case 'BigToSmall':
	                template = bigToSmallTemplate;
	                break;
	            case 'PostCodeBeforeCity':
	                template = postCodeBeforeCityTemplate;
	                break;
	            default:
	                template = defaultTemplate;
	                break;
	        }
	
	        return {
	            restrict: 'A',
	            template: template,
	            scope: {
	                address: '=',
	                allContacts: '=',
	                readonly: '@',
	                addressType: '@',
	                displayCountry: '@',
	                defaultCountryCode: '@',
	                disableZipCode: '=',
	                disableCity: '=',
	                disableState: '=',
	                showLoading: '=',
	                hideFields: '='
	            },
	
	            link: function link(scope, element, attrs) {
	                attrs.$observe('readonly', function (value) {
	                    scope.readonly = value === 'true';
	                });
	
	                var defaultCountryCode = scope.defaultCountryCode || LocaleService.getCountry().code;
	
	                scope.isVisible = function (fieldName) {
	                    var visible = addressConfig.fieldNames.indexOf(fieldName) >= 0;
	                    if (scope.hideFields) {
	                        visible = visible && !(_.contains(scope.hideFields, fieldName) || _.contains(_.map(scope.hideFields, function (idx) {
	                            return idx + 'Kanji';
	                        }), fieldName));
	                    }
	                    return visible;
	                };
	
	                function syncAddressData() {
	                    if (scope.address.value) {
	                        scope.address.country.value = scope.address.country.value || defaultCountryCode;
	                    } else {
	                        scope.address.value = {
	                            country: defaultCountryCode
	                        };
	                    }
	                }
	
	                scope.$watch('address.value', syncAddressData);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine1')\"\n                      model=\"address.addressLine1\" readonly=\"readonly\"\n                      ng-attr-maxlength=\"50\"\n                      label=\"{{'platform.inputs.address-details.Address Line 1'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine2')\"\n                      model=\"address.addressLine2\" readonly=\"readonly\"\n                      ng-attr-maxlength=\"50\"\n                      label=\"{{'platform.inputs.address-details.Address Line 2'|translate}}\"></gw-pl-input-ctrl>\n    <!--<gw-pl-input-ctrl ng-if=\"isVisible('AddressLine3')\" model=\"address.addressLine3\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 3'|translate}}\"></gw-pl-input-ctrl>-->\n    <gw-pl-input-ctrl ng-if=\"isVisible('City')\" model=\"address.city\" readonly=\"readonly || disableCity\"\n                      label=\"{{'platform.inputs.address-details.City'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('PostalCode')\"\n                      model=\"address.postalCode\" readonly=\"readonly || disableZipCode\"\n                      ng-attr-maxlength=\"5\"\n                      label=\"{{'platform.inputs.address-details.ZIP Code'|translate}}\"></gw-pl-input-ctrl>\n\n    <div ng-if=\"isVisible('State')\" gw-pl-input-ctrl model=\"address.state\" readonly=\"readonly || disableState\"\n         label=\"{{'platform.inputs.address-details.State'|translate}}\"\n         placeholder=\"-- {{'platform.inputs.address-details.Choose State'|translate}} --\">\n    </div>\n</div>\n\n"

/***/ },
/* 601 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isVisible('PostalCode')\" model=\"address.postalCode\" readonly=\"readonly || disableZipCode\"\n                      label=\"{{'platform.inputs.address-details.ZIP Code'|translate}}\"></gw-pl-input-ctrl>\n\n    <div ng-if=\"isVisible('State')\" gw-pl-input-ctrl model=\"address.state\" readonly=\"readonly || disableCity\"\n         label=\"{{'platform.inputs.address-details.State'|translate}}\"\n         placeholder=\"-- {{'platform.inputs.address-details.Choose State'|translate}} --\">\n    </div>\n\n    <gw-pl-input-ctrl ng-if=\"isVisible('City')\" model=\"address.city\" readonly=\"readonly || disableCity\"\n                      label=\"{{'platform.inputs.address-details.City'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('CityKanji')\" model=\"address.cityKanji\" readonly=\"readonly || disableCity\"\n                      label=\"{{'platform.inputs.address-details.City Kanji'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine1')\" model=\"address.addressLine1\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 1'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine1Kanji')\" model=\"address.addressLine1Kanji\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 1 Kanji'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine2')\" model=\"address.addressLine2\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 2'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine2Kanji')\" model=\"address.addressLine2Kanji\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 2 Kanji'|translate}}\"></gw-pl-input-ctrl>\n</div>\n"

/***/ },
/* 602 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine1')\" model=\"address.addressLine1\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 1'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine2')\" model=\"address.addressLine2\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 2'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('AddressLine3')\" model=\"address.addressLine3\" readonly=\"readonly\"\n                      label=\"{{'platform.inputs.address-details.Address Line 3'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('PostalCode')\" model=\"address.postalCode\" readonly=\"readonly || disableZipCode\"\n                      label=\"{{'platform.inputs.address-details.ZIP Code'|translate}}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isVisible('City')\" model=\"address.city\" readonly=\"readonly || disableCity\"\n                      label=\"{{'platform.inputs.address-details.City'|translate}}\"></gw-pl-input-ctrl>\n\n    <div ng-if=\"isVisible('State')\" gw-pl-input-ctrl model=\"address.state\" readonly=\"readonly || disableCity\"\n         label=\"{{'platform.inputs.address-details.State'|translate}}\"\n         placeholder=\"-- {{'platform.inputs.address-details.Choose State'|translate}} --\">\n    </div>\n</div>\n"

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(604), __webpack_require__(605)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, defaultModeTemplate, japanModeTemplate) {
	    return ['LocaleService', function (LocaleService) {
	        var defaultHiddenFields = [];
	        var nameConfig = LocaleService.getNameConfig();
	
	        return {
	            restrict: 'A',
	            template: nameConfig.mode === 'Japan' ? japanModeTemplate : defaultModeTemplate,
	            scope: {
	                contact: '=', //if this val is changed in view then it changes in the model
	                readonly: '=' //if this val is changed in view it DOES NOT change in the model
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.hiddenFields = defaultHiddenFields;
	                $scope.isFieldVisible = function (fieldName) {
	                    var visible = nameConfig.visibleFields.indexOf(fieldName) >= 0;
	                    var hidden = $scope.hiddenFields.indexOf(fieldName) >= 0;
	                    return visible && !hidden;
	                };
	            }]
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 604 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('Name')\" readonly=\"readonly\" model=\"contact.contactName\"\n                      label=\"{{'platform.inputs.company-details.Name' | translate }}\"></gw-pl-input-ctrl>\n</div>"

/***/ },
/* 605 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('Name')\" readonly=\"readonly\" model=\"contact.contactName\"\n                      label=\"{{'platform.inputs.company-details.Name' | translate }}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('NameKanji')\" readonly=\"readonly\" model=\"contact.contactNameKanji\"\n                      label=\"{{'platform.inputs.contact-details.Name Kanji' | translate }}\"></gw-pl-input-ctrl>\n</div>"

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /**
	     * Taken from https://github.com/angular-ui/ui-mask with changes to ignore validation and remove any
	     * trailing placeholder characters
	     */
	    return ['uiMaskConfig', function (maskConfig) {
	        return {
	            priority: 100,
	            require: 'ngModel',
	            restrict: 'A',
	            compile: function uiMaskCompilingFunction() {
	                var options = maskConfig;
	
	                return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                    var maskProcessed = false;
	                    var eventsBound = false;
	                    var maskCaretMap = void 0;
	                    var maskPatterns = void 0;
	                    var maskPlaceholder = void 0;
	                    var maskComponents = void 0;
	                    // Minimum required length of the value to be considered valid
	                    var minRequiredLength = void 0;
	                    var value = void 0;
	                    var valueMasked = void 0;
	                    var isValid = void 0;
	                    // Vars for initializing/uninitializing
	                    var originalPlaceholder = iAttrs.placeholder;
	                    var originalMaxlength = iAttrs.maxlength;
	                    // Vars used exclusively in eventHandler()
	                    var oldValue = void 0;
	                    var oldValueUnmasked = void 0;
	                    var oldCaretPosition = void 0;
	                    var oldSelectionLength = void 0;
	                    // Used for communicating if a backspace operation should be allowed between
	                    // keydownHandler and eventHandler
	                    var preventBackspace = void 0;
	
	                    var originalIsEmpty = controller.$isEmpty;
	                    controller.$isEmpty = function (_value) {
	                        if (maskProcessed) {
	                            return originalIsEmpty(unmaskValue(_value || ''));
	                        }
	                        return originalIsEmpty(_value);
	                    };
	
	                    function initialize(maskAttr) {
	                        if (!angular.isDefined(maskAttr)) {
	                            return uninitialize();
	                        }
	                        processRawMask(maskAttr);
	                        if (!maskProcessed) {
	                            return uninitialize();
	                        }
	                        initializeElement();
	                        bindEventListeners();
	                        return true;
	                    }
	
	                    function initPlaceholder(placeholderAttr) {
	                        if (!placeholderAttr) {
	                            return;
	                        }
	
	                        maskPlaceholder = placeholderAttr;
	
	                        // If the mask is processed, then we need to update the value
	                        // but don't set the value if there is nothing entered into the element
	                        // and there is a placeholder attribute on the element because that
	                        // will only set the value as the blank maskPlaceholder
	                        // and override the placeholder on the element
	                        if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                            iElement.val(maskValue(unmaskValue(iElement.val())));
	                        }
	                    }
	
	                    function initPlaceholderChar() {
	                        return initialize(iAttrs.uiMask);
	                    }
	
	                    function formatter(fromModelValue) {
	                        if (!maskProcessed) {
	                            return fromModelValue;
	                        }
	                        value = unmaskValue(fromModelValue || '');
	                        isValid = validateValue(value);
	                        controller.$setValidity('mask', isValid);
	                        return isValid && value.length ? maskValue(value) : undefined;
	                    }
	
	                    function parser(fromViewValue) {
	                        var returnedValue = void 0;
	                        if (!maskProcessed) {
	                            return fromViewValue;
	                        }
	                        value = unmaskValue(fromViewValue || '');
	                        isValid = validateValue(value);
	                        // We have to set viewValue manually as the reformatting of the input
	                        // value performed by eventHandler() doesn't happen until after
	                        // this parser is called, which causes what the user sees in the input
	                        // to be out-of-sync with what the controller's $viewValue is set to.
	                        controller.$viewValue = value.length ? maskValue(value) : '';
	                        controller.$setValidity('mask', isValid);
	                        //JC: change from original  implementation- remove trailing placeholder characters
	                        if (value.length && angular.isDefined(iAttrs.leaveValueMasked)) {
	                            returnedValue = fromViewValue;
	                            if (controller.$viewValue.length > maskCaretMap.length) {
	                                //remove any trailing characters when we have entered the required number of characters
	                                returnedValue = returnedValue.substr(0, maskCaretMap.length + 1);
	                            }
	                        } else {
	                            returnedValue = value;
	                        }
	                        return returnedValue;
	                    }
	
	                    var linkOptions = {};
	
	                    if (iAttrs.uiOptions) {
	                        linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                        if (angular.isObject(linkOptions[0])) {
	                            // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                            linkOptions = function (original, current) {
	                                for (var i in original) {
	                                    if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                        if (current[i] === undefined) {
	                                            current[i] = angular.copy(original[i]);
	                                        } else {
	                                            if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                current[i] = angular.extend({}, original[i], current[i]);
	                                            }
	                                        }
	                                    }
	                                }
	                                return current;
	                            }(options, linkOptions[0]);
	                        } else {
	                            linkOptions = options; //gotta be a better way to do this..
	                        }
	                    } else {
	                        linkOptions = options;
	                    }
	
	                    iAttrs.$observe('gwPlUiMask', initialize);
	                    if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                        iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                    } else {
	                        iAttrs.$observe('placeholder', initPlaceholder);
	                    }
	                    if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                        iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                    }
	
	                    controller.$formatters.unshift(formatter);
	                    controller.$parsers.unshift(parser);
	
	                    function uninitialize() {
	                        maskProcessed = false;
	                        unbindEventListeners();
	
	                        if (angular.isDefined(originalPlaceholder)) {
	                            iElement.attr('placeholder', originalPlaceholder);
	                        } else {
	                            iElement.removeAttr('placeholder');
	                        }
	
	                        if (angular.isDefined(originalMaxlength)) {
	                            iElement.attr('maxlength', originalMaxlength);
	                        } else {
	                            iElement.removeAttr('maxlength');
	                        }
	
	                        iElement.val(controller.$modelValue);
	                        controller.$viewValue = controller.$modelValue;
	                        return false;
	                    }
	
	                    function initializeElement() {
	                        value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                        valueMasked = oldValue = maskValue(value);
	                        isValid = validateValue(value);
	                        if (iAttrs.maxlength) {
	                            // Double maxlength to allow pasting new val at end of mask
	                            iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                        }
	                        if (!originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                            iElement.attr('placeholder', maskPlaceholder);
	                        }
	                        var viewValue = controller.$modelValue;
	                        var idx = controller.$formatters.length;
	                        while (idx--) {
	                            viewValue = controller.$formatters[idx](viewValue);
	                        }
	                        controller.$viewValue = viewValue || '';
	                        controller.$render();
	                        // Not using $setViewValue so we don't clobber the model value and dirty the form
	                        // without any kind of user interaction.
	                    }
	
	                    function bindEventListeners() {
	                        if (eventsBound) {
	                            return;
	                        }
	                        iElement.bind('blur', blurHandler);
	                        iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                        iElement.bind('keydown', keydownHandler);
	                        iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                        eventsBound = true;
	                    }
	
	                    function unbindEventListeners() {
	                        if (!eventsBound) {
	                            return;
	                        }
	                        iElement.unbind('blur', blurHandler);
	                        iElement.unbind('mousedown', mouseDownUpHandler);
	                        iElement.unbind('mouseup', mouseDownUpHandler);
	                        iElement.unbind('keydown', keydownHandler);
	                        iElement.unbind('input', eventHandler);
	                        iElement.unbind('keyup', eventHandler);
	                        iElement.unbind('click', eventHandler);
	                        iElement.unbind('focus', eventHandler);
	                        eventsBound = false;
	                    }
	
	                    function validateValue() {
	                        //JC: change from original  implementation- leave view model to handle validation - just mark it valid
	                        return true;
	                    }
	
	                    function unmaskValue(_value) {
	                        var valueUnmasked = '';
	                        var input = iElement[0];
	                        var maskPatternsCopy = maskPatterns.slice();
	                        var selectionStart = oldCaretPosition;
	                        var selectionEnd = selectionStart + getSelectionLength(input);
	                        var valueOffset = void 0;
	                        var valueDelta = void 0;
	                        var tempValue = '';
	                        // Preprocess by stripping mask components from _value
	                        _value = _value.toString();
	                        valueOffset = 0;
	                        valueDelta = _value.length - maskPlaceholder.length;
	                        angular.forEach(maskComponents, function (component) {
	                            var position = component.position;
	                            //Only try and replace the component if the component position is not within the selected range
	                            //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                            if (!(position >= selectionStart && position < selectionEnd)) {
	                                if (position >= selectionStart) {
	                                    position += valueDelta;
	                                }
	                                if (_value.substring(position, position + component.value.length) === component.value) {
	                                    tempValue += _value.slice(valueOffset, position); // + _value.slice(position + component.value.length);
	                                    valueOffset = position + component.value.length;
	                                }
	                            }
	                        });
	                        _value = tempValue + _value.slice(valueOffset);
	                        angular.forEach(_value.split(''), function (chr) {
	                            if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                valueUnmasked += chr;
	                                maskPatternsCopy.shift();
	                            }
	                        });
	
	                        return valueUnmasked;
	                    }
	
	                    function maskValue(unmaskedValue) {
	                        valueMasked = '';
	                        var _maskCaretMapCopy = maskCaretMap.slice();
	
	                        angular.forEach(maskPlaceholder.split(''), function (chr, i) {
	                            if (unmaskedValue.length && i === _maskCaretMapCopy[0]) {
	                                valueMasked += unmaskedValue.charAt(0) || '_';
	                                unmaskedValue = unmaskedValue.substr(1);
	                                _maskCaretMapCopy.shift();
	                            } else {
	                                valueMasked += chr;
	                            }
	                        });
	                        return valueMasked;
	                    }
	
	                    function getPlaceholderChar(i) {
	                        var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder;
	                        var defaultPlaceholderChar = void 0;
	
	                        if (angular.isDefined(placeholder) && placeholder[i]) {
	                            return placeholder[i];
	                        }
	                        defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                        return defaultPlaceholderChar.toLowerCase() === 'space' ? ' ' : defaultPlaceholderChar[0];
	                    }
	
	                    // Generate array of mask components that will be stripped from a masked value
	                    // before processing to prevent mask components from being added to the unmasked value.
	                    // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                    function getMaskComponents() {
	                        var maskPlaceholderChars = maskPlaceholder.split('');
	                        var maskPlaceholderCopy = void 0;
	                        var components = void 0;
	
	                        //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                        if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                            //Instead of trying to manipulate the RegEx based on the placeholder characters
	                            //we can simply replace the placeholder characters based on the already built
	                            //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                            //mask components
	                            angular.forEach(maskCaretMap, function (_value) {
	                                maskPlaceholderChars[_value] = '_';
	                            });
	                        }
	                        maskPlaceholderCopy = maskPlaceholderChars.join('');
	                        components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                        components = components.filter(function (s) {
	                            return s !== '';
	                        });
	
	                        // need a string search offset in cases where the mask contains multiple identical components
	                        // E.g., a mask of 99.99.99-999.99
	                        var offset = 0;
	                        return components.map(function (c) {
	                            var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                            offset = componentPosition + 1;
	                            return {
	                                value: c,
	                                position: componentPosition
	                            };
	                        });
	                    }
	
	                    function processRawMask(mask) {
	                        var characterCount = 0;
	
	                        maskCaretMap = [];
	                        maskPatterns = [];
	                        maskPlaceholder = '';
	
	                        if (angular.isString(mask)) {
	                            minRequiredLength = 0;
	
	                            var isOptional = false;
	                            var numberOfOptionalCharacters = 0;
	                            var splitMask = mask.split('');
	
	                            angular.forEach(splitMask, function (chr, i) {
	                                if (linkOptions.maskDefinitions[chr]) {
	
	                                    maskCaretMap.push(characterCount);
	
	                                    maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                    maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                    characterCount++;
	                                    if (!isOptional) {
	                                        minRequiredLength++;
	                                    }
	
	                                    isOptional = false;
	                                } else if (chr === '?') {
	                                    isOptional = true;
	                                    numberOfOptionalCharacters++;
	                                } else {
	                                    maskPlaceholder += chr;
	                                    characterCount++;
	                                }
	                            });
	                        }
	                        // Caret position immediately following last position is valid.
	                        maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                        maskComponents = getMaskComponents();
	                        maskProcessed = maskCaretMap.length > 1;
	                    }
	
	                    var prevValue = iElement.val();
	                    function blurHandler() {
	                        if (linkOptions.clearOnBlur || linkOptions.clearOnBlurPlaceholder && value.length === 0 && iAttrs.placeholder) {
	                            oldCaretPosition = 0;
	                            oldSelectionLength = 0;
	                            if (!isValid || value.length === 0) {
	                                valueMasked = '';
	                                iElement.val('');
	                                scope.$apply(function () {
	                                    //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                    if (!controller.$pristine) {
	                                        controller.$setViewValue('');
	                                    }
	                                });
	                            }
	                        }
	                        //Check for different value and trigger change.
	                        if (value !== prevValue) {
	                            triggerChangeEvent(iElement[0]);
	                        }
	                        prevValue = value;
	                    }
	
	                    function triggerChangeEvent(element) {
	                        var change = void 0;
	                        if (angular.isFunction(window.Event) && !element.fireEvent) {
	                            // modern browsers and Edge
	                            change = new Event('change', {
	                                view: window,
	                                bubbles: true,
	                                cancelable: false
	                            });
	                            element.dispatchEvent(change);
	                        } else if ('createEvent' in document) {
	                            // older browsers
	                            change = document.createEvent('HTMLEvents');
	                            change.initEvent('change', false, true);
	                            element.dispatchEvent(change);
	                        } else if (element.fireEvent) {
	                            // IE <= 11
	                            element.fireEvent('onchange');
	                        }
	                    }
	
	                    function mouseDownUpHandler(e) {
	                        if (e.type === 'mousedown') {
	                            iElement.bind('mouseout', mouseoutHandler);
	                        } else {
	                            iElement.unbind('mouseout', mouseoutHandler);
	                        }
	                    }
	
	                    iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                    function mouseoutHandler() {
	                        /*jshint validthis: true */
	                        oldSelectionLength = getSelectionLength(this);
	                        iElement.unbind('mouseout', mouseoutHandler);
	                    }
	
	                    function keydownHandler(e) {
	                        /*jshint validthis: true */
	                        var isKeyBackspace = e.which === 8;
	                        var caretPos = getCaretPosition(this) - 1 || 0; //value in keydown is pre change so bump caret position back to simulate post change
	
	                        if (isKeyBackspace) {
	                            while (caretPos >= 0) {
	                                if (isValidCaretPosition(caretPos)) {
	                                    //re-adjust the caret position.
	                                    //Increment to account for the initial decrement to simulate post change caret position
	                                    setCaretPosition(this, caretPos + 1);
	                                    break;
	                                }
	                                caretPos--;
	                            }
	                            preventBackspace = caretPos === -1;
	                        }
	                    }
	
	                    function eventHandler(e) {
	                        /*jshint validthis: true */
	                        e = e || {};
	                        // Allows more efficient minification
	                        var eventWhich = e.which;
	                        var eventType = e.type;
	
	                        // Prevent shift and ctrl from mucking with old values
	                        if (eventWhich === 16 || eventWhich === 91) {
	                            return;
	                        }
	
	                        var val = iElement.val();
	                        var valOld = oldValue;
	                        var valMasked = void 0;
	                        var valAltered = false;
	                        var valUnmasked = unmaskValue(val);
	                        var valUnmaskedOld = oldValueUnmasked;
	                        var caretPos = getCaretPosition(this) || 0;
	                        var caretPosOld = oldCaretPosition || 0;
	                        var caretPosDelta = caretPos - caretPosOld;
	                        var caretPosMin = maskCaretMap[0];
	                        var caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift();
	                        var selectionLenOld = oldSelectionLength || 0;
	                        var isSelected = getSelectionLength(this) > 0;
	                        var wasSelected = selectionLenOld > 0;
	                        // Case: Typing a character to overwrite a selection
	                        var isAddition = val.length > valOld.length || selectionLenOld && val.length > valOld.length - selectionLenOld;
	                        // Case: Delete and backspace behave identically on a selection
	                        var isDeletion = val.length < valOld.length || selectionLenOld && val.length === valOld.length - selectionLenOld;
	                        var isSelection = eventWhich >= 37 && eventWhich <= 40 && e.shiftKey; // Arrow key codes
	
	                        var isKeyLeftArrow = eventWhich === 37;
	                        // Necessary due to "input" event not providing a key code
	                        var isKeyBackspace = eventWhich === 8 || eventType !== 'keyup' && isDeletion && caretPosDelta === -1;
	                        var isKeyDelete = eventWhich === 46 || eventType !== 'keyup' && isDeletion && caretPosDelta === 0 && !wasSelected;
	                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                        // a character when clicking within a filled input.
	                        var caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                        oldSelectionLength = getSelectionLength(this);
	
	                        // These events don't require any action
	                        if (isSelection || isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus')) {
	                            return;
	                        }
	
	                        if (isKeyBackspace && preventBackspace) {
	                            iElement.val(maskPlaceholder);
	                            // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                            // This keeps the $viewValue updated and correct.
	                            scope.$apply(function () {
	                                controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                            });
	                            setCaretPosition(this, caretPosOld);
	                            return;
	                        }
	
	                        // Value Handling
	                        // ==============
	
	                        // User attempted to delete but raw value was unaffected--correct this grievous offense
	                        if (eventType === 'input' && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                            while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                caretPos--;
	                            }
	                            while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                caretPos++;
	                            }
	                            var charIndex = maskCaretMap.indexOf(caretPos);
	                            // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                            valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                            // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                            if (valUnmasked !== valUnmaskedOld) {
	                                valAltered = true;
	                            }
	                        }
	
	                        // Update values
	                        valMasked = maskValue(valUnmasked);
	
	                        oldValue = valMasked;
	                        oldValueUnmasked = valUnmasked;
	
	                        //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                        //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                        if (!valAltered && val.length > valMasked.length) {
	                            valAltered = true;
	                        }
	
	                        iElement.val(valMasked);
	
	                        //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                        //actually doing anything.  Meaning, things like pristine and touched will be set.
	                        if (valAltered) {
	                            scope.$apply(function () {
	                                controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                            });
	                        }
	
	                        // Caret Repositioning
	                        // ===================
	
	                        // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                        // the input is a mask char and the caret is placed at the 0 position.
	                        if (isAddition && caretPos <= caretPosMin) {
	                            caretPos = caretPosMin + 1;
	                        }
	
	                        if (caretBumpBack) {
	                            caretPos--;
	                        }
	
	                        // Make sure caret is within min and max position limits
	                        caretPos = caretPos > caretPosMax ? caretPosMax : caretPos;
	                        caretPos = caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                        // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                        while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                            caretPos += caretBumpBack ? -1 : 1;
	                        }
	
	                        if (caretBumpBack && caretPos < caretPosMax || isAddition && !isValidCaretPosition(caretPosOld)) {
	                            caretPos++;
	                        }
	                        oldCaretPosition = caretPos;
	                        setCaretPosition(this, caretPos);
	                    }
	
	                    function isValidCaretPosition(pos) {
	                        return maskCaretMap.indexOf(pos) > -1;
	                    }
	
	                    function isFocused(elem) {
	                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                    }
	
	                    function getCaretPosition(input) {
	                        if (!input) {
	                            return 0;
	                        }
	                        if (input.selectionStart !== undefined) {
	                            return input.selectionStart;
	                        } else if (document.selection) {
	                            if (isFocused(iElement[0])) {
	                                // Curse you IE
	                                input.focus();
	                                var selection = document.selection.createRange();
	                                selection.moveStart('character', input.value ? -input.value.length : 0);
	                                return selection.text.length;
	                            }
	                        }
	                        return 0;
	                    }
	
	                    function setCaretPosition(input, pos) {
	                        if (!input) {
	                            return 0;
	                        }
	                        if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                            return; // Input's hidden
	                        }
	                        if (input.setSelectionRange) {
	                            if (isFocused(iElement[0])) {
	                                input.focus();
	                                input.setSelectionRange(pos, pos);
	                            }
	                        } else if (input.createTextRange) {
	                            // Curse you IE
	                            var range = input.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	
	                    function getSelectionLength(input) {
	                        if (!input) {
	                            return 0;
	                        }
	                        if (input.selectionStart !== undefined) {
	                            return input.selectionEnd - input.selectionStart;
	                        }
	                        if (document.selection) {
	                            return document.selection.createRange().text.length;
	                        }
	                        return 0;
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(608)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$timeout', function ($timeout) {
	        return {
	            'restrict': 'A',
	            'scope': {
	                'clampLines': '@',
	                'clampValue': '@'
	            },
	            'link': function link(scope, elt) {
	                function update() {
	                    $timeout(function () {
	                        var jqElement = angular.element(elt[0]).empty();
	                        jqElement.append(document.createTextNode(scope.clampValue));
	                        window.$clamp(elt[0], { clamp: scope.clampLines });
	                    });
	                }
	
	                update();
	                scope.$watch('clampValue', update);
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 608 */
/***/ function(module, exports) {

	/*!
	* Clamp.js 0.5.1
	*
	* Copyright 2011-2013, Joseph Schmitt http://joe.sh
	* Released under the WTFPL license
	* http://sam.zoy.org/wtfpl/
	*/
	
	(function(){
	    /**
	     * Clamps a text node.
	     * @param {HTMLElement} element. Element containing the text node to clamp.
	     * @param {Object} options. Options to pass to the clamper.
	     */
	    function clamp(element, options) {
	        options = options || {};
	
	        var self = this,
	            win = window,
	            opt = {
	                clamp:              options.clamp || 2,
	                useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	                splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	                animate:            options.animate || false,
	                truncationChar:     options.truncationChar || '…',
	                truncationHTML:     options.truncationHTML
	            },
	
	            sty = element.style,
	            originalText = element.innerHTML,
	
	            supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	            clampValue = opt.clamp,
	            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	            truncationHTMLContainer;
	            
	        if (opt.truncationHTML) {
	            truncationHTMLContainer = document.createElement('span');
	            truncationHTMLContainer.innerHTML = opt.truncationHTML;
	        }
	
	
	// UTILITY FUNCTIONS __________________________________________________________
	
	        /**
	         * Return the current style for an element.
	         * @param {HTMLElement} elem The element to compute.
	         * @param {string} prop The style property.
	         * @returns {number}
	         */
	        function computeStyle(elem, prop) {
	            if (!win.getComputedStyle) {
	                win.getComputedStyle = function(el, pseudo) {
	                    this.el = el;
	                    this.getPropertyValue = function(prop) {
	                        var re = /(\-([a-z]){1})/g;
	                        if (prop == 'float') prop = 'styleFloat';
	                        if (re.test(prop)) {
	                            prop = prop.replace(re, function () {
	                                return arguments[2].toUpperCase();
	                            });
	                        }
	                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	                    }
	                    return this;
	                }
	            }
	
	            return win.getComputedStyle(elem, null).getPropertyValue(prop);
	        }
	
	        /**
	         * Returns the maximum number of lines of text that should be rendered based
	         * on the current height of the element and the line-height of the text.
	         */
	        function getMaxLines(height) {
	            var availHeight = height || element.clientHeight,
	                lineHeight = getLineHeight(element);
	
	            return Math.max(Math.floor(availHeight/lineHeight), 0);
	        }
	
	        /**
	         * Returns the maximum height a given element should have based on the line-
	         * height of the text and the given clamp value.
	         */
	        function getMaxHeight(clmp) {
	            var lineHeight = getLineHeight(element);
	            return lineHeight * clmp;
	        }
	
	        /**
	         * Returns the line-height of an element as an integer.
	         */
	        function getLineHeight(elem) {
	            var lh = computeStyle(elem, 'line-height');
	            if (lh == 'normal') {
	                // Normal line heights vary from browser to browser. The spec recommends
	                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
	            }
	            return parseInt(lh);
	        }
	
	
	// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	        var splitOnChars = opt.splitOnChars.slice(0),
	            splitChar = splitOnChars[0],
	            chunks,
	            lastChunk;
	        
	        /**
	         * Gets an element's last child. That may be another node or a node's contents.
	         */
	        function getLastChild(elem) {
	            //Current element has children, need to go deeper and get last child as a text node
	            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	                return getLastChild(Array.prototype.slice.call(elem.children).pop());
	            }
	            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
	            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
	                elem.lastChild.parentNode.removeChild(elem.lastChild);
	                return getLastChild(element);
	            }
	            //This is the last child we want, return it
	            else {
	                return elem.lastChild;
	            }
	        }
	        
	        /**
	         * Removes one character at a time from the text until its width or
	         * height is beneath the passed-in max param.
	         */
	        function truncate(target, maxHeight) {
	            if (!maxHeight) {return;}
	            
	            /**
	             * Resets global variables.
	             */
	            function reset() {
	                splitOnChars = opt.splitOnChars.slice(0);
	                splitChar = splitOnChars[0];
	                chunks = null;
	                lastChunk = null;
	            }
	            
	            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	            
	            //Grab the next chunks
	            if (!chunks) {
	                //If there are more characters to try, grab the next one
	                if (splitOnChars.length > 0) {
	                    splitChar = splitOnChars.shift();
	                }
	                //No characters to chunk by. Go character-by-character
	                else {
	                    splitChar = '';
	                }
	                
	                chunks = nodeValue.split(splitChar);
	            }
	            
	            //If there are chunks left to remove, remove the last one and see if
	            // the nodeValue fits.
	            if (chunks.length > 1) {
	                // console.log('chunks', chunks);
	                lastChunk = chunks.pop();
	                // console.log('lastChunk', lastChunk);
	                applyEllipsis(target, chunks.join(splitChar));
	            }
	            //No more chunks can be removed using this character
	            else {
	                chunks = null;
	            }
	            
	            //Insert the custom HTML before the truncation character
	            if (truncationHTMLContainer) {
	                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	            }
	
	            //Search produced valid chunks
	            if (chunks) {
	                //It fits
	                if (element.clientHeight <= maxHeight) {
	                    //There's still more characters to try splitting on, not quite done yet
	                    if (splitOnChars.length >= 0 && splitChar != '') {
	                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	                        chunks = null;
	                    }
	                    //Finished!
	                    else {
	                        return element.innerHTML;
	                    }
	                }
	            }
	            //No valid chunks produced
	            else {
	                //No valid chunks even when splitting by letter, time to move
	                //on to the next node
	                if (splitChar == '') {
	                    applyEllipsis(target, '');
	                    target = getLastChild(element);
	                    
	                    reset();
	                }
	            }
	            
	            //If you get here it means still too big, let's keep truncating
	            if (opt.animate) {
	                setTimeout(function() {
	                    truncate(target, maxHeight);
	                }, opt.animate === true ? 10 : opt.animate);
	            }
	            else {
	                return truncate(target, maxHeight);
	            }
	        }
	        
	        function applyEllipsis(elem, str) {
	            elem.nodeValue = str + opt.truncationChar;
	        }
	
	
	// CONSTRUCTOR ________________________________________________________________
	
	        if (clampValue == 'auto') {
	            clampValue = getMaxLines();
	        }
	        else if (isCSSValue) {
	            clampValue = getMaxLines(parseInt(clampValue));
	        }
	
	        var clampedText;
	        if (supportsNativeClamp && opt.useNativeClamp) {
	            sty.overflow = 'hidden';
	            sty.textOverflow = 'ellipsis';
	            sty.webkitBoxOrient = 'vertical';
	            sty.display = '-webkit-box';
	            sty.webkitLineClamp = clampValue;
	
	            if (isCSSValue) {
	                sty.height = opt.clamp + 'px';
	            }
	        }
	        else {
	            var height = getMaxHeight(clampValue);
	            if (height <= element.clientHeight) {
	                clampedText = truncate(getLastChild(element), height);
	            }
	        }
	        
	        return {
	            'original': originalText,
	            'clamped': clampedText
	        }
	    }
	
	    window.$clamp = clamp;
	})();

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(610), __webpack_require__(611)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, DateUtil) {
	    return ['$filter', 'TranslateService', function factory($filter, TranslateService) {
	        var now = DateUtil.currentDate();
	        var currentYear = now.getFullYear();
	
	        var populateDropDownValues = function populateDropDownValues(scope) {
	            scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
	
	            scope.months = [{ value: 0, _name: 'January' }, { value: 1, _name: 'February' }, { value: 2, _name: 'March' }, { value: 3, _name: 'April' }, { value: 4, _name: 'May' }, { value: 5, _name: 'June' }, { value: 6, _name: 'July' }, { value: 7, _name: 'August' }, { value: 8, _name: 'September' }, { value: 9, _name: 'October' }, { value: 10, _name: 'November' }, { value: 11, _name: 'December' }];
	
	            scope.months.forEach(function (month) {
	                TranslateService.translate({
	                    object: month,
	                    propName: 'name',
	                    displayKey: 'platform.inputs.DateDropDownDirective.' + month._name,
	                    scope: scope
	                });
	            });
	
	            var oldestYear = currentYear - (parseInt(scope.minYearsFromNow, 10) || 100);
	            var futurestYear = currentYear + (scope.maxYearsFromNow || 50);
	            var futureOnly = angular.isDefined(scope.futureOnly) ? scope.futureOnly : false;
	            var yrIdx = currentYear;
	
	            scope.years = [];
	            if (futureOnly) {
	                if (angular.isDefined(scope.startFromOffset)) {
	                    yrIdx = yrIdx + parseInt(scope.startFromOffset, 10);
	                }
	                for (; yrIdx < futurestYear; yrIdx++) {
	                    scope.years.push(yrIdx);
	                }
	            } else {
	                if (angular.isDefined(scope.startFromOffset)) {
	                    yrIdx = yrIdx - parseInt(scope.startFromOffset, 10);
	                }
	                for (; yrIdx > oldestYear; yrIdx--) {
	                    scope.years.push(yrIdx);
	                }
	            }
	        };
	
	        return {
	            restrict: 'A',
	            replace: true,
	            require: 'ngModel',
	            scope: true,
	            template: templateStr,
	
	            link: function link(scope, element, attrs, ctrl) {
	                var ngModelCtrl = ctrl;
	
	                scope.startFromOffset = attrs.startFromOffset;
	                scope.minYearsFromNow = attrs.minYearsFromNow;
	                scope.maxYearsFromNow = attrs.maxYearsFromNow;
	                scope.showDays = attrs.showDays === 'true';
	                scope.futureOnly = attrs.futureOnly === 'false' ? undefined : true;
	                scope.disableFields = attrs.disabled;
	                scope.placeholderDate = {};
	
	                populateDropDownValues(scope);
	
	                scope.dateFields = {};
	                if (ngModelCtrl.$modelValue) {
	                    scope.dateFields.day = new Date(ngModelCtrl.$modelValue).getDate();
	                    scope.dateFields.month = new Date(ngModelCtrl.$modelValue).getMonth();
	                    scope.dateFields.year = new Date(ngModelCtrl.$modelValue).getFullYear();
	                    if (scope.futureOnly) {
	                        ngModelCtrl.$modelValue.setHours(23, 59, 59, 0);
	                    }
	                } else {
	                    scope.placeholderDate = angular.copy(now);
	                    if (scope.futureOnly) {
	                        //if future only then set date to be the last day of the month
	                        var lastDateOfThisMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
	                        scope.placeholderDate.setDate(lastDateOfThisMonth);
	                        scope.placeholderDate.setFullYear(scope.placeholderDate.getFullYear() + (angular.isDefined(scope.startFromOffset) ? parseInt(scope.startFromOffset, 10) : 0));
	                    } else {
	                        //set to first day of month
	                        scope.placeholderDate.setDate(1);
	                        scope.placeholderDate.setMonth(0);
	                        scope.placeholderDate.setFullYear(scope.placeholderDate.getFullYear() - (angular.isDefined(scope.startFromOffset) ? parseInt(scope.startFromOffset, 10) : 0));
	                    }
	                }
	
	                scope.$watch(attrs.ngModel, function (newValue) {
	                    if (newValue) {
	                        scope.dateFields.day = new Date(newValue).getDate();
	                        scope.dateFields.month = new Date(newValue).getMonth();
	                        scope.dateFields.year = new Date(newValue).getFullYear();
	                    } else {
	                        scope.dateFields.day = undefined;
	                        scope.dateFields.month = undefined;
	                        scope.dateFields.year = undefined;
	                    }
	                });
	
	                attrs.$observe('disabled', function (isDisabled) {
	                    scope.disableFields = isDisabled;
	                });
	
	                scope.updateModel = function () {
	                    if (scope.dateFields.year === null || scope.dateFields.month === null || scope.dateFields.day === null) {
	                        ngModelCtrl.$setViewValue(null);
	                    } else {
	                        ngModelCtrl.$setViewValue(new Date(angular.isDefined(scope.dateFields.year) ? scope.dateFields.year : scope.placeholderDate.getFullYear(), angular.isDefined(scope.dateFields.month) ? scope.dateFields.month : scope.placeholderDate.getMonth(), angular.isDefined(scope.dateFields.day) ? scope.dateFields.day : scope.placeholderDate.getDate(),
	                        //Set the appropriate time based on future date or not - otherwise the validators will fail to work
	                        scope.futureOnly ? 23 : 0, scope.futureOnly ? 59 : 0, scope.futureOnly ? 59 : 0, 0));
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = "<div style=\"display:inline\">\n    <select class=\"gw-input-mini\"\n            ng-show=\"showDays\"\n            name=\"dateFieldsDay\"\n            ng-model=\"dateFields.day\"\n            ng-options=\"day for day in days\"\n            ng-change=\"updateModel('dateFieldsDay')\"\n            ng-disabled=\"disableFields\">\n        <option value=\"\">-</option>\n    </select>\n    <select class=\"gw-input-medium\"\n            name=\"dateFieldsMonth\"\n            ng-model=\"dateFields.month\"\n            ng-options=\"month.value as month.name for month in months\"\n            ng-change=\"updateModel('dateFieldsMonth')\"\n            ng-disabled=\"disableFields\">\n        <option value=\"\">-</option>\n    </select>\n    <select class=\"gw-input-small\"\n            name=\"dateFieldsYear\"\n            ng-model=\"dateFields.year\"\n            ng-options=\"year for year in years\"\n            ng-change=\"updateModel('dateFieldsYear')\"\n            ng-disabled=\"disableFields\">\n        <option value=\"\">-</option>\n    </select>\n</div>\n"

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Module that returns the current date. Can be replaced with
	     * another implementation, for example if you needed to time travel and return
	     * a different current date
	     */
	    return {
	        currentDate: function currentDate() {
	            return new Date();
	        },
	        getYear: function getYear(date) {
	            return date ? date.getFullYear() : null;
	        },
	
	        /**
	         * Returns new date object with time portion set to zero
	         * Original date parameter is not modified
	         * @param date Initial date. Tis object is not modified
	         * @returns {Date}
	         */
	        trimToMidnight: function trimToMidnight(date) {
	            var returnedDate = new Date(date);
	            returnedDate.setHours(0, 0, 0, 0);
	            return returnedDate;
	        },
	
	        getHour: function getHour(date) {
	            return date.getHours();
	        },
	
	        /**
	         * Increments date by x number of hours
	         *
	         * @param date Initial date. Tis object is not modified
	         * @param hrsToAdd (Integer} number of hours to add
	         * @returns {Date} new date object incremented by 4 hours
	         */
	        addHours: function addHours(date, hrsToAdd) {
	            date.setHours(date.getHours() + hrsToAdd);
	            return date;
	        },
	
	        /**
	         * Returns the current time with minutes, seconds and milliseconds set to zero
	         * @returns {*}
	         */
	        getCurrentTimeTrimmedToHour: function getCurrentTimeTrimmedToHour() {
	            var time = this.currentDate();
	            time.setMinutes(0, 0, 0);
	            return time;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(613)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'EA',
	            transclude: true,
	            replace: true,
	            template: templateStr,
	            scope: {
	                type: '@',
	                close: '&'
	            },
	            link: function link(scope, element, attrs) {
	                scope.closeable = 'close' in attrs;
	
	                scope.icon = function () {
	                    switch (scope.type) {
	                        case 'error':
	                            return 'fa fa-minus-circle';
	                        case 'warning':
	                            return 'fa fa-exclamation-triangle';
	                        case 'info':
	                            return 'fa fa-info-circle';
	                        default:
	                            /* don't display an icon if unknown type provided */
	                            return null;
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-alert\" ng-class=\"['gw-alert-' + (type || 'info'), gw-closeable ? 'gw-alert-dismissable' : null]\">\n    <i class=\"gw-alert-icon\" ng-class=\"icon()\"></i>\n    <button ng-show=\"closeable\" type=\"button\" class=\"gw-close\" ng-click=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n"

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(615)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    var controlId = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                titleLeft: '@',
	                titleRight: '@',
	                valueLeft: '=',
	                valueRight: '=',
	                model: '='
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.controlId = 'binaryinputctrlx' + controlId++;
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-controls-radios\">\n    <div gw-pl-radios-binary\n         title1=\"{{titleLeft}}\"\n         title2=\"{{titleRight}}\"\n    >\n        <input type=\"radio\"\n               id=\"{{controlId}}Left\"\n               ng-model=\"model.value\"\n               data-ng-value=\"valueLeft\"\n        />\n        <input type=\"radio\"\n               id=\"{{controlId}}Right\"\n               ng-model=\"model.value\"\n               data-ng-value=\"valueRight\"\n        />\n    </div>\n</div>\n"

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(617), __webpack_require__(618)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, defaultModeTemplate, japanModeTemplate) {
	    return ['LocaleService', function (LocaleService) {
	        var defaultHiddenFields = ['Prefix', 'Particle'];
	        var nameConfig = LocaleService.getNameConfig();
	
	        return {
	            restrict: 'A',
	            template: nameConfig.mode === 'Japan' ? japanModeTemplate : defaultModeTemplate,
	            scope: {
	                contact: '=', //if this val is changed in view then it changes in the model
	                readonly: '=', //if this val is changed in view it DOES NOT change in the model
	                filterNameDetailCodes: '='
	            },
	
	            link: function link(scope) {
	
	                //console.log("filterNameDetailCodes: ",scope.filterNameDetailCodes);
	
	                // Default filter codes for 
	                scope.prefixFilterCodes = scope.filterNameDetailCodes && scope.filterNameDetailCodes.prefix ? scope.filterNameDetailCodes.prefix : [];
	                scope.suffixFilterCodes = scope.filterNameDetailCodes && scope.filterNameDetailCodes.suffix ? scope.filterNameDetailCodes.suffix : [];
	
	                scope.hiddenFields = defaultHiddenFields;
	                scope.isFieldVisible = function (fieldName) {
	                    var visible = nameConfig.visibleFields.indexOf(fieldName) >= 0;
	                    var hidden = scope.hiddenFields.indexOf(fieldName) >= 0;
	                    return visible && !hidden;
	                };
	            }
	
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 617 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div gw-pl-input-ctrl ng-if=\"isFieldVisible('Prefix')\" filter-codes=\"prefixFilterCodes\" readonly=\"readonly\" model=\"contact.prefix\"\n         label=\"{{'platform.inputs.contact-details.Prefix' | translate }}\"></div>\n    <div gw-pl-input-ctrl ng-if=\"isFieldVisible('FirstName')\" readonly=\"readonly\" model=\"contact.firstName\" ng-attr-maxlength=\"30\"\n         label=\"{{'platform.inputs.contact-details.First Name' | translate }}\"></div>\n    <div gw-pl-input-ctrl ng-if=\"isFieldVisible('MiddleName')\" readonly=\"readonly\" model=\"contact.middleName\" ng-attr-maxlength=\"1\"\n         label=\"{{'platform.inputs.contact-details.Middle Initial' | translate }}\"></div>\n    <div gw-pl-input-ctrl ng-if=\"isFieldVisible('LastName')\" readonly=\"readonly\" model=\"contact.lastName\" ng-attr-maxlength=\"50\"\n         label=\"{{'platform.inputs.contact-details.Last Name' | translate }}\"></div>\n    <div gw-pl-input-ctrl ng-if=\"isFieldVisible('Suffix')\" filter-codes=\"suffixFilterCodes\" readonly=\"readonly\" model=\"contact.suffix\"\n         label=\"{{'platform.inputs.contact-details.Suffix' | translate }}\"></div>\n</div>\n"

/***/ },
/* 618 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <gw-pl-input-ctrl readonly=\"readonly\" model=\"contact.lastName\"\n                      label=\"{{'platform.inputs.contact-details.Last Name' | translate }}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl readonly=\"readonly\" model=\"contact.firstName\"\n                      label=\"{{'platform.inputs.contact-details.First Name' | translate }}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl readonly=\"readonly\" model=\"contact.lastNameKanji\"\n                      label=\"{{'platform.inputs.contact-details.Last Name Kanji' | translate }}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl readonly=\"readonly\" model=\"contact.firstNameKanji\"\n                      label=\"{{'platform.inputs.contact-details.First Name Kanji' | translate }}\"></gw-pl-input-ctrl>\n</div>\n"

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(620)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'AE',
	            template: templateStr,
	            scope: {
	                model: '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 620 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-binary-choice model=\"model\" label=\"{{label}}\"\n     title-left=\"{{'platform.inputs.Yes' | translate}}\"\n     title-right=\"{{'platform.inputs.No' | translate}}\"\n     value-left=\"true\"\n     value-right=\"false\">\n</div>"

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(622)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'AE',
	            template: templateStr,
	            scope: {
	                label: '@',
	                model: '=',
	                helpTip: '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 622 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-binary-choice-group model=\"model\" label=\"{{label}}\"\n     title-left=\"{{'platform.inputs.Yes' | translate}}\"\n     title-right=\"{{'platform.inputs.No' | translate}}\"\n     value-left=\"true\"\n     value-right=\"false\"\n     help-tip=\"{{helpTip}}\">\n</div>"

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(624)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    /** Base stepper directive. This one is responsible for displaying a current value and for displaying
	     * "previous" and "next" buttons.
	     */
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	
	            scope: {
	                'displayValue': '=',
	                'havePrevValue': '=',
	                'haveNextValue': '=',
	
	                'selectPrevValue': '&',
	                'selectNextValue': '&'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 624 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-stepper\">\n    <div class=\"gw-stepper-btn gw-minus\"\n         ng-class=\"{'gw-disabled':!havePrevValue}\"\n         ng-click=\"selectPrevValue()\"\n    >\n        <span class=\"gw-icon fa fa-minus\"></span>\n    </div>\n\n    <div class=\"gw-value\">\n        <input type=\"text\" ng-model=\"displayValue\" type=\"text\" disabled/>\n    </div>\n\n    <div class=\"gw-stepper-btn gw-plus\"\n         ng-class=\"{'gw-disabled':!haveNextValue}\"\n         ng-click=\"selectNextValue()\"\n    >\n        <span class=\"gw-icon fa fa-plus\"></span>\n    </div>\n</div>"

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(626)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    /** Creates an element accessor. Returns undefined if fnOrProp do not define a valid accessor. */
	    function accessor(fnOrProp) {
	        if (_.isFunction(fnOrProp)) {
	            return fnOrProp;
	        }
	        if (_.isString(fnOrProp)) {
	            return _.property(fnOrProp);
	        }
	
	        return undefined;
	    }
	
	    function toString(obj) {
	        return _.isNull(obj) || _.isUndefined(obj) ? '' : obj.toString();
	    }
	
	    /**
	     * Stepper-based selection for the predefined list of values.
	     * This one is strictly MVC-based. It ultimately respects a model value and have hooks for renderers, setters and
	     * option value accessor.
	     */
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	
	            scope: {
	                'model': '=gwPlStepperSelect',
	                'options': '=',
	
	                'selectBy': '=',
	                'optionValue': '=',
	                'renderBy': '='
	            },
	
	            controller: ['$scope', function ($scope) {
	                var valueAccessor = accessor($scope.optionValue) || _.identity;
	                var renderer = accessor($scope.renderBy) || toString;
	
	                $scope.$watch('optionValue', function () {
	                    valueAccessor = accessor($scope.optionValue) || _.identity;
	                });
	                $scope.$watch('renderBy', function () {
	                    renderer = accessor($scope.renderBy) || toString;
	                });
	
	                function selectedIndex() {
	                    return _.findIndex($scope.options, function (mv) {
	                        return valueAccessor(mv) === $scope.model;
	                    });
	                }
	
	                function couldGoPrev() {
	                    return $scope.options.length > 0 && $scope.model !== valueAccessor($scope.options[0]);
	                }
	
	                function couldGoNext() {
	                    var l = $scope.options.length;
	                    return l > 0 && $scope.model !== valueAccessor($scope.options[l - 1]);
	                }
	
	                function selectAt(idx) {
	                    if (idx < 0 || idx >= $scope.options.length) {
	                        return;
	                    }
	                    var modelValue = valueAccessor($scope.options[idx]);
	                    if ($scope.selectBy) {
	                        $scope.selectBy(modelValue);
	                    } else {
	                        $scope.model = modelValue;
	                    }
	                }
	
	                $scope.couldGoPrev = couldGoPrev;
	                $scope.couldGoNext = couldGoNext;
	                $scope.displayValue = function () {
	                    var selIdx = selectedIndex();
	                    return selIdx < 0 ? '' : renderer($scope.options[selIdx]);
	                };
	                $scope.goBack = function () {
	                    var idx = selectedIndex();
	                    if (idx < 0) {
	                        idx = $scope.options.length - 1;
	                    } else {
	                        idx -= 1;
	                    }
	                    selectAt(idx);
	                };
	                $scope.goForward = function () {
	                    var idx = selectedIndex();
	                    if (idx < 0) {
	                        idx = 0;
	                    } else {
	                        idx += 1;
	                    }
	                    selectAt(idx);
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 626 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-stepper-ctrl\n     display-value=\"displayValue()\"\n     have-prev-value=\"couldGoPrev()\"\n     have-next-value=\"couldGoNext()\"\n     select-prev-value=\"goBack()\"\n     select-next-value=\"goForward()\"></div>"

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(628), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, _) {
	    return ['LocaleService', function (LocaleService) {
	        return {
	            restrict: 'A',
	            scope: {
	                phone: '='
	            },
	            require: '^form',
	            template: templateStr,
	
	            link: function link(scope, element, attrs, Ctrl) {
	                scope.phoneNumberForm = Ctrl;
	                scope.phoneTypes = {
	                    home: _.find(scope.phone.primaryPhoneType.aspects.availableValues, { code: 'home' }),
	                    work: _.find(scope.phone.primaryPhoneType.aspects.availableValues, { code: 'work' }),
	                    mobile: _.find(scope.phone.primaryPhoneType.aspects.availableValues, { code: 'mobile' })
	                };
	                // Depending on the UserDefaultPhoneCountry configured in the backend, the mask
	                // required by the input fields can vary. For example, the Australian mask should
	                // look like this '(99) 9999 9999' whilst the German mask should look like this
	                // '999/999999'. Here we take a sample phone number for the server configured
	                // UserDefaultPhoneCountry. We then replace all digits with '9' so that the
	                // masking logic in UiMaskDirective can be applied.
	                scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 628 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div gw-pl-ctrl-group model=\"phone.homeNumber\" label=\"{{'platform.inputs.phone-details.Home Phone'|translate}}\">\n        <input type=\"text\"\n               ng-model=\"phone.homeNumber.value\"\n               gw-pl-ui-mask=\"{{phoneMask}}\"\n               leave-value-masked/>\n\n        <div class=\"gw-vpadded\">\n            <input type=\"radio\"\n                   id=\"HomeNumberPrimaryPhoneType\"\n                   name=\"primaryPhoneType\"\n                   ng-model=\"phone.primaryPhoneType.value\"\n                   ng-value=\"phoneTypes.home\"\n                   ng-show=\"phone.homeNumber.value\"/>\n            <label for=\"HomeNumberPrimaryPhoneType\" class=\"gw-primaryNumberIcon\">\n                <span ng-show=\"phone.primaryPhoneType.value.code == 'home'\">{{'platform.inputs.phone-details.Primary number'|translate}}</span>\n            </label>\n        </div>\n    </div>\n    <div gw-pl-ctrl-group model=\"phone.workNumber\" label=\"{{'platform.inputs.phone-details.Work Phone'|translate}}\">\n        <input type=\"text\"\n               ng-model=\"phone.workNumber.value\"\n               gw-pl-ui-mask=\"{{phoneMask}}\"\n               leave-value-masked/>\n\n        <div class=\"gw-vpadded\">\n            <input type=\"radio\"\n                   id=\"WorkNumberPrimaryPhoneType\"\n                   name=\"primaryPhoneType\"\n                   ng-model=\"phone.primaryPhoneType.value\"\n                   ng-value=\"phoneTypes.work\"\n                   ng-show=\"phone.workNumber.value\"/>\n            <label for=\"WorkNumberPrimaryPhoneType\" class=\"gw-primaryNumberIcon\">\n                <span ng-show=\"phone.primaryPhoneType.value.code == 'work'\">{{'platform.inputs.phone-details.Primary number'|translate}}</span>\n            </label>\n        </div>\n    </div>\n    <div gw-pl-ctrl-group model=\"phone.cellNumber\" label=\"{{'platform.inputs.phone-details.Cell'|translate}}\">\n        <input type=\"text\"\n               ng-model=\"phone.cellNumber.value\"\n               gw-pl-ui-mask=\"{{phoneMask}}\"\n               leave-value-masked/>\n\n        <div class=\"gw-vpadded\">\n            <input type=\"radio\"\n                   id=\"CellNumberPrimaryPhoneType\"\n                   name=\"primaryPhoneType\"\n                   ng-model=\"phone.primaryPhoneType.value\"\n                   ng-value=\"phoneTypes.mobile\"\n                   ng-show=\"phone.cellNumber.value\"/>\n            <label for=\"CellNumberPrimaryPhoneType\" class=gw-\"primaryNumberIcon\">\n                <span ng-show=\"phone.primaryPhoneType.value.code == 'mobile'\">{{'platform.inputs.phone-details.Primary number'|translate}}</span>\n            </label>\n        </div>\n    </div>\n</div>"

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(630)], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return angular.module('edge.platform.widgets.table', ['angular-table']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 630 */
/***/ function(module, exports) {

	// author:   Samuel Mueller 
	// version:  0.0.7 
	// license:  MIT 
	// homepage: http://github.com/ssmm/angular-table 
	!function(){angular.module("angular-table",[]),angular.module("angular-table").directive("atTable",["metaCollector","setupFactory",function(t,e){var i,n,r;return i=function(t,e){var i,n,r,a,o,l,u,c,g,s,f;for(l=angular.element("<tr></tr>"),u=0,g=e.length;g>u;u++){if(r=e[u],a=angular.element("<th style='cursor: pointer;'></th>"),t[r.attribute]){for(f=t[r.attribute].attributes,c=0,s=f.length;s>c;c++)i=f[c],a.attr(""+i.name,""+i.value);o=t[r.attribute].content}else o=r.title;a.html(""+o),r.sortable&&(a.attr("ng-click","predicate = '"+r.attribute+"'; descending = !descending;"),n=angular.element("<i style='margin-left: 10px;'></i>"),n.attr("ng-class","getSortIcon('"+r.attribute+"')"),a.append(n)),a.attr("width",r.width),l.append(a)}return l},r=function(t){if(t.pagination&&t.list)throw"You can not specify a list if you have specified a pagination. The list defined for the pagnination will automatically be used.";if(!t.pagination&&!t.list)throw"Either a list or pagination must be specified."},n=function(t){return t.atPagination?(t.pagination=t.atPagination,t.atPagination=null):void 0},{restrict:"AC",scope:!0,compile:function(a,o,l){var u,c,g,s,f,d;return n(o),r(o),f=a.find("thead"),s=a.find("tbody"),u=t.collectBodyDefinition(s),f[0]&&(c=t.collectCustomHeaderMarkup(f),d=f.find("tr"),d.remove(),f.append(i(c,u.tds))),g=e(o),g.compile(a,o,l),{post:function(t,e,i){return u.initialSorting&&(t.predicate=u.initialSorting.predicate,t.descending="desc"===u.initialSorting.direction),t.getSortIcon=function(e){return e!==t.predicate?"icon-minus":t.descending?"icon-chevron-down":"icon-chevron-up"},g.link(t,e,i)}}}}}]),angular.module("angular-table").directive("atImplicit",[function(){return{restrict:"AC",compile:function(t){var e;if(e=t.attr("attribute"),!e)throw"at-implicit specified without attribute: "+t.html();return t.append("{{item."+e+"}}")}}}]),angular.module("angular-table").directive("atPagination",[function(){return{replace:!0,restrict:"E",template:"      <div class='pagination' style='margin: 0px;'>        <ul>          <li ng-class='{disabled: currentPage <= 0}'>            <a href='' ng-click='goToPage(currentPage - 1)'>&laquo;</a>          </li>          <li ng-class='{active: currentPage == page}' ng-repeat='page in pages'>            <a href='' ng-click='goToPage(page)'>{{page + 1}}</a>          </li>          <li ng-class='{disabled: currentPage >= numberOfPages - 1}'>            <a href='' ng-click='goToPage(currentPage + 1); normalize()'>&raquo;</a>          </li>        </ul>      </div>",scope:{itemsPerPage:"@",instance:"=",list:"="},link:function(t){var e,i;return t.instance=t,t.currentPage=0,e=function(e){return e=Math.max(0,e),e=Math.min(t.numberOfPages-1,e)},i=function(){var e;return t.currentPage=0,t.list?t.list.length>0?(t.numberOfPages=Math.ceil(t.list.length/t.itemsPerPage),t.pages=function(){var i,n,r;for(r=[],e=i=0,n=t.numberOfPages-1;n>=0?n>=i:i>=n;e=n>=0?++i:--i)r.push(e);return r}()):(t.numberOfPages=1,t.pages=[0]):void 0},t.fromPage=function(){return t.list?t.itemsPerPage*t.currentPage-t.list.length:void 0},t.getFillerArray=function(){var e,i,n,r,a,o,l;if(t.currentPage===t.numberOfPages-1){if(i=t.list.length%t.itemsPerPage,0!==i||0===t.list.length){for(e=t.itemsPerPage-i-1,l=[],n=r=a=t.list.length,o=t.list.length+e;o>=a?o>=r:r>=o;n=o>=a?++r:--r)l.push(n);return l}return[]}},t.goToPage=function(i){return t.currentPage=e(i)},i(),t.$watch("itemsPerPage",function(){return i()}),t.$watch("list",function(){return i()})}}}]),angular.module("angular-table").service("metaCollector",[function(){var t,e,i,n;return t=function(t){return t?t.charAt(0).toUpperCase()+t.slice(1):""},e=function(t){var e;return e=/([0-9]+px)/i.exec(t),e?e[0]:""},n=function(t){var e;return e=/(sortable)/i.exec(t),e?!0:!1},i=function(t){var e;if(e=t.attr("initial-sorting")){if("asc"===e||"desc"===e)return e;throw"Invalid value for initial-sorting: "+e+". Allowed values are 'asc' or 'desc'."}return void 0},{collectCustomHeaderMarkup:function(t){var e,i,n,r,a,o,l;for(i={},r=t.find("tr"),l=r.find("th"),a=0,o=l.length;o>a;a++)n=l[a],n=angular.element(n),e=i[n.attr("attribute")]={},e.content=n.html(),e.attributes=n[0].attributes;return i},collectBodyDefinition:function(r){var a,o,l,u,c,g,s,f,d,p;for(o={},o.tds=[],o.initialSorting=void 0,p=r.find("td"),f=0,d=p.length;d>f;f++)if(c=p[f],c=angular.element(c),a=c.attr("attribute"),g=c.attr("title")||t(c.attr("attribute")),u=c[0].attributes.sortable||n(c.attr("class")),s=e(c.attr("class")),o.tds.push({attribute:a,title:g,sortable:u,width:s}),l=i(c)){if(!a)throw"initial-sorting specified without attribute.";o.initialSorting={},o.initialSorting.direction=l,o.initialSorting.predicate=a}return o}}}]),angular.module("angular-table").factory("setupFactory",[function(){var t,e,i,n,r;return n="| orderBy:predicate:descending",i="| limitTo:fromPage() | limitTo:toPage()",r=function(t,e){var i,n;return i=t.find("tbody"),n=i.find("tr"),n.attr("ng-repeat",e),i},e=function(t){var e;e="item in "+t.list+" "+n,this.compile=function(t){return r(t,e)},this.link=function(){}},t=function(t){var e,a,o;if(o=t.sortContext||"global",e=t.pagination,"global"===o)a="item in "+e+".list "+n+" "+i;else{if("page"!==o)throw"Invalid sort-context: "+o+".";a="item in "+e+".list "+i+" "+n+" "}this.compile=function(t,i){var n,o,l,u,c,g,s;if(o=r(t,a),"undefined"!=typeof i.fillLastPage){for(c=t.find("td"),u="",g=0,s=c.length;s>g;g++)l=c[g],u+="<td>&nbsp;</td>";return n=angular.element("<tr>"+u+"</tr>"),n.attr("ng-repeat","item in "+e+".getFillerArray() "),o.append(n)}},this.link=function(t){return t.fromPage=function(){return t[e]?t[e].fromPage():void 0},t.toPage=function(){return t[e]?t[e].itemsPerPage:void 0}}},function(i){return i.list?new e(i):i.pagination?new t(i):void 0}}])}.call(this);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(632), __webpack_require__(634), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BankAccountDetailsDirective, CreditCardDetailsDirective) {
	    return angular.module('edge.platform.paymentdetails', []).directive('gwPlBankAccountDetails', BankAccountDetailsDirective).directive('gwPlCreditCardDetails', CreditCardDetailsDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(633)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	
	            scope: {
	                bankAccountDetails: '=gwPlBankAccountDetails'
	            },
	
	            controller: ['$scope', function (scope) {
	                scope.bankAccountDetails.value = scope.bankAccountDetails.value || {};
	                scope.accTypes = scope.bankAccountDetails.bankAccountType.aspects.availableValues;
	                scope.bankAccountDetails.bankAccountType.value = scope.bankAccountDetails.bankAccountType.value || scope.accTypes[0];
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 633 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-binary-choice-group model=\"bankAccountDetails.bankAccountType\"\n     label=\"{{'platform.paymentdetails.bank-account-details.Account Type'|translate}}\"\n     title-left=\"{{accTypes[0].name}}\"\n     title-right=\"{{accTypes[1].name}}\"\n     value-left=\"accTypes[0]\"\n     value-right=\"accTypes[1]\">\n</div>\n\n<div gw-pl-input-ctrl label=\"{{'platform.paymentdetails.bank-account-details.Account Number'|translate}}\"\n     model=\"bankAccountDetails.bankAccountNumber\">\n</div>\n<div gw-pl-input-ctrl label=\"{{'platform.paymentdetails.bank-account-details.Routing (ABA) Number'|translate}}\"\n     model=\"bankAccountDetails.bankABANumber\">\n</div>\n<div gw-pl-input-ctrl label=\"{{'platform.paymentdetails.bank-account-details.Bank Name'|translate}}\"\n     model=\"bankAccountDetails.bankName\">\n</div>\n"

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(635), __webpack_require__(636)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CreditCardUtil, templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	
	            scope: {
	                creditCardDetails: '=gwPlCreditCardDetails'
	            },
	
	            controller: ['$scope', function (scope) {
	                scope.creditCardDetails.value = scope.creditCardDetails.value || {};
	                scope.issuers = scope.creditCardDetails.creditCardIssuer.aspects.availableValues;
	                scope.creditCardDetails.creditCardIssuer.value = scope.creditCardDetails.creditCardIssuer.value || scope.issuers[0];
	
	                scope.cardMask = {};
	
	                //watcher to update the input mask on the card number field depending on issuer.
	                scope.$watch('creditCardDetails.creditCardIssuer.value', function () {
	                    var newValue = scope.creditCardDetails.creditCardIssuer.value;
	                    if (!newValue) {
	                        return;
	                    }
	
	                    var newMask = CreditCardUtil.getInputValidatorForIssuerCode(newValue.code);
	                    scope.cardMask = newMask;
	
	                    var maskLength = newMask.replace(/-/g, '').length; //Get the length of the string of digits unformatted
	                    var cardNumberValue = scope.creditCardDetails.creditCardNumber.value;
	                    if (cardNumberValue && cardNumberValue.length > maskLength) {
	                        scope.creditCardDetails.creditCardNumber.value = cardNumberValue.substring(0, maskLength); //Truncate if the previous value is too big
	                    }
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var creditCardMasks = {
	        'amex': { 'input': '9999-999999-99999', 'mask': '####-######-99999' },
	        'dinersclub': { 'input': '9999-999999-9999', 'mask': '####-######-9999' },
	        'discover': { 'input': '9999-9999-9999-9999', 'mask': '####-####-####-9999' },
	        'mastercard': { 'input': '9999-9999-9999-9999', 'mask': '####-####-####-9999' },
	        'visa': { 'input': '9999-9999-9999-9999', 'mask': '####-####-####-9999' }
	    };
	
	    return {
	        getInputValidatorForIssuerCode: function getInputValidatorForIssuerCode(code) {
	            return creditCardMasks[code].input;
	        },
	
	        getInputMaskForIssuerCode: function getInputMaskForIssuerCode(code) {
	            return creditCardMasks[code].mask;
	        },
	
	        getInputLength: function getInputLength(code) {
	            return creditCardMasks[code].input.replace(/-/g, '').length;
	        },
	
	        getMaskedValue: function getMaskedValue(number, issuer) {
	            var mask = creditCardMasks[issuer].mask;
	
	            var valueMasked = '';
	
	            if (number.length && number.length === mask.replace(/-/g, '').length) {
	                var numberPosition = 0;
	                angular.forEach(mask.split(''), function (chr, i) {
	                    if (mask[i] === '#') {
	                        valueMasked += '#';
	                        numberPosition++;
	                    } else if (mask[i] === '-') {
	                        valueMasked += '-';
	                    } else {
	                        valueMasked += number[numberPosition];
	                        numberPosition++;
	                    }
	                });
	            }
	
	            return valueMasked;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div gw-pl-input-ctrl label=\"{{'platform.paymentdetails.credit-card-auto-details.Card Issuer'|translate}}\"\n         model=\"creditCardDetails.creditCardIssuer\"></div>\n    <div gw-pl-ctrl-group label=\"{{'platform.paymentdetails.credit-card-auto-details.Credit card number'|translate}}\"\n         model=\"creditCardDetails.creditCardNumber\">\n        <input type=\"text\" gw-pl-ui-mask=\"{{cardMask}}\" ng-model=\"creditCardDetails.creditCardNumber.value\"/>\n    </div>\n    <div gw-pl-ctrl-group label=\"{{'platform.paymentdetails.credit-card-auto-details.Expiration Date'|translate}}\"\n         model=\"creditCardDetails.creditCardExpDate\">\n        <span gw-pl-date-drop-down future-only=true maxYearsFromNow=\"10\" show-days=\"false\"\n              ng-model=\"creditCardDetails.creditCardExpDate.value\"></span>\n    </div>\n</div>"

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(638), __webpack_require__(639), __webpack_require__(574), __webpack_require__(641), __webpack_require__(334),
	// datetimepicker library tries to require() for angular inside (a bug)
	// it cases errors in case Webpack doesn't parse this file
	__webpack_require__(642)], __WEBPACK_AMD_DEFINE_RESULT__ = function (datepickerDecorator, datetimepicker) {
	    return angular.module('edge.platform.widgets.ui.bootstrap.datetimepicker', ['edge.platform.widgets.dropdown', 'ui.bootstrap.datetimepicker']).config(datepickerDecorator).directive('ngDatepicker', datetimepicker);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/** http://dalelotts.github.io/angular-bootstrap-datetimepicker/
	 * decorator
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(334), __webpack_require__(611)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, DateUtil) {
	    function getValidDateOrNull(dateParam) {
	        var date = void 0;
	        if (typeof dateParam === 'undefined') {
	            date = null;
	        } else {
	            date = new Date(dateParam);
	            // check if date object is invalid;
	            if (isNaN(date.getTime())) {
	                date = null;
	            }
	        }
	        return date;
	    }
	
	    return ['$provide', 'dateTimePickerConfig', function ($provide, dateTimePickerConfig) {
	        $provide.decorator('datetimepickerDirective', ['$delegate', '$timeout', function ($delegate, $timeout) {
	            var directive = $delegate[0];
	
	            /*----- INTERNAL DATEPICKER'S METHODS START -----*/
	            function DateObject() {
	                var tempDate = DateUtil.currentDate();
	                var localOffset = tempDate.getTimezoneOffset() * 60000;
	                this.utcDateValue = tempDate.getTime();
	                this.selectable = true;
	
	                this.localDateValue = function () {
	                    return this.utcDateValue + localOffset;
	                };
	
	                var validProperties = ['utcDateValue', 'localDateValue', 'display', 'active', 'selectable', 'past', 'future'];
	
	                for (var prop in arguments[0]) {
	                    /* istanbul ignore else */
	                    //noinspection JSUnfilteredForInLoop
	                    if (validProperties.indexOf(prop) >= 0) {
	                        //noinspection JSUnfilteredForInLoop
	                        this[prop] = arguments[0][prop];
	                    }
	                }
	            }
	
	            var getUTCTime = function getUTCTime(modelValue) {
	                var tempDate = modelValue ? moment(modelValue).toDate() : DateUtil.currentDate();
	                return tempDate.getTime() - tempDate.getTimezoneOffset() * 60000;
	            };
	            /*----- INTERNAL DATEPICKER'S METHODS END -----*/
	
	            directive.compile = function () {
	                return function (scope, element, attrs, ngModelController) {
	                    directive.link.apply(this, arguments);
	                    var parentScope = scope.$parent;
	
	                    // support the default date
	                    function updateDefaultDate(newDate, oldDate) {
	                        if (oldDate !== newDate) {
	                            if (angular.isDate(newDate)) {
	                                $timeout(function () {
	                                    scope.changeView(parentScope.startView, new DateObject({
	                                        utcDateValue: newDate.getTime()
	                                    }));
	                                });
	                            }
	                        }
	                    }
	
	                    updateDefaultDate(parentScope.defaultDate);
	                    parentScope.$watch('defaultDate', updateDefaultDate);
	
	                    // add support for max-date and min-date to the picker
	                    scope.beforeRender = function (picker) {
	                        var dates = picker.$dates;
	                        var view = picker.$view; // hour, day, month or year
	                        var maxDate = getValidDateOrNull(parentScope.maxDate);
	                        var minDate = getValidDateOrNull(parentScope.minDate);
	                        // extend range for each view
	                        if (maxDate) {
	                            maxDate = moment(maxDate).endOf(view).valueOf();
	                        }
	                        if (minDate) {
	                            minDate = moment(minDate).startOf(view).valueOf();
	                        }
	                        // make items outside of the range not selectable
	                        dates.forEach(function (dateObject) {
	                            var date = dateObject.utcDateValue;
	                            var isGreaterThanMaxDate = maxDate && date > maxDate;
	                            var isLesserThanMinDate = minDate && date < minDate;
	                            if (isGreaterThanMaxDate || isLesserThanMinDate) {
	                                dateObject.selectable = false;
	                            }
	                        });
	                    };
	                    scope.$root.$on('$translateChangeSuccess', function () {
	                        // RESET VIEW TO BE UPDATED WITH THE NEW LOCALE
	                        scope.changeView(dateTimePickerConfig.startView, new DateObject({ utcDateValue: getUTCTime(ngModelController.$viewValue) }));
	                    });
	                };
	            };
	
	            return $delegate;
	        }]);
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(640), __webpack_require__(334)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, moment) {
	    // @const
	    var ESC_KEY = 27;
	
	    // @const
	    var ENTER_KEY = 13;
	
	    var _uniqueId = 1;
	
	    /**
	     * Provides filter value for date view
	     * DATE | date:dateFormat
	     *
	     * @param minView {string}
	     * @returns {string}
	     */
	    function getDateFormat(minView) {
	        var validViews = ['minute', 'hour', 'day', 'month', 'year'];
	        if (validViews.indexOf(minView) === -1) {
	            throw new Error('Minimal view has invalid value: ' + minView);
	        }
	
	        switch (minView) {
	            case 'day':
	                return 'shortDate';
	            default:
	                return 'short';
	        }
	    }
	
	    /**
	     * A map for date format normalization.
	     * Those format parts that are
	     * in the list, the format should not occur in short and shortDate
	     * formats
	     */
	    var dateFormatPartsMap = {
	        yyyy: 'yyyy',
	        yy: 'yyyy',
	        y: 'yyyy',
	        MMMM: 'MM',
	        MMM: 'MM',
	        MM: 'MM',
	        M: 'MM',
	        dd: 'dd',
	        d: 'dd',
	        HH: 'HH',
	        H: 'HH',
	        hh: 'hh',
	        h: 'hh',
	        mm: 'mm',
	        m: 'mm',
	        a: 'a'
	    };
	
	    var formattingTokens = /(yyyy|yy?|M{1,4}|dd?|HH?|hh?|mm?|a|.)/g;
	
	    /**
	     *  @class TransormedFormatInfo
	     *
	     *  @property {String} format A new format with padded parts
	     *  @property {String} placeholder A placeholder for a new format
	     *  @property {Array.<String>}  parts An array of matched parts
	     *  @property {String} am AM localization stored in placeholder
	     */
	
	    /**
	     *  Takes an Angular.js date format and transforms it to analogous format with
	     *  padded values
	     *  @param {String} format Angular.js date format
	     *  @param {Object} locale
	     *  @returns {TransormedFormatInfo} new format and placehoder
	     */
	    function transformDateFormat(format, locale) {
	        var AM = locale.DATETIME_FORMATS.AMPMS[0];
	        format = locale.DATETIME_FORMATS[format];
	        return format.match(formattingTokens).map(function (part) {
	            var matchedPart = dateFormatPartsMap[part];
	            var res = void 0;
	            if (matchedPart) {
	                res = {
	                    // add the part to the format string
	                    part: matchedPart,
	                    // will be AM, else, leave the part intact
	                    placeholder: matchedPart !== 'a' ? matchedPart.toLowerCase() : AM
	                };
	            } else {
	                // leave all other text as is
	                res = part;
	            }
	            return res;
	        }).reduce(function (acc, val) {
	            // combine the format with padded parts
	            // along with combining created mask and placeholder
	            // to strings
	            var part = void 0;
	            var placeholder = void 0;
	            if (typeof val !== 'string') {
	                if (val.part === 'a') {
	                    acc.am = val.placeholder;
	                }
	                part = val.part;
	                placeholder = val.placeholder;
	                acc.parts.push(part);
	            } else {
	                // if val was not a part of the pattern,
	                // just add it up to all the properties
	                part = val;
	                placeholder = val;
	            }
	            acc.format += part;
	            acc.placeholder += placeholder;
	            return acc;
	        }, /* initial object */{
	            format: '',
	            placeholder: '',
	            parts: [],
	            am: null
	        });
	    }
	
	    /**
	     *  Groups some format-related information in one place.
	     *  @class FormatInfo
	     *
	     *  @property {String} format A new format with padded parts
	     *  @property {String} placeholder A placeholder for a new format
	     *  @property {Array.<String>}  parts An array of matched parts
	     *  @property {String} am AM localization stored in placeholder
	     */
	    function FormatInfo(minView) {
	        this._formatName = getDateFormat(minView);
	    }
	
	    /**
	     * Calculate format-related information based on the locale
	     * and add related info to instance
	     * @param locale
	     */
	    FormatInfo.prototype.updateLocale = function (locale) {
	        var transormedFormatInfo = transformDateFormat(this._formatName, locale);
	        this.dateFormat = transormedFormatInfo.format;
	        this.parts = transormedFormatInfo.parts;
	        this.am = transormedFormatInfo.am;
	        this.placeholder = transormedFormatInfo.placeholder;
	    };
	
	    /**
	     * Parses a date with padded format parts
	     *
	     * @param {String} format
	     * @param {String} date
	     * @returns {Date}
	     */
	    function parseDate(format, date) {
	        // will reuse moment's robust parser
	        // convert angular format to moment's format
	        format = format.replace(/yyyy/, 'YYYY').replace(/dd/, 'DD');
	        var d = moment(date, format);
	        return d.isValid() ? d.toDate() : null;
	    }
	
	    return ['$locale', '$filter', function ($locale, $filter) {
	        // LocaleService is loaded to set a correct locale even when only Datepicker is only present on a page (e.g. Live Style Guide)
	        return {
	            restrict: 'EA',
	            template: templateStr,
	            require: ['ngModel'],
	            scope: {
	                disabled: '=',
	                maxDate: '=',
	                minDate: '=',
	                defaultDate: '=',
	                open: '=',
	                onSetTime: '&',
	                ngModel: '='
	            },
	
	            compile: function compile(element, attrs) {
	                // INPUT ATTRIBUTES
	                var input = element.find('input:text');
	
	                if (attrs.inputId) {
	                    input.attr('id', attrs.inputId);
	                }
	                if (attrs.inputName) {
	                    input.attr('name', attrs.inputName);
	                }
	
	                return {
	                    pre: function pre($scope, _element, _attrs, ctrls) {
	                        var dropdownToggle = _element.find('.gw-dropdown-toggle');
	                        var datetimepickerWrapper = _element.find('.datetimepicker-wrapper');
	                        $(document).on('keydown', onKeydown);
	
	                        function onKeydown(evt) {
	                            if (evt.keyCode === ESC_KEY) {
	                                toggleDropdown();
	                            }
	                        }
	
	                        function toggleDropdown() {
	                            dropdownToggle.click();
	                        }
	
	                        /**
	                         * Uses jQuery to find whether a dropdown is open,
	                         * since the current implementation of
	                         * dropdown doesn't provide a sufficient API
	                         */
	                        function dropdownIsOpen() {
	                            return datetimepickerWrapper.hasClass('open');
	                        }
	
	                        $scope.open = dropdownIsOpen();
	                        $scope.$watch('open', function (newVal, oldVal) {
	                            if (newVal !== oldVal) {
	                                if (newVal && !dropdownIsOpen() || !newVal && dropdownIsOpen()) {
	                                    toggleDropdown();
	                                }
	                                $scope.open = newVal;
	                            }
	                        });
	
	                        var ngModelCtrl = ctrls[0];
	                        $scope.keydown = onKeydown;
	                        $scope.uniqueId = 'datepicker' + _uniqueId++; // needed for linking to dropdown
	                        $scope.minView = _attrs.minView || 'hour';
	
	                        // handle input's  placeholder and create
	                        // a new date format with padded values from locale
	                        $scope.fmt = new FormatInfo($scope.minView, $locale);
	                        $scope.fmt.updateLocale($locale);
	
	                        // handle direct user input
	                        var rawVal = '';
	                        Object.defineProperty($scope, 'inputVal', {
	                            get: function get() {
	                                if ($scope.ngModel && !rawVal.length) {
	                                    return $filter('date')($scope.ngModel, $scope.fmt.dateFormat);
	                                }
	                                return rawVal;
	                            },
	                            set: function set(val) {
	                                if (val === '') {
	                                    rawVal = '';
	                                    $scope.ngModel = null;
	                                    return;
	                                }
	                                if ($scope.fmt.placeholder.length - 2 === val.length && val.indexOf("/") === -1 || $scope.fmt.placeholder.length === val.length) {
	                                    var d = parseDate($scope.fmt.dateFormat, val);
	                                    if (d) {
	                                        rawVal = '';
	                                        $scope.ngModel = d;
	                                        return;
	                                    }
	                                }
	                                $scope.ngModel = null;
	                                rawVal = val;
	                            }
	                        });
	
	                        $scope.$root.$on('$localeChangeSuccess', function () /*event, data*/{
	                            $scope.fmt.updateLocale($locale);
	                        });
	
	                        $scope.$watch('ngModel', function (newVal, oldVal) {
	                            if (oldVal !== newVal) {
	                                ngModelCtrl.$setDirty();
	                                if (angular.isDate(newVal)) {
	                                    rawVal = '';
	                                }
	                            }
	                        });
	
	                        // prevents user from closing a dropdown
	                        // when he clicks multiple times on input
	                        // if he editing the date
	                        var _input = _element.find('input');
	                        $scope.focus = false;
	                        _input.on('focus', function () {
	                            $scope.$apply(function () {
	                                $scope.focus = 'focus';
	                            });
	                        });
	                        _input.on('blur', function () {
	                            $scope.$apply(function () {
	                                $scope.focus = false;
	                            });
	                        });
	
	                        // if user pressed enter key
	                        // try to commit date that he added
	                        // if is not a valid date,
	                        // just close the dropdown
	                        _input.on('keypress', function (evt) {
	                            if (evt.keyCode === ENTER_KEY) {
	                                evt.stopPropagation();
	                                evt.preventDefault();
	                                $(undefined).blur();
	                                toggleDropdown();
	                                var d = parseDate($scope.fmt.dateFormat, $(undefined).val());
	                                if (d) {
	                                    rawVal = '';
	                                    $scope.ngModel = d;
	                                }
	                            }
	                        });
	
	                        $scope.uniqueId = 'datepicker' + _uniqueId++; // needed for linking to dropdown
	                        $scope.startView = _attrs.startView || 'day';
	
	                        $scope.$watch('disabled', function (oldVal, newVal) {
	                            if (oldVal === newVal) {
	                                return;
	                            }
	                            if (!!newVal) {
	                                // disable datetimepicker
	                                $('#' + $scope.uniqueId).dropdown('toggle'); // close datetimepicker
	                            }
	                        });
	
	                        $scope._onSetTime = function (newValue) {
	                            ngModelCtrl.$setViewValue(newValue);
	                            $scope.onSetTime();
	                        };
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 640 */
/***/ function(module, exports) {

	module.exports = "<div class=\"datetimepicker-wrapper\" tab-index=\"1\">\n    <div class=\"gw-dropdown-toggle\" data-toggle=\"dropdown\" id=\"{{::uniqueId}}\">\n        <input type=\"text\" class=\"gw-form-control\"\n               placeholder=\"{{fmt.placeholder}}\"\n               ng-model=\"inputVal\">\n        <i class=\"datetimepicker-icon fa fa-calendar\"></i>\n    </div>\n    <div ng-show=\"disabled\" class=\"gw-disabled-layer\"></div>\n    <div class=\"datetimepicker-dropdown gw-dropdown-menu\" ng-class=\"gw-focus\">\n        <datetimepicker\n                on-set-time=\"_onSetTime(newDate)\"\n                data-ng-model=\"ngModel\"\n                data-datetimepicker-config=\"{ dropdownSelector: '#{{::uniqueId}}', minView:'{{::minView}}', startView: '{{::startView}}' }\"/>\n    </div>\n</div>\n"

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(333)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	    /**
	     * Part of Dropdown functionality from Angular Bootstrap Framework
	     * which is needed for datepicker plugin
	     */
	
	    /* ========================================================================
	     * Bootstrap: dropdown.js v3.3.4
	     * http://getbootstrap.com/javascript/#dropdowns
	     * ========================================================================
	     * Copyright 2011-2015 Twitter, Inc.
	     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	     * ======================================================================== */
	
	    // DROPDOWN CLASS DEFINITION
	    // =========================
	
	    var backdrop = '.dropdown-backdrop';
	    var toggle = '[data-toggle="dropdown"]';
	    var Dropdown = function Dropdown(element) {
	        $(element).on('click.bs.dropdown', this.toggle);
	    };
	
	    Dropdown.VERSION = '3.3.4';
	    Dropdown.prototype.toggle = function (e) {
	        var $this = $(this);
	
	        if (!e) {
	            // FOR OLD BOOTSTRAP VERSION ON CALLING TOGGLE DIRECTLY-
	            // JUST TRIGGER PARENT CLICK
	            $this.parent().trigger('click');
	        }
	    };
	
	    function clearMenus(e) {
	        if (e && e.which === 3) {
	            return;
	        }
	        $(backdrop).remove();
	        $(toggle).each(function () {
	            var $this = $(this);
	            var $parent = getParent($this);
	            var relatedTarget = { relatedTarget: this };
	
	            if (!$parent.hasClass('open')) {
	                return;
	            }
	
	            $parent.trigger(e = new $.Event('hide.bs.dropdown', relatedTarget));
	
	            if (e.isDefaultPrevented()) {
	                return;
	            }
	
	            $this.attr('aria-expanded', 'false');
	            $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget);
	        });
	    }
	
	    function getParent($this) {
	        var selector = $this.attr('data-target');
	
	        if (!selector) {
	            selector = $this.attr('href');
	            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	        }
	
	        var $parent = selector && $(selector);
	
	        return $parent && $parent.length ? $parent : $this.parent();
	    }
	
	    // DROPDOWN PLUGIN DEFINITION
	    // ==========================
	
	    function Plugin(option) {
	        return this.each(function () {
	            var $this = $(this);
	            var data = $this.data('bs.dropdown');
	
	            if (!data) {
	                $this.data('bs.dropdown', data = new Dropdown(this));
	            }
	            if (typeof option === 'string') {
	                data[option].call($this);
	            }
	        });
	    }
	
	    var old = $.fn.dropdown;
	
	    $.fn.dropdown = Plugin;
	    $.fn.dropdown.Constructor = Dropdown;
	
	    // DROPDOWN NO CONFLICT
	    // ====================
	
	    $.fn.dropdown.noConflict = function () {
	        $.fn.dropdown = old;
	        return this;
	    };
	
	    // APPLY TO STANDARD DROPDOWN ELEMENTS
	    // ===================================
	
	    $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	        e.stopPropagation();
	    }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 642 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var require = function(arg){return window[arg];};
	
	/*globals define, jQuery, module, require */
	/*jslint vars:true */
	
	/**
	 * @license angular-bootstrap-datetimepicker  version: 0.3.12
	 * (c) 2013-2014 Knight Rider Consulting, Inc. http://www.knightrider.com
	 * License: MIT
	 */
	
	/**
	 *
	 *    @author        Dale "Ducky" Lotts
	 *    @since        2013-Jul-8
	 */
	
	(function (factory) {
	  'use strict';
	  /* istanbul ignore if */
	  if (typeof define === 'function' && /* istanbul ignore next */ define.amd) {
	    define(['angular', 'moment'], factory); // AMD
	    /* istanbul ignore next */
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('angular'), require('moment')); // CommonJS
	  } else {
	    factory(window.angular, window.moment); // Browser global
	  }
	}(function (angular, moment) {
	  'use strict';
	  angular.module('ui.bootstrap.datetimepicker', [])
	    .constant('dateTimePickerConfig', {
	      dropdownSelector: null,
	      minuteStep: 5,
	      minView: 'minute',
	      startView: 'year'
	    })
	    .directive('datetimepicker', ['$log', 'dateTimePickerConfig', function datetimepickerDirective($log, defaultConfig) {
	
	      function DateObject() {
	
	        var tempDate = new Date();
	        var localOffset = tempDate.getTimezoneOffset() * 60000;
	        this.utcDateValue = tempDate.getTime();
	        this.selectable = true;
	
	        this.localDateValue = function () {
	          return this.utcDateValue + localOffset;
	        };
	
	        var validProperties = ['utcDateValue', 'localDateValue', 'display', 'active', 'selectable', 'past', 'future'];
	
	        for (var prop in arguments[0]) {
	          /* istanbul ignore else */
	          //noinspection JSUnfilteredForInLoop
	          if (validProperties.indexOf(prop) >= 0) {
	            //noinspection JSUnfilteredForInLoop
	            this[prop] = arguments[0][prop];
	          }
	        }
	      }
	
	      var validateConfiguration = function validateConfiguration(configuration) {
	        var validOptions = ['startView', 'minView', 'minuteStep', 'dropdownSelector'];
	
	        for (var prop in configuration) {
	          //noinspection JSUnfilteredForInLoop
	          if (validOptions.indexOf(prop) < 0) {
	            throw ('invalid option: ' + prop);
	          }
	        }
	
	        // Order of the elements in the validViews array is significant.
	        var validViews = ['minute', 'hour', 'day', 'month', 'year'];
	
	        if (validViews.indexOf(configuration.startView) < 0) {
	          throw ('invalid startView value: ' + configuration.startView);
	        }
	
	        if (validViews.indexOf(configuration.minView) < 0) {
	          throw ('invalid minView value: ' + configuration.minView);
	        }
	
	        if (validViews.indexOf(configuration.minView) > validViews.indexOf(configuration.startView)) {
	          throw ('startView must be greater than minView');
	        }
	
	        if (!angular.isNumber(configuration.minuteStep)) {
	          throw ('minuteStep must be numeric');
	        }
	        if (configuration.minuteStep <= 0 || configuration.minuteStep >= 60) {
	          throw ('minuteStep must be greater than zero and less than 60');
	        }
	        if (configuration.dropdownSelector !== null && !angular.isString(configuration.dropdownSelector)) {
	          throw ('dropdownSelector must be a string');
	        }
	
	        /* istanbul ignore next */
	        if (configuration.dropdownSelector !== null && ((typeof jQuery === 'undefined') || (typeof jQuery().dropdown !== 'function'))) {
	          $log.error('Please DO NOT specify the dropdownSelector option unless you are using jQuery AND Bootstrap.js. ' +
	          'Please include jQuery AND Bootstrap.js, or write code to close the dropdown in the on-set-time callback. \n\n' +
	          'The dropdownSelector configuration option is being removed because it will not function properly.');
	          delete configuration.dropdownSelector;
	        }
	      };
	
	      return {
	        restrict: 'E',
	        require: 'ngModel',
	        template: '<div class="datetimepicker table-responsive">' +
	        '<table class="table table-striped  {{ data.currentView }}-view">' +
	        '   <thead>' +
	        '       <tr>' +
	        '           <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"/></th>' +
	        '           <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>' +
	        '           <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"/></th>' +
	        '       </tr>' +
	        '       <tr>' +
	        '           <th class="dow" data-ng-repeat="day in data.dayNames" >{{ day }}</th>' +
	        '       </tr>' +
	        '   </thead>' +
	        '   <tbody>' +
	        '       <tr data-ng-if="data.currentView !== \'day\'" >' +
	        '           <td colspan="7" >' +
	        '              <span    class="{{ data.currentView }}" ' +
	        '                       data-ng-repeat="dateObject in data.dates"  ' +
	        '                       data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" ' +
	        '                       data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span> ' +
	        '           </td>' +
	        '       </tr>' +
	        '       <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">' +
	        '           <td data-ng-repeat="dateObject in week.dates" ' +
	        '               data-ng-click="changeView(data.nextView, dateObject, $event)"' +
	        '               class="day" ' +
	        '               data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" >{{ dateObject.display }}</td>' +
	        '       </tr>' +
	        '   </tbody>' +
	        '</table></div>',
	        scope: {
	          onSetTime: '&',
	          beforeRender: '&'
	        },
	        replace: true,
	        link: function link(scope, element, attrs, ngModelController) {
	
	          var directiveConfig = {};
	
	          if (attrs.datetimepickerConfig) {
	            directiveConfig = scope.$parent.$eval(attrs.datetimepickerConfig);
	          }
	
	          var configuration = {};
	
	          angular.extend(configuration, defaultConfig, directiveConfig);
	
	          validateConfiguration(configuration);
	
	          var startOfDecade = function startOfDecade(unixDate) {
	            var startYear = (parseInt(moment.utc(unixDate).year() / 10, 10) * 10);
	            return moment.utc(unixDate).year(startYear).startOf('year');
	          };
	
	          var dataFactory = {
	            year: function year(unixDate) {
	              var selectedDate = moment.utc(unixDate).startOf('year');
	              // View starts one year before the decade starts and ends one year after the decade ends
	              // i.e. passing in a date of 1/1/2013 will give a range of 2009 to 2020
	              // Truncate the last digit from the current year and subtract 1 to get the start of the decade
	              var startDecade = (parseInt(selectedDate.year() / 10, 10) * 10);
	              var startDate = moment.utc(startOfDecade(unixDate)).subtract(1, 'year').startOf('year');
	
	              var activeYear = ngModelController.$modelValue ? moment(ngModelController.$modelValue).year() : 0;
	
	              var result = {
	                'currentView': 'year',
	                'nextView': configuration.minView === 'year' ? 'setTime' : 'month',
	                'previousViewDate': new DateObject({
	                  utcDateValue: null,
	                  display: startDecade + '-' + (startDecade + 9)
	                }),
	                'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(9, 'year').valueOf()}),
	                'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(11, 'year').valueOf()}),
	                'dates': []
	              };
	
	              for (var i = 0; i < 12; i += 1) {
	                var yearMoment = moment.utc(startDate).add(i, 'years');
	                var dateValue = {
	                  'utcDateValue': yearMoment.valueOf(),
	                  'display': yearMoment.format('YYYY'),
	                  'past': yearMoment.year() < startDecade,
	                  'future': yearMoment.year() > startDecade + 9,
	                  'active': yearMoment.year() === activeYear
	                };
	
	                result.dates.push(new DateObject(dateValue));
	              }
	
	              return result;
	            },
	
	            month: function month(unixDate) {
	
	              var startDate = moment.utc(unixDate).startOf('year');
	              var previousViewDate = startOfDecade(unixDate);
	              var activeDate = ngModelController.$modelValue ? moment(ngModelController.$modelValue).format('YYYY-MMM') : 0;
	
	              var result = {
	                'previousView': 'year',
	                'currentView': 'month',
	                'nextView': configuration.minView === 'month' ? 'setTime' : 'day',
	                'previousViewDate': new DateObject({
	                  utcDateValue: previousViewDate.valueOf(),
	                  display: startDate.format('YYYY')
	                }),
	                'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(1, 'year').valueOf()}),
	                'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(1, 'year').valueOf()}),
	                'dates': []
	              };
	
	              for (var i = 0; i < 12; i += 1) {
	                var monthMoment = moment.utc(startDate).add(i, 'months');
	                var dateValue = {
	                  'utcDateValue': monthMoment.valueOf(),
	                  'display': monthMoment.format('MMM'),
	                  'active': monthMoment.format('YYYY-MMM') === activeDate
	                };
	
	                result.dates.push(new DateObject(dateValue));
	              }
	
	              return result;
	            },
	
	            day: function day(unixDate) {
	
	              var selectedDate = moment.utc(unixDate);
	              var startOfMonth = moment.utc(selectedDate).startOf('month');
	              var previousViewDate = moment.utc(selectedDate).startOf('year');
	              var endOfMonth = moment.utc(selectedDate).endOf('month');
	
	              var startDate = moment.utc(startOfMonth).subtract(Math.abs(startOfMonth.weekday()), 'days');
	
	              var activeDate = ngModelController.$modelValue ? moment(ngModelController.$modelValue).format('YYYY-MMM-DD') : '';
	
	              var result = {
	                'previousView': 'month',
	                'currentView': 'day',
	                'nextView': configuration.minView === 'day' ? 'setTime' : 'hour',
	                'previousViewDate': new DateObject({
	                  utcDateValue: previousViewDate.valueOf(),
	                  display: startOfMonth.format('YYYY-MMM')
	                }),
	                'leftDate': new DateObject({utcDateValue: moment.utc(startOfMonth).subtract(1, 'months').valueOf()}),
	                'rightDate': new DateObject({utcDateValue: moment.utc(startOfMonth).add(1, 'months').valueOf()}),
	                'dayNames': [],
	                'weeks': []
	              };
	
	
	              for (var dayNumber = 0; dayNumber < 7; dayNumber += 1) {
	                result.dayNames.push(moment.utc().weekday(dayNumber).format('dd'));
	              }
	
	              for (var i = 0; i < 6; i += 1) {
	                var week = {dates: []};
	                for (var j = 0; j < 7; j += 1) {
	                  var monthMoment = moment.utc(startDate).add((i * 7) + j, 'days');
	                  var dateValue = {
	                    'utcDateValue': monthMoment.valueOf(),
	                    'display': monthMoment.format('D'),
	                    'active': monthMoment.format('YYYY-MMM-DD') === activeDate,
	                    'past': monthMoment.isBefore(startOfMonth),
	                    'future': monthMoment.isAfter(endOfMonth)
	                  };
	                  week.dates.push(new DateObject(dateValue));
	                }
	                result.weeks.push(week);
	              }
	
	              return result;
	            },
	
	            hour: function hour(unixDate) {
	              var selectedDate = moment.utc(unixDate).startOf('day');
	              var previousViewDate = moment.utc(selectedDate).startOf('month');
	
	              var activeFormat = ngModelController.$modelValue ? moment(ngModelController.$modelValue).format('YYYY-MM-DD H') : '';
	
	              var result = {
	                'previousView': 'day',
	                'currentView': 'hour',
	                'nextView': configuration.minView === 'hour' ? 'setTime' : 'minute',
	                'previousViewDate': new DateObject({
	                  utcDateValue: previousViewDate.valueOf(),
	                  display: selectedDate.format('ll')
	                }),
	                'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'days').valueOf()}),
	                'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'days').valueOf()}),
	                'dates': []
	              };
	
	              for (var i = 0; i < 24; i += 1) {
	                var hourMoment = moment.utc(selectedDate).add(i, 'hours');
	                var dateValue = {
	                  'utcDateValue': hourMoment.valueOf(),
	                  'display': hourMoment.format('LT'),
	                  'active': hourMoment.format('YYYY-MM-DD H') === activeFormat
	                };
	
	                result.dates.push(new DateObject(dateValue));
	              }
	
	              return result;
	            },
	
	            minute: function minute(unixDate) {
	              var selectedDate = moment.utc(unixDate).startOf('hour');
	              var previousViewDate = moment.utc(selectedDate).startOf('day');
	              var activeFormat = ngModelController.$modelValue ? moment(ngModelController.$modelValue).format('YYYY-MM-DD H:mm') : '';
	
	              var result = {
	                'previousView': 'hour',
	                'currentView': 'minute',
	                'nextView': 'setTime',
	                'previousViewDate': new DateObject({
	                  utcDateValue: previousViewDate.valueOf(),
	                  display: selectedDate.format('lll')
	                }),
	                'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'hours').valueOf()}),
	                'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'hours').valueOf()}),
	                'dates': []
	              };
	
	              var limit = 60 / configuration.minuteStep;
	
	              for (var i = 0; i < limit; i += 1) {
	                var hourMoment = moment.utc(selectedDate).add(i * configuration.minuteStep, 'minute');
	                var dateValue = {
	                  'utcDateValue': hourMoment.valueOf(),
	                  'display': hourMoment.format('LT'),
	                  'active': hourMoment.format('YYYY-MM-DD H:mm') === activeFormat
	                };
	
	                result.dates.push(new DateObject(dateValue));
	              }
	
	              return result;
	            },
	
	            setTime: function setTime(unixDate) {
	              var tempDate = new Date(unixDate);
	              var newDate = new Date(tempDate.getTime() + (tempDate.getTimezoneOffset() * 60000));
	
	              var oldDate = ngModelController.$modelValue;
	              ngModelController.$setViewValue(newDate);
	
	              if (configuration.dropdownSelector) {
	                jQuery(configuration.dropdownSelector).dropdown('toggle');
	              }
	
	              scope.onSetTime({newDate: newDate, oldDate: oldDate});
	
	              return dataFactory[configuration.startView](unixDate);
	            }
	          };
	
	          var getUTCTime = function getUTCTime(modelValue) {
	            var tempDate = (modelValue ? moment(modelValue).toDate() : new Date());
	            return tempDate.getTime() - (tempDate.getTimezoneOffset() * 60000);
	          };
	
	          scope.changeView = function changeView(viewName, dateObject, event) {
	            if (event) {
	              event.stopPropagation();
	              event.preventDefault();
	            }
	
	            if (viewName && (dateObject.utcDateValue > -Infinity) && dateObject.selectable && dataFactory[viewName]) {
	              var result = dataFactory[viewName](dateObject.utcDateValue);
	
	              var weekDates = [];
	              if (result.weeks) {
	                for (var i = 0; i < result.weeks.length; i += 1) {
	                  var week = result.weeks[i];
	                  for (var j = 0; j < week.dates.length; j += 1) {
	                    var weekDate = week.dates[j];
	                    weekDates.push(weekDate);
	                  }
	                }
	              }
	
	              scope.beforeRender({
	                $view: result.currentView,
	                $dates: result.dates || weekDates,
	                $leftDate: result.leftDate,
	                $upDate: result.previousViewDate,
	                $rightDate: result.rightDate
	              });
	
	              scope.data = result;
	            }
	          };
	
	          ngModelController.$render = function $render() {
	            scope.changeView(configuration.startView, new DateObject({utcDateValue: getUTCTime(ngModelController.$viewValue)}));
	          };
	        }
	      };
	    }]);
	}));
	


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(644), __webpack_require__(646), __webpack_require__(648), __webpack_require__(649), __webpack_require__(651), __webpack_require__(652), __webpack_require__(654)], __WEBPACK_AMD_DEFINE_RESULT__ = function (accordion, accordionGroup, accordionHeading, accordionChevron, accordionTransclude) {
	    return angular.module('edge.platform.widgets.ui.bootstrap.accordion', ['edge.platform.widgets.ui.bootstrap.transition', 'edge.platform.widgets.ui.bootstrap.collapse']).constant('gwPlAccordionConfig', {
	        closeOthers: true
	    }).directive('gwPlAccordion', accordion).directive('gwPlAccordionGroup', accordionGroup).directive('gwPlAccordionHeading', accordionHeading).directive('gwPlAccordionChevron', accordionChevron).directive('gwPlAccordionTransclude', accordionTransclude).controller('GwPlAccordionController', ['$scope', '$attrs', 'gwPlAccordionConfig', function ($scope, $attrs, gwPlAccordionConfig) {
	        // This array keeps track of the accordion groups
	        this.groups = [];
	
	        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	        this.closeOthers = function (openGroup) {
	            var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : gwPlAccordionConfig.closeOthers;
	            if (closeOthers) {
	                angular.forEach(this.groups, function (group) {
	                    if (group !== openGroup) {
	                        group.isOpen = false;
	                    }
	                });
	            }
	        };
	
	        // This is called from the gw-pl-accordion-group directive to add itself to the accordion
	        this.addGroup = function (groupScope) {
	            var that = this;
	            this.groups.push(groupScope);
	
	            groupScope.$on('$destroy', function () {
	                that.removeGroup(groupScope);
	            });
	        };
	
	        // This is called from the gw-pl-accordion-group directive when to remove itself
	        this.removeGroup = function (group) {
	            var index = this.groups.indexOf(group);
	            if (index !== -1) {
	                this.groups.splice(index, 1);
	            }
	        };
	    }]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(645)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'EA',
	            controller: 'GwPlAccordionController',
	            transclude: true,
	            replace: false,
	            template: templateStr,
	            scope: {
	                'flavour': '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-panel-group\" ng-transclude></div>"

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// The gw-pl-accordion-group directive indicates a block of html that will expand and collapse in an accordion
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(647)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            require: '^gwPlAccordion', // We need this directive to be inside an accordion
	            restrict: 'EA',
	            transclude: true, // It transcludes the contents of the directive into the template
	            replace: true, // The element containing the directive will be replaced with the template
	            template: templateStr,
	            scope: {
	                gwPlHeading: '@', // Interpolate the heading attribute onto this scope
	                isOpen: '=?',
	                initialIsOpen: '&',
	                isDisabled: '=?',
	                validationForm: '=',
	                flavour: '@'
	            },
	            controller: function controller() {
	                var _this = this;
	
	                this.setHeading = function (element) {
	                    _this.gwPlHeading = element;
	                };
	            },
	
	            link: function link(scope, element, attrs, accordionCtrl, transcludeFn) {
	                if (typeof scope.initialIsOpen() !== 'undefined') {
	                    scope.isOpen = scope.initialIsOpen();
	                }
	
	                transcludeFn(function (clonedMarkup, childScope) {
	                    element.find('[transclude-here]').append(clonedMarkup);
	                    childScope.isAccordionOpen = function () {
	                        return scope.isOpen;
	                    };
	                });
	
	                scope.flavour = scope.flavour || 'default';
	                accordionCtrl.addGroup(scope);
	
	                scope.$watch('isOpen', function (value) {
	                    if (value) {
	                        accordionCtrl.closeOthers(scope);
	                    }
	                });
	
	                scope.toggleOpen = function () {
	                    if (!scope.isDisabled) {
	                        scope.isOpen = !scope.isOpen;
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-panel\" ng-class=\"[{'gw-is-open': isOpen}, 'gw-panel_{{flavour}}']\">\n    <div class=\"gw-panel-heading\" ng-class=\"'gw-panel-heading_{{flavour}}'\">\n        <div class=\"gw-panel-title gw-accordion-toggle\"\n             ng-class=\"[{'gw-text-muted': isDisabled}, 'gw-panel-title_{{flavour}}']\"\n             ng-click=\"toggleOpen()\"\n        >\n            <div ng-if=\"validationForm !== undefined\" class=\"gw-validation-sign\">\n                <i\n                        ng-if=\"validationForm.valid\"\n                        class=\"gw-validation-valid fa fa-check\"></i>\n                <i\n                        ng-if=\"validationForm.invalid && validationForm.submitted\"\n                        class=\"gw-validation-invalid fa fa-arrow-left\"></i>\n            </div>\n\n            <div\n                    gw-pl-accordion-transclude=\"gwPlHeading\"\n            >\n                {{gwPlHeading}}\n            </div>\n        </div>\n    </div>\n    <div class=\"gw-panel-collapse\" gw-pl-collapse=\"!isOpen\">\n        <div class=\"gw-panel-body\" transclude-here ng-class=\"'gw-panel-body_{{flavour}}'\"></div>\n    </div>\n</div>"

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// Use gw-pl-accordion-heading below an gw-pl-accordion-group to provide a heading containing HTML
	// <gw-pl-accordion-group>
	//   <gw-pl-accordion-heading>Heading containing HTML - <img src="..."></gw-pl-accordion-heading>
	// </gw-pl-accordion-group>
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return [function () {
	        return {
	            restrict: 'EA',
	            transclude: true, // Grab the contents to be used as the heading
	            template: '', // In effect remove this element!
	            replace: true,
	            require: '^gwPlAccordionGroup',
	            link: function link(scope, element, attr, accordionGroupCtrl, transclude) {
	                // Pass the gwPlHeading to the gw-pl-accordion-group controller
	                // so that it can be transcluded into the right place in the template
	                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	                accordionGroupCtrl.setHeading(transclude(scope, function () {}));
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// Use gw-pl-accordion-chevron to provide a chevron containing HTML
	//   <gw-pl-accordion-chevron is-open="isOpen"></gw-pl-accordion-chevron>
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(650)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'EA',
	            replace: true,
	            template: templateStr,
	            scope: {
	                isOpen: '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = "<span class=\"gw-accordion-chevron fa fa-chevron-right\" ng-class=\"{'gw-chevron-is-open': isOpen}\"></span>"

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	// Use in the gw-pl-accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the gw-pl-accordion-group controller that will hold the transcluded element
	// <div class="gw-pl-accordion-group">
	//   <div class="gw-pl-accordion-heading" ><a ... gw-pl-accordion-transclude="gwPlHeading">...</a></div>
	//   ...
	// </div>
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return [function () {
	        return {
	            require: '^gwPlAccordionGroup',
	            link: function link(scope, element, attr, controller) {
	                scope.$watch(function () {
	                    return controller[attr.gwPlAccordionTransclude];
	                }, function (heading) {
	                    if (heading) {
	                        element.html('');
	                        element.append(heading);
	                    }
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(653)], __WEBPACK_AMD_DEFINE_RESULT__ = function (TransitionService) {
	    return angular.module('edge.platform.widgets.ui.bootstrap.transition', []).factory('$gwPlTransition', TransitionService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * $gwPlTransition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
	     * @param  {{DOMElement}} element  The DOMElement that will be animated.
	     * @param  {string|object|function} trigger  The thing that will cause the transition to start:
	     *   - As a string, it represents the css class to be added to the element.
	     *   - As an object, it represents a hash of style attributes to be applied to the element.
	     *   - As a function, it represents a function to be called that will cause the transition to occur.
	     * @return {Promise}  A promise that is resolved when the transition finishes.
	     */
	    return ['$q', '$timeout', '$rootScope', function ($q, $timeout, $rootScope) {
	        var $gwPlTransition = function $gwPlTransition(element, trigger, options) {
	            options = options || {};
	            var deferred = $q.defer();
	            var endEventName = $gwPlTransition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];
	
	            var transitionEndHandler = function transitionEndHandler() {
	                $rootScope.$apply(function () {
	                    element.unbind(endEventName, transitionEndHandler);
	                    deferred.resolve(element);
	                });
	            };
	
	            if (endEventName) {
	                element.bind(endEventName, transitionEndHandler);
	            }
	
	            // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
	            $timeout(function () {
	                if (angular.isString(trigger)) {
	                    element.addClass(trigger);
	                } else if (angular.isFunction(trigger)) {
	                    trigger(element);
	                } else if (angular.isObject(trigger)) {
	                    element.css(trigger);
	                }
	                //If browser does not support transitions, instantly resolve
	                if (!endEventName) {
	                    deferred.resolve(element);
	                }
	            });
	
	            // Add our custom cancel function to the promise that is returned
	            // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
	            // i.e. it will therefore never raise a transitionEnd event for that transition
	            deferred.promise.cancel = function () {
	                if (endEventName) {
	                    element.unbind(endEventName, transitionEndHandler);
	                }
	                deferred.reject('Transition cancelled');
	            };
	
	            return deferred.promise;
	        };
	
	        // Work out the name of the transitionEnd event
	        var transElement = document.createElement('trans');
	        var transitionEndEventNames = {
	            'WebkitTransition': 'webkitTransitionEnd',
	            'MozTransition': 'transitionend',
	            'OTransition': 'oTransitionEnd',
	            'transition': 'transitionend'
	        };
	        var animationEndEventNames = {
	            'WebkitTransition': 'webkitAnimationEnd',
	            'MozTransition': 'animationend',
	            'OTransition': 'oAnimationEnd',
	            'transition': 'animationend'
	        };
	
	        function findEndEventName(endEventNames) {
	            for (var name in endEventNames) {
	                if (transElement.style[name] !== undefined) {
	                    return endEventNames[name];
	                }
	            }
	        }
	
	        $gwPlTransition.transitionEndEventName = findEndEventName(transitionEndEventNames);
	        $gwPlTransition.animationEndEventName = findEndEventName(animationEndEventNames);
	        return $gwPlTransition;
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(655), __webpack_require__(652)], __WEBPACK_AMD_DEFINE_RESULT__ = function (collapse) {
	    return angular.module('edge.platform.widgets.ui.bootstrap.collapse', ['edge.platform.widgets.ui.bootstrap.transition']).directive('gwPlCollapse', collapse);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$gwPlTransition', function ($gwPlTransition) {
	        return {
	            link: function link(scope, element, attrs) {
	                var initialAnimSkip = true;
	                var currentTransition = void 0;
	
	                function doTransition(change) {
	                    var newTransition = $gwPlTransition(element, change);
	                    if (currentTransition) {
	                        currentTransition.cancel();
	                    }
	                    currentTransition = newTransition;
	                    newTransition.then(newTransitionDone, newTransitionDone);
	                    return newTransition;
	
	                    function newTransitionDone() {
	                        // Make sure it's this transition, otherwise, leave it alone.
	                        if (currentTransition === newTransition) {
	                            currentTransition = undefined;
	                        }
	                    }
	                }
	
	                function expand() {
	                    if (initialAnimSkip) {
	                        initialAnimSkip = false;
	                        expandDone();
	                    } else {
	                        element.removeClass('gw-collapse').addClass('gw-collapsing');
	                        doTransition({ height: element[0].scrollHeight + 'px' }).then(expandDone);
	                    }
	                }
	
	                function expandDone() {
	                    element.removeClass('gw-collapsing');
	                    element.addClass('gw-collapse gw-in');
	                    element.css({ height: 'auto' });
	                }
	
	                function collapse() {
	                    if (initialAnimSkip) {
	                        initialAnimSkip = false;
	                        collapseDone();
	                        element.css({ height: 0 });
	                    } else {
	                        // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
	                        element.css({ height: element[0].scrollHeight + 'px' });
	                        //trigger reflow so a browser realizes that height was updated from auto to a specific value
	                        /*eslint-disable */
	                        //noinspection BadExpressionStatementJS
	                        element[0].offsetWidth;
	                        /*eslint-enable */
	
	                        element.removeClass('gw-collapse gw-in').addClass('gw-collapsing');
	
	                        doTransition({ height: 0 }).then(collapseDone);
	                    }
	                }
	
	                function collapseDone() {
	                    element.removeClass('gw-collapsing');
	                    element.addClass('gw-collapse');
	                }
	
	                scope.$watch(attrs.gwPlCollapse, function (shouldCollapse) {
	                    if (shouldCollapse) {
	                        collapse();
	                    } else {
	                        expand();
	                    }
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(657), __webpack_require__(659), __webpack_require__(660), __webpack_require__(662), __webpack_require__(663), __webpack_require__(637), __webpack_require__(664)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CtrlGroupDirective, InlineCtrlGroupDirective, InputCtrlDirective, InlineInputCtrlDirective, NgFormDecorator) {
	    return angular.module('edge.platform.widgets.basicinputs', ['edge.platform.widgets.ui.bootstrap.datetimepicker', 'edge.platform.widgets.select']).config(['$provide', function ($provide) {
	        $provide.decorator('ngFormDirective', NgFormDecorator);
	    }]).config(['$provide', function ($provide) {
	        $provide.decorator('formDirective', NgFormDecorator);
	    }]).directive('gwPlCtrlGroup', CtrlGroupDirective).directive('gwPlInlineCtrlGroup', InlineCtrlGroupDirective).directive('gwPlInputCtrl', InputCtrlDirective).directive('gwPlInlineInputCtrl', InlineInputCtrlDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(658)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    var inputId = 0;
	
	    return function () {
	        return {
	            require: ['?^form', '?^ngForm'],
	            transclude: true,
	            scope: {
	                label: '@?',
	                readonly: '=?',
	                model: '=',
	                helpTip: '@',
	                filterCodes: '='
	            },
	            template: templateStr,
	
	            controller: ['$scope', function ($scope) {
	                if (!$scope.model) {
	                    throw new Error('Input with label "' + $scope.label + '" has an undefined model scope value');
	                }
	
	                $scope.pristine = true;
	                //once a different value is set on the model then we mark the field as not pristine
	                $scope.$watch('model.value', function (newValue, oldValue) {
	                    $scope.pristine = !$scope.pristine ? false : newValue === oldValue;
	                });
	            }],
	
	            link: function link(scope, element, attrs, ctrls) {
	                var parentForm = ctrls[0];
	                var validityFn = function validityFn() {
	                    // console.log("ELEMENT PRINT ",element,"  ASPECTS = ",scope.model.aspects[0]);
	                    return scope.model.aspects.valid;
	                };
	                var setPristineFn = function setPristineFn() {
	                    //we need to use this postDigest function here because the
	                    //watch on 'model.value' in the controller gets called after
	                    //this function is called even though the model was changed first
	                    scope.$$postDigest(function () {
	                        scope.pristine = true;
	                        scope.$apply();
	                    });
	                };
	                if (parentForm) {
	                    var removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
	                    scope.$on('$destroy', removeListenerFn);
	                }
	
	                if (!('readonly' in scope) && attrs.readonly === '') {
	                    //if readonly attr exists with no value then set it to true
	                    scope.readonly = true;
	                }
	                scope.isVisible = function () {
	                    return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
	                };
	
	                scope.inputId = inputId++;
	
	                scope.showError = function () {
	                    var formHasBeenSubmitted = parentForm ? parentForm.submitted : true;
	                    if (!scope.model.aspects.valid && !scope.pristine || !scope.model.aspects.valid && formHasBeenSubmitted) {
	                        return true;
	                    }
	                };
	
	                element.on('focusin', function () {
	                    scope.focused = true;
	                    scope.$apply();
	                    //element.addClass('control-group-focused');
	                });
	                element.on('focusout', function () {
	                    scope.focused = false;
	                    scope.$apply();
	                    //element.removeClass('control-group-focused');
	                });
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{ 'gw-error': showError(), 'gw-inline-control-group': inline, 'gw-control-group': !inline, 'gw-control-group-focused' : focused }\"\n     ng-show=\"isVisible()\">\n    <label ng-class=\"{'gw-control-inline-label': inline, 'gw-control-label': !inline}\">\n        <span>{{ label }}</span>\n        <span class=\"gw-required-asterisk\" ng-show=\"model.aspects.required && !readonly\">*</span>\n\n         <span ng-if=\"helpTip\" class=\"aaa-inline-info-wrapper\">\n            <div class=\"aaa-inline-info\"><span ng-bind-html=\"helpTip\"></span></div>\n            <i class=\"fa fa-info-circle cursor-pointer\"></i>\n        </span>\n    </label>\n\n    <div ng-class=\"{'gw-inline-controls': inline, 'gw-controls': !inline}\">\n        <ng-transclude></ng-transclude>\n        <div class=\"gw-inline-messages\" ng-show=\"!readonly\">\n            <div ng-repeat=\"errorMessage in model.aspects.validationMessages track by $index\">\n                <span class=\"gw-error-inline\">{{errorMessage}}</span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(657)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CtrlGroupDirective) {
	    return function () {
	        var controlGroupDirectiveObj = new CtrlGroupDirective();
	        var origLink = controlGroupDirectiveObj.link;
	        controlGroupDirectiveObj.link = function (scope) {
	            origLink.apply(this, arguments);
	            scope.inline = true;
	        };
	
	        return controlGroupDirectiveObj;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Uses CtrlGroupDirective.js changing the template and transclude options.
	 * The new template adds the input directly based on the inputCtrlType aspect instead of having
	 * it transcluded.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(661), __webpack_require__(657), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, CtrlGroupDirective, _) {
	    return function () {
	        var controlGroupDirectiveObj = new CtrlGroupDirective();
	        controlGroupDirectiveObj.template = templateStr;
	        controlGroupDirectiveObj.transclude = false;
	        controlGroupDirectiveObj.scope.placeholder = '@?';
	
	        var origLink = controlGroupDirectiveObj.link;
	        controlGroupDirectiveObj.link = function (scope, element, attrs) {
	
	            scope.availableValues = scope.model.aspects.availableValues;
	
	            // Checking for maxlength property and add 
	            // maxlength attribute to the element
	            if (attrs.maxlength != undefined) {
	                scope.maxlength = attrs.maxlength;
	            }
	
	            // Checking for filterCodes property
	            if (scope.filterCodes != undefined) {
	
	                // Check if filterCodes is an array
	                // then remove those values from availableValues
	                if (!_.isUndefined(scope.filterCodes) && _.isArray(scope.filterCodes)) {
	
	                    scope.availableValues = _.filter(scope.availableValues, function (typeCode) {
	
	                        return scope.filterCodes.indexOf(typeCode.code) === -1;
	                    });
	                }
	            }
	
	            origLink.apply(this, arguments);
	            //The inputCtrlType aspect is created from the property metadata
	            scope.metatype = scope.model.aspects.inputCtrlType;
	        };
	        return controlGroupDirectiveObj;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{ 'gw-error': showError(), 'gw-inline-control-group': inline, 'gw-control-group': !inline, 'gw-control-group-focused' : focused }\"\n     ng-show=\"isVisible()\">\n    <label ng-class=\"{'gw-control-inline-label': inline, 'gw-control-label': !inline}\" for=\"{{inputId}}\">\n        <span>{{ label }}</span>\n        <span class=\"gw-required-asterisk\" ng-show=\"model.aspects.required && !readonly\">*</span>\n\n        <span ng-if=\"helpTip\" class=\"aaa-inline-info-wrapper\">\n            <div class=\"aaa-inline-info\">{{helpTip}}</div>\n            <i class=\"fa fa-info-circle cursor-pointer\"></i>\n        </span>\n    </label>\n\n\n\n    <div ng-class=\"{'gw-inline-controls': inline, 'gw-controls': !inline}\">\n        <div ng-if=\"readonly\">\n            <span ng-if=\"metatype === 'text' || metatype === 'tel'\">{{model.value}}</span>\n            <span ng-if=\"metatype === 'typelist'\">{{model.value.name}}</span>\n            <span ng-if=\"metatype === 'date'\">{{model.value | date: \"longDate\"}}</span>\n        </div>\n        <div ng-if=\"!readonly\">\n            <input ng-if=\"metatype === 'text' || metatype === 'tel'\" ng-attr-maxlength=\"{{maxlength}}\" type=\"{{metatype}}\" ng-model=\"model.value\"\n                   id=\"{{inputId}}\"\n                   placeholder=\"{{placeholder}}\"/>\n            <select gw-pl-select=\"model.value\" ng-if=\"metatype === 'typelist'\" id=\"{{inputId}}\"\n                    placeholder=\"{{placeholder}}\"\n                    options=\"availableValues\" render-by=\"'name'\">\n            </select>\n            <div ng-if=\"metatype === 'date'\" ng-datepicker ng-model=\"model.value\" input-id=\"{{inputId}}\"\n                 min-view=\"day\"></div>\n\n            <div class=\"gw-inline-messages\">\n                <div ng-repeat=\"errorMessage in model.aspects.validationMessages track by $index\">\n                    <span class=\"gw-error-inline\">{{errorMessage}}</span>\n                </div>\n            </div>\n\n            <gw-pl-yes-no ng-if=\"metatype === 'boolean'\"\n                          model=\"model\">\n            </gw-pl-yes-no>\n\n        </div>\n    </div>\n</div>"

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(660)], __WEBPACK_AMD_DEFINE_RESULT__ = function (InputCtrlDirective) {
	    return function () {
	        var inputCtrlDirective = new InputCtrlDirective();
	        var origLink = inputCtrlDirective.link;
	        inputCtrlDirective.link = function (scope) {
	            origLink.apply(this, arguments);
	            scope.inline = true;
	        };
	
	        return inputCtrlDirective;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Decorates the ngFormDirective so that the control group directives
	 * get passed a reference to the ngModelCtrl that is used by the input. This is
	 * needed to determine if the input is pristine.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return ['$delegate', function ($delegate) {
	        var directive = $delegate[0];
	        var origControllerCtr = directive.controller;
	
	        directive.controller = ['$scope', '$element', '$attrs', '$injector', function ($scope, $element, $attrs, $injector) {
	            var self = this;
	            this._inputModelValidationFns = [];
	            this._setPristineFns = [];
	
	            function removeListeners(validationListener, setPristineListener) {
	                var idx = self._inputModelValidationFns.indexOf(validationListener);
	                if (idx >= 0) {
	                    self._inputModelValidationFns.splice(idx, 1);
	                }
	                idx = self._setPristineFns.indexOf(setPristineListener);
	                if (idx >= 0) {
	                    self._setPristineFns.splice(idx, 1);
	                }
	            }
	
	            /**
	             * Register a control with a form so that we can mark a form
	             * as valid or pristine based on the pristine and validity values
	             * of each control.
	             *
	             * @param validtyFn : Function to get the validity value of a control
	             * @param setPristineFn : Function to mark a control as pristine
	             */
	            this.addModelControl = function (validtyFn, setPristineFn) {
	                self._inputModelValidationFns.push(validtyFn);
	                self._setPristineFns.push(setPristineFn);
	                return _.partial(removeListeners, validtyFn, setPristineFn);
	            };
	
	            /**
	             * Set all controls registered with a form to pristine
	             */
	            this.setPristine = function () {
	                self._setPristineFns.forEach(function (setCtrlToPristine) {
	                    setCtrlToPristine();
	                });
	            };
	
	            Object.defineProperty(self, 'valid', {
	                get: function get() {
	                    //   console.log("self INSIDE DECORATOR",self)
	                    return _.every(self._inputModelValidationFns, function (validFn) {
	                        return validFn();
	                    });
	                }
	            });
	            Object.defineProperty(self, 'invalid', {
	                get: function get() {
	                    return !self.valid;
	                }
	            });
	            //call the original controller with the correct DI services passed in
	            $injector.invoke(origControllerCtr, this, {
	                $scope: $scope,
	                $element: $element,
	                $attrs: $attrs
	            });
	        }];
	        return $delegate;
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(665)], __WEBPACK_AMD_DEFINE_RESULT__ = function (select) {
	    return angular.module('edge.platform.widgets.select', []).directive('gwPlSelect', select);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /* WARNING: Angular do not have a good propagation control. So this code is somewhat UGLY. Most of it should go
	     * into utilities or propagation/execution model. Until then we have what we have.
	     */
	
	    function toString(obj) {
	        return _.isNull(obj) || _.isUndefined(obj) ? '' : obj.toString();
	    }
	
	    function toBoolean(obj) {
	        return _.isNull(obj) || _.isUndefined(obj) || obj === 'false';
	    }
	
	    /** Creates an element accessor. Returns undefined if fnOrProp do not define a valid accessor. */
	    function accessor(fnOrProp) {
	        if (_.isFunction(fnOrProp)) {
	            return fnOrProp;
	        }
	        if (_.isString(fnOrProp)) {
	            return _.property(fnOrProp);
	        }
	
	        return undefined;
	    }
	
	    /** Creates a new text component.
	     * @param value initial text value.
	     */
	    function textComponent(value) {
	        var res = document.createTextNode(value);
	        return {
	            'ui': res,
	            'set': function set(newValue) {
	                if (newValue === value) {
	                    return;
	                }
	                value = newValue;
	                res.textContent = newValue;
	            }
	        };
	    }
	
	    /** Creates a new placeholder controller. */
	    function placeholderComponent(scope) {
	        var res = document.createElement('option');
	        res.setAttribute('value', '0');
	        res.setAttribute('class', toBoolean(scope.hidePlaceholderOption) ? 'hide-placeholder' : 'show-placeholder');
	
	        var text = textComponent(scope.placeholder || '');
	        res.appendChild(text.ui);
	
	        return {
	            'ui': res,
	            'getValue': function getValue() {
	                return undefined;
	            },
	            'update': function update() {
	                res.setAttribute('class', toBoolean(scope.hidePlaceholderOption) ? 'hide-placeholder' : 'show-placeholder');
	                return text.set(scope.placeholder || '');
	            }
	        };
	    }
	
	    /** Creates a new option component. */
	    function optionComponent(scope, idx, ctx) {
	        var option = scope.options[idx];
	        var value = ctx.optionValue(option);
	
	        var res = document.createElement('option');
	        res.setAttribute('value', (idx + 1).toString());
	
	        var text = textComponent(ctx.optionName(option));
	        res.appendChild(text.ui);
	
	        return {
	            'ui': res,
	            'getValue': function getValue() {
	                return value;
	            },
	            'update': function update(_ctx) {
	                option = scope.options[idx];
	                value = _ctx.optionValue(option);
	                text.set(_ctx.optionName(option));
	            }
	        };
	    }
	
	    function createContext(scope) {
	        return {
	            'optionValue': accessor(scope.optionValue) || _.identity,
	            'optionName': accessor(scope.renderBy) || toString
	        };
	    }
	
	    function selectComponent(elt, scope) {
	        var ctx = createContext(scope);
	
	        var placeholder = placeholderComponent(scope);
	        var options = scope.options.map(function (option, idx) {
	            return optionComponent(scope, idx, ctx);
	        });
	        options.unshift(placeholder);
	
	        /** Returns an index of the item. */
	        function indexOf(item) {
	            /*
	             * Additional defensive measure of "findIndex", if item is no longer present in the list of options
	             * then we return the placeholder.
	             * Note the model is the source of truth so the component will not reset the model back to undefined,
	             * this is the responsibility of the application
	             */
	            return Math.max(0, _.findIndex(options, function (opt) {
	                return opt.getValue() === item;
	            }));
	        }
	
	        function syncSelection() {
	            var selIndex = indexOf(scope.value);
	            var changed = selIndex !== elt.selectedIndex;
	            if (changed) {
	                elt.selectedIndex = selIndex;
	            }
	            return changed;
	        }
	
	        options.forEach(function (optComp) {
	            elt.appendChild(optComp.ui);
	        });
	
	        return {
	            'ui': elt,
	            'valueAt': function valueAt(idx) {
	                return options[idx].getValue();
	            },
	            syncSelection: syncSelection,
	            'update': function update() {
	                ctx = createContext(scope);
	                //model options plus placeholder
	                var optionsLength = scope.options.length + 1;
	
	                while (options.length > optionsLength) {
	                    elt.removeChild(options.pop().ui);
	                }
	                options.forEach(function (opt) {
	                    opt.update(ctx);
	                });
	                while (options.length < optionsLength) {
	                    var newOpt = optionComponent(scope, options.length - 1, ctx);
	                    options.push(newOpt);
	                    elt.appendChild(newOpt.ui);
	                }
	
	                syncSelection();
	            }
	        };
	    }
	
	    return [function () {
	        return {
	            restrict: 'A',
	            scope: {
	                /** Model (value) to select. */
	                'value': '=gwPlSelect',
	                /** List of options to select from. */
	                'options': '=',
	                /** Function to call to select an element. */
	                'selectBy': '=?',
	                /** Function or attribute name used to extract value from the option. That value would be set on the
	                 * model and would be matched with the model value.
	                 */
	                'optionValue': '=?',
	                /** Function or attribute name used for the attribute rendering. */
	                'renderBy': '=?',
	                /** Value to be displayed if nothing was selected by the user. */
	                'placeholder': '@',
	                /** Flag to hide placeholder from list of available options, may be preferred behavior for required fields */
	                'hidePlaceholderOption': '=?'
	            },
	            link: function link(scope, elt) {
	                var domElement = elt[0];
	
	                domElement.classList.add('gw-pl-select');
	                var ctrl = selectComponent(domElement, scope);
	
	                /** Update ctrl on each digest cycle. Second function is used to fulfill watch signature. */
	                scope.$watch(ctrl.update, function () {});
	
	                /** Update ctrl on each digest cycle. Second function is used to fulfill watch signature. */
	                scope.$watch(ctrl.update, function () {});
	
	                domElement.addEventListener('change', function () {
	                    var newValue = ctrl.valueAt(domElement.selectedIndex);
	                    if (scope.selectBy) {
	                        scope.selectBy(newValue);
	                    } else {
	                        scope.value = newValue;
	                    }
	                    scope.$apply();
	
	                    ctrl.syncSelection();
	                });
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(668), __webpack_require__(686), __webpack_require__(678), __webpack_require__(680), __webpack_require__(681), __webpack_require__(682), __webpack_require__(683), __webpack_require__(684), __webpack_require__(685), __webpack_require__(667), __webpack_require__(687), __webpack_require__(693), __webpack_require__(611), __webpack_require__(694), __webpack_require__(358), __webpack_require__(695), __webpack_require__(706), __webpack_require__(535)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ViewModel, Context, Requiredness, Validity, SubtreeValidity, InputCtrlType, AvailableValues, SerializedForm, RebuildVMFromData, DebugInvalidChildProperties, TypedValue, _ValidationFunctions, DateUtil, _PhoneUtil, LocalDateUtil) {
	    return angular.module('edge.platform.viewmodel.aspects', ['edge.platform.el', 'edge.platform.viewmodel']).run(['ViewModelService', 'ExpressionLanguageService', 'TranslateService', 'LocaleService', 'DateFormatter', function (ViewModelService, ExpressionLanguageService, TranslateService, LocaleService, DateFormatter) {
	        var typeValidationMessages = {};
	
	        TranslateService.translate({
	            'object': typeValidationMessages,
	            'displayKey': 'platform.modelvalidation.DTOValidationService.Please enter numbers only',
	            'propName': 'notANumber'
	        });
	        TranslateService.translate({
	            'object': typeValidationMessages,
	            'displayKey': 'platform.modelvalidation.DTOValidationService.Value entered must not contain decimal values',
	            'propName': 'notAnInteger'
	        });
	
	        ViewModelService.addAspectFactory(Context.create(ExpressionLanguageService));
	        ViewModelService.addAspectFactory(Requiredness.create(ExpressionLanguageService));
	        ViewModelService.addAspectFactory(Validity.create(ExpressionLanguageService, typeValidationMessages));
	        ViewModelService.addAspectFactory(SubtreeValidity);
	        ViewModelService.addAspectFactory(InputCtrlType);
	        ViewModelService.addAspectFactory(AvailableValues.create(ExpressionLanguageService));
	        ViewModelService.addAspectFactory(SerializedForm);
	        ViewModelService.addAspectFactory(RebuildVMFromData);
	        ViewModelService.addAspectFactory(DebugInvalidChildProperties);
	        ViewModelService.addAspectFactory(TypedValue);
	
	        ExpressionLanguageService.getCompilationContext().registerType('edge.aspects.validation.ValidationFunctions', _ValidationFunctions(LocaleService));
	        ExpressionLanguageService.getCompilationContext().registerType('edge.capabilities.locale.util.DateFormatter', DateFormatter);
	        ExpressionLanguageService.getCompilationContext().registerType('gw.api.util.DateUtil', DateUtil);
	        ExpressionLanguageService.getCompilationContext().registerType('gw.api.util.PhoneUtil', _PhoneUtil(LocaleService));
	        ExpressionLanguageService.getCompilationContext().registerType('edge.time.LocalDateUtil', LocalDateUtil);
	    }]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Aspect to help track down which properties in a model are invalid
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    function failingPropertiesReducer(currentVmNode, pathFromRoot, errorPathsArray) {
	        if (!currentVmNode || currentVmNode.aspects.subtreeValid) {
	            return errorPathsArray;
	        }
	        var valueType = currentVmNode._metadataInfo.valueType;
	        if (valueType.isPrimitive || valueType.typeInfo.metaType.isTypelist) {
	            if (!currentVmNode.aspects.valid) {
	                errorPathsArray.push(pathFromRoot);
	            }
	        } else if (valueType.isCollection) {
	            currentVmNode.children.forEach(function (vmChildNode, idx) {
	                return failingPropertiesReducer(vmChildNode, pathFromRoot + '[' + idx + ']', errorPathsArray);
	            });
	        } else if (valueType.isClass || !currentVmNode._parent) {
	            var props = currentVmNode._metadataInfo.valueType.typeInfo.properties;
	            props.forEach(function (prop) {
	                return failingPropertiesReducer(currentVmNode[prop.jsProperty], pathFromRoot + '.' + prop.jsProperty, errorPathsArray);
	            });
	        }
	        return errorPathsArray;
	    }
	
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	            if (ancestorChain.parent) {
	                //only add this aspect to the root object
	                return undefined;
	            }
	            return {
	                'invalidChildProperties': {
	                    'get': function get() {
	                        return failingPropertiesReducer(currentViewModelNode, '', []);
	                    }
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(669), __webpack_require__(673)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, _VMFactory, _Step) {
	    return {
	        /**
	         * A factory function that returns a service that is used to create view models from simple data object and back again
	         *
	         * @param insuranceSuiteMetaData {Object}: Object returned from InsuranceSuiteMetadata.createSuiteMetadata
	         *
	         * @return {Object}: exported view model functions
	         **/
	        get: function get(insuranceSuiteMetaData) {
	            var aspectFactories = [];
	
	            /**
	             * View model objects hold data and aspect properties for binding to UI components
	             * This service is responsible for creating a view model object from a plain data object and converting back to plain
	             * data for sending back to the server.
	             *
	             */
	            return {
	                /**
	                 * Add a factory function to the list of functions that are called to add aspect properties to the view model
	                 * An aspect is the term used for a set of synthetic properties that are added to a view model. OOTB example would be
	                 * a validation aspect that adds a 'validity' property to view model nodes
	                 *
	                 * @param aspectFactory {Function}: Function to create aspect properties on a view model
	                 *
	                 **/
	                addAspectFactory: function addAspectFactory(aspectFactory) {
	                    aspectFactories.push(aspectFactory);
	                },
	
	                /**
	                 * Create a new view model object based on an object containing data and a metadata type
	                 *
	                 * @param modelRoot {Object}: initial data object for view model. Error thrown if data is not an object
	                 * @param xCenter {String}: code identifying the xCenter containing the type metadata. Error thrown if there is no match for xCenter code.
	                 * @param type {String}: the name of the metadata type. Error thrown if there is no metadata found for the type
	                 * @param initialContext {Object}: Optional parameter used to provide initial context values. Any values defined
	                 * as metadata will take precedence over the values defined in this initial object.
	                 *
	                 * @return {Object}: A new view model object
	                 **/
	                create: function create(modelRoot, xCenter, type, initialContext) {
	                    var metadataNode = insuranceSuiteMetaData.get(xCenter).types.get(type);
	
	                    if (metadataNode.metaType.isTypelist) {
	                        throw new Error('View model objects can only be created from DTO types not Typelists ' + type);
	                    }
	
	                    var rootMetadataInfo = _Step.root(xCenter, metadataNode, initialContext);
	                    return _VMFactory(aspectFactories).create(modelRoot, rootMetadataInfo);
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(670), __webpack_require__(671), __webpack_require__(677), __webpack_require__(672), __webpack_require__(673)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, StringUtil, _VMListNode, _VMNode, _AncestorChainFactory, _Step) {
	    /**
	     * Return a factory to create new view model objects using registered aspects
	     *
	     * @param aspects {Array}: Aspect factory objects that have been registered with the ViewModel API
	     *
	     * @return {Object}: A factory object with a create function for creating new view model objects
	     **/
	    return function (aspects) {
	        function createRootViewModelNode(modelRoot, metadataInfo) {
	            var VMNode = _VMNode(modelRoot, aspects);
	            var VMListNode = _VMListNode(VMNode, createViewModelNode);
	
	            var viewModelNode = new VMNode(metadataInfo, _AncestorChainFactory.emptyChain);
	
	            /* Set view model nodes for properties of a DTO view model node */
	            function setDTOProperties(_viewModelNode) {
	                function setDTOProperty(dtoViewModel, propertyName, propertyMetadataInfo, propertyAncestorChain) {
	                    var getOrCreateViewModelNode = _.once(function () {
	                        return createViewModelNode(dtoViewModel, propertyName, _Step.property(propertyMetadataInfo.dtoType.xCenter.name, propertyMetadataInfo), propertyAncestorChain);
	                    });
	
	                    Object.defineProperty(dtoViewModel, propertyName, {
	                        get: function get() {
	                            if (!dtoViewModel.value) {
	                                return;
	                            }
	                            //create node lazily if parent node has a value
	                            return getOrCreateViewModelNode();
	                        },
	                        set: function set(vmNodeOrModel) {
	                            getOrCreateViewModelNode().set(vmNodeOrModel);
	                        },
	                        enumerable: true
	                    });
	                }
	
	                var pathBuilder = _AncestorChainFactory.build(_viewModelNode, _viewModelNode._metadataInfo, _viewModelNode._ancestorChain);
	                var metadataProperties = _viewModelNode._metadataInfo.valueType.typeInfo.properties;
	                metadataProperties.forEach(function (properyMetadata) {
	                    var propertyName = StringUtil.lowercaseFirstLetter(properyMetadata.name);
	                    var propertyAncestorChain = pathBuilder.forChild(properyMetadata.name);
	                    setDTOProperty(_viewModelNode, propertyName, properyMetadata, propertyAncestorChain);
	                });
	            }
	
	            /* Create a view model node for the current metadata and ancestor chain. */
	            function createViewModelNode(_parentViewModel, accessorCode, _metadataInfo, ancestorChain) {
	                if (_metadataInfo.valueType.isCollection) {
	                    return new VMListNode(_metadataInfo, ancestorChain, accessorCode);
	                }
	                var _viewModelNode = new VMNode(_metadataInfo, ancestorChain, accessorCode);
	                var typeInfo = _metadataInfo.valueType.typeInfo;
	                if (typeInfo && typeInfo.metaType.isDto) {
	                    setDTOProperties(_viewModelNode, _metadataInfo, ancestorChain);
	                }
	                return _viewModelNode;
	            }
	
	            setDTOProperties(viewModelNode);
	            return viewModelNode;
	        }
	
	        return {
	            /**
	             * Create a new view model object based on an object containing data and a metadata type
	             *
	             * @param modelRoot {Object}: initial data object for view model. Error thrown if data is not an object
	             * @param metadataInfo {Object}: metadata information associated with the root model object
	             *
	             * @return {Object}: A new view model object
	             **/
	            create: function create(modelRoot, metadataInfo) {
	                return createRootViewModelNode(modelRoot, metadataInfo);
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * String utility functions
	     */
	    return {
	        /** Capitalizes a first letter of the string. */
	        capitalizeFirstLetter: function capitalizeFirstLetter(str) {
	            return str.charAt(0).toUpperCase() + str.substring(1);
	        },
	
	        /** Sets the first letter of the string to lowercase */
	        lowercaseFirstLetter: function lowercaseFirstLetter(str) {
	            return str.charAt(0).toLowerCase() + str.substring(1);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(672), __webpack_require__(673)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_AncestorChainFactory, _Step) {
	    /**
	     * Returns a constructor object for creating new View Model Node List objects.
	     * The constructor inherits from VMNode and adds list access and modification methods.
	     *
	     * @param VMNode {Function}: The ViewModelNode constructor
	     * @param createViewModelNodeFn {Function}: The function passed from VMFactory to create View Model Nodes
	     *
	     * @return {Function}: A constructor function to create new View Model Node List objects
	     **/
	    return function (VMNode, createViewModelNodeFn) {
	        function VMListNode() /*metadataInfo, ancestorChain, accessorCode*/{
	            VMNode.apply(this, arguments);
	
	            //internal array to hold view model nodes pointing to model array objects
	            this._vmElements = [];
	            this._lastChildren = Object.freeze([]);
	        }
	
	        VMListNode.prototype = Object.create(VMNode.prototype);
	        VMListNode.prototype.constructor = VMListNode;
	
	        /**
	         * Returns a view model object which points to the corresponding element in the underlying model array
	         *
	         * @param idx {Number}: The index of the list element to be retrieved
	         * @return {Object}: A view model object that points to the model array element at the same index
	         **/
	        VMListNode.prototype.getElement = function (idx) {
	            if (idx >= this.value.length) {
	                return undefined;
	            }
	            if (!this._vmElements[idx]) {
	                //sync up internal array containing vm nodes with underlying model array
	                this._syncVmListWithModel();
	            }
	            return this._vmElements[idx];
	        };
	
	        /**
	         * Returns a view model object which points to last model element in the array
	         *
	         * @return {Object}: A view model object that points to the last model array element
	         **/
	        VMListNode.prototype.getLastElement = function () {
	            if (this.value.length === 0) {
	                return undefined;
	            }
	            if (!this._vmElements[this.value.length - 1]) {
	                //sync up internal array containing vm nodes with underlying model array
	                this._syncVmListWithModel();
	            }
	            return this._vmElements[this.value.length - 1];
	        };
	
	        /**
	         * Returns a view model object which points to the first element with a value that
	         * matches the first argument. Matching is done by strict equality.
	         *
	         * @param vmNodeOrModel {Object}: The value object that is used to search
	         * @param fromIndex {int}: The index to start the search at.
	         * If the index is greater than or equal to the array's length, undefined is returned.
	         * Default: 0 (entire array is searched).
	         * @return {Object}: A view model object that points to the matching model array element
	         **/
	        VMListNode.prototype.findFirstElement = function (vmNodeOrModel, fromIndex) {
	            if (fromIndex >= this.value.length - 1) {
	                return undefined;
	            }
	            if (vmNodeOrModel instanceof VMNode) {
	                vmNodeOrModel = vmNodeOrModel.value;
	            }
	            fromIndex = fromIndex === undefined ? 0 : fromIndex;
	            var foundIdx = this.value.indexOf(vmNodeOrModel, fromIndex);
	            if (!this._vmElements[foundIdx]) {
	                //sync up internal array containing vm nodes with underlying model array
	                this._syncVmListWithModel();
	            }
	            return this._vmElements[foundIdx];
	        };
	
	        /**
	         * Sets the model element array at the same index. Essentially an alias to calling vmListNode.value[idx] = modelElementValue
	         * Throws an error if a index value greater than the length of the underlying model array is passed in.
	         *
	         * @param idx {Number}: The index of the list element to be retrieved
	         * @param {Object} vmNodeOrModel A view model node or simple data object to replace the element at the index passed in
	         **/
	        VMListNode.prototype.setElement = function (idx, vmNodeOrModel) {
	            if (idx >= this.value.length) {
	                throw new Error('Index provided is outside the bounds of the list. Use the push or unshift methods to add elements');
	            }
	            if (vmNodeOrModel instanceof VMNode) {
	                vmNodeOrModel = vmNodeOrModel.value;
	            }
	            this.value[idx] = vmNodeOrModel;
	        };
	
	        /**
	         * Adds a new element to the end array of view model elements.
	         *
	         * @param {Object} vmNodeOrModel A view model node or simple data object
	         * @return {Object}: A view model object that points to the model array element that was just added
	         **/
	        VMListNode.prototype.pushElement = function (vmNodeOrModel) {
	            if (vmNodeOrModel instanceof VMNode) {
	                vmNodeOrModel = vmNodeOrModel.value;
	            }
	            this.value.push(vmNodeOrModel);
	            return this.findFirstElement(vmNodeOrModel);
	        };
	
	        /**
	         * Property returning the length of the underlying model array
	         *
	         * @return {Number}: Length of list
	         **/
	        Object.defineProperty(VMListNode.prototype, 'length', {
	            get: function get() {
	                return this.value ? this.value.length : 0;
	            }
	        });
	
	        /**
	         * A convenience method to iterate over the view model node elements
	         *
	         * @param callback {Function}: Function to execute for each element, taking three arguments: element, index, array
	         * @param  [thisArg] {Object}: Optional. Value to use as this when executing callback.
	         **/
	        VMListNode.prototype.forEach = function (callback, thisArg) {
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            this._syncVmListWithModel();
	            this._vmElements.forEach(callback, thisArg);
	        };
	
	        /**
	         * A convenience method to filter view model node elements.
	         * @param callback {Function} : Function taking a view model node and returning boolean.
	         * @param thisArg
	         * @return list of the view model nodes for which this function returned true.
	         */
	        VMListNode.prototype.filter = function (callback, thisArg) {
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            this._syncVmListWithModel();
	            return this._vmElements.filter(callback, thisArg);
	        };
	
	        /**
	         * Returns a frozen array object containing the view model elements of the list
	         * The same object is returned once the list hasn't been modified
	         * Useful if you need to access the list in an array-like fashion like with ng-repeat
	         */
	        Object.defineProperty(VMListNode.prototype, 'children', {
	            'get': function get() {
	                if (this.length === this._lastChildren.length) {
	                    return this._lastChildren;
	                }
	
	                this._syncVmListWithModel();
	                this._lastChildren = Object.freeze(this._vmElements.slice(0, this.length));
	                return this._lastChildren;
	            }
	        });
	
	        VMListNode.prototype._syncVmListWithModel = function () {
	            var metadataInfo = this._metadataInfo;
	            var pathBuilder = _AncestorChainFactory.build(this, this._metadataInfo, this._ancestorChain);
	            var elementMetadataInfo = _Step.collectionElement(metadataInfo.xCenter, metadataInfo.valueType.elementType);
	            for (var i = this._vmElements.length; i < this.value.length; i++) {
	                this._vmElements.push(createViewModelNodeFn(this, i, elementMetadataInfo, pathBuilder.forChild(i)));
	            }
	        };
	
	        return VMListNode;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /** Returns an accessor as a "first" element of the path. */
	    function asInitialAccessor(accessor) {
	        return _.isNumber(accessor) ? '[' + accessor + ']' : accessor;
	    }
	
	    /** Returns an accessor as a "intermediate" element of the path. */
	    function asNesterdAccessor(accessor) {
	        return _.isNumber(accessor) ? '[' + accessor + ']' : '.' + accessor;
	    }
	
	    /** Creates a new path representation. */
	    function createPath(accessor, parent) {
	        var name = parent ? parent.asString + asNesterdAccessor(accessor) : asInitialAccessor(accessor);
	        return {
	            asString: name
	        };
	    }
	
	    /** Converts an owner to an owner of the "child" (nested) object. */
	    function asMetaForChild(accessor, base) {
	        return {
	            container: base.container,
	            metadata: base.metadata,
	            pathToItem: createPath(accessor, base.pathToItem)
	        };
	    }
	
	    var emptyChain = {
	        'owners': [],
	        'parent': undefined
	    };
	
	    /** Creates a chain of owners for the new (nested) element. */
	    function createOwnerChain(element, metadata, accessor, owners) {
	        var newChain = owners ? owners.owners.map(_.partial(asMetaForChild, accessor)) : [];
	        newChain.push({
	            container: element,
	            metadata: metadata,
	            pathToItem: createPath(accessor)
	        });
	        return {
	            'owners': newChain,
	
	            get parent() {
	                var ancestorChainLength = this.owners.length;
	                if (ancestorChainLength !== 0) {
	                    return this.owners[ancestorChainLength - 1].container;
	                }
	            }
	
	        };
	    }
	
	    /** Creates a new metadata builder for the current container, metadata node and owner items. */
	    function builderFor(element, metadata, owners) {
	        return {
	            /** Returns a new owner chain for the child object. */
	            'forChild': function forChild(accessor) {
	                return createOwnerChain(element, metadata, accessor, owners);
	            }
	        };
	    }
	
	    /**
	     * This modules contains utilities to work with the "chain of ownership". Ownership is chain of containing
	     * (owning) objects from some "root" object. For example, in the object {a: 3} value 3 is contained in the object
	     * itself. And it the code {a : {b : 3}} value 3 is contained in both inner object (as property b) and in the outer
	     * object (under the path a.b). Ownership chain provides access to all those objects along the chain and paths
	     * from each object to the value ("b" and "a.b" in the latter example).
	     *
	     * <h1>Owner chain API</h1>
	     * Each owner chain have following methods and properties:
	     * <dl>
	     *     <dt>owners</dt><dd>List of owners from the outermost to innermost.</dd>
	     * </dl>
	     *
	     * <h1>Owner API</h1>
	     * Each owner object (element in the owners chain) have following methods and properties:
	     * <dl>
	     *     <dt>container</dt><dd>Container object itself (path sensitive model, dto, etc...).</dd>
	     *     <dt>metadata</dt><dd>All the metadata associated with the container object's type.</dd>
	     *     <dt>pathToItem</dt><dd>Path <strong>from</code> the container object to the "current" object.</dd>
	     * </dl>
	     *
	     *
	     * <h1>Path API</h1>
	     * Each path object (path description) have following properties and methods:
	     * <dl>
	     *     <dt>asString</dt>string representation of the path.
	     * </dl>
	     */
	    return {
	        /**
	         * Starts building a new chains for the child elements. Receives a current value, object metadata and optional
	         * chain of "parent containers". Creates a new builder object used to create chains for child objects.
	         *
	         * Common use is:
	         * <code>
	         *     function createNode(meta, owners) {
	         *         const newImpl = createNodeImplementation(meta, owners);
	          *        const pathBuilder = OwnershipChain.build(newImpl, meta, owners);
	          *        for (const subElement in subElementsOf(newImpl, meta)) {
	          *            newImpl[subElement] = createNode(meta.sub(subElement), pathBuilder.forChild(subElement));
	          *        }
	         *     }
	         * </code>
	         *
	         * You could use <code>emptyChain</code> to start from the root node.
	         */
	        'build': builderFor,
	
	        /** Representation of the empty chain (i.e. chain of owners of the root entity). */
	        emptyChain: emptyChain
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(674), __webpack_require__(675)], __WEBPACK_AMD_DEFINE_RESULT__ = function (StepSpec, NodeMetadataDefinition) {
	    /** Derives a metadata from the type reference. */
	    function getTypeRefMetadata(typeRef) {
	        if (typeRef.kind !== 'class') {
	            return NodeMetadataDefinition.EMPTY;
	        }
	
	        return typeRef.typeInfo.metadata;
	    }
	
	    /** Creates a step descriptor. */
	    function create(step, inheritedMeta, xCenter, valueType, externalContext, readOnly) {
	        var typeMeta = getTypeRefMetadata(valueType);
	        return Object.freeze({
	            step: step,
	            typeMeta: typeMeta,
	            inheritedMeta: inheritedMeta,
	            'elementMetadata': NodeMetadataDefinition.merge(inheritedMeta, typeMeta),
	            xCenter: xCenter,
	            valueType: valueType,
	            externalContext: externalContext,
	            readOnly: readOnly
	        });
	    }
	
	    /** This module defines a "build step" API which could be used by different model builders and aspects. Each
	     * step have following properties and functions:
	     * <dl>
	     *     <dt>step : StepSpec</dt><dd>Defines a type of last step used to descendd into this node.</dd>
	     *     <dt>typeMeta : ElementMetadata</dt><dd>Metadata on the value's type.</dd>
	     *     <dt>inheritedMeta : ElementMetadata</dt><dd>Metadata inherited from the owner'snnn definition of the step
	     *        (annotation on property in DTO).</dd>
	     *     <dt>elementMetadata : ElementMetadata</dt><dd>Effective metadata for the "receiving" node. It is a mix of both
	     *        inherited and type's metadata.</dd>
	     *     <dt>xCenter : String</dt><dd>Name of the xCenter for which object is created.</dd>
	     *     <dt>valueType : TypeRef</dt><dd>Type of the node's value. This is a reference to the type (generic type
	     *       name), not the type metadata.</dd>
	     *     <dt>externalContext : Object</dt><dd>Additional data passed to the model. This property is set to undefined
	     *       for most values and have some reasonable value for root nodes only.</dd>
	     * </dl>
	     */
	    return {
	        /**
	         * Creates a step definition for the root node.
	         * @param xCenter xCenter name.
	         * @param type DTO type instance.
	         * @param externalContext external data passed to the model.
	         */
	        'root': function root(xCenter, type, externalContext) {
	            var typeSpec = {
	                'kind': 'class',
	                'name': type.typeName,
	                'typeInfo': type
	            };
	            return create(StepSpec.ROOT, NodeMetadataDefinition.EMPTY, xCenter, typeSpec, externalContext);
	        },
	
	        /**
	         * Creates a step definition based on the property.
	         * @param xCenter xCenter name.
	         * @param prop property descriptor.
	         */
	        'property': function property(xCenter, prop) {
	            return create(StepSpec.property(prop.name), prop.metadata, xCenter, prop.type, null, prop.readOnly);
	        },
	
	        /**
	         * Creates a step definition based on the collection element's type reference.
	         * @param xCenter xCenter name.
	         * @param eltType type of the collection element.
	         */
	        'collectionElement': function collectionElement(xCenter, eltType) {
	            return create(StepSpec.COLLECTION_ELT, NodeMetadataDefinition.EMPTY, xCenter, eltType);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(670)], __WEBPACK_AMD_DEFINE_RESULT__ = function (StringUtil) {
	    var availKinds = ['root', 'property', 'collectionElement'];
	
	    /** Enhances an element with kind data and properties, freezes it and return it back. */
	    function finishWithKinds(kind, elt) {
	        elt.kind = kind;
	        availKinds.forEach(function (possibleKind) {
	            elt['is' + StringUtil.capitalizeFirstLetter(possibleKind)] = kind === possibleKind;
	        });
	        return Object.freeze(elt);
	    }
	
	    /** This module defines a step specification, description of one (direct) step in the view model.
	     *
	     *
	     * <h2>Step definition</h2>
	     * <dl>
	     *     <dt>kind</dt><dd>Type of the item, different types of steps have different kinds.</dd>
	     *     <dt>is[kind]</dt><dd>Boolean value (not a function) set to true only for the actual kind and to false for
	     *        all other possible kinds.
	     * </dl>
	     *
	     * <h2>Step kinds</h2>
	     * Valid values for the <code>step</code> property on the step definition are:
	     * <dl>
	     *     <dt>root</dt><dd>Object in question is an actual "root" object. It have no parents.</dd>
	     *     <dt>property</dt><dd>Object is a property on another object. Values with this kind have an additional
	     *        <code>property</code> property referencing a property definition from the metamirror package.</dd>
	     *     <dt>collectionElement</dt><dd>This steps defines a "dynamic" access, descent on one step in some unspecified
	     *        collection (map or array).</dd>*
	     * </dl>
	     */
	    return Object.freeze({
	        /** Step describing "entering" the tree (root object). */
	        'ROOT': finishWithKinds('root', {}),
	
	        /** Step describing a navigation in one collection element. */
	        'COLLECTION_ELT': finishWithKinds('collectionElement', {}),
	
	        /** Creates a property navigation step.
	         * @param info property metadata.
	         */
	        'property': function property(info) {
	            return finishWithKinds('property', {
	                'property': info
	            });
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(676)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, MapUtil) {
	    /** Puts an item into the meta map. */
	    function _put(map, meta) {
	        if (!_.has(map, meta.type)) {
	            map[meta.type] = [];
	        }
	        map[meta.type].push(meta.value);
	    }
	
	    /** Puts all items into the map. */
	    function _putAll(meta, items) {
	        var putter = _.partial(_put, meta);
	        items.forEach(putter);
	    }
	
	    /** Puts named annotation into the named map. */
	    function _putNamed(namedMetas, items) {
	        if (!namedMetas.hasOwnProperty(items.name)) {
	            namedMetas[items.name] = {};
	        }
	        _put(namedMetas[items.name], items.metadata);
	    }
	
	    /** Chooses a map to use for the given name. */
	    function _chooseMap(allMap, unnamedMap, namedMaps, name) {
	        if (_.isUndefined(name)) {
	            return allMap;
	        }
	
	        if (name === null) {
	            return unnamedMap;
	        }
	
	        return MapUtil.get(namedMaps, name) || {};
	    }
	
	    /** Generates an error "description". */
	    function _fail(message, type, name) {
	        if (_.isUndefined(name)) {
	            throw new Error(message + ' with type ' + type);
	        }
	        if (name === null) {
	            throw new Error(message + ' with type ' + type + ' and without name');
	        }
	
	        throw new Error(message + ' with type ' + type + ' and name ' + name);
	    }
	
	    function _createMetadata(unnamedMetadata, namedMetadata) {
	        unnamedMetadata = unnamedMetadata || [];
	        namedMetadata = namedMetadata || [];
	
	        var allMap = {};
	        var unnamedMap = {};
	        var namedMaps = {};
	
	        _putAll(allMap, unnamedMetadata);
	        _putAll(unnamedMap, unnamedMetadata);
	        namedMetadata.forEach(function (namedMeta) {
	            _putNamed(namedMaps, namedMeta);
	            _put(allMap, namedMeta.metadata);
	        });
	
	        function getMeta(typeName, name) {
	            var mapToUse = _chooseMap(allMap, unnamedMap, namedMaps, name);
	            return MapUtil.get(mapToUse, typeName) || [];
	        }
	
	        /** Returns all named metadata. */
	        function getNamed(name) {
	            return _.flatten(_.values(MapUtil.get(namedMaps, name) || {}), true);
	        }
	
	        return Object.freeze({
	            'get': getMeta,
	            'getOne': function getOne(typeName, name) {
	                var props = getMeta(typeName, name);
	                if (props.length < 1) {
	                    _fail('Could not find metadata', typeName, name);
	                }
	                if (props.length > 1) {
	                    _fail('Too many metadata (' + props.length + ')', typeName, name);
	                }
	
	                return props[0];
	            },
	            'getOptional': function getOptional(typeName, name) {
	                var props = getMeta(typeName, name);
	                if (props.length > 1) {
	                    _fail('Too many metadata (' + props.length + ')', typeName, name);
	                }
	
	                if (props.length < 1) {
	                    return;
	                }
	                return props[0];
	            },
	            getNamed: getNamed,
	            'getOneNamed': function getOneNamed(name) {
	                var res = getNamed(name);
	                if (res.length < 1) {
	                    throw new Error('Could not find named metadata ' + name);
	                }
	                if (res.length > 1) {
	                    throw new Error('Too many metadata (' + res.length + ') for name ' + name);
	                }
	                return res[0];
	            },
	            'getOptionalNamed': function getOptionalNamed(name) {
	                var res = getNamed(name);
	                if (res.length > 1) {
	                    throw new Error('Too many metadata (' + res.length + ') for name ' + name);
	                }
	                if (res.length < 1) {
	                    return;
	                }
	                return res[0];
	            },
	            'has': function has(typeName, name) {
	                return getMeta(typeName, name).length > 0;
	            },
	            'types': function types(name) {
	                var mapToUse = _chooseMap(allMap, unnamedMap, namedMaps, name);
	                return _.keys(mapToUse);
	            },
	            'names': Object.freeze(_.keys(namedMaps)),
	            '_namedArray': namedMetadata,
	            '_unnamedArray': unnamedMetadata
	        });
	    }
	
	    function _merge() {
	        if (arguments.length === 1) {
	            return arguments[0];
	        }
	
	        var named = [];
	        var unnamed = [];
	
	        for (var i = 0; i < arguments.length; i++) {
	            named.push.apply(named, arguments[i]._namedArray);
	            unnamed.push.apply(unnamed, arguments[i]._unnamedArray);
	        }
	        return _createMetadata(unnamed, named);
	    }
	
	    return {
	        /** Constant: empty metadata. */
	        'EMPTY': _createMetadata([], []),
	
	        /**
	         * Creates a new metadata representation object.
	         * Metadata object have following properties and methods:
	         * <dl>
	         *     <dt>get(typeName, [name])</dt><dd> returns array of metadata with the given metadata type.</dd>
	         *     <dt>getOne(typeName, [name])</dt><dd> returns exactly one metadata of the given type. Throws an
	         *     Error if there is no metadata or more than one items with the same name.</dd>
	         *     <dt>getOptional(typeName, [name])</dt><dd> returns an "optional" item. Returns metadata representation
	         *       when it is defined. Returns undefined if there is no metadata with the given name. Throws an Error
	         *       if there is no metadata with the given type.</dt>
	         *     <dt>has(typeName, [name])</dt><dd> checks if a metadata have at least one metadata item with the given
	         *       type.
	         *     <dt>types([name])</dt><dd>Metadata types defined for the specific metadata name or without the name.</dd>
	         *     <dt>getNamed(name)</dt><dd>Returns all items of named metatada for the given type.</dd>
	         *     <dt>getOneNamed(name)</dt><dd>Returns exactly one named item.</dd>
	         *     <dt>getOptionalNamed(name)</dt><dd>Returns at most one named metadata</dd>
	         *     <dt>names</dt><dd>Array of possible metadata names (excluding null).</dd>
	         * </dl>
	         * Functions with optional <code>name</code> argument works with both named and unnamed metadata. By default
	         * (when name is not defined or passed) it takes both named and unnamed arguments into the account. When name
	         * is passed, only named metadata of that name is taken into the account. When name is <code>null</code> then
	         * only unnamed metadata is taken into the account.
	         *
	         * @param [unnamedMetadata=[]] unnamed metadata items.
	         * @param [namedMetadata=[]] named metadata items.
	         */
	        'createMetadata': _createMetadata,
	        /**
	         * Merges metadata into one object. This method could be used to evaluate effective metadata based on
	         * multiple (inherited) objects. This function is applicable to any number of arguments.
	         */
	        'merge': _merge
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return {
	        /** "Safer" version of accessor which retrieves object's own properties only. */
	        'get': function get(map, prop) {
	            if (!_.has(map, prop)) {
	                return;
	            }
	
	            return map[prop];
	        },
	
	        /**
	         * Converts items list into the unique map.
	         * @param items items to convert into the map.
	         * @param keyFunctionOrProperty function used to access a key or name of the key property.
	         * @return map from key to object.
	         * @throws Error if key is not unique.
	         */
	        'toUniqueMap': function toUniqueMap(items, keyFunctionOrProperty) {
	            var res = {};
	            var keyFunction = _.isFunction(keyFunctionOrProperty) ? keyFunctionOrProperty : _.property(keyFunctionOrProperty);
	            items.forEach(function (item) {
	                var key = keyFunction(item);
	                if (_.has(res, key)) {
	                    throw new Error('Duplicate key ' + key + ' found');
	                }
	                res[key] = item;
	            });
	            return res;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /**
	     * Returns a constructor object for creating new View Model Node objects.
	     * A view model node is a pointer to an underlying model object. It also contains aspect properties
	     * based on the underlying model value and metadata
	     *
	     * @param modelRoot {Object}: The root model object that was used to create the view model
	     * @param aspects {Array}: Aspect factory objects that have been registered with the ViewModel API
	     *
	     * @return {Function}: A constructor function to create new View Model Node objects
	     **/
	    return function (modelRoot, aspects) {
	        function VMNode(metadataInfo, ancestorChain, accessorCode) {
	            this._ancestorChain = ancestorChain;
	            this._metadataInfo = metadataInfo;
	            this._accessorCode = accessorCode;
	            this._aspectFactories = aspects;
	            this._aspects = {};
	
	            /* Provide more convenient methods for the typelists. They provide an automatic conversion between
	             * typecodes and string values on the model.
	             */
	            if (metadataInfo.valueType.kind === 'class' && metadataInfo.valueType.typeInfo.metaType.isTypelist) {
	                this.get = typelistGet;
	                this.set = typelistSet;
	            }
	
	            /*mixin aspect properties to the view model node */
	            aspects.forEach(function (aspectFactory) {
	                var aspectProperties = aspectFactory.getAspectProperties(this, this._metadataInfo, this._ancestorChain);
	                if (aspectProperties) {
	                    Object.getOwnPropertyNames(aspectProperties).forEach(function (propName) {
	                        if (this._aspects.hasOwnProperty(propName)) {
	                            throw new Error('View model node already has a property ' + propName + ', it cannot be overridden by another aspect');
	                        }
	                        Object.defineProperty(this._aspects, propName, aspectProperties[propName]);
	                    }, this);
	                }
	            }, this);
	        }
	
	        /**
	         * Typelist version of the get function. It provides automatic conversion into the typecode.
	         */
	        function typelistGet() {
	            var baseValue = VMNode.prototype.get.call(this);
	            if (_.isString(baseValue)) {
	                return _.findWhere(this._metadataInfo.valueType.typeInfo.codes, { code: baseValue });
	            }
	            return baseValue;
	        }
	
	        /** Typelist version of the setter. */
	        function typelistSet(vmNodeOrModel) {
	            if (vmNodeOrModel instanceof VMNode) {
	                vmNodeOrModel = vmNodeOrModel.value;
	            }
	
	            if (vmNodeOrModel && !_.isString(vmNodeOrModel)) {
	                /* Somebody (like an angular) cheats and provides clones of the objects. Do not allow that! */
	                var trueEntity = this._metadataInfo.valueType.typeInfo.getCode(vmNodeOrModel.code);
	                if (trueEntity !== vmNodeOrModel) {
	                    console.error('Critical MVC violation: attempt to provide non-genuine typecode');
	                    vmNodeOrModel = trueEntity;
	                }
	                vmNodeOrModel = vmNodeOrModel.code;
	            }
	
	            VMNode.prototype.set.call(this, vmNodeOrModel);
	        }
	
	        VMNode.prototype = {
	            get: function get() {
	                if (this._ancestorChain.parent) {
	                    return this._ancestorChain.parent.value[this._propertyName];
	                }
	                return modelRoot;
	            },
	            set: function set(vmNodeOrModel) {
	                if (vmNodeOrModel instanceof VMNode) {
	                    vmNodeOrModel = vmNodeOrModel.value;
	                }
	                if (!this._ancestorChain.parent) {
	                    modelRoot = vmNodeOrModel;
	                } else {
	                    this._ancestorChain.parent.value[this._propertyName] = vmNodeOrModel;
	                }
	            },
	
	
	            get value() {
	                return this.get();
	            },
	            set value(pathOrValue) {
	                this.set(pathOrValue);
	            },
	
	            get aspects() {
	                return this._aspects;
	            },
	
	            get _propertyName() {
	                return this._accessorCode;
	            },
	
	            get _parent() {
	                return this._ancestorChain.parent;
	            }
	        };
	
	        return VMNode;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(679)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Augment) {
	    var METADATA_CLASS = 'edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO';
	
	    /** Creates a new "Field is required" aspect. */
	    function create(expressionLanguage) {
	        function getAllRules(compilationContext, node, nodeMetadata, ancestorChain) {
	            return Augment.collectRules(compilationContext, node, nodeMetadata, ancestorChain, METADATA_CLASS);
	        }
	
	        function compileRule(compilationContext, rule) {
	            var visibilityExpr = compilationContext.compile(rule.data.expression);
	            var messageExpr = compilationContext.compile(rule.data.message);
	
	            return {
	                'shouldApply': rule.shouldApply,
	                'status': visibilityExpr,
	                'message': messageExpr
	            };
	        }
	
	        function combineRules(rules) {
	            return {
	                'visible': function visible(v, pv, ctx) {
	                    return rules.every(function (rule) {
	                        return !rule.shouldApply() || rule.status(v, pv, ctx) !== 'NOT_SET';
	                    });
	                },
	                'required': function required(v, pv, ctx) {
	                    return rules.some(function (rule) {
	                        return rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED';
	                    });
	                },
	                'requirednessMessages': function requirednessMessages(v, pv, ctx) {
	                    return rules.filter(function (rule) {
	                        return rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED';
	                    }).map(function (rule) {
	                        return rule.message(v, pv, ctx);
	                    });
	                }
	            };
	        }
	
	        return {
	            'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	                var compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
	                var rules = getAllRules(compilationContext, currentViewModelNode, currentMetadataNode, ancestorChain);
	                var compiledRules = rules.map(_.partial(compileRule, compilationContext));
	                var descriptor = combineRules(compiledRules);
	                return {
	                    'visible': {
	                        'get': function get() {
	                            return descriptor.visible(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
	                        }
	                    },
	                    'required': {
	                        'get': function get() {
	                            return descriptor.required(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
	                        }
	                    },
	                    '_requirednessMessages': {
	                        'get': function get() {
	                            return descriptor.requirednessMessages(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
	                        }
	                    }
	                };
	            }
	        };
	    }
	
	    return {
	        create: create
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    var METADATA_CLASS = 'edge.aspects.validation.dto.RuleAugmentationRuleDTO';
	
	    /** Returns a list of augments derived from the metadata. */
	    function getAugmentsFromMeta(expressionLanguage, metadata, targetType, targetPath, currentNode, parentNode) {
	        var augments = metadata.elementMetadata.get(METADATA_CLASS);
	        var applicableAugments = augments.filter(function (augment) {
	            return augment.targets.indexOf(targetPath) >= 0;
	        });
	        var res = [];
	
	        applicableAugments.forEach(function (augment) {
	            var cond = augment.when ? expressionLanguage.compile(augment.when) : _.constant(true);
	            var targetMetas = augment.augments.filter(function (override) {
	                return override.type === targetType;
	            }).map(function (override) {
	                return override.value;
	            });
	
	            targetMetas.forEach(function (meta) {
	                res.push({
	                    'shouldApply': function shouldApply() {
	                        /* Explicit cast to a true due to three-state value: true, false and NONSENSE. */
	                        return cond(currentNode, parentNode, currentNode.aspects.context) === true;
	                    },
	                    'data': meta,
	                    'node': currentNode,
	                    parentNode: parentNode
	                });
	            });
	        });
	
	        return res;
	    }
	
	    /** Collects rules from all the nodes. */
	    function collectRules(expressionLanguage, node, nodeMetadata, ancestorChain, targetType) {
	        var res = [];
	        var localMeta = nodeMetadata.elementMetadata.get(targetType);
	        localMeta.forEach(function (targetMeta) {
	            res.push({
	                'shouldApply': _.constant(true),
	                'data': targetMeta,
	                node: node,
	                'parentNode': ancestorChain.parent
	            });
	        });
	
	        for (var ancestorIdx = ancestorChain.owners.length - 1; ancestorIdx >= 0; ancestorIdx--) {
	            var owner = ancestorChain.owners[ancestorIdx];
	            var parent = ancestorIdx === 0 ? undefined : ancestorChain.owners[ancestorIdx - 1].container;
	            var inheritedAugments = getAugmentsFromMeta(expressionLanguage, owner.metadata, targetType, owner.pathToItem.asString, owner.container, parent);
	            res.push.apply(res, inheritedAugments);
	        }
	
	        return res;
	    }
	
	    /** Utilities for the augmentable properties. */
	    return {
	        collectRules: collectRules
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(679)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Augment) {
	    var METADATA_CLASS = 'edge.aspects.validation.dto.ValidationRuleDTO';
	
	    /** Validitiy descriptor for any type. Considers value as always valid. */
	    var ANY_TYPE = {
	        'typeValid': _.constant(true),
	        'messages': _.constant([])
	    };
	
	    var INT_TYPES = ['byte', 'short', 'int', 'long', 'Byte', 'Short', 'Integer', 'Long', 'BigInteger'];
	    var FLOAT_TYPES = ['float', 'double', 'Float', 'Double', 'BigDecimal'];
	
	    /** Creates a new "Field is required" aspect. */
	    function create(expressionLanguage, validationMessages) {
	        /** Validity for the decimal type. */
	        var DECIMAL_TYPE = {
	            'typeValid': function typeValid(val) {
	                if (_.isNumber(val)) {
	                    return true;
	                }
	                return (/^-?\d*(\.\d*)?$/.test(val)
	                );
	            },
	            'messages': function messages() /*val*/{
	                return [validationMessages.notANumber];
	            }
	        };
	
	        /** Validity descriptor for the integer types. */
	        var INT_TYPE = {
	            'typeValid': function typeValid(val) {
	                if (_.isNumber(val)) {
	                    return Math.round(val) === val;
	                }
	
	                return (/^-?\d+$/.test(val)
	                );
	            },
	            'messages': function messages(val) {
	                if (!DECIMAL_TYPE.typeValid(val)) {
	                    return DECIMAL_TYPE.messages(val);
	                }
	                return [validationMessages.notAnInteger];
	            }
	        };
	
	        function getAllRules(compilationContext, node, nodeMetadata, ancestorChain) {
	            return Augment.collectRules(compilationContext, node, nodeMetadata, ancestorChain, METADATA_CLASS);
	        }
	
	        function compileRule(compilationContext, rule) {
	            var validationRule = compilationContext.compile(rule.data.expression);
	            var messageExpr = compilationContext.compile(rule.data.message);
	
	            return {
	                'shouldApply': rule.shouldApply,
	                'validate': validationRule,
	                'message': messageExpr
	            };
	        }
	
	        function combineRules(rules) {
	            function getMessages(v, pv, ctx) {
	                return rules.filter(function (rule) {
	                    /* NONSENSE handling: shouldApply do that internally. Negation is fine for it. */
	                    return rule.shouldApply() && !rule.validate(v, pv, ctx);
	                }).map(function (rule) {
	                    return rule.message(v, pv, ctx);
	                });
	            }
	
	            return {
	                'messages': getMessages,
	                'valid': function valid(v, pv, ctx) {
	                    return rules.every(function (rule) {
	                        /* NONSENSE handling: shouldApply internally. Explicit check in validate. */
	                        return !rule.shouldApply() || rule.validate(v, pv, ctx) === true;
	                    });
	                }
	            };
	        }
	
	        /** Returns a type validation descriptor based on the DTO type. */
	        function getTypeDescriptor(type) {
	            switch (type.kind) {
	                case 'primitive':
	                    if (INT_TYPES.indexOf(type.name) >= 0) {
	                        return INT_TYPE;
	                    }
	                    if (FLOAT_TYPES.indexOf(type.name) >= 0) {
	                        return DECIMAL_TYPE;
	                    }
	                    return ANY_TYPE;
	
	                default:
	                    return ANY_TYPE;
	            }
	        }
	
	        return {
	            'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	                var compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
	                var rules = getAllRules(compilationContext, currentViewModelNode, currentMetadataNode, ancestorChain);
	                var compiledRules = rules.map(_.partial(compileRule, compilationContext));
	                var descriptor = combineRules(compiledRules);
	                var typeDescriptor = getTypeDescriptor(currentMetadataNode.valueType);
	                var readOnlyProperty = currentMetadataNode.readOnly;
	
	                /* Angular evaluation model workaround. */
	                var lastMessages = null;
	
	                function valueNotSet() {
	                    var val = currentViewModelNode.value;
	                    return _.isUndefined(val) || _.isNull(val) || val === '';
	                }
	
	                function calcAllMessages() {
	                    if (valueNotSet()) {
	                        return currentViewModelNode.aspects._requirednessMessages;
	                    }
	                    if (!typeDescriptor.typeValid(currentViewModelNode.value)) {
	                        return typeDescriptor.messages(currentViewModelNode.value);
	                    }
	                    return descriptor.messages(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
	                }
	
	                function allMessages() {
	                    if (readOnlyProperty) {
	                        return [];
	                    }
	                    var newMessages = _.unique(calcAllMessages());
	                    if (!_.isEqual(lastMessages, newMessages)) {
	                        lastMessages = newMessages;
	                    }
	                    return lastMessages;
	                }
	
	                return {
	                    'valid': {
	                        'get': function get() {
	                            if (readOnlyProperty) {
	                                return true;
	                            }
	                            if (valueNotSet()) {
	                                return !currentViewModelNode.aspects.required;
	                            }
	                            return typeDescriptor.typeValid(currentViewModelNode.value) && descriptor.valid(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
	                        }
	                    },
	                    'validationMessages': {
	                        'get': allMessages
	                    },
	                    'validationMessage': {
	                        'get': function get() {
	                            return allMessages()[0];
	                        }
	                    }
	                };
	            }
	        };
	    }
	
	    return {
	        create: create
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /** Default notion of the subtree validity. This validity is just tho validity of the node itself. */
	    function defaultValidity(node) {
	        return node.aspects.valid;
	    }
	
	    /** Notion of the validity for the array node. */
	    function arrayValidity(node) {
	        if (!node.aspects.valid) {
	            return false;
	        }
	        var len = node.length;
	        for (var i = 0; i < len; i++) {
	            if (!node.getElement(i).aspects.subtreeValid) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    /** Returns a validity function for the dto. */
	    function getDtoValidityFunction(info) {
	        return function (node) {
	            if (!node.aspects.valid) {
	                return false;
	            }
	
	            return info.properties.every(function (prop) {
	                return !node[prop.jsProperty] || node[prop.jsProperty].aspects.subtreeValid;
	            });
	        };
	    }
	
	    /** Returns a function to extract validity from the metadata node. */
	    function getValidityFn(metadata) {
	        if (metadata.readOnly) {
	            return function () {
	                return true;
	            };
	        }
	        switch (metadata.valueType.kind) {
	            case 'class':
	                var typeInfo = metadata.valueType.typeInfo;
	                if (typeInfo.metaType.isDto) {
	                    return getDtoValidityFunction(typeInfo);
	                }
	                return defaultValidity;
	            case 'collection':
	                return arrayValidity;
	            default:
	                return defaultValidity;
	        }
	    }
	
	    /** Aspect defining validity of the whole model subtree. */
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /*, ancestorChain*/) {
	            var accessor = getValidityFn(currentMetadataNode);
	
	            return {
	                'subtreeValid': {
	                    'get': function get() {
	                        return accessor(currentViewModelNode);
	                    }
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Simple aspect that is used to suggest the type of input directive that
	 * should be used based on the metadata for the property
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    function getInputCtrlType(metadataType) {
	        var inputType = 'text';
	        var isClass = metadataType.kind !== 'primitive';
	        if (isClass && metadataType.typeInfo.metaType.isTypelist) {
	            inputType = 'typelist';
	        } else if (metadataType.name === 'Date') {
	            inputType = 'date';
	        } else if (metadataType.name === 'Integer') {
	            inputType = 'tel'; // We use tel for integer as the input type for number is also applicable for floats.
	        } else if (metadataType.name === 'Boolean') {
	            inputType = 'boolean';
	        }
	        return inputType;
	    }
	
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /*, ancestorChain*/) {
	            return {
	                'inputCtrlType': {
	                    'get': function get() {
	                        return getInputCtrlType(currentMetadataNode.valueType);
	                    }
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    var FILTER_METADATA = 'edge.aspects.validation.dto.TypelistFilterDTO';
	    var CATEGORY_METADATA = 'edge.aspects.validation.dto.CategoryFilterDTO';
	    var EXPLICIT_LISTS = 'edge.aspects.validation.dto.TypekeyListFilterDTO';
	
	    /** This aspect defines a list of available values for the field based on the field type
	     * and property metadata.
	     */
	    function create(expressionLanguage) {
	        function compileCategory(compilationContext, node, parent, category) {
	            var expr = compilationContext.compile(category.categoryExpression);
	            return function () {
	                return expr(node, parent, node.aspects.context);
	            };
	        }
	
	        /** Checks if two lists matches each other. */
	        function matches(arr1, arr2) {
	            if (arr1 === null !== (arr2 === null)) {
	                return false;
	            }
	
	            if (arr1.length !== arr2.length) {
	                return false;
	            }
	
	            for (var i = 0; i < arr1.length; i++) {
	                if (arr1[i] !== arr2[i]) {
	                    return false;
	                }
	            }
	
	            return true;
	        }
	
	        return {
	            'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	                if (currentMetadataNode.valueType.kind !== 'class') {
	                    return {};
	                }
	
	                var typeInfo = currentMetadataNode.valueType.typeInfo;
	                if (!typeInfo.metaType.isTypelist) {
	                    return {};
	                }
	
	                var baseValues = typeInfo.codes;
	
	                var filterRules = currentMetadataNode.elementMetadata.get(FILTER_METADATA);
	
	                filterRules.forEach(function (filterName) {
	                    var filter = typeInfo.getFilter(filterName.filterName);
	                    baseValues = baseValues.filter(filter.allows);
	                });
	
	                var explicitLists = currentMetadataNode.elementMetadata.get(EXPLICIT_LISTS);
	                explicitLists.forEach(function (explicitList) {
	                    baseValues = baseValues.filter(function (value) {
	                        return explicitList.codes.indexOf(value.code) >= 0;
	                    });
	                });
	
	                var categoryRules = currentMetadataNode.elementMetadata.get(CATEGORY_METADATA);
	                if (categoryRules.length === 0) {
	                    return {
	                        'availableValues': { 'value': baseValues }
	                    };
	                }
	
	                var compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
	
	                var parent = ancestorChain.parent || {};
	                var categoryExprs = categoryRules.map(_.partial(compileCategory, compilationContext, currentViewModelNode, parent));
	
	                var res = null;
	
	                return {
	                    'availableValues': {
	                        'get': function get() {
	                            var newValues = baseValues.filter(function (typekey) {
	                                return categoryExprs.every(function (categoryExpr) {
	                                    var cat = categoryExpr();
	                                    return !cat || typekey.belongsToCategory(cat);
	                                });
	                            });
	
	                            /** This is a work around for Angular. It does not have a propagation/dependency tracking.
	                             * At the same time it does not consider two arrays with the same content equivalent. So we have
	                             * to return the same array to prevent infinite update loops.
	                             */
	                            if (!matches(newValues, res)) {
	                                res = newValues;
	                            }
	
	                            return res;
	                        }
	                    }
	                };
	            }
	        };
	    }
	
	    return {
	        create: create
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /** Serializes node as its value. */
	    function simpleSerializer(node) {
	        return node.value;
	    }
	
	    /** Serializer for typelist values. */
	    function typelistSerializer(node) {
	        var value = node.value;
	        if (_.isString(value)) {
	            console.warn('Serializing string as a typelist value. Typecodes should be used instead.');
	            return value;
	        }
	        return value.code;
	    }
	
	    /** Serializer for the array values. */
	    function arraySerializer(node) {
	        var len = node.length;
	        var res = [];
	        for (var i = 0; i < len; i++) {
	            res.push(node.getElement(i).aspects.serializedForm);
	        }
	        return res;
	    }
	
	    /** Serializes a DTO using given properties. */
	    function dtoSerializer(propNames, node) {
	        var res = {};
	        propNames.forEach(function (propName) {
	            var propVal = node[propName].aspects.serializedForm;
	            if (!_.isUndefined(propVal)) {
	                res[propName] = propVal;
	            }
	        });
	        return res;
	    }
	
	    /** Finds a value serializer based on the step metadata. Serializer takes an object node and returns its
	     * serialized form.
	     */
	    function getSerializer(metadata) {
	        var type = metadata.valueType;
	
	        switch (type.kind) {
	            case 'primitive':
	                return simpleSerializer;
	            case 'collection':
	                return arraySerializer;
	            case 'stringMap':
	                if (type.valueType.kind === 'primitive') {
	                    //console.log('Using fallback for the map value on the view model');
	                    return simpleSerializer;
	                }
	                throw new Error('Maps are not supported on the view model');
	            case 'class':
	                switch (type.typeInfo.metaType.kind) {
	                    case 'typelist':
	                        return typelistSerializer;
	                    case 'dto':
	                        return _.partial(dtoSerializer, type.typeInfo.properties.map(function (property) {
	                            return property.jsProperty;
	                        }));
	                    default:
	                        throw new Error('Unsupported class type kind ' + type.typeInfo.metaType.kind);
	                }
	                break;
	            default:
	                throw new Error('Unsupported kind of the view model node : ' + type.kind);
	        }
	    }
	
	    /** Model cleanup and optimization module. Removes non-visible and read-only arguments. Converts model values into
	     * its serialized form.
	     */
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /*, ancestorChain*/) {
	            var serializer = getSerializer(currentMetadataNode);
	
	            return {
	                'serializedForm': {
	                    'get': function get() {
	                        if (!currentViewModelNode.aspects.visible) {
	                            return;
	                        }
	                        var value = currentViewModelNode.value;
	                        if (_.isUndefined(value) || _.isNull(value)) {
	                            return value;
	                        }
	                        return serializer(currentViewModelNode);
	                    }
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(669)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, _VMFactory) {
	    /**
	     * Add an aspect property to create recreate the view model object from data
	     * Private aspect used by flow to recreate a view model object from a snapshot
	     **/
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	            if (ancestorChain.parent) {
	                //only interested in root objects
	                return undefined;
	            }
	            return {
	                _vmFromData: {
	                    'get': function get() {
	                        return _.partial(_VMFactory(currentViewModelNode._aspectFactories).create, _, currentMetadataNode);
	                    }
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    var factoryFn = function factoryFn(expressionLanguage) {
	        var CONTEXT_DTO_TYPE = 'edge.aspects.validation.dto.ContextDTO';
	
	        function getContextValuesForNode(currentMetadataNode) {
	            var cachedContext = {};
	            var compilationCtx = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
	
	            //Add external context values as context value expressions
	            if (currentMetadataNode.externalContext) {
	                _.keys(currentMetadataNode.externalContext).forEach(function (key) {
	                    cachedContext[key] = function () {
	                        return currentMetadataNode.externalContext[key];
	                    };
	                });
	            }
	
	            _.each(currentMetadataNode.elementMetadata.get(CONTEXT_DTO_TYPE), function (contextDefn) {
	                var expFn = compilationCtx.compile(contextDefn.expression);
	                cachedContext[contextDefn.name] = expFn;
	            });
	            return cachedContext;
	        }
	
	        var contextAspect = {
	            /**
	             * Add aspect properties to a view model node
	             */
	            getAspectProperties: function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
	                var ctx = getContextValuesForNode(currentMetadataNode);
	
	                return {
	                    context: {
	                        value: function value(name) {
	                            if (ctx[name]) {
	                                return ctx[name](currentViewModelNode, ancestorChain.parent);
	                            }
	                            return ancestorChain.parent ? ancestorChain.parent.aspects.context(name) : undefined;
	                        }
	                    }
	                };
	            }
	        };
	
	        return contextAspect;
	    };
	
	    return {
	        'create': factoryFn
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(688)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, _ref) {
	    var NONSENSE = _ref.NONSENSE;
	
	
	    function intParser(v) {
	        if (typeof v === 'number') {
	            return v;
	        }
	        if (typeof v === 'string') {
	            var nv = Number.parseInt(v);
	            return Number.isNaN(nv) ? NONSENSE : nv;
	        }
	        return NONSENSE;
	    }
	
	    function numberParser(v) {
	        if (typeof v === 'number') {
	            return v;
	        }
	        if (typeof v === 'string') {
	            var nv = Number.parseFloat(v);
	            return Number.isNaN(nv) ? NONSENSE : nv;
	        }
	        return NONSENSE;
	    }
	
	    function booleanParser(v) {
	        if (typeof v === 'boolean') {
	            return v;
	        }
	        if (typeof v === 'string') {
	            return v.toLowerCase().trim() === 'true';
	        }
	        return NONSENSE;
	    }
	
	    function dateParser(v) {
	        if (typeof v === 'string') {
	            return new Date(v);
	        }
	        if (v instanceof Date) {
	            return v;
	        }
	        if (typeof v === 'number') {
	            return new Date(v);
	        }
	        return NONSENSE;
	    }
	
	    var primitiveConverters = {
	        'byte': intParser,
	        'Byte': intParser,
	        'short': intParser,
	        'Short': intParser,
	        'char': _.identity,
	        'Char': _.identity,
	        'int': intParser,
	        'Integer': intParser,
	        'long': intParser,
	        'Long': intParser,
	        'BigInteger': intParser,
	
	        'float': numberParser,
	        'Float': numberParser,
	        'double': numberParser,
	        'Double': numberParser,
	        'BigDecimal': numberParser,
	
	        'String': _.identity,
	        'boolean': booleanParser,
	        'Boolean': booleanParser,
	        'Date': dateParser
	    };
	
	    function converterForType(type) {
	        switch (type.kind) {
	            case 'primitive':
	                return primitiveConverters[type.name] || _.identity;
	            default:
	                return _.identity;
	        }
	    }
	
	    /** Invokes a converter. */
	    function access(node, converter) {
	        var v = node.value;
	        if (v === null || v === undefined) {
	            return v;
	        }
	        return converter(v);
	    }
	
	    function getAspectProperties(currentViewModelNode, currentMetadataNode) {
	        var converter = converterForType(currentMetadataNode.valueType);
	        return {
	            'typedValue': {
	                'get': access.bind(null, currentViewModelNode, converter)
	            }
	        };
	    }
	
	    return {
	        getAspectProperties: getAspectProperties
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(689), __webpack_require__(676)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, CompilationContext, MapUtil) {
	    var NONSENSE = CompilationContext.NONSENSE;
	    var cleanse = CompilationContext.cleanse;
	
	    /** Common (global) operator namespace. */
	    var operators = {
	        ':sys:ops:': {
	            'and': function and(exprs, exprArgs) {
	                var hasNonsense = false;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = exprs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var expr = _step.value;
	
	                        var v = cleanse(expr(exprArgs));
	                        if (v === NONSENSE) {
	                            hasNonsense = true;
	                        } else if (!v) {
	                            return false;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return hasNonsense ? NONSENSE : true;
	            },
	            'or': function or(exprs, exprArgs) {
	                var hasNonsense = false;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = exprs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var expr = _step2.value;
	
	                        var v = cleanse(expr(exprArgs));
	                        if (v === NONSENSE) {
	                            hasNonsense = true;
	                        } else if (v) {
	                            return true;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                return hasNonsense ? NONSENSE : false;
	            }
	        }
	    };
	
	    var eqf = function eqf(a, b) {
	        if (a === b) {
	            return true;
	        }
	        if (a && a.code && a.typelist) {
	            a = a.code;
	        }
	
	        if (_.isUndefined(a)) {
	            a = null;
	        }
	
	        if (b && b.code && b.typelist) {
	            b = b.code;
	        }
	
	        if (_.isUndefined(b)) {
	            b = null;
	        }
	
	        return a === b;
	    };
	
	    /** Common (global) function/type namespace. */
	    var baseFunctions = {
	        ':sys:ops:': {
	            'eq': eqf,
	            'neq': function neq(a, b) {
	                return !eqf(a, b);
	            },
	            'less': function less(a, b) {
	                return a < b;
	            },
	            'greater': function greater(a, b) {
	                return a > b;
	            },
	            'not': function not(v) {
	                return !v;
	            }
	        }
	    };
	
	    /** Default typekey lookup function. Throws an exception on each access. */
	    function defaultLookupType(xcenter, typelist /*, typekey*/) {
	        throw new Error('Could not find typelist ' + typelist + ' in the xcenter ' + xcenter);
	    }
	
	    /** Creates a new expression language with a given translation provider.
	     * @param translate translation function.
	     * @param {Function} [typekeyLookup] function used to lookup the typekeys. This function have a type
	     *   (xcenter : String, typelistName : String, typecodeName : String) : Typecode. XCenter could be null to indicate
	     *   that typekey was requested in the generic context.
	     */
	    function createExpressionLanguage(translate, typekeyLookup) {
	        typekeyLookup = typekeyLookup || defaultLookupType;
	        var commonContext = CompilationContext.createRootContext(operators, baseFunctions, translate, typekeyLookup);
	
	        /** Compilation contexts for each xCenter instance. */
	        var xCenterContexts = {};
	
	        return {
	            /** Returns a compilation context.
	             * <p>If xCenter is not provided, returns a common context. Types registered in
	             * the common context would be available in all xCenters. It is not possible to register a type which is already
	             * defined for any xCenter. However, expressions could see only functions defined in this common context.
	             * <p>If xCenter is provided, xcenter-specific context is returned. It is possible to register a type which
	             * would be accessible to this context only (however, it is not possible to define a type already registered
	             * in common context). Expressions could see functions defined both in common context and returned context.
	             * @param {String} [xCenter] optional xCenter.
	             */
	            'getCompilationContext': function getCompilationContext(xCenter) {
	                if (!xCenter) {
	                    return commonContext;
	                }
	
	                var storedContext = MapUtil.get(xCenterContexts, xCenter);
	                if (storedContext) {
	                    return storedContext;
	                }
	
	                var newContext = commonContext.deriveContext(xCenter);
	                xCenterContexts[xCenter] = newContext;
	                return newContext;
	            }
	        };
	    }
	
	    /** Expression language access point. */
	    return {
	        /** Creates a new expression language.
	         * @param {Function} translate function used to translate messages. This function receives a display key and
	         * translation arguments (as function positional arguments) and must return a translated string.
	         */
	        createExpressionLanguage: createExpressionLanguage,
	        /** Magical value meaning that there is no meaningful value in the expression. Similar to SQL null. */
	        NONSENSE: NONSENSE,
	        /** Converts a maybe-view-model node into its typed value. */
	        cleanse: cleanse
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(690), __webpack_require__(691)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Namespace, ExpressionCompiler) {
	    /**
	     * This module defines a compilation context. Each compilation context has following functions:
	     * <dl>
	     *     <dt>registerType(typeName : String, typeMethods : Map&lt;string, function&gt;)</dt><dd>Registers a type for
	     *       the specific context. There could be additional restriction on when type could be registered, those
	     *       restrictions are defined in the documentation to the particular compilation context.</dd>
	     *     <dt>registerTypes(types: Map&lt;String, Map&lt;string, function&gt;&gt;)</dt><dd>Batch version of
	     *       <code>registerType</code></dd>
	     *     <dt>compile(expr : ExpressionDTO) : Function</dt><dd>Compiles an expression. </dd>
	     * </dl>
	     */
	
	    /**
	     * Creates a root compilation context. Additional methods on the compilation context:
	     * <dl>
	     *     <dt>deriveContext(ctxName : String) : CompilationContext</dt><dd>Defines a "derived" context. That derived
	     *       context have an access to all functions and operators in this base context. The context could
	     *       have additional types not present in this core context.</dd>
	     * </dl>
	     * @param ops map from string name to operators.
	     * @param coreClasses initial classes defined in the root context.
	     * @param translate translation function which takes display key and input parameters and returns a translated string.
	     * @param typekeyLookup function used to lookup typekey based on xCenter name, typekey name and typecode.
	     */
	    function createRootContext(ops, coreClasses, translate, typekeyLookup) {
	        var opsNS = Namespace.createMutableNamespace('[Root]', ops);
	        var commonNS = Namespace.createMutableNamespace('[Root]', coreClasses);
	        var commonCompiler = ExpressionCompiler.createCompiler(opsNS, commonNS, translate, _.partial(typekeyLookup, null));
	        var derivedNamespaces = [];
	
	        /** Registers a common type. */
	        function registerCommonType(typeName, methods) {
	            var offender = _.find(derivedNamespaces, function (context) {
	                return context.namespace.hasType(typeName);
	            });
	            if (offender) {
	                throw new Error('Type ' + typeName + ' is already registered in child context ' + offender.name);
	            }
	            commonNS.registerType(typeName, methods);
	        }
	
	        /** Derives a child context. */
	        function deriveContext(ctxName) {
	            var privateNS = Namespace.createMutableNamespace(ctxName, {});
	            var effectiveNS = Namespace.createCompositeNamespace(commonNS, privateNS);
	            var derivedCompiler = ExpressionCompiler.createCompiler(opsNS, effectiveNS, translate, _.partial(typekeyLookup, ctxName));
	            derivedNamespaces.push({
	                'name': ctxName,
	                'namespace': privateNS
	            });
	
	            function registerDerivedType(typeName, methods) {
	                if (commonNS.hasType(typeName)) {
	                    throw new Error('Type ' + typeName + ' is already registered in common namespace');
	                }
	                privateNS.registerType(typeName, methods);
	            }
	
	            return {
	                'registerType': function registerType(typeName, methods) {
	                    registerDerivedType(typeName, methods);
	                },
	                'registerTypes': function registerTypes(types) {
	                    _.each(types, function (funcs, typeName) {
	                        registerDerivedType(typeName, funcs);
	                    });
	                },
	                'compile': function compile(expr) {
	                    return derivedCompiler.compile(expr);
	                }
	            };
	        }
	
	        return {
	            'registerType': function registerType(typeName, methods) {
	                registerCommonType(typeName, methods);
	            },
	            'registerTypes': function registerTypes(types) {
	                _.each(types, function (funcs, typeName) {
	                    registerCommonType(typeName, funcs);
	                });
	            },
	            'compile': function compile(expr) {
	                return commonCompiler.compile(expr);
	            },
	            deriveContext: deriveContext
	        };
	    }
	
	    return {
	        createRootContext: createRootContext,
	        NONSENSE: ExpressionCompiler.NONSENSE,
	        cleanse: ExpressionCompiler.cleanse
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(676)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, MapUtil) {
	    /** Mutable namespace, see module docs. */
	    function createMutableNamespace(nsId, initialMap) {
	        var container = {};
	
	        function registerType(typeName, funcs) {
	            if (_.has(container, typeName)) {
	                throw new Error('Type ' + typeName + ' is already defined in ' + nsId);
	            }
	            container[typeName] = funcs;
	        }
	
	        if (initialMap) {
	            _.each(initialMap, function (funcs, type) {
	                registerType(type, funcs);
	            });
	        }
	
	        return {
	            'hasType': function hasType(typeName) {
	                return _.has(container, typeName);
	            },
	            'getFunction': function getFunction(typeName, functionName) {
	                var typeSpec = MapUtil.get(container, typeName) || {};
	                return MapUtil.get(typeSpec, functionName);
	            },
	            registerType: registerType
	        };
	    }
	
	    /** Creates a composite namespace, see module docs. */
	    function createCompositeNamespace() {
	        var peers = Array.prototype.slice.call(arguments);
	
	        return {
	            'hasType': function hasType(typeName) {
	                return peers.some(function (peer) {
	                    return peer.hasType(typeName);
	                });
	            },
	            'getFunction': function getFunction(typeName, functionName) {
	                var declaringPeer = _.find(peers, function (peer) {
	                    return peer.hasType(typeName);
	                });
	
	                if (declaringPeer) {
	                    return declaringPeer.getFunction(typeName, functionName);
	                }
	            }
	        };
	    }
	
	    /** Module used to create different types of namespaces.
	     *
	     * <h1>Types and interfaces.</h1>
	     * <h2>Namespace</h2>
	     * Namespace defines a way to lookup types and functions based on the input parameters. Each namespace have following
	     * functions and properties:
	     * <dl>
	     *     <dt>getFunction(typeName : String, functionName : String) : Function</dt>
	     *       <dd>Returns a function belonging to a given type. Returns undefined if there is no such function or type
	     *       in this namespace</dd>
	     *     <dt>hasType(typeName: String) : boolean</dt><dd>Checks if type is defined in the namespace.</dd>
	     * </dl>
	     */
	    return {
	        /** Creates a new modifiable (mutable) namespace. Returned object is a namespace with the following
	         * additional functions:
	         * <dl>
	         *     <dt>registerType(typeName : String, funcs : Map&lt;String, Function$gt;)</dt>
	         *       <dd>Registers a type with the specific name and static function on that type. Throws an Error if
	         *         type is already defined inside the namespace.</dd>
	         * </dl>
	         * @param {String} nsId identifier of the namespace, used for debug purposes and error reporting.
	         * @param {Object} [initialMap] initial values, map from type to function in this type.
	         * @return {Namespace} with additional mutation functions.
	         */
	        createMutableNamespace: createMutableNamespace,
	
	        /**
	         * Creates a new read-only composite namespace. This namespace tries to find a type in all child namespaces
	         * and returns value from the first one.
	         * Receives peer (child) namespaces an an input.
	         */
	        createCompositeNamespace: createCompositeNamespace
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(676), __webpack_require__(692)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, MapUtil, ViewModelUtil) {
	    /** Module providing compilation facilities for the specific set of "platform definitions" (functions, operators,
	     * etc...).
	     *
	     * Supported types/aliases:
	     *   * expressionEvaluator == (args : Object[]) => Object - function taking arguments as
	     *     an array and returning expression value.
	     *   * kindCompiler == (expr : ExpressionDTO, ctx : CompileContext) => expressionEvaluator - compiler for the
	     *     specific expression kind.
	     */
	
	    /** NO-VALUE value (like null/unknown in SQL). */
	    var NONSENSE = Object.freeze({});
	
	    function cleanse(v) {
	        return ViewModelUtil.isViewModelNode(v) ? v.aspects.typedValue : v;
	    }
	
	    /**
	     * Applies an eager function to its arguments.
	     * @param fun function to apply.
	     * @param funArgExprs expression defining arguments to function.
	     * @param exprArgs arguments to the expression itself.
	     */
	    function applyEagerFunction(fun, funArgExprs, exprArgs) {
	        var funArgs = funArgExprs.map(function (funArgExpr) {
	            /*
	             * function which expects values and not expressions.
	             */
	            return cleanse(funArgExpr(exprArgs));
	        });
	        if (funArgs.includes(NONSENSE)) {
	            return NONSENSE;
	        }
	        return fun.apply(null, funArgs);
	    }
	
	    /** Compiles a constant expression into expression evaluator.
	     * @param {{ConstantExpressionDTO}} expr constant expression definition.
	     * @return {{expressionEvaluator}} constant expression evaluator.
	     */
	    var compileConst = function () {
	        /** Mapping from constant type into type factory. */
	        var valueFactoriesForType = {
	            'int': _.identity,
	            'long': _.identity,
	            'string': _.identity,
	            'BigDecimal': _.identity,
	            'boolean': _.identity,
	            'dto': _.identity,
	            'null': _.constant(null),
	            'Date': function (_Date) {
	                function Date(_x) {
	                    return _Date.apply(this, arguments);
	                }
	
	                Date.toString = function () {
	                    return _Date.toString();
	                };
	
	                return Date;
	            }(function (str) {
	                return new Date(str);
	            })
	        };
	
	        return function (expr, buildContext) {
	            var valueFactory = MapUtil.get(valueFactoriesForType, expr.type);
	            if (valueFactory) {
	                return _.constant(valueFactory(expr.value));
	            }
	
	            if (expr.type.substring(0, 5) === 'enum ') {
	                return _.constant(expr.value);
	            }
	
	            if (expr.type.substring(0, 8) === 'typekey ') {
	                return _.constant(buildContext.typekeyLookup(expr.type.substring(8), expr.value));
	            }
	
	            throw new Error('Unsupported constant type ' + expr.type);
	        };
	    }();
	
	    /**
	     * Compiles a parameter access expression.
	     * @param {{ParameterExpressionDTO}} expr expression to compile.
	     * @return {{expressionEvaluator}} parameter value evaluator.
	     */
	    function compileParameter(expr) {
	        var paramIdx = expr.index;
	        return function (args) {
	            return args[paramIdx];
	        };
	    }
	
	    /** Compiles a property access expression. */
	    var compileFieldAccess = function () {
	        function _decapitalize(str) {
	            return str.charAt(0).toLowerCase() + str.substring(1);
	        }
	
	        /** Fetches a property from the object. */
	        function getProperty(obj, propName) {
	            if (obj === NONSENSE || _.isUndefined(obj) || _.isNull(obj)) {
	                return obj;
	            }
	
	            /*
	             * Keep navigating VM nodes as much as possible.
	             */
	            if (ViewModelUtil.isViewModelNode(obj)) {
	                var propValue = obj[propName];
	                if (!propValue) {
	                    propValue = obj[_decapitalize(propName)];
	                }
	
	                if (propValue) {
	                    return propValue;
	                }
	
	                obj = obj.aspects.typedValue;
	            }
	
	            var r = obj[propName];
	            if (r) {
	                return r;
	            }
	            r = obj[_decapitalize(propName)];
	            return r;
	        }
	
	        return function (expr, buildContext) {
	            var baseEvaluator = buildContext.compile(expr.base);
	            var propName = expr.propertyName;
	
	            return function (args) {
	                return getProperty(baseEvaluator(args), propName);
	            };
	        };
	    }();
	
	    /** Method invocation compiler. */
	    var compileInvocation = function () {
	        return function (expr, buildContext) {
	            var ns = expr.container;
	            var funcName = expr.name;
	            var argExprs = expr.params.map(buildContext.compile);
	
	            var maybeOp = buildContext.operators.getFunction(ns, funcName);
	            if (maybeOp) {
	                return _.partial(maybeOp, argExprs);
	            }
	
	            var maybeFunction = buildContext.functions.getFunction(ns, funcName);
	            if (maybeFunction) {
	                return _.partial(applyEagerFunction, maybeFunction, argExprs);
	            }
	            throw new Error('Could not find function ' + funcName + ' in ' + ns);
	        };
	    }();
	
	    /** Compiles a "translate" expression. */
	    function compileTranslate(expr, buildContext) {
	        var args = expr.arguments.map(buildContext.compile);
	        args.unshift(_.constant(expr.displayKey));
	        return _.partial(applyEagerFunction, buildContext.translate, args);
	    }
	
	    /** Mapping from kind name to expression compiler for that kind. */
	    var kindCompilers = {
	        'const': compileConst,
	        'parameter': compileParameter,
	        'getfield': compileFieldAccess,
	        'nativecall': compileInvocation,
	        'translate': compileTranslate
	    };
	
	    /** Creates base (non-caching) compiler. */
	    function createBaseCompiler(operators, functions, translate, typekeyLookup) {
	        function compileExpr(expr) {
	            var kindCompiler = MapUtil.get(kindCompilers, expr.kind);
	            if (!kindCompiler) {
	                throw new Error('Unsupported expression kind ' + expr.kind);
	            }
	            return kindCompiler(expr, ctx);
	        }
	
	        var ctx = {
	            'compile': compileExpr,
	            operators: operators,
	            functions: functions,
	            translate: translate,
	            typekeyLookup: typekeyLookup
	        };
	
	        return {
	            compile: function compile(expr) {
	                var compiledFn = compileExpr(expr);
	                return function () {
	                    /**
	                     * the parameter. We have to return a value, not the node.
	                     */
	                    return cleanse(compiledFn(Array.prototype.slice.call(arguments)));
	                };
	            }
	        };
	    }
	
	    return {
	        /** Creates a compiler. This compiler caches result of operations based on the expression
	         * <em>identity</em>.
	         * @param operators operators namespace.
	         * @param functions function namespace.
	         * @param translate translation function.
	         * @param typekeyLookup function used to lookup typekeys (for typekey constant). It takes typekey name and
	         * typecode and returns a typecode object.
	         * @return compiler.
	         */
	        'createCompiler': function createCompiler(operators, functions, translate, typekeyLookup) {
	            return createBaseCompiler(operators, functions, translate, typekeyLookup);
	        },
	        NONSENSE: NONSENSE,
	        cleanse: cleanse
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    var vmQualifyingProperties = ['value', 'aspects', '_propertyName', '_parent', '_ancestorChain', '_metadataInfo', '_accessorCode', '_aspects'];
	
	    /** Checks if maybenode is view model node. */
	    function isVMNode(maybeNode) {
	        if (!maybeNode || !_.isObject(maybeNode)) {
	            return false;
	        }
	
	        return vmQualifyingProperties.every(function (qp) {
	            return qp in maybeNode;
	        });
	    }
	
	    /** Miscellaneous utilities for the view model nodes. */
	    return {
	        /** Checks if maybenode is view model node. */
	        'isViewModelNode': isVMNode,
	
	        /** Cleans item and extracts its true value. */
	        'cleanse': function cleanse(maybeNode) {
	            return isVMNode(maybeNode) ? maybeNode.value : maybeNode;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (LocaleService) {
	        return {
	            'optionalVisibility': function optionalVisibility(cond, target) {
	                return cond ? target : 'OPTIONAL';
	            },
	            'belongsToFilter': function belongsToFilter(value, filterName) {
	                return value.typelist.getFilter(filterName).allows(value);
	            },
	            'hasCategory': function hasCategory(value, parent) {
	                if (!parent) {
	                    return false;
	                }
	
	                return value.belongsToCategory(parent);
	            },
	            'getContextValue': function getContextValue(context, prop) {
	                return context(prop);
	            },
	            matchesPattern: function matchesPattern(pattern, value) {
	                return !pattern || !value || new RegExp('^' + pattern + '$').test(value);
	            },
	            'typekeyIn': function typekeyIn(tk, values) {
	                return values.indexOf(tk.code) >= 0;
	            },
	            'range': function range(l, r, m) {
	                return l <= m && m <= r;
	            },
	            'strLength': function strLength(s) {
	                return s ? s.length : 0;
	            },
	            'getFromMap': function getFromMap(m, k) {
	                return m[k];
	            },
	            'compareDate': function compareDate(d1, d2) {
	                return new Date(d1).getTime() - new Date(d2).getTime();
	            },
	            'isEmpty': function isEmpty(s1) {
	                return !s1 || s1.length === 0;
	            },
	            'isCurrency': function isCurrency(obj) {
	                if (!angular.isDefined(obj) || obj === null || obj === '') {
	                    return false;
	                }
	
	                if (typeof obj === 'number') {
	                    obj = obj.toString();
	                }
	
	                if (typeof obj !== 'string') {
	                    return false;
	                }
	
	                if (!obj.match(/^\d*(.\d*)?$/)) {
	                    return false;
	                }
	
	                var currencyInfo = LocaleService.getLocaleInfo().currency;
	                return obj.indexOf('.') === -1 || obj.indexOf('.') >= obj.length - (currencyInfo.fractionSize + 1);
	            },
	            'isValidSSN': function isValidSSN(value) {
	
	                var regex1 = new RegExp("-", 'g');
	                var regex2 = new RegExp("_", 'g');
	
	                var tempValue = value.replace(regex1, '');
	                tempValue = tempValue.replace(regex2, '');
	
	                if (tempValue.length === 9 || tempValue.length === 0) {
	                    return true;
	                }
	                return false;
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(349), __webpack_require__(447)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ApplicationFeatures, phoneUtils) {
	    /**
	     * Module that returns the current date. Can be replaced with
	     * another implementation, for example if you needed to time travel and return
	     * a different current date
	     */
	    return function (LocaleService) {
	        return {
	            'isPossibleNumber': function isPossibleNumber(propertyValue, countryCode) {
	                var returnVal = true;
	                var extPos = void 0;
	                var number = void 0;
	                if (angular.isDefined(propertyValue) && propertyValue !== null && propertyValue !== '') {
	                    if (ApplicationFeatures.hasFeature('phone-validation.libphonenumber')) {
	                        extPos = propertyValue.indexOf(' x');
	                        number = extPos > 0 ? propertyValue.substring(0, extPos) : propertyValue;
	                        number = number.replace(/[-_]/g, '');
	                        try {
	                            returnVal = phoneUtils.isPossibleNumber(number, countryCode || LocaleService.getConfiguredPhoneRegion());
	                        } catch (e) {
	                            return false; //Suppress log error message from libphonenumber when number is not valid
	                        }
	                    }
	                }
	                return returnVal;
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(696)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ExpressionLanguageService) {
	    return angular.module('edge.platform.el', []).factory('ExpressionLanguageService', ExpressionLanguageService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(688), __webpack_require__(697)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ExpressionLanguage) {
	    return ['TranslateService', 'InsuranceSuiteMetadata', function (TranslateService, InsuranceSuiteMetadata) {
	        return ExpressionLanguage.createExpressionLanguage(function () {
	            var displayKey = arguments[0];
	            var transKeys = {};
	            for (var i = 1; i < arguments.length; i++) {
	                transKeys['_' + (i - 1)] = arguments[i];
	            }
	            return TranslateService.instant(displayKey, transKeys);
	        }, function (xCenter, typekey, typecode) {
	            return InsuranceSuiteMetadata.get(xCenter).types.get('typelist', 'typekey.' + typekey).getCode(typecode);
	        });
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(698), __webpack_require__(535)], __WEBPACK_AMD_DEFINE_RESULT__ = function (InsuranceSuiteMetadata) {
	    return angular.module('edge.platform.metamirror', ['edge.platform.l10n']).factory('InsuranceSuiteMetadata', InsuranceSuiteMetadata);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(699)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XCenters) {
	    return ['TranslateService', function (TranslateService) {
	        function translate(key) {
	            var obj = {};
	            TranslateService.translate({
	                object: obj,
	                propName: 'value',
	                displayKey: key
	            });
	            return function () {
	                return obj.value;
	            };
	        }
	
	        return XCenters.createSuiteMetadata(translate);
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(700), __webpack_require__(676), __webpack_require__(705)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, XCenterTypes, MapUtil, metadata) {
	    metadata = JSON.parse(metadata);
	
	    /** Parses an XCenter definition object. */
	    function parseXCenter(translator, meta, name) {
	        var res = {
	            name: name
	        };
	        res.types = XCenterTypes.createXCenterTypes(translator, meta, res);
	        return Object.freeze(res);
	    }
	
	    return {
	        /**
	         * Parses Insunarse suite metadata information.
	         * Returned object have following properties and functions:
	         * <dl>
	         *     <dt>xcenters</dt><dd>List of all xcenter objects defined in the configuration.<dd>
	         *     <dt>has(xcenter)</dt><dd>Checks if this suite have metadata for the specific xcenter type.</dd>
	         *     <dt>get(xcenter)</dt><dd>Returns xcenter metadata. Throws error if xcenter metadata is not defined.</dd>
	         * </dl>
	         *
	         * Each xcenter metadata object have following method and properties:
	         * <dl>
	         *     <dt>name</dt><dd>xcenter name.</dd>
	         *     <dt>types</dt><dd>type metadata object containing information about types defined in the xcenter.</dd>
	         * </dl>
	         */
	        createSuiteMetadata: function createSuiteMetadata(translator) {
	            var xcenterMap = _.mapObject(metadata, _.partial(parseXCenter, translator));
	            return {
	                'xcenters': _.values(xcenterMap),
	                'has': function has(xcenter) {
	                    return _.has(xcenterMap, xcenter);
	                },
	                'get': function get(xcenter) {
	                    var res = MapUtil.get(xcenterMap, xcenter);
	                    if (!res) {
	                        throw new Error('No xcenter ' + xcenter + ' is defined');
	                    }
	                    return res;
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(676), __webpack_require__(701), __webpack_require__(703), __webpack_require__(670)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, MapUtil, Typelists, Dtos, StringUtil) {
	    var metaTypeNames = ['dto', 'typelist'];
	    var metaTypes = {};
	
	    metaTypeNames.forEach(function (metaType) {
	        var metaObject = {
	            kind: metaType
	        };
	        metaTypeNames.forEach(function (possibleMetaType) {
	            metaObject['is' + StringUtil.capitalizeFirstLetter(possibleMetaType)] = possibleMetaType === metaType;
	        });
	        metaTypes[metaType] = Object.freeze(metaObject);
	    });
	
	    var typeFactories = {
	        'edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO': function edgeMetadataTypeinfoDtoinfoDtoDTOMetadataDTO(typeRef, xCenter, translator, typeName, typeMeta) {
	            return Dtos.createDTOInfo(xCenter, typeRef, typeName, typeMeta.value, metaTypes.dto);
	        },
	        'edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO': function edgeMetadataTypeinfoTypelistinfoDtoTypelistMetadataDTO(typeRef, xCenter, translator, typeName, typeMeta) {
	            return Typelists.createTypelistInfo(xCenter, translator, typeName, typeMeta.value, metaTypes.typelist);
	        }
	    };
	
	    /** Parses a type metadata. */
	    function parseType(typeRef, xCenter, translator, typeMeta, typeName) {
	        var typeKindTranslator = MapUtil.get(typeFactories, typeMeta.type);
	        if (!typeKindTranslator) {
	            throw new Error('Type metadata format ' + typeMeta.type + ' was not recognized as a valid type metadata.');
	        }
	        return typeKindTranslator(typeRef, xCenter, translator, typeName, typeMeta);
	    }
	
	    /** Checks if type have a specific (meta-)type. */
	    function hasKind(kind, typeObject) {
	        return typeObject.metaType.kind === kind;
	    }
	
	    return {
	        /**
	         * Creates a representation of types belonging to an xcenter.
	         *
	         * Following properties and functions are defined on the object:
	         * <dl>
	         *     <dt>allTypes</dt><dd>List of all types defined for the xcenter</dd>
	         *     <dt>dtoTypes</dt><dd>List of all DTO types defined for the xcenter</dd>
	         *     <dt>typelists</dt><dd>List of typelists defined for the xcenter</dd>
	         *     <dt>has([typeKind], typeName)</dt><dd>Checks if typeName is defined for the types. If typekind is passed,
	         *       checks type presense of the specific kind.</dd>
	         *     <dt>get([typeKind], typeName)</dt><dd>Retrieves a type by its name. Throws Error if type was not found.
	         *       Searches for specific type kinds if two-arg version is used.
	         *     <dt>getTypelist(typelistNameOrType)</dt><dd>Retrieves a typelist by either a type name or simple typelist
	         *       name. Throws Error if typelist is not present in the xcenter</dd>
	         * </dl>
	         *
	         * @param translator translation function.
	         * @param typesMeta information about types.
	         * @param xCenter reference back to an xCenter.
	         */
	        'createXCenterTypes': function createXCenterTypes(translator, typesMeta, xCenter) {
	            var typeMap = {};
	
	            function getTypeRef(typeName) {
	                if (!_.has(typesMeta, typeName)) {
	                    throw new Error('Illegal reference to unknown type ' + typeName);
	                }
	                return function () {
	                    return typeMap[typeName];
	                };
	            }
	
	            typeMap = _.mapObject(typesMeta, _.partial(parseType, getTypeRef, xCenter, translator));
	
	            var _get = function _get() {
	                var guess = void 0;
	                if (arguments.length === 2) {
	                    guess = MapUtil.get(typeMap, arguments[1]);
	                    if (!guess || !hasKind(arguments[0], guess)) {
	                        throw new Error('No ' + arguments[0] + ' with name ' + arguments[1] + ' is defined');
	                    }
	                    return guess;
	                }
	                guess = MapUtil.get(typeMap, arguments[0]);
	                if (!guess) {
	                    throw new Error('No type with name ' + arguments[0] + ' is defined');
	                }
	                return guess;
	            };
	
	            return {
	                'allTypes': _.values(typeMap),
	                'dtoTypes': _.values(typeMap).filter(_.partial(hasKind, 'dto')),
	                'typelists': _.values(typeMap).filter(_.partial(hasKind, 'typelist')),
	                'has': function has() {
	                    if (arguments.length === 2) {
	                        return _.has(typeMap, arguments[1]) && hasKind(arguments[0], typeMap[arguments[1]]);
	                    }
	                    return _.has(typeMap, arguments[0]);
	                },
	
	                'get': _get,
	                'getTypelist': function getTypelist(typelistNameOrType) {
	                    /* Convert simple typelist name into the type name. */
	                    if (typelistNameOrType.indexOf('.') < 0) {
	                        typelistNameOrType = 'typekey.' + typelistNameOrType;
	                    }
	                    return _get('typelist', typelistNameOrType);
	                }
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(675), __webpack_require__(702), __webpack_require__(676)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Metadata, PropDef, MapUtil) {
	    var typePrefix = 'typekey.';
	
	    /** Returns typelist name based on its type. */
	    function _getTypelistName(type) {
	        if (typePrefix !== type.substring(0, typePrefix.length)) {
	            throw new Error('Illegal typelist type  name ' + type);
	        }
	        return type.substring(typePrefix.length);
	    }
	
	    /** Creates a new filter. */
	    function newFilter(typelist, codeMap, filter) {
	        var lookupCode = function lookupCode(code) {
	            var codeInfo = MapUtil.get(codeMap, code);
	            if (!codeInfo) {
	                throw new Error('Bad reference to ' + code + ' from filter ' + filter + ' on typelist ' + typelist);
	            }
	            return codeInfo;
	        };
	
	        var referencedCodes = filter.includedCodes.map(lookupCode);
	
	        var res = {
	            'name': filter.name,
	            'codes': referencedCodes,
	
	            'allows': function allows(codeOrCodeName) {
	                return _.some(referencedCodes, function (code) {
	                    return code === codeOrCodeName || code.code === codeOrCodeName;
	                });
	            }
	        };
	
	        Object.freeze(res);
	        Object.freeze(res.codes);
	
	        return res;
	    }
	
	    /** Creates a new typecode draft. */
	    function newCode(translator, typelist, code) {
	        var res = {
	            code: code.code,
	            priority: code.priority,
	            typelist: typelist,
	            belongsToCategory: function belongsToCategory(categoryCode) {
	                return _.some(code.categories, function (cat) {
	                    return cat.typecode === categoryCode.code && cat.typelist === categoryCode.typelist.name;
	                });
	            }
	        };
	        Object.defineProperty(res, 'name', PropDef.toPropertyDef(translator(code.displayKey)));
	        Object.freeze(res);
	
	        return res;
	    }
	
	    /** Creates a new typelist definition.
	     * @param xCenter xCenter to which this typelist belongs.
	     * @param translator translation function.
	     * @param type typelist's type name.
	     * @param meta typelist metadata.
	     * @param metaType meta-type of the typelist.
	     */
	    function newTypelist(xCenter, translator, type, meta, metaType) {
	        var res = {
	            typeName: type,
	            xCenter: xCenter,
	            name: _getTypelistName(type),
	            metadata: Metadata.createMetadata([], meta.namedMetadata)
	        };
	        res.codes = meta.codes.map(_.partial(newCode, translator, res));
	
	        /* Fields. */
	        if (metaType) {
	            res.metaType = metaType;
	        }
	        var codeMap = MapUtil.toUniqueMap(res.codes, 'code');
	        res.filters = meta.filters.map(_.partial(newFilter, type, codeMap));
	        var filterMap = MapUtil.toUniqueMap(res.filters, 'name');
	
	        /* Functions. */
	        res.getCode = function (code) {
	            if (!_.has(codeMap, code)) {
	                throw new Error('Typelist ' + type + ' do not have a typecode ' + code);
	            }
	            return codeMap[code];
	        };
	        res.getCodesForCategory = function (category) {
	            return res.codes.filter(function (code) {
	                return code.belongsToCategory(category);
	            });
	        };
	        res.hasCode = function (codeName) {
	            return _.has(codeMap, codeName);
	        };
	        res.getFilter = function (name) {
	            if (!_.has(filterMap, name)) {
	                throw new Error('Typelist ' + type + ' do not have a filter ' + name);
	            }
	            return filterMap[name];
	        };
	        res.hasFilter = function (name) {
	            return _.has(filterMap, name);
	        };
	
	        Object.freeze(res.codes);
	        Object.freeze(res.filters);
	        Object.freeze(res);
	
	        return res;
	    }
	
	    return {
	        /**
	         * Creates a new typelist representation.
	         * Typelist have following properties and methods:
	         * <dl>
	         *     <dt>name</dt> <dd>simple typelist name.</dd>
	         *     <dt>typeName</dt> <dd>typelist's type name.</dd>
	         *     <dt>metadata</dt> <dd>metadata defined on the typelist.<dd>
	         *     <dt>codes</dt> <dd>array of all codes on the typelist</dd>.
	         *     <dt>hasCode(codeName)</dt> <dd>Checks if typecode with the specific name is defined for the typelist.</dd>
	         *     <dt>getCode(code)</dt> <dd>returns typecode by its name. Throws an exception if no type code is defined.</dd>
	         *     <dt>getCodesForCategory(code)</dt> <dd>returns an array of codes
	         *       in a category defined by another typekey.</dd>
	         *     <dt>filters</dt> <dd>array of all type filters defined on the typelist</dd>.
	         *     <dt>getFilter(filterName)</dt> <dd>returns filter by its name. Throws an exception if filter could not be
	         *       found.</dd>
	         *     <dt>hasFilter(filterName)</dt><dd>Checks if typelist have a filter with the specific name.</dd>
	         *     <dt>xcenter</dt><dd>Reference back to the xcenter to which this dto belongs.</dd>
	         * </dl>
	         *
	         * Typecodes have following methods and properties:
	         * <dl>
	         *     <dt>code</dt><dd> code of the item</dd>
	         *     <dt>priority</dt> <dd> priority of the typecode</dd>
	         *     <dt>name</dt> <dd>(translateable) typecode name</dd>
	         *     <dt>typelist</dt> <dd>reference back to a typelist instance</dd>
	         *     <dt>belongsToCategory(code)<dt> <dd>checks if this typekey belongs to a category</dd>
	         * </dl>
	         *
	         * Each filter have following methods and properties:
	         * <dl>
	         *     <dt>name</dt> <dd>name of the filter.</dd>
	         *     <dt>codes</dt> <dd>typecodes included in the filter.</dd>
	         *     <dt>allows(typecodeOrCodeName)</dt><dd> checks if this filter has this typecode in it</dt>
	         * </dl>
	         *
	         * @param xCenter xCenter to which this typelist belongs.
	         * @param translator translator function. This function receives a display key and returns either a value (
	         * which could not be changed) or no-arg function used to fetch translated value during the runtime.
	         * @param typeName type name.
	         * @param meta typelist metadata.
	         * @param [metaType] optional meta-type definition. If present, could define some meta-properties (like
	         *   isTypelist, isDTOType, etc...)
	         * @return typelist information.
	         */
	        'createTypelistInfo': function createTypelistInfo(xCenter, translator, typeName, meta, metaType) {
	            return newTypelist(xCenter, translator, typeName, meta, metaType);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    return {
	        /** Converts a type info or function returning a type info into the property definition. */
	        toPropertyDef: function toPropertyDef(typeRef) {
	            if (_.isFunction(typeRef)) {
	                return {
	                    'get': typeRef
	                };
	            }
	
	            return {
	                'value': typeRef
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(675), __webpack_require__(676), __webpack_require__(704), __webpack_require__(670)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Metadata, MapUtil, Types, StringUtil) {
	    /**
	     * Creates a new DTO property description.
	     * @param typeLinker function used to access information about related types.
	     * @param dtoType DTO type object.
	     * @param metadata property metadata.
	     * @param name property name.
	     */
	    function createProperty(typeLinker, dtoType, metadata, name) {
	        return Object.freeze({
	            name: name,
	            jsProperty: StringUtil.lowercaseFirstLetter(name),
	            type: Types.parseType(typeLinker, metadata.valueType),
	            metadata: Metadata.createMetadata(metadata.metadata, []),
	            dtoType: dtoType,
	            readOnly: metadata.readOnly
	        });
	    }
	
	    return {
	        /**
	         * Creates a new DTO definition from its serialized form. Returned object have following
	         * properties and functions:
	         * <dl>
	         *     <dt>typeName</dt><dd>Name of the type represented by the mirror.</dd>
	         *     <dt>metadata</dt><dd>Metadata (named and unnamed) defined on the type.</dd>
	         *     <dt>properties</dt><dd>List of all properties defined on the DTO type.</dd>
	         *     <dt>hasProperty(propName)</dt><dd>Checks if property with the <code>propName</code> is defined on the DTO.</dd>
	         *     <dt>getProperty(propName)</dt><dd>Retrieves a property by its name. Throws Error if property is not found.</dd>
	         *     <dt>metaType</dt><dd>Optional meta-type of the DTO type.</dd>
	         *     <dt>xCenter</dt><dd>Reference back to the xcenter to which this dto belongs.</dd>
	         * </dl>
	         *
	         * Each property definition have following properties and methods:
	         * <dl>
	         *     <dt>name</dt><dd>Property name.</dd>
	         *     <dt>jsProperty</dt><dd>Name of the javascript property. It should be used to access this property on the
	         *       frontend.</dd>
	         *     <dt>type</dt><dd>Property type description.</dd>
	         *     <dt>metadata</dt><dd>Metadata object with information about property.</dd>
	         *     <dt>dtoType</dt><dd>Reference to the owning DTO type.</dd>
	         * </dl>
	         *
	         * @param xCenter xCenter instance for which this type belongs.
	         * @param typeLinker function used to get an access to referenced types (like types of DTO properties).
	         * @param name type name.
	         * @param metadata DTO definition to parse.
	         * @param [metaType] optional meta-type data containing information about the type (like "isDto", etc...).
	         * @return {Object} DTO type definition.
	         */
	        'createDTOInfo': function createDTOInfo(xCenter, typeLinker, name, metadata, metaType) {
	            var res = {
	                typeName: name,
	                xCenter: xCenter,
	                metadata: Metadata.createMetadata(metadata.metadata, metadata.namedMetadata)
	            };
	
	            /* PROPERTIES */
	            var propMap = _.mapObject(metadata.properties, _.partial(createProperty, typeLinker, res));
	            res.properties = _.values(propMap);
	            if (metaType) {
	                res.metaType = metaType;
	            }
	
	            /* FUNCTIONS */
	            res.hasProperty = function (propName) {
	                return _.has(propMap, propName);
	            };
	
	            res.getProperty = function (propName) {
	                var prop = MapUtil.get(propMap, propName);
	                if (!prop) {
	                    throw new Error('No property ' + propName + ' is defined on type ' + res.typeName);
	                }
	                return prop;
	            };
	
	            Object.freeze(res.properties);
	            Object.freeze(res);
	            return res;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(702), __webpack_require__(670)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, PropDef, StringUtil) {
	    /** Kind initializers. Receives resulting object, class definition and class link resolver. */
	    var kindConstructors = {
	        'primitive': function primitive(obj, def) {
	            obj.name = def.name;
	        },
	        'collection': function collection(obj, def, classResolver) {
	            obj.elementType = _parseType(classResolver, def.elementType);
	        },
	        'stringMap': function stringMap(obj, def, classResolver) {
	            obj.valueType = _parseType(classResolver, def.valueType);
	        },
	        'class': function _class(obj, def, classResolver) {
	            obj.name = def.className;
	            Object.defineProperty(obj, 'typeInfo', PropDef.toPropertyDef(classResolver(def.className)));
	        }
	    };
	
	    /** All supported type kinds. */
	    var kinds = _.keys(kindConstructors);
	
	    /**
	     * Defines kind properties on the object.
	     * @param obj object to define properties on.
	     * @param kind object (type) kind.
	     */
	    function _defineKinds(obj, kind) {
	        obj.kind = kind;
	        kinds.forEach(function (k) {
	            obj['is' + StringUtil.capitalizeFirstLetter(k)] = k === kind;
	        });
	    }
	
	    /* See parse type on exports. */
	    function _parseType(classResolver, definition) {
	        if (!kindConstructors.hasOwnProperty(definition.kind)) {
	            throw new Error('Unsupported type kind ' + definition.kind);
	        }
	        var res = {};
	        _defineKinds(res, definition.kind);
	        kindConstructors[definition.kind](res, definition, classResolver);
	        Object.freeze(res);
	
	        return res;
	    }
	
	    return {
	        /**
	         * Parses a type metadata representation and returns a "type reference" object. Type reference is more like a
	         * type name (i.e. string, edge.dto.SampleDTO, int[][]) rather than the type information ("this type have
	         * these properties").
	         *
	         * Common functions/properties (applicable for each kind of types) are:
	         * <dl>
	         *     <dt>kind</dt> <dd>Kind of the type (class, collection, primitive, stringMap).</dd>
	         *     <dt>isClass, isCollection, isPrimitive, isStringMap</dt> <dd>Properties used to verify if dto have
	         *       a corresponding kind. Equivalent to "kind === ..."<dd>
	         * </dl>
	         *
	         * Depending on the type, there could be additional properties. They are (for the appropriate kinds):
	         * <dl>
	         *     <dt>primitive</dt><dd><dl>
	         *         <dt>name</dt><dd> name of the primitive type</dd>
	         *     </dl></dd>
	         *     <dt>collection</dt><dd><dl>
	         *         <dt>elementType</dt><dd> type of the element in the collection</dd>
	         *     </dl></dd>
	         *     <dt>stringMap</dt><dd><dl>
	         *         <dt>valueType</dt><dd> type of the value in the map</dd>
	         *     </dl></dd>
	         *     <dt>class</dt><dd><dl>
	         *         <dt>name</dt><dd> name of the class</dd>
	         *         <dt>typeInfo</dt><dd> metadata about the referenced type (class mirror).</dd>
	         *     </dl></dd>
	         * </dl>
	         *
	         * @param classResolver function used to access "referenced class" in the type hierarchy. It could return
	         * either:
	         * <ul>
	         *     <li>No-arg function which returns a type metadata (lazy initialization).
	         *     <li>Non-functional value describing the destination type.
	         * </ul>
	         * This style allows the <code>classResolver</code> to validate type name before the type metadata is
	         * constructed.
	         * @param definition type definition (taken from the metadata).
	         */
	        'parseType': _parseType,
	
	        /**
	         * Creates a type info factory using class data resolver.
	         */
	        'createFactory': function createFactory(classResolver) {
	            return _.partial(_parseType, classResolver);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 705 */
/***/ function(module, exports) {

	module.exports = "{\n    \"pc\": {\n        \"edge.capabilities.quote.dto.QuoteRetrievalDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"UserName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ExternalUser\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PostalCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[0-9]{5}(-[0-9]{4})?\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.PostalCode\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"agentportalnewsubmission\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"UserProductAttributes\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"primitive\",\n                                \"name\": \"String\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.dto.QuoteDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"QuoteData\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.quoting.dto.QuotingDTO\"\n                        },\n                        \"metadata\": [],\n                        \"readOnly\": true\n                    },\n                    \"SessionUUID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BindData\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.binding.dto.BindingDataDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PolicyPeriodStatus\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DraftData\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.draft.dto.DraftDataDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsSubmitAgent\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.mailing.dto.QuoteEmailDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"QuoteID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SessionID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.draft.dto.DraftDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"InsuranceScoreLabel\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProductName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProductCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyQuotePaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PreQualQuestionSets\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.questionset.dto.QuestionSetAnswersDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ESignature\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"aaa.edge.capabilities.policycommon.esign.dto.ESignatureDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyInfoPaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"AddressLine1\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"PeriodEndDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 0\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FutureDate\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PeriodStartDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"or\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"not\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsSubmitAgent\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": false\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"not\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"trimToMidnight\",\n                                                                \"params\": [\n                                                                    {\n                                                                        \"kind\": \"nativecall\",\n                                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                                        \"name\": \"currentDate\",\n                                                                        \"params\": []\n                                                                    }\n                                                                ]\n                                                            },\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"trimToMidnight\",\n                                                                \"params\": [\n                                                                    {\n                                                                        \"kind\": \"parameter\",\n                                                                        \"index\": 0\n                                                                    }\n                                                                ]\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.WithIn30Days\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"or\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"not\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsSubmitAgent\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": false\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                        \"name\": \"compareDate\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"addHours\",\n                                                                \"params\": [\n                                                                    {\n                                                                        \"kind\": \"nativecall\",\n                                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                                        \"name\": \"currentDate\",\n                                                                        \"params\": []\n                                                                    },\n                                                                    {\n                                                                        \"kind\": \"const\",\n                                                                        \"type\": \"int\",\n                                                                        \"value\": 720\n                                                                    }\n                                                                ]\n                                                            },\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": -1\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.WithIn30Days\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \"edge.capabilities.locale.util.DateFormatter\",\n                                                \"name\": \"formatShortDate\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"addHours\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 720\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TermType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.TermType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NcVoilations\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"primitive\",\n                                \"name\": \"String\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyInfoDocumentDeliveryMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DocumentDeliveryType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Lobs\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.dto.DraftLobDataDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ScVoilations\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"primitive\",\n                                \"name\": \"String\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsSubmitAgent\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InsuranceScore\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InsuranceScoreAgreed\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"retrievePrevCarrierInfo\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"aaa.edge.capabilities.policycommon.prefill.dto.RetrievePrevCarrierInfoDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountHolder\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"DateOfBirth\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ],\n                                    \"when\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"ProductCode\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"PersonalAuto\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                        \"name\": \"getContextValue\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 2\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"AccountDOBRequired\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PortalType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PortalType_aaa\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [\n                    {\n                        \"type\": \"edge.aspects.validation.dto.ContextDTO\",\n                        \"value\": {\n                            \"name\": \"policyCountry\",\n                            \"expression\": {\n                                \"kind\": \"getfield\",\n                                \"base\": {\n                                    \"kind\": \"getfield\",\n                                    \"base\": {\n                                        \"kind\": \"parameter\",\n                                        \"index\": 0\n                                    },\n                                    \"propertyName\": \"PolicyAddress\"\n                                },\n                                \"propertyName\": \"Country\"\n                            }\n                        }\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.quoting.dto.QuotingDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"OfferedQuotes\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.quoting.dto.QuoteDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.binding.dto.BindingDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PrimaryPhoneType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PrimaryPhoneType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WarningMessage\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DocumentSign\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"aaa.edge.capabilities.policycommon.esign.dto.ESignDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyQuotePaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AllPaymentPlans\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.binding.dto.PaymentPlanDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"FinanceCompanyName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyInfoPaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChosenQuote\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ContactPhone\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BillingAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"AddressLine1\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"PaymentPlans\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.binding.dto.PaymentPlanDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"OwnershipAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ContactEmail\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PaymentDetails\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.binding.dto.PaymentDetailsDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"UWCompanyCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SelectedPaymentPlan\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LeaseCompanyName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"UWCompanyName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PolicyPeriodStatus\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Draft\",\n                        \"priority\": 0,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Draft\"\n                    },\n                    {\n                        \"code\": \"Temporary\",\n                        \"priority\": 0,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Temporary\"\n                    },\n                    {\n                        \"code\": \"Withdrawn\",\n                        \"priority\": 0,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Withdrawn\"\n                    },\n                    {\n                        \"code\": \"Declined\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Declination\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Declined\"\n                    },\n                    {\n                        \"code\": \"Expired\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Expired\"\n                    },\n                    {\n                        \"code\": \"New\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.New\"\n                    },\n                    {\n                        \"code\": \"NonRenewing\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.NonRenewing\"\n                    },\n                    {\n                        \"code\": \"Quoted\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Quoted\"\n                    },\n                    {\n                        \"code\": \"Quoting\",\n                        \"priority\": 15,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Quoting\"\n                    },\n                    {\n                        \"code\": \"Binding\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Binding\"\n                    },\n                    {\n                        \"code\": \"Bound\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Bound\"\n                    },\n                    {\n                        \"code\": \"Canceling\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Canceling\"\n                    },\n                    {\n                        \"code\": \"AuditComplete\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.AuditComplete\"\n                    },\n                    {\n                        \"code\": \"NonRenewed\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.NonRenewed\"\n                    },\n                    {\n                        \"code\": \"NotTaken\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"NotTakenAck\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.NotTaken\"\n                    },\n                    {\n                        \"code\": \"NotTaking\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"NotTakenAck\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.NotTaking\"\n                    },\n                    {\n                        \"code\": \"Reinstating\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Reinstating\"\n                    },\n                    {\n                        \"code\": \"Renewing\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"LetterType\",\n                                \"typecode\": \"Confirmation\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Renewing\"\n                    },\n                    {\n                        \"code\": \"Rescinded\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Rescinded\"\n                    },\n                    {\n                        \"code\": \"Rescinding\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Rescinding\"\n                    },\n                    {\n                        \"code\": \"Waived\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.Waived\"\n                    },\n                    {\n                        \"code\": \"LegacyConversion\",\n                        \"priority\": 25,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyPeriodStatus.LegacyConversion\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"Closed\",\n                        \"includedCodes\": [\n                            \"Withdrawn\",\n                            \"Declined\",\n                            \"Expired\",\n                            \"Bound\",\n                            \"AuditComplete\",\n                            \"NonRenewed\",\n                            \"NotTaken\",\n                            \"Rescinded\",\n                            \"Waived\",\n                            \"LegacyConversion\"\n                        ]\n                    },\n                    {\n                        \"name\": \"IneligibleForTotalCostCalculations\",\n                        \"includedCodes\": [\n                            \"Temporary\",\n                            \"Withdrawn\",\n                            \"Declined\",\n                            \"Expired\",\n                            \"NotTaken\"\n                        ]\n                    },\n                    {\n                        \"name\": \"Open\",\n                        \"includedCodes\": [\n                            \"Draft\",\n                            \"New\",\n                            \"NonRenewing\",\n                            \"Quoted\",\n                            \"Quoting\",\n                            \"Binding\",\n                            \"Canceling\",\n                            \"NotTaking\",\n                            \"Reinstating\",\n                            \"Renewing\",\n                            \"Rescinding\"\n                        ]\n                    },\n                    {\n                        \"name\": \"Expirable\",\n                        \"includedCodes\": [\n                            \"Draft\",\n                            \"New\",\n                            \"Quoted\"\n                        ]\n                    },\n                    {\n                        \"name\": \"Copyable\",\n                        \"includedCodes\": [\n                            \"Declined\",\n                            \"Expired\",\n                            \"NotTaken\"\n                        ]\n                    },\n                    {\n                        \"name\": \"Posted\",\n                        \"includedCodes\": [\n                            \"Bound\",\n                            \"AuditComplete\"\n                        ]\n                    },\n                    {\n                        \"name\": \"Closing\",\n                        \"includedCodes\": [\n                            \"NonRenewing\",\n                            \"Binding\",\n                            \"Canceling\",\n                            \"NotTaking\",\n                            \"Reinstating\",\n                            \"Renewing\",\n                            \"Rescinding\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PrimaryPhoneType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PrimaryPhoneType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsNew\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MembershipStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.MembershipStatus_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EmailAddress1\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsNew\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"EmailExist\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Gender\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.GenderType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"isCreditUnionMember\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Particle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AgeLimit\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsFairCreditReportingAct\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TempID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FaxNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PayGrade\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PayGrade_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"Occupation\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey Occupation_aaa\",\n                                                        \"value\": \"military\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ProducerCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                        \"name\": \"getContextValue\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 2\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"ProducerCodeRequired\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsAddressOverridden\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.time.LocalDateUtil\",\n                                        \"name\": \"isValidAge\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"AgeLimit\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.ValidAge\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"AgeLimit\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PrimaryContactName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LastNameKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EmailExist\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Jurisdiction\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MaritalStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.MaritalStatus\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Suffix\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NameSuffix\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WorkNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryPhoneType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey PrimaryPhoneType\",\n                                                        \"value\": \"work\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LastName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"Subtype\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"Person\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Subtype\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            }\n                        ]\n                    },\n                    \"FirstNameKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PrimaryAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"AddressLine1\",\n                                        \"PostalCode\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"Prefix\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NamePrefix\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MembershipNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsNew\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsMember\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [],\n                        \"readOnly\": true\n                    },\n                    \"DummyProperty\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountHolder\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MarkedForDelete\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EducationalLevel\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.EducationLevel_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsNew\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"FirstName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"Subtype\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"Person\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MembershipType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.MembershipType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteAsAAAMember\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MiddleName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"joinedYearCreditUnionMembership\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"isCreditUnionMember\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"qnbSource\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HomeNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryPhoneType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey PrimaryPhoneType\",\n                                                        \"value\": \"home\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AccountExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Occupation\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Occupation_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ContactNameKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"JoinedYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ContactName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"Subtype\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"Company\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CellNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryPhoneType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey PrimaryPhoneType\",\n                                                        \"value\": \"mobile\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.address.dto.AddressDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PostalCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[0-9]{5}(-[0-9]{4})?\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.PostalCode\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine2Kanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"NOT_SET\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Null\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"City\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CityKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"County\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsAutofilled\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressLine3\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressLine2\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine1\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"State\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"Country\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"getfield\",\n                                        \"base\": {\n                                            \"kind\": \"parameter\",\n                                            \"index\": 1\n                                        },\n                                        \"propertyName\": \"Country\"\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Country\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Country\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine1Kanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"NOT_SET\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Null\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AddressType\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.questionset.dto.QuestionSetAnswersDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Answers\": {\n                        \"valueType\": {\n                            \"kind\": \"stringMap\",\n                            \"valueType\": {\n                                \"kind\": \"primitive\",\n                                \"name\": \"String\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Code\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.dto.DraftLobDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PersonalAuto\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.PaDraftDataExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Homeowners\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.draft.dto.HoDraftDataExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CommercialProperty\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.commercialproperty.draft.dto.CpDraftDataExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.TermType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Annual\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.TermType.Annual\"\n                    },\n                    {\n                        \"code\": \"HalfYear\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.TermType.HalfYear\"\n                    },\n                    {\n                        \"code\": \"ThreeYear\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.TermType.ThreeYear\"\n                    },\n                    {\n                        \"code\": \"Other\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.TermType.Other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"aaa.edge.capabilities.policycommon.esign.dto.ESignatureDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"QuoteNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ESignedName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ESignedDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IpAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ESignAgreed\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EmailAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"aaa.edge.capabilities.policycommon.prefill.dto.RetrievePrevCarrierInfoDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PriorBILimits\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PriorBILimits_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PrevPolicyStatus_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PortalStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InsuranceCarriers\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.InsuranceCarriers\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PaymentMethod_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"paid_in_full\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod_aaa.paid_in_full\"\n                    },\n                    {\n                        \"code\": \"billbymail\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod_aaa.billbymail\"\n                    },\n                    {\n                        \"code\": \"recurring\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod_aaa.recurring\"\n                    },\n                    {\n                        \"code\": \"bill_mortgagee\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod_aaa.bill_mortgagee\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"PaymntMethod_PaymntInfo\",\n                        \"includedCodes\": [\n                            \"billbymail\",\n                            \"recurring\"\n                        ]\n                    },\n                    {\n                        \"name\": \"PaymntMethod_PAPolicyInfo\",\n                        \"includedCodes\": [\n                            \"paid_in_full\",\n                            \"billbymail\",\n                            \"recurring\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DocumentDeliveryType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"email\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentDeliveryType_aaa.email\"\n                    },\n                    {\n                        \"code\": \"mail\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentDeliveryType_aaa.mail\"\n                    },\n                    {\n                        \"code\": \"emailandmail\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentDeliveryType_aaa.emailandmail\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PortalType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"AM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.AM\"\n                    },\n                    {\n                        \"code\": \"EZLynx\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.EZLynx\"\n                    },\n                    {\n                        \"code\": \"GPA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.GPA\"\n                    },\n                    {\n                        \"code\": \"Jenesis\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.Jenesis\"\n                    },\n                    {\n                        \"code\": \"LeadCloud\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.LeadCloud\"\n                    },\n                    {\n                        \"code\": \"PC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.PC\"\n                    },\n                    {\n                        \"code\": \"PLRater\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.PLRater\"\n                    },\n                    {\n                        \"code\": \"QB\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.QB\"\n                    },\n                    {\n                        \"code\": \"Turborater\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PortalType_aaa.Turborater\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.quoting.dto.QuoteDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"TermMonths\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"QuoteID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsCustom\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Discounts\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"aaa.edge.capabilities.policycommon.discounts.dto.DiscountsDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"TotalBeforeTaxes\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PeriodEndDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 0\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FutureDate\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PeriodStartDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"trimToMidnight\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 0\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FutureDate\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Lobs\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.dto.QuoteLobDataDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MonthlyPremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Taxes\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Total\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BranchName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BranchCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.binding.dto.PaymentPlanDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Installment\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BillingId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Total\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InvoiceFrequency\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BillingPeriodicity\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DownPayment\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NumberOfInstallments\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.binding.dto.PaymentDetailsDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"BankAccountData\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.binding.dto.BankDetailsDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CreditCardData\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.binding.dto.CreditCardDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PaymentFrequency\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentFrequency_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChequeNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PaymentMethod\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"cheque\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PaymentType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"paymentEffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"aaa.edge.capabilities.policycommon.esign.dto.ESignDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"DocumentSignOptions\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DocumentSignOptions_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EmailAddressRe\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"DocumentSignOptions\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey DocumentSignOptions_aaa\",\n                                                        \"value\": \"electronicsignature\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"eq\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"EmailAddress\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.The email address entered does not match. Please re-enter to proceed.\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EmailAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"DocumentSignOptions\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey DocumentSignOptions_aaa\",\n                                                        \"value\": \"electronicsignature\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PrimaryPhoneType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"work\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"Person\"\n                            },\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"Company\"\n                            },\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"UserContact\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PrimaryPhoneType.work\"\n                    },\n                    {\n                        \"code\": \"home\",\n                        \"priority\": 2,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"Person\"\n                            },\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"Company\"\n                            },\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"UserContact\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PrimaryPhoneType.home\"\n                    },\n                    {\n                        \"code\": \"mobile\",\n                        \"priority\": 3,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"Person\"\n                            },\n                            {\n                                \"typelist\": \"Contact\",\n                                \"typecode\": \"UserContact\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PrimaryPhoneType.mobile\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.LetterType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Confirmation\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.LetterType.Confirmation\"\n                    },\n                    {\n                        \"code\": \"Declination\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.LetterType.Declination\"\n                    },\n                    {\n                        \"code\": \"NotTakenAck\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.LetterType.NotTakenAck\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.time.LocalDateDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Month\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Min\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 11\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Max\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 11\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Min\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 5000\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Max\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 5000\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Day\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Min\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 1\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"edge.time.LocalDateUtil\",\n                                                        \"name\": \"daysInLocalDate\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"parameter\",\n                                                                \"index\": 1\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Max\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \"edge.time.LocalDateUtil\",\n                                                \"name\": \"daysInLocalDate\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 1\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Occupation_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"aaaemployee\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.aaaemployee\"\n                    },\n                    {\n                        \"code\": \"accountantcpaauditor\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.accountantcpaauditor\"\n                    },\n                    {\n                        \"code\": \"attorney\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.attorney\"\n                    },\n                    {\n                        \"code\": \"claimadjuster\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.claimadjuster\"\n                    },\n                    {\n                        \"code\": \"clergyministerpastor\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.clergyministerpastor\"\n                    },\n                    {\n                        \"code\": \"childcarecenteremp\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.childcarecenteremp\"\n                    },\n                    {\n                        \"code\": \"chiropractor\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.chiropractor\"\n                    },\n                    {\n                        \"code\": \"dentistdentalofcemp\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.dentistdentalofcemp\"\n                    },\n                    {\n                        \"code\": \"educator\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.educator\"\n                    },\n                    {\n                        \"code\": \"engineer\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.engineer\"\n                    },\n                    {\n                        \"code\": \"farmer\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.farmer\"\n                    },\n                    {\n                        \"code\": \"homemaker\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.homemaker\"\n                    },\n                    {\n                        \"code\": \"govtemployee\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.govtemployee\"\n                    },\n                    {\n                        \"code\": \"insuranceagentbroker\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.insuranceagentbroker\"\n                    },\n                    {\n                        \"code\": \"lawenforcementpersonnel\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.lawenforcementpersonnel\"\n                    },\n                    {\n                        \"code\": \"medicalprofessional\",\n                        \"priority\": 160,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.medicalprofessional\"\n                    },\n                    {\n                        \"code\": \"military\",\n                        \"priority\": 170,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.military\"\n                    },\n                    {\n                        \"code\": \"realestateagentbroker\",\n                        \"priority\": 180,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.realestateagentbroker\"\n                    },\n                    {\n                        \"code\": \"retired\",\n                        \"priority\": 190,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.retired\"\n                    },\n                    {\n                        \"code\": \"selfemployed\",\n                        \"priority\": 200,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.selfemployed\"\n                    },\n                    {\n                        \"code\": \"studentfulltime\",\n                        \"priority\": 210,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.studentfulltime\"\n                    },\n                    {\n                        \"code\": \"studentgpa3orabove\",\n                        \"priority\": 220,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.studentgpa3orabove\"\n                    },\n                    {\n                        \"code\": \"othersnotlisted\",\n                        \"priority\": 230,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.othersnotlisted\"\n                    },\n                    {\n                        \"code\": \"studentawaymorethan100mi\",\n                        \"priority\": 240,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Occupation_aaa.studentawaymorethan100mi\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PayGrade_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"e1\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e1\"\n                    },\n                    {\n                        \"code\": \"e2\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e2\"\n                    },\n                    {\n                        \"code\": \"e3\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e3\"\n                    },\n                    {\n                        \"code\": \"e4\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e4\"\n                    },\n                    {\n                        \"code\": \"e5\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e5\"\n                    },\n                    {\n                        \"code\": \"e6\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e6\"\n                    },\n                    {\n                        \"code\": \"e7\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e7\"\n                    },\n                    {\n                        \"code\": \"e8\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e8\"\n                    },\n                    {\n                        \"code\": \"e9\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.e9\"\n                    },\n                    {\n                        \"code\": \"01\",\n                        \"priority\": 95,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.01\"\n                    },\n                    {\n                        \"code\": \"02\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.02\"\n                    },\n                    {\n                        \"code\": \"03\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.03\"\n                    },\n                    {\n                        \"code\": \"04\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.04\"\n                    },\n                    {\n                        \"code\": \"05\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.05\"\n                    },\n                    {\n                        \"code\": \"06\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.06\"\n                    },\n                    {\n                        \"code\": \"07\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.07\"\n                    },\n                    {\n                        \"code\": \"08\",\n                        \"priority\": 160,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.08\"\n                    },\n                    {\n                        \"code\": \"09\",\n                        \"priority\": 170,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.09\"\n                    },\n                    {\n                        \"code\": \"010\",\n                        \"priority\": 180,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.010\"\n                    },\n                    {\n                        \"code\": \"w1\",\n                        \"priority\": 190,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.w1\"\n                    },\n                    {\n                        \"code\": \"w2\",\n                        \"priority\": 200,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.w2\"\n                    },\n                    {\n                        \"code\": \"w3\",\n                        \"priority\": 210,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.w3\"\n                    },\n                    {\n                        \"code\": \"w4\",\n                        \"priority\": 220,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.w4\"\n                    },\n                    {\n                        \"code\": \"w5\",\n                        \"priority\": 230,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PayGrade_aaa.w5\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.GenderType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"F\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.GenderType.F\"\n                    },\n                    {\n                        \"code\": \"M\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.GenderType.M\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.NamePrefix\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"mr\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NamePrefix.mr\"\n                    },\n                    {\n                        \"code\": \"mrs\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NamePrefix.mrs\"\n                    },\n                    {\n                        \"code\": \"ms\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NamePrefix.ms\"\n                    },\n                    {\n                        \"code\": \"dr\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NamePrefix.dr\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.NameSuffix\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"jr\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NameSuffix.jr\"\n                    },\n                    {\n                        \"code\": \"sr\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NameSuffix.sr\"\n                    },\n                    {\n                        \"code\": \"c_II\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NameSuffix.c_II\"\n                    },\n                    {\n                        \"code\": \"c_III\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NameSuffix.c_III\"\n                    },\n                    {\n                        \"code\": \"c_IV\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NameSuffix.c_IV\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Jurisdiction\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"NC\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"veh_dmv_reporting_inx\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NC\"\n                    },\n                    {\n                        \"code\": \"SC\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"fr_dmv_reporting_inx\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.SC\"\n                    },\n                    {\n                        \"code\": \"AU_ACT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_ACT\"\n                    },\n                    {\n                        \"code\": \"AL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AL\"\n                    },\n                    {\n                        \"code\": \"AK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AK\"\n                    },\n                    {\n                        \"code\": \"AB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AB\"\n                    },\n                    {\n                        \"code\": \"AZ\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AZ\"\n                    },\n                    {\n                        \"code\": \"AR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AR\"\n                    },\n                    {\n                        \"code\": \"DE_BW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_BW\"\n                    },\n                    {\n                        \"code\": \"DE_BY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_BY\"\n                    },\n                    {\n                        \"code\": \"DE_BE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_BE\"\n                    },\n                    {\n                        \"code\": \"DE_BB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_BB\"\n                    },\n                    {\n                        \"code\": \"DE_HB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_HB\"\n                    },\n                    {\n                        \"code\": \"BC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.BC\"\n                    },\n                    {\n                        \"code\": \"CA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.CA\"\n                    },\n                    {\n                        \"code\": \"CO\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.CO\"\n                    },\n                    {\n                        \"code\": \"CT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.CT\"\n                    },\n                    {\n                        \"code\": \"DE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE\"\n                    },\n                    {\n                        \"code\": \"DC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DC\"\n                    },\n                    {\n                        \"code\": \"FM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.FM\"\n                    },\n                    {\n                        \"code\": \"FL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.FL\"\n                    },\n                    {\n                        \"code\": \"FR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"FR\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.FR\"\n                    },\n                    {\n                        \"code\": \"GA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.GA\"\n                    },\n                    {\n                        \"code\": \"GU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.GU\"\n                    },\n                    {\n                        \"code\": \"DE_HH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_HH\"\n                    },\n                    {\n                        \"code\": \"HI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.HI\"\n                    },\n                    {\n                        \"code\": \"DE_HE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_HE\"\n                    },\n                    {\n                        \"code\": \"ID\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.ID\"\n                    },\n                    {\n                        \"code\": \"IL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.IL\"\n                    },\n                    {\n                        \"code\": \"IN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.IN\"\n                    },\n                    {\n                        \"code\": \"IA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.IA\"\n                    },\n                    {\n                        \"code\": \"AU_JBT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_JBT\"\n                    },\n                    {\n                        \"code\": \"JP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.JP\"\n                    },\n                    {\n                        \"code\": \"KS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.KS\"\n                    },\n                    {\n                        \"code\": \"KY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.KY\"\n                    },\n                    {\n                        \"code\": \"LA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.LA\"\n                    },\n                    {\n                        \"code\": \"DE_NI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_NI\"\n                    },\n                    {\n                        \"code\": \"ME\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.ME\"\n                    },\n                    {\n                        \"code\": \"MB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MB\"\n                    },\n                    {\n                        \"code\": \"MH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MH\"\n                    },\n                    {\n                        \"code\": \"MD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MD\"\n                    },\n                    {\n                        \"code\": \"MA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MA\"\n                    },\n                    {\n                        \"code\": \"DE_MV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_MV\"\n                    },\n                    {\n                        \"code\": \"MI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MI\"\n                    },\n                    {\n                        \"code\": \"MN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MN\"\n                    },\n                    {\n                        \"code\": \"MS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MS\"\n                    },\n                    {\n                        \"code\": \"MO\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MO\"\n                    },\n                    {\n                        \"code\": \"MT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MT\"\n                    },\n                    {\n                        \"code\": \"NE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NE\"\n                    },\n                    {\n                        \"code\": \"NV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NV\"\n                    },\n                    {\n                        \"code\": \"NB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NB\"\n                    },\n                    {\n                        \"code\": \"NH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NH\"\n                    },\n                    {\n                        \"code\": \"NJ\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NJ\"\n                    },\n                    {\n                        \"code\": \"NM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NM\"\n                    },\n                    {\n                        \"code\": \"AU_NSW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_NSW\"\n                    },\n                    {\n                        \"code\": \"NY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NY\"\n                    },\n                    {\n                        \"code\": \"NL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NL\"\n                    },\n                    {\n                        \"code\": \"ND\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.ND\"\n                    },\n                    {\n                        \"code\": \"DE_NW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_NW\"\n                    },\n                    {\n                        \"code\": \"MP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.MP\"\n                    },\n                    {\n                        \"code\": \"AU_NT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_NT\"\n                    },\n                    {\n                        \"code\": \"NT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NT\"\n                    },\n                    {\n                        \"code\": \"NS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NS\"\n                    },\n                    {\n                        \"code\": \"NU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.NU\"\n                    },\n                    {\n                        \"code\": \"OH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.OH\"\n                    },\n                    {\n                        \"code\": \"OK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.OK\"\n                    },\n                    {\n                        \"code\": \"ON\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.ON\"\n                    },\n                    {\n                        \"code\": \"OR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.OR\"\n                    },\n                    {\n                        \"code\": \"PA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.PA\"\n                    },\n                    {\n                        \"code\": \"PE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.PE\"\n                    },\n                    {\n                        \"code\": \"PR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.PR\"\n                    },\n                    {\n                        \"code\": \"QC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.QC\"\n                    },\n                    {\n                        \"code\": \"AU_QLD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_QLD\"\n                    },\n                    {\n                        \"code\": \"DE_RP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_RP\"\n                    },\n                    {\n                        \"code\": \"RI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.RI\"\n                    },\n                    {\n                        \"code\": \"DE_SL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_SL\"\n                    },\n                    {\n                        \"code\": \"SK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.SK\"\n                    },\n                    {\n                        \"code\": \"DE_SN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_SN\"\n                    },\n                    {\n                        \"code\": \"DE_ST\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_ST\"\n                    },\n                    {\n                        \"code\": \"DE_SH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_SH\"\n                    },\n                    {\n                        \"code\": \"AU_SA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_SA\"\n                    },\n                    {\n                        \"code\": \"SD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.SD\"\n                    },\n                    {\n                        \"code\": \"AU_TAS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_TAS\"\n                    },\n                    {\n                        \"code\": \"TN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.TN\"\n                    },\n                    {\n                        \"code\": \"TX\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.TX\"\n                    },\n                    {\n                        \"code\": \"DE_TH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.DE_TH\"\n                    },\n                    {\n                        \"code\": \"GB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"GB\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.GB\"\n                    },\n                    {\n                        \"code\": \"UT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.UT\"\n                    },\n                    {\n                        \"code\": \"VT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.VT\"\n                    },\n                    {\n                        \"code\": \"AU_VIC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_VIC\"\n                    },\n                    {\n                        \"code\": \"VI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.VI\"\n                    },\n                    {\n                        \"code\": \"VA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.VA\"\n                    },\n                    {\n                        \"code\": \"WA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.WA\"\n                    },\n                    {\n                        \"code\": \"WV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.WV\"\n                    },\n                    {\n                        \"code\": \"AU_WA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.AU_WA\"\n                    },\n                    {\n                        \"code\": \"WI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.WI\"\n                    },\n                    {\n                        \"code\": \"WY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.WY\"\n                    },\n                    {\n                        \"code\": \"YT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"insurance\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"driving_lic\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"vehicle_reg\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"ins_tax\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"cons_tax\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Jurisdiction.YT\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"CarolinaStates_aaa\",\n                        \"includedCodes\": [\n                            \"NC\",\n                            \"SC\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.MaritalStatus\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"S\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MaritalStatus.S\"\n                    },\n                    {\n                        \"code\": \"M\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MaritalStatus.M\"\n                    },\n                    {\n                        \"code\": \"C\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MaritalStatus.C\"\n                    },\n                    {\n                        \"code\": \"D\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MaritalStatus.D\"\n                    },\n                    {\n                        \"code\": \"W\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MaritalStatus.W\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.MembershipStatus_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"active\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipStatus_aaa.active\"\n                    },\n                    {\n                        \"code\": \"inactive\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipStatus_aaa.inactive\"\n                    },\n                    {\n                        \"code\": \"lapsed\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipStatus_aaa.lapsed\"\n                    },\n                    {\n                        \"code\": \"pending\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipStatus_aaa.pending\"\n                    },\n                    {\n                        \"code\": \"renewal\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipStatus_aaa.renewal\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.MembershipType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"basic\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipType_aaa.basic\"\n                    },\n                    {\n                        \"code\": \"plus\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipType_aaa.plus\"\n                    },\n                    {\n                        \"code\": \"plusrv\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipType_aaa.plusrv\"\n                    },\n                    {\n                        \"code\": \"premier\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipType_aaa.premier\"\n                    },\n                    {\n                        \"code\": \"premierrv\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.MembershipType_aaa.premierrv\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.EducationLevel_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"highschool\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.highschool\"\n                    },\n                    {\n                        \"code\": \"associate\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.associate\"\n                    },\n                    {\n                        \"code\": \"bachelor\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.bachelor\"\n                    },\n                    {\n                        \"code\": \"master\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.master\"\n                    },\n                    {\n                        \"code\": \"phd\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.phd\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.EducationLevel_aaa.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.State\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Hokkaido\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Hokkaido\"\n                    },\n                    {\n                        \"code\": \"NC\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NC\"\n                            },\n                            {\n                                \"typelist\": \"JurisdictionType\",\n                                \"typecode\": \"veh_dmv_reporting_inx\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NC\"\n                    },\n                    {\n                        \"code\": \"Aomori\",\n                        \"priority\": 2,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Aomori\"\n                    },\n                    {\n                        \"code\": \"SC\",\n                        \"priority\": 2,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"SC\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.SC\"\n                    },\n                    {\n                        \"code\": \"Iwate\",\n                        \"priority\": 3,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Iwate\"\n                    },\n                    {\n                        \"code\": \"Miyagi\",\n                        \"priority\": 4,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Miyagi\"\n                    },\n                    {\n                        \"code\": \"Akita\",\n                        \"priority\": 5,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Akita\"\n                    },\n                    {\n                        \"code\": \"Yamagata\",\n                        \"priority\": 6,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Yamagata\"\n                    },\n                    {\n                        \"code\": \"Fukushima\",\n                        \"priority\": 7,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Fukushima\"\n                    },\n                    {\n                        \"code\": \"Ibaraki\",\n                        \"priority\": 8,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Ibaraki\"\n                    },\n                    {\n                        \"code\": \"AU_JBT\",\n                        \"priority\": 9,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_JBT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_JBT\"\n                    },\n                    {\n                        \"code\": \"Tochigi\",\n                        \"priority\": 9,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Tochigi\"\n                    },\n                    {\n                        \"code\": \"Gumma\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Gumma\"\n                    },\n                    {\n                        \"code\": \"Saitama\",\n                        \"priority\": 11,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Saitama\"\n                    },\n                    {\n                        \"code\": \"Chiba\",\n                        \"priority\": 12,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Chiba\"\n                    },\n                    {\n                        \"code\": \"Tokyo\",\n                        \"priority\": 13,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Tokyo\"\n                    },\n                    {\n                        \"code\": \"Kanagawa\",\n                        \"priority\": 14,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kanagawa\"\n                    },\n                    {\n                        \"code\": \"Niigata\",\n                        \"priority\": 15,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Niigata\"\n                    },\n                    {\n                        \"code\": \"Toyama\",\n                        \"priority\": 16,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Toyama\"\n                    },\n                    {\n                        \"code\": \"Ishikawa\",\n                        \"priority\": 17,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Ishikawa\"\n                    },\n                    {\n                        \"code\": \"Fukui\",\n                        \"priority\": 18,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Fukui\"\n                    },\n                    {\n                        \"code\": \"Yamanashi\",\n                        \"priority\": 19,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Yamanashi\"\n                    },\n                    {\n                        \"code\": \"Nagano\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Nagano\"\n                    },\n                    {\n                        \"code\": \"Gifu\",\n                        \"priority\": 21,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Gifu\"\n                    },\n                    {\n                        \"code\": \"Shizuoka\",\n                        \"priority\": 22,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Shizuoka\"\n                    },\n                    {\n                        \"code\": \"Aichi\",\n                        \"priority\": 23,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Aichi\"\n                    },\n                    {\n                        \"code\": \"Mie\",\n                        \"priority\": 24,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Mie\"\n                    },\n                    {\n                        \"code\": \"Shiga\",\n                        \"priority\": 25,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Shiga\"\n                    },\n                    {\n                        \"code\": \"Kyoto\",\n                        \"priority\": 26,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kyoto\"\n                    },\n                    {\n                        \"code\": \"Osaka\",\n                        \"priority\": 27,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Osaka\"\n                    },\n                    {\n                        \"code\": \"Hyogo\",\n                        \"priority\": 28,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Hyogo\"\n                    },\n                    {\n                        \"code\": \"Nara\",\n                        \"priority\": 29,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Nara\"\n                    },\n                    {\n                        \"code\": \"Wakayama\",\n                        \"priority\": 30,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Wakayama\"\n                    },\n                    {\n                        \"code\": \"Tottori\",\n                        \"priority\": 31,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Tottori\"\n                    },\n                    {\n                        \"code\": \"Shimane\",\n                        \"priority\": 32,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Shimane\"\n                    },\n                    {\n                        \"code\": \"Okayama\",\n                        \"priority\": 33,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Okayama\"\n                    },\n                    {\n                        \"code\": \"Hiroshima\",\n                        \"priority\": 34,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Hiroshima\"\n                    },\n                    {\n                        \"code\": \"Yamaguchi\",\n                        \"priority\": 35,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Yamaguchi\"\n                    },\n                    {\n                        \"code\": \"Tokushima\",\n                        \"priority\": 36,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Tokushima\"\n                    },\n                    {\n                        \"code\": \"Kagawa\",\n                        \"priority\": 37,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kagawa\"\n                    },\n                    {\n                        \"code\": \"Ehime\",\n                        \"priority\": 38,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Ehime\"\n                    },\n                    {\n                        \"code\": \"Kochi\",\n                        \"priority\": 39,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kochi\"\n                    },\n                    {\n                        \"code\": \"Fukuoka\",\n                        \"priority\": 40,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Fukuoka\"\n                    },\n                    {\n                        \"code\": \"Saga\",\n                        \"priority\": 41,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Saga\"\n                    },\n                    {\n                        \"code\": \"Nagasaki\",\n                        \"priority\": 42,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Nagasaki\"\n                    },\n                    {\n                        \"code\": \"Kumamoto\",\n                        \"priority\": 43,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kumamoto\"\n                    },\n                    {\n                        \"code\": \"Oita\",\n                        \"priority\": 44,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Oita\"\n                    },\n                    {\n                        \"code\": \"Miyazaki\",\n                        \"priority\": 45,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Miyazaki\"\n                    },\n                    {\n                        \"code\": \"Kagoshima\",\n                        \"priority\": 46,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Kagoshima\"\n                    },\n                    {\n                        \"code\": \"Okinawa\",\n                        \"priority\": 47,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"JP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.Okinawa\"\n                    },\n                    {\n                        \"code\": \"AU_ACT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_ACT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_ACT\"\n                    },\n                    {\n                        \"code\": \"AL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AL\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AL\"\n                    },\n                    {\n                        \"code\": \"AK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AK\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AK\"\n                    },\n                    {\n                        \"code\": \"AB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AB\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AB\"\n                    },\n                    {\n                        \"code\": \"AZ\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AZ\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AZ\"\n                    },\n                    {\n                        \"code\": \"AR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AR\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AR\"\n                    },\n                    {\n                        \"code\": \"DE_BW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_BW\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_BW\"\n                    },\n                    {\n                        \"code\": \"DE_BY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_BY\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_BY\"\n                    },\n                    {\n                        \"code\": \"DE_BE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_BE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_BE\"\n                    },\n                    {\n                        \"code\": \"DE_BB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_BB\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_BB\"\n                    },\n                    {\n                        \"code\": \"DE_HB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_HB\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_HB\"\n                    },\n                    {\n                        \"code\": \"BC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"BC\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.BC\"\n                    },\n                    {\n                        \"code\": \"CA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"CA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.CA\"\n                    },\n                    {\n                        \"code\": \"CO\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"CO\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.CO\"\n                    },\n                    {\n                        \"code\": \"CT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"CT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.CT\"\n                    },\n                    {\n                        \"code\": \"DE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE\"\n                    },\n                    {\n                        \"code\": \"DC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DC\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DC\"\n                    },\n                    {\n                        \"code\": \"FM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"FM\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.FM\"\n                    },\n                    {\n                        \"code\": \"FL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"FL\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.FL\"\n                    },\n                    {\n                        \"code\": \"GA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"GA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.GA\"\n                    },\n                    {\n                        \"code\": \"GU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"GU\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.GU\"\n                    },\n                    {\n                        \"code\": \"DE_HH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_HH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_HH\"\n                    },\n                    {\n                        \"code\": \"HI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"HI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.HI\"\n                    },\n                    {\n                        \"code\": \"DE_HE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_HE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_HE\"\n                    },\n                    {\n                        \"code\": \"ID\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"ID\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.ID\"\n                    },\n                    {\n                        \"code\": \"IL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"IL\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.IL\"\n                    },\n                    {\n                        \"code\": \"IN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"IN\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.IN\"\n                    },\n                    {\n                        \"code\": \"IA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"IA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.IA\"\n                    },\n                    {\n                        \"code\": \"KS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"KS\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.KS\"\n                    },\n                    {\n                        \"code\": \"KY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"KY\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.KY\"\n                    },\n                    {\n                        \"code\": \"LA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"LA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.LA\"\n                    },\n                    {\n                        \"code\": \"DE_NI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_NI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_NI\"\n                    },\n                    {\n                        \"code\": \"ME\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"ME\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.ME\"\n                    },\n                    {\n                        \"code\": \"MB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MB\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MB\"\n                    },\n                    {\n                        \"code\": \"MH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MH\"\n                    },\n                    {\n                        \"code\": \"MD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MD\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MD\"\n                    },\n                    {\n                        \"code\": \"MA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MA\"\n                    },\n                    {\n                        \"code\": \"DE_MV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_MV\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_MV\"\n                    },\n                    {\n                        \"code\": \"MI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MI\"\n                    },\n                    {\n                        \"code\": \"MN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MN\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MN\"\n                    },\n                    {\n                        \"code\": \"MS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MS\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MS\"\n                    },\n                    {\n                        \"code\": \"MO\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MO\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MO\"\n                    },\n                    {\n                        \"code\": \"MT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MT\"\n                    },\n                    {\n                        \"code\": \"NE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NE\"\n                    },\n                    {\n                        \"code\": \"NV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NV\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NV\"\n                    },\n                    {\n                        \"code\": \"NB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NB\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NB\"\n                    },\n                    {\n                        \"code\": \"NH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NH\"\n                    },\n                    {\n                        \"code\": \"NJ\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NJ\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NJ\"\n                    },\n                    {\n                        \"code\": \"NM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NM\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NM\"\n                    },\n                    {\n                        \"code\": \"AU_NSW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_NSW\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_NSW\"\n                    },\n                    {\n                        \"code\": \"NY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NY\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NY\"\n                    },\n                    {\n                        \"code\": \"NL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NL\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NL\"\n                    },\n                    {\n                        \"code\": \"ND\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"ND\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.ND\"\n                    },\n                    {\n                        \"code\": \"DE_NW\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_NW\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_NW\"\n                    },\n                    {\n                        \"code\": \"MP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"MP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.MP\"\n                    },\n                    {\n                        \"code\": \"AU_NT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_NT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_NT\"\n                    },\n                    {\n                        \"code\": \"NT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NT\"\n                    },\n                    {\n                        \"code\": \"NS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NS\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NS\"\n                    },\n                    {\n                        \"code\": \"NU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"NU\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.NU\"\n                    },\n                    {\n                        \"code\": \"OH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"OH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.OH\"\n                    },\n                    {\n                        \"code\": \"OK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"OK\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.OK\"\n                    },\n                    {\n                        \"code\": \"ON\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"ON\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.ON\"\n                    },\n                    {\n                        \"code\": \"OR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"OR\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.OR\"\n                    },\n                    {\n                        \"code\": \"PA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"PA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.PA\"\n                    },\n                    {\n                        \"code\": \"PE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"PE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.PE\"\n                    },\n                    {\n                        \"code\": \"PR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"PR\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.PR\"\n                    },\n                    {\n                        \"code\": \"QC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"QC\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.QC\"\n                    },\n                    {\n                        \"code\": \"AU_QLD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_QLD\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_QLD\"\n                    },\n                    {\n                        \"code\": \"DE_RP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_RP\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_RP\"\n                    },\n                    {\n                        \"code\": \"RI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"RI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.RI\"\n                    },\n                    {\n                        \"code\": \"DE_SL\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_SL\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_SL\"\n                    },\n                    {\n                        \"code\": \"SK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"SK\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.SK\"\n                    },\n                    {\n                        \"code\": \"DE_SN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_SN\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_SN\"\n                    },\n                    {\n                        \"code\": \"DE_ST\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_ST\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_ST\"\n                    },\n                    {\n                        \"code\": \"DE_SH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_SH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_SH\"\n                    },\n                    {\n                        \"code\": \"AU_SA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_SA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_SA\"\n                    },\n                    {\n                        \"code\": \"SD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"SD\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.SD\"\n                    },\n                    {\n                        \"code\": \"AU_TAS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_TAS\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_TAS\"\n                    },\n                    {\n                        \"code\": \"TN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"TN\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.TN\"\n                    },\n                    {\n                        \"code\": \"TX\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"TX\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.TX\"\n                    },\n                    {\n                        \"code\": \"DE_TH\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"DE\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"DE_TH\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.DE_TH\"\n                    },\n                    {\n                        \"code\": \"UT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"UT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.UT\"\n                    },\n                    {\n                        \"code\": \"VT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"VT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.VT\"\n                    },\n                    {\n                        \"code\": \"AU_VIC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_VIC\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_VIC\"\n                    },\n                    {\n                        \"code\": \"VI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"VI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.VI\"\n                    },\n                    {\n                        \"code\": \"VA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"VA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.VA\"\n                    },\n                    {\n                        \"code\": \"WA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"WA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.WA\"\n                    },\n                    {\n                        \"code\": \"WV\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"WV\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.WV\"\n                    },\n                    {\n                        \"code\": \"AU_WA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"AU\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"AU_WA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.AU_WA\"\n                    },\n                    {\n                        \"code\": \"WI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"WI\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.WI\"\n                    },\n                    {\n                        \"code\": \"WY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"US\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"WY\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.WY\"\n                    },\n                    {\n                        \"code\": \"YT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Country\",\n                                \"typecode\": \"CA\"\n                            },\n                            {\n                                \"typelist\": \"Jurisdiction\",\n                                \"typecode\": \"YT\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.State.YT\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Country\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"US\",\n                        \"priority\": 0,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.US\"\n                    },\n                    {\n                        \"code\": \"CA\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"cad\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.CA\"\n                    },\n                    {\n                        \"code\": \"AF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AF\"\n                    },\n                    {\n                        \"code\": \"AL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AL\"\n                    },\n                    {\n                        \"code\": \"DZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.DZ\"\n                    },\n                    {\n                        \"code\": \"AS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AS\"\n                    },\n                    {\n                        \"code\": \"AD\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.AD\"\n                    },\n                    {\n                        \"code\": \"AO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AO\"\n                    },\n                    {\n                        \"code\": \"AI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AI\"\n                    },\n                    {\n                        \"code\": \"AQ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AQ\"\n                    },\n                    {\n                        \"code\": \"AG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AG\"\n                    },\n                    {\n                        \"code\": \"AR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AR\"\n                    },\n                    {\n                        \"code\": \"AM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AM\"\n                    },\n                    {\n                        \"code\": \"AW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AW\"\n                    },\n                    {\n                        \"code\": \"AU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"aud\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.AU\"\n                    },\n                    {\n                        \"code\": \"AT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.AT\"\n                    },\n                    {\n                        \"code\": \"AZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AZ\"\n                    },\n                    {\n                        \"code\": \"BS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BS\"\n                    },\n                    {\n                        \"code\": \"BH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BH\"\n                    },\n                    {\n                        \"code\": \"BD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BD\"\n                    },\n                    {\n                        \"code\": \"BB\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BB\"\n                    },\n                    {\n                        \"code\": \"BY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BY\"\n                    },\n                    {\n                        \"code\": \"BE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.BE\"\n                    },\n                    {\n                        \"code\": \"BZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BZ\"\n                    },\n                    {\n                        \"code\": \"BJ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BJ\"\n                    },\n                    {\n                        \"code\": \"BM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BM\"\n                    },\n                    {\n                        \"code\": \"BT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BT\"\n                    },\n                    {\n                        \"code\": \"BO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BO\"\n                    },\n                    {\n                        \"code\": \"BA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BA\"\n                    },\n                    {\n                        \"code\": \"BW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BW\"\n                    },\n                    {\n                        \"code\": \"BV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BV\"\n                    },\n                    {\n                        \"code\": \"BR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BR\"\n                    },\n                    {\n                        \"code\": \"IO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IO\"\n                    },\n                    {\n                        \"code\": \"VG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VG\"\n                    },\n                    {\n                        \"code\": \"BN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BN\"\n                    },\n                    {\n                        \"code\": \"BG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BG\"\n                    },\n                    {\n                        \"code\": \"BF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BF\"\n                    },\n                    {\n                        \"code\": \"BI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BI\"\n                    },\n                    {\n                        \"code\": \"KH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KH\"\n                    },\n                    {\n                        \"code\": \"CM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CM\"\n                    },\n                    {\n                        \"code\": \"CV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CV\"\n                    },\n                    {\n                        \"code\": \"KY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KY\"\n                    },\n                    {\n                        \"code\": \"CF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CF\"\n                    },\n                    {\n                        \"code\": \"TD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TD\"\n                    },\n                    {\n                        \"code\": \"CL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CL\"\n                    },\n                    {\n                        \"code\": \"CN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CN\"\n                    },\n                    {\n                        \"code\": \"CX\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CX\"\n                    },\n                    {\n                        \"code\": \"CC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CC\"\n                    },\n                    {\n                        \"code\": \"CO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CO\"\n                    },\n                    {\n                        \"code\": \"KM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KM\"\n                    },\n                    {\n                        \"code\": \"CG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CG\"\n                    },\n                    {\n                        \"code\": \"CD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CD\"\n                    },\n                    {\n                        \"code\": \"CK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CK\"\n                    },\n                    {\n                        \"code\": \"CR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CR\"\n                    },\n                    {\n                        \"code\": \"HR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HR\"\n                    },\n                    {\n                        \"code\": \"CU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CU\"\n                    },\n                    {\n                        \"code\": \"CY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.CY\"\n                    },\n                    {\n                        \"code\": \"CZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CZ\"\n                    },\n                    {\n                        \"code\": \"DK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.DK\"\n                    },\n                    {\n                        \"code\": \"DJ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.DJ\"\n                    },\n                    {\n                        \"code\": \"DM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.DM\"\n                    },\n                    {\n                        \"code\": \"DO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.DO\"\n                    },\n                    {\n                        \"code\": \"EC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.EC\"\n                    },\n                    {\n                        \"code\": \"EG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.EG\"\n                    },\n                    {\n                        \"code\": \"SV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SV\"\n                    },\n                    {\n                        \"code\": \"GQ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GQ\"\n                    },\n                    {\n                        \"code\": \"ER\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ER\"\n                    },\n                    {\n                        \"code\": \"EE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.EE\"\n                    },\n                    {\n                        \"code\": \"ET\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ET\"\n                    },\n                    {\n                        \"code\": \"FK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.FK\"\n                    },\n                    {\n                        \"code\": \"FO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.FO\"\n                    },\n                    {\n                        \"code\": \"FJ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.FJ\"\n                    },\n                    {\n                        \"code\": \"FI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.FI\"\n                    },\n                    {\n                        \"code\": \"FR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.FR\"\n                    },\n                    {\n                        \"code\": \"GF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GF\"\n                    },\n                    {\n                        \"code\": \"PF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PF\"\n                    },\n                    {\n                        \"code\": \"TF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TF\"\n                    },\n                    {\n                        \"code\": \"GA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GA\"\n                    },\n                    {\n                        \"code\": \"GM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GM\"\n                    },\n                    {\n                        \"code\": \"GE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GE\"\n                    },\n                    {\n                        \"code\": \"DE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.DE\"\n                    },\n                    {\n                        \"code\": \"GH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GH\"\n                    },\n                    {\n                        \"code\": \"GI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GI\"\n                    },\n                    {\n                        \"code\": \"GR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.GR\"\n                    },\n                    {\n                        \"code\": \"GL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GL\"\n                    },\n                    {\n                        \"code\": \"GD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GD\"\n                    },\n                    {\n                        \"code\": \"GP\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GP\"\n                    },\n                    {\n                        \"code\": \"GU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GU\"\n                    },\n                    {\n                        \"code\": \"GT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GT\"\n                    },\n                    {\n                        \"code\": \"GN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GN\"\n                    },\n                    {\n                        \"code\": \"GW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GW\"\n                    },\n                    {\n                        \"code\": \"GY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GY\"\n                    },\n                    {\n                        \"code\": \"HT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HT\"\n                    },\n                    {\n                        \"code\": \"HM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HM\"\n                    },\n                    {\n                        \"code\": \"HN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HN\"\n                    },\n                    {\n                        \"code\": \"HK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HK\"\n                    },\n                    {\n                        \"code\": \"HU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.HU\"\n                    },\n                    {\n                        \"code\": \"IS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IS\"\n                    },\n                    {\n                        \"code\": \"IN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IN\"\n                    },\n                    {\n                        \"code\": \"ID\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ID\"\n                    },\n                    {\n                        \"code\": \"IR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IR\"\n                    },\n                    {\n                        \"code\": \"IQ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IQ\"\n                    },\n                    {\n                        \"code\": \"IE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.IE\"\n                    },\n                    {\n                        \"code\": \"IL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.IL\"\n                    },\n                    {\n                        \"code\": \"IT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.IT\"\n                    },\n                    {\n                        \"code\": \"CI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CI\"\n                    },\n                    {\n                        \"code\": \"JM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.JM\"\n                    },\n                    {\n                        \"code\": \"JP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"jpy\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.JP\"\n                    },\n                    {\n                        \"code\": \"JO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.JO\"\n                    },\n                    {\n                        \"code\": \"KZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KZ\"\n                    },\n                    {\n                        \"code\": \"KE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KE\"\n                    },\n                    {\n                        \"code\": \"KI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KI\"\n                    },\n                    {\n                        \"code\": \"KP\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KP\"\n                    },\n                    {\n                        \"code\": \"KR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KR\"\n                    },\n                    {\n                        \"code\": \"KW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KW\"\n                    },\n                    {\n                        \"code\": \"KG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KG\"\n                    },\n                    {\n                        \"code\": \"LA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LA\"\n                    },\n                    {\n                        \"code\": \"LV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LV\"\n                    },\n                    {\n                        \"code\": \"LB\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LB\"\n                    },\n                    {\n                        \"code\": \"LS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LS\"\n                    },\n                    {\n                        \"code\": \"LR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LR\"\n                    },\n                    {\n                        \"code\": \"LY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LY\"\n                    },\n                    {\n                        \"code\": \"LI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LI\"\n                    },\n                    {\n                        \"code\": \"LT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LT\"\n                    },\n                    {\n                        \"code\": \"LU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.LU\"\n                    },\n                    {\n                        \"code\": \"MO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MO\"\n                    },\n                    {\n                        \"code\": \"MK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MK\"\n                    },\n                    {\n                        \"code\": \"MG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MG\"\n                    },\n                    {\n                        \"code\": \"MW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MW\"\n                    },\n                    {\n                        \"code\": \"MY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MY\"\n                    },\n                    {\n                        \"code\": \"MV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MV\"\n                    },\n                    {\n                        \"code\": \"ML\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ML\"\n                    },\n                    {\n                        \"code\": \"MT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.MT\"\n                    },\n                    {\n                        \"code\": \"MH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MH\"\n                    },\n                    {\n                        \"code\": \"MQ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MQ\"\n                    },\n                    {\n                        \"code\": \"MR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MR\"\n                    },\n                    {\n                        \"code\": \"MU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MU\"\n                    },\n                    {\n                        \"code\": \"YT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.YT\"\n                    },\n                    {\n                        \"code\": \"MX\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MX\"\n                    },\n                    {\n                        \"code\": \"FM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.FM\"\n                    },\n                    {\n                        \"code\": \"MD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MD\"\n                    },\n                    {\n                        \"code\": \"MC\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.MC\"\n                    },\n                    {\n                        \"code\": \"MN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MN\"\n                    },\n                    {\n                        \"code\": \"ME\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.ME\"\n                    },\n                    {\n                        \"code\": \"MS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MS\"\n                    },\n                    {\n                        \"code\": \"MA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MA\"\n                    },\n                    {\n                        \"code\": \"MZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MZ\"\n                    },\n                    {\n                        \"code\": \"MM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MM\"\n                    },\n                    {\n                        \"code\": \"NA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NA\"\n                    },\n                    {\n                        \"code\": \"NR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NR\"\n                    },\n                    {\n                        \"code\": \"NP\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NP\"\n                    },\n                    {\n                        \"code\": \"NL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NL\"\n                    },\n                    {\n                        \"code\": \"AN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.AN\"\n                    },\n                    {\n                        \"code\": \"NC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NC\"\n                    },\n                    {\n                        \"code\": \"NZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NZ\"\n                    },\n                    {\n                        \"code\": \"NI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NI\"\n                    },\n                    {\n                        \"code\": \"NE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NE\"\n                    },\n                    {\n                        \"code\": \"NG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NG\"\n                    },\n                    {\n                        \"code\": \"NU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NU\"\n                    },\n                    {\n                        \"code\": \"NF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NF\"\n                    },\n                    {\n                        \"code\": \"MP\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MP\"\n                    },\n                    {\n                        \"code\": \"NO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.NO\"\n                    },\n                    {\n                        \"code\": \"OM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.OM\"\n                    },\n                    {\n                        \"code\": \"PK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PK\"\n                    },\n                    {\n                        \"code\": \"PW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PW\"\n                    },\n                    {\n                        \"code\": \"PS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PS\"\n                    },\n                    {\n                        \"code\": \"PA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PA\"\n                    },\n                    {\n                        \"code\": \"PG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PG\"\n                    },\n                    {\n                        \"code\": \"PY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PY\"\n                    },\n                    {\n                        \"code\": \"PE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PE\"\n                    },\n                    {\n                        \"code\": \"PH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PH\"\n                    },\n                    {\n                        \"code\": \"PN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PN\"\n                    },\n                    {\n                        \"code\": \"PL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PL\"\n                    },\n                    {\n                        \"code\": \"PT\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.PT\"\n                    },\n                    {\n                        \"code\": \"PR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PR\"\n                    },\n                    {\n                        \"code\": \"QA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.QA\"\n                    },\n                    {\n                        \"code\": \"RE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.RE\"\n                    },\n                    {\n                        \"code\": \"RO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.RO\"\n                    },\n                    {\n                        \"code\": \"RU\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"rub\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.RU\"\n                    },\n                    {\n                        \"code\": \"RW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.RW\"\n                    },\n                    {\n                        \"code\": \"BL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.BL\"\n                    },\n                    {\n                        \"code\": \"MF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.MF\"\n                    },\n                    {\n                        \"code\": \"WS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.WS\"\n                    },\n                    {\n                        \"code\": \"SM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.SM\"\n                    },\n                    {\n                        \"code\": \"ST\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ST\"\n                    },\n                    {\n                        \"code\": \"SA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SA\"\n                    },\n                    {\n                        \"code\": \"SN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SN\"\n                    },\n                    {\n                        \"code\": \"RS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.RS\"\n                    },\n                    {\n                        \"code\": \"SC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SC\"\n                    },\n                    {\n                        \"code\": \"SL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SL\"\n                    },\n                    {\n                        \"code\": \"SG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SG\"\n                    },\n                    {\n                        \"code\": \"SK\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.SK\"\n                    },\n                    {\n                        \"code\": \"SI\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.SI\"\n                    },\n                    {\n                        \"code\": \"SB\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SB\"\n                    },\n                    {\n                        \"code\": \"SO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SO\"\n                    },\n                    {\n                        \"code\": \"ZA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ZA\"\n                    },\n                    {\n                        \"code\": \"GS\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.GS\"\n                    },\n                    {\n                        \"code\": \"ES\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.ES\"\n                    },\n                    {\n                        \"code\": \"LK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LK\"\n                    },\n                    {\n                        \"code\": \"SH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SH\"\n                    },\n                    {\n                        \"code\": \"KN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.KN\"\n                    },\n                    {\n                        \"code\": \"LC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.LC\"\n                    },\n                    {\n                        \"code\": \"PM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.PM\"\n                    },\n                    {\n                        \"code\": \"VC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VC\"\n                    },\n                    {\n                        \"code\": \"SD\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SD\"\n                    },\n                    {\n                        \"code\": \"SR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SR\"\n                    },\n                    {\n                        \"code\": \"SJ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SJ\"\n                    },\n                    {\n                        \"code\": \"SZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SZ\"\n                    },\n                    {\n                        \"code\": \"SE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SE\"\n                    },\n                    {\n                        \"code\": \"CH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.CH\"\n                    },\n                    {\n                        \"code\": \"SY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.SY\"\n                    },\n                    {\n                        \"code\": \"TW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TW\"\n                    },\n                    {\n                        \"code\": \"TJ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TJ\"\n                    },\n                    {\n                        \"code\": \"TZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TZ\"\n                    },\n                    {\n                        \"code\": \"TH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TH\"\n                    },\n                    {\n                        \"code\": \"TL\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TL\"\n                    },\n                    {\n                        \"code\": \"TG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TG\"\n                    },\n                    {\n                        \"code\": \"TK\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TK\"\n                    },\n                    {\n                        \"code\": \"TO\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TO\"\n                    },\n                    {\n                        \"code\": \"TT\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TT\"\n                    },\n                    {\n                        \"code\": \"TN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TN\"\n                    },\n                    {\n                        \"code\": \"TR\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TR\"\n                    },\n                    {\n                        \"code\": \"TM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TM\"\n                    },\n                    {\n                        \"code\": \"TC\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TC\"\n                    },\n                    {\n                        \"code\": \"TV\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.TV\"\n                    },\n                    {\n                        \"code\": \"UM\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"usd\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.UM\"\n                    },\n                    {\n                        \"code\": \"VI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VI\"\n                    },\n                    {\n                        \"code\": \"UG\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.UG\"\n                    },\n                    {\n                        \"code\": \"UA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.UA\"\n                    },\n                    {\n                        \"code\": \"AE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.AE\"\n                    },\n                    {\n                        \"code\": \"GB\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"gbp\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.GB\"\n                    },\n                    {\n                        \"code\": \"UY\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.UY\"\n                    },\n                    {\n                        \"code\": \"UZ\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.UZ\"\n                    },\n                    {\n                        \"code\": \"VU\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VU\"\n                    },\n                    {\n                        \"code\": \"VA\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"Currency\",\n                                \"typecode\": \"eur\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.Country.VA\"\n                    },\n                    {\n                        \"code\": \"VE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VE\"\n                    },\n                    {\n                        \"code\": \"VN\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.VN\"\n                    },\n                    {\n                        \"code\": \"WF\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.WF\"\n                    },\n                    {\n                        \"code\": \"EH\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.EH\"\n                    },\n                    {\n                        \"code\": \"YE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.YE\"\n                    },\n                    {\n                        \"code\": \"ZM\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ZM\"\n                    },\n                    {\n                        \"code\": \"ZW\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Country.ZW\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AddressType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"billing\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddressType.billing\"\n                    },\n                    {\n                        \"code\": \"business\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddressType.business\"\n                    },\n                    {\n                        \"code\": \"home\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddressType.home\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddressType.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.commercialproperty.draft.dto.CpDraftDataExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AccountOrgType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AccountOrgType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Locations\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.commercialproperty.draft.dto.LocationDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"BuildingCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.commercialproperty.quoting.dto.BuildingCoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.draft.dto.HoDraftDataExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AdditionalInfo\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.draft.dto.AdditionalInfoDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProtectionClass\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Construction\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.draft.dto.ConstructionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Rating\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.draft.dto.RatingDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PreQualQuestionSets\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.questionset.dto.QuestionSetAnswersDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProtectionClassCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MembershipHO\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"aaa.edge.capabilities.policycommon.membership.dto.MembershipDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"YourHome\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.draft.dto.YourHomeDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.PaDraftDataExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"MembershipPA\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"aaa.edge.capabilities.policycommon.membership.dto.MembershipDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Drivers\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.DriverDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"PrevCarrierInfo\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.PrevCarrierInfoDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PreQualQuestionSets\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.questionset.dto.QuestionSetAnswersDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Vehicles\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.VehicleDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PrevPolicyStatus_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Active\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Active\"\n                    },\n                    {\n                        \"code\": \"Lapse30Less\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Lapse30Less\"\n                    },\n                    {\n                        \"code\": \"Lapse30DaysMore\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Lapse30DaysMore\"\n                    },\n                    {\n                        \"code\": \"NoPrior\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.NoPrior\"\n                    },\n                    {\n                        \"code\": \"Cancelled\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Cancelled\"\n                    },\n                    {\n                        \"code\": \"Disputed\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Disputed\"\n                    },\n                    {\n                        \"code\": \"Expired\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PrevPolicyStatus_aaa.Expired\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"PrevPolicyStatusOverride\",\n                        \"includedCodes\": [\n                            \"Active\",\n                            \"Lapse30Less\",\n                            \"Lapse30DaysMore\",\n                            \"NoPrior\"\n                        ]\n                    },\n                    {\n                        \"name\": \"PrevPolicyStatusForOperators\",\n                        \"includedCodes\": [\n                            \"Active\",\n                            \"Lapse30Less\",\n                            \"Lapse30DaysMore\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.InsuranceCarriers\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"NoPrior\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.NoPrior\"\n                    },\n                    {\n                        \"code\": \"tmic_aaa\",\n                        \"priority\": 12,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.tmic_aaa\"\n                    },\n                    {\n                        \"code\": \"uic_aaa\",\n                        \"priority\": 15,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.uic_aaa\"\n                    },\n                    {\n                        \"code\": \"AAA\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.AAA\"\n                    },\n                    {\n                        \"code\": \"AIG\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.AIG\"\n                    },\n                    {\n                        \"code\": \"Allstate\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Allstate\"\n                    },\n                    {\n                        \"code\": \"AMICA\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.AMICA\"\n                    },\n                    {\n                        \"code\": \"AutoOwners\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.AutoOwners\"\n                    },\n                    {\n                        \"code\": \"BoatUS\",\n                        \"priority\": 65,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.BoatUS\"\n                    },\n                    {\n                        \"code\": \"BristolWest\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.BristolWest\"\n                    },\n                    {\n                        \"code\": \"DirectGeneral\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.DirectGeneral\"\n                    },\n                    {\n                        \"code\": \"Encompass\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Encompass\"\n                    },\n                    {\n                        \"code\": \"Erie\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Erie\"\n                    },\n                    {\n                        \"code\": \"Esurance\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Esurance\"\n                    },\n                    {\n                        \"code\": \"FarmBureau\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.FarmBureau\"\n                    },\n                    {\n                        \"code\": \"Farmers\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Farmers\"\n                    },\n                    {\n                        \"code\": \"GEICO\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.GEICO\"\n                    },\n                    {\n                        \"code\": \"GMAC\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.GMAC\"\n                    },\n                    {\n                        \"code\": \"Hartford\",\n                        \"priority\": 160,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Hartford\"\n                    },\n                    {\n                        \"code\": \"HoraceMann\",\n                        \"priority\": 170,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.HoraceMann\"\n                    },\n                    {\n                        \"code\": \"Kemper\",\n                        \"priority\": 180,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Kemper\"\n                    },\n                    {\n                        \"code\": \"LibertyMutual\",\n                        \"priority\": 190,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.LibertyMutual\"\n                    },\n                    {\n                        \"code\": \"MetLife\",\n                        \"priority\": 200,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.MetLife\"\n                    },\n                    {\n                        \"code\": \"Nationwide\",\n                        \"priority\": 210,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Nationwide\"\n                    },\n                    {\n                        \"code\": \"Other\",\n                        \"priority\": 220,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Other\"\n                    },\n                    {\n                        \"code\": \"PeakProperty\",\n                        \"priority\": 230,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.PeakProperty\"\n                    },\n                    {\n                        \"code\": \"Progressive\",\n                        \"priority\": 240,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Progressive\"\n                    },\n                    {\n                        \"code\": \"SafeAutoIns\",\n                        \"priority\": 250,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.SafeAutoIns\"\n                    },\n                    {\n                        \"code\": \"SeaSafeSkiSafe\",\n                        \"priority\": 255,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.SeaSafeSkiSafe\"\n                    },\n                    {\n                        \"code\": \"Safeco\",\n                        \"priority\": 260,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Safeco\"\n                    },\n                    {\n                        \"code\": \"StateFarm\",\n                        \"priority\": 270,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.StateFarm\"\n                    },\n                    {\n                        \"code\": \"Travelers\",\n                        \"priority\": 280,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Travelers\"\n                    },\n                    {\n                        \"code\": \"USAAIns\",\n                        \"priority\": 290,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.USAAIns\"\n                    },\n                    {\n                        \"code\": \"ASI\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.ASI\"\n                    },\n                    {\n                        \"code\": \"Bankers\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Bankers\"\n                    },\n                    {\n                        \"code\": \"Central\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.InsuranceCarriers.Central\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"HOInsuranceCarriers\",\n                        \"includedCodes\": [\n                            \"Hartford\",\n                            \"MetLife\",\n                            \"Other\",\n                            \"Safeco\",\n                            \"Travelers\",\n                            \"ASI\",\n                            \"Bankers\",\n                            \"Central\"\n                        ]\n                    },\n                    {\n                        \"name\": \"OtherInsuranceCarriers\",\n                        \"includedCodes\": [\n                            \"NoPrior\",\n                            \"tmic_aaa\",\n                            \"uic_aaa\",\n                            \"AAA\",\n                            \"AIG\",\n                            \"Allstate\",\n                            \"AMICA\",\n                            \"AutoOwners\",\n                            \"BoatUS\",\n                            \"BristolWest\",\n                            \"DirectGeneral\",\n                            \"Encompass\",\n                            \"Erie\",\n                            \"Esurance\",\n                            \"FarmBureau\",\n                            \"Farmers\",\n                            \"GEICO\",\n                            \"GMAC\",\n                            \"Hartford\",\n                            \"HoraceMann\",\n                            \"Kemper\",\n                            \"LibertyMutual\",\n                            \"MetLife\",\n                            \"Nationwide\",\n                            \"Other\",\n                            \"PeakProperty\",\n                            \"Progressive\",\n                            \"SafeAutoIns\",\n                            \"SeaSafeSkiSafe\",\n                            \"Safeco\",\n                            \"StateFarm\",\n                            \"Travelers\",\n                            \"USAAIns\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PriorBILimits_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"MinimumLimits\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.MinimumLimits\"\n                    },\n                    {\n                        \"code\": \"25_50\",\n                        \"priority\": 25,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.25_50\"\n                    },\n                    {\n                        \"code\": \"50_100\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.50_100\"\n                    },\n                    {\n                        \"code\": \"100_300\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.100_300\"\n                    },\n                    {\n                        \"code\": \"250_500\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.250_500\"\n                    },\n                    {\n                        \"code\": \"300CSL\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.300CSL\"\n                    },\n                    {\n                        \"code\": \"500CSL\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.500CSL\"\n                    },\n                    {\n                        \"code\": \"Other\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PriorBILimits_aaa.Other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.currency.dto.AmountDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Amount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"BigDecimal\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"isCurrency\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Currency\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Currency\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Currency\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.dto.QuoteLobDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PersonalAuto\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.quoting.dto.PaAvailableCoveragesDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Homeowners\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.homeowners.quoting.dto.HoAvailableCoveragesDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CommercialProperty\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.commercialproperty.quoting.dto.CpAvailableCoveragesDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"aaa.edge.capabilities.policycommon.discounts.dto.DiscountsDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"DiscountName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BillingPeriodicity\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"monthly\",\n                        \"priority\": 11,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.monthly\"\n                    },\n                    {\n                        \"code\": \"everyweek\",\n                        \"priority\": 13,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyweek\"\n                    },\n                    {\n                        \"code\": \"everyotherweek\",\n                        \"priority\": 14,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyotherweek\"\n                    },\n                    {\n                        \"code\": \"twicepermonth\",\n                        \"priority\": 15,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.twicepermonth\"\n                    },\n                    {\n                        \"code\": \"everyothermonth\",\n                        \"priority\": 16,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyothermonth\"\n                    },\n                    {\n                        \"code\": \"quarterly\",\n                        \"priority\": 17,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.quarterly\"\n                    },\n                    {\n                        \"code\": \"everyfourmonths\",\n                        \"priority\": 18,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyfourmonths\"\n                    },\n                    {\n                        \"code\": \"everysixmonths\",\n                        \"priority\": 19,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everysixmonths\"\n                    },\n                    {\n                        \"code\": \"everyyear\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyyear\"\n                    },\n                    {\n                        \"code\": \"everyotheryear\",\n                        \"priority\": 21,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BillingPeriodicity.everyotheryear\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PaymentFrequency_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"paidinfull\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentFrequency_aaa.paidinfull\"\n                    },\n                    {\n                        \"code\": \"monthly\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentFrequency_aaa.monthly\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.binding.dto.BankDetailsDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"BankName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"isAlphaNumeric\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"null\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AlphaNumericError\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BankABANumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsBank\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccHolderName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"isAlphaNumeric\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"null\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AlphaNumericError\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BankAccountType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BankAccountType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BankAccountNumberRe\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"eq\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"BankAccountNumber\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.The account number entered does not match please check and re-enter.\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"NickName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BankAccountNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsBank\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.binding.dto.CreditCardDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"CardNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProviderId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpiryDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Token\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"OneTime\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NickName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CardHolderName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CardType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PaymentMethod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PaymentMethod\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TokenId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Detail\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DocumentSignOptions_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"electronicsignature\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSignOptions_aaa.electronicsignature\"\n                    },\n                    {\n                        \"code\": \"hardcopysign\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSignOptions_aaa.hardcopysign\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Contact\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Company\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.Company\"\n                    },\n                    {\n                        \"code\": \"Person\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.Person\"\n                    },\n                    {\n                        \"code\": \"Place\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.Place\"\n                    },\n                    {\n                        \"code\": \"Adjudicator\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.Adjudicator\"\n                    },\n                    {\n                        \"code\": \"Contact\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.Contact\"\n                    },\n                    {\n                        \"code\": \"LegalVenue\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.LegalVenue\"\n                    },\n                    {\n                        \"code\": \"UserContact\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.UserContact\"\n                    },\n                    {\n                        \"code\": \"CompanyVendor\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.CompanyVendor\"\n                    },\n                    {\n                        \"code\": \"PersonVendor\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Contact.PersonVendor\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.JurisdictionType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"cons_tax\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.cons_tax\"\n                    },\n                    {\n                        \"code\": \"fr_dmv_reporting_inx\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.fr_dmv_reporting_inx\"\n                    },\n                    {\n                        \"code\": \"driving_lic\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.driving_lic\"\n                    },\n                    {\n                        \"code\": \"insurance\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.insurance\"\n                    },\n                    {\n                        \"code\": \"ins_tax\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.ins_tax\"\n                    },\n                    {\n                        \"code\": \"veh_dmv_reporting_inx\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.veh_dmv_reporting_inx\"\n                    },\n                    {\n                        \"code\": \"vehicle_reg\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.JurisdictionType.vehicle_reg\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Currency\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"usd\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.usd\"\n                    },\n                    {\n                        \"code\": \"eur\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.eur\"\n                    },\n                    {\n                        \"code\": \"gbp\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.gbp\"\n                    },\n                    {\n                        \"code\": \"cad\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.cad\"\n                    },\n                    {\n                        \"code\": \"aud\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.aud\"\n                    },\n                    {\n                        \"code\": \"rub\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.rub\"\n                    },\n                    {\n                        \"code\": \"jpy\",\n                        \"priority\": 7,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Currency.jpy\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.commercialproperty.draft.dto.LocationDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FireProtection\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.FireProtectClass\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Address\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"AddressLine1\",\n                                        \"PostalCode\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"Buildings\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.commercialproperty.draft.dto.BuildingDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Phone\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TerritoryCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LocationCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsPrimary\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LocationName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AccountOrgType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"commonownership\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.commonownership\"\n                    },\n                    {\n                        \"code\": \"privatecorp\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.privatecorp\"\n                    },\n                    {\n                        \"code\": \"corporation\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.corporation\"\n                    },\n                    {\n                        \"code\": \"executortrustee\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.executortrustee\"\n                    },\n                    {\n                        \"code\": \"government\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.government\"\n                    },\n                    {\n                        \"code\": \"individual\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.individual\"\n                    },\n                    {\n                        \"code\": \"jointventure\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.jointventure\"\n                    },\n                    {\n                        \"code\": \"limitedpartnership\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.limitedpartnership\"\n                    },\n                    {\n                        \"code\": \"llc\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.llc\"\n                    },\n                    {\n                        \"code\": \"llp\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.llp\"\n                    },\n                    {\n                        \"code\": \"nonprofit\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.nonprofit\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.other\"\n                    },\n                    {\n                        \"code\": \"partnership\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.partnership\"\n                    },\n                    {\n                        \"code\": \"religious\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.religious\"\n                    },\n                    {\n                        \"code\": \"solepropship\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.solepropship\"\n                    },\n                    {\n                        \"code\": \"trustestate\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccountOrgType.trustestate\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.commercialproperty.quoting.dto.BuildingCoverageDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Building\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.commercialproperty.draft.dto.BuildingDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Coverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"FixedId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Long\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Premium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"aaa.edge.capabilities.policycommon.membership.dto.MembershipDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"DwellingFire\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Renters\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Flood\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WaterCraft\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HomeOwners\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PersonalAuto\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Life\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Umbrella\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Product\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"OtherPolicies\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.draft.dto.ConstructionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PrimaryHeatingType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.HeatingType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WiringUpgradeYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"WiringUpgradeExists\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"YearBuilt\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterBuildYear\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"YearBuilt\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"getYear\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterCurrentYear\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PrimaryHeatingTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryHeatingType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey HeatingType_HOE\",\n                                                        \"value\": \"Other\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PlumbingType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PlumbingType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ConstructionTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"ConstructionType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey ConstructionType_HOE\",\n                                                        \"value\": \"OTHER\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"isFlatRoof\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ElectricalType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BreakerType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"RoofUpgradeExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SecondaryHeatingExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PlumbingUpgradeYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PlumbingUpgradeExists\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"YearBuilt\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterBuildYear\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"YearBuilt\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"getYear\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterCurrentYear\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PlumbingTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PlumbingType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey PlumbingType_HOE\",\n                                                        \"value\": \"other\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"YearBuilt\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"getYear\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterCurrentYear\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ConstructionType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ConstructionType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"RoofUpgradeYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RoofUpgradeExists\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"YearBuilt\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterBuildYear\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"YearBuilt\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"getYear\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterCurrentYear\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PlumbingUpgradeExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"RoofType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.RoofType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"belongsToFilter\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"HOSpecific\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterBy\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.TypelistFilterDTO\",\n                                \"value\": {\n                                    \"filterName\": \"HOSpecific\"\n                                }\n                            }\n                        ]\n                    },\n                    \"HeatingUpgradeExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FoundationType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.FoundationType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HeatingUpgradeYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"HeatingUpgradeExists\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"YearBuilt\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterBuildYear\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"YearBuilt\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \"gw.api.util.DateUtil\",\n                                                        \"name\": \"getYear\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"nativecall\",\n                                                                \"container\": \"gw.api.util.DateUtil\",\n                                                                \"name\": \"currentDate\",\n                                                                \"params\": []\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.AfterYear.AfterCurrentYear\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"HasGarage\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"StoriesNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NumberOfStories_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WiringUpgradeExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WiringTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"WiringType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey WiringType_HOE\",\n                                                        \"value\": \"other\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"RoofTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RoofType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey RoofType\",\n                                                        \"value\": \"other\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WiringType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.WiringType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ElectricalTypeDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"ElectricalType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey BreakerType_HOE\",\n                                                        \"value\": \"other\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.draft.dto.AdditionalInfoDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"formType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.HOPolicyType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BestDescribeHome\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DwellingOccupancyType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DistanceToFireStation\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"HomeOccupationInMonths\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 0\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.aaa.Edge.Web.Api.Model.startMonth\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 12\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.aaa.Edge.Web.Api.Model.endMonth\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 12\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BankruptcyInfo\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ResidenceType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ResidenceType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BussWalkInTraffic\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"policyType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PolicyType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"past3YearLoss\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DistanceToFireHydrant\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AnyPets\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AdditionalOccupants\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"homeType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.draft.dto.YourHomeDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"ResidenceType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ResidenceType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"typekeyIn\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": [\n                                                    \"Fam1\",\n                                                    \"Fam2\",\n                                                    \"TownRow\",\n                                                    \"Mobile\"\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterBy\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.TypekeyListFilterDTO\",\n                                \"value\": {\n                                    \"codes\": [\n                                        \"Fam1\",\n                                        \"Fam2\",\n                                        \"TownRow\",\n                                        \"Mobile\"\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"FloodingOrFireHazard\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DwellingLocation\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DwellingLocationType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NearCommercial\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HomeType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.HOPolicyType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DwellingUsage\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DwellingUsage_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Occupancy\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DwellingOccupancyType_HOE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ReplacementCost\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"HomeType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey HOPolicyType_HOE\",\n                                                        \"value\": \"HO3\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 75000\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.MinCoverageOffer\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 75000\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1125000\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.MaxCoverageOffer\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 1125000\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PurchaseYearRequired\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ContentReplacementCost\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"HomeType\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"typekey HOPolicyType_HOE\",\n                                                                \"value\": \"HO4\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"HomeType\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"typekey HOPolicyType_HOE\",\n                                                                \"value\": \"HO6\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 12000\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.MinCoverageOffer\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 12000\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 300000\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.MaxCoverageOffer\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 300000\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PurchaseYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"and\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"greater\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 1900\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"less\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 0\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"int\",\n                                                        \"value\": 2999\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Year\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PurchaseYearRequired\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.draft.dto.RatingDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"SwimmingPoolExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Deadbolts\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BurglarAlarm\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SwimmingPoolDivingBoard\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TrampolineExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BurglarAlarmType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BurglarAlarmType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"BurglarAlarm\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WaterProtectionDeviceType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.WaterProtectDevice_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FireExtinguishers\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"RoomerBoarders\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SmokeAlarmOnAllFloors\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccessType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AccessType_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"SecurityGuard\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"waterProtectionDevice\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"KnownWaterLeakage\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FireAlarm\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"RoomerBoardersNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RoomerBoarders\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"FireplaceOrWoodStovesNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DeadboltsNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SprinklerSystemType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.SprinklerSystemType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SwimmingPoolFencing\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SecurityGuard\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SmokeAlarm\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"KnownWaterLeakageDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"KnownWaterLeakage\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"VisibleToNeighbors\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FireAlarmType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.FireAlarmType_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"FireAlarm\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"FireplaceOrWoodStoveExists\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"UnitsNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NumUnits_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"typekey HOPolicyType_HOE\",\n                                                \"value\": \"HO3\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"typekey HOPolicyType_HOE\",\n                                        \"value\": \"HO3\"\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TrampolineSafetyNet\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.DriverDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AccidentVoilationList\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.AccidentClaimDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"RelationShipToYou\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsAccountHolder\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": false\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"YearLicensed\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"^[a-zA-Z0-9]+$\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.PolicyHandler.LicenseNumber\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Gender\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.GenderType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ENCDateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Violations\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NumberOfAccidents\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TakenMotorSafetyCourse\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"InMotorCycle\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TempID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsPrefilledDriver\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PrefillDriverCount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InExperiencedDriver\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PrefillVehicleCount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HasPrefilledLicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DriverStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DriverStatus_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsGpaQuote\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PayGrade\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PayGrade_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"Occupation\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey Occupation_aaa\",\n                                                        \"value\": \"military\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.time.LocalDateUtil\",\n                                        \"name\": \"isValidLicenseAge\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 16\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.ValidDateOfBirth\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsGpaQuote\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DeleteViolationList\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.AccidentClaimDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ENCGender\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TakenDefDrivingCourse\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"OwnHome\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"IsAccountHolder\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EndorsementOnDriverLicense\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"InMotorCycle\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AccidentsInLast3Years\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MostDriveVehicle\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.VehicleDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Jurisdiction\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                \"name\": \"getContextValue\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 2\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"policyCountry\"\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"getContextValue\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 2\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"policyCountry\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DefensiveCourseYear\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"and\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"AccountHolderState\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"typekey State\",\n                                                                \"value\": \"SC\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"TakenDefDrivingCourse\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MinAge\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Person\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.person.dto.PersonDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"FirstName\",\n                                        \"LastName\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"MiddleName\",\n                                        \"Suffix\"\n                                    ],\n                                    \"augments\": []\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"Prefix\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"nativecall\",\n                                                    \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                    \"name\": \"optionalVisibility\",\n                                                    \"params\": [\n                                                        {\n                                                            \"kind\": \"const\",\n                                                            \"type\": \"boolean\",\n                                                            \"value\": true\n                                                        },\n                                                        {\n                                                            \"kind\": \"const\",\n                                                            \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                            \"value\": \"NOT_SET\"\n                                                        }\n                                                    ]\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.Null\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"OftenDriveVehicle\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DriverType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SecondaryInsuredRequired\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EndorsementEffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"EndorsementOnDriverLicense\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SecondaryInsured\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"and\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsGpaQuote\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"SecondaryInsuredRequired\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AssociationOrAffiliation\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AffinityGroup_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ENCLicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"RelationShip\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.RelationshipType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsEditAccidentValid\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsAddAccidentValid\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MaritialStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.MaritalStatus\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DriverMvrStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PAPolicyType_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"and\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsGpaQuote\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"IsAccountHolder\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"boolean\",\n                                                                \"value\": true\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AccidentVoilationPortalList\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.AccidentClaimPortalDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"SocialSecurityNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"isValidSSN\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Validator.SSN\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EducationalLevel\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.EducationLevel_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"NeedSR22\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"AccountHolderState\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey State\",\n                                                        \"value\": \"SC\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"isPolicyHolder\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [],\n                        \"readOnly\": true\n                    },\n                    \"InMotorCycle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ENCLicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountHolderState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FirstLicensed\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Occupation\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Occupation_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsAccountHolder\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MotorCycleSafetyCourseYear\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TakenMotorSafetyCourse\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Accidents\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NumberOfAccidents\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.VehicleDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"HasTrailer\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"License\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EncryptedVIN\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PurchasedOn\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"NewPurchase\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"paPassiveRestraint\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddnlInterest\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.PAVehicleAdditionalInterest\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PrimaryUse\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.VehiclePrimaryUse\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CCs\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TmpPaType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"motorcycle_aaa\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ExtendedAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LeaseOrRent\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"tmpOwnership\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PrinicipalSelected\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChosenDriver\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.DriverDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"NewPurchase\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"and\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"TmpPaType\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"traveltrailer_aaa\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"AccountHolderState\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"typekey State\",\n                                                                \"value\": \"NC\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DriverType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DriverType_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TmpPrimeUse\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LengthOfLease\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.LengthOfLease\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"paAntiTheft\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsGpaQuote\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AnnualMileage\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MotorcycleEndorsement\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"StorageType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.StorageType_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TmpPaType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"motorcycle_aaa\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"RegularlyParked\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"City\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsQbQuote\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                \"name\": \"getContextValue\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 2\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"policyCountry\"\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"getContextValue\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 2\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"policyCountry\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine3\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TmpPaType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SerialNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"TmpPaType\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"traveltrailer_aaa\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"TmpPaType\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"utilitytrailer_aaa\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AssignedDriver\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.personalauto.draft.dto.DriverDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TempId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InCitiyLimits\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"AccountHolderState\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey State\",\n                                                        \"value\": \"SC\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"comprehensiveSymbolCd\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"paAntiLockBrakes\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Ownership\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AdditionalInterestType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CostNew\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"Amount\"\n                                    ],\n                                    \"augments\": []\n                                }\n                            }\n                        ]\n                    },\n                    \"BodyType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BodyType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"RestrInd\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ParkedState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RegularlyParked\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": false\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                                \"name\": \"getContextValue\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"parameter\",\n                                                        \"index\": 2\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"policyCountry\"\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"getContextValue\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 2\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"policyCountry\"\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"County\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Abs\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"vehicleSurchargeCd\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"InLockedGarage\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"MotorcycleEndorsement\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": true\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsPrefilledVehicle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DamageInAccident\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsConvertedToTrike\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TmpPaType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"motorcycle_aaa\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"VehicleNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsCustomizedVehicle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"twoDgVSRSymbol\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PaType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.VehicleType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CommutingMiles\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryUse\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"commuting\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AccountHolderState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AntiTheft\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ParkedZipCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RegularlyParked\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": false\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ShortVin\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NearTwoMonths\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Cylinder\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TmpPaType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"auto\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Series\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"TmpPaType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"string\",\n                                                        \"value\": \"motorcycle_aaa\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"StreetAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"RegularlyParked\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"boolean\",\n                                                        \"value\": false\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SalvageTitle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"BodyStyle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PrimaryUser\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Vin\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"collisionSymbolCd\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.PrevCarrierInfoDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"PortalStatus\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"My Insurance cancelled or expired\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PriorBILimits\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PriorBILimits_aaa\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"PortalStatus\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"I have Insurance\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"PortalStatus\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"My Insurance cancelled or expired\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PrevPolicyStatus_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PortalStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"InsuranceCarriers\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.InsuranceCarriers\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"PortalStatus\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"I have Insurance\"\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"eq\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 1\n                                                                },\n                                                                \"propertyName\": \"PortalStatus\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"string\",\n                                                                \"value\": \"My Insurance cancelled or expired\"\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.commercialproperty.quoting.dto.CpAvailableCoveragesDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"BuildingCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.commercialproperty.quoting.dto.BuildingCoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.quoting.dto.HoAvailableCoveragesDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AdditionalCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ScheduledProperties\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.homeowners.quoting.dto.ScheduledPropertyDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"BasePremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BlanketItems\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.homeowners.quoting.dto.BlanketValueItemsDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"BaseCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.quoting.dto.PaAvailableCoveragesDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"VehicleCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.lob.personalauto.quoting.dto.VehicleCoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"LineCoverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BankAccountType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"checking\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BankAccountType.checking\"\n                    },\n                    {\n                        \"code\": \"savings\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BankAccountType.savings\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PaymentMethod\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Installments\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod.Installments\"\n                    },\n                    {\n                        \"code\": \"ReportingPlan\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PaymentMethod.ReportingPlan\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.commercialproperty.draft.dto.BuildingDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"NumberOfStories\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ConstructionType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ConstructionType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AlarmType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.BuildingAlarmType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Exposure\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PercentageSprinklered\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Sprinklered\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressDisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TotalAreaExcludingBasement\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ClassCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CoverageForm\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.CoverageForm\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"locationId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"BuildingNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"RateType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.RateType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"YearBuilt\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.FireProtectClass\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"1\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireProtectClass.1\"\n                    },\n                    {\n                        \"code\": \"2\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireProtectClass.2\"\n                    },\n                    {\n                        \"code\": \"3\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireProtectClass.3\"\n                    },\n                    {\n                        \"code\": \"4\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireProtectClass.4\"\n                    },\n                    {\n                        \"code\": \"5\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireProtectClass.5\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.coverage.dto.CoverageDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Updated\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Required\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Amount\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Terms\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.TermDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Index\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Selected\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CoverageCategory\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.NumberOfStories_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"1\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.1\"\n                    },\n                    {\n                        \"code\": \"1.5\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.1.5\"\n                    },\n                    {\n                        \"code\": \"2\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.2\"\n                    },\n                    {\n                        \"code\": \"2.5\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.2.5\"\n                    },\n                    {\n                        \"code\": \"3\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.3\"\n                    },\n                    {\n                        \"code\": \"Morethan3\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.Morethan3\"\n                    },\n                    {\n                        \"code\": \"bilevel_aaa\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.bilevel_aaa\"\n                    },\n                    {\n                        \"code\": \"trilevel_aaa\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfStories_HOE.trilevel_aaa\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"DP3NumberOfStories\",\n                        \"includedCodes\": [\n                            \"1\",\n                            \"1.5\",\n                            \"2\",\n                            \"2.5\",\n                            \"3\",\n                            \"Morethan3\",\n                            \"bilevel_aaa\",\n                            \"trilevel_aaa\"\n                        ]\n                    },\n                    {\n                        \"name\": \"HONumberOfStories\",\n                        \"includedCodes\": [\n                            \"1\",\n                            \"1.5\",\n                            \"2\",\n                            \"2.5\",\n                            \"3\",\n                            \"Morethan3\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.ConstructionType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"C\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.C\"\n                    },\n                    {\n                        \"code\": \"F\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.F\"\n                    },\n                    {\n                        \"code\": \"M\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.M\"\n                    },\n                    {\n                        \"code\": \"S\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.S\"\n                    },\n                    {\n                        \"code\": \"L\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.L\"\n                    },\n                    {\n                        \"code\": \"OTHER\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.OTHER\"\n                    },\n                    {\n                        \"code\": \"Log\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.Log\"\n                    },\n                    {\n                        \"code\": \"Frame\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.Frame\"\n                    },\n                    {\n                        \"code\": \"MasonryConcrete\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.MasonryConcrete\"\n                    },\n                    {\n                        \"code\": \"FireResistiveSteel\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.FireResistiveSteel\"\n                    },\n                    {\n                        \"code\": \"FramewithSiding\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.FramewithSiding\"\n                    },\n                    {\n                        \"code\": \"LessMasonryVeneer\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.LessMasonryVeneer\"\n                    },\n                    {\n                        \"code\": \"MoreMasonryVeneer\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.MoreMasonryVeneer\"\n                    },\n                    {\n                        \"code\": \"Superior\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.Superior\"\n                    },\n                    {\n                        \"code\": \"MasonryVeneer\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType_HOE.MasonryVeneer\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"ConstructionType_HOE_aaa\",\n                        \"includedCodes\": [\n                            \"Log\",\n                            \"Frame\",\n                            \"MasonryConcrete\",\n                            \"FireResistiveSteel\",\n                            \"FramewithSiding\",\n                            \"LessMasonryVeneer\",\n                            \"MoreMasonryVeneer\"\n                        ]\n                    },\n                    {\n                        \"name\": \"DP3ConstructionTypeSC_aaa\",\n                        \"includedCodes\": [\n                            \"M\",\n                            \"Frame\",\n                            \"Superior\",\n                            \"MasonryVeneer\"\n                        ]\n                    },\n                    {\n                        \"name\": \"DP3ConstructionTypeNC_aaa\",\n                        \"includedCodes\": [\n                            \"M\",\n                            \"Frame\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.RoofType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"comp\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.comp\"\n                    },\n                    {\n                        \"code\": \"wood\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.wood\"\n                    },\n                    {\n                        \"code\": \"plastic\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.plastic\"\n                    },\n                    {\n                        \"code\": \"targravel\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.targravel\"\n                    },\n                    {\n                        \"code\": \"slate\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.slate\"\n                    },\n                    {\n                        \"code\": \"tileclay\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.tileclay\"\n                    },\n                    {\n                        \"code\": \"tileconcrete\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.tileconcrete\"\n                    },\n                    {\n                        \"code\": \"fiberCement\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.fiberCement\"\n                    },\n                    {\n                        \"code\": \"fiberAluminum\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.fiberAluminum\"\n                    },\n                    {\n                        \"code\": \"copper\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.copper\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.other\"\n                    },\n                    {\n                        \"code\": \"A\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.A\"\n                    },\n                    {\n                        \"code\": \"B\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.B\"\n                    },\n                    {\n                        \"code\": \"C\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.C\"\n                    },\n                    {\n                        \"code\": \"standingSeamMetal\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.standingSeamMetal\"\n                    },\n                    {\n                        \"code\": \"ArchitecturalShingles\",\n                        \"priority\": 160,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.ArchitecturalShingles\"\n                    },\n                    {\n                        \"code\": \"AsphaltFiberComp\",\n                        \"priority\": 170,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.AsphaltFiberComp\"\n                    },\n                    {\n                        \"code\": \"ClayTileSlate\",\n                        \"priority\": 180,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.ClayTileSlate\"\n                    },\n                    {\n                        \"code\": \"ConcreteTile\",\n                        \"priority\": 190,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.ConcreteTile\"\n                    },\n                    {\n                        \"code\": \"CorrugatedMetalTin\",\n                        \"priority\": 200,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.CorrugatedMetalTin\"\n                    },\n                    {\n                        \"code\": \"FlatFoamComposite\",\n                        \"priority\": 210,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.FlatFoamComposite\"\n                    },\n                    {\n                        \"code\": \"FlatMembrane\",\n                        \"priority\": 220,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.FlatMembrane\"\n                    },\n                    {\n                        \"code\": \"FlatTarGravel\",\n                        \"priority\": 230,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.FlatTarGravel\"\n                    },\n                    {\n                        \"code\": \"WoodShakeShingles\",\n                        \"priority\": 240,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.WoodShakeShingles\"\n                    },\n                    {\n                        \"code\": \"FlatPitchedRoof\",\n                        \"priority\": 250,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.FlatPitchedRoof\"\n                    },\n                    {\n                        \"code\": \"TarShingle\",\n                        \"priority\": 260,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.TarShingle\"\n                    },\n                    {\n                        \"code\": \"SuperiorPouredConcrete\",\n                        \"priority\": 270,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.SuperiorPouredConcrete\"\n                    },\n                    {\n                        \"code\": \"Asbestos\",\n                        \"priority\": 280,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.Asbestos\"\n                    },\n                    {\n                        \"code\": \"WoodShake\",\n                        \"priority\": 290,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.WoodShake\"\n                    },\n                    {\n                        \"code\": \"WoodShingle\",\n                        \"priority\": 300,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.WoodShingle\"\n                    },\n                    {\n                        \"code\": \"BarrelTile\",\n                        \"priority\": 310,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.BarrelTile\"\n                    },\n                    {\n                        \"code\": \"FlatTile\",\n                        \"priority\": 320,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.FlatTile\"\n                    },\n                    {\n                        \"code\": \"Tile\",\n                        \"priority\": 330,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.Tile\"\n                    },\n                    {\n                        \"code\": \"Metal\",\n                        \"priority\": 340,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.Metal\"\n                    },\n                    {\n                        \"code\": \"RolledRoof\",\n                        \"priority\": 350,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.RolledRoof\"\n                    },\n                    {\n                        \"code\": \"AluminumCorrugated\",\n                        \"priority\": 360,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.AluminumCorrugated\"\n                    },\n                    {\n                        \"code\": \"PouredConcrete\",\n                        \"priority\": 370,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RoofType.PouredConcrete\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"HOSpecific\",\n                        \"includedCodes\": [\n                            \"other\",\n                            \"standingSeamMetal\",\n                            \"ArchitecturalShingles\",\n                            \"AsphaltFiberComp\",\n                            \"ClayTileSlate\",\n                            \"ConcreteTile\",\n                            \"CorrugatedMetalTin\",\n                            \"FlatFoamComposite\",\n                            \"FlatMembrane\",\n                            \"FlatTarGravel\",\n                            \"WoodShakeShingles\",\n                            \"FlatPitchedRoof\"\n                        ]\n                    },\n                    {\n                        \"name\": \"CPSpecific\",\n                        \"includedCodes\": [\n                            \"A\",\n                            \"B\",\n                            \"C\"\n                        ]\n                    },\n                    {\n                        \"name\": \"DP3Specific\",\n                        \"includedCodes\": [\n                            \"comp\",\n                            \"slate\",\n                            \"other\",\n                            \"ArchitecturalShingles\",\n                            \"ConcreteTile\",\n                            \"FlatTarGravel\",\n                            \"TarShingle\",\n                            \"SuperiorPouredConcrete\",\n                            \"Asbestos\",\n                            \"WoodShake\",\n                            \"WoodShingle\",\n                            \"BarrelTile\",\n                            \"FlatTile\",\n                            \"Tile\",\n                            \"Metal\",\n                            \"RolledRoof\",\n                            \"AluminumCorrugated\",\n                            \"PouredConcrete\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.FoundationType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"SlabOnGround\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.SlabOnGround\"\n                    },\n                    {\n                        \"code\": \"Basement\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.Basement\"\n                    },\n                    {\n                        \"code\": \"OpenFoundation\",\n                        \"priority\": 15,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.OpenFoundation\"\n                    },\n                    {\n                        \"code\": \"CrawlSpace\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.CrawlSpace\"\n                    },\n                    {\n                        \"code\": \"PiersElevated\",\n                        \"priority\": 25,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.PiersElevated\"\n                    },\n                    {\n                        \"code\": \"Pilings\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.Pilings\"\n                    },\n                    {\n                        \"code\": \"Stilts\",\n                        \"priority\": 35,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.Stilts\"\n                    },\n                    {\n                        \"code\": \"SuspendedOverHillside\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FoundationType_HOE.SuspendedOverHillside\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.HeatingType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"CentralElectric\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.CentralElectric\"\n                    },\n                    {\n                        \"code\": \"Central-Gas\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.Central-Gas\"\n                    },\n                    {\n                        \"code\": \"CentralOilAboveGT\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.CentralOilAboveGT\"\n                    },\n                    {\n                        \"code\": \"CentralOilBelowGT\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.CentralOilBelowGT\"\n                    },\n                    {\n                        \"code\": \"GeothermalOpenClosed\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.GeothermalOpenClosed\"\n                    },\n                    {\n                        \"code\": \"Woodstove\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.Woodstove\"\n                    },\n                    {\n                        \"code\": \"FireplaceInsert\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.FireplaceInsert\"\n                    },\n                    {\n                        \"code\": \"SpaceHeater\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.SpaceHeater\"\n                    },\n                    {\n                        \"code\": \"NoCentralHeatingSys\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.NoCentralHeatingSys\"\n                    },\n                    {\n                        \"code\": \"Other\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HeatingType_HOE.Other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PlumbingType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"copper\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.copper\"\n                    },\n                    {\n                        \"code\": \"pvc\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.pvc\"\n                    },\n                    {\n                        \"code\": \"PEX\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.PEX\"\n                    },\n                    {\n                        \"code\": \"galv\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.galv\"\n                    },\n                    {\n                        \"code\": \"Polybutylene\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.Polybutylene\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PlumbingType_HOE.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.WiringType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Romex\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WiringType_HOE.Romex\"\n                    },\n                    {\n                        \"code\": \"KnobAndTube\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WiringType_HOE.KnobAndTube\"\n                    },\n                    {\n                        \"code\": \"aluminum\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WiringType_HOE.aluminum\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WiringType_HOE.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BreakerType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"CircuitBreaker\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BreakerType_HOE.CircuitBreaker\"\n                    },\n                    {\n                        \"code\": \"Fuses\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BreakerType_HOE.Fuses\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BreakerType_HOE.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PolicyType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"condounitowner\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyType_aaa.condounitowner\"\n                    },\n                    {\n                        \"code\": \"homeowners\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HE7_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyType_aaa.homeowners\"\n                    },\n                    {\n                        \"code\": \"landlord\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyType_aaa.landlord\"\n                    },\n                    {\n                        \"code\": \"renter\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.PolicyType_aaa.renter\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.HOPolicyType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"HO3\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.HO3\"\n                    },\n                    {\n                        \"code\": \"HO4\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.HO4\"\n                    },\n                    {\n                        \"code\": \"HO6\",\n                        \"priority\": 15,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.HO6\"\n                    },\n                    {\n                        \"code\": \"HE7_aaa\",\n                        \"priority\": 16,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.HE7_aaa\"\n                    },\n                    {\n                        \"code\": \"HO8_aaa\",\n                        \"priority\": 17,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.HO8_aaa\"\n                    },\n                    {\n                        \"code\": \"DP3\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.HOPolicyType_HOE.DP3\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"PolicyTypeUIC\",\n                        \"includedCodes\": [\n                            \"HO3\",\n                            \"HO4\",\n                            \"HO6\",\n                            \"HO8_aaa\",\n                            \"DP3\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.ResidenceType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Fam1\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HE7_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Fam1\"\n                    },\n                    {\n                        \"code\": \"Fam2\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Fam2\"\n                    },\n                    {\n                        \"code\": \"Fam3\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Fam3\"\n                    },\n                    {\n                        \"code\": \"Fam4\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Fam4\"\n                    },\n                    {\n                        \"code\": \"Fam5\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Fam5\"\n                    },\n                    {\n                        \"code\": \"Apt\",\n                        \"priority\": 60,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Apt\"\n                    },\n                    {\n                        \"code\": \"Condo\",\n                        \"priority\": 70,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Condo\"\n                    },\n                    {\n                        \"code\": \"TownRow\",\n                        \"priority\": 80,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.TownRow\"\n                    },\n                    {\n                        \"code\": \"rowhouse_aaa\",\n                        \"priority\": 82,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.rowhouse_aaa\"\n                    },\n                    {\n                        \"code\": \"Duplex\",\n                        \"priority\": 85,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Duplex\"\n                    },\n                    {\n                        \"code\": \"Coop\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Coop\"\n                    },\n                    {\n                        \"code\": \"Mobile\",\n                        \"priority\": 100,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Mobile\"\n                    },\n                    {\n                        \"code\": \"ManufacturedHome_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO8_aaa\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.ManufacturedHome_aaa\"\n                    },\n                    {\n                        \"code\": \"Quadplex_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Quadplex_aaa\"\n                    },\n                    {\n                        \"code\": \"Triplex_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP3\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.ResidenceType_HOE.Triplex_aaa\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DwellingOccupancyType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"owner\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingOccupancyType_HOE.owner\"\n                    },\n                    {\n                        \"code\": \"tenant\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingOccupancyType_HOE.tenant\"\n                    },\n                    {\n                        \"code\": \"nonown\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingOccupancyType_HOE.nonown\"\n                    },\n                    {\n                        \"code\": \"vacant\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingOccupancyType_HOE.vacant\"\n                    },\n                    {\n                        \"code\": \"inconst\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingOccupancyType_HOE.inconst\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DwellingLocationType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"city\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingLocationType_HOE.city\"\n                    },\n                    {\n                        \"code\": \"fire\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingLocationType_HOE.fire\"\n                    },\n                    {\n                        \"code\": \"prot\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingLocationType_HOE.prot\"\n                    },\n                    {\n                        \"code\": \"unprot\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingLocationType_HOE.unprot\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingLocationType_HOE.other\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DwellingUsage_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"prim\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingUsage_HOE.prim\"\n                    },\n                    {\n                        \"code\": \"sec\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingUsage_HOE.sec\"\n                    },\n                    {\n                        \"code\": \"seas\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingUsage_HOE.seas\"\n                    },\n                    {\n                        \"code\": \"rent\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DwellingUsage_HOE.rent\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BurglarAlarmType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"local\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BurglarAlarmType_HOE.local\"\n                    },\n                    {\n                        \"code\": \"central\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BurglarAlarmType_HOE.central\"\n                    },\n                    {\n                        \"code\": \"police\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BurglarAlarmType_HOE.police\"\n                    },\n                    {\n                        \"code\": \"none\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BurglarAlarmType_HOE.none\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.FireAlarmType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"centralstation_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireAlarmType_aaa.centralstation_aaa\"\n                    },\n                    {\n                        \"code\": \"firestation_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireAlarmType_aaa.firestation_aaa\"\n                    },\n                    {\n                        \"code\": \"local_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireAlarmType_aaa.local_aaa\"\n                    },\n                    {\n                        \"code\": \"none\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.FireAlarmType_aaa.none\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.SprinklerSystemType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"none\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.SprinklerSystemType_HOE.none\"\n                    },\n                    {\n                        \"code\": \"full\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.SprinklerSystemType_HOE.full\"\n                    },\n                    {\n                        \"code\": \"partial\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.SprinklerSystemType_HOE.partial\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.NumUnits_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"One\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.One\"\n                    },\n                    {\n                        \"code\": \"Two\",\n                        \"priority\": 20,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO3\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"DP2\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.Two\"\n                    },\n                    {\n                        \"code\": \"Three\",\n                        \"priority\": 30,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.Three\"\n                    },\n                    {\n                        \"code\": \"Four\",\n                        \"priority\": 40,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.Four\"\n                    },\n                    {\n                        \"code\": \"FiveToFifteen\",\n                        \"priority\": 50,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.FiveToFifteen\"\n                    },\n                    {\n                        \"code\": \"SixteeenToTwentyFive\",\n                        \"priority\": 60,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.SixteeenToTwentyFive\"\n                    },\n                    {\n                        \"code\": \"TwentySixPlus\",\n                        \"priority\": 70,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO4\"\n                            },\n                            {\n                                \"typelist\": \"HOPolicyType_HOE\",\n                                \"typecode\": \"HO6\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.NumUnits_HOE.TwentySixPlus\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AccessType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"limitedaccess_aaa\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccessType_aaa.limitedaccess_aaa\"\n                    },\n                    {\n                        \"code\": \"mannedsecurity_aaa\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AccessType_aaa.mannedsecurity_aaa\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.WaterProtectDevice_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"none\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaterProtectDevice_aaa.none\"\n                    },\n                    {\n                        \"code\": \"closeShutOffMasterPlumbOnly\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaterProtectDevice_aaa.closeShutOffMasterPlumbOnly\"\n                    },\n                    {\n                        \"code\": \"closeShutOffMasterPlumbNotify\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaterProtectDevice_aaa.closeShutOffMasterPlumbNotify\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.person.dto.PersonDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PrimaryPhoneType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PrimaryPhoneType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FirstNameKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 50\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 50\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LastNameKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 50\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 50\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"FirstName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 50\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 50\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            }\n                        ]\n                    },\n                    \"Prefix\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NamePrefix\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MiddleName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 1\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 1\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ENCDateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HomeNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"optionalVisibility\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"eq\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"getfield\",\n                                                        \"base\": {\n                                                            \"kind\": \"parameter\",\n                                                            \"index\": 1\n                                                        },\n                                                        \"propertyName\": \"PrimaryPhoneType\"\n                                                    },\n                                                    {\n                                                        \"kind\": \"const\",\n                                                        \"type\": \"typekey PrimaryPhoneType\",\n                                                        \"value\": \"home\"\n                                                    }\n                                                ]\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                \"value\": \"REQUIRED\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Particle\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MaritalStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.MaritalStatus\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Suffix\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.NameSuffix\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TempID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [],\n                        \"readOnly\": true\n                    },\n                    \"WorkNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LastName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 50\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 50\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"java.util.ArrayList<java.lang.Object>\",\n                                \"value\": [\n                                    {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[&amp;A-Za-z0-9#/`', ._-]+\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.SpecialChar\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    }\n                                ]\n                            }\n                        ]\n                    },\n                    \"CellNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 30\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 30\n                                            }\n                                        ]\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"gw.api.util.PhoneUtil\",\n                                        \"name\": \"isPossibleNumber\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"dto\",\n                                                \"value\": \"US\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Phone\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.NumberOfAccidents\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"0\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.0\"\n                    },\n                    {\n                        \"code\": \"1\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.1\"\n                    },\n                    {\n                        \"code\": \"2\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.2\"\n                    },\n                    {\n                        \"code\": \"3\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.3\"\n                    },\n                    {\n                        \"code\": \"4\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.4\"\n                    },\n                    {\n                        \"code\": \"5\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.NumberOfAccidents.5\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.RelationshipType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"insured_aaa\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.insured_aaa\"\n                    },\n                    {\n                        \"code\": \"secondNamedInsured_aaa\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.secondNamedInsured_aaa\"\n                    },\n                    {\n                        \"code\": \"Trust\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Trust\"\n                    },\n                    {\n                        \"code\": \"Guardian\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Guardian\"\n                    },\n                    {\n                        \"code\": \"Attorney\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Attorney\"\n                    },\n                    {\n                        \"code\": \"CoOwner\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.CoOwner\"\n                    },\n                    {\n                        \"code\": \"OtherParty\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.OtherParty\"\n                    },\n                    {\n                        \"code\": \"Relative\",\n                        \"priority\": 7,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Relative\"\n                    },\n                    {\n                        \"code\": \"Spouse\",\n                        \"priority\": 8,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Spouse\"\n                    },\n                    {\n                        \"code\": \"Child\",\n                        \"priority\": 9,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Child\"\n                    },\n                    {\n                        \"code\": \"Other\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RelationshipType_aaa.Other\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"RelationshipPrimaryInsured_PA\",\n                        \"includedCodes\": [\n                            \"Trust\",\n                            \"Guardian\",\n                            \"Attorney\",\n                            \"CoOwner\",\n                            \"OtherParty\",\n                            \"Relative\",\n                            \"Spouse\"\n                        ]\n                    },\n                    {\n                        \"name\": \"RelationshipPrimaryInsured_HO\",\n                        \"includedCodes\": [\n                            \"Trust\",\n                            \"Guardian\",\n                            \"Attorney\",\n                            \"CoOwner\",\n                            \"OtherParty\",\n                            \"Relative\"\n                        ]\n                    },\n                    {\n                        \"name\": \"RelationShipFilterForDriver\",\n                        \"includedCodes\": [\n                            \"Relative\",\n                            \"Spouse\",\n                            \"Child\",\n                            \"Other\"\n                        ]\n                    },\n                    {\n                        \"name\": \"RelationshipPrimaryInsured_PUP\",\n                        \"includedCodes\": [\n                            \"insured_aaa\",\n                            \"secondNamedInsured_aaa\",\n                            \"Trust\",\n                            \"Relative\",\n                            \"Spouse\",\n                            \"Child\",\n                            \"Other\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AffinityGroup_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"AmericanLegion\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.AmericanLegion\"\n                    },\n                    {\n                        \"code\": \"AARP\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.AARP\"\n                    },\n                    {\n                        \"code\": \"BASS\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.BASS\"\n                    },\n                    {\n                        \"code\": \"CarpentersUnion\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.CarpentersUnion\"\n                    },\n                    {\n                        \"code\": \"COSTCO\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.COSTCO\"\n                    },\n                    {\n                        \"code\": \"SamsClub\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.SamsClub\"\n                    },\n                    {\n                        \"code\": \"CreditUnion\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.CreditUnion\"\n                    },\n                    {\n                        \"code\": \"NationalGuard\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.NationalGuard\"\n                    },\n                    {\n                        \"code\": \"NationalNotary\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.NationalNotary\"\n                    },\n                    {\n                        \"code\": \"NRA\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.NRA\"\n                    },\n                    {\n                        \"code\": \"RuralLetter\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.RuralLetter\"\n                    },\n                    {\n                        \"code\": \"USCAlumni\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.USCAlumni\"\n                    },\n                    {\n                        \"code\": \"None\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AffinityGroup_aaa.None\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DriverType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"principal\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverType_aaa.principal\"\n                    },\n                    {\n                        \"code\": \"occasional\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverType_aaa.occasional\"\n                    },\n                    {\n                        \"code\": \"nondriver\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverType_aaa.nondriver\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"driverrule\",\n                        \"includedCodes\": [\n                            \"principal\",\n                            \"occasional\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.AccidentClaimDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WaivedStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.WaivedStatus_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Category\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Amount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WaivedStatusStr\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfEvent\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.AccidentClaimPortalDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Type\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WaivedStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.WaivedStatus_aaa\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Category\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Amount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Editing\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Remove\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"WaivedStatusStr\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PcDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Date\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.time.LocalDateDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PortalDescription\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DriverStatus_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Rated\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverStatus_aaa.Rated\"\n                    },\n                    {\n                        \"code\": \"Not-Rated\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverStatus_aaa.Not-Rated\"\n                    },\n                    {\n                        \"code\": \"Excluded\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DriverStatus_aaa.Excluded\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"NC_Driver_Status\",\n                        \"includedCodes\": [\n                            \"Rated\",\n                            \"Not-Rated\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PAPolicyType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"personal_automobiles\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PAPolicyType_aaa.personal_automobiles\"\n                    },\n                    {\n                        \"code\": \"liability_only\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PAPolicyType_aaa.liability_only\"\n                    },\n                    {\n                        \"code\": \"named_non_owner\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PAPolicyType_aaa.named_non_owner\"\n                    },\n                    {\n                        \"code\": \"motorcycle\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PAPolicyType_aaa.motorcycle\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"NCPolicyTypes\",\n                        \"includedCodes\": [\n                            \"personal_automobiles\",\n                            \"named_non_owner\",\n                            \"motorcycle\"\n                        ]\n                    },\n                    {\n                        \"name\": \"SCPolicyTypes\",\n                        \"includedCodes\": [\n                            \"personal_automobiles\",\n                            \"named_non_owner\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.VehicleType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Commercial\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"BusinessAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.Commercial\"\n                    },\n                    {\n                        \"code\": \"PP\",\n                        \"priority\": 2,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"BusinessAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.PP\"\n                    },\n                    {\n                        \"code\": \"PublicTransport\",\n                        \"priority\": 3,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"BusinessAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.PublicTransport\"\n                    },\n                    {\n                        \"code\": \"Special\",\n                        \"priority\": 4,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"BusinessAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.Special\"\n                    },\n                    {\n                        \"code\": \"auto\",\n                        \"priority\": 5,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"PersonalAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.auto\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 10,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"BusinessAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.other\"\n                    },\n                    {\n                        \"code\": \"motorcycle_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"PersonalAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.motorcycle_aaa\"\n                    },\n                    {\n                        \"code\": \"traveltrailer_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"PersonalAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.traveltrailer_aaa\"\n                    },\n                    {\n                        \"code\": \"utilitytrailer_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"PolicyLine\",\n                                \"typecode\": \"PersonalAutoLine\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehicleType.utilitytrailer_aaa\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.VehiclePrimaryUse\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"business\",\n                        \"priority\": 1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"traveltrailer_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"utilitytrailer_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.business\"\n                    },\n                    {\n                        \"code\": \"pleasure\",\n                        \"priority\": 2,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"traveltrailer_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"utilitytrailer_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.pleasure\"\n                    },\n                    {\n                        \"code\": \"commuting\",\n                        \"priority\": 3,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"traveltrailer_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"utilitytrailer_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.commuting\"\n                    },\n                    {\n                        \"code\": \"mixed\",\n                        \"priority\": 4,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"other\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.mixed\"\n                    },\n                    {\n                        \"code\": \"Antique\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Antique\"\n                    },\n                    {\n                        \"code\": \"AutoDeliveryPickUp\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.AutoDeliveryPickUp\"\n                    },\n                    {\n                        \"code\": \"AthleteEntertainer\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.AthleteEntertainer\"\n                    },\n                    {\n                        \"code\": \"CharterBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.CharterBus\"\n                    },\n                    {\n                        \"code\": \"ChurchBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.ChurchBus\"\n                    },\n                    {\n                        \"code\": \"InterCityBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.InterCityBus\"\n                    },\n                    {\n                        \"code\": \"UrbanBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.UrbanBus\"\n                    },\n                    {\n                        \"code\": \"OtherBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.OtherBus\"\n                    },\n                    {\n                        \"code\": \"OtherSchoolBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.OtherSchoolBus\"\n                    },\n                    {\n                        \"code\": \"DistrictOwnedSchoolBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.DistrictOwnedSchoolBus\"\n                    },\n                    {\n                        \"code\": \"SightseeingBus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.SightseeingBus\"\n                    },\n                    {\n                        \"code\": \"AirportBusLimo\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.AirportBusLimo\"\n                    },\n                    {\n                        \"code\": \"Commercial\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Commercial\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Commercial\"\n                    },\n                    {\n                        \"code\": \"CarService\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.CarService\"\n                    },\n                    {\n                        \"code\": \"CommDrivingSchool\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.CommDrivingSchool\"\n                    },\n                    {\n                        \"code\": \"Retail\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Commercial\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Retail\"\n                    },\n                    {\n                        \"code\": \"AmbulanceService\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.AmbulanceService\"\n                    },\n                    {\n                        \"code\": \"farm_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"traveltrailer_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"utilitytrailer_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.farm_aaa\"\n                    },\n                    {\n                        \"code\": \"FarmLaborExcPassHaz\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FarmLaborExcPassHaz\"\n                    },\n                    {\n                        \"code\": \"FarmLaborIncPassHaz\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FarmLaborIncPassHaz\"\n                    },\n                    {\n                        \"code\": \"FireDepartmentOther\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FireDepartmentOther\"\n                    },\n                    {\n                        \"code\": \"FireDepartmentPP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FireDepartmentPP\"\n                    },\n                    {\n                        \"code\": \"FuneralLimousine\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FuneralLimousine\"\n                    },\n                    {\n                        \"code\": \"FuneralHearse\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.FuneralHearse\"\n                    },\n                    {\n                        \"code\": \"GolfMobiles\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.GolfMobiles\"\n                    },\n                    {\n                        \"code\": \"LeasingContingentCov\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.LeasingContingentCov\"\n                    },\n                    {\n                        \"code\": \"Limousine\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Limousine\"\n                    },\n                    {\n                        \"code\": \"RentedLeasedTaxi\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentedLeasedTaxi\"\n                    },\n                    {\n                        \"code\": \"OwnerDrivenTaxi\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.OwnerDrivenTaxi\"\n                    },\n                    {\n                        \"code\": \"MobileHomeTrailorLQ\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.MobileHomeTrailorLQ\"\n                    },\n                    {\n                        \"code\": \"LawEnforcementMCycle\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.LawEnforcementMCycle\"\n                    },\n                    {\n                        \"code\": \"LawEnforcementOther\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.LawEnforcementOther\"\n                    },\n                    {\n                        \"code\": \"LawEnforcementPP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.LawEnforcementPP\"\n                    },\n                    {\n                        \"code\": \"RentalMisc\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalMisc\"\n                    },\n                    {\n                        \"code\": \"RentalPPAuto\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalPPAuto\"\n                    },\n                    {\n                        \"code\": \"RentalMotorHome\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalMotorHome\"\n                    },\n                    {\n                        \"code\": \"RentalTractor\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalTractor\"\n                    },\n                    {\n                        \"code\": \"RentalTrailer\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalTrailer\"\n                    },\n                    {\n                        \"code\": \"RentalTruck\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RentalTruck\"\n                    },\n                    {\n                        \"code\": \"RepossessedAutomobile\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.RepossessedAutomobile\"\n                    },\n                    {\n                        \"code\": \"MobileHomeLess22Ft\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.MobileHomeLess22Ft\"\n                    },\n                    {\n                        \"code\": \"MobileHomeCamperBody\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.MobileHomeCamperBody\"\n                    },\n                    {\n                        \"code\": \"MobileHomeGreater22Ft\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.MobileHomeGreater22Ft\"\n                    },\n                    {\n                        \"code\": \"DriverTraining\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.DriverTraining\"\n                    },\n                    {\n                        \"code\": \"Snowmobiles\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Snowmobiles\"\n                    },\n                    {\n                        \"code\": \"SSA_Emp\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.SSA_Emp\"\n                    },\n                    {\n                        \"code\": \"SSA_Other\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.SSA_Other\"\n                    },\n                    {\n                        \"code\": \"Taxicab\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Taxicab\"\n                    },\n                    {\n                        \"code\": \"tncride_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"traveltrailer_aaa\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"utilitytrailer_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.tncride_aaa\"\n                    },\n                    {\n                        \"code\": \"BobtailOperation\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Special\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.BobtailOperation\"\n                    },\n                    {\n                        \"code\": \"Service\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"Commercial\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.Service\"\n                    },\n                    {\n                        \"code\": \"OtherVan\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.OtherVan\"\n                    },\n                    {\n                        \"code\": \"EmployerFurnishedVan\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"PublicTransport\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.VehiclePrimaryUse.EmployerFurnishedVan\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AdditionalInterestType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"additionalinterest_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"PAVhcleAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"WCRBoatAddlInterest_AAA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.additionalinterest_aaa\"\n                    },\n                    {\n                        \"code\": \"CERTHOLDER\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.CERTHOLDER\"\n                    },\n                    {\n                        \"code\": \"CONSALE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BOPBldgAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"CPBldgAddlInterest\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.CONSALE\"\n                    },\n                    {\n                        \"code\": \"LENDLOSS\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BOPBldgAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"CPBldgAddlInterest\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.LENDLOSS\"\n                    },\n                    {\n                        \"code\": \"LESSOR\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BAVhcleAddlInterest\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.LESSOR\"\n                    },\n                    {\n                        \"code\": \"LIEN\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BAVhcleAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BOPBldgAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"IMSchEquipAddlInterest\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.LIEN\"\n                    },\n                    {\n                        \"code\": \"LOSSPAY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"CPBldgAddlInterest\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.LOSSPAY\"\n                    },\n                    {\n                        \"code\": \"LOSSP\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"BOPBldgAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"PAVhcleAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"WCRBoatAddlInterest_AAA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.LOSSP\"\n                    },\n                    {\n                        \"code\": \"MORTGAGEE\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.MORTGAGEE\"\n                    },\n                    {\n                        \"code\": \"otherparty_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"PAVhcleAddlInterest\"\n                            },\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"WCRBoatAddlInterest_AAA\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.otherparty_aaa\"\n                    },\n                    {\n                        \"code\": \"THIRDPARTY\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"AddlInterestDetail\",\n                                \"typecode\": \"HODwellingAddlInt_HOE\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.AdditionalInterestType.THIRDPARTY\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.LengthOfLease\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"SixMonthsOrMore\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.LengthOfLease.SixMonthsOrMore\"\n                    },\n                    {\n                        \"code\": \"LessSixMonths\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.LengthOfLease.LessSixMonths\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.draft.dto.PAVehicleAdditionalInterest\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AddnlInterstType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AdditionalInterestType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddnlInterestAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressAdditionalInterestDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BodyType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"adultscooter_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.adultscooter_aaa\"\n                    },\n                    {\n                        \"code\": \"atv\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.atv\"\n                    },\n                    {\n                        \"code\": \"bus\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.bus\"\n                    },\n                    {\n                        \"code\": \"cabriolet_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.cabriolet_aaa\"\n                    },\n                    {\n                        \"code\": \"camper_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.camper_aaa\"\n                    },\n                    {\n                        \"code\": \"chopper_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.chopper_aaa\"\n                    },\n                    {\n                        \"code\": \"convertible\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.convertible\"\n                    },\n                    {\n                        \"code\": \"coupe\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.coupe\"\n                    },\n                    {\n                        \"code\": \"cruiser_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            },\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.cruiser_aaa\"\n                    },\n                    {\n                        \"code\": \"dirtbike_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.dirtbike_aaa\"\n                    },\n                    {\n                        \"code\": \"dualpurpose_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.dualpurpose_aaa\"\n                    },\n                    {\n                        \"code\": \"electric_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.electric_aaa\"\n                    },\n                    {\n                        \"code\": \"fastback_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.fastback_aaa\"\n                    },\n                    {\n                        \"code\": \"golfcart_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.golfcart_aaa\"\n                    },\n                    {\n                        \"code\": \"hatchback_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.hatchback_aaa\"\n                    },\n                    {\n                        \"code\": \"incomplete_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.incomplete_aaa\"\n                    },\n                    {\n                        \"code\": \"kombi_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.kombi_aaa\"\n                    },\n                    {\n                        \"code\": \"liftback_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.liftback_aaa\"\n                    },\n                    {\n                        \"code\": \"limitedproduction_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.limitedproduction_aaa\"\n                    },\n                    {\n                        \"code\": \"limousine_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.limousine_aaa\"\n                    },\n                    {\n                        \"code\": \"moped_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.moped_aaa\"\n                    },\n                    {\n                        \"code\": \"motorcycle\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.motorcycle\"\n                    },\n                    {\n                        \"code\": \"MPV_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.MPV_aaa\"\n                    },\n                    {\n                        \"code\": \"offroad_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.offroad_aaa\"\n                    },\n                    {\n                        \"code\": \"other_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.other_aaa\"\n                    },\n                    {\n                        \"code\": \"pickup\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.pickup\"\n                    },\n                    {\n                        \"code\": \"scooter_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.scooter_aaa\"\n                    },\n                    {\n                        \"code\": \"fourdoor\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.fourdoor\"\n                    },\n                    {\n                        \"code\": \"twodoor\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.twodoor\"\n                    },\n                    {\n                        \"code\": \"sidecar_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sidecar_aaa\"\n                    },\n                    {\n                        \"code\": \"snowmobile\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.snowmobile\"\n                    },\n                    {\n                        \"code\": \"sport_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sport_aaa\"\n                    },\n                    {\n                        \"code\": \"sportcoupe_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sportcoupe_aaa\"\n                    },\n                    {\n                        \"code\": \"sporthatchback_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sporthatchback_aaa\"\n                    },\n                    {\n                        \"code\": \"sportsedan_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sportsedan_aaa\"\n                    },\n                    {\n                        \"code\": \"sporttouring_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sporttouring_aaa\"\n                    },\n                    {\n                        \"code\": \"sportsutility_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.sportsutility_aaa\"\n                    },\n                    {\n                        \"code\": \"standard_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.standard_aaa\"\n                    },\n                    {\n                        \"code\": \"supersport_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.supersport_aaa\"\n                    },\n                    {\n                        \"code\": \"targaconvertible_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.targaconvertible_aaa\"\n                    },\n                    {\n                        \"code\": \"touring_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.touring_aaa\"\n                    },\n                    {\n                        \"code\": \"trikes_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.trikes_aaa\"\n                    },\n                    {\n                        \"code\": \"truck\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.truck\"\n                    },\n                    {\n                        \"code\": \"uncladsport_aaa\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.uncladsport_aaa\"\n                    },\n                    {\n                        \"code\": \"util-trailer\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.util-trailer\"\n                    },\n                    {\n                        \"code\": \"van\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.van\"\n                    },\n                    {\n                        \"code\": \"wagon\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"auto\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.BodyType.wagon\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"InEligibleBodyTypeForAuto_aaa\",\n                        \"includedCodes\": [\n                            \"bus\",\n                            \"limousine_aaa\",\n                            \"MPV_aaa\"\n                        ]\n                    },\n                    {\n                        \"name\": \"InEligibleBodyTypeForMC_aaa\",\n                        \"includedCodes\": [\n                            \"adultscooter_aaa\",\n                            \"atv\",\n                            \"chopper_aaa\",\n                            \"dirtbike_aaa\",\n                            \"dualpurpose_aaa\",\n                            \"golfcart_aaa\",\n                            \"incomplete_aaa\",\n                            \"limitedproduction_aaa\",\n                            \"moped_aaa\",\n                            \"other_aaa\",\n                            \"scooter_aaa\",\n                            \"snowmobile\",\n                            \"supersport_aaa\",\n                            \"uncladsport_aaa\",\n                            \"util-trailer\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.StorageType_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"driveway\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.driveway\"\n                    },\n                    {\n                        \"code\": \"lockedgarage\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.lockedgarage\"\n                    },\n                    {\n                        \"code\": \"lockedstorageunit\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.lockedstorageunit\"\n                    },\n                    {\n                        \"code\": \"onstreet\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.onstreet\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.other\"\n                    },\n                    {\n                        \"code\": \"parkinglot\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.parkinglot\"\n                    },\n                    {\n                        \"code\": \"privateparkinggarage\",\n                        \"priority\": -1,\n                        \"categories\": [\n                            {\n                                \"typelist\": \"VehicleType\",\n                                \"typecode\": \"motorcycle_aaa\"\n                            }\n                        ],\n                        \"displayKey\": \"typekey.StorageType_aaa.privateparkinggarage\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.quoting.dto.ScheduledPropertyDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Type\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ScheduleType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"belongsToFilter\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"SchedulePersonalProperty_aaa\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterBy\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.TypelistFilterDTO\",\n                                \"value\": {\n                                    \"filterName\": \"SchedulePersonalProperty_aaa\"\n                                }\n                            }\n                        ]\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FixedId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExposureValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.homeowners.quoting.dto.BlanketValueItemsDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Type\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.ScheduleType_HOE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"belongsToFilter\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"BlanketItems_aaa\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterBy\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.TypelistFilterDTO\",\n                                \"value\": {\n                                    \"filterName\": \"BlanketItems_aaa\"\n                                }\n                            }\n                        ]\n                    },\n                    \"FixedId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExposureValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.lob.personalauto.quoting.dto.VehicleCoverageDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Coverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"FixedId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Long\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"VehicleName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.CoverageForm\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"BPP\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.CoverageForm.BPP\"\n                    },\n                    {\n                        \"code\": \"CondoAssoc\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.CoverageForm.CondoAssoc\"\n                    },\n                    {\n                        \"code\": \"CondoUnitOwners\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.CoverageForm.CondoUnitOwners\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.RateType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Class\",\n                        \"priority\": 0,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RateType.Class\"\n                    },\n                    {\n                        \"code\": \"Specific\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.RateType.Specific\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.ConstructionType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"F\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.F\"\n                    },\n                    {\n                        \"code\": \"JMR\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.JMR\"\n                    },\n                    {\n                        \"code\": \"JMNR\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.JMNR\"\n                    },\n                    {\n                        \"code\": \"NCLS\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.NCLS\"\n                    },\n                    {\n                        \"code\": \"NCNLS\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.NCNLS\"\n                    },\n                    {\n                        \"code\": \"MNCR\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.MNCR\"\n                    },\n                    {\n                        \"code\": \"MNCNR\",\n                        \"priority\": 7,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.MNCNR\"\n                    },\n                    {\n                        \"code\": \"MFR\",\n                        \"priority\": 8,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.MFR\"\n                    },\n                    {\n                        \"code\": \"FRLSR\",\n                        \"priority\": 9,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.FRLSR\"\n                    },\n                    {\n                        \"code\": \"FRLSNR\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.FRLSNR\"\n                    },\n                    {\n                        \"code\": \"FRNLSR\",\n                        \"priority\": 11,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.FRNLSR\"\n                    },\n                    {\n                        \"code\": \"FRNLSNR\",\n                        \"priority\": 12,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ConstructionType.FRNLSNR\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.Sprinklered\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"100\",\n                        \"priority\": 0,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.100\"\n                    },\n                    {\n                        \"code\": \"90\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.90\"\n                    },\n                    {\n                        \"code\": \"80\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.80\"\n                    },\n                    {\n                        \"code\": \"70\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.70\"\n                    },\n                    {\n                        \"code\": \"60\",\n                        \"priority\": 4,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.60\"\n                    },\n                    {\n                        \"code\": \"50\",\n                        \"priority\": 5,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.50\"\n                    },\n                    {\n                        \"code\": \"40\",\n                        \"priority\": 6,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.40\"\n                    },\n                    {\n                        \"code\": \"30\",\n                        \"priority\": 7,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.30\"\n                    },\n                    {\n                        \"code\": \"20\",\n                        \"priority\": 8,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.20\"\n                    },\n                    {\n                        \"code\": \"10\",\n                        \"priority\": 9,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.10\"\n                    },\n                    {\n                        \"code\": \"0\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.Sprinklered.0\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.BuildingAlarmType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"local\",\n                        \"priority\": 1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BuildingAlarmType.local\"\n                    },\n                    {\n                        \"code\": \"central\",\n                        \"priority\": 2,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BuildingAlarmType.central\"\n                    },\n                    {\n                        \"code\": \"police\",\n                        \"priority\": 3,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.BuildingAlarmType.police\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.coverage.dto.TermDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Options\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.quote.coverage.dto.TermOptionDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Updated\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"isAscendingBetter\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ValueType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Visible\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Editable\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChosenTerm\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChosenTermValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DirectValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"BigDecimal\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PatternCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.WaivedStatus_aaa\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"notapplicable\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.notapplicable\"\n                    },\n                    {\n                        \"code\": \"pjc\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.pjc\"\n                    },\n                    {\n                        \"code\": \"waived\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.waived\"\n                    },\n                    {\n                        \"code\": \"none\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.none\"\n                    },\n                    {\n                        \"code\": \"Yes\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.Yes\"\n                    },\n                    {\n                        \"code\": \"No\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.WaivedStatus_aaa.No\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"HOCatestropheFilter\",\n                        \"includedCodes\": [\n                            \"none\",\n                            \"Yes\",\n                            \"No\"\n                        ]\n                    },\n                    {\n                        \"name\": \"PAWaivedStatus\",\n                        \"includedCodes\": [\n                            \"notapplicable\",\n                            \"pjc\",\n                            \"waived\"\n                        ]\n                    },\n                    {\n                        \"name\": \"WCRWaivedStatus\",\n                        \"includedCodes\": [\n                            \"notapplicable\",\n                            \"pjc\",\n                            \"waived\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PolicyLine\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"BusinessOwnersLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.BusinessOwnersLine\"\n                    },\n                    {\n                        \"code\": \"BusinessAutoLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.BusinessAutoLine\"\n                    },\n                    {\n                        \"code\": \"CommercialPropertyLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.CommercialPropertyLine\"\n                    },\n                    {\n                        \"code\": \"GeneralLiabilityLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.GeneralLiabilityLine\"\n                    },\n                    {\n                        \"code\": \"HomeownersLine_HOE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.HomeownersLine_HOE\"\n                    },\n                    {\n                        \"code\": \"InlandMarineLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.InlandMarineLine\"\n                    },\n                    {\n                        \"code\": \"PersonalAutoLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.PersonalAutoLine\"\n                    },\n                    {\n                        \"code\": \"PUPLine_PUE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.PUPLine_PUE\"\n                    },\n                    {\n                        \"code\": \"PolicyLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.PolicyLine\"\n                    },\n                    {\n                        \"code\": \"WatercraftLine_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.WatercraftLine_AAA\"\n                    },\n                    {\n                        \"code\": \"WorkersCompLine\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PolicyLine.WorkersCompLine\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"PolicyHoldLines\",\n                        \"includedCodes\": [\n                            \"HomeownersLine_HOE\",\n                            \"PersonalAutoLine\",\n                            \"PUPLine_PUE\",\n                            \"WatercraftLine_AAA\"\n                        ]\n                    },\n                    {\n                        \"name\": \"UWRuleApplicable\",\n                        \"includedCodes\": [\n                            \"HomeownersLine_HOE\",\n                            \"PersonalAutoLine\",\n                            \"PUPLine_PUE\",\n                            \"WatercraftLine_AAA\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.AddlInterestDetail\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"AddlInterestDetail\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.AddlInterestDetail\"\n                    },\n                    {\n                        \"code\": \"BAVhcleAddlInterest\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.BAVhcleAddlInterest\"\n                    },\n                    {\n                        \"code\": \"BOPBldgAddlInterest\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.BOPBldgAddlInterest\"\n                    },\n                    {\n                        \"code\": \"CPBldgAddlInterest\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.CPBldgAddlInterest\"\n                    },\n                    {\n                        \"code\": \"HODwellingAddlInt_HOE\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.HODwellingAddlInt_HOE\"\n                    },\n                    {\n                        \"code\": \"IMSchEquipAddlInterest\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.IMSchEquipAddlInterest\"\n                    },\n                    {\n                        \"code\": \"PAVhcleAddlInterest\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.PAVhcleAddlInterest\"\n                    },\n                    {\n                        \"code\": \"WCRBoatAddlInterest_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.AddlInterestDetail.WCRBoatAddlInterest_AAA\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.address.dto.AddressAdditionalInterestDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PostalCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[0-9]{5}(-[0-9]{4})?\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.PostalCode\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine2Kanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"City\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CityKanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"County\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IsAutofilled\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressLine3\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressLine2\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressLine1\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"State\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"hasCategory\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"getfield\",\n                                                \"base\": {\n                                                    \"kind\": \"parameter\",\n                                                    \"index\": 1\n                                                },\n                                                \"propertyName\": \"Country\"\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.FilterByCategory\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.CategoryFilterDTO\",\n                                \"value\": {\n                                    \"categoryExpression\": {\n                                        \"kind\": \"getfield\",\n                                        \"base\": {\n                                            \"kind\": \"parameter\",\n                                            \"index\": 1\n                                        },\n                                        \"propertyName\": \"Country\"\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Country\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Country\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressLine1Kanji\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"AddressType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.AddressType\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.ScheduleType_HOE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Jewelry\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Jewelry\"\n                    },\n                    {\n                        \"code\": \"Furs\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Furs\"\n                    },\n                    {\n                        \"code\": \"Cameras\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Cameras\"\n                    },\n                    {\n                        \"code\": \"MusicalInstruments\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.MusicalInstruments\"\n                    },\n                    {\n                        \"code\": \"Silverware\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Silverware\"\n                    },\n                    {\n                        \"code\": \"GolfersEquipment\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.GolfersEquipment\"\n                    },\n                    {\n                        \"code\": \"FineArts\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.FineArts\"\n                    },\n                    {\n                        \"code\": \"PostageStamps\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.PostageStamps\"\n                    },\n                    {\n                        \"code\": \"RareCurrentCoins\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.RareCurrentCoins\"\n                    },\n                    {\n                        \"code\": \"Computer_aaa\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Computer_aaa\"\n                    },\n                    {\n                        \"code\": \"Guns_aaa\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Guns_aaa\"\n                    },\n                    {\n                        \"code\": \"ChinaAndCrystal_aaa\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.ChinaAndCrystal_aaa\"\n                    },\n                    {\n                        \"code\": \"HobbyCollection_aaa\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.HobbyCollection_aaa\"\n                    },\n                    {\n                        \"code\": \"LimitedEditions_aaa\",\n                        \"priority\": 140,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.LimitedEditions_aaa\"\n                    },\n                    {\n                        \"code\": \"PhoneRecTapeCasst_aaa\",\n                        \"priority\": 150,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.PhoneRecTapeCasst_aaa\"\n                    },\n                    {\n                        \"code\": \"ElectronicMedia_aaa\",\n                        \"priority\": 160,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.ElectronicMedia_aaa\"\n                    },\n                    {\n                        \"code\": \"SoundEquipRecorder_aaa\",\n                        \"priority\": 170,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.SoundEquipRecorder_aaa\"\n                    },\n                    {\n                        \"code\": \"Trophies_aaa\",\n                        \"priority\": 180,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.ScheduleType_HOE.Trophies_aaa\"\n                    }\n                ],\n                \"filters\": [\n                    {\n                        \"name\": \"BlanketItems_aaa\",\n                        \"includedCodes\": [\n                            \"Jewelry\",\n                            \"Furs\",\n                            \"Cameras\",\n                            \"MusicalInstruments\",\n                            \"Silverware\",\n                            \"FineArts\",\n                            \"Computer_aaa\",\n                            \"Guns_aaa\",\n                            \"ChinaAndCrystal_aaa\"\n                        ]\n                    },\n                    {\n                        \"name\": \"SchedulePersonalProperty_aaa\",\n                        \"includedCodes\": [\n                            \"Jewelry\",\n                            \"Furs\",\n                            \"Cameras\",\n                            \"MusicalInstruments\",\n                            \"Silverware\",\n                            \"GolfersEquipment\",\n                            \"FineArts\",\n                            \"PostageStamps\",\n                            \"RareCurrentCoins\",\n                            \"Guns_aaa\",\n                            \"ChinaAndCrystal_aaa\",\n                            \"HobbyCollection_aaa\",\n                            \"LimitedEditions_aaa\",\n                            \"PhoneRecTapeCasst_aaa\",\n                            \"ElectronicMedia_aaa\",\n                            \"SoundEquipRecorder_aaa\",\n                            \"Trophies_aaa\"\n                        ]\n                    }\n                ],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.coverage.dto.TermOptionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"OptionValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"MaxValue\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Code\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.quote.streamlined.dto.StreamlinedQuoteDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Email\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,6}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Email\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"ProductCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyAddress\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.RuleAugmentationRuleDTO\",\n                                \"value\": {\n                                    \"targets\": [\n                                        \"AddressLine1\",\n                                        \"City\",\n                                        \"State\",\n                                        \"PostalCode\"\n                                    ],\n                                    \"augments\": [\n                                        {\n                                            \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                            \"value\": {\n                                                \"expression\": {\n                                                    \"kind\": \"const\",\n                                                    \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                                    \"value\": \"REQUIRED\"\n                                                },\n                                                \"message\": {\n                                                    \"kind\": \"translate\",\n                                                    \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                                    \"arguments\": []\n                                                }\n                                            }\n                                        }\n                                    ]\n                                }\n                            }\n                        ]\n                    },\n                    \"SubmissionNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TermType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.TermType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Lobs\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.quote.lob.dto.DraftLobDataDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TempID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Vin\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TermsChecked\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"eq\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"boolean\",\n                                                \"value\": true\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Quote.streamlined.CheckTermsAndConditions\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Age\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PortalType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PortalType_aaa\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policycommon.availability.dto.PostalCodeAvailabilityRequestDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"ProductCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PostalCode\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.AvailabilityHandler.PostalCode\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"[0-9]{5}(-[0-9]{4})?\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.PostalCode\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policycommon.availability.dto.AvailabilityResponseDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"AddressCompletion\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AvailableInFuture\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"IsAvailable\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"boolean\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalumbrella.dto.VehicleDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"VehicleType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PUPVehicleType_PUE\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Vin\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalauto.dto.PaPolicyExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Status\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalCost\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalPremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LineOfBusiness\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"VehicleDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalauto.dto.CoveredVehicleDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"CoverageDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"DriverDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalauto.dto.DriverDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Discounts\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"aaa.edge.capabilities.policycommon.discounts.dto.DiscountsDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalauto.dto.DriverDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Jurisdiction\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FirstName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LastName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalumbrella.dto.WatercraftDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WatercraftType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PUPWatercraftType_PUE\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WatercraftNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalumbrella.dto.PropertyDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HasTrampoline\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HasSwimmingPool\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LocationType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.PUPLocationType_PUE\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.PolicyPeriodSummaryDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PolicyType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IdCardSessionID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyPeriodStatus\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ProductName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Expiration\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DocumentDelivery\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Premium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Overview\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Effective\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"TotalCost\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"IdCardPublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EDelivery\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyPeriod\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.dto.PolicyPeriodDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Lines\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"typekey.PolicyLine\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalumbrella.dto.PuPolicyExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Status\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Drivers\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalumbrella.dto.DriverDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Watercrafts\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalumbrella.dto.WatercraftDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"NumDriversless22\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CoverageDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"TotalDriverCount\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Properties\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalumbrella.dto.PropertyDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"NumDriversgreater70\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Vehicles\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.personalumbrella.dto.VehicleDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"TotalCost\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalPremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LineOfBusiness\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.PolicySummaryDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Periods\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.PolicyPeriodSummaryDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.PolicyPeriodDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Lobs\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.lob.dto.PolicyLobDataDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Expiration\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"idCardSessionID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 40\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 40\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DocumentDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.document.dto.PolicyDocumentDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"idCardPublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 50\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 50\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Effective\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.dto.PolicyLobDataDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"PersonalUmbrella\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.lob.personalumbrella.dto.PuPolicyExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"HomeOwners\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.lob.homeowners.dto.HoPolicyExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PersonalAuto\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.lob.personalauto.dto.PaPolicyExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Watercraft\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.policy.lob.watercraft.dto.WaPolicyExtensionDTO\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.MailPoliciesDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.CoverageDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Deductible\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Premium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \"edge.aspects.validation.ValidationFunctions\",\n                                        \"name\": \"matchesPattern\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"string\",\n                                                \"value\": \"-?[0-9]{1,16}''.?[0-9]{0,2}\"\n                                            },\n                                            {\n                                                \"kind\": \"parameter\",\n                                                \"index\": 0\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Pattern\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Index\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Limit\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"CoverageCategory\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.dto.SignUpEmailDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"EmailChanged\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyNumbers\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"primitive\",\n                                \"name\": \"String\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ChangedEmail\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AccountNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.watercraft.dto.DriverDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.State\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FirstName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LastName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.document.dto.PolicyDocumentDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Status\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DocumentStatusType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"SecurityType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DocumentSecurityType\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Description\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 255\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 255\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CanDelete\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Boolean\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DocumentType\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.DocumentType\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Recipient\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DocName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DocUID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 255\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 255\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"MimeType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 80\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 80\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"Name\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Author\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 60\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 60\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"WorkingPublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"SessionID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            },\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 40\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 40\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"DateModified\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.watercraft.dto.WaPolicyExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Status\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalCost\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DiscountsDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"aaa.edge.capabilities.policycommon.discounts.dto.DiscountsDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalPremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LineOfBusiness\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"VehicleDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.watercraft.dto.CoveredVehicleDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"CoverageDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"DriverDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.lob.watercraft.dto.DriverDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.homeowners.dto.HoPolicyExtensionDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Status\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalCost\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PublicID\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PolicyType\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"AddressDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.address.dto.AddressDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"ExpirationDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"PolicyNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"TotalPremium\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LineOfBusiness\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"CoverageDTOs\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"Discounts\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"aaa.edge.capabilities.policycommon.discounts.dto.DiscountsDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"EffectiveDate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalauto.dto.CoveredVehicleDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"Coverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LicensePlate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 40\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 40\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"vin\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.watercraft.dto.CoveredVehicleDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"HullId1\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"Coverages\": {\n                        \"valueType\": {\n                            \"kind\": \"collection\",\n                            \"elementType\": {\n                                \"kind\": \"class\",\n                                \"className\": \"edge.capabilities.policy.dto.CoverageDTO\"\n                            }\n                        },\n                        \"metadata\": []\n                    },\n                    \"year\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"LicensePlate\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.ValidationRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"nativecall\",\n                                        \"container\": \":sys:ops:\",\n                                        \"name\": \"not\",\n                                        \"params\": [\n                                            {\n                                                \"kind\": \"nativecall\",\n                                                \"container\": \":sys:ops:\",\n                                                \"name\": \"or\",\n                                                \"params\": [\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"less\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 0\n                                                            }\n                                                        ]\n                                                    },\n                                                    {\n                                                        \"kind\": \"nativecall\",\n                                                        \"container\": \":sys:ops:\",\n                                                        \"name\": \"greater\",\n                                                        \"params\": [\n                                                            {\n                                                                \"kind\": \"getfield\",\n                                                                \"base\": {\n                                                                    \"kind\": \"parameter\",\n                                                                    \"index\": 0\n                                                                },\n                                                                \"propertyName\": \"length\"\n                                                            },\n                                                            {\n                                                                \"kind\": \"const\",\n                                                                \"type\": \"int\",\n                                                                \"value\": 40\n                                                            }\n                                                        ]\n                                                    }\n                                                ]\n                                            }\n                                        ]\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.Size\",\n                                        \"arguments\": [\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 0\n                                            },\n                                            {\n                                                \"kind\": \"const\",\n                                                \"type\": \"int\",\n                                                \"value\": 40\n                                            }\n                                        ]\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"HullId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"int\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"model\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    },\n                    \"HullValue\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"edge.capabilities.currency.dto.AmountDTO\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"make\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": [\n                            {\n                                \"type\": \"edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO\",\n                                \"value\": {\n                                    \"expression\": {\n                                        \"kind\": \"const\",\n                                        \"type\": \"enum edge.aspects.validation.VisibilityAndRequiredness\",\n                                        \"value\": \"REQUIRED\"\n                                    },\n                                    \"message\": {\n                                        \"kind\": \"translate\",\n                                        \"displayKey\": \"displaykey.Edge.Web.Api.Model.NotNull\",\n                                        \"arguments\": []\n                                    }\n                                }\n                            }\n                        ]\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PUPVehicleType_PUE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Passenger\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.Passenger\"\n                    },\n                    {\n                        \"code\": \"Motorcycle\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.Motorcycle\"\n                    },\n                    {\n                        \"code\": \"Moped\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.Moped\"\n                    },\n                    {\n                        \"code\": \"GolfCart\",\n                        \"priority\": 35,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.GolfCart\"\n                    },\n                    {\n                        \"code\": \"Recreational\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.Recreational\"\n                    },\n                    {\n                        \"code\": \"MotorHome\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.MotorHome\"\n                    },\n                    {\n                        \"code\": \"AntiqueCollectibleorClassic\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPVehicleType_PUE.AntiqueCollectibleorClassic\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PUPWatercraftType_PUE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Airboat\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Airboat\"\n                    },\n                    {\n                        \"code\": \"BassWalleyeBoat\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.BassWalleyeBoat\"\n                    },\n                    {\n                        \"code\": \"Cruiser\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Cruiser\"\n                    },\n                    {\n                        \"code\": \"HighPerformance\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.HighPerformance\"\n                    },\n                    {\n                        \"code\": \"Houseboat\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Houseboat\"\n                    },\n                    {\n                        \"code\": \"Hovercraft\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Hovercraft\"\n                    },\n                    {\n                        \"code\": \"MidPerformance\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.MidPerformance\"\n                    },\n                    {\n                        \"code\": \"personalwcr_aaa\",\n                        \"priority\": 75,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.personalwcr_aaa\"\n                    },\n                    {\n                        \"code\": \"Pontoon\",\n                        \"priority\": 80,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Pontoon\"\n                    },\n                    {\n                        \"code\": \"Runabout\",\n                        \"priority\": 90,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Runabout\"\n                    },\n                    {\n                        \"code\": \"Sailboat\",\n                        \"priority\": 100,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Sailboat\"\n                    },\n                    {\n                        \"code\": \"SkiBoat\",\n                        \"priority\": 110,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.SkiBoat\"\n                    },\n                    {\n                        \"code\": \"SportFishing\",\n                        \"priority\": 120,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.SportFishing\"\n                    },\n                    {\n                        \"code\": \"Trawler\",\n                        \"priority\": 130,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPWatercraftType_PUE.Trawler\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.PUPLocationType_PUE\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"Dwelling\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPLocationType_PUE.Dwelling\"\n                    },\n                    {\n                        \"code\": \"VacantLand\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.PUPLocationType_PUE.VacantLand\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"edge.capabilities.policy.lob.personalumbrella.dto.DriverDTO\": {\n            \"type\": \"edge.metadata.typeinfo.dtoinfo.dto.DTOMetadataDTO\",\n            \"value\": {\n                \"properties\": {\n                    \"LicenseState\": {\n                        \"valueType\": {\n                            \"kind\": \"class\",\n                            \"className\": \"typekey.Jurisdiction\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DateOfBirth\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Date\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"PublicId\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LicenseNumber\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"FirstName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DriverAge\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"Integer\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"DisplayName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    },\n                    \"LastName\": {\n                        \"valueType\": {\n                            \"kind\": \"primitive\",\n                            \"name\": \"String\"\n                        },\n                        \"metadata\": []\n                    }\n                },\n                \"metadata\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DocumentType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"correspondence_aaa\",\n                        \"priority\": 10,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.correspondence_aaa\"\n                    },\n                    {\n                        \"code\": \"email\",\n                        \"priority\": 20,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.email\"\n                    },\n                    {\n                        \"code\": \"inspectionreport\",\n                        \"priority\": 30,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.inspectionreport\"\n                    },\n                    {\n                        \"code\": \"reports_aaa\",\n                        \"priority\": 40,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.reports_aaa\"\n                    },\n                    {\n                        \"code\": \"trailingdocs_aaa\",\n                        \"priority\": 50,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.trailingdocs_aaa\"\n                    },\n                    {\n                        \"code\": \"TdocLetter_aaa\",\n                        \"priority\": 51,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.TdocLetter_aaa\"\n                    },\n                    {\n                        \"code\": \"DEFENSIVE_DRIVER_AAA\",\n                        \"priority\": 55,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DEFENSIVE_DRIVER_AAA\"\n                    },\n                    {\n                        \"code\": \"EXCLUDE_WIND_HAIL_AAA\",\n                        \"priority\": 55,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.EXCLUDE_WIND_HAIL_AAA\"\n                    },\n                    {\n                        \"code\": \"EXCLUDED_DRIVER_AAA\",\n                        \"priority\": 55,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.EXCLUDED_DRIVER_AAA\"\n                    },\n                    {\n                        \"code\": \"HOMEOWNERSHIP_AAA\",\n                        \"priority\": 55,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.HOMEOWNERSHIP_AAA\"\n                    },\n                    {\n                        \"code\": \"TdocProof_aaa\",\n                        \"priority\": 55,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.TdocProof_aaa\"\n                    },\n                    {\n                        \"code\": \"TdocSignature_aaa\",\n                        \"priority\": 56,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.TdocSignature_aaa\"\n                    },\n                    {\n                        \"code\": \"insureduploaded_aaa\",\n                        \"priority\": 60,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.insureduploaded_aaa\"\n                    },\n                    {\n                        \"code\": \"other\",\n                        \"priority\": 70,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.other\"\n                    },\n                    {\n                        \"code\": \"DecAdditionalInsured_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecAdditionalInsured_AAA\"\n                    },\n                    {\n                        \"code\": \"DecAdditionalInterest_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecAdditionalInterest_AAA\"\n                    },\n                    {\n                        \"code\": \"DecInsured_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecInsured_AAA\"\n                    },\n                    {\n                        \"code\": \"DecLienHolder_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecLienHolder_AAA\"\n                    },\n                    {\n                        \"code\": \"DecLossPayee_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecLossPayee_AAA\"\n                    },\n                    {\n                        \"code\": \"DecMortgagee_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecMortgagee_AAA\"\n                    },\n                    {\n                        \"code\": \"DecOrganisation_AAA\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentType.DecOrganisation_AAA\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DocumentSecurityType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"agencyonly\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSecurityType.agencyonly\"\n                    },\n                    {\n                        \"code\": \"internalonly\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSecurityType.internalonly\"\n                    },\n                    {\n                        \"code\": \"sensitive\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSecurityType.sensitive\"\n                    },\n                    {\n                        \"code\": \"unrestricted\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentSecurityType.unrestricted\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        },\n        \"typekey.DocumentStatusType\": {\n            \"type\": \"edge.metadata.typeinfo.typelistinfo.dto.TypelistMetadataDTO\",\n            \"value\": {\n                \"codes\": [\n                    {\n                        \"code\": \"approved\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentStatusType.approved\"\n                    },\n                    {\n                        \"code\": \"approving\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentStatusType.approving\"\n                    },\n                    {\n                        \"code\": \"draft\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentStatusType.draft\"\n                    },\n                    {\n                        \"code\": \"final\",\n                        \"priority\": -1,\n                        \"categories\": [],\n                        \"displayKey\": \"typekey.DocumentStatusType.final\"\n                    }\n                ],\n                \"filters\": [],\n                \"namedMetadata\": []\n            }\n        }\n    }\n}"

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(707), __webpack_require__(697)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ViewModelService) {
	    return angular.module('edge.platform.viewmodel', ['edge.platform.metamirror']).factory('ViewModelService', ViewModelService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(668), __webpack_require__(698)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ViewModel) {
	    return ['InsuranceSuiteMetadata', function (InsuranceSuiteMetaDataService) {
	        // return the service instance
	        return ViewModel.get(InsuranceSuiteMetaDataService);
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(709), __webpack_require__(514), __webpack_require__(512), __webpack_require__(556), __webpack_require__(535)], __WEBPACK_AMD_DEFINE_RESULT__ = function (WizardFlowService) {
	    return angular.module('edge.platform.flow', ['edge.platform.widgets.modal', 'ui.router', 'edge.platform.util', 'edge.platform.l10n']).factory('WizardFlowService', WizardFlowService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(710), __webpack_require__(723), __webpack_require__(724), __webpack_require__(725), __webpack_require__(726)], __WEBPACK_AMD_DEFINE_RESULT__ = function (FlowFactory, routerStepChangeListener, cancelConfirmation, actionStatusMessages, snapshotResetConfirmation) {
	    return ['$q', '$state', 'StateUtils', 'ModalService', function ($q, $state, StateUtils, ModalService) {
	        /**
	         *  Angular service to wrap FlowFactory and set dependencies that are specific to use in a wizard context.
	         *  For example provides a stepChange listener that hooks into ui-router and transitions to a new page for each
	         *  transition to a step or exit junction.
	         *  The flow model object returned from the FlowFactory.get call is stored in the base wizard state object.
	         *  Here it can be accessed by components like the NavBar that are not under the wizard component.
	         *
	         * @param {Function} flowDefn - flow definition function
	         *
	         * @param {String} parentWizardState - The parent state which all wizard pages are children
	         *
	         * @param {Object} [stepToStateMapping] - Mapping from a step name to a function that handles a transition to a router state
	         *                                       This function overrides the default mapping of what routing behavior to do
	         *                                       after moving to a new step in the flow.
	         *
	         */
	        return function (flowDefn, parentWizardState, stepToStateMapping, eventListeners) {
	            var routerListenerFn = routerStepChangeListener($state, StateUtils, parentWizardState, stepToStateMapping);
	
	            var modalBehavior = {
	                actionStatusInfo: actionStatusMessages(ModalService),
	                snapshotResetConfirmation: snapshotResetConfirmation(ModalService, $q),
	                cancelConfirmation: cancelConfirmation(ModalService, StateUtils)
	            };
	
	            function storeModelAndFlow(_model, _flow) {
	                //flowModel is accessbile globally from base wizard state object
	                var wizardStateData = StateUtils.dataForState(parentWizardState);
	                wizardStateData.flowModel = _flow;
	                wizardStateData.model = _model;
	            }
	
	            var listeners = angular.isDefined(eventListeners) ? [routerListenerFn].concat(_toConsumableArray(eventListeners)) : [routerListenerFn];
	            var factory = FlowFactory.get($q, listeners, modalBehavior, storeModelAndFlow);
	
	            var flowInstance = factory(flowDefn);
	            return {
	                start: function start(model, extraArgs) {
	                    var flowModel = flowInstance.start(model, extraArgs);
	                    storeModelAndFlow(model, flowModel);
	                    return flowModel;
	                },
	                resume: function resume(model, extraArgs) {
	                    var flowModel = flowInstance.resume(model, extraArgs);
	                    storeModelAndFlow(model, flowModel);
	                    return flowModel;
	                }
	            };
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(711), __webpack_require__(715), __webpack_require__(712)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, flowModel, flowBuilder, FlowUtil) {
	
	    return {
	        /**
	         * A factory function that returns a service used to create wizard flows
	         *
	         * @param {Object} $q - ES6 Promise API implementation
	         * @param {Array} stepChangeListenerFactories - Array of functions returning a callback that is called for step and exit transitions
	         * @param {Object} modalBehavior - Provides promises resulting from displaying information dialogs
	         *                                      actionStatusInfo - (modals for displaying progress & error messages of calls to the server)
	         *                                      snapshotResetConfirmation - (confirmation message to prompt that data may be lost when reset to snapshot)
	         *                                      cancelConfirmation - (confirmation message to cancel flow)
	         *
	         *
	         * @returns {Function} - Function to call for storing model and flowModel after creation (like in the state)
	         **/
	        get: function get($q, stepChangeListenerFactories, modalBehavior) {
	
	            var dummyModalBehavior = {
	                actionStatusInfo: function actionStatusInfo(model) {
	                    return $q.resolve(model);
	                },
	                snapshotResetConfirmation: function snapshotResetConfirmation(model) {
	                    return $q.resolve(model);
	                },
	                cancelConfirmation: function cancelConfirmation(model) {
	                    return $q.resolve(model);
	                }
	            };
	
	            modalBehavior = modalBehavior || dummyModalBehavior;
	
	            /**
	             * Create a new flow object
	             *
	             * @param {Function} flowDefn - function for defining flow definition
	             *
	             * @returns {Object} A new flow object which can be started or combined with other flows
	             **/
	            return function (flowDefn) {
	                /**
	                 * Validate Flow
	                 *  - there is one flow entry and one or more flow exits
	                 *  - there is only one event associated with a step
	                 *
	                 *  @param {Object} flow - Object with entry, exit and steps property
	                 *  @throws {Error} error with details of how flow is invalid
	                 */
	                function validateFlow(flow) {
	                    var validationErrors = [];
	                    if (!flow.entry) {
	                        validationErrors.push('Flow has no entry step defined');
	                    }
	                    if (_.keys(flow.exits).length === 0) {
	                        validationErrors.push('Flow has no exit steps defined');
	                    }
	                    if (validationErrors.length > 0) {
	                        throw new Error(validationErrors.join('\n'));
	                    }
	                    return true;
	                }
	
	                var flow = flowBuilder(flowDefn, $q);
	                validateFlow(flow);
	                var stepListeners = stepChangeListenerFactories ? stepChangeListenerFactories.map(function (fn) {
	                    return fn(flow);
	                }) : [];
	
	                return {
	                    /**
	                     * A factory function that returns a flow model initialized to the first step
	                     *
	                     * @param {Object} model         - Model holding initial data object
	                     * @param {Object} [extraArgs]   - Map of arguments passed to branch functions and step listeners
	                     *
	                     * @return {Object} FlowModel
	                     **/
	                    start: function start(model, extraArgs) {
	                        var flowObj = flowModel(flow, $q, stepListeners, modalBehavior);
	                        flowObj.snapshot = model;
	                        if (FlowUtil.isStepObject(flow.entry)) {
	                            //go to the first step triggering any callbacks.
	                            flowObj.jumpToStep(flow.entry, model, extraArgs, true);
	                        } else {
	                            //if junction proceed until a step is reached
	                            flowObj.next(model, extraArgs);
	                        }
	                        return flowObj;
	                    },
	
	
	                    /**
	                     * A factory function that returns a flow model which compares the model with the resume expression for each step
	                     *
	                     * @param {Object} model - Object that is checked against resume expressions for subsequent steps
	                     * @param {Object} [extraArgs]   - Map of arguments passed to branch functions and step listeners
	                     *
	                     *  @returns {Object} FlowModel
	                     **/
	                    resume: function resume(model, extraArgs) {
	                        var currentStep = flow.entry;
	                        if (FlowUtil.isJunctionObject(currentStep)) {
	                            currentStep = FlowUtil.getNextStep(flow, currentStep, model);
	                        }
	                        var stepHistory = [currentStep];
	                        var nextStep = currentStep;
	                        do {
	                            var stepSkipFn = currentStep.skipOnResumeIf ? currentStep.skipOnResumeIf() : undefined;
	                            if (stepSkipFn && stepSkipFn(model, extraArgs)) {
	                                nextStep = FlowUtil.getNextStep(flow, nextStep, model);
	                                if (nextStep) {
	                                    stepHistory.push(nextStep);
	                                    currentStep = nextStep;
	                                }
	                            } else {
	                                nextStep = undefined;
	                            }
	                        } while (nextStep);
	
	                        var flowObj = flowModel(flow, $q, stepListeners, modalBehavior);
	                        flowObj.resetFlowProgress(currentStep, stepHistory, model);
	                        flowObj.jumpToStep(flowObj.currentStep, model, extraArgs, true);
	                        return flowObj;
	                    }
	                };
	            };
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(712), __webpack_require__(713), __webpack_require__(714)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, FlowUtil, defaultJumpToCheck, snapshotBuilder) {
	    /**
	     * A factory function that returns an object for interacting with a wizard flow
	     *
	     * @param {Object} flow                  - The definition of the entry, exit and steps of a flow
	     * @param {Object} Q                     - ES6 Promise API implementation
	     * @param {Function} routerStepChangeFn  - Function to get called on flow step transitions to trigger router transition
	     * @param {Object} modalBehavior         - Provides promises resulting from displaying information dialogs
	     *                     actionStatusInfo - (modals for displaying progress & error messages of calls to the server)
	     *                     snapshotResetConfirmation - (confirmation message to prompt that data may be lost when reset to snapshot)
	     *                     cancelConfirmation - (confirmation message to cancel flow)
	     *
	     * @returns {Object} Wizard Model
	     **/
	    return function (flow, Q, stepChangeFns, modalBehavior) {
	        var currentSnapshot = void 0;
	        var _jumpToStepCheck = defaultJumpToCheck;
	        var stepHistory = FlowUtil.isStepObject(flow.entry) ? [flow.entry] : [];
	        var stepChangeListeners = stepChangeFns.concat();
	        var navigatingFrom = {
	            'name': '',
	            'index': ''
	        };
	
	        /**
	         * Function that takes in a step and executes the transition in response to an event.
	         * If the result of that transition is an Junction then it will keep calling the next transition
	         * until a step or flow exit is reached. At that point the step change listeners and route change handler will be
	         * called.
	         */
	        function goToStepForEvent(eventName, _model, startStep) {
	            var _extraArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            /**
	             * Return the promise of a single transition to a step or junction
	             */
	            function getTransitionPromise(model, step, args) {
	                var actionHandlerObject = step[eventName].doAction();
	                if (actionHandlerObject) {
	                    //promise that resolves to an object - {model, extraArgs}
	                    var actionPromise = actionHandlerObject.action(model, args);
	                    var actionStatusHandler = modalBehavior.actionStatusInfo;
	                    //return promise that resolves to an object - {model, step, extraArgs}
	                    return actionStatusHandler(actionPromise, actionHandlerObject.msgs);
	                }
	                //if just a branch or goTo - convert sync into promise that is immediately resolved
	                var nextStepOrJct = FlowUtil.getNextSyncStepOrJunction(flow, step, model, args);
	                //promise resolving to model and next step
	                return Q.resolve({ model: model, step: nextStepOrJct, extraArgs: args });
	            }
	
	            /**
	             * If the result of a next transition is a junction instead of a step or flow exit then we recursively
	             * go to the next transition until a step is reached.
	             */
	            function finalTransitionPromise(stepTransitionPromise) {
	                function successAndErrorCb(_ref) {
	                    var model = _ref.model,
	                        step = _ref.step,
	                        extraArgs = _ref.extraArgs;
	
	                    step = FlowUtil.getStepOrJunctionObject(step, flow);
	                    if (step._type === 'STEP' || flow.exits[step.name]) {
	                        return { model: model, step: step, extraArgs: extraArgs };
	                    }
	                    var transitionPromise = getTransitionPromise(model, step, extraArgs);
	                    return finalTransitionPromise(transitionPromise);
	                }
	                return stepTransitionPromise.then(successAndErrorCb, successAndErrorCb);
	            }
	
	            /**
	             * If the final reached point in the flow is a Step then set the current step and fire stepChange and route listeners
	             * If the final point reached in the flow is a Junction and an exit point then fire the route listener
	             */
	            function fireListenersForFinalTransition(_ref2) {
	                var model = _ref2.model,
	                    step = _ref2.step,
	                    extraArgs = _ref2.extraArgs;
	
	                var nextStep = FlowUtil.getStepOrJunctionObject(step, flow);
	                flow.currentStep = nextStep;
	                if (FlowUtil.isStepObject(nextStep, flow)) {
	                    var previouslySeenIndex = getStepIndexStepArray(flow.currentStep.name, stepHistory);
	                    if (previouslySeenIndex !== -1) {
	                        //set the history back to where the step was first encountered
	                        stepHistory = stepHistory.slice(0, previouslySeenIndex + 1);
	                    } else {
	                        stepHistory.push(flow.currentStep);
	                    }
	                    executeStepChangeListeners(model, startStep, nextStep, extraArgs);
	                } else if (flow.exits[nextStep.name]) {
	                    //junction as flow exit
	                    executeStepChangeListeners(model, startStep, nextStep, extraArgs);
	                }
	            }
	
	            var finalPromise = finalTransitionPromise(getTransitionPromise(_model, startStep, _extraArgs));
	            return finalPromise.then(function (result) {
	                fireListenersForFinalTransition(result);
	                return result;
	            }).catch(function (error) {
	                fireListenersForFinalTransition(error);
	                throw error;
	            });
	        }
	
	        /**
	         *
	         * @returns {number} the index of a step from an array of step based on step name
	         */
	        function getStepIndexStepArray(stepName, steps) {
	            var previousStepNames = _.pluck(steps, 'name');
	            return previousStepNames.indexOf(stepName);
	        }
	
	        /**
	         * Call each of the stepchange listeners with the model
	         *
	         * @param model
	         */
	        function executeStepChangeListeners(model, fromStep, toStep, extraArgs) {
	            var listeners = stepChangeListeners.concat();
	            listeners.forEach(function (listenerFn) {
	                return listenerFn(model, fromStep, toStep, extraArgs);
	            });
	        }
	
	        return {
	            /**
	             * Register callback function to be called on next and previous transitions
	             * Callback function is passed flow, step and model parameters
	             *
	             * @param {Function} callback
	             */
	            addStepChangeListener: function addStepChangeListener(callback) {
	                stepChangeListeners.push(callback);
	            },
	
	
	            /**
	             * Remove a listener.
	             *
	             * @param {Function} callback
	             * @throws {Error} if there is no matching listener function
	             */
	            removeStepChangeListener: function removeStepChangeListener(callback) {
	                var removeIndex = stepChangeListeners.indexOf(callback);
	                if (removeIndex !== -1) {
	                    stepChangeListeners.splice(removeIndex, 1);
	                }
	            },
	
	
	            /**
	             * Remove all listeners.
	             */
	            removeAllStepChangeListeners: function removeAllStepChangeListeners() {
	                stepChangeListeners.length = 0;
	            },
	
	
	            /**
	             * Provides an alternative implementation to the default function that determines if a user can directly
	             * transition to another step.
	             * The default implementation only allows a user to transition to a previous step as long as there are no
	             * gate points between the current step and the destination see @ modelhelpers/JumpToStepCheck
	             *
	             * @param {Function} jumpCheckImplementation
	             *
	             */
	            set alternativeJumpToStepCheck(jumpCheckImplementation) {
	                _jumpToStepCheck = jumpCheckImplementation;
	            },
	
	            /**
	             * Reset the current step and step history of the flow
	             *
	             * @param {Object} currentStep - New current step in flow
	             * @param {Array} steps        - New step history, array of step names or step objects
	             * @param {Object} snapshot    - New snapshot
	             *
	             * @throws Error if currentStep does not exist as a step in the flow
	             * @throws Error if any of the steps elements do not exist as steps in the flow
	             *
	             */
	            resetFlowProgress: function resetFlowProgress(currentStep, steps, snapShot) {
	                steps = steps.map(function (step) {
	                    return FlowUtil.getStepObject(step, flow);
	                });
	                stepHistory.length = 0;
	                stepHistory = stepHistory.concat(steps);
	                flow.currentStep = FlowUtil.getStepObject(currentStep, flow);
	                this.snapshot = snapShot;
	            },
	
	
	            /**
	             * Check to see if it is possible to transition to this step from the current step
	             *
	             * @param {Object} targetStep - Step to transition to.
	             * @param {Object} [model] - Model to use for transition check function
	             *
	             * @returns {Boolean}
	             */
	            isStepAccessibleFromCurrent: function isStepAccessibleFromCurrent(targetStep, model) {
	                return _jumpToStepCheck(this, this.currentStep, targetStep, model);
	            },
	
	
	            /**
	             * A deep clone of the model is stored on every next transition
	             *
	             * @returns {Object} - the latest clone of the model
	             */
	            get snapshot() {
	                return currentSnapshot;
	            },
	
	            /**
	             * Take a clone of the model parameter to store as the latest snapshot
	             *
	             * @param {Object} model - object to be cloned
	             */
	            set snapshot(model) {
	                currentSnapshot = snapshotBuilder(model);
	            },
	
	            /**
	             * The name of the current step in the flow
	             *
	             * @returns {Object} The current step object in the flow
	             */
	            get currentStep() {
	                return flow.currentStep || flow.entry;
	            },
	
	            /**
	             * Ordered list of steps based on the history of steps we have passed through and the
	             * future steps that can be reached based on the model snapshot.
	             * (Future steps will be included until an action transition is reached or a branch function returns undefined)
	             *
	             * @returns {Array}
	             */
	            get steps() {
	                //add the steps that we have passed through already
	                var steps = stepHistory.concat();
	                var nextStep = void 0;
	
	                //add forward steps based on the model snapshot
	                do {
	                    nextStep = FlowUtil.getNextStep(flow, steps[steps.length - 1], this.snapshot);
	                    if (nextStep) {
	                        var previouslySeenIndex = getStepIndexStepArray(nextStep.name, steps);
	                        if (previouslySeenIndex !== -1) {
	                            //return the steps up until the cycle is encountered
	                            return steps.slice(0, previouslySeenIndex + 1);
	                        }
	                        steps.push(nextStep);
	                    }
	                } while (nextStep);
	
	                return steps;
	            },
	
	            /**
	             * Progress to the next step in the flow based on the model parameter
	             *
	             * @param {Object} model - object passed to transition functions
	             * @param {Object} [extraArgs]   - Map of arguments passed to branch functions and step listeners
	             *
	             * @returns {Promise} - promise that resolves to next step
	             */
	            next: function next(model, extraArgs) {
	                var _this = this;
	
	                if (this.currentStep.isValid && !this.currentStep.isValid()(model, extraArgs)) {
	                    //current step is invalid, do not proceed to next step
	                    return Q.resolve({ model: model, step: this.currentStep, extraArgs: extraArgs });
	                }
	                this.snapshot = model;
	                var currentStepIndex = _.findIndex(stepHistory, function (step) {
	                    return step.name === _this.currentStep.name;
	                });
	                if (typeof navigatingFrom != 'undefined') {
	                    navigatingFrom.index = currentStepIndex;
	                    navigatingFrom.name = angular.copy(this.currentStep.name);
	                }
	                var self = this;
	                return goToStepForEvent('onNext', model, this.currentStep, extraArgs).then(function (result) {
	                    //if the transition succeeded then set the snapshot with the model that may have been updated following actions
	                    self.snapshot = result.model;
	                    return result;
	                });
	            },
	
	
	            /**
	             * Transition to a step in the flow in response to a named event
	             * Similar in behavior to onNext behavior where we first check that the model is valid.
	             *
	             * @param {String} eventName - name of event
	             * @param {Object} model - object passed to transition functions
	             * @param {Object} [extraArgs]   - Map of arguments passed to branch functions and step listeners
	             *
	             * @returns {Promise} - promise that resolves to next step
	             */
	            event: function event(eventName, model) {
	                var _this2 = this;
	
	                var extraArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	                if (this.currentStep.isValid && !this.currentStep.isValid()(model, extraArgs)) {
	                    //current step is invalid, do not proceed to next step
	                    return Q.resolve({ model: model, step: this.currentStep, extraArgs: extraArgs });
	                }
	                this.snapshot = model;
	                var self = this;
	                var currentStepIndex = _.findIndex(stepHistory, function (step) {
	                    return step.name === _this2.currentStep.name;
	                });
	                if (typeof navigatingFrom != 'undefined') {
	                    navigatingFrom.name = angular.copy(this.currentStep.name);
	                    navigatingFrom.index = currentStepIndex;
	                }
	
	                return goToStepForEvent(eventName, model, this.currentStep, extraArgs).then(function (result) {
	                    //if the transition succeeded then set the snapshot with the model that may have been updated following actions
	                    self.snapshot = result.model;
	                    return result;
	                });
	            },
	
	
	            /**
	             * Move back to a previous step in the flow. If there is a onPrevious handler function
	              * defined then that function will be used to determine the p tion has been entered then the default implementation will return the previous
	             * step in the list of ordered steps.
	             *
	             * @param [model] - if a model is not provided then the snapshot will be used
	             * @param {Object} [extraArgs]   - Map of arguments passed to branch functions and step listeners
	             *
	             */
	            previous: function previous(_model, _extraArgs) {
	                var _this3 = this;
	
	                var prevStep = void 0;
	                var prevStepIndex = void 0;
	                var fromStep = this.currentStep;
	                if (typeof navigatingFrom != 'undefined') {
	                    navigatingFrom.name = angular.copy(this.currentStep.name);
	                    navigatingFrom.index = _.findIndex(stepHistory, function (step) {
	                        return step.name === _this3.currentStep.name;
	                    });
	                }
	                var hasPreviousHandler = this.currentStep.onPrevious();
	
	                function transitionToPrevious(transitionModel, currentStep) {
	                    if (!hasPreviousHandler) {
	                        //no onPrevious handler defined in flow definition so provide default behavior
	                        var currentStepIndex = _.findIndex(stepHistory, function (step) {
	                            return step.name === currentStep.name;
	                        });
	                        prevStepIndex = currentStepIndex - 1;
	                        if (prevStepIndex < 0) {
	                            throw new Error('Could not find previous step from current step', currentStep);
	                        }
	                        prevStep = stepHistory[prevStepIndex];
	                        flow.currentStep = prevStep;
	                    } else {
	                        //custom handler for previous, may return undefined to act as a gate point in the flow
	                        prevStep = hasPreviousHandler(transitionModel, _extraArgs);
	                        if (!prevStep) {
	                            prevStepIndex = _.findIndex(stepHistory, function (step) {
	                                return step.name === currentStep.name;
	                            });
	                        } else {
	                            prevStep = FlowUtil.getStepObject(prevStep, flow);
	                            flow.currentStep = prevStep;
	                            prevStepIndex = _.findIndex(stepHistory, function (step) {
	                                return step.name === prevStep.name;
	                            });
	                        }
	                    }
	                    stepHistory = stepHistory.slice(0, prevStepIndex + 1);
	                    if (fromStep.name !== flow.currentStep.name) {
	                        executeStepChangeListeners(transitionModel, fromStep, flow.currentStep, _extraArgs);
	                    }
	                }
	
	                if (_model) {
	                    //check that model is valid, if not then we need to give the user a warning that they might lose information
	                    return modalBehavior.snapshotResetConfirmation(_model)
	                    //model is valid so proceed without resetting model to snapshot
	                    .then(function (model) {
	                        return transitionToPrevious(model, _this3.currentStep);
	                    }).catch(function (error) {
	                        if (error === 'cancelled') {
	                            //navigation cancelled
	                            return false;
	                        }
	                        //confirmed reset to snapshot and proceed with navigation
	                        transitionToPrevious(_this3.snapshot, _this3.currentStep);
	                    });
	                }
	                return transitionToPrevious(this.snapshot, this.currentStep);
	            },
	
	
	            /**
	             * Move directly to a step or junction. Step must be in the list of flow steps.
	             * A check is performed to determine if the target step is accessable
	             *
	             * @param {String|Object} step - target step
	             * @param {Object} [_model] - object passed to transition functions, if undefined then the snapshot is used.
	             * @param {Object} [_extraArgs]   - Map of arguments passed to branch functions and step listeners
	             * @param {Boolean} [force] - perform transition bypassing any checks and execute step listener functions
	             *                              even in the case where the target step is the same as the current step.
	             *                              Defaults to false.
	             *
	             * @throws {Error} if stepOrJunction does not reference a step in the list of ordered steps or a flow exit point
	             * @throws {Error} if transition to step or junction step is not allowed
	             *
	             * @returns {Promise} Returned promise is resolved when cancel confirmed or rejected if cancel is dismissed
	             *
	             */
	            jumpToStep: function jumpToStep(step, _model, _extraArgs, force) {
	                var _this4 = this;
	
	                var targetStep = FlowUtil.getStepObject(step, flow);
	                if (!targetStep) {
	                    throw new Error('Target step does not exist in the flow', targetStep);
	                }
	                var fromStep = this.currentStep;
	
	                function transitionToStep(modelOrSnapshot) {
	                    flow.currentStep = targetStep;
	                    executeStepChangeListeners(modelOrSnapshot, fromStep, targetStep, _extraArgs);
	                }
	
	                _model = _model || this.snapshot;
	
	                if (force !== true && !_jumpToStepCheck(this, this.currentStep, targetStep, _model)) {
	                    //transition not allowed
	                    return false;
	                }
	
	                if (targetStep.name === this.currentStep.name && !force) {
	                    //nothing to do
	                    return;
	                } else if (!modalBehavior.snapshotResetConfirmation || targetStep.name === this.currentStep.name && force) {
	                    transitionToStep(_model);
	                    return;
	                }
	
	                modalBehavior.snapshotResetConfirmation(_model)
	                //model is valid so proceed without resetting to snapshot
	                .then(function (model) {
	                    return transitionToStep(model);
	                }).catch(function (error) {
	                    if (error === 'cancelled') {
	                        //navigation cancelled
	                        return false;
	                    }
	                    //confirmed reset to snapshot and proceed with navigation
	                    transitionToStep(_this4.snapshot);
	                });
	            },
	
	
	            /**
	             * Prompts the user to cancel the flow. Assumes that the flow has a 'cancel' junction or step.
	             *
	             * @param {Object} [_model] - object passed to transition functions, if undefined then the snapshot is used.
	             * @param {Object} [cancelMsgs]   - Map of alternative cancel messages title: message: description:
	             *
	             * @throws {Error} if flow has no cancel step or junction
	             *
	             */
	            cancel: function cancel(_model) {
	                var _extraArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                var cancelPoint = FlowUtil.getStepOrJunctionObject('cancel', flow);
	                if (!cancelPoint) {
	                    throw new Error('Flow requires a cancel exit junction to be defined');
	                }
	                _extraArgs.message = cancelPoint.data().confirmationMsg(_model);
	                return modalBehavior.cancelConfirmation(_model, _extraArgs).then(function (snapshotOrModel) {
	                    return goToStepForEvent('onNext', snapshotOrModel, cancelPoint, _extraArgs);
	                }).catch(function () {
	                    //cancel transition declined so don't perform transition
	                    return Q.reject();
	                });
	            },
	            navigatingFromStep: function navigatingFromStep() {
	                return navigatingFrom;
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /**
	     *  Duck typing to check that an object is a step or junction based on a type attribute
	     *
	     * @param {String} [type]  'STEP' or 'JUNCTION', if undefined then matches for step or junction
	     * @param {Object} objectToTest
	     * @returns {*|boolean}
	     */
	    function checkStepOrJunction(type, objectToTest) {
	        return objectToTest && objectToTest.name && objectToTest.onNext && (objectToTest._type === type || type === null);
	    }
	
	    /**
	     * Returns the next step or junction in the flow based on the model and extraArgs
	     *
	     * @param {Boolean} syncTransitionsOnly  If true then return undefined if a doAction transition is defined
	     * @param flow
	     * @param currentStep
	     * @param model
	     * @param extraArgs
	     * @returns {*} Step or Junction Object
	     */
	    function getNextStepOrJunction(syncTransitionsOnly, flow, currentStep, model) {
	        var extraArgs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	        var possibleTransitions = [currentStep.onNext.goTo(), currentStep.onNext.branch()];
	        if (!syncTransitionsOnly) {
	            possibleTransitions.push(currentStep.onNext.doAction() ? currentStep.onNext.doAction().callbacks.success : undefined);
	        }
	        var transition = _.find(possibleTransitions, function (_transition) {
	            return _transition !== undefined;
	        });
	
	        if (!transition) {
	            return undefined;
	        }
	        var stepOrJct = transition(model, extraArgs);
	        if (!stepOrJct) {
	            //branch function returned falsey
	            return undefined;
	        }
	        if (checkStepOrJunction(null, stepOrJct)) {
	            //if a step or junction object no need to lookup in flow
	            return stepOrJct;
	        }
	        var nextStep = flow._steps[stepOrJct] || flow._junctions[stepOrJct];
	        if (!nextStep) {
	            throw new Error('Could not find step or junction object: ' + stepOrJct);
	        }
	        return nextStep;
	    }
	
	    /**
	     * Returns the next step in the flow based on the model and extraArgs. Will follow the next transition on successive
	     * junctions until a step is reached or a tranistion returns undefined;
	     *
	     * @param {Boolean} syncTransitionsOnly  If true then return undefined if a doAction transition is defined
	     * @param flow
	     * @param currentStep
	     * @param model
	     * @param extraArgs
	     * @returns {*} Step object
	     */
	    function getNextStep(syncTransitionsOnly, flow, currentStep, model) {
	        var _this = this;
	
	        var extraArgs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	        var getNextStepFollowingJunctions = function getNextStepFollowingJunctions(currentStepOrJunction) {
	            var nextStepOrJunction = getNextStepOrJunction(syncTransitionsOnly, flow, currentStepOrJunction, model, extraArgs);
	            if (!nextStepOrJunction) {
	                return undefined;
	            }
	            if (_this.isStepObject(nextStepOrJunction)) {
	                return nextStepOrJunction;
	            }
	            return getNextStepFollowingJunctions(nextStepOrJunction);
	        };
	        return getNextStepFollowingJunctions(currentStep);
	    }
	
	    return {
	        getNextSyncStepOrJunction: _.partial(getNextStepOrJunction, true),
	
	        getNextStepOrJunction: _.partial(getNextStepOrJunction, false),
	
	        getNextSyncStep: _.partial(getNextStep, true),
	
	        getNextStep: _.partial(getNextStep, false),
	
	        isStepObject: _.partial(checkStepOrJunction, 'STEP'),
	
	        isJunctionObject: _.partial(checkStepOrJunction, 'JUNCTION'),
	
	        getStepObject: function getStepObject(stepNameOrObject, flow) {
	            if (this.isStepObject(stepNameOrObject) && flow._steps[stepNameOrObject.name]) {
	                return stepNameOrObject;
	            } else if (typeof stepNameOrObject === 'string' && flow._steps[stepNameOrObject]) {
	                return flow._steps[stepNameOrObject];
	            }
	            throw new Error('Unable to find step object ' + stepNameOrObject + ' in flow');
	        },
	        getJunctionObject: function getJunctionObject(junctionNameOrObject, flow) {
	            if (this.isJunctionObject(junctionNameOrObject) && flow._junctions[junctionNameOrObject.name]) {
	                return junctionNameOrObject;
	            } else if (typeof junctionNameOrObject === 'string' && flow._junctions[junctionNameOrObject]) {
	                return flow._junctions[junctionNameOrObject];
	            }
	            throw new Error('Unable to find step object ' + junctionNameOrObject + ' in flow');
	        },
	        getStepOrJunctionObject: function getStepOrJunctionObject(stepOrJunction, flow) {
	            if (typeof stepOrJunction === 'string' && flow._junctions[stepOrJunction]) {
	                return flow._junctions[stepOrJunction];
	            } else if (typeof stepOrJunction === 'string' && flow._steps[stepOrJunction]) {
	                return flow._steps[stepOrJunction];
	            } else if (checkStepOrJunction(null, stepOrJunction)) {
	                return stepOrJunction;
	            }
	            throw new Error('Unable to find step or junction object ' + stepOrJunction + ' in flow');
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    /**
	     * Function to check if a direct transition to another step is allowed
	     *
	     * @param {Array} flowSteps - the ordered set of steps in the flow
	     * @param {Object} currentStep - the current step in the flow
	     *  @param {Object} targetStep
	     * @param {Object} model
	     */
	    return function checkIfTransitionAllowed(flowModel, currentStep, targetStep) {
	        var currentStepIndex = _.findIndex(flowModel.steps, { name: currentStep.name });
	        var targetStepIndex = _.findIndex(flowModel.steps, { name: targetStep.name });
	        //only allow going back in the wizard
	        return currentStepIndex >= targetStepIndex;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Function that accepts a view model object and returns a function to recreate the same
	     *
	     * @param {Object} model - view model object
	     *
	     * @returns {Object} clone of view model object passed in as a parameter
	     */
	    return function getViewModelBuilder(viewModel) {
	        var Constructor = void 0;
	        var vmBuilder = void 0;
	        var valueJSON = void 0;
	
	        if (viewModel) {
	            if (viewModel.value && viewModel.aspects && viewModel.aspects._vmFromData) {
	                //view model created created with gw viewmodel API
	                Constructor = viewModel.value.constructor;
	                vmBuilder = viewModel.aspects._vmFromData;
	                valueJSON = JSON.stringify(viewModel.value);
	            } else {
	                //just a plain JS Object
	                Constructor = viewModel.constructor;
	                valueJSON = JSON.stringify(viewModel);
	            }
	        }
	        if (!valueJSON) {
	            return undefined;
	        }
	        var value = JSON.parse(valueJSON);
	        value = new Constructor(value);
	        if (vmBuilder) {
	            //build a view model object
	            return vmBuilder(value);
	        }
	        return value;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(716), __webpack_require__(717), __webpack_require__(718), __webpack_require__(719), __webpack_require__(720), __webpack_require__(721), __webpack_require__(722), __webpack_require__(712), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (skipOnResume, next, previous, valid, label, data, event, FlowUtil, _) {
	    /**
	     * Returns a flow object from a flow definition
	     *
	     * @param {Function} flowDefn
	     * @param {Object} $q - ES6 Promise API implementation
	     * @param [Array] extraStepDefnPropFactories - factory functions to add new properties to the step definition
	     *
	     * @return {Object} Flow object with an entry, exits, steps.
	     */
	    return function (flowDefn, $q, extraStepDefnPropFactories) {
	        function checkAndSetFlowEntry(stepOrJctToTest, flow) {
	            if (stepOrJctToTest) {
	                if (flow.entry) {
	                    throw new Error('Cannot define ' + stepOrJctToTest + ' as an entry as the flow already has an entry point defined: ' + flow.entry.name);
	                }
	                flow.entry = stepOrJctToTest;
	            }
	        }
	
	        function stepBuilder(stepNameOrObject, isFlowEntry, flow) {
	            function addStepToCurrentAndParentFlows(step, flowObj) {
	                if (!flowObj) {
	                    return;
	                }
	                flowObj._steps[step.name] = step;
	                return addStepToCurrentAndParentFlows(step, flowObj._parent);
	            }
	
	            if (FlowUtil.isStepObject(stepNameOrObject)) {
	                if (isFlowEntry) {
	                    checkAndSetFlowEntry(stepNameOrObject, flow);
	                }
	                return stepNameOrObject;
	            }
	            if (!_.isString(stepNameOrObject)) {
	                throw new Error('Step function takes a string: ' + stepNameOrObject);
	            }
	            if (flow._steps[stepNameOrObject]) {
	                throw new Error('Step with name ' + stepNameOrObject + ' already exists in flow');
	            }
	
	            var step = {
	                _type: 'STEP',
	                name: stepNameOrObject
	            };
	            step.onNext = next(step, $q);
	            step.onPrevious = previous(step);
	            step.onEvent = event(step, $q);
	            step.isValid = valid(step);
	            step.skipOnResumeIf = skipOnResume(step);
	            step.label = label(step);
	            step.data = data(step);
	
	            if (extraStepDefnPropFactories && _.isArray(extraStepDefnPropFactories)) {
	                extraStepDefnPropFactories.forEach(function (propFactory) {
	                    return propFactory(step);
	                });
	            }
	            if (isFlowEntry) {
	                checkAndSetFlowEntry(step, flow);
	            }
	            addStepToCurrentAndParentFlows(step, flow);
	            return step;
	        }
	
	        function junctionBuilder(junctionNameOrObject, isFlowEntry, flow) {
	            function addJunctionToCurrentAndParentFlows(junction, flowObj) {
	                if (!flowObj) {
	                    return;
	                }
	                flowObj._junctions[junction.name] = junction;
	                return addJunctionToCurrentAndParentFlows(junction, flowObj._parent);
	            }
	
	            if (FlowUtil.isJunctionObject(junctionNameOrObject)) {
	                if (isFlowEntry) {
	                    checkAndSetFlowEntry(junctionNameOrObject, flow);
	                }
	                return junctionNameOrObject;
	            }
	            if (!_.isString(junctionNameOrObject)) {
	                throw new Error('Junction function takes a string: ' + junctionNameOrObject);
	            }
	            if (flow._junctions[junctionNameOrObject]) {
	                throw new Error('Junction with name ' + junctionNameOrObject + ' already exists in flow');
	            }
	
	            var junction = {
	                _type: 'JUNCTION',
	                name: junctionNameOrObject
	            };
	            junction.onNext = next(junction, $q);
	            junction.data = data(junction);
	
	            if (isFlowEntry) {
	                checkAndSetFlowEntry(junction, flow);
	            }
	            addJunctionToCurrentAndParentFlows(junction, flow);
	            return junction;
	        }
	
	        function flowBuilder(stepFn, junctionFn, parentFlow) {
	            var cachedFlows = [];
	
	            return function (flowFn) {
	                //cache the result of a flow creation if the same flow definition is encountered
	                var cacheHit = _.find(cachedFlows, function (cacheItem) {
	                    return cacheItem.defn === flowFn;
	                });
	                if (cacheHit) {
	                    return cacheHit.flow;
	                }
	                var currentFlow = {
	                    entry: undefined,
	                    exits: undefined,
	                    _steps: {},
	                    _junctions: {},
	                    _parent: parentFlow
	                };
	
	                var boundStepFn = _.partial(stepFn, _, _, currentFlow);
	                var boundJunctionFn = _.partial(junctionFn, _, _, currentFlow);
	
	                flowFn(boundStepFn, boundJunctionFn, flowBuilder(stepFn, junctionFn, currentFlow));
	
	                //A flow exit is a step or junction that does not have a doAction, branch, or goTo handler defined
	                currentFlow.exits = _.pick(currentFlow._steps, function (step) {
	                    return _.every(_.values(step.onNext), function (prop) {
	                        return prop() === undefined;
	                    });
	                });
	                //add unbound junctions also
	                _.extend(currentFlow.exits, _.pick(currentFlow._junctions, function (junction) {
	                    return _.every(_.values(junction.onNext), function (prop) {
	                        return prop() === undefined;
	                    });
	                }));
	
	                cachedFlows.push({
	                    defn: flowFn,
	                    flow: currentFlow
	                });
	                return currentFlow;
	            };
	        }
	
	        var flowFn = flowBuilder(stepBuilder, junctionBuilder);
	        return flowFn(flowDefn);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (step) {
	        var defaultSkipFn = function defaultSkipFn() {
	            return undefined;
	        }; //default skip function prevents skipping a step
	        var _skipOp = void 0;
	
	        /**
	         *
	         * @param {Function} [skipEvaluationFunction] - If no skip function is provided for a step then the default
	         *                                              behavior is not to skip
	         * @returns Step or skip function
	         */
	        return function skipIf(skipEvaluationFunction) {
	            if (arguments.length === 0) {
	                return _skipOp || defaultSkipFn;
	            }
	
	            /**
	             *
	             * @param {Object} model
	             *
	             * @returns {String}|{Object} The next step or flow to move to in the flow.
	             *                            The function should return undefined if there is no branch or goTo transition
	             *                            defined for the step or if the transition is a doAction
	             */
	            _skipOp = skipEvaluationFunction || defaultSkipFn;
	            return step;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(712)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, FlowUtil) {
	    return function (step, Q) {
	        var _doActionOp = void 0;
	        var _doActionMsgs = void 0;
	        var _doActionCallbacks = void 0;
	        var _goToOp = void 0;
	        var _branchOp = void 0;
	        var transitionSet = false;
	
	        function transition(stepNameOrBranchFn) {
	            return function (model, extraArgs) {
	                if (_.isString(stepNameOrBranchFn) || FlowUtil.isStepObject(stepNameOrBranchFn) || FlowUtil.isJunctionObject(stepNameOrBranchFn)) {
	                    //step name
	                    return stepNameOrBranchFn;
	                }
	                //branch function
	                return stepNameOrBranchFn(model, extraArgs);
	            };
	        }
	
	        function action(actionFn, callbacks) {
	            return function (model) {
	                var extraArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                var updateModelPromise = actionFn(model, extraArgs);
	                if (!updateModelPromise || !updateModelPromise.then) {
	                    throw new Error('Action function should return a promise: ' + actionFn);
	                }
	                return updateModelPromise.then(function (modelAfterPromise) {
	                    var actionSuccessTransition = callbacks.success(modelAfterPromise, extraArgs);
	                    if (!actionSuccessTransition) {
	                        throw new Error('Undefined result returned from action success transition');
	                    }
	                    return {
	                        model: modelAfterPromise,
	                        step: actionSuccessTransition,
	                        extraArgs: extraArgs
	                    };
	                }, function (errorFromAction) {
	                    var actionErrorTransition = callbacks.error(errorFromAction, extraArgs);
	                    if (!actionErrorTransition) {
	                        throw new Error('Undefined result returned from action error transition');
	                    }
	                    extraArgs.error = errorFromAction;
	                    return Q.reject({
	                        model: model,
	                        step: actionErrorTransition,
	                        extraArgs: extraArgs
	                    });
	                });
	            };
	        }
	
	        return {
	            /**
	             * Defines an action to call before going to a new step
	             *
	             * @param {Function}  doActionFn - Function that takes in the model and returns a promise that resolves to {model, extraArgs}
	             * @param {Object}  actionMsgs - Progress, Success and Error messages associated with action. Typically used for
	             *                               with dialog messages.
	             *
	             * @returns {*} If parameters are supplied then returns an object with thenGoTo and thenBranch properties otherwise
	             *              if no parameters are supplied then an object representing the action is returned.
	             *              Any extraParams will be bound to the action function.
	             */
	            doAction: function doAction(doActionFn, actionMsgs) {
	                if (arguments.length === 0) {
	                    return _doActionOp ? {
	                        action: _doActionOp,
	                        msgs: _doActionMsgs,
	                        callbacks: _doActionCallbacks
	                    } : undefined;
	                }
	                if (transitionSet) {
	                    throw new Error('A step definition can only have one doAction, goTo or branch property set');
	                }
	                transitionSet = true;
	                //object used to store what function to call when action promise is resolved
	                //functions are set on object in thenGoTo and thenBranch
	                var callbacks = {
	                    success: undefined,
	                    error: undefined
	                };
	                _doActionOp = action(doActionFn, callbacks);
	                _doActionMsgs = actionMsgs;
	                _doActionCallbacks = callbacks;
	                return {
	                    thenGoTo: function thenGoTo(successStep, errorStep) {
	                        callbacks.success = transition(successStep);
	                        callbacks.error = transition(errorStep);
	                        return step;
	                    },
	                    thenBranch: function thenBranch(successFn, errorFn) {
	                        callbacks.success = transition(successFn);
	                        callbacks.error = transition(errorFn);
	                        return step;
	                    }
	                };
	            },
	
	
	            /**
	             * Defines a transition to a new step
	             *
	             * @param {String|Object}  stepNameOrStepObject - String identifying the next step or a step object
	             *
	             * @returns {*} If parameters are supplied then undefined is returned
	             *              if no parameters are supplied then a string or object representing the next step returned
	             */
	            goTo: function goTo(stepNameOrStepObject) {
	                if (arguments.length === 0) {
	                    return _goToOp;
	                }
	                if (transitionSet) {
	                    throw new Error('A step definition can only have one doAction, goTo or branch property set');
	                }
	                transitionSet = true;
	                _goToOp = transition(stepNameOrStepObject);
	                return step;
	            },
	
	
	            /**
	             * Defines a branch function that returns the next step in the flow
	             *
	             * @param {Function}  branchFn - Function that returns the next step
	             *
	             * @returns {*} If parameters are supplied then undefined is returned
	             *              if no parameters are supplied then the branch function. Any extraParams will be bound to the
	             *              branch function.
	             */
	            branch: function branch(branchFn) {
	                if (arguments.length === 0) {
	                    return _branchOp;
	                }
	                if (transitionSet) {
	                    throw new Error('A step definition can only have one doAction, goTo or branch property set');
	                }
	                transitionSet = true;
	                _branchOp = transition(branchFn);
	                return step;
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (step) {
	        var _goBackFn = void 0;
	
	        /**
	         * Provide a function with logic about how to go backwards in the flow
	         *
	         * The arguments to this function are model, extraArgs
	         */
	        return function (goBackFn) {
	            if (arguments.length === 0) {
	                //previous function takes model and extraArgs parameters
	                return _goBackFn;
	            }
	            _goBackFn = goBackFn;
	            return step;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (step) {
	        var _isValidFn = void 0;
	        var defaultValidationFn = function defaultValidationFn() {
	            return true;
	        };
	
	        /**
	         * Provide a function to validate a step
	         *
	         * @params {Function} isValidFn - Function to validate the data entered in a step,
	         *                              The arguments to this function are model along with extraArgs.
	         *                              The function should return a boolean.
	         *                              If no function is provided the default behavior is to return true.
	         *
	         *
	         */
	        return function (isValidFn) {
	            if (arguments.length === 0) {
	                //isValid function takes model and extraArgs parameters
	                return _isValidFn || defaultValidationFn;
	            }
	            _isValidFn = isValidFn;
	            return step;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var defaultStepLabel = function defaultStepLabel(step) {
	        console.error('No label defined for step ' + step.name);
	        return 'Dummy label';
	    };
	
	    return function (step) {
	        var _labelFn = void 0;
	
	        /**
	         * Provide a function to associate a label with a step
	         *
	         * @params {Function} labelFn - Function to return a translated label for a step,
	         *                              The arguments to this function are model along with extraArgs map
	         *                              The function should return a string.
	         *                              If no function is provided the default behavior is to return 'Dummy label'.
	         *
	         *
	         */
	        return function (labelFn) {
	            if (arguments.length === 0) {
	                return _labelFn ? _labelFn() : defaultStepLabel(step);
	            }
	            _labelFn = labelFn;
	
	            return step;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    return function (stepOrJunction) {
	        var _data = void 0;
	
	        /**
	         * Associate a object for holding various properties with a step or junction
	         *
	         * @params {Object|Function} data = If no object is provided the default behavior is to return an empty object.
	         *
	         *
	         */
	        return function (data) {
	            if (arguments.length === 0) {
	                return _data || {};
	            }
	            _data = data;
	
	            return stepOrJunction;
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(717)], __WEBPACK_AMD_DEFINE_RESULT__ = function (next) {
	    return function (step, Q) {
	        return function (eventName) {
	            if (step[eventName]) {
	                return step[eventName];
	            }
	            step[eventName] = next(step, Q);
	            return step[eventName];
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(712)], __WEBPACK_AMD_DEFINE_RESULT__ = function (FlowUtil) {
	    /**
	     * This component has 2 responsibilities
	     * 1) To hook up a flow step to a router state so that step transitions in the flow trigger the correct router transitions
	     * 2) Clean-up the flowModel object from the state data when we transition to an exit step or go to a non-flow router state
	     */
	    return function ($state, StateUtils, parentWizardState, stepToStateMapping) {
	        //Check if there has been a router transition that is going from a wizard state to non-wizard state as result of
	        //a router state change (user clicks on home page link for example) rather than moving to a flow exit.
	        //Prompt user that they are exiting wizard and call the cancel action
	        var routerExitListenerRemoveFn = StateUtils.beforeStateChangeStart(function (event, toState, toParams, fromState) {
	            if (ifExitingWizardState(fromState, toState) && toState.name !== 'contactUs') {
	                //initially prevent transition until we get confirmation
	                event.preventDefault();
	                var wizardStateData = StateUtils.dataForState(parentWizardState);
	                wizardStateData.flowModel.cancel(wizardStateData.model).then(function () {
	                    cleanupWizardStateData();
	                    $state.go(toState, toParams);
	                });
	            }
	        });
	
	        function setModelData(model) {
	            var wizardStateData = StateUtils.dataForState(parentWizardState);
	            wizardStateData.model = model;
	        }
	
	        function cleanupWizardStateData() {
	            var stateData = StateUtils.dataForState(parentWizardState);
	            if (stateData.flowModel) {
	                stateData.flowModel.removeAllStepChangeListeners();
	            }
	            StateUtils.removeDataForState(parentWizardState, ['flowModel', 'model'], true);
	            routerExitListenerRemoveFn();
	        }
	
	        function ifExitingWizardState(fromState, toState) {
	            var fromStateInWizard = StateUtils.hasState(parentWizardState, fromState);
	            var toStateInWizard = StateUtils.hasState(parentWizardState, toState);
	            return fromStateInWizard && !toStateInWizard;
	        }
	
	        return function (flowDefn) {
	            /**
	             * Step change listener callback
	             */
	            return function (model, fromStep, nextStep, extraArgs) {
	                //default routing is to go to state with same name as step
	                nextStep = FlowUtil.getStepOrJunctionObject(nextStep);
	                var nextState = nextStep.name;
	                var nextStateArgs = extraArgs;
	                var specificRouterHandler = stepToStateMapping[nextStep.name];
	                if (specificRouterHandler) {
	                    var _specificRouterHandle = specificRouterHandler(model, nextStep, fromStep, extraArgs);
	
	                    var _specificRouterHandle2 = _slicedToArray(_specificRouterHandle, 2);
	
	                    nextState = _specificRouterHandle2[0];
	                    nextStateArgs = _specificRouterHandle2[1];
	                }
	
	                //if exiting wizard clean up data held in top level wizard state
	                if (flowDefn.exits[nextStep.name]) {
	                    cleanupWizardStateData();
	                } else {
	                    //Ideally we would pass model data as a parameter instead of using the state data but ui-router copies
	                    // parameter object instead of using the object reference.This causes problems for objects like view model
	                    // which initialise properties in the object constructor
	                    setModelData(model);
	                }
	
	                $state.go(nextState, nextStateArgs);
	            };
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Show a cancel confirmation
	     */
	    return function (ModalComponent, StateUtils) {
	        return function (model, _ref) {
	            var title = _ref.title,
	                message = _ref.message;
	
	            title = title || 'platform.flow.angularhelpers.CancelConfirmation.Are you sure you want to cancel?';
	            message = message || 'platform.flow.angularhelpers.CancelConfirmation.The information previously entered will be stored as a draft';
	
	            var validModel = model && model.aspects && model.aspects.valid && model.aspects.subtreeValid ? model : StateUtils.activeDataForState(true).flowModel.snapshot;
	            var cancelConfirmedPromise = ModalComponent.showWarning(title, message).result;
	
	            return cancelConfirmedPromise.then(function () {
	                return validModel;
	            });
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Default behavior for displaying status information about an action
	     *  Progress: while the action is in progress then a progress dialog will be shown with a progress message if provided
	     *  Success: if there is a success message provided then a success message will be displayed, otherwise no dialog is displayed
	     *  Error: if the action results in an error then an error dialog will be show with the error message if provided
	     */
	    return function (ModalComponent) {
	        var defaultActionMsgs = {
	            error: {
	                title: 'platform.flow.angularhelpers.ActionStatusMessages.Unable to perform operation',
	                message: 'platform.flow.angularhelpers.ActionStatusMessages.An error occurred, please contact your agent'
	            },
	            progress: {
	                message: 'platform.flow.angularhelpers.ActionStatusMessages.Processing operation...'
	            }
	        };
	
	        return function (actionPromise) {
	            var actionMsgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultActionMsgs;
	
	            var progressClosedPromise = ModalComponent.showProgressDialog(actionMsgs.progress.message, actionPromise).result;
	
	            return progressClosedPromise.then(function (resp) {
	                if (actionMsgs.success) {
	                    var successMsg = function successMsg() {
	                        return actionMsgs.success.message;
	                    };
	                    //when the dialog is closed return the response from the action
	                    return ModalComponent.showSuccess(successMsg, successMsg).result.then(function () {
	                        return resp;
	                    });
	                }
	                return resp;
	            }).catch(function (e) {
	                // Default error messages for the state
	                if (actionMsgs.error) {
	                    var errorTitle = actionMsgs.error.title;
	                    var errorMessage = actionMsgs.error.message;
	                }
	
	                // Server response
	                // Overriding default error messages if systemdown has valid value
	                if (angular.isDefined(e.extraArgs.error) && e.extraArgs.error.length > 0) {
	                    var baseError = e.extraArgs.error[0].baseError;
	                    if (baseError.statusText == "Internal Server Error" && actionMsgs.systemdown) {
	                        errorTitle = actionMsgs.systemdown.title;
	                        errorMessage = actionMsgs.systemdown.message;
	                    }
	                }
	                //US-10685, Added to display PC validation error
	                if (angular.isDefined(e.extraArgs.error) && e.extraArgs.error.length > 0) {
	                    var baseError = e.extraArgs.error[0].baseError;
	                    if (baseError && baseError.statusText == "Server Error" && baseError.data && baseError.data.error && baseError.data.error.message) {
	                        errorTitle = 'platform.flow.angularhelpers.ActionStatusMessages.Unable to perform operation';
	                        // errorMessage = baseError.data.error.message;
	                        errorMessage = 'platform.flow.angularhelpers.ActionStatusMessages.validationError';
	                    }
	                }
	                //US-10685, Ended to display PC validation error
	
	                //when the dialog is closed return throw an error to trigger the next error handler in the chain
	                if (errorTitle && errorMessage) {
	                    if (errorTitle === "quoteandbind.controllers.ZipCodeCtrl.Error") {
	                        return ModalComponent.showError(errorTitle, errorMessage).result.then(function () {
	                            throw e;
	                        });
	                    }
	                    throw e;
	                }
	                //US-10685, Added to display PC validation error
	                else {
	                        throw e;
	                    }
	                //US-10685, Ended to display PC validation error
	            });
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * When the user navigates forwards or backwards in the flow we want to know if we should
	     * set the model back to the last snapshot.
	     *
	     * This module checks if the model invalid and if so alerts the user that model will be reset
	     * and data will be lost.
	     *
	     */
	    return function (ModalMessageComponent, Q, snapshotResetWarningMessages) {
	        var defaultSnapshotResetWarningMessages = {
	            title: 'platform.flow.angularhelpers.SnapshotResetConfirmation.Are you sure you want to leave this page?',
	            message: 'platform.flow.angularhelpers.SnapshotResetConfirmation.Changes entered on this page may be lost'
	        };
	
	        /**
	         * @returns {Promise} if promise is rejected then the model should be reset with the last snapshot otherwise the
	         *                        snapshot should be set to the model
	         */
	        return function (model) {
	            if (model && model.aspects && model.aspects.valid && model.aspects.subtreeValid) {
	                return Q.resolve(model);
	            }
	            var messageKeys = snapshotResetWarningMessages || defaultSnapshotResetWarningMessages;
	            var confirmPromise = ModalMessageComponent.showConfirm(messageKeys.title, messageKeys.message).result;
	
	            return confirmPromise.then(function () {
	                return Q.reject('confirmed');
	            }, function () {
	                return Q.reject('cancelled');
	            });
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(728), __webpack_require__(730), __webpack_require__(733), __webpack_require__(735), __webpack_require__(512)], __WEBPACK_AMD_DEFINE_RESULT__ = function (WizardContentDirective, WizardSidebarRibbonDirective, WizardStepProgressDirective, WizardPageActionsDirective) {
	    return angular.module('edge.platform.widgets.wizard', ['edge.platform.base', 'ui.router']).directive('gwWizardContent', WizardContentDirective).directive('gwWizardSidebarRibbon', WizardSidebarRibbonDirective).directive('gwWizardStepProgress', WizardStepProgressDirective).directive('gwWizardPageActions', WizardPageActionsDirective);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(729)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return function () {
	        return {
	            replace: true,
	            transclude: true,
	            template: templateStr,
	            require: '^?gwPortalNavBar',
	            link: function link(scope, element, attrs, navBarCtrl) {
	                scope.sidebarMenuVisible = function () {
	                    return navBarCtrl.isSideBarMenuVisible();
	                };
	                if (navBarCtrl) {
	                    scope.hideSidebarMenu = function () {
	                        navBarCtrl.hideSideBarMenu();
	                    };
	                }
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 729 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-wizard-main\">\n    <div class=\"gw-page gw-box\">\n        <div class=\"gw-wizard-progress\" gw-wizard-step-progress></div>\n        <div ng-transclude></div>\n    </div>\n    <div class=\"gw-preventActionsLayer\" ng-class=\"{'gw-locked': sidebarMenuVisible()}\"\n         ng-click=\"hideSidebarMenu()\"></div>\n</div>"

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(731), __webpack_require__(732)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, _WizardStepsCtrl, templateStr) {
	    return function () {
	        return {
	            restrict: 'A',
	            replace: true,
	            template: templateStr,
	            controller: _WizardStepsCtrl,
	            scope: {
	                title: '@'
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, _) {
	    var fn = function fn($scope, StateUtils) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        /**
	         * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
	         */
	        function refreshStepsFn() {
	            function setStepClasses(wizardSteps) {
	
	                if (wizardSteps.length > 0) {
	                    var currentStateIdx = _.findIndex(wizardSteps, function (step) {
	                        return step.name === flowModel.currentStep.name;
	                    });
	
	                    for (var stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
	                        var step = wizardSteps[stepIdx];
	                        var visited = stepIdx <= currentStateIdx;
	
	                        if (currentStateIdx != -1 && ctrl.getVisibleStatus(wizardSteps[currentStateIdx].name) == true) {
	                            var activeClass = currentStateIdx === stepIdx ? 'gw-current' : '';
	                            var notVisitedClass = visited || stepIdx === 0 ? '' : 'gw-not-visited';
	                            var visitedClass = visited && currentStateIdx === stepIdx ? 'gw-visited' : '';
	                            var allowedVisitClass = flowModel.isStepAccessibleFromCurrent(step) ? 'gw-allowed' : 'gw-not-allowed';
	                            step.styleClass = activeClass + ' ' + notVisitedClass + ' ' + visitedClass + ' ' + allowedVisitClass;
	                        }
	                    }
	                }
	            }
	            $scope.wizardSteps.length = 0;
	            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
	            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
	            setStepClasses($scope.wizardSteps);
	            //console.log("wizardsteps  ", $scope.wizardSteps);
	        }
	
	        ctrl.init = function () {
	            if (!flowModel) {
	                return;
	            }
	            $scope.wizardSteps = [];
	            $scope.ribbonVisible = false;
	            //console.log("scope: ", $scope.$root.submission.draftData);
	            $scope.ignoreStates = [];
	            // If product code is home owners then skip to display the following states
	            if ($scope.$root.submission.draftData.productCode === "Homeowners") {
	                $scope.ignoreStates = ["hoPrequalQuestions", "hoMembership", "hoYourHome", "hoConstruction", "hoPolicyInfo", "paymentDetails", "nextSteps"];
	            } else if ($scope.$root.submission.draftData.productCode == "PersonalAuto") {
	                $scope.ignoreStates = ["paPrequalQuestions", "paMembership", "paPrevCarrierInfo", "paDriverVehiclePrefillInfo", "paPolicySummary", "paymentConfirmation"];
	            }
	            refreshStepsFn();
	
	            flowModel.addStepChangeListener(refreshStepsFn);
	
	            $scope.$on('$destroy', function () {
	                flowModel.removeStepChangeListener(refreshStepsFn);
	            });
	        };
	
	        ctrl.getVisibleStatus = function (stateName) {
	
	            return $scope.ignoreStates.indexOf(stateName) == -1;
	        };
	        /**
	         * Method used by wizard ribbon to move between steps.
	         * @param {Object} step - selected step
	         */
	        ctrl.selectStep = function (step) {
	            var currentModel = StateUtils.activeDataForState(true).model;
	            if (flowModel.isStepAccessibleFromCurrent(step)) {
	                flowModel.jumpToStep(step, currentModel);
	            }
	        };
	
	        ctrl.stepLabel = function (step) {
	            return step.label();
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'StateUtils'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 732 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-wizard-sidebar-steps\">\n    <div class=\"gw-section-title\">\n        <span>{{title}}</span>\n    </div>\n    <ul class=\"gw-steps\">\n        <li ng-repeat=\"step in wizardSteps\" ng-class=\"step.styleClass\"\n            ng-click=\"selectStep(step.name)\"\n            ng-show=\"getVisibleStatus(step.name)\">{{ stepLabel(step) }}\n        </li>\n    </ul>\n</div>\n"

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*
	 *  For adding a progress bar at top of wizard for responsive view
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(731), __webpack_require__(734)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_WizardStepsCtrl, templateStr) {
	    return function () {
	        return {
	            restrict: 'A',
	            replace: true,
	            template: templateStr,
	            require: '^gwPortalNavBar',
	            controller: _WizardStepsCtrl,
	            link: function link(scope, element, attrs, navBarCtrl) {
	                var wizardStepsDisplayed = false;
	                scope.toggleWizardStepDisplay = function () {
	                    if (wizardStepsDisplayed) {
	                        navBarCtrl.hideSideBarMenu();
	                        wizardStepsDisplayed = false;
	                    } else {
	                        navBarCtrl.showSideBarMenu();
	                        wizardStepsDisplayed = true;
	                    }
	                };
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 734 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-wizard-progress\" ng-if=\"ribbonVisible\">\n    <ul ng-click=\"toggleWizardStepDisplay()\"><!-- slide the wizard step sidebar in and out of view-->\n        <li ng-repeat=\"step in wizardSteps\" ng-class=\"step.styleClass\" ng-show=\"getVisibleStatus(step.name)\"></li>\n    </ul>\n</div>"

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(736), __webpack_require__(737)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr, FormUtil) {
	    return ['StateUtils', function (StateUtils) {
	        return {
	            template: templateStr,
	            scope: {
	                'showCancel': '=?',
	                'showPrevious': '=?',
	                'showNext': '=?',
	                'disableCancel': '=?',
	                'disablePrevious': '=?',
	                'disableNext': '=?',
	                'next': '=?',
	                'nextLabel': '@?',
	                'previous': '=?',
	                'cancel': '=?',
	                'gwWizardPageActions': '='
	            },
	            require: ['?^form', '?^ngForm'],
	            link: function link(scope, element, attrs, formCtrls) {
	                var formCtrl = formCtrls[0] || {};
	                var flowModel = StateUtils.activeDataForState(true).flowModel;
	                var model = scope.gwWizardPageActions || StateUtils.activeDataForState(true).model;
	                if (!flowModel) {
	                    throw new Error('Page action directive under a wizard state that has a flowModel data property');
	                }
	
	                scope.showNext = scope.showNext || true;
	                if (flowModel.steps.length > 0) {
	                    var isFirstStep = flowModel.steps[0].name === flowModel.currentStep.name;
	                    scope.showPrevious = scope.showPrevious !== undefined ? scope.showPrevious : !isFirstStep;
	                }
	                scope.showCancel = scope.showCancel || true;
	
	                scope.disableCancel = scope.disableCancel || false;
	                scope.disablePrevious = scope.disablePrevious || false;
	
	                scope.goToNext = function () {
	                    FormUtil.markFormsSubmitted(formCtrl);
	                    if (scope.next) {
	                        scope.next(function (_model, args) {
	                            return flowModel.next(_model, args);
	                        }, formCtrl);
	                    } else {
	                        flowModel.next(model);
	                    }
	                };
	                scope.goToPrevious = function () {
	                    if (scope.previous) {
	                        scope.previous(function (_model, args) {
	                            return flowModel.previous(_model, args);
	                        }, formCtrl);
	                    } else {
	                        flowModel.previous(model);
	                    }
	                };
	                scope.goToCancel = function () {
	                    if (scope.cancel) {
	                        scope.cancel(function (_model, args) {
	                            return flowModel.cancel(_model, args);
	                        }, formCtrl);
	                    } else {
	                        flowModel.cancel(model);
	                    }
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 736 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-page-buttons\">\n    <button class=\"gw-btn\" ng-show=\"showCancel\" ng-disabled=\"disableCancel\"\n            ng-click=\"goToCancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\n    </button>\n    <button class=\"gw-btn\" ng-show=\"showPrevious\" ng-disabled=\"disablePrevious\"\n            ng-click=\"goToPrevious()\">{{'platform.widgets.wizard.Previous'|translate}}\n    </button>\n    <button class=\"gw-btn-primary\" ng-show=\"showNext\" ng-disabled=\"disableNext\"\n            ng-click=\"goToNext()\">{{nextLabel || 'platform.widgets.wizard.Next' | translate}}\n    </button>\n</div>"

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        /**
	         * Marks form and immediate child forms submitted
	         *
	         * @param form
	         */
	        markFormsSubmitted: function markFormsSubmitted(form) {
	            form.submitted = true;
	
	            Object.keys(form).forEach(function (key) {
	                if (_typeof(form[key]) === 'object' && form[key].$submitted !== undefined // checking if child is a form
	                ) {
	                        form[key].submitted = true;
	                    }
	            });
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(739), __webpack_require__(706), __webpack_require__(637), __webpack_require__(741)], __WEBPACK_AMD_DEFINE_RESULT__ = function (localDateChooser) {
	    return angular.module('edge.platform.widgets.ui.time', ['edge.platform.widgets.ui.bootstrap.datetimepicker', 'edge.platform.time']).directive('gwPlLocalDateChooser', localDateChooser);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(740)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    function localDate2Date(localDate) {
	        return localDate ? new Date(localDate.year, localDate.month, localDate.day) : undefined;
	    }
	
	    function date2localDate(date) {
	        return date ? { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() } : undefined;
	    }
	
	    return [function () {
	        return {
	            'restrict': 'AE',
	            'template': template,
	            'scope': {
	                'model': '=',
	                'maxDate': '=',
	                'initialDate': '='
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.value = localDate2Date($scope.model);
	                $scope.initialDateV = localDate2Date($scope.initialDate || $scope.model);
	                $scope.maxDateV = localDate2Date($scope.maxDate);
	
	                $scope.$watch('model', function (nv) {
	                    $scope.value = localDate2Date(nv);
	                    $scope.initialDateV = localDate2Date($scope.initialDate || nv);
	                }, true);
	                $scope.$watch('value', function (nv) {
	                    return $scope.model = date2localDate(nv);
	                }, true);
	                $scope.$watch('initialDate', function (nv) {
	                    return $scope.initialDateV = localDate2Date(nv || $scope.model);
	                }, true);
	                $scope.$watch('initialDateV', console.log, true);
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 740 */
/***/ function(module, exports) {

	module.exports = "<span ng-datepicker\n      default-date=\"initialDateV\"\n      start-view=\"year\"\n      min-view=\"day\"\n      input-id=\"localDateChooser\"\n      name=\"localDateChooser\"\n      max-date=\"maxDateV\"\n      ng-model=\"value\"></span>\n"

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(706), __webpack_require__(742)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ViewModel, JSInteropAscpect) {
	    return angular.module('edge.platform.time', ['edge.platform.viewmodel']).run(['ViewModelService', function (ViewModelService) {
	        ViewModelService.addAspectFactory(JSInteropAscpect);
	    }]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Interoperability extension to the view model. Allows developers to access edge date/time types as values of a
	 * Javascript date.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(743), __webpack_require__(744), __webpack_require__(745)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LocalDate, Instant, OffsetDateTime) {
	    /** An aspect for the non-date times. It does not have any value and could not be set to anything meaningful. */
	    var noDateDescriptor = {};
	
	    /** Compares two dates. */
	    function datesEqual(dt1, dt2) {
	        if (dt1 === dt2) {
	            return true;
	        }
	
	        if (dt1 === null || dt1 === undefined || dt2 === null || dt2 === undefined) {
	            return false;
	        }
	
	        return dt1.getTime() === dt2.getTime() && dt1.getTimezoneOffset() === dt2.getTimezoneOffset();
	    }
	
	    function createPropertyWrapper(dto2date, date2dto, viewModelNode) {
	        /**
	         * Creates a "proper" date wrapper with date caching.
	         * @param dto2date function used for conversion from DTO to js date.
	         * @param date2dto function used for conversion from js date to DTO.
	         * @param viewModelNode model node for which a wrapper is created.
	         * @return property descriptor of the "
	         */
	        var cached = dto2date(viewModelNode.value);
	        return {
	            'jsDateValue': {
	                get: function get() {
	                    var newValue = dto2date(viewModelNode.value);
	                    /* Prevent unlimited date digesting by angular. */
	                    if (!datesEqual(cached, newValue)) {
	                        cached = newValue;
	                    }
	                    return cached;
	                },
	                set: function set(newValue) {
	                    viewModelNode.value = date2dto(newValue);
	                }
	            }
	        };
	    }
	
	    /** Factories for the different date-time classes. */
	    var factories = {
	        'edge.time.LocalDateDTO': createPropertyWrapper.bind(null, LocalDate.toLocalMidnight, LocalDate.fromJSDate),
	        'edge.time.InstantDTO': createPropertyWrapper.bind(null, Instant.toJSDate, Instant.fromJSDate),
	        'edge.time.OffsetDateTimeDTO': createPropertyWrapper.bind(null, OffsetDateTime.toLocalDate, OffsetDateTime.fromJSDate),
	        'edge.time.LocalTimeDTO': createPropertyWrapper.bind(null, LocalDate.toLocalTodayDate, OffsetDateTime.fromJSDate)
	    };
	
	    return {
	        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /*, ancestorChain*/) {
	            var type = currentMetadataNode.valueType;
	            if (type.kind !== 'class') {
	                return noDateDescriptor;
	            }
	
	            var factory = factories[type.name];
	            return factory ? factory(currentViewModelNode) : noDateDescriptor;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Utilities for operations on the local date.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        /** Converts a jsDate into a DTO. */
	        fromJSDate: function fromJSDate(jsDate) {
	            return jsDate ? { 'year': jsDate.getFullYear(), 'month': jsDate.getMonth(), 'day': jsDate.getDate() } : jsDate;
	        },
	
	
	        /** Converts a dto into a local midnight. */
	        toLocalMidnight: function toLocalMidnight(dto) {
	            return dto ? new Date(dto.year, dto.month, dto.day) : dto;
	        },
	
	
	        /** Converts a dto into a local noon time. */
	        toLocalNoon: function toLocalNoon(dto) {
	            return dto ? new Date(dto.year, dto.month, dto.day, 12) : dto;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Utilities for an "instant" date/time.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        /** Creates a new instant from JS date. */
	        fromJSDate: function fromJSDate(date) {
	            return date ? { 'time': date.getTime() } : date;
	        },
	
	
	        /** Creates a new JS date from an instant. */
	        toJSDate: function toJSDate(instant) {
	            return instant ? new Date(instant.time) : instant;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Utilities for the OffsetDateTimeDTO.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(744)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Instant) {
	  return {
	    /**
	     * Creates a new instance of offsetDateTime DTO capturing a local UTC time offset from the date (based on current
	     * client TZ rules.
	     */
	    fromJSDate: function fromJSDate(date) {
	      return date ? { instant: Instant.fromJSDate(date), offset: -date.getTimezoneOffset() } : date;
	    },
	
	
	    /**
	     * Converts a DTO into a local date. The returned date represents correct instant but originating time offest
	     * is lost.
	     */
	    toLocalDate: function toLocalDate(dto) {
	      return dto ? Instant.toJSDate(dto.instant) : dto;
	    }
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355),
	//'./config/RouteConfig',
	__webpack_require__(759), __webpack_require__(393), __webpack_require__(749), __webpack_require__(751), __webpack_require__(753), __webpack_require__(755), __webpack_require__(757), __webpack_require__(747), __webpack_require__(773), __webpack_require__(775), __webpack_require__(777), __webpack_require__(779), __webpack_require__(390), __webpack_require__(695), __webpack_require__(512)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, RouteConfig, QuestionSets, HOConfirmation, HOUpgrade, HOSelectWithOther, HORoofTypeSelect, HOTypelistRadios, HOEditScheduledProperty, HOEditBlanketItems, HOEditCoverages, HOViewCoverages, scheduledPropValidation) {
	    var questionSets = JSON.parse(QuestionSets);
	
	    return angular.module('edge.quoteandbind.ho.app', ['edge.quoteandbind.common.app', 'edge.platform.el']).constant('HOConstants', {
	        POLICY_TYPE_ID: 'HO3'
	    }).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
	        var states = new RouteConfig(RootStateConfig);
	        for (var stateName in states) {
	            if (states.hasOwnProperty(stateName)) {
	                $stateProvider.state(stateName, states[stateName]);
	            }
	        }
	    }]).config(['QuestionSetServiceProvider', function (QuestionSetServiceProvider) {
	        QuestionSetServiceProvider.addQuestionSets(questionSets);
	    }]).filter('orderObjectBy', function () {
	        return function (items, field, reverse) {
	            var filtered = [];
	            angular.forEach(items, function (item) {
	                filtered.push(item);
	            });
	            filtered.sort(function (a, b) {
	                /*eslint-disable */
	                return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
	                /*eslint-enable */
	            });
	            if (reverse) {
	                filtered.reverse();
	            }
	            return filtered;
	        };
	    }).directive('gwHoConfirmation', HOConfirmation).directive('gwHoUpgrade', HOUpgrade).directive('gwHoSelectWithOther', HOSelectWithOther).directive('gwHoRoofTypeSelect', HORoofTypeSelect).directive('gwHoTypelistRadios', HOTypelistRadios).directive('gwQnbHoEditScheduledProperty', HOEditScheduledProperty).directive('gwQnbHoEditBlanketItems', HOEditBlanketItems).directive('gwQnbHoEditCoverages', HOEditCoverages).directive('gwQnbHoViewCoverages', HOViewCoverages).run(['ExpressionLanguageService', function (ExpressionLanguage) {
	        ExpressionLanguage.getCompilationContext('pc').registerType('edge.capabilities.quote.lob.homeowners.quoting.internal.HOQuoteUtilities', scheduledPropValidation);
	    }]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(748)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    var nextId = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbHoEditScheduledProperty',
	                onListChange: '=',
	                loading: '=?'
	            },
	            controller: ['$scope', function (scope) {
	                function notifyChange() {
	                    if (scope.onListChange) {
	                        scope.onListChange();
	                    }
	                }
	
	                scope.addScheduledProperty = function () {
	                    /* Do this on push as "null" would be set when custom quote is loaded without
	                     * any additional properties.
	                     */
	                    if (!scope.model.value) {
	                        scope.model.value = [];
	                    }
	                    scope.model.value.push({
	                        tempID: nextId++,
	                        type: 'Jewelry'
	                    });
	                    notifyChange();
	                };
	
	                scope.removeScheduledProperty = function (index) {
	                    scope.model.value.splice(index, 1);
	                    notifyChange();
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 748 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-padded20\">\n    <h4 class=\"gw-coverage-header\">{{'quoteandbind.ho.directives.ho-additional-coverages.Contents Coverages' | translate}}</h4>\n\n\n    <button class=\"gw-btn\" ng-click=\"addScheduledProperty()\"\n            ng-disabled=\"loading\">{{'quoteandbind.ho.directives.ho-additional-coverages.Add Article' | translate}}\n    </button>\n<span class=\"gw-error-text gw-padded20 gw-bold\" ng-show=\"!model.aspects.valid\">\n    <span ng-repeat=\"errorMessage in model.aspects.validationMessages\">\n        <span class=\"gw-error-inline\">{{errorMessage}}</span>\n    </span>\n</span>\n</div>\n\n<table class=\"gw-table\" ng-if=\"model.length > 0\">\n    <thead>\n    <tr>\n        <th class=\"gw-inline-control-group\">\n            <label class=\"gw-control-inline-label\">\n                <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Article or Property Type' | translate}}</span>\n                <span class=\"gw-required-asterisk\">*</span>\n            </label>\n        </th>\n        <th class=\"gw-inline-control-group\">\n            <label class=\"gw-control-inline-label\">\n                <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Description' | translate}}</span>\n                <span class=\"gw-required-asterisk\">*</span>\n            </label>\n        <th class=\"gw-inline-control-group\">\n            <label class=\"gw-control-inline-label\">\n                <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Value' | translate}}</span>\n                <span class=\"gw-required-asterisk\">*</span>\n            </label>\n        </th>\n        <th>{{'quoteandbind.ho.directives.ho-additional-coverages.Delete' | translate}}</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr\n            ng-repeat=\"item in model.children track by $index\">\n        <td title=\"{{'quoteandbind.ho.directives.ho-additional-coverages.Article or Property Type' | translate}} *\">\n            <select gw-pl-select=\"item.type.value\" options=\"item.type.aspects.availableValues\" render-by=\"'name'\"\n                    ng-disabled=\"loading\"></select>\n        </td>\n        <td title=\"{{'quoteandbind.ho.directives.ho-additional-coverages.Description' | translate}} *\">\n            <input type=\"text\" class=\"gw-input-block-level\"\n                   id=\"Description_{{$index}}\"\n                   ng-disabled=\"loading\"\n                   ng-model=\"item.description.value\"\n                   ng-class=\"{'ng-invalid' : !item.description.aspects.valid}\"/>\n            <label for=\"Description_{{$index}}\" class=\"gw-with-error-sign\">\n                <span class=\"gw-error-sign\"></span>\n            </label>\n        </td>\n        <td title=\"{{'quoteandbind.ho.directives.ho-additional-coverages.Value' | translate}} *\">\n            <input type=\"text\" class=\"gw-input-block-level\"\n                   ng-disabled=\"loading\"\n                   id=\"Value_{{$index}}\"\n                   ng-model=\"item.exposureValue.value\"\n                   ng-class=\"{'ng-invalid' : !item.exposureValue.aspects.valid}\"/>\n            <label for=\"Value_{{$index}}\" class=\"gw-with-error-sign\">\n                <span class=\"gw-error-sign\"></span>\n            </label>\n        </td>\n        <td>\n            <button type=\"button\" ng-click=\"removeScheduledProperty($index)\" ng-disabled=\"loading\"><span\n                    class=\"fa fa-trash\"></span></button>\n        </td>\n    </tr>\n    </tbody>\n</table>"

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(750)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            controller: ['$scope', function ($scope) {
	                this._coverages = function (coverages) {
	                    return coverages.map(function (cov) {
	                        return { name: cov.description, amount: cov.amount, terms: cov.terms };
	                    });
	                };
	
	                $scope.baseCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.baseCoverages);
	                $scope.additionalCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.additionalCoverages);
	                $scope.scheduledProperties = $scope.chosenQuote.lobs.homeowners.scheduledProperties;
	                $scope.basePremium = $scope.chosenQuote.lobs.homeowners.basePremium;
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 750 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div>\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.ho.views.ho-confirmation.YourInfo' | translate}}</h2>\n\n        <div>\n            <div class=\"gw-control-group\">\n                <div class=\"gw-control-label\">{{'quoteandbind.ho.views.ho-confirmation.FirstName' | translate}}</div>\n                <div class=\"gw-controls\">{{accountHolder.firstName}}</div>\n            </div>\n            <div class=\"gw-control-group\">\n                <div class=\"gw-control-label\">{{'quoteandbind.ho.views.ho-confirmation.LastName' | translate}}</div>\n                <div class=\"gw-controls\">{{accountHolder.lastName}}</div>\n            </div>\n            <div class=\"gw-control-group\" ng-if=\"contactNumber\">\n                <div class=\"gw-control-label\">{{'quoteandbind.ho.views.ho-confirmation.Phone' | translate}}</div>\n                <div class=\"gw-controls\">{{contactNumber}}</div>\n            </div>\n            <div class=\"gw-control-group\">\n                <div class=\"gw-control-label\">{{'quoteandbind.ho.views.ho-confirmation.Email' | translate}}</div>\n                <div class=\"gw-controls\">{{accountHolder.emailAddress1}}</div>\n            </div>\n        </div>\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.ho.views.ho-confirmation.YourHouse' | translate}}</h2>\n\n        <div>\n            <div class=\"gw-control-group\">\n                <div class=\"gw-control-label\">{{'quoteandbind.ho.views.ho-confirmation.Address' | translate}}</div>\n                <div class=\"gw-controls\">{{accountHolderAddress.addressLine1}},\n                    <div ng-if=\"accountHolderAddress.addressLine2\">{{accountHolderAddress.addressLine2}},</div>\n                    <div ng-if=\"accountHolderAddress.city\">{{accountHolderAddress.city}},</div>\n                    <div ng-if=\"accountHolderAddress.state\">{{accountHolderAddress.state}},</div>\n                    <div ng-if=\"accountHolderAddress.postalCode\">{{accountHolderAddress.postalCode}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <h2 class=\"gw-page-section-title\">{{'quoteandbind.ho.views.ho-confirmation.YourCoverages' | translate}}</h2>\n\n    <div>\n        <table class=\"gw-table\">\n            <tbody>\n            <tr>\n                <td class=\"gw-notitle gw-mobile-hidden\">\n                    <b>{{'quoteandbind.ho.views.ho-confirmation.BaseCoverages' | translate}}</b></td>\n                <td class=\"gw-mobile-hidden\"/>\n                <td title=\"{{'quoteandbind.ho.views.ho-confirmation.BaseCoverages' | translate}}\">{{basePremium|gwCurrency}}</td>\n            </tr>\n            </tbody>\n            <tbody ng-repeat=\"coverage in baseCoverages\">\n            <tr>\n                <td class=\"gw-notitle gw-mobile-hidden\"><b>{{coverage.name}}</b></td>\n                <td class=\"gw-mobile-hidden\"/>\n                <td title=\"{{coverage.name}}\"/>\n            </tr>\n            <tr ng-repeat=\"term in coverage.terms\">\n                <td class=\"gw-notitle gw-mobile-hidden\">&nbsp;&nbsp;{{term.name}}</td>\n                <td title=\"&nbsp;&nbsp;{{term.name}}\">{{term.chosenTermValue}}</td>\n                <td class=\"gw-mobile-hidden\"/>\n            </tr>\n            </tbody>\n            <tbody>\n            <tr>\n                <td class=\"gw-notitle gw-mobile-hidden\">\n                    <b>{{'quoteandbind.ho.views.ho-confirmation.AdditionalCoverages' | translate}}</b></td>\n                <td class=\"gw-mobile-hidden\"/>\n                <td title=\"{{'quoteandbind.ho.views.ho-confirmation.AdditionalCoverages' | translate}}\"/>\n            </tr>\n            </tbody>\n            <tbody ng-repeat=\"cov in additionalCoverages\">\n            <tr>\n                <td class=\"gw-notitle gw-mobile-hidden\"><b>{{cov.name}}</b></td>\n                <td class=\"gw-mobile-hidden\"/>\n                <td title=\"{{cov.name}}\">{{cov.amount|gwCurrency}}</td>\n            </tr>\n            <tr ng-repeat=\"term in cov.terms\">\n                <td class=\"gw-notitle gw-mobile-hidden\">&nbsp;&nbsp;{{term.name}}</td>\n                <td title=\"&nbsp;&nbsp;{{term.name}}\">{{term.chosenTermValue}}</td>\n                <td class=\"gw-mobile-hidden\"/>\n            </tr>\n            <tbody ng-if=\"scheduledProperties.length > 0\">\n            <tr>\n                <td><b>{{'quoteandbind.ho.views.ho-confirmation.Contents Coverages' | translate}}</b></td>\n            </tr>\n            <tr ng-repeat=\"cov in scheduledProperties\">\n                <td class=\"gw-notitle gw-mobile-hidden\">{{cov.description}}</td>\n                <td class=\"gw-mobile-hidden\"/>\n                <td title=\"{{cov.name}}\">{{cov.value}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>"

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(752)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    var ctrlId = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                upgradeExists: '=',
	                upgradeYear: '=',
	                label: '@'
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.ctrlId = 'HoUpgradeCtrl' + ctrlId++;
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 752 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-upgraded-section\"\n     gw-pl-ctrl-group label=\"{{label}}\" model=\"upgradeExists\">\n    <div class=\"gw-control-label\">\n        <input type=\"checkbox\"\n               id=\"{{ctrlId}}\"\n               name=\"{{ctrlId}}\"\n               ng-model=\"upgradeExists.value\"\n        />\n        <label for=\"{{ctrlId}}\"></label>\n    </div>\n    <div class=\"gw-controls\">\n        <div gw-pl-inline-input-ctrl class=\"gw-other-section\"\n             model=\"upgradeYear\" label=\"\"\n             placeholder=\"{{'quoteandbind.ho.views.construction.Year' | translate}}\"\n             ng-if=\"upgradeExists.value\">\n        </div>\n    </div>\n</div>"

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(754)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=',
	                otherModel: '=',
	                label: '@',
	                filterCodes: '=' // List of type codes to be removed from dropdown
	            },
	            controller: ['$scope', function ($scope) {
	
	                // Assign available values from model object
	                // Replaced options='model.aspects.availableValues' to options='availableValues' (ho-select-with-other.html) 
	                // to filter the not required values from the dropdown
	                $scope.availableValues = $scope.model.aspects.availableValues;
	
	                // Check if filterCodes is an array
	                // then remove those values from availableValues
	                if (!_.isUndefined($scope.filterCodes) && _.isArray($scope.filterCodes)) {
	
	                    /*for(var idx in  $scope.availableValues){
	                     var typeCode = $scope.availableValues[idx];
	                     if($scope.filterCodes.indexOf(typeCode.code))
	                     }*/
	
	                    //array.splice(i, 1);
	
	                    $scope.availableValues = _.filter($scope.availableValues, function (typeCode) {
	
	                        return $scope.filterCodes.indexOf(typeCode.code) === -1;
	                    });
	                }
	
	                $scope.isOther = function (v) {
	                    return v && v.code.toLowerCase() === 'other';
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 754 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-ctrl-group label=\"{{label}}\" model=\"model\">\n    <select gw-pl-select=\"model.value\"\n            options=\"availableValues\"\n            render-by=\"'name'\"\n            placeholder=\"{{'quoteandbind.ho.views.construction.Please Select' | translate}}\">\n    </select>\n\n    <div gw-pl-inline-input-ctrl model=\"otherModel\"\n         class=\"gw-other-section\" ng-if=\"isOther(model.value)\"\n         label=\"{{'quoteandbind.ho.views.construction.Specify other:' | translate}}\"></div>\n</div>"

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(756)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=',
	                otherModel: '=',
	                filterCodes: '='
	            },
	            controller: ['$scope', function ($scope) {
	
	                // Assign available values from model object
	                // Replaced options='model.aspects.availableValues' to options='availableValues' (ho-roof-type-select.html) 
	                // to filter the not required values from the dropdown
	                $scope.availableValues = $scope.model.aspects.availableValues;
	                // Check if filterCodes is an array
	                // then remove those values from availableValues
	                if (!_.isUndefined($scope.filterCodes) && _.isArray($scope.filterCodes)) {
	
	                    $scope.availableValues = _.filter($scope.availableValues, function (typeCode) {
	
	                        return $scope.filterCodes.indexOf(typeCode.code) === -1;
	                    });
	                }
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 756 */
/***/ function(module, exports) {

	module.exports = "<div gw-pl-inline-ctrl-group class=\"gw-roof-group-wrapper\" model=\"model\">\n    <div class=\"gw-roof-group\">\n        <label ng-repeat=\"roof in availableValues track by roof.code\">\n            <input type=\"radio\" name=\"RoofType\" ng-value=\"roof\" ng-model=\"model.value\"/>\n\n            <div class=\"gw-item-content\">\n                <div class=\"gw-media-wrapper\">\n                    <img class=\"gw-media\" ng-src=\"../styles/images/ho/roof/{{roof.code}}.jpg\"/>\n                    <i class=\"gw-icon fa fa-check\"></i>\n                </div>\n\n                <div class=\"gw-text\">\n                    {{roof.name}}\n                </div>\n            </div>\n        </label>\n\n        <label ng-if=\"model.value.code === 'other'\" class=\"gw-other-section\">\n            <div gw-pl-inline-ctrl-group class=\"gw-item-content\"\n                 label=\"{{'quoteandbind.ho.views.construction.Specify other:' | translate}}\"\n                 model=\"otherModel\">\n                <textarea name=\"RoofTypeDescription\"\n                          cols=\"30\" rows=\"10\"\n                          ng-model=\"otherModel.value\"\n                          placeholder=\"\">\n                </textarea>\n            </div>\n        </label>\n    </div>\n</div>"

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(758)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    var ctrlId = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '='
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.ctrlId = 'hotypelistradioctrl' + ctrlId++ + '_';
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 758 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-controls-radios\">\n    <div class=\"gw-controls-radios-repeat-wrapper\">\n        <div class=\"gw-controls-radios-repeat\" ng-repeat=\"item in model.aspects.availableValues track by item.code\">\n            <input\n                    type=\"radio\"\n                    id=\"{{ctrlId}}{{$index}}\"\n                    ng-value=\"item\"\n                    ng-model=\"model.value\"\n            />\n            <label for=\"{{ctrlId}}{{$index}}\">\n                {{item.name}}\n            </label>\n        </div>\n    </div>\n</div>"

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(761), __webpack_require__(377), __webpack_require__(368), __webpack_require__(762), __webpack_require__(436), __webpack_require__(763), __webpack_require__(764), __webpack_require__(765), __webpack_require__(766), __webpack_require__(760), __webpack_require__(767), __webpack_require__(379), __webpack_require__(768), __webpack_require__(448), __webpack_require__(769), __webpack_require__(770), __webpack_require__(771), __webpack_require__(772)], __WEBPACK_AMD_DEFINE_RESULT__ = function (HOContactDetailsView, HOPreQualQuestionsView, HOMembershipView, HOAdditionalInfoView, NextStepsView, HOYourHomeView, HOConstructionView, HORatingView, HOPolicyInfoView, HOContactDetailsCtrl, HOPreQualQuestionsCtrl, MembershipCtrl, HOAdditionalInfoCtrl, NextStepsCtrl, HOYourHomeCtrl, HOConstructionCtrl, HORatingCtrl, HOPolicyInfoCtrl) {
	    return function () {
	        var wizardParentState = 'baseQnbWizard';
	
	        return {
	            hoContactDetails: {
	                parent: wizardParentState,
	                template: HOContactDetailsView,
	                controller: HOContactDetailsCtrl
	            },
	            hoPrequalQuestions: {
	                parent: wizardParentState,
	                template: HOPreQualQuestionsView,
	                controller: HOPreQualQuestionsCtrl
	            },
	            hoMembership: {
	                parent: wizardParentState,
	                template: HOMembershipView,
	                controller: MembershipCtrl
	            },
	
	            hoAdditionalInfo: {
	                parent: wizardParentState,
	                template: HOAdditionalInfoView,
	                controller: HOAdditionalInfoCtrl
	            },
	
	            hoYourHome: {
	                parent: wizardParentState,
	                template: HOYourHomeView,
	                controller: HOYourHomeCtrl
	            },
	
	            hoConstruction: {
	                parent: wizardParentState,
	                template: HOConstructionView,
	                controller: HOConstructionCtrl
	            },
	            hoRating: {
	                parent: wizardParentState,
	                template: HORatingView,
	                controller: HORatingCtrl
	            }
	            /*hoPolicyInfo: {
	                parent: wizardParentState,
	                template: HOPolicyInfoView,
	                controller: HOPolicyInfoCtrl
	            },*/
	            /*nextSteps: {
	                name: 'nextSteps',
	                parent: parentState,
	                template: NextStepsView,
	                controller: NextStepsCtrl
	            }*/
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(355)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, $state, $rootScope, $q, $filter, $anchorScroll, ModalService, submissionViewModel, AgeAllowedForHO, AvailabilityService, StateUtils, LocaleService, InputValidationService) {
	
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	            $anchorScroll();
	            $scope.isPeriodStartDateValid = true;
	            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	            $scope.minDob = "01-01-1800";
	            $scope.isMinDateOfBirthValid = true;
	            $scope.isNameValid = true; //ENHC0013007 -- Insurance Premium Refunds --Arpita
	            //DFCT0020397 - QnB Date Of Birth Validation ends
	
	            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
	            var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(accountHolder) {
	                if (accountHolder.firstName === '0streamlinedquote0') {
	                    accountHolder.firstName = undefined;
	                    accountHolder.lastName = undefined;
	                    accountHolder.dateOfBirth = undefined;
	                }
	            };
	            var submissionVM = submissionViewModel();
	
	            $scope.submissionVM = submissionVM;
	
	            //Added for Cancel button on Personal Information
	            //screen of Personal Auto - 10011- GW-QB-Quote-My information_AUTO
	            $scope.goToCancel = function (form) {
	                if ($scope.cancel) {
	                    $scope.cancel(function (_model, args) {
	                        return flowModel.cancel(_model, args);
	                    }, form);
	                } else {
	                    flowModel.cancel(model);
	                }
	            };
	            var today = new Date();
	
	            $scope.accountHolder = $scope.submissionVM.draftData.accountHolder.value;
	
	            //Added for the defect DE1321
	            $scope.accountCellNumber = $scope.accountHolder.cellNumber;
	            $scope.accountWorkNumber = $scope.accountHolder.workNumber;
	            $scope.accountHomeNumber = $scope.accountHolder.homeNumber;
	            //ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024
	            // Not display occupation typecodes from this list
	            $scope.occupationFilterCodes = ["studentawaymorethan100mi"];
	
	            //Added for defect DE823
	            if ($scope.accountHolder.primaryPhoneType == "mobile") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.cellNumber;
	            } else if ($scope.accountHolder.primaryPhoneType == "home") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.homeNumber;
	            } else if ($scope.accountHolder.primaryPhoneType == "work") {
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHolder.workNumber;
	            }
	            // DFCT0021660-phone no display issue
	            if ($scope.submissionVM.draftData.accountHolder.value.cellNumber && $scope.submissionVM.draftData.accountHolder.value.cellNumber.length > 10) {
	                $scope.submissionVM.draftData.accountHolder.value.cellNumber = $scope.submissionVM.draftData.accountHolder.value.cellNumber.slice($scope.submissionVM.draftData.accountHolder.value.cellNumber.length - 10);
	            } //ended
	            /*$scope.accountHolder.primaryPhoneType = null;*/
	            $scope.submissionVM.draftData.accountHolder.value.ageLimit = 18;
	            submissionVM.draftData.policyAddress.addressType.value = submissionVM.draftData.policyAddress.addressType.value || 'home';
	
	            // adding function to update period start date --Arpita Sengupta
	            $scope.submissionVM.draftData.periodStartDate.value = $scope.submissionVM.draftData.periodStartDate.value ? $scope.submissionVM.draftData.periodStartDate.value : today;
	            var startDt = new Date($scope.submissionVM.draftData.periodStartDate.value);
	            var effectiveDtManipulation = function effectiveDtManipulation(addedDt) {
	                var defaultEffDt = Date.UTC(addedDt.getUTCFullYear(), addedDt.getUTCMonth(), addedDt.getUTCDate(), addedDt.getUTCHours(), addedDt.getUTCMinutes(), addedDt.getUTCSeconds());
	                console.log('new changes', new Date(defaultEffDt));
	                $scope.submissionVM.draftData.periodStartDate.value = new Date(defaultEffDt);
	            };
	            if (!$scope.submissionVM.quoteID.value) {
	                startDt.setDate(startDt.getDate() + 10);
	                effectiveDtManipulation(startDt);
	            }
	            //for quote retrieval
	            if ($scope.submissionVM.quoteID.value && new Date(startDt).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
	                var formtdt = new Date(today.toISOString());
	                formtdt.setDate(formtdt.getDate() + 10);
	                effectiveDtManipulation(formtdt);
	            }
	            //ended
	
	            $scope.entryDate = $scope.submissionVM.draftData.periodStartDate.value;
	            $scope.today = new Date();
	            $scope.today.setHours(0, 0, 0, 0);
	
	            $scope.coverageStartDt = today.setHours(720);
	            /*current date from the Calendar fix by devendra start*/
	            if (new Date().getTimezoneOffset() > 0) {
	                $scope.today.setHours(-1);
	            }
	            /*current date from the Calendar fix by devendra end*/
	            var currentDate = new Date();
	
	            $scope.maxDateOfBirth = {
	                year: currentDate.getFullYear() - AgeAllowedForHO,
	                month: currentDate.getMonth(),
	                day: currentDate.getDate()
	            };
	
	            // CHG0031104 - Set QnB Source, Credit Union Member Flag and Credit Union Join year
	            // AB - 05/14/2018
	
	            // CHG0057320 - Add SEA & YOMTOB Inc. for QnB Links
	            // AB - 11/23/2020
	
	            if ($rootScope.Arg1 == null) {
	                var arg1 = $rootScope.Arg1;
	            } else {
	                var arg1 = $rootScope.Arg1.toUpperCase();
	            }
	
	            switch (arg1) {
	                case "GORMISH":
	                case "SEA":
	                case "YOMTOB":
	                case "SECU":
	                case "BWE":
	                case "SCOTT":
	                case "MERRILL":
	                case "CROWFIELD":
	                case "RICKARD":
	                case "NIXON":
	                case "BLUE":
	                case "GRAY":
	                case "JONES":
	                case "MCCARTHY":
	                case "ASSOCIATES":
	                case "ANTHONY":
	                case "SIMMONS":
	                case "WILLIAMS":
	                case "MORRISON":
	                case "CRUMEL":
	                case "YOU":
	                case "MILLER":
	                case "PERSINSKI":
	                case "FLOURNOY":
	                    $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase();
	                    //                  $scope.submissionVM.draftData.accountHolder.qnbSource = "SECU";
	                    //                  $scope.submissionVM.draftData.accountHolder.isCreditUnionMember = true
	                    //                  $scope.submissionVM.draftData.accountHolder.joinedYearCreditUnionMembership = (new Date()).getFullYear()
	                    break;
	                default:
	                    $scope.submissionVM.draftData.accountHolder.qnbSource = null;
	                //                  $scope.submissionVM.draftData.accountHolder.qnbSource = $rootScope.Arg1.toUpperCase();
	            }
	
	            // Check for the valid account holder details
	            var isValidAccount = $scope.accountHolder["emailAddress1"] ? true : false;
	            if (!isValidAccount) {
	
	                var accountDetails = angular.copy($rootScope.accountDetails);
	                var accountHolder = accountDetails.accountHolder;
	                var accountHolderAddress = accountDetails.accountHolderAddress;
	                // check account exists
	                if (accountHolder.accountExists) {
	
	                    // Fill Account Details
	                    $scope.accountHolder.publicID = accountHolder.publicID;
	                    $scope.accountHolder.accountNumber = accountHolder.accountNumber;
	                    $scope.accountHolder.displayName = accountHolder.displayName;
	                    $scope.accountHolder.accountExists = accountHolder.accountExists;
	                    $scope.accountHolder.firstName = accountHolder.firstName;
	                    $scope.accountHolder.lastName = accountHolder.lastName;
	                    $scope.accountHolder.emailAddress1 = accountHolder.emailAddress1;
	                    $scope.accountHolder.emailExist = true;
	                    var dateOfBirth = accountHolder.dateOfBirth;
	                    var day = parseInt($filter('date')(dateOfBirth, "dd"));
	                    var month = parseInt($filter('date')(dateOfBirth, "MM")) - 1;
	                    var year = parseInt($filter('date')(dateOfBirth, "yyyy"));
	                    //console.log("DateOfBirth: ", day, month, year);
	                    $scope.accountHolder.dateOfBirth = {
	                        day: day,
	                        month: month,
	                        year: year
	                    };
	                    //console.log("DateOfBirth: ", $scope.accountHolder.dateOfBirth);
	                    $scope.accountHolder.workNumber = accountHolder.workNumber;
	                    $scope.accountHolder.homeNumber = accountHolder.homeNumber;
	                    $scope.accountHolder.cellNumber = accountHolder.cellNumber;
	                    $scope.accountHolder.middleName = accountHolder.middleName;
	                    $scope.accountHolder.suffix = accountHolder.suffix;
	
	                    // Fill Policy Address
	                    $scope.submissionVM.draftData.policyAddress.addressLine1 = accountHolderAddress.addressLine1;
	                    $scope.submissionVM.draftData.policyAddress.addressLine2 = accountHolderAddress.addressLine2;
	                    $scope.submissionVM.draftData.policyAddress.addressLine3 = accountHolderAddress.addressLine3;
	                    $scope.submissionVM.draftData.policyAddress.state = accountHolderAddress.state;
	                    $scope.submissionVM.draftData.policyAddress.city = accountHolderAddress.city;
	                } else {
	                    $scope.accountHolder.accountExists = accountHolder.accountExists;
	                }
	
	                // Remove accountDetails object from rootscope
	                $rootScope.accountDetails = {
	                    accountHolder: {
	                        accountExists: false
	                    }
	                };
	            }
	
	            //console.log("Printing inside Contact details",$scope.questionSets)
	        };
	
	        //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	        ctrl.checkDate = function () {
	            if ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && $scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800") {
	                $scope.isMinDateOfBirthValid = false;
	                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = '';
	            } else {
	                $scope.isMinDateOfBirthValid = true;
	            }
	        };
	        //DFCT0020397 - QnB Date Of Birth Validation ends
	
	        /*ctrl.showDisclosure = () => {
	        var toShow = "<div class='yourInfo-static'><div class='yourInfo-static-message'><h4>Information disclosure</h4><p>{{'quoteandbind.ho.views.contact-details.informationdisclosure.static'|translate}}</p></div></div>";
	                ModalService.showSimpleDialog(toShow)
	        };*/
	        function validateInputs(inputsToValidate, scopeVar) {
	            var inputValidationData = [];
	            inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	            if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                for (var i = 0; i < inputValidationData[1].length; i++) {
	                    scopeVar[inputValidationData[1][i]] = '';
	                    $scope.isNameValid = false;
	                }
	            } else {
	                $scope.isNameValid = true;
	            }
	        }
	        ctrl.displayDisclaimer = function (form) {
	
	            // Changes for incident INC0019053 begins
	
	            var currentDateForBackDate = new Date();
	            var diffOfDaysForBackDate = moment(currentDateForBackDate).startOf('day').diff(moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day'), 'days');
	            var submissionVM = submissionViewModel();
	            //ENHC0013007 -- Insurance Premium Refunds --Arpita
	            var inputsToValidate = [{ 'firstName': $scope.submissionVM.draftData.accountHolder.firstName.value }, { 'middleName': $scope.submissionVM.draftData.accountHolder.middleName.value }, { 'lastName': $scope.submissionVM.draftData.accountHolder.lastName.value }];
	            var primaryAddInput = [{ 'addressLine1': $scope.submissionVM.draftData.policyAddress.addressLine1.value }, { 'addressLine2': $scope.submissionVM.draftData.policyAddress.addressLine2.value }, { 'city': $scope.submissionVM.draftData.policyAddress.city.value }];
	            validateInputs(inputsToValidate, $scope.submissionVM.draftData.accountHolder.value);
	            if (!$scope.isNameValid) {
	                return;
	            }
	            validateInputs(primaryAddInput, $scope.submissionVM.draftData.policyAddress.value);
	            if (!$scope.isNameValid) {
	                return;
	            }
	            //ended
	            // Period Start Date should not be back date
	            if (diffOfDaysForBackDate >= 1) {
	                $scope.isPeriodStartDateValid = false;
	                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	
	            var diffOfDaysForFutureDate = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(currentDateForBackDate).startOf('day'), 'days');
	            if (diffOfDaysForFutureDate > 30) {
	                submissionVM.draftData.lobs.value = {};
	                $scope.isPeriodStartDateValid = false;
	                //$state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	
	            var policyEnqDate = new Date($scope.entryDate);
	            var diffOfDays = moment($scope.submissionVM.draftData.periodStartDate.value).startOf('day').diff(moment(policyEnqDate).startOf('day'), 'days');
	
	            // Period Start Date should not be more than 30 days from date of quotation
	            if (diffOfDays > 30) {
	                $scope.isPeriodStartDateValid = false;
	                // $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
	                return;
	            }
	            // Changes for incident INC0019053 ends
	            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
	            if ($scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year && $scope.submissionVM.draftData.accountHolder.dateOfBirth.value.year < "1800") {
	                $scope.isMinDateOfBirthValid = false;
	                $scope.submissionVM.draftData.accountHolder.dateOfBirth.value = '';
	                return;
	            }
	            //DFCT0020397 - QnB Date Of Birth Validation ends
	
	
	            var title = "Information Disclosure";
	            var message = "I understand that as part of the underwriting process, in most states you will order an insurance score based upon credit history which may be used to rate my policy. Consumer reports that contain information about driving and claims history are also obtained. I further understand that I have the right to be told the name and address of the reporting agencies providing these reports and to see and correct my personal information." + "If you receive corrected information from a consumer reporting agency, you will re-evaluate the information. I understand that you may disclose this information to conduct your business and that I have a right to obtain a copy of the the company's privacy policy. By clicking next I've confirmed that I've read the information disclosure and would like to proceed with my quote.";
	            var continueModel = ModalService.showDisclaimer(title, message);
	            continueModel.result.then(function () {
	                ctrl.setNextState(form);
	            }, function () {});
	        };
	        ctrl.next = function (form) {
	            //console.log("Printing inside Contact details1111", $scope.questionSets)
	            $scope.submissionVM.draftData.accountHolder.value.emailExist = true;
	            form.submitted = true;
	            if ($scope.submissionVM.draftData.accountHolder.value.emailAddress1 == undefined || $scope.submissionVM.draftData.accountHolder.value.emailAddress1 == '') {
	                return false;
	            }
	            flowModel.next(submissionVM);
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	        ctrl.setNextState = function (form) {
	            if (!$scope.accountHolder.accountExists) {
	                //ENHC0011876- changed from home to mobile
	                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = "mobile";
	            } else {
	                //Added for the defect DE1321
	                $scope.submissionVM.draftData.accountHolder.value.primaryPhoneType = $scope.accountHolder.primaryPhoneType;
	                $scope.submissionVM.draftData.accountHolder.cellNumber = $scope.accountCellNumber;
	                $scope.submissionVM.draftData.accountHolder.homeNumber = $scope.accountHomeNumber;
	                $scope.submissionVM.draftData.accountHolder.workNumber = $scope.accountWorkNumber;
	            }
	            //console.log("inside HO next State: ",$scope.submissionVM.draftData)
	            //console.log("Printing inside Contact details222", $scope.questionSets)
	            //This is hardcoded to Oregon
	            //$scope.submissionVM.draftData.policyAddress.county = "OR";
	            //console.log("Scope Address", $scope.address)
	            //console.log("Print Form ", form)
	            // console.log("Print Form valid", form.valid)
	            form.submitted = true;
	
	            if (!form.valid) {
	                //console.log("Invalid form inside HO next State")    
	                return;
	            } else {
	                // $scope.saveQuote();
	                ctrl.next(form);
	            }
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$state', '$rootScope', '$q', '$filter', '$anchorScroll', 'ModalService', 'submissionViewModel', 'AgeAllowedForHO', 'AvailabilityService', 'StateUtils', 'LocaleService', 'qnb.InputValidationService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 761 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-ho-contact-details\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.contact-details.Your Information' | translate }}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <!-- ENHC0013007 -- Insurance Premium Refunds --Arpita -->\n        <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\n            <div  class=\"custom-error\">\n                {{'quoteandbind.views.Name OR Address Value May Not Be Formatted Correctly' | translate}}\n            </div>\n        </div>\n        <!-- ended -->\n        <div>\n            <div>\n                <div gw-pl-name-details contact=\"submissionVM.draftData.accountHolder\" readonly=\"false\"\n                        ></div>\n            </div>\n\n            <div>\n                <div gw-pl-ctrl-group model=\"submissionVM.draftData.accountHolder.dateOfBirth\"\n                     label=\"{{'quoteandbind.views.contact-details.Date of Birth' | translate}}\">\n                     <!-- DFCT0020397 - QnB Date Of Birth Validation - added min date,method on blur and keyup -Arpita -->\n                    <span gw-pl-local-date-chooser\n                          model=\"submissionVM.draftData.accountHolder.dateOfBirth.value\"\n                          max-date=\"maxDateOfBirth\" initial-date=\"maxDateOfBirth\" min-date=\"minDob\" ng-keyup=\"checkDate()\"></span>\n                </div>\n                <div  class=\"custom-error\" ng-show=\"!isMinDateOfBirthValid\">\n                    {{'quoteandbind.views.contact-details.Date of Birth must be no earlier than 01/01/1800' | translate}}\n                </div>\n            </div>\n            <!--ENHC0012832 - North Carolina Property Rate Review effective 02/01/2024 -->\n            <gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.occupation\"\n                      filter-codes=\"occupationFilterCodes\"\n                      label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Occupation' | translate }}\"\n                      placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Occupation--' | translate }}\">\n            </gw-pl-input-ctrl>\n            <div gw-pl-ctrl-group\n                model=\"submissionVM.draftData.accountHolder.payGrade\"\n                ng-show=\"submissionVM.draftData.accountHolder.occupation.value.code == 'military'\"\n                label=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.Whats your pay grade?' | translate}}\">\n                <select gw-pl-select=\"submissionVM.draftData.accountHolder.payGrade.value\" options=\"submissionVM.draftData.accountHolder.payGrade.aspects.availableValues\"\n                        render-by=\"'name'\"\n                        placeholder=\"{{'quoteandbind.pa.directives.templates.pa-edit-driver.--Choose Pay Grade--' | translate}}\"></select>\n            </div>\n\n            <div class=\"gw-select-home-label\">\n                {{'quoteandbind.ho.views.contact-details.Enter address for the home that you wish to insure.' | translate}}\n            </div>\n            <!--    <gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.emailAddress1\"\n                <div gw-pl-address-details address=\"submissionVM.draftData.policyAddress\"\n                 disable-state=\"quoteandbind.autocompletions.account.address.state\"\n                 disable-city=\"quoteandbind.autocompletions.account.address.city\"\n                 disable-zip-code=\"quoteandbind.autocompletions.account.address.zip\"\n                 display-country=\"false\"></div> -->\n            <!-- ENHC0011876 - changed the model and ng-model from homeNumber to cellNumber-->\n            <div gw-pl-standard-address address=\"submissionVM.draftData.policyAddress\"></div>\n            <div gw-pl-ctrl-group model=\"submissionVM.draftData.accountHolder.cellNumber\"\n                 label=\"{{'quoteandbind.views.contact-details.Telephone Number'|translate}}\">\n                <input type=\"text\"\n                       ng-model=\"submissionVM.draftData.accountHolder.cellNumber.value\"\n                       gw-pl-ui-mask=\"{{phoneMask}}\"\n                       leave-value-masked/>\n            </div>\n            <!--<gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.workNumber\" label=\"{{'quoteandbind.views.contact-details.Telephone Number'| translate }}\" ng-attr-maxlength=\"10\"></gw-pl-input-ctrl>-->\n            <gw-pl-input-ctrl model=\"submissionVM.draftData.accountHolder.emailAddress1\"  ng-attr-maxlength=\"50\" label=\"{{'quoteandbind.views.contact-details.Email Address' | translate }}\"></gw-pl-input-ctrl>\n            <span class=\"custom-error\" ng-show=\"form.submitted && submissionVM.draftData.accountHolder.emailExist.value === undefined\" >{{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}</span>\n        </div>\n\n        <!-- Add static text for DNC waiver consent, AB 09/29/2022 -->\n        <div class=\"yourInfo-static\">\n            <p>\n                {{'quoteandbind.views.contact-details.DNC Waiver Consent'|translate}}\n            </p>\n        </div>\n        \n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.views.contact-details.For Your Quote' | translate }}</h2>\n\n        <div>\n            <div gw-pl-ctrl-group model=\"submissionVM.draftData.periodStartDate\"\n                 label=\"{{'quoteandbind.views.contact-details.I\\'d like my coverage to start on' | translate }}\">\n                 <span ng-datepicker\n                      default-date=\"today\"\n                      min-view=\"day\"\n                      max-date=\"coverageStartDt\"\n                      input-id=\"PeriodStartDate\"\n                      name=\"PeriodStartDate\"\n                      min-date=\"today\"\n                      ng-model=\"submissionVM.draftData.periodStartDate.value\"></span>\n            </div>\n            <div  class=\"custom-error\" ng-show=\"!isPeriodStartDateValid\">\n                {{'quoteandbind.views.policy-date.Policy Effective date should be today or up to 30 days in the future.'|translate}}\n            </div>\n        </div>\n        <div class=\"yourInfo-static\" >\n            <div class=\"yourInfo-static-message\">\n                <!--<h4>{{'quoteandbind.ho.views.contact-details.disclaimer.heading'|translate}}</h4>-->\n                <p>\n                    {{'quoteandbind.ho.views.contact-details.disclaimer.static'|translate}}\n                </p>\n                <p></p>\n                <p>\n                    {{'quoteandbind.ho.views.contact-details.disclaimer.static.TCPA'|translate}}\n                </p>\n            </div>\n        </div>\n\n        <div class=\"gw-page-buttons\">\n            <button class=\"gw-btn\" ng-click=\"goToCancel(form)\">{{'platform.widgets.wizard.Cancel'| translate }}</button>\n            <button class=\"gw-btn-primary\" ng-disabled=\"gwPlWizard.requestInFlight\"\n                    ng-click=\"displayDisclaimer(form)\">{{'platform.widgets.wizard.Next'| translate }}\n            </button>\n\n        </div>\n\n        <!--    <div gw-wizard-page-actions next=\"next\"></div> -->\n\n    </ng-form>\n</div>\n"

/***/ },
/* 762 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <ng-form class=\"ng-class:{ 'submitted': addinfoform.submitted }\" novalidate name=\"form\">\r\n\r\n        <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.ho.wizard.step.Additional Information'| translate }}</h2>\r\n\r\n        <div gw-pl-binary-choice-group\r\n             label=\"{{'quoteandbind.ho.views.addinfo.Do you rent or own?'| translate }}\"\r\n             model=\"view.homeType\"\r\n\r\n             title-left=\"{{'quoteandbind.ho.views.addinfo.Rent'| translate }}\"\r\n             title-right=\"{{'quoteandbind.ho.views.addinfo.Own'| translate }}\"\r\n             value-left=\"500\"\r\n             value-right=\"1500\" ng-click=\"homeTypeClick()\">\r\n\r\n        </div>\r\n\r\n        <div ng-show=\"view.homeType.value === 1500 \">\r\n            <gw-pl-input-ctrl model=\"view.residenceType\" filter-codes=\"residenceTypeIgnoreList\" label=\"{{'quoteandbind.ho.views.addinfo.Type of Residence' | translate }}\" placeholder=\"{{'quoteandbind.ho.views.addinfo.residencetype.select' | translate }}\"></gw-pl-input-ctrl>\r\n\r\n            <gw-pl-input-ctrl model=\"view.bestDescribeHome\"  label=\"{{'quoteandbind.ho.views.addinfo.What best describes your home?' | translate }}\" placeholder=\"{{'quoteandbind.ho.views.addinfo.bestdescribehome.select' | translate }}\"></gw-pl-input-ctrl>\r\n        </div>\r\n\r\n        <!--<div class=\"gw-control-group\" ng-show=\"view.bestDescribeHome.value.code === 'sec' || view.bestDescribeHome.value.code === 'seas'\">\r\n            <label class=\"gw-control-label\">{{'quoteandbind.ho.views.addinfo.How many months out of the year do you occupy the home?' | translate}}</label>\r\n            <div class=\"gw-controls\">\r\n                <input type=\"text\"\r\n                       onkeypress='return (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || ( event.charCode >= 48 && event.charCode <= 57))'\r\n                       ng-model=\"view.homeOccupationInMonths.value\"\r\n                       name=\"months\"\r\n                       maxlength=\"2\"\r\n                       ng-required=\"view.bestDescribeHome.value.code === 'sec' || view.bestDescribeHome.value.code === 'seas' \"\r\n                />\r\n                <div  class=\"custom-error\" ng-show=\"form.submitted && form.months.$error.required\">\r\n                    {{'displaykey.Edge.Web.Api.Model.NotNull'|translate}}\r\n                </div>\r\n\r\n            </div>\r\n        </div>-->\r\n        <gw-pl-input-ctrl  ng-show=\"view.bestDescribeHome.value.code === 'nonown'\" model=\"view.homeOccupationInMonths\"  label=\"{{'quoteandbind.ho.views.addinfo.How many months out of the year do you occupy the home?' | translate }}\" maxlength=\"2\"></gw-pl-input-ctrl>\r\n\r\n        <div gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.ho.views.addinfo.Any additional occupants living in your home?' | translate }}\"\r\n             model=\"view.additionalOccupants\" name=\"AdditionalOccupants\" help-tip=\"{{'quoteandbind.views.additionalinfo.additionaloccupants.Tooltip' | translate }}\">\r\n        </div>\r\n\r\n\r\n<!--        <div gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.ho.views.addinfo.Do you have any pets?' | translate }}\"\r\n             model=\"view.anyPets\" name=\"AnyPets\">\r\n        </div>-->\r\n\r\n        <div>\r\n            <div gw-pl-yes-no-group\r\n                 label=\"{{'quoteandbind.ho.views.addinfo.Any losses in past 3 years?' | translate }}\"\r\n                 model=\"view.past3YearLoss\" name=\"past3YearLoss\" help-tip=\"{{'quoteandbind.views.additionalinfo.past3YrLoss.Tooltip' | translate }}\">\r\n\r\n            </div>\r\n\r\n        </div>\r\n        <div gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.ho.views.addinfo.Do you conduct any business with walk in traffic in your home?' | translate }}\"\r\n             model=\"view.bussWalkInTraffic\" name=\"BussWalkInTraffic\" help-tip=\"{{'quoteandbind.views.additionalinfo.busswalkintraffic.Tooltip' | translate }}\">\r\n\r\n        </div>\r\n\r\n        <div gw-pl-yes-no-group\r\n             label=\"{{'quoteandbind.ho.views.addinfo. bankruptcy info' | translate }}\"\r\n             model=\"view.bankruptcyInfo\" name=\"BankruptcyInfo\">\r\n        </div>\r\n\r\n        <!--CHG0034024-ISO PPC Trigger Changes-->\r\n<!--Adding Distance to Fire Hydrant and Distance to Fire Station field as per ISO PPC Changes -->\r\n\r\n<!--Distance of fire Hydrant-->\r\n        <div>\r\n            <div gw-pl-binary-choice-group\r\n                 label=\"{{'quoteandbind.ho.views.ho-your-home.Distance to Fire Hydrant' | translate }}\"\r\n                 model=\"view.distanceToFireHydrant\"\r\n                 title-left=\"{{'quoteandbind.ho.views.ho-your-home.Within 1000ft' | translate }}\"\r\n                 title-right=\"{{'quoteandbind.ho.views.ho-your-home.Over 1000ft' | translate }}\"\r\n                 value-left=\"500\"\r\n                 value-right=\"1500\">\r\n            </div>\r\n\r\n<!--Distance of fire Station-->\r\n\r\n            <div ng-if=\"protectionClass == false \" gw-pl-binary-choice-group\r\n                 label=\"{{'quoteandbind.ho.views.ho-your-home.Distance to Fire Station' | translate }}\"\r\n                 model=\"view.distanceToFireStation\"\r\n                 title-left=\"{{'quoteandbind.ho.views.ho-your-home.Within 5 Miles' | translate }}\"\r\n                 title-right=\"{{'quoteandbind.ho.views.ho-your-home.Over 5 Miles' | translate }}\"\r\n                 value-left=\"3\"\r\n                 value-right=\"10\">\r\n            </div>  \r\n        </div>\r\n\r\n        <!--<div gw-wizard-page-actions next=\"next\"></div>-->\r\n\r\n        <div class=\"gw-page-buttons\">\r\n            <button class=\"gw-btn\" type=\"button\"\r\n                    ng-click=\"cancel()\">{{'platform.widgets.wizard.Cancel'|translate}}\r\n            </button>\r\n            <button class=\"gw-btn-primary\" next-button\r\n                    ng-click=\"next(form)\" ng-disabled=\"view.bankruptcyInfo.value\">{{'platform.widgets.wizard.Next' | translate}}\r\n            </button>\r\n        </div>\r\n    </ng-form>\r\n</div>\r\n"

/***/ },
/* 763 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-ho-contact-details\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.ho.views.ho-your-home.Your Home' | translate }}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" name=\"form\">\n        \n        <div ng-show=\"view.purchaseYearRequired.value\">\n            <div gw-pl-ctrl-group\n                 model=\"view.purchaseYear\"\n                 label=\"{{'quoteandbind.ho.views.ho-your-home.What year did you purchase your home?' | translate }}\">\n                <input ng-model=\"view.purchaseYear.value\" type=\"text\" maxlength=\"4\" />\n            </div>\n        </div>\n\n\n             \n        <div ng-show=\"showEstimateHome\">\n            <div gw-pl-ctrl-group\n                 model=\"view.replacementCost\"\n                 label=\"{{'quoteandbind.ho.views.ho-your-home.Estimated value of Your Home' | translate }}\">\n                <input ng-model=\"view.replacementCost.value\" type=\"text\" gw-qnb-money maxlength=\"50\" />\n            </div>\n        </div>\n        <div ng-show=\"showEstimateContent\">\n            <!--DE1508 fixed-->\n            <div gw-pl-ctrl-group\n                 model=\"view.contentReplacementCost\"\n                 label=\"{{'quoteandbind.ho.views.ho-your-home.Estimated value of your contents' | translate }}\">\n                <input ng-model=\"view.contentReplacementCost.value\" type=\"text\" gw-qnb-money maxlength=\"50\" />\n            </div>\n        </div>  \n        \n        <!--Removing 2 fields CHG0034024-ISO PPC Trigger Changes -->\n        <div gw-wizard-page-actions next=\"next\"></div>\n    </ng-form>\n</div>\n"

/***/ },
/* 764 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-ho-construction\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.ho.views.construction.Construction' | translate}}</h2>\n    <form novalidate name=\"form\">\n        <gw-pl-accordion close-others=\"status.oneAtATime\">\n            <!--------- DETAILS START --------->\n            <ng-form novalidate name=\"detailsForm\">\n                <gw-pl-accordion-group\n                        validation-form=\"detailsForm\"\n                        ng-init=\"status.detailsOpen=true\"\n                        is-open=\"status.detailsOpen\">\n                    <!--- HEADING START --->\n                    <gw-pl-accordion-heading>\n                        <h3 class=\"gw-accordion-title\">\n                            {{'quoteandbind.ho.views.construction.Construction Details' | translate }}\n                        </h3>\n                    </gw-pl-accordion-heading>\n                    <!--- HEADING END --->\n                    <!--- CONTENT START --->\n                    <gw-pl-input-ctrl model=\"view.yearBuilt\" \n                                      maxlength=\"4\" \n                                      label=\"{{'quoteandbind.ho.views.construction.Year Build' | translate }}\"></gw-pl-input-ctrl>\n                    <gw-pl-input-ctrl model=\"view.storiesNumber\"\n                                      label=\"{{'quoteandbind.ho.views.construction.Number of Stories' | translate }}\"\n                                      placeholder=\"{{'quoteandbind.ho.views.construction.Please Select' | translate}}\"></gw-pl-input-ctrl>\n                   \n                    <div gw-ho-select-with-other\n                         label=\"{{'quoteandbind.ho.views.construction.Construction Type' | translate }}\"\n                         model=\"view.constructionType\" other-model=\"view.constructionTypeDescription\" \n                         filter-codes=\"constructionIgnoreList\">\n                    </div>\n                   \n                    <!--- CONTENT END --->\n                </gw-pl-accordion-group>\n            </ng-form>\n            <!--------- DETAILS END --------->\n            <!--------- ROOF START --------->\n            <ng-form novalidate name=\"roofsForm\">\n                <gw-pl-accordion-group\n                        validation-form=\"roofsForm\"\n                        is-open=\"true\">\n                    <!--- HEADING START --->\n                    <gw-pl-accordion-heading>\n                        <h3 class=\"gw-accordion-title\">\n                            {{'quoteandbind.ho.views.construction.Roof' | translate }}\n                        </h3>\n                    </gw-pl-accordion-heading>\n                    <!--- HEADING END --->\n                    <!--- CONTENT START --->\n                    <div gw-ho-roof-type-select model=\"view.roofType\" \n                         other-model=\"view.roofTypeDescription\" \n                         filter-codes=\"roofIgnoreList\"></div>\n                    <!-- UPGRADED START -->\n                    <!--<div gw-ho-upgrade\n                         label=\"{{'quoteandbind.ho.views.construction.Roofing Upgraded' | translate}}\"\n                         upgrade-label=\"{{'quoteandbind.ho.views.construction.Enter the year' | translate}}\"\n                         show-upgrade-label = \"true\"\n                         upgrade-exists=\"view.roofUpgradeExists\"\n                         upgrade-year=\"view.roofUpgradeYear\"></div>-->                  \n                    <!-- UPGRADED END -->\n                    <div gw-pl-yes-no-group\n                         label=\"{{'quoteandbind.ho.views.construction.Do you have a flat roof?' | translate }}\"\n                         model=\"view.isFlatRoof\" name=\"RoofFlat\">\n                    </div>\n                    <!--- CONTENT END --->\n                    <div gw-pl-yes-no-group\n                         label=\"{{'quoteandbind.ho.views.construction.Roofing Upgraded' | translate }}\"\n                         model=\"view.roofUpgradeExists\" name=\"RoofUpgradeExists\">\n                    </div>\n                    <div gw-pl-input-ctrl \n                         ng-if=\"roofUpgradeExists(view.roofUpgradeExists.value)\" \n                         model=\"view.roofUpgradeYear\"\n                         maxlength=\"4\"\n                         label=\"{{'quoteandbind.ho.views.construction.Enter the year' | translate}}\"\n                         placeholder=\"{{'quoteandbind.ho.views.construction.Enter the year' | translate }}\">\n                    </div>                   \n                    <!--- CONTENT END --->\n                </gw-pl-accordion-group>\n            </ng-form>\n            <!--------- ROOF END --------->\n            <!--------- HEATING START --------->\n            <ng-form novalidate name=\"heatingForm\">\n                <gw-pl-accordion-group\n                        validation-form=\"heatingForm\"\n                        ng-init=\"status.heatingOpen=true\"\n                        is-open=\"status.heatingOpen\">\n                    <!--- HEADING START --->\n                    <gw-pl-accordion-heading>\n                        <h3 class=\"gw-accordion-title\">\n                            {{'quoteandbind.ho.views.construction.Heating' | translate }}\n                        </h3>\n                    </gw-pl-accordion-heading>\n                    <!--- HEADING END --->\n                    <!--- CONTENT START --->\n                    <div gw-ho-select-with-other\n                         label=\"{{'quoteandbind.ho.views.construction.Primary Heating' | translate }}\"\n                         model=\"view.primaryHeatingType\" other-model=\"view.primaryHeatingTypeDescription\">\n                    </div>\n                    <div gw-pl-yes-no-group\n                         label=\"{{'quoteandbind.ho.views.construction.Secondary Heating' | translate }}\"\n                         model=\"view.secondaryHeatingExists\"\n                         name=\"SecondaryHeatingExists\"></div>\n                    <!-- UPGRADED START -->\n                    <!--<div gw-ho-upgrade\n                         label=\"{{'quoteandbind.ho.views.construction.Heating Upgraded' | translate}}\"\n                         upgrade-exists=\"view.heatingUpgradeExists\"\n                         upgrade-year=\"view.heatingUpgradeYear\"></div>-->\n                    <!-- UPGRADED END -->\n                    <!--- CONTENT END --->\n                </gw-pl-accordion-group>\n            </ng-form>\n            <!--------- HEATING END --------->\n        </gw-pl-accordion>\n\n        <div gw-wizard-page-actions next=\"next\"></div>\n    </form>\n</div>\n"

/***/ },
/* 765 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-ho-rating\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.ho.views.rating.Tell Us More' | translate }}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" novalidate name=\"form\">\n        <h3 class=\"gw-section-inner-title\">{{'quoteandbind.ho.views.rating.Do you have' | translate }}</h3>\n\n        <div class=\"gw-mandatory-group\">\n            <div gw-pl-yes-no-group\n                 label=\"{{'quoteandbind.ho.views.rating.Fire Extinguishers in Your Home' | translate }}\"\n                 model=\"view.fireExtinguishers\">\n            </div>\n            <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.rating.Theft Alarm' | translate }}\"\n                 model=\"view.burglarAlarm\">\n                <div gw-pl-yes-no model=\"view.burglarAlarm\"></div>\n                <div gw-pl-inline-ctrl-group ng-if=\"view.burglarAlarm.value\" class=\"gw-other-section\"\n                     label=\"{{'quoteandbind.ho.views.rating.Theft alarm type' | translate}}\"\n                     model=\"view.burglarAlarmType\"\n                     help-tip=\"{{'quoteandbind.views.rating.theftAlarm.Tooltip' | translate }}\"\n                        >\n                    <div gw-ho-typelist-radios model=\"view.burglarAlarmType\"></div>\n                </div>\n            </div>\n            <div gw-pl-ctrl-group  label=\"{{'quoteandbind.ho.views.rating.Fire Alarm' | translate }}\" model=\"view.fireAlarm\">\n                <div gw-pl-yes-no model=\"view.fireAlarm\"></div>\n                <div gw-pl-inline-ctrl-group ng-if=\"view.fireAlarm.value\" class=\"other-section\"\n                     label=\"{{'quoteandbind.ho.views.rating.Fire alarm type' | translate}}\"\n                     model=\"view.fireAlarmType\"\n                     help-tip=\"{{'quoteandbind.views.rating.burglarAlarm.Tooltip' | translate }}\"\n                        >\n                    <div gw-ho-typelist-radios model=\"view.fireAlarmType\"></div>\n                </div>\n            </div>\n\n            <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.rating.24 Hour Security Guard' | translate }}\"\n                 help-tip=\"{{'quoteandbind.views.rating.Security.Tooltip' | translate }}\"\n                 model=\"view.securityGuard\">\n                <div class=\"gw-controls-radios\">\n                    <div gw-pl-yes-no model=\"view.securityGuard\"></div>\n                </div>\n            </div>\n\n            <div gw-pl-input-ctrl ng-if=\"view.securityGuard.value\" class=\"gw-other-section\"\n                 label=\"{{'quoteandbind.ho.views.rating.Access Type' | translate}}\"\n                 placeholder=\"{{'quoteandbind.ho.views.construction.Please Select' | translate}}\"\n                 model=\"view.accessType\">\n            </div>\n\n            <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.rating.Water Protection Device' | translate }}\"\n                 model=\"view.waterProtectionDevice\">\n                <div class=\"gw-controls-radios\">\n                    <div gw-pl-yes-no model=\"view.waterProtectionDevice\"></div>\n                </div>\n            </div>\n\n\n            <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.rating.Smoke Detector' | translate }}\"\n                 model=\"view.smokeAlarm\">\n                <div class=\"gw-controls-radios\">\n                    <div gw-pl-yes-no model=\"view.smokeAlarm\"></div>\n                </div>\n            </div>\n\n            <div gw-pl-yes-no-group\n                 label=\"{{'quoteandbind.ho.views.rating.Deadbolt Locks' | translate }}\"\n                 model=\"view.deadbolts\">\n            </div>\n            <div gw-pl-input-ctrl label=\"{{'quoteandbind.ho.views.rating.Interior Fire Sprinkler System' | translate }}\"\n                 model=\"view.sprinklerSystemType\"\n                 placeholder=\"{{'quoteandbind.ho.views.construction.Please Select' | translate}}\"\n                 help-tip=\"{{'quoteandbind.views.rating.Fir Sprinkler System.Tooltip' | translate }}\">\n            </div>\n        </div>\n\n        <div gw-pl-ctrl-group\n             label=\"{{'quoteandbind.ho.views.rating.Fireplace or Wood Stove' | translate }}\"\n             model=\"view.fireplaceOrWoodStoveExists\">\n            <div gw-pl-yes-no model=\"view.fireplaceOrWoodStoveExists\"></div>\n        </div>\n        <div gw-pl-ctrl-group model=\"view.swimmingPoolExists\"\n             label=\"{{'quoteandbind.ho.views.rating.Swimming Pool' | translate }}\"\n             model=\"view.swimmingPoolExists\">\n            <div gw-pl-yes-no model=\"view.swimmingPoolExists\"></div>\n\n        </div>\n\n        <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.rating.Trampoline' | translate }}\"\n             model=\"view.trampolineExists\">\n            <div gw-pl-yes-no model=\"view.trampolineExists\"></div>\n\n        </div>\n\n\n        <div gw-wizard-page-actions next=\"next\"></div>\n    </ng-form>\n</div>"

/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <form class=\"ng-class:{ 'gw-submitted': policyInfoForm.submitted }\" novalidate name=\"policyInfoForm\">\n\n        <h1 class=\"gw-page-title\">{{'quoteandbind.ho.views.policy-info.Policy Info'|translate}}</h1>\n\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.ho.views.policy-info.Coverage Start Date'|translate}}</div>\n            <div class=\"gw-controls\">{{submissionVM.draftData.periodStartDate.value | date : medium}}</div>\n        </div>\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.ho.views.policy-info.Primary Insured'|translate}}</div>\n            <div class=\"gw-controls\">{{submissionVM.draftData.accountHolder.value.displayName}}</div>\n        </div>\n        <div class=\"gw-control-group\">\n            <div class=\"gw-control-label\">{{'quoteandbind.ho.views.policy-info.Address'|translate}}</div>\n            <div class=\"gw-controls\">\n                <div ng-repeat=\"addressLine in policyInfo.displayAddressArray track by $index\">{{addressLine.trim()}}</div>\n            </div>\n        </div>\n        <div gw-pl-yes-no-group model=\"policyInfo.billAndPolAddrsEqual\"\n             label=\"{{'quoteandbind.ho.views.policy-info.Is the Billing Address the same as the above address?'|translate}}\"></div>\n\n        <div class=\"ng-class:{ 'gw-submitted': policyInfoForm.submitted }\" novalidate>\n            <div>\n                <div ng-show=\"!policyInfo.billAndPolAddrsEqual.value\">\n                    <div gw-pl-address-details\n                         address=\"submissionVM.bindData.billingAddress\"\n                         disable-state=\"quoteandbind.autocompletions.account.address.state\"\n                         disable-city=\"quoteandbind.autocompletions.account.address.city\"\n                         display-country=\"false\">\n                    </div>\n                </div>\n                <div gw-pl-input-ctrl label=\"{{'quoteandbind.ho.views.policy-info.Email'|translate}}\"\n                     model=\"submissionVM.bindData.contactEmail\">\n                </div>\n                <div gw-pl-ctrl-group label=\"{{'quoteandbind.ho.views.policy-info.Phone'|translate}}\"\n                     model=\"submissionVM.bindData.contactPhone\">\n                    <input type=\"text\"\n                           ng-model=\"submissionVM.bindData.contactPhone.value\"\n                           gw-pl-ui-mask=\"{{phoneMask}}\"\n                           leave-value-masked/>\n                </div>\n            </div>\n        </div>\n        <h2 class=\"gw-page-section-title\">{{'quoteandbind.ho.views.policy-info.Your Coverages' | translate}}</h2>\n\n        <div gw-qnb-ho-view-coverages=\"chosenOffering.lobs.homeowners\"></div>\n\n        <div gw-wizard-page-actions></div>\n    </form>\n</div>\n"

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, StateUtils, submissionViewModel) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        ctrl.init = function () {
	            $scope.questionSets = submissionVM.draftData.lobs.homeowners.preQualQuestionSets.value;
	
	            for (var key in $scope.questionSets[0]["answers"]) {
	                //yearOfCons_aaa
	                if (key == "yearOfCons_aaa") {
	                    $scope.questionSets[0]["answers"][key] = "1900";
	                } else if (key == "DWOccupied_aaa") {
	                    $scope.questionSets[0]["answers"][key] = "owner_prim";
	                } else {
	                    $scope.questionSets[0]["answers"][key] = "false";
	                }
	            }
	
	            flowModel.next(submissionVM, true);
	        };
	
	        ctrl.next = function (flowNextFn, form) {
	
	            //prequal question requiredness not captured in the submission model, so pass form validity for isValid check
	            flowNextFn(submissionVM, form.valid);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 31-08-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(737)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, FormUtil) {
	    var fn = function fn($scope, $stateParams, $state, submissionViewModel, ModalService, $q, StateUtils) {
	        var ctrl = Object.create(BaseCtrl);
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	
	            // Residence Type List Filter Code
	            $scope.residenceTypeIgnoreList = ["Fam2", "Fam3", "Fam4", "Fam5", "Coop", "Quadplex_aaa", "Triplex_aaa", "Apt", "rowhouse_aaa"];
	
	            $scope.view = submissionVM.draftData.lobs.homeowners.additionalInfo;
	            $scope.view.value = $scope.view.value || {};
	            //HO4 means it is rented house
	            //HO6 and HO3 means own house selected
	            if ($scope.view.homeType.value === "HO4") {
	                $scope.view.homeType.value = 500;
	            } else if ($scope.view.homeType.value === "HO6" || $scope.view.homeType.value === "HO3") {
	                $scope.view.homeType.value = 1500;
	            }
	
	            $scope.view.homeOccupationInMonths.value = 0;
	            $scope.protectionClass = submissionVM.draftData.lobs.homeowners.protectionClass.value;
	        };
	
	        //This is to send default value to PC temporarily.
	        function setToDefault(model) {
	            if (!model.value) {
	                model.value = model.aspects.availableValues[0];
	            }
	        };
	
	        ctrl.homeTypeClick = function () {
	            if ($scope.view.homeType.value === 500) {
	                setToDefault($scope.view.residenceType);
	                $scope.view.value.bestDescribeHome = "owner";
	            } else if ($scope.view.homeType.value === 1500) {
	                $scope.view.value.residenceType = undefined;
	                $scope.view.value.bestDescribeHome = undefined;
	            }
	        };
	
	        ctrl.next = function (form) {
	            //$scope.view.homeType.value.$dirty &&
	            //console.log("inside additional info next");
	            //CHG0034024-ISO PPC Trigger Changes adding validation
	            if ($scope.protectionClass) {
	                $scope.view.distanceToFireStation = 3;
	            }
	            form.submitted = true;
	            if ($scope.view.homeType.value === 500) {
	                $scope.view.homeType.value = "HO4";
	            } else if ($scope.view.homeType.value === 1500) {
	                if ($scope.view.residenceType.value.code === "Condo") {
	                    $scope.view.homeType.value = "HO6";
	                } else {
	                    $scope.view.homeType.value = "HO3";
	                }
	            }
	
	            // Set form type value
	            $scope.view.formType.value = $scope.view.homeType.value;
	
	            // Test code
	
	            //$scope.view.homeOccupationInMonths.value = 1;
	
	            /* nextFn(submissionVM);*/
	
	            //This is used to hold the selected value of home type when there is an error in input
	            if (!submissionVM.draftData.lobs.homeowners.aspects.subtreeValid) {
	                if ($scope.view.homeType.value === "HO4") {
	                    $scope.view.homeType.value = 500;
	                } else if ($scope.view.homeType.value === "HO3" || $scope.view.homeType.value === "HO6") {
	                    $scope.view.homeType.value = 1500;
	                }
	            } else {
	                flowModel.next(submissionVM);
	            }
	        };
	
	        ctrl.cancel = function () {
	            flowModel.cancel(submissionVM);
	        };
	
	        ctrl.defineWatches = function () {
	            $scope.$watch('view.bankruptcyInfo.value', function () {
	                if ($scope.view.bankruptcyInfo.value) {
	                    /*var resp = const errorPromise = ModalService.showError(
	                         'quoteandbind.ho.views.addinfo.Attention',
	                         'quoteandbind.ho.views.addinfo.Bankruptcy Error Message'
	                     ).result;*/
	                    $state.go('contactUs');
	                }
	            });
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel', 'ModalService', '$q', 'StateUtils'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    /** Sets a typeke value to a first one. */
	    function setToDefault(model) {
	        if (!model.value) {
	            model.value = model.aspects.availableValues[0];
	        }
	    }
	
	    var fn = function fn($scope, submissionViewModel, ModalService) {
	        var submissionVm = submissionViewModel();
	
	        var ctrl = Object.create(BaseCtrl);
	        //const defaultVisibleFields = ['Fam1', 'Fam2', 'TownRow', 'Mobile'];
	
	        ctrl.init = function () {
	            $scope.view = submissionVm.draftData.lobs.homeowners.yourHome;
	            $scope.view.value = $scope.view.value || {};
	
	            setToDefault($scope.view.dwellingLocation);
	            //setToDefault($scope.view.residenceType);
	            setToDefault($scope.view.dwellingUsage);
	
	            // Start: Set default values to avoid exception in PC; Test code should be reomved
	            $scope.view.nearCommercial.value = false;
	            $scope.view.floodingOrFireHazard.value = false;
	            //$scope.view.occupancy.value = "owner";
	            // End: Set default values to avoid exception in PC; Test code should be reomved
	
	
	            // Temp code :: Uncomment this once additonal info page gets displayed
	            /***********************************************************************
	            * TODO:: change this value once the additional info screen is migrated *
	            ************************************************************************/
	            var additionalInfo = submissionVm.draftData.lobs.homeowners.additionalInfo.value;
	
	            $scope.residenceType = additionalInfo.residenceType; // "Condo"
	
	            // Passing home type value for coverage A and C (Estimate Home and Estimate Content) requiredness
	            //Ho membership field missing --Arpita
	            // $scope.homeType = additionalInfo.homeType; // "X"
	            // $scope.view.homeType.value = additionalInfo.homeType;
	            if (additionalInfo.homeType === 500) {
	                $scope.view.homeType.value = "HO4";
	                $scope.homeType = "HO4"; // "X"
	            } else if (additionalInfo.homeType === 1500) {
	                if ($scope.view.residenceType.value && $scope.view.residenceType.value.code === "Condo" || additionalInfo.residenceType && additionalInfo.residenceType === "Condo") {
	                    $scope.view.homeType.value = "HO6";
	                    $scope.homeType = "HO6";
	                } else {
	                    $scope.view.homeType.value = "HO3";
	                    $scope.homeType = "HO3";
	                }
	            } else {
	                $scope.view.homeType.value = additionalInfo.homeType;
	                $scope.homeType = additionalInfo.homeType; // "X"
	            }
	            //ended
	            if ($scope.view.purchaseYearRequired.value == undefined) {
	                $scope.view.purchaseYearRequired.value = false;
	            }
	
	            //Condition: This field is only visible for when user selects 'Own' from story card #10029 UIF.002; 
	            //this field is also only visible for HO3 and HO6
	            if ($scope.homeType == "HO3" || $scope.homeType == "HO6") {
	                $scope.view.purchaseYearRequired.value = true;
	            } else {
	                $scope.view.purchaseYearRequired.value = false;
	            }
	
	            $scope.showEstimateHome = true;
	            $scope.showEstimateContent = true;
	            // console.log("$scope.view:: ",$scope.view);
	            // console.log("Home Type: ", $scope.homeType, "Residence Type: ", $scope.residenceType);
	            // console.log("ReplacementCost: ", $scope.view.replacementCost, "ContentReplacementCost: ", $scope.view.contentReplacementCost);
	            //console.log("ReplacementCost: ", $scope.view.replacementCost.value, "ContentReplacementCost: ", $scope.view.contentReplacementCost.value);
	
	            // Hide visibility of "Estimated value of your home" input field
	            // If home type is "rent" or "own" + Residence type "condo"
	            if ($scope.homeType == "HO4" || $scope.homeType == "HO6") {
	                $scope.showEstimateHome = false;
	                // Set default value
	                //if ($scope.view.replacementCost.value == undefined){
	                //$scope.view.replacementCost.value = 1;
	                //}
	            }
	
	            // Hide visibility of "Estimated value of your contents" input field
	            // If home type is "own" + Residence type is other than "condo"
	            if ($scope.homeType == "HO3") {
	                $scope.showEstimateContent = false;
	                // Set default value
	                //if ($scope.view.contentReplacementCost.value == undefined){
	                //$scope.view.contentReplacementCost.value = 12000;
	                //}
	            }
	
	            // Temp Code should be removed after implemented split protection class
	            // Uncomment the html frame in ho-your-home.html
	            //$scope.view.distanceToFireHydrant = 500;
	            //$scope.view.distanceToFireStation = 3;
	            // Temp Code
	
	            //$scope.protectionClass = submissionVm.draftData.lobs.homeowners.protectionClass.value;
	            var questions = submissionVm.draftData.lobs.homeowners.preQualQuestionSets.value[0]["answers"];
	            questions["Select_Prior_InsStatus_aaa"] = "NewHomePurchase_aaa";
	        };
	
	        ctrl.next = function (nextFn, form) {
	
	            //removing protection class validation
	
	            if ($scope.showEstimateHome) {
	
	                var estimateHomeVal = $scope.view.replacementCost.value;
	
	                if ($scope.homeType == "HO3" && estimateHomeVal < 75000) {
	                    //  ModalService.showError('','The minimum amount of coverage offered is $75,000  Please adjust your value.');
	                    return false;
	                }
	
	                if ($scope.homeType == "HO3" && estimateHomeVal > 1125000) {
	                    //   ModalService.showError('','The maximum amount of coverage offered is $1,125,000 Please adjust your value.');
	                    return false;
	                }
	            }
	
	            if ($scope.showEstimateContent) {
	
	                var estimateContentVal = $scope.view.contentReplacementCost.value;
	                // ENHC0011872 changed from $100,000 to $300,000 for Estimated Value of contents
	                if (($scope.homeType == "HO4" || $scope.homeType == "HO6") && estimateContentVal > 300000) {
	                    //  ModalService.showError('','The maximum amount of coverage offered is $100,000 Please adjust your value.');
	                    return false;
	                }
	
	                if (($scope.homeType == "HO4" || $scope.homeType == "HO6") && estimateContentVal < 12000) {
	                    // ModalService.showError('','The minimum amount of coverage offered is $12,000 Please adjust your value.');
	                    return false;
	                }
	            }
	            nextFn(submissionVm);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'submissionViewModel', 'ModalService'];
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340), __webpack_require__(737)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl, FormUtil) {
	    var fn = function fn($scope, $anchorScroll, submissionViewModel, StateUtils) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVm = submissionViewModel();
	        var flowModel = StateUtils.activeDataForState(true).flowModel;
	
	        ctrl.init = function () {
	            $anchorScroll();
	            $scope.view = submissionVm.draftData.lobs.homeowners.construction;
	            // Temp code :: Uncomment this once additonal info page gets displayed
	            /***********************************************************************
	            * TODO:: change this value once the additional info screen is migrated *
	            ************************************************************************/
	            // Get homeType from additionalInfo details
	            var additionalInfo = submissionVm.draftData.lobs.homeowners.additionalInfo.value;
	            var homeType = additionalInfo.homeType; // "X"
	
	            // Ignore type codes other than "Brick (B)" and "Frame (F)" if occupancy is "owner"
	            if (homeType == "HO3" || homeType == "HO6") {
	                //$scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER'];
	                // For Dev
	                //$scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER','F','M','FireResistiveSteel','FramewithSiding','LessMasonryVeneer','MoreMasonryVeneer','Log'];
	                $scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER', 'F', 'M', 'Superior', 'MasonryVeneer'];
	            }
	
	            // Temp code to show roof images only mentioned in story card
	            // standingSeamMetal,ArchitecturalShingles,ConcreteTile, WoodShakeShingles
	            // Changes as per the changes done in RoofType.tti in PC - 16/09/2016
	            // Copying old images and renaming to current type codes and display keys in resources.json
	            //$scope.roofIgnoreList = ["tileclay", "plastic", "targravel", "slate", "fiberCement", "fiberAluminum"];
	            // For Dev
	            $scope.roofIgnoreList = ["AsphaltFiberComp", "ClayTileSlate", "CorrugatedMetalTin", "FlatFoamComposite", "FlatMembrane", "FlatTarGravel", "FlatPitchedRoof"];
	            if (!$scope.view.value) {
	                var currentYear = new Date().getFullYear();
	                $scope.view.value = {
	                    hasGarage: false, // requirement
	                    //secondaryHeatingExists: false,
	                    foundationType: "slab",
	                    plumbingType: "pvc",
	                    plumbingUpgradeExists: false,
	                    plumbingUpgradeYear: currentYear,
	                    //primaryHeatingType : "Gas",
	                    //heatingUpgradeExists : false,
	                    //heatingUpgradeYear : 2016,
	                    wiringType: "copper",
	                    electricalType: "CircuitBreaker",
	                    wiringUpgradeExists: false,
	                    wiringUpgradeYear: currentYear // requirement
	                };
	
	                // Check if home type is rent
	                // if it is rent then fill default values for construction screen 
	                // and go to next state
	                if (homeType == "HO4") {
	
	                    // Assign default values
	                    $scope.view.value.yearBuilt = 2004;
	                    $scope.view.value.storiesNumber = "1";
	                    $scope.view.value.constructionType = "Frame";
	                    $scope.view.value.roofType = "standingSeamMetal";
	                    $scope.view.value.roofUpgradeExists = false;
	                    $scope.view.value.isFlatRoof = false;
	                    $scope.view.value.primaryHeatingType = "CentralElectric";
	                    $scope.view.value.secondaryHeatingExists = false;
	                }
	            }
	
	            // Add default value
	            /*if ($scope.view.value.roofUpgradeExists == undefined){
	                $scope.view.value.roofUpgradeExists = false;
	            }*/
	
	            if (homeType == "HO4") {
	                // var savePromise = $scope.conditionallySaveSubmission();
	                //$scope.goToNext(savePromise, $filter('translate')('quoteandbind.ho.controllers.HOConstructionCtrl.Saving submission'));
	                flowModel.next(submissionVm, true);
	            }
	        };
	
	        // Roof upgrade exists
	        ctrl.roofUpgradeExists = function (val) {
	
	            //console.log("roofUpgradeExists: ",typeof val, val);
	
	            if (val == true) {
	
	                return true;
	            } else if (val == false) {
	                return false;
	            }
	
	            return undefined;
	        };
	
	        ctrl.isOther = function (val) {
	            return val && val.toLowerCase() === 'other';
	        };
	
	        ctrl.next = function (nextFn, form) {
	            FormUtil.markFormsSubmitted(form);
	            //console.log("construction: ",$scope.view.storiesNumber, $scope.view.value.storiesNumber);
	
	            /*if($scope.view.value.storiesNumber == "Unknown"){
	                $scope.view.value.storiesNumber = 1;
	             }*/
	
	            // Temp code
	            //delete $scope.view.value["roofFlat"];
	
	            // Default value for roof flat
	            $scope.view.value.hasGarage = false;
	            // Delete roofUpgradeYear if roofUpgradeExists is false
	            if ($scope.view.value.roofUpgradeExists == false) {
	                delete $scope.view.value["roofUpgradeYear"];
	            }
	
	            var questions = submissionVm.draftData.lobs.homeowners.preQualQuestionSets.value[0]["answers"];
	
	            //assigning the construction value for pre question set which is mandatory and asked by Iris to be assigned from constuction page
	            questions["yearOfCons_aaa"] = $scope.view.value.yearBuilt;
	            nextFn(submissionVm);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$anchorScroll', 'submissionViewModel', 'StateUtils'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseCtrl) {
	    var fn = function fn($scope, $anchorScroll, submissionViewModel) {
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	
	        ctrl.init = function () {
	            $anchorScroll();
	            /* Rating object */
	            $scope.view = submissionVM.draftData.lobs.homeowners.rating;
	            $scope.view.value = $scope.view.value || {};
	
	            /* Additional fields */
	            //$scope.isAdditionalOpen = isAnyAdditionalField();
	        };
	
	        ctrl.next = function (nextFn) {
	
	            $scope.view.deadboltsNumber.value = $scope.view.deadbolts.value ? 1 : undefined;
	
	            //Sending default values for the fields to overcome PC validations
	            $scope.view.visibleToNeighbors.value = true;
	            //ENHC0011872 NC & SC Property Underwriting Updates
	            //$scope.view.swimmingPoolFencing.value = false;
	            if ($scope.view.swimmingPoolExists.value == true) {
	                $scope.view.swimmingPoolFencing.value = true;
	            } else {
	                $scope.view.swimmingPoolFencing.value = false;
	            }
	            $scope.view.swimmingPoolDivingBoard.value = false;
	            $scope.view.trampolineSafetyNet.value = false;
	            $scope.view.smokeAlarmOnAllFloors.value = true;
	            // Temp Fix - This question should be "true" always to generate the quote - 16/09/2016
	            //$scope.view.smokeAlarm.value = true;
	
	            nextFn(submissionVM);
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', '$anchorScroll', 'submissionViewModel'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl) {
	    var fn = function fn($scope, LocaleService, StateUtils, submissionViewModel) {
	
	        var ctrl = Object.create(BaseCtrl);
	        var submissionVM = submissionViewModel();
	        var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;
	
	        ctrl.init = function () {
	            ctrl._setBindDataDefaultValues();
	
	            $scope.policyInfo = {};
	            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
	
	            $scope.policyInfo.billAndPolAddrsEqual = {
	                aspects: {
	                    valid: true,
	                    required: true,
	                    subtreeValid: true
	                },
	                value: true
	            };
	            $scope.policyInfo.displayAddressArray = $scope.policyInfo.displayAddressArray || submissionVM.draftData.policyAddress.value.displayName.split(',');
	            $scope.chosenOffering = _.findWhere(submissionVM.quoteData.offeredQuotes.value, { publicID: chosenQuoteId });
	            $scope.policyInfo.HOBaseCoverages = this._coverages($scope.chosenOffering.lobs.homeowners.baseCoverages);
	            $scope.policyInfo.HOAdditionalCoverages = this._coverages($scope.chosenOffering.lobs.homeowners.additionalCoverages);
	            $scope.policyInfo.ScheduledProperties = $scope.chosenOffering.lobs.homeowners.scheduledProperties;
	
	            $scope.submissionVM = submissionVM;
	            $scope.submissionVM.bindData.chosenQuote.value = StateUtils.activeDataForState(true).chosenQuote;
	        };
	
	        /**
	         * Each time the user selects the 'Yes' option for Billing address being equal to displayed address,
	         * Ensure that all of the hidden fields are populated to the same values of the displayed address.
	         * @returns {Array}
	         */
	        ctrl.resetBillingAddress = function () {
	            if ($scope.policyInfo.billAndPolAddrsEqual.value) {
	                angular.copy(submissionVM.draftData.policyAddress.value, submissionVM.bindData.billingAddress.value);
	            }
	        };
	
	        ctrl._coverages = function (coverages) {
	            return coverages.map(function (cov) {
	                return { name: cov.description, amount: cov.amount, terms: cov.terms };
	            });
	        };
	
	        ctrl._setBindDataDefaultValues = function () {
	            submissionVM.bindData.value = submissionVM.bindData.value || {};
	            if (!submissionVM.bindData.billingAddress.value) {
	                submissionVM.bindData.billingAddress.value = {};
	                angular.copy(submissionVM.draftData.policyAddress.value, submissionVM.bindData.billingAddress.value);
	            }
	            submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
	            submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value || submissionVM.draftData.accountHolder.emailAddress1.value;
	        };
	
	        return ctrl.create($scope);
	    };
	    fn.$inject = ['$scope', 'LocaleService', 'StateUtils', 'submissionViewModel'];
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Venkata.Pittam on 10-03-2017.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(774)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    var nextId = 0;
	
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbHoEditBlanketItems',
	                onListChange: '=',
	                loading: '=?'
	            },
	            controller: ['$scope', 'InsuranceSuiteMetadata', function (scope, InsuranceSuiteMetadata) {
	                function notifyChange() {
	                    if (scope.onListChange) {
	                        scope.onListChange();
	                    }
	                }
	
	                var typelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('ScheduleType_HOE');
	                scope.getOptions = ['Computer_aaa', 'Jewelry'].map(function (key) {
	                    return typelist.getCode(key);
	                });
	
	                scope.addScheduledProperty = function () {
	                    /* Do this on push as "null" would be set when custom quote is loaded without
	                     * any additional properties.
	                     */
	                    if (!scope.model.value) {
	                        scope.model.value = [];
	                    }
	                    scope.model.value.push({
	                        tempID: nextId++,
	                        type: 'Jewelry'
	                    });
	                    notifyChange();
	                };
	
	                scope.removeScheduledProperty = function (index) {
	                    scope.model.value.splice(index, 1);
	                    notifyChange();
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 774 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-padded20\">\r\n    <h4 class=\"gw-coverage-header\">{{'quoteandbind.ho.directives.ho-additional-coverages.Blanket Value Items' | translate}}\r\n    <span class=\"aaa-inline-info-wrapper\">\r\n               <div class=\"aaa-inline-info\"> {{'quoteandbind.ho.directives.ho-additional-coverages.Blanket Value Items Desc' |translate}}</div>\r\n                <i class=\"fa fa-info-circle\"></i>\r\n            </span>\r\n    </h4>\r\n\r\n    <button class=\"gw-btn\" ng-click=\"addScheduledProperty()\"\r\n            ng-disabled=\"loading\">{{'quoteandbind.ho.directives.ho-additional-coverages.Add Article' | translate}}\r\n    </button>\r\n    <span class=\"gw-error-text gw-padded20 gw-bold\" ng-show=\"!model.aspects.valid\">\r\n    <span ng-repeat=\"errorMessage in model.aspects.validationMessages\">\r\n        <span class=\"gw-error-inline\">{{errorMessage}}</span>\r\n    </span>\r\n</span>\r\n</div>\r\n\r\n<table class=\"gw-table\" ng-if=\"model.length > 0\">\r\n    <thead>\r\n    <tr>\r\n        <th class=\"gw-inline-control-group\">\r\n            <label class=\"gw-control-inline-label\">\r\n                <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Article or Property Type' | translate}}</span>\r\n                <span class=\"gw-required-asterisk\">*</span>\r\n            </label>\r\n        </th>\r\n        <th class=\"gw-inline-control-group\">\r\n            <label class=\"gw-control-inline-label\">\r\n                <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Value' | translate}}</span>\r\n                <span class=\"gw-required-asterisk\">*</span>\r\n            </label>\r\n        </th>\r\n        <th>{{'quoteandbind.ho.directives.ho-additional-coverages.Delete' | translate}}</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr\r\n            ng-repeat=\"item in model.children track by $index\">\r\n        <td title=\"{{'quoteandbind.ho.directives.ho-additional-coverages.Article or Property Type' | translate}} *\">\r\n            <select gw-pl-select=\"item.type.value\" options=\"getOptions\" render-by=\"'name'\"\r\n                    ng-disabled=\"loading\"></select>\r\n        </td>\r\n        <td title=\"{{'quoteandbind.ho.directives.ho-additional-coverages.Value' | translate}} *\">\r\n            <input type=\"text\" class=\"gw-input-block-level\"\r\n                   ng-disabled=\"loading\"\r\n                   id=\"Value_{{$index}}\"\r\n                   ng-model=\"item.exposureValue.value\"\r\n                   ng-class=\"{'ng-invalid' : !item.exposureValue.aspects.valid}\"/>\r\n            <label for=\"Value_{{$index}}\" class=\"gw-with-error-sign\">\r\n                <span class=\"gw-error-sign\"></span>\r\n            </label>\r\n        </td>\r\n        <td>\r\n            <button type=\"button\" ng-click=\"removeScheduledProperty($index)\" ng-disabled=\"loading\"><span\r\n                    class=\"fa fa-trash\"></span></button>\r\n        </td>\r\n    </tr>\r\n    </tbody>\r\n</table>\r\n"

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(776)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbHoEditCoverages',
	                onCovChange: '=',
	                onGeneralChange: '=',
	                loading: '=?',
	                lob: '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 776 */
/***/ function(module, exports) {

	module.exports = "<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.ho.directives.ho-main-coverages.Main Coverages Premium' | translate}}</span>\n    <span>{{model.basePremium.value | gwCurrency}}</span>\n</h4>\n\n<div class=\"gw-quote-boxes\">\n    <div gw-qnb-editable-coverages=\"model.baseCoverages.value\" loading=\"loading\" on-cov-change=\"onCovChange\" lob=\"{{lob}}\"></div>\n</div>\n\n<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Additional Coverages' | translate}}</span>\n</h4>\n\n<div class=\"gw-quote-boxes\">\n    <div gw-qnb-editable-coverages=\"model.additionalCoverages.value\" loading=\"loading\"\n         on-cov-change=\"onCovChange\" allow-select-coverage=\"true\"  lob=\"{{lob}}\"></div>\n    <!--<div gw-qnb-ho-edit-scheduled-property=\"model.scheduledProperties\" loading=\"loading\"\n         on-list-change=\"onGeneralChange\" allow-select-coverage=\"true\"></div>-->\n    <div gw-qnb-ho-edit-blanket-items=\"model.blanketItems\" loading=\"loading\"\n         on-list-change=\"onGeneralChange\" allow-select-coverage=\"true\"></div>\n</div>\n\n"

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(778)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                model: '=gwQnbHoViewCoverages',
	                lob: '@'
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 778 */
/***/ function(module, exports) {

	module.exports = "<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.ho.directives.ho-main-coverages.Main Coverages Premium' | translate}}</span>\n    <span>{{model.basePremium | gwCurrency}}</span>\n</h4>\n\n<div class=\"gw-quote-boxes\">\n    <div gw-qnb-readonly-coverages=\"model.baseCoverages\" lob=\"{{lob}}\"></div>\n</div>\n\n<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.ho.directives.ho-additional-coverages.Additional Coverages' | translate}}</span>\n</h4>\n\n<div class=\"gw-quote-boxes\">\n    <div gw-qnb-readonly-coverages=\"model.additionalCoverages\" lob=\"{{lob}}\"></div>\n</div>\n\n"

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        'getDuplicatedPropertyDescrs': function getDuplicatedPropertyDescrs(scheds) {
	            if (!scheds) {
	                return {};
	            }
	            var seen = {};
	            var duplicates = {};
	            scheds.forEach(function (item) {
	                var descr = item.description;
	                if (seen.hasOwnProperty(descr)) {
	                    duplicates[descr] = 1;
	                } else {
	                    seen[descr] = 1;
	                }
	            });
	            return duplicates;
	        },
	
	        'isEmpty': function isEmpty(m) {
	            return Object.keys(m).length === 0;
	        },
	
	        'notIn': function notIn(v, m) {
	            return !m.hasOwnProperty(v);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 780 */
/***/ function(module, exports) {



/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(782)], __WEBPACK_AMD_DEFINE_RESULT__ = function (SupportedLobModules) {
	    return angular.module('edge.quoteandbind.quickquote.app', SupportedLobModules);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(349), __webpack_require__(783)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ApplicationFeatures) {
	    var lobModules = [];
	
	    if (!ApplicationFeatures.hasFeature('role.vendor')) {
	        if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
	            lobModules.push('edge.quoteandbind.quickquote.pa.app');
	        }
	    }
	
	    return lobModules;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(784), __webpack_require__(789), __webpack_require__(803), __webpack_require__(829), __webpack_require__(839), __webpack_require__(851), __webpack_require__(706), __webpack_require__(708)], __WEBPACK_AMD_DEFINE_RESULT__ = function (RouteConfig) {
	
	    return angular.module('edge.quoteandbind.quickquote.pa.app', ['edge.quoteandbind.quickquote.common.app', 'edge.quoteandbind.quickquote.pa.tiles.vehicle', 'edge.quoteandbind.quickquote.pa.tiles.address', 'edge.quoteandbind.quickquote.pa.tiles.additional', 'edge.quoteandbind.quickquote.pa.tiles.quote']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
	        var states = new RouteConfig(RootStateConfig);
	        for (var stateName in states) {
	            if (states.hasOwnProperty(stateName)) {
	                $stateProvider.state(stateName, states[stateName]);
	            }
	        }
	    }]);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(785), __webpack_require__(786)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAQuickQuoteView, PAQuickQuoteCtrl) {
	    return function (RootStates) {
	        var parentState = RootStates.quote_bind;
	
	        return {
	            paQuickQuote: {
	                parent: parentState,
	                url: '/paquickQuote',
	                controller: PAQuickQuoteCtrl,
	                template: PAQuickQuoteView
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-streamlined-quote\">\n    <div class=\"gw-slq-mobile-nav\">\n        <i ng-class=\"{'gw-hidden':currentStepIndex === 0}\" class=\"fa fa-chevron-left gw-nav-icon\"\n           ng-click=\"previousPanel()\"></i>\n        <section class=\"gw-mobile-indicators\" gw-quick-step-progress\n                 transition-fn=\"jumpFn(targetStep)\"\n                 step-validity-fns=\"panelsValid\"\n                 form=\"form\"\n                 current-step=\"currentStepIndex\"></section>\n        <i ng-class=\"{'gw-hidden':currentStepIndex >= flow.steps.length - 1}\" class=\"fa fa-chevron-right gw-nav-icon\"\n           ng-click=\"nextPanel()\"></i>\n    </div>\n    <div gw-swipe-right=\"previousPanel()\" gw-swipe-left=\"nextPanel()\" class=\"gw-slq-container\">\n        <ng-form class=\"gw-slq-form\" ng-class=\"{ 'gw-submitted': form.submitted}\" novalidate name=\"form\">\n            <div class=\"gw-slq-form-row\">\n                <!-- Vin -->\n                <section class=\"gw-slq-section\"\n                         ng-class=\"getSectionClass(0)\"\n                         gw-pa-quick-vehicle-tile=\"tileModel\"\n                         step-idx=\"0\"\n                         panels-valid=\"panelsValid[0]\">\n                </section>\n                <section class=\"gw-slq-section\"\n                         ng-class=\"getSectionClass(1)\"\n                         gw-pa-quick-address-tile=\"tileModel\"\n                         step-idx=\"1\"\n                         panels-valid=\"panelsValid[1]\">\n                    <!-- Address -->\n                </section>\n            </div>\n            <div class=\"gw-slq-form-row\">\n                <section class=\"gw-slq-section\"\n                         ng-class=\"getSectionClass(2)\"\n                         gw-pa-quick-additional-tile=\"tileModel\"\n                         step-idx=\"2\"\n                         panels-valid=\"panelsValid[2]\">\n                    <!-- Info -->\n                </section>\n                <section class=\"gw-slq-section\"\n                         ng-class=\"getSectionClass(3)\"\n                         gw-pa-quick-quote-tile=\"tileModel\"\n                         gw-pa-quick-quote-previous-model=\"previousTileModel\"\n                         step-idx=\"3\"\n                         panels-valid=\"panelsValid[3]\"\n                         pre-quote-fn=\"preQuoteFn()\"\n                         transition-quote-to-edit=\"transitionQuoteToEdit\"\n                         transition-quote-to-quoted=\"transitionQuoteToQuoted\">\n                    <!-- Quote -->\n                </section>\n            </div>\n        </ng-form>\n    </div>\n</div>\n"

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(340), __webpack_require__(710), __webpack_require__(787)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseCtrl, flowFactory, flowConfig) {
	
	    var fn = function fn($scope, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, StateUtils, LocaleService) {
	        var countryCode = LocaleService.getCountry().code;
	
	        var ctrl = Object.create(BaseCtrl);
	        var quickQuoteVm = ViewModelService.create({
	            policyAddress: { country: countryCode },
	            productCode: 'PersonalAuto'
	        }, 'pc', 'edge.capabilities.quote.streamlined.dto.StreamlinedQuoteDTO');
	
	        var flowDefn = flowConfig($q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, StateUtils);
	        var flowModelFactory = flowFactory.get($q)(flowDefn);
	        var flowModel = flowModelFactory.start(quickQuoteVm);
	        var stepNames = ['vehicles', 'address', 'additional', 'quote'];
	
	        ctrl.init = function () {
	            $scope.panelsValid = [{}, {}, {}, {}];
	            $scope.flow = flowModel;
	
	            $scope.previousTileModel = {};
	
	            $scope.tileModel = {
	                viewModel: quickQuoteVm,
	                isLocked: false,
	                isSkipToQuoting: false,
	                startQuoting: undefined,
	                get completedSteps() {
	                    return flowModel.steps.filter(function (step) {
	                        return step.name !== 'quote';
	                    }).map(function (step) {
	                        return step.isCompleted;
	                    });
	                },
	                actions: {
	                    setLocked: function setLocked(flag) {
	                        return $scope.tileModel.isLocked = flag;
	                    },
	                    setStepCompleted: function setStepCompleted(stepIdx, status) {
	                        var step = flowModel.steps[stepIdx];
	                        step.isCompleted = status;
	                        if (step.isCompleted) {
	                            flowModel.next(quickQuoteVm);
	                        }
	                    },
	                    setStarQuotingFn: function setStarQuotingFn(startQuoteFn) {
	                        $scope.tileModel.startQuoting = startQuoteFn;
	                        flowModel.jumpToStep('quote');
	                    },
	                    proceedToFullQuote: function proceedToFullQuote() {
	                        if (flowModel.currentStep.name === 'quote') {
	                            flowModel.next(quickQuoteVm);
	                        }
	                    },
	                    reviseQuote: function reviseQuote() {
	                        flowModel.jumpToStep('vehicles');
	                    },
	                    triggerSubmission: function triggerSubmission() {
	                        $scope.form.submitted = true;
	                    }
	                }
	            };
	
	            Object.defineProperty($scope, 'currentStepIndex', {
	                get: function get() {
	                    return flowModel.steps.indexOf(flowModel.currentStep);
	                }
	            });
	        };
	
	        ctrl.getSectionClass = function (stepIdx) {
	            if (stepIdx === $scope.currentStepIndex) {
	                return 'gw-active-section';
	            } else if (stepIdx < $scope.currentStepIdx) {
	                return 'gw-inactive-section-left';
	            }
	            return 'gw-inactive-section-right';
	        };
	
	        ctrl.nextPanel = function () {
	            if ($scope.currentStepIndex < $scope.flow.steps.length - 1) {
	                // Handle if the user tried to transition to quote without valid panels
	                if ($scope.currentStepIndex + 1 === $scope.flow.steps.length - 1 && !allInputPanelsValid()) {
	                    $scope.form.submitted = true;
	                    return;
	                }
	                flowModel.next(quickQuoteVm).then(function () {
	
	                    if ($scope.currentStepIndex === flowModel.steps.length - 1) {
	                        //set quote tile to quoting for mobile view
	                        $scope.tileModel.startQuoting();
	                    }
	                });
	            }
	        };
	
	        ctrl.previousPanel = function () {
	            if ($scope.currentStepIndex > 0) {
	                // If swiping back from quote we must unlock the form
	                if ($scope.currentStepIndex === stepNames.indexOf('quote')) {
	                    $scope.tileModel.actions.setLocked(false);
	                }
	                flowModel.previous(quickQuoteVm);
	            }
	        };
	
	        ctrl.preQuoteFn = function () {
	            // Recurse through flow until we get to the quote
	            var quoteStateName = stepNames[stepNames.length - 1];
	            if (flowModel.currentStep.name !== quoteStateName) {
	                _recurseToState(quoteStateName, 'forward');
	            }
	        };
	
	        ctrl.jumpFn = function (targetStep) {
	            var finalStep = stepNames.length - 1;
	            // Block jump to quote panel unless all the panels are valid.
	            if (targetStep !== finalStep || allInputPanelsValid()) {
	                var stepName = stepNames[targetStep];
	                var currentStateIndex = stepNames.indexOf(flowModel.currentStep.name);
	                var direction = targetStep > currentStateIndex ? 'forward' : 'back';
	
	                // Switch to edit mode if going back
	                if (currentStateIndex === finalStep && targetStep !== finalStep) {
	                    $scope.tileModel.actions.setLocked(false);
	                    $scope.transitionQuoteToEdit();
	                    //set edit
	                } else if (currentStateIndex !== finalStep && targetStep === finalStep) {
	                    //Trigger quote if going to that state
	                    $scope.tileModel.actions.setLocked(true);
	                    $scope.transitionQuoteToQuoted();
	                }
	                // Recurse through the flow to get to the target step
	                _recurseToState(stepName, direction);
	            }
	        };
	
	        return ctrl.create($scope);
	
	        /**
	         * Recurse forward or backward in the flowmodel to get to a step
	         * @param stateName - name of the destination step
	         * @param direction - the recursion direction - values ('back'|'forward')
	         * @private
	         */
	        function _recurseToState(stateName, direction) {
	            // Recurse through flow until we get to the state
	            if (flowModel.currentStep.name !== stateName) {
	                if (direction === 'back') {
	                    flowModel.previous(quickQuoteVm).then(function () {
	                        _recurseToState(stateName, direction);
	                    });
	                } else if (direction === 'forward') {
	                    flowModel.next(quickQuoteVm).then(function () {
	                        _recurseToState(stateName, direction);
	                    });
	                }
	            }
	        }
	
	        function allInputPanelsValid() {
	            var inputPanels = $scope.panelsValid.slice(0, -1);
	            return _.all(inputPanels, function (panelFns) {
	                return panelFns.isValid && panelFns.isValid();
	            });
	        }
	    };
	
	    fn.$inject = ['$scope', '$q', 'WizardFlowService', 'qnb.LoadSaveService', 'ViewModelService', 'AvailabilityService', 'TranslateService', 'qnb.ViewModelCtx', '$stateParams', 'StateUtils', 'LocaleService'];
	
	    return fn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(456), __webpack_require__(788), __webpack_require__(396)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, commonSubFlowDefnFactories, paFlowDefnFactory, Submission) {
	
	    return function ($q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams) {
	
	        var ACTIONS = {
	
	            proceedToFullQuote: function proceedToFullQuote(_ref) {
	                var quotedSubmission = _ref.quotedSubmission;
	
	
	                var paFullQuoteFlowDefn = function paFullQuoteFlowDefn(step, junction, flow) {
	                    var commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
	                    var quoteFlow = flow(commonSubFlowDefns.quote);
	                    var bindFlow = flow(commonSubFlowDefns.bindAndPay);
	
	                    var paFlowDefn = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
	                    var paContactDetailsFlow = flow(paFlowDefn.contactDetails);
	                    var paCoverablesFlow = flow(paFlowDefn.coverables);
	                    var paMoreInfoFlow = flow(paFlowDefn.moreInfo);
	
	                    flow(commonSubFlowDefns.globalExits);
	                    step(paContactDetailsFlow.entry, true);
	                    paContactDetailsFlow.exits.paContactDetailsComplete.onNext.goTo(paCoverablesFlow.entry);
	                    paCoverablesFlow.exits.paCoverablesComplete.onNext.goTo(quoteFlow.entry);
	                    quoteFlow.exits.offeringSelected.onNext.goTo(paMoreInfoFlow.entry);
	                    paMoreInfoFlow.exits.paMoreInfoComplete.onNext.goTo(bindFlow.entry);
	                };
	
	                var stepToStateMapping = {
	                    returnHome: function returnHome() {
	                        return ['zipCode'];
	                    },
	                    confirmation: function confirmation(model) {
	                        return ['qnbconfirmation', {
	                            quoteSummary: model.value,
	                            returnStateInfo: ['zipCode']
	                        }];
	                    },
	                    error: function error(model, args) {
	                        return ['contactUs', {
	                            quoteID: model.quoteID ? model.quoteID.value : '',
	                            errorMsg: args.errorMsg
	                        }];
	                    }
	                };
	
	                var parentWizardState = 'baseQnbWizard';
	                var flowfactory = wizardFlowService(paFullQuoteFlowDefn, parentWizardState, stepToStateMapping);
	
	                quotedSubmission.bindData = undefined;
	                quotedSubmission.quoteData = undefined;
	                quotedSubmission = new Submission(quotedSubmission);
	                var submissionModel = ViewModelService.create(quotedSubmission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelCtx);
	                flowfactory.start(submissionModel, $stateParams);
	
	                //doesn't matter what we return here as long as it's a promise, starting a new wizard flow moves to a new page
	                return $q.resolve();
	            }
	        };
	
	        return function (step, junction) {
	            step('vehicles', true).onNext.goTo('address');
	
	            step('address').onNext.goTo('additional');
	
	            step('additional').onNext.goTo('quote');
	
	            step('quote').onNext.doAction(ACTIONS.proceedToFullQuote).thenGoTo('exit', 'vehicles');
	
	            junction('exit');
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext) {
	        var translateFn = TranslateService.instant;
	
	        var ACTION_MSGS = {
	            saveSubmission: {
	                error: {
	                    title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
	                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
	                },
	                progress: {
	                    message: 'quoteandbind.common.config.FlowConfig.Saving quote submission details...'
	                }
	            }
	        };
	
	        var ACTIONS = {
	            saveDraftSubmission: function saveDraftSubmission(_ref) {
	                var submission = _ref.value;
	                return LoadSaveService.saveSubmission(null, submission).then(function (submissionDTO) {
	                    return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
	                });
	            }
	        };
	
	        return {
	            contactDetails: function contactDetails(step, junction) {
	                step('paContactDetails', true).onNext.branch(function (model) {
	                    // If we come from quick quote go to intermediate step which will save the submission, otherwise
	                    // carry on as normal to the next state.
	                    return model.quoteID.value ? 'paQuickQuotePostContactDetails' : 'paContactDetailsComplete';
	                }).skipOnResumeIf(function (_ref2) {
	                    var submission = _ref2.value;
	                    return submission.persons[0].emailAddress1 && submission.persons[0].firstName !== '0streamlinedquote0';
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Your Info');
	                });
	
	                junction('paQuickQuotePostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('paContactDetailsComplete', 'error');
	
	                junction('paContactDetailsComplete');
	            },
	            coverables: function coverables(step, junction) {
	                step('paPrequalQuestions', true).onNext.goTo('paMembership').skipOnResumeIf(function (_ref3, _ref4) {
	                    var submission = _ref3.value;
	                    var agentportalnewsubmission = _ref4.agentportalnewsubmission;
	                    return submission.draftData.lobs.personalAuto.preQualQuestionSets && !agentportalnewsubmission;
	                }).isValid(function (model, isFormValid) {
	                    return model.aspects.valid && model.aspects.subtreeValid && isFormValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Qualification');
	                });
	
	                step('paMembership').onNext.goTo('paPrevCarrierInfo')
	                /*.isValid(model => model.aspects.valid && model.aspects.subtreeValid)*/
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Membership');
	                });
	
	                step('paPrevCarrierInfo').onNext.goTo('paDriverVehiclePrefillInfo').skipOnResumeIf(function (_ref5) {
	                    var submission = _ref5.value;
	                    return submission.draftData.lobs.personalAuto.prevCarrierInfo && !agentportalnewsubmission;
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.PreviousCarrierInfo');
	                });
	
	                step('paDriverVehiclePrefillInfo').onNext.goTo('paDriverDetails')
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.PrefilledDriverVehicle');
	                });
	
	                step('paDriverDetails').onNext.goTo('paVehicleDetails').skipOnResumeIf(function (_ref6) {
	                    var submission = _ref6.value;
	                    return submission.draftData.lobs.personalAuto.drivers[0] && submission.draftData.lobs.personalAuto.drivers[0].licenseNumber && submission.draftData.lobs.personalAuto.drivers[0].licenseNumber !== '0streamlinedquote0';
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Drivers');
	                });
	
	                step('paVehicleDetails').onNext.goTo('paCoverablesComplete').skipOnResumeIf(function (_ref7) {
	                    var submission = _ref7.value;
	                    return submission.draftData.lobs.personalAuto.vehicles[0] && submission.draftData.lobs.personalAuto.vehicles[0].license && submission.quoteData && submission.quoteData.offeredQuotes && submission.draftData.lobs.personalAuto.vehicles[0].vin !== '0streamlinedquote0';
	                }).isValid(function (model) {
	                    return model.aspects.valid && model.aspects.subtreeValid;
	                }).label(function () {
	                    return translateFn('quoteandbind.wizard.step.Vehicles');
	                });
	
	                junction('paCoverablesComplete');
	            },
	            moreInfo: function moreInfo(step, junction) {
	                step('paPolicyInfo', true).onNext.goTo('paPolicySummary').skipOnResumeIf(function (_ref8) {
	                    var submission = _ref8.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Policy Info');
	                });
	
	                step('paPolicySummary').onNext.goTo('paEsignature')
	                //.onNext.goTo('paMoreInfoComplete')                
	                .skipOnResumeIf(function (_ref9) {
	                    var submission = _ref9.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.Policy Summary');
	                });
	
	                step('paEsignature').onNext.goTo('paMoreInfoComplete').skipOnResumeIf(function (_ref10) {
	                    var submission = _ref10.value;
	                    return submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1;
	                })
	                //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
	                .label(function () {
	                    return translateFn('quoteandbind.wizard.step.E-Signature');
	                });
	
	                junction('paMoreInfoComplete');
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(790), __webpack_require__(792), __webpack_require__(794), __webpack_require__(796)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAQuickVehicleEditState, PAQuickVehicleInfoState, PAQuickVehicleVinLookupState, PAQuickVehicleTile) {
	    angular.module('edge.quoteandbind.quickquote.pa.tiles.vehicle', []).directive('gwPaQuickVehicleEditState', PAQuickVehicleEditState).directive('gwPaQuickVehicleInfoState', PAQuickVehicleInfoState).directive('gwPaQuickVehicleVinLookupState', PAQuickVehicleVinLookupState).directive('gwPaQuickVehicleTile', PAQuickVehicleTile);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(791)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'model': '='
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.submit = function () {
	                    $scope.vehicleForm.submitted = true;
	                    $scope.model.submit();
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 791 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-panel-form\" name=\"vehicleForm\">\n    <section class=\"gw-slq-info-panel-items\" >\n        <gw-pl-ctrl-group model=\"model.make\"\n                                             label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Make' | translate}}\">\n        <select gw-pl-select=\"model.make.value\" options=\"model.make.aspects.availableValues\"></select>\n    </gw-pl-ctrl-group>\n        <gw-pl-ctrl-group model=\"model.model\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Model' | translate}}\">\n            <select gw-pl-select=\"model.model.value\" options=\"model.model.aspects.availableValues\" placeholder=\"\"></select>\n        </gw-pl-ctrl-group>\n        <gw-pl-ctrl-group model=\"model.year\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Year' | translate}}\">\n            <select gw-pl-select=\"model.year.value\" options=\"model.year.aspects.availableValues\"\n                    class=\"gw-slq-vehicle-year-input\"></select>\n        </gw-pl-ctrl-group>\n    </section>\n\n    <div class=\"gw-slq-cancel-edit-buttons gw-slq-buttons\" id=\"gw-slq-make-model-year-search\">\n        <button class=\"gw-icon-primary gw-slq-button-cancel\" ng-hide=\"submitted\" ng-click=\"model.cancel()\" type=\"button\">\n        </button>\n        <button class=\"gw-icon-primary gw-slq-button-check\" ng-hide=\"submitted\" ng-click=\"submit()\"\n                type=\"submit\">\n        </button>\n    </div>\n</form>\n\n\n"

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(793)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: template,
	            scope: {
	                model: '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 793 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-info-panel\">\n    <section class=\"gw-slq-info-panel-items\">\n        <div ng-show=\"model.dto.vin.value\">\n            <gw-pl-ctrl-group class=\"gw-slq-readonly-field\" readonly=\"true\" model=\"model.dto.vin\"\n                              label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.VIN' | translate}}\">\n                <span class=\"readonly\">{{model.dto.vin.value}}</span>\n            </gw-pl-ctrl-group>\n        </div>\n        <gw-pl-ctrl-group class=\"gw-slq-readonly-field\" readonly=\"true\" model=\"model.dto.make\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Make' | translate}}\">\n            <span>{{model.dto.make.value}}</span>\n        </gw-pl-ctrl-group>\n        <gw-pl-ctrl-group class=\"gw-slq-readonly-field\" readonly=\"true\" model=\"model.dto.model\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Model' | translate}}\">\n            <span>{{model.dto.model.value}}</span>\n        </gw-pl-ctrl-group>\n        <gw-pl-ctrl-group class=\"gw-slq-readonly-field\" readonly=\"true\" model=\"model.dto.year\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-edit-vehicle.Year' | translate}}\">\n            <span>{{model.dto.year.value}}</span>\n        </gw-pl-ctrl-group>\n    </section>\n    <div class=\"gw-flip-card-bottom gw-slq-edit-button\">\n        <button class=\"gw-icon-primary gw-slq-button-edit\" ng-show=\"model.isEditable\" ng-click=\"model.edit()\" type=\"submit\">\n        </button>\n    </div>\n</form>"

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(795)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            restrict: 'A',
	            template: template,
	            scope: {
	                model: '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 795 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-car-details-section\">\n    <div class=\"gw-enter-car-details\">\n        {{'quoteandbind.pa.directives.templates.pa-quick-vehicle-info.Enter Car Details' | translate }}\n    </div>\n    <div class=\"gw-button-bar fit-to-screen\">\n\n        <button class=\"gw-btn-primary gw-slq-car-details-button\" ng-click=\"model.cancel()\"\n                type=\"button\">\n            <i class=\"fa fa-car gw-slq-icon-button\"></i>\n        </button>\n    </div>\n</form>\n<div class=\"gw-slq-vin-lookup-seperator\">\n    <div class=\"gw-slq-dotted-line\"></div>\n    <div class=\"gw-or-seperator\">{{'quoteandbind.pa.directives.templates.pa-quick-vehicle-info.or' | translate }}</div>\n    <div class=\"gw-slq-dotted-line\"></div>\n</div>\n<form class=\"gw-slq-enter-vin-section\">\n    <div class=\"gw-enter-vin\">{{'quoteandbind.pa.directives.templates.pa-quick-vehicle-info.Enter VIN' | translate }}</div>\n    <div class=\"gw-slq-pad-element\">\n        <div model=\"vehicle.vin\" class=\"gw-slq-pad-input\">\n            <input type=\"text\" id=\"VinLookup\" ng-model=\"model.vin\" name=\"Vin\"\n                   class=\"gw-slq-placeholder gw-sql-center-placeholder\"\n                   placeholder=\"{{'quoteandbind.pa.directives.templates.pa-quick-vehicle-info.Vehicle ID Number' | translate }}\"\n                   ng-class=\"{'gw-invalid-field': vehicle.vin.length === 0}\"/>\n        </div>\n    </div>\n    <div class=\"gw-button-bar\">\n        <button class=\"gw-icon-primary gw-slq-button-search\" ng-click=\"model.lookup()\"\n                type=\"submit\">\n        </button>\n    </div>\n</form>"

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(797), __webpack_require__(802)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, vehicleTile, template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'stepIdx': '=',
	                'tileModel': '=gwPaQuickVehicleTile',
	                'panelsValid': '='
	            },
	            controller: ['$scope', 'VinLookupService', function ($scope, VinLookupService) {
	                $scope.model = vehicleTile(VinLookupService, $scope.tileModel);
	                $scope.panelsValid.isValid = function () {
	                    return _.chain($scope.tileModel.viewModel).pick('make', 'model', 'year').values().every(function (prop) {
	                        return prop.aspects.valid;
	                    }).value() && $scope.model.isComplete;
	                };
	                $scope.$watch('model.isComplete', function (isCompleted) {
	                    $scope.tileModel.actions.setStepCompleted($scope.stepIdx, isCompleted);
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(798), __webpack_require__(799), __webpack_require__(801)], __WEBPACK_AMD_DEFINE_RESULT__ = function (vinLookupState, vehicleEditStateOrig, vehicleInfoState) {
	    return function (VinLookupService, tileModel) {
	        var state = undefined;
	        var dto = tileModel.viewModel;
	        var vehicleEditState = vehicleEditStateOrig(VinLookupService);
	
	        function toVinLookup(vin) {
	            state = {
	                'id': 'enterOrEdit',
	                'data': vinLookupState(VinLookupService, {
	                    initialVin: vin,
	                    onVinResult: function onVinResult(_vin, make, model, year) {
	                        dto.make = make;
	                        dto.model = model;
	                        dto.year = year;
	                        dto.vin = _vin;
	                        toSummary(function () {
	                            return toVinLookup('');
	                        });
	                    },
	                    onVinFailure: function onVinFailure() {
	                        dto.make = undefined;
	                        dto.model = undefined;
	                        dto.year = undefined;
	                        dto.vin = undefined;
	                        toEditVehicle();
	                    }
	                })
	            };
	        }
	
	        function toEditVehicle() {
	            state = {
	                'id': 'editVehicle',
	                'data': vehicleEditState({
	                    dto: dto,
	                    onSubmit: function onSubmit() {
	                        toSummary(toEditVehicle);
	                    },
	                    onCancel: function onCancel() {
	                        toVinLookup('');
	                    }
	                })
	            };
	        }
	
	        function toSummary(toPrevState) {
	            state = {
	                'id': 'complete',
	                'data': vehicleInfoState({
	                    dto: dto,
	                    isEditable: function isEditable() {
	                        return !tileModel.isLocked;
	                    },
	                    onEdit: toPrevState
	                })
	            };
	        }
	
	        toVinLookup('');
	        return {
	            get state() {
	                return state;
	            },
	            get isComplete() {
	                return state.id === 'complete';
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/** Creates a new lookup state with the corresponding actions.
	 * @param VinLookpService service for vin lookup.
	 * @paran initialVin initial VIN value.
	 * @param onVinResult function of type (vin, make, model, year) => Unit.
	 * @param onVinFailure function of type () = > Unit to invoke when vin was requested but not loaded;j
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (VinLookupService, _ref) {
	        var initialVin = _ref.initialVin,
	            onVinResult = _ref.onVinResult,
	            onVinFailure = _ref.onVinFailure;
	
	        var loading = false;
	        var vin = initialVin;
	
	        function lookupVin() {
	            if (loading) {
	                return;
	            }
	            loading = VinLookupService.autofillBasedOnVIN('quoteandbind', vin).then(function (succ) {
	                loading = false;
	                if (succ && succ.make && succ.model && succ.year) {
	                    onVinResult(vin, succ.make, succ.model, succ.year);
	                } else {
	                    onVinFailure();
	                }
	            }, function () {
	                return onVinFailure();
	            });
	        }
	
	        return {
	            get loading() {
	                return loading;
	            },
	            get vin() {
	                return vin;
	            },
	            set vin(newVin) {
	                if (!loading) {
	                    vin = newVin;
	                }
	            },
	            'lookup': lookupVin,
	            'cancel': onVinFailure
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Creates a new vehicle editor state.
	 * @param VinLookupService vin manipulation service.
	 * @param dto vehicle DTO to edit.
	 * @param onSuccess callback of type () => Unit
	 * @param onCancel cancellation callback of type () => Unit
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(800)], __WEBPACK_AMD_DEFINE_RESULT__ = function (asyncLookup) {
	    return function (VinLookupService) {
	        var makeLookup = asyncLookup(function () {
	            return VinLookupService.lookupMakes('quoteandbind').then(function (x) {
	                return x.makes;
	            });
	        });
	        makeLookup.load();
	
	        var modelLookup = asyncLookup(function (make) {
	            return VinLookupService.autofillBasedOnPartialDto('quoteandbind', { make: make }).then(function (x) {
	                return x.models;
	            });
	        });
	        var yearsLookup = asyncLookup(function (make, model) {
	            return VinLookupService.autofillBasedOnPartialDto('quoteandbind', { make: make, model: model }).then(function (x) {
	                return x.years;
	            });
	        });
	
	        return function (_ref) {
	            var dto = _ref.dto,
	                onSubmit = _ref.onSubmit,
	                onCancel = _ref.onCancel;
	
	
	            function isValid() {
	                return dto.make.aspects.valid && dto.model.aspects.valid && dto.year.aspects.valid;
	            }
	
	            var EMPTY = [];
	
	            return {
	                'make': {
	                    get value() {
	                        return dto.make.value;
	                    },
	                    set value(nv) {
	                        dto.make.value = nv;
	                        modelLookup.load(nv);
	                    },
	                    'aspects': Object.create(dto.make.aspects, {
	                        availableValues: { 'get': function get() {
	                                return makeLookup.state.value || EMPTY;
	                            } }
	                    })
	                },
	                'model': {
	                    get value() {
	                        return dto.model.value;
	                    },
	                    set value(nv) {
	                        dto.model.value = nv;
	                        yearsLookup.load(dto.make.value, nv);
	                    },
	                    'aspects': Object.create(dto.model.aspects, {
	                        availableValues: { 'get': function get() {
	                                return modelLookup.state.value || EMPTY;
	                            } }
	                    })
	                },
	                'year': {
	                    get value() {
	                        return dto.year.value;
	                    },
	                    set value(nv) {
	                        dto.year.value = nv;
	                    },
	                    'aspects': Object.create(dto.year.aspects, {
	                        availableValues: { 'get': function get() {
	                                return yearsLookup.state.value || EMPTY;
	                            } }
	                    })
	                },
	                cancel: onCancel,
	                submit: function submit() {
	                    if (isValid()) {
	                        onSubmit();
	                    }
	                }
	            };
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /**
	     * Controller for the asynchronous "lookup" data loading. It attempts to load the data for the latest request
	     * only and ignores all intermediate requests while the current request is in flight.
	     *
	     * <p>The lookup instance have the following properties and functions:
	     * <dl>
	     *     <dt>load</dt><dd>Requests to load a data for the specific set of arguments. The arguments would be passed to
	     *       the loader directly.</dd>
	     *     <dt>state</dt><dd>Current status of the object.</dd>
	     * </dl>
	     *
	     * <p>The state object have the following fields:
	     * <dl>
	     *     <dt>status</dt><dd>Current status of the lookup. One of 'ready', 'loading', 'error'.</dd>
	     *     <dt>value</dt><dd>Lookup result in the 'ready' state. Defaults to <code>defaultValue</code> immediately
	     *       after the loader creation and during 'loading' or 'error' states. </dd>
	     *     <dt>error</dt><dd>Error definition in the 'error' state, undefined otherwise.</dt>
	     * </dl>
	     *
	     * @param loader [Function] function used to load the data. All the "load" arguments are passed to the loader.
	     *   It must return the promise - an operation progress.
	     * @param defaultValue value to be exposed on the list during the operation progress.
	     * @returns returns a new Lookup instance.
	     */
	    function createLookup(loader, defaultValue) {
	        var nextArgs = undefined;
	        var state = {
	            'status': 'ready',
	            'value': defaultValue
	        };
	
	        /** Starts a load operation. */
	        function startLoad() {
	            state = {
	                'status': 'loading',
	                'value': defaultValue
	            };
	
	            var args = nextArgs;
	            nextArgs = undefined;
	
	            var operation = loader.apply(undefined, _toConsumableArray(args));
	            operation.then(function (succ) {
	                return onLoaded({
	                    'status': 'ready',
	                    'value': succ
	                });
	            }, function (fail) {
	                return onLoaded({
	                    'status': 'error',
	                    'value': defaultValue,
	                    'error': fail
	                });
	            });
	        }
	
	        /** Handles a load completion. */
	        function onLoaded(newState) {
	            if (nextArgs === undefined) {
	                /* No pending requests. */
	                state = newState;
	            } else {
	                /* Target changed, have to load a new goal. */
	                startLoad();
	            }
	        }
	
	        /** Handles a change of the loading goal. */
	        function onGoalChange() {
	            if (state.status === 'loading') {
	                return;
	            }
	            startLoad();
	        }
	
	        return {
	            get state() {
	                return state;
	            },
	            'load': function load() {
	                nextArgs = arguments;
	                onGoalChange();
	            }
	        };
	    }
	
	    return createLookup;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var dto = _ref.dto,
	            isEditable = _ref.isEditable,
	            onEdit = _ref.onEdit;
	
	        return {
	            dto: dto,
	            get isEditable() {
	                return isEditable();
	            },
	            edit: function edit() {
	                onEdit();
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 802 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-form-section gw-flip-container\">\n    <section class=\"gw-flip-card gw-slq-tile\">\n        <section class=\"gw-flip-front gw-edit-mode \" ng-class=\"{'gw-flipped' : !model.isComplete}\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot\">{{stepIdx+1}}</div>\n            </div>\n            <div class=\"form-data gw-slq-input-section-form\">\n                <div ng-if=\"model.state.id == 'enterOrEdit'\" class=\"gw-slq-vehicle-section\"\n                     gw-pa-quick-vehicle-vin-lookup-state model=\"model.state.data\">\n                </div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'editVehicle'\" class=\"gw-slq-vehicle-manual-section\"\n                     gw-pa-quick-vehicle-edit-state model=\"model.state.data\">\n                </div>\n            </div>\n        </section>\n        <section class=\"gw-flip-back gw-readonly-mode\" ng-class=\"{'gw-flipped' : model.isComplete }\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot gw-complete\">{{stepIdx+1}}</div>\n            </div>\n            <section class=\"gw-slq-input-section-form\">\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.isComplete\" gw-pa-quick-vehicle-info-state model=\"model.state.data\"></div>\n            </section>\n        </section>\n    </section>\n</div>"

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(804), __webpack_require__(806), __webpack_require__(808), __webpack_require__(810), __webpack_require__(812), __webpack_require__(814), __webpack_require__(816), __webpack_require__(818), __webpack_require__(827)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAQuickAddressLookupState, PAQuickAddressLookupFailureState, PAQuickAddressListState, PAQuickAddressZipLookupState, PAQuickAddressAddressInputState, PAQuickAddressStreetInputState, PAQuickAddressInfoState, PAQuickAddressTile, PAQuickAddressInvalidState) {
	    angular.module('edge.quoteandbind.quickquote.pa.tiles.address', []).directive('gwPaQuickAddressLookupState', PAQuickAddressLookupState).directive('gwPaQuickAddressLookupFailureState', PAQuickAddressLookupFailureState).directive('gwPaQuickAddressListState', PAQuickAddressListState).directive('gwPaQuickAddressZipLookupState', PAQuickAddressZipLookupState).directive('gwPaQuickAddressAddressInputState', PAQuickAddressAddressInputState).directive('gwPaQuickAddressStreetInputState', PAQuickAddressStreetInputState).directive('gwPaQuickAddressInfoState', PAQuickAddressInfoState).directive('gwPaQuickAddressTile', PAQuickAddressTile).directive('gwPaQuickAddressInvalidState', PAQuickAddressInvalidState);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(805)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 805 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-panel-form\">\n    <section class=\"gw-slq-info-panel-items\">\n        <p class=\"gw-prefill-label\">{{'quoteandbind.pa.directives.templates.pa-quick-address-info.My Address' | translate }}</p>\n        <div class=\"gw-mobile-input-width gw-slq-pad-input\">\n            <input type=\"text\" id=\"Address\" ng-model=\"model.address\"\n                   ng-class=\"{'gw-invalid-field': model.address.length === 0}\"\n                   name=\"Address\"\n                   class=\"gw-slq-placeholder\"\n                   placeholder=\"{{'quoteandbind.pa.directives.templates.pa-quick-vehicle-info.Number, Street, City' | translate }}\"/>\n        </div>\n    </section>\n    <div class=\"gw-slq-buttons\">\n        <button class=\"gw-icon-primary gw-slq-button-search\" ng-click=\"model.lookup()\" type=\"submit\">\n        </button>\n    </div>\n</form>\n"

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(807)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 807 */
/***/ function(module, exports) {

	module.exports = "<form name=\"lookupFailureForm\" class=\"gw-slq-address-fields gw-slq-panel-form\">\n    <section class=\"gw-slq-info-panel-items\">\n        <div ng-show=\"model.error.failure === 'lookupUnavailable'\" class=\"gw-error-text gw-slq-address-error\">\n            <p>{{'quoteandbind.quickquote.pa.tiles.address.directives.templates.pa-quick-address-lookup-failure-state.Address not found.' | translate }}</p>\n            <p>{{\"quoteandbind.quickquote.pa.tiles.address.directives.templates.pa-quick-address-lookup-failure-state.Enter manually.\" | translate }}</p>\n        </div>\n    </section>\n    <div class=\"gw-slq-cancel-edit-buttons gw-slq-buttons\">\n        <button class=\"gw-icon-primary gw-slq-button-check\" ng-click=\"model.confirm()\" type=\"submit\"></button>\n    </div>\n</form>"

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(809)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 809 */
/***/ function(module, exports) {

	module.exports = "<form>\n    <p class=\"gw-prefill-label\">{{'quoteandbind.pa.directives.templates.pa-quick-address-info.My Address' | translate }}</p>\n    <div class=\"gw-button-bar\">\n        <button class=\"gw-btn-primary gw-text-button\" ng-click=\"model.createNew()\"\n                type=\"submit\">\n            {{'quoteandbind.pa.directives.templates.pa-quick-address-info.My address is not in this list' | translate }}\n        </button>\n    </div>\n    <section class=\"gw-slq-address-results\">\n        <div ng-repeat=\"result in model.addresses\">\n            <div ng-click=\"model.select(result)\">\n                <p>{{result.address.addressLine1}}</p>\n                <p>{{result.address.city}}, <span\n                        ng-if=\"result.address.state\">{{result.address.state}},</span> {{result.address.postalCode}}</p>\n                <hr>\n            </div>\n        </div>\n    </section>\n</form>"

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(811)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '=',
	                'error': '='
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.submit = function () {
	                    $scope.zipForm.submitted = true;
	                    $scope.model.lookup();
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 811 */
/***/ function(module, exports) {

	module.exports = "<form name=\"zipForm\" class=\"gw-slq-panel-form\">\n    <section class=\"gw-prefill-label gw-slq-info-panel-items\">\n        <p class=\"gw-slq-zip-lookup-label\">{{'quoteandbind.pa.directives.templates.pa-quick-address-info.my ZIP Code is' | translate }}</p>\n        <div class=\"gw-mobile-input-width gw-slq-pad-input gw-zip-lookup-input-div\">\n            <input type=\"text\" id=\"PostalCode\" ng-model=\"model.zip.value\" name=\"PostalCode\"\n                   ng-class=\"{'gw-invalid-field': !model.zip.aspects.valid }\"/>\n        </div>\n        <div ng-show=\"error.failure === 'noMatch' && !zipForm.submitted\" class=\"gw-error-text\">{{'quoteandbind.quickquote.pa.tiles.address.directives.templates.pa-quick-address-zip-lookup-state.No matching addresses found' | translate }}</div>\n        <div ng-show=\"zipForm.submitted && !model.zip.aspects.valid\" class=\"gw-error-text\">{{'quoteandbind.quickquote.pa.tiles.address.directives.templates.pa-quick-address-zip-lookup-state.Invalid postal code' | translate }}</div>\n    </section>\n    <div class=\"gw-slq-buttons\">\n        <button class=\"gw-icon-primary gw-slq-button-search\" ng-click=\"submit()\" type=\"submit\">\n        </button>\n    </div>\n</form>"

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(813)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '=',
	                'error': '='
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.submit = function () {
	                    $scope.addressForm.submitted = true;
	                    if ($scope.model.isValid) {
	                        $scope.model.accept();
	                    }
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 813 */
/***/ function(module, exports) {

	module.exports = "<form name=\"addressForm\" class=\"gw-slq-address-fields gw-slq-panel-form\">\n    <section class=\"gw-slq-info-panel-items\">\n        <gw-pl-input-ctrl model=\"model.dto.addressLine1\"\n                          placeholder=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.enter street address' | translate}}\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.Street' | translate }}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl ng-disabled=\"model.dto.addressLine1.value\" model=\"model.dto.city\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.City' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl ng-disabled=\"model.dto.city.value\" model=\"model.dto.state\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.State' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl ng-disabled=\"model.dto.value\" model=\"model.dto.postalCode\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.ZIP Code' | translate}}\">\n        </gw-pl-input-ctrl>\n    </section>\n\n    <div class=\"gw-slq-cancel-edit-buttons gw-slq-buttons\">\n        <button class=\"gw-icon-primary gw-slq-button-cancel\" ng-click=\"model.cancel()\" type=\"button\"></button>\n        <button class=\"gw-icon-primary gw-slq-button-check\" ng-click=\"submit()\" type=\"submit\"></button>\n    </div>\n</form>"

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(815)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.submit = function () {
	                    $scope.addressForm.submitted = true;
	                    if ($scope.model.isValid) {
	                        $scope.model.accept();
	                    }
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 815 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-panel-form\"  name=\"addressForm\" class=\"gw-slq-address-fields\">\n    <section class=\"gw-slq-info-panel-items\">\n        <gw-pl-input-ctrl model=\"model.dto.addressLine1\"\n                          placeholder=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.enter street address' | translate}}\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.Street' | translate }}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" ng-disabled=\"model.dto.addressLine1.value\" model=\"model.dto.city\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.City' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" ng-disabled=\"model.dto.city.value\" model=\"model.dto.state\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.State' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" ng-disabled=\"model.dto.value\" model=\"model.dto.postalCode\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.ZIP Code' | translate}}\">\n        </gw-pl-input-ctrl>\n    </section>\n\n    <div class=\"gw-slq-cancel-edit-buttons gw-slq-buttons\">\n        <button class=\"gw-icon-primary gw-slq-button-cancel\" ng-click=\"model.cancel()\" type=\"button\"></button>\n        <button class=\"gw-icon-primary gw-slq-button-check\" ng-click=\"submit()\" type=\"submit\"></button>\n    </div>\n</form>"

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(817)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 817 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-info-panel-items\">\n    <div class=\"gw-slq-address-fields\">\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" model=\"model.dto.addressLine1\" readonly=\"true\"\n                          placeholder=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.enter street address' | translate}}\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.Street' | translate }}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" model=\"model.dto.city\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.City' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" model=\"model.dto.state\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.State' | translate}}\">\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" model=\"model.dto.postalCode\" readonly=\"true\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-address-info.ZIP Code' | translate}}\">\n        </gw-pl-input-ctrl>\n    </div>\n</form>\n<div class=\"gw-flip-card-bottom gw-slq-edit-button gw-slq-buttons\">\n    <button class=\"gw-icon-primary gw-slq-button-edit\" ng-show=\"model.cancellable()\" ng-click=\"model.cancel()\" type=\"submit\"></button>\n</div>"

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(819), __webpack_require__(826)], __WEBPACK_AMD_DEFINE_RESULT__ = function (addressTile, template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'stepIdx': '=',
	                'tileModel': '=gwPaQuickAddressTile',
	                'panelsValid': '='
	            },
	            controller: ['$scope', 'AddressLookupService', 'AvailabilityService', 'LocaleService', function ($scope, AddressLookupService, AvailabilityService, LocaleService) {
	                $scope.model = addressTile(LocaleService, AddressLookupService, AvailabilityService, $scope.tileModel);
	                $scope.panelsValid.isValid = function () {
	                    return $scope.tileModel.viewModel.policyAddress.aspects.valid && $scope.tileModel.viewModel.policyAddress.aspects.subtreeValid && $scope.model.isComplete;
	                };
	                $scope.$watch('model.isComplete', function (isCompleted) {
	                    $scope.tileModel.actions.setStepCompleted($scope.stepIdx, isCompleted);
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(820), __webpack_require__(821), __webpack_require__(822), __webpack_require__(823), __webpack_require__(824), __webpack_require__(825)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, lookupAddressState, addressListState, zipLookupState, editAddressState, addressInfoState, lookupFailureState) {
	    return function (LocaleService, AddressLookupService, AvailabilityService, tileModel) {
	        var state = undefined;
	        var dto = tileModel.viewModel.policyAddress;
	
	        function toLookup() {
	            state = {
	                'id': 'lookupAddress',
	                'data': lookupAddressState(AddressLookupService, {
	                    initialAddress: '',
	                    onLookup: toAddressList,
	                    onNoResult: function onNoResult() {
	                        return toZipLookup({ failure: 'noMatch' });
	                    },
	                    onLookupFail: function onLookupFail() {
	                        return toLookupFailure({ failure: 'lookupUnavailable' });
	                    }
	                })
	            };
	        }
	
	        function toLookupFailure() {
	            var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            state = {
	                'id': 'lookupFailure',
	                'data': lookupFailureState({
	                    error: error,
	                    onConfirm: function onConfirm() {
	                        return toAddressInput(dto.value);
	                    }
	                })
	            };
	        }
	
	        function toAddressList(addresses) {
	            var returnFunc = function returnFunc() {
	                return toAddressList(addresses);
	            };
	            var nextFunc = function nextFunc() {
	                return toConfirmation(function () {
	                    return toAddressInput(dto.value);
	                });
	            };
	            state = {
	                'id': 'addressList',
	                'data': addressListState({
	                    addresses: addresses,
	                    onAddress: function onAddress(addr) {
	                        dto.value = _.clone(addr.address);
	                        if (!dto.country.value) {
	                            dto.country.value = getCountryCode();
	                        }
	                        checkAvailability(returnFunc, nextFunc);
	                    },
	
	                    onNewAddress: toZipLookup
	                })
	            };
	        }
	
	        function toZipLookup() {
	            var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var returnFunc = function returnFunc() {
	                return toStreetInput();
	            };
	            var nextFunc = function nextFunc() {
	                return autofillBasedOnPostcode();
	            };
	            dto.value = {};
	            state = {
	                'id': 'zipLookup',
	                'error': error,
	                'data': zipLookupState(AddressLookupService, {
	                    zipDto: dto.postalCode,
	                    onLookup: function onLookup() {
	                        checkAvailability(returnFunc, nextFunc);
	                    },
	                    onLookupFail: function onLookupFail() {
	                        toLookupFailure({ failure: 'lookupUnavailable' });
	                    }
	                })
	            };
	        }
	
	        function toAddressInput() {
	            var prefill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var returnFunc = function returnFunc() {
	                return toAddressInput(dto.value);
	            };
	            var nextFunc = function nextFunc() {
	                return toConfirmation(returnFunc);
	            };
	            dto.value = prefill;
	            dto.country = getCountryCode();
	            state = {
	                'id': 'addressInput',
	                'data': editAddressState({
	                    dto: dto,
	                    onDone: function onDone() {
	                        checkAvailability(returnFunc, nextFunc);
	                    },
	
	                    onCancel: function onCancel() {
	                        clearObject(dto.value);
	                        toLookup();
	                    },
	                    onInvalid: function onInvalid() {
	                        toInvalid(function () {
	                            return toAddressInput(dto.value);
	                        });
	                    }
	                })
	            };
	        }
	
	        function toStreetInput() {
	            var prefill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var returnFunc = function returnFunc() {
	                return toStreetInput(dto.value);
	            };
	            var nextFunc = function nextFunc() {
	                return toConfirmation(returnFunc);
	            };
	            dto.value = prefill;
	            dto.country = getCountryCode();
	            state = {
	                'id': 'streetInput',
	                'data': editAddressState({
	                    dto: dto,
	                    onDone: function onDone() {
	                        checkAvailability(returnFunc, nextFunc);
	                    },
	
	                    onCancel: function onCancel() {
	                        clearObject(dto.value);
	                        toLookup();
	                    },
	                    onInvalid: function onInvalid() {
	                        toInvalid(function () {
	                            return toStreetInput(dto.value);
	                        });
	                    }
	                })
	            };
	        }
	
	        function toConfirmation(onBack) {
	            state = {
	                'id': 'complete',
	                'data': addressInfoState({
	                    dto: dto,
	                    isCancellable: function isCancellable() {
	                        return !tileModel.isLocked;
	                    },
	                    onCancel: onBack
	                })
	            };
	        }
	
	        function toInvalid(onBack) {
	            var errorState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            state = {
	                'id': 'addressInvalid',
	                'data': addressInfoState({
	                    dto: dto,
	                    errorState: errorState,
	                    isCancellable: function isCancellable() {
	                        return !tileModel.isLocked;
	                    },
	                    onCancel: onBack
	                })
	            };
	        }
	
	        function checkAvailability(onBack, onNext) {
	            var data = preparePostCodeData();
	
	            var availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode(null, data);
	            availabilityPromise.then(function (availabilityResp) {
	                if (!availabilityResp.isAvailable) {
	                    toInvalid(onBack);
	                } else {
	                    onNext();
	                }
	            }, function () {
	                return toInvalid(onBack);
	            });
	        }
	
	        function autofillBasedOnPostcode() {
	            var data = preparePostCodeData();
	
	            AddressLookupService.autofillBasedOnPostalCode('quoteandbind', data).then(function (addressInfo) {
	                _.mapObject(_.max(addressInfo.matches, function (match) {
	                    return match.matchAccuracy;
	                }).address, function (value, key) {
	                    if (key !== 'addressLine1') {
	                        dto[key].value = value;
	                    }
	                });
	                toStreetInput(dto.value);
	            }, function () {
	                return toLookupFailure({ failure: 'lookupUnavailable' });
	            });
	        }
	
	        function preparePostCodeData() {
	            var data = {
	                agentportalnewsubmission: null,
	                effectiveDate: new Date(),
	                postalCode: tileModel.viewModel.policyAddress.postalCode.value,
	                productCode: tileModel.viewModel.productCode.value,
	                quoteID: null
	            };
	            return data;
	        }
	
	        function clearObject(dtoObject) {
	            Object.keys(dtoObject).forEach(function (key) {
	                dtoObject[key] = '';
	            });
	        }
	
	        function getCountryCode() {
	            return LocaleService.getCountry().code;
	        }
	
	        toLookup();
	
	        return {
	            get state() {
	                return state;
	            },
	            get isComplete() {
	                return state.id === 'complete';
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * State used for address lookup.
	 * @param AddressLookupService service used for the address lookup.
	 * @param initialAddress initial address value.
	 * @param onLookup callback of type Address[] => Unit to invoke with the lookup result.
	 * @param onNoResult callback to invoke when no address was found.
	 * @param onLookupFail callback to invoke when address lookup failed.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (AddressLookupService, _ref) {
	        var initialAddress = _ref.initialAddress,
	            onLookup = _ref.onLookup,
	            onNoResult = _ref.onNoResult,
	            onLookupFail = _ref.onLookupFail;
	
	        var address = initialAddress;
	        var loading = false;
	        var haveError = false;
	
	        return {
	            get address() {
	                return address;
	            },
	            set address(newAddress) {
	                address = newAddress;
	                haveError = false;
	            },
	            get loading() {
	                return loading;
	            },
	            get hasError() {
	                return haveError;
	            },
	            lookup: function lookup() {
	                if (loading) {
	                    return;
	                }
	                loading = true;
	                AddressLookupService.autofillBasedOnAdddress('quoteandbind', address).then(function (addressInfo) {
	                    loading = false;
	                    if (addressInfo && addressInfo.matches && addressInfo.matches.length > 0) {
	                        haveError = false;
	                        onLookup(addressInfo.matches);
	                    } else {
	                        haveError = true;
	                        onNoResult();
	                    }
	                }, function () {
	                    loading = false;
	                    haveError = true;
	                    onLookupFail();
	                });
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * State where a list of addresses is displayed.
	 * @param addresses addresses to display.
	 * @param onAddress callback of type Address => Unit to invoke when an address is selected.
	 * @param onNewAddress callback to invoke when user selects a "no address" action.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var addresses = _ref.addresses,
	            onAddress = _ref.onAddress,
	            onNewAddress = _ref.onNewAddress;
	
	        return {
	            get addresses() {
	                return addresses;
	            },
	            select: onAddress,
	            createNew: onNewAddress
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * State used for the zip code lookup.
	 * @param AddressLookupService service used for the address lookup.
	 * @param zipDto view model of the zip code.
	 * @param onLookup callback with type Address => Unit invoked after initial zip code processing.
	 * @param onLookupFail callback with type String => Unit invoked when lookup failed due to network error.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (AddressLookupService, _ref) {
	        var zipDto = _ref.zipDto,
	            onLookup = _ref.onLookup;
	
	        var loadError = false;
	
	        return {
	            zip: {
	                get value() {
	                    return zipDto.value;
	                },
	                set value(nv) {
	                    zipDto.value = nv;
	                    loadError = false;
	                },
	                aspects: zipDto.aspects
	            },
	            get hasError() {
	                return loadError;
	            },
	            lookup: onLookup
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * State of editing the full address.
	 * @param dto dto to edit.
	 * @param onDone callback to invoke when editing is done.
	 * @param onCancel callback to invoke when editing is cancelled.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var dto = _ref.dto,
	            onDone = _ref.onDone,
	            onCancel = _ref.onCancel;
	
	        return {
	            dto: dto,
	            cancel: onCancel,
	            accept: onDone,
	            get isValid() {
	                return dto.addressLine1.aspects.valid && dto.city.aspects.valid && dto.state.aspects.valid && dto.postalCode.aspects.valid;
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * Creates a new address "display" form.
	 * @param dto address DTO to display.
	 * @param isCancellable function of type () => Boolean returning true iff the state could be cancelled.
	 * @param onCancel callback of type () => to invoke when the form is cancelled.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var dto = _ref.dto,
	            isCancellable = _ref.isCancellable,
	            onCancel = _ref.onCancel;
	
	        return {
	            dto: dto,
	            get cancellable() {
	                return isCancellable;
	            },
	            cancel: function cancel() {
	                onCancel();
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * State used to represent a failure of the lookup service
	 * @param error type to display.
	 * @param onConfirm callback of type () => to invoke when the user confirms.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var error = _ref.error,
	            onConfirm = _ref.onConfirm;
	
	        return {
	            get error() {
	                return error;
	            },
	            confirm: function confirm() {
	                onConfirm();
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 826 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-form-section gw-flip-container\">\n    <section class=\"gw-flip-card gw-slq-tile\">\n        <section class=\"gw-flip-front gw-edit-mode\" ng-class=\"{'gw-flipped' : !model.isComplete}\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot\">{{stepIdx+1}}</div>\n            </div>\n            <div class=\"gw-slq-input-section-form\">\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'lookupAddress'\" gw-pa-quick-address-lookup-state\n                     model=\"model.state.data\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'lookupFailure'\" gw-pa-quick-address-lookup-failure-state\n                     model=\"model.state.data\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'addressList'\" gw-pa-quick-address-list-state\n                     model=\"model.state.data\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'zipLookup'\" gw-pa-quick-address-zip-lookup-state\n                     model=\"model.state.data\" error=\"model.state.error\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'addressInput'\" gw-pa-quick-address-address-input-state\n                     model=\"model.state.data\" error=\"model.state.error\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'streetInput'\" gw-pa-quick-address-street-input-state\n                     model=\"model.state.data\"></div>\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'addressInvalid'\" gw-pa-quick-address-invalid-state\n                     model=\"model.state.data\"></div>\n            </div>\n        </section>\n        <section class=\"gw-control-group-section gw-flip-back gw-readonly-mode\"\n                 ng-class=\"{'gw-flipped' : model.isComplete}\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot gw-complete\">{{stepIdx+1}}</div>\n            </div>\n            <section class=\"gw-slq-input-section-form\">\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.isComplete\" gw-pa-quick-address-info-state model=\"model.state.data\"></div>\n            </section>\n        </section>\n    </section>\n</div>"

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(828)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 828 */
/***/ function(module, exports) {

	module.exports = "<form>\n    <div>\n        {{'quoteandbind.pa.directives.templates.pa-quick-address-invalid.We can’t offer a quick quote for your location. If you would like to speak with an agent please call' | translate}}\n    </div>\n    <div class=\"gw-flip-card-bottom\">\n        <button class=\"gw-icon-primary\" ng-show=\"model.cancellable()\" ng-click=\"model.cancel()\" type=\"submit\">\n            <i class=\"fa fa-close gw-slq-icon-button\"></i>\n        </button>\n    </div>\n</form>"

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(830), __webpack_require__(832), __webpack_require__(834)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAQuickAdditionalEditState, PAQuickAdditionalInfoState, PAQuickAdditionalTile) {
	    angular.module('edge.quoteandbind.quickquote.pa.tiles.additional', []).directive('gwPaQuickAdditionalEditState', PAQuickAdditionalEditState).directive('gwPaQuickAdditionalInfoState', PAQuickAdditionalInfoState).directive('gwPaQuickAdditionalTile', PAQuickAdditionalTile);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(831)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'tileModel': '=',
	                'model': '='
	            },
	            'controller': ['$scope', function ($scope) {
	
	                $scope.quote = function () {
	                    $scope.additionalForm.submitted = true;
	                    $scope.tileModel.actions.triggerSubmission();
	                    if ($scope.model.allStepsComplete()) {
	                        $scope.model.quote();
	                    }
	                };
	
	                $scope.markComplete = function () {
	                    $scope.additionalForm.submitted = true;
	                    $scope.model.markComplete();
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 831 */
/***/ function(module, exports) {

	module.exports = "<form class=\"gw-slq-panel-form\" name=\"additionalForm\">\n    <section class=\"gw-slq-info-panel-items\">\n        <gw-pl-input-ctrl model=\"model.dto.email\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.My Email' | translate }}\">\n            <input type=\"text\" id=\"Email\" ng-model=\"model.dto.email\" name=\"Email\"/>\n        </gw-pl-input-ctrl>\n        <gw-pl-input-ctrl class=\"gw-age-input\" model=\"model.dto.age\"\n                          label=\"{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.Youngest Driver' | translate}}\">\n            <input type=\"number\" id=\"Age\" ng-model=\"model.dto.age\" name=\"Age\"/>\n        </gw-pl-input-ctrl>\n        <p class=\"gw-age-input\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.years old' | translate}}</p>\n        <div class=\"gw-terms-conditions\">\n            <gw-pl-ctrl-group model=\"model.dto.termsChecked\" class=\"gw-terms-conditions\"\n                              ng-class=\"{'gw-invalid-field': !model.dto.termsChecked.value}\">\n                <input type=\"checkbox\" id=\"Agree\" ng-model=\"model.dto.termsChecked.value\" name=\"Agree\"/>\n                <label for=\"Agree\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.I agree to' | translate}}</label>\n                <span class=\"gw-terms-link\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.Terms and Conditions' | translate}}</span>\n            </gw-pl-ctrl-group>\n        </div>\n    </section>\n\n    <div class=\"gw-slq-buttons\">\n        <button class=\"gw-get-quote-button\" ng-click=\"quote()\"\n                type=\"submit\">\n            {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Quote!' | translate }}\n        </button>\n        <button class=\"gw-slq-button-check gw-icon-primary gw-additional-confirm-button\" ng-click=\"markComplete()\" type=\"submit\">\n        </button>\n    </div>\n</form>"

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(833)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            scope: {
	                'model': '='
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-slq-info-panel-items\">\n    <gw-pl-input-ctrl class=\"gw-slq-readonly-field\" model=\"model.dto.email\" readonly=\"true\" label=\"{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.My Email' | translate }}\">\n        <input type=\"text\" id=\"Email\" ng-model=\"model.dto.email\" name=\"Email\"/>\n    </gw-pl-input-ctrl>\n    <gw-pl-input-ctrl class=\"gw-age-input\" model=\"model.dto.age\" readonly=\"true\" label=\"{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.Youngest Driver' | translate}}\">\n        <input type=\"number\" id=\"Age\" ng-model=\"model.dto.age\" name=\"Age\"/>\n    </gw-pl-input-ctrl>\n    <p class=\"gw-age-input\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.years old' | translate}}</p>\n    <div class=\"gw-terms-conditions\">\n        <gw-pl-ctrl-group model=\"model.dto.termsChecked\" class=\"gw-terms-conditions gw-readonly\" readonly=\"true\">\n            <input type=\"checkbox\"  id=\"Agree\" ng-model=\"model.dto.termsChecked.value\" name=\"Agree\"/>\n            <label for=\"Agree\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.I agree to' | translate}}</label>\n            <span class=\"gw-terms-link\">{{'quoteandbind.pa.directives.templates.pa-quick-additional-info.Terms and Conditions' | translate}}</span>\n        </gw-pl-ctrl-group>\n    </div>\n</div>\n<div class=\"gw-flip-card-bottom gw-slq-edit-button gw-slq-buttons\">\n    <button class=\"gw-icon-primary gw-slq-button-edit\" ng-show=\"model.isEditable\" ng-click=\"model.edit()\">\n    </button>\n</div>"

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(835), __webpack_require__(838)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, additionalTile, template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'stepIdx': '=',
	                'tileModel': '=gwPaQuickAdditionalTile',
	                'panelsValid': '='
	            },
	            controller: ['$scope', function ($scope) {
	                $scope.model = additionalTile($scope.tileModel);
	
	                $scope.panelsValid.isValid = function () {
	                    return _.chain($scope.tileModel.viewModel).pick('termsChecked', 'email', 'age').values().every(function (prop) {
	                        return prop.aspects.valid;
	                    }).value();
	                };
	                $scope.$watch('model.isComplete', function (isCompleted) {
	                    $scope.tileModel.actions.setStepCompleted($scope.stepIdx, isCompleted);
	                });
	                $scope.$watch('model.state.id', function (state) {
	                    if (state === 'attemptingQuote') {
	                        $scope.tileModel.startQuoting();
	                    }
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(836), __webpack_require__(837)], __WEBPACK_AMD_DEFINE_RESULT__ = function (editAdditionalInfo, additionalInfo) {
	    return function (tileModel) {
	        var state = undefined;
	
	        var dto = tileModel.viewModel;
	
	        function toEdit() {
	            state = {
	                'id': 'edit',
	                'data': editAdditionalInfo({
	                    dto: dto,
	                    onQuote: function onQuote() {
	                        toQuote();
	                    },
	                    markComplete: function markComplete() {
	                        toInfo();
	                    },
	
	                    tileModel: tileModel
	                })
	            };
	        }
	
	        function toInfo() {
	            state = {
	                'id': 'complete',
	                'data': additionalInfo({
	                    dto: dto,
	                    isEditable: function isEditable() {
	                        return !tileModel.isLocked;
	                    },
	                    onEdit: toEdit
	                })
	            };
	        }
	
	        function toQuote() {
	            state = {
	                'id': 'attemptingQuote',
	                'data': additionalInfo({
	                    dto: dto,
	                    isEditable: function isEditable() {
	                        return !tileModel.isLocked;
	                    },
	                    onEdit: toEdit
	                })
	            };
	        }
	
	        toEdit();
	
	        return {
	            get state() {
	                return state;
	            },
	            get isComplete() {
	                return state.id === 'complete' || state.id === 'attemptingQuote';
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * Creates a new "Additional info" page.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var dto = _ref.dto,
	            onQuote = _ref.onQuote,
	            _markComplete = _ref.markComplete,
	            tileModel = _ref.tileModel;
	
	        function isValid() {
	            return dto.email.aspects.valid && dto.age.aspects.valid && dto.termsChecked.aspects.valid;
	        }
	        return {
	            dto: dto,
	            markComplete: function markComplete() {
	                if (isValid()) {
	                    _markComplete();
	                }
	            },
	            quote: function quote() {
	                if (isValid()) {
	                    onQuote();
	                }
	            },
	            allStepsComplete: function allStepsComplete() {
	                return tileModel.completedSteps.slice(0, -1).every(function (isComplete) {
	                    return isComplete;
	                });
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (_ref) {
	        var dto = _ref.dto,
	            isEditable = _ref.isEditable,
	            onEdit = _ref.onEdit;
	
	        return {
	            dto: dto,
	            get isEditable() {
	                return isEditable();
	            },
	            edit: function edit() {
	                onEdit();
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 838 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-form-section gw-flip-container\">\n    <section class=\"gw-flip-card gw-slq-tile\" ng-class=\"{'gw-submit-pressed': submitPressed}\">\n        <div class=\"gw-flip-front gw-edit-mode gw-additional-info\" ng-class=\"{'gw-flipped': !model.isComplete}\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot\">{{stepIdx+1}}</div>\n            </div>\n            <section class=\"gw-slq-input-section-form\">\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.state.id == 'edit'\" gw-pa-quick-additional-edit-state tile-model=\"tileModel\" model=\"model.state.data\"></div>\n            </section>\n        </div>\n        <div class=\"gw-flip-back gw-readonly-mode gw-additional-info\" ng-class=\"{'gw-flipped': model.isComplete}\">\n            <div class=\"gw-complete-indicator\">\n                <div class=\"gw-indicator-dot gw-complete\">{{stepIdx+1}}</div>\n            </div>\n            <section class=\"gw-slq-input-section-form\">\n                <div class=\"gw-slq-info-panel\" ng-if=\"model.isComplete\" gw-pa-quick-additional-info-state model=\"model.state.data\"></div>\n            </section>\n        </div>\n    </section>\n</div>"

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(840), __webpack_require__(842), __webpack_require__(844), __webpack_require__(847), __webpack_require__(849)], __WEBPACK_AMD_DEFINE_RESULT__ = function (PAQuickQuoteEditState, PAQuickQuoteQuotingState, PAQuickQuoteQuotedState, PAQuickQuoteQuoteErrorState, PAQuickQuoteTile) {
	    angular.module('edge.quoteandbind.quickquote.pa.tiles.quote', []).directive('gwPaQuickQuoteEditState', PAQuickQuoteEditState).directive('gwPaQuickQuoteQuotingState', PAQuickQuoteQuotingState).directive('gwPaQuickQuoteQuotedState', PAQuickQuoteQuotedState).directive('gwPaQuickQuoteQuoteErrorState', PAQuickQuoteQuoteErrorState).directive('gwPaQuickQuoteTile', PAQuickQuoteTile);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(841)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'model': '=',
	                'preQuoteFn': '&'
	            },
	            'controller': ['$scope', function ($scope) {
	                $scope.quote = function () {
	                    if ($scope.model.allStepsComplete) {
	                        $scope.preQuoteFn();
	                        $scope.model.onQuote();
	                    }
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 841 */
/***/ function(module, exports) {

	module.exports = "<section class=\"gw-dot-indicators\">\n    <div ng-repeat=\"item in model.completedSteps track by $index\">\n        <p class=\"gw-indicator-dot\" ng-class=\"{'gw-complete': item }\">\n            <span>{{$index + 1}}</span>\n        </p>\n    </div>\n    <div>\n        <div class=\"gw-indicator-dot gw-slq-quote-dot\" ng-click=\"quote()\" ng-class=\"{'gw-complete': model.allStepsComplete}\">\n            {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Quote!' | translate}}\n        </div>\n    </div>\n</section>"

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(843)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 843 */
/***/ function(module, exports) {

	module.exports = "<p>{{'quoteandbind.pa.directives.templates.pa-quick-indicative.Getting your Quote...' | translate}}</p>"

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(845), __webpack_require__(846)], __WEBPACK_AMD_DEFINE_RESULT__ = function (quickQuoteTile, template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'model': '='
	            },
	            controller: ['$scope', 'quickquote.QuickQuoteService', 'InsuranceSuiteMetadata', 'qnb.EmailService', 'ModalService', '$q', '$translate', function ($scope, QuickQuoteService, InsuranceSuiteMetadata, QuoteEmailService, ModalService, $q, $translate) {
	                $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.total premium';
	
	                if (angular.isDefined($scope.model)) {
	                    var termTypeList = InsuranceSuiteMetadata.get('pc').types.getTypelist('TermType');
	
	                    if ($scope.model.quote.termType === termTypeList.getCode('Annual').code) {
	                        $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.per 12 months';
	                    } else if ($scope.model.quote.termType === termTypeList.getCode('HalfYear').code) {
	                        $scope.totalPremiumString = 'quoteandbind.pa.directives.templates.pa-quick-indicative.per 6 months';
	                    }
	                }
	
	                $scope.emailQuote = function () {
	                    var emailAddress = $scope.model.contactEmail;
	                    var emailInfo = {
	                        quoteID: $scope.model.quote.reference,
	                        sessionID: $scope.model.quote.sessionUUID
	                    };
	
	                    $q.when(QuoteEmailService.emailQuote('quoteandbind', emailInfo), function () {
	                        ModalService.showInfo('quoteandbind.directives.QnbWizardButtons.Quote Emailed', $translate('quoteandbind.directives.QnbWizardButtons.The quote details have been emailed', { emailAddress: emailAddress }));
	                    }, function () {
	                        ModalService.showError('quoteandbind.directives.QnbWizardButtons.Error', 'quoteandbind.directives.QnbWizardButtons.Sorry, we were not able to email the quote details at this time.');
	                    });
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (QuickQuoteService, tileModel, previousModel) {
	        var state = undefined;
	        var previousQuote = undefined;
	        var previousEmail = undefined;
	        var previousSubmission = undefined;
	
	        function reviseQuote() {
	            toEdit();
	        }
	
	        function toEdit() {
	            state = {
	                'id': 'edit',
	                data: {
	                    onQuote: startQuote,
	                    get completedSteps() {
	                        return tileModel.completedSteps;
	                    },
	                    get allStepsComplete() {
	                        return tileModel.completedSteps.every(function (isComplete) {
	                            return isComplete;
	                        });
	                    }
	                }
	            };
	            tileModel.viewModel.quotedSubmission = null;
	        }
	
	        function proceedToFullQuote() {
	            state = {
	                'id': 'proceedToFullQuote'
	            };
	        }
	
	        function startQuote() {
	            /*  Ignore if not in edit mode and the model is invalid. If the user has already a previous quote and
	             *  the submission data hasn't changed, then we reuse the previous quote
	             */
	            if (state.id !== 'edit' && !tileModel.viewModel.aspects.valid) {
	                return;
	            } else if (angular.equals(previousModel, tileModel.viewModel.value)) {
	                _handleNoChangeOnRequote();
	                return;
	            }
	
	            // Copy previous additional details which will be checked to ensure
	            // the quote is not requested if no details have changed
	            previousModel = angular.copy(tileModel.viewModel.value);
	
	            var quoteProcess = QuickQuoteService.createSubmission('quoteandbind', tileModel.viewModel.value);
	            state = {
	                'id': 'quoting',
	                'data': {
	                    'process': quoteProcess
	                }
	            };
	
	            quoteProcess.then(_handleQuoteSuccess, _handleQuoteFailure);
	
	            function _handleNoChangeOnRequote() {
	                if (previousQuote) {
	                    tileModel.viewModel.quotedSubmission = previousSubmission;
	                    state = {
	                        'id': 'quoted',
	                        'data': {
	                            'quote': previousQuote,
	                            'contactEmail': previousEmail,
	                            onRevise: reviseQuote,
	                            onNext: proceedToFullQuote
	                        }
	                    };
	                } else {
	                    state = {
	                        'id': 'quoteError'
	                    };
	                }
	            }
	
	            function _handleQuoteSuccess(data) {
	                if (state.data.process !== quoteProcess) {
	                    return;
	                }
	                tileModel.viewModel.quotedSubmission = data;
	                tileModel.viewModel.value.submissionNumber = data.quoteID;
	                // Save previous quote in case user goes back and doesn't change submission
	                previousModel.submissionNumber = data.quoteID;
	                previousEmail = data.bindData.contactEmail;
	                previousSubmission = data;
	                previousQuote = {
	                    'reference': data.quoteID,
	                    'premiumPerMonth': data.quoteData.offeredQuotes[0].monthlyPremium,
	                    'premiumPerYear': data.quoteData.offeredQuotes[0].total,
	                    'termType': data.draftData.termType,
	                    'sessionUUID': data.sessionUUID
	                };
	                state = {
	                    'id': 'quoted',
	                    'data': {
	                        'quote': previousQuote,
	                        'contactEmail': previousEmail,
	                        onRevise: reviseQuote,
	                        onNext: proceedToFullQuote
	                    }
	                };
	            }
	
	            function _handleQuoteFailure() {
	                if (state.data.process !== quoteProcess) {
	                    return;
	                }
	                state = {
	                    'id': 'quoteError'
	                };
	                tileModel.viewModel.quotedSubmission = null;
	            }
	        }
	
	        toEdit();
	
	        return {
	            get state() {
	                return state;
	            },
	            startQuoting: function startQuoting() {
	                startQuote();
	            }
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 846 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-slq-header\">\n    <p>\n        {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Your Quote' | translate}}\n        <button class=\"gw-slq-button-email\" ng-click=\"emailQuote()\"></button>\n    </p>\n</div>\n<div class=\"gw-slq-premium\">\n    <p>\n        {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Premium' | translate}}\n    <p>\n        {{'quoteandbind.pa.directives.templates.pa-quick-indicative.per month' | translate:{monthlyPremium: model.quote.premiumPerMonth} }}\n    </p>\n    <p>{{'quoteandbind.pa.directives.templates.pa-quick-indicative.or' | translate}}</p>\n    <p>\n        {{totalPremiumString | translate:{premium: model.quote.premiumPerYear} }}\n    </p>\n</div>\n<div class=\"gw-slq-reference\">\n    <p>\n        {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Reference' | translate}}\n    </p>\n    <p>{{model.quote.reference}}</p>\n</div>\n<div class=\"gw-slq-buttons gw-slq-indicative-buttons\">\n    <button class=\"gw-icon-primary gw-slq-button-edit gw-slq-quote-button\" ng-click=\"model.onRevise()\">\n    </button>\n    <button class=\"gw-icon-primary gw-slq-button-check gw-slq-quote-button\" ng-click=\"model.onNext()\">\n    </button>\n</div>\n"

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(848)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports = "<p>{{'quoteandbind.pa.directives.templates.pa-quick-indicative.Sorry, based on the data entered this quote cannot be completed online.' | translate}}</p>"

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(845), __webpack_require__(850)], __WEBPACK_AMD_DEFINE_RESULT__ = function (quickQuoteTile, template) {
	    return [function () {
	        return {
	            'restrict': 'A',
	            template: template,
	            'scope': {
	                'tileModel': '=gwPaQuickQuoteTile',
	                'previousTileModel': '=gwPaQuickQuotePreviousModel',
	                'preQuoteFn': '&',
	                'panelsValid': '=',
	                'transitionQuoteToEdit': '=',
	                'transitionQuoteToQuoted': '='
	            },
	            controller: ['$scope', 'quickquote.QuickQuoteService', function ($scope, QuickQuoteService) {
	                $scope.model = quickQuoteTile(QuickQuoteService, $scope.tileModel, $scope.previousTileModel);
	                $scope.tileModel.actions.setStarQuotingFn($scope.model.startQuoting);
	
	                $scope.panelsValid.isValid = function () {
	                    return $scope.tileModel.viewModel.aspects.valid && $scope.tileModel.viewModel.aspects.subtreeValid && $scope.tileModel.viewModel.quotedSubmission;
	                };
	
	                $scope.transitionQuoteToEdit = function () {
	                    $scope.model.state.data.onRevise();
	                };
	
	                $scope.transitionQuoteToQuoted = function () {
	                    $scope.model.startQuoting();
	                };
	
	                $scope.$watch('model.state.id', function (newState, oldState) {
	                    if (newState === 'proceedToFullQuote') {
	                        $scope.tileModel.actions.proceedToFullQuote();
	                    }
	                    if (newState !== 'edit' && newState !== 'quoteError') {
	                        $scope.tileModel.actions.setLocked(true);
	                    } else {
	                        $scope.tileModel.actions.setLocked(false);
	                    }
	
	                    if (newState === 'edit' && oldState === 'quoted') {
	                        $scope.tileModel.actions.reviseQuote();
	                    }
	                });
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 850 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-form-section gw-flip-container\">\n    <div class=\"gw-flip-card gw-slq-tile\">\n        <div class=\"gw-flip-front gw-edit-mode\" ng-class=\"{'gw-flipped': model.state.id == 'edit'}\">\n            <div ng-if=\"model.state.id == 'edit'\" gw-pa-quick-quote-edit-state model=\"model.state.data\" step-idx=\"stepIdx\"\n                 class=\"gw-tablet-indicators\" pre-quote-fn=\"preQuoteFn()\"></div>\n        </div>\n        <div class=\"gw-flip-back gw-readonly-mode gw-slq-quote\" ng-class=\"{'gw-flipped' : model.state.id != 'edit'}\">\n            <div ng-if=\"model.state.id == 'quoting'\" gw-pa-quick-quote-quoting-state></div>\n            <div ng-if=\"model.state.id == 'quoted'\" gw-pa-quick-quote-quoted-state model=\"model.state.data\"></div>\n            <div ng-if=\"model.state.id == 'quoteError'\" gw-pa-quick-quote-quote-error-state></div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(852), __webpack_require__(853), __webpack_require__(855)], __WEBPACK_AMD_DEFINE_RESULT__ = function (QuickQuoteService, QuickStepProgress, QuickQuoteLink) {
	
	    return angular.module('edge.quoteandbind.quickquote.common.app', []).factory('quickquote.QuickQuoteService', QuickQuoteService).directive('gwQuickStepProgress', QuickStepProgress).directive('gwQuickQuoteLink', QuickQuoteLink);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(396)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Submission) {
	    return ['$q', 'JsonRPCService', 'qnb.ErrorHandlingService', function ($q, JsonRPCService, ErrorHandlingService) {
	        return {
	            createSubmission: function createSubmission(callGroups, submissionDTO) {
	                var deferred = $q.defer();
	                JsonRPCService.send('quote', 'slquote', 'createBaseOffering', [submissionDTO], callGroups).then(function (response) {
	                    submissionDTO = new Submission(response);
	                    ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
	                    return deferred.resolve(submissionDTO);
	                }, function (error, status, headers) {
	                    return deferred.reject([error, status, headers]);
	                });
	                return deferred.promise;
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(854)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	
	    return [function () {
	        return {
	            restrict: 'A',
	            scope: {
	                transitionFn: '&',
	                stepValidityFns: '=',
	                form: '=',
	                currentStep: '='
	            },
	            template: templateStr,
	            controller: ['$scope', function ($scope) {
	                $scope.customClasses = ['', '', '', 'gw-slq-quote-dot-small'];
	
	                $scope.transition = function (targetStep) {
	                    $scope.transitionFn({ targetStep: targetStep });
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports = "<section class=\"gw-dot-indicators\">\n    <div ng-repeat=\"step in stepValidityFns track by $index\">\n        <p class=\"gw-indicator-dot\" ng-click=\"transition($index)\"\n           ng-class=\"[customClasses[$index],{'gw-complete': step.isValid(),'gw-invalid': form.submitted && !step.isValid(), 'gw-active': currentStep===$index}]\"\n        >\n        </p>\n    </div>\n</section>"

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(856)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return [function () {
	        return {
	            replace: true,
	            restrict: 'A',
	            template: templateStr
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 856 */
/***/ function(module, exports) {

	module.exports = "<a href=\"#paquickQuote\" class=\"gw-slq-link\">\n    <img class=\"slq-car-icon\" src=\"../styles/images/common/icons/car-profile-speedline.png\"/>\n    <span class=\"gw-slq-link-text\">{{'quoteandbind.views.zip-code.Get a Quick Quote' | translate }}</span>\n</a>"

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(858), __webpack_require__(859), __webpack_require__(861), __webpack_require__(862), __webpack_require__(512)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NavigationHistoryService, NavigationDirective, NavigationListener, swipeDirective) {
	    return angular.module('edge.platform.navigation', ['ui.router']).factory('NavigationService', NavigationHistoryService).directive('gwPlNavigation', NavigationDirective).directive('gwSwipeLeft', swipeDirective('gwSwipeLeft', -1)).directive('gwSwipeRight', swipeDirective('gwSwipeRight', 1)).run(NavigationListener);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var nodes = [];
	
	    var navObj = function navObj(state, params) {
	        return {
	            state: state,
	            params: params
	        };
	    };
	
	    var nodeObj = function nodeObj(to, toParams, from, fromParams) {
	        return {
	            to: navObj(to, toParams),
	            from: navObj(from, fromParams)
	        };
	    };
	
	    var addNodeToHistory = function addNodeToHistory(node) {
	        var to = node.to.state.name;
	        if (nodes.length > 0) {
	            if (nodes[0].from.state.name === to) {
	                nodes.shift();
	            } else {
	                nodes.unshift(node);
	            }
	        } else {
	            nodes.unshift(node);
	        }
	    };
	
	    return [function () {
	        return {
	            updateHistory: function updateHistory(to, toParams, from, fromParams) {
	                var node = nodeObj(to, toParams, from, fromParams);
	                if (!from.abstract) {
	                    addNodeToHistory(node);
	                }
	            },
	            recentHistory: function recentHistory() {
	                return nodes.length > 0 ? nodes[0] : null;
	            }
	        };
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(860)], __WEBPACK_AMD_DEFINE_RESULT__ = function (templateStr) {
	    return ['$state', '$filter', 'NavigationService', function ($state, $filter, NavigationService) {
	        return {
	            restrict: 'EA',
	            scope: {},
	            template: templateStr,
	            link: function link(scope) {
	                var navHistoryObj = NavigationService.recentHistory();
	                scope.previous = navHistoryObj ? navHistoryObj.from : null;
	
	                scope.goToPrevious = function () {
	                    if (scope.previous) {
	                        if (scope.previous.params) {
	                            $state.transitionTo(scope.previous.state.name, scope.previous.params);
	                        } else {
	                            $state.transitionTo(scope.previous.state.name);
	                        }
	                    }
	                };
	
	                scope.getPreviousLabel = function () {
	                    var label = void 0;
	                    var prevState = scope.previous ? scope.previous.state : null;
	                    if (prevState) {
	                        if (prevState.data) {
	                            label = prevState.data.label ? prevState.data.label : prevState.name;
	                        } else {
	                            label = prevState.name;
	                        }
	                    }
	                    return label ? $filter('translate')('platform.navigation.NavigationDirective.Back to') + ' ' + label : null;
	                };
	            }
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 860 */
/***/ function(module, exports) {

	module.exports = "<div class=\"gw-clearfix\">\n    <div class=\"span12 mb10\" ng-show=\"previous\">\n        <button class=\"gw-btn-primary\" ng-click=\"goToPrevious()\">\n            <i class=\"fa fa-chevron-left\"></i>\n            {{getPreviousLabel()}}\n        </button>\n    </div>\n</div>"

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return ['$rootScope', 'NavigationService', function ($rootScope, NavigationService) {
	        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	            NavigationService.updateHistory(toState, toParams, fromState, fromParams);
	        });
	    }];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return function (directiveName, direction) {
	        return ['$parse', function ($parse) {
	            return {
	                restrict: 'EA',
	                template: '',
	                link: function link(scope, element, attr) {
	                    /*
	                     *   Due to AP-953 we cannot use the ng-touch library for swipe, this directive tries to mimic the
	                     *   behaviour of the angular swipe directives as closely as possible. If angular-touch ever get rid
	                     *   of their override of the ng-click directive, as proposed here https://github.com/angular/angular.js/pull/12317
	                     *   this directive could be replaced by the angular-touch library.
	                     */
	                    var MAX_VERTICAL_DISTANCE = 75;
	                    var MIN_HORIZONTAL_DISTANCE = 30;
	                    var MAX_VERTICAL_RATIO = 0.3;
	
	                    /*
	                     *   Parse the swipe action using the directive name attribute. We do not pass the swipe action here
	                     *   using a scope variable as an element cannot be bound to multiple isolated scopes.
	                     *   Eg. gw-swipe-left="closePanel()" would mean that directiveName would equal gwSwipeLeft and the
	                     *   result of attr['gwSwipeLeft'] would be the string "closePanel()". We pass this string to the
	                     *   $parse function which parses the Angular expression and returns a function which will execute
	                     *   that expression when called. This the code that the user expects to be run when a valid swipe
	                     *   occurs.
	                     */
	                    var swipeAction = $parse(attr[directiveName]);
	                    var startPosition = void 0;
	                    var isSwipeActive = false;
	
	                    $(element).on('touchstart', startSwipe).on('touchcancel', cancelSwipe).on('touchend', endSwipe);
	
	                    function startSwipe(event) {
	                        startPosition = getCoordinates(event);
	                        isSwipeActive = true;
	                    }
	
	                    function cancelSwipe() {
	                        // Notifications, calls, etc can cancel a swipe
	                        isSwipeActive = false;
	                    }
	
	                    function endSwipe(event) {
	                        var endPosition = getCoordinates(event);
	                        if (isSwipeActive && isSwipeValid(startPosition, endPosition)) {
	                            /*
	                             *   If a valid swipe occurs we call the swipeAction function. This function is the result of
	                             *   parsing an angular expression which was passed into the directive as an attribute. We
	                             *   use an $apply here as this code will be executed outside the scope of angular. Using
	                             *   $apply will execute this function and then call $digest for us. This is approach used
	                             *   by the angular.
	                             */
	                            scope.$apply(function () {
	                                return swipeAction(scope, { $event: event });
	                            });
	                        }
	                        isSwipeActive = false;
	                    }
	
	                    function isSwipeValid(start, end) {
	                        // Identical to ng-touch getCoordinates function.
	                        if (!start || !end) {
	                            return false;
	                        }
	                        var deltaY = Math.abs(end.y - start.y);
	                        var deltaX = (end.x - start.x) * direction;
	                        /*
	                         *   DeltaY is the length of the vertical swipe
	                         *   DeltaX is the length of the horizontal swipe (which can be negative if it is a left swipe)
	                         *   we multiply this by a direction above as valid swipes will only have a positive deltaX.
	                         *   For a swipe to be valid its vertical distance must less than our vertical threshold, the
	                         *   deltaX after being multiplied by a direction must be greater than 0, the horizontal length
	                         *   must be greater than our minimum horizontal threshold and the vertical ratio must be less
	                         *   than our max vertical ratio.
	                         */
	                        return deltaY < MAX_VERTICAL_DISTANCE && deltaX > 0 && deltaX > MIN_HORIZONTAL_DISTANCE && deltaY / deltaX < MAX_VERTICAL_RATIO;
	                    }
	
	                    function getCoordinates(event) {
	                        // Identical to ng-touch getCoordinates function.
	                        var originalEvent = event.originalEvent || event;
	                        var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
	                        var eventTouch = originalEvent.changedTouches && originalEvent.changedTouches[0] || touches[0];
	                        return {
	                            x: eventTouch.clientX,
	                            y: eventTouch.clientY
	                        };
	                    }
	                }
	            };
	        }];
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 27-08-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(864), __webpack_require__(866), __webpack_require__(868)], __WEBPACK_AMD_DEFINE_RESULT__ = function (StandardAddress, OwnershipAddress, AddressStandardizationService) {
	        return angular.module('customerEdge.addressstandardization.app', []).directive('gwPlStandardAddress', StandardAddress).directive('gwPlOwnershipAddress', OwnershipAddress).factory('AddressStandardizationService', AddressStandardizationService);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 27-08-2016.
	 */
	/*
	        CHG0032036 - Omega Integration with Melissa Data Service
	        AB - 01/10/2019
	*/
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(865)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	        return ['AddressStandardizationService', '$q', 'ModalService', 'qnb.InputValidationService', function (AddressStandardizationService, $q, ModalService, InputValidationService) {
	                return {
	                        restrict: 'A',
	                        template: templateStr,
	                        scope: {
	                                address: '=',
	                                readonly: '='
	                        },
	                        controller: ['$scope', function ($scope) {
	                                $scope.showLoading = false;
	                                $scope.isNameValid = true;
	                                $scope.getStandardAddress = function () {
	
	                                        if ($scope.address.addressLine1.value && $scope.address.addressLine1.value.length > 0) {
	                                                $scope.readonly = true;
	                                                $scope.showLoading = true;
	                                                $scope.State = '';
	
	                                                $scope.standardAddressDetails = {
	                                                        streetAddress: $scope.address.addressLine1.value,
	                                                        extendedAddress: $scope.address.addressLine2.value,
	                                                        zipCode: $scope.address.postalCode.value.trim()
	                                                };
	
	                                                var inputsToValidate = [{ 'addressLine1': $scope.address.addressLine1.value }, { 'addressLine2': $scope.address.addressLine2.value }, { 'city': $scope.address.city.value }];
	                                                inputValidationData = InputValidationService.isInputValid(inputsToValidate);
	                                                if (!inputValidationData[0] && inputValidationData[1].length > 0) {
	                                                        for (var i = 0; i < inputValidationData[1].length; i++) {
	                                                                $scope.address[inputValidationData[1][i]].value = '';
	                                                                $scope.isNameValid = false;
	                                                        }
	                                                        return;
	                                                } else {
	                                                        $scope.isNameValid = true;
	                                                }
	
	                                                $q.when(AddressStandardizationService.standardAddress('addressstandardization', $scope.standardAddressDetails), function (AddressResponse) {
	                                                        switch (AddressResponse.addressErrorCode) {
	                                                                case "Success":
	                                                                        var title = "We are able to validate your address, is this your correct address?";
	                                                                        var message2 = "We were unable to validate your address";
	                                                                        var validationMessage = "No, go back and edit";
	
	                                                                        if (null != AddressResponse.extendedAddress) {
	                                                                                var address = AddressResponse.streetAddress + " " + AddressResponse.extendedAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
	                                                                        } else {
	                                                                                var address = AddressResponse.streetAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
	                                                                        }
	                                                                        var addressModel = ModalService.showMelissaSuccessPopup(title, address);
	                                                                        addressModel.result.then(function (result) {
	                                                                                if (result.actionType == "yes") {
	                                                                                        $scope.address.addressLine1.value = AddressResponse.streetAddress;
	                                                                                        $scope.address.addressLine2.value = AddressResponse.extendedAddress;
	                                                                                        $scope.address.city.value = AddressResponse.city.trim();
	                                                                                        $scope.address.postalCode = AddressResponse.zipCode;
	                                                                                        $scope.address.county = AddressResponse.county;
	                                                                                        $scope.address.state.value = AddressResponse.state;
	                                                                                        $scope.State = AddressResponse.state;
	                                                                                } else {
	                                                                                        $scope.readonly = false;
	                                                                                        //$scope.State = $scope.address.state.value
	                                                                                }
	                                                                        }, function () {});
	                                                                        break;
	                                                                case "Warning":
	                                                                        var title = "We are unable to validate your address with the US Postal Service";
	                                                                        var message = AddressResponse.addressErrorDesc;
	                                                                        var continueModel = ModalService.showMelissaWarningPopup(title, message);
	                                                                        continueModel.result.then(function () {}, function () {});
	                                                                        //Author: Devnandan : Mandatory County Enhancement: If address standardization fails, pull county from ZipCodeToCountyMapping table
	                                                                        $scope.address.county.value = AddressResponse.county;;
	                                                                        $scope.readonly = false;
	                                                                        break;
	                                                                case "Error":
	                                                                        var title = "We are unable to validate your address with the US Postal Service";
	                                                                        var message = AddressResponse.addressErrorDesc;
	                                                                        var continueModel = ModalService.showInfo(title, message);
	                                                                        continueModel.result.then(function () {}, function () {});
	                                                                        //Author: Devnandan : Mandatory County Enhancement: If address standardization fails, pull county from ZipCodeToCountyMapping table
	                                                                        $scope.address.county.value = AddressResponse.county;;
	                                                                        $scope.readonly = false;
	                                                                        break;
	                                                                default:
	                                                                        console.log("Melissa Service Handler Error ");
	                                                        }
	                                                        $scope.showLoading = false;
	                                                }, function () {
	                                                        //Something has gone legitimately wrong, let the user input the data manually
	                                                        console.log("Melissa Service Error ");
	                                                        $scope.readonly = false;
	                                                        $scope.showLoading = false;
	                                                });
	                                        } else {
	                                                $scope.readonly = false;
	                                                $scope.address.city.value = '';
	                                                $scope.address.county.value = '';
	                                                $scope.address.state.value = undefined;
	                                        }
	                                };
	                        }]
	                };
	        }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 865 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <!-- security vulnerabilities -->\r\n    <div class=\"gw-control-group\" ng-hide=\"isNameValid\">\r\n        <div  class=\"custom-error\">\r\n            {{'quoteandbind.views.Name OR Address Value May Not Be Formatted Correctly' | translate}}\r\n        </div>\r\n    </div>\r\n    <!-- ended -->\r\n    <div gw-pl-ctrl-group model=\"address.addressLine1\"\r\n         label=\"{{'platform.inputs.address-details.Address Line 1'|translate}}\">\r\n        <input type=\"text\" ng-model=\"address.addressLine1.value\"\r\n               maxlength=\"50\"\r\n               ng-blur=\"getStandardAddress()\" />\r\n    </div>\r\n\r\n    <gw-pl-input-ctrl model=\"address.addressLine2\"\r\n                      ng-attr-maxlength=\"50\"\r\n                      ng-model=\"address.addressLine2.value\"\r\n                      label=\"{{'platform.inputs.address-details.Address Line 2'|translate}}\"></gw-pl-input-ctrl>\r\n\r\n\r\n    <div gw-pl-input-ctrl model=\"address.postalCode\"\r\n                          readonly=\"true\"\r\n                          ng-model=\"address.postalCode.value\"\r\n                          label=\"{{'platform.inputs.address-details.ZIP Code'|translate}}\"> </div>\r\n\r\n    <div gw-pl-ctrl-group model=\"address.city\" readonly=\"readonly\" ng-attr-maxlength=\"50\"\r\n        label=\"{{'platform.inputs.address-details.City'|translate}}\">\r\n        <span ng-show=\"readonly\">{{address.city.value}}</span>\r\n        <input type=\"text\" id=\"City\" ng-model=\"address.city.value\" name=\"City\" ng-hide=\"readonly\" maxlength=\"50\"/>\r\n        <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n    </div>\r\n\r\n    <!-- Author: Devnandan : Mandatory County Enhancement: County Field should be available in portal. -->\r\n    <div gw-pl-ctrl-group model=\"address.county\" readonly=\"readonly\" ng-attr-maxlength=\"50\"\r\n        label=\"{{'platform.inputs.address-details.County'|translate}}\">\r\n        <span ng-show=\"readonly\">{{address.county.value}}</span>\r\n        <input type=\"text\" id=\"County\" ng-model=\"address.county.value\" name=\"County\" ng-hide=\"readonly\" maxlength=\"50\"/>\r\n        <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n    </div>\r\n\r\n    <div gw-pl-ctrl-group model=\"address.state\" readonly=\"readonly\"\r\n        label=\"{{'platform.inputs.address-details.State'|translate}}\">\r\n        <span ng-show=\"readonly\">{{State}}</span>\r\n        <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n        <select gw-pl-select=\"address.state.value\" ng-hide=\"readonly\" options=\"address.state.aspects.availableValues\" render-by=\" 'name' \"\r\n                placeholder=\"{{'platform.inputs.address-details.Choose State'|translate}}\"></select>\r\n    </div>\r\n</div>"

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(355), __webpack_require__(867)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, templateStr) {
	    return ['AddressStandardizationService', '$q', 'ModalService', 'LocaleService', function (AddressStandardizationService, $q, ModalService, LocaleService) {
	        return {
	            restrict: 'A',
	            template: templateStr,
	            scope: {
	                address: '=',
	                lease: '=',
	                readonly: '=',
	                vehicles: '='
	            },
	            controller: ['$scope', function ($scope) {
	                //console.log("Teeee ", $scope.address);
	                $scope.showLoading = false;
	                $scope.isFormSubmitted = false;
	                var defaultCountryCode = $scope.defaultCountryCode || LocaleService.getCountry().code;
	                $scope.address.country.value = defaultCountryCode;
	                $scope.$on('submit-form', function () {
	                    $scope.isFormSubmitted = true;
	                });
	                $scope.getStandardAddress = function () {
	                    if ($scope.address.postalCode.value && $scope.address.postalCode.value.length > 0) {
	                        $scope.readonly = true;
	                        $scope.showLoading = true;
	                        $scope.State = '';
	
	                        $scope.standardAddressDetails = {
	                            streetAddress: $scope.address.addressLine1.value,
	                            extendedAddress: $scope.address.addressLine2.value,
	                            zipCode: $scope.address.postalCode.value
	
	                        };
	                        $q.when(AddressStandardizationService.standardAddress('addressstandardization', $scope.standardAddressDetails), function (AddressResponse) {
	
	                            // AddressResponse.streetAddress = undefined;
	                            // AddressResponse.streetAddress && AddressResponse.extendedAddress && AddressResponse.city && AddressResponse.state
	                            if (AddressResponse && AddressResponse.streetAddress && AddressResponse.city && AddressResponse.state) {
	                                //Autofill with the returned data
	                                //var title = "Title"
	                                var message = "Is this your correct Address?";
	                                var message2 = "We were unable to validate your address";
	                                var validationMessage = "No, proceed with address I entered";
	                                var validationMessage2 = "No, go back and edit";
	                                if (null != AddressResponse.extendedAddress) {
	                                    var address = AddressResponse.streetAddress + " " + AddressResponse.extendedAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
	                                } else {
	                                    var address = AddressResponse.streetAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
	                                }
	                                var addressModel = ModalService.showAddressStandard(message, validationMessage, address);
	
	                                addressModel.result.then(function (result) {
	                                    if (result.actionType == "yes") {
	
	                                        $scope.address.addressLine1.value = AddressResponse.streetAddress;
	                                        $scope.address.addressLine2.value = AddressResponse.extendedAddress;
	                                        $scope.address.city.value = AddressResponse.city;
	                                        $scope.address.postalCode = AddressResponse.zipCode;
	                                        $scope.address.county = AddressResponse.county;
	                                        if ($scope.address.addressLine1.value) {
	                                            $scope.address.addressLine1.value = $scope.address.addressLine1.value.trim();
	                                        }
	
	                                        if ($scope.address.addressLine2.value) {
	                                            $scope.address.addressLine2.value = $scope.address.addressLine2.value.trim();
	                                        }
	
	                                        if (AddressResponse.state == 'North Carolina' || AddressResponse.state == 'NC') {
	                                            // console.log("inside NC")
	                                            $scope.address.state.value = 'NC';
	                                        } else if (AddressResponse.state == 'South Carolina' || AddressResponse.state == 'SC') {
	                                            $scope.address.state.value = 'SC';
	                                        } else {
	                                            $scope.address.state.value = _.findWhere($scope.address.state.aspects.availableValues, { name: AddressResponse.state });
	                                        }
	                                        $scope.State = AddressResponse.state;
	                                        //$scope.State  = $scope.address.state.value
	                                        //  $scope.address.state.value = AddressResponse.state;
	                                    } else {
	                                        $scope.readonly = false;
	                                        //$scope.State = $scope.address.state.value
	                                    }
	                                }, function () {});
	                            } else {
	
	                                //Autofill with the returned data
	                                //var title = "Title"
	                                var message = "We were unable to validate your address";
	                                var validationMessage = "No, go back and edit";
	                                var address = "Would you like to proceed with the address you entered?";
	                                var addressModel = ModalService.showAddressStandard(message, validationMessage, address);
	                                addressModel.result.then(function (result) {
	                                    if (result.actionType == "yes") {
	                                        //Need to add code if yes is pressed
	                                    }
	                                }, function () {});
	                                $scope.readonly = false;
	                                $scope.address.city.value = '';
	                                $scope.address.county.value = '';
	                                $scope.address.state.value = undefined;
	                            }
	                            $scope.showLoading = false;
	                        }, function () {
	                            //Something has gone legitimately wrong, let the user input the data manually
	                            $scope.readonly = false;
	                            $scope.showLoading = false;
	                        });
	                    } else {
	                        $scope.readonly = false;
	                        $scope.address.city.value = '';
	                        $scope.address.county.value = '';
	                        $scope.address.state.value = undefined;
	                    }
	                };
	            }]
	        };
	    }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 867 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n    <div ng-if=\"lease\">\r\n        <div  model=\"address.addressLine1\"  >\r\n            <input type=\"text\" ng-model=\"address.addressLine1.value\"\r\n                   placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.Lease Company Address'|translate}}\"\r\n                   maxlength=\"50\" />\r\n            <span class=\"custom-error\"\r\n                  ng-show=\"!address.addressLine1.value || address.addressLine1.value == '' && isFormSubmitted \">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-if=\"!lease\">\r\n        <div  model=\"address.addressLine1\" >\r\n            <input type=\"text\" ng-model=\"address.addressLine1.value\"\r\n                   placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.Finance Company Address'|translate}}\"\r\n                   maxlength=\"50\" />\r\n            <span class=\"custom-error\"\r\n                  ng-show=\"!address.addressLine1.value || address.addressLine1.value == '' && isFormSubmitted \">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <table>\r\n        <tr>\r\n            <td>\r\n                <div  model=\"address.postalCode\" >\r\n                    <input type=\"text\" ng-model=\"address.postalCode.value\"\r\n                           maxlength=\"10\" placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.Zipcode'|translate}}\"\r\n                           ng-blur=\"getStandardAddress()\" />\r\n                    <span class=\"custom-error\"\r\n                          ng-show=\"!address.postalCode.value && isFormSubmitted\">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n                </div>\r\n            </td>\r\n            <td>\r\n                <div model=\"address.city\" readonly=\"readonly\" ng-attr-maxlength=\"50\"\r\n                >\r\n                    <span ng-show=\"readonly\">{{address.city.value}}</span>\r\n                    <input type=\"text\" placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.City'|translate}}\"\r\n                           id=\"City\" ng-model=\"address.city.value\" name=\"City\" ng-hide=\"readonly\" maxlength=\"50\"/>\r\n                    <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n                    <span class=\"custom-error\"\r\n                          ng-show=\"!address.city.value && isFormSubmitted\">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n                </div>\r\n            </td>\r\n            <td >\r\n                <div  model=\"address.state\" readonly=\"readonly\">\r\n                    <span ng-show=\"readonly\">{{State}}</span>\r\n                    <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n        <!-- Author: Devnandan : Mandatory County Enhancement: County Field should be available in portal. -->\r\n                    <span class=\"custom-error\"\r\n                          ng-show=\"!address.county.value && isFormSubmitted\">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n                </div>\r\n            </td>\r\n            <td >\r\n                <div  model=\"address.county\" readonly=\"readonly\">\r\n                    <span ng-show=\"readonly\">{{County}}</span>\r\n                    <span ng-hide=\"!showLoading\">\r\n            <img src=\"../styles/images/common/throbber.gif\"/>\r\n        </span>\r\n                    <select gw-pl-select=\"address.state.value\" ng-hide=\"readonly\" options=\"address.state.aspects.availableValues\" render-by=\" 'name' \"\r\n                            placeholder=\"{{'quoteandbind.pa.views.pa-policy-info.State'|translate}}\"></select>\r\n                    <span class=\"custom-error\"\r\n                          ng-show=\"!address.state.value && isFormSubmitted\">\r\n                     {{'displaykey.Edge.Web.Api.Model.NotNull' | translate}}</span>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>"

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Ganesh.Sharma on 26-08-2016.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
	                return {
	                        standardAddress: function standardAddress(callGroups, AddressRequestDTO) {
	                                var deferred = $q.defer();
	                                JsonRPCService.send('addressstandardization', 'standardization', 'standardAddress', [AddressRequestDTO], callGroups).then(function (AddressResponse) {
	                                        return deferred.resolve(AddressResponse);
	                                }, function (error, status, headers) {
	                                        return deferred.reject([error, status, headers]);
	                                });
	                                return deferred.promise;
	                        }
	                };
	        }];
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.js
 **/